window.VERSION = '%BUILD_VERSION%';

var LOGIN_PATH = '/login';
var SIGNUP_PATH = '/signup';
var FORGOT_PATH = '/forgot';
var SET_PASSWORD_PATH = '/set_password';
var CONFIRMED_PATH = '/confirmed';
var ROOM_TYPES = '/set_room_types';
var SERVER_PATH = (window.location.hostname === 'localhost' && window.location.protocol == 'http:')  ? 'http://localhost:3000' : '';
var braintree;

var getTemplatePath = function (template) {
  return 'templates/' + template.replace('.html', '_tpl.html');
};

var customCurrencyExtended = function(amount, booking, isForeignAmount, $filter, $rootScope) {
  if (isForeignAmount) {
    currency = booking.foreignCurrency;
    currencyRate = booking.foreignCurrencyRate;
    return customCurrency($filter, $rootScope)((amount/currencyRate), 2, currency);
  }
  return customCurrency($filter, $rootScope)(amount)
}

var saveBookingRoomNotes = function (bookingRoomId, guestNotes, hotelNotes, housekeepingNotes, bookingStorage) {
  var room = bookingStorage.get_room(bookingRoomId);
  room.note = guestNotes;
  room.hotelNote = hotelNotes;
  room.housekeepingNote = housekeepingNotes;
  room.save();
  bookingStorage.bookingsById[room.bookingId].rooms.forEach(function(room) {
    room.hotelNote = hotelNotes;
  });
}

var noteModal = function(bookingRoomId, bookingId, bookingStorage, uIDialogService) {
  bookingStorage.get_room(bookingRoomId, bookingId, function(room){
    uIDialogService.open('booking-notes', {
      title: 'Booking Notes',
      guest_notes: room.note,
      hotel_notes: room.hotelNote,
      housekeeping_notes: room.housekeepingNote,
      callback: function (values) {
        var guest_notes = values[0],
            hotel_notes = values[1],
            housekeeping_notes = values[2];
        uIDialogService.close('booking-notes');
        saveBookingRoomNotes(
          bookingRoomId,
          guest_notes,
          hotel_notes,
          housekeeping_notes,
          bookingStorage
        )
      }
    });
  });
}

var downloadFile = function(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

var mobilecheck = function() {
  var check = false;

  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

SERVER_PATH = window.location.hostname === 'test-domain.com' ? 'http://test-domain.com:3000' : SERVER_PATH;

CodeMirror.defineMode("liquid", function(config, parserConfig) {
  function chain(stream, state, f) {
    state.tokenize = f;
    return f(stream, state);
  }

  // Used as scratch variables to communicate multiple values without
  // consing up tons of objects.
  var type, content;
  function ret(tp, style, cont) {
    type = tp; content = cont;
    return style;
  }

  function liquidTokenBase(stream, state) {
    var ch = stream.next();
    if (/[\s]/.test(ch)) {
      return ret("whitespace", "liquid-whitespace");
    }
    else if (state.liquidMode == "output-markup" && ch == '}' && stream.eat('}')) {
      state.tokenize = nonLiquid;
      return ret("}}");
    }
    else if (state.liquidMode == "tag-markup" && ch == '%' && stream.eat('}')) {
      state.tokenize = nonLiquid;
      return ret("%}");
    }
    else if (ch == '"' || ch == "'")
      return chain(stream, state, liquidTokenString(ch));
    else if (/[\.,:\|\[\]]/.test(ch))
      return ret(ch);
    else if (/\d/.test(ch)) {
      stream.match(/^\d*(?:\.\d*)?/);
      return ret("number", "liquid-atom");
    }
    else {
      stream.eatWhile(/[\w_?<>=]/);
      var word = stream.current();
      return ret("word", "liquid-word", word);
    }

  }

  function liquidTokenString(quote) {
    return function(stream, state) {
      if (!nextUntilUnescaped(stream, quote))
        state.tokenize = liquidTokenBase;
      return ret("string", "liquid-string");
    };
  }

  function nextUntilUnescaped(stream, end) {
    var escaped = false, next;
    while ((next = stream.next()) != null) {
      if (next == end && !escaped)
        return false;
      // Liquid does not seem to have string quote escaping
      escaped = !escaped && next == "abc";
    }
    return escaped;
  }

  function nonLiquid(stream, state) {
    var ch = stream.next();
    state.liquidMode = null;
    if (ch == '{') {
      if (stream.eat('%')) {
        state.tokenize = liquidTokenBase;
        state.liquidMode = "tag-markup";
        return ret("{%", "liquid-markup-delimiter");
      }
      else if (stream.eat('{')) {
        state.tokenize = liquidTokenBase;
        state.liquidMode = "output-markup";
        return ret("{{", "liquid-markup-delimiter");
      }
    }
    stream.eatWhile(/[^{]/);
    return null;
  }


  function parseLiquid(state, type, content, stream) {
    var cc = state.cc;
    // Communicate our context to the combinators.
    // (Less wasteful than consing up a hundred closures on every call.)
    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc;

    while(true) {
      var combinator = cc.length ? cc.pop() : liquidMarkup;
      if (combinator(type, content)) {
        // Immediately work off any autocompletion objects on the stack
        while(cc.length && cc[cc.length - 1].ac)
          cc.pop()();

        if (cx.marked) return cx.marked;
        return null;
      }
    }
  }

  // Combinator utils

  var cx = {state: null, column: null, marked: null, cc: null};
  function pass() {
    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
  }
  function cont() {
    pass.apply(null, arguments);
    return true;
  }

  // Combinators

  function expect(wanted, marker, wantedValue) {
    return function expecting(type, value) {
      if (type == wanted && (typeof(value) == "undefined" || value == wantedValue)) {
        if (typeof(marker) == 'string') cx.marked = marker;
        return cont();
      }
      else return cont(arguments.callee);
    };
  }

  function markAc(type) {
    var result = function() {
      var state = cx.state;
      state.ac = type;
      pass(unmarkAc);
    };
    result.ac = true;

    return result;
  }

  function unmarkAc() {
    cx.state.ac = null;
  }

  function liquidMarkup(type) {
    if (type == "{{") return cont(markAc('variable'), expression, maybeFilters, expect("}}", "liquid-markup-delimiter"));
    if (type == "{%") return cont(markAc('tag'), tagName, expect("%}", "liquid-markup-delimiter"));
    return cont();
  }

  var endTag = /^end[\w]+$/;
  var zeroArgTags = {"live": true, "footer": true, "comment": true};

  function tagName(type, value) {
    if (type == "word") {
      if (endTag.test(value)) {
        cx.marked = "liquid-endtag-name";
      }
      else {
        cx.marked = "liquid-tag-name";
        if (value == "include") return cont(expression, maybeIncludeArgs);
        if (value == "cycle") return cont(maybeCycleName, commasep(expression, "%}", true));
        if (value == "if" || value == "unless") return cont(markAc('variable'), expression, maybeOperator);
        if (value == "capture") return cont(expression);
        if (value == "for") return cont(expression, expect("word", "liquid-keyword", "in"), markAc('variable'), expression, maybeForArgs);
        if (value == "assign") return cont(expression, expect('word', "liquid-operator", "="), markAc('variable'), expression);
        if (zeroArgTags.hasOwnProperty(value)) return cont();
      }
    }
    return cont();
  }

  function maybeForArgs(type, value) {
    if (type == 'word' && value == 'reversed') {
      cx.marked = "liquid-keyword";
      return cont(maybeTagAttributes);
    }
    return pass(maybeTagAttributes);
  }

  function maybeTagAttributes(type) {
    if (type == "word") {
      cx.marked = "liquid-tag-attribute-name";
      return cont(expect(":"), expression, maybeTagAttributes);
    }
    return pass();
  }

  function expression(type) {
    if (type == 'word') {
      cx.marked = "liquid-variable";
      return cont(maybeMethod);
    }
    return cont();
  }

  function maybeMethod(type) {
    if (type == '.') return cont(markAc('method'), method, maybeMethod);
    if (type == '[') return cont(expression, expect(']'), maybeMethod);
    return pass();
  }

  function method(type) {
    if (type == 'word') {
      cx.marked = "liquid-method";
    }
    return cont();
  }

  var operators = {"<": true, ">": true, "<=": true, ">=": true, "==": true, "contains": true, "and": true, "or": true};

  function maybeOperator(type, value) {
    if (operators.hasOwnProperty(value)) {
      cx.marked = "liquid-operator";
      return cont(markAc('variable'), expression, maybeOperator);
    }
    return pass();
  }

  function maybeCycleName() {
    // Liquid's cycle interprets its first argument as the cycle name if it is follow by a :.
    // In order to separate between a non-name variable argument and the name argument, we
    // do a look-ahead here.
    // If we find a : after our current position, the current expression is the cycle name.
    if (cx.stream.match(/\s*:/, false)) {
      cx.stream.match(/\s*/);
      cx.marked = "liquid-tag-cycle-name";
      return cont(expect(':'));
    }
    return pass();
  }

  function maybeIncludeArgs(type, value) {
    if (type == 'word') {
      if (value == 'for' || value == 'with') {
        cx.marked = "liquid-keyword";
        return cont(expression);
      }
    }
    return pass();
  }

  function maybeFilters(type) {
    if (type == '|') return cont(markAc('filter'), filterName, maybeFilterArgs, maybeFilters);
    return pass();
  }

  function filterName() {
    cx.marked = "liquid-filter";
    return cont();
  }

  function maybeFilterArgs(type) {
    if (type == ':') return cont(commasep(expression, {"}}": true, "|": true}, true));
    return pass(maybeFilters);
  }

  function commasep(what, end, doNotEat) {
    function checkForEnd(type) {
      return (typeof(end) == "string" && type == end) || (typeof(end) == "object" && end.hasOwnProperty(type));
    }
    function proceed(type) {
      if (type == ",") return cont(what, proceed);
      if (checkForEnd(type)) return doNotEat ? pass() : cont();
      return cont(expect(end));
    }
    return function commaSeparated(type) {
      if (checkForEnd(type)) return doNotEat ? pass() : cont();
      else return pass(what, proceed);
    };
  }

  return {
    startState: function() {
      return {
        tokenize: nonLiquid,
        cc: [],
        liquidMode: null,
        ac: null
      }
    },

    resetState: function(state) {
      state.tokenize = nonLiquid;
      state.cc = [];
      state.liquidMode = null;
      state.ac = null;
      return state;
    },

    token: function(stream, state) {
      type = null;

      // Liquid markup cannot span multiple lines
      if (stream.sol()) this.resetState(state);

      var style = state.tokenize(stream, state);

      // If we have found liquid markup, we always set some common CSS classes, so we can make use
      // of the style cascade.
      if (state.liquidMode != null) {
        style = (style || "") + " liquid liquid-" + state.liquidMode;
      }

      // No parsing necessary for white space inside liquid markup or when did not detect any liquid markup.
      if (type == "whitespace" || type == null) return style;

      var parseType = parseLiquid(state, type, content, stream);

      return (style || "") + " " + (parseType || "");
    }
  };
});
CodeMirror.defineMIME("application/x-liquid-template", "liquid");

CodeMirror.defineMode("htmlmixedliquid", function(config, parserConfig) {
  return CodeMirror.overlayParser(CodeMirror.getMode(config, parserConfig.backdrop || "text/html"), CodeMirror.getMode(config, parserConfig.overlay || "application/x-liquid-template"));
});

// Compatibility with CodeMirror's formatting addon
if (CodeMirror.modeExtensions){
  CodeMirror.modeExtensions["htmlmixedliquid"] = CodeMirror.modeExtensions["htmlmixed"];

  // If the current mode is 'htmlmixed', returns the extension of a mode located at
  // the specified position (can be htmlmixed, css or javascript). Otherwise, simply
  // returns the extension of the editor's current mode.
  CodeMirror.defineExtension("getModeExtAtPos", function (pos) {
    var token = this.getTokenAt(pos);
    if (token && token.state && token.state.mode)
      return CodeMirror.modeExtensions[token.state.mode == "html" ? "htmlmixed" : token.state.mode];
    else
      if (token && token.state && token.state.base && token.state.base.mode)
        return CodeMirror.modeExtensions[token.state.base.mode == "html" ? "htmlmixed" : token.state.base.mode];
      else
        return this.getModeExt();
  });

}

CodeMirror.defineExtension("commentRangeLiquid", function (isComment, from, to) {
  var curMode = this.getModeExtAtPos(this.getCursor());
  if (isComment) { // Comment range
    var commentedText = this.getRange(from, to);
    this.replaceRange("{% comment %}" + this.getRange(from, to) + "{% endcomment %}"
      , from, to);
    if (from.line == to.line && from.ch == to.ch) { // An empty comment inserted - put cursor inside
      this.setCursor(from.line, from.ch + "{% comment %}".length);
    }
  }
  else { // Uncomment range
    var selText = this.getRange(from, to);
    var startIndex = selText.indexOf("{% comment %}");
    var endIndex = selText.lastIndexOf("{% endcomment %}");
    if (startIndex > -1 && endIndex > -1 && endIndex > startIndex) {
      // Take string till comment start
      selText = selText.substr(0, startIndex)
      // From comment start till comment end
        + selText.substring(startIndex + "{% comment %}".length, endIndex)
      // From comment end till string end
        + selText.substr(endIndex + "{% endcomment %}".length);
    }
    this.replaceRange(selText, from, to);
  }
});

(function () {
  "use strict";

  angular
    .module(
      'buuqit',
      [
        'rails',
        'ngRoute',
        'ngCookies',
        'route-segment',
        'view-segment',
        'LocalStorageModule',
        'ui.bootstrap',
        'ui.mask',
        'ng-context-menu',
        'ngSanitize',
        'angularPayments',
        'summernote',
        'AngularGM',
        'slugifier',
        'dndLists',
        'ngMaterial',
        'ui.tree',
        'ui.codemirror'
      ]
    );
}());

angular
  .module('buuqit')
  .service('Dates', Dates);

Dates.$inject = ["$rootScope"];

function Dates ($rootScope) {
  if (!$rootScope.currentDate) {
    $rootScope.currentDate = new Date(new Date().setHours(0,0,0,0));
    if (new Date().getHours() < 4) {
      $rootScope.currentDate = new Date(moment(new Date()).subtract(1, 'day').toDate().setHours(0,0,0,0));
    }
  }

  var self = this,
      today = moment($rootScope.currentDate);

  this.startDate    = angular.copy(today).subtract(20, 'days');
  this.startDatePos = this.startDate.diff(today, 'day');
  this.endDate      = angular.copy(today).add(24, 'days');
  this.endDatePos   = this.endDate.diff(today, 'day');
  this.dates        = [];


  this.get = function () {
    return this.dates;
  };


  this.init = function () {
    var pinDate = angular.copy(this.startDate),
        date;

    while (pinDate < this.endDate) {
      date = angular.copy(pinDate.toDate());
      self.dates.push({
        date: date,
        note: null,
        date_string: String(date)
      });
      pinDate.add(1, 'day');
    }
  };


  this.load = function (currentDate, direction, count, callback) {
    var startDate = moment(this.dates[currentDate].date),
        pinDate   = angular.copy(startDate),
        step      = 0,
        dateMethod = direction === -1 ? 'subtract' : 'add',
        arrayMethod = direction === -1 ? 'unshift' : 'push',
        self = this;

    while (step < count) {
      pinDate[dateMethod](1, 'day');
      self.dates[arrayMethod]({ date: angular.copy(pinDate.toDate()), note: null });
      step++;
    }

    this.startDate = moment(this.dates[0].date);
    this.startDatePos = this.startDate.diff(today, 'day');
    this.endDate = moment(this.dates[this.dates.length - 1].date);
    this.endDatePos = this.endDate.diff(today, 'day');

    if (typeof(callback) == 'function') {
      callback.apply(this);
      $rootScope.$broadcast('Dates:loaded');
    }
  };


  this.setNote = function(note) {
    var index = this.slotOfDay(note.date);
    if (this.dates[index]) {
      this.dates[index].note = note.note;
      $rootScope.$broadcast('Dates:update', this.dates[index]);
    }
  };


  this.removeNote = function(note) {
    var index = this.slotOfDay(note.date);
    if (this.dates[index]) {
      this.dates[index].note = null;
      $rootScope.$broadcast('Dates:update', this.dates[index]);
    }
  };


  this.slotOfDay = function (pinDay) {
    if (typeof(pinDay) != 'string') {
      pinDay = moment(pinDay).format('YYYY-MM-DD');
    }

    var momentPin = moment(pinDay);

    return momentPin.diff(this.startDate, 'days');
  };


  $rootScope.$on('scheduler:changeDate', function() {
    today = moment(moment().format('YYYY-MM-DD'));
    self.startDatePos = self.startDate.diff(today, 'day');
    self.endDatePos = self.endDate.diff(today, 'day');
  });


  this.init();
}

angular
  .module('buuqit')
  .service('RoomBuilderService', RoomBuilderService);

RoomBuilderService.$inject = ['$rootScope', 'BookingRoomService', 'RoomCalculator'];

function RoomBuilderService($rootScope, BookingRoomService, RoomCalculator) {
  function Service(restrictionsService) {
    this.restrictionsService = restrictionsService;

    // hack, deps injected later in controllers: problem - room builded earlier then booking and blocked_rooms available
    // looks like blocked_rooms usages can be refactored to booking.rooms
    // booking object can be injected from above layer to controller scope
    this.booking = null;
    this.blockedRooms = null;
  }

  _.extend(Service.prototype, {
    buildInitialRoom: function (roomId, dateIn, dateOut) {
      var initialRoom = findInitialRoom(roomId);

      this.roomTemplate = buildRoomTemplateByRoomTypeId(initialRoom, dateIn, dateOut);

      var room = angular.copy(this.roomTemplate);
      var index = 0;

      room.room_name = initialRoom.number;
      room.room_id = initialRoom.id;

      room.$service = BookingRoomService.build(room, this.booking, this.restrictionsService, index, this.blockedRooms);

      var _this = this;

      return room.$service.initRoom().then(function () {
        return {
          initialRoom: room,
          roomTemplate: _this.roomTemplate
        }
      });
    },

    buildRoom: function(index, initialAttributes) {
      var room = buildRoomTemplateByRoomTypeId(initialAttributes, initialAttributes.checkin_date, initialAttributes.checkout_date);

      room.$service = BookingRoomService.build(room, this.booking, this.restrictionsService, index, this.blockedRooms);

      _.assign(room, initialAttributes);

      return room.$service.initRoom().then(function () {
        return room;
      });
    },
  });

  var findInitialRoom = function (roomId) {
    return $rootScope.hotel.rooms.filter(function(room) { return room.id == roomId; })[0];
  };

  var buildRoomTemplateByRoomTypeId = function (initialAttributes, dateIn, dateOut) {
    var roomTypeId = initialAttributes.roomTypeId;

    var rateCategoryId = initialAttributes.rateCategoryId;
    var rateCategory = $rootScope.hotel.rateCategories.filter(function(rateCategory) { return rateCategory.id == rateCategoryId; })[0];

    var cancellationPolicyId = initialAttributes.cancellation_policy_id;

    var roomType = $rootScope.hotel.roomTypes.filter(function(roomType) { return roomType.id == roomTypeId; })[0];
    var numberOfAdults = roomType.defaultAdultsCount;
    var numberOfChildren = roomType.defaultChildrenCount;

    var roomRepresentations = $rootScope.hotel.roomRepresentations.filter(function (e) { return e.roomTypeId == roomTypeId });
    var roomRepresentationIds = roomRepresentations.map(function (rr) { return rr.id; });
    var roomRepresentation = roomRepresentations.filter(function (roomRepresentation) { return roomRepresentation.coverRoomTypeId == null; })[0];
    var roomRepresentationId = roomRepresentation.id;

    var roomRates = $rootScope.hotel.roomRates
      .filter(function(roomRate) { return roomRepresentationIds.indexOf(roomRate.roomRepresentationId) !== -1 && roomRate.isRemoved == false });

    var rateCategoryIds = roomRates.map(function(roomRate) { return roomRate.rateCategoryId });
    var rateCategories = $rootScope.hotel.rateCategories
      .filter(function(el) { return rateCategoryIds.indexOf(el.id) !== -1 });

    if (typeof(rateCategoryId) == 'undefined' || typeof(rateCategory) == 'undefined')
    {
      var rateCategory = rateCategories.filter(function(el) { return el.isBaseRate })[0];
      if (!rateCategory) {
        rateCategory = rateCategories[0];
      }
      var rateCategoryId = rateCategory ? rateCategory.id : null;
    }

    var applicableRoomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {
      return roomRate.roomRepresentationId == roomRepresentation.id
        && roomRate.maxAdults >= Number(numberOfAdults)
        && roomRate.maxChildren >= Number(numberOfChildren)
        && roomRate.rateCategoryId === rateCategoryId
        && roomRate.isRemoved === false;
    });

    var roomRate = applicableRoomRates[0];
    if (typeof(cancellationPolicyId) == 'undefined' && roomRate) {
      cancellationPolicyId = roomRate.cancellationPolicyId;
    }

    var roomTemplate = {
      available: true,
      room_name: null,
      opened_in: false,
      opened_out: false,
      total_price: 0,
      maxDates: 30,

      checkin_date: dateIn,
      checkin_time: null,
      checkout_date: dateOut,
      min_checkout_date: moment(dateIn).add(1, 'day').toDate(),
      max_checkout_date: dateOut,

      number_of_nights: RoomCalculator.calcNigthsCount(dateIn, dateOut),
      number_of_adults: numberOfAdults,
      number_of_children: numberOfChildren,

      roomType: roomType,
      roomTypeId: roomType.id,
      room_id: null,

      rateCategory: rateCategory,
      rateCategoryId: rateCategoryId,

      roomRepresentation: roomRepresentation,
      roomRepresentationId: roomRepresentationId,
      applicableRoomRates: applicableRoomRates,
      roomRate: roomRate,

      cancellation_policy_id: cancellationPolicyId,

      hotel_id: $rootScope.hotel.id,

      dont_move: false,
      note: null,

      nights_select: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],

      guest: {
        title: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        hotel_id: $rootScope.hotel.id
      },

      isGuestDirty: false
    };

    return roomTemplate;
  };

  return {
    build: function (restrictionsService) {
      return new Service(restrictionsService);
    }
  }
}
angular
  .module('buuqit')
  .service('RestrictionsService', RestrictionsService);

RestrictionsService.$inject = ['RestrictionStorage'];

function RestrictionsService(RestrictionStorage) {
  function Service() {
    this.byRoomRate = {};
  }

  Service.prototype.load = function (roomRateIds, dateIn, dateOut) {
    var _this = this;

    if (!_.isArray(roomRateIds)) {
      roomRateIds = [roomRateIds];
    }

    if (this._isAlreadyLoaded(roomRateIds, dateIn, dateOut)) {
      return Promise.resolve();
    }

    return RestrictionStorage.load(dateIn, dateOut)
      .then(function (restrictions) {
        _this.byRoomRate = restrictions;
      })
  };

  Service.prototype._isAlreadyLoaded = function (roomRateIds, dateIn, dateOut) {
    var _this = this;

    if (Object.keys(this.byRoomRate).length === 0) {
      return false;
    }

    var isAllDatesHaveRestrictions = true;
    var daysDiff = moment(dateOut).diff(moment(dateIn), 'days');

    // "for" used for "break"
    for (var i = 0; i <= daysDiff; i++) {
      for (var j = 0; j < roomRateIds.length; j++) {
        var roomRateId = roomRateIds[j];

        if (_this.byRoomRate[roomRateId][moment(dateIn).add(i, 'days').format('YYYY-MM-DD')] === undefined) {
          isAllDatesHaveRestrictions = false;
          break;
        }
      }

      if (!isAllDatesHaveRestrictions) {
        break;
      }
    }

    return isAllDatesHaveRestrictions
  };

  return {
    build: function() {
      return new Service();
    }
  }
}


angular
  .module('buuqit')
  .service('BookingRoomService', BookingRoomService);

BookingRoomService.$inject = ['$rootScope', '$timeout', '$i18next', 'RoomCalculator', 'AvailabilityChecker'];

function BookingRoomService($rootScope, $timeout, $i18next, RoomCalculator, AvailabilityChecker) {
  function Service(room, booking, restrictionsService, roomIndex, blockedRooms) {
    this.room = room;
    this.booking = booking;
    this.restrictionsService = restrictionsService;
    this.blockedRooms = blockedRooms;
    this.roomIndex = roomIndex;

    this.closedRooms = [];
    this.recommendedMaxAdults = 0;
    this.recommendedMaxChildren = 0;

    this.hotelCoverRoomTypes = (function() {
      var out = [];

      $rootScope.hotel.roomTypes.forEach(function(rt) {
        out.push({
          id: rt.id,
          title: rt.shortName,
          room_type_id: rt.id
        });
      });

      $rootScope.hotel.coverRoomTypes.forEach(function(rt) {
        out.push({
          id: 's' + rt.id,
          title: rt.name + ' ' + $i18next.t("bookings.create_booking.booking_form.virtual_js_str"),
          room_type_id: rt.roomTypeId
        });
      });

      return out;
    })();

    this.hotelRooms = angular.copy(
      $rootScope.hotel.rooms
    );

    this.hotelRateCategories = angular.copy(
      $rootScope.hotel.rateCategories.filter(function(el) { return el.isRemoved === false })
    );

    this.hotelRoomRates = $rootScope.hotel.roomRates.filter(function(el) { return el.isRemoved === false });
    this.hotelRoomTypes = $rootScope.hotel.roomTypes;
  }

  _.extend(Service.prototype, {
    getRateCategories: function () {
      var room = this.room;

      var rateCategoryIds = _.uniq(
        this.hotelRoomRates
          .filter(function(el) {
            return el.roomRepresentationId === room.roomRepresentation.id
          })
          .map(function(el) {
            return el.rateCategoryId;
          })
      );

      var applicableRateCategoryIds = _.uniq(
        room.applicableRoomRates.map(function(el) { return el.rateCategoryId; })
      );

      var rateCategories = this.hotelRateCategories.filter(function(rate) {
        return rateCategoryIds.indexOf(rate.id) > -1;
      });

      rateCategories.forEach(function(el) {
        el.applicable = applicableRateCategoryIds.indexOf(el.id) === -1 ? 0 : 1;
      });

      return _.sortBy(rateCategories, function(rate) { return rate.applicable * -1; });
    },

    getRooms: function () {
      if (!this.booking) {
        throw 'booking is required';
      }

      var room = this.room;

      var notBlockedRooms = this.hotelRooms.filter(this._notBlockedRoomFilter.bind(this));

      notBlockedRooms = notBlockedRooms
        .map(function(el) {
          el.applicable = Number(el.roomTypeId == Number(room.roomTypeId));

          return el;
        })
        .sort(function(a, b) {
          return (a.applicable - b.applicable) * -1;
        });

      return notBlockedRooms;
    },

    getCoverRoomTypes: function () {
      return this.hotelCoverRoomTypes.filter(this._notBlockedCoverRoomTypesFilter.bind(this));
    },

    getRecommendedMaxAdults: function () {
      return this.recommendedMaxAdults;
    },

    getRecommendedMaxChildren: function () {
      return this.recommendedMaxChildren;
    },

    // both checkin and checkout date set, we need to calc/fetch other values based on these dates
    handleRoomDatesChange: function () {
      var room = this.room;

      var checkinDate = room.checkin_date;
      var checkoutDate = room.checkout_date;

      room.min_checkout_date = moment(checkinDate).add(1, 'day').toDate();

      var diff = moment(checkoutDate).diff(moment(checkinDate), 'days');

      if (diff > 0 && diff <= room.maxDates) {
        if (room.number_of_nights != diff) {
          room.number_of_nights = diff;
        }
      }

      return this._processDatesChange();
    },

    handleRoomCheckinDateChange: function () {
      var val = this.room.checkin_date;

      this.room.checkout_date = moment(val).add(this.room.number_of_nights, 'days').toDate();
      this.room.min_checkout_date = moment(val).add(1, 'day').toDate();

      return this._processDatesChange();
    },

    handleRoomCheckoutDateChange: function () {
      var room = this.room;

      var val = room.checkout_date;

      var diff = moment(val).diff(moment(room.checkin_date), 'days');

      if (diff > 0 && diff <= room.maxDates) {
        if (room.number_of_nights != diff) {
          room.number_of_nights = diff;
        }
      }

      return this._processDatesChange();
    },

    handleNumberOfNightsChange: function () {
      var room = this.room;

      var out = moment(room.checkin_date).add(room.number_of_nights, 'days').toDate();

      if (out != room.checkout_date) {
        room.checkout_date = out;
      }

      return this._processDatesChange();
    },

    _processDatesChange: function () {
      this._checkAvailability();

      var _this = this;

      return this._loadRestrictions()
        .then(function () {
          return _this._setApplicableRoomRates();
        })
        .then(function () {
          return _this.resetNightPrices();
        });
    },

    handleRoomTotalForeignAmountChange: function () {
      var room = this.room;
      var currencyRate = this.booking.foreignCurrencyRate;
      var total = room.total_foreign_amount;
      var count = room.nights.length;
      var per_day = Math.floor(total / count);
      var correct = Math.round((total % count) * 100) / 100;

      _.each(room.nights, function(night) {
        night.foreignAmount = per_day;
        night.price = per_day * currencyRate;
      });

      if (room.nights[0]) {
        room.nights[0].foreignAmount = room.nights[0].foreignAmount + correct;
        this.room.nights[0].price = room.nights[0].foreignAmount * currencyRate;
      }

      this.room.total_price = total * currencyRate;
    },

    handleRoomTotalPriceChange: function () {
      var room = this.room;

      var total = room.total_price;
      var count = room.nights.length;
      var per_day = Math.floor(total / count);
      var correct = Math.round((total % count) * 100) / 100;

      _.each(room.nights, function(night) {
        night.price = per_day;
      });

      if (room.nights[0]) {
        room.nights[0].price = room.nights[0].price + correct;
      }
    },

    initRoom: function () {
      var bookingLoading = document.getElementsByClassName('booking__loading')[0];
      bookingLoading.classList.add('visible');
      var _this = this;

      this._ensureRoomTypeAndCoverSet();
      this._setRoomRepresentationFromCoverRoomType();
      this._checkAvailability();
      this._setRoomRate();

      return this._loadRestrictions()
        .then(function () {
          return _this._setApplicableRoomRates();
        })
        .then(function () {
          return _this.handleRateCategoryChange();
        })
        .then(function () {
          bookingLoading.classList.remove('visible');
        });
    },

    _ensureRoomTypeAndCoverSet: function () {
      var roomTypeId = this.room.roomTypeId;

      if (!this.room.roomType) {
        this.room.roomType = this.hotelRoomTypes.filter(function (el) { return el.id == roomTypeId })[0];
      }

      if (!this.room.cover_room_type) {
        this.room.cover_room_type = this.hotelCoverRoomTypes.filter(function (el) { return el.id == roomTypeId })[0];
      }
    },

    _loadRestrictions: function () {
      var room = this.room;
      return this.restrictionsService.load(
        ((typeof(room.roomRate) == 'undefined') ? [] : room.roomRate.id),
        moment(room.checkin_date).format('YYYY-MM-DD'),
        moment(room.checkout_date).format('YYYY-MM-DD')
      );
    },

    setRateCategoryById: function () {
      if (this.isRateCategoryApplicable()) {
        var roomRateCategoryId = this.room.rateCategoryId;

        this.room.rateCategory = this.getRateCategories().filter(function (rateCategory) { return rateCategory.id == roomRateCategoryId })[0];
      } else {
        this._setBaseRateCategory();
      }
    },

    handleRateCategoryChange: function () {
      this._setRoomRate();

      var _this = this;

      return this.resetNightPrices()
        .then(function () {
          return _this._checkAvailability();
        })
        .then(function () {
          $rootScope.$broadcast('create-booking-room-rate-changed');
        });
    },

    isRateCategoryApplicable: function () {
      var rateCategoryIds = this.getRateCategories().map(function (rateCategory) { return rateCategory.id });

      return rateCategoryIds.indexOf(this.room.rateCategoryId) !== -1;
    },

    handleRoomNightPriceChange: function () {
      var room = this.room;

      RoomCalculator.calcTotalPerRoom(room);
    },

    resetNightPrices: function () {
      var room = this.room;

      if (!room || !room.roomRate) {
        return Promise.resolve();
      }

      return RoomCalculator.fillNights(
        this.restrictionsService.byRoomRate,
        room.number_of_nights,
        room.checkin_date,
        room.roomRate.id,
        room.roomRate,
        $rootScope.hotel,
        this.booking
      )
        .then(function(result) {
          room.nights = result;

          RoomCalculator.calcTotalPerRoom(room);
        });
    },

    handleRoomIdChange: function () {
      var room = this.room;

      this.room.room_id = Number(this.room.room_id);

      var selectedRoom = this.hotelRooms.filter(function (hotelRoom) { return hotelRoom.id == room.room_id })[0];

      if (selectedRoom.roomTypeId != room.roomTypeId) {
        room.roomType = this.hotelRoomTypes.filter(function(el) {
          if (el.id == parseInt(selectedRoom.roomTypeId)) {
            return el;
          }
        })[0];
        room.roomTypeId = room.roomType.id;
        room.cover_room_type = this.hotelCoverRoomTypes.filter(function(coverRoomType) { return coverRoomType.room_type_id == room.roomType.id})[0];

        return this._processCoverRoomTypeChange();
      }

      if (!room.room_id) {
        return;
      }

      this.blockedRooms[this.roomIndex] = room.room_id;

      room.room_name = selectedRoom.number;

      this._checkAvailability();

      return Promise.resolve();
    },

    handleCoverRoomTypeChange: function () {
      return this._processCoverRoomTypeChange();
    },

    _processCoverRoomTypeChange: function () {
      this._setRoomTypeFromCoverRoomType();
      this._ensureRoomIdMatchRoomType();

      this._setRoomRepresentationFromCoverRoomType();
      this._ensureRoomOccupancyMatchesRoomRepresentation();

      this._setApplicableRoomRates();
      this._setRoomRate(); // based on RoomRepresentation and RateCategory

      var _this = this;

      return this.resetNightPrices()
        .then(function () {
          return _this._checkAvailability();
        })
        .then(function () {
          $rootScope.$broadcast('create-booking-room-rate-changed');
        });
    },

    _setRoomTypeFromCoverRoomType: function () {
      var room = this.room;

      room.roomType = this.hotelRoomTypes.filter(function(el) {
        if (el.id == parseInt(room.cover_room_type.room_type_id)) {
          return el;
        }
      })[0];
      room.roomTypeId = room.roomType.id;
    },

    _setBaseRateCategory: function () {
      var room = this.room;

      var baseRateCategory = this.hotelRateCategories.filter(function(el) {
        return el.isBaseRate;
      })[0];

      room.rateCategory = baseRateCategory;
      room.rateCategoryId = baseRateCategory.id;
    },

    _ensureRoomOccupancyMatchesRoomRepresentation: function () {
      var room = this.room;

      if (Number(room.number_of_adults) > room.roomRepresentation.maxAdults) {
        room.number_of_adults = room.roomRepresentation.maxAdults;
      }

      if (Number(room.number_of_children) > room.roomRepresentation.maxChildren) {
        room.number_of_children = room.roomRepresentation.maxChildren;
      }
    },

    _notBlockedRoomFilter: function (room) {
      if (!room.isActive) return false;
      var _this = this;

      var usedRoomsWithoutCurrent = _this.booking.rooms
        .filter(function(bookingRoom) {
          return bookingRoom.room_id != _this.room.room_id;
        });

      return usedRoomsWithoutCurrent
        .filter(function(room) {
          return !(_this.room.checkin_date >= room.checkout_date || _this.room.checkout_date <= room.checkin_date);
        })
        .map(function(room) {
          return Number(room.room_id);
        })
        .indexOf(room.id) == -1 && _this.closedRooms.indexOf(room.id) == -1;
    },

    _getNotBlockedRoomTypeIds: function () {
      var types = [];
      var closed = _.without(this.closedRooms.concat(this.blockedRooms), this.room.room_id);

      _.each(this.hotelRooms, function(hotelRoom) {
        if (closed.indexOf(hotelRoom.id) == -1 && hotelRoom.isActive) {
          types.push(hotelRoom.roomTypeId);
        }
      });

      return _.uniq(types);
    },

    _notBlockedRoomTypesFilter: function (type) {
      return this._getNotBlockedRoomTypeIds().indexOf(type.id) > -1;
    },

    _notBlockedCoverRoomTypesFilter: function (type) {
      return this._getNotBlockedRoomTypeIds().indexOf(type.room_type_id) > -1;
    },

    _getRoomRates: function (roomRepresentationId) {
      rates = this.hotelRoomRates.filter(function(roomRate) {
        return roomRate.roomRepresentationId === roomRepresentationId;
      });

      if (rates.count == 0) {
        defaultRateCategory = $rootScope.hotel.rateCategories.find(function(rateCategory) {return rateCategory.isBaseRate})
        rates = this.hotelRoomRates.filter(function(roomRate) {
          return roomRate.rateCategoryId === defaultRateCategory.id;
        });
      }
      return rates;
    },

    _setApplicableRoomRates: function () {
      var room = this.room;
      var restrictionsService = this.restrictionsService;

      var roomRates = this._getRoomRates(room.roomRepresentation.id);

      room.applicableRoomRates = roomRates
        .filter(function(roomRate) {
          return roomRate.maxAdults >= Number(room.number_of_adults) &&
            roomRate.maxChildren >= Number(room.number_of_children)
        })
        .filter(function(roomRate) {
          var values = [];

          Object
            .keys(restrictionsService.byRoomRate[roomRate.id])
            .sort()
            .forEach(function(date) {
              var d = new Date(new Date(date).setHours(0,0,0,0));

              if (d >= room.checkin_date && d <= room.checkout_date) {
                values.push(restrictionsService.byRoomRate[roomRate.id][date]);
              }
            });

          return values[values.length - 1] && values[values.length - 1].closedToDeparture == false
            && values[0].closedToArrival == false
            && values[0].minStayArrival <= Number(room.number_of_nights)
            && (values[0].maxStay >= Number(room.number_of_nights) || values[0].maxStay == 0)
            && values.slice(0, values.length - 1).map(function(el) { return el.stopSell; }).reduce(function(out, el) {
              return out && el == false;
            }, true)
            && values.slice(0, values.length - 1).map(function(el) { return el.minStayThrough; }).reduce(function(out, el) {
              return out && el <= Number(room.number_of_nights);
            }, true);
        });
    },

    _setRoomRate: function () {
      var room = this.room;

      var roomRatesFromGetRoomRates = this._getRoomRates(room.roomRepresentation.id);
      roomRates = roomRatesFromGetRoomRates.filter(function (roomRate) {
        return roomRate.rateCategoryId === room.rateCategoryId;
      });

      if (roomRates.length == 0) {
        roomRates = roomRatesFromGetRoomRates;
      }

      this.recommendedMaxAdults = Math.max.apply(Math,
        roomRates.map(function(el) { return el.maxAdults })
      );

      this.recommendedMaxChildren = Math.max.apply(Math,
        roomRates.map(function(el) { return el.maxChildren })
      );

      var roomRatesWithOccupancy = roomRates.filter(function (el) {
        return el.maxAdults === Number(room.number_of_adults)
          && el.maxChildren === Number(room.number_of_children);
      });

      if (roomRatesWithOccupancy.length === 0 && $rootScope.hotel.addons.useNearestOccupancy === true) {
        var occ = Number(room.number_of_adults) + Number(room.number_of_children);

        roomRatesWithOccupancy = roomRates
          .filter(function(el) {
            return el.maxAdults + el.maxChildren >= occ;
          })
          .sort(function(a, b) {
            return Math.abs(a.maxAdults + a.maxChildren - occ) - Math.abs(b.maxAdults + b.maxChildren - occ);
          });
      }

      if (roomRatesWithOccupancy.length === 0) {
        roomRatesWithOccupancy = roomRates.filter(function(el) {
          return el.maxAdults === Number(room.number_of_adults);
        });
      }

      if (roomRatesWithOccupancy.length > 0) {
        room.roomRate = roomRatesWithOccupancy[0];
        room.rateCategoryId = room.roomRate.rateCategoryId;
      } else {
        room.roomRate = roomRates
          .sort(function(a, b) {
            var av = [a.maxAdults, a.maxChildren];
            var bv = [b.maxAdults, b.maxChildren];

            if (av > bv) { return -1; }
            if (av < bv) { return 1; }

            return 0
          })[0];
      }

      if (room.roomRate) {
        room.cancellation_policy_id = room.roomRate.cancellationPolicyId;
      }
    },

    _ensureRoomIdMatchRoomType: function () {
      var room = this.room;

      if (!room.room_id) {
        return;
      }

      var currentRoomId = room.room_id;
      var hotelRoom = this.hotelRooms.filter(function (hotelRoom) { return hotelRoom.id == currentRoomId })[0];

      if (hotelRoom.roomTypeId != room.roomType.id) {
        room.room_id = null;
      }
    },

    _setRoomRepresentationFromCoverRoomType: function () {
      var room = this.room;

      var coverRoomTypeId = typeof(room.cover_room_type.id) === 'number'
        ? null
        : Number(room.cover_room_type.id.replace('s', ''));

      room.roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(roomRepresentation) {
        return roomRepresentation.roomTypeId == room.roomTypeId &&
          roomRepresentation.coverRoomTypeId == coverRoomTypeId
      })[0];

      room.roomRepresentationId = room.roomRepresentation.id;
    },

    _checkAvailability: function () {
      var room = this.room;

      var availability = AvailabilityChecker.checkAvailability(
        room.room_id,
        room.checkin_date,
        room.number_of_nights
      );

      if (availability.closed.indexOf(room.room_id) > -1) {
        room.room_id = null;

        var notBlockedRoomTypeIds = this.hotelRoomTypes
          .filter(this._notBlockedRoomTypesFilter.bind(this))
          .map(function (roomType) { return roomType.id; });

        if (notBlockedRoomTypeIds.indexOf(room.roomType.id) == -1) {
          room.roomType = null;
          room.roomTypeId = null;
        }
      }

      this.closedRooms = availability.closed;

      room.maxDates = availability.diff;
      room.nights_select = [];

      for (var x = 1; x <= availability.diff; x++) {
        room.nights_select.push(x);
      }

      room.available = availability.available;
      room.max_checkout_date = moment(room.checkin_date).add(availability.diff, 'days').toDate();
    }
  });

  return {
    build: function(room, booking, restrictionsService, roomIndex, blockedRooms) {
      return new Service(room, booking, restrictionsService, roomIndex, blockedRooms);
    }
  }
}

angular
  .module('buuqit')
  .factory('Reports.Token', TokenFactory);

TokenFactory.$inject = ["railsResourceFactory", "$http"];

function TokenFactory(railsResourceFactory, $http) {

  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/{{reportType}}",
    name: "token"
  });

  resource.prototype.getToken = function (params) {
    return $http({
      method: 'GET',
      url: this.$url() + '/token',
      headers: {
        'Accept': 'application/json'
      },
      params: params
    });
  };

  return resource;
}
angular
  .module('buuqit')
  .factory('Reports.StatisticalReportIsFactory', StatisticalReportIsFactory);

StatisticalReportIsFactory.$inject = ["$rootScope", "railsResourceFactory"];

function StatisticalReportIsFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/local/statistical_report_is",
    name: "report"
  });

  resource.prototype.get = function (month, type) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        month: month,
        type: type
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.ReservationReport', ReservationReportFactory);

ReservationReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ReservationReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/reservation_report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.RatePlanReport', RatePlanReportFactory);

RatePlanReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function RatePlanReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/rate_plan_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.PoliceReport', PoliceReportFactory);

PoliceReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function PoliceReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/police_report"
  });

  resource.prototype.get = function (dateFrom, dateTo) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.PerformanceChargeReport', PerformanceChargeReportFactory);

PerformanceChargeReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function PerformanceChargeReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/performance_charge_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.OccupancyReport', OccupancyReportFactory);

OccupancyReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function OccupancyReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/occupancy_report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type, excludeBlockers) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        roomType: type,
        excludeBlockers: excludeBlockers
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.MealReport', MealReportFactory);

MealReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function MealReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/meal_report",
    name: "report"
  });

  resource.prototype.get = function (date, extra_id) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        date: date,
        extra_id: extra_id
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.ManagerReport', ManagerReportFactory);

ManagerReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ManagerReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/manager_report"
  });

  resource.prototype.get = function (date) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        date: date
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.InHouseReport', InHouseReportFactory);

InHouseReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function InHouseReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/in_house_report"
  });

  resource.prototype.get = function (date) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        date: date
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.HousekeepingReport', HousekeepingReportFactory);

HousekeepingReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function HousekeepingReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/housekeeping_report"
  });

  resource.prototype.get = function (date) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        date: date
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.FolioReport', FolioReportFactory);

  FolioReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function FolioReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/folio_report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type, filterDateType, showOnlyFailedSendBookkeeping) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type,
        filterDateType: filterDateType,
        showOnlyFailedSendBookkeeping: showOnlyFailedSendBookkeeping
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.ExtrasReport', ExtrasReportFactory);

ExtrasReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ExtrasReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/extras_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo, extra_id) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        extra_id: extra_id
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.EndOfDayReport', EndOfDayReportFactory);

EndOfDayReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function EndOfDayReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/end_of_day_report"
  });

  resource.prototype.get = function (date, dateTo, perUser) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        date: date,
        date_to: dateTo,
        per_user: perUser,
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.DepositReport', DepositReportFactory);

DepositReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function DepositReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/deposit_report"
  });

  resource.prototype.get = function () {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {}
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.DebtorsReport', DebtorsReportFactory);

DebtorsReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function DebtorsReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/debtors_report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type) {
    return this.$http({
      method: 'GET',
      url: this.$url()
    });
  }

  resource.prototype.exportUrl = function () {
    return this.$url() + '?export=true';
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.DailyCheckoutReport', DailyCheckoutReportFactory);

DailyCheckoutReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function DailyCheckoutReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/daily_checkout_report",
    name: "report"
  });

  resource.prototype.get = function (date) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        date: date
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.CreditReport', CreditReportFactory);

CreditReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function CreditReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/daily_credit_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo, properties, paymentType, useField, per_user) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        properties: properties.join(','),
        paymentType: paymentType.join(','),
        useField: useField,
        per_user: per_user
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.CitizenshipReport', CitizenshipReportFactoryA);

CitizenshipReportFactoryA.$inject = ["$rootScope", "railsResourceFactory"];

function CitizenshipReportFactoryA ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/citizenship_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.ChannelReport', ChannelReportFactory);

ChannelReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ChannelReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/channel_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.CancellationReport', CancellationReportFactory);

CancellationReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function CancellationReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/booking_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: 'Cancellation',
        allow_canceled: true
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.BookingWaitlistReport', BookingWaitlistReportFactory);

BookingWaitlistReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BookingWaitlistReportFactory($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/booking_waitlist_report",
    name: "report"
  });

  resource.prototype.get = function (checkin_date, checkout_date) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        checkin_date: checkin_date,
        checkout_date: checkout_date
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.BookingReport', BookingReportFactory);

BookingReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BookingReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/booking_report",
    name: "report"
  });

  resource.prototype.get = function (dateFrom, dateTo, type, source, showCancelled, dueGreaterZero) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type,
        source: source == 'All' ? null : source,
        allow_canceled: showCancelled,
        due_greater_zero: dueGreaterZero
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.AccountingReport', AccountingReportFactory);

AccountingReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function AccountingReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/accounting_report"
  });

  resource.prototype.get = function (dateFrom, dateTo) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .directive('shortCode', shortCode);

shortCode.$inject = [];

function shortCode () {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$validators.shortCode = function(modelValue, viewValue) {
        var roomTypes = [];
        if (scope.$root.hotel && scope.$root.hotel.roomTypes) {
          roomTypes = scope.$root.hotel.roomTypes.filter(function(room_type) {return room_type.id != scope.value.id;}).map(function (room_type) {return room_type.shortCode;});
        }

        return roomTypes.indexOf(modelValue) == -1
      };
    }
  };
}

angular
  .module('buuqit')
  .directive('onScrollNearEnd', onScrollNearEnd);

onScrollNearEnd.$inject = ['$parse'];

function onScrollNearEnd ($parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var threshold = parseInt(attrs.scrollThreshold, 10) || 150;
      var fn = $parse(attrs.onScrollNearEnd);

      if (attrs.scrollResetOn) {
        scope.$watch(attrs.scrollResetOn, function() {
          element[0].scrollTop = 0;
        });
      }

      element.on('scroll', function(event) {
        var el = event.target;
        var scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight;

        if (scrollBottom < threshold) {
          scope.$apply(function() {
            fn(scope);
          });
        }
      });

      scope.$on('$destroy', function() {
        element.off('scroll');
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('monthSelector', monthSelector);

monthSelector.$inject = [];

function monthSelector () {
  return {
    restrict: 'E',
    scope: {
      value:    '=ngModel',
      ngChange: '&'
    },
    templateUrl: getTemplatePath('ui/month_selector.html'),
    link: function (scope) {
      scope.openMenu = function ($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      };


      scope.setMonth = function(month) {
        scope.value = moment(angular.copy(scope.value)).month(month).date(1).toDate();
      };

      scope.prevYear = function(event) {
        event.preventDefault();
        event.stopPropagation();
        scope.value = moment(angular.copy(scope.value)).subtract(1, 'year').toDate();
      };

      scope.nextYear = function(event) {
        event.preventDefault();
        event.stopPropagation();
        scope.value = moment(angular.copy(scope.value)).add(1, 'year').toDate();
      };

      scope.prevMonth = function() {
        scope.value = moment(angular.copy(scope.value)).subtract(1, 'month').toDate();
      };

      scope.nextMonth = function() {
        scope.value = moment(angular.copy(scope.value)).add(1, 'month').toDate();
      };

      scope.currentMonth = function() {
        scope.value = moment(new Date()).date(1).toDate();
      };
    }
  };
}
angular
  .module('buuqit')
  .directive('triggerForm', triggerForm);

triggerForm.$inject = [];

function triggerForm () {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    controller: triggerFormController,
    templateUrl: getTemplatePath('forms/settingsTriggerForm.html')
  };
}


triggerFormController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$filter",
  "$http",
  "TriggersFactory",
];


function triggerFormController ($rootScope, $scope, $i18next, $filter, $http, TriggersFactory) {
  angular.extend(
    $scope,
    {
      saveTriggerEditing: saveTriggerEditing,
    }
  );

  $scope.value.executionConditions = JSON.stringify($scope.value.executionConditions);
  $scope.value.executionTime = String($scope.value.executionTime);

  function saveTriggerEditing(trigger) {
    if (trigger.id) {
      updateTrigger(trigger);
    } else {
      createTrigger(trigger);
    }
  }

  function createTrigger(trigger) {
    var index = $scope.ctrl.triggers.indexOf(trigger);
    trigger = new TriggersFactory(trigger);
    trigger.hotelId = $rootScope.hotel.id;
    if (trigger.reactions)
      trigger.reactionIds = trigger.reactions.map(function(trigger) { return trigger.id });
    trigger.reactions = null;
    trigger.create().then(
      function(response) {
        $scope.ctrl.createTrigger(index, response);
      },
      function(response) {
        var message = Object.keys(response.data.errors)
          .map(function(key) {
            return key + ": " + response.data.errors[key].join(", ");
          })
          .join(". ");
        $rootScope.alert(message);
      }
    );
  }

  function updateTrigger(trigger) {
    var index = $scope.ctrl.triggers.indexOf(trigger);
    if (trigger.reactions)
      trigger.reactionIds = trigger.reactions.map(function(trigger) { return trigger.id });
    trigger.reactions = null;
    trigger.update().then(
      function(response) {
        $scope.ctrl.updateTrigger(index, response);
      },
      function(response) {
        var message = Object.keys(response.data.errors)
          .map(function(key) {
            return key + ": " + response.data.errors[key].join(", ");
          })
          .join(". ");
        $rootScope.alert(message);
      }
    );
  }

}
angular
  .module("buuqit")
  .controller("seasonCalendarController", seasonCalendarController)
  .directive("seasonCalendar", seasonCalendar);

seasonCalendarController.$inject = ["$rootScope", "$scope", "$i18next"];
seasonCalendar.$inject = [];

function seasonCalendarController($rootScope, $scope, $i18next) {
  var self = this;
  var months = "January February March April May June July August September October November December".split(
    " "
  );
  var weekDays = "Sun Mon Tue Wed Thu Fri Sat".split(" ");
  var ranges = [];
  var DEFAULT_COLOR = "AAAAAA";

  $scope.selection_start_date = null;
  $scope.selection_end_date = null;
  $scope.selection_in_progress = false;
  $scope.year = new Date().getFullYear();

  calculateColor = function(date) {
    if (self.ranges && self.ranges.length > 0) {
      var range = self.ranges.filter(function(range) {
        return range.startDate <= date && range.endDate >= date;
      });
      return range && range.length > 0 ? range[0].color : DEFAULT_COLOR;
    } else {
      return DEFAULT_COLOR;
    }
  };

  getContrastColor = function(hex) {
    var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);

    return (r * 0.299 + g * 0.587 + b * 0.114) > 184.5 ? '666666' : 'FFFFFF';
  }

  calculateSeasonID = function(date) {
    if (self.ranges && self.ranges.length > 0) {
      var range = self.ranges.filter(function(range) {
        return range.startDate <= date && range.endDate >= date;
      });
      return range && range.length > 0 ? range[0].seasonID : null;
    } else {
      return null;
    }
  };

  generateDates = function() {
    var MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
    $scope.months = [];
    for (var x = 0; x < 12; x++) {
      var initialDate = new Date($scope.year, x, 1);
      var dates = [];
      var countOfDaysInMonth = null;
      var weekrow = 0;

      countOfDaysInMonth = Math.ceil(
        (new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0) -
          new Date(initialDate.getFullYear(), initialDate.getMonth(), 1)) /
        MILLISECONDS_IN_DAY
      );

      for (var y = 0; y <= countOfDaysInMonth; y++) {
        var date = new Date(initialDate.setDate(y + 1));
        dates.push({
          date: date,
          weekday: weekDays[date.getDay()],
          weekrow: weekrow,
          bgColor: calculateColor(date.setHours(0, 0, 0, 0)),
          color: getContrastColor(calculateColor(date.setHours(0, 0, 0, 0))),
          seasonID: calculateSeasonID(date.setHours(0, 0, 0, 0))
        });
        if (date.getDay() == 0) {
          weekrow++;
        }
      }

      $scope.months.push({
        title: $i18next.t('general.months.' + months[x]),
        dates: dates
      });
    }
  };

  $scope.nextYear = function() {
    $scope.year++;
    generateDates();
  };

  $scope.prevYear = function() {
    $scope.year--;
    generateDates();
  };

  $scope.mouseEnter = function(event, seasonID) {
    $scope.ctrl.highlightOn({
      event: event,
      seasonId: seasonID
    });
  };

  $scope.mouseLeave = function(seasonID) {
    $scope.ctrl.highlightOff(seasonID);
  };

  $scope.mouseDown = function(date) {
    $scope.selection_in_progress = true;
    $scope.selection_start_date = date;
    $scope.selection_end_date = date;
  };

  $scope.mouseUp = function(date) {
    $scope.selection_in_progress = false;
    $scope.selection_end_date = date;
    $scope.ctrl.createFromCalendarSelection({
      startDate: $scope.selection_start_date,
      endDate: $scope.selection_end_date
    });
  };

  $scope.mouseMove = function(date) {
    if ($scope.selection_in_progress) {
      $scope.selection_end_date = date;
    }
  };

  $scope.$on("seasons:reload", function(event, seasons) {
    if (seasons.length > 0) {
      $rootScope.hotel.seasons = seasons;
      self.ranges = [];
      seasons.forEach(function(season) {
        season.ranges.forEach(function(range) {
          self.ranges.push({
            // set dates to midnight to avoid timezone issues
            startDate: new Date(range.startDate + 'T00:00:00'),
            endDate: new Date(range.endDate + 'T00:00:00'),
            color: season.color,
            seasonID: season.id
          });
        });
      });
      generateDates();
    }
  });
}

function seasonCalendar() {
  return {
    restrict: "E",
    controller: seasonCalendarController,
    templateUrl: getTemplatePath("settings/season_calendar.html")
  };
}

angular
  .module('buuqit')
  .directive('saleChannelForm', saleChannelForm);

function saleChannelForm() {
  return {
    restrict: 'E',
    scope: {
      saleChannel: '=',
      cancelCallback: '=',
      saveCallback: '=',
      requestInProgress: '=',
    },
    controller: SaleChannelFormController,
    controllerAs: "vm",
    templateUrl: getTemplatePath('forms/saleChannelForm.html'),
    bindToController: true,
  };
}

SaleChannelFormController.$inject = ['$scope'];

function SaleChannelFormController($scope) {
  var self = this;

  self.onNameChange = function () {
    self.saleChannel.code = self.saleChannel.name.substr(0,3).toLowerCase();
  }

  self.cancelAction = function () {
    self.cancelCallback();
  };

  self.saveAction = function() {
    if (!self.customerQuery) {
      self.saleChannel.customer_id = null;
    }
    self.saveCallback(self.saleChannel);
  };

  this.customerQuery = this.saleChannel.customer ? this.saleChannel.customer.visibleName : null;

  this.chooseCustomer = function (customer) {
    self.saleChannel.customer_id = customer ? customer.id : null;
  }
}

angular
  .module('buuqit')
  .directive('roomTypeForm', roomTypeForm);

roomTypeForm.$inject = [];

function roomTypeForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    controller: roomTypeFormController,
    templateUrl: getTemplatePath('forms/roomTypeForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}


roomTypeFormController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$filter",
  "$http",
  "RoomTypeFactory",
  "Slug",
  "Globalize"
];


function roomTypeFormController ($rootScope, $scope, $i18next, $filter, $http, RoomTypeFactory, Slug, Globalize) {
  angular.extend(
    $scope,
    {
      // Variables
      showErrors: false,
      saving : false,
      selectedAvailableFacility : null,
      selectedChoosedFacility   : null,
      originalRoomType : angular.copy($scope.value),
      icelandKind: [
        {name: 'Summer House', value: 'summer_house'},
        {name: 'Apartment', value: 'apartment'},
        {name: 'Room', value: 'room'}
      ],

      // Methods
      moveToSelected : moveToSelected,
      moveFromSelected : moveFromSelected,
      closeCreateForm : closeCreateForm,
      saveCreateForm : saveCreateForm,
      multipleFileUpload : multipleFileUpload,
      removePhoto : removePhoto,
      featurePhoto : featurePhoto,
      addBedConfig: addBedConfig,
      removeBedConfig: removeBedConfig,
      addBed: addBed,
      removeBed: removeBed,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function (val) {
    if (val) {
      $scope.facilities = angular.copy($rootScope.hotel.facilities);

      if ($scope.value && $scope.value.facilities) {
        _.each($scope.value.facilities, function (saved_facility) {
          var facility = $scope.facilities.filter(function(facility) { return facility.id == saved_facility.id; })[0];
          $scope.facilities.splice($scope.facilities.indexOf(facility), 1);
        });

        $scope.value.link = 'http://' + window.location.host + '/api/public/ari/v1/ical/' + $rootScope.hotel.slug + '/' + $scope.value.baseRateCode;
      }

      $scope.originalFacilities = angular.copy($scope.facilities);

      $scope.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
    }
  });

  if ($scope.$parent.RoomTypeCtrl) {
    $scope.parent = $scope.$parent.RoomTypeCtrl;
  } else {
    $scope.parent = $scope.$parent.$parent.$parent;
  }


  function moveToSelected () {
    var selected = $scope.selectedAvailableFacility,
        facility = $scope.facilities.filter(function(facility) { return facility.id == selected; })[0];

    $scope.value.facilities.push(facility);
    $scope.facilities.splice($scope.facilities.indexOf(facility), 1);

    $scope.selectedAvailableFacility = null;
  }


  function moveFromSelected () {
    var selected = $scope.selectedChoosedFacility,
        facility = $scope.value.facilities.filter(function(facility) { return facility.id == selected; })[0];

    $scope.facilities.push(facility);
    $scope.value.facilities.splice($scope.value.facilities.indexOf(facility), 1);

    $scope.selectedChoosedFacility = null;
  }


  function closeCreateForm () {
    if (typeof($scope.value.id) === 'undefined') {
      angular.copy($scope.originalRoomType, $scope.value);
    } else {
      angular.copy($scope.originalRoomType, $scope.value);
    }

    angular.copy($scope.originalFacilities, $scope.facilities);

    $scope.parent.editedRoomType    = null;
    $scope.parent.createFormVisible = false;
  }


  function saveCreateForm () {
    if ($scope.RoomTypeForm.$invalid) {
      $scope.showErrors = true;
    } else {
      $scope.saving = true;
      Globalize.updateCurrentTranslation($scope.value, 'roomType');
      if ($scope.value.id) {
        updateRoomType();
      } else {
        createRoomType();
      }
    }
  }


  function createRoomType () {
    $scope.value.hotelId = $rootScope.hotel.id;
    $scope.value.photos = $scope.value.photos.map(function(el) {return el.id;});
    $scope.value.bedConfig = JSON.stringify($scope.value.bedConfigRaw);

    new RoomTypeFactory($scope.value)
      .create()
      .then(
        function (data) {
          $scope.saving = false;
          $scope.showErrors = false;
          $rootScope.hotel.roomTypes.push(data);
          $scope.parent.roomTypes = $filter('orderBy')($rootScope.hotel.roomTypes, 'priority');
          $scope.facilities = angular.copy($rootScope.hotel.facilities);
          $scope.selectedAvailableFacility = null;
          $scope.selectedChoosedFacility   = null;
    

          if ($scope.parent.availableRooms) {
            data.visible = false;
            data.slug = Slug.slugify(data.name);
            $scope.parent.availableRooms.push(data);
            $scope.parent.website.rooms.push({
              roomTypeId : data.id,
              visible    : false
            });
          }

          $scope.parent.newRoomType = angular.copy($scope.parent.originalRoomType);
          $rootScope.hotel.get().then(function() {
            $scope.parent.createFormVisible = false;
          });
        },
        function(error) {
          $scope.saving = false;
          console.error('Error while creating room type:', error);
          $rootScope.notify($i18next.t('profile_nav.settings.inventory.room_type_form.alert.room_type_is_not_save_check_data_and_try_again_js_str'));
        }
      );
  }

  function updateRoomType () {
    $scope.value.hotelId = $rootScope.hotel.id;
    $scope.value.facilitiesids = [];
    $scope.value.bedConfig = JSON.stringify($scope.value.bedConfigRaw);

    _.each($scope.value.facilities, function (facility) {
      $scope.value.facilitiesids.push(facility.id);
    });

    new RoomTypeFactory($scope.value)
      .update()
      .then(
        function (data) {
          $scope.saving = false;
          $scope.showErrors = false;
          $rootScope.hotel.roomTypes.filter(function(roomType) { return roomType.id == data.id; })[0] = data;
          $scope.originalRoomType = angular.copy(data);
          $scope.parent.editedRoomType = null;
          $rootScope.loadHotel();
        },
        function(error) {
          $scope.saving = false;
          console.error('Error while updating room type:', error);
          $rootScope.notify($i18next.t('profile_nav.settings.inventory.room_type_form.alert.room_type_is_not_save_check_data_and_try_again_js_str'));
        }
      );
  }


  function multipleFileUpload ($event) {
    var files  = $event.target.files;
    var loaded = 0;
    $scope.photoLoaded = true;

    _.each(files, function (file) {
      var fd = new FormData();
      fd.append("photo[photo]", file);
      fd.append("photo[zone]", 'Room');
      
      if ($scope.value.id) {
        fd.append("photo[room_type_id]", $scope.value.id);
      }

      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/photos', fd, {
          headers: {'Content-Type': undefined },
          transformRequest: angular.identity
      }).success(function(response) {
        $scope.value.photos.push(response.photo);
      }).error(function(response) {
        console.error('Error while uploading photo:', response);
      }).then(function () {
        loaded++;
        if (loaded == files.length) {
          $scope.photoLoaded = false;
        }
      });
    });
  }


  function removePhoto (photo) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = $scope.value.photos.indexOf(photo);
      $scope.value.photos.splice(index, 1);
    } else {
      $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/photos/'+photo.id).then(function (response) {
        photo.loading = false;
        if (response.data && response.data.success === true) {
          var index = $scope.value.photos.indexOf(photo);
          $scope.value.photos.splice(index, 1);
          $scope.originalRoomType.photos.splice(index, 1);
        } else {
          photo.loading = false;
          console.error('Error while deleting photo:', response);
          $rootScope.alert($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
        }
      });
    }
  }

  function featurePhoto (photo) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = $scope.value.photos.indexOf(photo);
      photo.featured = !photo.featured;
      $scope.value.photos[index] = photo;
    } else {
      photo.featured = !photo.featured;
      $http.put(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/photos/'+photo.id, photo).then(function (response) {
        photo.loading = false;
        if (response.data && response.data.photo) {
          var index = $scope.value.photos.indexOf(photo);
          $scope.value.photos[index] = response.data.photo;
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
        }
      }).catch(function(error) {
        photo.loading = false;
        console.error('Error while updating photo:', error);
        $rootScope.alert($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
      });
    }
  }

  function addBedConfig() {
    if (!$scope.value.bedConfigRaw || !$scope.value.bedConfigRaw.push) {
      $scope.value.bedConfigRaw = [];
    }
    $scope.value.bedConfigRaw.push([
      ['', 1, null]
    ]);
  }

  function removeBedConfig(index) {
    $scope.value.bedConfigRaw.splice(index, 1);
  }

  function addBed(config) {
    config.push(['', 1, null]);
  }

  function removeBed(config, index) {
    config.splice(index, 1);
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module("buuqit")
  .directive("roomRates", roomRatesDirective)
  .controller("RoomRatesController", roomRatesController)
  .component(
    'reactRoomRatesCombinations',
    window.TBFLibs.react2angular(
      window.TBFLibs.RoomRateCombinations,
      [
        'rateCategories',
        'roomRepresentations',
        'seasons',
        'roomRates',
        'hideFields',
        'cancellationPolicies',
        'hotelSettings',
        'onSave',
        'onRoomRateRemoved',
        'onRoomRateChanged',
        'onSaveNewRoomRateCombination',
        'onSaveEditRoomRateCombination',
        'manualModificationEnabled'
      ],
      [
        '$i18next',
        'RelationCalculator'
      ]
    )
  );

roomRatesController.$inject = [
  "$scope",
  "$rootScope",
  "$i18next",
  "RoomRatesStorage"
];

function roomRatesController($scope, $rootScope, $i18next, RoomRatesStorage) {
  var ctrl = this;
  angular.extend(this, {
    rateCategories: [],
    roomRepresentations: [],
    seasons: [],
    roomRates: [],
    hideFields: [],
    cancellationPolicies: [],
    hotelSettings: {},
    manualModificationEnabled: false,
    onSave: handleSave,
    onRoomRateRemoved: handleRoomRateRemoved,
    onRoomRateChanged: handleRoomRateChanged,
    onSaveNewRoomRateCombination: handleSaveNewRoomRateCombination,
    onSaveEditRoomRateCombination: handleSaveEditRoomRateCombination,
  });

  function handleSave(roomRates) {
    var results = [];
    roomRates.forEach(function(rr) {
      RoomRatesStorage.updateSeason(rr).then(function(data) {
        results.push(data.success !== false);

        if (results.length == roomRates.length) {
          RoomRatesStorage.load();
          var total_result = results.reduce(function(a, b) {return a && b}, true);
          if (total_result === false) {
            return { success: false };
          }
        }
      });
    });
  }

  function handleRoomRateRemoved(roomRate) {
    RoomRatesStorage.remove(roomRate).then(function(data) {
      if (data.success === false) {
        console.error('Error while trying to remove room rate:', data);
        $rootScope.error_notify(data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str'), true);
      }
      return data;
    });
  }

  function handleRoomRateChanged(roomRate) {
    RoomRatesStorage.update(roomRate).then(function(data) {
      if (data.success === false) {
        console.error('Error while trying to update room rate:', data);
        return $rootScope.notify(data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
      }
      RoomRatesStorage.load();
    });
  }

  function handleSaveNewRoomRateCombination(roomRate) {
    return RoomRatesStorage.create(roomRate).then(function(data) {
      return data;
    });
  }

  function handleSaveEditRoomRateCombination(roomRate, selectedSeasonId) {
    if (roomRate.updateRoomRate) {
      return RoomRatesStorage.update(roomRate).then(function(data) {
        if (data.success === false) return data;
        return RoomRatesStorage.updateSeason(roomRate.roomRateSeasons[selectedSeasonId]).then(function(data) {
          if (data.success === false) return data;
          RoomRatesStorage.load();
          return data;
        });
      });
    } else {
      return RoomRatesStorage.updateSeason(roomRate.roomRateSeasons[selectedSeasonId]).then(function(data) {
        if (data.success === false) return data;
        RoomRatesStorage.load();
        return data;
      });
    }
  }

  function getHiddenFields() {
    var hiddenFields = [];
    if (!$rootScope.hotel.minStayArrivalVisible) hiddenFields.push('minStayArrival');
    if (!$rootScope.hotel.minStayThroughVisible) hiddenFields.push('minStayThrough');
    if (!$rootScope.hotel.maxStayVisible) hiddenFields.push('maxStay');
    if (!$rootScope.hotel.closedToArrivalVisible) hiddenFields.push('closedToArrival');
    if (!$rootScope.hotel.closedToDepartureVisible) hiddenFields.push('closedToDeparture');
    if (!$rootScope.hotel.stopSellVisible) hiddenFields.push('stopSell');
    return hiddenFields;
  }

  function initialize() {
    ctrl.manualModificationsEnabled = $rootScope.hotel.modifyRoomRateCombinationsEnabled;
    ctrl.hideFields = getHiddenFields();
    ctrl.hotelSettings = {
      roundMethod: $rootScope.hotel.roundMethod,
      roundTo: $rootScope.hotel.roundTo,
    };
    ctrl.rateCategories = $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved === false});
    ctrl.roomRates = $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved === false;}).map(function(roomRate) {
      if (roomRate.roomRateSeasons.reduce) {
        roomRate.roomRateSeasons = roomRate.roomRateSeasons.reduce(function(obj, el) {
          obj[el.seasonId] = el;
          return obj;
        }, {});
      }
      var cancellationPolicy = $rootScope.hotel.cancellationPolicies.find(function(cp) {
        return cp.id == roomRate.cancellationPolicyId;
      });
      roomRate.cancellationPolicyTitle = cancellationPolicy.title;
      return roomRate;
    });
    ctrl.cancellationPolicies = $rootScope.hotel.cancellationPolicies;
    ctrl.seasons = $rootScope.hotel.seasons;

    ctrl.roomRepresentations = $rootScope.hotel.roomRepresentations.map(
      function(roomRepresentation) {
        var roomRates = ctrl.roomRates.filter(function(roomRate) {
          return roomRate.roomRepresentationId === roomRepresentation.id;
        });

        roomRepresentation.roomRates = roomRates.map(function(roomRate) {
          var rateCategory = $rootScope.hotel.rateCategories.filter(function(rateCategory) {
            return rateCategory.id == roomRate.rateCategoryId;
          })[0];

          roomRate.rateTitle = rateCategory.name;
          roomRate.priority  = rateCategory.priority;

          return roomRate;
        });

        return roomRepresentation;
      }
    );
  }

  function initIfPossibleAndNeeded() {
    if ($rootScope.hotel && $rootScope.hotel.roomRates) {
      initialize();
    }
  }
  var hotelWatcher = $rootScope.$watch('hotel', initIfPossibleAndNeeded);
  var roomRatesLoadedListener = $rootScope.$on('roomRates:loaded', initIfPossibleAndNeeded);

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (roomRatesLoadedListener) {
      roomRatesLoadedListener();
    }
  });

  initIfPossibleAndNeeded();
}

function roomRatesDirective() {
  return {
    restrict: "E",
    scope: {
      withoutSeasons: '=withoutSeasons'
    },
    controller: roomRatesController,
    templateUrl: getTemplatePath("settings/room_rates.html")
  };
}

angular
  .module('buuqit')
  .directive('roomForm', roomForm);

function roomForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    templateUrl: getTemplatePath('forms/roomForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

angular
  .module('buuqit')
  .directive('reactionForm', reactionForm);

reactionForm.$inject = [];

function reactionForm () {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    controller: reactionFormController,
    templateUrl: getTemplatePath('forms/settingsReactionForm.html')
  };
}

reactionFormController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$http",
  "ReactionsFactory",
  "EmailTemplatePreviewFactory",
  "BeeFreeFactory",
  "EmailSystemConfigFactory"
];

function reactionFormController ($rootScope, $scope, $i18next, $http, ReactionsFactory, EmailTemplatePreviewFactory, BeeFreeFactory, EmailSystemConfigFactory) {
  var defaultOperators = [
    { value: '>', title: 'profile_nav.settings.other.reactions.condition_group.greater_option' },
    { value: '<', title: 'profile_nav.settings.other.reactions.condition_group.less_option' },
    { value: '=', title: 'profile_nav.settings.other.reactions.condition_group.equal_option' },
    { value: '!=', title: 'profile_nav.settings.other.reactions.condition_group.not_equal_option' },
    { value: '>=', title: 'profile_nav.settings.other.reactions.condition_group.greater_or_equal_option' },
    { value: '<=', title: 'profile_nav.settings.other.reactions.condition_group.less_or_equal_option' },
    { value: 'in', title: 'profile_nav.settings.other.reactions.condition_group.in_option' },
    { value: 'not_in', title: 'profile_nav.settings.other.reactions.condition_group.not_in_option' },
    { value: 'contains', title: 'profile_nav.settings.other.reactions.condition_group.contains_option' },
    { value: 'not_contains', title: 'profile_nav.settings.other.reactions.condition_group.not_contains_option' },
  ];

  var conditionsInputTypeMapping = {
    sale_channel: {
      $type: 'multiselect',
      $options: $rootScope.hotel.saleChannels.map(function (saleChannel) {
        return {
          id: saleChannel.id,
          name: saleChannel.name
        }
      }),
      $operators: [{ value: 'in', title: 'profile_nav.settings.other.reactions.condition_group.in_option' }],
      defaultOperator: 'in',
      emptyValue: []
    },
    _default: {
      $type: 'input',
      $operators: defaultOperators,
      defaultOperator: null,
      emptyValue: null
    }
  };

  angular.extend(
    $scope,
    {
      dropins: dropins,
      emailAdressDropins: emailAdressDropins,
      conditions: $scope.ctrl.conditions,
      openedEmailTemplateBuilders: [],
      mergeTags: getMergeTags(),
      hotelId: $rootScope.hotel.id,
      shouldSave: false,

      saveEditedReaction: saveEditedReaction,
      getTaskDescription: getTaskDescription,
      getTaskArguments: getTaskArguments,
      prepareSelectOptions: prepareSelectOptions,
      getSelectOptions: getSelectOptions,

      insertEmailAdressDropIn: insertEmailAdressDropIn,
      getPrefilledEditableContent: getPrefilledEditableContent,
      getPrefilledUneditableContent: getPrefilledUneditableContent,

      getTaskIsTestable: getTaskIsTestable,
      testTask: testTask,

      getConditionalTree: getConditionalTree,
      normalizeConditionsArray: normalizeConditionsArray,
      parseConditions: parseConditions,
      addCondition: addCondition,
      changeCondition: changeCondition,
      addGroup: addGroup,
      removeCondition: removeCondition,
      changeGroupType: changeGroupType,
      removeGroup: removeGroup,
      convertConditionsObjectToArray: convertConditionsObjectToArray,
      saveEditedReactionWithTemplate: saveEditedReactionWithTemplate,
      sendTestLetter: sendTestLetter,
      onLoadBeeFreeToken: onLoadBeeFreeToken,
    }
  );

  $scope.value.reactionConditions = JSON.stringify(
    $scope.value.reactionConditions,
    true,
    4
  );
  $scope.value.conditions = getConditionalTree(
    $scope.value
  );

  function createReaction(reaction) {
    var index = $scope.ctrl.reactions.indexOf(reaction);
    reaction = new ReactionsFactory(reaction);
    reaction.hotelId = $rootScope.hotel.id;
    reaction.reactionConditions = JSON.stringify(
      convertConditionsObjectToArray(reaction.conditionTree),
      true,
      4
    );
    reaction.defaultArguments = JSON.stringify(reaction.defaultArguments);
    if (reaction.triggers)
      reaction.triggerIds = reaction.triggers.map(function(trigger) { return trigger.id });
    if (reaction.kind === "scheduled") {
      reaction.reactionConditions = [];
    }
    reaction.create().then(
      function(response) {
        $scope.ctrl.createReaction(index, response);
      },
      function(response) {
        var message = Object.keys(response.data.errors)
          .map(function(key) {
            return key + ": " + response.data.errors[key].join(", ");
          })
          .join(". ");
        $rootScope.alert(message);
      }
    );
  }

  function updateReaction(reaction) {
    var index = $scope.ctrl.reactions.indexOf(reaction);
    reaction.reactionConditions = JSON.stringify(
      convertConditionsObjectToArray(reaction.conditionTree),
      true,
      4
    );
    reaction.defaultArguments = typeof reaction.defaultArguments === "string"
                                ? reaction.defaultArguments
                                : JSON.stringify(reaction.defaultArguments);
    JSON.stringify(reaction.defaultArguments);
    if (reaction.triggers)
      reaction.triggerIds = reaction.triggers.map(function(trigger) { return trigger.id });
    if (reaction.kind === "scheduled") {
      reaction.reactionConditions = [];
    }
    reaction.update().then(
      function(response) {
        $scope.ctrl.updateReaction(index, response);
      },
      function(response) {
        var message = Object.keys(response.data.errors)
          .map(function(key) {
            return key + ": " + response.data.errors[key].join(", ");
          })
          .join(". ");
        $rootScope.alert(message);
      }
    );
  }

  function getTaskDescription(taskName) {
    var task = getTaskByName(taskName);
    return task ? task.description : "";
  }

  function getTaskByName(taskName) {
    return $scope.ctrl.tasks.filter(function(task) {
      return task.className == taskName;
    })[0];
  }

  function getTaskArguments(taskName) {
    var task = getTaskByName(taskName);
    return task ? prepareSelectOptions(task.arguments) : "";
  }

  function prepareSelectOptions(args) {
    return args.map(function(argument) {
      if (argument[4] && typeof argument[4] === "string") {
        argument[4] = getSelectOptions(argument[4]);
      }
      return argument;
    });
  }

  function getSelectOptions(options) {
    var options = options.split(",");
    return options.map(function(option) {
      var el = option.split(":");
      return {
        value: el[0],
        display: el[1]
      };
    });
  }

  function insertEmailAdressDropIn(arr, index, dropin) {
    arr[index] = dropin;
  }

  function getPrefilledEditableContent(name) {
    switch (name) {
      case 'fromText': 
      case 'replayTo':
        return emailSystemConfig.emailFromText;
      default: 
        return "";
    }
  }

  function getPrefilledUneditableContent(name) {
    switch (name) {
      case 'fromText': 
        return "<bookings@" + emailSystemConfig.emailDomain + ">";
      case 'replayTo':
        return "<" + emailSystemConfig.emailFromAddress + ">";
      default: 
        return "";
    }
  }


  function getTaskIsTestable(taskName) {
    var task = getTaskByName(taskName);
    return task ? task.testable : false;
  }

  function testTask(task, args) {
    $http
      .post(
        SERVER_PATH +
          "/api/v1/hotels/" +
          $rootScope.hotel.id +
          "/reactions/test",
        { task: task, arguments: args }
      )
      .success(function(response) {
        $rootScope.alert($i18next.t('profile_nav.settings.other.reactions.alert.success'));
      })
      .error(function(response) {
        $rootScope.alert($i18next.t('profile_nav.settings.other.reactions.alert.failed'));
      });
  }

  function saveEditedReactionWithTemplate(content, contentJson, reactionId) {
    var reaction = $scope.value;
    reaction.defaultArguments.content = content;
    reaction.defaultArguments.contentJson = contentJson;
    saveReaction(reaction, reactionId);
  }

  function saveEditedReaction (reaction) {
    var arguments = getTaskArguments(reaction.task);
    var content = arguments.find(function(arg) {
      return arg[0] === 'content';
    });

    if (content && content[1] === 'wysiwyg') {
      this.shouldSave = true;
    } else {
      saveReaction(reaction, reaction.id);
    }
  };
  
  function saveReaction (reaction, id) {
    if (id) {
      updateReaction(reaction);
    } else {
      createReaction(reaction);
    }
  }

  function getConditionalTree(reaction) {
    var conditions = normalizeConditionsArray(
      typeof reaction.reactionConditions === "string"
        ? JSON.parse(reaction.reactionConditions)
        : reaction.reactionConditions
    );

    var outputTree = parseConditions(
      {
        rule: "",
        conditions: [],
        groups: []
      },
      conditions
    );

    reaction.conditionTree = outputTree;

    return outputTree;
  }

  function normalizeConditionsArray(conditions) {
    if (conditions[0] !== "ALL" && conditions[0] !== "ANY") {
      conditions = ["ALL", conditions];
    }

    return conditions;
  }

  function parseConditions(outputTree, conditions) {
    outputTree.rule = conditions[0];

    conditions
      .filter(function(el) {
        return typeof el != "string";
      })
      .forEach(function(el) {
        if (el[0] == "ALL" || el[0] == "ANY") {
          outputTree.groups.push(
            parseConditions(
              {
                rule: "",
                conditions: [],
                groups: []
              },
              el
            )
          );
        } else {
          _addInputParamsForConditions(el, { resetValues: false });

          outputTree.conditions.push(el);
        }
      });

    return outputTree;
  }

  function addCondition(group) {
    group.conditions.push(["", "", ""]);
  }

  function changeCondition(condition, value, index) {
    _addInputParamsForConditions(condition, { resetValues: true });

    var condition_rule = $scope.conditions.filter(function(rule) {
      return rule[0] == condition[1];
    })[0];

    if (condition_rule[2]) {
      value.conditions[index][0] = condition_rule[2][0];
      value.conditions[index][1] = condition[1];
      value.conditions[index][2] = condition_rule[2][1];
    }
  }

  function addGroup(group) {
    group.groups.push({
      rule: "ALL",
      conditions: [["", "", ""]],
      groups: []
    });
  }

  function removeCondition(group, index) {
    group.conditions.splice(index, 1);
  }

  function changeGroupType(group, value) {
    group.rule = value;
  }

  function removeGroup(group, parent) {
    parent.groups = _.without(parent.groups, group);
  }

  function convertConditionsObjectToArray(conditionTree) {
    var out = [];
    Object.keys(conditionTree).forEach(function(el) {
      if (!["rule", "conditions", "groups"].includes(el)) {
        return;
      }
      el = conditionTree[el];

      if (typeof el === "string") {
        out.push(isNaN(Number(el)) ? el : Number(el));
      } else {
        if (
          typeof el === "object" &&
          el.length &&
          el.length > 0 &&
          el[0].length
        ) {
          el.forEach(function(el) {
            var opValue;

            if (Array.isArray(el[2])) {
              opValue = el[2];
            } else {
              opValue = isNaN(Number(el[2])) ? el[2] : Number(el[2])
            }

            if (el.join("").length > 0) {
              out.push([
                el[0],
                el[1],
                opValue
              ]);
            }
          });
        } else {
          if (
            typeof el === "object" &&
            el.length &&
            el.length > 0 &&
            !el[0].length
          ) {
            el.forEach(function(el) {
              out.push(convertConditionsObjectToArray(el));
            });
          }
        }
      }
    });

    return out;
  }

  function _addInputParamsForConditions(condition, options) {
    options = options || {};

    var inputFieldParams = conditionsInputTypeMapping[condition[1]];

    if (inputFieldParams) {
      _.assign(condition, inputFieldParams);

      if (inputFieldParams.defaultOperator) {
        condition[0] = inputFieldParams.defaultOperator;
      }

      if (options.resetValues) {
        condition[2] = inputFieldParams.emptyValue;
      }
    } else {
      var defaultInputFieldParams = conditionsInputTypeMapping._default;

      var prevType = condition.$type;
      var newType = defaultInputFieldParams.$type;

      _.assign(condition, defaultInputFieldParams);

      if (options.resetValues && newType !== prevType) {
        condition[0] = null;
        condition[2] = defaultInputFieldParams.emptyValue;
      }
    }
  }

  function getMergeTags() {
    return dropins.map(function(dropin) {
      return { name: dropin[0], value: dropin[1]};
    });
  };

  function sendTestLetter(text) {
    var letter = {
      receiver: emailSystemConfig.email,
      templateHtml: text,
      hotelId: $rootScope.hotel.id,
    }
    new EmailTemplatePreviewFactory(letter).create().then(function () {
      $rootScope.notify($i18next.t('bookings.email.notify.test_email_has_been_sent_js_str'));
    }, function (error_message) {
      $rootScope.notify(error_message);
    });
  };

  function onLoadBeeFreeToken() {
    return BeeFreeFactory
      .get({
        hotelId: $rootScope.hotel.id
      });
  }

  function loadSystemEmailConfig() {
    EmailSystemConfigFactory.get({ hotelId: $rootScope.hotel.id }).then(function (response) {
      self.emailSystemConfig = response.systemConfig;
    });
  }

  init();

  function init() {
    loadSystemEmailConfig();
  }
}

angular
  .module("buuqit")
  .controller("rateCategoriesController", rateCategoriesController)
  .directive("rateCategories", rateCategories)
  .component('reactRateCategories',
  window.TBFLibs.react2angular(
    window.TBFLibs.RateCategories, [
      'rateCategories',
      'onSubmit',
      'onDelete',
      'onMoveUp',
      'onMoveDown',
      'isAdmin',
      'showSpecialOffers',
      'showExpired',
      'handleSpecialOffers',
      'handleExpiredRates',
      'cancellationPolicies',
      'currencyProfiles',
      'newTaxes',
      'isOwner',
      'isManager',
      'isCorporateRoleManager',
      'isCorporateRoleOwner',
      'minStayThroughVisible',
      'minStayArrivalVisible',
      'maxStayVisible',
      'closedToArrivalVisible',
      'closedToDepartureVisible',
      'stopSellVisible',
      'isAccountingCategoriesFeatureEnabled',
      'accountingCategories',
      'roomRepresentations',
      'hotelRoomRates',
      'rateCategoryLoading',
      'onLoadHotelExtras',
      'locales',
      'locale'
    ], [
      '$i18next',
      'RelationCalculator'
    ]
  ));

rateCategoriesController.$inject = ["$rootScope", "$scope", "$i18next", "$mdDialog", "$filter", "RateCategoriesStorage", "Globalize", "ExtrasFactory", "StringTransformService"];
rateCategories.$inject = [];

function rateCategoriesController($rootScope, $scope, $i18next, $mdDialog, $filter, RateCategoriesStorage, Globalize, ExtrasFactory, StringTransformService) {
  var self = this;
  var rateCategoryTemplate = {
    isAnchored: false,
    extras: [],
    roomTypes: [],
    roomRates: [],
    taxes: [],
    isSingleOccupancyRate: true,
    isAutomaticCalculatedRate: true,
    minStayThrough: [1, 1, 1, 1, 1, 1, 1],
    minStayArrival: [1, 1, 1, 1, 1, 1, 1],
    maxStay: [0, 0, 0, 0, 0, 0, 0],
    closedToArrival: [false, false, false, false, false, false, false],
    closedToDeparture: [false, false, false, false, false, false, false],
    stopSell: [false, false, false, false, false, false, false],
    channelOnly: false,
    sortTitleByHotelLang: sortTitleByHotelLang
  };

  function sortAndFilter() {
    var filteredOrderedRC = $scope.rateCategories.filter(filterFn).sort(function(a, b) {
      return a.priority - b.priority;
    });
    $scope.filteredOrderedRC = filteredOrderedRC;
    self.filteredOrderedRC = filteredOrderedRC;
  }
  function handleSpecialOffers(e) {
    var value = e.target.checked;
    self.showSpecialOffers = value;
    sortAndFilter();
    $scope.$apply();
  }
  function handleExpiredRates(e) {
    var value = e.target.checked;
    self.showExpired = value;
    sortAndFilter();
    $scope.$apply();
  }

  function init() {
    $rootScope.hotel.rateCategories.forEach(function(rateCategory){
      Globalize.loadTranslation(rateCategory, 'rateCategory');
    })
    $scope.rateCategories = updateCancellationPolicyTitle($rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved === false}), $rootScope.hotel);
    $scope.rateCategories = setCurrency($scope.rateCategories);
    sortAndFilter();
    self.locales = $rootScope.hotel.locales;
    self.locale = $rootScope.hotel.locale;
    self.cancellationPolicies = $rootScope.hotel.cancellationPolicies.filter(function(rc) {
      return !rc.isRemoved;
    });
    self.currencyProfiles = $rootScope.hotel.currencyProfiles;
    self.newTaxes = $rootScope.hotel.newTaxes;
    self.minStayThroughVisible = $rootScope.hotel.minStayThroughVisible;
    self.minStayArrivalVisible = $rootScope.hotel.minStayArrivalVisible;
    self.maxStayVisible = $rootScope.hotel.maxStayVisible;
    self.closedToArrivalVisible = $rootScope.hotel.closedToArrivalVisible;
    self.closedToDepartureVisible = $rootScope.hotel.closedToDepartureVisible;
    self.stopSellVisible = $rootScope.hotel.stopSellVisible;
    self.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
    self.accountingCategories = $rootScope.hotel.accountingCategories;
    self.roomRepresentations = $rootScope.hotel.roomRepresentations;
    self.hotelRoomRates = $rootScope.hotel.roomRates;
    self.rateCategoryLoading = {
      id: null,
      loading: false
    };
    self.moveUp = moveUp;
    self.moveDown = moveDown;
    self.onDelete = remove;
    self.onSubmit = save;
    self.handleSpecialOffers = handleSpecialOffers;
    self.handleExpiredRates = handleExpiredRates;
    self.showSpecialOffers = false;
    self.showExpired = false;
    self.onLoadHotelExtras = onLoadHotelExtras;
  }

  function remove(rateCategory) {
    self.rateCategoryLoading = {
      id: rateCategory.id,
      loading: true
    };
    RateCategoriesStorage.remove(rateCategory).then(function(data) {
      self.rateCategoryLoading = {
        id: rateCategory.id,
        loading: false
      };
      if (data.success === false) {
        console.error('Error while trying to remove rate category:', data);
        $rootScope.error_notify(data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str'));

        return data
      };

      $rootScope.hotel.rateCategories = data;
      $scope.rateCategories = $rootScope.hotel.rateCategories;
      $scope.rateCategories = setCurrency($rootScope.hotel.rateCategories);
      
      sortAndFilter();
    });
  }

  function save(rateCategory) {
    var method = rateCategory.id > 0 ? 'update' : 'create';
    if (method === 'create') {
      delete rateCategory.id;
      rateCategory.publicTitle = rateCategory.name;
    }

    return RateCategoriesStorage[method](rateCategory).then(function(data) {
      if (!data || data.success === false) return data;
      Globalize.loadTranslation(data, 'rateCategory');
      data.edited = false;
        
      if (method === 'create') {
        $scope.rateCategories = $rootScope.hotel.rateCategories;
        $rootScope.hotel.rateCategories.forEach(function(rateCategory){
          Globalize.loadTranslation(rateCategory, 'rateCategory');
        });

        if (rateCategory.isBaseRate === true) {
          RateCategoriesStorage.load().then(function(data) {
            $rootScope.hotel.rateCategories = data;
            $scope.rateCategories = $rootScope.hotel.rateCategories;
            $scope.rateCategories = setCurrency($rootScope.hotel.rateCategories);
            $rootScope.hotel.rateCategories.forEach(function(rateCategory){
              Globalize.loadTranslation(rateCategory, 'rateCategory');
            });
          });
        }
      } else {
        var rcIndex = $rootScope.hotel.rateCategories.findIndex(function (rc) {
          return rc.id == rateCategory.id;
        })
        Globalize.loadTranslation(data, 'rateCategory');
        $rootScope.hotel.rateCategories[rcIndex] = data;
      }
      if (rateCategory.isBaseRate) {
        $rootScope.hotel.rateCategories.forEach(function(rc) {
          rc.isBaseRate = rc.id == rateCategory.id;
        })
      }
      sortAndFilter();
      return data;
    }); 
  }

  function filterFn(el) {
    return el && el.isRemoved === false && (self.showSpecialOffers ? true : el.hasSpecialOffers == false) && (self.showExpired ? true : (el.endDate ? new Date(el.endDate) > new Date() : true));
  }

  angular.extend($scope, {
    rateCategoryTemplate: angular.copy(rateCategoryTemplate),

    confirmation: $mdDialog
      .confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('profile_nav.settings.inventory.rate_plans.rate_category.confirm.text_content'))
      .ok($i18next.t('general.confirm.ok'))
      .cancel($i18next.t('general.confirm.cancel')),

    filteredOrderedRC: [],
    addFormIsVisible: false,
    showSpecialOffers: false,
    showExpired: false,
    save: save,
    filterFn: filterFn,
    changeLang: changeLang,
    rateCategories: [],
    sortTitleByHotelLang: sortTitleByHotelLang,
    moveDown: moveDown,
    moveUp: moveUp,
    sortAndFilter: sortAndFilter,
  });

  function moveDown(el) {
    var sorted = $scope.rateCategories.filter(filterFn).sort(function(a, b) {
      return a.priority - b.priority;
    });

    var oldIndex = sorted.indexOf(el);

    if (oldIndex < sorted.length - 1) {
      var newIndex = oldIndex + 1;
      RateCategoriesStorage.swapPriority(sorted[oldIndex], sorted[newIndex], sortAndFilter);
    }
  }


  function onLoadHotelExtras (params) {
    return new Promise(function(resolve, reject) {
      try {
        if ($rootScope.hotel && $rootScope.hotel.id) {
          var extrasFactory = new ExtrasFactory();
          return extrasFactory.getExtras($rootScope.hotel.id, params)
          .then(function (data) {
            if (data.data) {
              resolve(data.data);
            };
            resolve(null);
          });
        }
      } catch (e) {
        console.error(e, 'Extras');
        reject();
      };
    });
  }

  function moveUp(el) {
    var sorted = $scope.rateCategories.filter(filterFn).sort(function(a, b) {
      return a.priority - b.priority;
    });

    var oldIndex = sorted.indexOf(el);

    if (oldIndex > 0) {
      var newIndex = oldIndex - 1;
      RateCategoriesStorage.swapPriority(sorted[oldIndex], sorted[newIndex], sortAndFilter);
    }
  }

  function changeLang(old_locale) {
    var rates = $scope.rateCategories.concat([$scope.rateCategoryTemplate]);
    rates.forEach(function(rate) {
      Globalize.saveTranslation(rate, 'rateCategory', old_locale);
      Globalize.loadTranslation(rate, 'rateCategory');
    });
  }

  function sortTitleByHotelLang(obj) {
    var translation = (obj.translations || []).filter(function(d) {
      return d.locale == $rootScope.hotel.locale;
    });
    return translation.length ? translation[0].name : '';
  }

  function updateCancellationPolicyTitle(rateCategories, hotel) {
    return rateCategories.map(function(rateCategory) {
      var policies = hotel.cancellationPolicies.filter(function(policy) {
        return policy.id == rateCategory.cancellationPolicyId;
      });

      if (policies.length > 0) {
        rateCategory.cancellationPolicyTitle = policies[0].title;
      } else {
        rateCategory.cancellationPolicyTitle = "Removed Policy";
      }

      return rateCategory;
    });
  }

  function setCurrency(rateCategories) {
    var defaultCurrency = $rootScope.hotel.currencyProfiles.filter(function(el) {return el.isDefault === true})[0];
    var currencyProfilesById = $rootScope.hotel.currencyProfiles.reduce(function(acc, el) {
      acc[el.id] = el;
      return acc;
    }, {});

    return rateCategories.map(function (rateCategory) {
      if (!rateCategory.currencyProfileId) {
        rateCategory.currencyProfileId = defaultCurrency.id;
      }
      rateCategory.currencyCode = currencyProfilesById[rateCategory.currencyProfileId].code;
      return rateCategory;
    });
  }

  function initIfPossibleAndNeeded() {
    if ($rootScope.hotel && $rootScope.hotel.roomRates) {
      init();
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', initIfPossibleAndNeeded);
  var roomRatesLoadedListener = $rootScope.$on('roomRates:loaded', initIfPossibleAndNeeded);

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (roomRatesLoadedListener) {
      roomRatesLoadedListener();
    }
  });

  initIfPossibleAndNeeded();
}

function rateCategories() {
  return {
    restrict: "E",
    controller: rateCategoriesController,
    templateUrl: getTemplatePath("settings/rate_categories.html")
  };
}

angular
  .module('buuqit')
  .directive('posProfileForm', posProfileForm)
  .component(
    'selectScrollableExtras',
    TBFLibs.react2angular(
      TBFLibs.SelectScrollable,
      ['onScroll',
        'onSearch',
        'onSelect',
        'options',
        'extras',
        'placeholder',
        'value'
      ],
      ['$i18next']
    )
  );

function posProfileForm() {
  return {
    restrict: 'E',
    scope: {
      profile: '=ngModel',
      pos_types: '=availablePosTypes',
      ctrl: '=ngScope',
    },
    controller: posProfileFormController,
    controllerAs: "FormCtrl",
    templateUrl: getTemplatePath('forms/posProfileForm.html'),
    link: function (scope, element, attrs, ctrl) {
    }
  };
}

posProfileFormController.$inject = [
  "$rootScope",
  "$scope",
  "ExtrasFactory"
];

function posProfileFormController($rootScope, $scope, ExtrasFactory) {
  var FormCtrl = this;
  angular.extend($scope, {
    closeForm: closeForm,
    saveForm: saveForm,
    install: install,
    extras: [],
    hasExtrasMapping: $scope.profile.data && $scope.profile.data.extras != undefined && Object.keys($scope.profile.data.extras).length > 0,
    extra: {
      selected: null,
      edited: null,
      edit: editExtra,
      save: saveExtra,
      cancel: cancelExtra
    },
    onLoadExtras: onLoadExtras,
    onSearchExtras: onSearchExtras,
    selectedExtraChange: selectedExtraChange,
    mapping: {},
    extrasReqParams: { term: '', pagination: { page: 1, limit: 100 } },
    extrasTotal: null
  });
  angular.extend(FormCtrl, {});

  function renewMapping() {
    angular.copy($scope.extras.reduce(function (map, obj) {
      map[obj.id] = obj.title;
      return map;
    }, {}), $scope.mapping);
  }

  function install(model) {
    $scope.ctrl.autoConfigure(model);
  }

  function editExtra(name, extraId) {
    $scope.extra.edited = name;
    $scope.extra.selected = $scope.extras.find(function (e) { return e.value == extraId; });
  };

  function fetchExtras () {
    var params = $scope.extrasReqParams;
    var extrasFactory = new ExtrasFactory();
    return extrasFactory.getExtras($rootScope.hotel.id, params).then(function (data) {
      if (data.data) {
        var currentPage = $scope.extrasReqParams.pagination.page;
        if (data.data.meta) {
          $scope.extrasReqParams.pagination.page = data.data.meta.page + 1;
          $scope.extrasTotal = data.data.meta.total;
        }
        var extras = [];
        if (data.data.extras) {
          extras = data.data.extras.map(function (extra) {
            var formattedExtra = extra;
            formattedExtra.key = extra.id;
            formattedExtra.value = extra.id;
            formattedExtra.label = extra.title;
            return formattedExtra;
          });
        }
        if (currentPage === 1) {
          $scope.extras = extras;
        } else {
          $scope.extras = $scope.extras.concat(extras);
        }
      };
    });
  }

  function onLoadExtras() {
    if ($rootScope.hotel && $rootScope.hotel.id && $scope.extrasTotal ? ($scope.extras && $scope.extras.length < $scope.extrasTotal) : true) {
      return fetchExtras();
    };
  };

  function onSearchExtras(term) {
    $scope.extrasReqParams.term = term;
    $scope.extrasReqParams.pagination.page = 1;
    return fetchExtras();
  };

  function selectedExtraChange(item) {
    $scope.extra.selected = item;
    $scope.$apply();
  };

  function saveExtra(profile, key) {
    if ($scope.extra.selected && $scope.extra.selected) {
      profile.data.extras[key] = $scope.extra.selected;
    }
    $scope.extra.edited = undefined;
    $scope.extra.selected = undefined;
  }

  function cancelExtra() {
    $scope.extra.edited = undefined;
    $scope.extra.selected = undefined;
  }

  function closeForm() {
    $scope.ctrl.closeForm();
  }

  function saveForm() {
    if ($scope.PosProfileForm.$invalid) {
      $scope.showErrors = true;
    } else {
      $scope.ctrl.saveForm($scope.profile);
    }
  }

  function initExtras() {
    fetchExtras().then(function () {
      if ($rootScope.hotel && $rootScope.hotel.id && $scope.extrasTotal ? ($scope.extras && $scope.extras.length < $scope.extrasTotal) : true) {
        initExtras();
      } else {
        renewMapping();
      }
    });
  }

  initExtras();
}

angular
  .module('buuqit')
  .directive('settingsPictureForm', settingsPictureForm);

settingsPictureForm.$inject = ["$i18next"];

function settingsPictureForm ($i18next) {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    templateUrl: getTemplatePath('forms/settingsPictureForm.html'),
    link: function (scope) {
      scope.unsupportedFile = false;

      scope.saveCreateForm = function (value) {
        if (scope.unsupportedFile === false) {
          if (typeof(scope.PictureForm) === 'undefined' || scope.PictureForm.$valid) {
            scope.ctrl.saveCreateForm(value);
          }
        } else {
          scope.$root.alert($i18next.t('website_settings.picture_form.alert.file_type_not_supported_js_str'));
        }
      };
    }
  };
}

angular
  .module("buuqit")
  .controller("paymentTypeFormController", paymentTypeFormController)
  .directive("paymentTypeForm", paymentTypeForm);

paymentTypeFormController.$inject = ["$rootScope", "$scope", "$i18next"];
paymentTypeForm.$inject = [];

function paymentTypeFormController($rootScope, $scope, $i18next) {
  // public:stable
  function cancelAction() {
    $scope.cancel($scope.paymentType);
  }
  // public:stable
  function saveAction() {
    $scope.save($scope.paymentType);
  }

  angular.extend($scope, {
    cancelAction: cancelAction,
    saveAction: saveAction,
    accountingCategories: $rootScope.hotel.accountingCategories
  });

  var hotelWatcher = $rootScope.$watch('hotel', function (val) {
    if (val) {
      $scope.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
    }
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

function paymentTypeForm() {
  return {
    restrict: "E",
    scope: {
      paymentType: '=',
      cancel: '=',
      save: '='
    },
    controller: paymentTypeFormController,
    templateUrl: getTemplatePath("settings/payment_type_form.html")
  };
}

angular
  .module('buuqit')
  .directive('localeSelector', localeSelector)
  .directive('localeSelectorNext', localeSelectorNext);

localeSelector.$inject = ["$rootScope", "Globalize"];

function localeSelector ($rootScope, Globalize) {
  return {
    restrict: 'E',
    scope: {
      change: "="
    },
    templateUrl: getTemplatePath('forms/localeSelectorForm.html'),
    link: function (scope) {
      scope.Globalize = Globalize;
      scope.$rootScope = $rootScope;
      var dismissWatcher = scope.$watch('Globalize.locale', function(newValue, oldValue){
        scope.change(oldValue, newValue);
      });

      scope.$on('$destroy', function() {
        dismissWatcher();
      });
    }
  };
}


localeSelectorNext.$inject = ["$rootScope", "Globalize"];

function localeSelectorNext ($rootScope, Globalize) {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('forms/localeSelectorNextForm.html'),
    link: function (scope) {
      scope.Globalize = Globalize;
      scope.$rootScope = $rootScope;
      scope.nextLocale = function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        Globalize.nextLocale();
      }
    }
  };
}
angular
  .module("buuqit")
  .controller("identificationTypeFormController", identificationTypeFormController)
  .directive("identificationTypeForm", identificationTypeForm);

identificationTypeFormController.$inject = ["$rootScope", "$scope", "$i18next"];
identificationTypeForm.$inject = [];

function identificationTypeFormController($rootScope, $scope, $i18next) {
  // public:stable
  function cancelAction() {
    $scope.cancel($scope.identificationType);
  }
  // public:stable
  function saveAction() {
    $scope.save($scope.identificationType);
  }

  angular.extend($scope, {
    cancelAction: cancelAction,
    saveAction: saveAction,
  });
}

function identificationTypeForm() {
  return {
    restrict: "E",
    scope: {
      identificationType: '=',
      cancel: '=',
      save: '='
    },
    controller: identificationTypeFormController,
    templateUrl: getTemplatePath("settings/identification_type_form.html")
  };
}

angular
  .module("buuqit")
  .controller("ibeProfileFormController", ibeProfileFormController)
  .directive("ibeProfileForm", ibeProfileForm)
  .component(
    "bookingProfileSelectScrollable",
    TBFLibs.react2angular(
      TBFLibs.SelectScrollable,
      [ 
        "onSelect", 
        "options",
        "placeholder",
        "opened",
        "onDropdownVisibleChange",
        "mode",
        'caretDownFilledSuffix',
        "value",
        "onChange",
        "showArrow",
        "onScroll",
        "onSearch",
        "autoClearSearchValue",
        "onDeselect"
      ],
      ["$i18next"]
    )
  );

ibeProfileFormController.$inject = ["$rootScope", "$scope", "Slug", "ExtrasFactory"];

function ibeProfileFormController($rootScope, $scope, Slug, ExtrasFactory) {
  var IBE_CURRENCIES = {
    "GBP": {
      "symbol": "£",
      "name": "British Pound Sterling",
      "symbol_native": "£",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "GBP",
      "name_plural": "British pounds sterling",
      "format": "$#",
      "locale": "en-GB"
    },
    "EUR": {
      "symbol": "€",
      "name": "Euro",
      "symbol_native": "€",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "EUR",
      "name_plural": "euros",
      "format": "$#",
      "locale": "en-EU"
    },
    "USD": {
      "symbol": "$",
      "name": "US Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "USD",
      "name_plural": "US dollars",
      "format": "$#",
      "locale": "en-US"
    },
    "AUD": {
      "symbol": "AU$",
      "name": "Australian Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "AUD",
      "name_plural": "Australian dollars",
      "format": "$#",
      "locale": "en-AU"
    },
    "ISK": {
    "symbol": "Ikr",
      "name": "Icelandic Króna",
      "symbol_native": "kr",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "ISK",
      "name_plural": "Icelandic krónur",
      "locale": "is-IS"
    },
    "THB": {
      "symbol": "฿",
      "name": "Thai Baht",
      "symbol_native": "฿",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "THB",
      "name_plural": "Thai baht",
      "format": "$#",
      "locale": "th-TH"
    },
    "CAD": {
      "symbol": "CA$",
      "name": "Canadian Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CAD",
      "name_plural": "Canadian dollars",
      "format": "$#",
      "locale": "en-CA"
    },
    "BGN": {
      "symbol": "BGN",
      "name": "Bulgarian Lev",
      "symbol_native": "лв.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BGN",
      "name_plural": "Bulgarian leva",
      "format": "# $",
      "locale": "bg-BG"
    },
    "BRL": {
      "symbol": "R$",
      "name": "Brazilian Real",
      "symbol_native": "R$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BRL",
      "name_plural": "Brazilian reals",
      "format": "$#",
      "locale": "pt-BR"
    },
    "CHF": {
      "symbol": "CHF",
      "name": "Swiss Franc",
      "symbol_native": "franks",
      "decimal_digits": 2,
      "rounding": 0.05,
      "code": "CHF",
      "name_plural": "Swiss francs",
      "format": "# $",
      "locale": "fr-CH"
    },
    "CNY": {
      "symbol": "CN¥",
      "name": "Chinese Yuan",
      "symbol_native": "¥",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CNY",
      "name_plural": "Chinese yuan",
      "format": "$#",
      "locale": "zh"
    },
    "CZK": {
      "symbol": "Kč",
      "name": "Czech Republic Koruna",
      "symbol_native": "Kč",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CZK",
      "name_plural": "Czech Republic korunas",
      "format": "# $",
      "locale": "cs-CZ"
    },
    "DKK": {
      "symbol": "Dkr",
      "name": "Danish Krone",
      "symbol_native": "kr.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "DKK",
      "name_plural": "Danish kroner",
      "format": "# $",
      "locale": "da-DK"
    },
    "HKD": {
      "symbol": "HK$",
      "name": "Hong Kong Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "HKD",
      "name_plural": "Hong Kong dollars",
      "format": "$#",
      "locale": "en-HK"
    },
    "HRK": {
      "symbol": "kn",
      "name": "Croatian Kuna",
      "symbol_native": "kn",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "HRK",
      "name_plural": "Croatian kunas",
      "format": "# $",
      "locale": "hr"
    },
    "HUF": {
      "symbol": "Ft",
      "name": "Hungarian Forint",
      "symbol_native": "Ft",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "HUF",
      "name_plural": "Hungarian forints",
      "format": "# $",
      "locale": "hu-HU"
    },
    "IDR": {
      "symbol": "Rp",
      "name": "Indonesian Rupiah",
      "symbol_native": "Rp",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "IDR",
      "name_plural": "Indonesian rupiahs",
      "format": "$ #",
      "locale": "id-ID"
    },
    "ILS": {
      "symbol": "₪",
      "name": "Israeli New Sheqel",
      "symbol_native": "₪",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ILS",
      "name_plural": "Israeli new sheqels",
      "format": "$#",
      "locale": "he-IL"
    },
    "INR": {
      "symbol": "Rs",
      "name": "Indian Rupee",
      "symbol_native": "₹",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "INR",
      "name_plural": "Indian rupees",
      "format": "$#",
      "locale": "en-IN"
    },
    "JPY": {
      "symbol": "¥",
      "name": "Japanese Yen",
      "symbol_native": "￥",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "JPY",
      "name_plural": "Japanese yen",
      "format": "$#",
      "locale": "ja"
    },
    "KRW": {
      "symbol": "₩",
      "name": "South Korean Won",
      "symbol_native": "₩",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "KRW",
      "name_plural": "South Korean won",
      "format": "$#",
      "locale": "ko"
    },
    "MAD": {
      "symbol": "MAD",
      "name": "Moroccan Dirham",
      "symbol_native": "د.م.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MAD",
      "name_plural": "Moroccan dirhams"
    },
    "MXN": {
      "symbol": "MX$",
      "name": "Mexican Peso",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MXN",
      "name_plural": "Mexican pesos",
      "format": "$#",
      "locale": "es"
    },
    "MYR": {
      "symbol": "RM",
      "name": "Malaysian Ringgit",
      "symbol_native": "RM",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MYR",
      "name_plural": "Malaysian ringgits",
      "format": "$#",
      "locale": "ms-my"
    },
    "NOK": {
      "symbol": "Nkr",
      "name": "Norwegian Krone",
      "symbol_native": "kr",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NOK",
      "name_plural": "Norwegian kroner",
      "format": "# $",
      "locale": "no-no"
    },
    "NZD": {
      "symbol": "NZ$",
      "name": "New Zealand Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NZD",
      "name_plural": "New Zealand dollars",
      "format": "$#",
      "locale": "en-NZ"
    },
    "PHP": {
      "symbol": "₱",
      "name": "Philippine Peso",
      "symbol_native": "₱",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "PHP",
      "name_plural": "Philippine pesos",
      "format": "$#",
      "locale": "en-PH"
    },
    "PLN": {
      "symbol": "zł",
      "name": "Polish Zloty",
      "symbol_native": "zł",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "PLN",
      "name_plural": "Polish zlotys",
      "format": "#$",
      "locale": "pl"
    },
    "RON": {
      "symbol": "RON",
      "name": "Romanian Leu",
      "symbol_native": "lei",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "RON",
      "name_plural": "Romanian lei",
      "format": "# $",
      "locale": "ro-RO"
    },
    "RUB": {
      "symbol": "RUB",
      "name": "Russian Ruble",
      "symbol_native": "руб.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "RUB",
      "name_plural": "Russian rubles",
      "format": "# $",
      "locale": "ru-RU"
    },
    "SEK": {
      "symbol": "Skr",
      "name": "Swedish Krona",
      "symbol_native": "kr",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "SEK",
      "name_plural": "Swedish kronor",
      "format": "# $",
      "locale": "sv"
    },
    "SGD": {
      "symbol": "S$",
      "name": "Singapore Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "SGD",
      "name_plural": "Singapore dollars",
      "format": "$#",
      "locale": "zh-SG"
    },
    "TRY": {
      "symbol": "TL",
      "name": "Turkish Lira",
      "symbol_native": "₺",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "TRY",
      "name_plural": "Turkish Lira",
      "format": "$ #",
      "locale": "tk"
    },
    "ZAR": {
      "symbol": "R",
      "name": "South African Rand",
      "symbol_native": "R",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ZAR",
      "name_plural": "South African rand",
      "format": "$ #",
      "locale": "af-ZA"
    }
  };

  function cancelAction() {
    $scope.cancel($scope.profile);
  }

  function saveAction() {
    $scope.save($scope.profile);
  }

  function addQuestion() {
    $scope.profile.questions.push({
      question: '',
      type: 'input',
      options: []
    });
  }

  function removeQuestion(index) {
    $scope.profile.questions.splice(index, 1);
  }

  function onTitleChange() {
    if (!$scope.slugIsManuallyChanged) {
      $scope.profile.slug = Slug.slugify($scope.profile.title);
    }
  }

  function onSlugChange() {
    $scope.slugIsManuallyChanged = true;
  }

  angular.extend($scope, {
    slugIsManuallyChanged: false,
    formWidth: angular.element('.settings-body-block').width() + 38,
    rateCategories: $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved === false}),
    roomRepresentations: $rootScope.hotel.roomRepresentations,
    properties: $rootScope.hotel.properties,
    preselectedExtras: [],
    extras: [],
    preselectedExtrasTotal: null,
    extrasTotal: null,
    extrasLoading: false,
    preselectedExtrasReqParams: { term: '', pagination: { page: 1, limit: 100 } },
    extrasReqParams: { term: '', pagination: { page: 1, limit: 10 } },
    extrasValue: null,
    hotelHasMultipleProperties: $rootScope.hotel.properties.length > 1,
    option: {},
    types: [
      {
        value: 'input',
        label: 'Short Text'
      },
      {
        value: 'textarea',
        label: 'Text Box'
      },
      {
        value: 'select',
        label: 'Dropdown Menu'
      }
    ],
    languages: [
      {icon: '', title: 'English', code: 'en'},
      {icon: '', title: 'Deutsch (German)', code: 'de'},
      {icon: '', title: 'Русский (Russian)', code: 'ru'},
      {icon: '', title: '漢語 (Chinese)', code: 'ch'},
      {icon: '', title: 'Française (French)', code: 'fr'},
      {icon: '', title: 'ελληνικά (Greek)', code: 'el'},
      {icon: '', title: 'Română (Romanian)', code: 'ro'},
      {icon: '', title: 'Italiano (Italian)', code: 'it'},
      {icon: '', title: 'Bahasa Indonesia (Indonesian)', code: 'id'},
      {icon: '', title: 'Español (Spanish)', code: 'es'},
      {icon: '', title: 'ภาษาไทย (Thai)', code: 'th'},
      {icon: '', title: 'íslenska (Icelandic)', code: 'is'},
      {icon: '', title: 'Português (Portuguese)', code: 'pt'},
      {icon: '', title: 'Slovenščina (Slovenian)', code: 'sl-SI'}
    ],
    currencies: IBE_CURRENCIES,

    cancelAction: cancelAction,
    saveAction: saveAction,
    addQuestion: addQuestion,
    removeQuestion: removeQuestion,
    onTitleChange: onTitleChange,
    onSlugChange: onSlugChange,
    onLoadExtras: onLoadExtras,
    onSearchExtras: onSearchExtras,
    onSelectExtraChange: onSelectExtraChange,
    onDropdownVisibleChange: onDropdownVisibleChange,
    onSelectExtra: onSelectExtra,
    onDeselectExtra: onDeselectExtra
  });

  function updateRequestParams () {
    if($scope.profile.id) {
      if($scope.profile.extraIds.length > 0) {
        $scope.preselectedExtrasReqParams.extra_ids = $scope.profile.extraIds;
      }
    } else {
      $scope.preselectedExtrasReqParams.online_sellable = true;
    }
  }

  updateRequestParams();

  function preselectExtras() {
    var par = $scope.preselectedExtrasReqParams;

    if($scope.profile.id && $scope.profile.extraIds.length == 0) {
      $scope.extrasValue = [];
      return;
    }

    var extrasFactory = new ExtrasFactory();

    return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
      if (data.data) {
        
        var currentPage = $scope.preselectedExtrasReqParams.pagination.page;

        if(data.data.meta) {
          $scope.preselectedExtrasReqParams.pagination.page = data.data.meta.page + 1;
          $scope.preselectedExtrasTotal = data.data.meta.total;
        };

        if(data.data.extras) {
          var newExtrasOptions = data.data.extras.map(function(extra) {
            var optionVal = Number(extra.id);

            return { key: optionVal, value: optionVal, label: extra.title }
          });

          if(currentPage > 1) {
            $scope.preselectedExtras = $scope.preselectedExtras.concat(newExtrasOptions);
          } else {
            $scope.preselectedExtras = newExtrasOptions;
          };

          if($scope.preselectedExtras.length < $scope.preselectedExtrasTotal) {
            preselectExtras();
          } else {
            $scope.extrasValue = $scope.preselectedExtras;
            $scope.profile.extraIds = $scope.preselectedExtras.map(function(extra) {return extra.value });
          };
        };
      };
    });
  }

  if ($rootScope.hotel && $rootScope.hotel.id) preselectExtras();

  function onLoadExtras() {
    if($rootScope.hotel && $rootScope.hotel.id && $scope.extrasTotal ? ($scope.extras.length < $scope.extrasTotal) : true) {
      fetchExtras();
    };
  }

  function onSearchExtras(term) {
    $scope.extrasReqParams.term = term;
    $scope.extrasReqParams.pagination.page = 1;

    return fetchExtras();
  }

  function onSelectExtraChange(values) {
    $scope.profile.extraIds = values;
  }

  function onSelectExtra(value, option) {
    var newValue = { key: value, value: value, label: option.children };
    $scope.extrasValue = $scope.extrasValue.concat([newValue]);
    
    $scope.$apply();
  }

  function onDeselectExtra(value) {
    $scope.extrasValue = $scope.extrasValue.filter(function(e) { return e.value != value });

    $scope.$apply();
  }

  function onDropdownVisibleChange(open) {
    if(open && $scope.extras.length < 10 && $scope.extrasTotal === null && $rootScope.hotel && $rootScope.hotel.id) {
      fetchExtras();
    };
  }

  function fetchExtras() {
    if(!$scope.extrasLoading) {
      $scope.extrasLoading = true;
      var par = $scope.extrasReqParams;
      var extrasFactory = new ExtrasFactory();
      
      return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
        if (data.data) {
          
          var currentPage = $scope.extrasReqParams.pagination.page;
          var isTermEmpty = $scope.extrasReqParams.term === "";

          if(data.data.meta) {
            $scope.extrasReqParams.pagination.page = data.data.meta.page + 1;
            $scope.extrasTotal = isTermEmpty ? data.data.meta.total + $scope.preselectedExtras.length : data.data.meta.total;
          };

          if(data.data.extras) {
            var newExtrasOptions = data.data.extras.map(function(extra) {return {value: Number(extra.id), label: extra.title}});
            if(currentPage == 1) {
              $scope.extras = newExtrasOptions;
            } else {
              $scope.extras = $scope.extras.concat(newExtrasOptions);
            };
          };
        };
      }).finally (function() {
        $scope.extrasLoading = false;
      });
    } else {
      return Promise.resolve()
    };
  };
}
function ibeProfileForm() {
  return {
    restrict: "E",
    scope: {
      profile: '=',
      cancel: '=',
      save: '='
    },
    controller: ibeProfileFormController,
    templateUrl: getTemplatePath("settings/edit_ibe_profile_form.html")
  };
}

angular
  .module('buuqit')
  .directive('settingsFacilityForm', settingsFacilityForm);

function settingsFacilityForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    templateUrl: getTemplatePath('forms/settingsFacilityForm.html'),
    link: function (scope) {
      scope.uniqIcons = _.uniq(icons);
      scope.saveCreateForm = function (value) {
        if (scope.FacilityForm.$valid) {
          scope.ctrl.saveCreateForm(value);
        }
      };
    }
  };
}
angular
  .module("buuqit")
  .directive("settingsExtraCategoryForm", settingsExtraCategoryForm);

settingsExtraCategoryForm.$inject = ["$rootScope"];

function settingsExtraCategoryForm($rootScope) {
  return {
    restrict: "E",
    scope: {
      value: "=ngModel",
      ctrl: "=ngScope",
      ngChange: "&"
    },
    templateUrl: getTemplatePath("forms/settingsExtraCategoryForm.html"),
    link: function(scope, element) {
      scope.user = $rootScope.user;
      scope.saveCategoryForm = function(value) {
        if (scope.ExtraForm.$valid && ((value.taxGroups && value.taxGroups.length > 0) || value.withoutTaxes) ) {
          if (value.withoutTaxes) {
            value.taxGroups = []
          }

          scope.ctrl.saveCategoryForm(value);
        }
      };

      var hotelWatcher = $rootScope.$watch('hotel', function (val) {
        if (val) {
          scope.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
        }
      });
      scope.$on('$destroy', function () {
        if (hotelWatcher) {
          hotelWatcher();
        }
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('settingsDiscountForm', settingsDiscountForm);

function settingsDiscountForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    templateUrl: getTemplatePath('forms/settingsDiscountForm.html'),
    link: function (scope) {
      scope.saveCreateForm = function (value) {
        if (scope.DiscountForm.$valid) {
          scope.ctrl.saveCreateForm(value);
        }
      };
    }
  };
}
angular
  .module('buuqit')
  .directive('coverRoomTypeForm', coverRoomTypeForm);

coverRoomTypeForm.$inject = [];

function coverRoomTypeForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      ngChange: "&"
    },
    controller: coverRoomTypeFormController,
    templateUrl: getTemplatePath('forms/coverRoomTypeForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}


coverRoomTypeFormController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$http",
  "CoverRoomTypeFactory",
  "Globalize"
];


function coverRoomTypeFormController ($rootScope, $scope, $i18next, $http, CoverRoomTypeFactory, Globalize) {
  angular.extend(
    $scope,
    {
      // Variables
      saving : false,
      selectedAvailableFacility : null,
      selectedChoosedFacility   : null,
      originalCoverRoomType : angular.copy($scope.value),
      roomTypes: [],

      // Methods
      moveToSelected : moveToSelected,
      moveFromSelected : moveFromSelected,
      closeCreateForm : closeCreateForm,
      saveCreateForm : saveCreateForm,
      multipleFileUpload : multipleFileUpload,
      removePhoto : removePhoto,
      featurePhoto: featurePhoto,
      addBedConfig: addBedConfig,
      removeBedConfig: removeBedConfig,
      addBed: addBed,
      removeBed: removeBed,
      loadBedConfig: loadBedConfig,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function (val) {
    if (val) {
      $scope.facilities = angular.copy($rootScope.hotel.facilities);
      $scope.roomTypes = $rootScope.hotel.roomTypes;
      $scope.originalFacilities = angular.copy($scope.facilities);
      $scope.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
    }
  });

  if ($scope.$parent.RoomTypeCtrl) {
    $scope.parent = $scope.$parent.RoomTypeCtrl;
  } else {
    $scope.parent = $scope.$parent.$parent.$parent;
  }


  function moveToSelected () {
    var selected = $scope.selectedAvailableFacility,
        facility = $scope.facilities.filter(function(facility) { return facility.id == selected; })[0];

    $scope.value.facilities.push(facility);
    $scope.facilities.splice($scope.facilities.indexOf(facility), 1);

    $scope.selectedAvailableFacility = null;
  }


  function moveFromSelected () {
    var selected = $scope.selectedChoosedFacility,
        facility = $scope.value.facilities.filter(function(facility) { return facility.id == selected; })[0];

    $scope.facilities.push(facility);
    $scope.value.facilities.splice($scope.value.facilities.indexOf(facility), 1);

    $scope.selectedChoosedFacility = null;
  }


  function closeCreateForm () {
    if (typeof($scope.value.id) === 'undefined') {
      angular.copy($scope.originalCoverRoomType, $scope.value);
    } else {
      angular.copy($scope.originalCoverRoomType, $scope.value);
    }

    $scope.facilities = angular.copy($scope.originalFacilities);

    $scope.parent.editedCoverRoomType    = null;
    $scope.parent.createCoverRoomTypeFormVisible = false;
  }


  function saveCreateForm () {
    $scope.saving = true;
    Globalize.updateCurrentTranslation($scope.value, 'coverRoomType');
    $scope.value.bedConfig = JSON.stringify($scope.value.bedConfigRaw);
    if ($scope.value.id) {
      updateCoverRoomType();
    } else {
      createCoverRoomType();
    }
  }


  function createCoverRoomType () {
    $scope.value.hotelId = $rootScope.hotel.id;
    $scope.value.photos = $scope.value.photos.map(function(el) {return el.id;});

    new CoverRoomTypeFactory($scope.value)
      .create()
      .then(
        function (data) {
          $scope.saving = false;
          $rootScope.hotel.coverRoomTypes.push(data);
          $scope.parent.coverRoomTypes = $rootScope.hotel.coverRoomTypes;
          $scope.parent.newRoomType = angular.copy($scope.parent.originalRoomType);
          $rootScope.hotel.get().then(function() {
            $scope.parent.createCoverRoomTypeFormVisible = false;
          });
        },
        function(error) {
          console.error('Error creating cover room type:', error);
          $scope.saving = false;
          $rootScope.notify($i18next.t('profile_nav.settings.inventory.room_type_form.notify.virtual_room_type_is_not_saved_check_data_and_try_again_js_str'));
        }
      );
  }


  function updateCoverRoomType () {
    $scope.value.hotelId = $rootScope.hotel.id;

    new CoverRoomTypeFactory($scope.value)
      .update()
      .then(
        function (data) {
          $scope.saving = false;
          $rootScope.hotel.coverRoomTypes.filter(function(coverRoomType) { return coverRoomType.id == data.id; })[0] = data;
          angular.copy(data, $scope.originalRoomType);
          $scope.parent.editedCoverRoomType = null;
          $rootScope.loadHotel();
        },
        function(error) {
          console.error('Error updating cover room type:', error);
          $scope.saving = false;
          $rootScope.notify($i18next.t('profile_nav.settings.inventory.room_type_form.notify.virtual_room_type_is_not_saved_check_data_and_try_again_js_str'));
        }
      );
  }


  function multipleFileUpload ($event) {
    var files  = $event.target.files;
    var loaded = 0;
    $scope.photoLoaded = true;

    _.each(files, function (file) {
      var fd = new FormData();
      fd.append("photo[photo]", file);
      
      if ($scope.value.id) {
        fd.append("photo[cover_room_type_id]", $scope.value.id);
      }

      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/cover_room_type_photos', fd, {
          headers: {'Content-Type': undefined },
          transformRequest: angular.identity
      }).success(function(response) {
        $scope.value.photos.push(response.photo);
      }).error(function(response) {
        console.error('Error while trying multiple file upload:', response);
      }).then(function () {
        loaded++;
        if (loaded == files.length) {
          $scope.photoLoaded = false;
        }
      });
    });
  }


  function removePhoto (photo) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = $scope.value.photos.indexOf(photo);
      $scope.value.photos.splice(index, 1);
    } else {
      $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/cover_room_type_photos/'+photo.id).then(function (response) {
        photo.loading = false;
        if (response.statusText === 'OK') {
          var index = $scope.value.photos.indexOf(photo);
          $scope.value.photos.splice(index, 1);
        } else {
          console.error('Error while trying to remove photo:', response);
          $rootScope.alert(response.statusText);
        }
      });
    }
  }


  function featurePhoto (photo) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = $scope.value.photos.indexOf(photo);
      photo.featured = !photo.featured;
      $scope.value.photos[index] = photo;
    } else {
      photo.featured = !photo.featured;
      $http.put(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/cover_room_type_photos/'+photo.id, {photo: photo}).then(function (response) {
        photo.loading = false;
        if (response.data && response.data.photo) {
          var index = $scope.value.photos.indexOf(photo);
          $scope.value.photos[index] = response.data.photo;
        } else {
          console.error('Error while trying to feature photo:', response);
          $rootScope.alert($i18next.t('profile_nav.settings.inventory.room_type_form.alert.unknown_error_please_contact_with_administator_js_str'));
        }
      });
    }
  }

  function addBedConfig() {
    if (!$scope.value.bedConfigRaw || !$scope.value.bedConfigRaw.push) {
      $scope.value.bedConfigRaw = [];
    }
    $scope.value.bedConfigRaw.push([
      ['', 1, null]
    ]);
  }

  function removeBedConfig(index) {
    $scope.value.bedConfigRaw.splice(index, 1);
  }

  function addBed(config) {
    config.push(['', 1, null]);
  }

  function removeBed(config, index) {
    config.splice(index, 1);
  }

  function loadBedConfig() {
    var rt = $scope.roomTypes.filter(function(el) {
      return el.id == $scope.value.roomTypeId;
    })[0];

    $scope.value.bedConfigRaw = angular.copy(rt.bedConfigRaw);
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .directive('settingsConditionGroup', settingsConditionGroup);

settingsConditionGroup.$inject = [
  "RecursionHelper"
];

function settingsConditionGroup (RecursionHelper) {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ctrl: '=ngScope',
      parent: '=parent',
      ngChange: "&"
    },
    templateUrl: getTemplatePath('ui/condition_group.html'),
    link: function (scope) {},
    compile: function(element) {
      return RecursionHelper.compile(element);
    }
  };
}
angular
  .module('buuqit')
  .directive('accountingCategoryForm', accountingCategoryForm);

function accountingCategoryForm() {
  return {
    restrict: 'E',
    scope: {
      accountingCategory: '=',
      cancelCallback: '=',
      saveCallback: '=',
      requestInProgress: '=',
    },
    controller: AccountingCategoryFormController,
    controllerAs: 'vm',
    templateUrl: getTemplatePath('forms/accountingCategoryForm.html'),
    bindToController: true,
  };
}

AccountingCategoryFormController.$inject = [];

function AccountingCategoryFormController() {
  var vm = this;

  vm.cancelAction = function () {
    vm.cancelCallback();
  };

  vm.saveAction = function() {
    vm.saveCallback(vm.accountingCategory);
  };
}

angular
  .module('buuqit')
  .directive('zoomControl', zoomControl);

zoomControl.$inject = ["$rootScope", "Dates"];

function zoomControl ($rootScope, Dates) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      element[0].className = 'scheduler ng-scope zoom-'+scope.zoomLevel;
      scope.zoomIn = function () {
        if (scope.zoomLevel < 12) {
          scope.zoomLevel++;
        }

        zoomCallback();
      };

      scope.zoomOut = function () {
        if (scope.zoomLevel > 1) {
          scope.zoomLevel--;
        }

        zoomCallback();
      };


      function zoomCallback() {
        var position  = Math.floor((angular.element('.content-slots .scheduler-right').scrollLeft() - scope.OFFSET_SCROLL + 120) / scope.slotWidth),
            canceledH = angular.element('.canceled-rooms:eq(0)').outerHeight() / scope.slotHeight;

        localStorage.setItem('zoom_level', scope.zoomLevel);

        scope.slotWidth  = scope.zoomLevels[scope.zoomLevel - 1].width;
        scope.slotHeight = scope.zoomLevels[scope.zoomLevel - 1].height;

        scope.holdHeight = scope.slotHeight * scope.holdedArray.length;
        scope.cancelHeight = scope.slotHeight * scope.canceledArray.length;

        if (canceledH > 1) {
          angular.element('.canceled-rooms').css('height', canceledH * scope.slotHeight + 'px');
        }

        if (scope.days) {
          $('.content-slots .scheduler-right')
            .scrollLeft(scope.slotWidth * position + scope.OFFSET_SCROLL - 120);
        }

        element[0].className = 'scheduler ng-scope zoom-'+scope.zoomLevel;

        $rootScope.$broadcast('scheduler:zoomLevelChanged');
      }
    }
  };
}

angular
  .module('buuqit')
  .directive('schedulerSelector', schedulerSelector);

schedulerSelector.$inject = ['Dates', '$rootScope'];

function schedulerSelector (Dates, $rootScope) {
  return {
    restrict: 'A',
    link: function (scope) {
      scope.$on('mouseOver', function() {
        angular.element(scope.last.event.currentTarget).trigger('mouseup');
      });

      scope.mousedown = function (room, date, event) {
        if (date < scope.currentDate) {
          return false;
        } else {
          if (!angular.element('body').hasClass('mobile')) {
            $rootScope.currentScrollPosition = angular.element('.scheduler-right:first').scrollLeft();
            angular.element('.scheduler-right').addClass('no-scroll');
            if (event.button === 0) {
              scope.booking_handler.css({
                left: scope.slotWidth * scope.datePosition(date)  + scope.OFFSET_SCROLL,
                top: scope.slotHeight * scope.slotOfRoom(room.id),
                height: scope.slotHeight - 1,
                display: 'block',
                width: scope.slotWidth + 'px'
              });

              scope.new_booking = {
                room_id: room.id,
                date_in: date,
                date_out: null,
                move: true
              };
            }
          }
        }
      };


      scope.mouseup = function (room, date, event) {
        if (date < scope.currentDate) {
          return false;
        } else {
          if (angular.element('body').hasClass('mobile')) {
            scope.openContextMenu(event);
            angular.element('#ContextMenu').addClass('open').css('top', event.clientY+'px').css('left', event.clientX+'px')
          } else {
            angular.element('.scheduler-right').removeClass('no-scroll');
            if (event.button === 0 || event.button === undefined) {
              if (scope.new_booking && scope.new_booking.room_id == room.id) {
                scope.new_booking.date_out = (angular.copy(date)).setDate(date.getDate());

                // Reverse date if user draw from right to left
                if (scope.new_booking.date_in > scope.new_booking.date_out) {
                  date = scope.new_booking.date_out;
                  scope.new_booking.date_out = scope.new_booking.date_in;
                  scope.new_booking.date_in = date;
                }

                scope.new_booking.date_out = moment(angular.copy(scope.new_booking.date_out)).add(1, 'day').toDate();
                scope.open_modal(angular.copy(scope.new_booking), event);
                scope.new_booking = null;
              } else {
                if (scope.new_booking) {
                  $rootScope.alert("You can only select one room using the booking calendar, please select your first room then use the \"add room\" button for multiple rooms. Want to see video instructions? Click Here", "Trying to book multiple rooms?");
                }
              }

              scope.booking_handler.css({
                display: 'none'
              });
            }
          }
        }
      };


      scope.mousemove = function (room, date, event) {
        if (date < scope.currentDate) {
          return false;
        } else {
          var start_date, checkin, checkout;

          scope.last = {
            room: room,
            data: date,
            event: event
          };

          if (scope.new_booking && !scope.new_booking.move) {
            // Refactor date getter
            checkin = new Date(scope.blocker_booking.checkinDate);
            checkout = new Date(scope.blocker_booking.checkoutDate);
            checkout = checkout.setDate(checkout.getDate() - 1);

            if ((scope.new_booking.date_in < checkin && date < checkin) || (scope.new_booking.date_in > checkout && date > checkout)) {
              scope.blocker_booking = null;
              scope.new_booking.move = true;
            }
          }

          if (scope.new_booking && scope.new_booking.room_id == room.id && date >= scope.currentDate && scope.new_booking.move) {
            start_date = date < scope.new_booking.date_in ? date : scope.new_booking.date_in;

            scope.booking_handler.css({
              width: ((Math.abs(Dates.slotOfDay(scope.new_booking.date_in) - Dates.slotOfDay(date)) + 1) * scope.slotWidth) + 'px',
              left: (scope.slotWidth * scope.datePosition(start_date) + scope.OFFSET_SCROLL) + 'px'
            });
          }
        }
      };
    }
  };
}

angular
  .module('buuqit')
  .directive('schedulerBody', schedulerBody);

schedulerBody.$inject = ["$window"];

function schedulerBody ($window) {
  return {
    restrict: 'A',
    link: function (scope) {
      var win = angular.element($window),
          getWindowDimensions;


      getWindowDimensions = function () {
        return {
          'h': win.height(),
          'w': win.width()
        };
      };


      scope.$watch(
        getWindowDimensions,
        function () {
          angular.element('#scheduler-body').height(win.height() - 40);
          angular.element('#scheduler-body .scheduler-left .rooms').height(win.height() - 102);
          angular.element('#scheduler-body .scheduler-right').height(win.height() - 102);
        },
        true
      );


      win
        .bind('resize', function () {
          scope.$apply();
        })
        .bind('mousemove', function (e) {
          $window.clientX = e.clientX;
          $window.clientY = e.clientY;
        });
    }
  };
}
angular
  .module('buuqit')
  .directive('headerScroller', headerScroller);

headerScroller.$inject = ["$rootScope", "Dates"];

function headerScroller ($rootScope, Dates) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var header    = angular.element('.content-header .scheduler-right'),
          container = angular.element('.content-slots .scheduler-right'),
          columns   = angular.element('.content-slots .scheduler-right .columns-container'),
          rooms     = angular.element('.content-slots .scheduler-left .rooms'),
          loading = false,
          updateDataDebounced,
          oldX = null,
          firstCallback = true,
          oldY = null;

      function datesLoadingCallback () {
        loading = false;
        clearTimeout(updateDataDebounced);
        updateDataDebounced = setTimeout(updateData, 1500);
      }

      function updateData () {
        if (firstCallback) {
          firstCallback = false;
        } else {
          scope.holdedArray = [[]];
          scope.canceledArray = [[]];

          for(var x = 0; x < Dates.dates.length; x++) {
            scope.holdedArray[0].push(0);
            scope.canceledArray[0].push(0);
          }

          scope.getBookings();
          scope.getBlockers();
          scope.getDateNotes();
          scope.getRateByDates();
        }
      }

      function scrollCallback () {
        var posLeft = $(this).scrollLeft(),
          posTop = $(this).scrollTop(),
          minVisibleDatePosition, maxVisibleDatePosition;

        header.scrollLeft( posLeft );
        rooms.scrollTop( posTop );
        scope.hideContextMenu();

        if (loading === false) {
          minVisibleDatePosition = Math.floor((posLeft - scope.OFFSET_SCROLL) / scope.slotWidth);
          maxVisibleDatePosition = Math.floor(((posLeft + container.width()) - scope.OFFSET_SCROLL) / scope.slotWidth);

          if (maxVisibleDatePosition + (Math.floor((150 / scope.slotWidth) * 10)) > Dates.endDatePos) {
            loading = true;
            $rootScope.schedulerScrolling = true;
            Dates.load(scope.days.length - 1, 1, 15, datesLoadingCallback);
          }

          if (minVisibleDatePosition - (Math.floor((150 / scope.slotWidth) * 10)) < Dates.startDatePos ) {
            loading = true;
            $rootScope.schedulerScrolling = true;
            Dates.load(0, -1, 15, datesLoadingCallback);
          }
        }
      }

      element.on('scroll', scrollCallback);

      $(element).on('mouseout', function($event) {
        if ($($event.toTarget).closest('.calendar-zone').size() === 0) {
          oldX = null;
          oldY = null;
          $('.content-header .days-column.hovered').removeClass('hovered');
          $('.room-info.hovered').removeClass('hovered');
        }
      });
      $(element).on('mousemove', function($event) {
        var top = 102;

        positionX = Math.floor(($event.clientX + $(element).scrollLeft() - scope.OFFSET_SCROLL) / scope.slotWidth);
        positionY = Math.floor(($event.clientY - top + $(element).scrollTop()) / scope.slotHeight);

        if (positionX !== oldX) {
          oldX = positionX;
          $('.content-header .days-column.hovered').removeClass('hovered');
          $('.content-header .days-column[data-index="' + positionX + '"]').addClass('hovered');
        }

        if (positionY !== oldY) {
          oldY = positionY;
          $('.room-info.hovered').removeClass('hovered');
          if (positionY < scope.rooms.length) {
            $('.room-info:eq(' + positionY + ')').addClass('hovered');
          }
        }
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('headerColumns', headerColumns);

headerColumns.$inject = ["$rootScope", "Dates"];

function headerColumns ($rootScope, Dates) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var renderedElements = [],
          today = scope.currentDate;

      function init () {
        today = scope.currentDate;
        render(Dates.dates);

        $(element)
          .on('click', '.add-note a, .note i', function ($event) {
            $event.preventDefault();
            scope.addNote(
              $event,
              Dates.dates[Math.abs(Dates.startDatePos) + parseInt($($event.currentTarget).closest('.days-column').data('index'))]
            );
          })
          .on('mouseover', '.note i', function ($event) {
            scope.showPopover($event, $($event.currentTarget).closest('.note').data('note'));
          })
          .on('mouseout', '.note i', function () {
            scope.hidePopover();
          });

        scope.$on('Dates:loaded', update);
        scope.$on('Dates:update', updateOneDate);
        scope.$on('scheduler:zoomLevelChanged', updateZoomLevel);
        scope.$on('scheduler:changeDate', function() {
          today = scope.currentDate;
          angular.element(element).find('.days-column').remove();
          renderedElements = [];
          render(Dates.dates);
        });
      }


      function template (date) {
        var dateIndex = moment(date.date).diff(moment(today), 'days'),
          leftOffset = scope.slotWidth * dateIndex + scope.OFFSET_SCROLL,
          noteView = '',
          currentClass = '';

        renderedElements.push(date.date.toISOString().substr(0,10));

        if (_.isEmpty(date.note)) {
          noteView = '<div class="pull-right add-note">'+
            '<a href=""><i class="fa fa-edit"></i></a>'+
            '</div>';
        } else {
          noteView = '<div class="pull-right note" data-note="'+date.note+'">' +
            '<i class="fa fa-asterisk"></i></div>';
        }

        if (dateIndex === 0) {
          currentClass = ' current-date';
        }

        if (dateIndex < 0) {
          currentClass += ' day-before';
        }

        if (date.date.toISOString().substr(0,10) == scope.selectedDate.toISOString().substr(0,10)) {
          currentClass += ' selected-date';
        }

        if (date.date.getDay() === 6 || date.date.getDay() === 0) {
          currentClass += ' weekend';
        }

        return '<div class="days-column'+ currentClass +'" style="left: ' + leftOffset + 'px;" data-index="' + dateIndex + '" data-date="' + date.date.toISOString().substr(0,10) + '">' +
        '<div class="day-slot"><span class="fullDate">' +
        '<span class="day-number">'+moment(date.date).format('DD')+'</span> '+
        moment(date.date).format('dddd') +
        '<br><span class="day-title">' +
        moment(date.date).format('MMMM') +
        '</span></span>' +
        '<span class="smallDate">' +
        '<span class="day-number">'+moment(date.date).format('DD')+'</span> '+
        moment(date.date).format('ddd') +
        '<br><span class="day-title">' +
        moment(date.date).format('MMM') +
        '</span></span>' +
        noteView +
        '</div>';
      }


      function render (dates) {
        var out = [];

        angular.forEach(dates, function (date) {
          out.push($(template(date)));
        });

        angular.element(element).append(out);
      }


      function update () {
        var dates = _.map(Dates.dates, function(date) {return date.date.toISOString().substr(0,10);}),
            for_render_ids = _.difference(dates, renderedElements);

        render(
          Dates.dates.filter(
            function(date) {
              return for_render_ids.indexOf(date.date.toISOString().substr(0,10)) !== -1;
            }
          )
        );
      }


      function updateOneDate (event, date) {
        angular.element(element).find('.days-column[data-date="' + new Date(date.date).toISOString().substr(0,10) + '"]').replaceWith(
          template(date)
        );
      }


      function updateZoomLevel () {
        angular.element(element).find('.days-column').each(function (index, column) {
          var el = angular.element(column),
              dateIndex = parseInt(el.data('index')),
              leftOffset = scope.slotWidth * dateIndex + scope.OFFSET_SCROLL;

          el.css('left', leftOffset+'px');
        });
      }


      if (scope.rooms !== undefined) {
        init();
      } else {
        scope.$watch('rooms', function(val) {
          if (val !== undefined) {
            init();
          }
        });
      }
      scope.$on('$destroy', function () {
        $(element).off('click', '.add-note a, .note i');
        $(element).off('mouseover', '.note i');
        $(element).off('mouseout', '.note i');
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('groupBookingCommonFieldsForm', groupBookingCommonFieldsForm);

function groupBookingCommonFieldsForm() {
  return {
    restrict: 'E',
    scope: {
      checkinDate: '=',
      checkinMinDate: '=',
      checkoutDate: '=',
      checkoutMinDate: '=',
      numberOfNights: '=',
      numberOfNightsCollection: '=',
      checkinTime: '=',
      checkinTimeCollection: '=',
      rateCategoryId: '=',
      rateCategoryCollection: '=',
      cancellationPolicyId: '=',
      cancellationPolicyCollection: '=',
      onDatesChange: '='
    },
    controller: groupBookingCommonFieldsFormCtrl,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: getTemplatePath('scheduler/group_booking_common_fields_form.html'),
  };
}

groupBookingCommonFieldsFormCtrl.$inject = [];

function groupBookingCommonFieldsFormCtrl() {
  this.checkinDateChange = function () {
    var val = this.checkinDate;

    this.checkoutDate = moment(val).add(this.numberOfNights, 'days').toDate();
    this.checkoutMinDate = moment(val).add(1, 'day').toDate();

    this.onDatesChange({
      checkinDate: this.checkinDate,
      checkoutDate: this.checkoutDate,
      numberOfNights: this.numberOfNights
    });
  };

  this.checkoutDateChange = function () {
    var val = this.checkoutDate;

    var diff = moment(val).diff(moment(this.checkinDate), 'days');

    if (diff > 0) {
      if (this.numberOfNights != diff) {
        this.numberOfNights = diff;
      }
    }

    this.onDatesChange({
      checkinDate: this.checkinDate,
      checkoutDate: this.checkoutDate,
      numberOfNights: this.numberOfNights
    });
  };

  this.numberOfNightsChange = function () {
    var out = moment(this.checkinDate).add(this.numberOfNights, 'days').toDate();

    if (out != this.checkoutDate) {
      this.checkoutDate = out;
    }

    this.onDatesChange({
      checkinDate: this.checkinDate,
      checkoutDate: this.checkoutDate,
      numberOfNights: this.numberOfNights
    })
  };
}
angular
  .module('buuqit')
  .directive('columnsContainer', columnsContainer);

columnsContainer.$inject = ["$rootScope", "Dates"];

function columnsContainer ($rootScope, Dates) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var renderedElements = [],
          today = moment(moment().format('YYYY-MM-DD')).toDate();


      function init () {
        today = scope.currentDate;
        render(Dates.dates);

        $(element)
          .on('mouseup', '.room-slot.clickable', function($event) {
            scope.mouseup(
              scope.rooms[$($event.currentTarget).index()],
              Dates.dates[Math.abs(Dates.startDatePos) + parseInt($($event.currentTarget).closest('.days-column').data('index'))].date,
              $event
            );
          })
          .on('mousedown', '.room-slot.clickable', function($event) {
            scope.mousedown(
              scope.rooms[$($event.currentTarget).index()],
              Dates.dates[Math.abs(Dates.startDatePos) + parseInt($($event.currentTarget).closest('.days-column').data('index'))].date,
              $event
            );
          })
          .on('mousemove', '.room-slot.clickable', function($event) {
            scope.mousemove(
              scope.rooms[$($event.currentTarget).index()],
              Dates.dates[Math.abs(Dates.startDatePos) + parseInt($($event.currentTarget).closest('.days-column').data('index'))].date,
              $event
            );
          });


        scope.$on('Dates:loaded', update);
        scope.$on('scheduler:zoomLevelChanged', updateZoomLevel);
        scope.$on('scheduler:areaSizeChanged', updateAreaSizes);
        scope.$on('scheduler:changeDate', function() {
          today = scope.currentDate;
          angular.element(element).find('.days-column').remove();
          renderedElements = [];
          render(Dates.dates);
        });
      }


      function render (dates) {
        var out = [];

        angular.forEach(dates, function (date) {
          var dateIndex = moment(date.date).diff(moment(today), 'days'),
            className = dateIndex < 0 ? ' day-before' : '',
            leftOffset = scope.slotWidth * dateIndex + scope.OFFSET_SCROLL,
            el;
            if (date.date.getDay() === 6 || date.date.getDay() === 0) {
              className += ' weekend';
            }
            el = $('<div class="days-column' + className + '" data-index="' + dateIndex + '" style="left: ' + leftOffset + 'px;"></div>');

          for (var x = 0; x < scope.rooms.length; x++) {
            el.append('<div class="room-slot clickable"></div>');
          }

          el.append(
            '<div class="separator"></div>' +
            '<div class="holded-rooms room-slot" style="height: ' + scope.holdHeight + 'px"></div>' +
            '<div class="separator"></div>' +
            '<div class="canceled-rooms room-slot" style="height: ' + scope.cancelHeight + 'px"></div>'
          );

          renderedElements.push(date.date.getTime());
          out.push(el);
        });

        angular.element(element).append(out);
      }


      function update () {
        var dates = _.map(Dates.dates, function(date) {return date.date.getTime();}),
          for_render_ids = _.difference(dates, renderedElements);

        render(
          Dates.dates.filter(
            function(date) {
              return for_render_ids.indexOf(date.date.getTime()) !== -1;
            }
          )
        );
      }


      function updateZoomLevel () {
        angular.element(element).find('.days-column').each(function (index, column) {
          var el = angular.element(column),
            dateIndex = parseInt(el.data('index')),
            leftOffset = scope.slotWidth * dateIndex + scope.OFFSET_SCROLL;

          el.css('left', leftOffset+'px');
        });

        updateAreaSizes();
      }


      function updateAreaSizes () {
        angular.element('.holded-rooms').css('height', scope.holdHeight+'px');
        angular.element('.canceled-rooms').css('height', scope.cancelHeight+'px');
      }


      if (scope.rooms !== undefined) {
        init();
      } else {
        scope.$watch('rooms', function(val) {
          if (val !== undefined) {
            init();
          }
        });
      }
      scope.$on('$destroy', function () {
        $(element).off('mouseup', '.room-slot.clickable');
        $(element).off('mousedown', '.room-slot.clickable');
        $(element).off('mousemove', '.room-slot.clickable');
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('bookingRoomTypeShortForm', bookingRoomTypeShortForm);

function bookingRoomTypeShortForm() {
  return {
    restrict: 'E',
    scope: {
      booking: '=',
      roomType: '=',
      addRoom: '=',
      buildRoomForGroupBooking: '='
    },
    controller: bookingRoomTypeShortFormCtrl,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: getTemplatePath('scheduler/booking_room_type_short_form.html'),
  };
}

bookingRoomTypeShortFormCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$filter",
  "$timeout",
  "$http"
];

function bookingRoomTypeShortFormCtrl($rootScope, $scope, $i18next, $filter, $timeout, $http) {
  var ctrl = this;
  resetForm();
  ctrl.roomRates = $rootScope.hotel.roomRates;
  // ctrl.roomType.basketRooms = []
  ctrl.rooms = $rootScope.hotel.rooms;
  ctrl.adults_select = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16];
  ctrl.child_select = ['0',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16];

  function resetForm() {
    ctrl.roomType.number_of_adults = ctrl.roomType.defaultAdultsCount;
    ctrl.roomType.number_of_children = ctrl.roomType.defaultChildrenCount;
    ctrl.roomType.number_of_rooms = null;
  }

  this.removeAllRooms = function () {
    ctrl.roomType.basketRooms.forEach(function(basket_room) {
      ctrl.roomType.availableRooms.push(basket_room);
    })
    ctrl.roomType.basketRooms = [];
    $rootScope.$broadcast('updateBasketRooms');
  }

  this.addRooms = function () {
    if (!ctrl.roomType.number_of_rooms) {return}
    ctrl.roomType.availableRooms.sort(function(a,b) {return b.priority - a.priority})

    for (var i = 1; i <= ctrl.roomType.number_of_rooms; i++) {
      availableRoom = ctrl.roomType.availableRooms.pop();
      if (typeof(availableRoom) == 'undefined') {
        return
      }
      availableRoom.roomTypeName = ctrl.roomType.name;
      availableRoom.number_of_children = ctrl.roomType.number_of_children
      availableRoom.number_of_adults = ctrl.roomType.number_of_adults
      if (i == 1) {
        ctrl.buildRoomForGroupBooking(1, availableRoom)
      }
      ctrl.roomType.basketRooms.push(availableRoom);
    }
    $rootScope.$broadcast('updateBasketRooms');
    resetForm();
  };
}

angular
  .module('buuqit')
  .directive('bookingRoomShortForm', bookingRoomShortForm);

function bookingRoomShortForm() {
  return {
    restrict: 'E',
    scope: {
      booking: '=',
      room: '=',
      roomIndex: '=',
      currencySymbol: '=',
      calcTotal: '=',
      onEditClick: '=',
      onDeleteClick: '='
    },
    controller: bookingRoomShortFormCtrl,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: getTemplatePath('scheduler/booking_room_short_form.html'),
  };
}

bookingRoomShortFormCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$filter",
  "$timeout",
  "$http",
];

function bookingRoomShortFormCtrl($rootScope, $scope, $i18next, $filter, $timeout, $http) {
  bookingRoomFullFormCtrl.call(this, $rootScope, $scope, $i18next, $filter, $timeout, $http);

  var ctrl = this;

  this.cancellationPolicies = $rootScope.hotel.cancellationPolicies.reduce(function (acc, item) { acc[item.id] = item.title; return acc; }, {});
  this.rateCategories = $rootScope.hotel.rateCategories.reduce(function (acc, item) { acc[item.id] = item.name; return acc; }, {});

  this.handleDeleteClick = function () {
    ctrl.onDeleteClick(this.roomIndex);
  };

  this.handleEditClick = function () {
    ctrl.onEditClick(this.roomIndex);
  };

  var groupBookingListener = $rootScope.$on('group_booking:room_id_update', function () {
    ctrl.room.$service._checkAvailability();

    ctrl.availableCoverRoomTypes = ctrl.room.$service.getCoverRoomTypes();
    ctrl.availableRooms = ctrl.room.$service.getRooms();
  });

  $scope.$on('$destroy', function () {
    if (groupBookingListener) {
      groupBookingListener();
    }
  });
}
angular
  .module('buuqit')
  .directive('bookingRoomFullForm', bookingRoomFullForm);

function bookingRoomFullForm() {
  return {
    restrict: 'E',
    scope: {
      booking: '=',
      room: '=',
      roomIndex: '=',
      blockedRooms: '=',
      calcTotal: '=',
      policies: '=',
      currencySymbol: '=',
      assignGuest: '=',
      onGuestChange: '=',
      clearGuestInfo: '=',
    },
    controller: bookingRoomFullFormCtrl,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: getTemplatePath('scheduler/booking_room_full_form.html'),
  };
}

bookingRoomFullFormCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$filter",
  "$timeout",
  "$http",
];

function bookingRoomFullFormCtrl($rootScope, $scope, $i18next, $filter, $timeout, $http) {
  var ctrl = this;

  //
  // Template vars
  //

  this.availableRateCategories = ctrl.room.$service.getRateCategories();
  this.availableRooms = ctrl.room.$service.getRooms();

  this.availableCoverRoomTypes = ctrl.room.$service.getCoverRoomTypes();

  this.recommendedMaxAdults = ctrl.room.$service.getRecommendedMaxAdults();
  this.recommendedMaxChildren = ctrl.room.$service.getRecommendedMaxChildren();

  this.prevDay = moment($rootScope.currentDate).toDate();
  this.adults_select = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16];
  this.child_select = ['0',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16];
  this.times = times;
  this.room_types_by_id = $rootScope.hotel.roomTypes.reduce(function(acc, el) { acc[el.id] = el; return acc; }, {});
  this.countries = countries_in;
  this.locales = locales;

  //
  // Template handlers
  //

  this.handleRoomCheckinDateChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleRoomCheckinDateChange()
      .then(function () {
        ctrl.availableRooms = ctrl.room.$service.getRooms();
        ctrl.availableRateCategories = ctrl.room.$service.getRateCategories();

        ctrl.calcTotal();
        ctrl.loadNights = false;
      });
  };

  this.handleRoomCheckoutDateChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleRoomCheckoutDateChange()
      .then(function () {
        ctrl.availableRooms = ctrl.room.$service.getRooms();
        ctrl.availableRateCategories = ctrl.room.$service.getRateCategories();

        ctrl.calcTotal();
        ctrl.loadNights = false;
      });
  };

  this.handleNumberOfNightsChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleNumberOfNightsChange()
      .then(function () {
        ctrl.availableRooms = ctrl.room.$service.getRooms();
        ctrl.availableRateCategories = ctrl.room.$service.getRateCategories();

        ctrl.calcTotal();
        ctrl.loadNights = false;
      })
  };

  this.handleRateCategoryIdChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.setRateCategoryById();
    ctrl.room.$service.handleRateCategoryChange()
      .then(function () {
        ctrl.recommendedMaxAdults = ctrl.room.$service.getRecommendedMaxAdults();
        ctrl.recommendedMaxChildren = ctrl.room.$service.getRecommendedMaxChildren();

        ctrl.calcTotal();
        ctrl.loadNights = false;
      });
  };

  this.handleNumberOfAdultsChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleRateCategoryChange()
      .then(function () {
        ctrl.recommendedMaxAdults = ctrl.room.$service.getRecommendedMaxAdults();
        ctrl.recommendedMaxChildren = ctrl.room.$service.getRecommendedMaxChildren();

        ctrl.calcTotal();
        ctrl.loadNights = false;
      });
  };

  this.handleNumberOfChildrenChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleRateCategoryChange()
      .then(function () {
        ctrl.recommendedMaxAdults = ctrl.room.$service.getRecommendedMaxAdults();
        ctrl.recommendedMaxChildren = ctrl.room.$service.getRecommendedMaxChildren();

        ctrl.calcTotal();
        ctrl.loadNights = false;
      });
  };

  this.handleRoomNightPriceChange = function () {
    ctrl.room.$service.handleRoomNightPriceChange();
    ctrl.calcTotal();
  };

  this.handleResetNightPricesClick = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.resetNightPrices().then(function () {
      ctrl.calcTotal();
      ctrl.loadNights = false;
    });
  };

  this.handleRoomIdChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleRoomIdChange().then(function () {
      ctrl.calcTotal();

      ctrl.availableRateCategories = ctrl.room.$service.getRateCategories();
      ctrl.availableRooms = ctrl.room.$service.getRooms();

      ctrl.recommendedMaxAdults = ctrl.room.$service.getRecommendedMaxAdults();
      ctrl.recommendedMaxChildren = ctrl.room.$service.getRecommendedMaxChildren();

      ctrl.loadNights = false;

      $rootScope.$broadcast('group_booking:room_id_update');
    });
  };

  this.handleCoverRoomTypeChange = function () {
    ctrl.loadNights = true;

    ctrl.room.$service.handleCoverRoomTypeChange().then(function () {
      ctrl.calcTotal();

      ctrl.availableRateCategories = ctrl.room.$service.getRateCategories();
      ctrl.availableRooms = ctrl.room.$service.getRooms();

      ctrl.recommendedMaxAdults = ctrl.room.$service.getRecommendedMaxAdults();
      ctrl.recommendedMaxChildren = ctrl.room.$service.getRecommendedMaxChildren();

      ctrl.loadNights = false;
    });
  };

  this.handleRoomTotalPriceChange = function () {
    ctrl.room.$service.handleRoomTotalPriceChange();
    ctrl.calcTotal();
  };

  this.handleRoomTotalForeignAmountChange = function () {
    ctrl.room.$service.handleRoomTotalForeignAmountChange();
    ctrl.calcTotal();
  };

  //
  // Guest widget
  //

  this.searchGuest = function(field) {
    var room = this.room;

    var params = {};
    params[field] = room.guest[field];

    if (room.wasSettled === undefined || room.wasSettled === null || new Date().getTime() - room.wasSettled > 2500) {
      return $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/guests/autocomplete', {
        params: params
      })
        .then(function(results) {
          return results.data.guests;
        });
    }
  };

  this.handleGuestChange = function(guest) {
    $scope.guestDetailsForm.$setPristine();

    var room = this.room;

    if (guest) {
      room.isGuestDirty = false;
      this.assignGuest(room, guest);
      this.onGuestChange(guest);
    }
  };

  $scope.$watch('guestDetailsForm.$dirty', function (value) {
    // ctrl.room.isGuestDirty || value - condition to handle cases when we reopen form.
    // When initially form renders it sets $dirty to false and then on first change sets to true.
    // But when form with guest is closed in dirty state we need to ensure that this flag is kept in true state.
    ctrl.room.isGuestDirty = ctrl.room.isGuestDirty || value;
  })
}
angular
  .module('buuqit')
  .directive('bookingRoomDetailedForm', bookingRoomDetailedForm);

function bookingRoomDetailedForm() {
  return {
    restrict: 'E',
    scope: {
      booking: '=',
      room: '=',
      guests: '=',
      currencySymbol: '=',
      calcTotal: '=',
      policies: '=',
      assignGuest: '=',
    },
    controller: bookingRoomDetailedFormCtrl,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: getTemplatePath('scheduler/booking_room_detailed_form.html'),
  };
}

bookingRoomDetailedFormCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$filter",
  "$timeout",
  "$http",
];

function bookingRoomDetailedFormCtrl($rootScope, $scope, $i18next, $filter, $timeout, $http) {
  bookingRoomFullFormCtrl.call(this, $rootScope, $scope, $i18next, $filter, $timeout, $http);

  var ctrl = this;

  this.handleGuestChange = function(guest) {
    if (!guest) {
      return
    }

    $scope.guestDetailsForm.$setPristine();
    ctrl.room.isGuestDirty = false;

    ctrl.assignGuest(ctrl.room, guest);
  };

  this.handleResetGuestClick = function () {
    if (!ctrl.room.guest.id) {
      return
    }

    $scope.guestDetailsForm.$setPristine();
    ctrl.room.isGuestDirty = false;

    var originalGuest = ctrl.guests[ctrl.room.guest.id];

    ctrl.room.guest.first_name = originalGuest.first_name;
    ctrl.room.guest.last_name = originalGuest.last_name;
    ctrl.room.guest.email = originalGuest.email;
    ctrl.room.guest.phone = originalGuest.phone;
    ctrl.room.guest.address = originalGuest.address;
    ctrl.room.guest.city = originalGuest.city;
    ctrl.room.guest.country = originalGuest.country;
    ctrl.room.guest.state = originalGuest.state;
    ctrl.room.guest.zipCode = originalGuest.zip_code;
    ctrl.room.guest.locale = originalGuest.locale;
    ctrl.room.guest.nationality = originalGuest.nationality;
    ctrl.room.guest.identifiction_type_id = originalGuest.identifiction_type_id;
    ctrl.room.guest.identification = originalGuest.identification;
    ctrl.room.guest_id = originalGuest.id;
  };

  this.handleClearGuestClick = function () {
    ctrl.room.guest.id = null;
    ctrl.room.guest.first_name = null;
    ctrl.room.guest.last_name = null;
    ctrl.room.guest.email = null;
    ctrl.room.guest.phone = null;
    ctrl.room.guest.address = null;
    ctrl.room.guest.city = null;
    ctrl.room.guest.country = null;
    ctrl.room.guest.state = null;
    ctrl.room.guest.zipCode = null;
    ctrl.room.guest.locale = null;
    ctrl.room.guest.nationality = null;
    ctrl.room.guest.identifiction_type_id = null;
    ctrl.room.guest.identification = null;
    ctrl.room.guest_id = null;

    ctrl.room.wasSettled = null;
    ctrl.room.note = null;

    $scope.guestDetailsForm.$setPristine();
    ctrl.room.isGuestDirty = false;
    ctrl.room.isGuestCleared = true;
  };

  $scope.$watch('roomDetailsForm.checkin_date.$dirty', function (value) {
    ctrl.room.isDateFieldsDirty = ctrl.room.isDateFieldsDirty || value;
  });

  $scope.$watch('roomDetailsForm.checkout_date.$dirty', function (value) {
    ctrl.room.isDateFieldsDirty = ctrl.room.isDateFieldsDirty || value;
  });

  $scope.$watch('roomDetailsForm.number_of_nights.$dirty', function (value) {
    ctrl.room.isDateFieldsDirty = ctrl.room.isDateFieldsDirty || value;
  });

  $scope.$watch('roomDetailsForm.checkin_time.$dirty', function (value) {
    ctrl.room.isCheckinTimeDirty = ctrl.room.isCheckinTimeDirty || value;
  });

  $scope.$watch('roomDetailsForm.rate_category_id.$dirty', function (value) {
    ctrl.room.isRateCategoryIdDirty = ctrl.room.isRateCategoryIdDirty || value;
  });

  $scope.$watch('roomDetailsForm.cancellation_policy_id.$dirty', function (value) {
    ctrl.room.isCancellationPolicyIdDirty = ctrl.room.isCancellationPolicyIdDirty || value;
  });

  $scope.$watch('guestDetailsForm.$dirty', function (value) {
    // ctrl.room.isGuestDirty || value - condition to handle cases when we reopen form.
    // When initially form renders it sets $dirty to false and then on first change sets to true.
    // But when form with guest is closed in dirty state we need to ensure that this flag is kept in true state.
    ctrl.room.isGuestDirty = ctrl.room.isGuestDirty || value;
  })
}
angular
  .module('buuqit')
  .directive('bookingRenderer', bookingRenderer);

bookingRenderer.$inject = ["$rootScope", "$scope", "$timeout", "BookingStorage", "Dates", "UIDialogService"];

function bookingRenderer ($rootScope, $scope, $timeout, BookingStorage, Dates, UIDialogService) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var renderedElements = [],
          booking_width = 0,
          booking_height = 0;


      function init () {
        if ($rootScope.schedulerIsReady == true) {
          booking_width = scope.zoomLevels[scope.zoomLevel - 1].width;
          booking_height = scope.zoomLevels[scope.zoomLevel - 1].height;

          render(_.flatten(_.map(BookingStorage.bookings, function(booking) {return booking.rooms;})), true);
        }
      }


      function template(booking_room, silent) {
        booking_room.col = Dates.slotOfDay(booking_room.checkinDate) + 1;

        var out = '',
            booking = BookingStorage.get(booking_room.bookingId),
            col = Dates.slotOfDay(booking_room.checkinDate) + 1,
            row = scope.slotOfRoom(booking_room.roomId, booking_room, silent),
            dateIndex = scope.datePosition(new Date(booking_room.checkinDate)),
            left = dateIndex * booking_width + scope.OFFSET_SCROLL - 1,
            top = row * booking_height,
            width = (booking_room.numberOfNights * booking_width),
            height = booking_height,
            room_note = '',
            pending_cancellation = '',
            adults = '',
            child = '',
            source = '',
            dontMove = '',
            long = '',
            payerClass = '',
            special_offer = '',
            variants = {
              '00' : 'paid',
              '10' : 'unpaid',
              '01' : 'paid',
              '11' : 'partially'
            },
            correction = 0,
            popovernote = '';

        if (row === false) {
          return "";
        }

        if (booking_room.status == 'hold') { correction = 20; }
        if (booking_room.status == 'canceled') { correction = 40; }

        top = top + correction - 1;

        var icon = 'fa-comment-o';
        if (!_.isEmpty(booking_room.note) || !_.isEmpty(booking_room.housekeepingNote) || !_.isEmpty(booking_room.hotelNote)) {
          icon = 'fa-comment';
        }
        room_note = '<span class="note" data-note="'+$.trim(booking_room.note)+'" data-housekeepingnote="'+$.trim(booking_room.housekeepingNote)+'" data-hotelnote="'+$.trim(booking_room.hotelNote)+'"><i class="fa ' + icon + '"></i></span> ';

        if (booking_room.canceledMark) {
          pending_cancellation = '<span class="pending-cancelation">Pending cancelation</span>';
        }

        if (booking_room.numberOfAdults > 0) {
          adults = '<span><i class="fa fa-user"></i> ' + booking_room.numberOfAdults + '</span>';
        }
        if (booking_room.numberOfChildren > 0) {
          child = ' <span><i class="fa fa-child"></i> ' + booking_room.numberOfChildren + '</span>';
        }
        if (booking.source == 'app') {
          source = ' <span class="source"><i class="fa fa-phone"></i></span>';
        }
        if (booking_room.dontMove) {
          dontMove = ' <span class="source"><i class="fa fa-lock"></i></span>';
        }

        if (booking_room.numberOfNights > 2) {
          long = 'long';
        }

        if (booking.customer.customerType == 1) {
          payerClass = 'company-payer';
        }

        if ($rootScope.bookingForHighlight === booking.id) {
          payerClass += 'new';
        }

        if (booking_room.specialOfferId) {
          special_offer = '<div class="special-offer-mark"><span class="offers_icon"></span></div>';
        }

        popovernote = '' +
          (booking_room.guest.title ? booking_room.guest.title + ' ' : '') +
          (booking_room.guest.firstName ? booking_room.guest.firstName + ' ' : '') +
          (booking_room.guest.lastName ? booking_room.guest.lastName + ', ' : '') +
          booking_room.numberOfNights +
          ' night' + (booking_room.numberOfNights > 1 ? 's' : '') +
          ', Total Due: ' + $rootScope.currencySymbol + parseFloat(booking.due).toFixed(2);


        return '<div class="booking payment-'+variants[String(Number(booking.due > 0)) + String(Number(booking.totalPaid > 0))]+' '+payerClass+' '+booking_room.status+' '+booking_room.occupationStatus+' '+ (pending_cancellation && booking_room.status != 'canceled' ? 'pending-cancellation-booking' : '') +'"'+
          'style="left: ' + left + 'px; top: ' + top + 'px; width: ' + width + 'px; height: ' + height + 'px;"' +
          'data-col="'+dateIndex+'" data-row="'+row+'" data-width="'+booking_room.numberOfNights+'"'+
          'data-booking-room-id="' + booking_room.id + '"' +
          'data-correction="' + correction + '"' +
          'data-note="' + popovernote + '"' +
          'data-booking-id="' + booking_room.bookingId + '">' +
          '<div class="booking-details">' +
          '<div class="booking-slot">' +
          '<div class="guest-info">' +
          room_note +
          (booking_room.guest.lastName ? booking_room.guest.lastName + ', ' : '') +
          (booking_room.guest.firstName ? booking_room.guest.firstName : '') + '<br>'+
          pending_cancellation +
          '</div>' +
          special_offer +
          '<div class="occupation-info">' +
          adults + child + source + dontMove +
          '</div>' +
          '<div class="payment-info ' + long + '">' +
          $rootScope.currencySymbol + (booking.due * -1).toFixed(2) +
          '</div></div></div></div>';
      }


      function render (booking_rooms, silent) {
        var out = [];

        var roomStatus = ['pending', 'hold', 'canceled'];
        booking_rooms = booking_rooms.filter(function (el) { return roomStatus.includes(el.status) });

        angular.forEach(booking_rooms, function(room, index) {
          if (renderedElements.indexOf(room.id) == -1) {
            out.push(template(room, silent));
            renderedElements.push(room.id);
          }
        });

        angular.element(element).append(out);
      }


      function updateZoomLevel () {
        booking_width = scope.zoomLevels[scope.zoomLevel - 1].width;
        booking_height = scope.zoomLevels[scope.zoomLevel - 1].height;

        angular.element(element).find('.booking').css('height', booking_height+'px');
        angular.element(element).find('.booking').each(function(index, el) {
          el = angular.element(el);
          el.css({
            left: parseInt(el.data('col')) * booking_width + scope.OFFSET_SCROLL - 1,
            top: parseInt(el.data('row')) * booking_height + parseInt(el.data('correction')) - 1,
            width: (parseInt(el.data('width')) * booking_width)
          });
        });
      }


      function create (event, id) {
        var booking = BookingStorage.get(id);
        render(booking.rooms);
      }


      function update (event, id) {
        var booking_room = BookingStorage.get_room(id);

        if (angular.element(element).find('.booking[data-booking-room-id="'+booking_room.id+'"]').size() > 0) {
          angular.element(element).find('.booking[data-booking-room-id="' + booking_room.id + '"]').replaceWith(
            template(booking_room)
          );
        }
      }


      function updateBooking (event, id) {
        var booking = BookingStorage.get(id);

        if (booking) {
          angular.forEach(booking.rooms, function (booking_room) {
            update(event, booking_room.id);
          });
        } else {
          console.warn('Booking with ID: ' + id + ' is not found in booking storage.');
        }
      }


      function remove (event, id) {
        angular.element(element).find('.booking[data-booking-id="'+id+'"]').each(function(index, el) {
          renderedElements = _.without(renderedElements, $(el).data('booking-room-id'));
        });
        angular.element(element).find('.booking[data-booking-id="'+id+'"]').remove();
      }


      function updateCanceled (event) {
        scope.canceledArray = [[]];
        for (var x = 0; x < Dates.dates.length; x++) {
          scope.canceledArray[0].push(0);
        }

        angular.forEach(_.flatten(_.map(BookingStorage.bookings, function(booking) {return booking.rooms;})), function(booking_room) {
          if (booking_room.status == 'canceled') {
            update(event, booking_room.id);
          }
        });

        scope.cancelHeight = scope.slotHeight * scope.canceledArray.length;
      }


      function updateHolded (event) {
        scope.holdedArray = [[]];
        for (var x = 0; x < Dates.dates.length; x++) {
          scope.holdedArray[0].push(0);
        }

        angular.forEach(_.flatten(_.map(BookingStorage.bookings, function(booking) {return booking.rooms;})), function(booking_room) {
          if (booking_room.status == 'hold') {
            update(event, booking_room.id);
          }
        });

        scope.holdHeightRow = scope.holdedArray.length;
        scope.holdHeight = scope.slotHeight * scope.holdedArray.length;
        updateCanceled();
      }


      function subscribeToEvents() {
        if ($rootScope.hotel) {
          $scope.$on('BookingStorage:loaded', init);
          $scope.$on('BookingStorage:update', update);
          $scope.$on('BookingStorage:update_booking', updateBooking);
          $scope.$on('BookingStorage:create', create);
          $scope.$on('BookingStorage:remove_temp', remove);
          $scope.$on('scheduler:zoomLevelChanged', updateZoomLevel);
          $scope.$on('scheduler:updateCanceled', updateCanceled);
          $scope.$on('scheduler:updateHolded', updateHolded);
          $scope.$on('bookings:destroyEmpty', remove);
          $scope.$on('scheduler:changeDate', function() {
            angular.element(element).find('.booking').remove();
            renderedElements = [];
            var bookingRooms = _.flatten(_.map(BookingStorage.bookings, function(booking) {return booking.rooms;}))
            render(bookingRooms);
          });
          if (BookingStorage.bookings) {
            init();
          }
        } else {
          $scope.timeoutPromise = $timeout(function() {
            subscribeToEvents();
          }, 10);
        }
      }


      $(element)
        .on('click', '.booking', function($event) {
          if ($rootScope.hasAccess('viewBookingInfo') && $($event.toElement).hasClass('fa-comment') === false && $($event.toElement).hasClass('fa-comment-o') === false) {
            if (angular.element('body').hasClass('mobile')) {
              scope.openContextMenu($event);
              angular.element('#ContextMenu').addClass('open').css('top', $event.clientY+'px').css('left', $event.clientX+'px')
            } else {
              scope.hidePopover();
              $rootScope.openBookingManagementModal($event.currentTarget.dataset.bookingId);
            }
          }
        })
        .on('mouseup', '.booking', scope.bookingMouseup)
        .on('mouseout', '.booking', function($event) {
          scope.hidePopover();
          scope.bookingOut(BookingStorage.get($($event.currentTarget).data('booking-id')));
        })
        .on('mouseover', '.booking', function($event) {
          if ($($event.toElement).hasClass('fa-comment') === false) {
            scope.showPopover($event, $($event.currentTarget).data('note'), 'room');
          }
          if (scope.rooms[parseInt($($event.currentTarget).data('row'))]) {
            scope.bookingOver(
              BookingStorage.get($($event.currentTarget).data('booking-id')),
              scope.rooms[parseInt($($event.currentTarget).data('row'))]
            );
          }
        })
        .on('mouseover', '.note i', function ($event) {
          scope.showPopover(
            $event,
            [
              $($event.currentTarget).closest('.note').data('note'),
              $($event.currentTarget).closest('.note').data('hotelnote'),
              $($event.currentTarget).closest('.note').data('housekeepingnote')
            ],
            'note'
          );
        })
        .on('click', '.note i', function ($event) {
          $event.preventDefault();
          scope.hidePopover();
          UIDialogService.open('booking-notes', {
            title: 'Booking Notes',
            guest_notes: $($event.currentTarget).closest('.note').data('note'),
            hotel_notes: $($event.currentTarget).closest('.note').data('hotelnote'),
            housekeeping_notes: $($event.currentTarget).closest('.note').data('housekeepingnote'),
            callback: function (values) {
              var guest_notes = values[0],
                  hotel_notes = values[1],
                  housekeeping_notes = values[2];

              UIDialogService.close('booking-notes');
              scope.saveBookingRoomNotes(
                $($event.currentTarget).closest('.booking')[0].dataset.bookingRoomId,
                guest_notes,
                hotel_notes,
                housekeeping_notes
              )
            }
          });
        })
        .on('mouseout', '.note i', function () {
          scope.hidePopover();
        });

      if (BookingStorage.booking_rooms.length > 0) {
        init();
      }

      subscribeToEvents();
      $scope.$on('$destroy', function() {
        if ($scope.timeoutPromise) {
          $timeout.cancel($scope.timeoutPromise);
        }
        $(element).off('click', '.booking');
        $(element).off('mouseup', '.booking');
        $(element).off('mouseout', '.booking');
        $(element).off('mouseover', '.booking');
        $(element).off('mouseover', '.note i');
        $(element).off('click', '.note i');
        $(element).off('mouseout', '.note i');
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('blockerRenderer', blockerRenderer);

blockerRenderer.$inject = ["$rootScope", "BlockerStorage", "Dates"];

function blockerRenderer ($rootScope, BlockerStorage, Dates) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var renderedElements = [],
          blocker_width = 0,
          blocker_height = 0;


      function init () {
        blocker_width = scope.zoomLevels[scope.zoomLevel - 1].width;
        blocker_height = scope.zoomLevels[scope.zoomLevel - 1].height;
        render(BlockerStorage.blockers);
      }


      function template(blocker) {
        var col = Dates.slotOfDay(blocker.dateFrom) + 1,
            end_col = col + moment(blocker.dateTo).diff(moment(blocker.dateFrom), 'days'),
            row = scope.slotOfRoom(blocker.roomId),
            dateIndex = scope.datePosition(new Date(blocker.dateFrom)),
            left = dateIndex * blocker_width + scope.OFFSET_SCROLL - 1,
            top = row * blocker_height - 1,
            width = (end_col - col) * blocker_width;

        out = '<div class="room-blocker" data-index="' + blocker.id +
              '" data-row="' + row + '" data-col="' + dateIndex + '" data-width="' + (end_col - col) + '"' +
              'style="left: ' + left + 'px; top: ' + top + 'px; width: ' + width + 'px; height: ' + blocker_height + 'px;">' +
              '<div class="closer"><div><span>' + blocker.reason + '</span></div></div>' +
              '</div>';

        return out;
      }


      function render (blockers) {
        var out = [];

        angular.forEach(blockers, function(blocker, index) {
          if (renderedElements.indexOf(blocker.id) == -1) {
            out.push(template(blocker));
            renderedElements.push(blocker.id);
          }
        });

        angular.element(element).append(out);
      }


      function update (event, id) {
        if (angular.element(element).find('.room-blocker[data-index="'+id+'"]').size() > 0) {
          angular.element(element).find('.room-blocker[data-index="' + id + '"]').replaceWith(
            template(BlockerStorage.get(id))
          );
        }
      }


      function create (event, id) {
        angular.element(element).append(template(BlockerStorage.get(id)));
      }


      function destroy (event, id) {
        angular.element(element).find('.room-blocker[data-index="'+id+'"]').remove();
      }


      function updateZoomLevel () {
        blocker_width = scope.zoomLevels[scope.zoomLevel - 1].width;
        blocker_height = scope.zoomLevels[scope.zoomLevel - 1].height;

        angular.element(element).find('.room-blocker').css('height', blocker_height + 'px');
        angular.element(element).find('.room-blocker').each(function(index, el) {
          el = angular.element(el);
          el.css({
            left: parseInt(el.data('col')) * blocker_width + scope.OFFSET_SCROLL - 1,
            top: parseInt(el.data('row')) * blocker_height - 1,
            width: (parseInt(el.data('width')) * blocker_width)
          });
        });
      }

      function changeDate () {
        angular.element(element).find('.room-blocker').remove();
        renderedElements = [];
        render(BlockerStorage.blockers);
      }

      var blockerStorageLoaded = $rootScope.$on('BlockerStorage:loaded', init);
      var blockerStorageDestroy = $rootScope.$on('BlockerStorage:destroy', destroy);
      var blockerStorageUpdate = $rootScope.$on('BlockerStorage:update', update);
      var blockerStorageCreate = $rootScope.$on('BlockerStorage:create', create);
      var blockersUpdate = $rootScope.$on('blockers:update', init);
      var schedulerZoomLevelChanged = $rootScope.$on('scheduler:zoomLevelChanged', updateZoomLevel);
      var schedulerChangeDate = $rootScope.$on('scheduler:changeDate', changeDate);

      $(element)
        .on('click', '.room-blocker', function($event) {
          if (angular.element('body').hasClass('mobile')) {
            scope.openContextMenu($event);
            angular.element('#ContextMenu').addClass('open').css('top', $event.clientY+'px').css('left', $event.clientX+'px')
          } else {
            scope.openBlockerManagementModal(
              $event,
              BlockerStorage.get(parseInt($($event.currentTarget).data('index')))
            );
          }
        })
        .on('mouseup', '.room-blocker', scope.bookingMouseup)
        .on('mousemove', '.room-blocker', function($event) {
          scope.setHoveredRoomRow(BlockerStorage.get(parseInt($($event.currentTarget).data('index'))));
        });

      if (BlockerStorage.blockers.length > 0) {
        init();
      }
      scope.$on('$destroy', function() {
        blockerStorageLoaded();
        blockerStorageDestroy();
        blockerStorageUpdate();
        blockerStorageCreate();
        blockersUpdate();
        schedulerZoomLevelChanged();
        schedulerChangeDate();

        $(element).off('click', '.room-blocker');
        $(element).off('mouseup', '.room-blocker');
        $(element).off('mousemove', '.room-blocker');
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('signupPage', signupPage);

signupPage.$inject = ["$rootScope", "$location"];

function signupPage ($rootScope, $location) {
  return {
    restrict: 'E',
    controller: 'SignupCtrl',
    templateUrl: getTemplatePath('signup.html'),
    link: function (scope, element) {
      if ($location.$$url == '/signup') {
        element.css({display : 'block'});
      }

      $rootScope.$on( "$routeChangeStart", function(event, next) {
        if (next.$$route && next.$$route.originalPath == "/signup") {
          element.css({display : 'block'});
        } else {
          element.css({display : 'none'});
        }
      });
    }
  };
}

angular
    .module('buuqit')
    .directive('recaptchaLabel', recaptchaLabel)

function recaptchaLabel () {
    return {
        restrict: 'E', // This means the directive will be used as an element
        templateUrl: getTemplatePath('recaptcha_label.html'),
    };
}

angular
  .module('buuqit')
  .directive('loginPage', loginPage);

loginPage.$inject = ["$rootScope", "$location"];

function loginPage ($rootScope, $location) {
  return {
    restrict: 'E',
    controller: 'LoginCtrl',
    templateUrl: getTemplatePath('login.html'),
    link: function (scope, element) {
      if ($location.$$url == '/login') {
        element.css({display : 'block'});
      }

      $rootScope.$on( "$routeChangeStart", function (event, next) {
        if (next.$$route && next.$$route.originalPath == "/login") {
          element.css({display : 'block'});
        } else {
          element.css({display : 'none'});
        }
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('selectCustomerInput', selectCustomerInput);

function selectCustomerInput() {
  return {
    restrict: 'E',
    scope: true,
    controllerAs: 'ctrl',
    bindToController: {
      onChange: '=',
      customerQuery: '=',
      showNotFound: '@',
      notFoundText: '@',
      minlength: '@',
      label: '@',
      source: '@',
      saleChannelId: '=',
    },
    templateUrl: getTemplatePath('inputs/select_customer_input.html'),
    controller: selectCustomerController,
    compile: function(tElement, tAttrs) {
      if (tAttrs.showNotFound === "true") {
        var notFoundText = tAttrs.notFoundText || 'no.customers.were.found';

        tElement.find('md-autocomplete').append(angular.element("<md-not-found>{{'" + notFoundText + "' | i18next}}</md-not-found>"));
      }
    },
  };
}

selectCustomerController.$inject = [
  "$rootScope",
  "$http",
  "CustomerService"
];

function selectCustomerController($rootScope, $http, CustomerService) {
  this.minlength = typeof this.minlength === "undefined" ? 2 : this.minlength;
  this.selectMode = typeof this.selectMode === "undefined" ? false : this.selectMode;
  this.source = typeof this.source === "undefined" ? 'hotel' : this.source;

  this.searchCustomer = function searchCustomer(query) {
    var searchPromise;

    if (this.source === 'hotel') {
      searchPromise = CustomerService.searchForHotel(query)
    } else if (this.source === 'sale_channel') {
      searchPromise = CustomerService.searchForSaleChannel(this.saleChannelId, query)
    } else {
      console.error('unknown source for select_customer_input');
      searchPromise = Promise.resolve({ data: { customers: []}});
    }

    return searchPromise.then(function(results) {
      return results.data.customers;
    });
  };
}
angular
  .module('buuqit')
  .directive('saleChannelInput', saleChannelInput);

function saleChannelInput() {
  return {
    restrict: 'E',
    scope: {
      value: '=',
      collection: '=',
      onChange: '='
    },
    controller: saleChannelcontroller,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: getTemplatePath('inputs/sale_channel_input.html'),
  };
}

saleChannelcontroller.$inject = [
  "$scope"
];

function saleChannelcontroller($scope) {
  var ctrl = this;
  this.query = null;

  this.namesCollection = [];

  if (this.collection) {
    this.namesCollection = this.collection.map(function (saleChannel) { return saleChannel.name });
  }

  this.search = function () {
    // if no search results was choosen create new sales_channel based on search input
    this.value = this.query;

    var namesCollection = this.namesCollection;
    var query = this.query;

    namesCollection = namesCollection.filter(function(item) {
      return query && query.length > 0 &&
        item
          ? item.toLowerCase().indexOf(query.toLowerCase()) != -1
          : true;
      }).sort(function(a, b) {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
        return 0;
      });

    return namesCollection;
  };

  if (typeof ctrl.onChange === 'function') {
    $scope.$watch(
      function watchValue() {
        return ctrl.value;
      },
      function handleValueChange(newValue, oldValue) {
        if (newValue !== oldValue) {
          ctrl.onChange(newValue);
        }
      }
    );
  }
}
angular
  .module('buuqit')
  .controller('Dashboard.LiveFeedController', dashboardLiveFeedController)
  .directive('dashboardLiveFeed', dashboardLiveFeed)
  .component(
    'reactDashboardLiveFeed',
    window.TBFLibs.react2angular(
      window.TBFLibs.DashboardLiveFeed,
      [
        'feedEvents',
        'showViewBookingMenuOption',
        'onViewBooking',
        'onOpenCalendar',
        'showMarkAllAsRead',
        'markAsRead',
        'markAllAsRead',
        'loadMoreVisible',
        'loadMore',
      ],
      ['$i18next']
    )
  );

function dashboardLiveFeed () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('dashboard/liveFeed.html'),
  };
}

dashboardLiveFeedController.$inject = [
  "$scope",
  "$i18next",
  "$rootScope",
  "$location",
  "$http",
  "$interval",
  "$timeout",
  "LiveFeedFactory"
];

function dashboardLiveFeedController ($scope, $i18next, $rootScope, $location, $http, $interval, $timeout, LiveFeedFactory) {
  var ctrl = this;

  angular.extend(
    this,
    {
      offset: 0,
      limit: 50,
      loadMoreVisible: true,
      interval: null,
      feedEvents: [],
      openBooking: openBooking,
      openCalendar: openCalendar,
      markAsRead: markAsRead,
      markAllAsRead: markAllAsRead,
      loadMore: loadMore,
      stopUpdate: stopUpdate,
      consecutiveErrors: 0,
      maxErrors: 5,
      requestInProgress: false,
    }
  );

  function prepareEvent(event) {
    event.ago = ago(event.createdAt);
    if (event.params && event.params.type) {
      event.description = $i18next.t('dashboard.live_feed.' + event.params.type + '.description', event.params);
      event.visibleLabel = $i18next.t('dashboard.live_feed.' + event.params.type + '.label');
    } else {
      event.visibleLabel = event.label;
    }
    return event;
  }

  function initialize() {
    LiveFeedFactory.query({offset: ctrl.offset}, {hotelId: $rootScope.hotel.id})
      .then(function(response) {
        if (!$scope.$$destroyed) {
          ctrl.feedEvents = response.map(prepareEvent);
          ctrl.offset++;
          ctrl.lastLoad = new Date().getTime();

          if (response.length < ctrl.limit) {
            ctrl.loadMoreVisible = false;
          }
          initUpdater();
        }
      }).catch(function(error) {
        console.error('Error loading live feed:', error);
        $rootScope.alert($i18next.t('live_feed.alert_modals.something_went_wrong_please_try_again_later_text'));
      });
  };


  function ago(timestamp) {
    return moment(timestamp).fromNow();
  };

  function sortLiveFeeds(feeds) {
    return feeds.sort(function(a, b) {
      if (a.id > b.id) return -1;
      if (a.id < b.id) return 1;
      return 0;
    });
  }

  function openBooking(event) {
    $rootScope.openBookingManagementModal(event.bookingId);
    markAsRead(event);
  };


  function openCalendar(event) {
    stopUpdate();
    $rootScope.bookingForHighlight = event.bookingId;
    $location.path($rootScope.hotel.id == 72 ? 'bookings' : 'calendar', true);
  };


  function markAsRead(event) {
    event.hotelId = $rootScope.hotel.id;
    event.markAsRead();
    ctrl.feedEvents = ctrl.feedEvents.map(function(fe) {
      if (fe.id === event.id) {
        var selectedFeed = fe;
        selectedFeed.readStatus = true;
        return selectedFeed;
      }
      return fe;
    });
  };


  function markAllAsRead() {
    $http
      .post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/live_feed/mark_all_as_read')
      .then(
        function() {
          ctrl.feedEvents = ctrl.feedEvents.map(function(fe) {
            fe.readStatus = true;
            return fe;
          });
        },
        function(error) {
          console.error('Error marking all as read:', error);
          $rootScope.alert($i18next.t('live_feed.alert_modals.something_went_wrong_please_try_again_later_text'));
        }
      );
  };


  function loadMore() {
    LiveFeedFactory.query({offset: ctrl.offset}, {hotelId: $rootScope.hotel.id})
      .then(function(response) {
        ctrl.feedEvents = _.union(ctrl.feedEvents, response.map(prepareEvent));
        ctrl.offset++;

        if (response.length < ctrl.limit) {
          ctrl.loadMoreVisible = false;
        }
      }).catch(function(error) {
        console.error('Error loading more live feed:', error);
        $rootScope.alert($i18next.t('live_feed.alert_modals.something_went_wrong_please_try_again_later_text'));
      });
  };


  function loadUpdates() {
    if (ctrl.requestInProgress) return;

    ctrl.requestInProgress = true;
    LiveFeedFactory.query({offset: 0, last_load: parseInt(String(ctrl.lastLoad).substr(0,10))}, {hotelId: $rootScope.hotel.id})
      .then(function(response) {
        ctrl.consecutiveErrors = 0;
        var ids = ctrl.feedEvents.map(function(event) {return event.id;});
        var feeds = Object.assign([], ctrl.feedEvents);
        response
          .map(prepareEvent)
          .forEach(function(event) {
            if (ids.indexOf(event.id) == -1) {
              feeds.push(event);
            }
          });
        ctrl.feedEvents = sortLiveFeeds(feeds);
        ctrl.lastLoad = new Date().getTime();
      }).catch(function(error) {
        ctrl.consecutiveErrors++;
        console.error('Error loading live feed updates:', error);

        if (ctrl.consecutiveErrors >= ctrl.maxErrors) {
          console.warn('Live feed circuit breaker activated - pausing for 5 minutes');
          $interval.cancel(ctrl.interval);
          ctrl.interval = null;

          // Resume after 5 minutes
          $timeout(function() {
            ctrl.consecutiveErrors = 0;
            if (!ctrl.interval && !$scope.$$destroyed) {
              initUpdater();
            }
          }, 300000);
        }
      }).finally(function() {
        ctrl.requestInProgress = false;
      });
  };

  var throttledloadUpdates = _.throttle(loadUpdates, 2000, {leading: false});

  function initUpdater() {
    if (ctrl.interval === null) {
      ctrl.interval = $interval(function () {
        loadUpdates();
        updateAgo();
      }, 60000);
    }
  };


  function updateAgo() {
    ctrl.feedEvents = ctrl.feedEvents.map(function(event) {
      event.ago = ago(event.createdAt);
      return event;
    });
  }

  if ($rootScope.hotel) {
    initialize();
  }
  var unsubscribe_hotel = $rootScope.$on('hotel:loaded', initialize);
  var unsubscribe_update = $rootScope.$on('livefeed:need_update', function () {
    throttledloadUpdates();
  });
  var unsubscribe_language_update = $rootScope.$on('languageChanged', function() {
    ctrl.feedEvents.forEach(function(event) {
      if (event.description) {
        delete event.description;
      }
      if (event.visibleLabel) {
        delete event.visibleLabel;
      }
      prepareEvent(event);
    });
  });

  function stopUpdate() {
    $interval.cancel(ctrl.interval);
    ctrl.interval = null;
    if (unsubscribe_hotel) {
      unsubscribe_hotel();
    }
    if (unsubscribe_update) {
      unsubscribe_update();
    }
    if (unsubscribe_language_update) {
      unsubscribe_language_update();
    }
  };

  $scope.$on('$destroy', function() {
    stopUpdate();
  });
}

angular
  .module('buuqit')
  .directive('dashboardCheckouts', dashboardCheckouts)
  .controller('Dashboard.CheckoutsController', dashboardCheckoutsController)
  .component(
    'reactDashboardCheckouts',
    window.TBFLibs.react2angular(
      window.TBFLibs.DashboardCheckouts,
      [
        'checkouts',
        'currencySymbol',
        'checkedOutTodayCount',
        'showLoadingIndicator', 
        'hidePrices',
        'showQuickCheckoutMenuOption',
        'showViewBookingInfoMenuOption',
        'onViewBooking',
        'onQuickCheckout',
        'onCheckoutAndPayment',
        'onAddComment'
      ],
      ['$i18next']
    )
  );

function dashboardCheckouts () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('dashboard/checkouts.html'),
  };
}

dashboardCheckoutsController.$inject = [
  "$i18next",
  "$rootScope",
  "$scope",
  "$http",
  "BookingStorage",
  "UIDialogService"
];

function dashboardCheckoutsController ($i18next, $rootScope, $scope, $http, BookingStorage, UIDialogService) {
  var ctrl = this;

  angular.extend(
    this,
    {
      loading                  : true,
      checkouts                : [],
      currencySymbol           : '',
      checkedTodayCount        : 0,
      handleViewBooking        : handleViewBooking,
      handleQuickCheckOut      : handleQuickCheckOut,
      handleCheckOutAndPayment : handleCheckOutAndPayment,
      handleAddComment         : handleAddComment
    }
  );

  function initialize() {
    ctrl.currencySymbol = $rootScope.currencySymbol;
    ctrl.loading = true;
    $http
      .get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/dashboard_checkouts')
      .then(function(response) {
        ctrl.checkouts = response.data.checkouts || [];
        ctrl.checkedTodayCount = response.data.checked || 0;
      }).catch(function(error) {
        console.error('Failed to load checkouts:', error);
      }).finally(function() {
        ctrl.loading = false;
      });
  };

  function checkOut(callback, room_id) {
    var room = BookingStorage.get_room(room_id);
    if (room) {
      room.checkout(function() {
        var current = ctrl.checkouts.filter(function (el) {return el.id === room_id;})[0];
        ctrl.checkouts = _.without(ctrl.checkouts, current);
        BookingStorage.checked_out_bokings.push(room_id);
        if (typeof(callback) === 'function') {
          callback();
        }
      });
    } else {
      console.warn($i18next.t('dashboard.try_to_checkin_undefined_room_console_warn'));
    }
  };

  function loadNew(_event, bookingId) {
    var today = moment(moment(new Date()).format("YYYY-MM-DD"));
    var ids = ctrl.checkouts ? ctrl.checkouts.map(function(el) {return el.id;}) : [];

    var booking = BookingStorage.get(bookingId);
    booking.rooms.forEach(function(bookingRoom) {
      var diff = moment(bookingRoom.checkoutDate).diff(today, "day");
      if (diff === 0 || diff === 1) {
        if (ids.indexOf(bookingRoom.id) !== -1) {
          if (bookingRoom.occupationStatus === "checked_in" && bookingRoom.status === "pending") {
            updateBooking(bookingRoom, booking);
          } else {
            removeBooking(bookingRoom, booking);
          }
        } else {
          if (bookingRoom.occupationStatus === "checked_in" && bookingRoom.status === "pending") {
            insertBooking(bookingRoom, booking);
          }
        }
      } else {
        if (ids.indexOf(bookingRoom.id) !== -1) {
          removeBooking(bookingRoom, booking);
        }
      }
    });
  }

  function update(_event, bookingRoomId, bookingId) {
    BookingStorage.load_by_id(bookingId, false, function(booking) {});
  }

  function updateBooking(bookingRoom, booking) {
    var data = extractBookingRoomData(bookingRoom, booking);
    var item = ctrl.checkouts.filter(function(el) {return el.id === bookingRoom.id;})[0];

    if (item) {
      var index = ctrl.checkouts.indexOf(item);
      ctrl.checkouts[index] = data;
    } else {
      insertBooking(bookingRoom, booking);
    }
  }

  function insertBooking(bookingRoom, booking) {
    var data = extractBookingRoomData(bookingRoom, booking);
    ctrl.checkouts.push(data);
  }

  function removeBooking(bookingRoom, booking) {
    ctrl.checkouts = ctrl.checkouts.filter(function(el) {return el.id !== bookingRoom.id;});
  }

  function extractBookingRoomData(bookingRoom, booking) {
    var roomNumber = '';

    if ($rootScope.hotel && $rootScope.hotel.rooms) {
      var roomObj = null;
      for (var i = 0; i < $rootScope.hotel.rooms.length; i++) {
        if ($rootScope.hotel.rooms[i].id === bookingRoom.roomId) {
          roomObj = $rootScope.hotel.rooms[i];
          break;
        }
      }
      if (roomObj) {
        roomNumber = roomObj.number || '';
      }
    }

    return {
      adults: bookingRoom.numberOfAdults || 0,
      booking_id: bookingRoom.bookingId,
      children: bookingRoom.numberOfChildren || 0,
      customer_type: booking.customer ? booking.customer.customerType : '',
      due: booking.due || 0,
      first_name: bookingRoom.guest ? bookingRoom.guest.firstName : '',
      hotel_note: booking.customer && booking.customer.notes ? booking.customer.notes : '',
      housekeeping_note: bookingRoom.housekeepingNote || '',
      id: bookingRoom.id,
      last_name: bookingRoom.guest ? bookingRoom.guest.lastName : '',
      nights: bookingRoom.nights && bookingRoom.nights.length ? bookingRoom.nights.length : 0,
      note: bookingRoom.note || '',
      room: roomNumber,
      today: moment(bookingRoom.checkoutDate).isSame(new Date(), "day")
    };
  }

  function saveBookingRoomNotes(booking_room_id, booking_id, guest_notes, hotel_notes, housekeeping_notes) {
    BookingStorage.load_by_id(booking_id, false, function() {
      var room = BookingStorage.get_room(booking_room_id);

      room.note = guest_notes;
      room.hotelNote = hotel_notes;
      room.housekeepingNote = housekeeping_notes;
      room.save();
    })
  };

  function handleViewBooking(checkout) {
    $rootScope.openBookingManagementModal(checkout.booking_id);
  };

  function handleQuickCheckOut(checkout) {
    var room_id = checkout.id;
    var booking_id = checkout.booking_id;

    if (BookingStorage.get_room(room_id)) {
      checkOut(initialize, room_id, booking_id);
    } else {
      BookingStorage.load_by_id(booking_id, false, function() {
        checkOut(initialize, room_id, booking_id);
      });
    }
  };

  function handleCheckOutAndPayment(checkout) {
    var room_id = checkout.id;
    var booking_id = checkout.booking_id;

    if (BookingStorage.get_room(room_id)) {
      checkOut(function () {
        $rootScope.openBookingManagementModal(booking_id, 'payment');
      }, room_id, booking_id);
    } else {
      BookingStorage.load_by_id(booking_id, false, function() {
        checkOut(function () {
          $rootScope.openBookingManagementModal(booking_id, 'payment');
        }, room_id, booking_id);
      });
    }
  };

  function handleAddComment(checkout) {
    UIDialogService.open('booking-notes', {
      title: 'Booking Notes',
      guest_notes: checkout.note,
      hotel_notes: checkout.hotel_note,
      housekeeping_notes: checkout.housekeeping_note,
      callback: function (values) {
        var guest_notes = values[0],
            hotel_notes = values[1],
            housekeeping_notes = values[2];

        UIDialogService.close('booking-notes');

        ctrl.checkouts = ctrl.checkouts.map(function(c) {
          return c.id === checkout.id
            ? Object.assign({}, c, { note: guest_notes, hotel_note: hotel_notes, housekeeping_note: housekeeping_notes })
            : c
        });

        saveBookingRoomNotes(
          checkout.id,
          checkout.booking_id,
          guest_notes,
          hotel_notes,
          housekeeping_notes
        )
      }
    });
  };

  if ($rootScope.hotel) {initialize();}
  var hotelLoadedListener = $rootScope.$on('hotel:loaded', initialize);
  var createListener = $rootScope.$on('BookingStorage:create', loadNew);
  var updateListener = $rootScope.$on('BookingStorage:update', update);

  $scope.$on('$destroy', function () {
    if (hotelLoadedListener) {
      hotelLoadedListener();
    }
    if (createListener) {
      createListener();
    }
    if (updateListener) {
      updateListener();
    }
  });
}

angular
  .module('buuqit')
  .directive('dashboardCheckins', dashboardCheckins)
  .controller('Dashboard.CheckinsController', dashboardCheckinsController)
  .component(
    'reactDashboardCheckins',
    window.TBFLibs.react2angular(
      window.TBFLibs.DashboardCheckins,
      [
        'checkins',
        'currencySymbol',
        'currencyFractionSize',
        'checkedTodayCount',
        'tomorrowCheckinsCount',
        'showLoadingIndicator', 
        'hidePrices',
        'showQuickCheckinMenuOption',
        'showViewBookingInfoMenuOption',
        'useProMode',
        'onViewBooking',
        'onQuickCheckin',
        'onCheckinAndPayment',
        'onProCheckin',
        'onAddComment'
      ],
      ['$i18next']
    )
  );

function dashboardCheckins () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('dashboard/checkins.html')
  };
}

dashboardCheckinsController.$inject = [
  "$i18next",
  "$rootScope",
  "$scope",
  "$http",
  "$mdDialog",
  "BookingStorage",
  "UIDialogService"
];

function dashboardCheckinsController ($i18next, $rootScope, $scope, $http, $mdDialog, BookingStorage, UIDialogService) {
  var ctrl = this;

  angular.extend(
    this,
    {
      loading                     : true,
      checkins                    : [],
      currencySymbol              : '',
      currencyFractionSize        : 2,
      useProMode                  : false,
      checkedTodayCount           : 0,
      tomorrowCheckinsCount       : 0,

      handleViewBooking       : handleViewBooking,
      handleQuickCheckin      : handleQuickCheckin,
      handleCheckinAndPayment : handleCheckinAndPayment,
      handleProCheckin        : handleProCheckin,
      handleAddComment        : handleAddComment
    }
  );

  function initialize() {
    ctrl.useProMode = $rootScope.hotel.useCheckinProMode;
    ctrl.currencySymbol = $rootScope.currencySymbol;
    ctrl.currencyFractionSize = $rootScope.currencyFractionSize;
    ctrl.loading = true;
    $http
      .get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/dashboard_checkins')
      .then(function(response) {
        ctrl.checkins = response.data.checkins || [];
        ctrl.checkedTodayCount = response.data.checked || 0;
        ctrl.tomorrowCheckinsCount = response.data.tomorrow || 0;
      }).catch(function(error) {
        console.error('Failed to load checkins:', error);
      }).finally(function() {
        ctrl.loading = false;
      });
  };

  function checkIn(callback, room_id) {
    var room = BookingStorage.get_room(room_id);
    if (room) {
      room.checkin(function() {
        var current = ctrl.checkins.filter(function (el) {return el.id === room_id;})[0];
        ctrl.checkins = _.without(ctrl.checkins, current);
        BookingStorage.checked_in_bokings.push(room_id);
        if (typeof(callback) === 'function') {
          callback();
        }
      });
    } else {
      console.warn($i18next.t('dashboard.try_to_checkin_undefined_room_console_warn'));
    }
  };

  function loadNew(_event, bookingId) {
    var today = moment(moment(new Date()).format("YYYY-MM-DD"));
    var ids = ctrl.checkins ? ctrl.checkins.map(function(el) {return el.id;}) : [];

    var booking = BookingStorage.get(bookingId);
    booking.rooms.forEach(function(bookingRoom) {
      var diff = moment(bookingRoom.checkinDate).diff(today, "day");
      if (diff === 0 || diff === 1) {
        if (ids.indexOf(bookingRoom.id) !== -1) {
          if (bookingRoom.occupationStatus === "pending" && bookingRoom.status === "pending") {
            updateBooking(bookingRoom, booking);
          } else {
            removeBooking(bookingRoom, booking);
          }
        } else {
          if (bookingRoom.occupationStatus === "pending" && bookingRoom.status === "pending") {
            insertBooking(bookingRoom, booking);
          }
        }
      } else {
        if (ids.indexOf(bookingRoom.id) !== -1) {
          removeBooking(bookingRoom, booking);
        }
      }
    });
  }

  function update(_event, bookingRoomId, bookingId) {
    BookingStorage.load_by_id(bookingId, false, function(booking) {});
  }

  function updateBooking(bookingRoom, booking) {
    var data = extractBookingRoomData(bookingRoom, booking);
    var index = ctrl.checkins.findIndex(function(el) { return el.id === bookingRoom.id; });

    if (index !== -1) {
      ctrl.checkins = ctrl.checkins.map(function(el) {
        return el.id === bookingRoom.id
          ? data
          : el
      })
    } else {
      insertBooking(bookingRoom, booking);
    }
  }

  function insertBooking(bookingRoom, booking) {
    var data = extractBookingRoomData(bookingRoom, booking);
    ctrl.checkins = ctrl.checkins.concat(data);
  }

  function removeBooking(bookingRoom, booking) {
    ctrl.checkins = ctrl.checkins.filter(function(el) {return el.id !== bookingRoom.id;});
  }

  function extractBookingRoomData(bookingRoom, booking) {
    var roomNumber = '';

    if ($rootScope.hotel && $rootScope.hotel.rooms) {
      var roomObj = null;
      for (var i = 0; i < $rootScope.hotel.rooms.length; i++) {
        if ($rootScope.hotel.rooms[i].id === bookingRoom.roomId) {
          roomObj = $rootScope.hotel.rooms[i];
          break;
        }
      }
      if (roomObj) {
        roomNumber = roomObj.number || '';
      }
    }

    return {
      adults: bookingRoom.numberOfAdults || 0,
      booking_id: bookingRoom.bookingId,
      children: bookingRoom.numberOfChildren || 0,
      customer_type: booking.customer ? booking.customer.customerType : '',
      due: booking.due || 0,
      first_name: bookingRoom.guest ? bookingRoom.guest.firstName : '',
      hotel_note: booking.customer && booking.customer.notes ? booking.customer.notes : '',
      housekeeping_note: bookingRoom.housekeepingNote || '',
      id: bookingRoom.id,
      last_name: bookingRoom.guest ? bookingRoom.guest.lastName : '',
      nights: bookingRoom.nights && bookingRoom.nights.length ? bookingRoom.nights.length : 0,
      note: bookingRoom.note || '',
      room: roomNumber,
      today: moment(bookingRoom.checkinDate).isSame(new Date(), "day")
    };
  }

  function saveBookingRoomNotes(booking_room_id, booking_id, guest_notes, hotel_notes, housekeeping_notes) {
    BookingStorage.load_by_id(booking_id, false, function() {
      var room = BookingStorage.get_room(booking_room_id);

      room.note = guest_notes;
      room.hotelNote = hotel_notes;
      room.housekeepingNote = housekeeping_notes;
      room.save();
    })
  };

  function handleViewBooking(checkin) {
    $rootScope.openBookingManagementModal(checkin.booking_id);
  }

  function handleQuickCheckin(checkin) {
    var room_id = checkin.id;
    var booking_id = checkin.booking_id;

    if (BookingStorage.get_room(room_id)) {
      checkIn(initialize, room_id);
    } else {
      BookingStorage.load_by_id(booking_id, false, function() {
        checkIn(initialize, room_id);
      });
    }
  }

  function handleCheckinAndPayment(checkin) {
    var room_id = checkin.id;
    var booking_id = checkin.booking_id;

    if (BookingStorage.get_room(room_id)) {
      checkIn(function () {
        $rootScope.openBookingManagementModal(booking_id, 'payment');
      }, room_id);
    } else {
      BookingStorage.load_by_id(booking_id, false, function() {
        checkIn(function () {
          $rootScope.openBookingManagementModal(booking_id, 'payment');
        }, room_id);
      });
    }
  }

  function handleProCheckin(checkin) {
    var room_id = checkin.id;
    var booking_id = checkin.booking_id;
    var room = BookingStorage.get_room(room_id);

    if (room) {
      $mdDialog.show({
        controller: CheckinDialogCtrl,
        templateUrl: getTemplatePath('modals/checkinDialog.html'),
        parent: angular.element(document.body),
        locals: {
          room : room,
          checkin: function(openPaymentScreen) {
            room.checkin(function() {
              var current = ctrl.checkins.filter(function (el) {return el.id === room_id;})[0];
              ctrl.checkins = _.without(ctrl.checkins, current);
              BookingStorage.checked_in_bokings.push(room_id);
              if (openPaymentScreen) {
                $rootScope.openBookingManagementModal(booking_id, 'payment');
              }
            });
          }
        },
        clickOutsideToClose: true
      });
    } else {
      BookingStorage.load_by_id(booking_id, false, function(booking) {
        handleProCheckin(checkin);
      });
    }
  }

  function handleAddComment(checkin) {
    UIDialogService.open(
      'booking-notes',
      {
        title: 'Booking Notes',
        guest_notes: checkin.note,
        hotel_notes: checkin.hotel_note,
        housekeeping_notes: checkin.housekeeping_note,
        callback: function (values) {
          var guest_notes = values[0];
          var hotel_notes = values[1];
          var housekeeping_notes = values[2];

          UIDialogService.close('booking-notes');

          ctrl.checkins = ctrl.checkins.map(function(c) {
            return c.id === checkin.id
              ? Object.assign({}, c, { note: guest_notes, hotel_note: hotel_notes, housekeeping_note: housekeeping_notes })
              : c
          });

          saveBookingRoomNotes(
            checkin.id,
            checkin.booking_id,
            guest_notes,
            hotel_notes,
            housekeeping_notes
          )
        }
      }
    );
  }

  if ($rootScope.hotel) {initialize();}
  var hotelLoadedListener = $rootScope.$on('hotel:loaded', initialize);
  var createListener = $rootScope.$on('BookingStorage:create', loadNew);
  var updateListener = $rootScope.$on('BookingStorage:update', update);

  $scope.$on('$destroy', function () {
    if (hotelLoadedListener) {
      hotelLoadedListener();
    }
    if (createListener) {
      createListener();
    }
    if (updateListener) {
      updateListener();
    }
  });
}

angular
  .module('buuqit')
  .directive('dashboardCharts', dashboardCharts)
  .controller('Dashboard.ChartsController', dashboardChartsController)
  .component(
    'reactDashboardCharts',
    window.TBFLibs.react2angular(
      window.TBFLibs.DashboardStatistics,
      [
        'occupancies',
        'revenues',
        'bookingSources',
        'currencySymbol',
        'hideRevenue',
        'isLoading'
      ],
      ['$i18next']
    )
  );

function dashboardCharts () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('dashboard/charts.html'),
  };
}

dashboardChartsController.$inject = [
  "$rootScope",
  "$scope",
  "$http"
];

function dashboardChartsController ($rootScope, $scope, $http) {
  var ctrl = this;
  var loadingCharts = {};

  angular.extend(this, {
    isLoading         : true,
    occupancies       : [],
    revenues          : [],
    bookingSources    : [],
    currencySymbol    : '',
  });

  function initialize() {
    ctrl.currencySymbol = $rootScope.currencySymbol;

    var occupancyChart = 'occupancy';
    var revenueChart = 'revenue';
    var bookingSourceChart = 'booking_source';
    
    getChartData(occupancyChart)
      .then(prepareSimpleChartData)
      .then(function (occupancies) {
        ctrl.occupancies = occupancies;
        setLoadingStatus(occupancyChart, false);
      });
      
    getChartData(revenueChart)
      .then(prepareSimpleChartData)
      .then(function (revenues) {
        ctrl.revenues = revenues;
        setLoadingStatus(revenueChart, false);
      });

    getChartData(bookingSourceChart)
      .then(prepareBookingSourceChartData)
      .then(function (sources) {
        ctrl.bookingSources = sources;
        setLoadingStatus(bookingSourceChart, false);
      });
  }

  function getChartData(chartType) {
    setLoadingStatus(chartType, true);
    return $http
      .get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/charts/' + chartType)
      .catch(handleRequestError)
  }

  function handleRequestError(error) {
    // The same translation string is used for all charts in the original Angular implementation.
    // There are no translation string for any chart except the occupancy chart.
    console.warn($i18next.t('can_not_receive_data_from_server_for_occupancy_chart_console_warn'));
    return null;
  }

  function prepareSimpleChartData(response) {
    if (!response || !response.data) return [];
    var chartData = [];
    var data = response.data;

    for (day in data) {
      chartData.push(Object.assign(data[day], { day: day }))
    }

    return chartData;
  }

  function prepareBookingSourceChartData(response) {
    if (!response || !response.data) return [];
    var chartData = [];
    var data = response.data;

    for (day in data) {
      var dayValue = data[day];
      for (source in dayValue) {
        var count = dayValue[source];
        chartData.push({ day: day, count: count, source: source })
      }
    }

    return chartData;
  }

  function setLoadingStatus(chart, status) {
    loadingCharts[chart] = status;
    ctrl.isLoading = checkLoading();
  }

  function checkLoading() {
    var lc = [];

    for (chartName in loadingCharts) {
      if (loadingCharts[chartName]) {
        lc.push(chartName);
      }
    }

    return lc.length !== 0;
  }

  var hotelLoadedListener = $rootScope.$on('hotel:loaded', initialize);
  var languageChangedListener = $rootScope.$on('languageChanged', initIfHotelLoaded)

  initIfHotelLoaded();

  function initIfHotelLoaded() {
    if ($rootScope.hotel) {
      initialize();
    }
  }

  $scope.$on('$destroy', function () {
    if (hotelLoadedListener) {
      hotelLoadedListener();
    }
    if (languageChangedListener) {
      languageChangedListener();
    }
  });
}

angular
  .module('buuqit')
  .directive('roomEdit', roomEdit);

function roomEdit () {
  return {
    restrict: 'E',
    scope: {
      edited_room: '=ngModel',
      bookingRoomsCtrl: '=bookingRoomsCtrl',
      booking: '=booking',
      ngChange: "&"
    },
    controller: roomEditController,
    templateUrl: getTemplatePath('roomEdit.html'),
    link: function (scope, element, attrs, ctrl) {
      element.addClass('customRoomEdit');
    }
  };
}

roomEditController.$inject = [
  "$rootScope",
  "$scope",
  "$filter",
  "$timeout",
  "$http",
  "$mdDialog",
  "$i18next",
  "BookingRoomFactory",
  "BookingStorage",
  "AvailabilityChecker",
  "RateByDateStorage",
  "UIDialogService",
  "RestrictionStorage",
  "CalendarStorage"
];

function roomEditController ($rootScope, $scope, $filter, $timeout, $http, $mdDialog, $i18next, BookingRoomFactory, BookingStorage, AvailabilityChecker, RateByDateStorage, UIDialogService, RestrictionStorage, CalendarStorage) {
  var closed_rooms = [],
      original_room;

  function isDST(d) {
    var jan = new Date(new Date(d).getFullYear(), 0, 1).getTimezoneOffset();
    var jul = new Date(new Date(d).getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(jan, jul) !== new Date(d).getTimezoneOffset();    
  }


  function datesAreOnSameDay(first, second) {
    return (first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate());
  }

  function minPricePerNight(field, result, old_nights, nights) {
    var dateFields = ['checkinDate', 'numberOfNights'],
      min_price = undefined,
      remainder = undefined;

    if(dateFields.indexOf(field) !== -1  && $scope.edited_room.belongsToInvoiceOrReceipt) {
      old_total = $scope.edited_room.total;

      new_total = result.reduce(function(sum, value, index) {
        price = old_nights && old_nights[index] && $scope.value.id ? old_nights[index] : value.price;

        return sum + price;
      }, 0);

      if (new_total < old_total) {
        min_price = Math.floor(old_total / nights);
        remainder = old_total % nights;
      }
    }

    return {
      min_price: min_price,
      remainder: remainder
    };
  }

  $scope.cover_room_types = (function() {
    var out = [];
    $rootScope.hotel.roomTypes.forEach(function(el) {
      out.push({
        id: el.id,
        roomTypeId: el.id,
        title: el.shortName
      });
    });
    $rootScope.hotel.coverRoomTypes.forEach(function(el) {
      out.push({
        id: 's' + el.id,
        roomTypeId: el.roomTypeId,
        title: el.name + ' (virtual)'
      });
    });

    return out;
  })();
  $scope.edited_room.total = $scope.edited_room.nights.reduce(function(sum, value) {
    return sum + value.price;
  }, 0);
  $scope.value = angular.copy($scope.edited_room);
  $scope.value.checkinDate = new Date($scope.value.checkinDate);
  $scope.value.checkoutDate = new Date($scope.value.checkoutDate);
  // logic for handling DST checkout date
  var checkinIsDST = isDST($scope.value.checkinDate);
  var checkoutIsDST = isDST($scope.value.checkoutDate);
  var checkoutSubstracted = new Date($scope.value.checkoutDate);
  checkoutSubstracted.setDate(checkoutSubstracted.getDate() - $scope.value.numberOfNights);
  var checkoutOffset = !checkinIsDST && checkoutIsDST && datesAreOnSameDay(checkoutSubstracted, $scope.value.checkinDate) ? $scope.value.checkinDate.getTimezoneOffset() : $scope.value.checkoutDate.getTimezoneOffset();
  $scope.value.original_rate = $scope.value.id ? $scope.value.rateCategoryId : null;
  $scope.value.checkinDate = new Date($scope.value.checkinDate.getTime() + $scope.value.checkinDate.getTimezoneOffset() * 60000);
  $scope.value.checkoutDate = new Date($scope.value.checkoutDate.getTime() + checkoutOffset * 60000);
  $scope.value.roomRepresentationId = $scope.value.roomRepresentationId || $rootScope.hotel.roomRepresentations.filter(function(el) {
    return el.roomTypeId == $scope.value.roomTypeId && el.coverRoomTypeId == null;
  })[0].id;
  $scope.value.roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(el) {
    return el.id == $scope.value.roomRepresentationId;
  })[0];
  $scope.value.roomRate = $rootScope.hotel.roomRates.filter(function(el) {
    return el.id == $scope.value.roomRateId;
  })[0];
  $scope.value.isForeignAmount = $scope.$parent.booking.isForeignAmount();

  $scope.value.coverRoomType = $scope.cover_room_types.filter(function(cvr) {
    if ($scope.value.roomRepresentation !== undefined) {
      if ($scope.value.roomRepresentation.coverRoomTypeId) {
        return cvr.id == 's' + $scope.value.roomRepresentation.coverRoomTypeId;
      } else {
        return cvr.id == $scope.value.roomRepresentation.roomTypeId;
      }
    } else {
      return cvr.id == $scope.value.roomTypeId;
    }
  })[0];

  $scope.value.cancellationPolicyDescription = $scope.value.cancellationPolicyId ? $rootScope.hotel.cancellationPolicies.filter(function(el) {return el.id == $scope.value.cancellationPolicyId;})[0].text : '';

  $scope.currencySymbol = $scope.value.isForeignAmount ? $scope.$parent.booking.getActiveCurrency() : $rootScope.currencySymbol;

  // Part of add new room action
  if ($scope.value.belongsToFolio === undefined) {
    $scope.value.belongsToFolio = true;
  }

  if ($scope.value.roomRate) {
    $scope.recomendedMaxAdults = Math.max.apply(Math, $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved == false && el.roomRepresentationId == $scope.value.roomRepresentationId && el.rateCategoryId == $scope.value.roomRate.rateCategoryId}).map(function(el) {return el.maxAdults}));
    $scope.recomendedMaxChildren = Math.max.apply(Math, $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved == false && el.roomRepresentationId == $scope.value.roomRepresentationId && el.rateCategoryId == $scope.value.roomRate.rateCategoryId}).map(function(el) {return el.maxChildren}));
  }

  if ($scope.$parent.booking.isForeignAmount() && !$scope.value.isForeignAmount) {
    for (var night in $scope.value.nights) {
      $scope.value.nights[night].foreignAmount = $scope.value.nights[night].price/$scope.$parent.booking.foreignCurrencyRate;
    }
  }
  
  var getRestrictions = function () {
    RestrictionStorage
    .load(
      moment($scope.value.checkinDate).format('YYYY-MM-DD'),
      moment($scope.value.checkoutDate).format('YYYY-MM-DD')
    )
    .then(function(restrictions) {
      $scope.value.restrictions = restrictions;
      filterAvailableRates();
    });
  }

  var filterAvailableRates = function() {
    $scope.value.applicableRoomRates = $rootScope.hotel
      .roomRates
      .filter(function(roomRate) {
        return roomRate.roomRepresentationId == $scope.value.roomRepresentationId
            && roomRate.maxAdults >= Number($scope.value.numberOfAdults)
            && roomRate.maxChildren >= Number($scope.value.numberOfChildren)
            && roomRate.isRemoved === false;
      })
      .filter(function(roomRate) {
        var values = [];

        var rateRestrictions = $scope.value.restrictions[roomRate.id];
        if (!rateRestrictions) {
          return false;
        }

        Object
          .keys(rateRestrictions)
          .sort()
          .forEach(function(date) {
            var d = new Date(new Date(date).setHours(0,0,0,0));
            if (d >= $scope.value.checkinDate && d <= $scope.value.checkoutDate) {
              values.push($scope.value.restrictions[roomRate.id][date]);
            }
          });

        return values[values.length - 1].closedToDeparture == false
            && values[0].closedToArrival == false
            && values[0].minStayArrival <= Number($scope.value.numberOfNights)
            && (values[0].maxStay >= Number($scope.value.numberOfNights) || values[0].maxStay == 0)
            && values.slice(0, values.length - 1).map(function(el) { return el.stopSell; }).reduce(function(out, el) {
                return out && el == false;
              }, true)
            && values.slice(0, values.length - 1).map(function(el) { return el.minStayThrough; }).reduce(function(out, el) {
                return out && el <= Number($scope.value.numberOfNights);
              }, true);
      });

    var applicableRateCategoryIds = _.uniq($scope.value.applicableRoomRates.map(function(el) {
      return el.rateCategoryId;
    }));

    if ($scope.value.original_rate && applicableRateCategoryIds.indexOf($scope.value.original_rate) == -1) {
      applicableRateCategoryIds.unshift($scope.value.original_rate);
    }

    if (applicableRateCategoryIds.indexOf($scope.value.rateCategoryId) == -1) {
      $scope.value.rateCategoryId = applicableRateCategoryIds[0];
      var rate = $rootScope.hotel.rateCategories.filter(function(rate) {
        return rate.id == $scope.value.rateCategoryId;
      })[0];
      if (!rate) {
        rate = $rootScope.hotel.rateCategories.filter(function(rate) {
          return rate.isBaseRate === true;
        })[0];
      }
      $scope.value.rate_select = rate;
      $scope.value.rate = rate;
      $scope.changeRoom('rate');
    }
  }

  getRestrictions();
  angular.extend(
    $scope,
    {
      today       : new Date(new Date().setHours(0,0,0,0)),
      dateOptions : {
        formatYear  : 'yy',
        startingDay : 1
      },
      room_types  : $rootScope.hotel.roomTypes,
      room_types_by_id: $rootScope.hotel.roomTypes.reduce(function(acc, el) {acc[el.id] = el; return acc;}, {}),
      rates       : $rootScope.hotel.rateCategories.filter(function(el) { return el.isRemoved === false || el.id === $scope.value.rateCategoryId }),
      rooms       : $rootScope.hotel.rooms,
      policies    : $rootScope.hotel.cancellationPolicies.filter(function(el) { return !el.isRemoved || $scope.edited_room.cancellationPolicyId == el.id; }),
      titles      : titles,
      times       : times,
      prevDay     : (function() {
        var today = moment(new Date().setHours(0,0,0,0)).toDate();
        return moment($scope.value.checkinDate).subtract(1, 'day').toDate();
      })(),
      loading     : false,
      adults_select : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
      child_select  : ['0',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],

      icon_choices: [
        'fas fa-ban',
        'fas fa-star',
        'fas fa-crown',
        'fas fa-bell',
        'fas fa-phone',
        'fas fa-clock',
        'fas fa-coffee',
        'fas fa-utensils',
        'fas fa-user-cog',
        'fas fa-wheelchair',
        'fas fa-allergies',
        'fas fa-head-side-mask',
        'fas fa-backspace',
        'fas fa-arrow-up',
        'fas fa-arrow-down'
      ],
      icon_class: function(icon) {
        return icon + ($scope.value.icon==icon?' selected':'');
      },
      set_icon: function(event) {
        var new_icon = event.target.dataset.iconName;
        $scope.value.icon = $scope.value.icon!=new_icon? new_icon: null;
      },

      notBlockedRoomFilter : function (room) {
        if ($scope.value.roomTypeId === null) {
          return false;
        }

        return closed_rooms.indexOf(room.id) == -1 && room.isActive == true;
      },


      notBlockedRoomTypesFilter: function (type) {
        var types = [];

        _.each($scope.rooms, function(room) {
          if (closed_rooms.indexOf(room.id) == -1) {
            types.push(room.roomTypeId);
          }
        });

        return types.indexOf(type.roomTypeId) > -1;
      },


      roomTypeFilter: function (room_option) {
        if ($scope.value && $scope.value.roomTypeId && $scope.notBlockedRoomTypesFilter({roomTypeId: $scope.value.roomTypeId})) {
          return room_option.roomTypeId == $scope.value.roomTypeId;
        } else {
          return true;
        }
      },


      changeRoom : function (field, notCalcCheckOut) {
        var room = $scope.value,
            recalcNights = true,
            roomType = null,
            rate = null,
            selectedRoom = room.roomId ? $scope.rooms.filter(function(el) {return el.id == Number(room.roomId);})[0] : null,
            recalc = !Boolean(room.id);

        if (field == 'roomSelect') {
          if (selectedRoom && selectedRoom.roomTypeId != room.roomTypeId) {
            room.roomTypeId = selectedRoom.roomTypeId;
            room.coverRoomType = this.cover_room_types.reduce(function(acc, el) {acc[el.id] = el; return acc;}, {})[room.roomTypeId];
            this.changeRoom('roomType');
            return;
          }
          room.roomId = Number(room.roomId);
          $scope.changeRoom('numberOfNights');
          return;
        }

        if (field == 'roomType') {
          oldRT = Number(room.roomTypeId);
          room.roomTypeId = Number($scope.value.coverRoomType.roomTypeId);
          if (oldRT != room.roomTypeId) {
            room.roomId = null;
            room.room_select = null;
          }
          roomType = $scope.room_types.filter(function(el) {return el.id == room.roomTypeId;})[0];
          $scope.value.roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(el) {
            if (String($scope.value.coverRoomType.id).indexOf('s') != -1) {
              return el.roomTypeId == $scope.value.coverRoomType.roomTypeId && el.coverRoomTypeId == Number($scope.value.coverRoomType.id.replace('s', ''));
            } else {
              return el.roomTypeId == $scope.value.coverRoomType.roomTypeId && el.coverRoomTypeId == null;
            }
          })[0];
          $scope.value.roomRepresentationId = $scope.value.roomRepresentation.id;
          var roomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {
            return roomRate.isRemoved === false && roomRate.rateCategoryId == $scope.value.rateCategoryId
              && roomRate.roomRepresentationId == $scope.value.roomRepresentationId;
          });
          var filteredRoomRate = roomRates.filter(function(roomRate) {
            return roomRate.maxAdults == Number($scope.value.numberOfAdults) && roomRate.maxChildren == Number($scope.value.numberOfChildren);
          });
          var roomRate = filteredRoomRate.length > 0 ? filteredRoomRate[0] : roomRates[0];
          if (roomRate && roomRate !== undefined) {
            $scope.value.roomRate = roomRate;
            $scope.value.roomRateId = roomRate.id;
            $scope.value.rateCategoryId = $scope.value.roomRate.rateCategoryId;
            $scope.value.rate_select = $scope.rates.filter(function(el) {return el.id == $scope.value.rateCategoryId})[0];
          } else {
            $scope.value.roomRate = null;
            $scope.value.roomRateId = null;
            $scope.value.rateCategoryId = null;
            $scope.value.rate_select = null;
          }

          if ($scope.value.restrictions) {
            filterAvailableRates();
          }
        }

        if (field == 'checkinDate') {
          if ($scope.value.checkinDate.toString() == (new Date(original_room.checkinDate)).toString()) {
            recalcNights = false;
          }
          recalc = true;
        }

        if (field == 'numberOfNights') {
          if (notCalcCheckOut === true) {
            out = room.checkoutDate;
          } else {
            out = moment(room.checkinDate).add(room.numberOfNights, 'days').toDate();
            if (out != room.checkoutDate) {
              room.checkoutDate = out;
            }
          }
          recalc = true;
        }

        if (field == 'checkinDate' || field == 'numberOfNights') {
          var checkinDate = moment($scope.value.checkinDate).format('YYYY-MM-DD');
          var checkoutDate = moment($scope.value.checkoutDate).format('YYYY-MM-DD');
          var rsDateFrom = RestrictionStorage.dateFrom ? RestrictionStorage.dateFrom : moment().format('YYYY-MM-DD');
          var rsDateTo = RestrictionStorage.dateTo ? RestrictionStorage.dateTo : moment().format('YYYY-MM-DD');

          if (checkinDate !== rsDateFrom || checkoutDate !== rsDateTo) {
            getRestrictions();
          } else {
            filterAvailableRates();
          }
        }

        if (field == 'rate' || $scope.value.roomRate === undefined) {
          console.log('New rate', $scope.value.rate_select.id)
          room.rateCategoryId = $scope.value.rate_select ? $scope.value.rate_select.id : $scope.value.rateCategoryId;
          var roomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {
            return roomRate.isRemoved === false && roomRate.rateCategoryId == $scope.value.rateCategoryId
              && roomRate.roomRepresentationId == $scope.value.roomRepresentationId;
          });
          var filteredRoomRate = roomRates.filter(function(roomRate) {
            return roomRate.maxAdults == Number($scope.value.numberOfAdults) && roomRate.maxChildren == Number($scope.value.numberOfChildren);
          });
          var roomRate = filteredRoomRate.length > 0 ? filteredRoomRate[0] : roomRates[0];
          if (roomRate && roomRate !== undefined) {
            $scope.value.roomRate = roomRate;
            $scope.value.roomRateId = roomRate.id;
            recalc = true;
          } else {
            $scope.value.roomRate = null;
            $scope.value.roomRateId = null;
            $scope.value.rate_select = null;
          }
        }

        if ($scope.value.roomRate !== null && $scope.value.roomTypeId !== null && recalc) {
          if (!$scope.value.cancellationPolicyIsCustom) {
            $scope.value.cancellationPolicyId = $scope.value.roomRate.cancellationPolicyId;
          }
          $scope.value.cancellationPolicyDescription = $rootScope.hotel.cancellationPolicies.filter(function(el) {return el.id == $scope.value.cancellationPolicyId;})[0].text;
          $scope.fillNights(
            room.numberOfNights,
            room.checkinDate,
            $scope.value.roomRate.id,
            room.nights.map(function(room) {return room.price}),
            room.nights.map(function(room) {return room.foreignAmount}),
            field
          ).then(function(result) {
            room.nights = result;
            $scope.calcTotalPerRoom();
            $rootScope.$broadcast('bookings:update');
          });
        }
        if (room.roomRate) {
          $scope.recomendedMaxAdults = Math.max.apply(Math, $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved == false && el.roomRepresentationId == room.roomRepresentationId && el.rateCategoryId == room.roomRate.rateCategoryId}).map(function(el) {return el.maxAdults}));
          $scope.recomendedMaxChildren = Math.max.apply(Math, $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved == false && el.roomRepresentationId == room.roomRepresentationId && el.rateCategoryId == room.roomRate.rateCategoryId}).map(function(el) {return el.maxChildren}));
        }
        $timeout(function() {
          $scope.checkAvailable();
        }, 50);
      },


      cancelRoomEditing : function () {
        _.each(_.keys($scope.value), function(key) {
          if (key.indexOf('$') == -1) {
            $scope.value[key] = original_room[key];
          }
        });

        if ($scope.value.id) {
          $rootScope.$broadcast('bookings:update');
        } 
        $scope.bookingRoomsCtrl.closeRoomEditDrawer();
      },

      finishFolioRoomEditing : function () {
        if ($scope.value.belongsToFolio){
          $scope._finishRoomEditing();
        }
        else {
          var confirm = $mdDialog.confirm()
              .title($i18next.t('bookings.rooms.edit.belongs_to_receipt.title'))
              .textContent($i18next.t('bookings.rooms.edit.belongs_to_receipt.content'))
              .ok('Confirm')
              .cancel('Cancel');

          angular.element('.tooltip').hide();

          $mdDialog.show(confirm).then(function() {
            $scope._finishRoomEditing();
          }, function() {});
        }
      },

      _finishRoomEditing : function () {
        if (!$scope.value.isForeignAmount) {
          for (var night in $scope.value.nights) {
            $scope.value.nights[night].foreignAmount = null;
          }
        }
        if ($scope.roomEdit.$valid && $scope.value.available) {
          $scope.loading = true;
          if ($scope.value.id) {
            if ($rootScope.networkStatus) {
              $scope._updateOnlineRoom();
            } else {
              $scope._updateOfflineRoom();
            }
          } else {
            if ($rootScope.networkStatus) {
              $scope._createOnlineRoom();
            } else {
              $scope._createOfflineRoom();
            }
          }
        } else {
          UIDialogService.open('alert', {
            title: 'Error',
            text: 'Form is not valid!'
          });
        }
      },


      checkAvailable : function () {
        if ($scope.edited_room.edited) {
          var room = $scope.value,
              availability = AvailabilityChecker.checkAvailability(
                room.roomId,
                room.checkinDate,
                room.numberOfNights,
                room.id
              );

          closed_rooms = availability.closed;

          if (closed_rooms.indexOf($scope.value.roomId) > -1) {
            $scope.value.roomId = null;
            $scope.value.room_select = null;

            if ($scope.room_types.filter($scope.notBlockedRoomTypesFilter).indexOf($scope.value.room_type_select) !== -1) {
              $scope.value.roomTypeId = null;
            }
          }

          $scope.value.nights_select = [];
          for (x = 1; x <= availability.diff; x++) {
            $scope.value.nights_select.push(x);
          }

          $scope.value.maxDates  = availability.diff;
          $scope.value.max_checkout_date = moment(room.checkinDate).add(availability.diff, 'days').toDate();
          $scope.value.available = availability.available;
        }
      },


      fillNights : function (number_of_nights, date_in, roomRateId, old_nights, old_nights_foreign_amount, field) {
        var nights = Number(number_of_nights),
            dates = [],
            out = [];

        $scope.loadNights = true;
        if (typeof(date_in) == 'number') { date_in = new Date(date_in); }
        if (typeof(date_in) == 'string') { date_in = new Date(date_in); }

        for (x = 0; x < nights; x++) {
          dates.push(moment(date_in).add(x, 'd').toDate().getTime());
        }
        return RateByDateStorage.getPriceByDatePromise(dates, roomRateId).then(function(result) {
          $scope.loadNights = false;
          var minPriceObject = minPricePerNight(field, result, old_nights, nights),
            min_price = minPriceObject.min_price,
            remainder = minPriceObject.remainder;

          return result.map(function(el, index) {
            min_price_per_index = index == 0 ? (min_price + remainder) : min_price;
            min_foreign_price_per_index = parseFloat((min_price_per_index/$scope.$parent.booking.foreignCurrencyRate).toFixed(2));
            price = min_price_per_index || (old_nights && old_nights[index] && $scope.value.id ? old_nights[index] : el.price);
            foreignAmount = min_foreign_price_per_index || ((old_nights_foreign_amount && old_nights_foreign_amount[index] && $scope.value.id) ? old_nights_foreign_amount[index] : el.foreignAmount);

            if (foreignAmount == undefined) {
              foreignAmount = parseFloat((price/$scope.$parent.booking.foreignCurrencyRate).toFixed(2));
            }

            return {
              date: el.date,
              price: price,
              foreignAmount: foreignAmount
            };
          });
        });
      },

      toggleIsForeignCurrency : function() {
        $scope.currencySymbol = $scope.value.isForeignAmount ? $scope.$parent.booking.getActiveCurrency() : $rootScope.currencySymbol;
      },

      calcTotalPerRoom : function () {
        var total = 0;
        var total_foreign = 0;

        for (var night in $scope.value.nights) {
          $scope.value.nights[night].foreignAmount = $scope.value.nights[night].foreignAmount || ($scope.value.nights[night].price/$scope.$parent.booking.foreignCurrencyRate);
          total += parseFloat($scope.value.nights[night].price);
          total_foreign += parseFloat($scope.value.nights[night].foreignAmount);
        }

        $scope.value.total_foreign_amount = parseFloat(total_foreign.toFixed($rootScope.currencyFractionSize));
        $scope.value.total_price = parseFloat(total.toFixed($rootScope.currencyFractionSize));
      },


      canBeSaved : function () {
        if ($scope.roomEdit) {
          return !($scope.value.available && $scope.roomEdit.$valid && !$scope.loading && !$scope.loadNights && $scope.value.nights.length > 0);
        }
      },


      dateInChanged: function () {
        var val = $scope.value.checkinDate,
            availability = AvailabilityChecker.checkAvailability(
              $scope.value.roomId,
              $scope.value.checkinDate,
              $scope.value.numberOfNights,
              $scope.value.id
            );
        $scope.value.checkoutDate = moment(val).add($scope.value.numberOfNights, 'days').toDate();
        $scope.value.min_checkout_date = moment(val).add(1, 'day').toDate();
        $scope.value.max_checkout_date = moment(val).add(availability.diff, 'days').toDate();
        $scope.changeRoom('checkinDate');
      },


      dateOutChanged: function (date) {
        var diff = moment(date).diff(moment(angular.copy($scope.value.checkinDate).setHours(0,0,0,0)), 'days');

        if (diff > 0 && $scope.value.numberOfNights != diff) {
          $scope.value.numberOfNights = diff;
          $scope.changeRoom('numberOfNights', true);
        }
      },


      recalcNightsFromTotal: function () {
        var total   = $scope.booking.rooms[activeRoom].total_price,
            count   = $scope.booking.rooms[activeRoom].nights.length,
            per_day = Math.floor(total / count),
            correct = total % count;

        _.each($scope.booking.rooms[activeRoom].nights, function(night) {
          night.price = per_day;
        });

        if ($scope.booking.rooms[activeRoom].nights[0]) {
          $scope.booking.rooms[activeRoom].nights[0].price = $scope.booking.rooms[activeRoom].nights[0].price+correct;
        }

        calcTotal();
      },

      recalcNightsFromTotal: function () {
        var total   = $scope.value.total_price,
            count   = $scope.value.nights.length,
            per_day = Math.floor(total / count),
            correct = Math.round((total % count) * 100) / 100;

        if ($scope.$parent.booking.isForeignAmount()) {
          $scope.value.total_foreign_amount = $scope.value.total_price/$scope.$parent.booking.foreignCurrencyRate;
        }

        _.each($scope.value.nights, function(night) {
          night.price = per_day;
          if ($scope.$parent.booking.isForeignAmount()) {
            night.foreignAmount = per_day/$scope.$parent.booking.foreignCurrencyRate;
          }
        });

        $scope.value.nights[0].price = $scope.value.nights[0].price + correct;
        $scope.value.nights[0].foreignAmount = $scope.value.nights[0].price / $scope.$parent.booking.foreignCurrencyRate;
      },

      recalcNightsFromForeignTotal: function () {
        var total   = $scope.value.total_foreign_amount,
            count   = $scope.value.nights.length,
            per_day = Math.floor(total / count),
            correct = Math.round((total % count) * 100) / 100;

        _.each($scope.value.nights, function(night) {
          night.foreignAmount = per_day;
          night.price = per_day * $scope.$parent.booking.foreignCurrencyRate;
        });

        $scope.value.total_price = $scope.value.total_foreign_amount * $scope.$parent.booking.foreignCurrencyRate;

        $scope.value.nights[0].foreignAmount = $scope.value.nights[0].foreignAmount + correct;
        $scope.value.nights[0].price = $scope.value.nights[0].foreignAmount * $scope.$parent.booking.foreignCurrencyRate;
      },


      checkField: function (val, suffix) {
        if (!_.isUndefined($scope.roomEdit)) {
          if (_.isUndefined(suffix)) { suffix = ''; }
          if ($scope.roomEdit[val+suffix]) {
            return $scope.roomEdit[val + suffix].$invalid;
          }
        }
      },


      resetNightPrices: function () {
        var room = $scope.value;

        if ($scope.value.roomTypeId !== null && $scope.value.rateCategoryId !== null && $scope.value.roomId !== null && $scope.value.roomRate !== null) {
          $scope.fillNights(
            room.numberOfNights,
            room.checkinDate,
            room.roomRate.id
          ).then(function(result) {
            room.nights = result;
            $scope.calcTotalPerRoom();
            $rootScope.$broadcast('bookings:update');
          });
        }
      },


      getRates: function(rate) {
        var applicableRateCategoryIds;
        var rateCategoryIds = $rootScope.hotel.roomRates.filter(function(el) {
          return el.isRemoved == false && el.roomRepresentationId == $scope.value.roomRepresentationId;
        }).map(function(el) {
          return el.rateCategoryId;
        });

        if ($scope.value.original_rate && rateCategoryIds.indexOf($scope.value.original_rate) == -1) {
          rateCategoryIds.push($scope.value.original_rate);
        }

        if ($scope.value.applicableRoomRates) {
          applicableRateCategoryIds = _.uniq($scope.value.applicableRoomRates.map(function(el) {
            return el.rateCategoryId;
          }));
        } else {
          applicableRateCategoryIds = [];
        }

        rates = $rootScope.hotel.rateCategories.filter(function(rate) {
          return rateCategoryIds.indexOf(rate.id) > -1;
        });

        rates.forEach(function(el) {
          el['applicable'] = Number(applicableRateCategoryIds.indexOf(el.id) > -1) * (-1);
        });

        return _.sortBy(rates, function(rate){ return rate.applicable; });
      },

      getRooms: function(rooms) {
        var room = $scope.value;

        return rooms
          .filter(this.notBlockedRoomFilter).map(function(el) {
            el.applicable = Number(el.roomTypeId == Number(room.roomTypeId));
            return el;
          })
          .sort(function(a, b) {
            return (a.applicable - b.applicable) * -1;
          });
      },

      normalizeNights: function(saveObject) {
        saveObject.nights.forEach(function(el, index) {
          saveObject.nights[index].price = parseFloat(saveObject.nights[index].price.toFixed($rootScope.currencyFractionSize))
        });
        return saveObject;
      },

      parseDateOnly: function (dateInput) {
        if (typeof dateInput === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
          var date = dateInput.split("-").map(Number);
          return new Date(date[0], date[1] - 1, date[2]);
        }

        var d = new Date(dateInput);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      },

      getNights: function (checkinDate, checkoutDate) {
        var checkin = $scope.parseDateOnly(checkinDate);
        var checkout = $scope.parseDateOnly(checkoutDate);

        var diffMs = checkout - checkin;
        return Math.round(diffMs / (1000 * 60 * 60 * 24));
      },

      _updateOnlineRoom: function () {
        var saveObject = angular.copy($scope.value);
        saveObject.checkinDate = $filter('date')(moment(saveObject.checkinDate).toDate(), "yyyy-MM-dd");
        saveObject.lastUpdateTimestamp = $rootScope.bookingsLastUpdated;
        if (saveObject.status === 'hold') { saveObject.status = 'pending'; }
        $rootScope.isDisabledPusherEvents = true;
        saveObject = $scope.normalizeNights(saveObject);
        var numberOfNights = $scope.getNights(saveObject.checkinDate, saveObject.checkoutDate);
        if (saveObject.numberOfNights != numberOfNights) {
          UIDialogService.open('alert', {
            title: 'Error',
            text: $i18next.t('general.booking_room.number_of_nights_difference')
          });
          $rootScope.isDisabledPusherEvents = false;
          $scope.loading = false;
          return;
        }
        saveObject
          .update()
          .then(function (data) {
            var index = $scope.$parent.booking.rooms.indexOf($scope.edited_room);
            data.checkinDate = new Date(data.checkinDate);
            data.checkoutDate = new Date(data.checkoutDate);
            $scope.value = data;
            $scope.edited_room = data;

            $scope.$parent.booking.rooms[index] = data;

            $scope.loading = false;

            if ($scope.value.restoreAfterSave) {
              $scope.value.restoreAfterSave = false;
              $scope.bookingRoomsCtrl.ctrl.restoreRoom($scope.value);
            }

            $scope.bookingRoomsCtrl.editedRoom = null;
            $scope.bookingRoomsCtrl.closeRoomEditDrawer();

            var booking = BookingStorage.bookings.find(function (b) {
              return b.id == data.bookingId;
            });

            var roomIndex = booking.rooms.findIndex(function (r) {
              return r.id == data.id;
            });

            if (roomIndex !== -1) {
              booking.rooms[roomIndex] = data;
              $rootScope.$broadcast('booking_management:reload', booking);
            }
          }).catch(function (error) {
            if (error.status === 0) {
              $scope._updateOfflineRoom();
            } else {
              UIDialogService.open('alert', {
                title: 'Error',
                text: error.data ? error.data.errors : 'Unknown error'
              });

              $scope.loading = false;
            }
          }).finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
      },


      _updateOfflineRoom: function () {
        if ($scope.$parent.booking.for_create) {
          var index = $scope.$parent.booking.rooms.indexOf($scope.edited_room);
          angular.extend(
            $scope.$parent.booking.forSaveObject.rooms[index],
            {
              checkinDate : $filter('date')(moment($scope.value.checkinDate).toDate(), "yyyy-MM-dd"),
              checkinTime : $scope.value.checkinTime,
              checkoutDate : $filter('date')(moment($scope.value.checkoutDate).toDate(), "yyyy-MM-dd"),
              roomId : $scope.value.roomId,
              roomName : $scope.value.room_select.name,
              roomType : $scope.value.roomTypeId,
              dontMove : $scope.value.dontMove,
              guest : $scope.value.guest.id ? null : $scope.value.guest,
              guestID : $scope.value.guest.id,
              nights : $scope.value.nights,
              note : $scope.value.note || '',
              housekeepingNote : $scope.value.housekeepingNote,
              rateCategoryId : $scope.value.rateCategoryId,
              totalPrice : $scope.value.totalPrice,
              numberOfNights : $scope.value.numberOfNights,
              numberOfChildren : $scope.value.numberOfChildren,
              numberOfAdults : $scope.value.numberOfAdults,
              icon: $scope.value.icon,
            }
          );
        } else {
          $scope.value.checkinDate = $filter('date')(moment($scope.value.checkinDate).toDate(), "yyyy-MM-dd");
          $scope.value.checkoutDate = $filter('date')(moment($scope.value.checkoutDate).toDate(), "yyyy-MM-dd");
          $scope.value.__sync = false;
          $scope.value.for_create = false;
          $scope.edited_room.checkinDate = $filter('date')(moment($scope.value.checkinDate).toDate(), "yyyy-MM-dd");
          $scope.edited_room.checkoutDate = $filter('date')(moment($scope.value.checkoutDate).toDate(), "yyyy-MM-dd");
          $scope.edited_room.__sync = false;
          $scope.edited_room.for_create = false;
        }

        $rootScope.$broadcast('bookings:update');

        $scope.loading = false;
        $scope.bookingRoomsCtrl.editedRoom = null;
        $scope.bookingRoomsCtrl.closeRoomEditDrawer();
      },


      _createOnlineRoom: function () {
        $rootScope.isDisabledPusherEvents = true;
        var booking_room = angular.copy($scope.value);
        booking_room.checkinDate = $filter('date')(moment(booking_room.checkinDate).toDate(), "yyyy-MM-dd");
        booking_room.bookingId = $scope.$parent.booking.id;
        booking_room.lastUpdateTimestamp = $rootScope.bookingsLastUpdated;
        new BookingRoomFactory(booking_room)
          .create()
          .then(function (data) {
            booking = BookingStorage.get(data.bookingId);
            booking.rooms.push(data);

            $scope.loading = false;
            $scope.bookingRoomsCtrl.closeRoomEditDrawer();
          }).finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
      },


      _createOfflineRoom: function () {
        var booking_room = angular.copy($scope.value),
            booking = BookingStorage.get($scope.$parent.booking.id);

        if (booking.for_create) {
          booking.forSaveObject.rooms.push({
            checkin_date: $filter('date')(moment(booking_room.checkinDate).toDate(), "yyyy-MM-dd"),
            checkin_time: booking_room.checkinTime,
            checkout_date: $filter('date')(moment(booking_room.checkoutDate).toDate(), "yyyy-MM-dd"),
            dont_move: booking_room.dontMove,
            guest: booking_room.guest.id ? null : booking_room.guest,
            guestID : booking_room.guest.id,
            hotel_id: booking_room.hotel_id,
            nights: booking_room.nights,
            note: booking_room.note,
            housekeeping_note: booking_room.housekeepingNote,
            number_of_adults: booking_room.numberOfAdults,
            number_of_children: booking_room.numberOfChildren,
            number_of_nights: booking_room.numberOfNights,
            rate_category_id: booking_room.rateCategoryId,
            room_id: booking_room.roomId,
            room_name: booking_room.room_select.name,
            room_type: booking_room.room_type_select.shortName,
            total_price: booking_room.total_price
          });
        } else {
          booking_room.bookingId = $scope.$parent.booking.id;
          booking_room.booking_id = $scope.$parent.booking.id;
          booking_room.__sync = false;
          booking_room.for_create = true;
        }

        booking.rooms.push(booking_room);

        $rootScope.$broadcast('bookings:update');

        $scope.loading = false;
        $scope.bookingRoomsCtrl.closeRoomEditDrawer();
      },

      resetCancellationPolicy: function(room) {
        room.cancellationPolicyId = room.roomRate.cancellationPolicyId;
        room.cancellationPolicyIsCustom = false;
      },

      setCustomPolicy: function(room) {
        room.cancellationPolicyIsCustom = room.cancellationPolicyId != room.roomRate.cancellationPolicyId;
      },

      searchGuest: function(field) {
        var room = $scope.value;
        var fields = {
          'firstName' : 'first_name',
          'lastName': 'last_name',
          'email': 'email',
          'phone': 'phone'
        }
        var params = {};
        params[fields[field]] = room.guest[field];
        if (room.wasSettled === undefined || room.wasSettled === null || new Date().getTime() - room.wasSettled > 2500) {
          return $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/autocomplete', {
            params: params
          }).then(function(results) {
            return results.data.guests;
          });
        }
      },

      changeGuest: function(guest) {
        var room = $scope.value;
        if (guest) {
          $scope.assignGuest(room, guest);
        }
      },

      assignGuest: function(room, guest) {
        room.guest.id = guest.id;
        room.guest.firstName = guest.first_name;
        room.guest.lastName = guest.last_name;
        room.guest.email = guest.email;
        room.guest.phone = guest.phone;
        room.guest.address = guest.address;
        room.guest.city = guest.city;
        room.guest.country = guest.country;
        room.guest.state = guest.state;
        room.guest.zipCode = guest.zip_code;
        room.guest.locale = guest.locale;
        room.guest.nationality = guest.nationality;
        room.guest.identifictionTypeId = guest.identifiction_type_id;
        room.guest.identification = guest.identification;
        room.guestId = guest.id;
        room.wasSettled = new Date().getTime();
      }
    }
  );

  angular.extend(
    $scope.value,
    {
      checkinTime      : $scope.value.checkinTime ? $filter('dateToMoment')($scope.value.checkinTime, "HH:mm", 'UTC', true) : $scope.value.checkinTime,
      available        : true,
      nights_select    : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
      room_type_select : $scope.room_types.filter(function (type) { return type.id == $scope.value.roomTypeId; })[0],
      room_select      : $scope.rooms.filter(function (room) { return room.id == $scope.value.roomId; })[0],
      rate_select      : $scope.rates.filter(function (rate) { return rate.id == $scope.value.rateCategoryId; })[0],
      min_checkout_date : (function() {
        var date = moment($scope.value.checkinDate).toDate(),
            today = moment(new Date().setHours(0,0,0,0)).toDate();

        return moment(date).add(1, 'day').toDate();
      })()
    }
  );

  if (parseInt($scope.value.numberOfChildren) === 0) {
    $scope.value.numberOfChildren = String($scope.value.numberOfChildren);
  }

  $scope.calcTotalPerRoom();

  function validateEmails(emailInput) {
    if (!emailInput) return true; // Empty is valid

    var emails = emailInput.split(',').map(function(email) {
      return email.trim();
    });

    var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emails.every(function(email) {
      return email === '' || emailPattern.test(email);
    });
  }

  original_room = angular.copy($scope.value);

  $scope.$watch('value.edited', function (val) {
    if (val) {
      $scope.checkAvailable();
    }
  });

  $scope.$watch('edited_room.id', function (new_val, old_val) {
    if (old_val !== new_val) {
      $scope.value.id = $scope.edited_room.id;
      original_room.id = $scope.edited_room.id;
    }
  });

  $scope.$watch('value.guest.email', function(newVal) {
    var isValid = validateEmails(newVal);
    if ($scope.roomEdit && $scope.roomEdit.guestEmail) {
      $scope.roomEdit.guestEmail.$setValidity('emailFormat', isValid);
    }
  });


  // Fixup current rate with adults/children.
  // BQT-2597. IF we have room with wrong occ, it should recalc and take proper.
  // Example: adults:3 but rate for adults:1 selected. This should change rate to adults:3 if found
  var room = $scope.value;
  room.rateCategoryId = $scope.value.rate_select && $scope.value.rate_select.id;
  var roomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {
    return roomRate.isRemoved === false && roomRate.rateCategoryId == $scope.value.rateCategoryId
      && roomRate.roomRepresentationId == $scope.value.roomRepresentationId;
  });
  var filteredRoomRate = roomRates.filter(function(roomRate) {
    return roomRate.maxAdults == Number($scope.value.numberOfAdults) && roomRate.maxChildren == Number($scope.value.numberOfChildren);
  });
  if (filteredRoomRate.length > 0) {
    $scope.value.roomRate = filteredRoomRate[0];
    $scope.value.roomRateId = filteredRoomRate[0].id;
    $scope.getRates();
  }

  $scope.checkAvailable();
}

angular
  .module('buuqit')
  .directive('paymentForm', paymentForm);

function paymentForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ngChange: "&"
    },
    controller: paymentFormController,
    templateUrl: getTemplatePath('forms/paymentForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

paymentFormController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "PaymentFactory",
  "BookingStorage",
  "UIDialogService"
];

function hotelDateToLocal(date_str, hotel_timezone) {
  if (date_str.toISOString !== undefined) {
    date_str = moment.tz(moment.tz(date_str, moment.tz.guess()).utc().format(), hotel_timezone).format();
  }
  var date = date_str.slice(0, 10);
  return new Date(date.slice(0,4), date.slice(5,7) - 1, date.slice(8, 10));
}

function localDateToHotel(date, timezone, addCurrentTime){
  date = moment.tz(moment(date).format('YYYY-MM-DD'), timezone || 'UTC')
  if (addCurrentTime) {
    hotel_time = moment.tz(moment.tz(new Date(), moment.tz.guess()).utc().format(), timezone);
    date.add(hotel_time.hours(), 'hours')
    date.add(hotel_time.minutes(), 'minutes')
  }
  return date.format();
}

function paymentFormController ($rootScope, $scope, $i18next, PaymentFactory, BookingStorage, UIDialogService) {
  $scope.value.dateValue = hotelDateToLocal($scope.value.date, $rootScope.hotel.timezone);
  $scope.foreignInvoicesFeatureEnabled = $rootScope.hotel.foreignInvoicesFeatureEnabled;
  var activeSystemPaymentTypes = $rootScope.hotel.systemPaymentTypes.filter(function(type) {return type.isActive == true})

  $scope.paymentTypes = _.union(
    [
      ['Cash', $i18next.t('bookings.payment_form.payment_types.Cash')],
      ['Cheque', $i18next.t('bookings.payment_form.payment_types.Cheque')],
      ['Bank Transfer', $i18next.t('bookings.payment_form.payment_types.Bank Transfer')],
      ['Voucher', $i18next.t('bookings.payment_form.payment_types.Voucher')],
      ['Credit Card', $i18next.t('bookings.payment_form.payment_types.Credit Card')],
      ['Debit Card', $i18next.t('bookings.payment_form.payment_types.Debit Card')],
      ['Other', $i18next.t('bookings.payment_form.payment_types.Other')]
    ].filter(function(type) {return (typeof (activeSystemPaymentTypes.find(function(type2) {return type2.name == type[0]})) != 'undefined')}),
    $rootScope.hotel.customPaymentTypes.map(function(type) {return [type.name, type.name];})
  );

  $scope.cardTypes = [
    "VISA",
    "Master Card",
    "American Express",
    "Discover",
    "JCB",
    "Union Pay",
    "Other"
  ];

  $scope.currencySymbol = $scope.value.isForeignAmount ? $scope.$parent.booking.getActiveCurrency() : $rootScope.currencySymbol;

  $scope.paymentAnimation = false;
  $scope.folios = $scope.$parent.folios;

  $scope.changeFolioSelection = function (folio) {
    if ($scope.value.isForeignAmount) {
      $scope.value.foreignAmount = +(parseFloat(folio.due) / $scope.$parent.booking.foreignCurrencyRate).toFixed(5);
    } else {
      $scope.value.amount = +(parseFloat(folio.due)).toFixed(5);
    }
  }

  $scope._createBookingPayment = function () {
    var payment = angular.copy($scope.value),
        deposit = $scope.$parent.booking.payments.filter(function(el) {return el.operation == 'deposit';}).map(function(el) {return el.amount}).reduce (function(a,b) {return a+b}, 0),
        card = true;
    payment.booking_id = $scope.$parent.booking.id;
    payment.hotel_id   = $rootScope.hotel.id;

    if (payment.type == 'Credit Card' || payment.type == 'Debit Card') {
      payment.description = 'Offline Card Payment, ' + payment.cardType + (payment.cardEnd ? ', Card ending at ' + payment.cardEnd : '');
      card = payment.cardType !== null && payment.cardEnd !== null;
    }

    if (payment.type !== '' && (payment.amount > 0 || payment.foreignAmount > 0) && card) {
      if ((payment.amount <= $scope.$parent.booking.due + deposit && payment.operation != 'refund') || payment.operation == 'deposit' || (payment.operation == 'refund' && payment.amount <= $scope.$parent.booking.totalPaid)) {
        if (payment.operation == 'refund' && payment.amount > 0) {
          payment.amount = payment.amount * -1;
        }
        if (payment.operation == 'refund' && payment.foreignAmount && payment.foreignAmount > 0) {
          payment.foreignAmount = payment.foreignAmount * -1;
        }

        payment = new PaymentFactory(payment);

        payment.date = localDateToHotel(payment.dateValue, $rootScope.hotel.timezone, true);

        payment.save(function(payment, error) {
          var success = true;
          if (error) {
            success = payment.__sync === false;
            if (error.data.msg == 'Amount is greater then booking due') {
              success = false;
              UIDialogService.open('alert', {
                text: 'Amount is greater then booking due. Payment is not accepted.',
                title: $i18next.t('bookings.payment.alert.transaction_error_title')
              });
              $scope.paymentAnimation = false;
              BookingStorage.load_by_id(payment.bookingId, false, function(booking) {
                $rootScope.$broadcast('booking_management:reload', booking);
              });
            }
          }

          if (success) {
            $scope.$parent.booking.payments.push(payment);
            $scope.$parent.hidePaymentForm();
            $scope.paymentAnimation = false;
            $rootScope.$broadcast('bookings:update');
          }
        });
      } else {
        if (payment.operation == 'refund') {
          UIDialogService.open('alert', {
            title: $i18next.t('general.titles.error'),
            text: $i18next.t('bookings.payment_form.alert_modals.you_can_not_refund_summ_greater_charged_summ_text')
          });
        } else {
          UIDialogService.open('alert', {
            title: $i18next.t('general.titles.error'),
            text: $i18next.t('bookings.payment_form.alert_modals.you_can_not_charge_summ_greater_due_summ_text')
          });
        }

        $scope.paymentAnimation = false;
      }
    } else {
      UIDialogService.open('alert', {
        title: $i18next.t('general.titles.error'),
        text: $i18next.t('bookings.payment_form.alert_modals.form_is_invalid_please_fill_required_fields_text')
      });
      $scope.paymentAnimation = false;
    }
  };

  $scope._saveBookingPayment = function () {
    var payment = $scope.value,
        card    = true;

    if (payment.type == 'Credit Card' || payment.type == 'Debit Card') {
      payment.description = 'Offline Card Payment, ' + payment.cardType + (payment.cardEnd ? ', Card ending at ' + payment.cardEnd : '');
      card = payment.cardType !== null && payment.cardEnd !== null;
    }

    if (payment.type !== '' && (payment.amount > 0 || payment.foreignAmount > 0) && card) {
      $scope.paymentAnimation = true;

      payment = new PaymentFactory(payment);

      if (hotelDateToLocal(payment.date, $rootScope.hotel.timezone).toString() != payment.dateValue.toString()) {
        payment.date = localDateToHotel(payment.dateValue, $rootScope.hotel.timezone);
      }
      payment.save(function(data) {
        angular.copy(data, $scope.value);

        $scope.value.saved = true;
        $scope.paymentAnimation = false;
        $scope.$parent.closeEditPayment(false);
        $rootScope.$broadcast('bookings:update');
      });

    } else {
      UIDialogService.open('alert', {
        title: $i18next.t('general.titles.error'),
        text: $i18next.t('bookings.payment_form.alert_modals.form_is_invalid_please_fill_required_fields_text')
      });
    }
  };

  $scope.savePaymentForm = function () {
    if ($scope.addPaymentForm.$valid) {
      $scope.paymentAnimation = true;
      if ($scope.value.id) {
        $scope._saveBookingPayment();
      } else {
        $scope._createBookingPayment();
      }
    } else {
      UIDialogService.open('alert', {
        title: $i18next.t('general.titles.error'),
        text: $i18next.t('general.alert_modals.form_is_not_valid_js_str')
      });
    }
  };

  $scope.hidePaymentForm = function () {
    if ($scope.value.id) {
      $scope.$parent.closeEditPayment(true);
    } else {
      $scope.$parent.hidePaymentForm();
    }
  };
}

// after rooms rewrite this directive is not if service anymore
angular
  .module('buuqit')
  .directive('keyLocksEdit', keyLocksEdit);

function keyLocksEdit () {
  return {
    restrict: 'E',
    scope: {
      loading_room_keys: "=loadingRoomKeys",
      key_lock_id: "=keyLockId",
      room_keys: "=roomKeys",
      edited_room: '=ngModel',
      ngChange: "&"
    },
    controller: keyLocksEditController,
    templateUrl: getTemplatePath('keyLocksEdit.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

keyLocksEditController.$inject = [
  "$rootScope",
  "$scope",
  "$filter",
  "$timeout",
  "$http"
];

function keyLocksEditController ($rootScope, $scope, $filter, $timeout, $http) {
  $bookingRoomsCtrl = $scope.$parent.$parent.$parent.$parent;
  angular.extend(
    $scope,
    {
      creatingRoomKey : false,
      closeDisplayRoomKeys : function () {
        $bookingRoomsCtrl.displayingRoomKeys = null;
      },
      createBookingRoomKey : function () {
        $scope.creatingRoomKey = true;
        $http.post(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/key_locks/' + $scope.key_lock_id + '/create_booking_room_key_code', {
          booking_room_id: $bookingRoomsCtrl.displayingRoomKeys
        })
          .then(function(response) {
            $scope.creatingRoomKey = false;
            $scope.room_keys[$bookingRoomsCtrl.displayingRoomKeys].push(response.data.key_lock_code)
            // $scope.roomKeys[bookingRoom.id] = response.data.key_lock_codes;
          }, function(error) {
              $scope.creatingRoomKey = false;
          });
      }
    }
  );  
}

// after rooms rewrite this directive is not in service anymore
angular
  .module('buuqit')
  .directive('foreignCurrencyEdit', foreignCurrencyEdit);

function foreignCurrencyEdit () {
  return {
    restrict: 'E',
    scope: {
      booking: '=ngModel',
      ngChange: "&"
    },
    controller: foreignCurrencyEditController,
    templateUrl: getTemplatePath('foreignCurrencyEdit.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

foreignCurrencyEditController.$inject = [
  "$rootScope",
  "$scope",
  "$filter",
  "$timeout",
  "$http",
  "BookingRoomFactory",
  "BookingStorage",
  "AvailabilityChecker",
  "RateByDateStorage",
  "UIDialogService",
  "RestrictionStorage"
];

function foreignCurrencyEditController ($rootScope, $scope, $filter, $timeout, $http, BookingRoomFactory, BookingStorage, AvailabilityChecker, RateByDateStorage, UIDialogService, RestrictionStorage) {
  $scope.value = angular.copy($scope.booking);
  $scope.isLoading = false;
  $scope.currencyProfiles = $rootScope.hotel.currencyProfiles;
  $scope.handleCurrencyChange = function () {
    var selectedCurrency = this.value.foreignCurrency;
    var currencyProfile = $rootScope.hotel.currencyProfiles.find(function(currencyProfile) {return currencyProfile.code == selectedCurrency});
    var exchangeRate = +(1/currencyProfile.realExchangeRate)
    if (exchangeRate < 0.1) {
      exchangeRate = +(exchangeRate.toFixed(8));
    } else {
      exchangeRate = +(exchangeRate.toFixed(2));
    }

    this.value.foreignCurrencyRate = exchangeRate;
  }
  $scope.editForeignCurrencyRate = function () {
    $scope.isLoading = true;
    $scope.booking.updateForeignCurrencyRate($scope.value).then(function(results) {
      $scope.$parent.$parent.foreignCurrencyEditVisibility = false;
      $scope.isLoading = false;
    },
    function (error) {
      $scope.isLoading = false;
      $rootScope.notify(error.data.errors);
    });
  };

  $scope.cancelRoomEditing = function () {
    $scope.$parent.$parent.foreignCurrencyEditVisibility = false;
  }
}

angular
  .module('buuqit')
  .directive('folioTaxForm', folioTaxForm);

folioTaxForm.$inject = ["$rootScope"];

function folioTaxForm ($rootScope) {
  return {
    controller: ["$scope", "$rootScope", "$timeout", function ($scope, $rootScope, $timeout) {
      $scope.taxes = $rootScope.hotel.newTaxes.filter(function(tax) {return tax.isRemoved === false});
      $scope.loading = false;
      $scope.errorIsVisible = false;
      $scope.editedTax = angular.copy($scope.folioTax);
      $scope.editedTax.description = $scope.editedTax.tax;

      $scope.onTaxChange = function () {
        var tax = $scope.taxes.filter(function(el) {
          return el.id === $scope.editedTax.taxId;
        })[0];

        $scope.editedTax.calculationLogic = tax.calculationLogic;
        $scope.editedTax.calculationMethod = tax.calculationMethod;
        $scope.editedTax.value = tax.amount;
      }

      $scope.save = function () {
        var promise = null;

        if ($scope.folioTaxForm.$valid) {
          $scope.loading = true;
          $rootScope.isDisabledPusherEvents = true;

          if ($scope.editedTax.id) {
            promise = __updateTax(__convertFoliTaxToSaveObject($scope.editedTax));
          } else {
            promise = __createTax(__convertFoliTaxToSaveObject($scope.editedTax), $scope.folioItemId);
          }

          var lastActiveFolio = $scope.activeFolio;
          promise.then(function(response) {
            if (response.data.success === true) {
              $scope.loading = false;
              $scope.onSave();
            } else {
              showError(response.data.message);
              $scope.loading = false;
            }
          })
          .catch(function() {
            showError('Something went wrong');
            $scope.loading = false;
          })
          .finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
        } else {
          showError('Form is invalid');
        }
      }

      function __updateTax(editedTax) {
        return $scope.folio
          .updateTax(editedTax.id, editedTax);
      }

      function __createTax(editedTax, folioItemId) {
        return $scope.folio
          .addTax(folioItemId, editedTax);
      }

      function __convertFoliTaxToSaveObject(editedTax) {
        return {
          amount: editedTax.amount,
          id: editedTax.id,
          new_tax_id: editedTax.taxId,
          value: editedTax.value,
          is_manual: editedTax.isManual
        }
      }

      function showError(message) {
        console.time('anim');
        $scope.error = message;
        $scope.errorIsVisible = true;
        $timeout(function() {
          $scope.errorIsVisible = false;
          console.timeEnd('anim');
        }, 2000);
      }

      $scope.onClose = function () {
        $scope.folioTax.editMode = false;
      }
    }],
    restrict: 'E',
    scope: {
      folioTax: '=folioTax',
      folioItemId: '=folioItemId',
      folio: '=folio',
      onReset: '=onReset',
      onSave: '=onSave'
    },
    templateUrl: getTemplatePath('booking_management/folioTaxForm.html'),
    link: function (scope, element, attrs, ctrl) {
    }
  };
}

angular
  .module('buuqit')
  .directive('customerForm', customerForm);

customerForm.$inject = [];

function customerForm () {
  return {
    controller: ["$scope", "$rootScope", function ($scope, $rootScope) {
      $scope.locales = window.locales;
      $scope.idTypes = $rootScope.hotel.identificationTypes;
      $scope.countries = countries.map(function(el) {return el.name});
      $scope.rateCategories = $rootScope.hotel.rateCategories.filter(function(rateCategory) {return rateCategory.isRemoved === false;});

      if ($scope.countries && $scope.countries.indexOf($scope.customer.country) == -1) {
        $scope.countries.push($scope.customer.country);
      }

      $scope.saveCustomer = function () {
        $scope.saveCustomerInProgress = true;
        $scope.customer.hotelId = $rootScope.hotel.id;

        var isNewCustomer = !Boolean($scope.customer.id);

        $scope.filterDataByCustomerType();

        $scope.customer
          .save()
          .then(function(customer) {
            $scope.saveCustomerInProgress = false;

            if ($scope.onNewCustomer && isNewCustomer) {
              $scope.onNewCustomer(customer);
              return;
            }

            if ($scope.onUpdatedCustomer) {
              $scope.onUpdatedCustomer(customer);
              return;
            }

            $scope.onClose();
          });
      };

      $scope.filterDataByCustomerType = function () {
        var customerType = $scope.customer.customerType;

        if(customerType == "0") {
          $scope.customer.companyName = "";
          $scope.customer.billTo = "";
          $scope.customer.taxNumber = "";
          $scope.customer.referenceText = "";
        } else {
          $scope.customer.firstName = "";
          $scope.customer.lastName = "";
          $scope.customer.nationality = "";
          $scope.customer.identification = "";
          $scope.customer.identificationTypeId = "";
        };
      };
    }],
    restrict: 'E',
    scope: {
      customer: '=customer',
      onClose: '=onClose',
      onNewCustomer: '=onNewCustomer',
      onUpdatedCustomer: '=onUpdatedCustomer',
    },
    templateUrl: getTemplatePath('booking_management/customerForm.html'),
    link: function (scope, element, attrs, ctrl) {
    }
  };
}

var $injector;
angular
  .module('buuqit')
  .directive('bookingRooms', bookingRooms)
  .controller('BookingRoomsController', bookingRoomsController)
  .component(
    'reactBookingRooms',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingRooms,
      [
        'bookingRooms',
        'bookingInfo',
        'bookingChannelReservationId',
        'bookingPreparedChannel',
        'roomTypes',
        'rateCategories',
        'hotelRooms',
        'roomRepresentations',
        'coverRoomTypes',
        'virtualRoomTypes',
        'housekeepingEnabled',
        'foreignInvoicesFeatureEnabled',
        'bookingRoomsRef',
        'rootTimezone',
        'cancellationPolicies',
        'hotelProperties',
        'hotelBookingComCode',
        'keyLocks',
        'bookingPayments',
        'bookingToken',
        'roomKeys',
        'foreignCurrencyRate',
        'foreignCurrency',
        'currencyProfiles',
        'convertCurrency',
        'saveBookingRoomNotes',
        'checkin',
        'checkout',
        'showRoomKeys',
        'cancelRoom',
        'markRoomAsCanceled',
        'splitRoom',
        'restoreRoom',
        'changeRoom',
        'checkinSelected',
        'checkoutSelected',
        'cancelCheckinStatus',
        'cancelCheckoutStatus',
        'cancelSelected',
        'changeSelectedDate',
        'changeSelectedOccupancy',
        'changeSelectedPrice',
        'printRoomsInfo',
        'mergeWithBooking',
        'createBookingRoomKey',
        'editForeignCurrencyRate',
        'openRoomForm',
        'showBookingRoomsWithStatus',
        'bulkStatusUpdating',
        'onLoadAvailableMergeBookings',
      ],
      ['$i18next']
    )
  )
  .run(['$injector', function(_$injector) { $injector = _$injector }]);

bookingRooms.$inject = ["$rootScope"];

function bookingRooms () {
  return {
    // controller: bookingRoomsController,
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingRooms.html'),
    // link: function (scope, element, attrs, ctrl) {}
  };
}

bookingRoomsController.$inject = [
  "$scope",
  "$rootScope",
  "$http",
  "$filter",
  "$i18next",
  "BookingRoomFactory",
  "AvailabilityChecker",
  "RateByDateStorage",
  "BookingStorage",
  "BookingExtraFactory",
  "UIDialogService",
  "BookingRoomsFactory",
  "ExtrasFactory",
  "BookingMergeFactory",
];

function bookingRoomsController ($scope, $rootScope, $http, $filter, $i18next, BookingRoomFactory, AvailabilityChecker, RateByDateStorage, BookingStorage, BookingExtraFactory, UIDialogService, BookingRoomsFactory, ExtrasFactory, BookingMergeFactory) {
  var ROOM_STATUSES = {
    ALL: 'all',
    ACTIVE: 'active',
    CANCELED: 'canceled',
  }
  var ctrl = this;
  ctrl.bookingRoomsStatus = ROOM_STATUSES.ALL;
  angular.extend(
    this,
    {
      bookingRooms: getNonCanceledRooms(sorted($scope.booking.rooms)),
      bookingInfo: $scope.booking.info,
      bookingChannelReservationId: $scope.booking.channelReservationId,
      bookingPreparedChannel: $scope.booking.preparedChannel,
      roomTypes: $rootScope.hotel.roomTypes,
      rateCategories: $rootScope.hotel.rateCategories,
      hotelRooms: $rootScope.hotel.rooms,
      roomRepresentations: $rootScope.hotel.roomRepresentations,
      coverRoomTypes: $rootScope.hotel.coverRoomTypes,
      virtualRoomTypes: $rootScope.hotel.virtualRoomTypes,
      housekeepingEnabled: $rootScope.hotel.housekeepingEnabled,
      foreignInvoicesFeatureEnabled: $rootScope.hotel.foreignInvoicesFeatureEnabled,
      rootTimezone: $rootScope.hotel.timezone,
      cancellationPolicies: $rootScope.hotel.cancellationPolicies,
      hotelProperties: $rootScope.hotel.properties,
      hotelBookingComCode: $rootScope.hotel.bookingComCode,
      keyLocks: $rootScope.hotel.keyLocks,
      bookingPayments: $scope.booking.payments,
      bookingToken: $scope.booking.token,
      roomKeys: {},
      foreignCurrencyRate: $scope.booking.foreignCurrencyRate,
      foreignCurrency: $scope.booking.foreignCurrency,
      currencyProfiles: $rootScope.hotel.currencyProfiles,
      bookingRoomsRef: React && React.createRef({}),
      bulkStatusUpdating: false,
      convertCurrency: convertCurrency,
      saveBookingRoomNotes: saveBookingRoomNotes,
      checkin: checkin,
      showRoomKeys: showRoomKeys,
      checkout: checkout,
      cancelRoom: cancelRoom,
      markRoomAsCanceled: markRoomAsCanceled,
      splitRoom: splitRoom,
      restoreRoom: restoreRoom,
      changeRoom: changeRoom,
      checkinSelected: checkinSelected,
      checkoutSelected: checkoutSelected,
      cancelCheckinStatus: cancelCheckinStatus,
      cancelCheckoutStatus: cancelCheckoutStatus,
      cancelSelected: cancelSelected,
      changeSelectedDate: changeSelectedDate,
      changeSelectedOccupancy: changeSelectedOccupancy,
      changeSelectedPrice: changeSelectedPrice,
      printRoomsInfo: printRoomsInfo,
      mergeWithBooking: mergeWithBooking,
      createBookingRoomKey: createBookingRoomKey,
      editForeignCurrencyRate: editForeignCurrencyRate,
      openRoomForm: openRoomForm,
      showBookingRoomsWithStatus: showBookingRoomsWithStatus,
      onLoadAvailableMergeBookings: onLoadAvailableMergeBookings,
    }
  );

  function showBookingRoomsWithStatus(status) {
    ctrl.bookingRoomsStatus = status;
    var allRooms = JSON.parse(JSON.stringify(sorted($scope.booking.rooms)));
    switch(status) {
      case ROOM_STATUSES.ALL:
        ctrl.bookingRooms = allRooms;
        break;
      case ROOM_STATUSES.ACTIVE:
        ctrl.bookingRooms = getNonCanceledRooms(allRooms);
        break;
      case ROOM_STATUSES.CANCELED:
        ctrl.bookingRooms = getCanceledRooms(allRooms);
        break;
    }
    clearSelectedRooms();
    $scope.$apply();
  }

  function saveBookingRoomNotes(booking_room_id, guest_notes, hotel_notes, housekeeping_notes) {
    var room = BookingStorage.get_room(booking_room_id);
    room.note = guest_notes;
    room.hotelNote = hotel_notes;
    room.housekeepingNote = housekeeping_notes;
    return room.save().then(function() {
      return $rootScope.$broadcast('BookingStorage:update', room.id, room.bookingId);
    });
  }

  function openRoomForm(ref, selectedRoom) {
    if (ref && ref.current) {
      var room;
      if(!selectedRoom) {
        room = generateNewRoom(ctrl.newRoom);
      } else {
        room = $scope.booking.rooms.find(function(r) { return r.id === selectedRoom.id; });
        if (!room) {
          room = BookingStorage.get_room(selectedRoom.id);
        }
        room.edited = true;
      }
      var $roomEdit = angular.element('<room-edit ng-model="room" booking="booking" booking-rooms-ctrl="bookingRoomsCtrl"></room-edit>');
      var reactComponent = angular.element(ref.current);
      reactComponent.append($roomEdit);
      var $compile = $injector.get('$compile');
      var scope = angular.element($roomEdit).scope();
      scope.room = room;
      scope.bookingRoomsCtrl = $scope;
      scope.booking = $scope.booking;
      $compile($roomEdit)(scope);
    }
  }
  function editForeignCurrencyRate(payload) {
    var value = angular.copy($scope.booking);
    value.foreignCurrencyRate = payload.foreignCurrencyRate;
    value.foreignCurrency = payload.foreignCurrency;
    return $scope.booking.updateForeignCurrencyRate(value).then(function(results) {
      return results;
    },
    function (error) {
      console.error(error);
      $rootScope.notify(error.data.errors);
      return error;
    });
  };

  function createBookingRoomKey(bookingRoomId, keyLockId) {
    return $http.post(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/key_locks/' + keyLockId + '/create_booking_room_key_code', {
      booking_room_id: bookingRoomId
    })
      .then(function(response) {
        ctrl.roomKeys[bookingRoomId].push(response.data.key_lock_code);
        return response;
      }, function(error) {
        console.error(error);
        return error;
      });
  }

  function mergeBookings(booking2) {
    var booking1Info = [
      $i18next.t('bookings.rooms.merge_booking_confirm.booking_x_js_str', {number: 1}),
      $scope.booking.customer.firstName,
      $scope.booking.customer.lastName+",",
      $scope.booking.channel ? $scope.booking.channel+"," : $i18next.t('bookings.rooms.merge_booking_confirm.internal_booking_js_str'),
      $i18next.t('bookings.rooms.merge_booking_confirm.payments_js_str'),
      $scope.booking.payments.length > 0 ? $i18next.t('general.other.yes') : $i18next.t('general.other.no')
    ].join(" ");
    var booking2Info = [
      $i18next.t('bookings.rooms.merge_booking_confirm.booking_x_js_str', {number: 2}),
      booking2.customer.firstName,
      booking2.customer.lastName+",",
      booking2.channel ? booking2.channel+"," : $i18next.t('bookings.rooms.merge_booking_confirm.internal_booking_js_str'),
      $i18next.t('bookings.rooms.merge_booking_confirm.payments_js_str'),
      booking2.payments.length > 0 ? $i18next.t('general.other.yes') : $i18next.t('general.other.no')
    ].join(" ");
    UIDialogService.open('confirmation', {
      title: $i18next.t('bookings.rooms.merge_booking_confirm.merge_bookings_title'),
      text: $i18next.t('bookings.rooms.merge_booking_confirm.text') + booking1Info + booking2Info,
      positive_callback: function () {
        $scope.booking.hotelId = $rootScope.hotel.id;
        $rootScope.isDisabledPusherEvents = true;
        $scope.booking
          .mergeWith(booking2.id)
          .then(function(response) {
            BookingStorage.update(BookingStorage);
          })
          .catch(function (response) {
            $rootScope.notify(response.data.error);
          })
          .finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });
  };

  function mergeWithBooking(booking_id) {
    var booking2 = BookingStorage.get(booking_id);
    if (!booking2) {
      BookingStorage.load_by_id(booking_id, false, function (booking) {
        mergeBookings(booking);
      });
    } else {
      mergeBookings(booking2);
    }
  };

  function sorted(rooms) {
    var sorting = 'type';
    return rooms.sort(function(a,b){
      var first = sorting.startsWith('-')? a: b,
          second = first===a? b: a;
      if(sorting.endsWith('type'))
        return first.roomTypeId - second.roomTypeId;
      else if(sorting.endsWith('room'))
        return $scope.getRoom(first.roomId).number - $scope.getRoom(second.roomId).number;
      else if(sorting.endsWith('checkin'))
        return first.checkinDate - second.checkinDate;
      else if(sorting.endsWith('guest'))
        return String(first.guest.firstName + first.guest.lastName).localeCompare(String(second.guest.firstName + second.guest.lastName));
      else if(sorting.endsWith('occupancy'))
        return (first.numberOfAdults+first.numberOfChildren) - (second.numberOfAdults+second.numberOfChildren)
      else if(sorting.endsWith('total'))
        return $scope.roomTotalPrice(first) - $scope.roomTotalPrice(second);
    });
  };

  function clearSelectedRooms() {
    if (ctrl.bookingRoomsRef && ctrl.bookingRoomsRef.current && ctrl.bookingRoomsRef.current.clearSelectedRooms) {
      ctrl.bookingRoomsRef.current.clearSelectedRooms();
    }
  }

  function checkoutSelected(ids) {
    $rootScope.isDisabledPusherEvents = true;
    $scope.$parent.batchSpinnerActive = true;
    ctrl.bulkStatusUpdating = 'checkout';

    var selected = getSelected(ids);
    var canCheckoutIds = [];

    selected.forEach(function (room) {
      if (room.occupationStatus == 'checked_in') {
        canCheckoutIds.push(room.id)
      }
    });

    var model = { hotelId: $rootScope.hotel.id, bookingId: $scope.booking.id };

    new BookingRoomsFactory(model).checkoutBookingRooms(canCheckoutIds).then(function (response) {
      if (response.data && response.data.errors) {
        console.error(response.data.errors);
        $rootScope.notify('Error: ' + response.data.errors);
      } else {
        canCheckoutIds.map(function (bookingRoomId) {
          var bookingRoom = ctrl.bookingRooms.find(function (bookingRoom) { return bookingRoom.id == bookingRoomId });
          var roomIndex = $rootScope.hotel.rooms.findIndex(function (room) {
            return room.id == bookingRoom.roomId;
          });
          if (roomIndex) {
            $rootScope.hotel.rooms[roomIndex].clean_status = 'dirty';
            $rootScope.hotel.rooms[roomIndex].cleanStatus = 'dirty';
            $rootScope.$broadcast('hk:reload_room', $rootScope.hotel.rooms[roomIndex]);
          }
        })
        $rootScope.$broadcast('booking:reload', $scope.booking.id);
      }
    }).catch(function (error) {
      console.error(error)
      $rootScope.notify('Error: ' + error.data.errors);
    })
    .finally(function () {
      ctrl.bulkStatusUpdating = false;
      $rootScope.isDisabledPusherEvents = false;
      $scope.$parent.batchSpinnerActive = false;
      clearSelectedRooms();
    });
  }

  function getSelected(ids) {
    return ctrl.bookingRooms.filter(function(room) {
      return ids.includes(Number(room.id))
    });
  }

  function checkinSelected(ids) {
    $rootScope.isDisabledPusherEvents = true;
    $scope.$parent.batchSpinnerActive = true;
    ctrl.bulkStatusUpdating = 'checkin';

    var selected = getSelected(ids);
    var canCheckinIds = [];

    var can_checkin = function(room){
      var now = moment(moment().format('YYYY-MM-DD')).toDate();
      var checkin_date = moment(moment(room.checkinDate).format('YYYY-MM-DD')).toDate();
      return  now >= checkin_date && room.status == 'pending' && room.occupationStatus == 'pending';
    };
    
    selected.forEach(function(room){
      if(can_checkin(room)){
        canCheckinIds.push(room.id)
      }
    });

    var model = { hotelId: $rootScope.hotel.id, bookingId: $scope.booking.id };

    new BookingRoomsFactory(model).checkinBookingRooms(canCheckinIds)
    .then(function (response) {
      if (response.data && response.data.errors) {
        console.error(response.data.errors);
        $rootScope.notify('Error: ' + response.data.errors);
      } else {
        $rootScope.$broadcast('booking:reload', $scope.booking.id);
      }
    })
    .catch(function (error) {
      console.error(error);
      $rootScope.notify('Error: ' + error.data.errors);
    })
    .finally(function () {
      ctrl.bulkStatusUpdating = false;
      $rootScope.isDisabledPusherEvents = false;
      $scope.$parent.batchSpinnerActive = false;
      clearSelectedRooms();
    });
  }

  function cancelCheckinStatus(ids) {
    $rootScope.isDisabledPusherEvents = true;
    $scope.$parent.batchSpinnerActive = true;
    ctrl.bulkStatusUpdating = 'cancelCheckin';

    var model = { hotelId: $rootScope.hotel.id, bookingId: $scope.booking.id };

    new BookingRoomsFactory(model).cancelCheckInBookingRooms(ids)
    .then(function (response) {
      if (response.data && response.data.errors) {
        console.error(response.data.errors);
        $rootScope.notify('Error: ' + response.data.errors);
      } else {
        $rootScope.$broadcast('booking:reload', $scope.booking.id);
      }
    })
    .catch(function (error) {
      console.error(error)
      $rootScope.notify('Error: ' + error.data.errors);
    })
    .finally(function () {
      ctrl.bulkStatusUpdating = false;
      $rootScope.isDisabledPusherEvents = false;
      $scope.$parent.batchSpinnerActive = false;
      clearSelectedRooms();
    });
  }

  function cancelCheckoutStatus(ids) {
    $rootScope.isDisabledPusherEvents = true;
    $scope.$parent.batchSpinnerActive = true;
    ctrl.bulkStatusUpdating = 'cancelCheckout';

    var model = {hotelId: $rootScope.hotel.id, bookingId: $scope.booking.id};
    new BookingRoomsFactory(model).cancelCheckoutBookingRooms(ids)
      .then(function (response) {
        if (response.data && response.data.errors) {
          console.error(response.data.errors);
          $rootScope.notify('Error: ' + response.data.errors);
        } else {
          $rootScope.$broadcast('booking:reload', $scope.booking.id);
        }
      })
      .catch(function (error) {
        console.error(error)
        $rootScope.notify('Error: ' + error.data.errors);
      })
      .finally(function () {
        ctrl.bulkStatusUpdating = false;
        $rootScope.isDisabledPusherEvents = false;
        $scope.$parent.batchSpinnerActive = false;
        clearSelectedRooms();
      });
  }

  function cancelSelected(ids) {
    var selected = getSelected(ids);

    if ($scope.booking.token.indexOf('-C') > -1) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.rooms.cancel_room_confirm.cancel_room_title'),
        text: $i18next.t('bookings.rooms.cancel_room_confirm.text'),
        positive_callback: function () {
          $rootScope.isDisabledPusherEvents = true;
          $scope.$parent.batchSpinnerActive = true;
          ctrl.bulkStatusUpdating = 'cancelRoom';

          var email = $scope.booking.customer.email;
          var selectedRoomsIds = selected.map(function (room) {
            return room.id;
          });
          var model = { hotelId: $rootScope.hotel.id, bookingId: $scope.booking.id };

          new BookingRoomsFactory(model).cancelBookingRooms(selectedRoomsIds, email)
            .then(function (response) {
              if (response.data && response.data.errors) {
                console.error(response.data.errors);
                $rootScope.notify('Error: ' + response.data.errors);
              } else {
                $rootScope.$broadcast('booking:reload', $scope.booking.id);
              }
            })
            .catch(function (error) {
              console.error(error)
              $rootScope.notify('Error: ' + error.data.errors);
            })
            .finally(function() {
              ctrl.bulkStatusUpdating = false;
              $rootScope.isDisabledPusherEvents = false;
              $scope.$parent.batchSpinnerActive = false;
              clearSelectedRooms();
            });
        }
      });
    } else {
      var total_fee = selected.length>1?
        selected.reduce(function(a, b){
          var costB = getBookingRoomNightsCost(b);
          if(typeof(a)==='number')
            return a + getCancellationFeeForBookingRoom(b, costB);
          var costA = getBookingRoomNightsCost(a);
          return getCancellationFeeForBookingRoom(a, costA) + getCancellationFeeForBookingRoom(b, costB);
        }):
        getCancellationFeeForBookingRoom(selected[0], getBookingRoomNightsCost(selected[0]));
      UIDialogService.open('cancellation-modal', {
        fee: total_fee,
        max_fee: 100000000,
        min_fee: 0,
        email: $scope.booking.customer.email,
        sendNotification: false,
        callback: function (value, email) {
          $rootScope.isDisabledPusherEvents = true;
          $scope.$parent.batchSpinnerActive = true;
          ctrl.bulkStatusUpdating = 'cancelRoom';

          UIDialogService.close('cancellation-modal');

          var selectedRoomsIds = selected.map(function (room) {
            return room.id;
          });
          var model = { hotelId: $rootScope.hotel.id, bookingId: $scope.booking.id };
          new BookingRoomsFactory(model).cancelBookingRooms(selectedRoomsIds, email)
            .then(function (response) {
              if (response.data && response.data.errors) {
                console.error(response.data.errors);
                $rootScope.notify('Error: ' + response.data.errors);
              } else {
                createCancelationFeeExtra(value).then(function () {
                  $rootScope.$broadcast('booking:reload', $scope.booking.id);
                });
              }
            })
            .catch(function (error) {
              console.error(error)
              $rootScope.notify('Error: ' + error.data.errors);
            })
            .finally(function() {
              ctrl.bulkStatusUpdating = false;
              $rootScope.isDisabledPusherEvents = false;
              $scope.$parent.batchSpinnerActive = false;
              clearSelectedRooms();
            });
        }
      });
    }
  };

  $scope._batchUpdateOnline = function (data) {
    var url = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' + $scope.$parent.booking.id + '/batch_update_booking_rooms'
    return $http.post(url, data)
  }

  function loadExtra(params) {
    var extrasFactory = new ExtrasFactory();

    return new Promise(function (resolve, reject) {
      try {
        extrasFactory.getExtras($rootScope.hotel.id, params)
          .then(function (data) {
            if (data && data.data && data.data.extras && data.data.extras.length > 0) {
              resolve(data.data.extras[0]);
            } else {
              resolve(null);
            }
          });
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  function createCancelationFeeExtra(value) {
    return new Promise(function (resolve, reject) {
      if (value == 0) {
        return resolve();
      }

      if (value > 0) {
        loadExtra({ term: 'Cancelation Fee' })
          .then(function (extra) {
            if (!extra) {
              return resolve();
            }

            var model = new BookingExtraFactory({
              extra_id: extra.id,
              booking_id: $scope.booking.id,
              hotel_id: $rootScope.hotel.id,
              count: 1,
              price: parseInt(value),
              total: parseInt(value),
              vat: 0
            });

            model.save()
              .then(function () {
                resolve();
              })
              .catch(function (err) {
                console.error(err);
                reject(err);
              });
          })
          .catch(function (err) {
            console.error(err);
            reject(err);
          });
      } else {
        reject(new Error("Something went wrong."));
      }
    });
  }  


  function changeSelectedPrice(ids) {
    var selected = getSelected(ids);
    var is_foreign = $scope.$parent.booking.isForeignAmount();
    var min_checkin =
      selected
        .map(function(a){ return moment(a.checkinDate) })
        .reduce(function(a,b) { return a<b?a:b })
        .hour(0).minute(0).second(0);
    var max_checkout =
      selected
        .map(function(a){ return moment(a.checkoutDate) })
        .reduce(function(a,b) { return a>b?a:b })
        .hour(0).minute(0).second(0);

    var nights = [];
    for(var i = min_checkin; i < max_checkout; i = i.add(1, 'day')) {
      var room_with_this_night = selected.find(function(a){
        return a.nights.find(function(n){return moment(n.date).isSame(i)})!=null;
      });
      var night_price = room_with_this_night?room_with_this_night.nights.find(function(n){return moment(n.date).isSame(i)}):{price:0};
      nights.push({date: i.clone().format('YYYY-MM-DD'), price: night_price.price})
    }

    if (is_foreign) {
      nights.map(function(night){
        night.foreignAmount = night.price/$scope.$parent.booking.foreignCurrencyRate
      })
    }

    var rooms_per_night = {};
    selected.map(function(room) {
      room.nights.map(function(night){
        rooms_per_night[night.date] = rooms_per_night[night.date]? rooms_per_night[night.date]+1: 1;
      })
    });

    var total_price = nights.reduce(function(total, night){
          return total + (rooms_per_night[night.date] || 0) * night.price;
      }, 0);

    var total_foreign = is_foreign ?
        nights.reduce(function(total, night){
          return total + (rooms_per_night[night.date] || 0) * night.price;
        }, 0) : 0;

    var selected_policy = 0;
    for(var i = 1; i < selected.length; i++ ) {
      selected_policy = selected[i].cancellationPolicyId == selected[0].cancellationPolicyId? selected[0].cancellationPolicyId: -1;
      if(selected_policy<0) break;
    }

    function getRates() {
      var category_ids =
        $rootScope.hotel.roomRates.filter(function(r) {
          return !r.isRemoved && r.roomRepresentationId == selected[0].roomRepresentationId;
        }).map(function(r) { return r.rateCategoryId; });
      var applicable_categories =
        selected[0].applicableRoomRates?
         _.uniq(selected[0].applicableRoomRates.map(function(r) {return r.rateCategoryId;})):[];

      rates = $rootScope.hotel.rateCategories.filter(function(r) {return category_ids.indexOf(r.id) > -1;});
      rates.forEach(function(r) {r['applicable'] = applicable_categories.indexOf(r.id) > -1;});
      return _.sortBy(rates, function(r){ return r.applicable; });
    };

    var rates = getRates();
    var selected_rate = 0;
    for(var i = 1; i < selected.length; i++) {
      selected_rate = selected[i].rateCategoryId == selected[0].rateCategoryId? selected[0].rateCategoryId: -1;
      if(selected_rate<0) break;
    }
    selected_rate = (selected_rate >= 0)? rates.filter(function(r){ return r.id == selected_rate;})[0]: null;

    var values = {
      selected: selected,
      nights: nights,
      total_price: total_price,
      total_foreign_amount: total_foreign,
      per_night: rooms_per_night,
      currency_symbol: is_foreign ? $scope.$parent.booking.getActiveCurrency() : $rootScope.currencySymbol,
      is_foreign: is_foreign,
      rates: getRates(),
      policies: $rootScope.hotel.cancellationPolicies.filter(function(p) { return !p.isRemoved; }),
      selected_policy: selected_policy,
      selected_rate: selected_rate,
    };

    UIDialogService.open('change-price-modal', {
      values: values,
      title: $i18next.t('bookings.rooms.cancel_room_confirm.cancel_room_title'),
      text: $i18next.t('bookings.rooms.cancel_room_confirm.text'),
      callback: function (values) {
        $rootScope.isDisabledPusherEvents = true;
        $scope.$parent.batchSpinnerActive = true;
        return new Promise(function(resolve, reject){
          values.selected.map(function(room){
            if(values.selected_policy>=0)
              room.cancellationPolicyId = values.selected_policy
            if(values.selected_rate)
              room.rateCategoryId = values.selected_rate.id
            room.nights = room.nights.map(function(night){
              return values.nights.filter(function(n){
                if(n.date == night.date) return night;
              })[0];
            });
          });

          var data = {
              booking_room_ids: ids,
              booking_room: {
                price_by_night: values.nights.map(function(night){
                  return (values.is_foreign)?
                    {
                        date: night.date,
                        price: night.foreignAmount * $scope.$parent.booking.foreignCurrencyRate,
                        foreign_amount: night.foreignAmount
                    }:
                    {
                      date: night.date,
                      price: night.price
                    };
                }),
                updated_at: new Date().getTime(),
                is_modification: false
              }
          }

          if(values.selected_policy>=0) data.booking_room.cancellation_policy_id = values.selected_policy
          if(values.selected_rate) data.booking_room.rate_category_id = values.selected_rate.id
          $scope._batchUpdateOnline(data)
            .then(function () {
              clearSelectedRooms();
            })
            .catch(function (error) {
              $rootScope.notify('Error: ' + error.data.errors);
            })
            .finally(function () {
              $rootScope.isDisabledPusherEvents = false;
              resolve();
            });
        });
      },
      updateRate: function() {
        var dates = nights.map(function(n){return n.date;});
        var _unique = function(value, index, self) { return self.indexOf(value)===index; };
        var representationIds = values.selected.map(function(r){ return r.roomRepresentationId; }).filter(_unique);
        var roomRates =
          $rootScope.hotel
            .roomRates
              .filter(function (roomRate) {
                  var h = !roomRate.isRemoved;
                  h &= roomRate.rateCategoryId == values.selected_rate.id
                  h &= representationIds.indexOf(roomRate.roomRepresentationId) >= 0;
                  return Boolean(h);
                });

          var roomRate = roomRates.reverse()[0];
          var p = RateByDateStorage.getPriceByDatePromise(dates, roomRate.id)
          p.then(function(result) {
            result.map(function(n){
              for(var i = 0; i < values.nights.length; i++)
                if(values.nights[i].date == n.date){
                  values.nights[i].price = n.price;
                  break;
                }
            })

            if (values.is_foreign) {
              values.nights.map(function(night){
                night.foreignAmount = night.price/$scope.$parent.booking.foreignCurrencyRate
              })
            }

            values.total_price = values.nights.length>1?
              nights.reduce(function(a, b){
                if(typeof(a)==='number')
                  return a + rooms_per_night[b.date] * b.price;
                return rooms_per_night[a.date] * a.price + rooms_per_night[b.date] * b.price;
              }):
              rooms_per_night[values.nights[0].date] * values.nights[0].price;

            values.total_foreign_amount = values.is_foreign ?
              values.nights.length>1?
                values.nights.reduce(function(a, b){
                  if(typeof(a)==='number')
                    return a + rooms_per_night[b.date] * b.foreignAmount;
                  return rooms_per_night[a.date] * a.foreignAmount + rooms_per_night[b.date] * b.foreignAmount;
                }):
                rooms_per_night[values.nights[0].date] * values.nights[0].foreignAmount:
              0;
          });
      }
    });
  }

  function changeSelectedOccupancy(ids) {
    var selected = getSelected(ids),
        first = selected[0];

    var max = $rootScope.hotel.roomRates.filter(
        function(r) {
            return !r.isRemoved && r.roomRepresentationId == first.roomRepresentationId;
        }
    )
    .map(function(r) { return {'adults': r.maxAdults, 'children':r.maxChildren}})[0];

    var adults_range = [];
    var child_range = [];
    for(var i = 1; i<max['adults']+1; i++) adults_range.push(i);
    for(var i = 0; i<max['children']+1; i++) child_range.push(i);
    UIDialogService.open('change-occupancy-modal', {
      selected: angular.copy(selected),
      title: $i18next.t('bookings.rooms.cancel_room_confirm.cancel_room_title'),
      text: $i18next.t('bookings.rooms.cancel_room_confirm.text'),
      values: {
        max: max,
        adults_range: adults_range,
        child_range: child_range,
        selected_adults: first.numberOfAdults,
        selected_children: first.numberOfChildren
      },
      callback: function (values) {
        $rootScope.isDisabledPusherEvents = true;
        $scope.$parent.batchSpinnerActive = true;
        return new Promise(function(resolve, reject){
          selected.map(function(room){
            room.numberOfAdults = values.selected_adults
            room.numberOfChildren = values.selected_children
          })
          $scope._batchUpdateOnline({
            booking_room_ids: ids,
            booking_room: {
              number_of_adults: values.selected_adults,
              number_of_children: values.selected_children,
              updated_at: new Date().getTime(),
              is_modification: false
            }
          })
            .then(function (response) {
              clearSelectedRooms();
            })
            .catch(function (error) {
              $rootScope.notify('Error: ' + error.data.errors);
            })
            .finally(function () {
              $rootScope.isDisabledPusherEvents = false;
              resolve();
            });
        });
      }
    });
  }

  function changeSelectedDate(ids) {
    var selected = getSelected(ids);
    var nights_range = [], times_range = [];
    for(var i = 1; i <= 31; i++) nights_range.push(i)
    for(var h = 0; h < 48; h++) {
     var t = String((h%2)?h/2-0.5:h/2).padStart(2,'0') +':'+ ((h%2)?'30':'00');
     times_range.push(t);
    }
    var max_nights =
      selected
        .map(function(a){ return a.numberOfNights })
        .reduce(function(a,b) { return a>b?a:b })
    var min_checkin =
      selected
        .map(function(a){ return moment(a.checkinDate).toDate()  })
        .reduce(function(a,b) { return a<b?a:b })

      var values = {
        selected: selected,
        checkinTime: selected[0].checkinTime?moment(selected[0].checkinTime).utc().format('HH:mm'):'14:00',
        checkinDate: min_checkin,
        numberOfNights: max_nights,
        nights_select: nights_range,
        times: times_range,
        confirming: false
      }

    UIDialogService.open('change-date-modal', {
      values: values,
      title: $i18next.t('bookings.rooms.cancel_room_confirm.cancel_room_title'),
      text: $i18next.t('bookings.rooms.cancel_room_confirm.text'),
      checkout_date: function() {
        var tz_offset = new Date().getTimezoneOffset()/60 * -1;
        var checkin_moment = moment(values.checkinDate).startOf('day').add(tz_offset, 'hour');
        var checkout_moment = checkin_moment.clone().add(values.numberOfNights, 'day');
        return checkout_moment.toDate()
      },
      check_and_confirm: function() {
        values.selected.map(function(room){
          var available = AvailabilityChecker.checkAvailability(
            room.roomId,
            values.checkinDate,
            values.numberOfNights,
            room.id
          );
          room._canmove = available.closed.indexOf(room.roomId)<0;
        })
        return values.confirm_step = true;
      },
      reduced_number_of_nights: function() {
        return selected.find(function(booking_room) {
          return values.numberOfNights < booking_room.nights.length
        });
      },
      setRecalcStep: function() {
        values.recalc_confirm_step = true
      },
      can_move_all: function() {
        return values.selected
                      .map(function(r){return r._canmove?r._canmove:false})
                      .reduce(function(a,b){return a && b;})
      },
      callback: function (values) {
        $rootScope.isDisabledPusherEvents = true;
        $scope.$parent.batchSpinnerActive = true;

        return new Promise(function (resolve_callback, reject_callback) {
          var tz_offset = new Date().getTimezoneOffset() / 60 * -1;
          var checkin_moment = moment(values.checkinDate).startOf('day').add(tz_offset, 'hour');
          var checkout_moment = checkin_moment.clone().add(values.numberOfNights, 'day');
          $scope._batchUpdateOnline({
            booking_room_ids: selected.map(function (room) { return room.id }),
            booking_room: {
              checkin_date: checkin_moment.toDate(),
              checkout_date: checkout_moment.toDate(),
              number_of_nights: values.numberOfNights,
              updated_at: new Date().getTime(),
              is_modification: false
            }
          })
            .then(function () {
              clearSelectedRooms();
            }).catch(function (error) {
              $rootScope.notify('Error: ' + error.data.errors);
            }).finally(function () {
              $rootScope.isDisabledPusherEvents = false;
              resolve_callback();
            })
        });
      }
    });
  }

  $scope.closeRoomEditDrawer = function () {
    ctrl.bookingRoomsRef.current.handleCloseBookingRoomDrawer();
  }

  function showRoomKeys(bookingRoom, keyLockId) {
    return $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/key_locks/' + keyLockId + '/get_booking_room_key_codes?booking_room_id=' + bookingRoom.id)
      .then(function(response) {
        ctrl.roomKeys[bookingRoom.id] = response.data.key_lock_codes;
        return response;
      }, function(error) {
          console.error(error);
          return error;
      });
  };

  function restoreRoom(selectedRoom) {
    $rootScope.isDisabledPusherEvents = true;
    var room = ctrl.bookingRooms.find(function(r) {
      return r.id === selectedRoom.id
    });
    var index = ctrl.bookingRooms.indexOf(room);
    availability = AvailabilityChecker.checkAvailability(
      room.roomId,
      room.checkinDate,
      room.numberOfNights,
      room.id
    );

    if (availability.available === false) {
      UIDialogService.open('alert', {
        title: $i18next.t('general.titles.error'),
        text: $i18next.t('bookings.rooms.alert.the_original_room_is_not_available_please_choose_another_room_js_str')
      });
      $scope.booking.rooms[index].restoreAfterSave = true;
      ctrl.bookingRooms[index].restoreAfterSave = true;
      ctrl.bookingRooms[index].edited = true;
      ctrl.bookingRoomsRef.current.onEdit(ctrl.bookingRooms[index]);
    } else {
      var room = BookingStorage.get_room(room.id);
      room.restore()
      .then(function (response) {})
      .finally(function() {
        $rootScope.isDisabledPusherEvents = false;

        $rootScope.$broadcast('restore_room', room.id);
        $rootScope.$broadcast('scheduler:updateCanceled');
      });
    }
  };

  function cancelRoom(selectedRoom) {
    if ($scope.booking.token.indexOf('-C') > -1) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.rooms.cancel_room_confirm.cancel_room_title'),
        text: $i18next.t('bookings.rooms.cancel_room_confirm.text'),
        positive_callback: function () {
          $rootScope.isDisabledPusherEvents = true;
          var room = BookingStorage.get_room(selectedRoom.id);

          room.cancel()
            .then(function () {
              $rootScope.isDisabledPusherEvents = false;
            })
            .catch(function (error) {
              if (error && error.data && error.data.errors) {
                if (Array.isArray(error.data.errors)) {
                  error.data.errors.map(function (error) {
                    $rootScope.notify(error);
                  });
                } else if (typeof error.data.errors === 'string') {
                  $rootScope.notify(error.data.errors);
                }
              }
              $rootScope.isDisabledPusherEvents = false;
            });
        }
      });
    } else {
      var room = selectedRoom;
      var nightsCost = getBookingRoomNightsCost(room);
      var fee = getCancellationFeeForBookingRoom(room, nightsCost);
      UIDialogService.open('cancellation-modal', {
        fee: fee,
        max_fee: 100000000,
        min_fee: 0,
        email: $scope.booking.customer.email,
        sendNotification: false,
        callback: function (value, email) {
          $rootScope.isDisabledPusherEvents = true;
          var room;

          UIDialogService.close('cancellation-modal');

          room = BookingStorage.get_room(selectedRoom.id);
          room.cancel(email)
            .then(function () {
              createCancelationFeeExtra(value)
                .finally(function () {
                  $rootScope.isDisabledPusherEvents = false;
                });
            })
            .catch(function (error) {
              if (error && error.data && error.data.errors) {
                if (Array.isArray(error.data.errors)) {
                  error.data.errors.map(function (error) {
                    $rootScope.notify(error);
                  });
                } else if (typeof error.data.errors === 'string') {
                  $rootScope.notify(error.data.errors);
                }
              }

              $rootScope.isDisabledPusherEvents = false;
            });
        }
      });
    }
  };

  function onLoadAvailableMergeBookings(params) {
    var bookingMerge = new BookingMergeFactory();

    return bookingMerge.getAvailableBookings($rootScope.hotel.id, params.id, params);
  }

  function markRoomAsCanceled(selectedRoom) {
    UIDialogService.open('confirmation', {
      title: $i18next.t('bookings.rooms.mark_room_as_canceled_confirm.mark_as_cancelled_title'),
      text: $i18next.t('bookings.rooms.mark_room_as_canceled_confirm.text'),
      positive_callback: function () {
        var room = BookingStorage.get_room(selectedRoom.id);
        room.markAsCanceled();
      }
    });
  };

  function convertCurrency(amount) {
    return customCurrencyExtended(amount, $scope.booking, $scope.booking.isForeignAmount(), $filter, $rootScope);
  };

  function generateNewRoom(newRoom) {
    if ($scope.booking && $scope.booking.rooms) {
      newRoom.checkinDate = $scope.booking.rooms[0].checkinDate;
      newRoom.checkoutDate = moment($scope.booking.rooms[0].checkinDate).add(1, 'day').toDate();
      newRoom.rateCategoryId = $scope.booking.rooms[0].rateCategoryId;
      newRoom.roomTypeId = $scope.booking.rooms[0].roomTypeId;
      newRoom.isForeignAmount = $scope.booking.isForeignAmount();
      newRoom.edited = true;
    }
    return newRoom;
  };

  function checkin(selectedRoom) {
    $rootScope.isDisabledPusherEvents = true;
    var room = BookingStorage.get_room(selectedRoom.id);
    room.checkin().finally(function () {
      $rootScope.isDisabledPusherEvents = false;
    });
  };

  function checkout(selectedRoom) {
    $rootScope.isDisabledPusherEvents = true;
    var room = BookingStorage.get_room(selectedRoom.id);

    room.checkout().finally(function () {
      $rootScope.isDisabledPusherEvents = false;
    });
  };

  $scope.getRoom = function (roomId) {
    return $rootScope.hotel.rooms.filter(function (room) {return room.id == roomId;})[0];
  };

  function splitRoom(selectedRoom,index) {
    var index = ctrl.bookingRooms.indexOf(selectedRoom);
    if ($scope.booking.payments.length > 0) {
      $rootScope.alert($i18next.t('bookings.rooms.split_room_alert.text'), $i18next.t('bookings.rooms.split_room_alert.title'));
    } else {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.rooms.split_room_confirm.title'),
        text: $i18next.t('bookings.rooms.split_room_confirm.text'),
        positive_callback: function () {
          $rootScope.isDisabledPusherEvents = true;
          new BookingRoomFactory(selectedRoom)
            .split_room()
            .then(function (data) {
              if (data.status != 'Success') {
                UIDialogService.open('alert', {
                  title: $i18next.t('general.titles.error'),
                  text: data.msg
                });
              }
            })
            .catch(function (error) {
              console.error(error);
            })
            .finally(function () {
              $rootScope.isDisabledPusherEvents = false;
            });
        }
      });
    }
  };

  function changeRoom(selectedRoom) {
    var room = selectedRoom;
    var today = new Date(moment(new Date()).utc().format('YYYY-MM-DD'));
    var changeDate = today > room.checkinDate && today <= room.checkoutDate ? today : moment(room.checkinDate).utc().add(1, 'day').toDate();
    if (room.checkinDate && !room.checkinDate.getMonth) {
      room.checkinDate = new Date(room.checkinDate);
    }
    UIDialogService.open('change-room-modal', {
      max_date: moment(room.checkoutDate).subtract(1, 'day').toDate(),
      min_date: moment(room.checkinDate).add(1, 'day').toDate(),
      date: changeDate,
      room: room,
      callback: function (changeDate, targetRoom, note) {
        UIDialogService.close('change-room-modal');
        $scope.booking.hotelId = $rootScope.hotel.id;

        $rootScope.isDisabledPusherEvents = true;

        $scope.booking.split_room(room, targetRoom, changeDate, note)
          .then(function(data){
            booking = BookingStorage.get(data.id);
            booking.rooms = data.rooms;

            $rootScope.notify($i18next.t('booking.rooms.split_completed'))
          })
          .catch(function(data) {
            var msg = data.data.msg;

            if(msg) {
              $rootScope.notify(msg);
            }
            else {
              $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
            }
          })
          .finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
        $rootScope.notify($i18next.t('booking.rooms.split_in_progress'))
      }
    });
  }


  $scope.rates = $rootScope.hotel.rateCategories;

  ctrl.newRoom = {
    active             : true,
    available          : true,
    opened             : false,
    total_price        : 0,
    maxDates           : 30,

    checkinDate        : new Date(),
    checkoutDate       : moment(new Date()).add(1, 'day').toDate(),
    checkinTime        : null,

    numberOfNights     : 1,
    numberOfAdults     : 1,
    numberOfChildren   : 0,

    roomType           : null,
    roomId             : null,
    rateCategoryId     : $scope.rates[0].id,
    rate               : $scope.rates[0],
    hotel_id           : $rootScope.hotel.id,
    booking_id         : $scope.booking_id,
    occupationStatus   : 'pending',

    dontMove           : false,
    note               : null,

    nights             : [],

    guest : {
      title        : null,
      first_name   : null,
      last_name    : null,
      email        : null,
      phone        : null,
      hotel_id     : $rootScope.hotel.id
    }
  };

  $scope.cleanRoom = angular.copy(ctrl.newRoom);

  function printRoomsInfo() {
    UIDialogService.open('print-rooms', {
      callback: function (rates, prices, roomTypes) {
        var params = [];
        if (rates) { params.push("with_rates=true") }
        if (prices) { params.push("with_prices=true") }
        if (roomTypes) { params.push("with_room_types=true") }

        fetch(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' + $scope.$parent.booking.id + '/print_guests?' + params.join('&'),
          { headers: { 'Authorization': $http.defaults.headers.common['AUTHORIZATION'] } })
          .then(function (response) { return response.blob(); })
          .then(function (blob) {
            if (blob) {
              var pdfUrl = URL.createObjectURL(blob);

              printJS({
                printable: pdfUrl,
                type: 'pdf',
                showModal: true
              });
            }
          })
          .catch(function (error) {
            console.error('Error fetching PDF:', error);
          });
      }
    });
  }

  function getBookingRoomNightsCost(room) {
    return room.nights.map(function(night) { return night.price; }).reduce(function(a, b) {return a + b}, 0);
  }

  function getCancellationFeeForBookingRoom(room, price) {
    var cancellationPolicy = $rootScope.hotel.cancellationPolicies.filter(function(policy) {
      return policy.id == room.cancellationPolicyId
    })[0];

    var ways = {
      'Free cancellation at any time': function(price) {
        return 0;
      },
      'Free cancellation up N day(s) before arrival': function(price) {
        var date = moment(room.checkinDate),
          mode = cancellationPolicy.cancellationMode.toLowerCase();

        if (date.diff(moment(), mode) < cancellationPolicy.cancellationDays) {
          return price;
        } else {
          return 0;
        }
      },
      'Cancellation Custom Policy': function(price) {
        return price;
      },
      'No cancellation or modification can be applied to this booking': function(price) {
        return price;
      },
      'Flexible Cancellation Fee based at cancellation period': function(price) {
        var days = moment(room.checkinDate).diff(new Date(moment(Date.today).format('YYYY-MM-DD')), 'days');
        var periods = cancellationPolicy && cancellationPolicy.cancellationPeriods ? cancellationPolicy.cancellationPeriods.filter(function(period) {
          return period.days <= days;
        }) : [];

        if (periods.length > 0) {
          return price * (periods[0].percent / 100);
        } else {
          return price;
        }
        return price;
      }
    }

    if (cancellationPolicy) {
      return ways[cancellationPolicy.cancellation](price);
    } else {
      return price;
    }
  }

  function getNonCanceledRooms(rooms) {
    return rooms.filter(function(e){ return e.status != 'canceled'; });
  }
  function getCanceledRooms(rooms) {
    return rooms.filter(function(e){ return e.status == 'canceled'; });
  }

  var reloadListener = $rootScope.$on('booking_management:reload', function(event, booking) {
    $scope.booking.rooms = booking.rooms;
  });

  $scope.$watch('booking.rooms', function(val) {
    var allRooms = JSON.parse(JSON.stringify(sorted(val)));
    var newRooms = allRooms;
    switch(ctrl.bookingRoomsStatus) {
      case ROOM_STATUSES.ALL:
        newRooms = allRooms;
        break;
      case ROOM_STATUSES.ACTIVE:
        newRooms = getNonCanceledRooms(allRooms);
        break;
      case ROOM_STATUSES.CANCELED:
        newRooms = getCanceledRooms(allRooms);
        break;
    }
    angular.extend(
      ctrl,
      {
        bookingRooms : newRooms
      }
    );

    if(ctrl.bulkStatusUpdating) {
      clearSelectedRooms();
      ctrl.bulkStatusUpdating = false;
      $rootScope.isDisabledPusherEvents = false;
    }
  }, true);

  $scope.$on('$destroy', function() {
    if (reloadListener) {
      reloadListener();
    }
    if (ctrl.bookingRoomsRef) {
      ctrl.bookingRoomsRef = null
    }
    ctrl = null;
  });
}

angular
  .module('buuqit')
  .directive('bookingPayments', bookingPayments)
  .controller('BookingPaymentsController', BookingPaymentsController)
  .component(
    'reactBookingPaymentTransactions',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingPaymentTransactions,
      [
        'bookingPayments',
        'bookingRooms',
        'paymentTypes',
        'cardTypes',
        'bookingDue',
        'bookingTotalPaid',
        'foreignCurrencyRate',
        'timezone',
        'rootTimezone',
        'wirecardName',
        'foreignCurrency',
        'currencySymbol',
        'payerName',
        'allowChangePaymentFeature',
        'depositFeatureEnabled',
        'paymentRequestIsVisible',
        'hitIsVisible',
        'paymentTerminalEnabled',
        'online',
        'actionLoading',
        'isForeignAmount',
        'customCurrency',
        'onSavePaymentForm',
        'onSaveTerminalPaymentForm',
        'fetchPaymentTerminals',
        'refundManualPayment',
        'refundPaymentTerminal',
        'convertDepositToPayment',
        'refundPayment',
        'voidPayment',
        'submitPayment',
        'requestPayment',
        'hitPayment',
        'onLoadFolios'
      ],
      ['$i18next']
    )
  );


bookingPayments.$inject = ["$rootScope"];

function bookingPayments () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingPayments.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

BookingPaymentsController.$inject = [
  "$scope",
  "$i18next",
  "$rootScope",
  "PaymentFactory",
  "TerminalsFactory",
  "FolioFactory",
  "UIDialogService",
  "$filter",
  "$interval",
];

function BookingPaymentsController($scope, $i18next, $rootScope, PaymentFactory, TerminalsFactory, FolioFactory, UIDialogService, $filter, $interval) {
  var ctrl = this;

  // payableProvider stripe depends on feature flag of stripe integration and means either "stripe" either "stripe_sca"
  var payableProviders = ["stripe", "stripe_sca", "braintree", "payment_express", "valitor", 'wirecard', 'borgun', 'valitor_pay'];
  var activeSystemPaymentTypes = $rootScope.hotel.systemPaymentTypes.filter(function(type) {return type.isActive == true});
  var terminalTransactionStatusMaxRetries = 12;
  var terminalTransactionStatusRetryInterval = 5000; // 5 seconds
  var terminalTransactionRetryCount = 0;
  var terminalTransactionInterval;

  function init() {
    ctrl.bookingPayments = $scope.booking.payments;
    ctrl.bookingRooms = $scope.booking.rooms;
    ctrl.paymentTypes = _.union(
      [
        ['Cash', $i18next.t('bookings.payment_form.payment_types.Cash')],
        ['Cheque', $i18next.t('bookings.payment_form.payment_types.Cheque')],
        ['Bank Transfer', $i18next.t('bookings.payment_form.payment_types.Bank Transfer')],
        ['Voucher', $i18next.t('bookings.payment_form.payment_types.Voucher')],
        ['Credit Card', $i18next.t('bookings.payment_form.payment_types.Credit Card')],
        ['Debit Card', $i18next.t('bookings.payment_form.payment_types.Debit Card')],
        ['Other', $i18next.t('bookings.payment_form.payment_types.Other')]
      ].filter(function (type) { return (typeof (activeSystemPaymentTypes.find(function (type2) { return type2.name == type[0] })) != 'undefined') }),
      $rootScope.hotel.customPaymentTypes.map(function (type) { return [type.name, type.name]; })
    );
    ctrl.cardTypes = [
      "VISA",
      "Master Card",
      "American Express",
      "Discover",
      "JCB",
      "Union Pay",
      "Other"
    ];
    ctrl.folios = [];


    ctrl.bookingDue = $scope.booking.due;
    ctrl.bookingTotalPaid = $scope.booking.totalPaid;
    ctrl.foreignCurrencyRate = $scope.booking.foreignCurrencyRate;
    ctrl.timezone = $scope.hotel.timezone;
    ctrl.rootTimezone = $rootScope.hotel.timezone;
    ctrl.wirecardName = $rootScope.domain_settings.wirecardName;
    ctrl.foreignCurrency = $scope.booking.foreignCurrency;
    ctrl.currencySymbol = $scope.booking.isForeignAmount() ? $scope.booking.getActiveCurrency() : $rootScope.currencySymbol;
    ctrl.payerName = [$scope.booking.customer.firstName, $scope.booking.customer.lastName].join(' ');
    ctrl.allowChangePaymentFeature = $rootScope.hotel.allowChangePaymentFeature;
    ctrl.depositFeatureEnabled = $rootScope.hotel.depositFeatureEnabled;
    ctrl.paymentRequestIsVisible = $rootScope.hotel.paymentGateways.filter(function (el) { return payableProviders.indexOf(el) != -1 }).length > 0;
    ctrl.actionLoading = false;
    ctrl.hitIsVisible = $rootScope.hotel.paymentGateway == "payment_express" && $rootScope.hotel.paymentGatewaySettings && $rootScope.hotel.paymentGatewaySettings.development === true;
    ctrl.online = $rootScope.networkStatus;
    ctrl.isForeignAmount = $scope.booking.isForeignAmount();
    ctrl.paymentTerminalEnabled = $rootScope.hotel.paymentTerminalEnabled;
  }
  init();

  angular.extend(
    this,
    {
      refundManualPayment: refundManualPayment,
      convertDepositToPayment: convertDepositToPayment,
      refundPayment: refundPayment,
      refundPaymentTerminal: refundPaymentTerminal,
      voidPayment: voidPayment,
      submitPayment: submitPayment,
      requestPayment: requestPayment,
      hitPayment: hitPayment,
      onSavePaymentForm: savePaymentForm,
      onSaveTerminalPaymentForm: chargeTerminal,
      fetchPaymentTerminals: fetchPaymentTerminals,
      customCurrency: customCurrency,
      onLoadFolios: onLoadFolios
    }
  );

  function customCurrency (amount, fractionSize, currencyCode) {
    var currency = $filter('currency');
    var mathcingCurrencySymbol = null;
    if (currencyCode !== undefined) {
      var symbol = currencies.filter(function (el) {
        return el[0] == currencyCode;
      })[0];
      if (symbol) {
        mathcingCurrencySymbol = symbol[2];
      }
    }

    var currencySymbol = mathcingCurrencySymbol || $rootScope.currencySymbol;

    if (typeof(fractionSize) === 'undefined') {
      fractionSize = $rootScope.currencyFractionSize;
    }

    if (amount !== undefined) {
      if (String(amount).charAt(0) === "-") {
        return currency(amount, currencySymbol, fractionSize).replace("(", "- ").replace(")", "");
      }
    }

    return currency(amount, currencySymbol, fractionSize);
  };

  function refundManualPayment (payment) {
    var original_payment = payment;
    var max_refund = (original_payment.isForeignAmount ? (original_payment.amount - original_payment.refunded)/$scope.booking.foreignCurrencyRate : (original_payment.amount - original_payment.refunded));

    UIDialogService.open('money-prompt', {
      title: $i18next.t('bookings.payment.money_prompt.refund_title'),
      placeholder: $i18next.t('bookings.payment.money_prompt.please_enter_amount_to_refund_placeholder'),
      value: max_refund,
      max_value: angular.copy(max_refund),
      min_value: 0,
      callback: function (value) {
        if (value > max_refund) {
          UIDialogService.close('money-prompt');
          UIDialogService.open('alert', {
            title: $i18next.t('general.titles.error'),
            text: $i18next.t('bookings.payment.alert.you_can_not_refund_summ_greater_charged_summ_js_str')
          });
        } else {
          $rootScope.isDisabledPusherEvents = true;
          UIDialogService.close('money-prompt');
          ctrl.actionLoading = true;
          original_payment
            .refund(value)
            .then(
              function(response) {
                ctrl.actionLoading = false;
                if (response.status == false) {
                  $rootScope.notify(response.msg);
                } else {
                  original_payment.refunded = original_payment.refunded + value;
                  if (response.originalPayment) {
                    angular.copy(response.originalPayment, original_payment);
                  }
                  $scope.booking.payments.push(new PaymentFactory(response));
                }
              })
            .catch(function (error) {
              console.error('Error refunding payment:', error);
              ctrl.actionLoading = false;
              if (error.status === 400) {
                $rootScope.notify(error.data.error, 'error');
              }
              return;
            })
            .finally(function () {
              $rootScope.isDisabledPusherEvents = false;
            });
        }
      }
    });
  }

  function refundPayment(payment) {
    var max_refund = (payment.isForeignAmount ? (payment.amount - payment.refunded)/$scope.booking.foreignCurrencyRate : (payment.amount - payment.refunded));

    UIDialogService.open('money-prompt', {
      title: $i18next.t('bookings.payment.money_prompt.refund_title'),
      placeholder: $i18next.t('bookings.payment.money_prompt.please_enter_amount_to_refund_placeholder'),
      value: max_refund,
      max_value: max_refund,
      min_value: 0,
      callback: function (value) {
        UIDialogService.close('money-prompt');
        payment.hotel_id = $rootScope.hotel.id;
        payment.booking_id = $scope.booking.id;
        ctrl.actionLoading = true;

        $rootScope.isDisabledPusherEvents = true;
        new PaymentFactory(payment)
          .refund(value)
          .then(function (data) {
            ctrl.actionLoading = false;
            if (data.status == false) {
              $rootScope.notify(data.msg);
            } else {
              ctrl.actionLoading = false;
              if (payment.amount - payment.refunded + data.amount == 0) {
                payment.status = 'refunded';
              }
              payment.refunded = payment.refunded + (data.amount * -1);
              $scope.booking.payments.push(data);
            }
          })
          .catch(function(error) {
            console.error('Error refunding payment:', error);
            ctrl.actionLoading = false;
            if (error.status === 400) {
              $rootScope.notify(error.data.error, 'error');
            }
            return;
          })
          .finally(function() {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });
  }

  function convertDepositToPayment(payment) {
    var original_payment = payment;
    if (original_payment.operation != 'deposit') {
      return;
    };

    $rootScope.isDisabledPusherEvents = true;
    ctrl.actionLoading = true;
    original_payment
      .convertToPayment()
      .then(function(response) {
        ctrl.actionLoading = false;
        angular.copy(response.originalPayment, original_payment);
        if (response.refundPayment) {
          $scope.booking.payments.push(new PaymentFactory(response.refundPayment));
        }
        if (response.chargePayment) {
          $scope.booking.payments.push(new PaymentFactory(response.chargePayment));
        }
      })
      .catch(function (error) {
        console.error('Error converting deposit to payment:', error);
        throw error;
      })
      .finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      });
  }

  function voidPayment(payment) {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        ctrl.actionLoading = true;
        payment.hotel_id = $rootScope.hotel.id;
        payment.booking_id = $scope.booking.id;
        $rootScope.isDisabledPusherEvents = true;

        new PaymentFactory(payment)
          .refund(parseFloat(payment.amount))
          .then(function(data) {
            ctrl.actionLoading = false;
            if (payment.status == 'authorized') {
              var index = $scope.booking.payments.indexOf(payment),
                card = $scope.booking.customer.cards.filter(function (card) { return card.id == payment.card; })[0];
              card.authorized = false;
              $scope.booking.payments.splice(index, 1);
            } else {
              payment.status = 'canceled';
              ctrl.actionLoading = false;
              $scope.booking.payments.push(data);
            }
          })
          .catch(function (error) {
            console.error('Error voiding payment:', error);
            throw error;
          })
          .finally(function() {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });
  }

  function submitPayment(payment) {
    var max;

    if ($scope.booking.due < payment.amount) {
      max = angular.copy($scope.booking.due);
    } else {
      max = angular.copy(payment.amount);
    }

    UIDialogService.open('money-prompt', {
      title: $i18next.t('bookings.payment.money_prompt.submit_preauthorized_payment_title'),
      placeholder: $i18next.t('bookings.payment.money_prompt.please_enter_amount_to_submit_placeholder'),
      value: max,
      max_value: max,
      min_value: 0,
      callback: function (value) {
        UIDialogService.close('money-prompt');
        payment.hotel_id = $rootScope.hotel.id;
        payment.booking_id = $scope.booking.id;
        payment.amount = value;
        ctrl.actionLoading = true;
        $rootScope.isDisabledPusherEvents = true;

        new PaymentFactory(payment)
          .charge()
          .then(function(data) {
            var card;

            ctrl.actionLoading = false;

            card = $scope.booking.customer.cards.filter(function (card) { return card.id == payment.card; })[0];
            card.authorized = false;
          })
          .catch(function() {
            console.error('Error submitting payment:', error);
            UIDialogService.open('alert', {
              title: $i18next.t('general.titles.error'),
              text: $i18next.t('bookings.payment.alert.something_went_wrong_try_again_later_or_contact_with_administrator_js_str')
            });
            ctrl.actionLoading = false;
          })
          .finally(function() {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });
  }

  function requestPayment() {
    var originalDue = angular.copy($scope.booking.due);
    var value = $rootScope.currencyFractionSize > 0 ? Math.floor(originalDue * 100) / 100 : Number(Number(originalDue).toFixed(2));

    onLoadAllFolios().then(function (data) {
      var folios = data;

      UIDialogService.open('request-payment', {
        title: $i18next.t('bookings.payment.request_payment_title_js_str'),
        value: value,
        folios: folios,
        folio: folios[0],
        booking: $scope.booking,
        providers: $rootScope.hotel.paymentGateways.filter(function(el) {return payableProviders.indexOf(el) != -1}),
        provider: payableProviders.indexOf($rootScope.hotel.paymentGateway) != -1 ? $rootScope.hotel.paymentGateway : $rootScope.hotel.paymentGateways.filter(function(el) {return payableProviders.indexOf(el) != -1})[0],
        max_value: angular.copy($scope.booking.due),
        min_value: 0,
        address: $scope.booking.customer.email,
        callback: function (response) {
          $scope.booking.hotelId = $rootScope.hotel.id;
          $scope.booking.sendPaymentRequest(response);
          UIDialogService.close('request-payment');
          $rootScope.notify($i18next.t('bookings.payment.notify.request_sent_successfully_js_str'));
        }
      });
    })
  }

  function hitPayment() {
    UIDialogService.open('hit-payment', {
      title: $i18next.t('bookings.payment.request_payment_title_js_str'),
      value: Number(Number(angular.copy($scope.booking.due)).toFixed(2)),
      providers: $rootScope.hotel.paymentGateways.filter(function (el) { return payableProviders.indexOf(el) != -1 }),
      provider: payableProviders.indexOf($rootScope.hotel.paymentGateway) != -1 ? $rootScope.hotel.paymentGateway : $rootScope.hotel.paymentGateways.filter(function (el) { return payableProviders.indexOf(el) != -1 })[0],
      max_value: angular.copy($scope.booking.due),
      min_value: 0,
      address: $scope.booking.customer.email,
      callback: function (response) {
        $scope.booking.hotelId = $rootScope.hotel.id;
        $scope.booking.sendPaymentRequest(response);
        UIDialogService.close('request-payment');
        $rootScope.notify($i18next.t('bookings.payment.notify.request_sent_successfully_js_str'));
      }
    }, true);
  }

  function convertPrepaymentToPayment (index) {
    var payment = $scope.booking.payments[index];
    payment.hotel_id = $rootScope.hotel.id;
    payment.booking_id = $scope.booking.id;
    ctrl.actionLoading = true;

    new PaymentFactory(payment)
      .convertPrepaymentToPayment(payment.amount - payment.refunded)
      .then(function(data) {
        angular.copy(data.originalPayment, payment);
        if (data.redeemPayment) {
          $scope.booking.payments.push(new PaymentFactory(data.redeemPayment));
        }
        if (data.chargePayment) {
          $scope.booking.payments.push(new PaymentFactory(data.chargePayment));
        }
      }).catch(function (error) {
        console.error('Error converting prepayment to payment:', error);
        throw error;
      }).finally(function () {
        ctrl.actionLoading = false;
      });
  }

  function _createBookingPayment (payment) {
    payment.booking_id = $scope.booking.id;
    payment.hotel_id = $rootScope.hotel.id;

    return new Promise(function (resolve) {
      payment = new PaymentFactory(payment);

      payment.save(function(payment, error) {
        var success = true;
        if (error) {
          success = payment.__sync === false;
          if (error.data.msg == 'Amount is greater then booking due') {
            success = false;
            UIDialogService.open('alert', {
              text: 'Amount is greater then booking due. Payment is not accepted.',
              title: $i18next.t('bookings.payment.alert.transaction_error_title')
            });
            BookingStorage.load_by_id(payment.bookingId, false, function(booking) {
              $rootScope.$broadcast('booking_management:reload', booking);
            });
          }
        }

        if (success) {
          $scope.booking.payments.push(payment);
          resolve(payment);
        }
      });
    });
  };

  _saveBookingPayment = function (payment) {
    var originalPayment = payment

    if (payment.type === 'Credit Card' || payment.type === 'Debit Card') {
      payment.description = 'Offline Card Payment, ' + payment.cardType + (payment.cardEnd ? ', Card ending at ' + payment.cardEnd : '');
    }

    return new Promise(function(resolve) {
      payment = new PaymentFactory(payment);

      payment.save(function(data) {
        angular.copy(data, originalPayment);
        originalPayment.saved = true;
        resolve(data);
      });
    });
  };

  function savePaymentForm(payment) {
    $rootScope.isDisabledPusherEvents = true;

    if (payment.id) {
      _saveBookingPayment(payment).finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      });
    } else {
      _createBookingPayment(payment).finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      });
    }
  };

  function chargeTerminal(data, callback, resolve, reject) {
    data.isForeignAmount = ctrl.isForeignAmount;
    data.bookingId = $scope.booking.id;
    var payload = { payment: data };
    $rootScope.isDisabledPusherEvents = true;

    clearTerminalChargeStatusDependencies();
    return TerminalsFactory.charge(_camelToSnake(payload)).then(function (response) {
      var response = _snakeToCamel(response.data);
      return checkTerminalTransactionStatus(response.correlationId, data.id, callback, resolve, reject)
    }).catch(function (error) {
      console.error('Error charging terminal:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      reject(error);
    }).finally(function () {
      $rootScope.isDisabledPusherEvents = false;
    });
  }

  function refundPaymentTerminal(data, callback, resolve, reject) {
    $rootScope.isDisabledPusherEvents = true;
    data.id = data.terminalId;
    var payload = { refund: data };
    clearTerminalChargeStatusDependencies();
    return TerminalsFactory.refund(_camelToSnake(payload)).then(function (response) {
      var response = _snakeToCamel(response.data);
      return checkTerminalTransactionStatus(response.correlationId, data.terminalId, callback, resolve, reject)
    }).catch(function (error) {
      console.error('Error refunding terminal payment:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      reject(error);
    }).finally(function () {
        $rootScope.isDisabledPusherEvents = false;
    });
  }

  function clearTerminalChargeStatusDependencies() {
    terminalTransactionRetryCount = 0;
    $interval.cancel(terminalTransactionInterval);
  }

  function fetchPaymentTerminals() {
    $rootScope.isDisabledPusherEvents = true;
    return TerminalsFactory.getTerminals().then(function (response) {
      return _snakeToCamel(response.data.payment_terminals);
    }).catch(function (error) {
      console.error('Error fetching payment terminals:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    }).finally(function () {
      $rootScope.isDisabledPusherEvents = false;
    });
  }
  function checkTerminalTransactionStatus(correlationId, id, callback, resolve, reject) {
    var data = {
      correlationId: correlationId,
      id: id
    }
    function handleStatusResponse(response) {
      var response = _snakeToCamel(response.data);
      var event = response && response.event;
      var message = response && response.message || $i18next.t('booking.payment.terminal.payment_received');
      if (!event || event === "SALE_RECEIVED") {
        // Continue the loop for SALE_RECEIVED event
        terminalTransactionRetryCount += 1;
        if (terminalTransactionRetryCount < terminalTransactionStatusMaxRetries) {
          terminalTransactionInterval && $interval.cancel(terminalTransactionInterval);
          terminalTransactionInterval = $interval(checkTerminalTransactionStatus, terminalTransactionStatusRetryInterval, 5, true, correlationId, id, callback, resolve, reject);
          if (terminalTransactionRetryCount === 1) {
            callback('SALE_RECEIVED', message);
          }
        } else {
          clearTerminalChargeStatusDependencies();
          return resolve(response);
        }
      } else {
        callback(event, message);
        clearTerminalChargeStatusDependencies();
        return resolve(response);
      }
    }
    return TerminalsFactory.getPaymentTerminalTransactionStatus(data).then(function (response) {
      handleStatusResponse(response);
    }).catch(function (error) {
      handleStatusResponse(error);
      console.error('Error checking terminal transaction status:', error);
    });
  }

  function onLoadAllFolios(params) {
    var DEFAULT_PARAMS = { pagination: { page: 1, limit: 50 }}
    var allParams = params ? params : DEFAULT_PARAMS;
    var bookingFolios = [];
    return onLoadFolios(allParams).then(function (response) {
      bookingFolios = bookingFolios.concat(response.folios);
      if (response.meta && (response.meta.page * response.meta.limit < response.meta.total)) {
        var updatedParams = allParams;
        updatedParams.pagination.page = updatedParams.pagination.page + 1;

        return onLoadAllFolios(updatedParams);
      }
      return bookingFolios;
    });
  }

  function onLoadFolios(params) {
    return new Promise(function (resolve, reject) {
      try {
        if ($rootScope.hotel && $rootScope.hotel.id) {
          var folioFactory = new FolioFactory({
            hotelId: $rootScope.hotel.id,
            bookingId: $scope.booking.id
          })
          folioFactory.getFolios(params).then(function (data) {
            if (data.data) {
              resolve(data.data);
            }
          });
        }
      } catch (e) {
        console.error(e, 'Folios error');
        reject();
      };
    });
  }

  // Function to convert object attributes from camel case to snake case
  function _camelToSnake(input) {
    if (Array.isArray(input)) {
      return input.map(function (obj) {
        return _camelToSnake(obj);
      });
    } else if (typeof input === 'object' && input !== null) {
      var snakeObj = {};
      for (var key in input) {
        if (input.hasOwnProperty(key)) {
          var snakeKey = key.replace(/[A-Z]/g, function (letter) {
            return '_' + letter.toLowerCase();
          });
          snakeObj[snakeKey] = _camelToSnake(input[key]);
        }
      }
      return snakeObj;
    } else {
      return input;
    }
  }
  // Function to convert object attributes from snake case to camel case
  function _snakeToCamel(input) {
    if (Array.isArray(input)) {
      return input.map(function (obj) {
        return _snakeToCamel(obj);
      });
    } else if (typeof input === 'object' && input !== null) {
      var camelObj = {};
      for (var key in input) {
        if (input.hasOwnProperty(key)) {
          var camelKey = key.replace(/_([a-z])/g, function (match, letter) {
            return letter.toUpperCase();
          });
          camelObj[camelKey] = _snakeToCamel(input[key]);
        }
      }
      return camelObj;
    } else {
      return input;
    }
  }

  $scope.$watch('booking', function (val) {
    var paymentIds = val.payments.map(function (payment) { return payment.id; });
    ctrl.bookingPayments = paymentIds && paymentIds.length > 0 && _.uniq(paymentIds).map(function (paymentId) {
      return val.payments.filter(function (payment) { return payment.id === paymentId })[0];
    });
    ctrl.bookingDue = val.due;
    ctrl.bookingTotalPaid = val.totalPaid;
  }, true);
  var networkStatusWatcher = $rootScope.$watch('networkStatus', function (val) {
    ctrl.online = val;
  });
  $scope.$on('$destroy', function () {
    clearTerminalChargeStatusDependencies();
    if (networkStatusWatcher) {
      networkStatusWatcher();
    }
  });
}

angular
  .module('buuqit')
  .directive('bookingPaymentTab', bookingPaymentTab);

bookingPaymentTab.$inject = ["$rootScope"];

function bookingPaymentTab () {
  return {
    controller: bookingPaymentTabController,
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingPaymentTab.html'),
    link: function (scope, element, attrs, ctrl) {
    }
  };
}

bookingPaymentTabController.$inject = ["$scope"];

function bookingPaymentTabController ($scope) {
  angular.extend(
    $scope,
    {
      similarDates : function (dateA, dateB) {
        return moment(dateA).tz($scope.hotel.timezone || 'UTC').format("D MMM YYYY") == moment(dateB).tz($scope.hotel.timezone || 'UTC').format("D MMM YYYY");
      }
    }
  );
}

var $injector;
angular
  .module('buuqit')
  .directive('bookingManagementDrawer', bookingManagementDrawer)
  .controller('BookingManagementDrawerCtrl', BookingManagementDrawerCtrl)
  .component(
    'reactBookingManagement',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingManagement,
      [
        'activeTab',
        'bookingChannel',
        'bookingPreparedToken',
        'bookingPreparedChannel',
        'bookingPreparedChannelReservationId',
        'bookingSource',
        'bookingDue',
        'bookingTotal',
        'bookingTotalExtras',
        'bookingTotalPaid',
        'bookingTotalRoom',
        'bookingDrawerControllerRef',
        'isSaleChannelsFeatureEnabled',
        'roomSize',
        'convertCurrency',
        'closeBookingManagementDrawerController',
        'editChannel',
        'editReference',
        'editSaleChannel',
        'openDrawerTab',
        'bookingManagementMounted',
      ],
      ['$i18next']
    )
  )
  .run(['$injector', function(_$injector) { $injector = _$injector }]);

function bookingManagementDrawer () {
  return {
    restrict: 'E',
    scope: {
      booking: "=booking",
      activeTab: "=activeTab",
      params: "=params",
      closeDrawer: '=closeDrawer',
    },
    templateUrl: getTemplatePath('booking_management/bookingManagementDrawer.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

BookingManagementDrawerCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$filter",
  "$timeout",
  "$templateRequest",
  "$i18next",
  "UIDialogService",
];

function BookingManagementDrawerCtrl ($rootScope, $scope, $filter, $timeout, $templateRequest, $i18next, UIDialogService) {
  var ctrl = this;
  var TABS = ['rooms', 'extras_and_discounts', 'guests', 'folios', 'payment', 'email', 'history', 'attachments'];
  var $tabScope, $tabComponent;
  var activeTab = _.isUndefined($scope.activeTab) || $scope.activeTab === null ? TABS[0] : $scope.activeTab;
  if ($scope.booking && $scope.booking.rooms) {
    _.each($scope.booking.rooms, function(el) {
      el.checkinDate = new Date(el.checkinDate);
      el.checkoutDate = new Date(el.checkoutDate);
    });

    $scope.booking.preparedToken = _prepareToken($scope.booking.token);
    $scope.booking.preparedChannel = _prepareChannel($scope.booking.channel);
    $scope.booking.preparedChannelReservationId = _prepareChannelReservationId($scope.booking.channelReservationId);
  }

  angular.extend(
    this,
    {      
      isSaleChannelsFeatureEnabled: $rootScope.hotel.saleChannelsFeatureEnabled,
      bookingDrawerControllerRef: React && React.createRef({}),
      activeTab: activeTab,
      template: _prepareTabTemplate(activeTab),
    }
  );
  angular.extend(
    $scope,
    {
      hotel: $rootScope.hotel,
      openTab: openTab
    }
  );

  function init(booking) {
    if (booking) {
      ctrl.bookingChannel = booking.channel;
      ctrl.bookingPreparedToken = booking.preparedToken;
      ctrl.bookingPreparedChannel = booking.preparedChannel;
      ctrl.bookingPreparedChannelReservationId = booking.preparedChannelReservationId;
      ctrl.bookingSource = booking.source;
      ctrl.bookingDue = booking.due;
      ctrl.bookingTotal = booking.total;
      ctrl.bookingTotalExtras = booking.totalExtras;
      ctrl.bookingTotalPaid = booking.totalPaid;
      ctrl.bookingTotalRoom = booking.totalRoom;
      ctrl.roomSize = booking.rooms.filter(function(e) { return e.status != 'canceled'}).length;
    }
  }

  init($scope.booking);

  function _prepareToken(token) {
    if (token && token.split) {
      return token.split('-').map(function(block) {
        if (block.indexOf('/') > -1) {
          return block.split('/')[0];
        } else {
          return block;
        }
      }).join('-');
    } else {
      return token;
    }
  }
  function _prepareChannel(channel) {
    if (channel == 'BOOKINGS EUROPE B.V.') {
      return 'Booking.com';
    } else {
      return channel;
    }
  }
  function _prepareChannelReservationId(token) {
    if (token && token.indexOf && token.indexOf('/') > -1) {
      return token.split('/')[0];
    } else {
      return token;
    }
  }
  function _prepareTabTemplate(activeTab) {
    return getTemplatePath('booking_management/' + (_.isUndefined(activeTab) || activeTab === null ? TABS[0] : activeTab) + '.html');
  }
  ctrl.convertCurrency = function (amount) {
    return customCurrencyExtended(amount, $scope.booking, $scope.booking.isForeignAmount(), $filter, $rootScope);
  }
  ctrl.editChannel = function() {
    UIDialogService.open('channel-name', {
      title: $i18next.t('bookings.change_channel_name_title'),
      placeholder: $i18next.t('bookings.change_channel_name_placeholder'),
      value: angular.copy($scope.booking.channel),
      callback: function (value) {
        UIDialogService.close('channel-name');
        $scope.booking.hotelId = $rootScope.hotel.id;
        $scope.booking.channel = value;
        $scope.booking.save();
      }
    });
  }
  ctrl.editReference = function() {
    UIDialogService.open('channel-name', {
      title: $i18next.t('bookings.change_reference_title'),
      placeholder: $i18next.t('bookings.change_reference_placeholder'),
      value: angular.copy($scope.booking.channelReservationId),
      callback: function (value) {
        UIDialogService.close('channel-name');
        $scope.booking.hotelId = $rootScope.hotel.id;
        $scope.booking.channelReservationId = value;
        $scope.booking.save();
      }
    });
  }
  ctrl.editSaleChannel = function() {
    var saleChannel = angular.copy($scope.booking.saleChannel);

    UIDialogService.open('choose-sale-channel', {
      title: $i18next.t('bookings.change_channel_name_title'),
      placeholder: $i18next.t('bookings.change_channel_name_placeholder'),
      collection: $rootScope.hotel.saleChannels,
      value: saleChannel ? saleChannel.name : null,
      callback: function (saleChannelName) {
        UIDialogService.close('choose-sale-channel');

        $scope.booking.hotelId = $rootScope.hotel.id;
        $scope.booking.channel = saleChannelName;

        $scope.booking.save();
      }
    }, true);
  }
  ctrl.closeBookingManagementDrawerController = function() {
    $rootScope.activeBookingId = null;

    clearTabScope();
    $timeout(function() {
      $scope.closeDrawer();
    }, 400);
  }
  function clearTabScope() {
    if (!_.isUndefined($tabScope) && $tabComponent.length) {
      $tabComponent.remove();
      $tabScope.$destroy();
    }
  }
  function openTab($event, tab_index) {
    $event.preventDefault();
    if (ctrl.bookingDrawerControllerRef && ctrl.bookingDrawerControllerRef.current && ctrl.bookingDrawerControllerRef.current.onChange) {
      ctrl.bookingDrawerControllerRef.current.onChange(TABS[tab_index]);
    }
  }
  ctrl.openDrawerTab = function(ref, tab) {
    if (ref && ref.current) {
      clearTabScope();
      if (!_.isUndefined(tab)) {
        ctrl.activeTab = tab;
        ctrl.template = _prepareTabTemplate(tab);
      }
      var reactComponent = angular.element(ref.current);
      var $compile = $injector.get('$compile');

      $templateRequest(ctrl.template).then(function(template) {
        $tabScope = $scope.$new();
        $tabComponent = $compile(template)($tabScope);
        reactComponent.append($tabComponent);
      }).catch(function(error) {
        console.error('Failed to load template:', error);
      });
    }
  }
  ctrl.bookingManagementMounted = function() {
    if (ctrl.bookingDrawerControllerRef && ctrl.bookingDrawerControllerRef.current && ctrl.bookingDrawerControllerRef.current.showBookingManagementDrawer) {
      ctrl.bookingDrawerControllerRef.current.showBookingManagementDrawer();
    }
  }

  var reloadListener = $rootScope.$on('booking_management:reload', function(event, booking) {
    if ($scope.booking.id === booking.id) {
      $scope.booking = booking;
      $scope.booking.preparedToken = _prepareToken($scope.booking.token);
      $scope.booking.preparedChannel = _prepareChannel($scope.booking.channel);
      $scope.booking.preparedChannelReservationId = _prepareChannelReservationId($scope.booking.channelReservationId);
      ctrl.bookingTotalExtras = booking.totalExtras;
      init($scope.booking);

      var activeTab = ctrl.activeTab || TABS[0];
      var eventName = 'booking_management:reload_' + activeTab;
      $rootScope.$broadcast(eventName, booking);
    }
  });

  $scope.$on('$destroy', function() {
    if (reloadListener) {
      reloadListener();
    }
    if (ctrl.bookingDrawerControllerRef) {
      ctrl.bookingDrawerControllerRef = null;
    }
    if (ctrl.template) {
      ctrl.template = null;
    }
    if ($tabComponent) {
      $tabComponent.remove();
      $tabComponent = null;
    }
    if ($tabScope) {
      $tabScope.$destroy();
      $tabScope = null;
    }
    ctrl = null;
  });
}

angular
  .module('buuqit')
  .directive('bookingHistoryTab', bookingHistoryTab)
  .controller('BookingHistoryTableController', bookingHistoryController)
  .component(
    'reactBookingHistoryTable',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingHistoryTable,
      [
        'logs',
        'getEmail',
        'loadLogs',
        'hotelId',
        'bookingId',
        'logsMeta',
      ],
      ['$i18next']
    )
  );

bookingHistoryController.$inject = ["$scope", "$rootScope", "LogFactory", "$http", "$i18next", "StringTransformService"];

function bookingHistoryController($scope, $rootScope, LogFactory, $http, $i18next, StringTransformService) {
  var ctrl = this;

  angular.extend(
    this,
    {
      logs: [],
      logsMeta: {},
      hotelId: null,
      bookingId: null,
      getEmail: getEmail,
      loadLogs: loadLogs
    }
  );

  function getEmail(log) {
    var booking_url = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' + $scope.booking.id;
    return $http
      .get(booking_url + '/logs/' + log.id + '/get_email')
      .then(function(response) {
        if (response.data && response.data.success) {
          var a = document.createElement('a');
          a.target = '_blank';
          a.href = booking_url + '/show_email/' + response.data.token;
          a.click();
          $rootScope.notify($i18next.t('booking.history.email_opened'));
        } else {
          $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        }
        return true;
      })
      .catch(function(error) {
        $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        return error;
      });
  }

  var DEFAULT_PAGINATION = { page: 1, limit: 10 };
  
  function loadLogs(params) {
    var par = params || DEFAULT_PAGINATION;

    try {
      if ($rootScope.hotel && $rootScope.hotel.id && $scope.booking.id) {
        var logsFactory = new LogFactory();
        
        return logsFactory.getLogs($rootScope.hotel.id, $scope.booking.id, par).then(function (data) {
          if (data.data) {
            ctrl.logsMeta = data.data.meta || {};

            data.data.logs.forEach(function(log){
              var startToken = '{{email:',
                  endToken = '}}',
                  startTokenPos = log.action.indexOf(startToken),
                  endTokenPos = log.action.indexOf(endToken);
    
              if (startTokenPos !== -1) {
                log.emailId = log.action.slice(startTokenPos + startToken.length, endTokenPos).trim();
                log.action = log.action.slice(0, startTokenPos) + log.action.slice(endTokenPos + 2);
                log.showEmail = true;
              };
            });

            ctrl.logs = data.data.logs ? StringTransformService.snakeToCamel(data.data.logs) : [];
          };
        });
      }
    } catch (e) {
      console.error(e, 'Logs');
    };
  };

  function init() {
    ctrl.hotelId = $rootScope.hotel.id;
    ctrl.bookingId = $scope.booking.id;

    loadLogs();
  }

  init();
}

function bookingHistoryTab () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingHistoryTab.html'),
  };
}

angular
  .module('buuqit')
  .directive('bookingGuestsTab', bookingGuestsTab)
  .controller('BookingGuestsTabController', BookingGuestsTabController)
  .component(
    'reactBookingGuests',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingGuests,
      [
        'bookingGuests',
        'bookingRooms',
        'hotelRooms',
        'roomTypes',
        'coverRoomTypes',
        'roomRepresentations',
        'leadGuest',
        'rooms',
        'nationalities',
        'locales',
        'idTypes',
        'countries',
        'hotelCountry',
        'guestDetailsSettings',
        'getBookingGuestsUrl',
        'authorizationToken',
        'uploadFiles',
        'fetchGuestAttachments',
        'printRegistrationForm',
        'onDelete',
        'onSaveBookingGuestForm',
        'printRegistrationFormForAll',
        'changeLeadGuest',
        'saveBulkEditChanges',
      ],
      ['$i18next']
    )
  );

function bookingGuestsTab () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingGuestsTab.html')
  };
}

BookingGuestsTabController.$inject = [
  "$scope",
  "$rootScope",
  "$i18next",
  "$http",
  "GuestFactory",
  "BookingFactory",
  "AttachmentFactory",
  "BookingStorage"
];

function BookingGuestsTabController ($scope, $rootScope, $i18next, $http, GuestFactory, BookingFactory, AttachmentFactory, BookingStorage) {
  var ctrl = this;

  angular.extend(
    this,
    {
      bookingRooms: $scope.booking.rooms,
      hotelRooms: $rootScope.hotel.rooms,
      roomTypes: $rootScope.hotel.roomTypes,
      coverRoomTypes: $rootScope.hotel.coverRoomTypes,
      roomRepresentations: $rootScope.hotel.roomRepresentations,
      leadGuestId: $scope.booking.leadGuestId,
      idTypes: $rootScope.hotel.identificationTypes,
      hotelCountry: $rootScope.hotel.country,
      guestDetailsSettings: $rootScope.hotel.guestDetailsSetting && $rootScope.hotel.guestDetailsSetting.questions ? $rootScope.hotel.guestDetailsSetting.questions : [],
      getBookingGuestsUrl: SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/autocomplete',
      authorizationToken: $http.defaults.headers.common['AUTHORIZATION'],
      uploadFiles: uploadFiles,
      fetchGuestAttachments: fetchGuestAttachments,
      printRegistrationForm: printRegistrationForm,
      onDelete: onDelete,
      onSaveBookingGuestForm: onSaveBookingGuestForm,
      printRegistrationFormForAll: printRegistrationFormForAll,
      changeLeadGuest: changeLeadGuest,
      saveBulkEditChanges: saveBulkEditChanges,
      openedAttachmentsGuest: null,
    }
  );

  function init() {
    ctrl.bookingGuests = _getGuests($scope.booking.rooms);
    ctrl.leadGuest = ctrl.bookingGuests.find(function(g){ return g.id === ctrl.leadGuestId; });
    ctrl.rooms = _getRoomsList($scope.booking.rooms);
    ctrl.countries = _prepareCountries(countries_in);
    ctrl.nationalities = _prepareNationalities($rootScope.hotel.nationalities);
    ctrl.locales = window.locales && window.locales.filter(function(locale) {
      return locale.is_production
    });
  }

  init();

  function uploadFiles (files) {
    var fd = new FormData();
    var keys = Object.keys(files);
    keys.forEach(function(key) {
      fd.append(key, files[key].originFileObj);
    });
    fd.append('guest_id', ctrl.openedAttachmentsGuest.id);
    return $http.post($scope.booking.$url('attachments'), fd, {
      headers: {'Content-Type': undefined },
      transformRequest: angular.identity
    }).success(function(response) {
      if (response && response.attachments) {
        return response.attachments;
      }
      return false;
    }).error(function(response) {
      console.warn('error', response);
      return false;
    });
  }

  function fetchGuestAttachments (guest) {
    ctrl.openedAttachmentsGuest = guest;
    return AttachmentFactory
      .$get(AttachmentFactory.resourceUrl({
        hotelId: $rootScope.hotel.id,
        bookingId: $scope.booking.id
      }) + '?guest_id=' + guest.id)
      .then(function(response) {
        return response;
      });
  }
  // Call serverside method to genereate PDF with registration form for
  // selected guest and send it to print
  function printRegistrationForm (guest) {
    var gen_form_url = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/' + guest.id + '/generate_form';
    return $http.get(gen_form_url)
      .then(function(response) {
        if (response.data && response.data.token) {
          _print(gen_form_url+'/'+response.data.token+'?type=print&booking_room_id='+ guest.bookingRoomId);
          return true;
        }
        return false;
      });
  }

  function onDelete (guest) {
    return new GuestFactory(guest)
      .removeFrom(guest.bookingRoomId)
      .then(function() {
        ctrl.bookingGuests = _.without(ctrl.bookingGuests, guest);
        _updateLead($scope);
        _normalizeBookingRoomsGuests();
        return true;
      });
  }

  function onSaveBookingGuestForm (guest) {
    $rootScope.isDisabledPusherEvents = true;
    var primary = guest.primary || false;

    if ($rootScope.hotel.nationalities.indexOf(guest.nationality) == -1) {
      $rootScope.hotel.nationalities.push(guest.nationality);
    }

    guest.hotelId = $rootScope.hotel.id;
    guest.addonsJson = JSON.stringify(guest.addons);
    if (guest.addonsJson && (guest.addonsJson.birthDate || guest.addonsJson.idIssueDate)) {
      if (guest.addonsJson.birthDate) {
        guest.addonsJson.birthDate = moment(guest.addonsJson.birthDate).format('YYYY-MM-DD');
      }
      if (guest.addonsJson.idIssueDate) {
        guest.addonsJson.idIssueDate = moment(guest.addonsJson.idIssueDate).format('YYYY-MM-DD');
      }
    }
    var guestExists = ctrl.bookingGuests.find(function(bg) {
      var sameGuests = bg.firstName == guest.firstName && bg.lastName == guest.lastName && bg.bookingRoomId == guest.bookingRoomId;
      return sameGuests;
    });
    // prevent creating same guest for same room;
    if (guestExists && !guest.id) {
      return true;
    }

    if (guest.id) {
      return new GuestFactory(guest)
        .save()
        .then(function(response) {
          resetPrimaryGuest(primary, response.bookingRoomId);
          var updatedGuest = _normalizeDates(_generateRepresentationName(angular.copy(response)));
          
          var updatedGuestWithRoom = _setRoomToGuest(angular.copy(updatedGuest), response.bookingRoomId);
          updatedGuestWithRoom.primary = primary;
          if(updatedGuestWithRoom.addons && updatedGuestWithRoom.addons.citizenship) {
            updatedGuestWithRoom.citizenship = updatedGuestWithRoom.addons.citizenship;
          }

          ctrl.bookingGuests = ctrl.bookingGuests && ctrl.bookingGuests.map(function(guest) {
            if (guest.id === updatedGuestWithRoom.id) {
              var updatedGuest = angular.copy(updatedGuestWithRoom);
              updatedGuest.bookingRoomId = guest.bookingRoomId;
              updatedGuest.room = guest.room;
              updatedGuest.roomId = guest.roomId;

              return updatedGuest;
            }
            return guest;
          })

          if (guest.lead) {
            $scope.booking.leadGuestId = response.id;
            ctrl.leadGuestId = response.id;
          }
          _updateLead($scope);

          BookingStorage.load_by_id($scope.booking.id, false, function(booking) {
            $rootScope.$broadcast('booking_management:reload', booking);
          });
          return true;
        })
        .finally (function () {
          $rootScope.isDisabledPusherEvents = false;
        });
    } else {
      return new GuestFactory(guest)
        .save()
        .then(function(response) {
          resetPrimaryGuest(primary, response.bookingRoomId);
          // remove replaced
          if (guest.hasOwnProperty('guest_for_replace') && guest.hasOwnProperty('replaceGuestIndex')) {
            ctrl.bookingGuests = ctrl.bookingGuests.filter(function(gst, index) {
              return index !== guest.replaceGuestIndex;
            });
            // remove replaced from rooms
            $scope.booking.rooms = $scope.booking.rooms.map(function(bookingRoom) {
              bookingRoom.guests = bookingRoom.guests.filter(function(gst) {
                return gst.bookingRoomId === bookingRoom.id && gst.id !== guest.guest_for_replace;
              });
              return bookingRoom;
            });
          }
          var updatedGuestWithRoom = _normalizeDates(_setRoomToGuest(
            _generateRepresentationName(angular.copy(response)),
            response.bookingRoomId
          ));
          updatedGuestWithRoom.primary = primary;
          if(updatedGuestWithRoom.addons && updatedGuestWithRoom.addons.citizenship) {
            updatedGuestWithRoom.citizenship = updatedGuestWithRoom.addons.citizenship;
          }
          ctrl.bookingGuests.push(updatedGuestWithRoom);
          if (guest.lead) {
            $scope.booking.leadGuestId = response.id;
            ctrl.leadGuestId = response.id;
          }
          _updateLead($scope);
          _normalizeBookingRoomsGuests();
          return true;
        })
        .finally (function () {
          $rootScope.isDisabledPusherEvents = false;
        });
    }
  }
  // Call serverside method to genereate PDF with registration form for
  // all guests and send it to print
  function printRegistrationFormForAll () {
    var gen_form_url = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/generate_form/'+$scope.booking.id;
    return $http.get(gen_form_url)
      .then(function(response) {
        if (response.data && response.data.token) {
          _print(gen_form_url+'/'+response.data.token+'?type=print');
          return true;
        }
        return false;
      });
  }

  function changeLeadGuest (guestId) {
    $scope.booking.hotelId = $rootScope.hotel.id;
    return $http.post((new BookingFactory($scope.booking)).$url('change_lead_guest'), {
      'lead_guest_id' : guestId,
    }).then(function(response) {
      var data = response.data;
      if (data.success && data.leadGuestId) {
        $scope.booking.leadGuestId = data.leadGuestId;
        ctrl.leadGuestId = data.leadGuestId;
        _updateLead($scope);
        return true;
      } else {
        $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      }
    }, function(error) {
      $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      console.error(error);
      return false;
    });
  }

  function saveBulkEditChanges (guests) {
    var url = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/guests/batch_update/' + $scope.$parent.booking.id;
    var guestsToBeReplaced = [];
    var guestsForUpdate = guests.filter(function(guest) {
      return guest.hasChange && (!guest.inlineCreated && !guest.newGroupGuest);
    });
    var createdGuests = guests.filter(function(guest) {
      return guest.inlineCreated || (guest.newGroupGuest && guest.hasChange);
    });
    guestsForUpdate = guestsForUpdate.map(function(guest) {
      if (guest.citizenship) {
        guest.addons.citizenship = guest.citizenship;
      }
      return _switch_var_style(guest, _from_camel);
    })
    createdGuests = createdGuests.map(function(guest) {
      if (guest.citizenship) {
        if (!guest.addons) {
          guest.addons = {};
        }
        guest.addons.citizenship = guest.citizenship;
      }
      if (guest.id) {
        delete guest.id;
      }
      if (guest.newGroupGuest) {
        var guestForReplacement = ctrl.bookingGuests.find(function(g) { return g.id === guest.guest_for_replace && g.bookingRoomId === guest.bookingRoomId});
        guestsToBeReplaced.push(guestForReplacement);
      }
      return _switch_var_style(guest, _from_camel);
    });
    var data = {
      update_guests: guestsForUpdate,
      new_guests: createdGuests
    };
    return $http.post(url, data).then(function(response) {
      if (response.data && response.data.updated_guests) {
        response.data.updated_guests.forEach(function(guest) {
          var parsedGuest = _switch_var_style(guest, _to_camel)
          _updateSameGuest(parsedGuest);
        });
      }
      if (response.data && response.data.created_guests) {
        response.data.created_guests.forEach(function(guest) {
          var parsedGuest = _switch_var_style(guest, _to_camel);
          var updatedGuestWithRoom = _normalizeDates(_setRoomToGuest(
            _generateRepresentationName(angular.copy(parsedGuest)),
            parsedGuest.bookingRoomId
          ));
          if(updatedGuestWithRoom.addons && updatedGuestWithRoom.addons.citizenship) {
            updatedGuestWithRoom.citizenship = updatedGuestWithRoom.addons.citizenship;
          }
          // for handling group bookings
          if (guestsToBeReplaced && guestsToBeReplaced.length > 0) {
            var matchingReplacement = guestsToBeReplaced.find(function(gr) {return gr.bookingRoomId === updatedGuestWithRoom.bookingRoomId});
            if (matchingReplacement) {
              updatedGuestWithRoom.primary = matchingReplacement.primary;
              var index = ctrl.bookingGuests.findIndex(function(g) {return g.id === matchingReplacement.id && g.bookingRoomId === matchingReplacement.bookingRoomId});
              ctrl.bookingGuests = ctrl.bookingGuests.map(function(g, inx) {
                if (inx === index) {
                  return updatedGuestWithRoom;
                }
                return g;
              });
            } else {
              ctrl.bookingGuests = ctrl.bookingGuests.concat(updatedGuestWithRoom);
            }
          } else {
            ctrl.bookingGuests = ctrl.bookingGuests.concat(updatedGuestWithRoom);
          }
          _normalizeBookingRoomsGuests();
        });
      }
    }).catch(function(error) {
      console.error(error);
      return error;
    });
  }

  function _prepareCountries(countries) {
    return countries.map(function(country) {
      return {
        label: country,
        value: country
      }
    });
  }

  function _prepareNationalities(nationalities) {
    return _.compact(nationalities).map(function(nationality) {
      return {
        label: nationality,
        value: nationality
      }
    });
  }

  function _to_camel  (s) { return s.split('_')[0] + s.split('_').slice(1).map(function(c){ return c[0].toUpperCase() + c.slice(1)}).join(''); }

  function _from_camel(s) { return s.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase(); }

  function _switch_var_style(o, f) {
    var n_o = {};
    for(var k in o) n_o[f(k)] = o[k];
    return n_o;
  };

  function _getGuests(bookingRooms) {
    function _update_guest_for_editing(room, guest) {
      guest.citizenship = (guest.addons && guest.addons.citizenship) ? guest.addons.citizenship : null;
      var representationName = _generateRepresentationName(guest);
      var roomGuest = _setRoomToGuest(representationName, room.id)
      return _normalizeDates(roomGuest);
    }
    var validRooms = bookingRooms.filter(function(room){ return room.status !== 'canceled'; });
    var roomGuests = validRooms.map(function(room) {
      return room.guests.map(function(guest){ return _update_guest_for_editing(room, guest); });
    });
    roomGuests = _.flatten(roomGuests);
    return roomGuests;
  }

  function _getRoomNameById(roomId) {
    var room = $rootScope.hotel.rooms.find(function(room){ return room.id == roomId; });
    return (room) ? room.number : 'Room is not defined';
  }

  function _generateRepresentationName(guest) {
    guest.representationName = [guest.title, guest.firstName, guest.lastName].join(' ').trim();
    return guest;
  }

  function _getRoomsList(bookingRooms) {
    return bookingRooms.map(function(bookingRoom) {
      return {id: bookingRoom.id, number: _getRoomNameById(bookingRoom.roomId), status: bookingRoom.status};
    });
  }

  function _setRoomToGuest(guest, bookingRoomId) {
    var bookingRoom = $scope.booking.rooms.find(function(bookingRoom){ return bookingRoom.id == bookingRoomId; });
    guest.room = _getRoomNameById(bookingRoom.roomId);
    guest.roomId = bookingRoom.roomId;
    guest.bookingRoomId = bookingRoomId;
    var room = $scope.booking.rooms.find(function(room){ return room.id == bookingRoomId; });
    guest.primary = (guest.id == room.guest.id);
    return guest;
  }

  function _normalizeBookingRoomsGuests() {
    $scope.booking.rooms = $scope.booking.rooms.map(function(bookingRoom) {
      bookingRoom.guests = ctrl.bookingGuests.filter(function(guest) {
        return guest.bookingRoomId == bookingRoom.id;
      });
      return bookingRoom;
    });
    $rootScope.$broadcast('bookings:update');
  }

  function _normalizeDates(guest) {
    if (guest.addons) {
      if (guest.addons.birthDate) {
        guest.addons.birthDate = moment.isMoment(guest.addons.birthDate) ? guest.addons.birthDate : moment(guest.addons.birthDate);
      }
      if (guest.addons.idIssueDate) {
        guest.addons.idIssueDate = moment.isMoment(guest.addons.idIssueDate) ? guest.addons.idIssueDate : moment(guest.addons.idIssueDate);
      }
    }
    return guest;
  }

  function _updateSameGuest(updatedGuest) {
    ctrl.bookingGuests = ctrl.bookingGuests.map(function(guest) {
      if (guest.id !== updatedGuest.id) {
        return guest;
      } else {
        var pickedGuest = Object.assign(guest,
          _.pick(
            updatedGuest,
            "addons",
            "addonsJson",
            "email",
            "firstName",
            "hotelId",
            "identification",
            "lastName",
            "nationality",
            "phone"
          )
        );
        if (pickedGuest.addons && pickedGuest.addons.citizenship) {
          pickedGuest.citizenship = pickedGuest.addons.citizenship;
        }
        return  _generateRepresentationName(pickedGuest);
      }
    });
  }

  function _print(path) {
    $('#pdfDocument').remove();
    var printWrap = $('#guestsHeader');
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = path;
    iframe.name = 'pdfGuests';
    iframe.id = 'pdfDocument';
    iframe.width = '100%';
    iframe.height = '100%';

    iframe.onload = function () {
      try {
        setTimeout(function () {
          if (iframe.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          } else {
            console.error('Unable to print PDF.');
          }
        }, 100);
      } catch (e) {
        console.error('Unable to print pdf', e);
      }
    };

    printWrap.append(iframe);
  }

  function _returnLead(id) {
    return ctrl.bookingGuests.find(function(e){ return e.id == id });
  }

  function _updateLead($scope) {
    $scope.leadGuest = _returnLead($scope.booking.leadGuestId);
    ctrl.leadGuest = _returnLead(ctrl.leadGuestId);
  }

  function resetPrimaryGuest(primary, bookingRoomId) {
    if (primary) {
      ctrl.bookingGuests = ctrl.bookingGuests.map(function(guest) {
        if (guest.bookingRoomId === bookingRoomId) {
          guest.primary = false;
        }
        return guest;       
      });
    }
  };
}

angular
  .module('buuqit')
  .directive('bookingGuestAttachments', bookingGuestAttachments);

bookingGuestAttachments.$inject = ["$rootScope", "AttachmentFactory"];

GUEST_ATTACHMENTS = ['facial_picture', 'front_id_picture', 'back_id_picture', 'digital_signature']

function bookingGuestAttachments ($rootScope, AttachmentFactory) {
  return {
    controller: BookingGuestAttachmentsController,
    scope: {
      guest: '='
    },
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingGuestAttachments.html'),
    link: function (scope, element, attrs, ctrl) {
      scope.loading = true;
      var bookingId = scope.$parent.booking.id;
      var hotelId = $rootScope.hotel.id;

      load();

      scope.processAttachments = function(attachments) {
        GUEST_ATTACHMENTS.forEach(function(name) {
          scope.files[name].attachment = attachments.filter(function(e) { return e.type == name; })[0];
        });
        // angular.copy(attachments, $scope.attachments);
        scope.loading = false;
      }

      function load() {
        AttachmentFactory
          .$get(AttachmentFactory.resourceUrl({
            hotelId: hotelId,
            bookingId: bookingId
          }) + '?guest_id=' + scope.guest.id)
          .then(function(response) {
            scope.processAttachments(response)
          },
            function (response) {
              scope.loading = false;
              scope.errors = ['Something goes wrong and we can\'t load attachments for that booking.'];
            }
          );
      }
    }
  };
}

BookingGuestAttachmentsController.$inject = [
  "$scope",
  "$rootScope",
  "$http"
];

function BookingGuestAttachmentsController ($scope, $rootScope, $http) {
  angular.extend($scope, {
    files: GUEST_ATTACHMENTS.reduce(function(result, item, index, array) {
      result[item] = {
        files: [],
        attachment: undefined,
        selected: false
      };
      return result;
    }, {}),
    uploadFiles: uploadFiles
  });

  function uploadFiles() {
    if ($scope.loading) {
      return;
    }

    $scope.loading = true;

    var fd = new FormData();
    fd.append('guest_id', $scope.guest.id);
    GUEST_ATTACHMENTS.forEach(function(i) {
      if ($scope.files[i].selected) {
        fd.append(i, $scope.files[i].files[0].file);
      }
    });

    $http.post($scope.$parent.booking.$url('attachments'), fd, {
        headers: {'Content-Type': undefined },
        transformRequest: angular.identity
    }).success(function(response) {
      GUEST_ATTACHMENTS.forEach(function(i) {
        if ($scope.files[i].selected) {
          $scope.files[i].selected = false;
          angular.copy([], $scope.files[i].files);
        }
      });

      $scope.processAttachments(response.attachments)
    }).error(function(response) {
      $scope.loading = false;
      console.warn('error', response);
    });

  }
}


angular
  .module('buuqit')
  .directive('bookingGuestAttachment', bookingGuestAttachment);

bookingGuestAttachment.$inject = ["$rootScope"];

function bookingGuestAttachment ($rootScope) {
  return {
    controller: BookingGuestAttachmentController,
    scope: {
      name: '=',
      attachment: '=',
      choosePhotoFile: '&',
      multi: '='
    },
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingGuestAttachment.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

BookingGuestAttachmentController.$inject = [
  "$scope",
  "$rootScope",
  "$timeout"
];

function BookingGuestAttachmentController ($scope, $rootScope, $timeout) {
  angular.extend($scope, {
    choosePhotoFile: choosePhotoFile
  });

  function choosePhotoFile(input) {
    $timeout(function() {
      if ($scope.attachment.files.length > 0) {
        $scope.attachment.files.splice(0, $scope.attachment.files.length);
      }
      for (var i = 0; i < input.files.length; i++) {
        var f = input.files[i];
        $scope.attachment.files.push({name: f.name || "noname.png", file: f});
      }

      $scope.attachment.selected = $scope.attachment.files.length > 0;

    }, 0);
  }
}
angular
  .module('buuqit')
  .directive('bookingFoliosTab', bookingFoliosTab)
  .controller('bookingFoliosTabController', bookingFoliosTabController)

bookingFoliosTabController.$inject = [
  "$scope",
  "$rootScope",
  "$http",
  "$i18next",
  "$filter",
  "UIDialogService",
  "FolioFactory",
  "CustomerFactory",
  "DeviceDetector",
  "DiscountsFactory"
];

function bookingFoliosTabController($scope, $rootScope, $http, $i18next, $filter, UIDialogService, FolioFactory, CustomerFactory, DeviceDetector, DiscountsFactory) {
  var bookingId = $scope.$parent.booking.id;
  var hotelId = $rootScope.hotel.id;

  angular.extend(
    $scope, {
      folios: [],
      allowChangeInvoiceDateFeature: $rootScope.hotel.allowChangeInvoiceDateFeature,
      allowChangeInvoiceNumberFeature: $rootScope.hotel.allowChangeInvoiceNumberFeature,
      activeFolio: null,
      loadingFolios: false,
      errors: [],
      accomodationsAndExtrasByRoom: [],
      selectedItemsCount: 0,
      selectedPayableItemsCount: 0,
      discountAmount: 0,
      discounts: [],
      allowedToMoveTypes: ['folio', 'invoice'],
      statuses: {
        'folio': $i18next.t('bookings.folios.statuses.folio'),
        'invoice': $i18next.t('bookings.folios.statuses.invoice'),
        'receipt': $i18next.t('bookings.folios.statuses.receipt'),
        'voided': $i18next.t('bookings.folios.statuses.voided'),
        'credited_receipt': $i18next.t('bookings.folios.statuses.receipt'),
        'credit': $i18next.t('bookings.folios.statuses.credit')
      },
      addFolioInProgress: false,
      defaultNoteText: $rootScope.hotel.invoiceDefaultNotes,
      user: $rootScope.user,
      viewFoliosBy: 'category',
      accomodationsAndExtrasByRoom: [],
      newTaxes: $rootScope.hotel.newTaxes,
      is_mobile  : DeviceDetector === 'mobile',
      openFolio: openFolio,
      addFolio: addFolio,
      removeFolio: removeFolio,
      setViewFoliosBy: setViewFoliosBy,
      moveItems: moveItems,
      openDropDown: openDropDown,
      touchSelectedItemsCount: touchSelectedItemsCount,
      toggleShowTaxBreakdown: toggleShowTaxBreakdown,
      toggleShowNightBreakdown: toggleShowNightBreakdown,
      toggleFolioRoomSelection: toggleFolioRoomSelection,
      selectAccomodationsAndExtras: selectAccomodationsAndExtras,
      enableNoteEditMode: enableNoteEditMode,
      disableNoteEditMode: disableNoteEditMode,
      enableOverlayEditMode: enableOverlayEditMode,
      disableOverlayEditMode: disableOverlayEditMode,
      enableOverrideNoteEditMode: enableOverrideNoteEditMode,
      disableOverrideNoteEditMode: disableOverrideNoteEditMode,
      openCustomerEditForm: openCustomerEditForm,
      closeCustomerEditForm: closeCustomerEditForm,
      changeCustomerTo: changeCustomerTo,
      changeGuestToCustomer: changeGuestToCustomer,
      createNewCustomer: createNewCustomer,
      setNewCustomer: setNewCustomer,
      toggleFindCustomerForm: toggleFindCustomerForm,
      chooseCustomer: chooseCustomer,
      applyFindedCustomer: applyFindedCustomer,
      openAddDiscountForm: openAddDiscountForm,
      closeAddDiscountForm: closeAddDiscountForm,
      searchDiscount: searchDiscount,
      chooseDiscount: chooseDiscount,
      applyDiscount: applyDiscount,
      removeDiscount: removeDiscount,
      changeDiscount: changeDiscount,
      closeMoveInterface: closeMoveInterface,
      submitMoveInterface: submitMoveInterface,
      changeNightTargetPart: changeNightTargetPart,
      changeTargetPart: changeTargetPart,
      changeCurrentPart: changeCurrentPart,
      switchMode: switchMode,
      setPredefinedMoveValue: setPredefinedMoveValue,
      changeCountCurrentPart: changeCountCurrentPart,
      changeCountTargetPart: changeCountTargetPart,
      toggleNight: toggleNight,
      nightsComparator: nightsComparator,
      createInvoice: createInvoice,
      createReceipt: createReceipt,
      voidFolio: voidFolio,
      creditFolio: creditFolio,
      moveToFilter: moveToFilter,
      openPaymentsTab: openPaymentsTab,
      toggleEditFolioNumber: toggleEditFolioNumber,
      toggleEditFolioDate: toggleEditFolioDate,
      toggleEditFolioTaxDate: toggleEditFolioTaxDate,
      sendPaymentRequest: sendPaymentRequest,
      toggleFolioItemVisibility: toggleFolioItemVisibility,
      toggleFolioItemComplimentary: toggleFolioItemComplimentary,
      print: print,
      downloadPDF: downloadPDF,
      toggleSendInterface: toggleSendInterface,
      openEmailsTab: openEmailsTab,
      removeTax: removeTax,
      editTax: editTax,
      addTax: addTax,
      resetTax: resetTax,
      saveFolioTax: saveFolioTax,
      generateTaxText: generateTaxText,
      feeOrCityTaxFilter: feeOrCityTaxFilter,
      showOperation: showOperation,
      representationStatus: representationStatus,
      convertCurrency: convertCurrency,
      changeSelectedPayments: changeSelectedPayments,
      movePaymentsAndCreateReceipt: movePaymentsAndCreateReceipt,
      toggleIsForeignAmount: toggleIsForeignAmount,
      defaultCurrency: $rootScope.hotel.currency
    }
  )
  
  function init() {
    load();
  }

  function representationStatus(folio) {
    if (folio.creditStatus !== 'no_credit') {
      return $scope.statuses[folio.creditStatus]
    } else {
      return $scope.statuses[folio.status]
    }
  }

  function toggleIsForeignAmount(isForeignAmount) {
    activeFolio().toggleIsForeignCurrencyLoading = true;
    var folio = angular.copy($scope.folios[$scope.activeFolio])
    folio.isForeignAmount = isForeignAmount;
    folio.update().then(function(results) {
      $scope.folios[$scope.activeFolio].isForeignAmount = isForeignAmount;
      activeFolio().toggleIsForeignCurrencyLoading = false;
    });
  }

  function prepareNavigation() {
    var navItems = $scope.folios.map(function(el, index) {
      return {
        number: el.number,
        status: el.status,
        creditStatus: el.creditStatus,
        index: index,
        due: el.due,
        visibleName: el.customer.visibleName
      };
    });
    $scope.visibleLinks = navItems.slice(0, 7);
    $scope.otherLinks = navItems.slice(7, navItems.length);
  }

  function load() {
    if($scope.loadingFolios) {
      return new Promise(function(resolve, reject) {
        reject('Folios are already loading');
      });
    }
    $scope.loadingFolios = true;
    $scope.availablePayments = [];
    $scope.accomodationsAndExtrasByRoom = [];
    return FolioFactory
      .get({
        hotelId: hotelId,
        bookingId: bookingId
      })
      .then(
        function (response) {
          $scope.loadingFolios = false;
          $scope.folios = response.map(prepareFolio);
          $scope.folios.forEach(getPaymentsAndPrepaymentsFromFolio);

          prepareNavigation();
          if ($scope.folios && $scope.folios.length > 0) {
            if ($scope.$parent && $scope.$parent.params && $scope.$parent.params.folio_id !== undefined) {
               $scope.activeFolio = _.findIndex($scope.folios, { 'id': $scope.$parent.params.folio_id}) || 0;
                $scope.$parent.params.folio_id = undefined;
            } else {
              $scope.activeFolio = 0;
            }
            $scope.selectedItemsCount = 0;
            $scope.selectedPayableItemsCount = 0;
          }
          prepareOtherBookingCustomers();
          prepareBookingGuests();
          prepareAccomodationAndExtras();
        },
        function (response) {
          $scope.loadingFolios = false;
          $scope.errors = ['Something goes wrong and we can\'t load folios for that booking.'];
          console.error(response);
        }
      );
  }

  function loadDiscounts(params) {
    params.pagination = { page: 1, limit: 100 };
    try {
      if ($rootScope.hotel && $rootScope.hotel.id) {
        var discountsFactory = new DiscountsFactory();
        return discountsFactory.getDiscounts($rootScope.hotel.id, params).then(function (data) {
          if (data.data && data.data.discounts) {
            $scope.discounts = data.data.discounts.map(function(d) {
              d.amount = Number(d.amount);
              return d;
            });
            return $scope.discounts;
          }
        })
      } else {
        Promise.resolve([]);
      }
    } catch (e) {
      console.error(e, 'Discounts');
    }
  }
  function updateAccomodations(checked) {
    $scope.folios[$scope.activeFolio].folioRooms.forEach(function(folioRoom) {
      toggleFolioRoomSelection(folioRoom, checked);
    })
  }
  function updateAccomodationsByRoom(checked, room) {
    $scope.folios[$scope.activeFolio].folioRooms.forEach(function(folioRoom) {
      if (folioRoom.room === room) {
        toggleFolioRoomSelection(folioRoom, checked);
      }
    })
  }
  function updateExtras(checked) {
    $scope.folios[$scope.activeFolio].extraItems.forEach(function(extraItem) {
      touchSelectedItemsCount(extraItem, checked);
    })
  }
  function updateExtrasByRoom(checked, room) {
    $scope.folios[$scope.activeFolio].extraItems.forEach(function(extraItem) {
      if (extraItem.room === room || !extraItem.room && room === 'none') {
        touchSelectedItemsCount(extraItem, checked);
      }
    })
  }
  function selectAccomodationsAndExtras(dropdownValue, range, checked) {
    if (range === 'all') {
      switch(dropdownValue) {
        case '1':
          updateAccomodations(checked);
          updateExtras(checked);
          break;
        case '2':
          updateAccomodations(checked);
          updateExtras(!checked);
          break;
        case '3':
          updateAccomodations(!checked);
          updateExtras(checked);
          break;
      }
    } else {
      switch(dropdownValue) {
        case '1':
          updateAccomodationsByRoom(checked, range);
          updateExtrasByRoom(checked, range);
          break;
        case '2':
          updateAccomodationsByRoom(checked, range);
          updateExtrasByRoom(!checked, range);
          break;
        case '3':
          updateAccomodationsByRoom(!checked, range);
          updateExtrasByRoom(checked, range);
          break;
      }
    }
    prepareAccomodationAndExtras();
  }

  function prepareAccomodationAndExtras() {
    if ($scope.activeFolio === null || !$scope.folios[$scope.activeFolio]) {
      return;
    }
    var unasignedExtraItems = [];
    var accomodationsAndExtrasByRoom = $scope.folios[$scope.activeFolio].folioRooms.map(function(fr) {
      return {
        room: fr.room,
        folioRoom: fr,
        extraItems: [],
      }
    });
    var hasAccomodationsInitially = accomodationsAndExtrasByRoom.length > 0;
    var extrasRoom = [];
    $scope.folios[$scope.activeFolio].extraItems.forEach(function(ei) {
      if (ei.room) {
        if (hasAccomodationsInitially) {
          accomodationsAndExtrasByRoom = accomodationsAndExtrasByRoom.map(function(ac) {
            if (ac.room === ei.room) {
              var updatedAc = ac;
              updatedAc.extraItems.push(ei);
              return updatedAc;
            }
            return ac;
          });
        } else {
          // if there are extras without accomodation
          if (accomodationsAndExtrasByRoom.length > 0 && _.contains(extrasRoom, ei.room)) {
            accomodationsAndExtrasByRoom = accomodationsAndExtrasByRoom.map(function(item) {
              if (item.room === ei.room) {
                var updatedAc = item;
                updatedAc.extraItems.push(ei);
                return updatedAc;
              }
              return item;
            });
          } else {
            extrasRoom.push(ei.room);
            accomodationsAndExtrasByRoom.push({
              room: ei.room,
              extraItems: [ei],
            });
          }
        }
      } else {
        unasignedExtraItems.push(ei);
      }
    });
    accomodationsAndExtrasByRoom.push({
      room: 'none',
      extraItems: unasignedExtraItems
    });
    $scope.accomodationsAndExtrasByRoom = accomodationsAndExtrasByRoom;
  }

  function prepareOtherBookingCustomers() {
    $scope.otherBookingCustomers = $scope.folios.reduce(function (customers, folio) {
      if (!customers.find(function(c) { return c.id === folio.customer.id; })) {
        customers.push(folio.customer);
      }
      return customers;
    }, []);

    var customers = $scope.folios.map(function(el) { return el.customer; })

    var customerIds = customers.map(function(customer) { return customer.id; });
    $scope.booking.customers = _.uniq(customerIds).map(function(customerId) {
      return customers.filter(function(customer) {return customer.id == customerId})[0];
    });
  }

  function prepareBookingGuests() {
    var customerNames = $scope.booking.customers.map(function(customer) {
      return customer.visibleName;
    });

    $scope.bookingGuests = _.uniq(
      _.flatten(
        $scope.booking.rooms.map(function(room) {return room.guests})
      )
    ).map(function(guest) {
      guest.visibleName = [guest.firstName, guest.lastName].join(' ');
      return guest;
    })
    .filter(function(guest) {
      return customerNames.indexOf(guest.visibleName) == -1;
    });
  }
  
  function openFolio(folio_index) {
    $scope.activeFolio = folio_index;
    switchToRoomViewFolio();
  }

  function switchToRoomViewFolio() {
    if ($scope.viewFoliosBy === 'room') {
      setViewFoliosBy('category');
      prepareAccomodationAndExtras();
    } else {
      prepareAccomodationAndExtras();
    }
  }

  function addFolio() {
    $rootScope.isDisabledPusherEvents = true;
    $scope.addFolioInProgress = true;
    new FolioFactory({
      hotelId: hotelId,
      bookingId: bookingId
    })
      .create()
      .then(function (response) {
        $scope.addFolioInProgress = false;
        $scope.folios.push(prepareFolio(response));
        $scope.activeFolio = $scope.folios.length - 1;
        switchToRoomViewFolio();
        prepareNavigation();
      })
      .finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      });
  }

  function removeFolio() {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        $rootScope.isDisabledPusherEvents = true;
        var folio = $scope.folios[$scope.activeFolio]
        $scope.folios = _.without($scope.folios, folio);
        prepareNavigation();
        $scope.activeFolio === 0 ? null : $scope.activeFolio--;
        switchToRoomViewFolio();

        folio.remove().finally(function () {
          $rootScope.isDisabledPusherEvents = false;
        });
      }
    });
  }

  function _cleanUpFolioItem(folioItem) {
    folioItem.selected = false;
    return folioItem;
  }

  function prepareFolio(folio) {
    var blocks = ['accomodation', 'extra'];

    folio.customerEditFormIsOpened = false;
    folio.discountFormIsOpened = false;
    folio.discountAmount = 0;
    folio.discountIsPercent = true;
    folio.selectedDiscount = null;
    folio.saveFolioDiscount = false;
    folio.moveItemsInProgress = false;
    folio.moveInterfaceIsOpened = false;
    folio.selectedCustomer = null;
    folio.findCustomerFormIsOpened = false
    folio.editableNote = null;
    folio.noteEditIsEnabled = false;
    folio.overlayEditIsEnabled = false;
    folio.overrideNoteEditIsEnabled = false;
    folio.printLoading = false;

    folio.folioItems = folio.folioItems.map(_cleanUpFolioItem);

    folio.accomodationItems = folio.folioItems.filter(function(item) {
      return item.calculableType === 'RoomPricePerNight';
    });
    folio.extraItems = folio.folioItems.filter(function(item) {
      return item.calculableType === 'BookingExtra';
    });

    blocks.forEach(function(block) {
      folio[block + 'TotalNet'] = folio[block + 'Items']
        .map(function(item) { return item.net; })
        .reduce(function(acc, val) { return acc + Number(val); }, 0);
      folio[block + 'TotalTax'] = folio[block + 'Items']
        .map(function(item) { return item.taxes.total; })
        .reduce(function(acc, val) { return acc + Number(val); }, 0);
      folio[block + 'TotalAmount'] = folio[block + 'Items']
        .map(function(item) { return item.amountWithTaxes; })
        .reduce(function(acc, val) { return acc + Number(val); }, 0);
    });

    folio.totalPaid = folio.folioPayments
      .map(function(payment) {
        return payment.amount;
      }).reduce(function(acc, val) {
        return acc + Number(val);
      }, 0);

    folio.totalCharged = folio.folioPayments
      .filter(function(payment) {
        return payment.calculable;
      })
      .map(function(payment) {
        return payment.amount;
      }).reduce(function(acc, val) {
        return acc + Number(val);
      }, 0);

    var taxes = [];
    folio.folioItems.forEach(function(folioItem) {
      taxes = _.union(taxes, folioItem.taxes.excluded, folioItem.taxes.included);
    });

    folio.folioRooms.forEach(function(folioRoom, roomIndex) {
      folioRoom.taxes.excluded.forEach(function(tax, taxIndex) {
        tax.calculationLogic = $rootScope.hotel.newTaxes.filter(function(t) {return t.id == tax.taxId})[0].calculationLogic;
      });
      folioRoom.taxes.included.forEach(function(tax, taxIndex) {
        tax.calculationLogic = $rootScope.hotel.newTaxes.filter(function(t) {return t.id == tax.taxId})[0].calculationLogic;
      });
    });

    folio.taxes = _.values(_.groupBy(taxes, function(tax) {
      return tax.tax + tax.value + tax.calculationLogic + tax.calculationMethod;
    })).map(function(taxGroup) {
      var withoutTaxedAmount = taxGroup.filter(function(tax) {
        return typeof(tax.taxedAmount) !== 'number'
      });
      if (withoutTaxedAmount.length > 0) {
        taxedAmount = null;
      } else {
        taxedAmount = taxGroup.map(function(tax) {return tax.taxedAmount || 0}).reduce(function(acc, val) {return acc + Number(val)}, 0);
      }
      return {
        tax: taxGroup[0].tax,
        taxId: taxGroup[0].taxId,
        value: taxGroup[0].value,
        childValue: taxGroup[0].childValue,
        mode: taxGroup[0].mode,
        amount: taxGroup.map(function(tax) {return tax.amount}).reduce(function(acc, val) {return acc + Number(val)}, 0),
        taxedAmount: taxedAmount,
        calculationLogic: taxGroup[0].calculationLogic,
        calculationMethod: taxGroup[0].calculationMethod,
        selected: false
      };
    });

    folio.haveFeeOrCityTax = folio.taxes.filter(feeOrCityTaxFilter).length > 0;

    folio.accomodationItemsById = folio.accomodationItems.reduce(function(acc, el) {
      acc[el.id] = el;
      return acc;
    }, {});

    folio.canBeRemoved = folio.accomodationItems.length == 0 && folio.extraItems.length == 0 && folio.folioPayments.length == 0;

    folio.totalDiscount = _.flatten(
      folio.folioItems.map(
        function(fi) {
          return fi.folioDiscounts
        }
      )
    )
      .map(function(discount) {
        return Number(discount.amount);
      })
      .reduce(function(acc, discount) {
        return acc + discount;
      }, 0);

    return folio;
  }

  function getPaymentsAndPrepaymentsFromFolio(folio) {
    if (folio.status != 'folio') return;

    folio.folioItems.filter(function(fi) {
      if (fi.calculableType != 'BookingExtra') return false;
      return fi.extraId == $rootScope.hotel.depositExtraId;
    }).forEach(function(fi) {
      $scope.availablePayments.push({amount: fi.amount * -1, paymentType: 'Prepayment', folioId: folio.id, folioNumber: folio.visibleNumber, id: fi.id});
    });

    folio.folioPayments.forEach(function(p) {
      if (p.calculable)
        $scope.availablePayments.push({amount: p.amount, paymentType: p.paymentType, folioId: folio.id, folioNumber: folio.visibleNumber, id: p.id});
    });
  }

  function changeSelectedPayments() {
    var sum = 0;
    $scope.availablePayments.forEach(function(p) { sum += p.selected ? parseFloat(p.amount) : 0; });
    $scope.moveAndDoReceiptAllowed = sum.toFixed(2) == parseFloat($scope.folios[$scope.activeFolio].due).toFixed(2) ? true : false;
  }

  function movePaymentsAndCreateReceipt() {
    changeSelectedPayments()
    if (!$scope.moveAndDoReceiptAllowed || activeFolio().createInvoiceInProgress) return false;

    var payments = $scope.availablePayments.filter(function(e) { return e.selected && e.paymentType != 'Prepayment'; }).map(function(p) { return {id: p.id, folioId: p.folioId}; });
    var deposits = $scope.availablePayments.filter(function(e) { return e.selected && e.paymentType == 'Prepayment'; }).map(function(p) { return {id: p.id, folioId: p.folioId}; });

    $rootScope.isDisabledPusherEvents = true;
    activeFolio().createInvoiceInProgress = true;
    activeFolio()
      .movePaymentsAndCreateReceipt(payments, deposits)
      .finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      })
  }

  function _prepareMoveItem(el) {
    el.min = Math.min(Number(el.amount), 0);
    el.max = Math.max(Number(el.amount), 0);
    el.currentFolio = el.selected ? el.min : el.max;
    el.targetFolio = el.selected ? el.max : el.min;
    el.currentFolioPercent = el.selected ? 0 : 100;
    el.targetFolioPercent = el.seleceted ? 100 : 0;
    el.currentFolioCount = el.selected ? 0 : el.count;
    el.targetFolioCount = el.selected ? el.count : 0;
    el.move = el.selected;
    el.mode = 'amount';
  }

  function _prepareMoveTax(el) {
    el.move = el.selected;
  }

  function _prepareMovePayment(el) {
    el.title = el.paymentType + ' ' + el.operation;
    el.min = Math.min(Number(el.amount), 0);
    el.max = Math.max(Number(el.amount), 0);
    el.currentFolio = el.amount > 0 ? el.min : el.max;
    el.targetFolio = el.amount > 0 ? el.max : el.min;
    el.currentFolioPercent = 0;
    el.targetFolioPercent = 100;
    el.move = el.selected;
    el.mode = 'amount';
  }

  function _prepareMoveRoom(el) {
    el.nights = el
      .folioItems
      .map(function(id) {return activeFolio().accomodationItemsById[id]});
    
    el.filteredFolioItems = el.nights
      .filter(function(night) {
        return night.selected;
      })
      .map(function(night) {
        return night.id;
      });

    el.min = Math.min(Number(el.amount), 0);
    el.max = Math.max(Number(el.amount), 0);
    el.currentFolio = el.nights
      .filter(function(el) {return !el.selected})
      .map(function(el) {return Number(el.amount)})
      .reduce(function(acc, val) {return acc + val}, 0);
    el.targetFolio = el.max - el.currentFolio;
    el.currentFolioPercent = el.currentFolio / el.max / 100;
    el.targetFolioPercent = 100 - el.currentFolioPercent;
    el.currentFolioCount = el.nights.filter(function(el) {return !el.selected}).length;
    el.targetFolioCount = el.count - el.currentFolioCount;
    el.mode = 'amount';

    return el;
  }

  function _setSelectedFolioRooms(room) {
    room.selectedAtLeastOne = room.folioItems
      .map(function(folioItemId) {
        return activeFolio().accomodationItemsById[folioItemId].selected;
      })
      .reduce(function(acc, val) {
        return acc || val;
      }, false);
    return room;
  }

  function setViewFoliosBy(viewBy) {
    $scope.viewFoliosBy = viewBy;
  }

  function moveItems(target) {
    $scope.moveItemsTarget = target ? target.id : undefined;
    $scope.moveItemsTargetName = target ? target.visibleNumber : $i18next.t('bookings.folios.new_folio');

    if (!target || target.status === 'folio') {
      activeFolio()
        .extraItems
        .forEach(_prepareMoveItem);

      activeFolio()
        .taxes
        .forEach(_prepareMoveTax);

      activeFolio()
        .accomodationItems
        .forEach(_prepareMoveItem);

      activeFolio()
        .folioRooms
        .map(_setSelectedFolioRooms)
        .filter(function(el) { return el.selectedAtLeastOne; })
        .forEach(_prepareMoveRoom);
    }

    activeFolio()
      .folioPayments
      .filter(function(el) { return el.selected; })
      .forEach(_prepareMovePayment);

    activeFolio().taxesMoveIsVisible = !(
      activeFolio()
        .extraItems
        .filter(function(el) { return el.selected; })
        .length > 0
      ||
      activeFolio()
        .accomodationItems
        .filter(function(el) { return el.selected; })
        .length > 0
    );

    activeFolio().moveInterfaceIsOpened = true;
  }

  function openDropDown($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  }

  function touchSelectedItemsCount(folioItem, selected) {
    if (selected !== undefined) {
      // addition for react part
      $scope.folios[$scope.activeFolio].extraItems.forEach(function(extraItem) {
        if (extraItem.id === folioItem.id) {
          extraItem.selected = selected;
        }
      })
    }
    folioItem.selected ? $scope.selectedItemsCount++ : $scope.selectedItemsCount--;
    if (folioItem.calculableType) {
      folioItem.selected ? $scope.selectedPayableItemsCount++ : $scope.selectedPayableItemsCount--;
    }

    if (folioItem.calculableType === 'RoomPricePerNight') {
      _normalizeSelectedRoom();
    }
    if (selected !== undefined) {
      // addition for react part
      $scope.$apply();
    }
  }

  function _normalizeSelectedRoom() {
    activeFolio().folioRooms.forEach(function(folioRoom) {
      folioRoom.selected = folioRoom
        .folioItems
        .map(function(folioItemId) {
          return activeFolio().accomodationItemsById[folioItemId].selected;
        })
        .reduce(function(acc, val) {
          return acc && val;
        }, true);

      folioRoom = _setSelectedFolioRooms(folioRoom);

      $('[data-room-check="' + activeFolio().id + '-' + folioRoom.id + '"]').prop(
        'indeterminate',
        !folioRoom.selected && folioRoom.selectedAtLeastOne == true
      )
    });
  }

  function toggleShowTaxBreakdown(folioItem) {
    folioItem.showTaxBreakdown = !Boolean(folioItem.showTaxBreakdown);
  }

  function toggleShowNightBreakdown(folioItem) {
    folioItem.showNightBreakdown = !Boolean(folioItem.showNightBreakdown);
  }

  function enableNoteEditMode() {
    activeFolio().editableNote = activeFolio().note;
    activeFolio().noteEditIsEnabled = true;
    setTimeout(function() {
      $('.folios--notes--editableNote').focus();
    }, 20);
  }

  function disableNoteEditMode(save) {
    if (save) {
      activeFolio().note = activeFolio().editableNote;
      activeFolio()
        .save()
        .then(function(response) {
          activeFolio().noteEditIsEnabled = false;
        });
    } else {
      activeFolio().noteEditIsEnabled = false;
    }
  }

  function enableOverlayEditMode() {
    activeFolio().editableOverlay = activeFolio().overlayText;
    activeFolio().overlayEditIsEnabled = true;
    setTimeout(function() {
      $('.folios--notes--editableOverlay').focus();
    }, 20);
  }

  function disableOverlayEditMode(save) {
    if (save) {
      activeFolio().overlayText = activeFolio().editableOverlay;
      activeFolio()
        .save()
        .then(function(response) {
          activeFolio().overlayEditIsEnabled = false;
        });
    } else {
      activeFolio().overlayEditIsEnabled = false;
    }
  }

  function enableOverrideNoteEditMode() {
    activeFolio().editableOverrideNote = activeFolio().noteOverride;
    activeFolio().overrideNoteEditIsEnabled = true;
    setTimeout(function() {
      $('.folios--notes--editableOverrideNote').focus();
    }, 20);
  }

  function disableOverrideNoteEditMode(save) {
    if (save) {
      activeFolio().noteOverride = activeFolio().editableOverrideNote;
      activeFolio()
        .save()
        .then(function(response) {
          activeFolio().overrideNoteEditIsEnabled = false;
        });
    } else {
      activeFolio().overrideNoteEditIsEnabled = false;
    }
  }

  function openCustomerEditForm(field) {
    activeFolio().customerEditFormIsOpened = true;
    if (field) {
      setTimeout(function() {
        document.querySelector('[name="'+field+'"]').focus();
      }, 100);
    }
  }

  function closeCustomerEditForm() {
    if (activeFolio().originalCustomer) {
      activeFolio().customer = angular.copy(activeFolio().originalCustomer);
      activeFolio().originalCustomer = null;
    }

    activeFolio().customerEditFormIsOpened = false;
    $scope.folios.filter(function(folio) {
      return folio.customer.id == activeFolio().customer.id;
    }).forEach(function(folio) {
      folio.customer = activeFolio().customer;
    });
    prepareOtherBookingCustomers();
    prepareBookingGuests();
  }

  function changeCustomerTo(customerId) {
    $rootScope.isDisabledPusherEvents = true;
    activeFolio().customerId = customerId;
    activeFolio()
      .save()
      .then(function(response) {
        prepareOtherBookingCustomers();
        prepareBookingGuests();
      })
      .finally(function() {
        $rootScope.isDisabledPusherEvents = false;
      });
  }

  function changeGuestToCustomer(guest) {
    $rootScope.isDisabledPusherEvents = true;
    if (guest.customerId) {
      new CustomerFactory({
        bookingId:    bookingId,
        hotelId:      hotelId,
        id:           guest.customerId
      })
        .get()
        .then(function(customer) {
          activeFolio().originalCustomer = null;
          activeFolio().customer = customer;
          changeCustomerTo(customer.id);
        })
        .finally(function() {
          $rootScope.isDisabledPusherEvents = false;
        })
    } else {
      var customer = new CustomerFactory({
        bookingId:    bookingId,
        hotelId:      hotelId,
        address:      guest.address,
        city:         guest.city,
        country:      guest.country,
        email:        guest.email,
        firstName:    guest.firstName,
        lastName:     guest.lastName,
        mobile_phone: guest.phone,
        zipCode:      guest.zipCode,
        guestId:      guest.id
      });
  
      customer
        .save()
        .then(function(customer) {
          activeFolio().originalCustomer = null;
          activeFolio().customer = customer;
          changeCustomerTo(customer.id);
        })
        .finally(function() {
          $rootScope.isDisabledPusherEvents = false;
        })
    }
  }

  function reloadFolios() {
    var lastActiveFolio = $scope.activeFolio;
    load()
      .then(function () {
        $scope.activeFolio = lastActiveFolio;
      });
  }

  function createNewCustomer() {
    activeFolio().originalCustomer = angular.copy(activeFolio().customer);
    activeFolio().customer = new CustomerFactory({
      bookingId: bookingId,
      hotelId: hotelId
    });
    activeFolio().customerEditFormIsOpened = true;
  }

  function setNewCustomer(customer) {
    activeFolio().originalCustomer = null;
    activeFolio().customer = customer;

    changeCustomerTo(customer.id);
    closeCustomerEditForm();
  }

  function activeFolio() {
    return $scope.folios[$scope.activeFolio];
  }

  function toggleFindCustomerForm() {
    activeFolio().selectedCustomer = null;
    activeFolio().findCustomerFormIsOpened = !Boolean(activeFolio().findCustomerFormIsOpened);
  }

  function chooseCustomer(customer) {
    activeFolio().selectedCustomer = customer;
  }

  function applyFindedCustomer() {
    if (activeFolio().selectedCustomer) {
      changeCustomerTo(activeFolio().selectedCustomer.id);
    }
    toggleFindCustomerForm();
  }

  function openAddDiscountForm() {
    activeFolio().discountFormIsOpened = true;
  }

  function closeAddDiscountForm() {
    activeFolio().discountFormIsOpened = false;
    activeFolio().discountAmount = 0;
    activeFolio().discountIsPercent = true;
    activeFolio().selectedDiscount = null;
    activeFolio().saveFolioDiscount = false;
  }

  function searchDiscount(term) {
    return loadDiscounts({ term: term });
  }
  
  function chooseDiscount(discount) {
    if (discount) {
      activeFolio().selectedDiscount = discount;
      activeFolio().discountAmount = discount.amount;
      activeFolio().discountIsPercent = discount.percent;
    } else {
      activeFolio().selectedDiscount = null;
    }
  }

  function applyDiscount() {
    var ids = _.union(
      activeFolio().accomodationItems,
      activeFolio().extraItems
    )
      .filter(function(el) {
        return el.selected;
      })
      .map(function(el) {
        return el.id;
      });


    if (ids && (activeFolio().selectedDiscount || this.discountQuery)) {
      $rootScope.isDisabledPusherEvents = true;
      activeFolio().saveFolioDiscount = true;
      new FolioFactory({
        hotelId: hotelId,
        bookingId: bookingId
      })
        .applyDiscount(
          ids,
          activeFolio().selectedDiscount && activeFolio().selectedDiscount.id,
          activeFolio().discountIsPercent,
          activeFolio().discountAmount,
          this.discountQuery,
          activeFolio().isForeignAmount
        )
        .then(function () {
          reloadFolios();
        })
        .finally(function () {
          closeAddDiscountForm();
          $rootScope.isDisabledPusherEvents = false;
        })
    }
  }

  function removeDiscount(folioDiscountId) {
    $rootScope.isDisabledPusherEvents = true;
    new FolioFactory({
      hotelId: hotelId,
      bookingId: bookingId
    })
      .removeDiscount(
        folioDiscountId
      )
      .then(function(response) {
        if (!response.data.success) {
          $rootScope.notify('Error: ' + response.data.error);
        }
      })
      .finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      });
  }

  function changeDiscount(field, value) {
    activeFolio()[field] = value;
  }

  function closeMoveInterface() {
    activeFolio().moveItemsInProgress = false;
    activeFolio().moveInterfaceIsOpened = false;
  }

  function handleMoveItemsError(error) {
    closeMoveInterface();
    if (error.status === 400) { $rootScope.notify(error.data.errors, 'error'); }
  }

  function submitMoveInterface() {
    var folioItems = _.union(
      activeFolio().accomodationItems,
      activeFolio().extraItems
    )
      .filter(function(el) { return el.selected && ((el.targetFolio && el.targetFolio != 0) || (el.targetFolio == 0 && el.amount == 0)); })
      .map(function(el) { return [el.id, el.targetFolio]; });
    
    var paymentItems = activeFolio().folioPayments
      .filter(function(el) { return el.selected && (el.targetFolio && el.targetFolio != 0); })
      .map(function(el) { return [el.id, el.targetFolio]; });

    var taxItems = activeFolio().taxes
      .filter(function(el) { return el.selected })
      .map(function(el) { return el.taxId; });

    activeFolio().moveItemsInProgress = true;

    if (folioItems.length > 0 || paymentItems.length > 0) {
      $rootScope.isDisabledPusherEvents = true;
      new FolioFactory({
        hotelId: hotelId,
        bookingId: bookingId
      })
        .moveItems($scope.moveItemsTarget, folioItems, paymentItems)
        .then(function(response) {
          closeMoveInterface();
          var targetFolioId = response.data.targetFolioId;
          load().then(function() {
            var target = $scope.folios.filter(function (folio) {
              return folio.id == targetFolioId;
            });
            if (target.length > 0) {
              $scope.activeFolio = $scope.folios.indexOf(target[0]);
              switchToRoomViewFolio();
            }
          });
        })
        .catch(function (error) {
          handleMoveItemsError(error);
        })
        .finally(function () {
          $rootScope.isDisabledPusherEvents = false;
        });
    } else if (taxItems.length > 0) {
      $rootScope.isDisabledPusherEvents = true;
      new FolioFactory({
        hotelId: hotelId,
        bookingId: bookingId
      })
        .moveTaxes($scope.moveItemsTarget, activeFolio().id, taxItems)
        .then(function(response) {
          closeMoveInterface();
          var targetFolioId = response.data.targetFolioId;
          load().then(function() {
            var target = $scope.folios.filter(function (folio) {
              return folio.id == targetFolioId;
            });
            if (target.length > 0) {
              $scope.activeFolio = $scope.folios.indexOf(target[0]);
              switchToRoomViewFolio();
            }
          });
        })
        .finally(function () {
          $rootScope.isDisabledPusherEvents = false;
        });
    } else {
      activeFolio().moveItemsInProgress = false;
    }
  }

  function changeNightTargetPart(item, room) {
    changeTargetPart(item);
    room.currentFolio = room.nights
      .map(function(el) {return Number(el.currentFolio)})
      .reduce(function(acc, val) {return acc + val}, 0);
    room.targetFolio = room.max - room.currentFolio;
    room.currentFolioPercent = room.currentFolio / room.max / 100;
    room.targetFolioPercent = 100 - room.currentFolioPercent;
  }

  function changeTargetPart(item) {
    switch (item.mode) {
      case 'amount':
        changeTargetPartAmount(item);
        break;
      case 'percent':
        changeTargetPartPercent(item);
        break;
      case 'count':
        changeTargetPartCount(item);
        break;
      default:
        break;
    }
  }

  function changeCurrentPart(item) {
    switch (item.mode) {
      case 'amount':
        changeCurrentPartAmount(item);
        break;
      case 'percent':
        changeCurrentPartPercent(item);
        break;
      case 'count':
        changeCurrentPartCount(item);
        break;
      default:
        break;
    }
  }

  function changeTargetPartAmount(item) {
    item.currentFolio = Number(item.amount) - item.targetFolio;
    item.targetFolioPercent = Number((item.targetFolio / (Number(item.amount) / 100)).toFixed(2));
    item.currentFolioPercent = Number((100 - item.targetFolioPercent).toFixed(2));
  }

  function changeTargetPartPercent(item) {
    item.targetFolio = Number(((Number(item.amount) / 100) * item.targetFolioPercent).toFixed(2));
    item.currentFolio = Number((Number(item.amount) - item.targetFolio).toFixed(2));
    item.currentFolioPercent = Number((100 - item.targetFolioPercent).toFixed(2));
  }

  function changeTargetPartCount(item) {
    item.targetFolio = Number(((Number(item.amount) / item.count) * item.targetFolioCount).toFixed(2));
    item.currentFolio = Number(item.amount) - item.targetFolio;
    item.currentFolioCount = Number((item.count - item.targetFolioCount).toFixed(2));
    item.targetFolioPercent = Number((item.targetFolio / (Number(item.amount) / 100)).toFixed(2));
    item.currentFolioPercent = Number((100 - item.targetFolioPercent).toFixed(2));
  }

  function changeCurrentPartAmount(item) {
    item.targetFolio = Number(item.amount) - item.currentFolio;
    item.targetFolioPercent = Number((item.targetFolio / (Number(item.amount) / 100)).toFixed(2));
    item.currentFolioPercent = Number((100 - item.targetFolioPercent).toFixed(2));
  }

  function changeCurrentPartPercent(item) {
    item.currentFolio = Number(((Number(item.amount) / 100) * item.currentFolioPercent).toFixed(2));
    item.targetFolio = Number((Number(item.amount) - item.currentFolio).toFixed(2));
    item.targetFolioPercent = Number((100 - item.currentFolioPercent).toFixed(2));
  }

  function changeCurrentPartCount(item) {
    item.currentFolio = Number(((Number(item.amount) / item.count) * item.currentFolioCount).toFixed(2));
    item.targetFolio = Number(item.amount) - item.currentFolio;
    item.targetFolioCount = Number((item.count - item.currentFolioCount).toFixed(2));
    item.targetFolioPercent = Number((item.targetFolio / (Number(item.amount) / 100)).toFixed(2));
    item.currentFolioPercent = Number((100 - item.targetFolioPercent).toFixed(2));
  }

  function switchMode(item, mode) {
    item.mode = mode;
    if (item.nights && item.nights.forEach) {
      item.nights.forEach(function(el) {
        switchMode(el, mode)
      });
    }
  }

  function setPredefinedMoveValue(item, value) {
    switch (value) {
      case 0:
        item.currentFolio = Number(item.amount);
        break;
      case 50:
        item.currentFolio = Number(item.amount) / 2;
        break;
      case 100:
        item.currentFolio = 0;
        break;
      default:
        break;
    }
    changeCurrentPartAmount(item);
    if (item.nights && item.nights.forEach) {
      item.nights.forEach(function(el) {
        setPredefinedMoveValue(el, value)
      });
    }
  }

  function _normalizeNights(item) {
    item.nights = item.nights.map(function(night, index) {
      if (index + 1 <= item.targetFolioCount) {
        night.selected = true;
        night.price = night.original;
        night.nonMovedPrice = 0;
      } else {
        night.selected = false;
        night.price = 0;
        night.nonMovedPrice = night.original;
      }
      return night;
    });
  }

  function _calcCountPrice(item) {
    item.sliderIsDisabled = false;
    _normalizeNights(item);
    item.targetFolio = item.nights
      .filter(function(el) { return el.selected; })
      .map(function(night) { return night.price; })
      .reduce(function(acc, price) { return acc + price; }, 0);
    changeTargetPartAmount(item);
  }

  function isContinuousNights(item) {
    var count = item.nights.length;
    var firstFalseIndex = -1;
    var nonSelectedItems = item.nights.filter(function(night) {
      return !night.selected;
    });

    if (nonSelectedItems.length > 0) {
      firstFalseIndex = item.nights.indexOf(nonSelectedItems[0]);
      return item.nights
        .slice(firstFalseIndex, count)
        .map(function(night) { return night.selected; })
        .reduce(function(acc, el) { return acc && !el }, true);
    } else {
      return true;
    }
  }

  function changeCountCurrentPart(item) {
    if (item.nights) {
      item.targetFolioCount = item.count - item.currentFolioCount;
      _calcCountPrice(item);
    } else {
      changeCurrentPart(item);
    }
  }

  function changeCountTargetPart(item) {
    if (item.nights) {
      _calcCountPrice(item)
    } else {
      changeTargetPart(item);
    }
  }

  function toggleNight(item, night) {
    night.currentFolio = night.selected ? 0 : Number(night.amount);
    night.targetFolio = night.selected ? Number(night.amount) : 0;
    item.targetFolio = item.nights
      .filter(function(el) { return el.selected; })
      .map(function(night) { return night.targetFolio; })
      .reduce(function(acc, price) { return acc + price; }, 0);

    changeTargetPartAmount(item);

    if (isContinuousNights(item)) {
      item.targetFolioCount = item.nights.filter(function(el) {
        return el.selected
      }).length;
      item.currentFolioCount = item.count - item.targetFolioCount;
      item.sliderIsDisabled = false;
    } else {
      item.sliderIsDisabled = true;
    }
  }

  function toggleFolioRoomSelection(folioRoom, selected) {
    if (selected !== undefined) {
      // addition for react part
      folioRoom.selected = selected
    }
    folioRoom.folioItems
      .forEach(function(itemId) {
        activeFolio().accomodationItemsById[itemId].selected = folioRoom.selected;
      });
    folioRoom.folioItems
      .forEach(function(itemId) {
        touchSelectedItemsCount(activeFolio().accomodationItemsById[itemId]);
      });
    if (selected !== undefined) {
      // addition for react part
      $scope.$apply();
    }
  }

  function nightsComparator(id) {
    return activeFolio().accomodationItemsById[id].title;
  }

  function createInvoice() {
    if (activeFolio().createInvoiceInProgress === true) {
      return false;
    }

    var depositExtras = activeFolio().extraItems.filter(function(e) {
      return e.extraId == $rootScope.hotel.depositExtraId;
    });

    if (depositExtras.length > 0) {
      $rootScope.notify($i18next.t('booking.folios.convert_invoice_failed_due_prepayment'));
      return false;
    }

    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('booking.folios.invoice_warning'),
      positive_callback: function () {
        activeFolio().createInvoiceInProgress = true;
        activeFolio()
          .createInvoice()
          .then(load);
      }
    });
  }

  function createReceipt() {
    if (activeFolio().due != 0) {
      $rootScope.notify($i18next.t('booking.folios.convert_receipt_failed_due_non_zero'));
      return false;
    }

    var depositExtras = activeFolio().extraItems.filter(function(e) {
      return e.extraId == $rootScope.hotel.depositExtraId;
    });

    if (depositExtras.length > 0) {
      text = $i18next.t('booking.folios.prepayment_warning') + '<br>' + $i18next.t('booking.folios.receipt_warning')
    } else {
      text = $i18next.t('booking.folios.receipt_warning');
    }
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: text,
      positive_callback: function () {
        $rootScope.isDisabledPusherEvents = true;
        activeFolio().createInvoiceInProgress = true;
        activeFolio()
          .createReceipt()
          .then(load)
          .then(prepareNavigation)
          .finally(function() {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });

  }

  function voidFolio() {
    if (activeFolio().voidInProgress === true) {
      return false;
    }

    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        activeFolio().voidInProgress = true;
        activeFolio()
          .void()
          .catch(function(response) {
            $rootScope.notify(response.data && response.data.error ? response.data.error : "Server error");
            activeFolio().voidInProgress = false;
          });
      }
    });
  }

  function creditFolio() {
    if (activeFolio().creditInProgress === true) {
      return false;
    }

    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        activeFolio().creditInProgress = true;
        activeFolio()
          .credit()
          .catch(function(response) {
            $rootScope.notify(response.data && response.data.error ? response.data.error : "Server error");
            activeFolio().creditInProgress = false;
          });
      }
    });
  }

  function moveToFilter(el) {
    return $scope.allowedToMoveTypes.indexOf(el.status) > -1 && el.id !== activeFolio().id;
  }

  function openPaymentsTab($event) {
    var paymentTab = $scope.is_mobile ? 5 : 4;
    $scope.openTab($event, paymentTab);
  }

  function _saveFolioNumber() {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        activeFolio().number = activeFolio().editableNumber;
        activeFolio()
          .save()
          .then(function(response) {
            activeFolio().numberEditFormIsOpened = false;
            prepareNavigation();
        });
      }
    });
  }

  function toggleEditFolioNumber(save) {
    switch (save) {
      case true:
        _saveFolioNumber();
        break;
      case false:
        activeFolio().editableNumber = activeFolio().number;
        activeFolio().numberEditFormIsOpened = false;
        break;
      default:
        activeFolio().editableNumber = activeFolio().number;
        activeFolio().numberEditFormIsOpened = !Boolean(activeFolio().numberEditFormIsOpened);
        break;
    }
  }

  function toggleEditFolioDate(save) {
    switch (save) {
      case true:
        activeFolio().date = moment(activeFolio().editableDate).format('YYYY-MM-DD');
        activeFolio()
          .save()
          .then(function(response) {
            activeFolio().dateEditFormIsOpened = false;
            prepareNavigation();
          });
        break;
      case false:
        activeFolio().editableDate = new Date(activeFolio().date);
        activeFolio().dateEditFormIsOpened = false;
        break;
      default:
        activeFolio().editableDate = new Date(activeFolio().date);
        activeFolio().dateEditFormIsOpened = !Boolean(activeFolio().dateEditFormIsOpened);
        break;
    }
  }

  function toggleEditFolioTaxDate(save) {
    switch (save) {
      case true:
        activeFolio().taxDate = moment(activeFolio().editableTaxDate).format('YYYY-MM-DD');
        activeFolio()
          .save()
          .then(function(response) {
            activeFolio().taxDateEditFormIsOpened = false;
            prepareNavigation();
          });
        break;
      case false:
        activeFolio().editableTaxDate = new Date(activeFolio().taxDate);
        activeFolio().taxDateEditFormIsOpened = false;
        break;
      default:
        activeFolio().editableTaxDate = new Date(activeFolio().taxDate);
        activeFolio().taxDateEditFormIsOpened = !Boolean(activeFolio().taxDateEditFormIsOpened);
        break;
    }
  }

  function sendPaymentRequest() {
    var payableProviders = ["stripe", "braintree", "payment_express", "valitor", "valitor_pay"];
    var originalDue = angular.copy(activeFolio().due);
    var value = $rootScope.currencyFractionSize > 0 ? Math.floor(originalDue * 100) / 100 : Number(Number(originalDue).toFixed(2));
    
    UIDialogService.open('request-payment', {
      title: $i18next.t('bookings.payment.request_payment_title_js_str'),
      value: value,
      providers: $rootScope.hotel.paymentGateways.filter(function(el) {return payableProviders.indexOf(el) != -1}),
      provider: payableProviders.indexOf($rootScope.hotel.paymentGateway) != -1 ? $rootScope.hotel.paymentGateway : $rootScope.hotel.paymentGateways.filter(function(el) {return payableProviders.indexOf(el) != -1})[0],
      max_value: angular.copy(activeFolio().due),
      min_value: 0,
      address: activeFolio().customer.email,
      callback: function (response) {
        $scope.booking.hotelId = $rootScope.hotel.id;
        $scope.booking.sendPaymentRequest(response);
        UIDialogService.close('request-payment');
        $rootScope.notify($i18next.t('bookings.payment.notify.request_sent_successfully_js_str'));
      }
    });
  }

  function toggleFolioItemVisibility(folioItem, isVisible) {
    activeFolio()
      .toggleItemVisibility(folioItem)
      .then(function(el) {
        if (isVisible !== undefined) { // added for react part
          folioItem.isVisible = isVisible;
        } else {
          folioItem.isVisible = !Boolean(folioItem.isVisible);
        }
      });
  }

  function toggleFolioItemComplimentary(folioItem, isComplimentary) {
    activeFolio()
      .toggleItemComplimentary(folioItem)
      .then(function(el) {
        if (isComplimentary !== undefined) { // added for react part
          folioItem.isComplimentary = isComplimentary;
        } else {
          folioItem.isComplimentary = !Boolean(folioItem.isComplimentary);
        }
      });
  }

  function print() {
    activeFolio().printLoading = true;
    $('#pdfFolioDocument').remove();
  
    getDownloadToken(function(token) {
      var path = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' +
                   $scope.booking.id + '/folios/' + token + '/' + activeFolio().id + '.pdf?print=true';
  
      var printWrap = $scope.is_mobile ? $('.booking-management-right-side') : $('#booking-drawer');
  
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = path;
      iframe.name = 'pdfFolio';
      iframe.id = 'pdfFolioDocument';
      iframe.width = '100%';
      iframe.height = '100%';
  
      iframe.onload = function() {
        try {
          setTimeout(function() {
            activeFolio().printLoading = false;
            
            if (iframe.contentWindow) {
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
            } else {
              console.error('Unable to print PDF.');
            }
          }, 100);
        } catch (e) {
          console.error('Unable to print pdf', e);
          activeFolio().printLoading = false;
        }
      };

      printWrap.append(iframe);
    });
  }

  function getDownloadToken(callback) {
    $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/bookings/'+$scope.booking.id + '/folios/' + activeFolio().id + '/token')
      .then(function(response) {
        if (response.data && response.data.token) {
          callback(response.data.token);
        }
      })
  }

  function downloadPDF() {
    getDownloadToken(function(token){
      window.location.href = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/bookings/'+$scope.booking.id+'/folios/'+token+'/'+activeFolio().id+'.pdf';
    })
  }

  function toggleSendInterface(save) {
    switch (save) {
      case true:
        activeFolio()
          .sendTo(activeFolio().email)
          .then(function(response) {
            activeFolio().sendEmailFormIsOpened = false;
          });
        break;
      case false:
        activeFolio().email = activeFolio().customer.email;
        activeFolio().sendEmailFormIsOpened = false;
        break;
      default:
      activeFolio().email = activeFolio().customer.email;
        activeFolio().sendEmailFormIsOpened = !Boolean(activeFolio().sendEmailFormIsOpened);
        break;
    }
  }

  function openEmailsTab($event) {
    var emailTab = $scope.is_mobile ? 6 : 5;
    $scope.openTab($event, emailTab);
  }

  function convertCurrency(amount) {
    return customCurrencyExtended(amount, $scope.$parent.booking, activeFolio().isForeignAmount, $filter, $rootScope);
  }

  function removeTax(tax) {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        $rootScope.isDisabledPusherEvents = true;
        activeFolio()
          .removeTax(tax.id)
          .then(function () {
            reloadFolios();
          })
          .finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });
  }

  function editTax(tax) {
    tax.editMode = true;
  }

  function addTax(folioItem) {
    folioItem.newTax = {
      editMode: true
    };
  }

  function resetTax(tax) {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        $rootScope.isDisabledPusherEvents = true;
        activeFolio()
          .resetTax(tax.id)
          .then(function () {
            reloadFolios();
          })
          .finally(function () {
            $rootScope.isDisabledPusherEvents = false;
          });
      }
    });
  }

  function saveFolioTax(editedTax, folioItemId) {
    var lastActiveFolio = $scope.activeFolio;
    load()
      .then(function() {
        $scope.activeFolio = lastActiveFolio;
      });
  }

  function generateTaxText(tax) {
    switch (tax.calculationLogic) {
      case "percent":
        return tax.value + "% (" + $filter('customCurrency')(tax.taxedAmount) + ")";
        break;
      case "fixed":
        return $filter('customCurrency')(tax.value);
        break;
      case "per_person_per_night":
        if (tax.value == tax.childValue) {
          return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Person Per Night');
        } else if (!tax.childValue) {
          return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Adult Per Night');
        } else {
          return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Adult Per Night') + ', ' + tax.childValue.toFixed(2) + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Children Per Night');
        }
        break;
      case "per_person_per_booking":
        if (tax.value == tax.childValue) {
          return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Person Per Booking')
        } else if (!tax.childValue) {
          return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Adult Per Booking')
        } else {
          return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Adult Per Booking') + ', ' + tax.childValue.toFixed(2) + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Children Per Booking');
        }
        break;
      case "per_room_per_night":
        return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Room Per Night');
        break;
      case "per_room_per_booking":
        return $filter('customCurrency')(tax.value) + ' ' + $i18next.t('general.other.Per Room Per Booking');
        break;
    }
  }

  function feeOrCityTaxFilter(tax) {
    return (tax.mode === 'fee' || tax.mode === 'city_tax') && tax.calculationMethod === 'exclusive';
  }

  function showOperation(payment) {
    var operation = payment.status != 'deposit_refunded' ? payment.operation : 'deposit refund';
    operation = payment.operation != 'prepayment_redeem' ? operation : 'prepayment redeem';
    return operation;
  }

  init();
}

bookingFoliosTab.$inject = ["$rootScope"];

function bookingFoliosTab($rootScope) {
  return {
    controller: bookingFoliosTabController,
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingFoliosTab.html'),
    link: function (scope) {}
  };
}

angular
  .module('buuqit')
  .directive('bookingFoliosByRoom', bookingFoliosByRoom)
  .controller('Booking.FoliosByRoomController', bookingFoliosByRoomController)
  .component(
    'reactFolioViewByRoom',
    window.TBFLibs.react2angular(
      window.TBFLibs.FolioViewByRoom,
      [
        'accomodationsAndExtras',
        'discounts',
        'folios',
        'activeFolio', 
        'newTaxes',
        'convertCurrency',
        'removeDiscount',
        'generateTaxText',
        'removeTax',
        'resetTax',
        'saveFolioTax',
        'touchSelectedItemsCount',
        'toggleFolioRoomSelection',
        'toggleFolioItemComplimentary',
        'toggleFolioItemVisibility',
        'selectAccomodationsAndExtras',
      ],
      ['$i18next']
    )
  );


bookingFoliosByRoomController.$inject = ["$scope"];

function bookingFoliosByRoom () {
  return {
    restrict: 'E',
    scope: {
      accomodationsAndExtras: '=accomodationsAndExtras',
      discounts: '=discounts',
      folios: '=folios',
      activeFolio: '=activeFolio',
      newTaxes: '=newTaxes',
      convertCurrency: '=convertCurrency',
      removeDiscount: '=removeDiscount',
      generateTaxText: '=generateTaxText',
      removeTax: '=removeTax',
      resetTax: '=resetTax',
      saveFolioTax: '=saveFolioTax',
      touchSelectedItemsCount: '=touchSelectedItemsCount',
      toggleFolioRoomSelection: '=toggleFolioRoomSelection',
      toggleFolioItemComplimentary: '=toggleFolioItemComplimentary',
      toggleFolioItemVisibility: '=toggleFolioItemVisibility',
      selectAccomodationsAndExtras: '=selectAccomodationsAndExtras',
    },
    templateUrl: getTemplatePath('booking_management/bookingFoliosByRoom.html'),
  };
}
function bookingFoliosByRoomController($scope) {
  var ctrl = this;
  angular.extend(
    ctrl,
    $scope.$parent
  );
  $scope.$watch('accomodationsAndExtras', function() {
    angular.extend(
      ctrl,
      $scope.$parent
    );
    var newAccomodationsAndExtras = JSON.parse(JSON.stringify($scope.accomodationsAndExtras));
    angular.extend(
      ctrl,
      {
        accomodationsAndExtras: newAccomodationsAndExtras
      }
    );
  }, true);
}

angular
  .module('buuqit')
  .directive('bookingExtras', bookingExtras)
  .controller('BookingExtrasController', bookingExtrasController)
  .component(
    'reactBookingExtras',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingExtras,
      [
        'bookingExtras',
        'hotelExtras',
        'hotelExtrasMeta',
        'rooms',
        'categories',
        'groupedTaxes',
        'depositExtraId',
        'createNewExtraViaBookingEnabled',
        'removingExtraInProgress',
        'isForeignAmount',
        'foreignCurrencyRate',
        'currencySymbol',
        'totalExtras',
        'minSellDate',
        'convertCurrency',
        'onDelete',
        'onBulkDelete',
        'onSave',
        'onLoadExtras',
        'onLoadHotelExtras',
        'onLoadFolios'
      ],
      ['$i18next']
    )
  );

function bookingExtras() {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingExtras.html')
  };
}

bookingExtrasController.$inject = [
  "$scope",
  "$filter",
  "$i18next",
  "$rootScope",
  "BookingExtraFactory",
  "ExtraFactory",
  "ExtrasFactory",
  "FolioFactory",
  "StringTransformService",
  "$http",
];

function bookingExtrasController($scope, $filter, $i18next, $rootScope, BookingExtraFactory, ExtraFactory, ExtrasFactory, FolioFactory, StringTransformService, $http) {
  var ctrl = this;

  angular.extend(
    this,
    {
      paginatedBookingExtras: [],
      booking: $scope.booking,
      convertCurrency: convertCurrency,
      onSave: onSave,
      onDelete: onDelete,
      onBulkDelete: onBulkDelete,
      onLoadExtras: onLoadExtras,
      onLoadHotelExtras: onLoadHotelExtras,
      onLoadFolios: onLoadFolios
    }
  );
  
  function init() {
    ctrl.minSellDate = new Date(Math.min.apply(this, $scope.booking.rooms.map(function(el) {return el.checkinDate})));
    ctrl.depositExtraId = $rootScope.hotel.depositExtraId;
    ctrl.totalExtras = $scope.booking.totalExtras;
    ctrl.availableTaxes = $rootScope.hotel.newTaxes;
    var grouppedTaxes = _.groupBy($rootScope.hotel.newTaxes, 'group');
    ctrl.grouppedTaxes = _.keys(grouppedTaxes).map(function(tax_group) {
      return {
        id: Number(tax_group),
        name: grouppedTaxes[tax_group][0].name,
        translations: grouppedTaxes[tax_group][0].translations,
        applicableToExtra: grouppedTaxes[tax_group][0].applicableToExtra
      };
    });
    ctrl.createNewExtraViaBookingEnabled = $rootScope.hotel.createNewExtraViaBookingEnabled;
    ctrl.otherCategory = "Other";
    ctrl.isForeignAmount = $scope.booking.isForeignAmount();
    ctrl.currencySymbol = $scope.booking.getActiveCurrency();
    ctrl.rooms = $scope.booking.rooms.filter(function(room) {return room.status != 'canceled'}).map(function(room) {
      return {
        id: room.id,
        number: $rootScope.hotel.rooms.find(function(r) { return r.id == room.roomId }).number
      }
    });

    ctrl.categories = $rootScope.hotel.categories;
    ctrl.removingExtraInProgress = false;
    ctrl.paginatedBookingExtras = [];
  }

  init();

  function convertCurrency (amount) {
    return customCurrencyExtended(amount, ctrl.booking, ctrl.booking.isForeignAmount(), $filter, $rootScope);
  }

  function onLoadHotelExtras (params) {
    return new Promise(function(resolve, reject) {
      try {
        if ($rootScope.hotel && $rootScope.hotel.id) {
          var extrasFactory = new ExtrasFactory();
          extrasFactory.getExtras($rootScope.hotel.id, params).then(function (data) {
            if (data.data) {
              ctrl.extrasMeta = data.data && data.data.meta ? data.data.meta : {};
              var extras = data.data && data.data.extras ? StringTransformService.snakeToCamel(data.data.extras) : [];
              if (ctrl.extrasMeta && ctrl.extrasMeta.page == 1) {
                ctrl.extras = extras;
              } else {
                ctrl.extras = ctrl.extras.concat(extras);
              }
            };
            resolve();
          });
        }
      } catch (e) {
        console.error(e, 'Extras');
        reject();
      };
    });
  }

  function onLoadFolios(params) {
    return new Promise(function (resolve, reject) {
      try {
        if ($rootScope.hotel && $rootScope.hotel.id) {
          var folioFactory = new FolioFactory({
            hotelId: $rootScope.hotel.id,
            bookingId: ctrl.booking.id
          })
          folioFactory.getFolios(params).then(function (data) {
            if (data.data) {
              resolve(data.data);
            }
          });
        }
      } catch (e) {
        console.error(e, 'Folios error');
        reject();
      };
    });
  }

  function onDelete (extra) {
    $rootScope.isDisabledPusherEvents = true;
    var id = extra.id;
    var url = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' + ctrl.booking.id + '/extras/' + id;
    ctrl.removingExtraInProgress = true;

    return $http.delete(url).then(function(response) {
      ctrl.removingExtraInProgress = false;
      if (!response.data.success) {
        console.error(response.data.msg)
      }
      return response;
    })
    .catch(function(error) {
      console.error(error);
    })
    .finally(function() {
      $rootScope.isDisabledPusherEvents = false;
    });
  };

  function onBulkDelete (ids) {
    $rootScope.isDisabledPusherEvents = true;
    var url = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' + ctrl.booking.id + '/extras/bulk_remove';
    ctrl.removingExtraInProgress = true;
    var payload = {
      booking_extra_ids: ids
    };
    return $http.post(url, payload).then(function(response) {
      ctrl.removingExtraInProgress = false;
      if (!response.data.success) {
        console.error(response.data.msg)
      }
      return response;
    })
    .catch(function(error) {
      console.error(error);
    })
    .finally(function() {
      $rootScope.isDisabledPusherEvents = false;
    });
  };

  function _to_camel  (s) { return s.split('_')[0] + s.split('_').slice(1).map(function(c){ return c[0].toUpperCase() + c.slice(1)}).join(''); }

  function _switch_var_style(o, f) {
    var n_o = {};
    for(var k in o) n_o[f(k)] = o[k];
    return n_o;
  };

  function onLoadExtras (params) {
    try {
      var url = SERVER_PATH + "/api/v1/hotels/" + $rootScope.hotel.id +"/bookings/" + ctrl.booking.id + "/extras";
      var searchParams = new URLSearchParams();

      Object.keys(params).map(function(param) {
        if (['limit', 'page'].includes(param)) {
          searchParams.set("pagination[" + param + "]", params[param]);
        } else {
          var paramName = param.replace(/[A-Z]/g, '_' + '$&').toLowerCase();
          searchParams.set(paramName, params[param]);
        }
      });

      var queryString = searchParams.toString();
      var queryUrl = url + "?" + queryString;

      return $http.get(queryUrl).then(function(response) {
        if (response.data) {
          if (response.data.data) {
            var convertedResponse = response.data.data.map(function(_, index) {
              return _switch_var_style(response.data.data[index], _to_camel);
            });
              
            ctrl.paginatedBookingExtras = convertedResponse;
          }
          if (response.data.meta) {
            return _switch_var_style(response.data.meta, _to_camel);
          }
        }
         
      });
    } catch(e) {
      console.error(e, 'error')
    }
  }

  function _createBookingExtra (formData) {
    var newBookingExtraData = {
      extraId    : formData.hotelExtra.id,
      booking_id : ctrl.booking.id,
      booking_room_id : formData.bookingRoomId,
      hotel_id   : $rootScope.hotel.id,
      price      : formData.price,
      vat        : formData.vat,
      count      : formData.count,
      isForeignAmount : ctrl.isForeignAmount,
      foreignAmount : formData.foreignAmount,
      totalForeignAmount : formData.foreignAmountTotal,
      total      : formData.total,
      title      : formData.extra,
      sell_date  : moment(formData.sellDate).format('YYYY-MM-DD'),
      include_price_into_rate : formData.includePriceIntoRate,
      include_price_into_rate_for_invoice : formData.includePriceIntoRateForInvoice,
      show_at_invoice : formData.showAtInvoice,
      folio_id : formData.folioId
    }
    return new Promise(function(resolve, reject) {
      new BookingExtraFactory(newBookingExtraData).save(function(data) {
        if(data === false) {
          reject(data);
        }
        resolve(data);
      }, function(error) {
        reject(error);
      });
    });
  };

  $scope.$watch('booking.totalExtras', function() {
    var newTotal = JSON.parse(JSON.stringify($scope.booking.totalExtras));
    angular.extend(
      ctrl,
    {
      totalExtras: newTotal
    }
    );
  }, true);

  function _saveBookingExtra (formData) {
    formData.sellDate = moment(formData.sellDate).format('YYYY-MM-DD');
    var bookingExtra = ctrl.paginatedBookingExtras.find(function(extra) {
      return extra.id === formData.id;
    });
    bookingExtra.bookingRoomId = formData.bookingRoomId;
    bookingExtra.sellDate = formData.sellDate;
    bookingExtra.count = formData.count;
    bookingExtra.price = formData.price;
    bookingExtra.total = formData.total;
    bookingExtra.includePriceIntoRate = formData.includePriceIntoRate;
    bookingExtra.showAtInvoice = formData.showAtInvoice;
    bookingExtra.includePriceIntoRateForInvoice = formData.includePriceIntoRateForInvoice;
    if (ctrl.isForeignAmount) {
      bookingExtra.foreignAmount = formData.foreignAmount;
      bookingExtra.totalForeignAmount = formData.foreignAmountTotal;
    }
    function updateExtras(resolve, data) {
      resolve(data);
    }
    return new Promise(function(resolve, reject) {
      if (bookingExtra.save) {
        bookingExtra.save(function(data) {
          if (data === false) {
            reject(data);
          }
          updateExtras(resolve, data);
       }, function(error) {
        reject(error);
       });
      } else {
        new BookingExtraFactory(bookingExtra).save(function(data) {
          updateExtras(resolve, data);
        });
      }
    });
  };

  function loadExtra(params) {
    var extrasFactory = new ExtrasFactory();

    return new Promise(function (resolve, reject) {
      try {
        extrasFactory.getExtras($rootScope.hotel.id, params)
          .then(function (data) {
            if (data && data.data && data.data.extras && data.data.extras.length > 0) {
              // return the one which has the exact same title
              var extra = data.data.extras.find(function (extra) {
                return extra.title === params.term;
              });
              if (extra) {
                resolve(extra);
              } else {
                resolve(null);
              }
            } else {
              resolve(null);
            }
          });
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  function onSave (formData) {
    return loadExtra({ term: formData.extra }).then(function (extra) {
      $rootScope.isDisabledPusherEvents = true;
      if (formData.id) {
        return _saveBookingExtra(formData).then(function (response) {
        return response;
        })
        .catch(function(error) {
          console.error(error);
          throw error;
        });
      } else {
        if (!extra) {
          return new ExtraFactory({
            title    : formData.extra,
            category : formData.extraCategory || ctrl.otherCategory,
            price    : formData.price,
            vat      : 0,
            hotel_id : $rootScope.hotel.id,
            tax_groups : formData.withoutTaxes ? null : formData.taxGroups.join(',')
          }, {
            hotelId  : $rootScope.hotel.id
          }).create().then(function (data) {
            formData.hotelExtra = data;
            return _createBookingExtra(formData).then(function (response) {
              return response;
              })
              .catch(function(error) {
                console.error(error);
                throw error;
              })
              .finally(function() {
                $rootScope.isDisabledPusherEvents = false;
              });
          });
        } else {
          formData.hotelExtra = extra;
          return _createBookingExtra(formData).then(function (response) {
            return response;
            })
            .catch(function(error) {
              console.error(error);
              if (error === false) {
                $rootScope.notify($i18next.t('bookings.extras.deposit_saving_error'));
              }
              throw error;
            });
        }
      }
    }).catch(function(e) {
      console.error(e);
      throw e;
    })
    .finally(function() {
      $rootScope.isDisabledPusherEvents = false;
    });
  };
}

angular
  .module('buuqit')
  .directive('bookingEmailTab', bookingEmailTab);

bookingEmailTab.$inject = [];

function bookingEmailTab () {
  return {
    controller: BookingEmailTabController,
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingEmailTab.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}


BookingEmailTabController.$inject = ["$scope", "$rootScope", "$i18next", "$mdConstant", "BookingLettersFactory", "FolioFactory", "EmailTemplatePreviewFactory", "DeviceDetector", "BeeFreeFactory", "EmailTemplatesListFactory"];

function BookingEmailTabController ($scope, $rootScope, $i18next, $mdConstant, BookingLettersFactory, FolioFactory, EmailTemplatePreviewFactory, DeviceDetector, BeeFreeFactory, EmailTemplatesListFactory) {
  angular.extend($scope, {
    letter : {
      createdAt:          new Date(),
      deliveryAddress:    '',
      selectedAddress:    [],
      text:               null,
      mailType:           'outcomming',
      bookingId:          $scope.booking.id,
      hotelId:            $rootScope.hotel.id,
      subject:            $i18next.t('bookings.email.email_subject_js_str') + ' ' + $rootScope.hotel.name + ' #' + $scope.booking.token,
      attachInvoice:      false,
      attachConfirmation: false
    },
    additionalTemplate: { id: 'default', text: null, textJson: null },
    letter_sending : false,
    shouldSend: false,
    templateEditor: 'basic',
    folios: $scope.folios,
    delimiters: [$mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.SEMICOLON, $mdConstant.KEY_CODE.SPACE, $mdConstant.KEY_CODE.ENTER],
    is_mobile: DeviceDetector === 'mobile',
    addresses: [],
    transformChip: function (chip) {
      var email_regx = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      var emailStr = typeof(chip) == 'string' ? chip : chip.email;
      var emails = emailStr.split(',').map(function(e) { return e.trim(); });

      var allValid = emails.every(function(email) {
        return email_regx.test(email);
      });

      return allValid ? emailStr : null;
    },
    findAddress: function (query) {
      return new Promise(function (resolve, reject) {
        var unused = $scope.addresses.filter(function(a) {
                          return $scope.letter.selectedAddress.indexOf(a.email)<0
                      });
        if(query.length<=0) {
            resolve(unused)
        } else {
          var q = query.toLowerCase();
          resolve(unused.filter(function(a){
            return a.fullName.toLowerCase().indexOf(q)>-1 || a.email.toLowerCase().indexOf(q)>-1;
          }))
        }
      })
    },

    setShouldDeliverLetter: function () {
      if ($scope.templateEditor === 'basic') {
        this.deliveryLetter($scope.letter.text);
      } else {
        $scope.shouldSend = true;
      }
    },

    deliveryLetter : function (text) {
      $scope.letter_sending = true;
      var letter = new BookingLettersFactory($scope.letter);
      letter.deliveryAddress = letter.selectedAddress.join(',');

      letter.text = text;
      letter.save(function () {
        $scope.booking.letters.push(letter);
        $scope.newLetter = false;
        $scope.letter = angular.copy($scope.originalLetter);
        $rootScope.$broadcast('bookings:update');
        $rootScope.notify($i18next.t('bookings.email.notify.email_has_been_sent_js_str'));
        $scope.letter_sending = false;
        $scope.shouldSend = false;
      }, function (error_message) {
        $rootScope.notify(error_message);
        $scope.letter_sending = false;
        $scope.shouldSend = false;
      });
    },

    sendTestLetter: function (text) {
      var letter = {
        receiver: $rootScope.hotel.email,
        templateHtml: text,
        hotelId: $rootScope.hotel.id,
      }
      new EmailTemplatePreviewFactory(letter).create().then(function () {
        $rootScope.notify($i18next.t('bookings.email.notify.test_email_has_been_sent_js_str'));
      }, function (error_message) {
        $rootScope.notify(error_message);
      });
    },

    onLoadBeeFreeToken: function () {
      return BeeFreeFactory
        .get({
          hotelId: $rootScope.hotel.id
        });
    },

    toSnakeCase: function (str) {
      return str.replace(/([A-Z])/g, function(match) {
        return "_" + match.toLowerCase();
      });
    },

    getTemplates: function () {
      return $scope.emailTemplates;
    },

    setAdditionalTemplate: function () {
      var footer = $scope.emailFooter === null ? '' : '<br><br>' + $scope.emailFooter;
      var template = $scope.emailTemplates && $scope.emailTemplates.find(function(el) {
        return el.id == $scope.letter.template_id;
      });
      if (template) {
        $scope.additionalTemplate = {
          id: template.id,
          text: template.text,
          textJson: template.textJson
        };
        $scope.letter.text = template.text + footer;
      } else {
        $scope.additionalTemplate = {
          id: 'default',
          text: null,
          textJson: null
        };
        $scope.letter.text = footer;
      }
    },

    setTemplateEditor: function (editor) {
      $scope.templateEditor = editor;
    },

    wysiwygPaste : function (e) {
      var thisNote = $(e.currentTarget);

      var updatePastedText = function(someNote){
        var original = someNote.code();
        var cleaned = (function(original){
          var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
          var output = original.replace(stringStripper, ' ');
          var commentSripper = new RegExp('<!--(.*?)-->','g');
          var tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>','gi');
          var badTags = ['style', 'script','applet','embed','noframes','noscript'];
          output = output.replace(commentSripper, '');
          output = output.replace(tagStripper, '');

          for (var i=0; i< badTags.length; i++) {
            tagStripper = new RegExp('<'+badTags[i]+'.*?'+badTags[i]+'(.*?)>', 'gi');
            output = output.replace(tagStripper, '');
          }
          var badAttributes = ['style', 'start'];
          for (var x=0; x< badAttributes.length; x++) {
            var attributeStripper = new RegExp(' ' + badAttributes[x] + '="(.*?)"','gi');
            output = output.replace(attributeStripper, '');
          }
          return output;
        })(original);
        someNote.code('').html(cleaned);
      };

      setTimeout(function () {
        updatePastedText(thisNote);
      }, 10);
    },

    dropins: dropins,
    insertDropIn: function(editor, dropin) {
      angular.element('[data-role="'+editor+'"]').summernote('insertText', dropin);
    },

    openMenu: function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    },

    gotoCustomer : function(field, event) {
      event.preventDefault();
      var customerTab = $scope.is_mobile ? 8 : 3;
      $scope.openTab(event, customerTab);
    },

    mergeTags: getMergeTags(),
  });

  if ($scope.addresses.length === 1) {
    $scope.letter.selectedAddress.push($scope.addresses[0].email);
  }

  $scope.originalLetter = angular.copy($scope.letter);

  function getMergeTags() {
    return dropins.map(function(dropin) {
      return { name: dropin[0], value: dropin[1]};
    });
  };

  function getAddresses(folios) {
      var out = [];

      folios.forEach(function(folio) {
        if (folio.customer.email && out.map(function(el) {return el.email;}).indexOf(folio.customer.email) == -1) {
          out.push({
            email: folio.customer.email,
            firstName: folio.customer.firstName,
            lastName: folio.customer.lastName,
            fullName: folio.customer.firstName + ' ' + folio.customer.lastName,
            type: 'Customer'
          });
        }
      })

      angular.forEach($scope.booking.rooms, function(room) {
        if (room.guest.email &&  out.map(function(el) {return el.email;}).indexOf(room.guest.email) == -1) {
          out.push({
            email: room.guest.email,
            firstName: room.guest.firstName,
            lastName: room.guest.lastName,
            fullName: room.guest.firstName + ' ' + room.guest.lastName,
            type: 'Guest'
          });
        }

        angular.forEach(room.guests, function(guest) {

          if (guest.email &&  out.map(function(el) {return el.email;}).indexOf(guest.email) == -1) {
            out.push({
              email: guest.email,
              firstName: guest.firstName,
              lastName: guest.lastName,
              fullName: guest.firstName + ' ' + guest.lastName,
              type: 'Guest'
            });
          }
         });
      });

      return out;
    }

  function loadBookingFolios() {
    return FolioFactory
      .get({
        hotelId: $rootScope.hotel.id,
        bookingId: $scope.booking.id
      });
  };

  function loadEmailTemplates() {
    return EmailTemplatesListFactory('email').get({ hotel_id: $rootScope.hotel.id })
    .then(function (emailTemplates) {
      $scope.emailTemplates = emailTemplates;
    });
  }

  function loadEmailFooterTemplate() {
    return EmailTemplatesListFactory("system")
      .query({
        "fetch[]": ['email_footer']
      }, { hotel_id: $rootScope.hotel.id })
      .then(function (emailTemplates) {
        var emailFooter = emailTemplates && emailTemplates.emailTemplates[0]['emailFooter'];
        $scope.emailFooter = emailFooter['emailFooter'];
        $scope.emailFooterJson = emailFooter['emailFooterJson'];
        $scope.letter.text = emailFooter['emailFooter'];
        $scope.letter.text_json = emailFooter['emailFooterJson'];
        $scope.letter.textBase = emailFooter['emailFooter'];
        $scope.setAdditionalTemplate();
      })
      .catch(function (error) {
        console.error("Failed to load templates:", error);
        $rootScope.notify("Failed to load email templates.");
      });
  }

  function init () {
    loadEmailFooterTemplate();
    loadEmailTemplates();
    loadBookingFolios().then(function(folios) {
      $scope.folios = folios;
      $scope.addresses = getAddresses(folios);
    });
  }

  init();

  document.body.style.paddingTop = '40px';
}

angular
  .module('buuqit')
  .directive('bookingDiscounts', bookingDiscounts);

bookingDiscounts.$inject = ["$rootScope"];

function bookingDiscounts ($rootScope) {
  return {
    controller: BookingDiscountsController,
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingDiscounts.html'),
    link: function (scope, element, attrs, ctrl) {
    }
  };
}


BookingDiscountsController.$inject = [
  "$scope",
  "$rootScope",
  "$i18next",
  "UIDialogService",
  "BookingDiscountFactory"
];

function BookingDiscountsController ($scope, $rootScope, $i18next, UIDialogService, BookingDiscountFactory) {
  $scope.showDiscountsForm = function () {
    $scope.discountsFormVisible = true;
  };

  $scope.removeDiscounts = function (index) {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        $scope.booking.bookingDiscounts[index]
          .remove()
          .then(function () {
            $scope.booking.bookingDiscounts.splice(index, 1);
            $rootScope.$broadcast('bookings:update');
          });
      }
    });
  };

  $scope.editDiscounts = function (index) {
    $scope.editedDiscount = index;
  };

  $scope.closeEditDiscount = function () {
    $scope.editedDiscount = null;
  };

  $scope.createBookingDiscount = function (model) {
    new BookingDiscountFactory(model).create().then(function (data) {
      $scope.booking.bookingDiscounts.push(data);
      $scope.discountsFormVisible = false;
    });
  };

  $scope.discountsFormVisible = false;
  $scope.discountsTotal = 0;
  $scope.editedDiscount = null;
  $scope.newDiscount = {
    discount : null,
    title    : null,
    percent  : true,
    amount   : 0,
    total    : 0
  };
  $scope.discountsAnimation = false;
  $scope.enableDiscounts = $rootScope.hotel.enableDiscounts;
}

angular
  .module('buuqit')
  .directive('bookingCustomerTab', bookingCustomerTab);

bookingCustomerTab.$inject = ["$rootScope"];

function bookingCustomerTab ($rootScope) {
  return {
    controller: ["$scope", "$rootScope", function ($scope, $rootScope) {
      $scope.locales = window.locales;
      $scope.idTypes = $rootScope.hotel.identificationTypes;
      if ($scope.countries.indexOf($scope.booking.customer.country) == -1) {
        $scope.countries.push($scope.booking.customer.country);
      }
      $scope.selectStoredCustomer = function($item) {
        $scope.booking.customer = angular.copy($item);
      };

      $scope.saveCustomer = function () {
        $scope.booking.rooms.forEach(function(room) {
          $rootScope.$broadcast('BookingStorage:update', room.id, room.bookingId);
        });
        $rootScope.$broadcast('bookings:update');
        $scope.booking.hotelId = $rootScope.hotel.id;
        $scope.booking._save();
      };

      $scope.printRegistrationForm = function () {
        $scope.print_loading = true;
        $('#pdfDocument').remove();
        var path = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/checkin_form/generate/'+$scope.booking.id+'?type=print';
        $('.customer-header').append('<iframe style="display: none;" src="' + path + '" name="pdf" id="pdfDocument" width="100%" height="100%" ></iframe>');

        function printDocument() {
          var doc = frames['pdf'];

          if (doc.document.getElementsByTagName('embed').length === 0) {
            setTimeout(function(){printDocument();}, 10);
          } else {
            setTimeout(function() {
              $scope.print_loading = false;
              doc.print();
            }, 3000);
          }
        }

        printDocument();
      };
    }],
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingCustomerTab.html'),
    link: function (scope, element, attrs, ctrl) {
    }
  };
}

angular
  .module('buuqit')
  .directive('bookingCardVault', bookingCardVault)
  .controller('BookingCardVaultController', BookingCardVaultController)
  .component(
    'reactBookingPaymentCards',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingPaymentCards,
      [
        'bookingCustomers',
        'activeCustomer',
        'cards',
        'bookingId',
        'actionLoading',
        'cardAnimation',
        'showCredentialsModal',
        'cardFormVisible',
        'pciBookingIframePath',
        'credentialsIframePath',
        'gateway',
        'gateways',
        'online',
        'otherCardsSize',
        'chargeCard',
        'preauthorizeCard',
        'changeCustomer',
        'changeCardholderName',
        'showCardCredentials',
        'tokenizeCard',
        'destroyCard',
        'nextCard',
        'saveStripeScaCard',
        'saveStripeCard',
        'saveWubookCard',
        'handleAddCard',
        'handleCredentialsModal',
      ],
      ['$i18next']
    )
  );

bookingCardVault.$inject = ["$rootScope"];

function bookingCardVault () {
  return {
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingCardVault.html'),
    link: function (scope, element, attrs, ctrl) {},
  };
}


BookingCardVaultController.$inject = [
  "$scope",
  "$i18next",
  "$rootScope",
  "$timeout",
  "$sce",
  "PaymentFactory",
  "CreditCardFactory",
  "UIDialogService",
  "BookingStorage",
  "BookingCustomersFactory"
];

function BookingCardVaultController ($scope, $i18next, $rootScope, $timeout, $sce, PaymentFactory, CreditCardFactory, UIDialogService, BookingStorage, BookingCustomersFactory) {
  var ctrl = this;

  function init() {
    ctrl.activeCustomer = 0;
    ctrl.bookingId = $scope.booking.id;
    ctrl.pciBookingIframePath  = $sce.trustAsResourceUrl(SERVER_PATH + '/api/public/v1/credit_card_form');
    ctrl.credentialsIframePath = '';
    ctrl.showCredentialsModal  = false;
    ctrl.cardAnimation         = false;
    ctrl.cardFormVisible       = false;
    ctrl.actionLoading         = false;
    ctrl.online = $rootScope.networkStatus;
    ctrl.gateway = $rootScope.hotel.paymentGateway;
    ctrl.gateways = $rootScope.hotel.paymentActiveGateways;

    loadBookingCustomers().then(function(customers) {
      ctrl.bookingCustomers = customers;

      setCards();
    });
  }

  init();

  angular.extend(
    this, 
    {
      cardMountTimeout: null,
      addNewCard: addNewCard,
      chargeCard: chargeCard,
      preauthorizeCard: preauthorizeCard,
      destroyCard: destroyCard,
      changeCardholderName: changeCardholderName,
      showCardCredentials: showCardCredentials,
      tokenizeCard: tokenizeCard,
      saveStripeCard: saveStripeCard,
      saveStripeScaCard: saveStripeScaCard,
      pcibooking_callback: pcibooking_callback,
      saveWubookCardCallback: saveWubookCardCallback,
      saveWubookCard: saveWubookCard,
      nextCard: nextCard,
      changeCustomer: changeCustomer,
      handleAddCard: handleAddCard,
      handleCredentialsModal: handleCredentialsModal,
    }
  );

  function loadBookingCustomers() {
    var bookingCustomers = new BookingCustomersFactory({hotel_id: $rootScope.hotel.id, booking_id: $scope.booking.id});

    return bookingCustomers.getCustomers().then(function(data) {
      if (data.customers) {
        return data.customers;
      }
      return [];
    }).catch(function(error) {
      console.error('Error loading booking customers:', error);
      return [];
    });
  }

  function addNewCard(data) {
    ctrl.cardAnimation = false;
    ctrl.bookingCustomers[ctrl.activeCustomer].cards.push(data.card)

    setCards();

    $rootScope.$broadcast('booking:reload', $scope.booking.id);
  }

  function handleAddCard() {
    $rootScope.isDisabledPusherEvents = true;
    ctrl.cardFormVisible = !ctrl.cardFormVisible;
    if (window.Stripe && ctrl.gateway === 'stripe_sca') {
      if (ctrl.cardFormVisible) {
        if (ctrl.cardMountTimeout) {
          $timeout.cancel(ctrl.cardMountTimeout);
        }
        ctrl.cardMountTimeout = $timeout(function () {
          ctrl.cardElements.mount('#stripe-sca-drop-in');
        }, 100);
      } else {
        ctrl.cardElements.unmount('#stripe-sca-drop-in');
      }
    }
    $scope.$apply();
  }

  function handleCredentialsModal() {
    ctrl.showCredentialsModal = !ctrl.showCredentialsModal;
    if (!ctrl.showCredentialsModal) {
      ctrl.credentialsIframePath = '';
    }
    $scope.$apply();
  }

  function chargeCard (card) {
    UIDialogService.open('money-prompt', {
      title: $i18next.t('bookings.payment.money_prompt.charge_card_title'),
      reference_title: $i18next.t('bookings.payment.money_prompt.charge_card_reference'),
      placeholder: $i18next.t('bookings.payment.money_prompt.please_enter_amount_to_charge_placeholder'),
      notice: card.isVirtual ? $i18next.t('bookings.payment.money_prompt.notice_virtual_card') : null,
      with_reference: $rootScope.hotel.paymentGatewaySettings && $rootScope.hotel.paymentGatewaySettings.showReference && card.provider == 'payment_express',
      reference: $scope.booking.paymentReferenceTemplate ? $scope.booking.paymentReferenceTemplate.substring(0, 63) : null,
      value: angular.copy($scope.booking.due),
      max_value: angular.copy($scope.booking.due),
      min_value: 0.01,
      callback: function (value, reference) {
        UIDialogService.close('money-prompt');
        $rootScope.isDisabledPusherEvents = true;
        ctrl.actionLoading = true;
        new PaymentFactory({
          amount      : value,
          booking_id  : $scope.booking.id,
          payerName   : card.cardholderName,
          card        : card.id,
          description : 'Online Card Payment, ' + card.cardType + ', Card ending at ' + card.last4,
          hotel_id    : $rootScope.hotel.id,
          type        : 'Credit Card',
          submitted   : true,
          options     : {
            reference: reference
          }
        }).create().then(function(data) {
          ctrl.actionLoading = false;
          $scope.booking.payments.push(data);

          $rootScope.$broadcast('booking:reload', $scope.booking.id);
          $rootScope.$broadcast('bookings:update');
        })
        .catch(function (response) {
          var message = (response.status >= 500 || response.status == 0) ? $i18next.t('bookings.payment.charge_card.server_error_new_js_str') : (response.data && response.data.msg ? response.data.msg : $i18next.t('bookings.payment.charge_card.payment_was_rejected_js_str'));
          if (response.data && response.data.payment) {
            if (response.data.payment.status == 'processor_declined') {
              message = $i18next.t('bookings.payment.charge_card.processor_declined_transaction_js_str');
            }
            if (response.data.payment.status == 'gateway_rejected') {
              message = $i18next.t('bookings.payment.charge_card.gateway_rejected_transaction_js_str');
            }
          }
          ctrl.actionLoading = false;
          if (response.data && response.data.msg == 'Amount is greater then booking due') {
            UIDialogService.open('alert', {
              text: 'Amount is greater then booking due. Payment is not accepted.',
              title: $i18next.t('bookings.payment.alert.transaction_error_title')
            });
            BookingStorage.load_by_id($scope.booking.id, false, function(booking) {
              $rootScope.$broadcast('booking_management:reload', booking);
            });
          } else {
            UIDialogService.open('alert', {
              text: $i18next.t('bookings.payment.alert.transaction_error_text') + ' ' + message,
              title: $i18next.t('bookings.payment.alert.transaction_error_title')
            });
          }
        })
        .finally (function () {
          $rootScope.isDisabledPusherEvents = false;
        });
      }
    });
  }

  function preauthorizeCard (card) {
    UIDialogService.open('money-prompt', {
      title: $i18next.t('bookings.payment.money_prompt.preauthorize_card_title'),
      placeholder: $i18next.t('bookings.payment.money_prompt.please_enter_amount_to_authorize_placeholder'),
      notice: card.isVirtual ? $i18next.t('bookings.payment.money_prompt.notice_virtual_card') : null,
      value: angular.copy($scope.booking.due),
      max_value: angular.copy($scope.booking.due) + 100000000,
      min_value: 0,
      callback: function (value) {
        UIDialogService.close('money-prompt');
        $rootScope.isDisabledPusherEvents = true;
        ctrl.actionLoading = true;
        new PaymentFactory({
          amount      : value,
          booking_id  : $scope.booking.id,
          payerName   : card.cardholderName,
          card        : card.id,
          description : 'Online Card Payment, ' + card.cardType + ", Card ending at " + card.last4,
          hotel_id    : $rootScope.hotel.id,
          type        : "Credit Card",
          submitted   : false,
          operation   : 'pre-authorize'
        })
        .create()
        .then(function(data) {
          ctrl.actionLoading = false;
          $scope.booking.payments.push(data);
          card.authorized = true;
          $rootScope.$broadcast('bookings:update');
        })
        .catch(function(error) {
          console.error('Error preauthorizing card:', error);
          ctrl.actionLoading = false;
          UIDialogService.open('alert', {
            text: $i18next.t('bookings.payment.alert.preauthorise_error_text'),
            title: $i18next.t('bookings.payment.alert.preauthorise_error_title')
          });
        })
        .finally(function () {
          $rootScope.isDisabledPusherEvents = false;
        });
      }
    });
  }

  function destroyCard (card) {
    UIDialogService.open('confirmation', {
      title: $i18next.t('general.confirm.confirm'),
      text: $i18next.t('general.confirm.are_you_sure_text_content'),
      positive_callback: function () {
        var index = ctrl.bookingCustomers[ctrl.activeCustomer].cards.indexOf(card);
        var indexAtCards = ctrl.cards.indexOf(card);
        card.hotel_id = $rootScope.hotel.id;
        card.booking_id = $scope.booking.id;

        ctrl.actionLoading = true;

        new CreditCardFactory(card).remove().then(function (data) {
          ctrl.actionLoading = false;
          if (data.success) {
            if (ctrl.bookingCustomers[ctrl.activeCustomer].cards.length == 1) {
              ctrl.bookingCustomers[ctrl.activeCustomer].cards.splice(index, 1);
              if (indexAtCards !== -1) { ctrl.cards.splice(indexAtCards, 1); }
            } else {
              ctrl.bookingCustomers[ctrl.activeCustomer].cards.splice(index, 1);
              if (indexAtCards !== -1) { ctrl.cards.splice(indexAtCards, 1) }
            }
            $rootScope.$broadcast('bookings:update');
            $rootScope.notify($i18next.t('booking.payment.card.removed'));
          } else {
            console.error('Error removing card:', data);
            UIDialogService.open('alert', {
              text: $i18next.t('bookings.payment.alert.cannot_remove_card_text'),
              title: $i18next.t('bookings.payment.alert.cannot_remove_card_title')
            });
          }
        });
      }
    });
  }

  function changeCardholderName (card) {
    UIDialogService.open('cardholder-name', {
      title: $i18next.t('bookings.payment.cardholder_name.change_cardholder_name_title'),
      placeholder: $i18next.t('bookings.payment.cardholder_name.please_enter_cardhodler_name_placeholder'),
      value: angular.copy(card.cardholderName),
      callback: function (value) {
        UIDialogService.close('cardholder-name');
        ctrl.actionLoading = true;

        card.hotel_id = $rootScope.hotel.id;
        card.booking_id = $scope.booking.id;
        card.cardholderName = value;
        new CreditCardFactory(card)
          .update()
          .then(function() {
            ctrl.actionLoading = false;
            $rootScope.$broadcast('bookings:update');
          }).catch(function (error) {
            console.error('Error changing cardholder name:', error);
            ctrl.actionLoading = false;
          })
      }
    });
  }

  function showCardCredentials (card) {
    card.hotel_id = $rootScope.hotel.id;
    card.booking_id = $scope.booking.id;

    UIDialogService.open('credit-password', {
      title: $i18next.t('bookings.payment.credit_password.enter_user_password_title'),
      placeholder: $i18next.t('bookings.payment.credit_password.enter_user_password_placeholder'),
      value: '',
      callback: function (password) {
        UIDialogService.close('credit-password');
        ctrl.actionLoading = true;
        new CreditCardFactory(card).showCredentials(password).then(function (response) {
          if (response.data.success) {
            ctrl.actionLoading = false;
            ctrl.showCredentialsModal = true;
            ctrl.credentialsIframePath = response.data.url;
          } else {
            UIDialogService.open('alert', {
              text: response.data.error,
              title: $i18next.t('general.titles.error')
            });
            ctrl.actionLoading = false;
          }
        }, function (response) {
          console.error('Error showing card credentials:', response);
          UIDialogService.open('alert', {
            text: response.error,
            title: $i18next.t('general.titles.error')
          });
          ctrl.actionLoading = false;
        });
      }
    });
  }

  function tokenizeCard (card, provider) {
    $rootScope.isDisabledPusherEvents = true;

    card.hotel_id = $rootScope.hotel.id;
    card.booking_id = $scope.booking.id;

    ctrl.actionLoading = true;

    new CreditCardFactory(card)
      .tokenizeCard(provider)
      .then(function (response) {
        if (response.data.success === false) {
          console.error('Error tokenizing card:', response);
          $rootScope.notify(response.data.error);
        } else {
          if (response.data.card) {
            angular.extend(
              card,
              response.data.card
            )
          }
          $rootScope.$broadcast('booking:reload', $scope.booking.id);
          $rootScope.$broadcast('bookings:update');
        }
        ctrl.actionLoading = false;
      })
      .finally(function () {
        $rootScope.isDisabledPusherEvents = false;
      });
  }

  function saveStripeCard (cardData) {
    if (cardData.cardholderName && cardData.number && cardData.expirationMonth && cardData.expirationYear) {
      ctrl.cardAnimation = true;
      Stripe.setPublishableKey($rootScope.hotel.clientToken);
      var cardNumber = cardData.number.replace(/\s/g, '');
      var data = {
        name: cardData.cardholderName,
        number: cardNumber,
        cvc: cardData.cvv,
        exp_month: cardData.expirationMonth,
        exp_year: cardData.expirationYear
      };
      if (typeof($rootScope.hotel.paymentGatewaySettings.passAddressInfo) == "undefined" || $rootScope.hotel.paymentGatewaySettings.passAddressInfo == true) {
        data.address_city = ctrl.bookingCustomers[ctrl.activeCustomer].city;
        data.address_country = ctrl.bookingCustomers[ctrl.activeCustomer].country;
        data.address_line1 = ctrl.bookingCustomers[ctrl.activeCustomer].address;
        data.address_state = ctrl.bookingCustomers[ctrl.activeCustomer].state;
        data.address_zip = ctrl.bookingCustomers[ctrl.activeCustomer].zipCode;
      }

      Stripe.card.createToken(data, function(status, response) {
        $rootScope.isDisabledPusherEvents = true;
        new CreditCardFactory(
          {
            nonce       : response.id,
            customer_id : ctrl.bookingCustomers[ctrl.activeCustomer].id,
            hotel_id    : $scope.hotel.id,
            booking_id  : $scope.booking.id,
            cvv_present : !_.isEmpty(cardData.cvv),
            cardholder_name: cardData.cardholderName
          }
        ).create().then(function (data) {
          ctrl.cardFormVisible = false;
          ctrl.addNewCard(data);
        }.catch(function (response) {
          console.error('Error saving Stripe card:', response);
          ctrl.cardAnimation = false;
          UIDialogService.open('alert', {
            title: $i18next.t('general.titles.error'),
            text: response.data.msg ? (response.data.msg.join ? response.data.msg.join('. ') : response.data.msg) : $i18next.t('bookings.payment.alert.card_is_invalid_text')
          });
        }).finally (function() {
          $rootScope.isDisabledPusherEvents = false;
        }));
      });
    } else {
      $rootScope.notify($i18next.t('bookings.payment.notify.fix_error_and_try_again_js_str'));
    }
  }

  function saveStripeScaCard () {
    var data = {};
    ctrl.cardAnimation = true;
    $scope.$apply();

    if (typeof($rootScope.hotel.paymentGatewaySettings.passAddressInfo) == "undefined" || $rootScope.hotel.paymentGatewaySettings.passAddressInfo == true) {
      data.address = {};
      data.address.city = ctrl.bookingCustomers[ctrl.activeCustomer].city;
      data.address.country = ctrl.bookingCustomers[ctrl.activeCustomer].countryShort;
      data.address.line1 = ctrl.bookingCustomers[ctrl.activeCustomer].address;
      data.address.state = ctrl.bookingCustomers[ctrl.activeCustomer].state;
      data.address.postal_code = ctrl.bookingCustomers[ctrl.activeCustomer].zipCode;
    }

    ctrl.stripeScaGateway.createPaymentMethod('card', ctrl.cardElements, {
      billing_details: data
    })
      .then(function (result) {
        if (result.error) {
          console.error('Error saving Stripe SCA card:', result.error);
          return Promise.reject({
            error: {
              data: {
                msg: result.error.message
              }
            }
          });
        }

        return new CreditCardFactory({
          nonce: result.paymentMethod.id,
          customer_id: ctrl.bookingCustomers[ctrl.activeCustomer].id,
          hotel_id: $scope.hotel.id,
          booking_id: $scope.booking.id,
        }).create().then(function (data) {
          ctrl.cardFormVisible = false;
          ctrl.addNewCard(data);
          ctrl.cardElements.clear();
        }, function (err) {
          console.error('Error saving Stripe SCA card:', err);
          ctrl.cardFormVisible = false;
          ctrl.cardAnimation = false;
          ctrl.cardElements.clear();

          UIDialogService.open('alert', {
            title: $i18next.t('general.titles.error'),
            text: err.data.msg ? (err.data.msg.join ? err.data.msg.join('. ') : err.data.msg) : $i18next.t('bookings.payment.alert.card_is_invalid_text')
          });
        });
      })
  }

  function pcibooking_callback (event) {
    if (event.data) {
      var status = event.data.success;
      var card = event.data.card;
      var token = card ? card.card_token : event.data.token;

      if (status === true) {
        ctrl.cardAnimation = true;

        if (window.addEventListener) {
          window.removeEventListener('message', ctrl.pcibooking_callback);
        } else if (window.attachEvent) {
          window.detachEvent('onmessage', ctrl.pcibooking_callback);
        }

        ctrl.saveWubookCardCallback(
          token,
          card ? card.cardholder_name : window.decodeURI(event.data.cardHolderName),
          card ? card.card_number : event.data.cardNumber,
          card ? card.card_type : event.data.cardType,
          card ? card.expiration_month + card.expiration_year : event.data.expiration
        );
      } else {
        ctrl.cardAnimation = false;
        console.error($i18next.t('general.other.error'));
      }
    }
  }

  function saveWubookCardCallback (nonce, cardHolderName, last_4, cardType, expiration) {
    new CreditCardFactory(
      {
        nonce       : nonce,
        customer_id : ctrl.bookingCustomers[ctrl.activeCustomer].id,
        hotel_id    : $scope.hotel.id,
        booking_id  : $scope.booking.id,
        cvv_present : true,
        cardholder_name : cardHolderName,
        card_type: cardType,
        expiration_year: expiration.slice(2,6),
        expiration_month: expiration.slice(0,2),
        last_4: last_4
      }
    ).create().then(function (data) {
      ctrl.cardFormVisible = false;
      ctrl.cardAnimation = false;
      ctrl.addNewCard(data);
    }, function (response) {
      ctrl.cardAnimation = false;
      ctrl.cardFormVisible = false;

      UIDialogService.open('alert', {
        title: $i18next.t('general.titles.error'),
        text: response.data.msg ? (response.data.msg.join ? response.data.msg.join('. ') : response.data.msg) : $i18next.t('bookings.payment.alert.card_is_invalid_text')
      });
    });
  }

  function saveWubookCard () {
    if (window.addEventListener) {
      window.addEventListener('message', ctrl.pcibooking_callback);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', ctrl.pcibooking_callback);
    }

    document.getElementById('pcibooking_frame_react').contentWindow.postMessage('submit', "*");
  }

  function nextCard() {
    var card = ctrl.bookingCustomers[ctrl.activeCustomer].cards.shift();
    ctrl.bookingCustomers[ctrl.activeCustomer].cards.push(card);
    ctrl.bookingCustomers = JSON.parse(JSON.stringify(ctrl.bookingCustomers));
    $scope.$apply();
  }

  function changeCustomer(customer) {
    ctrl.activeCustomer = ctrl.bookingCustomers.findIndex(function (c) { return c.id == customer.id });

    setCards();

    $scope.$apply();
  }

  if (window.Stripe && ctrl.gateway === 'stripe_sca') {
    ctrl.stripeScaGateway = window.Stripe($rootScope.hotel.clientToken);
    var elements = ctrl.stripeScaGateway.elements();
    ctrl.cardElements = elements.create('card', {
      hidePostalCode: true,
    });
  }

  var networkSatusWatcher = $rootScope.$watch('networkStatus', function (val) {
    ctrl.online = val;
  });

  $scope.$on('$destroy', function () {
    if (networkSatusWatcher) {
      networkSatusWatcher();
    }
    if (window.Stripe && ctrl.gateway === 'stripe_sca' && ctrl.cardFormVisible) {
      ctrl.cardElements.mount('#stripe-sca-drop-in');
    }
    if (window.addEventListener) {
      window.removeEventListener('message', ctrl.pcibooking_callback);
    } else if (window.attachEvent) {
      window.detachEvent('onmessage', ctrl.pcibooking_callback);
    }
    if (ctrl.cardMountTimeout) {
      $timeout.cancel(ctrl.cardMountTimeout);
    }
  });

  function setCards() {
    var customer = ctrl.bookingCustomers[ctrl.activeCustomer];

    ctrl.cards = customer.cards.sort(function(cardA, cardB) {
      var a = Number(cardA.bookingId == $scope.booking.id);
      var b = Number(cardB.bookingId == $scope.booking.id);

      if (a > b) { return -1; }
      if (a < b) { return 1; }
      return 0;
    });
    ctrl.otherCardsSize = customer.cards.filter(function(card) {
      return card.bookingId != null && card.bookingId != $scope.booking.id;
    }).length;
  }
}

angular
  .module('buuqit')
  .directive('bookingAttachmentsTab', bookingAttachmentsTab)
  .controller('bookingAttachmentsTabController', bookingAttachmentsTabController)

bookingAttachmentsTabController.$inject = [
  "$scope",
  "$rootScope",
  "$http",
  "$i18next",
  "$filter",
  "$timeout",
  "UIDialogService",
  "FolioFactory",
  "AttachmentFactory"
];

function bookingAttachmentsTabController($scope, $rootScope, $http, $i18next, $filter, $timeout, UIDialogService, FolioFactory, AttachmentFactory) {
  var bookingId = $scope.$parent.booking.id;
  var hotelId = $rootScope.hotel.id;

  angular.extend(
    $scope, {
      attachment: {files: []},
      attachments: [],
      attachmentsToUpload: [],
      loading: false,
      chooseFile: chooseFile,
      uploadFiles: uploadFiles,
      removeAttachment: removeAttachment,
      showType: showType
    }
  )

  function init() {
    load();
  }

  function chooseFile(input) {
    $timeout(function() {
      if ($scope.attachmentsToUpload.length > 0) {
        $scope.attachmentsToUpload.splice(0, $scope.attachmentsToUpload.length);
      }
      for (var i = 0; i < input.files.length; i++) {
        var f = input.files[i];
        $scope.attachmentsToUpload.push({name: f.name || "bazuzu", file: f});
      }
    }, 0);
  }

  function uploadFiles() {
    if ($scope.loading) {
      return;
    }

    $scope.loading = true;

    var fd = new FormData();
    $scope.attachment.files.forEach(function(file) {
        fd.append('booking_attachments[]', file.file);
    })

    $http.post($scope.$parent.booking.$url('attachments'), fd, {
        headers: {'Content-Type': undefined },
        transformRequest: angular.identity
    }).success(function(response) {
      $scope.loading = false;
      angular.copy([], $scope.attachment.files);
      angular.copy(response.attachments.map(function(e) { return new AttachmentFactory(e); }), $scope.attachments);
    }).error(function(response, status_code) {
      if (status_code == 413) {
        $rootScope.notify($i18next.t('general.alert_modals.files_too_big'));
      } else {
        $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      }
      $scope.loading = false;
    });
  }

  function load() {
    $scope.loading = true;
    return AttachmentFactory
      .get({
        hotelId: hotelId,
        bookingId: bookingId
      })
      .then(
        function (attachments) {
          angular.copy(attachments, $scope.attachments);
          $scope.loading = false;
        },
        function (response) {
          $scope.loading = false;
          $scope.errors = ['Something goes wrong and we can\'t load attachments for that booking.'];
        }
      );
  }

  function removeAttachment(attachment) {
    if (attachment.loading) {
      return;
    }
    attachment.loading = true;
    attachment.remove().then(function() {
      $scope.attachments.splice($scope.attachments.indexOf(attachment), 1);
    }, function() {

    })
  }

  function showType(type) {
    return {
      'facial_picture': 'Facial',
      'front_id_picture': 'Front ID',
      'back_id_picture': ' Back ID',
      'digital_signature': 'Signature',
    }[type] || type;
  }

  init();
}

bookingAttachmentsTab.$inject = ["$rootScope"];

function bookingAttachmentsTab($rootScope) {
  return {
    controller: bookingAttachmentsTabController,
    restrict: 'E',
    templateUrl: getTemplatePath('booking_management/bookingAttachmentsTab.html'),
    link: function (scope) {}
  };
}

angular
  .module('buuqit')
  .directive('userForm', userForm);

function userForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ngChange: "&"
    },
    controller: userFormController,
    templateUrl: getTemplatePath('forms/userForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

userFormController.$inject = [
  "$rootScope",
  "$scope",
  "AdminUsersFactory",
  "AdminHotelsFactory"
];

function userFormController ($rootScope, $scope, AdminUsersFactory, AdminHotelsFactory) {
  var cancel, save, _save, _create;

  cancel = function () {
    $scope.value = angular.copy($scope.originalValue);
    if (!$scope.value.id) {
      $scope.$parent.userNew = false;
    } else {
      $scope.$parent.closeEditedUser($scope.originalValue);
    }
  };

  save = function () {
    $scope.saving = true;

    if ($scope.value.id) {
      _save();
    } else {
      _create();
    }
  };

  _save = function () {
    $scope.value
      .save()
      .then(
        function (data) {
          $scope.saving = false;
          $scope.value.edited = false;
        }, function (error) {
          $scope.saving = false;
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };

  _create = function () {
    var value = angular.copy($scope.value);
    new AdminUsersFactory(value)
      .create()
      .then(function (data) {
        $scope.saving = false;
        $scope.$parent.users.push(data);
        cancel();
      }, function (error) {
        $scope.saving = false;
        $rootScope.alert(error.data.errors.join('.\r\n'));
      });
  };


  if ($scope.value.id) {
    $scope.value.hotel = $scope.$parent.hotels.filter(function (el) {return el.id == $scope.value.hotelId;})[0];
  }

  angular.extend(
    $scope,
    {
      roles : ['admin', 'user', 'reception', 'reception_no_finance'],
      originalValue : angular.copy($scope.value),
      hotels : $scope.$parent.hotels,
      saving : false,

      cancel : cancel,
      save   : save
    }
  );

  var formOpenListener = $rootScope.$on('form:openned', function(event, user_id) {
    if ($scope.value.id === user_id) {
      AdminHotelsFactory.query().then(function (data) {
        $scope.hotels = data;
        if (typeof(user_id) !== "undefined") {
          $scope.value.hotelId = $scope.originalValue.hotel.id;
        }
      }, function (error) {
        console.log(error);
      });
    }
  });

  $scope.$watch('value.hotel', function (value) {
    if (value) {
      $scope.value.hotelId = value.id;
    }
  });

  $scope.$on('$destroy', function () {
    if(formOpenListener) {
      formOpenListener();
    }
  });
}

angular
  .module('buuqit')
  .directive('hotelForm', hotelForm);

function hotelForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ngChange: "&"
    },
    controller: hotelFormController,
    templateUrl: getTemplatePath('forms/hotelForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

hotelFormController.$inject = [
  "$rootScope",
  "$scope",
  "AdminHotelsFactory"
];

function hotelFormController ($rootScope, $scope, AdminHotelsFactory) {
  var cancel, save, _save, _create;

  cancel = function () {
    $scope.value = angular.copy($scope.originalValue);
    if (!$scope.value.id) {
      $scope.$parent.hotelNew = false;
    } else {
      $scope.$parent.closeEditedHotel($scope.originalValue);
    }
  };

  save = function () {
    $scope.saving = true;

    if ($scope.value.id) {
      _save();
    } else {
      _create();
    }
  };

  _save = function () {
    $scope.value
      .save()
      .then(
        function (data) {
          $scope.saving = false;
          $scope.value.edited = false;
        }, function (error) {
          $scope.saving = false;
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };

  _create = function () {
    var value = angular.copy($scope.value);
    new AdminHotelsFactory(value)
      .create()
      .then(function (data) {
        $scope.saving = false;
        $scope.$parent.hotels.push(data);
        cancel();
      }, function (error) {
        $scope.saving = false;
        $rootScope.alert(error.data.errors.join('.\r\n'));
      });
  };


  angular.extend(
    $scope,
    {
      originalValue : angular.copy($scope.value),
      saving : false,

      cancel : cancel,
      save   : save
    }
  );
}

angular
  .module('buuqit')
  .directive('corporateAccountForm', corporateAccountForm);

function corporateAccountForm () {
  return {
    restrict: 'E',
    scope: {
      value: '=ngModel',
      ngChange: "&"
    },
    controller: corporateAccountFormController,
    templateUrl: getTemplatePath('forms/corporateAccountForm.html'),
    link: function (scope, element, attrs, ctrl) {}
  };
}

corporateAccountFormController.$inject = [
  "$rootScope",
  "$scope",
  "AdminCorporateAccountsFactory"
];

function corporateAccountFormController ($rootScope, $scope, AdminCorporateAccountsFactory) {
  var cancel, save, _save, _create;

  cancel = function () {
    $scope.value = angular.copy($scope.originalValue);
    if (!$scope.value.id) {
      $scope.$parent.corporateAccountNew = false;
    } else {
      $scope.$parent.closeEditedCorporateAccount($scope.originalValue);
    }
  };

  save = function () {
    $scope.saving = true;

    if ($scope.value.id) {
      _save();
    } else {
      _create();
    }
  };

  _save = function () {
    $scope.value
      .save()
      .then(
        function (data) {
          $scope.saving = false;
          $scope.value.edited = false;
        }, function (error) {
          $scope.saving = false;
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };

  _create = function () {
    var value = angular.copy($scope.value);
    new AdminCorporateAccountsFactory(value)
      .create()
      .then(function (data) {
        $scope.saving = false;
        $scope.$parent.corporate_accounts.push(data);
        cancel();
      }, function (error) {
        $scope.saving = false;
        $rootScope.alert(error.data.errors.join('.\r\n'));
      });
  };

  removeHotel = function (hotel) {
    $scope.value
      .removeHotel(hotel.id)
      .then(
        function (response) {
          $scope.originalValue = angular.copy(response);
        },
        function (error) {
          $rootScope.alert(error.data.message);
        }
      );
  };

  removeUser = function (user) {
    $scope.value
      .removeUser(user.id)
      .then(
        function (response) {
          $scope.originalValue = angular.copy(response);
        },
        function (error) {
          $rootScope.alert(error.data.message);
        }
      );
  };


  angular.extend(
    $scope,
    {
      originalValue : angular.copy($scope.value),
      saving : false,

      cancel : cancel,
      save   : save,
      removeHotel: removeHotel,
      removeUser: removeUser
    }
  );
}

angular
  .module('buuqit')
  .controller('WebsiteCtrl', WebsiteCtrl)
  .component('reactGoogleMap', window.TBFLibs.react2angular(
    window.TBFLibs.Map,
    [
      'zoom',
      'position',
      'onPositionChange',
      'onZoomChange'
    ],
    []
  ));

WebsiteCtrl.$inject = ["$rootScope", "$scope", "$i18next", "$timeout", "$routeParams", "$location", "WebsiteDataFactory", "$http", "$interval", "$mdDialog", "Slug"];

function WebsiteCtrl ($rootScope, $scope, $i18next, $timeout, $routeParams, $location, WebsiteDataFactory, $http, $interval, $mdDialog, Slug) {
  $rootScope.loading_preview = false;
  $rootScope.loading_draft = false;
  $rootScope.loading_publish = false;
  $rootScope.trackEvent('Website page openned');

  angular.extend($scope, {
    // Properties
    template    : getTemplatePath('website_settings/' + ($routeParams.block ? $routeParams.block : 'body_text') + '.html'),
    lang        : 'en',
    prevLang    : 'en',
    websiteDefaultLang: 'en',
    availableLangs : ['en'],
    newLang     : '',
    website     : {},
    availableRooms : [],
    addNewCustomRoom : false,
    addNewQuestion : false,
    addNewTestimonial : false,
    addNewPage : false,
    addNewRedirect : false,
    addNewDomain : false,
    addNewLink : false,
    newCustomRoom : {
      title : null,
      description : null,
      photos : []
    },
    newQuestion : {
      question : null,
      answer : null,
      showOnline : false
    },
    newTestimonial : {
      title : null,
      name : null,
      body : null,
      link: null
    },
    newPage : {
      title        : null,
      slug         : null,
      content      : '',
      menuTitle    : null,
      menuPosition : 'none',
      pagePhotos   : [],
      published    : false
    },
    newBlogRecord : {
      title : null,
      slug  : null,
      text  : '',
      cover : {
        content_type      : null,
        original_filename : null,
        data              : null
      },
      published: false
    },
    newRedirect : {
      fromUrl : null,
      toUrl   : null
    },
    newDomain : {
      domain : null
    },
    newLink : {
      title: null,
      category: null,
      value: null,
      url: null,
      position: null
    },
    pagesCollection : [],
    fake: '',
    cname_record: $rootScope.hotel && $rootScope.hotel.cnameRecord,
    uniqIcons : _.uniq(icons),
    address : $rootScope.hotel,
    bookingSystem : '',
    bodyTextVisible : false,
    termsTextVisible : false,
    ppTextVisible : false,
    aboutTextVisible : false,
    active : $routeParams.block !== undefined ? $routeParams.block : 'body_text',
    editedRoomType : null,
    newRoomType : {
      roomType    : null,
      shortName   : null,
      name        : null,
      maxAdults   : 1,
      maxChildren : 0,
      maxInfants  : 0,
      minStay     : 0,
      description : null,
      facilities  : [],
      hotel_id    : null
    },
    createFormVisible : false,
    langInterval : null,
    countries : languages,

    removeBlogRecordLoader : false,
    removePageRecordLoader : false,
    dialogPhotos : [],

    faqDescEditable : null,
    faqDescEditor : null,

    features_summernote_options : {
      toolbar: [
        ['headline', ['style']],
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['fontface', ['fontname']],
        ['textsize', ['fontsize']],
        ['view', ['fullscreen', 'codeview']]
      ]
    },

    gallery_photos: [],
    other_photos: [],
    geocodeTimeout: null,
    pasteTimeout: null,
    loadWebsiteDataTimeout: null,

    // Methods
    convertToBase64        : convertToBase64,
    save                   : save,
    setHotelLocation       : setHotelLocation,
    geocode                : geocode,

    loadCustomRoomPhotos   : loadCustomRoomPhotos,
    loadCustomPagePhotos   : loadCustomPagePhotos,
    removeFromNewPhotos    : removeFromNewPhotos,
    openAddCustomRoomForm  : openAddCustomRoomForm,
    closeAddCustomRoomForm : closeAddCustomRoomForm,
    saveNewCustomRoom      : saveNewCustomRoom,
    removeFromCustomRoomPhotos : removeFromCustomRoomPhotos,
    removeFromCustomPagePhotos : removeFromCustomPagePhotos,
    removeCustomRoom       : removeCustomRoom,
    editCustomRoom         : editCustomRoom,
    closeEditCustomRoom    : closeEditCustomRoom,

    removeQuestion         : removeQuestion,
    editQuestion           : editQuestion,
    closeEditQuestion      : closeEditQuestion,
    openAddQuestionForm    : openAddQuestionForm,
    closeAddQuestionForm   : closeAddQuestionForm,
    saveNewQuestion        : saveNewQuestion,

    removeTestimonial         : removeTestimonial,
    editTestimonial           : editTestimonial,
    closeEditTestimonial      : closeEditTestimonial,
    openAddTestimonialForm    : openAddTestimonialForm,
    closeAddTestimonialForm   : closeAddTestimonialForm,
    saveNewTestimonial        : saveNewTestimonial,

    closeAddPageRecordForm : closeAddPageRecordForm,
    saveNewPageRecord      : saveNewPageRecord,
    closeEditPageRecord    : closeEditPageRecord,
    removePageRecord       : removePageRecord,

    closeAddBlogRecordForm : closeAddBlogRecordForm,
    saveNewBlogRecord      : saveNewBlogRecord,
    closeEditBlogRecord    : closeEditBlogRecord,
    removeBlogRecord       : removeBlogRecord,
    loadBlogRecordCover    : loadBlogRecordCover,
    coverIsString          : coverIsString,

    openAddRedirectForm    : openAddRedirectForm,
    closeAddRedirectForm   : closeAddRedirectForm,
    saveNewRedirect        : saveNewRedirect,
    closeEditRedirect      : closeEditRedirect,
    editRedirect           : editRedirect,
    removeRedirect         : removeRedirect,

    openAddDomainForm      : openAddDomainForm,
    closeAddDomainForm     : closeAddDomainForm,
    saveNewDomain          : saveNewDomain,
    closeEditDomain        : closeEditDomain,
    editDomain             : editDomain,
    removeDomain           : removeDomain,

    slugify                : slugify,
    testSlug               : testSlug,
    testBlogSlug           : testBlogSlug,
    clearBookingLink       : clearBookingLink,
    openFormBlock          : openFormBlock,

    removeFromAboutPhotos  : removeFromAboutPhotos,
    loadAboutPhotos        : loadAboutPhotos,

    setActive              : setActive,
    removeLogoImage        : removeLogoImage,
    removeHeaderImage      : removeHeaderImage,
    removeFaviconImage     : removeFaviconImage,
    removeFeatureImage     : removeFeatureImage,
    editRoom               : editRoom,
    closeEditRoom          : closeEditRoom,
    changeRoomVisible      : changeRoomVisible,
    createNewRoom          : createNewRoom,
    setLangVersion         : setLangVersion,
    openAddLanguageDialog  : openAddLanguageDialog,

    removeLang             : removeLang,
    setAsDefault           : setAsDefault,
    buildPagesCollection   : buildPagesCollection,

    toggleCollapsedMenu    : toggleCollapsedMenu,
    setBlogRecord          : setBlogRecord,
    setPageRecord          : setPageRecord,
    wysiwygPaste           : wysiwygPaste,
    publishBlogRecord      : publishBlogRecord,
    publishPageRecord      : publishPageRecord,

    openAddLinkForm        : openAddLinkForm,
    closeAddLinkForm       : closeAddLinkForm,
    saveNewLink            : saveNewLink,
    navigationDnDCallback  : navigationDnDCallback,
    editLink               : editLink,
    removeLink             : removeLink,
    cancelLinkEditing      : cancelLinkEditing,
    saveLink               : saveLink,
    chooseFromLoaded       : chooseFromLoaded,
    getTranslation         : getTranslation,

    feature_filter         : feature_filter,
    getFullLanguageName    : getFullLanguageName,

    loadDataForblog        : loadDataForBlog,
    loadDataForpages       : loadDataForPages,
    loadDataFornavigation  : loadDataForNavigation,
    imageUpload            : imageUpload,
    uploadGalleryPhotos    : uploadGalleryPhotos,
    loadGalleryPhotos      : loadGalleryPhotos,
    removeGalleryPhoto     : removeGalleryPhoto,
    togglePhotoVisibility  : togglePhotoVisibility,
    setZoomLevel           : setZoomLevel,
  });

  $scope.newBlogRecordOriginal = angular.copy($scope.newBlogRecord);

  $scope.treeOptions = {
    dropped : function (e) {
      if (_.isUndefined(e.dest.nodesScope.$parent.$modelValue)) {
        e.source.nodeScope.$modelValue.link.parentId = null;
      } else {
        e.source.nodeScope.$modelValue.link.parentId = e.dest.nodesScope.$parent.$modelValue.link.id;
      }

      saveLinksTree();
    }
  };

  $scope.originalRoomType  = angular.copy($scope.newRoomType);


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      if ($rootScope.hotel.websiteBuilder == 'hidden') {
        $location.path('/');
      }
      else{
        $scope.cname_record = $rootScope.hotel.cnameRecord;
        $scope.websiteDefaultLang = $rootScope.hotel.websiteDefaultLang;
        if ($scope.loadWebsiteDataTimeout) {
          $timeout.cancel($scope.loadWebsiteDataTimeout);
        }
        $scope.loadWebsiteDataTimeout = $timeout(function () {
          loadWebsiteData();
        }, 0);
      }
    }
  });

  function convertToBase64 ($event, field, filetypes) {
    var reader = new FileReader(),
        file   = $event.target.files[0];

    if (typeof(filetypes) === "undefined") {
      filetypes = 'png,jpeg';
    }

    filetypes = _.map(filetypes.split(','), function(el) {
      return 'image/'+el;
    });

    reader.onloadend = function () {
      $scope.website[field].data = reader.result;
      $scope.$apply();
    };

    if (file) {
      if (filetypes.indexOf(file.type) > -1) {
        $scope.website[field] = {
          content_type      : file.type,
          original_filename : file.name
        };
        reader.readAsDataURL(file);
      } else {
        $rootScope.alert($i18next.t('general.alert_modals.we_support_only_format_js_str', {filetypes: filetypes}));
      }
    }
  }

  function save (type, callback) {
    if ($scope.website.textArea === null) {
      $scope.website.textArea = angular.copy($scope.textAreaOriginal);
    }

    _.each($scope.website.blogRecords, function(record, index) {
      if (typeof($scope.website.blogRecords[index].data) === "undefined") {
        delete $scope.website.blogRecords[index].cover;
      }
    });

    $scope['loading_' + type] = true;
    $scope.website
      .save()
      .then(function () {
        $scope['loading_' + type] = false;
        $scope.website.logo = { data : $scope.website.logo };
        $scope.website.headerImage = { data : $scope.website.headerImage };
        $scope.website.featuresBackgroundImage = { data : $scope.website.featuresBackgroundImage };
        $scope.website.favicon = { data : $scope.website.favicon };

        if (type === 'preview') {
          var win = window.open(window.location.origin.replace(/\/app./, '/website.').replace(/\/frontdesk./, '/website.') + '/' + $rootScope.hotel.slug + '/' + $scope.lang, '_blank');
          if (win && win.focus) {
            win.focus();
          } else {
            $rootScope.notify($i18next.t('website_settings.alert.your_browser_block_popup_window_js_str'));
          }
        }

        if (typeof(callback) === 'function') {
          callback();
        }
      }, function(error) {
        console.error('Error saving website data', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        $scope['loading_' + type] = false;
      });
  }


  function setHotelLocation (position) {
    $scope.website.mapCenterLat = position.lat;
    $scope.website.mapCenterLng = position.lng;
  }

  function geocode () {
    var address = [$scope.website.address].join(' ');

    if ($scope.geocodeTimeout) {
      $timeout.cancel(geocodeTimeout);
    }

    $scope.geocodeTimeout = $timeout(function () {
      $.get('//maps.googleapis.com/maps/api/geocode/json?address="' + address + '"' + '&key=AIzaSyD0H8S2XokqvDZ-fbbomihBjedprHjF89s', function (data) {
        if (data.status == 'OK') {
          $scope.website.mapCenterLat = data.results[0].geometry.location.lat;
          $scope.website.mapCenterLng = data.results[0].geometry.location.lng;
        }
      });
    }, 500);
  }


  function loadCustomRoomPhotos ($event, target) {
    var files  = $event.target.files;
    $scope.customPhotoLoaded = true;
    var loaded = 0;

    _.each(files, function (file) {
      var reader = new FileReader(),
          for_save = {};

      var fd = new FormData();
      fd.append("photo", file);

      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/image_upload/custom_photo_upload', fd, {
          headers: {'Content-Type': undefined },
          transformRequest: angular.identity
      }).success(function(response) {
        for_save = response;
        if (target === 'new') {
          $scope.newCustomRoom.photos.push(for_save);
        } else {
          if (target.photos === undefined) {target.photos = [];}
          target.photos.push(for_save);
        }
      }).error(function(error) {
        console.error('Error loading custom room photos:', error);
      }).then(function () {
        loaded++;
        if (loaded == files.length) {
          $scope.customPhotoLoaded = false;
        }
      });
    });
  }


  function removeFromNewPhotos (photo) {
    $scope.newCustomRoom.photos = _.without($scope.newCustomRoom.photos, photo);
  }


  function openAddCustomRoomForm (event) {
    event.preventDefault();
    $scope.originalNewCustomRoom = angular.copy($scope.newCustomRoom);
    $scope.addNewCustomRoom = true;
  }


  function closeAddCustomRoomForm () {
    $scope.addNewCustomRoom = false;
    $scope.newCustomRoom = angular.copy($scope.originalNewCustomRoom);
  }


  function saveNewCustomRoom () {
    var slugAvailable = $scope.testSlug($scope.newCustomRoom.slug);

    if (slugAvailable) {
      $scope.website.customRooms.push({
        title       : $scope.newCustomRoom.title,
        description : $scope.newCustomRoom.description,
        photos      : $scope.newCustomRoom.photos,
        slug        : $scope.newCustomRoom.slug,
        buttonText  : $scope.newCustomRoom.buttonText,
        introduction: $scope.newCustomRoom.introduction,
        pageTitle   : $scope.newCustomRoom.pageTitle,
        metaDescription: $scope.newCustomRoom.metaDescription,
        invisible   : true
      });

      $scope.save('publish', function() {
        $scope.closeAddCustomRoomForm();
      });
    } else {
      $rootScope.alert($i18next.t('website_settings.alert.page_with_current_title_is_present_change_title_for_better_seo_js_str'));
    }
  }


  function removeFromCustomRoomPhotos (photo, room) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = room.photos.indexOf(photo);
      room.photos.splice(index, 1);
    } else {
      $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/custom_photo/'+photo.id).then(function (response) {
        if (response.statusText === 'OK') {
          var index = room.photos.indexOf(photo);
          room.photos.splice(index, 1);
        }
      }).catch(function (error) {
        photo.loading = false;
        console.error('Error removing custom room photo:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    }
  }


  function removeFromCustomPagePhotos ($event, photo, page) {
    $event.preventDefault();

    if (photo.id === undefined) {
      var index = page.pagePhotos.indexOf(photo);
      page.pagePhotos.splice(index, 1);
    } else {
      $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/page_photo/'+photo.id).then(function (response) {
        if (response.statusText === 'OK') {
          var index = page.pagePhotos.indexOf(photo);
          page.pagePhotos.splice(index, 1);
        }
      }).catch(function (error) {
        console.error('Error removing from custom page:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    }
  }


  function removeCustomRoom (event, room) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      room.loading = true;
      if (room.id === undefined) {
        $scope.website.customRooms.splice($scope.website.customRooms.indexOf(room), 1);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/custom_room/'+room.id).then(function (response) {
          room.loading = false;
          if (response.statusText === 'OK') {
            $scope.website.customRooms.splice($scope.website.customRooms.indexOf(room), 1);
          } else {
            $rootScope.alert(response.statusText);
          }
        }).catch(function (error) {
          room.loading = false;
          console.error('Error removing custom room:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      }
    }, function() {});
  }


  function editCustomRoom (event, room) {
    event.preventDefault();

    $scope.originalCustomRoom = angular.copy(room);
    room.edited = true;
  }


  function closeEditCustomRoom (event, room, reset) {
    event.preventDefault();

    if (reset === true) {
      var index = $scope.website.customRooms.indexOf(room);
      $scope.website.customRooms[index] = angular.copy($scope.originalCustomRoom);
    } else {
      var slugAvailable = $scope.testSlug($scope.newCustomRoom.slug);
      if (slugAvailable) {
        $scope.save('publish', function() {
          room.edited = false;
        });
      } else {
        $rootScope.alert($i18next.t('website_settings.alert.page_with_current_title_is_present_change_title_for_better_seo_js_str'));
      }
    }
  }


  function closeEditRoom (event, room, reset) {
    event.preventDefault();

    if (reset === true) {
      var index = $scope.website.rooms.indexOf(room);
      $scope.website.rooms[index] = angular.copy($scope.originalRoom);
    } else {
      $scope.save('publish', function() {
        room.edited = false;
      });
    }
  }


  function editRoom (event, room) {
    event.preventDefault();

    $scope.originalRoom = angular.copy(room);
    room.edited = true;
  }


  function changeRoomVisible (state, record) {
    var type;

    record.visible_loader = true;
    record.visible = state;

    if (record.roomTypeId) {
      type = 'rooms';
    } else {
      type = 'custom_rooms';
    }

    $http
      .post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/' + type + '/' + record.id + '/toggle')
      .then(function(response) {
        record.visible_loader = false;
      }).catch(function (error) {
        console.error('Error changing room visibility:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function removeQuestion (event, question) {
    var confirm = $mdDialog.confirm()
    .title($i18next.t('general.confirm.confirm'))
    .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
    .ok($i18next.t('general.confirm.confirm'))
    .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      question.loading = true;
      if (question.id === undefined) {
        $scope.website.questions.splice($scope.website.questions.indexOf(question), 1);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/question/'+question.id).then(function (response) {
          if (response.statusText === 'OK') {
            $scope.website.questions.splice($scope.website.questions.indexOf(question), 1);
          } else {
            question.loading = false;
            console.error('Error removing question:', response);
            $rootScope.alert(response.statusText);
          }
        });
      }
    }, function() {});
  }


  function editQuestion (event, question) {
    event.preventDefault();

    $scope.originalQuestion = angular.copy(question);
    question.edited = true;
  }


  function closeEditQuestion (event, question, reset) {
    event.preventDefault();

    if (reset === true) {
      question.question   = angular.copy($scope.originalQuestion.question);
      question.answer     = angular.copy($scope.originalQuestion.answer);
      question.showOnline = angular.copy($scope.originalQuestion.showOnline);
      question.edited = false;
    }

    if (reset === false) {
      $scope.save('publish', function() {
        question.edited = false;
      });
    }
  }


  function openAddQuestionForm (event) {
    event.preventDefault();

    $scope.newQuestionOriginal = angular.copy($scope.newQuestion);
    $scope.addNewQuestion = true;
  }


  function closeAddQuestionForm () {
    $scope.newQuestion = angular.copy($scope.newQuestionOriginal);
    $scope.addNewQuestion = false;
  }


  function saveNewQuestion () {
    $scope.website.questions.push(angular.copy(angular.extend($scope.newQuestion, {invisible: true})));

    $scope.save('publish', function() {
      $scope.newQuestion = angular.copy($scope.newQuestionOriginal);
      $scope.addNewQuestion = false;
    });
  }


  function removeTestimonial (event, testimonial) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      testimonial.loading = true;
      if (testimonial.id === undefined) {
        $scope.website.testimonials.splice($scope.website.testimonials.indexOf(testimonial), 1);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/testimonial/'+testimonial.id).then(function (response) {
          if (response.statusText === 'OK') {
            $scope.website.testimonials.splice($scope.website.testimonials.indexOf(testimonial), 1);
          } else {
            testimonial.loading = false;
            console.error('Error removing testimonial:', response);
            $rootScope.alert(response.statusText);
          }
        });
      }
    }, function() {});
  }


  function editTestimonial (event, testimonial) {
    event.preventDefault();

    $scope.originalTestimonial = angular.copy(testimonial);
    testimonial.edited = true;
  }


  function closeEditTestimonial (event, testimonial, reset) {
    event.preventDefault();

    if (reset === true) {
      testimonial.name  = angular.copy($scope.originalTestimonial.name);
      testimonial.title = angular.copy($scope.originalTestimonial.title);
      testimonial.body  = angular.copy($scope.originalTestimonial.body);
      testimonial.link  = angular.copy($scope.originalTestimonial.link);
      testimonial.edited = false;
    }

    if (reset === false) {
      $scope.save('publish', function() {
        testimonial.edited = false;
      });
    }
  }


  function openAddTestimonialForm (event) {
    event.preventDefault();

    $scope.newTestimonialOriginal = angular.copy($scope.newTestimonial);
    $scope.addNewTestimonial = true;
  }


  function closeAddTestimonialForm () {
    $scope.newTestimonial = angular.copy($scope.newTestimonialOriginal);
    $scope.addNewTestimonial = false;
  }


  function saveNewTestimonial () {
    $scope.website.testimonials.push(angular.copy(angular.extend($scope.newTestimonial, {invisible: true})));

    $scope.save('publish', function() {
      $scope.newTestimonial = angular.copy($scope.newTestimonialOriginal);
      $scope.addNewTestimonial = false;
    });
  }


  function closeAddPageRecordForm () {
    $scope.newPageRecord = angular.copy($scope.originalPageRecord);
    $scope.page_record = null;
    $scope.setActive('pages');
  }


  function saveNewPageRecord () {
    var slugAvailable = $scope.testSlug($scope.page_record.slug);

    if (_.isEmpty($scope.page_record.title)) {
      $rootScope.alert($i18next.t('website_settings.alert.title_can_not_be_empty_js_str'));
    } else if (!slugAvailable) {
      $rootScope.alert($i18next.t('website_settings.alert.page_with_current_title_is_present_change_title_for_better_seo_js_str'));
    } else {
      var record = angular.copy($scope.page_record);
      record.menu_title = record.menuTitle;
      record.menu_position = record.menuPosition;
      record.page_title = record.pageTitle;
      record.meta_description = record.metaDescription;
      record.website_page_photos_attributes = angular.copy(record.pagePhotos);
      record.createdAt = moment().toDate();
      $scope.loading_publish = true;
      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/pages/?lang=' + $scope.lang, {data: record}).then(function(response) {
        var record = response.data;
        $scope.loading_publish = false;
        $scope.pages.push(record);
        $scope.newPageRecord = angular.copy($scope.originalPageRecord);
        $scope.page_record = null;
        $scope.setActive('pages');
      }).catch(function (error) {
        console.error('Error save new page record', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    }
  }


  function removePageRecord (event, record) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      $scope.removePageRecordLoader = true;
      if (record.id === undefined) {
        $scope.pages.splice($scope.pages.indexOf(record), 1);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/pages/'+record.id).then(function (response) {
          if (response.statusText === 'OK') {
            $scope.removePageRecordLoader = false;
            $scope.pages.splice($scope.pages.indexOf(record), 1);
            $scope.setActive('pages');
          }
        }).catch(function (error) {
          console.error('Error removing page record:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      }
    }, function() {});
  }


  function closeEditPageRecord (event, record, reset) {
    event.preventDefault();

    if (reset === true) {
      record.title   = angular.copy($scope.originalPageRecord.title);
      record.slug    = angular.copy($scope.originalPageRecord.slug);
      record.content = angular.copy($scope.originalPageRecord.content);
      $scope.setActive('pages');
    } else {
      var slugAvailable = $scope.testSlug(record.slug, record.id);
      record.updatedAt = new Date();
      if (_.isEmpty(record.title)) {
        $rootScope.alert($i18next.t('website_settings.alert.title_can_not_be_empty_js_str'));
      } else if (!slugAvailable) {
        $rootScope.alert($i18next.t('website_settings.alert.page_with_current_title_is_present_change_title_for_better_seo_js_str'));
      } else if (!record.slug) {
        $rootScope.alert($i18next.t('website_settings.alert.slug_can_t_be_empty'));
      } else {
        $scope.loading_publish = true;
        record.menu_title = record.menuTitle;
        record.menu_position = record.menuPosition;
        record.page_title = record.pageTitle;
        record.meta_description = record.metaDescription;
        record.website_page_photos_attributes = angular.copy(record.pagePhotos);
        $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/pages/'+record.id+'?lang=' + $scope.lang, {data: record}).then(function(response) {
          $scope.loading_publish = false;
          record = response.data;
        }).catch(function (error) {
          console.error('Error:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      }
    }
  }


  function slugify (title, page) {
    page.slug = Slug.slugify(title);
  }


  function testSlug (slug, type, id) {
    var free = true,
        reservedWords = ['about', 'book', 'blog'];

    pages = $scope.pages.filter(function (el) { return el.slug === slug; });
    rooms = $scope.availableRooms.filter(function (el) { return el.slug === slug; });
    customRooms = $scope.website.customRooms.filter(function (el) { return el.slug === slug; });

    if (rooms.length > 0) {
      free = false;
    }

    if (pages.lenth > 0) {
      if (type === 'page' && pages.filter(function(el) { return el.id !== id; }).length > 0) {
        free = false;
      }
    }

    if (customRooms.lenth > 0) {
      if (type === 'room' && customRooms.filter(function(el) { return el.id !== id; }).length > 0) {
        free = false;
      }
    }

    if (reservedWords.indexOf(slug) > -1) {
      free = false;
    }

    return free;
  }


  function testBlogSlug (slug, id) {
    var blogRecords = $scope.blogRecords.filter(function (el) { return el.slug === slug; });

    if (blogRecords.length > 0) {
      return !(typeof(id) === "undefined" || blogRecords.filter(function(el) { return el.id !== id; }).length > 0);
    } else {
      return true;
    }
  }


  function clearBookingLink (val) {
    if (val === 'internal') {
      $scope.originalBookingLink = angular.copy($scope.website.bookingLink);
      $scope.website.bookingLink = '';
    } else {
      $scope.website.bookingLink = angular.copy($scope.originalBookingLink);
    }
  }


  function openFormBlock (variable) {
    $scope[variable] = !$scope[variable];
  }


  function loadAboutPhotos ($event, index) {
    var files  = $event.target.files;

    _.each(files, function (file) {
      var reader = new FileReader(),
          for_save = {};

      reader.onloadend = function () {
        for_save.data = reader.result;
        if (typeof(index) === "undefined") {
          $scope.website.aboutPhotos.push(for_save);
        } else {
          $scope.website.aboutPhotos[index] = for_save;
        }
        $scope.$apply();
      };

      if (file) {
        if (file.type == 'image/png' || file.type == 'image/jpeg') {
          filename = file.name;
          for_save = {
            content_type      : file.type,
            original_filename : file.name,
            data              : null
          };

          if (index !== undefined) {
            for_save.id = $scope.website.aboutPhotos[index].id;
          }
          reader.readAsDataURL(file);
        } else {
          alert($i18next.t('general.alert_modals.we_support_only_png_format_js_str'));
        }
      }

    });
  }


  function loadCustomPagePhotos ($event, target) {
    var files  = $event.target.files;

    _.each(files, function (file) {
      var reader = new FileReader(),
          for_save = {};

      reader.onloadend = function () {
        for_save.data = reader.result;
        if (target === 'new') {
          $scope.newPage.pagePhotos.push(for_save);
        } else {
          if (target.pagePhotos === undefined) {target.pagePhotos = [];}
          target.pagePhotos.push(for_save);
        }
        $scope.$apply();
      };

      if (file) {
        if (file.type == 'image/png' || file.type == 'image/jpeg') {
          filename = file.name;
          for_save = {
            content_type      : file.type,
            original_filename : file.name,
            data              : null
          };
          reader.readAsDataURL(file);
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.we_support_only_png_format_js_str'));
        }
      }

    });
  }



  function removeFromAboutPhotos (photo) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = $scope.website.aboutPhotos.indexOf(photo);
      $scope.website.aboutPhotos.splice(index, 1);
    } else {
      $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/about_photo/'+photo.id).then(function (response) {
        photo.loading = false;
        if (response.statusText === 'OK') {
          var index = $scope.website.aboutPhotos.indexOf(photo);
          $scope.website.aboutPhotos.splice(index, 1);
        } else {
          console.error('Error removing about photo:', response);
          $rootScope.alert(response.statusText);
        }
      });
    }
  }


  function setActive (tab, id) {
    var path;

    $scope.active = tab;
    $scope.template = getTemplatePath('website_settings/' + tab + '.html');

    if (tab === 'blog_edit') { $scope.setBlogRecord(id); } else { $scope.blog_record = null; }
    if (tab === 'page_edit') { $scope.setPageRecord(id); } else { $scope.page_record = null; }
    if (tab === 'gallery') { $scope.loadGalleryPhotos(); }

    $scope.$broadcast('website:tabChanged');

    $timeout(function() {
      if (tab === 'contacts') {
        $scope.website.mapZoomLevel = $scope.original_zoom;
      }
    }, 500);

    $routeParams.block = tab;
    path = '/website/' + tab;

    if ((tab === 'blog_edit' || tab === 'page_edit') && id !== undefined) {
      $routeParams.id = id;
      path += '/' + id;
    }

    if (typeof($scope['loadDataFor'+tab]) === 'function') {
      $scope['loadDataFor'+tab]();
    }

    $location.path(path, false);
  }


  function setBlogRecord (id) {
    $scope.active_blog_record = id;
    if (id === undefined) {
      $scope.originalBlogRecord = angular.copy($scope.newBlogRecord);
      $scope.blog_record = angular.copy($scope.newBlogRecord);
      $scope.blogLoad = false;
    } else {
      if ($scope.blogRecords) {
        record = $scope.blogRecords.filter(function(el) { return el.id == id; });
        if (record.length > 0) {
          $scope.blogLoad = true;
          $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/blog_records/'+id+'?lang=' + $scope.lang).then(function(response) {
            record[0] = response.data;
            $scope.blog_record = record[0];
            $scope.originalBlogRecord = angular.copy(record[0]);
            $scope.blogLoad = false;
          }).catch(function (error) {
            console.error('Error:', error);
            $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
          });
        } else {
          $scope.setActive('blog');
          $location.path('/website/blog', false);
        }
      } else {
        $scope.loadDataForblog(function() {$scope.setBlogRecord(id)});
      }
    }
  }


  function setPageRecord (id) {
    $scope.active_page_record = id;
    if (id === undefined) {
      $scope.originalPageRecord = angular.copy($scope.newPage);
      $scope.page_record = angular.copy($scope.newPage);
      $scope.pagesLoad = false;
    } else {
      if ($scope.pages) {
        record = $scope.pages.filter(function(el) { return el.id == id; });
        if (record.length > 0) {
          $scope.pagesLoad = true;
          $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/pages/'+id+'?lang=' + $scope.lang).then(function(response) {
            record[0] = response.data;
            $scope.page_record = record[0];
            $scope.originalPageRecord = angular.copy(record[0]);
            $scope.pagesLoad = false;
          }).catch(function (error) {
            console.error('Error:', error);
            $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
          });
        } else {
          $scope.setActive('pages');
          $location.path('/website/pages', false);
        }
      } else {
        $scope.loadDataForpages(function() {
          $scope.setPageRecord(id);
        });
      }
    }
  }


  function removeLogoImage () {
    $http
      .delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/logo?lang='+$scope.lang)
      .then(
        function () {
          $scope.website.logo = null;
        },
        function (error) {
          console.error('Error removing logo image:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        }
      );
  }


  function removeHeaderImage () {
    $http
      .delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/header?lang='+$scope.lang)
      .then(
        function () {
          $scope.website.headerImage = null;
        },
        function (error) {
          console.error('Error removing header image:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        }
      );
  }


  function removeFaviconImage () {
    $http
      .delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/favicon?lang='+$scope.lang)
      .then(
        function () {
          $scope.website.favicon = null;
        },
        function (error) {
          console.error('Error removing favicon image:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        }
      );
  }


  function removeFeatureImage () {
    $http
      .delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/feature?lang='+$scope.lang)
      .then(
        function () {
          $scope.website.featuresBackgroundImage = null;
        },
        function (error) {
          console.error('Error removing feature image:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        }
      );
  }


  function createNewRoom () {
    $scope.createFormVisible = true;
  }


  function setLangVersion (lang) {
    if (lang !== undefined) {
      $scope.lang = lang;
    } else {
      if ($scope.lang === 'Add new language') {
        $scope.lang = $scope.prevLang;
      }
    }

    $scope.prevLang = angular.copy($scope.lang);

    loadWebsiteData();
  }

  function setZoomLevel(zoomLevel) {
    $scope.website.mapZoomLevel = zoomLevel;
  }

  function loadWebsiteData () {
    WebsiteDataFactory
      .query({lang : $scope.lang}, {hotelId : $rootScope.hotel.id})
      .then(function (response) {
        $scope.availableLangs = response.availableLangs;
        $scope.website = response;
        $scope.original_zoom = $scope.website.mapZoomLevel;
        $scope.textAreaOriginal = angular.copy($scope.website.textArea);
        $scope.website.lang = $scope.lang;
        $scope.website.logo = { data : $scope.website.logo };
        $scope.website.headerImage = { data : $scope.website.headerImage };
        $scope.website.featuresBackgroundImage = { data : $scope.website.featuresBackgroundImage };
        $scope.website.favicon = { data : $scope.website.favicon };
        $scope.blogRecords = [];
        $scope.pages = [];

        $scope.rtMapping = {}
        _.each($rootScope.hotel.roomTypes, function (room) {
          $scope.rtMapping[room.id] = room.name;

          var newRoom = {
            name : room.name,
            description : room.description,
            visible : false,
            slug : Slug.slugify(room.name),
            roomTypeId: room.id
          };

          if ($scope.website.rooms.filter(function(el) {return el.roomTypeId == room.id;}).length === 0) {
            $scope.website.rooms.push(newRoom);
          }
        });

        _.each($scope.availableRooms, function (room) {
          if ($scope.website.rooms.filter(function(el) {return el.roomTypeId === room.id; }).length === 0) {
            $scope.website.rooms.push({
              roomTypeId : room.id,
              visible    : room.visible
            });
          }
        });

        if ($scope.website.features.length === 0) { $scope.website.features = [{}, {}, {}, {}, {}, {}]; }
        if ($scope.website.footers.length === 0) { $scope.website.footers = [{}, {}, {}]; }
        if ($scope.website.questions.length === 0) { $scope.website.questions = []; }

        $scope.address = [
          $rootScope.hotel.address,
          $rootScope.hotel.city,
          $rootScope.hotel.state,
          $rootScope.hotel.country,
          $rootScope.hotel.zipCode
        ].join(', ');

        if ($scope.website.address === '' || $scope.website.address === undefined) {
          $scope.website.address = $scope.address;
        }

        if ($scope.website.bookingLink === '' || $scope.website.bookingLink === undefined || $scope.website.bookingLink === null) {
          $scope.bookingSystem = 'internal';
        } else {
          $scope.bookingSystem = 'other';
        }

        if ($routeParams.block == 'blog_edit') { $scope.setBlogRecord($routeParams.id); }
        if ($routeParams.block == 'page_edit') { $scope.setPageRecord($routeParams.id); }
        if ($routeParams.block == 'gallery') { $scope.loadGalleryPhotos(); }

        if (typeof($scope['loadDataFor'+$routeParams.block]) === 'function') {
          $scope['loadDataFor'+$routeParams.block]();
        }

        buildLinksTree('top');
        buildLinksTree('footer');
      }).catch(function (error) {
        console.error('Error:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function buildLinksTree(zone) {
    if (zone == 'top') {
      $scope.topLinks = [];

      _.each($scope.website.websiteLinks.filter(function(el) {return el.zone == 'top' && _.isNull(el.parentId);}), function(link) {
        addLinkIntoTree($scope.topLinks, link);
      });
    }

    if (zone == 'footer') {
      $scope.footerLinks = [];
      _.each($scope.website.websiteLinks.filter(function(el) {return el.zone == 'footer' && _.isNull(el.parentId);}), function(link) {
        addLinkIntoTree($scope.footerLinks, link);
      });
    }
  }


  function saveLinksTree() {
    var links = [];

    extractLinks(links, $scope.topLinks);
    extractLinks(links, $scope.footerLinks);

    $scope.save('publish');
  }


  function extractLinks(destObject, links) {
    _.each(links, function (linkNode, index) {
      destObject.push(linkNode.link);
      destObject[destObject.length - 1].position = index;

      if (linkNode.nodes.length > 0) {
        extractLinks(destObject, linkNode.nodes);
      }
    });
  }


  function addLinkIntoTree(target, link) {
    target.push({
      id: link.id,
      link: link,
      nodes: []
    });

    var newTarget = target[target.length - 1].nodes;

    _.each($scope.website.websiteLinks.filter(function(el) {return el.parentId == link.id;}), function(link) {
      addLinkIntoTree(newTarget, link);
    });
  }


  function openAddLanguageDialog() {
    $scope.lang = $scope.prevLang;
    $mdDialog.show({
      controller: AddLanguageCtrl,
      templateUrl: getTemplatePath('modals/addLanguage.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: false
    })
      .then(function(code) {
        if (code) {
          $scope.website.langDraft(code.toLowerCase());
          $rootScope.notify($i18next.t('website_settings.alert.please_wait_while_new_language_profile_was_created_js_str'));

          $scope.langInterval = $interval(function() {
            $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/langs').then(function(response) {
              if (response.data.available_langs.length == $scope.availableLangs.length + 1) {
                $interval.cancel($scope.langInterval);
                $scope.availableLangs = response.data.available_langs;
              }
            }).catch(function (error) {
              console.error('Error:', error);
              $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
            });
          }, 10000);

        }
      }, function() {});
  }


  function setAsDefault (lang) {
    $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/langs?lang=' + lang).then(function(response) {
      if (response.data.status == 'Ok') {
        $rootScope.hotel.websiteDefaultLang = response.data.lang;
        $scope.websiteDefaultLang = $rootScope.hotel.websiteDefaultLang;

        $rootScope.alert($i18next.t('website_settings.alert.this_language_marked_as_default_js_str'));
      }
    }).catch(function (error) {
      console.error('Error:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function removeLang (lang) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      $http
        .delete(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/langs?lang=' + lang)
        .then(function(response) {
          if (response.data.status == 'Ok') {
            $rootScope.alert($i18next.t('website_settings.alert.this_version_successfully_removed_js_str'));
            $scope.availableLangs = _.without($scope.availableLangs, lang);
            $rootScope.hotel.websiteDefaultLang = response.data.lang;
            $scope.websiteDefaultLang = $rootScope.hotel.websiteDefaultLang;
            $scope.setLangVersion('en');
          } else {
            console.error('Error removing language:', response);
            $rootScope.alert($i18next.t('website_settings.alert.you_cannot_delete_default_lang_js_str'));
          }
        });
    }, function() {});
  }


  function closeAddBlogRecordForm () {
    $scope.newBlogRecord = angular.copy($scope.newBlogRecordOriginal);
    $scope.newBlogRecord.cover = {
      data              : null,
      content_type      : null,
      original_filename : null
    };
    $scope.blog_record = null;
    $scope.setActive('blog');
  }


  function saveNewBlogRecord () {
    var slugAvailable = $scope.testBlogSlug($scope.blog_record.slug);

    if (_.isEmpty($scope.blog_record.title)) {
      $rootScope.alert($i18next.t('website_settings.alert.title_can_not_be_empty_js_str'));
    } else if (!slugAvailable) {
      $rootScope.alert($i18next.t('website_settings.alert.blog_record_with_current_title_is_present_change_title_for_better_seo'));
    } else {
      var record = angular.copy($scope.blog_record);
      record.meta_description = record.metaDescription;
      record.page_title = record.pageTitle;
      $scope.blog_record.createdAt = moment().toDate();
      $scope.loading_publish = true;
      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/blog_records/?lang=' + $scope.lang, {data: record}).then(function(response) {
        var record = response.data;
        $scope.loading_publish = false;
        $scope.blogRecords.push(record);
        $scope.newBlogRecord = angular.copy($scope.originalBlogRecord);
        $scope.newBlogRecord.cover = {
          data              : null,
          content_type      : null,
          original_filename : null
        };
        $scope.blog_record = null;
        $scope.setActive('blog');
      }).catch(function (error) {
        console.error('Error:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    }
  }


  function removeBlogRecord (event, record) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      $scope.removeBlogRecordLoader = true;
      if (record.id === undefined) {
        $scope.blogRecords.splice($scope.blogRecords.indexOf(record), 1);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/blog/'+record.id).then(function (response) {
          if (response.statusText === 'OK') {
            $scope.removeBlogRecordLoader = false;
            $scope.blogRecords.splice($scope.blogRecords.indexOf(record), 1);
            $scope.setActive('blog');
          }
        }).catch(function (error) {
          console.error('Error:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      }
    }, function() {});
  }


  function closeEditBlogRecord (event, record, reset) {
    event.preventDefault();

    if (reset === true) {
      record.title  = angular.copy($scope.originalBlogRecord.title);
      record.slug   = angular.copy($scope.originalBlogRecord.slug);
      record.text   = angular.copy($scope.originalBlogRecord.text);
      record.published = angular.copy($scope.originalBlogRecord.published);
      $scope.setActive('blog');
    } else {
      var slugAvailable = $scope.testBlogSlug(record.slug, record.id);
      record.updatedAt = new Date();
      if (_.isEmpty(record.title)) {
        $rootScope.alert($i18next.t('website_settings.alert.title_can_not_be_empty_js_str'));
      } else if (!slugAvailable) {
        $rootScope.alert($i18next.t('website_settings.alert.blog_record_with_current_title_is_present_change_title_for_better_seo'));
      } else {
        $scope.loading_publish = true;
        record.meta_description = record.metaDescription;
        record.page_title = record.pageTitle;
        $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/blog_records/'+record.id+'?lang=' + $scope.lang, {data: record}).then(function(response) {
          $scope.loading_publish = false;
          record = response.data;
        }).catch(function (error) {
          console.error('Error:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      }
    }
  }


  function loadBlogRecordCover ($event, target) {
    var files  = $event.target.files;

    _.each(files, function (file) {
      var reader = new FileReader(),
          for_save = {};

      reader.onloadend = function () {
        for_save.data = reader.result;
        angular.extend(target, for_save);
        $scope.$apply();
      };

      if (file) {
        if (file.type == 'image/png' || file.type == 'image/jpeg') {
          filename = file.name;
          for_save = {
            content_type      : file.type,
            original_filename : file.name,
            data              : null
          };
          reader.readAsDataURL(file);
        } else {
          $rootScope.alert($i18next.t('website_settings.alert.we_support_only_png_and_jpeg_format_js_str'));
        }
      }

    });
  }


  function coverIsString (cover) {
    return typeof(cover) === 'string';
  }


  function openAddRedirectForm (event) {
    event.preventDefault();

    $scope.buildPagesCollection();

    $scope.newRedirectOriginal = angular.copy($scope.newRedirect);
    $scope.addNewRedirect = true;
  }


  function closeAddRedirectForm () {
    $scope.newRedirect = angular.copy($scope.newRedirectOriginal);
    $scope.addNewRedirect = false;
  }


  function saveNewRedirect () {
    var redirect = angular.copy($scope.newRedirect);

    redirect.fromUrl = redirect.fromUrl.toLowerCase();
    redirect.toUrl = redirect.toUrl.toLowerCase();

    if (redirect.fromUrl[0] == "/") {
      redirect.fromUrl = redirect.fromUrl.slice(1, redirect.fromUrl.length);
    }
    if (redirect.toUrl[0] == "/") {
      redirect.toUrl = redirect.toUrl.slice(1, redirect.toUrl.length);
    }

    $scope.website.redirects.push(
      angular.extend(
        redirect,
        {
          invisible: true
        }
      )
    );

    $scope.save('publish', function() {
      $scope.newRedirect = angular.copy($scope.newRedirectOriginal);
      $scope.addNewRedirect = false;
    });
  }


  function removeRedirect (event, record) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      record.loading = true;
      if (record.id === undefined) {
        $scope.website.redirects.splice($scope.website.redirects.indexOf(record), 1);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/redirect/'+record.id).then(function (response) {
          if (response.statusText === 'OK') {
            $scope.website.redirects.splice($scope.website.redirects.indexOf(record), 1);
          } else {
            console.error('Error removing redirect:', response);
            record.loading = false;
            $rootScope.alert(response.statusText);
          }
        });
      }
    }, function() {});
  }


  function editRedirect (event, record) {
    event.preventDefault();

    $scope.buildPagesCollection();

    $scope.originalRedirect = angular.copy(record);
    record.edited = true;
  }


  function closeEditRedirect (event, record, reset) {
    event.preventDefault();

    if (reset === true) {
      record.fromUrl = angular.copy($scope.originalRedirect.fromUrl);
      record.toUrl   = angular.copy($scope.originalRedirect.toUrl);

      record.edited = false;
    } else {
      record.fromUrl = record.fromUrl.toLowerCase();
      record.toUrl   = record.toUrl.toLowerCase();

      if (record.fromUrl[0] == "/") {
        record.fromUrl = record.fromUrl.slice(1, record.fromUrl.length);
      }
      if (record.toUrl[0] == "/") {
        record.toUrl = record.toUrl.slice(1, record.toUrl.length);
      }

      $scope.save('publish', function() {
        record.edited = false;
      });
    }
  }


  function buildPagesCollection () {
    $scope.pagesCollection = [{
      url   : '',
      title : 'Main page',
      type  : 'Pages'
    }, {
      url   : '/book',
      title : 'Booking page',
      type  : 'Pages'
    }];

    _.each($scope.website.pages, function(el) {
      $scope.pagesCollection.push({
        url:   el.slug,
        title: el.title,
        type:  'Pages'
      });
    });
    _.each($scope.website.rooms, function(el) {
      var filteredRooms = $scope.availableRooms.filter(function(room) {return room.id == el.roomTypeId; });
      if (filteredRooms.length > 0) {
        $scope.pagesCollection.push({
          url: el.slug,
          title: $scope.availableRooms.filter(function (room) {
            return room.id == el.roomTypeId;
          })[0].shortName,
          type: 'Rooms'
        });
      }
    });
    _.each($scope.website.customRooms, function(el) {
      $scope.pagesCollection.push({
        url:   el.slug,
        title: el.title,
        type:  'Custom rooms'
      });
    });
    _.each($scope.website.blogRecords, function(el) {
      $scope.pagesCollection.push({
        url:   'blog/'+el.slug,
        title: el.title,
        type:  'Blog records'
      });
    });
  }


  function openAddDomainForm (event) {
    event.preventDefault();

    $scope.newDomainOriginal = angular.copy($scope.newDomain);
    $scope.addNewDomain = true;
  }


  function closeAddDomainForm () {
    $scope.newDomain = angular.copy($scope.newDomainOriginal);
    $scope.addNewDomain = false;
  }


  function saveNewDomain () {
    var domain = angular.copy(angular.extend($scope.newDomain, {invisible: true}));

    $scope.website.domains.push(domain);

    $scope.save('publish', function() {
      $scope.addNewDomain = false;
      $scope.newDomain = angular.copy($scope.newDomainOriginal);
    });
  }


  function removeDomain (event, record) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      if (record.id === undefined) {
        $scope.website.domains.splice($scope.website.domains.indexOf(record), 1);
      } else {
        record.loading = true;
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/domain/'+record.id).then(function (response) {
          if (response.statusText === 'OK') {
            $scope.website.domains.splice($scope.website.domains.indexOf(record), 1);
            if ($scope.website.url == record.domain) {
              $scope.website.url = '';
              $scope.save();
            }
          } else {
            console.error('Error removing domain:', response);
            record.loading = false;
            $rootScope.alert(response.statusText ? response.statusText : $i18next.t('website_settings.alert.server_error_try_again_later_or_contact_support_team_js_str'));
          }
        }, function(response) {
          console.error('Error:', response);
          record.loading = false;
          $rootScope.alert(response.statusText ? response.statusText : $i18next.t('website_settings.alert.server_error_try_again_later_or_contact_support_team_js_str'));
        });
      }
    }, function() {});
  }


  function editDomain (event, record) {
    event.preventDefault();

    $scope.originalDomain = angular.copy(record);

    record.edited = true;
  }


  function closeEditDomain (event, record, reset) {
    event.preventDefault();

    if (reset === true) {
      record.domain = angular.copy($scope.originalDomain.domain);
      record.edited = false;
    } else {
      $scope.save('publish', function() {
        record.edited = false;
      });
    }
  }


  function toggleCollapsedMenu (event) {
    angular.element(event.currentTarget).closest('li.collapsed-link').toggleClass('openned');
  }

  function wysiwygPaste (e) {
    var thisNote = $(e.currentTarget);
    var updatePastedText = function(someNote){
      var original = someNote.code();
      var cleaned = (function(original){
        var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
        var output = original.replace(stringStripper, ' ');
        var commentSripper = new RegExp('<!--(.*?)-->','g');
        var tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>','gi');
        var badTags = ['style', 'script','applet','embed','noframes','noscript'];
        output = output.replace(commentSripper, '');
        output = output.replace(tagStripper, '');

        for (var i=0; i< badTags.length; i++) {
          tagStripper = new RegExp('<'+badTags[i]+'.*?'+badTags[i]+'(.*?)>', 'gi');
          output = output.replace(tagStripper, '');
        }
        var badAttributes = ['style', 'start'];
        for (var x=0; x< badAttributes.length; x++) {
          var attributeStripper = new RegExp(' ' + badAttributes[x] + '="(.*?)"','gi');
          output = output.replace(attributeStripper, '');
        }
        return output;
      })(original);
      someNote.code('').html(cleaned);
    };
    if ($scope.pasteTimeout) {
      $timeout.cancel($scope.pasteTimeout);
    }
    $scope.pasteTimeout = $timeout(function () {
      updatePastedText(thisNote);
    }, 10);
  }


  function publishBlogRecord (state, record) {
    record.publishing_loader = true;
    record.published = state;
    $scope.save('publish', function() {
      record.publishing_loader = false;
    });
  }


  function publishPageRecord (state, record) {
    record.publishing_loader = true;
    record.published = state;
    $scope.save('publish', function() {
      record.publishing_loader = false;
    });
  }


  function openAddLinkForm (zone) {
    $scope.addNewLink = zone;
    $scope.originalLink = angular.copy($scope.newLink);
  }


  function closeAddLinkForm () {
    $scope.newLink = angular.copy($scope.originalLink);
    $scope.addNewLink = false;
  }


  function saveNewLink (zone) {
    var prefix = '';

    if ($scope.newLink.category == 'Blog Record Link') {
      prefix = 'blog/';
    }

    angular.extend($scope.newLink, {
      position: $scope.website.websiteLinks.filter(function(el) {return el.zone === zone;}).length,
      url: '/' + prefix + $scope.newLink.value,
      invisible: true,
      zone: zone
    });

    $scope.website.websiteLinks.push(angular.copy($scope.newLink));

    $scope.save('publish', function() {
      $scope.addNewLink = false;
      $scope.newLink = angular.copy($scope.originalLink);
      buildLinksTree(zone);
    });
  }


  function navigationDnDCallback(link, zone) {
    index = $scope.website.websiteLinks.indexOf(link);

    $scope.website.websiteLinks.splice(index, 1);

    angular.forEach($scope.website.websiteLinks.filter(function(el) {return el.zone === zone;}), function(el, index) {
      el.position = index;
    });

    $scope.save('publish');
  }


  function editLink (event, link) {
    event.preventDefault();
    $scope.originalLink = angular.copy(link);

    link.edited = true;
  }


  function removeLink (event, link) {
    var zone = link.zone;
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    event.preventDefault();

    $mdDialog.show(confirm).then(function() {
      link.loading = true;
      if (link.id === undefined) {
        $scope.website.websiteLinks.splice($scope.website.websiteLinks.indexOf(link), 1);
        buildLinksTree(zone);
      } else {
        $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/website_link/'+link.id).then(function (response) {
          link.loading = false;
          if (response.statusText === 'OK') {
            $scope.website.websiteLinks.splice($scope.website.websiteLinks.indexOf(link), 1);

            angular.forEach($scope.website.websiteLinks, function(el, index) {
              el.position = index;
            });

            buildLinksTree(zone);

            $scope.save('publish');
          } else {
            $rootScope.alert(response.statusText);
          }
        }).catch(function(error) {
          console.error('Error removing link:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      }
    }, function() {});
  }


  function cancelLinkEditing (link) {
    var index = $scope.website.websiteLinks.indexOf(link);
    $scope.website.websiteLinks[index] = angular.copy($scope.originalLink);
    buildLinksTree(link.zone, $scope.website.websiteLinks);
  }


  function saveLink (link) {
    var prefix = '';

    if (link.category == 'Blog Record Link') {
      prefix = 'blog/';
    }

    angular.extend(link, {
      url: '/' + prefix + link.value
    });

    $scope.save('publish', function() {
      buildLinksTree(link.zone);
    });
  }


  function chooseFromLoaded (type, record, many, field) {
    $scope.attachPhotoTarget = record;
    $scope.attachPhotoMany = many;
    $scope.attachPhotoField = field;

    $mdDialog.show({
      controller: ChoosePhotoCtrl,
      templateUrl: getTemplatePath('modals/choosePhoto.html'),
      parent: angular.element(document.body),
      locals: {
        dialogPhotos : angular.copy($scope.website[type])
      },
      clickOutsideToClose: false
    })
      .then(function(photo) {
        if (photo) {
          if ($scope.attachPhotoMany) {
            $scope.attachPhotoTarget[$scope.attachPhotoField].push({
              alt: photo.alt,
              photo: photo.photo,
              source_id: photo.id
            });
          }

          $scope.attachPhotoTarget = null;
          $scope.attachPhotoMany = null;
          $scope.attachPhotoField = null;
        }
      }, function(error) {
        console.error('Error while choosing photo:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function getTranslation (key, category) {
    if ($scope.website && $scope.website.websiteTranslations) {
      var element = $scope.website.websiteTranslations.filter(function (el) {
        return el.category === category && el.key === key;
      });

      if (element.length === 0) {
        $scope.website.websiteTranslations.push({
          id: null,
          websiteDataId: $scope.website.id,
          key: key,
          category: category,
          value: ''
        });
        return $scope.website.websiteTranslations[$scope.website.websiteTranslations.length - 1];
      } else {
        return element[0];
      }
    }
  }


  function feature_filter (searchText) {
    if (_.isEmpty(searchText)) {
      return $scope.uniqIcons;
    } else {
      return $scope.uniqIcons.filter(function (el) {
        return el.indexOf(searchText) > -1;
      });
    }
  }


  function getFullLanguageName (lng) {
    return languages.filter(function(lang) { return lang.code === lng; })[0].name;
  }


  function loadDataForNavigation (callback) {
    $scope.pages = [];
    $scope.blogRecords = [];
    $scope.loadDataForblog();
    $scope.loadDataForpages();
  }


  function loadDataForBlog (callback) {
    $scope.blogLoad = true;
    $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/blog_records?lang=' + $scope.lang).then(function(response) {
      $scope.blogRecords = response.data;
      $scope.blogLoad = false;
      if (typeof(callback) === 'function') {
        callback();
      }
    }).catch(function(error) {
      console.error('Error loading blog data:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function loadDataForPages (callback) {
    $scope.pagesLoad = true;
    $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/pages?lang=' + $scope.lang).then(function(response) {
      $scope.pages = response.data;
      $scope.pagesLoad = false;
      if (typeof(callback) === 'function') {
        callback();
      }
    }).catch(function(error) {
      console.error('Error loading page data:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function imageUpload(files, editable, editor) {
    var fd = new FormData();
    fd.append("photo", files[0]);

    $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/image_upload/upload', fd, {
        headers: {'Content-Type': undefined },
        transformRequest: angular.identity
    }).success(function(response) {
      angular.element('[data-role="'+editor+'"]').summernote("insertImage", response.attachment, 'filename');
    }).error(function(response) {
      console.error('Error while image upload', response);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function uploadGalleryPhotos ($event) {
    var files  = $event.target.files;
    var loaded = 0;
    $scope.galleryPhotoLoaded = true;

    _.each(files, function (file) {
      var reader = new FileReader(),
          for_save = {};

      var fd = new FormData();
      fd.append("photo", file);

      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/image_upload/gallery_photo_upload', fd, {
          headers: {'Content-Type': undefined },
          transformRequest: angular.identity
      }).success(function(response) {
        for_save = response;
        $scope.gallery_photos.push(response);
      }).error(function(response) {
        console.warn('Error uploading gallery photo:', response);
      }).then(function () {
        loaded++;
        if (loaded == files.length) {
          $scope.galleryPhotoLoaded = false;
        }
      });
    });
  };


  function loadGalleryPhotos () {
    if ($rootScope.hotel && $rootScope.hotel.id) {
      $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/website_data/gallery_photos?lang=' + $scope.lang).then(function(response) {
        $scope.gallery_photos = response.data.gallery_photos;
        $scope.other_photos = response.data.other_photos;
      }).catch(function(error) {
        console.error('Error loading gallery photos:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    }
  };


  function removeGalleryPhoto(photo) {
    photo.loading = true;
    if (photo.id === undefined) {
      var index = $scope.gallery_photos.indexOf(photo);
      $scope.gallery_photos.splice(index, 1);
    } else {
      $http.delete(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/gallery_photo/'+photo.id).then(function (response) {
        if (response.statusText === 'OK') {
          var index = $scope.gallery_photos.indexOf(photo);
          $scope.gallery_photos.splice(index, 1);
        }
      }).catch(function(error) {
        console.error('Error removing gallery photo:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    }
  };


  function togglePhotoVisibility(photo) {
    photo.is_visible = !photo.is_visible;

    $http.post(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/website_data/gallery/'+photo.id+'/'+photo.type, {is_visible: photo.is_visible}).then(function (response) {
      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }).catch(function(error) {
      console.error('Error toggling photo visibility:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if ($scope.langInterval) {
      $interval.cancel($scope.langInterval);
    }
    if ($scope.geocodeTimeout) {
      $timeout.cancel($scope.geocodeTimeout);
    }
    if ($scope.pasteTimeout) {
      $timeout.cancel($scope.pasteTimeout);
    }
    if ($scope.loadWebsiteDataTimeout) {
      $timeout.cancel($scope.loadWebsiteDataTimeout);
    }
  });
}

angular
  .module('buuqit')
  .controller('StripeSubscriptionCtrl', StripeSubscriptionCtrl);

StripeSubscriptionCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdToast",
  "StripeBillingFactory"
];

function StripeSubscriptionCtrl ($rootScope, $scope, $mdToast, StripeBillingFactory) {
  angular.extend(
    $scope,
    {
      closeToast : closeToast,
      goToStripeBilling: goToStripeBilling
    }
  );
    
  function closeToast () {
    $mdToast.hide();
  };

  function goToStripeBilling () {
    new StripeBillingFactory()
      .createBillingPortalSessionUrl($rootScope.hotel.id)
      .then(function(response) {
        window.open(response.stripeCustomerPortalSessionUrl, "_blank");
      })
      .catch(function(error) {
        console.error("Failed to open Stripe billing portal:", error);
        throw error;
      });
  };
}

angular
  .module('buuqit')
  .controller('PromptMoneyCtrl', PromptMoneyCtrl);

PromptMoneyCtrl.$inject = ["$scope", "$modalInstance", "options"];

function PromptMoneyCtrl ($scope, $modalInstance, options) {
  angular.extend(
    $scope,
    {
      text  : options.text,
      min   : options.min,
      max   : options.max,
      value : options.value,

      falseAction: function () {
        $modalInstance.close(false);
      },

      trueAction: function () {
        $modalInstance.close($scope.value);
      }
    }
  );
}
angular
  .module('buuqit')
  .controller('PromptCtrl', PromptCtrl);

PromptCtrl.$inject = ["$scope", "$modalInstance", "options"];

function PromptCtrl ($scope, $modalInstance, options) {
  angular.extend(
    $scope,
    {
      text  : options.text,
      value : options.value,

      falseAction: function () {
        $modalInstance.close(false);
      },

      trueAction: function () {
        $modalInstance.close($scope.value);
      }
    }
  );
}
angular
    .module('buuqit')
    .directive('multiEmailInput', function() {
      return {
        restrict: 'E',
        require: 'ngModel',
        scope: {
          ngModel: '=',
          requiredMessage: '@',
          maxEmails: '@'
        },
        templateUrl: getTemplatePath('ui/multi_email_input.html'),
        link: function (scope, element, attrs, ngModelCtrl) {
          scope.placeholder = attrs.placeholder || 'Add email(s)';
          scope.emails = [];
          scope.input = '';
          scope.inputFocused = false;
          scope.inputIsValid = true;
          scope.maxEmails = attrs.maxEmails ? parseInt(attrs.maxEmails, 10) : 5;
          scope.isAtMaxEmails = false;

          ngModelCtrl.$render = function () {
            var modelVal = ngModelCtrl.$viewValue || '';
            scope.emails = modelVal ? modelVal.split(',').map(function(e){ return e.trim(); }).filter(Boolean) : [];
          };

          scope.$watch('emails', function (newVal) {
            ngModelCtrl.$setViewValue(newVal.join(','));
            // Set validity for required
            if (attrs.ngRequired !== undefined) {
              ngModelCtrl.$setValidity('required', newVal.length > 0);
            }
          }, true);

          scope.$watch('emails.length', function(newVal) {
            scope.isAtMaxEmails = (scope.maxEmails && scope.emails.length >= scope.maxEmails);
          });

          scope.isValidEmail = function (email) {
            return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test((email||'').trim());
          };

          function tryAddInput() {
            var val = scope.input && scope.input.trim();
            if (val && scope.isValidEmail(val) && scope.emails.indexOf(val) === -1) {
              scope.addEmail(val);
            }
          }

          scope.onKeydown = function (event) {
            if (event.key === 'Enter' || event.key === 'Tab' || event.key === ',' || event.key === ';') {
              event.preventDefault();
              tryAddInput();
            }
            else if (event.key === 'Backspace' && !scope.input && scope.emails.length) {
              scope.removeEmail(scope.emails.length - 1);
            }
          };

          scope.addEmail = function (email) {
            email = (email || '').trim();
            if (
              email &&
              scope.isValidEmail(email) &&
              scope.emails.indexOf(email) === -1 &&
              scope.emails.length < scope.maxEmails
            ) {
              scope.emails.push(email);
              scope.input = '';
            }
          };

          scope.removeEmail = function (idx) {
            scope.emails.splice(idx, 1);
          };

          scope.onBlur = function () {
            scope.inputFocused = false;
            tryAddInput();
          };

          scope.onFocus = function () {
            scope.inputFocused = true;
          };

          scope.focusInput = function () {
            var input = element[0].querySelector('.multi-email-text-input');
            if (input) input.focus();
          };

          scope.$watch('input', function(newVal) {
            scope.inputIsValid = scope.isValidEmail(newVal);
          });
        }
      };
    });
angular
  .module('buuqit')
  .controller('ManageUserHotelsCtrl', ManageUserHotelsCtrl);

ManageUserHotelsCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "local"
];

function ManageUserHotelsCtrl ($rootScope, $scope, $mdDialog, local) {
  angular.extend(
    $scope,
    {
      user : local.user,
      hotels : local.parent.hotels,

      cancel : cancel,
      save : save,
      addAssociation: addAssociation,
      removeAssociation: removeAssociation
    }
  );

  $scope.originalValue = angular.copy($scope.user);
  $scope.user.hotels = $scope.user.hotels.map(function (hotel) {hotel.forRemove = false; return hotel;});

  function cancel () {
    local.parent.users[local.parent.users.indexOf($scope.user)] = angular.copy($scope.originalValue);
    $mdDialog.hide();
  }


  function save () {
    $scope.user
      .updateAssociations()
      .then(function (response) {
        $mdDialog.hide();
      }, function (b) {
        $rootScope.alert(error.data.errors.join('.\r\n'));
      });
  }


  function removeAssociation (association) {
    association.forRemove = true;
  }


  function addAssociation () {
    if ($scope.hotel_for_assign && $scope.role_for_assign && $scope.user.hotels.filter(function (h) {return h.hotelId == $scope.hotel_for_assign.id;}).length == 0) {
      $scope.user.hotels.push({
        hotelId: $scope.hotel_for_assign.id,
        hotelName: $scope.hotel_for_assign.name,
        role: $scope.role_for_assign,
        forRemove: false
      });

      $scope.hotel_for_assign = null;
      $scope.searchText = null;
      $scope.role_for_assign = null;
    }
  }
}

angular
  .module('buuqit')
  .controller('InviteUserModalCtrl', InviteUserModalCtrl);

InviteUserModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "$http",
  "locals"
];

function InviteUserModalCtrl ($rootScope, $scope, $mdDialog, $http, locals) {
  angular.extend(
    $scope,
    {
      email : null,
      name: null,
      role: 'reception',
      saving: false,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    $scope.saving = true;
    $http
      .post(
        SERVER_PATH + '/api/v1/hotels/' + locals.hotel.id + '/invite_user',
        {
          email: $scope.email,
          name: $scope.name,
          role: $scope.role
        }
      )
      .then(
        function (response) {
          $scope.saving = false;
          if (locals.hotel.users) {
            locals.hotel.users.push(response.data.user);
          }
          $mdDialog.hide();
        },
        function (response) {
          $scope.saving = false;
          $rootScope.alert(response.data && response.data.error ? response.data.error : "Something whent wrong, try again later.");
        }
      );
  }
}

angular
  .module('buuqit')
  .controller('EditUserModalCtrl', EditUserModalCtrl);

EditUserModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "$http",
  "locals"
];

function EditUserModalCtrl ($rootScope, $scope, $mdDialog, $http, locals) {
  angular.extend(
    $scope,
    {
      role: locals.user.role,
      name: locals.user.user_name,
      saving: false,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    $scope.saving = true;
    $http
      .put(
        SERVER_PATH + '/api/v1/hotels/' + locals.hotel.id + '/update_user',
        {
          hotel_user: {
            id: locals.user.id,
            user_name: $scope.name,
            role: $scope.role
          }
        }
      )
      .then(
        function (response) {
          $scope.saving = false;
          locals.user.role = response.data.role;
          locals.user.user_name = response.data.user_name;
          $mdDialog.hide();
        },
        function (response) {
          $scope.saving = false;
          $rootScope.alert(response.data && response.data.error ? response.data.error : 'Something whent wrong, try again later.');
        }
      );
  }
}

angular
  .module('buuqit')
  .controller('CreateNewHotelModalCtrl', CreateNewHotelModalCtrl);

CreateNewHotelModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "HotelFactory"
];

function CreateNewHotelModalCtrl ($rootScope, $scope, $mdDialog, HotelFactory) {
  angular.extend(
    $scope,
    {
      hotel: {},
      countries : countries,
      saving: false,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    hotel = new HotelFactory($scope.hotel);
    $scope.saving = true;
    hotel.create().then(function(hotel) {
      $scope.saving = false;
      $rootScope.user.hotels.push(hotel);
      $mdDialog.hide();
    }, function() {
      $scope.saving = false;
      $rootScope.alert('Something whent wrong, try again later.');
    });
  }
}

angular
  .module('buuqit')
  .controller('ChoosePhotoCtrl', ChoosePhotoCtrl);

ChoosePhotoCtrl.$inject = [
  "$scope",
  "$mdDialog",
  "dialogPhotos"
];

function ChoosePhotoCtrl ($scope, $mdDialog, dialogPhotos) {
  angular.extend(
    $scope,
    {
      dialogPhotos : dialogPhotos,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save (photo) {
    $mdDialog.hide(photo);
  }
}
angular
  .module('buuqit')
  .controller('ChooseHotelCtrl', ChooseHotelCtrl);

ChooseHotelCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "local"
];

function ChooseHotelCtrl ($rootScope, $scope, $mdDialog, local) {
  angular.extend(
    $scope,
    {
      hotel : local.hotels[0],
      hotels : local.hotels,

      choose : choose
    }
  );


  function choose () {
    $mdDialog.hide();
    $rootScope.changeHotel($scope.hotel);
  }
}

angular
  .module('buuqit')
  .controller('ChangeUserPasswordCtrl', ChangeUserPasswordCtrl);

ChangeUserPasswordCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "local"
];

function ChangeUserPasswordCtrl ($rootScope, $scope, $mdDialog, local) {
  angular.extend(
    $scope,
    {
      newPassword : null,
      confirmPassword : null,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    local.parent.editedUser.password = $scope.newPassword;
    local.parent.editedUser.passwordConfirmation = $scope.confirmPassword;

    local.parent.editedUser
      .save()
      .then(
      function () {
        $scope.cancel();
        delete local.parent.editedUser.password;
        delete local.parent.editedUser.passwordConfirmation;
        local.parent.editedUser = null;
      },
      function (error) {
        $rootScope.alert(error.data.errors.join('.\r\n'));
      }
    );
  }
}

angular
  .module('buuqit')
  .controller('AlertCtrl', AlertCtrl);

AlertCtrl.$inject = ["$scope", "$modalInstance", "options"];

function AlertCtrl ($scope, $modalInstance, options) {
  angular.extend(
    $scope,
    {
      text : options.text,

      falseAction: function () {
        $modalInstance.close(false);
      }
    }
  );
}

angular
  .module('buuqit')
  .controller('AddUserToCorporateAccountCtrl', AddUserToCorporateAccountCtrl);

AddUserToCorporateAccountCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "local"
];

function AddUserToCorporateAccountCtrl ($rootScope, $scope, $mdDialog, local) {
  angular.extend(
    $scope,
    {
      user : null,
      role : null,
      users : local.parent.users,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    local.account
      .addUser($scope.user.id, $scope.role)
      .then(
        function () {
          $scope.cancel();
        },
        function (error) {
          $rootScope.alert(error.data.message);
        }
      );
  }
}

angular
  .module('buuqit')
  .controller('AddUserCtrl', AddUserCtrl);

AddUserCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "AdminUsersFactory",
  "local"
];

function AddUserCtrl ($rootScope, $scope, $mdDialog, AdminUsersFactory, local) {
  angular.extend(
    $scope,
    {
      user : {},
      saving : false,
      hotels : local.parent.hotels,
      roles : ['user', 'admin'],

      cancel : cancel,
      save : save
    }
  );

  $scope.user = local.user ? local.user : {};
  $scope.originalValue = angular.copy($scope.user);

  function cancel () {
    local.parent.users[local.parent.users.indexOf($scope.user)] = angular.copy($scope.originalValue);
    $mdDialog.hide();
  }


  function save () {
    $scope.saving = true;

    if ($scope.user.id) {
      _save();
    } else {
      _create();
    }
  };

  function _save () {
    $scope.user
      .save()
      .then(
        function (data) {
          $scope.saving = false;
          $mdDialog.hide();
        }, function (error) {
          $scope.saving = false;
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };

  function _create () {
    var value = angular.copy($scope.user);
    new AdminUsersFactory(value)
      .create()
      .then(function (data) {
        $scope.saving = false;
        local.parent.users.push(data);
        $mdDialog.hide();
      }, function (error) {
        $scope.saving = false;
        $rootScope.alert(error.data.errors.join('.\r\n'));
      });
  };
}

angular
  .module('buuqit')
  .controller('AddLanguageCtrl', AddLanguageCtrl);

AddLanguageCtrl.$inject = [
  "$scope",
  "$mdDialog"
];

function AddLanguageCtrl ($scope, $mdDialog) {
  angular.extend(
    $scope,
    {
      newLang : null,
      countries : languages,
      searchText: null,

      filter: filter,
      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    $mdDialog.hide($scope.newLang.code);
  }


  function filter (searchText) {
    if (_.isEmpty(searchText)) {
      return $scope.countries;
    } else {
      return $scope.countries.filter(function (el) {
        return el.name.indexOf(searchText) > -1;
      });
    }
  }
}
angular
  .module('buuqit')
  .controller('AddHotelToCorporateAccountCtrl', AddHotelToCorporateAccountCtrl);

AddHotelToCorporateAccountCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "local"
];

function AddHotelToCorporateAccountCtrl ($rootScope, $scope, $mdDialog, local) {
  angular.extend(
    $scope,
    {
      hotel : null,
      hotels : local.parent.hotels,

      cancel : cancel,
      save : save
    }
  );


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    local.account
      .addHotel($scope.hotel.id)
      .then(
        function () {
          $scope.cancel();
        },
        function (error) {
          $rootScope.alert(error.data.message);
        }
      );
  }
}

angular
  .module('buuqit')
  .controller('Settings.I18nSettingsController', I18nSettingsController);

I18nSettingsController.$inject = ["$rootScope", "$scope", "$mdDialog", "$http", "$timeout", "$i18next", "CustomEmailTemplateFactory", "Globalize"];

function I18nSettingsController ($rootScope, $scope, $mdDialog, $http, $timeout, $i18next, CustomEmailTemplateFactory, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      init : init,
      save : save,
      openAddEmailTemplateForm  : openAddEmailTemplateForm,
      closeAddEmailTemplateForm : closeAddEmailTemplateForm,
      saveAddEmailTemplateForm  : saveAddEmailTemplateForm,
      removeEmailTemplate       : removeEmailTemplate,
      editEmailTemplate         : editEmailTemplate,
      closeEditedEmailTemplate  : closeEditedEmailTemplate,
      saveEditedEmailTemplate   : saveEditedEmailTemplate,
      insertDropIn              : insertDropIn,
      insertSummernoteDropIn    : insertSummernoteDropIn,
      openMenu                  : openMenu,
      addNewEmailTemplate : false,
      newEmailTemplate : {
        emailType: null,
        translations: []
      },
      dropins: dropins,
      possibleLocales: window.locales,
      emailTypes: [],
      initTimeout: null,
      changeLang: changeLang,
      saveDefaultLocale: saveDefaultLocale
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      if (self.initTimeout) {
        $timeout.cancel(self.initTimeout);
      }
      self.initTimeout = $timeout(init, 0);
    }
  });


  function init () {
    if ($rootScope.hotel) {
      angular.extend(
        self,
        {
          loaded    : false,
          hotel     : $rootScope.hotel,
          emailTypes: $rootScope.hotel.emailTypes
        }
      );
      $rootScope.hotel.customEmailTemplates.forEach(function(t) {
        Globalize.loadTranslation(t, 'customEmailTemplate');
      })
    }
  }


  function save () {
    self.loaded = true;
    self.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.loaded = false;
      $rootScope.notify('Changes was successfully saved.');
    }).catch(function (error) {
      console.error('Error saving hotel', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      self.loaded = false;
    });
  }


  function openAddEmailTemplateForm () {
    self.originalEmailTemplate = angular.copy(self.newEmailTemplate);
    self.edited = null;
    self.addNewEmailTemplate = true;
  }


  function closeAddEmailTemplateForm () {
    self.newEmailTemplate = angular.copy(self.originalEmailTemplate);
    self.edited = null;
    self.addNewEmailTemplate = false;
  }


  function saveAddEmailTemplateForm () {
    Globalize.updateCurrentTranslation(self.newEmailTemplate, 'customEmailTemplate');

    model = angular.copy(self.newEmailTemplate);
    model.hotelId = $rootScope.hotel.id;

    new CustomEmailTemplateFactory(model).create().then(function (data) {
      $rootScope.hotel.customEmailTemplates.push(data);
      Globalize.loadTranslation(data, 'customEmailTemplate');
      self.closeAddEmailTemplateForm();
    }).catch(function (error) {
      console.error('Error saving email template', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function removeEmailTemplate (index) {
    var confirm = $mdDialog.confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok('Confirm')
      .cancel('Cancel');

    $mdDialog.show(confirm).then(function() {
      var model = self.hotel.customEmailTemplates[index];

      model.hotelId = self.hotel.id;

      new CustomEmailTemplateFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            self.hotel.customEmailTemplates.splice(index, 1);
          } else {
            $rootScope.alert("Something went wrong, please try again later or contact with administrator!");
          }
        }, function (error) {
          console.error('Error removing email template', error);
          $rootScope.alert("Something went wrong, please try again later or contact with administrator!");
        });
    }, function() {});
  }


  function editEmailTemplate (index) {
    closeAddEmailTemplateForm()
    self.originalEmailTemplate = angular.copy(self.hotel.customEmailTemplates[index]);
    self.edited = index;
  }


  function closeEditedEmailTemplate (event, index) {
    event.preventDefault();
    self.hotel.customEmailTemplates[index] = angular.copy(self.originalEmailTemplate);
    self.edited = null;
  }


  function saveEditedEmailTemplate (event, template, index) {
    event.preventDefault();
    template.hotelId = self.hotel.id;
    Globalize.updateCurrentTranslation(template, 'customEmailTemplate');

    new CustomEmailTemplateFactory(template)
      .save()
      .then(function (data) {
        self.edited = null;
        self.hotel.customEmailTemplates[index] = data;
        Globalize.loadTranslation(self.hotel.customEmailTemplates[index], 'customEmailTemplate');
        self.originalEmailTemplate = angular.copy(self.newEmailTemplate);
      }, function (error) {
        console.error('Error saving email template', error);
        $rootScope.alert("Something went wrong, please try again later or contact with administrator!");
      });
  }

  function insertDropIn(editor, dropin) {
    var element = angular.element('[data-role="'+editor+'"]')[0];
    text = dropin || '';
    if (document.selection) {
      // IE
      element.focus();
      var sel = document.selection.createRange();
      sel.text = text;
    } else if (element.selectionStart || element.selectionStart === 0) {
      // Others
      var startPos = element.selectionStart;
      var endPos = element.selectionEnd;
      element.value = element.value.substring(0, startPos) +
        text +
        element.value.substring(endPos, element.value.length);
      element.selectionStart = startPos + text.length;
      element.selectionEnd = startPos + text.length;
    } else {
      element.value += text;
    }
    element.dispatchEvent(new Event('change'));
  }

  function insertSummernoteDropIn(editor, dropin) {
    angular.element('[data-role="'+editor+'"]').summernote('insertText', dropin);
  }

  function openMenu($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  };

  function changeLang(old_lang) {
    if (self.hotel == undefined) {
      return;
    }
    var templates = self.hotel.customEmailTemplates.concat([self.newEmailTemplate]);
    templates.forEach(function(t) {
      Globalize.saveTranslation(t, 'customEmailTemplate', old_lang);
      Globalize.loadTranslation(t, 'customEmailTemplate');
    });
  }

  function saveDefaultLocale(locale) {
    self.saving = true;
    $http.post($rootScope.hotel.$url() + '/change_default_language?locale=' + locale)
      .success(function(data){
        $rootScope.hotel.get().then(function() {
          self.saving = false;
          Globalize.locale = locale;
          $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
        });
      }).error(function(error) {
        console.error('Error saving default locale', error);
        self.saving = false;
      });

  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.HotelFeaturesController', HotelFeaturesController);

HotelFeaturesController.$inject = [
  "$rootScope",
  "$i18next",
  "$scope",
  "$timeout",
  "Globalize"
];

function HotelFeaturesController ($rootScope, $i18next, $scope, $timeout, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      initTimeout : null,
      init : init,
      save : save,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      if (self.initTimeout) {
        $timeout.cancel(self.initTimeout);
      }
      self.initTimeout = $timeout(init, 0);
    }
  });

  function init () {
    if ($rootScope.hotel) {
      angular.extend(
        self,
        {
          loading    : false,
          hotel     : $rootScope.hotel
        }
      );
    }
  }

  function save () {
    var self = this;
    this.loading = true;
    this.hotel.addons_json = JSON.stringify(this.hotel.addons);
    this.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.loading = false;
      Globalize.loadTranslation(self.hotel, 'hotel');
      $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str'));
    }, function (response) {
      this.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
    }
  });
}
angular
  .module("buuqit")
  .controller(
    "Settings.CalendarSettingsController",
    CalendarSettingsController
  );

CalendarSettingsController.$inject = [
  "$rootScope",
  "$scope",
  "$filter",
  "$i18next",
  "CalendarSettingService",
  "CALENDAR_SETTINGS"
];

function CalendarSettingsController(
  $rootScope,
  $scope,
  $filter,
  $i18next,
  CalendarSettingService,
  CALENDAR_SETTINGS
) {
  var self = this;

  angular.extend(self, {
    initialized: false,
    loading: false,

    init: init,
    save: save,
    reset: resetToDefaultSettings
  });

  function init() {
    self.initialized = true;
    self.calendarSetting = $filter('fillDefaultToCalendarSettings')(angular.copy($rootScope.hotel.calendarSetting));
  }

  function resetToDefaultSettings() {
    self.calendarSetting = angular.copy(CALENDAR_SETTINGS);
  }

  function save() {
    self.loading = true;
    CalendarSettingService.save(self.calendarSetting)
      .then(
        function(response) {
          self.calendarSetting = {
            blockerColor: response.data.calendar_setting.blocker_color,
            bookingUnpaidColor: response.data.calendar_setting.booking_unpaid_color,
            bookingPaidColor: response.data.calendar_setting.booking_paid_color,
            bookingPartiallyColor: response.data.calendar_setting.booking_partially_color,
            bookingCompanyColor: response.data.calendar_setting.booking_company_color,
            bookingGroupColor: response.data.calendar_setting.booking_group_color,
            weekendBorderColor: response.data.calendar_setting.weekend_border_color,
            useRoundedCorners: response.data.calendar_setting.use_rounded_corners,
            useShiftDisplay: response.data.calendar_setting.use_shift_display,
            useShiftCreate: response.data.calendar_setting.use_shift_create,
            useFixedWidthZoom: response.data.calendar_setting.use_fixed_width_zoom,
            showSeasonsInCalendar: response.data.calendar_setting.show_seasons_in_calendar,
            showChannelCode: response.data.calendar_setting.show_channel_code,
            showLastNameFirst: response.data.calendar_setting.show_last_name_first,
            hideCancellationArea: response.data.calendar_setting.hide_cancellation_area,
            showWaitlist: response.data.calendar_setting.show_waitlist,
          };
          $rootScope.hotel.calendarSetting = angular.copy(self.calendarSetting);
          $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
          self.loading = false;
        },
        function(response) {
          console.error('Error saving calendar settings', response);
          self.loading = false;
          $rootScope.notify($i18next.t('general.titles.error'));
        }
      );
  }

  if ($rootScope.hotel) {
    this.init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.SubscriptionController', SubscriptionController);

SubscriptionController.$inject = ["$rootScope", "$scope", "$http"];

function SubscriptionController ($rootScope, $scope, $http) {
  var self = this;

  angular.extend(
    this,
    {
      // Controller variables
      loaded : false,
      subscribed : null,

      getPlanName : getPlanName,
      getStatusName : getStatusName
    }
  );


  if ($rootScope.hotel) {
    this.loaded = true;
    init();
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && self.loaded == false) {
      self.loaded = true;
      init();
    }
  });


  function init () {
    self.subscribed = $rootScope.hotel.subscription;
    if ($rootScope.hotel.subscription) {
      $http
        .get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/subscription')
        .then(function(response) {
          if (response.data.success) {
            self.subscription = response.data.info.subscription;
            if (self.subscription.trial_end) {
              self.subscription.trial_end = new Date(Number(self.subscription.trial_end + '000'));
            }
            self.card = response.data.info.card;
            self.customer = response.data.info.customer;
            self.portal_session = response.data.portal_session;
            self.renew_card_url = response.data.renew_card_url;
          }
        });
    }
  }


  function getPlanName (plan_name) {
    var names = {'performance': 'Performane'};
    return names[plan_name];
  }


  function getStatusName (status_name) {
    var names = {'in_trial': 'Trial Period', 'active': 'Active', 'cancelled': 'Cancelled'};
    return names[status_name];
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.RoomTypeController', RoomTypeController);

RoomTypeController.$inject = ["$rootScope", "$scope", "$mdDialog", "$filter", "$i18next", "RoomTypeFactory", "CoverRoomTypeFactory", "Globalize"];

function RoomTypeController ($rootScope, $scope, $mdDialog, $filter, $i18next, RoomTypeFactory, CoverRoomTypeFactory, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      // Controller variables
      loaded            : false,
      roomTypes         : [],
      coverRoomTypes    : [],
      accountingCategories: [],
      createFormVisible : false,
      createCoverRoomTypeFormVisible: false,
      editedRoomType    : null,
      saving            : false,
      roomTypeOrder     : null,
      newRoomType       : {
        roomType    : null,
        shortName   : null,
        name        : null,
        maxOccupancy: 1,
        maxAdults   : 1,
        maxChildren : 0,
        maxInfants  : 0,
        minStay     : 1,
        defaultMinStay: 1,
        description : $i18next.t('profile_nav.settings.inventory.room_type.description_controller_variable_js_code'),
        facilities  : [],
        photos      : [],
        hotel_id    : null,
        shortCode   : null,
        translations: []
      },
      newCoverRoomType : {
        roomTypeId  : null,
        shortName   : null,
        name        : null,
        maxOccupancy: 1,
        maxAdults   : 1,
        maxChildren : 0,
        maxInfants  : 0,
        minStay     : 1,
        facilities  : [],
        description : $i18next.t('profile_nav.settings.inventory.room_type.description_controller_variable_js_code'),
        hotel_id    : null,
        shortCode   : null,
        photos      : []
      },

      treeOptions : {
        dropped : function (e) {
          e.dest.nodesScope.$modelValue.forEach(function (el, index) {
            el.priority = index;
          });

          self.saveRoomTypes();
        }
      },

      // Controller methods
      openCreateForm    : openCreateForm,
      openEditForm      : openEditForm,
      removeRoomType    : removeRoomType,
      saveRoomTypes     : saveRoomTypes,
      saveSortType      : saveSortType,
      openCreateCoverRoomTypeForm : openCreateCoverRoomTypeForm,
      openEditCoverRoomTypeForm : openEditCoverRoomTypeForm,
      removeCoverRoomType: removeCoverRoomType,
      getRoomTypeTitle: getRoomTypeTitle,
      changeLang        : changeLang
    }
  );


  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    this.roomTypes = $filter('orderBy')($rootScope.hotel.roomTypes, 'priority');
    this.coverRoomTypes = $rootScope.hotel.coverRoomTypes.map(function (el) {el.roomTypeId = String(el.roomTypeId); return el;});
    this.roomTypeOrder = $rootScope.hotel.sortRoomType;
    this.cutOffDate = $rootScope.hotel.cutOffDate ? new Date($rootScope.hotel.cutOffDate) : undefined;
    self.showCutOffDatePicker = typeof($rootScope.hotel.cutOffDate) !== 'undefined' && typeof($rootScope.hotel.cutOffDate) !== 'object';
    this.newRoomType.hotel_id = $rootScope.hotel.id;
    this.accountingCategories = $rootScope.hotel.accountingCategories;

    self.roomTypes.forEach(function(roomType) {
      Globalize.loadTranslation(roomType, 'roomType');
    });

    self.coverRoomTypes.forEach(function(roomType) {
      Globalize.loadTranslation(roomType, 'coverRoomType');
    });

    this.loaded = true;
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && $rootScope.hotel.roomTypes && self.roomTypes.length === 0) {
      self.roomTypes = $filter('orderBy')($rootScope.hotel.roomTypes, 'priority');
      self.coverRoomTypes = $rootScope.hotel.coverRoomTypes.map(function (el) {el.roomTypeId = String(el.roomTypeId); return el;});
      self.newRoomType.hotel_id = $rootScope.hotel.id;
      self.roomTypeOrder = $rootScope.hotel.sortRoomType;
      self.cutOffDate = $rootScope.hotel.cutOffDate ? new Date($rootScope.hotel.cutOffDate) : undefined;
      self.showCutOffDatePicker = typeof($rootScope.hotel.cutOffDate) !== 'undefined' && typeof($rootScope.hotel.cutOffDate) !== 'object';
      self.accountingCategories = $rootScope.hotel.accountingCategories;

      self.roomTypes.forEach(function(roomType) {
        Globalize.loadTranslation(roomType, 'roomType');
      });

      self.coverRoomTypes.forEach(function(roomType) {
        Globalize.loadTranslation(roomType, 'coverRoomType');
      });

      self.loaded = true;
    }
  });


  function openCreateForm () {
    this.originalRoomType  = angular.copy(self.newRoomType);
    this.createFormVisible = true;
  }


  function removeRoomType (index) {
    angular.element('.tooltip').hide();

    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      var model = self.roomTypes[index];

      model.hotelId = $rootScope.hotel.id;
      model.removing = true;

      new RoomTypeFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            $rootScope.hotel.roomTypes.splice(index, 1);
            self.roomTypes = $rootScope.hotel.roomTypes;
          } else {
            console.error('Error while trying to remove room type:', data);
            model.removing = false;
            $rootScope.alert($i18next.t('profile_nav.settings.inventory.room_type.alert.you_can_not_remove_room_type_with_rooms_or_with_virtual_room_types_js_str'));
          }
        });
    }, function() {});
  }


  function openEditForm (index) {
    angular.element('.tooltip').hide();
    this.originalRoomType = angular.copy(self.roomTypes[index]);
    this.editedRoomType   = index;
  }


  function saveRoomTypes () {
    this.roomTypes.forEach(function(roomType) {
      roomType.hotelId = $rootScope.hotel.id;

      new RoomTypeFactory(roomType)
        .updatePriority()
        .then(
          function (data) {}
        );
    });
  }


  function saveSortType () {
    $rootScope.hotel.sortRoomType = this.roomTypeOrder;
    $rootScope.hotel.cutOffDate = this.showCutOffDatePicker === true ? moment(this.cutOffDate).format('YYYY-MM-DD') : null;
    this.saving = true;
    $rootScope.hotel.save().then(function () {self.saving = false;});
  }


  function openCreateCoverRoomTypeForm () {
    this.originalCoverRoomType  = angular.copy(self.newCoverRoomType);
    this.createCoverRoomTypeFormVisible = true;
  }


  function openEditCoverRoomTypeForm (index) {
    angular.element('.tooltip').hide();
    this.originalCoverRoomType = angular.copy(self.coverRoomTypes[index]);
    this.editedCoverRoomType   = index;
  }


  function removeCoverRoomType (index) {
    angular.element('.tooltip').hide();

    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      var model = self.coverRoomTypes[index];

      model.hotelId = $rootScope.hotel.id;
      model.removing = true;

      new CoverRoomTypeFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            $rootScope.hotel.coverRoomTypes.splice(index, 1);
            self.coverRoomTypes = $rootScope.hotel.coverRoomTypes;
          } else {
            console.error('Error while trying to remove cover room type:', data);
            model.removing = false;
            $rootScope.alert($i18next.t('profile_nav.settings.inventory.room_type.alert.you_can_not_remove_virtual_room_type_js_str'));
          }
        });
    }, function() {});
  }


  function getRoomTypeTitle (roomTypeId) {
    var rt = self.roomTypes.filter(function(el) {return el.id == roomTypeId})
    if (rt) {
      return rt[0].name
    } else {
      return '';
    }
  }

  function changeLang(old_locale) {
    roomTypes = self.roomTypes.concat([self.newRoomType]);
    roomTypes.forEach(function(roomType) {
      Globalize.saveTranslation(roomType, 'roomType', old_locale);
      Globalize.loadTranslation(roomType, 'roomType');
    });

    coverRoomTypes = self.coverRoomTypes.concat([self.newCoverRoomType]);
    coverRoomTypes.forEach(function(roomType) {
      Globalize.saveTranslation(roomType, 'coverRoomType', old_locale);
      Globalize.loadTranslation(roomType, 'coverRoomType');
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.RoomController', RoomController);

RoomController.$inject = ["$rootScope", "$scope", "$timeout", "$mdDialog", "$i18next", "RoomFactory"];

function RoomController ($rootScope, $scope, $timeout, $mdDialog, $i18next, RoomFactory) {
  var self = this;
  angular.extend(
    this,
    {
      // Controller variables
      loaded            : false,
      color_options     : ROOM_COLORS.split(' '),
      roomTypes         : [],
      rooms             : [],
      createFormVisible : false,
      editedRoom        : null,
      savingHotel       : false,
      newRoom           : {
        roomTypeId      : null,
        number          : null,
        availableOnline : true,
        isActive        : true,
        priority        : 1,
        hotelId         : null,
        commonDoorName  : null,
        keyCode         : null
      },

      // Controller methods
      openCreateForm  : openCreateForm,
      closeCreateForm : closeCreateForm,
      saveCreateForm  : saveCreateForm,
      openEditForm    : openEditForm,
      createRoom      : createRoom,
      updateRoom      : updateRoom,
      removeRoom      : removeRoom,
      getRoomTypeName : getRoomTypeName,
      getPropertyName: getPropertyName,
      DropDownCallback : DropDownCallback,
      backgroundColor: backgroundColor,
      saveHotel: saveHotel
    }
  );


  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    this.hotel =  $rootScope.hotel;
    this.roomTypes = $rootScope.hotel.roomTypes;
    this.rooms = $rootScope.hotel.rooms.sort(function compare(a, b) {
      if (a.position < b.position) { return -1; }
      if (a.position > b.position) { return 1; }
      return 0;
    });
    this.newRoom.hotel_id = $rootScope.hotel.id;
    this.loaded = true;
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel) {

      if($rootScope.hotel.roomTypes && self.roomTypes.length === 0) {
      self.hotel = $rootScope.hotel;

        self.roomTypes = $rootScope.hotel.roomTypes;
        self.rooms = $rootScope.hotel.rooms;
        self.newRoom.hotel_id = $rootScope.hotel.id;
        self.loaded = true;
      }
    }
  });

  function backgroundColor(room) {
    return room.backgroundColor ? (room.backgroundColor.startsWith('--') ? 'var('+room.backgroundColor+')' : room.backgroundColor) : '#76a9e0';
  }

  function openCreateForm () {
    this.originalRoom = angular.copy(self.newRoom);
    this.createFormVisible = true;
  }


  function closeCreateForm () {
    angular.element('.tooltip').hide();
    if (this.editedRoom === null) {
      self.newRoom = angular.copy(this.originalRoom);
    } else {
      self.rooms[this.editedRoom] = angular.copy(self.originalRoom);
    }

    this.editedRoom        = null;
    this.createFormVisible = false;
  }


  function saveCreateForm (model) {
    if (model.number && model.roomTypeId && model.propertyId) {
      angular.element('.tooltip').hide();
      if (model.id) {
        this.updateRoom(model);
      } else {
        this.createRoom(model);
      }
    } else {
      $rootScope.alert($i18next.t('profile_nav.settings.inventory.room_setup.alert.form_is_invalid_all_fields_is_required_js_str'));
    }
  }


  function createRoom (model) {
    var self = this;

    model.hotelId = $rootScope.hotel.id;
    model.loading = true;

    if (model.number.indexOf(',') !== -1 || model.number.indexOf('-') !== -1) {
      new RoomFactory(model).multipleCreate(model).then(function (response) {
        response.data.rooms.forEach(function(room) {
          $rootScope.hotel.rooms.push(new RoomFactory(room));
        });

        self.newRoom = angular.copy(self.originalRoom);
        self.createFormVisible = false;
      }, function(response) {
        $rootScope.alert(response.data.errors);
        model.loading = false;
      });
    } else {
      new RoomFactory(model).create().then(function (data) {
        data.loading = false;
        $rootScope.hotel.rooms.push(data);

        self.newRoom = angular.copy(self.originalRoom);
        self.createFormVisible = false;
      });
    }
  }


  function updateRoom (model, index, hard) {
    var self = this;
    var index = index == undefined ? self.rooms.indexOf(model) : index;

    model.hotelId = $rootScope.hotel.id;
    model.loading = true;
    model.hard = hard || false;

    new RoomFactory(model).update().then(function (data) {
      if (model.isActive != data.isActive) {
        var confirm = $mdDialog.confirm()
          .title($i18next.t('profile_nav.settings.inventory.room_setup.confirm.title'))
          .textContent($i18next.t('profile_nav.settings.inventory.room_setup.confirm.textContent'))
          .ariaLabel($i18next.t('profile_nav.settings.inventory.room_setup.confirm.title'))
          .ok($i18next.t('profile_nav.settings.inventory.room_setup.confirm.ok'))
          .cancel($i18next.t('general.buttons.cancel'));

        $mdDialog.show(confirm).then(function() {
          updateRoom.call(self, model, index, true);
        }, function() {});
      }

      data.loading = false;
      self.rooms[index] = data;
      $rootScope.hotel.rooms.filter(function(room) {return room.id == data.id;})[0] = data;

      self.editedRoom = null;
    });
  }


  function removeRoom (index) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      var model = self.rooms[index];

      model.hotelId = $rootScope.hotel.id;

      new RoomFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            $rootScope.hotel.rooms.splice(index, 1);
          } else {
            console.error('Error removing room:', data);
            $timeout(function() {
              angular.element('body>.dialog, body>.dialog-filter').remove();
              $rootScope.alert($i18next.t('profile_nav.settings.inventory.room_setup.alert.you_can_not_remove_room_with_bookings'));
            }, 700);
          }
        });
    }, function() {});
  }


  function openEditForm (index) {
    angular.element('.tooltip').hide();
    this.originalRoom = angular.copy(self.rooms[index]);
    this.editedRoom   = index;
  }


  function getRoomTypeName (roomTypeId) {
    var rt = self.roomTypes.filter(function (roomType) {return roomType.id == roomTypeId;})[0];
    return rt ? rt.shortName : '';
  }

  function getPropertyName(propertyId) {
    var properties = $rootScope.hotel.properties.filter(function (property) { return propertyId == property.id;});
    if (properties.length) {
      return properties[0].name;
    }
  }

  function DropDownCallback(room) {
    var pos,
        index = self.rooms.indexOf(room);

    self.rooms.splice(index, 1);

    angular.forEach(self.rooms, function(el, index) {
      el.position = index;
      if (el.id == room.id) {
        pos = index;
      }
    });

    $rootScope.hotel.rooms = self.rooms;

    new RoomFactory(
      {
        hotelId: $rootScope.hotel.id,
        id: room.id,
        position: self.rooms.map(function(el) {
          return [el.id, el.position];
        })
      }
    ).move();
  }

  function saveHotel () {
    self.savingHotel = true;

    self.hotel.save()
      .then(function (data) {
        $rootScope.hotel = data;
        $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str'));
      })
      .catch(function (response) {
        console.error('Error saving hotel:', response);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      })
      .finally(function() {
        self.savingHotel = false;
      });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    angular.element('.tooltip').remove();
  });
}

angular
  .module('buuqit')
  .controller('Settings.PropertiesController', PropertiesController)
  .component(
    'reactHotelProperties',
    window.TBFLibs.react2angular(
      window.TBFLibs.HotelProperties,
      [
        'hotel',
        'onRemoveProperty',
        'onSaveProperty',
      ],
      ['$i18next']
    )
  );

PropertiesController.$inject = ["$rootScope", "$scope", "$http", "$i18next", "$timeout", "PropertiesFactory"];

function PropertiesController ($rootScope, $scope, $http, $i18next, $timeout, PropertiesFactory) {
  var self = this;

  angular.extend(
    this,
    {
      hotel: $rootScope.hotel,
      initTimeout: null,
      init: init,
      saveProperty: saveProperty,
      createProperty: createProperty,
      updateProperty: updateProperty,
      removeProperty: removeProperty,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      if (self.initTimeout) {
        $timeout.cancel(self.initTimeout);
      }
      self.initTimeout = $timeout(init, 0);
    }
  });


  function init () {
    if ($rootScope.hotel) {
      angular.extend(
        self,
        {
          hotel: $rootScope.hotel,
        }
      );
    }
  }

  function saveImage(model, image) {
    if (!image) return model;

    var form_data = new FormData();
    form_data.append("image", image);

    return $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/properties/' + model.id + '/upload_image', form_data, {
      headers: {'Content-Type': undefined },
      transformRequest: angular.identity
    }).then(function(response) {
      if (response.status === 200) {
        model.image = response.data.image;
      } else {
        $rootScope.alert('Bad image used');
        console.error('Error while trying to upload image:', response);
      }
      return model;
    });
  }

  function saveProperty (model) {
    if (model.id) {
      return self.updateProperty(model);
    } else {
      return self.createProperty(model);
    }
  }

  function createProperty (model) {
    model.hotelId = $rootScope.hotel.id;
    return new PropertiesFactory(model).create().then(function (data) {
      if (model.image) {
        return saveImage(data, model.image).then(function(success) {
          return data;
        })
      } else if (data) {
        return data;
      }
    }).catch(function (error) {
      console.error('Error while trying to create property:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      throw error;
    });
  }

  function updateProperty (model) {
    model.hotelId = $rootScope.hotel.id;

    return new PropertiesFactory(model).update().then(function (data) {
      if (model.image) {
        return saveImage(data, model.image).then(function(success) {
          return data;
        });
      } else if (data) {
        return data;
      }
    });
  }

  function removeProperty (model) {
    model.hotelId = $rootScope.hotel.id;
      return new PropertiesFactory(model)
        .remove()
        .then(function (data) {
          if (!data.success) {
            console.error('Error while trying to remove property:', data);
            $rootScope.alert($i18next.t('profile_nav.settings.hotel_profile.hotel_property.alert.you_can_not_remove_property_with_linked_rooms'));
          }
          return data.success;
        });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
    }
  });
}

angular
  .module("buuqit")
  .controller(
    "Settings.PosProfilesErrorsController",
    PosProfilesErrorsController
  );

PosProfilesErrorsController.$inject = [
  "$rootScope",
  "$scope",
  "$location",
];

function PosProfilesErrorsController(
  $rootScope,
  $scope,
  $location
) {
  var self = this;
  angular.extend(self, {
    initialized: false,
    loading: true,
    init: init,
    errors: {}
  });

  function init() {
    self.initialized = true;
    self.loading = false;
    parseErrors();
  }

  function parseErrors() {
    var params = $location.search();
    if (params['used']) {
      self.errors.used = true;
      $location.search('used', null);
    }
  }

  if ($rootScope.hotel) {
    this.init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.PicturesController', PicturesController);

PicturesController.$inject = ["$mdDialog", "$rootScope", "$scope", "$http", "$i18next", "PhotoFactory"];

function PicturesController ($mdDialog, $rootScope, $scope, $http, $i18next, PhotoFactory) {
  var self = this;

  angular.extend(
    this,
    {
      // Controller variables
      loaded            : false,
      pictures          : [],
      createFormVisible : false,
      editedPicture     : null,
      roomTypes         : [],
      zones             : ['Room'],
      targets           : ['Blog Cover', 'Other'],
      photoLoaded       : false,
      newPicture        : {
        description       : null,
        content_type      : null,
        original_filename : null,
        image_data        : null,
        hotel_id          : null
      },

      // Controller methods
      getRoomTypeTitle : getRoomTypeTitle,
      closeCreateForm  : closeCreateForm,
      saveCreateForm   : saveCreateForm,
      openEditForm     : openEditForm,
      updatePicture    : updatePicture,
      removePicture    : removePicture,
      preparePictureAddress : preparePictureAddress,
      multipleFileUpload : multipleFileUpload
    }
  );
  $rootScope.i18next=$i18next;
  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    this.pictures = $rootScope.hotel.pictures;
    this.roomTypes = $rootScope.hotel.roomTypes;
    this.newPicture.hotel_id = $rootScope.hotel.id;
    this.loaded = true;
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && self.newPicture && $rootScope.hotel.pictures && self.pictures.length === 0) {
      self.roomTypes = $rootScope.hotel.roomTypes;
      self.pictures = $rootScope.hotel.pictures;
      self.newPicture.hotel_id = $rootScope.hotel.id;
      self.loaded = true;
    }
  });


  function closeCreateForm () {
    if (self.editedPicture === null) {
      self.newPicture = angular.copy(self.originalPicture);
    } else {
      self.pictures[self.editedPicture] = angular.copy(self.originalPicture);
    }

    self.editedPicture     = null;
    self.createFormVisible = false;
  }


  function saveCreateForm (model) {
    model.loading = true;

    if (model.zone !== 'Room') {
      model.roomTypeId = null;
    }

    self.updatePicture(model);
  }


  function updatePicture (model) {
    model.hotelId = $rootScope.hotel.id;

    new PhotoFactory(model).update().then(function (data) {
      $rootScope.hotel.pictures.filter(function(picture) {return picture.id == data.id;})[0] = data;
      self.editedPicture = null;
    }).catch(function (error) {
      console.error('Error while trying to update picture:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function removePicture (index) {
    var confirm = $mdDialog.confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ok('Confirm')
      .cancel('Cancel');

    angular.element('.tooltip').hide();

    $mdDialog.show(confirm).then(function() {
      var model = self.pictures[index];

      model.hotelId = $rootScope.hotel.id;

      new PhotoFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            $rootScope.hotel.pictures.splice(index, 1);
          } else {
            console.error('Error while trying to remove picture:', data);
            $rootScope.alert("You can't remove extras used in bookings!");
          }
        });
    }, function() {});
  }


  function openEditForm (index) {
    angular.element('.tooltip').hide();
    self.originalPicture = angular.copy(self.pictures[index]);
    self.editedPicture   = index;
  }


  function getRoomTypeTitle (id) {
    var roomType = self.roomTypes.filter(function (rt) {return rt.id == id;} )[0];

    if (roomType) {
      return roomType.shortName;
    } else {
      return '';
    }
  }

  function preparePictureAddress (address, slug) {
    return (address.replace('thumb', slug)).split('?')[0];
  }


  function multipleFileUpload ($event) {
    var files  = $event.target.files;
    var loaded = 0;
    self.photoLoaded = true;

    _.each(files, function (file) {
      var fd = new FormData();
      fd.append("photo[photo]", file);

      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/photos', fd, {
          headers: {'Content-Type': undefined },
          transformRequest: angular.identity
      }).success(function(response) {
        self.pictures.push(response.photo);
      }).error(function(response) {
        console.error('Error while trying to upload multiple files:', response);
      }).then(function () {
        loaded++;
        if (loaded == files.length) {
          self.photoLoaded = false;
        }
      });
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    angular.element('.tooltip').remove();
  });
}

angular
  .module('buuqit')
  .controller('Settings.DetailsController', DetailsController)
  .component('reactHotelDetails', window.TBFLibs.react2angular(
    window.TBFLibs.HotelDetails,
    [
      'isAdmin',
      'countries',
      'currencies',
      'timezones',
      'hotel',
      'onSave',
    ],
    [
      '$i18next'
    ]
  ));

DetailsController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$timeout"
];

function DetailsController ($rootScope, $scope, $i18next, $timeout) {
  var self = this;

  angular.extend(
    this,
    {
      hotel : $rootScope.hotel,
      paymentGateway : $rootScope.hotel ? $rootScope.hotel.gateway : false,
      credentialsChanged: false,
      originalBraintreeCredentials : $rootScope.hotel ? angular.copy($rootScope.hotel.braintreeCredentials) : {},
      timezones: moment.tz.names(),
      initTimeout: null,

      init             : init,
      onSave           : onSave,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      if (self.initTimeout) {
        $timeout.cancel(self.initTimeout);
      }
      self.initTimeout = $timeout(init, 0);
    }
  });

  function init () {
    if ($rootScope.hotel) {

      angular.extend(
        self,
        {
          hotel     : $rootScope.hotel,
          paymentGateway: angular.copy($rootScope.hotel.paymentGateway),
          countries : countries,
          currencies : currencies,
          center    : null,
          originalBraintreeCredentials : angular.copy($rootScope.hotel.braintreeCredentials)
        }
      );

      self.hotel.user_timezone = moment.tz.guess();

      if ($rootScope.selectedField) {
        angular.element('[name="'+$rootScope.selectedField+'"]').focus();
        $rootScope.selectedField = null;
      }
    }
  }

  function onSave (hotelDetails) {
    self.hotel = Object.assign($rootScope.hotel, hotelDetails);
    if (self.hotel.payment_gateway == 'none') {
      self.hotel.braintree_creadentials = null;
    }
    if (self.hotel.payment_gateway == 'braintree') {}

    return self.hotel.save().then(function (data) {
      $rootScope.hotel = data;

      $rootScope.currencySymbol = currencies.filter(function(el) {return el[0] == $rootScope.hotel.currency;})[0][2];

      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }, function (response) {
      console.error('Error saving hotel details', response);
      $rootScope.notify($i18next.t('general.titles.error') + ': ' + response.data.error);
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
    }
  });
}

angular.module("buuqit").controller("Settings.Triggers", Triggers);

Triggers.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$q",
  "$mdDialog",
  "ReactionsFactory",
  "TriggersFactory",
  "ReactionTasksFactory",
  "ReactionConditionsFactory",
  "ReactionEventsFactory"
];

function Triggers(
  $rootScope,
  $scope,
  $i18next,
  $q,
  $mdDialog,
  ReactionsFactory,
  TriggersFactory,
  ReactionTasksFactory,
  ReactionConditionsFactory,
  ReactionEventsFactory
) {
  var self = this;

  angular.extend(this, {
    loaded: false,
    reactions: [],
    triggers: [],
    conditions: [],
    tasks: [],
    types: ["scheduled", "before", "after"],
    shouldShowTriggerReactionsList: true,
    
    openEditForm: openEditForm,
    updateTrigger: updateTrigger,
    createTrigger: createTrigger,
    cancelTriggerEditing: cancelTriggerEditing,
    addTrigger: addTrigger,
    removeTrigger: removeTrigger,

    getTriggerAvailableReactions: getTriggerAvailableReactions,

    attachReactionToTrigger: attachReactionToTrigger,
    detachReactionFromTrigger: detachReactionFromTrigger,
    addReaction: addReaction,
    openReactionEditForm: openReactionEditForm,
    cancelReactionEditing: cancelReactionEditing,
    updateReaction: updateReaction,
    createReaction: createReaction,

    getTriggerSummary: getTriggerSummary,
    getExecutionTime: getExecutionTime,
    getTriggerReactions: getTriggerReactions,

    openMenu: openMenu,
  });

  function init() {
    if (!$rootScope.hotel) return;

    this.loaded = false;

    function safeGet(factory, errorMsg) {
      return factory.query({}, { hotelId: $rootScope.hotel.id })
        .catch(function(error) {
          console.error(errorMsg || "API request failed", error);
          if (factory === ReactionsFactory) return [];
          if (factory === TriggersFactory) return [];
          if (factory === ReactionTasksFactory) return { tasks: [] };
          if (factory === ReactionEventsFactory) return { events: [] };
          if (factory === ReactionConditionsFactory) return { conditions: [] };
          return [];
        });
    }

    var promises = {
      reactions: safeGet(ReactionsFactory, "Failed to load reactions"),
      triggers: safeGet(TriggersFactory, "Failed to load triggers"),
      tasks: safeGet(ReactionTasksFactory, "Failed to load tasks"),
      events: safeGet(ReactionEventsFactory, "Failed to load events"),
      conditions: safeGet(ReactionConditionsFactory, "Failed to load conditions")
    };

    $q.all(promises)
      .then(function(results) {
        self.reactions = results.reactions || [];
        self.triggers = results.triggers || [];
        self.tasks = results.tasks.tasks || [];

        var events = results.events.events || [];
        self.events = events;
        self.before_events = events.filter(function(el) { return el.kind == "before"; });
        self.after_events = events.filter(function(el) { return el.kind == "after"; });

        self.conditions = results.conditions.conditions || [];
        self.loaded = true;
      })
      .catch(function(error) {
        console.error("Fatal error initializing reactions:", error);
        self.loaded = true;
      });
  }

  function openEditForm(trigger) {
    var previouslyEdited = getEditedTrigger();
    if (previouslyEdited) cancelTriggerEditing(previouslyEdited);

    self.originalTrigger = angular.copy(trigger);
    trigger.filteredTypes = self.types;
    trigger.reactions = getTriggerReactions(trigger);
    trigger.availableReactions = getTriggerAvailableReactions(trigger);
    trigger.edited = true;
  }

  function addTrigger() {
    var index = self.triggers.push({
      hotelId: $rootScope.hotel.id,
      isEnabled: true,
      reactionIds: []
    });

    openEditForm(self.triggers[index - 1]);
  }

  function cancelTriggerEditing(trigger) {
    var index = self.triggers.indexOf(trigger);
    var editedReaction = getEditedReaction();

    cancelReactionEditing(editedReaction);

    if (!trigger.id)
      self.triggers = _.without(self.triggers, trigger);
    else
      TriggersFactory
        .get({ id: trigger.id, hotelId: $rootScope.hotel.id })
        .then(function(trigger) {
          self.triggers[index] = trigger;
        }).catch(function(error) {
          console.error('Error fetching trigger:', error);
        });

    self.originalTrigger = {};
  }

  function updateTrigger(index, trigger) {
    self.triggers[index] = trigger;
    trigger.edited = false;
    self.originalTrigger = {};
  }

  function createTrigger(index, trigger) {
    self.triggers[index] = trigger;
    trigger.edited = false;
  }

  function removeTrigger(trigger) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      trigger.hotelId = $rootScope.hotel.id;
      trigger.remove().then(function(response) {
        if (response.success) {
          self.triggers = _.without(self.triggers, trigger);
        } else {
          console.error('Error removing trigger:', response);
          $rootScope.alert(response.msg);
        }
      });
    }, function() {});
  }

  function getEditedTrigger() {
    return self.triggers.filter(
      function(trigger) { return trigger.edited }
    )[0];
  }

  function getEditedReaction() {
    return self.reactions.filter(
      function(reaction) { return reaction.edited }
    )[0];
  }


  function attachReactionToTrigger(trigger, reaction) {
    trigger.availableReactions = _.without(trigger.availableReactions, reaction)
    trigger.reactions.push(reaction);
  }

  function detachReactionFromTrigger(trigger, reaction) {
    trigger.availableReactions.push(reaction);
    trigger.reactions = _.without(trigger.reactions, reaction)
  }

  function addReaction(trigger) {
    var index = self.reactions.push({
      isEnabled: true,
      defaultArguments: {},
      reactionConditions: [],
      triggerIds: [trigger.id]
    }) - 1;

    trigger.reactions.push(self.reactions[index]);

    self.openReactionEditForm(trigger, self.reactions[index]);
  }

  function openReactionEditForm(trigger, reaction) {
    var previouslyEdited = getEditedReaction();
    if (previouslyEdited) cancelReactionEditing(previouslyEdited);

    self.originalReaction = angular.copy(reaction);
    
    reaction.filteredTasks = filteredTasks(trigger.kind);
    trigger.reactionFormOpened = true;
    reaction.edited = true;
  }

  function cancelReactionEditing(reaction) {
    if (!reaction) return;

    var editedTrigger = getEditedTrigger();
    var index = self.reactions.indexOf(reaction);

    if (reaction.id) 
      self.reactions[index] = angular.copy(self.originalReaction);
    else
      self.reactions = _.without(self.reactions, reaction);

    editedTrigger.reactionFormOpened = false;
    editedTrigger.reactions = getTriggerReactions(editedTrigger)
    self.originalReaction = {};
  }

  function updateReaction(index, reaction) {
    self.reactions[index] = reaction;
    reaction.edited = false;
    self.originalReaction = {};
  }

  function createReaction(index, reaction) {
    var trigger = getEditedTrigger();
    self.reactions[index] = reaction;
    trigger.reactions = getTriggerReactions(trigger);
    attachReactionToTrigger(trigger, self.reactions[index]);
    self.reactions[index].edited = false;
    trigger.reactionFormOpened = false;
  }


  function getTriggerSummary(trigger) {
    if (!trigger) return;

    if (trigger.kind === 'scheduled') {
      return 'scheduled';
    }
    else if (trigger.kind && trigger.event && self.events) {
      var event = self.events.filter(function(e) { return e.value === trigger.event })[0];
      return event.kind + ' ' + event.display.toLowerCase();
    }
  }

  function zeroize(d) {
    var pad = "00";
    var n = '' + d;
    return (pad + ('' + d)).slice(-pad.length);
  }

  function getExecutionTime(time) {
    var h = Math.floor(time / 3600);
    return zeroize(h) + ":" + zeroize((time - h * 3600) / 60);
  }

  function getTriggerReactions(trigger) {
    return self.reactions.filter(function(reaction) {
      return trigger.reactionIds && trigger.reactionIds.includes(reaction.id);
    })
  }

  function getTriggerAvailableReactions(trigger) {
    var tasks = filteredTasks(trigger.kind).map(function(t){ return t.className });

    return self.reactions.filter(function(reaction) {
      return !trigger.reactionIds.includes(reaction.id) &&
              tasks.includes(reaction.task);
    });
  }


  function openMenu($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  };

  function filteredTasks(type) {
    return self.tasks.filter(function(task) {
      return task.type.indexOf(type) !== -1
    });
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    init.call(self);
  });

  $scope.$on('$destroy', function() {
    hotelWatcher();
  });

  init();
}

angular.module("buuqit").controller("Settings.Reactions", Reactions);

Reactions.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$q",
  "$mdDialog",
  "ReactionsFactory",
  "TriggersFactory",
  "ReactionTasksFactory",
  "ReactionConditionsFactory",
  "ReactionEventsFactory"
];

function Reactions(
  $rootScope,
  $scope,
  $i18next,
  $q,
  $mdDialog,
  ReactionsFactory,
  TriggersFactory,
  ReactionTasksFactory,
  ReactionConditionsFactory,
  ReactionEventsFactory
) {
  var self = this;

  angular.extend(this, {
    loaded: false,
    reactions: [],
    triggers: [],
    conditions: [],
    tasks: [],
    types: ["scheduled", "before", "after"],

    addReaction: addReaction,
    createReaction: createReaction,
    updateReaction: updateReaction,
    removeReaction: removeReaction,
    duplicateReaction: duplicateReaction,

    openEditForm: openEditForm,
    cancelReactionEditing: cancelReactionEditing,
    openTriggerEditForm: openTriggerEditForm,
    cancelTriggerEditing: cancelTriggerEditing,
    addTrigger: addTrigger,
    updateTrigger: updateTrigger,
    createTrigger: createTrigger,

    getReactionAvailableTriggers: getReactionAvailableTriggers,

    attachTriggerToReaction: attachTriggerToReaction,
    detachTriggerFromReaction: detachTriggerFromReaction,

    getTriggerSummary: getTriggerSummary,
    getExecutionTime: getExecutionTime,
    getReactionTriggers: getReactionTriggers,

    openMenu: openMenu,
    resetSelectedTrigger: resetSelectedTrigger,
  });

  function init() {
    if (!$rootScope.hotel) return;

    this.loaded = false;

    function safeGet(factory, errorMsg) {
      return factory.query({}, { hotelId: $rootScope.hotel.id })
        .catch(function(error) {
          console.error(errorMsg || "API request failed", error);
          if (factory === ReactionsFactory) return [];
          if (factory === TriggersFactory) return [];
          if (factory === ReactionTasksFactory) return { tasks: [] };
          if (factory === ReactionEventsFactory) return { events: [] };
          if (factory === ReactionConditionsFactory) return { conditions: [] };
          return [];
        });
    }

    var promises = {
      reactions: safeGet(ReactionsFactory, "Failed to load reactions"),
      triggers: safeGet(TriggersFactory, "Failed to load triggers"),
      tasks: safeGet(ReactionTasksFactory, "Failed to load tasks"),
      events: safeGet(ReactionEventsFactory, "Failed to load events"),
      conditions: safeGet(ReactionConditionsFactory, "Failed to load conditions")
    };

    $q.all(promises)
      .then(function(results) {
        self.reactions = results.reactions || [];
        self.triggers = results.triggers || [];
        self.tasks = results.tasks.tasks || [];

        var events = results.events.events || [];
        self.events = events;
        self.before_events = events.filter(function(el) { return el.kind == "before"; });
        self.after_events = events.filter(function(el) { return el.kind == "after"; });

        self.conditions = results.conditions.conditions || [];
        self.loaded = true;
      })
      .catch(function(error) {
        console.error("Fatal error initializing reactions:", error);
        self.loaded = true;
      });
  }

  function addReaction() {
    var index = self.reactions.push({
      isEnabled: true,
      defaultArguments: {},
      reactionConditions: [],
      triggerIds: [],
    }) - 1;

    self.openEditForm(self.reactions[index]);
  }

  function createReaction(index, reaction) {
    self.reactions[index] = reaction;
    reaction.edited = false;
  }

  function updateReaction(index, reaction) {
    self.reactions[index] = reaction;
    reaction.edited = false;
    self.originalReaction = {};
  }

  function removeReaction(reaction) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      reaction.hotelId = $rootScope.hotel.id;
      reaction.remove().then(function(response) {
        if (response.success) {
          self.reactions = _.without(self.reactions, reaction);
        } else {
          console.error('Error removing reaction:', response);
          $rootScope.alert(response.msg);
        }
      });
    }, function() {});
  }

  function duplicateReaction(originalReaction) {
    var cloned = angular.copy(originalReaction);
    delete cloned.id;

    cloned.title = $i18next.t('profile_nav.settings.other.reactions.copy_of') + ' '  + originalReaction.title;
    cloned.hotelId = $rootScope.hotel.id;
    cloned.isEnabled = false;
    cloned.defaultArguments = JSON.stringify(cloned.defaultArguments || {});
    cloned.reactionConditions = JSON.stringify(cloned.reactionConditions || []);

    var reaction = new ReactionsFactory(cloned);

    reaction.create().then(
      function(response) {
        if (response.id) {
          var index = self.reactions.push(response) - 1;
          openEditForm(self.reactions[index]);
        }
      },
      function(response) {
        console.error('Error duplicating reaction:', response);
        var message = Object.keys(response.data.errors)
          .map(function(key) {
            return key + ": " + response.data.errors[key].join(", ");
          })
          .join(". ");
        $rootScope.alert(message);
      }
    );
  }


  function attachTriggerToReaction(reaction, trigger) {
    reaction.availableTriggers = _.without(reaction.availableTriggers, trigger)
    reaction.triggers.push(trigger);
  }
  function detachTriggerFromReaction(reaction, trigger) {
    reaction.availableTriggers.push(trigger);
    reaction.triggers = _.without(reaction.triggers, trigger)
  }


  function openEditForm(reaction) {
    var previouslyEdited = getEditedReaction();
    if (previouslyEdited) cancelReactionEditing(previouslyEdited);

    self.originalReaction = angular.copy(reaction);

    reaction.filteredTasks = self.tasks;
    reaction.triggers = getReactionTriggers(reaction);
    reaction.availableTriggers = getReactionAvailableTriggers(reaction);
    reaction.edited = true;
  }

  function cancelReactionEditing(reaction) {
    var index = self.reactions.indexOf(reaction);

    if (!reaction.id)
      self.reactions = _.without(self.reactions, reaction);
    else
      ReactionsFactory
        .get({ id: reaction.id, hotelId: $rootScope.hotel.id })
        .then(function(reaction) {
          self.reactions[index] = reaction;
        })
      self.reactions[index] = angular.copy(self.originalReaction);

    self.originalReaction = {};
  }

  function openTriggerEditForm(reaction, trigger) {
    var previouslyEdited = getEditedTrigger();
    if (previouslyEdited) cancelTriggerEditing(previouslyEdited);

    self.originalTrigger = angular.copy(trigger);

    trigger.filteredTypes = filteredTypes(reaction.task);
    reaction.triggerFormOpened = true;
    trigger.edited = true;
  }

  function cancelTriggerEditing(trigger) {
    if (!trigger) return;

    var reaction = getEditedReaction();
    var index = self.triggers.indexOf(trigger);

    if (trigger.id) {
      self.triggers[index] = angular.copy(self.originalTrigger);
    } else {
      self.triggers = _.without(self.triggers, trigger);
    }

    reaction.triggerFormOpened = false;
    reaction.triggers = getReactionTriggers(reaction)
    self.originalTrigger = {};
  }

  function addTrigger(reaction) {
    var index = self.triggers.push({
      isEnabled: true,
      reactionIds: [reaction.id],
    }) - 1;

    reaction.triggers.push(self.triggers[index]);

    self.openTriggerEditForm(reaction, self.triggers[index]);
  }

  function updateTrigger(index, trigger) {
    var reaction = getEditedReaction();
    self.triggers[index] = trigger;
    trigger.edited = false;
    reaction.triggerFormOpened = false;
    self.originalTrigger = {};
  }

  function createTrigger(index, trigger) {
    var reaction = getEditedReaction();
    self.triggers[index] = trigger;
    reaction.triggers = getReactionTriggers(reaction);
    attachTriggerToReaction(reaction, self.triggers[index]);
    self.triggers[index].edited = false;
    reaction.triggerFormOpened = false;
  }


  function getReactionTriggers(reaction) {
    return self.triggers.filter(function(trigger) {
      return reaction.triggerIds.includes(trigger.id);
    })
  }

  function getReactionAvailableTriggers(reaction) {
    return self.triggers.filter(function(trigger) {
      return !reaction.triggerIds.includes(trigger.id) &&
              filteredTypes(reaction.task).includes(trigger.kind);
    })
  }

  function getTriggerSummary(trigger) {
    if (trigger) {
      if (trigger.kind === 'scheduled')
        return 'scheduled';
      else if (trigger.kind && trigger.event && self.events) {
        var event = self.events.filter(function(e) { return e.value === trigger.event })[0];
        return event.kind + ' ' + event.display.toLowerCase();
      }
    }
  }

  function zeroize(d) {
    var pad = "00";
    var n = '' + d;
    return (pad + ('' + d)).slice(-pad.length);
  }

  function getExecutionTime(time) {
    var h = Math.floor(time / 3600);
    return zeroize(h) + ":" + zeroize((time - h * 3600) / 60);
  }

  function openMenu($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  };

  function getEditedReaction() {
    return self.reactions.filter(
      function(reaction) { return reaction.edited }
    )[0];
  }

  function getEditedTrigger() {
    return self.triggers.filter(
      function(trigger) { return trigger.edited }
    )[0];
  }

  function filteredTypes(className) {
    var task = self.tasks.filter(function(task) {
      return task.className === className;
    })[0];

    return task ? task.type : [];
  }

    function resetSelectedTrigger(reaction) {
    reaction.triggerFormOpened = false;
    
    var editedTrigger = getEditedTrigger();
    if (editedTrigger) {
      cancelTriggerEditing(editedTrigger);
    }
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    init.call(self);
  });

  $scope.$on('$destroy', function() {
    hotelWatcher();
  });

  init();
}

angular
  .module('buuqit')
  .controller('Settings.PluginsController', PluginsController);

  PluginsController.$inject = ["$rootScope", "$scope", "PluginFactory", "$i18next"];

function PluginsController ($rootScope, $scope, PluginFactory, $i18next) {
  angular.extend(
    $scope,
    {
      loaded   : false,
      active_page_name: 'active',
      plugins  : [],
      havePlugins: false,
      install  : function (plugin) {
        if (plugin.loading) {
          return;
        }
        plugin.loading = true;

        plugin.install()
          .then(
            function(res) {
              plugin.loading = false;
              $scope.updatePlugins();
              $rootScope.notify($i18next.t('general.profile_nav.settings.other.plugin_settings.success_msg'));
            },
            function(err) {
              console.error('Error installing plugin:', err);
              plugin.loading = false;
              $rootScope.notify($i18next.t('general.titles.error'));
            }
          );
      },
      remove : function (plugin) {
        plugin.loading = true;

        plugin
          .remove()
          .then(
            function(res) {
              plugin.loading = false;
              $scope.updatePlugins();
              $rootScope.notify($i18next.t('general.profile_nav.settings.other.plugin_settings.destroy_pugin_msg'));
            },
            function(err) {
              console.error('Error removing plugin:', err);
              plugin.loading = false;
              $rootScope.notify($i18next.t('general.titles.error'));
            }
          );
      },
      showInfo : function (item) {
        item.additionalInfoIsVisible = !item.additionalInfoIsVisible;
      },
      changeActivePage : function(page) {
        $scope.active_page_name = page
      }
    }
  );


  function init () {
    if ($rootScope.hotel) {
      $scope.plugins = $rootScope.hotel.plugins;
      $scope.updatePlugins();
      $scope.loaded = true;
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  })

  $scope.updatePlugins = function() {
    $scope.havePlugins = $scope.plugins.filter(function(p){ return p.installed; }).length > 0;
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.HoperatorController', HoperatorController);

HoperatorController.$inject = ["$rootScope", "$scope", "$sce"];

function HoperatorController ($rootScope, $scope, $sce) {
  var self = this;

  angular.extend(
    this,
    {
      hotel : {},
      loaded : false
    }
  );


  function init () {
    if ($rootScope.hotel) {
      self.hotel = $rootScope.hotel;
      self.iframeURL = $sce.trustAsResourceUrl(generatePageURL());
      self.loaded = true;
    }
  }


  function generatePageURL() {
    return SERVER_PATH + '/hoperator_integration_page?api_key=' + $rootScope.hotel.apiKey;
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  init();

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.FolioController', FolioController);

  FolioController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "BookingStorage",
  "$sce",
  "FolioTemplateService",
  "FolioTemplateStorage",
  "CODEMIRROR_SETTINGS",
  "$mdDialog",
  "$timeout",
];

function FolioController (
  $rootScope,
  $scope,
  $i18next,
  BookingStorage,
  $sce,
  FolioTemplateService,
  FolioTemplateStorage,
  CODEMIRROR_SETTINGS,
  $mdDialog,
  $timeout
) {

  var self = this;

  function getTemplate() {
    return self.templates.filter(function(e){ return e.kind == self.templateType; })[0] || {};
  }

  // Maybe not so good but iframe appending happens via Jquery
  // and i do not wanna change it to angular right now
  window.templatePreviewIframeLoaded = function() {
    $timeout(function() {self.isPreviewLoaded = true;}, 0);
  };

  angular.extend(
    $scope,
    {
      defaultLoading: false
    }
  );

  angular.extend(
    this,
    {
      helpPage: $sce.trustAsResourceUrl("https://bookingfactory.github.io/user_manuals/templating"),
      help_opened: false,
      loaded: false,
      isPreviewShown: false,
      isPreviewLoaded: false,
      isHTMLpreview: false,
      bookings:  BookingStorage.bookings,
      templates: FolioTemplateStorage.templates,
      preview: '',
      cssEditor: CODEMIRROR_SETTINGS,
      liquidEditor: CODEMIRROR_SETTINGS,
      liquidCode: '',
      cssCode: '',
      booking: '',
      isActive: false,
      view: localStorage.getItem('template_ui_view') || 'vertically',
      templateArg: undefined,
      templateTypes: ['folio', 'guest_reg_form'],
      templateType: 'folio',
      openDropDown: function($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      },
      changeTemplateType: function(templateType) {
        if ($scope.defaultLoading) return;

        var confirm = $mdDialog.confirm()
          .title('Change Type')
          .htmlContent('You will loose all unsaved changes')
          .ok('Ok')
          .cancel('Cancel');

        $mdDialog.show(confirm).then(function () {
          self.templateType = templateType;
          t = getTemplate();
          self.isPreviewShown = false;
          self.isPreviewLoaded = false;
          self.liquidCode = t.html;
          self.cssCode = t.css;
          self.isActive = t.is_active;
        }, function (error) {
          console.error('Error changing template type:', error);
        });
      },

      toggleFullscreen: function($event) {
        var cm = $event.currentTarget.parentElement.querySelector('.CodeMirror').CodeMirror;
        cm.setOption("fullScreen", !cm.getOption("fullScreen"));
        var isFullscreen = cm.getOption("fullScreen");
        if (isFullscreen) {
          cm.getWrapperElement().parentElement.classList.add('opened');
          cm.focus();
        }
        else {
          cm.getWrapperElement().parentElement.classList.remove('opened');
        };
      },
      backToEdit : function  () {
        self.isPreviewShown = false
        self.isPreviewLoaded = false
      },
      selectTemplate: function () {
        var template = self.templates.find(function (item) {
          return item.id == self.template
        })

        self.liquidCode = template.html
        self.cssCode = template.css
      },
      saveTemplate : function () {
        var params = {
          html: self.liquidCode,
          css: self.cssCode,
          is_active: self.isActive || false,
          kind: self.templateType
        }

        FolioTemplateService.create(params)
          .then(function(response) {
            var t = self.templates.filter(function(e) { return e.id == response.data.template.id})[0];

            if (t) {
              angular.copy(response.data.template, t);
            } else {
              self.templates.push(response.data.template);
            }

            $rootScope.notify(response.data.msg);
          }, function (error) {
            console.error('Error saving template:', error);
            $rootScope.alert(error.data.errors.join('.\r\n'));
          })
      },
      showPreview : function(type) {
        self.isPreviewShown = true
        self.preview = ''

        var params = {
          html: self.liquidCode,
          css: self.cssCode,
          type: 'pdf',
          kind: self.templateType,
          arg: self.templateArg
        }

        FolioTemplateService.preview(params)
          .then(function(response) {
            if (params.type === 'pdf') {
              $('#pdfDocument').remove();
              if (response.data.success) {
                self.isHTMLpreview = false
                var token = response.data.token
                var path = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/folio_templates/preview_pdf?token=' + token;
                $('.template_pdf_preview').append('<iframe src="' + path + '" name="pdf" id="pdfDocument" width="100%" height="100%" onload="templatePreviewIframeLoaded()"></iframe>');
              } else {
                self.backToEdit();
                $rootScope.alert(response.data.error);
              }
            } else {
              self.isPreviewLoaded = true
              self.isHTMLpreview = true
              self.preview = $sce.trustAsHtml(response.data.html)
            }
          }, function(error) {
            console.error('Error loading template preview:', error);
            self.isPreviewLoaded = true
          });
      },
      toggleView : function () {
        var view = self.view === 'vertically' ? 'horizontally' : 'vertically'
        self.view = view
        localStorage.setItem('template_ui_view', self.view);
      },
      loadDefaults : function () {
        if ($scope.defaultLoading) {
          return;
        }

        var confirm = $mdDialog.confirm()
          .title('Load defaults')
          .htmlContent('Are you sure?')
          .ok('Ok')
          .cancel('Cancel');
        var templateType = self.templateType;
        $mdDialog.show(confirm).then(function () {
          $scope.defaultLoading = true;
          FolioTemplateService.getDefaultTemplate(templateType)
            .then(function(res) {
              if (self.templateType != templateType) {
                changeTemplateType(templateType);
              }
              var template = res.data.template;
              if (template) {
                self.liquidCode = template.html;
                self.cssCode = template.css;
              } else {
                self.liquidCode = '';
                self.cssCode = '';
              }
              $scope.defaultLoading = false;
            }, function(error) {
              console.error('Error loading default template:', error);
              $scope.defaultLoading = false;
              $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
            });
        }, function () {
        });
      }
    }
  );

  function initTemplates(){
    var t = getTemplate();
    self.liquidCode = t.html;
    self.cssCode = t.css;
    self.isActive = t.is_active;
  }

  function init () {
    if ($rootScope.hotel) {
      self.loaded = true;
      FolioTemplateStorage.load();
      initTemplates();
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  var bookingListener = $rootScope.$on('BookingStorage:loaded', function() {
    self.bookings = BookingStorage.bookings
  });

  var templateListener = $rootScope.$on('FolioTemplateStorage:loaded', function () {
    self.templates = FolioTemplateStorage.templates;
    self.loaded = true;
    initTemplates();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (bookingListener) {
      bookingListener();
    }
    if (templateListener) {
      templateListener();
    }
    if (window.templatePreviewIframeLoaded) {
      window.templatePreviewIframeLoaded = null;
    }
    $('#pdfDocument').remove();
  });
}
angular
  .module('buuqit')
  .controller('Settings.CountrySpecificController', CountrySpecificController);

CountrySpecificController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "Globalize"
];

function CountrySpecificController ($rootScope, $scope, $i18next, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      loading : true,
      save : save
    }
  );

  function init () {
    if ($rootScope.hotel) {
      self.loading = false;
    }
  }

  function save () {
    if (self.loading) return;
    self.loading = true;
    $rootScope.hotel.addons_json = JSON.stringify($rootScope.hotel.addons);
    $rootScope.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.loading = false;
      Globalize.loadTranslation($rootScope.hotel, 'hotel');
      $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str'));
    }, function(error) {
      console.error('Error saving hotel:', error);
      self.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });

  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.InventorySettingsController', InventorySettingsController);

InventorySettingsController.$inject = ["$rootScope", "$scope", "$i18next"];

function InventorySettingsController ($rootScope, $scope, $i18next) {
  var self = this;

  angular.extend(
    this, {
      minDate: new Date(),
      times: generateTimeOptions(),
      timezone: null,
      hotel: $rootScope.hotel,
      save: save,
      prepareTime: prepareTime,
      convertFromUTCToHotelTime: convertFromUTCToHotelTime
    }
  );

  init();

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  function init() {
    if ($rootScope.hotel) {
      self.hotel = $rootScope.hotel;
      self.cutOffDate = $rootScope.hotel.cutOffDate ? new Date($rootScope.hotel.cutOffDate) : undefined;
      self.stopSellingTime = $rootScope.hotel.stopSellingTime ? self.convertFromUTCToHotelTime($rootScope.hotel.stopSellingTime) : null;
      self.showCutOffDatePicker = typeof($rootScope.hotel.cutOffDate) !== 'undefined' && typeof($rootScope.hotel.cutOffDate) !== 'object';
      self.showCutOffTimePicker = typeof($rootScope.hotel.stopSellingTime) === 'string';
      self.timezone = $rootScope.hotel.timezone;
      self.loaded = true;
    }
  }

  function save () {
    if (self.saving) {
      return;
    }
    $rootScope.hotel.cutOffDate = self.showCutOffDatePicker === true ? moment(self.cutOffDate).format('YYYY-MM-DD') : null;
    $rootScope.hotel.stopSellingTime = self.showCutOffTimePicker === true ? self.prepareTime(self.stopSellingTime) : null;
    self.saving = true;
    $rootScope.hotel.save().then(function (data) {
      self.saving = false;
      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }, function (response) {
      console.error('Error saving hotel settings', response);
      self.saving = false;
      $rootScope.notify($i18next.t('general.titles.error') + ': ' + response.data.error);
    })
  }


  function prepareTime (time) {
    if (time && $rootScope.hotel && $rootScope.hotel.timezone) {
      var splittedTime = time.split(':'),
          date = new Date();

      date = moment(date.setHours(Number(splittedTime[0]), Number(splittedTime[1]), 0, 0)).format('YYYY-MM-DD HH:mm');

      return moment.tz(date, $rootScope.hotel.timezone).utc().format('HH:mm');
    }
  }

  function generateTimeOptions() {
    var times = [];
    for (var hour = 0; hour < 24; hour++) {
      var formattedHour = hour < 10 ? '0' + hour : '' + hour;
      times.push(formattedHour + ':00');
      times.push(formattedHour + ':30');
    }
    return times;
  }


  function convertFromUTCToHotelTime (time) {
    if (time && $rootScope.hotel && $rootScope.hotel.timezone) {
      var splittedTime = time.split(':'),
          date = new Date();

      date = moment(date.setHours(Number(splittedTime[0]), Number(splittedTime[1]), 0, 0)).format('YYYY-MM-DD HH:mm');

      return moment.tz(date, 'UTC').tz($rootScope.hotel.timezone).format('HH:mm');
    }
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module("buuqit")
  .controller("Settings.SeasonsController", SeasonsController)
  .component(
    'reactSeasonRoomRateCombinations',
    window.TBFLibs.react2angular(
      window.TBFLibs.SeasonRoomRateCombinations,
      [
        'rateCategories',
        'roomRepresentations',
        'seasons',
        'roomRates',
        'hideFields',
        'cancellationPolicies',
        'hotelSettings',
        'onSave',
        'onRoomRateRemoved',
        'onRoomRateChanged',
        'onSaveNewRoomRateCombination',
        'onSaveEditRoomRateCombination',
        'seasonId',
        'onClose',
        'manualModificationEnabled'
      ],
      [
        '$i18next',
        'RelationCalculator'
      ]
    )
  );

SeasonsController.$inject = [
  "$scope",
  "$rootScope",
  "$mdDialog",
  "$i18next",
  "Seasons",
  "Globalize",
  "RoomRatesStorage",
];

function SeasonsController($scope, $rootScope, $mdDialog, $i18next, Seasons, Globalize, RoomRatesStorage) {
  var ctrl = this;

  angular.extend(ctrl, {
    initialized: false,
    highlightedSeason: null,

    initialize: initialize,
    addSeason: addSeason,
    addRange: addRange,
    editSeason: editSeason,
    removeSeason: removeSeason,
    removeRange: removeRange,
    chooseSeason: chooseSeason,
    changeLang: changeLang,

    createFromCalendarSelection: createFromCalendarSelection,
    highlightOn: highlightOn,
    highlightOff: highlightOff,

    rateCategories: [],
    roomRepresentations: [],
    seasons: [],
    roomRates: [],
    hideFields: [],
    cancellationPolicies: [],
    seasonId: null,
    hotelSettings: {},
    displayDerivedSettings: false,
    onSave: handleSaveRoomRateChanges,
    onRoomRateRemoved: handleRoomRateRemoved,
    onRoomRateChanged: handleRoomRateChanged,
    onSaveNewRoomRateCombination: handleSaveNewRoomRateCombination,
    onSaveEditRoomRateCombination: handleSaveEditRoomRateCombination,
    onCloseSeason: handleCloseSeason,
    manualModificationsEnabled: false
  });

  function initialize() {
    ctrl.manualModificationsEnabled = $rootScope.hotel.modifyRoomRateCombinationsEnabled;
    ctrl.seasons = Seasons;
    ctrl.confirmation = $mdDialog
      .confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    ctrl.hideFields = getHiddenFields();
    ctrl.hotelSettings = {
      roundMethod: $rootScope.hotel.roundMethod,
      roundTo: $rootScope.hotel.roundTo,
    };
    ctrl.rateCategories = $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved === false});

    ctrl.roomRates = $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved === false;}).map(function(roomRate) {
      if (roomRate.roomRateSeasons.reduce) {
        roomRate.roomRateSeasons = roomRate.roomRateSeasons.reduce(function(obj, el) {
          obj[el.seasonId] = el;
          return obj;
        }, {});
      }
      var cancellationPolicy = $rootScope.hotel.cancellationPolicies.find(function(cp) {
        return cp.id == roomRate.cancellationPolicyId;
      });
      roomRate.cancellationPolicyTitle = cancellationPolicy.title;
      return roomRate;
    });

    ctrl.cancellationPolicies = $rootScope.hotel.cancellationPolicies;

    ctrl.roomRepresentations = $rootScope.hotel.roomRepresentations.map(
      function(roomRepresentation) {
        var roomRates = ctrl.roomRates.filter(function(room_rate) {
          return room_rate.roomRepresentationId === roomRepresentation.id;
        });

        roomRepresentation.roomRates = roomRates.map(function(roomRate) {
          var rateCategory = $rootScope.hotel
            .rateCategories
            .filter(function(rateCategory) {
              return rateCategory.id === roomRate.rateCategoryId;
            })[0];

          roomRate.rateTitle = rateCategory.name;
          roomRate.priority  = rateCategory.priority;

          return roomRate;
        });

        return roomRepresentation;
      }
    );

    ctrl.initialized = true;
    Seasons.load().then(function(seasons) {
      Seasons.list.forEach(function(season) {
        Globalize.loadTranslation(season, 'season');
      })
      $rootScope.$broadcast("seasons:reload", Seasons.list);
    });
  }

  function addSeason(startDate, endDate) {
    $mdDialog
      .show({
        controller: CreateSeasonController,
        templateUrl: getTemplatePath("modals/createSeason.html"),
        parent: angular.element(document.body),
        locals: {
          startDate: startDate,
          endDate: endDate
        },
        clickOutsideToClose: true
      })
      .then(function(success) {
        if (success) {
          ctrl.initialize();
        }
      });
  }

  function addRange(season) {
    $mdDialog
      .show({
        controller: CreateSeasonRangeController,
        templateUrl: getTemplatePath("modals/createSeasonRange.html"),
        parent: angular.element(document.body),
        locals: {
          season: season
        },
        clickOutsideToClose: true
      })
      .then(function(success) {
        if (success) {
          ctrl.initialize();
        }
      });
  }

  function addSeasonOrRange(startDate, endDate) {
    $mdDialog
    .show({
      controller: CreateSeasonOrRangeController,
      templateUrl: getTemplatePath("modals/createSeasonOrRange.html"),
      parent: angular.element(document.body),
      locals: {
        startDate: startDate,
        endDate: endDate
      },
      clickOutsideToClose: true
    })
    .then(function(success) {
      if (success) {
        ctrl.initialize();
      }
    });
  }

  function createFromCalendarSelection(range) {
    if (Seasons.list.length === 1) {
      addSeason(range.startDate, range.endDate);
    } else {
      addSeasonOrRange(range.startDate, range.endDate);
    }
  }

  function editSeason(season) {
    $mdDialog
      .show({
        controller: EditSeasonController,
        templateUrl: getTemplatePath("modals/editSeason.html"),
        parent: angular.element(document.body),
        locals: {
          season: season
        },
        clickOutsideToClose: true
      })
      .then(function(success) {
        if (success) {
          $rootScope.$broadcast("seasons:reload", Seasons.list);
        }
      });
  }

  function removeSeason(season) {
    $mdDialog.show(ctrl.confirmation).then(
      function() {
        Seasons.removeSeason(season).then(function(data) {
          $rootScope.$broadcast("seasons:reload", Seasons.list);
          if (ctrl.seasonId === season.id) {
            ctrl.seasonId = null;
          }
        });
      },
      function() {}
    );
  }

  function removeRange(season, range) {
    $mdDialog.show(ctrl.confirmation).then(
      function() {
        Seasons.removeRange(season, range).then(function(data) {
          $rootScope.$broadcast("seasons:reload", Seasons.list);
        });
      },
      function() {}
    );
  }

  function chooseSeason(season) {
    ctrl.seasonId = season.id;
  }

  function showPopover(event, seasonId) {
    var popover = $('#season-popover');
    
    var highlightedSeason = ctrl.seasons.list.find(function(season) {
      return season.id === seasonId;
    })

    var text = highlightedSeason ? highlightedSeason.title : seasonId;

    popover
      .css('opacity', '0')
      .css('white-space', 'nowrap')
      .show()
      .find('.popover-content')
      .html(text);

    var width = popover.width(),
      height = popover.height(),
      targetWidth = $(event.target).width(),
      targetHeight = $(event.target).height(),
      left = ($(event.target).offset().left + (targetWidth / 2) - (width / 2) - 2),
      top = $(event.target).offset().top;


      if (left > document.getElementsByTagName('body')[0].offsetWidth) {
        left = document.getElementsByTagName('body')[0].offsetWidth / 2;
      }
      if (left < 0) {
        left = 0;
      }

      popover.css({
        top: (top - height - targetHeight - 25) + 'px',
        left: left + 'px',
        opacity: 1
      });
  }

  function hidePopover() {
    var popover = $('#season-popover');
    popover.hide();
  }

  function highlightOn(data) {
    ctrl.highlightedSeason = data.seasonId;
    showPopover(data.event, data.seasonId);
  }

  function highlightOff() {
    hidePopover();
    ctrl.highlightedSeason = null;
  }

  function handleSaveRoomRateChanges(roomRates) {
    var results = [];
    roomRates.forEach(function(rr) {
      RoomRatesStorage.updateSeason(rr).then(function(data) {
        results.push(data.success !== false);

        if (results.length == roomRates.length) {
          RoomRatesStorage.load();
          var total_result = results.reduce(function(a, b) {return a && b}, true);
          if (total_result === false) {
            $rootScope.notify(data.message || $i18next.t('general.alert_modals.something_went_wrong_on_saving_js_str'));
          }
        }
      });
    });
  }

  function handleRoomRateRemoved(roomRate) {
    RoomRatesStorage.remove(roomRate).then(function(data) {
      if (data.success === false) {
        $rootScope.notify(data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
      }
    });
  }

  function handleRoomRateChanged(roomRate) {
    RoomRatesStorage.update(roomRate).then(function(data) {
      if (data.success === false) {
        return $rootScope.notify(data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
      }
      RoomRatesStorage.load();
    });
  }

  function handleSaveNewRoomRateCombination(roomRate) {
    return RoomRatesStorage.create(roomRate).then(function(data) {
      return data;
    });
  }

  function handleSaveEditRoomRateCombination(roomRate, selectedSeasonId) {
    if (roomRate.updateRoomRate) {
      return RoomRatesStorage.update(roomRate).then(function(data) {
        if (data.success === false) return data;
        return RoomRatesStorage.updateSeason(roomRate.roomRateSeasons[selectedSeasonId]).then(function(data) {
          if (data.success === false) return data;
          RoomRatesStorage.load();
          return data;
        });
      });
    } else {
      return RoomRatesStorage.updateSeason(roomRate.roomRateSeasons[selectedSeasonId]).then(function(data) {
        if (data.success === false) return data;
        RoomRatesStorage.load();
        return data;
      });
    }
  }

  function getHiddenFields() {
    var hiddenFields = [];
    if (!$rootScope.hotel.minStayArrivalVisible) hiddenFields.push('minStayArrival');
    if (!$rootScope.hotel.minStayThroughVisible) hiddenFields.push('minStayThrough');
    if (!$rootScope.hotel.maxStayVisible) hiddenFields.push('maxStay');
    if (!$rootScope.hotel.closedToArrivalVisible) hiddenFields.push('closedToArrival');
    if (!$rootScope.hotel.closedToDepartureVisible) hiddenFields.push('closedToDeparture');
    if (!$rootScope.hotel.stopSellVisible) hiddenFields.push('stopSell');
  }

  function handleCloseSeason() {
    ctrl.seasonId = null;
  }

  function initIfPossibleAndNeeded() {
    if ($rootScope.hotel && $rootScope.hotel.roomRates && ctrl.initialized === false) {
      initialize();
    }
  }

  function changeLang(old_lang) {
    var seasons = Seasons.list;
    seasons.forEach(function(s) {
      Globalize.saveTranslation(s, 'season', old_lang);
      Globalize.loadTranslation(s, 'season');
    })
  }

  var hotelWatcher = $rootScope.$watch('hotel', initIfPossibleAndNeeded);
  var roomRatesLoadedListener = $rootScope.$on('roomRates:loaded', initIfPossibleAndNeeded);

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (roomRatesLoadedListener) {
      roomRatesLoadedListener();
    }
    $('#season-popover').remove();
  });
}

angular
  .module('buuqit')
  .controller('Settings.DiscountsController', DiscountsController)
  .component(
    'inventoryDiscountsTable',
    TBFLibs.react2angular(
      TBFLibs.InventoryDiscountsTable,
      ['discounts', 'currencySymbol', 'onDiscountUpdate', 'onDiscountDelete', 'onLoadDiscounts', 'hotelId'],
      ['$i18next']
    ))

DiscountsController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "DiscountFactory",
  "DiscountsFactory",
  "Globalize"
];

function DiscountsController ($rootScope, $scope,$i18next, DiscountFactory, DiscountsFactory, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      // Controller variables
      discounts         : [],
      currencySymbol    : '',
      hotelId           : $rootScope.hotel && $rootScope.hotel.id,

      // Controller methods
      createDiscount  : createDiscount,
      updateDiscount  : updateDiscount,
      changeLang      : changeLang,
      
      onDiscountUpdate     : onDiscountUpdate,
      onDiscountDelete     : onDiscountDelete,
      onLoadDiscounts      : onLoadDiscounts
    }
  );

  var currencySymbolWatcher = $rootScope.$watch('currencySymbol', function() {
    self.currencySymbol = $rootScope.currencySymbol;
  })

  var hotelWatcher = $rootScope.$watch('hotel', function() {
    if ($rootScope.hotel && $rootScope.hotel.id) {
      self.hotelId = $rootScope.hotel.id;
    }
  })

  var DEFAULT_PAGINATION = { page: 1, limit: 10 };

  function onLoadDiscounts(params) {
    if ($rootScope.hotel && $rootScope.hotel.id) {
      var par = params || DEFAULT_PAGINATION;
      var discountsFactory = new DiscountsFactory();
      discountsFactory.getDiscounts($rootScope.hotel.id, par).then(function (data) {
        if (data.data) {
          self.discounts = data.data || {};
          self.discounts.discounts.forEach(function (d) {
            Globalize.loadTranslation(d, 'discount');
          });
        }
      }).catch(function (error) {
        console.error('Error loading discounts:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
        throw error;
      });
    }
    
  }

  function onDiscountUpdate(discount) {
    Globalize.updateCurrentTranslation(discount, 'discount');

    if (discount.id === -1) {
      delete discount.id;
      return self.createDiscount(discount);
    } else {
      return self.updateDiscount(discount);
    }
  }

  function createDiscount (model) {
    model.hotelId = $rootScope.hotel.id;

    return (new DiscountFactory(model)).create().catch(function (error) {
      console.error('Error creating discount:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
      throw error;
    });
  }

  function updateDiscount (model) {
    model.hotelId = $rootScope.hotel.id;
    return (new DiscountFactory(model)).update().catch(function (error) {
      console.error('Error updating discount:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
      throw error;
    });
  }

  function onDiscountDelete(id) {
    var modelIndex = self.discounts && self.discounts.discounts.findIndex(function (d) { return d.id === id });
    var model = self.discounts.discounts[modelIndex];
    model.hotelId = $rootScope.hotel.id;

    return (new DiscountFactory(model)).remove()
      .catch(function (error) {
        console.error('Error deleting discount:', error);
        $rootScope.alert($i18next.t('profile_nav.settings.hotel_profile.discounts.alert.you_can_not_remove_discounts_used_in_bookings_js_str'));
        throw error;
      });
  }

  function changeLang (old_locale) {
    if (self.discounts && self.discounts.discounts) {
      var discounts = self.discounts && self.discounts.discounts;
      discounts.forEach(function(d) {
        Globalize.saveTranslation(d, 'discount', old_locale);
        Globalize.loadTranslation(d, 'discount');
      })
      self.discounts = discounts.slice();
    }
  }

  $scope.$on('$destroy', function () {
    if (currencySymbolWatcher) {
      currencySymbolWatcher();
    }
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.RegistrationFormController', RegistrationFormController);

RegistrationFormController.$inject = ["$rootScope", "$scope", "$timeout", "Globalize"];

function RegistrationFormController ($rootScope, $scope, $timeout, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      initTimeout: null,
      pasteTimeout: null,
      init : init,
      save : save,
      changeLang: changeLang,
      wysiwygPaste: wysiwygPaste
    }
  );


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      if (self.initTimeout) {
        $timeout.cancel(self.initTimeout);
      }
      self.initTimeout = $timeout(init, 0);
    }
  });


  function init () {
    angular.extend(
      self,
      {
        loaded : false,
        hotel  : $rootScope.hotel
      }
    );
    Globalize.loadTranslation(self.hotel, 'hotel');
  }


  function save () {
    self.loaded = true;
    Globalize.updateCurrentTranslation(self.hotel, 'hotel');
    this.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.loaded = false;
      Globalize.loadTranslation(self.hotel, 'hotel');
    }).catch(function (error) {
      self.loaded = false;
      console.error('Error saving hotel data:', error);
    });
  }

  function changeLang(old_lang) {
    if (self.hotel === undefined) {
      return;
    }
    Globalize.saveTranslation(self.hotel, 'hotel', old_lang);
    Globalize.loadTranslation(self.hotel, 'hotel');
  }

  function wysiwygPaste(e) {
    var thisNote = $(e.currentTarget);
    var updatePastedText = function(someNote){
      var original = someNote.code();
      var cleaned = (function(original){
        var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
        var output = original.replace(stringStripper, ' ');
        var commentSripper = new RegExp('<!--(.*?)-->','g');
        var tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>','gi');
        var badTags = ['style', 'script','applet','embed','noframes','noscript'];
        output = output.replace(commentSripper, '');
        output = output.replace(tagStripper, '');

        for (var i=0; i< badTags.length; i++) {
          tagStripper = new RegExp('<'+badTags[i]+'.*?'+badTags[i]+'(.*?)>', 'gi');
          output = output.replace(tagStripper, '');
        }
        var badAttributes = ['style', 'start'];
        for (var x=0; x< badAttributes.length; x++) {
          var attributeStripper = new RegExp(' ' + badAttributes[x] + '="(.*?)"','gi');
          output = output.replace(attributeStripper, '');
        }
        return output;
      })(original);
      someNote.code('').html(cleaned);
    };
    if (self.pasteTimeout) {
      $timeout.cancel(self.pasteTimeout);
    }
    self.pasteTimeout = $timeout(function () {
      updatePastedText(thisNote);
    }, 10);
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
    }
    if (self.pasteTimeout) {
      $timeout.cancel(self.pasteTimeout);
    }
  });
}

angular
  .module("buuqit")
  .controller(
    "Settings.IdentificationTypesController",
    IdentificationTypesController
  );

  IdentificationTypesController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "Globalize",
  "IdentificationTypeFactory"
];

function IdentificationTypesController(
  $rootScope,
  $scope,
  $i18next,
  $mdDialog,
  Globalize,
  IdentificationTypeFactory
) {
  var self = this;

  angular.extend(self, {
    initialized: false,
    loading: false,
    addFormIsVisible: false,
    idTypeTemplate: {
      title: null,
      translations: []
    },
    newIdType: null,
    idTypes: [],
    confirmation: null,

    init: init,
    save: save,
    cancel: cancel,
    create: create,
    add: add,
    cancelAdd: cancelAdd,
    edit: edit,
    remove: remove,
    changeLang: changeLang,
  });

  function init() {
    self.initialized = true;
    fillTranslationsIntoIdTypes();
    self.confirmation = $mdDialog
      .confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('profile_nav.settings.hotel_profile.id_types.add_new_ID_type'))
      .ok($i18next.t('general.confirm.ok'))
      .cancel($i18next.t('general.confirm.cancel'));
  }

  function fillTranslationsIntoIdTypes() {
    self.idTypes = $rootScope.hotel.identificationTypes.map(function(idType) {
      Globalize.loadTranslation(idType, 'identificationType');
      return idType;
    });
  }

  function save(idType) {
    var index = $rootScope.hotel.identificationTypes.indexOf(idType);

    Globalize.updateCurrentTranslation(idType, 'identificationType');

    idType.loading = true;
    idType
      .save()
      .then(
        function (response) {
          response.loading = false;
          response.edited = false;
          $rootScope.hotel.identificationTypes[index] = response;
          fillTranslationsIntoIdTypes();
        },
        function (error) {
          console.error('Error saving identification type:', error);
          idType.loading = false;
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
        }
      )
  }

  function cancel(idType) {
    var index = $rootScope.hotel.identificationTypes.indexOf(idType);
    $rootScope.hotel.identificationTypes[index] = angular.copy(self.originalIdType);
    fillTranslationsIntoIdTypes();
  }

  function create(idType) {
    var newIdType = new IdentificationTypeFactory(idType);
    Globalize.updateCurrentTranslation(newIdType, 'identificationType');
    newIdType.hotelId = $rootScope.hotel.id;
    idType.loading = true;
    newIdType
      .save()
      .then(
        function(response) {
          self.cancelAdd();
          $rootScope.hotel.identificationTypes = _.union(
            $rootScope.hotel.identificationTypes,
            [response]
          );
          fillTranslationsIntoIdTypes();
        },
        function(error) {
          console.error('Error creating identification type:', error);
          idType.loading = false;
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
        }
      );
  }

  function add() {
    self.newIdType = angular.copy(self.idTypeTemplate);
    self.addFormIsVisible = true;
  }

  function cancelAdd() {
    self.newIdType = null;
    self.addFormIsVisible = false;
  }

  function changeLang(old_locale) {
    var idTypes = self.idTypes;
    if (self.addFormIsVisible) {
      idTypes = idTypes.concat([self.newIdType]);
    }

    idTypes.forEach(function(idType) {
      Globalize.saveTranslation(idType, 'identificationType', old_locale);
      Globalize.loadTranslation(idType, 'identificationType');
    });
  }

  function edit(idType) {
    self.originalIdType = angular.copy(idType);
    idType.edited = true;
  }

  function remove(idType) {
    $mdDialog.show(self.confirmation).then(
      function() {
        idType.loading = true;
        idType.remove().then(function(data) {
          if (data.success === false) {
            console.error('Error while removing identification type', data);
            idType.loading = false;
            $rootScope.alert(data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
          } else {
            $rootScope.hotel.identificationTypes = _.without($rootScope.hotel.identificationTypes, idType);
            self.idTypes = $rootScope.hotel.identificationTypes;
          }
        });
      },
      function() {}
    )
  }

  if ($rootScope.hotel) {
    this.init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module("buuqit")
  .controller("Settings.GuestDetailsController", GuestDetailsController);

GuestDetailsController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "GuestDetailsSettingService"
];

function GuestDetailsController(
  $rootScope,
  $scope,
  $i18next,
  GuestDetailsSettingService
) {
  var self = this;

  angular.extend(this, {
    questions: [],
    loaded: false,
    validate: false,
    types: [
      {
        value: "input",
        label: "Short Text"
      },
      {
        value: "textarea",
        label: "Text Box"
      },
      {
        value: "select",
        label: "Dropdown Menu"
      }
    ],
    addQuestion: addQuestion,
    removeQuestion: removeQuestion,
    save: save
  });

  function init() {
    if ($rootScope.hotel) {
      var guestDetailsSetting = $rootScope.hotel.guestDetailsSetting;
      self.questions =
        guestDetailsSetting && guestDetailsSetting.questions
          ? guestDetailsSetting.questions
          : [];
      self.loaded = true;
    }
  }

  function addQuestion() {
    self.questions.push({
      field: "",
      question: "",
      type: "input",
      options: [],
      showAtReport: false,
      isRequired: false
    });
  }

  function removeQuestion(index) {
    self.questions.splice(index, 1);
  }

  function save() {
    var questions = angular.copy(
      self.questions.filter(function(el) {
        return (
          el.field &&
          el.question &&
          ((el.type === "select" && el.options) || el.type !== "select")
        );
      })
    );
    if (questions.length !== self.questions.length) {
      self.validate = true;
    } else {
      self.validate = false;
      self.loading = true;
      GuestDetailsSettingService.save({
        questions: questions.map(function(el) {
          delete el.$$hashKey;
          return el;
        })
      }).then(
        function(response) {
          self.loading = false;
          $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
        },
        function(error) {
          console.error('Error saving guest details settings:', error);
          self.loading = false;
          $rootScope.notify($i18next.t("general.titles.error"));
        }
      );
    }
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    init();
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module("buuqit")
  .controller("Settings.NewTaxesController", NewTaxesController);

NewTaxesController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "UIDialogService",
  "NewTaxFactory",
  "Globalize"
];

function NewTaxesController(
  $rootScope,
  $scope,
  $i18next,
  UIDialogService,
  NewTaxFactory,
  Globalize
) {
  var self = this;
  this.initialized = false;
  this.taxes = [];
  this.modes = [
    { value: 'tax', display: 'Tax' },
    { value: 'city_tax', display: 'City Tax' },
    { value: 'fee', display: 'Fee' }
  ];
  this.calculationLogics = [
    { value: 'percent', display: 'Percent', exclude: '' },
    { value: 'fixed', display: 'Fixed Amount', exclude: '' },
    {
      value: 'per_person_per_night',
      display: 'Per Person Per Night',
      exclude: 'tax'
    },
    {
      value: 'per_person_per_booking',
      display: 'Per Person Per Booking',
      exclude: 'tax'
    },
    {
      value: 'per_room_per_night',
      display: 'Per Room Per Night',
      exclude: 'tax'
    },
    {
      value: 'per_room_per_booking',
      display: 'Per Room Per Booking',
      exclude: 'tax'
    }
  ];
  this.calculationMethods = [
    { value: 'inclusive', display: 'Inclusive' },
    { value: 'exclusive', display: 'Exclusive' }
  ];

  function initialize() {
    self.loaded = true;
    self.getTaxes();
    self.getAccountingCategories();
    self.initialized = true;
  }

  this.getTaxes = function() {
    self.taxes = $rootScope.hotel.newTaxes;
    self.grouppedTaxes = self.getGrouppedTaxes(self.taxes);
    self.prepareTaxes();
  };

  this.getAccountingCategories = function () {
    self.accountingCategories = $rootScope.hotel.accountingCategories;
  };

  this.getGrouppedTaxes = function(taxes) {
    return _.sortBy(
      Object.values(_.groupBy(taxes, 'group')).map(function(group) {
        return {
          translations: group[0].translations,
          mode: group[0].mode,
          name: group[0].name,
          isRemoved: group.map(function(el) {
            return el.isRemoved;
          }).reduce(function(acc, status) {
            return status && acc;
          }, true),
          position: Math.min.apply(Math, group.map(function(el) {
            return el.position;
          })),
          options: _.sortBy(group, function(tax) {
            return tax.applicableBefore ? new Date(tax.applicableBefore).getTime() : 9999999999999
          }),
          activeTax: self.getActiveTax(group)
        }
      }),
      'position'
    );
  }

  this.getActiveTax = function(group) {
    var nonRemovedTaxes = _.filter(group, function(tax) {
      return !tax.isRemoved
    });

    return nonRemovedTaxes.length > 0 ? nonRemovedTaxes[nonRemovedTaxes.length - 1] : null;
  }

  this.prepareTaxes = function() {
    self.taxes = self.taxes.map(function(tax) {
      tax.applicableAfterDate = new Date(tax.applicableAfter);
      tax.visibleAmountText = self.generateVisibleAmountText(tax);
      tax.applicableText = self.generateApplicableText(tax);
      tax.applicableTextPrefix = $i18next.t('profile_nav.settings.hotel_profile.taxe_new.applicable_text.' + self.generateApplicableTextPrefix(tax));
      Globalize.loadTranslation(tax, 'newTax');

      return tax;
    });
  };

  this.prepareDate = function(tax) {
    if (tax.applyMode === "for future" && !tax.applicableAfterDate) {
      tax.applicableAfterDate = new Date();
    }
    if (tax.applyMode === "for all") {
      delete tax.applicableAfterDate;
    }
    if (
      tax.applicableAfterDate &&
      tax.applicableAfterDate.getFullYear() !== 1970
    ) {
      return moment(tax.applicableAfterDate).format("YYYY-MM-DD");
    } else {
      return null;
    }
  };

  this.generateVisibleAmountText = function(tax) {
    switch (tax.calculationLogic) {
      case "percent":
        return tax.amount + "%";
        break;
      case "fixed":
        return tax.amount + $rootScope.currencySymbol;
        break;
      case "per_person_per_night":
        if (tax.amount == tax.childAmount) {
          return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Person Per Night');
        } else if (!tax.childAmount) {
          return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Adult Per Night');
        } else {
          return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Adult Per Night') + ', ' + tax.childAmount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Children Per Night');
        }
        break;
      case "per_person_per_booking":
        if (tax.amount == tax.childAmount) {
          return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Person Per Booking')
        } else if (!tax.childAmount) {
          return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Adult Per Booking')
        } else {
          return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Adult Per Booking') + ', ' + tax.childAmount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Children Per Booking');
        }
        break;
      case "per_room_per_night":
        return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Room Per Night');
        break;
      case "per_room_per_booking":
        return tax.amount + $rootScope.currencySymbol + ' ' + $i18next.t('general.other.Per Room Per Booking');
        break;
    }
  };

  this.generateApplicableText = function(tax) {
    var value1 = Number(Boolean(tax.applicableAfter));
    var value2 = Number(Boolean(tax.applicableBefore));

    switch (String(value1) + String(value2)) {
      case "00":
        return '';
        break;
      case "01":
        return moment(tax.applicableBefore).format('Do MMM YYYY');
        break;
      case "10":
        return moment(tax.applicableAfter).format('Do MMM YYYY');
        break;
      case "11":
        return moment(tax.applicableAfter).format('Do MMM YYYY') + " To " + moment(tax.applicableBefore).format('Do MMM YYYY');
        break;
      default:
        return '';
        break;
    }
  };

  this.generateApplicableTextPrefix = function(tax) {
    var value1 = Number(Boolean(tax.applicableAfter));
    var value2 = Number(Boolean(tax.applicableBefore));

    switch (String(value1) + String(value2)) {
      case "00":
        return 'Always';
        break;
      case "01":
        return 'Before';
        break;
      case "10":
        return 'After';
        break;
      case "11":
        return 'From';
        break;
      default:
        return 'Always';
        break;
    }
  };

  this.edit = function(tax) {
    self.originalTax = angular.copy(tax);
    if (!tax.applicableAfterDate.getTime) {
      tax.applicableAfterDate = new Date(tax.applicableAfterDate);
    }
    tax.edited = true;
  };

  this.save = function(tax) {
    Globalize.updateCurrentTranslation(tax, 'newTax');

    var method = tax.id ? "save" : "create";
    var index = self.taxes.indexOf(tax);
    var taxObject = new NewTaxFactory(
      Object.assign(tax, {
        hotelId: $rootScope.hotel.id,
        applicableAfter: self.prepareDate(tax),
        newTaxFrom: tax.newTaxFromDate ? moment(tax.newTaxFromDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      })
    );

    tax.saving = true;

    taxObject[method]().then(function(response) {
      response.edited = false;
      if (response[0] && response[1]) {
        self.taxes.push(response[1]);
        self.taxes[index] = response[0];
      } else {
        if (index !== -1) {
          self.taxes[index] = response;
        } else {
          self.taxes.push(response);
          index = self.taxes.length - 1;
        }
      }
      Globalize.loadTranslation(self.taxes[index], 'newTax');
      $rootScope.hotel.newTaxes = self.taxes;
      self.getTaxes();
    }).catch(function(error) {
      console.error('Error saving tax:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      tax.saving = false;
    });
  };

  this.cancelEdit = function(tax) {
    if (tax.id) {
      self.taxes[self.taxes.indexOf(tax)] = angular.copy(self.originalTax);
    } else {
      self.grouppedTaxes = _.without(self.grouppedTaxes, tax);
    }

    $rootScope.hotel.newTaxes = self.taxes;
    self.getTaxes();
  };

  this.remove = function(tax) {
    UIDialogService.open("remove-confirmation", {
      callback: function(removeTotally) {
        var index = self.taxes.indexOf(tax);
        var taxObject = new NewTaxFactory(
          Object.assign(tax, {
            hotelId: $rootScope.hotel.id
          })
        );

        taxObject.remove(removeTotally).then(function(response) {
          self.taxes = _.without(self.taxes, self.taxes[index]);
          $rootScope.hotel.newTaxes = self.taxes;
        }).catch(function(error) {
          console.error('Error removing tax:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });

        UIDialogService.close("remove-confirmation");
      }
    });
  };

  this.addTax = function(taxMode) {
    self.grouppedTaxes.push({
      activeTax: {
        name: "",
        mode: taxMode,
        amount: 0.0,
        childAmount: 0.0,
        calculationLogic: "percent",
        calculationMethod: "inclusive",
        applicableToReservation: true,
        applicableToExtra: true,
        applyMode: "for all",
        edited: true,
        translations: []
      }
    });
  };

  this.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  this.getFilteredCalculationLogics = function(tax) {
    return self.calculationLogics.filter(function(logic) {
      return logic.exclude.indexOf(tax.mode) == -1;
    });
  };

  this.changeCanculationLogic = function(tax) {
    if (tax.calculationLogic != "percent" && tax.calculationLogic != "fixed") {
      tax.applicableToExtra = false;
    }
  }

  this.DropDownCallback = function(grouppedTax) {
    var pos,
        index = self.grouppedTaxes.indexOf(grouppedTax);

    self.grouppedTaxes.splice(index, 1);

    angular.forEach(self.grouppedTaxes, function(el, index) {
      el.position = index;
      el.options.forEach(function(tax) {
        tax.position = index;
      });
      if (el.name == grouppedTax.name) {
        pos = index;
      }
    });

    self.taxes = _.flatten(self.grouppedTaxes.map(function(group) {return group.options}));
    $rootScope.hotel.newTaxes = self.taxes;

    grouppedTax.options.forEach(function(tax) {
      new NewTaxFactory(
        {
          hotelId: $rootScope.hotel.id,
          id: tax.id,
          position: self.taxes.map(function(el) {
            return [el.id, el.position];
          })
        }
      ).move();
    });
  }

  if ($rootScope.hotel) {
    initialize();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel) {
      initialize();
    }
  });

  this.changeLang = function(old_locale) {
    self.taxes.forEach(function(tax) {
      Globalize.saveTranslation(tax, 'newTax', old_locale);
      Globalize.loadTranslation(tax, 'newTax');
    })
  }
  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module("buuqit")
  .controller(
    "Settings.PosProfilesController",
    PosProfilesController
  );

PosProfilesController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "PosProfilesFactory",
];

function PosProfilesController(
  $rootScope,
  $scope,
  $i18next,
  PosProfilesFactory
) {
  var self = this;
  angular.extend(self, {
    initialized: false,
    loading: false,
    posTypes: [
      {'id': 'lightspeed', 'name': 'LightSpeed'},
      {'id': 'epos', 'name': 'Other POS'}
    ],
    init: init,
    createFormVisible: false,
    editedPosProfile: null,
    newPosProfile: {
      type: '',
      enabled: true,
      data: {}
    },
    openCreateForm: openCreateForm,
    alterPosTypeName: alterPosTypeName,
    openEditForm: openEditForm,
    saveForm: saveForm,
    removeProfile: removeProfile,
    originalPosProfile: null,
    closeForm: closeForm,
    autoConfigure: autoConfigure
  });

  function init() {
    angular.extend($scope, {
      hotel: $rootScope.hotel,
      availablePosTypes: getAvailablePosTypes()
    });
  }

  function getAvailablePosTypes() {
    return self.posTypes.filter(function(posType) {
        return $rootScope.hotel.posProfiles.filter(function(posProfile) {
          return posProfile.posType == posType.id;
        }).length == 0;
      });
  }

  if ($rootScope.hotel) {
    this.init();
  }

  function openCreateForm () {
    angular.copy(self.newPosProfile, self.originalPosProfile);
    self.editedPosProfile = null;
    self.createFormVisible = true;
  }

  function alterPosTypeName (profileType) {
    if (profileType === 'epos') {
      return 'Other POS'
    }
    return profileType
  }

  function openEditForm (profile) {
    angular.element('.tooltip').hide();
    var index = $rootScope.hotel.posProfiles.indexOf(profile);
    self.originalPosProfile = angular.copy(profile);
    self.editedPosProfile   = index;
    self.createFormVisible = false;
    profile.edited = true;
  }

  function saveForm(profile){
    if (profile.id) {
      updateProfile(profile);
    } else {
      createProfile(profile);
    };
  };

  function createProfile (model) {
    model.hotelId = $rootScope.hotel.id;
    model.loading = true;
    new PosProfilesFactory(model).create().then(function (data) {
      data.loading = false;
      $rootScope.hotel.posProfiles.push(data);
      closeForm();
      openEditForm(data);
      $scope.availablePosTypes = getAvailablePosTypes();
      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }, function(error) {
      console.error('Error creating profile:', error);
      model.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function updateProfile (model) {
    model.hotelId = $rootScope.hotel.id;
    model.loading = true;
    new PosProfilesFactory(model).update().then(function (data) {
      data.loading = false;
      var profileIndex = $rootScope.hotel.posProfiles.indexOf(model);
      if (self.editedPosProfile == profileIndex) {
        angular.copy(data, self.originalPosProfile);
      }
      angular.copy(data, $rootScope.hotel.posProfiles[profileIndex]);
      $scope.availablePosTypes = getAvailablePosTypes();
      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }, function(error) {
      console.error('Error updating profile:', error);
      model.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function autoConfigure (model) {
    model.loading = true;
    var res = new PosProfilesFactory(model);
    res.$post(res.$url('install'))
      .then(function(resource) {
        if (resource.error) {
          $rootScope.alert(resource.error);
        } else {
          if (resource.url !== undefined) {
            window.location = resource.url;
          } else {
            $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
            var profileIndex = $rootScope.hotel.posProfiles.indexOf(model);
            if (self.editedPosProfile == profileIndex) {
              angular.copy(resource, self.originalPosProfile);
            }
            angular.copy(resource, $rootScope.hotel.posProfiles[profileIndex]);
          }
        }
        model.loading = false;
      }, function(error) {
        console.error('Error auto configuring:', error);
        model.loading = false;
        $rootScope.alert('Something went wrong, try again later.');
      });
  }


  function removeProfile(model){
    model.loading = true;
    new PosProfilesFactory(model).remove().then(function (data) {
      $rootScope.hotel.posProfiles.splice($rootScope.hotel.posProfiles.indexOf(model), 1);
      $scope.availablePosTypes = getAvailablePosTypes();
    }, function(data) {
      console.error('Error removing profile:', data);
      model.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });

  };

  function closeForm () {
    if (self.editedPosProfile === null) {
      angular.copy(self.originalPosProfile, self.newPosProfile);
    } else {
      $rootScope.hotel.posProfiles[self.editedPosProfile] = angular.copy(self.originalPosProfile);
    }

    self.editedPosProfile = null;
    self.createFormVisible = false;
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    angular.element('.tooltip').remove();
  });
}

angular
  .module("buuqit")
  .controller(
    "Settings.PaymentTypesController",
    PaymentTypesController
  );

  PaymentTypesController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "PaymentTypeFactory"
];

function RemovePaymentTypeCtrl($rootScope, $scope, $mdDialog, local) {
  var paymentTypes = [
    {"id": "Cash", "name": "Cash"},
    {"id": "Cheque", "name": "Cheque"},
    {"id": "Bank Transfer", "name": "Bank Transfer"},
    {"id": "Voucher", "name": "Voucher"},
    {"id": "Credit Card", "name": "Credit Card"},
    {"id": "Debit Card", "name": "Debit Card"},
    {"id": "Other", "name": "Other"}
  ];

  angular.extend($scope, {
    paymentTypes: _.union(_.without(local.paymentTypes, local.paymentType), paymentTypes),
    paymentType: local.paymentType,
    choosedPT: 'Other',
    cancel: cancel,
    remove: remove
  });

  function cancel(){
    $mdDialog.hide();
  }

  function remove() {
    local.remove($scope.choosedPT);
    cancel();
  }
}

function PaymentTypesController(
  $rootScope,
  $scope,
  $i18next,
  $mdDialog,
  PaymentTypeFactory
) {
  var self = this;

  angular.extend(self, {
    initialized: false,
    loading: false,
    addFormIsVisible: false,
    paymentTypeTemplate: {
      name: null,
      description: null,
      sendToBookkeeping: true,
      sendReceiptToBookkeeping: true
    },
    newPaymentType: null,
    paymentTypes: [],
    confirmation: null,

    init: init,
    save: save,
    cancel: cancel,
    create: create,
    add: add,
    cancelAdd: cancelAdd,
    edit: edit,
    remove: remove,
    changeLang: changeLang,
  });

  function init() {
    self.paymentTypes = _.union(
      $rootScope.hotel.systemPaymentTypes,
      $rootScope.hotel.customPaymentTypes
    );

    self.initialized = true;
    self.confirmation = $mdDialog
      .confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('profile_nav.settings.hotel_profile.id_types.add_new_ID_type'))
      .ok($i18next.t('general.confirm.ok'))
      .cancel($i18next.t('general.confirm.cancel'));
  }

  function save(paymentType) {
    var systemPaymentTypeIndex = $rootScope.hotel.systemPaymentTypes.indexOf(paymentType);
    var customPaymentTypeIndex = $rootScope.hotel.customPaymentTypes.indexOf(paymentType);

    paymentType.loading = true;
    paymentType
      .save()
      .then(
        function (response) {
          response.loading = false;
          response.edited = false;

          if (systemPaymentTypeIndex !== -1) {
            response.isSystem = true;
            $rootScope.hotel.systemPaymentTypes[systemPaymentTypeIndex] = response;
          }

          if (customPaymentTypeIndex !== -1) {
            $rootScope.hotel.customPaymentTypes[customPaymentTypeIndex] = response;
          }
        },
        function (response) {
          console.error('Error saving payment type:', response);
          paymentType.loading = false;
          if (response.data && response.data.errors && response.data.errors.name) {
            $rootScope.alert($i18next.t('general.alert_modals.already_exists', {name: paymentType.name, type: 'name'}));
          } else {
            $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
          }
        }
      )
  }

  function cancel(paymentType) {
    var systemPaymentTypeIndex = $rootScope.hotel.systemPaymentTypes.indexOf(paymentType);
    var customPaymentTypeIndex = $rootScope.hotel.customPaymentTypes.indexOf(paymentType);

    if (systemPaymentTypeIndex !== -1) {
      $rootScope.hotel.systemPaymentTypes[systemPaymentTypeIndex] = angular.copy(self.originalPaymentType);
    }

    if (customPaymentTypeIndex !== -1) {
      $rootScope.hotel.customPaymentTypes[customPaymentTypeIndex] = angular.copy(self.originalPaymentType);
    }

    paymentType.edited = false;
    paymentType.loading = false;
  }

  function create(paymentType) {
    var newPaymentType = new PaymentTypeFactory(paymentType);

    newPaymentType.hotelId = $rootScope.hotel.id;
    paymentType.loading = true;

    newPaymentType
      .save()
      .then(
        function(response) {
          self.cancelAdd();

          $rootScope.hotel.customPaymentTypes = _.union(
            $rootScope.hotel.customPaymentTypes,
            [response]
          );

          self.paymentTypes = _.union(
            $rootScope.hotel.systemPaymentTypes,
            $rootScope.hotel.customPaymentTypes
          );
        },
        function(response) {
          newPaymentType.loading = false;
          if (response.data && response.data.errors && response.data.errors.name) {
            $rootScope.alert($i18next.t('general.alert_modals.already_exists', {name: newPaymentType.name, type: 'name'}));
          } else {
            console.error('Error creating payment type:', response);
            $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
          }
        }
      );
  }

  function add() {
    self.paymentTypes.forEach(function(pt) { if (pt.edited) cancel(pt); });
    self.newPaymentType = angular.copy(self.paymentTypeTemplate);
    self.addFormIsVisible = true;
  }

  function cancelAdd() {
    self.newPaymentType = null;
    self.addFormIsVisible = false;
  }

  function changeLang(old_locale) {
    var paymentTypes = self.paymentTypes;
    if (self.addFormIsVisible) {
      paymentTypes = paymentTypes.concat([self.newPaymentType]);
    }
  }

  function edit(paymentType) {
    self.paymentTypes.forEach(function(pt) { if (pt.edited) cancel(pt); });
    self.originalPaymentType = angular.copy(paymentType);
    paymentType.edited = true;
  }

  function remove(paymentType) {
    $mdDialog
      .show({
        controller: RemovePaymentTypeCtrl,
        templateUrl: getTemplatePath('modals/removePaymentType.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $rootScope,
            paymentTypes: self.paymentTypes,
            paymentType: paymentType,
            remove: function(replaceWith) {
              paymentType.loading = true;
              paymentType.remove(replaceWith).then(function(data) {
                if (data.success === false) {
                  console.error('Error removing payment type:', data);
                  paymentType.loading = false;
                  $rootScope.alert(data.msg || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
                } else {
                  $rootScope.hotel.customPaymentTypes = _.without($rootScope.hotel.customPaymentTypes, paymentType);
                  self.paymentTypes = _.union(
                    $rootScope.hotel.systemPaymentTypes,
                    $rootScope.hotel.customPaymentTypes
                  );
                }
              });
            }
          }
        }
      });
  }

  if ($rootScope.hotel) {
    this.init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });
  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.PaymentTerminals', PaymentTerminals)
  .component('reactPaymentTerminals', window.TBFLibs.react2angular(
    window.TBFLibs.PaymentTerminals,[
    'terminals',
    'currencyProfiles',
    'onSave',
    'onDelete',
    'onPair',
  ], [
    '$i18next'
  ]));;

  PaymentTerminals.$inject = ["$rootScope", "$scope", "$http", "TerminalsFactory", "$i18next"];

function PaymentTerminals ($rootScope, $scope, $http, TerminalsFactory, $i18next) {
  var ctrl = this;

  angular.extend(
    this,
    {
      loaded   : false,
      terminals : [],
      onSave: onSave,
      onDelete: onDelete,
      onPair: onPair,
    }
  );


  function init () {
    if ($rootScope.hotel) {
      ctrl.currencyProfiles = $rootScope.hotel.currencyProfiles;
      getTerminals();
    }
  }

  function getTerminals () {
    ctrl.loaded = false;
    TerminalsFactory.getTerminals().then(function(response) {
      ctrl.terminals = _snakeToCamel(response.data.payment_terminals);
      ctrl.loaded = true;      
    }).catch(function(error) {
      console.error('Error fetching terminals:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      ctrl.loaded = true;
    });
  }

  function onSave(terminal) {
    var method;
    var data = _camelToSnake({paymentTerminal: terminal});
    if (terminal.id) {
      method = TerminalsFactory.updateTerminal;
    } else {
      method = TerminalsFactory.createTerminal;
    }
    return method(data).then(function(response) {
      getTerminals();
      return response;
    }).catch(function(error) {
      console.error('Error saving terminal:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  function onDelete(terminal) {
    return TerminalsFactory.deleteTerminal(terminal).then(function(response) {
      getTerminals();
      return response;
    }).catch(function(error) {
      console.error('Error deleting terminal:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  function onPair(terminal) {
    return TerminalsFactory.pairTerminal(terminal).then(function(response) {
      getTerminals();
      return response;
    }).catch(function(error) {
      console.error('Error pairing terminal:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  // Function to convert object attributes from camel case to snake case
  function _camelToSnake(input) {
    if (Array.isArray(input)) {
      return input.map(function(obj) {
        return _camelToSnake(obj);
      });
    } else if (typeof input === 'object' && input !== null) {
      var snakeObj = {};
      for (var key in input) {
        if (input.hasOwnProperty(key)) {
          var snakeKey = key.replace(/[A-Z]/g, function(letter) {
            return '_' + letter.toLowerCase();
          });
          snakeObj[snakeKey] = _camelToSnake(input[key]);
        }
      }
      return snakeObj;
    } else {
      return input;
    }
  }
  // Function to convert object attributes from snake case to camel case
  function _snakeToCamel(input) {
    if (Array.isArray(input)) {
      return input.map(function(obj) {
        return _snakeToCamel(obj);
      });
    } else if (typeof input === 'object' && input !== null) {
      var camelObj = {};
      for (var key in input) {
        if (input.hasOwnProperty(key)) {
          var camelKey = key.replace(/_([a-z])/g, function(match, letter) {
            return letter.toUpperCase();
          });
          camelObj[camelKey] = _snakeToCamel(input[key]);
        }
      }
      return camelObj;
    } else {
      return input;
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.PaymentGateways', PaymentGateways);

PaymentGateways.$inject = ["$rootScope", "$scope", "$http", "$i18next", "ProvidersFactory"];

function PaymentGateways ($rootScope, $scope, $http, $i18next, ProvidersFactory) {
  var self = this;

  angular.extend(
    this,
    {
      loaded   : false,
      gateways : [],
      originalEditedGateway : {},

      openEditForm: openEditForm,
      removeGateway: removeGateway,
      cancelEditing: cancelEditing,
      saveEditing: saveEditing,
      openMenu: openMenu,
      addProvider: addProvider,
      updateTokens: updateTokens,
      __applyReadableName: __applyReadableName,
      dropins: dropins,
      insertDropIn: insertDropIn,
      goToStripe: goToStripe,
      goToStripeSca: goToStripeSca,
      switchToListView: switchToListView
    }
  );


  function init () {
    if ($rootScope.hotel) {
      this.loaded = false;
      self.africaCluster = $rootScope.domain_settings.isSinazo;
      self.wirecardName = $rootScope.domain_settings.wirecardName;

      ProvidersFactory
        .query({}, {hotelId: $rootScope.hotel.id})
        .then(function(response) {
          self.gateways = response.map(self.__applyReadableName).filter(function(gateway) {return !gateway.isRemoved});
          self.defaultGatewayName = getDefaultGatewayName();
          self.loaded = true;


          self.show_stripe_connect = (
            (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) !== -1)
            && self.gateways.length === 1
            && self.gateways[0].name === "wubook"
          );

          self.show_stripe_connected = (
            (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) !== -1)
            && self.gateways.length === 2
            && (self.gateways.map(function(el) {return el.name}).indexOf("wubook") !== -1)
            && ((self.gateways.filter(function(el) {return el.name === "stripe" || el.name == 'stripe_sca'})[0] || {details: {mode: ''}}).details.mode === "partner")
          );
        }).catch(function (error) {
          console.error('Error fetching payment gateways:', error);
          self.loaded = true;
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
    }
  }


  function getDefaultGatewayName() {
    var defaultGateway = self.gateways.find(function (g) { return g.isDefault });
    if (defaultGateway && defaultGateway.name) {
      return defaultGateway.name;
    }
    return '';
  }


  function openEditForm (index) {
    self.editedGateway = index;
    if ((self.gateways[self.editedGateway].name === 'stripe' || self.gateways[self.editedGateway].name === 'stripe_sca') && typeof(self.gateways[self.editedGateway].details.passAddressInfo) === "undefined") {
      self.gateways[self.editedGateway].details.passAddressInfo = true;
    }
    self.originalEditedGateway = angular.copy(self.gateways[self.editedGateway]);
  }


  function removeGateway (index) {
    var gateway = self.gateways[index];
    gateway.hotelId = $rootScope.hotel.id;
    gateway
      .remove()
      .then(function (response) {
        if (response.success) {
          self.gateways = _.without(self.gateways, self.gateways[index]);
        } else {
          $rootScope.alert(response.msg);
        }
      }).catch(function(error) {
        console.error('Error removing gateway:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function cancelEditing () {
    if (self.gateways[self.editedGateway].id) {
      cancelEditingSavedGateway();
    } else {
      cancelEditingUnsavedGateway();
    }
  }


  function cancelEditingSavedGateway () {
    self.gateways[self.editedGateway] = angular.copy(self.originalEditedGateway);
    self.originalEditedGateway = {};
    self.editedGateway = null;
  }


  function cancelEditingUnsavedGateway () {
    self.gateways.pop();
    self.originalEditedGateway = {};
    self.editedGateway = null;
  }


  function saveEditing () {
    if (self.gateways[self.editedGateway].id) {
      update();
    } else {
      create();
    }
  }


  function update () {
    var gateway = self.gateways[self.editedGateway];
    gateway.details = JSON.stringify(gateway.details);
    gateway.hotelId = $rootScope.hotel.id;
    gateway
      .update()
      .then(function(response) {
        if (response.isDefault) {
          self.defaultGatewayName = response.name;
        }
        self.gateways[self.editedGateway] = self.__applyReadableName(response);
        self.editedGateway = null;
        self.originalEditedGateway = {};
        if (response.isDefault) { normalizeDefault(response.id); }
        self.updateTokens();
      }).catch(function(error) {
        console.error('Error updating gateway:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function create () {
    var gateway = new ProvidersFactory(self.gateways[self.editedGateway]);
    gateway.details = JSON.stringify(gateway.details);
    gateway.hotelId = $rootScope.hotel.id;
    gateway
      .create()
      .then(function (response) {
        if (response.id) {
          self.gateways[self.editedGateway] = self.__applyReadableName(response);
          self.editedGateway = null;
          self.originalEditedGateway = {};
          if (response.isDefault) { normalizeDefault(response.id); }
          self.updateTokens();
        }
      }).catch(function(error) {
        console.error('Error creating gateway:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function openMenu ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  }


  function addProvider (provider_name) {
    self.gateways.push({
      name: provider_name,
      readableName: __getReadableName(provider_name),
      details: {}
    });

    if (provider_name == 'wirecard') {
      self.gateways[self.gateways.length - 1].details['ibeAllowFailed'] = true;
    }
    self.openEditForm(self.gateways.length - 1);
  }


  function normalizeDefault(id) {
    self.gateways.forEach(function (el) {
      if (el.isDefault && el.id != id) {
        el.isDefault = false;
      }
    })
  }


  function updateTokens() {
    $rootScope.hotel
      .update_tokens()
      .then(function(response) {
        $rootScope.hotel.clientToken = response.data.client_token;
        $rootScope.hotel.paymentGateway = response.data.payment_gateway;
      }).catch(function(error) {
        console.error('Error updating hotel tokens:', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function __getReadableName(name) {
    var names = {
      'wubook' : 'ChannexPCI',
      'stripe' : 'Stripe',
      'stripe_sca' : 'Stripe SCA',
      'omise' : 'Omise',
      'braintree' : 'Braintree',
      'worldpay' : 'WorldPay',
      'payment_express' : 'WindCave',
      'valitor' : 'Valitor',
      'valitor_pay' : 'ValitorPay',
      'wirecard' : self.wirecardName,
      'borgun': 'Borgun'
    }

    return names[name];
  }


  function __applyReadableName(provider) {
    provider['readableName'] = __getReadableName(provider['name']);
    return provider;
  }

  function insertDropIn(editor, dropin) {
    var element = angular.element('[data-role="'+editor+'"]')[0];
    text = dropin || '';
    if (document.selection) {
      // IE
      element.focus();
      var sel = document.selection.createRange();
      sel.text = text;
    } else if (element.selectionStart || element.selectionStart === 0) {
      // Others
      var startPos = element.selectionStart;
      var endPos = element.selectionEnd;
      element.value = element.value.substring(0, startPos) +
        text +
        element.value.substring(endPos, element.value.length);
      element.selectionStart = startPos + text.length;
      element.selectionEnd = startPos + text.length;
    } else {
      element.value += text;
    }
    element.dispatchEvent(new Event('change'));
  }

  function goToStripe() {
    $http.post(
      SERVER_PATH + "/api/v1/stripe/link",
      {
        hotel_id: $rootScope.hotel.id,
        location: window.location.href
      }
    ).then(function(response) {
      window.location.href = response.data.url;
    }).catch(function(error) {
      console.error('Error while trying to go to Stripe:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function goToStripeSca() {
    $http.post(
      SERVER_PATH + "/api/v1/stripe/link",
      {
        hotel_id: $rootScope.hotel.id,
        provider: "stripe_sca",
        location: window.location.href
      }
    ).then(function(response) {
      window.location.href = response.data.url;
    }).catch(function(error) {
      console.error('Error fetching Stripe SCA link:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function switchToListView() {
    this.show_stripe_connect = false;
    this.show_stripe_connected = false;
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module("buuqit")
  .controller(
    "Settings.InvoiceNumberSettingsController",
    InvoiceNumberSettingsController
  );

  InvoiceNumberSettingsController.$inject = [
  "$rootScope",
  "$scope",
  "$timeout",
  "$i18next",
  "$http",
  "Globalize"
];

function InvoiceNumberSettingsController(
  $rootScope,
  $scope,
  $timeout,
  $i18next,
  $http,
  Globalize
) {
  var self = this;

  angular.extend(self, {
    initialized: false,
    loading: false,
    loadingHotel: false,
    invoiceNumberSettings: {},
    countries : countries,
    invoiceSettings : {
      default_notes: '',
      logo: '',
      text: ''
    },
    use_text_instead_logo : false,
    timeoutPromise: null,

    init: init,
    save: save,
    saveHotel: saveHotel,
    updateNextInvoiceNumber: updateNextInvoiceNumber,
    saveStatementSetting: saveStatementSetting,
    choosePhotoFile : choosePhotoFile,
    saveLogo : saveLogo,
    changeLang: changeLang
  });

  function init() {
    self.initialized = true;
    self.hotel = $rootScope.hotel;
    self.invoiceNumberSettings = $rootScope.hotel.invoiceNumberSettings;
    fillSettingsIfNeeded();
    self.invoiceNumberSettings.formResetDate = new Date(self.invoiceNumberSettings.resetDate);
    self.nextInvoiceNumber = generateNextInvoiceNumber();
    self.statementSettings = {
      reminder: $rootScope.hotel.addons["statementReminder"],
      terms: $rootScope.hotel.addons["statementTerms"]
    }

    Globalize.loadTranslation($rootScope.hotel, 'hotel');
    self.invoiceSettings = {
      default_notes: $rootScope.hotel.invoiceDefaultNotes,
      logo: $rootScope.hotel.invoiceLogo,
      text: $rootScope.hotel.invoiceText
    }

    self.fileread = $rootScope.hotel.invoiceLogo;

    if (self.invoiceSettings.text) {
      self.use_text_instead_logo = true;
    } else {
      self.invoiceSettings.text = $rootScope.hotel.name;
    }
  }

  function save() {
    self.loading = true;
    self.invoiceNumberSettings.resetDate = moment(self.invoiceNumberSettings.formResetDate).format('YYYY-MM-DD');
    self.invoiceNumberSettings
      .save()
      .then(
        function(response) {
          self.loading = false;
          $rootScope.hotel.invoiceNumberSettings = response;
        },
        function(response) {
          console.log(response);
        }
      );
  }

  function updateNextInvoiceNumber() {
    self.nextInvoiceNumber = generateNextInvoiceNumber();
  }

  function fillSettingsIfNeeded() {
    if (self.invoiceNumberSettings.startValue === null) {
      self.invoiceNumberSettings.startValue = 0;
      self.invoiceNumberSettings.lastValue = 0;
      self.invoiceNumberSettings.length = getBestLength();
      self.invoiceNumberSettings.maxValue = getBestMaxValue(self.invoiceNumberSettings.length);
      self.invoiceNumberSettings.incrementStep = 1;
      self.invoiceNumberSettings.prefix = 'INV-';
      self.invoiceNumberSettings.postfix = '-%MM%%YY%';
      self.invoiceNumberSettings.resetDate = getResetDate();
    }
  }

  function generateNextInvoiceNumber() {
    return [
      self.invoiceNumberSettings.prefix,
      getNextNumber(
        self.invoiceNumberSettings.lastValue,
        self.invoiceNumberSettings.incrementStep,
        self.invoiceNumberSettings.length,
        self.invoiceNumberSettings.maxValue
      ),
      getRenderedPostfix(self.invoiceNumberSettings.postfix)
    ].join('');
  }

  function getBestLength() {
    return String($rootScope.hotel.rooms.length * 3 * 365).length;
  }

  function getBestMaxValue(length) {
    return Number(new Array(length).fill(9).join(''))
  }

  function getResetDate() {
    var date = new Date();
    return [date.getFullYear() + 1, '01', '01'].join('-');
  }

  function getNextNumber(number, increment, length, maxValue) {
    if (typeof(number) != 'number') { number = 0; }

    var nextNumber = String(Number(number) + increment);

    if (Number(nextNumber) > maxValue) {
      nextNumber = '1';
    }

    return __leftPad(nextNumber, length, '0');
  }

  function __leftPad(value, length, symbol) {
    value = String(value);

    var additionalLength = length - value.length > 0 ? length - value.length : 0;

    return new Array(additionalLength).fill(symbol).join('') + value;
  }

  function getRenderedPostfix(template) {
    return template
      .replace(/%MM%/gi, __leftPad((new Date().getMonth()), 2, '0'))
      .replace(/%YY%/gi, String((new Date().getFullYear())).substring(2,4))
      .replace(/%YYYY%/gi, (new Date().getFullYear()));
  }

  function saveHotel() {
    self.loadingHotel = true;
    self.hotel
      .save()
      .then(function (data) {
        $rootScope.hotel = data;
        self.loadingHotel = false;

        $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
        Globalize.loadTranslation(self.hotel, 'hotel');
      }, function (response) {
        self.loaded = false;
        $rootScope.notify($i18next.t('general.titles.error') + ': ' + response.data.error);
      });
  }

  function saveStatementSetting() {
    self.hotel.addons["statement_reminder"] = self.statementSettings.reminder;
    self.hotel.addons["statement_terms"] = self.statementSettings.terms;
    self.hotel.addons_json = JSON.stringify(self.hotel.addons);
    saveHotel();
  }

  if ($rootScope.hotel) {
    this.init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });

  function choosePhotoFile (input_object) {
    var reader = new FileReader();

    reader.onload = function (loadEvent) {
      if (self.timeoutPromise) {
        $timeout.cancel(self.timeoutPromise);
      }
      self.timeoutPromise = $timeout(function () {
        self.fileread = loadEvent.target.result;
        self.new_logo_uploaded = true;
      }, 0);
    }
    reader.onerror = function (error) {
      console.error('Error reading file', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    }
    if (input_object.files.length > 0) {
      self.invoiceSettings.logo = input_object.files[0];
      reader.readAsDataURL(input_object.files[0]);
    }
  }


  function saveLogo () {
    if (self.loadingHotel) {
      return;
    }

    $rootScope.hotel.invoiceText = self.invoiceSettings.text;
    $rootScope.hotel.invoiceDefaultNotes = self.invoiceSettings.default_notes;
    Globalize.updateCurrentTranslation($rootScope.hotel, 'hotel');

    var form_data = new FormData();
    if (self.new_logo_uploaded) { form_data.append("invoice_logo", self.invoiceSettings.logo); }

    var data = $rootScope.hotel.translations.map(function(t) {
      return {
        'locale': t['locale'],
        'invoice_text': self.use_text_instead_logo ? t['invoiceText'] : '',
        'invoice_default_notes': t['invoiceDefaultNotes']
      }
    })
    form_data.append("invoice_params", JSON.stringify(data));

    self.loadingHotel = true;

    $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/upload_invoice_logo', form_data, {
      headers: {'Content-Type': undefined },
      transformRequest: angular.identity
    }).success(function(response) {
      $rootScope.hotel.invoiceLogo = response.hotel.invoice_logo;
      $rootScope.hotel.default_notes = response.hotel.default_notes;
      $rootScope.hotel.text = response.hotel.text;

      self.invoiceSettings = {
        default_notes: $rootScope.hotel.invoiceDefaultNotes,
        logo: $rootScope.hotel.invoiceLogo,
        text: $rootScope.hotel.invoiceText
      }
      self.fileread = response.hotel.invoice_logo;
      self.new_logo_uploaded = false;
    }).error(function(response) {
      console.error('Error uploading invoice logo', response);
      var message = '';
      if (response.data.error.invoice_logo_content_type) {
        message = $i18next.t('profile_nav.settings.other.invoice.message.wrong_file_type_please_use_jpeg_or_png_image_js_str');
      }
      $rootScope.alert(message, $i18next.t('general.titles.error'));
    }).finally(function () {
      self.loadingHotel = false;
    });
  }


  function changeLang(old_lang) {
    if ($rootScope.hotel === undefined) {
      return;
    }
    $rootScope.hotel.invoiceText = self.invoiceSettings.text;
    $rootScope.hotel.invoiceDefaultNotes = self.invoiceSettings.default_notes;
    Globalize.saveTranslation($rootScope.hotel, 'hotel', old_lang);
    Globalize.loadTranslation($rootScope.hotel, 'hotel');
    self.invoiceSettings.text = $rootScope.hotel.invoiceText;
    self.invoiceSettings.default_notes = $rootScope.hotel.invoiceDefaultNotes;
  }

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.timeoutPromise) {
      $timeout.cancel(self.timeoutPromise);
    }
  });
}

angular
  .module("buuqit")
  .controller(
    "Settings.CurrencyProfilesController",
    CurrencyProfilesController
  );

CurrencyProfilesController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "CurrencyProfiles",
  "CurrencyRate"
];

function CurrencyProfilesController(
  $rootScope,
  $scope,
  $i18next,
  $mdDialog,
  CurrencyProfiles,
  CurrencyRate
) {
  var self = this;

  angular.extend(self, {
    initialized: false,
    confirmation: $mdDialog
      .confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel')),
    currencyProfiles: CurrencyProfiles,
    createFormIsVisible: false,
    editedCurrencyProfile: null,
    currencyProfile: {
      code: null,
      isExchangeRate: true,
      exchangeRate: 0
    },
    baseCurrency: null,
    currencies: currencies,
    originalCurrencyProfile: null,

    init: init,
    openEditForm: openEditForm,
    closeEditForm: closeEditForm,
    removeCurrencyProfile: removeCurrencyProfile,
    openCreateForm: openCreateForm,
    closeCreateForm: closeCreateForm,
    createCurrencyProfile: createCurrencyProfile,
    currencyIsChanged: currencyIsChanged,
    saveCurrencyProfile: saveCurrencyProfile
  });

  function init() {
    self.initialized = true;
    CurrencyProfiles.load().then(function(currencyProfiles) {
      self.baseCurrency = CurrencyProfiles.list.filter(function(
        currencyProfile
      ) {
        return currencyProfile.isDefault == true;
      })[0].code;
    }).catch(function(error) {
      console.error('Error loading currency profiles:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function openEditForm(currencyProfile) {
    self.originalCurrencyProfile = angular.copy(currencyProfile);
    currencyProfile.saving = false;
    if (currencyProfile.isExchangeRate === true) {
      loadExchangeRate(currencyProfile);
    }
    self.editedCurrencyProfile = currencyProfile.id;
  }

  function closeEditForm(currencyProfile) {
    self.editedCurrencyProfile = null;
    CurrencyProfiles.reload(currencyProfile).catch(function(error) {
      console.error('Error reloading currency profile:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function saveCurrencyProfile(currencyProfile) {
    currencyProfile.saving = true;
    CurrencyProfiles.update(currencyProfile).then(function() {
      self.editedCurrencyProfile = null;
    }).catch(function(error) {
      console.error('Error saving currency profile:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function removeCurrencyProfile(currencyProfile) {
    $mdDialog.show(self.confirmation).then(
      function() {
        CurrencyProfiles.remove(currencyProfile).catch(function(error) {
          console.error('Error removing currency profile:', error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      },
      function() {}
    );
  }

  function openCreateForm() {
    self.createFormIsVisible = true;
  }

  function closeCreateForm() {
    self.currencyProfile = {
      code: null,
      isExchangeRate: true,
      exchangeRate: 0
    };
    self.createFormIsVisible = false;
  }

  function createCurrencyProfile() {
    CurrencyProfiles.create(self.currencyProfile).then(function(data) {
      closeCreateForm();
    }).catch(function(error) {
      console.error('Error creating currency profile:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function loadExchangeRate(currencyProfile) {
    CurrencyRate.convert(self.baseCurrency, currencyProfile.code).then(function(
      rate
    ) {
      currencyProfile.exchangeRate = rate;
    });
  }

  function currencyIsChanged(currencyProfile) {
    loadExchangeRate(currencyProfile);
  }

  if ($rootScope.hotel) {
    this.init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && self.initialized === false) {
      self.init();
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.BookkeepingSystems', BookkeepingSystems);

BookkeepingSystems.$inject = ["$rootScope", "$scope", "$i18next", "BookkeepingsFactory"];

function BookkeepingSystems ($rootScope, $scope, $i18next, BookkeepingsFactory) {
  var self = this;

  angular.extend(
    this,
    {
      loaded   : false,
      formOpen : false,
      bookkeepings : [],
      originalEditedBookkeeping : {},
      openEditForm: openEditForm,
      removeBookkeeping: removeBookkeeping,
      downloadPaymentTypes: downloadPaymentTypes,
      cancelEditing: cancelEditing,
      saveEditing: saveEditing,
      openMenu: openMenu,
      addBookkeeping: addBookkeeping,
      __applyReadableName: __applyReadableName,
      dropins: dropins,
      insertDropIn: insertDropIn
    }
  );

  function init () {
    if ($rootScope.hotel) {
      this.loaded = false;
      this.formOpen = false;

      BookkeepingsFactory
        .query({}, {hotelId: $rootScope.hotel.id})
        .then(function(response) {
          self.bookkeepings = response.map(self.__applyReadableName);
          self.loaded = true;
        });
    }
  }

  function openEditForm (index) {
    if (self.formOpen) {cancelEditing()}
    self.formOpen = true;
    self.editedBookkeeping = index;
    self.originalEditedBookkeeping = angular.copy(self.bookkeepings[self.editedBookkeeping]);
  }

  function removeBookkeeping (index) {
    var bookkeeping = self.bookkeepings[index];
    bookkeeping.hotelId = $rootScope.hotel.id;
    bookkeeping
      .remove()
      .then(function (response) {
        if (response.success) {
          self.bookkeepings = _.without(self.bookkeepings, self.bookkeepings[index]);
        } else {
          $rootScope.alert(response.msg);
        }
      });
  }

  function cancelEditing () {
    self.formOpen = false;
    if (self.bookkeepings[self.editedBookkeeping].id) {
      cancelEditingSavedBookkeeping();
    } else {
      cancelEditingUnsavedBookkeeping();
    }
  }


  function cancelEditingSavedBookkeeping () {
    self.bookkeepings[self.editedBookkeeping] = angular.copy(self.originalEditedBookkeeping);
    self.originalEditedBookkeeping = {};
    self.editedBookkeeping = null;
  }


  function cancelEditingUnsavedBookkeeping () {
    self.bookkeepings.pop();
    self.originalEditedBookkeeping = {};
    self.editedBookkeeping = null;
  }


  function saveEditing () {
    if (self.bookkeepings[self.editedBookkeeping].id) {
      update();
    } else {
      create();
    }
  }


  function update () {
    var bookkeeping = self.bookkeepings[self.editedBookkeeping];
    bookkeeping.details = JSON.stringify(bookkeeping.details);
    bookkeeping.hotelId = $rootScope.hotel.id;
    bookkeeping
      .update()
      .then(function(response) {
        self.bookkeepings[self.editedBookkeeping] = self.__applyReadableName(response);
        self.editedBookkeeping = null;
        self.originalEditedBookkeeping = {};
        self.formOpen = false;
      }).catch(function (error) {
        console.error('Error updating bookkeeping:', error);
        self.formOpen = false;
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }


  function create () {
    var bookkeeping = new BookkeepingsFactory(self.bookkeepings[self.editedBookkeeping]);
    bookkeeping.details = JSON.stringify(bookkeeping.details);
    bookkeeping.hotelId = $rootScope.hotel.id;
    bookkeeping
      .create()
      .then(function (response) {
        if (response.id) {
          self.bookkeepings[self.editedBookkeeping] = self.__applyReadableName(response);
          self.editedBookkeeping = null;
          self.originalEditedBookkeeping = {};
          self.formOpen = false;
        }
      }).catch(function (error) {
        console.error('Error creating bookkeeping:', error);
        self.formOpen = false;
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }

  function openMenu ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  }

  function downloadPaymentTypes (index) {
    var bookkeeping = new BookkeepingsFactory(self.bookkeepings[index]);
    bookkeeping.hotelId = $rootScope.hotel.id;
    bookkeeping.download_payment_types().then(function (response) {
      downloadFile('payment_types.csv', response.data);
    });
  }

  function addBookkeeping (bookkeeping_name) {
    if (bookkeeping_name == 'xero') {
      self.formOpen = true;
      window.location.href = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/xero_authentication';
      return
    }
    self.bookkeepings.push({
      name: bookkeeping_name,
      isActive: true,
      readableName: __getReadableName(bookkeeping_name),
      details: {}
    });

    self.openEditForm(self.bookkeepings.length - 1);
  }

  function __getReadableName(name) {
    var names = {
      'dk' : 'DK',
      'xero' : 'Xero'
    }

    return names[name];
  }

  function __applyReadableName(bookkeeping) {
    bookkeeping['readableName'] = __getReadableName(bookkeeping['name']);
    return bookkeeping;
  }

  function insertDropIn(editor, dropin) {
    var element = angular.element('[data-role="'+editor+'"]')[0];
    var text = dropin || '';
    if (document.selection) {
      // IE
      element.focus();
      var sel = document.selection.createRange();
      sel.text = text;
    } else if (element.selectionStart || element.selectionStart === 0) {
      // Others
      var startPos = element.selectionStart;
      var endPos = element.selectionEnd;
      element.value = element.value.substring(0, startPos) +
        text +
        element.value.substring(endPos, element.value.length);
      element.selectionStart = startPos + text.length;
      element.selectionEnd = startPos + text.length;
    } else {
      element.value += text;
    }
    element.dispatchEvent(new Event('change'));
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.AccountingCategoriesController', AccountingCategoriesController);

AccountingCategoriesController.$inject = ["$rootScope", "$scope", "$i18next", "$mdDialog", "AccountingCategoryFactory"];

function AccountingCategoriesController($rootScope, $scope, $i18next, $mdDialog, AccountingCategoryFactory) {
  var vm = this;

  angular.extend(vm, {
    isListMode: true,
    loading: true,
    requestInProgress: false,
    haveItems: false,
    createFormVisible: false,

    addItem: addItem,
    removeItem: removeItem,
    editItem: editItem,

    closeForm: closeForm,
    saveHotel: saveHotel,

    // edit
    editItemId: null,
    createItem: createItem,
    updateItem: updateItem,

    items: [],

    newItem: null,
    itemTemplate: {
      name: null,
      internalCode: null,
      externalCode: null
    },
  });

  function init() {
    angular.extend(vm, {
      hotel: $rootScope.hotel,
      loading: false,
      hotelId: $rootScope.hotel.id,
      items: $rootScope.hotel.accountingCategories,
      haveItems: $rootScope.hotel.accountingCategories.length > 0,
    });
  }

  function addItem() {
    vm.newItem = angular.copy(vm.itemTemplate);

    vm.createFormVisible = true;
    vm.isListMode = false;
  }

  function editItem(item) {
    vm.itemForEdit = angular.copy(item);
    vm.editItemId = item.id;

    vm.isListMode = false;
  }

  function removeItem(item) {
    item.hotelId = vm.hotelId;
    var itemsWithoutCurrent = _.filter(vm.items, function (i) { return i.id != item.id });

    $mdDialog
      .show({
        controller: function ($rootScope, $scope, $mdDialog, local) {
          angular.extend($scope, {
            items: local.items,
            item: local.target,
            selectedItemId: local.items[0].id,
            cancel: cancel,
            confirm: confirm,
            buttonName: 'Replace'
          });

          function cancel() {
            _close();
          }

          function confirm() {
            $scope.loading = true;

            local.confirm($scope.selectedItemId)
              .then(function (isSuccess) {
                $scope.loading = false;

                if (isSuccess) {
                  _close();
                }
              })
              .catch(function(error) {
                $scope.loading = false;
                $rootScope.alert($i18next.t(error));
              })
          }

          function _close() {
            $mdDialog.hide();
          }
        },
        templateUrl: getTemplatePath('modals/select_items/template.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local: {
            parent: $rootScope,
            items: itemsWithoutCurrent,
            target: item,
            confirm: function(targetId) {
              return new AccountingCategoryFactory(item).remove(targetId)
                .then(function (response) {
                  if (!response.success) {
                    $rootScope.alert($i18next.t(response.msg));
                  }

                  return response.success;
                });
            }
          }
        }
      });
  }

  function createItem(item) {
    item.hotelId = vm.hotelId;
    vm.requestInProgress = true;

    new AccountingCategoryFactory(item).create()
      .then(function () {
        vm.requestInProgress = false;
        closeForm();
      })
      .catch(function (response) {
        vm.requestInProgress = false;
        $rootScope.alert($i18next.t(response.errors));
      });
  }

  function updateItem(item) {
    item.hotelId = vm.hotelId;
    vm.requestInProgress = true;

    new AccountingCategoryFactory(item).update()
      .then(function () {
        vm.requestInProgress = false;
        closeForm();
      })
      .catch(function (response) {
        vm.requestInProgress = false;
        $rootScope.alert($i18next.t(response.errors));
      });
  }

  function closeForm() {
    vm.editItemId = null;

    _switchToListMode();
  }

  function _switchToListMode() {
    vm.createFormVisible = false;
    vm.isListMode = true;
  }

  function saveHotel() {
    vm.loading = true
    $rootScope.hotel.save().then(function (data) {
      vm.loading = false;
      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }, function (response) {
      vm.loading = false;
      $rootScope.notify($i18next.t('general.titles.error') + ': ' + response.data.error);
    });
  }

  var categoryUpdatedListener = $rootScope.$on('accounting_categories:updated', function() {
    init();
  });

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel) {
      init();
    }
  });

  $scope.$on('$destroy', function () {
    if(categoryUpdatedListener) {
      categoryUpdatedListener();
    }
    if(hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.PolicyController', PolicyController);

PolicyController.$inject = ["$rootScope", "$scope",  "$timeout", "Globalize"];

function PolicyController ($rootScope, $scope, $timeout, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      init   : init,
      save   : save,
      recalcCustom : recalcCustom,
      setCustom    : setCustom,
      generatePolicyText : generatePolicyText,
      changeLang: changeLang,
      initTimeout: null,
    }
  );

  self.policy = {
    'childrenPolicy': null,
    'petsPolicy': null,
    'internetPolicy': null,
    'smokingPolicy': null,
    'parkingPolicy': null
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      $scope.hotel_locale = $rootScope.hotel.locale;
      $scope.translations = $rootScope.hotel.policiesTranslations;
      self.initTimeout = $timeout(init, 0);
    }
  });


  function init () {
    angular.extend(
      self,
      {
        loaded : false,
        hotel  : $rootScope.hotel,
        policy: $rootScope.hotel.hotelPolicy
      }
    );
    Globalize.loadTranslation(self.policy, 'hotelPolicy');

    generatePolicyText();
  }

  function save () {
    var self = this;
    this.loaded = true;
    updateTextBeforeSave(self.policy);

    this.policy.save().then(function (data) {
      self.loaded = false;
      Globalize.loadTranslation(self.policy, 'hotelPolicy');
    }).catch(function (error) {
      console.error('Error saving hotel settings', error);
      self.loaded = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
    
  }


  function recalcCustom (policy) {
    generatePolicyText();
  }


  function setCustom (policy) {
    generatePolicyText();
  }


  function generatePolicyText (lang) {
    lang = lang || Globalize.locale;
    var out = [];
    if (self.policy.childrenPolicy === 'Children Custom' ) {
      out.push(self.policy.childrenPolicyCustom);
    } else if (self.policy.childrenPolicy !== null) {
      out.push(getTranslation('children', self.policy.childrenPolicy, lang));
    }

    if (self.policy.petsPolicy === 'Pets Custom' ) {
      out.push(self.policy.petsPolicyCustom);
    } else if (self.policy.petsPolicy !== null) {
      out.push(getTranslation('pets', self.policy.petsPolicy, lang));
    }

    if (self.policy.smokingPolicy === 'Smoking Custom' ) {
      out.push(self.policy.smokingPolicyCustom);
    } else if (self.policy.smokingPolicy !== null) {
      out.push(getTranslation('smoking', self.policy.smokingPolicy, lang));
    }

    if (self.policy.internetPolicy === 'Internet Custom' ) {
      out.push(self.policy.internetPolicyCustom);
    } else if (self.policy.internetPolicy !== null) {
      out.push(getTranslation('internet', self.policy.internetPolicy, lang));
    }

    if (self.policy.parkingPolicy === 'Parking Custom' ) {
      out.push(self.policy.parkingPolicyCustom);
    } else if (self.policy.parkingPolicy !== null) {
      out.push(getTranslation('parking', self.policy.parkingPolicy, lang));
    }

    out.push(self.policy.otherPolicy);

    out = out.filter(function(t) { return t !== '' && t !== null && t !== undefined; }).join('. ') + '.';
    self.policy.policyText = out;
    return out;
  }

  function changeLang(old_locale) {
    Globalize.saveTranslation(self.policy, 'hotelPolicy', old_locale);
    Globalize.loadTranslation(self.policy, 'hotelPolicy');
  }

  function updateTextBeforeSave() {
    Globalize.updateCurrentTranslation(self.policy, 'hotelPolicy');
    // Just use locales as counter
    $rootScope.hotel.locales.forEach(function(old_locale) {
      Globalize.nextLocale();
      Globalize.loadTranslation(self.policy, 'hotelPolicy');
      self.policy.policyText = generatePolicyText(Globalize.locale);
      Globalize.updateCurrentTranslation(self.policy, 'hotelPolicy');
    })
  }

  function getTranslation(type, key, locale, params) {
    var string;
    params = params === undefined ? {} : params;
    var dict = $scope.translations[locale] ? $scope.translations[locale] : $scope.translations[$scope.hotel_locale];
    if (dict !== undefined && dict[type] !== undefined) {
      string = dict[type][key];
    } else {
      string = "<No translation yet>";
    }
    if (string === undefined) {
      string = '';
    }
    Object.keys(params).forEach(function(k) {
      string = string.replace('{' + k +'}', params[k]);
    })
    return string;
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
      self.initTimeout = null;
    }
  });
}
angular
  .module('buuqit')
  .controller('Settings.FacilitiesController', FacilitiesController);

FacilitiesController.$inject = ["$rootScope", "$scope", "$i18next", "$mdDialog", "FacilityFactory", "Globalize"];

function FacilitiesController ($rootScope, $scope, $i18next, $mdDialog, FacilityFactory, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      // Controller variables
      loaded            : false,
      facilities        : [],
      createFormVisible : false,
      editedFacility    : null,
      newFacility       : {
        title    : null,
        category : null,
        hotel_id : null
      },

      // Controller methods
      openCreateForm  : openCreateForm,
      closeCreateForm : closeCreateForm,
      saveCreateForm  : saveCreateForm,
      openEditForm    : openEditForm,
      createFacility  : createFacility,
      updateFacility  : updateFacility,
      removeFacility  : removeFacility,
      changeLang      : changeLang
    }
  );

  function init() {
    self.facilities = $rootScope.hotel.facilities;
    self.facilities.forEach(function(facility) {
      Globalize.loadTranslation(facility, 'facility');
    });
    self.newFacility.hotel_id = $rootScope.hotel.id;
    self.loaded = true;
  }

  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    init();
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && self.newFacility && $rootScope.hotel.facilities && self.facilities.length === 0) {
      init();
    }
  });


  function openCreateForm () {
    angular.copy(self.newFacility, this.originalFacility);
    this.createFormVisible = true;
  }


  function closeCreateForm () {
    if (this.editedFacility === null) {
      angular.copy(this.originalFacility, self.newFacility);
    } else {
      angular.copy(this.originalFacility, self.facilities[this.editedFacility]);
    }

    this.editedFacility       = null;
    this.createFormVisible = false;
  }


  function saveCreateForm (model) {
    Globalize.updateCurrentTranslation(model, 'facility');
    if (model.id) {
      this.updateFacility(model);
    } else {
      this.createFacility(model);
    }
  }


  function createFacility (model) {
    var self = this;

    model.hotelId = $rootScope.hotel.id;

    new FacilityFactory(model).create().then(function (data) {
      Globalize.loadTranslation(data, 'facility');
      $rootScope.hotel.facilities.push(data);

      angular.copy(self.originalFacility, self.newFacility);
      self.createFormVisible = false;
    });
  }


  function updateFacility (model) {
    var self = this;

    model.hotelId = $rootScope.hotel.id;

    new FacilityFactory(model).update().then(function (data) {
      Globalize.loadTranslation(model, 'facility');
      $rootScope.hotel.facilities.filter(function(facility) {return facility.id == data.id;})[0] = data;

      self.editedFacility = null;
    }).catch(function (error) {
      console.error('Error updating facility', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }


  function removeFacility (index) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    angular.element('.tooltip').hide();

    $mdDialog.show(confirm).then(function() {
      var model = self.facilities[index];

      model.hotelId = $rootScope.hotel.id;

      new FacilityFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            $rootScope.hotel.facilities.splice(index, 1);
          } else {
            console.error('Error removing facility', data);
            $rootScope.alert($i18next.t('profile_nav.settings.general.alert.you_can_not_remove_facility_used_in_room_type_js_str'));
          }
        });
    }, function() {});
  }


  function openEditForm (index) {
    angular.element('.tooltip').hide();
    this.originalFacility = angular.copy(self.facilities[index]);
    this.editedFacility   = index;
  }

  function changeLang (old_locale) {
    var facilities = self.facilities.concat([self.newFacility]);
    facilities.forEach(function(roomType) {
      Globalize.saveTranslation(roomType, 'facility', old_locale);
      Globalize.loadTranslation(roomType, 'facility');
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    angular.element('.tooltip').remove();
  });
}

angular
  .module('buuqit')
  .controller('Settings.ExtrasController', ExtrasController)
  .component(
    'hotelExtrasTable',
    TBFLibs.react2angular(
      TBFLibs.HotelExtrasTable,
      [ 'extras', 
        'categories', 
        'accountingCategories', 
        'isAccountingCategoriesFeatureEnabled', 
        'user',
        'groupedTaxes', 
        'onExtraUpdate',
        'onExtraMerge',
        'onExtraDelete',
        'onLoadExtras',
        'onLoadExtrasToMerge',
        'hotelId',
        'extrasMeta',
        'extrasToMerge',
        'extrasToMergeMeta',
      ],
      ['$i18next']
    )
  );

ExtrasController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "ExtraFactory",
  "ExtrasFactory",
  "ExtraCategoriesFactory",
  "$http",
  "Globalize",
  "StringTransformService"
];

function ExtrasController ($rootScope, $scope, $i18next, $mdDialog, ExtraFactory, ExtrasFactory, ExtraCategoriesFactory, $http, Globalize, StringTransformService) {
  var self = this;

  angular.extend(
    this,
    {
      // Controller variables
      loaded            : false,
      extras            : [],
      taxes             : [],
      categories        : [],
      editedExtra       : null,
      accountingCategories: [],
      newExtraTemplate    : {
        title    : null,
        price    : 1,
        vat      : 0,
        hotel_id : null,
        isOnlineSellable: false,
        description: null,
        sellMode: 'per_booking',
        photo: null,
        isMeal: false,
        category: null,
        translations: []
      },
      newCategoryTemplate : {
        title: '',
        translations: []
      },
      user: {},
      isAccountingCategoriesFeatureEnabled: false,
      hotel_id : null,
      extrasMeta: {},
      extrasToMerge: [],
      extrasToMergeMeta: {},

      // Controller methods
      init            : init,
      openCreateCategoryForm: openCreateCategoryForm,
      saveCreateForm  : saveCreateForm,
      createExtra     : createExtra,
      updateExtra     : updateExtra,
      mergeExtra     : mergeExtra,
      removeExtra     : removeExtra,
      mergeExtraCategory: mergeExtraCategory,
      removeExtraCategory: removeExtraCategory,
      openCategoryEditForm : openCategoryEditForm,
      saveCategoryForm : saveCategoryForm,
      closeCategoryForm : closeCategoryForm,
      addTaxNames : addTaxNames,
      addTaxNamesToCategories : addTaxNamesToCategories,
      changeLang      : changeLang,
      sortTitleByHotelLang: sortTitleByHotelLang,
      isCancellationFee: isCancellationFee,
      onLoadExtras: onLoadExtras,
      onLoadExtrasToMerge: onLoadExtrasToMerge,
    }
  );

  self.newExtra = angular.copy(self.newExtraTemplate);
  self.newCategory = angular.copy(self.newCategoryTemplate);

  function getGrouppedTaxes(taxes) {
    var nonRemovedTaxes = taxes.filter(function(tax) { return !tax.isRemoved; });
    var grouppedTaxes = _.groupBy(nonRemovedTaxes, 'group');
    return _.keys(grouppedTaxes).map(function(tax_group) {
      return {
        id: Number(tax_group),
        name: grouppedTaxes[tax_group][0].name,
        translations: grouppedTaxes[tax_group][0].translations,
        applicableToExtra: grouppedTaxes[tax_group][0].applicableToExtra
      };
    });
  }

  function prepareTaxGroups(items) {
    return items.map(function(item) {
      item.taxGroups = _.uniq((item.taxes || []).map(function(taxId) {
        if (self.taxesById[taxId]) {
          return self.taxesById[taxId].group;
        }
      }))
      .filter(function(group) {
        return group !== undefined;
      });

      return item;
    });
  }

  function prepareAccountingCategory(items, accountingCategories) {
    return items.map(function(item) {
      item.accountingCategory = accountingCategories.find(function(ac) {return ac.id == item.accountingCategoryId});
      return item;
    })
  }

  function init() {
    self.newExtra = angular.copy(self.newExtraTemplate);
    self.taxes = $rootScope.hotel.newTaxes;
    self.taxesById = $rootScope.hotel.newTaxes.reduce(function(acc, tax) {
      acc[tax.id] = tax;
      return acc;
    }, {});
    self.accountingCategories = $rootScope.hotel.accountingCategories.sort(function(a, b) {if (a.name < b.name) {return -1;} if (a.name > b.name) {return 1;}});
    self.grouppedTaxes = getGrouppedTaxes($rootScope.hotel.newTaxes);
    self.categories = prepareTaxGroups($rootScope.hotel.categories);

    self.newExtra.hotel_id = $rootScope.hotel.id;

    var vatTax = $rootScope.hotel.newTaxes.filter(function(el) {return el.title == 'VAT'});
    if (vatTax.length > 0) {
      self.newExtra.vat = vatTax[0].value;
    }

    self.addTaxNames();
    self.loaded = true;

    self.categories.forEach(function(extra) {
      Globalize.loadTranslation(extra, 'extraCategory');
    });

    self.user = {
      aclRole: $rootScope.user.aclRole,
      corporateRole: $rootScope.user.corporateRole,
      isOwner: $rootScope.user.isOwner,
      role: $rootScope.user.role
    };
    self.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
    self.hotelId = $rootScope.hotel.id;
  }


  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    this.init();
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && self.newExtra) {
      self.init();
    }
  });

  function addTaxNames() {
    self.extras.forEach(function(extra, index) {
      self.extras[index].taxNames = extra.taxGroups.map(function(tax_id) {
        var matchedTax = self.grouppedTaxes.filter(function(tax) {return tax.id == Number(tax_id)})[0];
        return matchedTax ? matchedTax.name : '';
      }).filter(Boolean).join(', ');
    });

    self.addTaxNamesToCategories();
  }


  function addTaxNamesToCategories() {
    self.categories.forEach(function(extra, index) {
      self.categories[index].taxNames = extra.taxGroups.map(function(tax_id) {
        var matchedTax = self.grouppedTaxes.filter(function(tax) {return tax.id == Number(tax_id)})[0];
        return matchedTax ? matchedTax.name : '';
      }).filter(Boolean).join(', ');
    });
  }

  function openCreateCategoryForm() {
    self.newCategory = angular.copy(self.newCategoryTemplate);
    this.createCategoryFormVisible = true;
  }

  function _extraWithSameTitleExists(model) {
    var exists = false;
    if (model.id) {
      self.extras.filter(function(extra) {
        return extra.id !== model.id;
      }).forEach(function(extra) {
        if (extra.title === model.title && !extra.isRemoved) {
          exists = true;
        }
      });
    } else {
      self.extras.forEach(function(extra) {
        if (extra.title === model.title && !extra.isRemoved) {
          exists = true;
        }
      });
    }
    if (exists) {
      return true;
    }
    return false;
  }

  function saveCreateForm (model) {
    Globalize.updateCurrentTranslation(model, 'extra');

    if (_extraWithSameTitleExists(model)) {
      $rootScope.notify($i18next.t('profile_nav.settings.hotel_profile.extras_form.unique_title_required'));
      return;
    };

    if (model.id === -1) {
      delete model.id;
      return self.createExtra(model);
    } else {
      return self.updateExtra(model);
    };
  };

  function createExtra (model) {
    var self = this;
    model.hotelId = $rootScope.hotel.id;
    if(!model.photo) model.photo = '';

    var fd = new FormData();

    Object.keys(model).forEach(function(key) {
      fd.append('extra['+key.replace(/([A-Z])/g, "_$1").toLowerCase() +']', model[key]);
    });
    fd.set('extra[translations]', JSON.stringify(model['translations']));
    
    return $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/extras/', fd, {
      headers: {'Content-Type': undefined },
      transformRequest: angular.identity
    }).success(function(response) {
      if (response.extra.extra_category) {
        var category = new ExtraCategoriesFactory(response.extra.extra_category);
        Globalize.loadTranslation(category, 'extraCategory');
        self.categories.push(category);
        $rootScope.hotel.categories.push(angular.copy(category));
        prepareTaxGroups([category]);
        addTaxNamesToCategories();
        delete response.extra.extra_category;
      };

      self.newExtra = angular.copy(self.newExtraTemplate);
      self.addTaxNames();
    }).error(function(error) {
      console.error('error', error);
    });
  }

  function updateExtra (model) {
    var self = this;

    model.hotelId = $rootScope.hotel.id;
    if(!model.photo) model.photo = '';

    var fd = new FormData();
    
    Object.keys(model).forEach(function(key) {
      fd.append('extra['+key.replace(/([A-Z])/g, "_$1").toLowerCase() +']', model[key]);
    });

    fd.set('extra[translations]', JSON.stringify(model['translations']));
    return $http.put(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/extras/' + model.id, fd, {
      headers: {'Content-Type': undefined },
      transformRequest: angular.identity
    }).success(function(response) {
      if (response && response.extra && response.extra.extra_category) {
        var category = new ExtraCategoriesFactory(response.extra.extra_category);
        Globalize.loadTranslation(category, 'extraCategory');
        $rootScope.hotel.categories.push(angular.copy(category));
        prepareTaxGroups([category]);
        self.categories.push(category);
        addTaxNamesToCategories();
        delete response.extra.extra_category;
      };
      if (response && response.extra) {
        var extra = new ExtraFactory(response.extra);
        prepareTaxGroups([extra]);
        Globalize.loadTranslation(extra, 'extra');
      }
      self.addTaxNames();
    }).error(function(error) {
      console.error('error', error);
    });
  }

  function mergeExtra(extraToBeMergedId, replacingExtraId) {
    ctrlExtraToBeMerged = self.extras && self.extras.find(function (e) { return e.id === extraToBeMergedId });
    ctrlExtraToBeMerged.hotelId = $rootScope.hotel.id;

    try {
      return ( new ExtraFactory(ctrlExtraToBeMerged)).remove(replacingExtraId);
    } catch (error) {
      console.error('Error merging extra', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
    };
  }

  function mergeExtraCategory(extra_category) {
    $mdDialog
      .show({
        controller: function ($rootScope, $scope, $mdDialog, local) {
          angular.extend($scope, {
            extras: _.without(local.extras.filter(function(el) {return !el.isRemoved;}), local.extra),
            extra: local.extra,
            choosedExtra: '',
            cancel: cancel,
            merge: merge
          });

          function cancel(){
            $mdDialog.hide();
          }

          function merge() {
            local.merge($scope.choosedExtra);
            cancel();
          }
        },
        templateUrl: getTemplatePath('modals/removeExtra.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $rootScope,
            extras: self.categories,
            extra: extra_category,
            merge: function(replaceWith) {
              extra_category.loading = true;
              extra_category.hotelId = $rootScope.hotel.id;

              new ExtraCategoriesFactory(extra_category).remove(replaceWith).then(function(data) {
                if (data.success === false) {
                  console.error('Error removing extra category', data);
                  extra_category.loading = false;
                  $rootScope.alert(data.msg || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
                } else {
                  extra_category.isRemoved = true;
                }
              });
            }
          }
        }
      });
  }

  function removeExtra (id) {
    var model = self.extras && self.extras.find(function (e) { return e.id === id });
    model.hotelId = $rootScope.hotel.id;

    try {
      return ( new ExtraFactory(model)).remove();
    } catch (error) {
      console.error('Error removing extra', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
    };
  };


  function removeExtraCategory (model) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel')),
      self = this;

    angular.element('.tooltip').hide();

    $mdDialog.show(confirm).then(function() {
      model.hotelId = $rootScope.hotel.id;
      model.isLoading = true;

      new ExtraCategoriesFactory(model)
        .remove()
        .then(function (data) {
          model.isLoading = false;
          if (data.success) {
            model.isRemoved = true;
          } else {
            $rootScope.alert(data.msg || $i18next.t('general.alert_modals.something_went_wrong_js_str'));
          }
        });
    }, function (reason) {
      model.isLoading = false;
      if (angular.isUndefined(reason)) {
        console.log('Dialog canceled by user');
        return;
      }
      console.error('Error removing extra category', reason);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
    });
  }

  function openCategoryEditForm (category) {
    angular.element('.tooltip').hide();
    this.categoryOriginalValue = angular.copy(category);
    category.edited = true;
  }


  function closeCategoryForm(value) {
    self.categories[self.categories.indexOf(value)] = angular.copy(self.categoryOriginalValue);
    this.createCategoryFormVisible = false;
  }

  function saveCategoryForm(value) {
    var index = self.categories.indexOf(value);
    var id = value.id;
    value.hotelId = $rootScope.hotel.id;
    value.taxes = value.taxes && value.taxes.length > 0 ? value.taxes.join(',') : null;
    Globalize.updateCurrentTranslation(value, 'extraCategory');

    new ExtraCategoriesFactory(value)
      .save()
      .then(function(edited_category) {
        if (index == -1) {
          self.createCategoryFormVisible = false;
          $rootScope.hotel.categories.push(edited_category);
        }
        edited_category.edited = false;
        angular.copy(edited_category, value)
        Globalize.loadTranslation(value, 'extraCategory');
        self.categories = prepareTaxGroups($rootScope.hotel.categories);

        self.extras = self.extras.map(function(extra) {
          if(extra.extraCategoryId == value.id) {
            extra.category = value.title;

            var extraObj = {};
            Object.keys(extra).forEach(function(key) {
              extraObj[key] = extra[key];
            });
            
            return extraObj;
          }
          
          return extra;
        });

        addTaxNamesToCategories();
      }).catch(function(error) {
        console.error('Error saving category', error);
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_js_str'));
      });
  }

  function changeLang(old_locale) {
    extras = self.extras.concat([self.newExtra]);
    extras.forEach(function(extra) {
      Globalize.saveTranslation(extra, 'extra', old_locale);
      Globalize.loadTranslation(extra, 'extra');
    });

    extras = self.categories.concat([]);
    extras.forEach(function(extra) {
      Globalize.saveTranslation(extra, 'extraCategory', old_locale);
      Globalize.loadTranslation(extra, 'extraCategory');
    });
  }

  function sortTitleByHotelLang(obj) {
    var translation = (obj.translations || []).filter(function(d) {
      return d.locale == $rootScope.hotel.locale;
    });
    return translation.length ? translation[0].title : '';
  }

  function isCancellationFee(extra) {
    return extra.translations.filter(function(e) {
      return e.title == 'Cancellation Fee' || e.title == 'Cancelation Fee';
    }).length;
  }

  var DEFAULT_PAGINATION = { page: 1, limit: 10 };
  
  function onLoadExtras(params) {
    var par = params || DEFAULT_PAGINATION;
    try {
      if ($rootScope.hotel && $rootScope.hotel.id) {
        var extrasFactory = new ExtrasFactory();
        return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
          if (data.data) {
            self.extrasMeta = data.data.meta || {};
            self.extras = data.data.extras ? StringTransformService.snakeToCamel(data.data.extras) : [];

            self.extras = prepareTaxGroups(self.extras);
            self.extras = prepareAccountingCategory(self.extras, self.accountingCategories);
            self.extras.forEach(function(extra) {
              Globalize.loadTranslation(extra, 'extra');
            });

            self.addTaxNames();
          };
        });
      }
    } catch (e) {
      console.error(e, 'Error loading extras');
    };
  };

  function onLoadExtrasToMerge(params) {
    var par = params || DEFAULT_PAGINATION;
    try {
      if ($rootScope.hotel && $rootScope.hotel.id) {
        var extrasFactory = new ExtrasFactory();
        return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
          if (data.data && data.data.extras) {
            self.extrasToMergeMeta = data.data.meta || {};

            newExtras = StringTransformService.snakeToCamel(data.data.extras);
            self.extrasToMerge = (par.pagination && par.pagination.page === 1) ? newExtras : self.extrasToMerge.concat(newExtras);

            self.extrasToMerge.forEach(function(extra) {
              Globalize.loadTranslation(extra, 'extra');
            });
          };
        });
      }
    } catch (e) {
      console.error(e, 'Extras');
    };
  };

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    angular.element('.tooltip').remove();
  });
}

angular
  .module('buuqit')
  .controller('Settings.WidgetController', WidgetController);

WidgetController.$inject = ["$rootScope", "$scope", "$i18next", "$timeout", "BookingWidgetSettingsFactory"];

function WidgetController ($rootScope, $scope, $i18next, $timeout, BookingWidgetSettingsFactory) {
  var self = this;
  var IBE_ACCEPTED_LANGUAGES = ['en', 'de', 'ru', 'ch', 'fr', 'el', 'ro', 'it', 'id', 'es', 'th', 'is'];
  var IBE_ACCEPTED_CURRENCIES = ['GBP', 'EUR', 'USD', 'CAD', 'AMD', 'AUD', 'BGN', 'BRL', 'CHF', 'CNY', 'CZK', 'DKK', 'HKD', 'HRK', 'HUF', 'IDR', 'ILS', 'INR', 'JPY', 'KRW', 'MAD', 'MXN', 'MYR', 'NAD', 'NOK', 'NZD', 'PHP', 'PLN', 'RON', 'RUB', 'SEK', 'SGD', 'THB', 'TRY', 'ZAR'];
  var timeouts = [];

  angular.extend(
    this,
    {
      is_white_label: (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) == -1),
      newWidgetFormVisible: false,
      originalWidgetSettings: {
        container: 'tbf-widget',
        title: $i18next.t('profile_nav.settings.other.booking_widget.widget_settings.book_now_js_str'),
        button_text: $i18next.t('profile_nav.settings.other.booking_widget.widget_settings.search_js_str'),
        checkin_date_text: $i18next.t('profile_nav.settings.other.booking_widget.widget_settings.check_in_date_js_str'),
        nights_text: $i18next.t('general.other.nights'),
        occupancy_visible: false,
        powered_by_visible: false,
        month_names: null,
        week_day_names: null,
        primary_color: '#0098d1',
        text_color: '#363b3d',
        background_color: '#ffffff',
        border_color: '#e2e2e2',
        label_color: '#a0acb2'
      },
      currencies: currencies.filter(function(currency) {return IBE_ACCEPTED_CURRENCIES.indexOf(currency[0]) !== -1}),
      languages: languages.filter(function(language) { return IBE_ACCEPTED_LANGUAGES.indexOf(language.code) !== -1}),

      editBookingWidget: editBookingWidget,
      removeBookingWidget: removeBookingWidget,
      closeEditForm: closeEditForm,
      saveEditForm: saveEditForm,
      openCreateBookingWidgetForm: openCreateBookingWidgetForm,
      getSettings : getSettings,
      preview : preview
    }
  );

  function init () {
    if ($rootScope.hotel) {
      self.originalWidgetSettings.hotel_id = $rootScope.hotel.slug;
      self.newWidget = angular.copy(self.originalWidgetSettings);
      BookingWidgetSettingsFactory
        .query({
        }, {
          hotelId: $rootScope.hotel.id
        })
        .then(function(data) {
          self.booking_widgets = data;
        }).catch(function(error) {
          console.error('Error fetching booking widgets', error);
        });
    }
  }


  function prepareWidgetSettings (settings) {
    return {
      hotel_id: $rootScope.hotel.slug,
      container: 'tbf-widget',
      title: settings.title,
      button_text: settings.buttonText,
      checkin_date_text: settings.checkinDateText,
      nights_text: settings.nightsText,
      occupancy_visible: settings.occupancyVisible,
      powered_by_visible: settings.poweredByVisible,
      month_names: settings.monthNames,
      week_day_names: settings.weekDayNames,
      primary_color: settings.primaryColor,
      text_color: settings.textColor,
      background_color: settings.backgroundColor,
      border_color: settings.borderColor,
      label_color: settings.labelColor,
      hash_key: settings.hashKey,
      use_checkout_instead_nights: settings.useCheckoutInsteadNights,
      endpoint: settings.endpoint,
      booking_link: settings.bookingLink
    };
  }


  function preview(widget_settings) {
    if (widget_settings.id) {
      widget_settings = prepareWidgetSettings(widget_settings);
    }
    angular.element('.preview-widget-box iframe').remove();
    var settings = angular.copy(widget_settings);
    settings.container = 'tbf-widget';
    var iframe = document.createElement('iframe');
    var html = '<!doctype html><html><head><meta charset="utf-8"><title>Booking Widget</title><meta name="description" content=""><meta name="viewport" content="width=device-width"><script src="https://d14m6r1z596agm.cloudfront.net/booking-widget.v2.js"></script></head><body><div class="widget"></div><script>setTimeout(function(){ var div =  document.getElementsByTagName("div")[0]; div.id = "tbf-widget"; tbfBookingWidget('+JSON.stringify(settings).replace(/#/gi, '')+');}, 100);</script></body></html>';
    iframe.src = 'data:text/html;charset=utf-8,' + encodeURI(html);
    angular.element('.preview-widget-box')[0].appendChild(iframe);
  }


  function getSettings (widget_settings) {
    if (widget_settings.id) {
      widget_settings = prepareWidgetSettings(widget_settings);
    }
    var settings = angular.copy(widget_settings);
    if (widget_settings) {
      return '' +
        '<div id="tbf-widget" data-hash="' + widget_settings.hash_key + '" data-endpoint="' + widget_settings.endpoint + '"></div>\r\n' +
        '<script src="https://d14m6r1z596agm.cloudfront.net/booking-widget.v2.js"></script>';
    } else {
      return '';
    }
  }


  function openCreateBookingWidgetForm () {
    self.newWidgetFormVisible = true;
    var timeout = $timeout(function() {
      self.preview(self.newWidget);
    }, 100);
    timeouts.push(timeout);
  }


  function closeEditForm (widget) {
    if (widget.id) {
      widget.edited = false;
    } else {
      self.newWidget = angular.copy(self.originalWidgetSettings);
      self.newWidgetFormVisible = false;
    }
  }


  function saveEditForm (widget) {
    if (widget.id) {
      widget.hotelId = $rootScope.hotel.id;
      widget.primaryColor = widget.primaryColor.replace('#', '');
      widget.textColor = widget.textColor.replace('#', '');
      widget.backgroundColor = widget.backgroundColor.replace('#', '');
      widget.borderColor = widget.borderColor.replace('#', '');
      widget.labelColor = widget.labelColor.replace('#', '');

      widget
        .save()
        .then(
          function (response) {
            widget.edited = false;
          },
          function (response) {
            console.error('Error saving widget settings', response);
          }
        )
    } else {
      widget.hotel_id = $rootScope.hotel.id;
      widget.primary_color = widget.primary_color.replace('#', '');
      widget.text_color = widget.text_color.replace('#', '');
      widget.background_color = widget.background_color.replace('#', '');
      widget.border_color = widget.border_color.replace('#', '');
      widget.label_color = widget.label_color.replace('#', '');

      new BookingWidgetSettingsFactory(widget)
        .save()
        .then(
          function (data) {
            self.booking_widgets.push(data);
          },
          function (response) {
            console.error('Error saving widget settings', response);
          }
        );


      self.newWidget = angular.copy(self.originalWidgetSettings);
      self.newWidgetFormVisible = false;
    }
  }


  function editBookingWidget (widget) {
    widget.edited = true;
    var timeout = $timeout(function () {
      self.preview(widget);
    }, 100);
    timeouts.push(timeout);
  }


  function removeBookingWidget (widget) {
    widget.remove().then(function(response) {
      self.booking_widgets = _.without(self.booking_widgets, widget);
    }).catch(function(error) {
      console.error('Error deleting widget settings', error);
    });
  }


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (timeouts) {
      for (var i = 0; i < timeouts.length; i++) {
        $timeout.cancel(timeouts[i]);
      }
      timeouts = [];
    }
    angular.element('.preview-widget-box iframe').remove();
  });
}

angular
  .module('buuqit')
  .controller('Settings.SaleChannelsController', SaleChannelsController);

SaleChannelsController.$inject = ["$rootScope", "$scope", "$i18next", "$mdDialog", "SaleChannelFactory"];

function SaleChannelsController($rootScope, $scope, $i18next, $mdDialog, SaleChannelFactory) {
  var vm = this;

  angular.extend(vm, {
    isListMode: true,
    loading: true,
    requestInProgress: false,
    haveSaleChannels: false,
    haveFilteredSaleChannels: false,
    createFormVisible: false,

    filter: 'confirmed',
    selectedItemsCount: 0,

    changeFilter: changeFilter,
    addItem: addItem,
    removeItem: removeItem,
    editItem: editItem,
    mergeItems: mergeItems,

    closeForm: closeForm,

    // edit
    editItemId: null,
    createItem: createItem,
    updateItem: updateItem,
    _switchToListMode: _switchToListMode,

    filteredSaleChannels: [],

    newSaleChannel: null,
    saleChannelTemplate: {
      name: null,
    },

    getStatus: getStatus,
  });

  function init() {
    angular.extend(vm, {
      loading: false,
      hotelId: $rootScope.hotel.id,
      saleChannels: $rootScope.hotel.saleChannels,
    });

    _filterCollection();
  }

  function changeFilter(filter) {
    vm.filter = filter;
  }

  function addItem() {
    vm.newSaleChannel = angular.copy(vm.saleChannelTemplate);

    var defaultStatus = vm.filter === 'all' ? 'draft' : vm.filter;
    vm.newSaleChannel.status = defaultStatus;

    vm.createFormVisible = true;
    this.isListMode = false;
  }

  function editItem(item) {
    this.editItemId = item.id;
    vm.editSaleChannel = angular.copy(item);

    this.isListMode = false;
  }

  function mergeItems() {
    var selectedItems = vm.saleChannels.filter(function (item) { return item.isSelected });

    $mdDialog
      .show({
        controller: function ($rootScope, $scope, $mdDialog, local) {
          angular.extend($scope, {
            items: local.items,
            selectedItemId: local.items[0].id,
            cancel: cancel,
            merge: merge,
            selectItem: selectItem
          });

          function close() {
            $mdDialog.hide();
          }

          function cancel() {
            close();
          }

          function selectItem(item) {
            $scope.selectedItemId = item.id;
          }

          function merge() {
            var targetItem = $scope.items.find(function (item) { return item.id === $scope.selectedItemId });

            $scope.loading = true;

            local.merge(targetItem)
              .then(function (isSuccess) {
                $scope.loading = false;

                if (isSuccess) {
                  close();
                }
              })
              .catch(function(error) {
                $scope.loading = false;
                $rootScope.alert($i18next.t(error));
              })
          }
        },
        templateUrl: getTemplatePath('modals/merge_items/template.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local: {
            parent: $rootScope,
            items: selectedItems,
            merge: function(targetSaleChannel) {
              var toMergeIds = selectedItems
                .filter(function (item) { return item.id !== targetSaleChannel.id })
                .map(function (item) { return item.id });

              targetSaleChannel.hotelId = vm.hotelId;

              return new SaleChannelFactory(targetSaleChannel).merge(toMergeIds)
                .then(function (response) {
                  if (response.success) {
                    toMergeIds.forEach(function (id) {
                      var itemIndex = vm.saleChannels.findIndex(function (saleChannel) { return saleChannel.id === id });

                      vm.saleChannels.splice(itemIndex, 1);
                    });
                  } else {
                    $rootScope.alert($i18next.t(response.msg));
                  }

                  return response.success;
                });
            }
          }
        }
      });
  }

  function removeItem(item) {
    item.hotelId = vm.hotelId;

    $mdDialog.show(
      $mdDialog
        .confirm()
        .title($i18next.t('general.confirm.confirm'))
        .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
        .ok($i18next.t('general.confirm.ok'))
        .cancel($i18next.t('general.confirm.cancel'))
    ).then(
      function() {
        new SaleChannelFactory(item).remove()
          .then(function (response) {
            if (response.success) {
              var itemIndex = vm.saleChannels.findIndex(function (saleChannel) { return saleChannel.id === item.id });

              vm.saleChannels.splice(itemIndex, 1);
            } else {
              $rootScope.alert($i18next.t(response.msg));
            }
          });
      }
    )
  }

  function createItem(item) {
    item.hotelId = vm.hotelId;
    vm.requestInProgress = true;

    new SaleChannelFactory(item).create()
      .then(function (data) {
        vm.saleChannels.push(data);
        vm.requestInProgress = false;

        closeForm();
      })
      .catch(function (response) {
        vm.requestInProgress = false;
        $rootScope.alert($i18next.t(response.errors));
      });
  }

  function updateItem(item) {
    item.hotelId = vm.hotelId;
    vm.requestInProgress = true;

    new SaleChannelFactory(item).update()
      .then(function (data) {
        vm.requestInProgress = false;

        var editedSaleChannel = vm.saleChannels.find(function (saleChannel) { return saleChannel.id === vm.editItemId });
        angular.extend(editedSaleChannel, data);

        vm._switchToListMode();
      })
      .catch(function (response) {
        vm.requestInProgress = false;
        $rootScope.alert($i18next.t(response.errors));
      });
  }

  function closeForm() {
    vm.editItemId = null;
    vm.editSaleChannel = null;

    vm._switchToListMode();
  }

  function _switchToListMode() {
    this.editItemId = null;
    this.createFormVisible = false;

    this.isListMode = true;
  }

  function _filterCollection() {
    var filterFn;

    if (vm.filter === 'all') {
      filterFn = function() { return true };
    } else {
      filterFn = function (saleChannel) {
        return saleChannel.status === vm.filter;
      }
    }

    vm.filteredSaleChannels = vm.saleChannels.filter(filterFn);
  }

  function _calcSelectedItems() {
    vm.selectedItemsCount = 0;

    vm.saleChannels.forEach(function (saleChannel) {
      if (saleChannel.isSelected) {
        vm.selectedItemsCount++;
      }
    });
  }

  function getStatus(saleChannel) {
    var uiStatusi18n = {
      confirmed: 'profile_nav.settings.booking_engine.sale_channels_settings.active',
      draft: 'profile_nav.settings.booking_engine.sale_channels_settings.draft',
    };

    var statusWithFallback = uiStatusi18n[saleChannel.status] || saleChannel.status;

    return $i18next.t(statusWithFallback);
  }

  var updateListener = $rootScope.$on('sale_channels:updated', function() {
    init();
  });

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel) {
      init();
    }
  });

  $scope.$watch('vm.filter', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      _filterCollection();
    }
  });

  $scope.$watch('vm.saleChannels', function () {
    if (!vm.saleChannels) {
      vm.haveSaleChannels = false;
      return;
    }

    vm.haveSaleChannels = vm.saleChannels.length > 0;

    _filterCollection();
    _calcSelectedItems();
  }, true);

  $scope.$watch('vm.filteredSaleChannels', function () {
    vm.haveFilteredSaleChannels = vm.filteredSaleChannels.length > 0;
  }, true);
  
  $scope.$on('$destroy', function () {
    if(updateListener) {
      updateListener();
    }
    if(hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.KeyLockController', KeyLockController)
  .component('keyLocks', window.TBFLibs.react2angular(
    window.TBFLibs.KeyLocks,[
    'onSave',
    'onDelete',
    'onSendTestLetter',
    'keyLocksData',
    'hotelProperties',
    'remoteLockUrl',
    'hotelId',
    'onLoadBeeFreeToken',
  ], [
    '$i18next'
  ]));

  KeyLockController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "KeyLockFactory",
  "EmailTemplatePreviewFactory",
  "BeeFreeFactory"
];


function KeyLockController ($rootScope, $scope, $i18next, KeyLockFactory, EmailTemplatePreviewFactory, BeeFreeFactory) {
  var ctrl = this;
  
  angular.extend(
    $scope,
    {
      keyLocksData: [],
      hotelProperties: [],
      loadedKeyLocks: false,
      remoteLockUrl: '',
      onSave: onSave,
      onDelete: onDelete,
      hotelId: '',
    }
  );

  function prepareProperties() {
    return $rootScope.hotel.properties.map(function(hp) {
      return {
        id: hp.id,
        name: hp.name
      };
    });
  }

  function getKeyLocks() {
    KeyLockFactory.getKeyLocks().then(function(response) {
      ctrl.keyLocksData = response.data.key_locks;
      $scope.loadedKeyLocks = true;
    }).catch(function() {
      console.error('Error fetching key locks:', error);
      $scope.loadedKeyLocks = true;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function onSave(key) {
    var method;
    if (key.id) {
      method = KeyLockFactory.updateKeyLock;
    } else {
      method = KeyLockFactory.createKeyLock;
    }
    return method(key).then(function(response) {
      getKeyLocks();
      return response;
    }).catch(function(error) {
      console.error('Error saving key lock:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  function onSendTestLetter(text) {
    var letter = {
      receiver: $rootScope.hotel.email,
      templateHtml: text,
      hotelId: $rootScope.hotel.id,
    }
    new EmailTemplatePreviewFactory(letter).create().then(function () {
      $rootScope.notify($i18next.t('bookings.email.notify.test_email_has_been_sent_js_str'));
    }, function (error_message) {
      console.error('Error sending test letter:', error_message);
      $rootScope.notify(error_message);
    });
  }

  function onDelete(key) {
    return KeyLockFactory.deleteKeyLock(key).then(function(response){
      getKeyLocks();
      return response;
    }).catch(function(error) {
      console.error('Error deleting key lock:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  function onLoadBeeFreeToken() {
    return BeeFreeFactory
      .get({
        hotelId: $rootScope.hotel.id
      });
  }

  function init () {
    if ($rootScope.hotel) {
      getKeyLocks();
      ctrl.hotelProperties = prepareProperties();
      ctrl.onDelete = onDelete;
      ctrl.onSave = onSave;
      ctrl.onSendTestLetter = onSendTestLetter;
      ctrl.onLoadBeeFreeToken = onLoadBeeFreeToken;
      ctrl.remoteLockUrl = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/key_locks/remote_lock_authentication';
      ctrl.hotelId = $rootScope.hotel.id.toString();
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel) {
      init();
    }
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}
angular
  .module('buuqit')
  .controller('Settings.HousekeepingSystemsController', HousekeepingSystemsController)
  .component('reactHousekeepingSystems', window.TBFLibs.react2angular(
    window.TBFLibs.HousekeepingSystems,[
    'onSave',
    'onDelete',
    'housekeepingSystemsData',
    'hotelId',
  ], [
    '$i18next'
  ]));

HousekeepingSystemsController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "HousekeepingSystemFactory",
];


function HousekeepingSystemsController ($rootScope, $scope, $i18next, HousekeepingSystemFactory) {
  var ctrl = this;

  angular.extend(
    $scope,
    {
      housekeepingSystemsData: [],
      hotelProperties: [],
      loadedHousekeepingSystems: false,
      remoteLockUrl: '',
      onSave: onSave,
      onDelete: onDelete,
    }
  );

  function getHousekeepings() {
    $scope.loadedHousekeepingSystems = false;
    HousekeepingSystemFactory.getHousekeepings().then(function(response) {
      ctrl.housekeepingSystemsData = response.data.housekeepings;
      $scope.loadedHousekeepingSystems = true;
    }).catch(function() {
      console.error('Error fetching housekeeping systems:', error);
      $scope.loadedHousekeepingSystems = true;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function onSave(key) {
    $scope.loadedHousekeepingSystems = false;
    var method;
    if (key.id) {
      // NOTE: use in case we have need for modification feature
      // method = HousekeepingSystemFactory.updateHousekeeping;
    } else {
      method = HousekeepingSystemFactory.createHousekeeping;
    }
    return method(key).then(function (response) {
      if (key.provider == "sweeply") {
        window.open(response.data.callback_url, "_blank");
      }
      getHousekeepings();
      $scope.loadedHousekeepingSystems = true;
      return response;
    }).catch(function (error) {
      console.error('Error saving housekeeping system:', error);
      $scope.loadedHousekeepingSystems = true;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  function onDelete(key) {
    return HousekeepingSystemFactory.deleteHousekeeping(key).then(function(response){
      getHousekeepings();
      return response;
    }).catch(function(error) {
      console.error('Error deleting housekeeping system:', error);
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return error;
    });
  }

  function init () {
    if ($rootScope.hotel) {
      getHousekeepings();
      ctrl.onDelete = onDelete;
      ctrl.onSave = onSave;
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel) {
      init();
    }
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}
angular
  .module('buuqit')
  .controller('Settings.DevKeysController', DevKeysController);

DevKeysController.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "DevKeyFactory"
];


function DevKeysController ($rootScope, $scope, $i18next, DevKeyFactory) {
  var self = this;
  this.newKeyName = '';
  angular.extend(
    $scope,
    {
      loaded_perms : false,
      loaded_keys : false,
      perms: [],
      keys: [],
      saveKey: saveKey,
      toggleKey: toggleKey,
      createKey: createKey,
      removeKey: removeKey,
      create_in_progress: false
    }
  );

  function toggleKey(k) {
    k.show = !k.show;
  }

  function loadPerms() {
    DevKeyFactory.loadPerms().then(function(response) {
      angular.copy(response.data.permissions, $scope.perms);
      $scope.endpoint = response.data.endpoint;
      $scope.loaded_perms = true;
    })
  }

  function loadKeys() {
    DevKeyFactory.loadKeys().then(function(keys){
      angular.copy(keys, $scope.keys);
      $scope.loaded_keys = true;
    })
  }

  function saveKey(key) {
    if (key.loading) return;
    key.loading = true;
    DevKeyFactory.updateKey(key, {
      'is_active': key.is_active,
      'perms': Object.keys(key.perms).filter(function(p){ return key.perms[p]}).join(',')
    }).then(function(updated_key){
      angular.copy(updated_key, key);
      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }).catch(function(error) {
      console.error('Error saving key:', error);
    }).finally(function() {
      key.loading = false;
    })
  }

  function createKey() {
    if ($scope.create_in_progress) return;
    $scope.create_in_progress = true;

    DevKeyFactory.createKey({'name': self.newKeyName})
      .then(function(key){
        $scope.keys.push(key);
        self.newKeyName = '';
        $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
      }).catch(function(error) {
        console.error('Error creating key:', error);
      }).finally(function(){
        $scope.create_in_progress = false;
      })
  }

  function removeKey(key) {
    if (key.loading) return;
    key.loading = true;
    DevKeyFactory.deleteKey(key).then(function(response){
      var index = $scope.keys.indexOf(key);
      if (index != -1) {
        $scope.keys.splice(index, 1);
      }
    }).catch(function(error) {
      console.error('Error deleting key:', error);
    });
  }


  function init () {
    if ($rootScope.hotel) {
      loadPerms();
      loadKeys();
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel) {
      $scope.hotel_id = $rootScope.hotel.id;
      init();
    }
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}
angular
  .module('buuqit')
  .controller('Settings.ChannelManagers', ChannelManagersController);

ChannelManagersController.$inject = ["$rootScope", "$scope", "$i18next", "$timeout", "$http", "$mdDialog", "ChannelManagerFactory", "ChannexAPI"];

function ChannelManagersController ($rootScope, $scope, $i18next, $timeout, $http, $mdDialog, ChannelManagerFactory, ChannexAPI) {
  var self = this;
  var visible_names = {
    'wubook': 'Wubook',
    'site_minder': 'Site Minder',
    'vertical_booking': 'Vertical Booking',
    'channex': 'Channex'
  };

  angular.extend(
    this,
    {
      channels: [],
      editedChannel: null,
      originalEditedChannel: null,
      saveHotelInProgress: false,
      hotelIsProduction: false,
      channexForm: getTemplatePath('forms/channexIntegrationForm.html'),

      initialized: false,
      init: init,
      openEditForm: openEditForm,
      removeChannel: removeChannel,
      openMenu: openMenu,
      addChannel: addChannel,
      cancelEditing: cancelEditing,
      saveEditing: saveEditing,
      syncChannel: syncChannel,
      fetchMissingBookings: fetchMissingBookings,
      prepare_wubook_channel_to_save: prepare_wubook_channel_to_save,
      prepare_site_minder_channel_to_save: prepare_site_minder_channel_to_save,
      prepare_vertical_booking_channel_to_save: prepare_vertical_booking_channel_to_save,
      prepare_channex_channel_to_save: prepare_channex_channel_to_save,
      uploadConfiguration: uploadConfiguration,
      uploadVBRoomConfiguration: uploadVBRoomConfiguration,
      uploadVBRateConfiguration: uploadVBRateConfiguration,
      executePlannedTasks: executePlannedTasks,
      reloadLogs: reloadLogs,
      reloadPlanned: reloadPlanned,
      openLog: openLog,
      clearLogs: clearLogs,
      clearPlanned: clearPlanned,
      saveHotel: saveHotel,
      normalizeWubookSettings: normalizeWubookSettings,
      loadFromChannex: loadFromChannex,
      loadChannexHotels: loadChannexHotels,
      installChannexWebhook: installChannexWebhook,
      createChannexHotel: createChannexHotel,
      createChannexRoomType: createChannexRoomType,
      createChannexRate: createChannexRate,
      channexUpdateHotel: channexUpdateHotel,
      channexProcessHotelsChange: channexProcessHotelsChange,
      channexApplyHotelsChange: channexApplyHotelsChange,
      channexUnmapRoomType: channexUnmapRoomType,
      channexMoveUnmapped: channexMoveUnmapped,
      initIfPossibleAndNeeded: initIfPossibleAndNeeded
    }
  );

  function init () {
    self.initialized = true;
    self.hotelIsProduction = $rootScope.hotel.isProduction;
    self.hotel_id = $rootScope.hotel.id;
    self.hotel = $rootScope.hotel;

    self.channels = $rootScope.hotel.channels;
    self.channels.forEach(function(channel) {
      channel.visible_name = visible_names[channel.name];
    });

    self.roomRepresentations = $rootScope.hotel.roomRepresentations.reduce(function(obj, el) {
      obj[el.id] = el;
      return obj;
    }, {});
    
    var activeRateCategories = $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved === false});
    self.rateCategoriesByIds = activeRateCategories.reduce(function(obj, el) {
      obj[el.id] = el;
      return obj;
    }, {});
    self.rateCategories = activeRateCategories.map(function(rc) {
      return {
        id: rc.id,
        title: rc.name,
        code: null
      };
    });

    self.roomTypes = $rootScope.hotel.roomTypes.map(function(rt) {
      return {
        id: rt.id,
        title: rt.name,
        code: null,
        type: "real"
      };
    });

    self.coverRoomTypes = $rootScope.hotel.virtualRoomTypes
      .filter(function(rt) {
        return rt.coverRoomTypeId !== null;
      })
      .map(function(rt) {
        return {
          id: rt.id,
          title: rt.title,
          code: null,
          type: "cover"
        };
      });

    var activeRoomRates = $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved === false});
    
    var roomRatesByRepresentationId = {};
    activeRoomRates.forEach(function(item) {
      if (!roomRatesByRepresentationId[item.roomRepresentationId]) {
        roomRatesByRepresentationId[item.roomRepresentationId] = [];
      }
      roomRatesByRepresentationId[item.roomRepresentationId].push(item);
    });

    self.mixedRoomTypes = Object.values(self.roomRepresentations).map(function(el) {
      var elRoomRates = roomRatesByRepresentationId[el.id] || [];
      el.roomRates = elRoomRates.map(function(item) {
        return {
          id: item.id,
          roomRepresentationId: item.roomRepresentationId,
          rateCategoryId: item.rateCategoryId,
          maxAdults: item.maxAdults,
          maxChildren: item.maxChildren,
          shortCode: item.shortCode,
          title: self.rateCategoriesByIds[item.rateCategoryId] ? self.rateCategoriesByIds[item.rateCategoryId].name : ''
        };
      });
      return el;
    });

    self.roomRates = activeRoomRates.map(function(el){
      var rc = self.rateCategoriesByIds[el.rateCategoryId],
          rc_title = rc ? rc.name : '',
          rr = self.roomRepresentations[el.roomRepresentationId],
          rr_title = rr ? rr.title : '';
      return {
        id: el.id,
        roomRepresentationId: el.roomRepresentationId,
        rateCategoryId: el.rateCategoryId,
        maxAdults: el.maxAdults,
        maxChildren: el.maxChildren,
        shortCode: el.shortCode,
        title: rr_title + " (" + rc_title + ")"
      };
    });
    
    self.roomRates.sort(function(a, b) {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });
  }

  function openEditForm (index) {
    if (this.editedChannel) {
      cancelEditing()
    }
    channel = self.channels[index];

    if (channel.name == 'wubook') {
      var forSyncSet = {};
      if (channel.settings.forSync && channel.settings.forSync.length) {
        channel.settings.forSync.forEach(function(id) {
          forSyncSet[id] = true;
        });
      }
      this.roomRates.forEach(function(roomRate) {
        roomRate.syncWithWubook = forSyncSet[roomRate.id] === true;
      });
    }
    this.editedChannel = index;
    this.originalEditedChannel = angular.copy(channel);

    if (channel.name == 'vertical_booking' && !channel.settings.daysCount) {
      channel.settings.daysCount = "400";
    }

    if (channel.name == 'channex') {
      channexPrepareToEdit(channel);
    }

  }

  function removeChannel (index) {
    var channel = new ChannelManagerFactory(self.channels[index]);
    channel.hotelId = $rootScope.hotel.id;
    channel
      .remove()
      .then(function (response) {
        if (response.success) {
          self.channels = _.without(self.channels, self.channels[index]);
        } else {
          $rootScope.alert(response.msg);
        }
      });
  }

  function syncChannel (index) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      var channel = new ChannelManagerFactory(self.channels[index]);
      channel.hotelId = $rootScope.hotel.id;
      channel
        .sync()
        .then(function (response) {
        });
    }, function() {});
  }

  function fetchMissingBookings (index) {
    var channel = new ChannelManagerFactory(self.channels[index]);
    channel.hotelId = $rootScope.hotel.id;
    channel
      .fetch_missing_bookings()
      .then(function (response) {
      });
  }

  function openMenu ($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  }

  function addChannel (name) {
    var channel = {
      name: name,
      is_active: false,
      is_synced: false,
      synced_at: null,
      settings: {}
    };

    if (name === "vertical_booking") {
      channel.settings.daysCount = "400";
    }
    if (name === "channex") {
      channel.settings.isProd = true;
      channel.settings.daysToSync = 500;
    }
    this.channels.push(channel);

    this.openEditForm(this.channels.length - 1);
  }

  function cancelEditing () {
    if (self.channels[self.editedChannel].id) {
      cancelEditingSavedchannel();
    } else {
      cancelEditingUnsavedchannel();
    }
  }

  function cancelEditingSavedchannel () {
    self.channels[self.editedChannel] = angular.copy(self.originalEditedChannel);
    self.originalEditedChannel = {};
    self.editedChannel = null;
  }

  function cancelEditingUnsavedchannel () {
    self.channels.pop();
    self.originalEditedChannel = {};
    self.editedChannel = null;
  }

  function saveEditing () {
    channel = self.channels[self.editedChannel];
    channel.loading = true;
    if (channel.id) {
      update();
    } else {
      create();
    }
  }

  function update () {
    var channel;
    if (self.channels[self.editedChannel].name == 'channex') {
      if (self.channels[self.editedChannel].settings.daysToSync > 730) {
        self.channels[self.editedChannel].loading = false;
        $rootScope.alert($i18next.t('general.alert_modals.channex_days_to_sync_limit_exceeded'));
        return
      }
      channel = self['prepare_' + self.channels[self.editedChannel].name + '_channel_to_save']
      .call(self, new ChannelManagerFactory(self.channels[self.editedChannel]));
    } else {
      channel = new ChannelManagerFactory(self.channels[self.editedChannel]);
    }
    channel.settings.lcode = Number(channel.settings.lcode);
    channel.settings = JSON.stringify(channel.settings);
    channel.hotelId = $rootScope.hotel.id;
    channel
      .update()
      .then(function(channel) {
        channel.visible_name = visible_names[channel.name];
        channel.loading = false;
        self.channels[self.editedChannel] = channel;
        self.editedChannel = null;
        self.originaleditedChannel = {};
      }).catch(function() {
        self.channels[self.editedChannel].loading = false;
        $rootScope.alert($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
      });
  }

  function create () {
    channel = self['prepare_' + self.channels[self.editedChannel].name + '_channel_to_save']
      .call(self, new ChannelManagerFactory(self.channels[self.editedChannel]));
    channel.settings = JSON.stringify(channel.settings);
    channel.hotelId = $rootScope.hotel.id;
    channel
      .create()
      .then(function (channel) {
        if (channel.id) {
          channel.visible_name = visible_names[channel.name];
          self.channels[self.editedChannel] = channel;
          channel.loading = false;
          self.editedChannel = null;
          self.originaleditedChannel = {};
        }
      }).catch(function() {
        self.channels[self.editedChannel].loading = false;
        $rootScope.alert($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
      });
  }

  function prepare_wubook_channel_to_save(channel) {
    channel.settings.lcode = Number(channel.settings.lcode);

    return channel;
  }

  function prepare_site_minder_channel_to_save(channel) {
    return channel;
  }

  function prepare_vertical_booking_channel_to_save(channel) {
    return channel;
  }

  function prepare_channex_channel_to_save(channel) {
    if (!channel.settings.roomRateRateCodes) {
      channel.settings.roomRateRateCodes = {};
    }

    var roomRatesByID = self.roomRates.reduce(function(acc, el) {acc[el.id] = el; return acc;}, {});
    var roomRateIDS = Object.keys(channel.settings.roomRateRateCodes);
    channel.settings.roomRateRoomCodes = roomRateIDS.reduce(function(acc, id) {
      acc[id] = channel.settings.roomTypeCodes[(roomRatesByID[Number(id)] || {}).roomRepresentationId];
      return acc;
    }, {});

    Object.keys(channel.settings.roomRateRoomCodes).forEach(function(id) {
      if (Boolean(channel.settings.roomRateRoomCodes[id]) == false) {
        channel.settings.roomRateRateCodes[id] = null;
        channel.settings.roomRateRoomCodes[id] = null;
      }
    });
    return channel;
  }

  function parseXMLToArray(csv) {
    var rows = csv.split(/\r\n|\n/);
    var controlRow = 'Room Type,Room Rate,Room Code,Rate Code,Inventory Code';
    if (rows[0] !== controlRow) {
      $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.channel_manager.alert.uploaded_csv_file_has_wrong_format_js_str'));
      return null;
    } else {
      var sm_data = rows
        .map(function(row) {return row.split(',')})
        .filter(function (row) {return row.length == 5});
      
      return {
        roomCodes: Array.from(
          new Set(
            sm_data
              .map(function(row, index) {return row[2]})
              .filter(function(row, index) {return index !== 0;})
          )
        ),
        rateCodes: Array.from(
          new Set(
            sm_data
              .map(function(row, index) {return row[3]})
              .filter(function(row, index) {return index !== 0;})
          )
        )
      }
    }
  }

  function parseVBCSVToArray(csv) {
    var rows = csv.split(/\r\n|\n/);
    var controlRow = ['"Name","Code","Update"', '"Name","Code","Update_Rates"'];
    if (controlRow.indexOf(rows[0]) == -1) {
      $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.channel_manager.alert.uploaded_csv_file_has_a_wrong_format'));
      return null;
    } else {
      var sm_data = rows
        .map(function(row) {return row.split(',').map(function(el) {return el.replace(/"/gi, '')})})
        .filter(function (row) {return row.length == 3}); 

      return Array.from(
        new Set(
          sm_data
            .filter(function(row, index) {return index !== 0 && row[2] === 'Y';})
            .map(function(row, index) {return row[1]})
        )
      )
    }
  }

  function uploadConfiguration($event) {
    var file  = $event.target.files[0];

    if (file) {
      var reader = new FileReader();
      reader.onload = function() {
        $timeout(function() {
          self.channels[self.editedChannel].settings.csvConfiguration = parseXMLToArray(reader.result);
        }, 0);
      };
      reader.readAsText(file);
    } else {
      $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.channel_manager.alert.wrong_file_format_please_use_csv_format_js_str'));
    }
  }

  function uploadVBRoomConfiguration($event) {
    var file  = $event.target.files[0];

    if (file) {
      var reader = new FileReader();
      reader.onload = function() {
        $timeout(function() {
          self.channels[self.editedChannel].settings.csvRoomConfiguration = parseVBCSVToArray(reader.result);
        }, 0);
      };
      reader.readAsText(file);
    } else {
      $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.channel_manager.alert.wrong_file_format_please_use_csv_format_js_str'));
    }
  }

  function uploadVBRateConfiguration($event) {
    var file  = $event.target.files[0];

    if (file) {
      var reader = new FileReader();
      reader.onload = function() {
        $timeout(function() {
          self.channels[self.editedChannel].settings.csvRateConfiguration = parseVBCSVToArray(reader.result);
        }, 0);
      };
      reader.readAsText(file);
    } else {
      $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.channel_manager.alert.wrong_file_format_please_use_csv_format_js_str'));
    }
  }
 
  function executePlannedTasks() {
    if (self.originalEditedChannel.id) {
      $http.post(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/sm/'+self.originalEditedChannel.id+'/planned').then(function(response) {
        setTimeout(function() {
          reloadPlanned()
        }, 1500);
      });
    }
  }

  function reloadPlanned() {
    if (self.originalEditedChannel.id) {
      $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/sm/'+self.originalEditedChannel.id+'/planned').then(function(response) {
        self.channels[self.editedChannel].planned = response.data;
      });
    }
  }

  function reloadLogs() {
    if (self.originalEditedChannel.id) {
      $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/sm/'+self.originalEditedChannel.id+'/logs').then(function(response) {
        self.channels[self.editedChannel].logs = response.data;
      });
    }
  }

  function clearLogs() {
    if (self.originalEditedChannel.id) {
      $http.post(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/sm/'+self.originalEditedChannel.id+'/logs').then(function(response) {
        self.channels[self.editedChannel].logs = response.data;
      });
    }
  }

  function openLog($index) {
    self.channels[self.editedChannel].logs[$index].openned = !self.channels[self.editedChannel].logs[$index].openned;
  }

  function clearPlanned() {
    if (self.originalEditedChannel.id) {
      $http.post(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/sm/'+self.originalEditedChannel.id+'/clear_planned').then(function(response) {
        self.channels[self.editedChannel].planned = response.data;
      });
    }
  }

  function saveHotel() {
    self.saveHotelInProgress = true;
    self.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.saveHotelInProgress = false;
      $rootScope.notify('Save successful');
    }, function (response) {
      self.saveHotelInProgress = false;
      $rootScope.notify('Error: ' + response.data.error);
    });
  }

  function normalizeWubookSettings(channel, roomRate) {
    if (!channel.settings.forSync || !channel.settings.forSync.push) {
      channel.settings.forSync = [];
    }
    var index = channel.settings.forSync.indexOf(roomRate.id);
    if (roomRate.syncWithWubook) {
      if (index === -1) {
        channel.settings.forSync.push(roomRate.id);
      }
    } else {
      if (index !== -1) {
        channel.settings.forSync.splice(index, 1);
      }
    }
  }

  function installChannexWebhook(channel, hotel) {
    if ((channel.settings.apiPublicKey && channel.settings.apiSecretKey) || channel.settings.apiKey) {
      channel.loading = true;
      ChannexAPI.installWebhook(
        channel.settings.apiPublicKey,
        channel.settings.apiSecretKey,
        channel.settings.isProd,
        [hotel.id],
        channel.id,
        channel.settings.apiKey
      ).then(function(response) {
        if (response.data.success) {
          Object.keys(response.data.result).forEach(function(k) {
            channel.settings.webhooks[k] = response.data.result[k];
          });
        }
        channel.loading = false;
      }, function(error) {
        channel.loading = false;
        $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.wrong_credentials'));
      });
    } else {
      $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.enter_credentials'));
    }

  }

  function loadChannexHotels(channel) {
    if ((channel.settings.apiPublicKey && channel.settings.apiSecretKey) || channel.settings.apiKey) {
      channel.loading = true;
      ChannexAPI.getHotels(
        channel.settings.apiPublicKey,
        channel.settings.apiSecretKey,
        channel.settings.isProd,
        channel.settings.apiKey
      )
        .then(function(response) {
          if (response.data.success) {
            // Drop hotel mapping for non-existent properties
            // Do not allow to miss room type
            var possibleHotelIds = response.data.hotels.map(function(el) { return el.id });
            self.mixedRoomTypes.forEach(function(el) {
              if (el['propertyId'] && possibleHotelIds.indexOf(el['propertyId']) == -1) {
                delete el['propertyId'];
                delete channel.settings['roomTypeCodes'][el.id];
                el.roomRates.forEach(function(rate) {
                  delete channel.settings['roomRateRoomCodes'][rate.id];
                  delete channel.settings['roomRateRateCodes'][rate.id];
                });
              }
            });

            channel.settings.hotels = response.data.hotels.map(function(el) {
              return {
                title: el.title,
                id: el.id,
                roomTypes: self.mixedRoomTypes.filter(function(e) { return e['propertyId'] == el.id; })
              };
            }).sort(function(a,b) {
              if (a.title > b.title) return 1;
              if (a.title < b.title) return -1;
              return 0;
            });

            channel.settings.hotels.push({
              title: "Unmapped",
              roomTypes: self.mixedRoomTypes.filter(function(e) { return !e['propertyId']; })
            })

            loadFromChannex(channel);
          } else {
            $rootScope.notify(response.data.errors);
          }
          channel.loading = false;
        }, function(error) {
          channel.loading = false;
          $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.wrong_credentials'));
        });
    } else {
      $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.enter_credentials'));
    }
  }

  function loadFromChannex(channel) {
    if (channel.settings.hotelCode) {
      if (!(channel.settings.hotelCode instanceof Array)){
        channel.settings.hotelCode = [channel.settings.hotelCode];
      }
      channel.loading = true;
      ChannexAPI.getRoomsAndRates(
        channel.settings.apiPublicKey,
        channel.settings.apiSecretKey,
        channel.settings.isProd,
        channel.settings.hotelCode.join(','),
        channel.settings.apiKey
      )
        .then(function(response) {
          if (response.data.success) {
            ratePlans = response.data.rate_plans.map(function(el) {
              var option = el.options.filter(function(el) {return el.is_primary;})[0];
              return {
                id: el.id,
                title: el.title + " (O:"+option.occupancy+")",
                propertyId: el.property_id,
                roomTypeId: el.room_type_id
              }
            });
            channel.settings.roomTypesArray = response.data.room_types.map(function(el) {
              return {
                id: el.id,
                title: el.title,
                propertyId: el.property_id,
                ratePlans: ratePlans.filter(function(item) {return item.roomTypeId == el.id;})
              };
            });
            channel.settings.roomTypes = channel.settings.roomTypesArray.reduce(function(acc, el) {
              acc[el.id] = el;
              return acc;
            }, {});
          } else {
            $rootScope.notify(response.data.errors);
          }
          channel.loading = false;
        });
    }
  }

  function channexUpdateHotel(channel, hotel, roomType) {
    moveTo = channel.settings.hotels.filter(function(h) { return h.id == roomType.propertyId; })[0];
    if (moveTo) {
      // Unmapped hotel
      hotel.roomTypes.splice(hotel.roomTypes.indexOf(roomType), 1);
      moveTo.roomTypes.push(roomType);
    }
  }

  function createChannexHotel(channel) {
    channel.loading = true;
    ChannexAPI.createHotel(
      channel.settings.apiPublicKey,
      channel.settings.apiSecretKey,
      channel.settings.isProd,
      channel.settings.apiKey
    )
      .then(function(response) {
        if (response.status == 200) {
          if (!channel.settings.hotels) {
            channel.settings.hotels = [];
          }

          if (channel.settings.hotels.length == 0) {
            channel.settings.hotels.push({
              title: "Unmapped",
              roomTypes: []
            });
          }

          h = {
              title: response.data.hotel.attributes.title,
              id: response.data.hotel.attributes.id,
              roomTypes: []
            }
          channel.settings.hotels.splice(channel.settings.hotels.length - 1, 0, h);

          channel.settings.hotelCode.push(response.data.hotel.attributes.id);
          channel.settings.hotelCodeCache.push(response.data.hotel.attributes.id);

          if (channel.settings.hotelCode.length == 1) {
            // Map all room types to hotel if there is no other hotels
            channexMoveUnmapped(channel, h);
          }

          channel.loading = false;
          loadFromChannex(channel);
        } else {
          channel.loading = false;
          $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.loading_error'));
        }
      });
  }
  
  function createChannexRoomType(channel, hotel, roomType) {
    channel.loading = true;
    ChannexAPI.createRoomType(
      channel.settings.apiPublicKey,
      channel.settings.apiSecretKey,
      channel.settings.isProd,
      hotel.id,
      roomType.id,
      channel.settings.apiKey
    )
      .then(function(response) {
        if (response.status == 200) {
          channel.settings.roomTypes[response.data.room_type.attributes.id] = {
            id: response.data.room_type.attributes.id,
            title: response.data.room_type.attributes.title,
            propertyId: response.data.room_type.relationships.property.data.id,
            ratePlans: []
          };
          channel.settings.roomTypesArray.push(channel.settings.roomTypes[response.data.room_type.attributes.id]);

          if (!channel.settings.roomTypeCodes) {
            channel.settings.roomTypeCodes = {}
          }
          channel.settings.roomTypeCodes[roomType.id] = response.data.room_type.attributes.id;
        } else {
          $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.loading_error'));
        }
        channel.loading = false;
      }, function(response) {
        channel.loading = false;
        $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.loading_error'));
      });
  }
  
  function createChannexRate(channel, hotel, roomType, ratePlan) {
    channel.loading = true;
    ChannexAPI.createRatePlan(
      channel.settings.apiPublicKey,
      channel.settings.apiSecretKey,
      channel.settings.isProd,
      hotel.id,
      channel.settings.roomTypeCodes[roomType.id],
      ratePlan.id,
      channel.settings.apiKey
    )
      .then(function(response) {
        if (response.status == 200) {
          var option = response.data.room_rate.attributes.options.filter(function(el) {return el.is_primary;})[0];
          channel.settings.roomTypes[response.data.room_rate.relationships.room_type.data.id].ratePlans.push({
            id: response.data.room_rate.attributes.id,
            title: response.data.room_rate.attributes.title + " ("+option.occupancy+")",
            propertyId: response.data.room_rate.relationships.property.data.id,
            roomTypeId: response.data.room_rate.relationships.room_type.data.id
          })
          if (!channel.settings.roomRateRateCodes) {
            channel.settings.roomRateRateCodes = {}
          }
          channel.settings.roomRateRateCodes[ratePlan.id] = response.data.room_rate.attributes.id;
        } else {
          $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.loading_error'));
        }
        channel.loading = false;
      }, function(response) {
        channel.loading = false;
        $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.channel_manager.loading_error'));
      });
  }
  function channexProcessHotelsChange(channel) {
    channel.needUpdate = !_.isEqual(channel.settings.hotelCode, channel.settings.hotelCodeCache);
  }

  function channexApplyHotelsChange(channel) {
    channel.needUpdate = false;
    unmapped = channel.settings.hotels[channel.settings.hotels.length - 1];
    (channel.settings.hotelCode || []).forEach(function(id) {
      if (channel.settings.hotelCodeCache.indexOf(id) === -1) {
        var h = channel.settings.hotels.filter(function(h) { return h.id == id})[0];
        h.roomTypes.forEach(function(rt) {
          if (channel.settings.roomTypeCodes && channel.settings.roomTypeCodes[rt.id]) {
            delete channel.settings.roomTypeCodes[rt.id];
          }
          rt.roomRates.forEach(function(rr) {
            delete channel.settings.roomRateRateCodes[rr.id];
          })
          delete rt.propertyId;
          unmapped.roomTypes.push(rt);
        });
        h.roomTypes.splice(0, h.roomTypes.length);
      }
    })
    angular.copy(channel.settings.hotelCodeCache, channel.settings.hotelCode);
    if ((channel.settings.hotelCode || []).length == 1) {
      var h = channel.settings.hotels.filter(function(h) { return h.id == channel.settings.hotelCode[0]})[0];
      channexMoveUnmapped(channel, h);
    }
    loadFromChannex(channel);
  }

  function channexUnmapRoomType(channel, h, rt) {
    unmapped = channel.settings.hotels[channel.settings.hotels.length - 1];
    h.roomTypes.splice(h.roomTypes.indexOf(rt), 1);
    if (channel.settings.roomTypeCodes && channel.settings.roomTypeCodes[rt.id]) {
      delete channel.settings.roomTypeCodes[rt.id];
    }
    rt.roomRates.forEach(function(rr) {
      delete channel.settings.roomRateRateCodes[rr.id];
    })
    delete rt.propertyId;
    unmapped.roomTypes.push(rt);
  }

  function channexPrepareToEdit(channel) {
    if (!channel.id) {
      channel.settings.hotelCode = [];
      channel.settings.roomRateRoomCodes = [];
    }
    if (channel.settings.roomTypeCodes == undefined) {
      channel.settings.roomTypeCodes = {};
    }

    if (!(channel.settings.hotelCode instanceof Array)){
      channel.settings.hotelCode = [channel.settings.hotelCode];
    }
    channel.settings.hotelCodeCache = angular.copy(channel.settings.hotelCode);
    channel.settings.hotels = [];

    self.mixedRoomTypes.forEach(function(rt) {
      channex_rt = channel.settings.roomTypeCodes[rt.id]
      if (channex_rt && channel.settings.roomTypes[channex_rt]) {
        rt.propertyId = channel.settings.roomTypes[channex_rt].propertyId
      } else {
        rt.propertyId = channel.settings.roomTypeCodes[rt.id] || rt.roomRates.map(function(e){ return channel.settings.roomRateRoomCodes[e.id]; }).filter(function(e) { return e }).map(function(e) { return channel.settings.roomTypes[e].propertyId })[0];
      }

    });
    if (!channel.settings.webhooks) {
      channel.settings.webhooks = {};
    }
    loadChannexHotels(channel);
  }

  function channexMoveUnmapped(channel, hotel) {
    var unmapped = channel.settings.hotels[channel.settings.hotels.length - 1];
    var index = unmapped.roomTypes.length;
    while (index > 0) {
      index -= 1;
      var rt = unmapped.roomTypes[0];
      rt.propertyId = hotel.id;
      channexUpdateHotel(channel, unmapped, rt);
    }
  }

  function initIfPossibleAndNeeded() {
    if ($rootScope.hotel && $rootScope.hotel.roomRates && !self.initialized) {
      self.init();
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', initIfPossibleAndNeeded);
  var roomRatesLoadedListener = $rootScope.$on('roomRates:loaded', initIfPossibleAndNeeded);

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }

    if (roomRatesLoadedListener) {
      roomRatesLoadedListener();
    }
  });

  initIfPossibleAndNeeded();
}

angular
  .module("buuqit")
  .controller("Settings.BookingEngineSettingsController", BookingEngineSettingsController);

BookingEngineSettingsController.$inject = ["$rootScope", "$scope", "$filter", "$timeout", "$i18next", "BookingOptionFactory", "Globalize"];

function BookingEngineSettingsController ($rootScope, $scope, $filter, $timeout, $i18next, BookingOptionFactory, Globalize) {
  var self = this;
  var defaultCustomizationValues = {
    bodyBackgroundColor: '#ffffff',
    navigationBackgroundColor: '#ffffff',
    navigationAdditionalControlColor: '#576979',
    contentPanelBackgroundColor: '#ffffff',
    mainPrimaryColor: '#4285f4',
    mainSuccessColor: '#3cc474',
    mainTextColor: '#363b3d',
    infoTextColor: '#949eaf',
    mainPrimaryButtonTextColor: '#ffffff',
    mainSuccessButtonTextColor: '#ffffff',
  };

  function init() {
    self.hotel = $rootScope.hotel;
    self.newProfile.rateCategoryIds = $rootScope.hotel.rateCategories
      .filter(function(el) { return el.isRemoved === false && el.channelOnly !== true; })
      .map(function(el) { return el.id; });
    self.newProfile.roomRepresentationIds = $rootScope.hotel.roomRepresentations
      .map(function(el) { return el.id; });
    self.newProfile.extraIds = [];
    self.newProfile.propertyIds = $rootScope.hotel.properties
      .map(function(el) { return el.id; });
    self.newProfile.currency = $rootScope.hotel.currency;
    self.profiles = $rootScope.hotel.bookingOptions;
    self.appendRoomTypeProfiles();
    self.memberIsActive = $rootScope.hotel.membershipActive;
    self.slug = $rootScope.hotel.slug;
    self.profiles.forEach(function(profile) {
      if (profile.questions !== undefined && profile.questions !== null) {
        profile.questions.forEach(function(question) {
          Globalize.loadTranslation(question, ['question', 'options']);
        })
      }
    })
  }

  function add() {
    self.addFormIsVisible = true;
    self.originalNewProfile = angular.copy(self.newProfile);
  }

  function edit(profile) {
    self.originalProfile = angular.copy(profile);
    if (profile.questions === null) {
      profile.questions = [];
    }
    if (profile.advancedOptions === null) {
      profile.advancedOptions = Object.assign({}, defaultCustomizationValues);
    } else {
      // set default customization value if previously not set
      var customizationFileds = Object.keys(defaultCustomizationValues);
      customizationFileds.forEach(function(cf) {
        if (!profile.advancedOptions.hasOwnProperty(cf) || (profile.advancedOptions.hasOwnProperty(cf) && profile.advancedOptions[cf] === '')) {
          profile.advancedOptions[cf] = defaultCustomizationValues[cf];
        }
      });
    }
    profile.availableFrom = moment(profile.advancedOptions.availableFrom).toDate();
    profile.availableTo = moment(profile.advancedOptions.availableTo).toDate();
    profile.passwordProtectionIsEnabled = Boolean(profile.bookingPassword);
    profile.edited = true;
  }

  function remove(profile) {
    profile.loading = true;
    new BookingOptionFactory(profile)
      .remove()
      .then(function(data) {
        if (data.success) {
          $rootScope.hotel.bookingOptions = _.without($rootScope.hotel.bookingOptions, profile);
          self.profiles = $rootScope.hotel.bookingOptions;
        } else {
          $rootScope.alert(data.message);
        }
      }, function(response) {
        console.error('Error removing booking option:', response);
        $rootScope.alert(response.data.message);
      })
      .finally(function() {
        profile.loading = false;
      });
  }

  function cancelEdit(profile) {
    var index = self.profiles.indexOf(profile);
    self.profiles[index] = angular.copy(self.originalProfile);
  }

  function cancelAdd(profile) {
    self.addFormIsVisible = false;
    self.newProfile = angular.copy(self.originalNewProfile);
  }

  function cancel(profile) {
    if (profile.id) {
      cancelEdit(profile)
    } else {
      cancelAdd(profile);
    }
  }

  function updateEntry(profile) {
    profile.loading = true;
    if (profile.passwordProtectionIsEnabled == false) {
      profile.bookingPassword = '';
    }
    var index = $rootScope.hotel.bookingOptions.indexOf($rootScope.hotel.bookingOptions.filter(function(el) {
      return el.id === profile.id;
    })[0]);
    new BookingOptionFactory(profile)
      .save()
      .then(function(data) {
        if (data.success !== false) {
          data.loading = false;
          data.edited = false;
          if (data.questions !== undefined && data.questions !== null) {
            data.questions.forEach(function(question) {
              Globalize.loadTranslation(question, ['question', 'options']);
            });
          }
          $rootScope.hotel.bookingOptions[index] = data;
        } else {
          profile.loading = false;
          $rootScope.alert(data.message);
        }
      }, function(response) {
        console.error('Error saving entry:', response);
        $rootScope.alert($filter('stringifyErrors')(response.data.errors));
        profile.loading = false;
      });
  }

  function createEntry(profile) {
    profile.loading = true;
    if (profile.passwordProtectionIsEnabled == false) {
      profile.bookingPassword = '';
    }
    new BookingOptionFactory(profile)
      .create()
      .then(function(data) {
        cancelAdd(profile);
        data.loading = false;
        if (data.questions !== undefined && data.questions !== null) {
          data.questions.forEach(function(question) {
            Globalize.loadTranslation(question, ['question', 'options']);
          });
        }
        $rootScope.hotel.bookingOptions.push(data);
      }, function(response) {
        console.error('Error creating entry:', response);
        $rootScope.alert($filter('stringifyErrors')(response.data.errors));
        profile.loading = false;
      });
  }

  function parseGoogleAdwords(options) {
    if (options.googleAdwordsRawCode) {
      var google_conversion_id_regexp = /google_conversion_id = (.*);/gi;
      var google_conversion_label_regexp = /google_conversion_label = "(.*)";/gi;
      var google_conversion_currency_regexp = /google_conversion_currency = "(.*)";/gi;
      var google_remarketing_only_regexp = /google_remarketing_only = (.*);/gi;
      var results = {
        google_conversion_id: google_conversion_id_regexp.exec(options.googleAdwordsRawCode),
        google_conversion_label: google_conversion_label_regexp.exec(options.googleAdwordsRawCode),
        google_conversion_currency: google_conversion_currency_regexp.exec(options.googleAdwordsRawCode),
        google_remarketing_only: google_remarketing_only_regexp.exec(options.googleAdwordsRawCode),
      }
      options.googleAdwords = {
        google_conversion_id: results['google_conversion_id'] ? Number(results['google_conversion_id'][1]) : null,
        google_conversion_label: results['google_conversion_label'] ? results['google_conversion_label'][1] : null,
        google_conversion_currency: results['google_conversion_currency'] ? results['google_conversion_currency'][1] : null,
        google_remarketing_only: results['google_remarketing_only'] ? results['google_remarketing_only'][1] == 'true' : null,
      }
    } else {
      delete options['googleAdwords'];
    }

    return options;
  }

  function prepareAvailabilityLimits(profile, options) {
    if (options.setAvailableActive) {
      options.availableFrom = moment(profile.availableFrom).format().slice(0,10);
      options.availableTo = moment(profile.availableTo).format().slice(0,10);
    } else {
      delete options.availableFrom
      delete options.availableTo
    }
    return options;
  }

  function prepareAdvanceOptions(profile, options) {
    options = prepareCustomization(options);
    options = parseGoogleAdwords(options);
    options = prepareAvailabilityLimits(profile, options);
    return JSON.stringify(options);
  }

  function prepareCustomization(options) {
    var customizationFileds = Object.keys(defaultCustomizationValues);
    customizationFileds.forEach(function(cf) {
      if (defaultCustomizationValues[cf] === options[cf]) {
        options[cf] = '';
      }
    });
    return options;
  }

  function save(profile) {
    var profileToSave = angular.copy(profile);
    profileToSave.hotelId = $rootScope.hotel.id;

    profileToSave.questions.forEach(function(q) {
      Globalize.updateCurrentTranslation(q, ['question', 'options']);
    });

    profileToSave.questions = JSON.stringify(profileToSave.questions);
    profileToSave.advancedOptions = prepareAdvanceOptions(profileToSave, profileToSave.advancedOptions);

    if (profileToSave.id) {
      updateEntry(profileToSave)
    } else {
      createEntry(profileToSave);
    }
  }

  function getLinkURL(slug) {
    return (window.location.origin.indexOf("localhost") > -1 ? "http://localhost:3005" : window.location.origin)
         + "/" + self.slug + "/book/" + (slug ? slug : "");
  }

  function appendRoomTypeProfiles() {
    var defaultProfile = self.profiles.filter(function(el) {
      return el.isDefault;
    });

    $rootScope.hotel.roomRepresentations.forEach(function(rr) {
      var profile = angular.copy(defaultProfile);
      profile.title = rr.title;
      profile.isDefault = false;
      profile.virtual = true;
      profile.slug = '__room_type_' + rr.shortCode;

      var savedProfile = self.profiles.filter(function(el) {
        return el.slug == profile.slug;
      });

      if (savedProfile.length == 0) {
        self.profiles.push(profile);
      }
    });
  }

  angular.extend(this, {
    addFormIsVisible: false,
    profiles: [],
    newProfile: {
      addressIsRequired: true,
      phoneIsRequired: true,
      creditCardIsRequired: true,
      allowZeroPrice: false,
      namePerRoomIsRequired: false,
      bookingPassword: "",
      hideAddressAtDesktop: false,
      hideAddressAtMobile: false,
      hidePhoneAtDesktop: false,
      hidePhoneAtMobile: false,
      showMemberAtStart: false,
      allowStripeThreeDFail: false,
      askForGuestNationality: false,
      orderByPriority: false,
      questions: [],
      isDefault: false,
      title: "",
      slug: "",
      promocode: null,
      language: 'en',
      advancedOptions: Object.assign({}, defaultCustomizationValues),
    },
    dropins: [
      ['Hotel Name', '{{hotel_name}}'],
      ['Hotel City', '{{hotel_city}}'],
      ['Hotel Address', '{{hotel_address}}'],
      ['Hotel Country', '{{hotel_country}}'],
      ['Hotel Postal Code','{{hotel_postal_code}}'],
      ['Hotel State','{{hotel_state}}'],
      ['Hotel Email','{{hotel_email}}'],
    ],
    editorSelectors: [],
    add: add,
    edit: edit,
    remove: remove,
    cancel: cancel,
    save: save,
    saveHotel: saveHotel,
    getLinkURL: getLinkURL,
    changeLang: changeLang,
    wysiwygPaste: wysiwygPaste,
    appendRoomTypeProfiles: appendRoomTypeProfiles,
    openMenu: function($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    },
    insertDropIn: insertDropIn,
  });

  if ($rootScope.hotel) {
    init();
  }

  var hotelWatcher = $rootScope.$watch("hotel", function () {
    if (typeof($rootScope.hotel) != "undefined") { init(); }
  });

  function saveHotel () {
    if (!self.hotel) {
      return;
    }
    if (self.loading) {
      return;
    }

    self.loading = true;
    Globalize.updateCurrentTranslation(self.hotel, 'hotel');
    self.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.loading = false;

      Globalize.loadTranslation(self.hotel, 'hotel');
      $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str'));
    }).catch(function (error) {
      console.error('Error saving hotel settings', error);
      self.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  function insertDropIn(editor, dropin) {
    if (self.editorSelectors.indexOf(editor) === -1) {
      self.editorSelectors.push(editor);
    }
    angular.element('[data-role="' + editor + '"]').summernote('insertText', dropin);
  }

  function wysiwygPaste (e) {
    var thisNote = $(e.currentTarget);
    var updatePastedText = function(someNote){
      var original = someNote.code();
      var cleaned = (function(original){
        var stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
        var output = original.replace(stringStripper, ' ');
        var commentSripper = new RegExp('<!--(.*?)-->','g');
        var tagStripper = new RegExp('<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>','gi');
        var badTags = ['style', 'script','applet','embed','noframes','noscript'];
        output = output.replace(commentSripper, '');
        output = output.replace(tagStripper, '');

        for (var i=0; i< badTags.length; i++) {
          tagStripper = new RegExp('<'+badTags[i]+'.*?'+badTags[i]+'(.*?)>', 'gi');
          output = output.replace(tagStripper, '');
        }
        var badAttributes = ['style', 'start'];
        for (var x=0; x< badAttributes.length; x++) {
          var attributeStripper = new RegExp(' ' + badAttributes[x] + '="(.*?)"','gi');
          output = output.replace(attributeStripper, '');
        }
        return output;
      })(original);
      someNote.code('').html(cleaned);
    };
    $timeout(function () {
      updatePastedText(thisNote);
    }, 10);
  }

  function changeLang(old_locale) {
    profiles = self.profiles.map(function(p){ return p.questions || []; }).concat([self.newProfile.questions]);
    profiles.forEach(function(questions){
      questions.forEach(function(question) {
        if (question.translations == undefined) {
          question.translations = [{
            'locale': old_locale || $rootScope.hotel.locale,
            'question': question.question,
            'options': question.options
          }];
        }
        Globalize.saveTranslation(question, ['question', 'options'], old_locale);
        Globalize.loadTranslation(question, ['question', 'options']);
      })
    });
    if (self.hotel) {
      Globalize.saveTranslation(self.hotel, 'hotel', old_locale);
      Globalize.loadTranslation(self.hotel, 'hotel');
    }
  }
  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.ApiKeyController', ApiKeyController);

ApiKeyController.$inject = ["$rootScope", "$scope", "$i18next"];

function ApiKeyController ($rootScope, $scope, $i18next) {

  angular.extend(
    this,
    {
      api_key : null,
      loaded : false,

      generate_api_key : generate_api_key,
      copy: copy,
    }
  );

  function init () {
    if ($rootScope.hotel) {
      $scope.api_key = $rootScope.hotel.apiKey;
      $scope.loaded = true;
    }
  }

  function generate_api_key () {
    $rootScope.hotel.generate_api_key().then(function (hotel) {
      $scope.api_key = hotel.apiKey;
    }).catch(function (error) {
      console.error('Error generating API key', error);
    });
  }

  function copy() {
    var el = angular.element('.api-key-textarea');
    el[0].select();
    document.execCommand("copy");
    $rootScope.notify($i18next.t('common_for_app.notify.copy_notification'));
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.HotelEmailSetupController', HotelEmailSetupController);

HotelEmailSetupController.$inject = [
  "$rootScope",
  "$scope",
  "$timeout",
  "$i18next",
  "Globalize",
  "EmailSystemConfigFactory"
];

function HotelEmailSetupController ($rootScope, $scope, $timeout, $i18next, Globalize, EmailSystemConfigFactory) {
  var self = this;

  angular.extend(
    this,
    {
      init : init,
      save : save,
      initTimeout : null,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      self.initTimeout = $timeout(init, 0);
    }
  });

  function loadSystemEmailConfig() {
    EmailSystemConfigFactory.get({ hotelId: $rootScope.hotel.id }).then(function (response) {
      self.notificationEmail = response.systemConfig.notificationEmail;
    });
  }

  function init () {
    if ($rootScope.hotel) {
      angular.extend(
        self,
        {
          loading    : false,
          hotel     : $rootScope.hotel
        }
      );

      loadSystemEmailConfig();
    }
  }

  function save () {
    var self = this;
    if (!self.notificationEmail) {
      return;
    }
    self.hotel.notificationEmail = self.notificationEmail;
    this.loading = true;
    this.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.loading = false;
      Globalize.loadTranslation(self.hotel, 'hotel');
      $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str'));
    }, function (error) {
      console.error('Error saving hotel settings', error);
      this.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
      self.initTimeout = null;
    }
  });
}
angular
  .module('buuqit')
  .controller('Settings.EmailSetupController', EmailSetupController)
  .component(
    'reactEmailTemplateBuilder',
    window.TBFLibs.react2angular(
      window.TBFLibs.EmailTemplateBuilder,
      [
        'baseTemplate',
        'baseTemplateJson',
        'additionalTemplate',
        'container',
        'mergeTags',
        'hotelId',
        'onSave',
        'onSend',
        'emailType',
        'shouldSave',
        'onLoadBeeFreeToken',
      ],
      []
    )
  );

EmailSetupController.$inject = [
  "$rootScope",
  "$scope",
  "$timeout",
  "$i18next",
  "$filter",
  "$mdDialog",
  "EmailTemplateFactory",
  "Globalize",
  "EmailTemplatePreviewFactory",
  "BeeFreeFactory",
  "EmailTemplatesListFactory",
  "EmailSystemConfigFactory"
];

function EmailSetupController ($rootScope, $scope, $timeout, $i18next, $filter, $mdDialog, EmailTemplateFactory, Globalize, EmailTemplatePreviewFactory, BeeFreeFactory, EmailTemplatesListFactory, EmailSystemConfigFactory) {
  var self = this;
  var defaultCustomizationValues = {
    confirmationHeaderInfoTextColor: '#003580',
    titleTextColor: '#2d90d1',
    reservationDetailsBackgroundColor: '#71bb6e',
    reservationDetailsTextColor: '#ffffff',
    roomDetailsBackgroundColor: '#eafbe9',
    roomDetailsTextColor: '#000000',
    roomPriceAndNightsColor: '#57a571',
  };

  angular.extend(
    this,
    {
      init : init,
      save : save,
      openAddEmailTemplateForm    : openAddEmailTemplateForm,
      closeAddEmailTemplateForm   : closeAddEmailTemplateForm,
      saveAddEmailTemplate        : saveAddEmailTemplate,
      saveNewEmailTemplate        : saveNewEmailTemplate,
      saveAddEmailTemplateForm    : saveAddEmailTemplateForm,
      removeEmailTemplate         : removeEmailTemplate,
      editEmailTemplate           : editEmailTemplate,
      closeEditedEmailTemplate    : closeEditedEmailTemplate,
      saveEditedEmailTemplate     : saveEditedEmailTemplate,
      saveTemplate                : saveTemplate,
      saveEmailTemplate           : saveEmailTemplate,
      openEmailTemplateBuilder    : openEmailTemplateBuilder,
      changeLang                  : changeLang,
      saveHotelChanges            : saveHotelChanges,
      onSave                      : onSave,
      onSendTestLetter            : onSendTestLetter,
      onLoadBeeFreeToken          : onLoadBeeFreeToken,
      onLoadEmailTemplates        : onLoadEmailTemplates,
      mergeTags: getMergeTags(),
      shouldSave: false,
      openedEmailTemplateBuilder: '',
      addNewEmailTemplate : false,
      newEmailTemplate : {
        name : null,
        text : null
      },
      arrival_days: (function() {
        var days = [];
        for (var x = 1; x <= 20; x++) { days.push(x); }
        return days;
      })(),
      initTimeout: null,
      emailSystemConfig: null,
    }
  );

  var hotelWatcher = $rootScope.$watch('hotel', function (hotel) {
    if (hotel && hotel.id) {
      if (self.initTimeout) {
        $timeout.cancel(self.initTimeout);
      }
      self.initTimeout = $timeout(init, 0);
    }
  });

  function loadSystemEmailConfig() {
    EmailSystemConfigFactory.get({ hotelId: $rootScope.hotel.id }).then(function (response) {
      self.emailSystemConfig = response.systemConfig;
    });
  }

  function init () {
    if ($rootScope.hotel) {
      angular.extend(
        self,
        {
          loaded    : false,
          hotel     : $rootScope.hotel
        }
      );

      Globalize.loadTranslation(self.hotel, 'hotel');

      if (_.isEmpty(self.hotel.postArrivalEmailSubject)) {
        self.hotel.postArrivalEmailSubject = $i18next.t('profile_nav.settings.booking_engine.email_setup.post_departure.email_subject_js_str', {hotel_name: self.hotel.name});
      }

      if (_.isEmpty(self.hotel.postArrivalEmailBody)) {
        self.hotel.postArrivalEmailBody = $i18next.t('profile_nav.settings.booking_engine.email_setup.post_departure.email_body_js_str', {hotel_name: self.hotel.name, hotel_city: self.hotel.city, this_hotel_name: self.hotel.name, hotel_city: self.hotel.city});
      }

      loadEmailTemplates();
      loadSystemEmailConfig();
    }
  }

  function loadEmailTemplates() {
    EmailTemplatesListFactory('email')
      .get({ hotel_id: $rootScope.hotel.id })
      .then(function (emailTemplates) {
        self.hotel.emailTemplates = emailTemplates;
        self.hotel.originalEmailTemplates = emailTemplates;
      })
      .catch(function (error) {
        console.error("Failed to load templates:", error);
        $rootScope.notify("Failed to load email templates.");
      });
  }

  function getMergeTags() {
    return dropins.map(function(dropin) {
      return { name: dropin[0], value: dropin[1]};
    });
  }

  function prepareCustomization(options) {
    var customizationFileds = Object.keys(defaultCustomizationValues);
    customizationFileds.forEach(function(cf) {
      if (!options.hasOwnProperty(cf) || (options.hasOwnProperty(cf) && (options[cf] === '' || options[cf].length < 7))) {
        options[cf] = defaultCustomizationValues[cf];
      }
    });
    return options;
  }

  function openEmailTemplateBuilder(emailBuilderType, hasTemplate) {
    this.openedEmailTemplateBuilder = emailBuilderType;
    this.shouldSave = false;
    if (self.addNewEmailTemplate) {
      self.closeAddEmailTemplateForm();
    }
    self.hotel.emailTemplates = angular.copy(self.hotel.originalEmailTemplates);
    if (!hasTemplate) {
      onLoadEmailTemplates(emailBuilderType);
    }
  }

  function onSave (template, templateJson, emailType) {
    self.hotel[emailType] = template;
    self.hotel[emailType + 'Json'] = templateJson;
    self.saveHotelChanges();
    
  }

  function saveHotelChanges () {
    var self = this;
    self.loaded = true;
    Globalize.updateCurrentTranslation(self.hotel, 'hotel');
    self.emailSystemConfig.emailSettings.preferences['bookingMailer.newConfirmation.customizationColors'] = prepareCustomization(self.emailSystemConfig.emailSettings.preferences['bookingMailer.newConfirmation.customizationColors']);
    self.hotel.save().then(function (data) {
        $rootScope.hotel = data;
        self.loaded = false;
        self.shouldSave = false;
        Globalize.loadTranslation(self.hotel, 'hotel');
        $rootScope.notify($i18next.t('profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str'));
    }, function (response) {
      console.error('Error saving hotel settings', response);
      $rootScope.alert($filter('stringifyErrors')(response.data.errors));
    });
  }

  function save () {
    if (this.openedEmailTemplateBuilder) {
      this.shouldSave = true;
    } else {
      self.saveHotelChanges();
    }
  }

  function openAddEmailTemplateForm () {
    self.openEmailTemplateBuilder('newEmailTemplate', true);
    this.originalEmailTemplate = angular.copy(this.newEmailTemplate);
    this.addNewEmailTemplate = true;
  }

  function closeAddEmailTemplateForm () {
    this.newEmailTemplate = angular.copy(this.originalEmailTemplate);
    this.addNewEmailTemplate = false;
    this.shouldSave = false;
    this.openedEmailTemplateBuilder = '';
  }

  function saveNewEmailTemplate (model) {
    new EmailTemplateFactory(model).create().then(function (data) {
      self.hotel.originalEmailTemplates.push(data);
      self.hotel.emailTemplates.push(data);

      self.closeAddEmailTemplateForm();
    });
  }

  function saveAddEmailTemplateForm () {
    if (this.openedEmailTemplateBuilder === 'newEmailTemplate') {
      this.shouldSave = true;
    } else {
      model = angular.copy(this.newEmailTemplate);
      model.hotelId = $rootScope.hotel.id;

      self.saveNewEmailTemplate(model);
    }
  }

  function saveAddEmailTemplate (text, textJson) {
    model = angular.copy(self.newEmailTemplate);
    model.hotelId = $rootScope.hotel.id;
    model.text = text;
    model.textJson = JSON.stringify(textJson);

    self.saveNewEmailTemplate(model);
  }

  function removeEmailTemplate (index) {
    var confirm = $mdDialog.confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.confirm'))
      .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
      var model = self.hotel.originalEmailTemplates[index];

      model.hotelId = self.hotel.id;

      new EmailTemplateFactory(model)
        .remove()
        .then(function (data) {
          if (data.success) {
            self.hotel.emailTemplates.splice(index, 1);
            self.hotel.originalEmailTemplates.splice(index, 1);
          } else {
            $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.email_setup.alert.something_went_wrong_try_again_later_or_contact_with_admin_js_str'));
          }
        }, function (error) {
          console.error('Error removing email template', error);
          $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.email_setup.alert.something_went_wrong_try_again_later_or_contact_with_admin_js_str'));
        });
    }, function() {});
  }

  function editEmailTemplate (index) {
    var templateContainer = "editTemplate-" + index;
    self.openEmailTemplateBuilder(templateContainer, true);
    self.originalEmailTemplate = angular.copy(self.hotel.originalEmailTemplates[index]);
    self.hotel.emailTemplates[index].edited = true;
    self.hotel.emailTemplates.map(function(et, ind) {
      if (ind !== index) {
        self.hotel.emailTemplates[ind] = angular.copy(self.hotel.originalEmailTemplates[ind]);
      }
    })
  }

  function closeEditedEmailTemplate (event, index) {
    event.preventDefault();
    this.hotel.emailTemplates[index] = angular.copy(this.hotel.originalEmailTemplates[index]);
  }

  function saveEmailTemplate (text, textJson, index) {
    var template = self.hotel.emailTemplates[index];
    template.text = text;
    template.textJson = JSON.stringify(textJson);
    template.hotelId = self.hotel.id;

    self.saveEditedEmailTemplate(template, index);
  }

  function saveEditedEmailTemplate (template, index) {
    new EmailTemplateFactory(template)
      .save()
      .then(function (data) {
        data.edited = false;
        self.hotel.emailTemplates[index] = data;
        self.hotel.originalEmailTemplates = angular.copy(self.hotel.emailTemplates);
        self.originalEmailTemplate = angular.copy(self.newEmailTemplate);
      }, function (error) {
        console.error('Error saving email template', error);
        $rootScope.alert($i18next.t('profile_nav.settings.booking_engine.email_setup.alert.something_went_wrong_try_again_later_or_contact_with_admin_js_str'));
      });
  }

  function saveTemplate (event, template, index) {
    var self = this;
    event.preventDefault();
    var templateId = 'editTemplate-' + index;
    if (self.openedEmailTemplateBuilder === templateId) {
      this.shouldSave = true;
    } else {
      template.hotelId = this.hotel.id;
      self.saveEditedEmailTemplate(template, index);
      }
  }

  function changeLang(old_lang) {
    if (self.hotel === undefined) {
      return;
    }
    Globalize.saveTranslation(self.hotel, 'hotel', old_lang);
    Globalize.loadTranslation(self.hotel, 'hotel');
  }

  function onSendTestLetter(text) {
    var letter = {
      receiver: $rootScope.hotel.email,
      templateHtml: text,
      hotelId: $rootScope.hotel.id,
    }
    new EmailTemplatePreviewFactory(letter).create().then(function () {
      $rootScope.notify($i18next.t('bookings.email.notify.test_email_has_been_sent_js_str'));
    }, function (error_message) {
      console.error('Error sending test email', error_message);
      $rootScope.notify(error_message);
    });
  }

  function onLoadBeeFreeToken() {
    return BeeFreeFactory
      .get({
        hotelId: $rootScope.hotel.id
      });
  }
  

  function toSnakeCase(str) {
    return str.replace(/([A-Z])/g, function(match) {
      return "_" + match.toLowerCase();
    });
  }

  function onLoadEmailTemplates(templateType) {
    var snakeTemplateType = toSnakeCase(templateType);

    return EmailTemplatesListFactory("system")
      .query({
        "fetch[]": [snakeTemplateType]
      }, { hotel_id: $rootScope.hotel.id })
      .then(function (res) {
        var index = res.emailTemplates.findIndex(function (t) {
          return t[templateType] !== undefined && t[templateType][templateType] !== undefined;
        });

        self.hotel[templateType] = res.emailTemplates[index][templateType][templateType];
        self.hotel[templateType + "Json"] = res.emailTemplates[index][templateType][templateType + "Json"];
      })
      .catch(function (error) {
        console.error("Failed to load templates:", error);
        $rootScope.notify("Failed to load email templates.");
      });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
      self.initTimeout = null;
    }
  });

}

angular
  .module('buuqit')
  .controller('Settings.MembershipSettingsController', MembershipSettingsController);

MembershipSettingsController.$inject = ["$rootScope", "$scope", "$timeout", "$i18next"];

function MembershipSettingsController ($rootScope, $scope, $timeout, $i18next) {
  var self = this;

  angular.extend(
    this,
    {
      initTimeout : null,
      save_loading : false,
      places: ['top', 'middle', 'bottom'],
      presets: [
        { name: 'Peach',       description_area: '#fbefdc', form_area: '#fdf7f0', primary_text: '#dc876b', secondary_text: '#8b7671', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Tea',         description_area: '#edecea', form_area: '#f9f9f9', primary_text: '#84af9b', secondary_text: '#7f7f7f', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Marine',      description_area: '#e9eff4', form_area: '#f9feff', primary_text: '#6792b1', secondary_text: '#7f95a4', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Dolly',       description_area: '#fdf1f5', form_area: '#ffffff', primary_text: '#e688a1', secondary_text: '#9c8e88', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Vine Red',    description_area: '#e4e3e2', form_area: '#f9feff', primary_text: '#bf2d45', secondary_text: '#6b635e', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'White Black', description_area: '#eaeaea', form_area: '#f9feff', primary_text: '#4a4a4a', secondary_text: '#727272', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Grass Green', description_area: '#eff4e9', form_area: '#f9feff', primary_text: '#6ebf2d', secondary_text: '#807d77', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Bright Blue', description_area: '#e9f2f4', form_area: '#f9feff', primary_text: '#04a2dc', secondary_text: '#4e7a8a', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Gold',        description_area: '#ece8e6', form_area: '#ffffff', primary_text: '#b58b72', secondary_text: '#5e5e5e', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'White',       description_area: '#f3f3f3', form_area: '#ffffff', primary_text: '#f4a907', secondary_text: '#5e5e5e', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Black White', description_area: '#2a2a2a', form_area: '#3a3a3a', primary_text: '#fbfbfb', secondary_text: '#b6b6b6', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Deep Blue',   description_area: '#20263c', form_area: '#252c44', primary_text: '#4fabd5', secondary_text: '#9b9cc4', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Cardinal',    description_area: '#2a1f28', form_area: '#372734', primary_text: '#e83277', secondary_text: '#c49b9b', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Black',       description_area: '#2a2a2a', form_area: '#3a3a3a', primary_text: '#fbbd18', secondary_text: '#ffffff', error: '#fb1d18', placeholder: '#eeeeee' },
        { name: 'Gold Black',  description_area: '#2a2a2a', form_area: '#3e3b3a', primary_text: '#bf9b62', secondary_text: '#ffffff', error: '#fb1d18', placeholder: '#eeeeee' },
      ],
      color_preset: null,

      init : init,
      save : save,
      updateColor : updateColor,
      changeColorPreset : changeColorPreset
    }
  );


  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      self.initTimeout = $timeout(init, 0);
    }
  });


  function init () {
    if ($rootScope.hotel) {
      angular.extend(
        self,
        {
          loaded    : false,
          hotel     : $rootScope.hotel
        }
      );

      var preset = self.presets.filter(function(preset) {
        return preset.description_area == self.hotel.memberSettings.descriptionColor &&
               preset.form_area == self.hotel.memberSettings.formColor &&
               preset.primary_text == self.hotel.memberSettings.primaryTextColor &&
               preset.secondary_text == self.hotel.memberSettings.secondaryTextColor &&
               preset.error == self.hotel.memberSettings.errorColor &&
               preset.placeholder == self.hotel.memberSettings.placeholderColor;
      });

      if (preset.length > 0) {
        self.color_preset = preset[0].name;
      }
    }
  }


  function save () {
    self.save_loading = true;
    this.hotel.save().then(function (data) {
      $rootScope.hotel = data;
      self.save_loading = false;

      $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
    }, function (response) {
      console.error('Error saving hotel settings', response);
      self.loaded = false;
      $rootScope.notify($i18next.t('general.other.error') + ': ' + response.data.error);
    });
  }


  function updateColor (cls, color) {
    angular.element('.' + cls).css('fill', color);
  }


  function changeColorPreset () {
    var preset = self.presets.filter(function(preset) {return preset.name == self.color_preset;})[0];

    self.hotel.memberSettings.descriptionColor   = preset.description_area;
    self.hotel.memberSettings.formColor          = preset.form_area;
    self.hotel.memberSettings.primaryTextColor   = preset.primary_text;
    self.hotel.memberSettings.secondaryTextColor = preset.secondary_text;
    self.hotel.memberSettings.errorColor         = preset.error;
    self.hotel.memberSettings.placeholderColor   = preset.placeholder;

    angular.element('.st0').css('fill', preset.description_area);
    angular.element('.st1').css('fill', preset.form_area);
    angular.element('.st2').css('fill', preset.secondary_text);
    angular.element('.st3').css('fill', preset.primary_text);
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (self.initTimeout) {
      $timeout.cancel(self.initTimeout);
      self.initTimeout = null;
    }
  });
}

angular
  .module('buuqit')
  .controller('Settings.CancellationPolicyController', CancellationPolicyController);

CancellationPolicyController.$inject = [
  "$rootScope",
  "$scope",
  "$timeout",
  "$i18next",
  "CancellationPolicyFactory",
  "Globalize"
];

function CancellationPolicyController ($rootScope, $scope, $timeout, $i18next, CancellationPolicyFactory, Globalize) {
  var self = this;

  angular.extend(
    this,
    {
      newPolicy : {
        'title' : 'Cancellation policy',
        'hotelId' : null,
        'deposit' : null,
        'refund' : null,
        'cancellation' : null,
        'nonshow' : null,
        'refundCustom' : null,
        'detailsCustom' : null,
        'cancellationCustom' : null,
        'nonshowCustom' : null,
        'depositNights' : null,
        'depositPercent' : null,
        'depositPerBooking' : null,
        'depositPerRoom' : null,
        'refundDays' : null,
        'detailsRemaining' : null,
        'cancellationDays' : null,

        'detailsCustomEnabled' : false,
        'detailsPreauthorize' : false,
        'detailsRemainingEnabled' : false,
        'text' : null,
        'cancellationMode' : null,
        'cancellationPeriods' : [],

        'breakfastPresent' : false,
        'breakfastIncluded' : true,
        'breakfastName' : null,
        'breakfastDescription' : null,
        'breakfastOmit' : true,
        'breakfastCustomPolicy' : false,
        'breakfastPrice': 0

      },
      originalPolicies : [],
      policies: [],

      init   : init,
      save   : save,
      addPolicy : addPolicy,
      removePolicy : removePolicy,
      generateText : generateText,
      openEditForm : openEditForm,
      addCancellationPeriod : addCancellationPeriod,
      removeCancellationPeriod : removeCancellationPeriod,
      sortPeriods: sortPeriods,
      cancel : cancel,
      changeLang: changeLang
    }
  );

  $scope.translations = {}

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (typeof($rootScope.hotel) != 'undefined') {
      $scope.hotel_locale = $rootScope.hotel.locale;
      $scope.translations = $rootScope.hotel.policiesTranslations;
      $timeout(init, 0);
    }
  });


  function init () {
    angular.extend(
      self,
      {
        loaded : false,
        hotel  : $rootScope.hotel,
        policies : $rootScope.hotel.cancellationPolicies,
        activePolicy : 0
      }
    );

    _.each(self.policies, function(el) {
      el.breakfastCustomPolicy = !_.isEmpty(el.breakfastDescription);
      el.breakfastPrice = parseInt(el.breakfastPrice);
    });

    self.newPolicy.hotelId = $rootScope.hotel.id;

    if (self.policies.length > 0) {
      self.policy = self.policies[0];
    }

    $scope.$apply();
  }


  function save (policy) {
    var valid = true;
    self.loaded = true;

    if (policy.deposit === null) { valid = false; }
    if (policy.deposit == 'No deposit is required') {
      policy.refund = null;
    }
    if (policy.refund === null && policy.deposit != 'No deposit is required') { valid = false; }
    if (policy.cancellation === null) { valid = false; }
    if (policy.nonshow === null) { valid = false; }

    if (policy.deposit == 'night deposit is required at the time of booking' && Number(policy.depositNights) <= 0) { valid = false; }
    if (policy.deposit == '% deposit is required at the time of booking' && Number(policy.depositPercent) <= 0) { valid = false; }
    if (policy.deposit == 'is required per booking' && Number(policy.depositPerBooking) <= 0) { valid = false; }
    if (policy.deposit == 'is required per room booked' && Number(policy.depositPerRoom) <= 0) { valid = false; }

    if (policy.refund == 'Deposits are refundable up to days prior to arrival' && Number(policy.refundDays) <= 0) { valid = false; }

    if (policy.cancellation == 'Free cancellation up N day(s) before arrival' && Number(policy.cancellationDays) <= 0) { valid = false; }

    if (policy.refund == 'Refund Custom Policy' && policy.refundCustom === null) { valid = false; }
    if (policy.cancellation == 'Cancellation Custom Policy' && policy.cancellationCustom === null) { valid = false; }
    if (policy.nonshow == 'NonShow Custom Policy' && policy.nonshowCustom === null) { valid = false; }

    if (policy.detailsCustomEnabled === true && policy.detailsCustom === null) { valid = false; }
    if (policy.detailsRemainingEnabled === true && policy.detailsRemaining === null) { valid = false; }
    if (policy.detailsCustomEnabled === false) { policy.detailsCustom = null; }

    if (policy.breakfastCustomPolicy === false) {
      policy.breakfastDescription = '';
    }

    if (valid) {
      if (policy.id) {
        updateTextBeforeSave(policy);
        policy.save().then(function() {
          self.loaded = false;
          policy.edited = false;
          Globalize.loadTranslation(policy, 'cancellationPolicy')

          $rootScope.notify($i18next.t('general.notify.save_successful_js_str'));
          if (policy.isDefault) {
            removeOldDefault(policy.id);
          }
        }).catch(function(error) {
          self.loaded = false;
          console.error('Error updating cancellation policy:', error);
        });
      } else {
        var newPolicy = new CancellationPolicyFactory(angular.copy(self.newPolicy));
        updateTextBeforeSave(newPolicy);
        newPolicy.save().then(function () {
          self.loaded = false;
          self.newPolicyVisible = false;
          self.policies.push(newPolicy);
          Globalize.loadTranslation(newPolicy, 'cancellationPolicy')
          self.newPolicy = angular.copy(self.originalNewPolicy);

          if (newPolicy.isDefault) {
            removeOldDefault(newPolicy.id);
          }
        }).catch(function(error) {
          self.loaded = false;
          console.error('Error creating cancellation policy:', error);
        });
      }
    } else {
      $rootScope.alert($i18next.t('profile_nav.settings.inventory.cancellation_policy.alert.please_fill_form_and_try_again_js_str'));
      self.loaded = false;
    }
  }


  function removeOldDefault(id) {
    self.policies.forEach(function (el, index) {
      if (el.id != id) {
        self.policies[index].isDefault = false;
      }
    });
  }


  function addPolicy ($event) {
    self.newPolicyVisible = true;
    self.originalNewPolicy = angular.copy(self.newPolicy);
    self.newPolicyVisible = true;
  }


  function removePolicy (policy) {
    var index = self.policies.indexOf(policy),
        isDefault = policy.isDefault;
    policy.removing = true;

    if (policy.id === undefined) {
      self.policies.splice(index, 1);
    } else {
      policy.remove().then(function(data) {
        if (data.msg == 'Policy removed') {
          data.isRemoved = true
        } else {
          $rootScope.alert($i18next.t('profile_nav.settings.inventory.cancellation_policy.alert.policy_can_not_be_removed'));
        }
        policy.removing = false;
      });
    }
  }

  function getTranslation(type, key, locale, params) {
    var string;
    params = params === undefined ? {} : params;
    if ($scope.translations[locale]) {
      string = $scope.translations[locale][type][key];
    } else {
      if ($scope.hotel_locale !== undefined && $scope.translations[$scope.hotel_locale] !== undefined) {
        string = $scope.translations[$scope.hotel_locale][type][key];
      }
    }
    if (string === undefined) {
      string = '';
    }
    Object.keys(params).forEach(function(k) {
      string = string.replace('{' + k +'}', params[k]);
    })
    return string;
  }

  function generateText (policy, lang) {
    var out = [];

    if (policy.deposit == 'No deposit is required') {
      out.push(getTranslation('deposit', policy.deposit, lang));
    } else {
      if (policy.deposit == 'A deposit equal to the total cost is required at the time of booking') {
        out.push(getTranslation('deposit', policy.deposit, lang));
      }
      if (policy.deposit == 'night deposit is required at the time of booking') {
        out.push(getTranslation('deposit', policy.deposit, lang, {'nights': policy.depositNights}));
      }
      if (policy.deposit == '% deposit is required at the time of booking') {
        out.push(getTranslation('deposit', policy.deposit, lang, {'percent': policy.depositPercent}));
      }
      if (policy.deposit == 'is required per booking') {
        out.push(getTranslation('deposit', policy.deposit, lang, {'deposit': policy.depositPerBooking, 'currency': self.hotel.currency}));
      }
      if (policy.deposit == 'is required per room booked') {
        out.push(getTranslation('deposit', policy.deposit, lang, {'deposit': policy.depositPerRoom, 'currency': self.hotel.currency}));
      }

      if (policy.refund == 'All deposits are non-refundable') {
        out.push(getTranslation('refund', policy.refund, lang));
        if (policy.noCancellationNoModification === true) {
          out.push(getTranslation('refund', policy.refund, lang));
        }
      } else if (policy.refund == 'Deposits are refundable up to days prior to arrival') {
        out.push(getTranslation('refund', policy.refund, lang, {'days': policy.refundDays}));
      } else {
        out.push(policy.refundCustom);
      }
    }

    if (policy.detailsRemainingEnabled) {
      out.push(getTranslation('details', 'Remaining Enabled', lang,
        {'details': getTranslation('detailsRemaining', policy.detailsRemaining, lang)}
      ));
    }

    if (policy.detailsPreauthorize) {
      out.push(getTranslation('details', 'Pre-authorise', lang));
    }

    if (policy.detailsCustomEnabled) {
      out.push(policy.detailsCustom);
    }

    if (policy.cancellation == 'Free cancellation at any time') {
      out.push(getTranslation('cancellation', policy.cancellation, lang));
    } else if (policy.cancellation == 'Free cancellation up N day(s) before arrival') {
      out.push(getTranslation('cancellation',
        policy.cancellation,
        lang,
        {'days': policy.cancellationDays,
         'mode': getTranslation('cancellationMode', policy.cancellationMode, lang)
        })
      );
    } else if (policy.cancellation == 'No cancellation or modification can be applied to this booking') {
      out.push(getTranslation('cancellation', policy.cancellation, lang));
    } else if (policy.cancellation == 'Flexible Cancellation Fee based at cancellation period') {
      out.push(generateTextForCancellationPeriods(policy, lang));
    } else {
      out.push(policy.cancellationCustom);
    }

    if (policy.nonshow == 'NonShow Custom Policy') {
      out.push(policy.nonshowCustom);
    } else {
      out.push(getTranslation('nonshow', policy.nonshow, lang));
    }

    var breakfastName = policy.breakfastName || $i18next.t('profile_nav.settings.inventory.cancellation_policy.for_generate_text_js_code.breakfast_js_str');

    if (policy.breakfastOmit === true) {

    } else if (policy.breakfastCustomPolicy === false) {
      if (policy.breakfastIncluded) {
        out.push(getTranslation('breakfast', 'included', lang, {'name': policy.breakfastName}));
      } else {
        out.push(getTranslation('breakfast', 'not included', lang, {'name': policy.breakfastName}));
        out.push(getTranslation('breakfast', 'charge', lang, {'charge': $rootScope.currencySymbol + policy.breakfastPrice}));
      }
    } else {
      out.push(policy.breakfastDescription);
    }
    out = out.filter(function(t) { return t !== '' && t !== null && t !== undefined; }).join('. ') + '.';
    policy.text = out;
    return out;
  }


  function openEditForm (policy, $index) {
    self.originalPolicies[$index] = angular.copy(policy);
    policy.edited = true;
  }


  function cancel (policy, $index) {
    if (policy) {
      self.policies[$index] = angular.copy(self.originalPolicies[$index]);
    } else {
      self.newPolicyVisible = false;
      self.newPolicy = angular.copy(self.originalNewPolicy);
    }
  }

  function addCancellationPeriod (policy) {
    if (policy.cancellationPeriods == null) {
      policy.cancellationPeriods = [];
    }
    policy.cancellationPeriods.push({days: "", percent: ""});
  }
  
  function removeCancellationPeriod (policy, index) {
    policy.cancellationPeriods = policy.cancellationPeriods.filter(function(el, i) {return i != index;});
  }

  function sortPeriods (policy) {
    if (policy.cancellationPeriods == null) {
      policy.cancellationPeriods = [];
    }
    if (policy.cancellationPeriods && policy.cancellationPeriods.sort) {
      policy.cancellationPeriods = policy.cancellationPeriods.sort(function(a,b) {
        var keyA = a.days ? a.days : 0,
            keyB = b.days ? b.days : 0;

        if(keyA < keyB) return 1;
        if(keyA > keyB) return -1;
        return 0;
      })
    }
  }

  function generateTextForCancellationPeriods (policy, lang) {
    if (policy.cancellationPeriods && policy.cancellationPeriods.sort) {
      sortPeriods(policy);
      return policy.cancellationPeriods.map(function(period, index) {
        return [
          (
            index == 0 ?
            getTranslation('cancellationPeriods', 'firstPeriod', lang, {'to': period.days}) :
            getTranslation('cancellationPeriods', 'secondPeriod', lang, {'from': policy.cancellationPeriods[index - 1].days - 1, 'to': period.days})
          ),
          (
            period.percent == 0 ?
            getTranslation('cancellationPeriods', 'freeCancellation', lang) :
            getTranslation('cancellationPeriods', 'nonfreeCancellation', lang, {'percent': period.percent})
          )
        ].join(' ');
      }).join(', ');
    }
  }

  function changeLang(old_locale) {
    var policies = self.policies.concat([self.newPolicy]);
    policies.forEach(function(p) {
      Globalize.saveTranslation(p, 'cancellationPolicy', old_locale);
      Globalize.loadTranslation(p, 'cancellationPolicy');
    })
  }

  function updateTextBeforeSave(policy) {
    Globalize.updateCurrentTranslation(policy, 'cancellationPolicy');
    // Just use locales as counter
    $rootScope.hotel.locales.forEach(function(old_locale) {
      Globalize.nextLocale();
      Globalize.loadTranslation(policy, 'cancellationPolicy');
      policy.text = generateText(policy, Globalize.locale);
      Globalize.updateCurrentTranslation(policy, 'cancellationPolicy');
    })
  }

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('RoomBlockerModalCtrl', RoomBlockerModalCtrl);

RoomBlockerModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$filter",
  "local",
  "blocker",
  "RoomBlockerFactory",
  "AvailabilityChecker",
  "BlockerStorage",
  "CalendarStorage"
];

function RoomBlockerModalCtrl ($rootScope, $scope, $i18next, $mdDialog, $filter, local, blocker, RoomBlockerFactory, AvailabilityChecker, BlockerStorage, CalendarStorage) {
  angular.extend(
    $scope,
    {
      open_from   : false,
      open_to     : false,
      prevDay     : moment(moment(new Date()).format('YYYY-MM-DD')).toDate(),
      rooms       : $rootScope.hotel.rooms,
      dateOptions : {
        formatYear: 'yy',
        startingDay: 1
      },
      user: $rootScope.user,

      cancel : cancel,
      save : save,
      remove : remove,
      change : change
    }
  );


  function initialize () {
    $scope.blocker = {};
    $scope.blocked_rooms = [];

    if (typeof(blocker) === 'number' || typeof(blocker) === 'string') {
      $scope.blocker = angular.copy(BlockerStorage.get(blocker));

      $scope.blocker.dateFromTMP = new Date($scope.blocker.dateFrom);
      $scope.blocker.dateToTMP = new Date($scope.blocker.dateTo);
      $scope.blocker.dateFromTMP = new Date($scope.blocker.dateFromTMP.getTime() + $scope.blocker.dateFromTMP.getTimezoneOffset() * 60000);
      $scope.blocker.dateToTMP = new Date($scope.blocker.dateToTMP.getTime() + $scope.blocker.dateToTMP.getTimezoneOffset() * 60000);
      $scope.blocker.minDateTo = moment($scope.blocker.dateFrom).add(1, 'day').toDate();
      $scope.blocker.room = $scope.rooms.filter(function (room) { return room.id == $scope.blocker.roomId;})[0];
    } else {
      $scope.blocker = {
        roomId      : blocker.room.id,
        room        : blocker.room,
        dateFrom    : blocker.day,
        dateTo      : moment(blocker.day).add(1, 'day').toDate(),
        dateFromTMP : blocker.day,
        dateToTMP   : moment(blocker.day).add(1, 'day').toDate(),
        minDateTo   : moment(blocker.day).add(1, 'day').toDate()
      };
    }

    $scope.maxPossibleDate = moment(new Date()).add(3*365 - 3, 'day').toDate();
    $scope.maxDate = fixMaxDate(moment($scope.blocker.dateFrom).add(364, 'day').toDate());
    $scope.maxForMaxDate = moment($scope.maxDate).add(1, 'day').toDate();
    $scope.blocker.prevDateTo = $scope.blocker.dateTo;
    $scope.blocker.prevDateFrom = $scope.blocker.dateFrom;
    $scope.blocker.prevRoomId = $scope.blocker.roomId;
    $scope.blocker.prevReason = $scope.blocker.reason;

    _checkAvailable();
  }

  function fixMaxDate(date) {
    // Do not allow blocker go out from calendar
    return date > $scope.maxPossibleDate ? $scope.maxPossibleDate : date;
  }

  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    var blocker;

    if ($scope.createRoomBlocker.$valid && $scope.blocker.available) {
      if ($scope.blocker.id) {
        blocker = BlockerStorage.blockers.filter(function (room_blocker) {return room_blocker.id == $scope.blocker.id;})[0];
        BlockerStorage.blockers[BlockerStorage.blockers.indexOf(blocker)] = $scope.blocker;
      } else {
        blocker = new RoomBlockerFactory($scope.blocker);
        blocker.id = String(new Date().getTime());
        BlockerStorage.blockers.push(blocker);
      }
      blocker.hotelId  = $rootScope.hotel.id;
      blocker.dateFrom = $filter('date')($scope.blocker.dateFromTMP, "yyyy-MM-dd");
      blocker.dateTo   = $filter('date')($scope.blocker.dateToTMP, "yyyy-MM-dd");
      blocker.roomId   = parseInt($scope.blocker.roomId);
      blocker.prevDateTo = $scope.blocker.prevDateTo;
      blocker.prevDateFrom = $scope.blocker.prevDateFrom;
      blocker.prevRoomId = $scope.blocker.prevRoomId;
      blocker.prevReason = $scope.blocker.prevReason;
      blocker.reason = $scope.blocker.reason;

      $rootScope.$broadcast('blockers:update');
      blocker.save();
      $mdDialog.hide();
    } else {
      $rootScope.alert($i18next.t('general.alert_modals.form_is_not_valid_js_str'));
    }
  }


  function remove () {
    var date = new Date(),
        confirm = $mdDialog.confirm()
          .title($i18next.t('general.confirm.confirm'))
          .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
          .ok($i18next.t('general.confirm.confirm'))
          .cancel($i18next.t('general.confirm.cancel'));

    $mdDialog.show(confirm).then(function() {
        $scope.blocker.hotelId = $rootScope.hotel.id;
        $scope.blocker.destroy();
        blocker = BlockerStorage.blockers.filter(function (room_blocker) {return room_blocker.id == $scope.blocker.id;})[0];
        $rootScope.$broadcast('BlockerStorage:destroy', $scope.blocker.id);
        BlockerStorage.blockers.splice(BlockerStorage.blockers.indexOf(blocker), 1);
        CalendarStorage.destroyBlocker(null, blocker.id);
        $mdDialog.hide();
    }, function() {
      local.parent.openBlockerManagementModal(undefined, local.blocker);
    });
  }

  function change () {
    $scope.blocker.dateFrom = moment($scope.blocker.dateFromTMP).format('YYYY-MM-DD');
    $scope.blocker.dateTo = moment($scope.blocker.dateToTMP).format('YYYY-MM-DD');

    if ($scope.blocker.roomId) {
      $scope.blocker.room = $scope.rooms.filter(function (room) { return room.id == $scope.blocker.roomId;})[0];
    } else {
      $scope.blocker.room = null;
    }

    $scope.blocker.minDateTo = moment($scope.blocker.dateFrom).add(1, 'day').toDate();
    if ($scope.blocker.dateToTMP < $scope.blocker.minDateTo) {
      $scope.blocker.dateToTMP = $scope.blocker.minDateTo;
      $scope.blocker.dateTo = moment($scope.blocker.dateToTMP).format('YYYY-MM-DD');
    }

    _checkAvailable();
  }


  function _checkAvailable () {
    var blocker = angular.copy($scope.blocker),
        availability = AvailabilityChecker.checkAvailability(
          blocker.roomId,
          blocker.dateFrom,
          moment(blocker.dateTo).diff(moment(blocker.dateFrom), 'days'),
          undefined,
          blocker.id
        );

    $scope.not_blocker_rooms = _.compact(_.map($scope.rooms, function(room) {
      if (availability.closed.indexOf(room.id) == -1) {
        return room;
      }
    }));

    if (availability.closed.indexOf(blocker.roomId) > -1) {
      $scope.blocker.roomId = null;
      $scope.blocker.room   = null;
    }

    $scope.blocker.available = availability.available;
    $scope.minDate = $scope.prevDay;
    $scope.maxDate = fixMaxDate(moment($scope.blocker.dateFromTMP).add(availability.diff - 1, 'days').toDate());
    $scope.maxForMaxDate = moment($scope.maxDate).add(1, 'day').toDate();
  }


  initialize();
}

angular
  .module('buuqit')
  .controller('CustomerModalCtrl', CustomerModalCtrl);

CustomerModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$filter",
  "local",
  "customer",
  "closeCustomerEditForm",
  "onNewCustomerCallback"
];

function CustomerModalCtrl ($rootScope, $scope, $i18next, $mdDialog, $filter, local, customer, closeCustomerEditForm, onNewCustomerCallback) {
  angular.extend(
    $scope,
    {
      cancel : cancel,
      onNewCustomer: onNewCustomer
    }
  );


  function initialize () {
    customer.companyName = customer.name;
    customer.customerType = customer.type;
    customer.zipCode = customer.postalCode;
    $scope.customer = customer;
  }


  function cancel () {
    $mdDialog.hide();
    closeCustomerEditForm();
  }

  function onNewCustomer () {
    $mdDialog.hide();
    closeCustomerEditForm($scope.customer.id);
    if (onNewCustomerCallback !== undefined) {
      onNewCustomerCallback()
    }
  }

  initialize();
}

angular
  .module('buuqit')
  .controller('CreateRoomNoteModalCtrl', CreateRoomNoteModalCtrl);

CreateRoomNoteModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "room",
  "local"
];

function CreateRoomNoteModalCtrl ($rootScope, $scope, $i18next, $mdDialog, room, local) {
  angular.extend(
    $scope,
    {
      room : room,
      note : angular.copy(room.note),

      cancel : function () {
        $mdDialog.hide();
      },

      save : function () {
        if ($scope.createDateNote.$valid) {
          $scope.room.save();
          $mdDialog.hide();
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.form_is_not_valid_js_str'));
        }
      },

      remove : function () {
        var confirm = $mdDialog.confirm()
          .title($i18next.t('general.confirm.confirm'))
          .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
          .ok($i18next.t('general.confirm.confirm'))
          .cancel($i18next.t('general.confirm.cancel'));

        $mdDialog.show(confirm).then(function() {
          $scope.room.note = null;
          $scope.room.save();
          if (local.parent.tbfCalendar) {
            local.parent.tbfCalendar.updateRoomNote($scope.room.id, null);
          }
          $mdDialog.hide();
        }, function() {
          local.parent.addRoomNote(undefined, local.room);
        });
      }
    }
  );
}
angular
  .module('buuqit')
  .controller('CreateRoomHKNoteCtrl', CreateRoomHKNoteCtrl);

  CreateRoomHKNoteCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "room",
  "local"
];

function CreateRoomHKNoteCtrl ($rootScope, $scope, $i18next, $mdDialog, room, local) {
  angular.extend(
    $scope,
    {
      room : room,

      cancel : function () {
        $mdDialog.hide('cancel');
      },

      save : function () {
        if ($scope.createDateNote.$valid) {
          $scope.room.save();
          $mdDialog.hide();
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.form_is_not_valid_js_str'));
        }
      },
    }
  );
}
angular
  .module('buuqit')
  .controller('CreateGroupBookingModalCtrl', CreateGroupBookingModalCtrl);

CreateGroupBookingModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$filter",
  "$timeout",
  "$http",
  "$sce",
  "$q",
  "UIDialogService",
  "options",
  "BookingFactory",
  "BookingStorage",
  "CalendarStorage",
  "RateByDateStorage",
  "AvailabilityChecker",
  "RestrictionStorage",
  "RoomCalculator",
  "RoomBuilderService",
  "CustomerFactory",
];

function CreateGroupBookingModalCtrl($rootScope, $scope, $i18next, $mdDialog, $filter, $timeout, $http, $sce, $q, UIDialogService, options, BookingFactory, BookingStorage, CalendarStorage, RateByDateStorage, AvailabilityChecker, RestrictionStorage, RoomCalculator, RoomBuilderService, CustomerFactory) {
  CreateBookingModalExperimentalCtrl.call(this, $rootScope, $scope, $i18next, $mdDialog, $filter, $timeout, $http, $sce, $q, UIDialogService, options, BookingFactory, BookingStorage, CalendarStorage, RateByDateStorage, AvailabilityChecker, RestrictionStorage, RoomCalculator, RoomBuilderService);

  var roomTemplate = options.roomTemplate;
  var restrictionsService = options.restrictionsService;
  var isFullCustomerLoaded = false;

  var ctrl = this;

  $scope.modalHeader = 'Create Booking';
  $scope.prevDay = moment($rootScope.currentDate).toDate();
  $scope.times = times;
  $scope.nightsSelect = Array(365).fill(0).map(function (e, i) { return i + 1 });
  $scope.policies = $rootScope.hotel.cancellationPolicies.filter(function(el) { return !el.isRemoved; });
  $scope.currencyProfiles = $rootScope.hotel.currencyProfiles;
  $scope.rateCategories = angular.copy(
    $rootScope.hotel.rateCategories.filter(function(el) { return el.isRemoved === false })
  );

  $scope.foreignInvoicesFeatureEnabled = $rootScope.hotel.foreignInvoicesFeatureEnabled;

  $scope.countries = countries_in;
  $scope.locales = window.locales;
  $scope.rootCustomerType = 0;

  $scope.common = {};
  $scope.showNextToFinalBookingFormButton = false;
  $scope.expandRoomList = true;

  $scope.common.checkinDate = roomTemplate.checkin_date;
  $scope.common.checkinTime = null;
  $scope.common.checkoutDate = roomTemplate.checkout_date;
  $scope.common.numberOfNights = roomTemplate.number_of_nights;
  $scope.common.minCheckoutDate = roomTemplate.min_checkout_date;
  $scope.common.cancellationPolicyId = roomTemplate.cancellation_policy_id || $scope.policies[0].id;
  $scope.common.rateCategoryId = roomTemplate.rateCategory.id;

  $scope.isBookingRoomFormShown = false;
  $scope.editRoomIndex = null;
  $scope.bookingRoomToEdit = null;

  $scope.common.step = options.step;
  $scope.loading = false;
  $scope.loadingRooms = 0;
  $scope.loadingShortCalendar = false;

  if (typeof($scope.common.step) == 'undefined') {
    $scope.common.step = 'final_booking_form'
  } else {
    $scope.booking.rooms = [];
  }

  $scope.updateShowNextToFinalBookingFormButton = function () {
    for (var roomTypeIndex in $scope.totalRoomsByRoomType) {
      var roomType = $scope.totalRoomsByRoomType[roomTypeIndex];
      if (roomType.basketRooms.length > 0) {
        $scope.showNextToFinalBookingFormButton = true;
        return;
      }
    }
    $scope.showNextToFinalBookingFormButton = false;
  }

  $scope.toggleExpandRooms = function () {
    $scope.expandRoomList = !$scope.expandRoomList;
  }

  $scope.handleCurrencyRateChange = function() {
    $scope.booking.rooms.forEach(function(room) {
      room.$service.handleRoomTotalForeignAmountChange();
    })
    $scope.calcTotal();
  }

  $scope.handleCurrencyChange = function() {
    var currencyProfile = $scope.currencyProfiles.find(function(currencyProfile) {return currencyProfile.code == $scope.booking.foreignCurrency});
    var currencyRate = undefined;
    if (currencyProfile.isDefault) {
      $scope.booking.isForeignAmount = false;
    } else {
      $scope.booking.isForeignAmount = true;
      if (1/(currencyProfile.realExchangeRate) < 90000) {
        currencyRate = +(1/(currencyProfile.realExchangeRate))
        if (currencyRate < 0.1) {
          currencyRate = +(currencyRate.toFixed(8));
        } else {
          currencyRate = +(currencyRate.toFixed(2));
        }
        $scope.booking.foreignCurrencyRate = currencyRate;
      }
    }

    $scope.booking.rooms.forEach(function (room) {
      room.isForeignAmount = $scope.booking.isForeignAmount;
      if (currencyRate !== undefined) {
        totalForeign = 0;
        room.nights.forEach(function (night) {
          foreignAmount = +(night.price/currencyRate).toFixed(2);
          night.foreignAmount = foreignAmount;
          totalForeign += foreignAmount
        })
        room.total_foreign_amount = totalForeign;
      }
    });
  }

  var getRooms = function () {
    var hotelRooms = $rootScope.hotel.rooms;

    // We need here only currently closed rooms and specific room_id passed only to satisfy method signature
    // specific room availability calculated in booking room controllers

    var availability = AvailabilityChecker.checkAvailability(
      ctrl.initialRoom.room_id,
      $scope.common.checkinDate,
      $scope.common.numberOfNights
    );

    var notBlockedRooms = hotelRooms.filter(function (room) {
      if (!room.isActive) return false;
      var usedRoomIds = $scope.booking.rooms.map(function(room) {
        return Number(room.room_id);
      });

      var isRoomUnused = usedRoomIds.indexOf(room.id) == -1;
      var isRoomOpen = availability.closed.indexOf(room.id) == -1;

      return isRoomUnused && isRoomOpen;
    });
    return notBlockedRooms;
  };

  $scope.totalRoomsByRoomType = AvailabilityChecker.getAvailableRoomsByType($rootScope.hotel.rooms, getRooms(), $rootScope.hotel.roomTypes)
  for (var roomTypeIndex in $scope.totalRoomsByRoomType) {
    $scope.totalRoomsByRoomType[roomTypeIndex].basketRooms = [];
  }

  $scope.getBasketAdults = function() {
    var adults = 0;
    for (var roomTypeIndex in $scope.totalRoomsByRoomType) {
      var roomType = $scope.totalRoomsByRoomType[roomTypeIndex];
      for (var basketRoomIndex in roomType.basketRooms) {
        var r = roomType.basketRooms[basketRoomIndex];
        adults += parseInt(r.number_of_adults);
      };
    };
    return adults;
  }

  $scope.getBasketChildren = function() {
    var children = 0;
    for (var roomTypeIndex in $scope.totalRoomsByRoomType) {
      var roomType = $scope.totalRoomsByRoomType[roomTypeIndex];
      for (var basketRoomIndex in roomType.basketRooms) {
        var r = roomType.basketRooms[basketRoomIndex];
        children += parseInt(r.number_of_children);
      };
    };
    return children;
  }

  $scope.getBasketRooms = function() {
    var rooms = 0;
    for (var roomTypeIndex in $scope.totalRoomsByRoomType) {
      var roomType = $scope.totalRoomsByRoomType[roomTypeIndex];
      rooms += (roomType.basketRooms || []).length;
    };
    return rooms;
  }

  $scope.showFinalBookingForm = function () {
    $scope.expandRoomList = false;
    $scope.booking.rooms = [];
    for (var roomTypeIndex in $scope.totalRoomsByRoomType) {
      var roomType = $scope.totalRoomsByRoomType[roomTypeIndex];
      for (var basketRoomIndex in roomType.basketRooms) {
        var basketRoom = roomType.basketRooms[basketRoomIndex];
        $scope.addRoom(basketRoom);
      }
    }
    $scope.changeStep('final_booking_form')
  }

  $scope.changeStep = function (step) {
    $scope.common.step = step;
  }

  $scope.pickRooms = function () {
    var isDateBetweenCheck = isDateBetween($scope.common.checkinDate) && isDateBetween($scope.common.checkoutDate);

    if (!isDateBetweenCheck) {
      $scope.loadingShortCalendar = true;
      var formatedCheckoutDate = moment($scope.common.checkoutDate).format('YYYY-MM-DD');
      CalendarStorage.fetchShortRepresentations($rootScope.current_date_from, formatedCheckoutDate, true).then(function() {
        $scope.loadingShortCalendar = false;
        $rootScope.current_date_to = formatedCheckoutDate;
        updateAvailabilityAndStep();
      });
    } else {
      updateAvailabilityAndStep();
    }
  };

  function updateAvailabilityAndStep() {
    var totalRoomsByRoomType = AvailabilityChecker.getAvailableRoomsByType($rootScope.hotel.rooms, getRooms(), $rootScope.hotel.roomTypes);
    $scope.totalRoomsByRoomType = totalRoomsByRoomType;
    $scope.changeStep('pick_rooms');
  };

  function isDateBetween(date) {
    var formattedDate = moment(date, 'YYYY-MM-DD');
    return formattedDate.isBetween($rootScope.current_date_from, $rootScope.current_date_to, null, '[]');
  };

  $scope.handleRoomEditClick = function (roomIndex) {
    $scope.modalHeader = 'Create Booking | Room Edit';
    $scope.editRoomIndex = roomIndex;
    console.time('editCopy');
    $scope.bookingRoomToEdit = angular.copy($scope.booking.rooms[roomIndex]);
    console.timeEnd('editCopy');
    $scope.isBookingRoomFormShown = true;
  };

  $scope.handleRoomDeleteClick = function (roomIndex) {
    if ($scope.booking.rooms.length == 1) {
      return;
    }

    $scope.booking.rooms.splice(roomIndex, 1);
    $scope.calcTotal();

    $rootScope.$broadcast('group_booking:room_id_update');
  };

  $scope.handleEditRoomConfirmClick = function () {
    var closeForm = function () {
      // Angular Deep copy goes crazy with circular dependencies.
      // Actually, we need only copy room properties, and $service
      // that contains links to booking, room, restrictions and so on
      // We do not need that copied so reuse service from old room.
      var target_room = $scope.booking.rooms[$scope.editRoomIndex],
        $service = target_room.$service;

      angular.copy($scope.bookingRoomToEdit, target_room);
      target_room.$service = $service;

      $scope.editRoomIndex = null;
      $scope.bookingRoomToEdit = null;
      $scope.isBookingRoomFormShown = false;
      $scope.modalHeader = 'Create Booking';
    };

    var room = $scope.bookingRoomToEdit;
    var guestWasChanged = ctrl.isGuestChanged(room.guest);

    if (guestWasChanged && !room.isSourceGuestModified) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.create_booking.guest_changes_confirmation.title'),
        text: $i18next.t('bookings.create_booking.room_guest_changes_confirmation.text'),
        negative: $i18next.t('bookings.create_booking.guest_changes_confirmation.negative'),
        positive: $i18next.t('bookings.create_booking.guest_changes_confirmation.positive'),
        positive_callback: function () {
          room.guest.id = null;
          room.guest_id = null;

          closeForm();
        },
        negative_callback: function () {
          closeForm();
        }
      });
    } else {
      closeForm();
    }
  };

  $scope.handleEditRoomCancelClick = function () {
    $scope.editRoomIndex = null;
    $scope.bookingRoomToEdit = null;
    $scope.isBookingRoomFormShown = false;
    $scope.modalHeader = 'Create Booking';
  };

  $scope.room_types_by_id = $rootScope.hotel.roomTypes.reduce(function(acc, el) { acc[el.id] = el; return acc; }, {});

  var ensureRestrictionsLoaded = function (options) {
    var checkin_checkout, roomRateIds;
    if ($scope.booking.rooms.length > 1) {
      /* For multi room bookings we want to find restrictions
       * from the first checkin date of the booking to the
       * last checkout date of the booking.
      */
      checkin_checkout = $scope.booking.rooms
        .map(function(room) {
          return [room.checkin_date, room.checkout_date];
        })
        .reduce(function(a, b) {
          return [
            Math.min(a[0], b[0]),
            Math.max(a[1], b[1])
          ]
        }, [options.checkinDate, options.checkoutDate]);
      roomRateIds = _.uniq($scope.booking.rooms.map(function(room){ return room.roomRate.id; }));
    } else if ($scope.booking.rooms.length === 1) {
      checkin_checkout = [$scope.booking.rooms[0].checkin_date, $scope.booking.rooms[0].checkout_date];
      roomRateIds = [$scope.booking.rooms[0].roomRate.id];
    } else {
      // Use initial room rate and passed-in dates
      checkin_checkout = [options.checkinDate, options.checkoutDate];
      var roomRateId = (roomTemplate && roomTemplate.rateCategory && roomTemplate.rateCategory.roomRateId) || (roomTemplate && roomTemplate.roomRate && roomTemplate.roomRate.id);
      roomRateIds = roomRateId ? [roomRateId] : [];
    }

    return restrictionsService.load(
      roomRateIds,
      moment(checkin_checkout[0]).format('YYYY-MM-DD'),
      moment(checkin_checkout[1]).format('YYYY-MM-DD')
    );
  };

  $scope.availableRooms = getRooms();

  // Customer Guest
  $scope.guest = {
    id: null,
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    country: '',
    state: '',
    zipCode: '',
    locale: ''
  };

  this.processCreateNewGuestForBooking = function () {};

  this.isCustomerChanged = function () {
    return false;
  };

  this.isCustomerDirty = function() {
    return false;
  };

  this.generateCustomer = function () {};

  this.generateGuestForCalendar = function () {
    var customerType = $scope.customer.type;
    if (typeof customerType === 'undefined') {
      customerType = $scope.customer.customerType;
    }

    var result = {
      customer_type: customerType,
    };

    if (customerType == 1) {
      result.company_name = $scope.customer.visible_name || $scope.customer.companyName;
    }

    result.first_name = $scope.guest.first_name;
    result.last_name = $scope.guest.last_name;

    return result;
  };

  this.buildBookingCustomerAndGuestParams = function (_booking) {};

  $scope.handleClearCustomerClick = function () {
    $scope.booking.customer_id = null;
    $scope.customer = {};
    $scope.customerInfo.query = '';
    isFullCustomerLoaded = false;

    $scope.clearGuestInfo($scope);
  };

  $scope.handleEditCustomerClick = function () {
    var customer = angular.copy($scope.customer);
    var customerRetrieve = Promise.resolve();

    if (!isFullCustomerLoaded) {
      customer = new CustomerFactory({
        hotelId: $rootScope.hotel.id,
        id: $scope.customer.id
      });

      customerRetrieve = customer.get()
        .then(function () {
          customer.customerType = customer.type;
        });
    }

    customerRetrieve.then(function () {
      $scope.formCustomer = customer;
      $scope.isCustomerFormShown = true;
    });
  };

  $scope.handleCreateNewCustomerClick = function () {
    var customer = new CustomerFactory({
      hotelId: $rootScope.hotel.id,
      customerType: 0,
      lastName: $scope.customerInfo.query,
    });

    $scope.formCustomer = customer;
    $scope.isCustomerFormShown = true;
  };

  $scope.handleCustomerFormCloseClick = function () {
    $scope.isCustomerFormShown = false;
  };

  $scope.handleUpdatedCustomerFormCallback = function () {
    var customer = $scope.formCustomer;

    $scope.customer = customer;
    $scope.customer.visible_name = customer.visibleName;

    if (!customer.guestId) {
      $scope.isCustomerFormShown = false;
      return;
    }

    $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/guests/' + customer.guestId)
      .then(function(response) {
        $scope.guestWasSettled = new Date().getTime();
        $scope.assignGuest($scope, response.data.guest);

        $scope.isCustomerFormShown = false;
      });
  };

  $scope.handleNewCustomerFormCallback = function (customer) {
    $scope.rootCustomerType = customer.customerType;
    $scope.fillRoomCustomerWithBlank();
    $scope.customer = customer;
    $scope.customer.visible_name = customer.visibleName;
    $scope.booking.customer_id = customer.id;
    isFullCustomerLoaded = true;

    if (!customer.guestId) {
      $scope.isCustomerFormShown = false;
      return;
    }

    $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/guests/' + customer.guestId)
      .then(function(response) {
        $scope.guestWasSettled = new Date().getTime();
        $scope.assignGuest($scope, response.data.guest);

        $scope.isCustomerFormShown = false;
      });
  };

  $scope.fillRoomCustomerWithBlank = function () {
    if ($scope.rootCustomerType == 0) {
      return;
    }
    $scope.booking.rooms.forEach(function (room) {
      if (room.isGuestDirty && !room.isAutoFilled) {
        return;
      }
      room.guest = {last_name: 'MISSING NAME'}
      room.guest_id = null;
      room.isGuestDirty = true;
      room.isAutoFilled = true;
    });
  }

  $scope.chooseCustomer = function (customer) {
    if (!customer) {
      $scope.booking.customer_id = null;
      $scope.customer.id = null;

      return;
    }

    if (customer.rate_category_id) {
      $timeout(function() {$scope.common.rateCategoryId = customer.rate_category_id;})
    }

    $scope.rootCustomerType = customer.type;
    $scope.customer = customer;
    $scope.booking.customer_id = customer.id;
    isFullCustomerLoaded = false;

    $scope.fillRoomCustomerWithBlank();

    if (!customer.guest_id || customer.type == 1) {
      return;
    }

    $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/guests/' + customer.guest_id)
      .then(function(response) {
        $scope.guestWasSettled = new Date().getTime();
        $scope.assignGuest($scope, response.data.guest);
      });
  };

  $scope.buildRoomForGroupBooking = function (index, selectedRoom) {
    $scope.loadingRooms += 1;
    var initialAttributes = buildRoomInitialAttributes(selectedRoom)
    return ctrl.roomBuilderService.buildRoom(index, initialAttributes).then(function (room) {
      $scope.loadingRooms -= 1;
    });
  }

  var buildRoomInitialAttributes = function (selectedRoom) {
    return {
      room_id: selectedRoom.id,
      roomTypeId: selectedRoom.roomTypeId,
      total_price: selectedRoom.total_price,
      room_name: selectedRoom.number,
      roomType: null,
      cover_room_type: null,
      guest: $scope.guest,
      checkin_date: $scope.common.checkinDate,
      checkout_date: $scope.common.checkoutDate,
      checkin_time: $scope.common.checkinTime,
      number_of_nights: $scope.common.numberOfNights,
      min_checkout_date: $scope.common.minCheckoutDate,
      cancellation_policy_id: $scope.common.cancellationPolicyId,
      rateCategoryId: $scope.common.rateCategoryId
    }
  }

  $scope.addRoom = function (selectedRoom) {
    var index = $scope.booking.rooms.length;
    var initialAttributes = buildRoomInitialAttributes(selectedRoom)

    if ($scope.rootCustomerType == 1) {
      initialAttributes.guest = {last_name: 'MISSING NAME'}
    }

    if (selectedRoom.number_of_adults) {
      initialAttributes.number_of_adults = selectedRoom.number_of_adults;
    }

    if (selectedRoom.number_of_children) {
      initialAttributes.number_of_children = selectedRoom.number_of_children;
    }

    ctrl.roomBuilderService.buildRoom(index, initialAttributes).then(function (room) {
      room.isForeignAmount = $scope.booking.isForeignAmount;
      $scope.booking.rooms.push(room);

      RoomCalculator.calcTotalPerRoom(room);
      $scope.calcTotal();

      $rootScope.$broadcast('group_booking:room_id_update');
    });
  };

  $scope.isBookingValid = function () {
    var hasCustomer = $scope.booking.customer_id;

    if (!hasCustomer) {
      return false;
    }

    var hasGlobalGuest = $scope.booking.customer && ($scope.booking.customer.guest_id || $scope.booking.customer.guestId);

    var isValid = true;

    _.each($scope.booking.rooms, function (room) {
      isValid = isValid && room.available;
      isValid = isValid && room.nights && room.nights.length > 0;

      if (room.isGuestDirty) {
        isValid = isValid && room.guest.last_name;
      }

      if (room.isGuestCleared) {
        isValid = isValid && room.guest.last_name;
      }

      if (!hasGlobalGuest) {
        isValid = isValid && room.guest.last_name;
      }
    });

    return isValid;
  };

  $scope.isCardValid = function () {
    if ($scope.gateway !== 'stripe_sca') {
      return true;
    }

    if (!$scope.addCreditCard) {
      return true;
    }

    return $scope.isCardDataValid;
  };

  var roomUpdateListener = $rootScope.$on('group_booking:room_id_update', function () {
    $scope.availableRooms = getRooms();
  });

  $scope.$watchCollection('guest', function () {
    var isSourceGuestModified = ctrl.isGuestChanged($scope.guest);

    $scope.booking.rooms.forEach(function (room) {
      if (room.isGuestDirty && !room.isAutoFilled) {
        return;
      }

      room.isSourceGuestModified = isSourceGuestModified;
      room.wasSettled = $scope.guestWasSettled;
      room.guest = angular.copy($scope.guest);
    });
  });

  $scope.handleCommonDatesChange = function (newDates) {
    $scope.loading = true;
    ensureRestrictionsLoaded({ checkinDate: newDates.checkinDate, checkoutDate: newDates.checkoutDate }).then(function () {
      var recalcs = [];

      $scope.booking.rooms.forEach(function (room) {
        if (room.isDateFieldsDirty) {
          return;
        }

        var wasDateChange = false;

        if (room.checkin_date != newDates.checkinDate) {
          room.checkin_date = newDates.checkinDate;
          wasDateChange = true;
        }

        if (room.checkout_date != newDates.checkoutDate) {
          room.checkout_date = newDates.checkoutDate;
          wasDateChange = true;
        }

        if (wasDateChange) {
          // Keep the recalc promise so the Book button stays disabled until
          // room.nights (price_by_night) is consistent with number_of_nights.
          recalcs.push(room.$service.handleRoomDatesChange());
          $rootScope.$broadcast('group_booking:room_id_update');
          $scope.calcTotal();
        }
      });

      return $q.all(recalcs);
    }).finally(function () {
      $scope.calcTotal();
      $scope.loading = false;
    });
  };

  $rootScope.$on('updateBasketRooms', function(e) {
    $scope.updateShowNextToFinalBookingFormButton();
  });

  $scope.$watch('common.checkinTime', function (newValue, prevValue) {
    if (newValue == prevValue) {
      return;
    }

    $scope.booking.rooms.forEach(function (room) {
      if (room.isCheckinTimeDirty) {
        return;
      }

      room.checkin_time = newValue;
    });
  });

  $scope.$watch('common.rateCategoryId', function (newValue, prevValue) {
    if (newValue == prevValue) {
      return;
    }

    $scope.loading = true;

    var rateCategory = $scope.rateCategories.filter(function(rateCategory) { return rateCategory.id == newValue; })[0];

    if ($rootScope.hotel.foreignInvoicesFeatureEnabled) {
      var currencyProfile = $scope.currencyProfiles.find(function(currencyProfile) { return currencyProfile.id == rateCategory.currencyProfileId });
      if (currencyProfile && currencyProfile.code) {
        $scope.booking.foreignCurrency = currencyProfile.code;
        $scope.handleCurrencyChange();
      }
    }

    var recalcs = [];

    $scope.booking.rooms.forEach(function (room) {
      if (room.isRateCategoryIdDirty) {
        return;
      }

      if (room.rateCategoryId != newValue) {
        room.rateCategoryId = newValue;
        room.$service.setRateCategoryById();
        recalcs.push(room.$service.handleRateCategoryChange());
      }
    });

    if (typeof(rateCategory) != 'undefined' && typeof(rateCategory.cancellationPolicyId) != 'undefined' && rateCategory.cancellationPolicyId != null) {
      var cancellationPolicy = $rootScope.hotel.cancellationPolicies.filter(function(cancellationPolicy) { return cancellationPolicy.id == rateCategory.cancellationPolicyId })[0];
      if (typeof(cancellationPolicy) != 'undefined' && !cancellationPolicy.isRemoved) {
        $scope.common.cancellationPolicyId = rateCategory.cancellationPolicyId;
      }
    }

    $q.all(recalcs).finally(function () {
      $scope.calcTotal();
      $scope.loading = false;
    });
  });

  $scope.$watch('common.cancellationPolicyId', function (newValue, prevValue) {
    if (newValue == prevValue) {
      return;
    }

    $scope.booking.rooms.forEach(function (room) {
      if (room.isCancellationPolicyIdDirty) {
        return;
      }

      room.cancellation_policy_id = newValue;
    });
  });

  function syncDropdownWithRooms() {
    var rateCounts = {};
    $scope.booking.rooms.forEach(function(room) {
      // Use the actual applied room rate, not the rateCategoryId
      var actualRateId = room.roomRate ? room.roomRate.rateCategoryId : room.rateCategoryId;
      rateCounts[actualRateId] = (rateCounts[actualRateId] || 0) + 1;
    });

    if (Object.keys(rateCounts).length > 0) {
      var mostCommonRate = Object.keys(rateCounts).reduce(function(a, b) {
        return rateCounts[a] > rateCounts[b] ? a : b;
      });

      if (mostCommonRate && parseInt(mostCommonRate) !== $scope.common.rateCategoryId) {
        $scope.common.rateCategoryId = parseInt(mostCommonRate);
      }
    }
  }

  $scope.$on('create-booking-room-rate-changed', function() {
    $timeout(function() {
      syncDropdownWithRooms();
    }, 0);
  });

  $scope.$on('$destroy', function () {
    if (roomUpdateListener) {
      roomUpdateListener();
    }
  });
}

angular
  .module('buuqit')
  .controller('CreateDateNoteModalCtrl', CreateDateNoteModalCtrl);

CreateDateNoteModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$filter",
  "note",
  "local",
  "DateNoteFactory",
  "DateNotesStorage",
  "Dates"
];

function CreateDateNoteModalCtrl ($rootScope, $scope, $i18next, $mdDialog, $filter, note, local, DateNoteFactory, DateNotesStorage, Dates) {
  angular.extend(
    $scope,
    {
      note        : (function() {
        var el = angular.copy(note);
        el.date = getDate(el.date);

        return el;
      })(),
      open        : false,
      dateOptions : {
        formatYear: 'yy',
        startingDay: 1
      },


      cancel : function () {
        $mdDialog.hide();
      },


      save : function () {
        if ($scope.createDateNote.$valid) {
          if (!note.id) {
            note = new DateNoteFactory();
            DateNotesStorage.notes.push(note);
          }

          note.date = $filter('date')($scope.note.date, "yyyy-MM-dd");
          note.note = $scope.note.note;
          note.status = 'active';
          note.hotelId = $rootScope.hotel.id;
          note.save();

          Dates.setNote(note);

          $rootScope.$broadcast('notes:update');
          $mdDialog.hide();
          if (local.parent.tbfCalendar) {
            local.parent.tbfCalendar.updateDateNote(note.date, note.note);
          }
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.form_is_not_valid_js_str'));
        }
      },


      remove : function () {
        var confirm = $mdDialog.confirm()
            .title($i18next.t('general.confirm.confirm'))
            .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
            .ok($i18next.t('general.confirm.confirm'))
            .cancel($i18next.t('general.confirm.cancel'));

        $mdDialog.show(confirm).then(function() {
          DateNotesStorage.removeNote(note);
          $mdDialog.hide();
          if (local.parent.tbfCalendar) {
            local.parent.tbfCalendar.updateDateNote(note.date, null);
          }
        }, function() {
          local.parent.addNote(undefined, local.day);
        });
      }
    }
  );

  function getDate (date) {
    var parts = date.split("-");
    var y = Number(parts[0]);
    var m = Number(parts[1]);
    var d = Number(parts[2]);
    
    return new Date(y, m - 1, d);
  }
}
angular
  .module('buuqit')
  .controller('CreateBookingModalExperimentalCtrl', CreateBookingModalExperimentalCtrl);

CreateBookingModalExperimentalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$filter",
  "$timeout",
  "$http",
  "$sce",
  "$q",
  "UIDialogService",
  "options",
  "BookingFactory",
  "BookingStorage",
  "CalendarStorage",
  "RateByDateStorage",
  "AvailabilityChecker",
  "RestrictionStorage",
  "RoomCalculator",
];

function CreateBookingModalExperimentalCtrl($rootScope, $scope, $i18next, $mdDialog, $filter, $timeout, $http, $sce, $q, UIDialogService, options, BookingFactory, BookingStorage, CalendarStorage, RateByDateStorage, AvailabilityChecker, RestrictionStorage, RoomCalculator) {
  $scope.guests = {};
  var saveBooking,
      ctrl = this,
      paymentFormMapping = {
        'valitor': 'wubook',
        'payment_express': 'wubook',
        'borgun': 'wubook'
      },
      paymentFormTemplate = paymentFormMapping[$rootScope.hotel.paymentGateway] || $rootScope.hotel.paymentGateway;

  $scope.activeRoomIndex = 0;
  $scope.loadNights = false;
  $scope.loadRestrictions = false;
  $scope.currencySymbol = $rootScope.currencySymbol;

  var gateway = $rootScope.hotel.paymentGateway;
  $scope.gateway = gateway;

  $scope.payment_form = getTemplatePath('tokenization/create_booking/' + paymentFormTemplate + '.html');
  $scope.pci_booking_iframe_path = $sce.trustAsResourceUrl(SERVER_PATH + '/api/public/v1/credit_card_form');


  var pcibooking_callback = function (event) {
    // if we are processing message from pci booking iframe
    if (event.data && (_.isObject(event.data) || event.data === 'invalid' || event.data === 'valid')) {
      // card in iframe is invalid, iframe shows invalid fields
      if (event.data === 'invalid' || (event.data.valid !== undefined && !event.data.valid)) {
        $scope.loading = false;

        return;
      }

      // card in iframe is valid, submitting card for tokenization
      if (event.data === 'valid' || (event.data.valid !== undefined && event.data.valid)) {
        document.getElementById('pcibooking_frame').contentWindow.postMessage('submit', '*');

        return;
      }

      // card tokenization completed
      var data = event.data;
      var status = data.success;
      var token = data.token;
      var card = data.card;

      if (status === undefined) return;
      if (status === true) {
        $scope.booking.nonce = card ? card.card_token : token;
        $scope.booking.cvv_present = true;
        $scope.booking.cardholder_name = card ? card.cardholder_name : window.decodeURI(data.cardHolderName);
        $scope.booking.card_type = card ? card.card_type : data.cardType;
        $scope.booking.expiration_year = card ? card.expiration_year : data.expiration.slice(2,6);
        $scope.booking.expiration_month = card ? card.expiration_month : data.expiration.slice(0,2);
        $scope.booking.last_4 = card ? card.card_number : data.cardNumber;

        if (window.addEventListener) {
          window.removeEventListener('message', pcibooking_callback);
        } else if (window.attachEvent) {
          window.detachEvent('onmessage', $scope.pcibooking_callback);
        }

        saveBooking();
      } else {
        $rootScope.notify($i18next.t('general.other.error'));
        $scope.loading = false;
        return;
      }
    }
  };


  // TODO: Move this logic into tokenization library
  if (window.braintree && gateway == 'braintree') {
    braintree.setup($rootScope.hotel.clientToken, "dropin", {
      container: "braintree-drop-in",
      onPaymentMethodReceived: function (response) {
        $scope.booking.nonce = response.nonce;
        $scope.booking.cvv_present = true;
        saveBooking();
      }
    });
  }

  if (gateway === 'wubook' || gateway == 'payment_express' || gateway == 'valitor' || gateway == 'valitor_pay' || gateway == 'borgun') {
    if (window.addEventListener) {
      window.addEventListener('message', pcibooking_callback);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', $scope.pcibooking_callback);
    }
  }

  if (window.Stripe && gateway == 'stripe') {
    Stripe.setPublishableKey($rootScope.hotel.clientToken);
  }

  if (window.Stripe && gateway === 'stripe_sca') {
    $scope.stripeScaGateway = window.Stripe($rootScope.hotel.clientToken);
    var elements = $scope.stripeScaGateway.elements();
    $scope.cardElements = elements.create('card', {
      hidePostalCode: true,
    });

    $scope.cardElements.on('change', function (payload) {
      if (payload.elementType === 'card') {
        $scope.card.number = true;
      }
    });

    var waitAndMount = function() {
      setTimeout(function () {
        if (document.getElementById('stripe-sca-drop-in')) {
          $scope.cardElements.mount('#stripe-sca-drop-in');
        } else {
          waitAndMount();
        }
      }, 500)};
    waitAndMount();
  }

  if (window.Omise && gateway == 'omise') {
    Omise.setPublicKey($rootScope.hotel.clientToken);
  }

  if (window.Worldpay && gateway == 'worldpay') {
    setTimeout(function() {
      Worldpay.useOwnForm({
        'clientKey': $rootScope.hotel.clientToken,
        'form': document.getElementsByClassName('booking-form')[0],
        'reusable': true,
        'callback': function(status, response) {
          if (response.error) {
          } else {
            $scope.booking.nonce = response.token;
            $scope.booking.cvv_present = true;
            saveBooking();
          }
        }
      });
    }, 500);
  }

  $scope.policies = $rootScope.hotel.cancellationPolicies.filter(function(el) { return !el.isRemoved; });

  $scope.calcTotal = function () {
    $timeout(function () {
      var total = 0;

      for (var roomIndex in $scope.booking.rooms) {
        if ($scope.booking.rooms.hasOwnProperty(roomIndex)) {
          total += $scope.booking.rooms[roomIndex].total_price;
        }
      }

      $scope.total = total;
    }, 0);
  };

  this.buildBookingCustomerAndGuestParams = function (booking) {
    if ($scope.isOverrideCustomer) {
      booking.customer = ctrl.generateCustomer();
    }

    if ($scope.isCreateNewGuest) {
      booking.customer = ctrl.generateCustomer();
      booking.customer.is_new_guest = true;

      ctrl.processCreateNewGuestForBooking(booking);
    }

    if ($scope.customer.name && $scope.customerInfo.query != $scope.customer.name) {
      booking.customer_id = null;
    }

    if (!booking.customer_id && !booking.customer) {
      ctrl.processCreateNewCustomerForBooking(booking);
    }
  };

  saveBooking = function () {
    var booking = angular.copy($scope.booking);
    var available = true;

    var customerWasChanged = ctrl.isCustomerChanged();

    if (customerWasChanged && $scope.guestOverrideIsResolved !== true) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.create_booking.guest_changes_confirmation.title'),
        text: $i18next.t('bookings.create_booking.guest_changes_confirmation.text'),
        negative: $i18next.t('bookings.create_booking.guest_changes_confirmation.negative'),
        positive: $i18next.t('bookings.create_booking.guest_changes_confirmation.positive'),
        positive_callback: function () {
          // create new

          $scope.guestOverrideIsResolved = true;
          $scope.isCreateNewGuest = true;
          saveBooking();
        },
        negative_callback: function () {
          // override

          $scope.guestOverrideIsResolved = true;
          $scope.isOverrideCustomer = true;
          saveBooking();
        }
      });
    } else {
      // used to display guest details on calendar
      booking.defaultGuestForCalendar = ctrl.generateGuestForCalendar();

      ctrl.buildBookingCustomerAndGuestParams(booking);

      booking.rooms.forEach(function (room) {
        if (!room.isGuestDirty) {
          delete room.guest;

          if ($scope.customer.guest_id == room.guest_id) {
            delete room.guest_id;
          }
        }
      });

      if ($filter('filter')(booking.rooms, function(el){return el.available === false;}).length > 0) {
        available = false;
      }

      if (available) {
        createBooking(booking);
      } else {
        $scope.loading = false;
        $rootScope.alert($i18next.t("bookings.create_booking.alert.not_all_rooms_available_for_booking_js_str"));
      }
    }
  };

  this.processCreateNewGuestForBooking = function (booking) {
    // we should delete guest details from first room in full booking mode
    // this is needed because one form/UI used to represent first room guest and customer details
    // when user chooses to create new guest profile it means that we should not touch prev customer guest
    // new create guest profile will be attached to customer and to first room
    delete booking.rooms[0].guest;
    delete booking.rooms[0].guest_id;
  };

  this.processCreateNewCustomerForBooking = function (booking) {
    if (booking.rooms[0].guest_id) {
      booking.customer = ctrl.generateCustomer({ onlyFromField: true });
    } else {
      booking.customer = ctrl.generateCustomer({ onlyFromField: false });

      delete booking.rooms[0].guest;
      delete booking.rooms[0].guest_id;
    }
  };

  createBooking = function (booking) {
    booking = angular.copy(booking);

    var check = _checkRoomOccupancy(booking);

    if (check.status === false) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.create_booking.confirmation.title'),
        text: $i18next.t('bookings.create_booking.confirmation.text') + '<br/>'+_generateProblemMessage(check.problems),
        positive_callback: function () {
          createBookingCallback(booking);
        },
        negative_callback: function () {
          $scope.loading = false;
        }
      });
    } else {
      createBookingCallback(booking);
    }
  };

  createBookingCallback = function (booking) {
    if (gateway == 'none') {
      booking.nonce = $scope[gateway].getNonce();
    }

    if ((gateway == 'wubook' || gateway == 'payment_express' || gateway == 'valitor' || gateway == 'valitor_pay' || gateway == 'borgun') && $scope.booking.nonce === null && $scope.addCreditCard) {
      document.getElementById('pcibooking_frame').contentWindow.postMessage('validate', '*');
    } else {
      $scope.loading = true;

      _.each(booking.rooms, function (el) {
        delete el.$service;

        el.rate_category_id = Number(el.rateCategory.id);
        el.room_type_id = Number(el.roomType.id);
        el.room_rate_id = el.roomRate.id;
        el.room_id = Number(el.room_id);
        el.number_of_nights = Number(el.number_of_nights);
        el.checkin_date = $filter('date')(el.checkin_date, "yyyy-MM-dd");
        el.room_representation_id = el.roomRepresentation.id;

        el.nights.forEach(function(p) {
          if (((p.price === undefined) || (p.price === null)) && (el.total_price == 0)) {
              p.price = 0;
          }
        })
      });

      booking.id = String(new Date().getTime());

      var defaultGuestForCalendar = booking.defaultGuestForCalendar;
      delete booking.defaultGuestForCalendar;

      booking = new BookingFactory(booking);

      // calendar renders guest information based on booking room.guest
      // for rooms with default guest (customer guest) we temporary add this information
      booking.rooms.forEach(function (room) {
        if (!room.guest) {
          room.guest = defaultGuestForCalendar;

          // this is a hack to tell that this guest should not be sent to backend
          room.guest.skip = true;
        }
      });

      BookingStorage.bookings.push(booking);

      booking._save();

      $rootScope.bookingForHighlight = booking.id;

      removeEventListeners();
      $mdDialog.hide(booking);
    }
  };

  _generateProblemMessage = function (problems) {
    return problems.map(function(problem) {
      return $i18next.t('general.other.room') + " " + problem[0] + "," + $i18next.t('bookings.create_booking.max_adults_js_str') + " " + problem[1] + ", " + $i18next.t('bookings.create_booking.max_children_js_str') + " " + problem[2] + ", "+ $i18next.t('profile_nav.settings.inventory.room_type_form.max_occupancy_label') + ": " + problem[3];
    }).join('\r\n');
  };

  _checkRoomOccupancy = function (booking) {
    var status = true;
    var problems = [];

    booking.rooms.forEach(function (room) {
      var roomStatus = Number(room.number_of_adults) <= room.roomType.maxAdults && Number(room.number_of_children) <= room.roomType.maxChildren && (Number(room.number_of_adults) + Number(room.number_of_children)) <= room.roomType.maxOccupancy;
      status = status && roomStatus;

      if (roomStatus === false) {
        problems.push([
          room.room_name,
          room.roomType.maxAdults,
          room.roomType.maxChildren,
          room.roomType.maxOccupancy
        ]);
      }
    });

    return {
      status: status,
      problems: problems
    }
  };

  var removeEventListeners = function () {
    if (gateway === 'wubook' || gateway == 'payment_express' || gateway == 'valitor' || gateway == 'valitor_pay' || gateway == 'borgun') {
      if (window.addEventListener) {
        window.removeEventListener('message', pcibooking_callback);
      } else if (window.attachEvent) {
        window.detachEvent('onmessage', pcibooking_callback);
      }
    }

    if (gateway === 'stripe_sca') {
      $scope.cardElements.destroy();
    }
  };

  this.isGuestChanged = function (guest) {
    if (guest.id && $scope.guests[guest.id]) {
      var original = $scope.guests[guest.id];

      return !(
        guest.first_name === original.first_name
        && guest.last_name === original.last_name
        && guest.email === original.email
        && guest.phone === original.phone
        && guest.address === original.address
        && guest.city === original.city
        && guest.country === original.country
        && guest.state === original.state
        && guest.zipCode === original.zip_code
        && guest.locale === original.locale
        && guest.nationality === original.nationality
        && guest.identifiction_type_id === original.identifiction_type_id
        && guest.identification === original.identification
      )
    } else {
      return false;
    }
  };

  this.isCustomerChanged = function() {
    return ctrl.isGuestChanged($scope.booking.rooms[0].guest);
  };

  this.isCustomerDirty = function() {
    return $scope.booking.rooms[0].isGuestDirty;
  };

  var guestIsEmpty = function(room) {
    return !(Boolean(room.guest.first_name) || Boolean(room.guest.last_name));
  };

  this.generateCustomer = function (options) {
    // two modes to generate customer attributes based on `onlyFromField`
    // when user creates new customer by filling autocomplete field without founded results
    // we should create new customer with last and first based on that input
    // but also user can select some existing guest on form. Because form is common for first room guest attributes and
    // customer attributes it means that we should not use existing guest attributes for new customer, so we build customer
    // attributes only based on autocomplete field
    options = options || {
      onlyFromField: false
    };

    var output = {
      customer_type: $scope.customerInfo.type
    };

    if ($scope.customerInfo.type === 1) {
      output.company_name = $scope.customerInfo.query;
    } else {
      var names = $scope.customerInfo.query.split(" ");

      if (names.length === 1) {
        output.last_name = names[0];
      } else {
        output.first_name = names[0];
        output.last_name = names.slice(1, names.length).join(" ");
      }
    }

    if (options.onlyFromField) {
      return output;
    }

    var roomWithCustomer = $scope.booking.rooms[0];

    output.last_name = roomWithCustomer.guest.last_name;
    output.first_name = roomWithCustomer.guest.first_name;
    output.email = roomWithCustomer.guest.email;
    output.phone = roomWithCustomer.guest.phone;
    output.address = roomWithCustomer.guest.address;
    output.city = roomWithCustomer.guest.city;
    output.country = roomWithCustomer.guest.country;
    output.zipCode = roomWithCustomer.guest.zipCode;
    output.locale = roomWithCustomer.guest.locale;

    return output;
  };

  this.generateGuestForCalendar = function () {
    var customer = this.generateCustomer();

    return {
      customer_type: customer.customer_type,
      company_name: customer.company_name,
      first_name: customer.first_name,
      last_name: customer.last_name,
    }
  };

  angular.extend(
    $scope,
    {
      addCreditCard : gateway === 'braintree',

      toggleCreditCard: function () {
        $scope.addCreditCard = !$scope.addCreditCard;
      },

      cancel: function () {
        removeEventListeners();
        $mdDialog.hide();
      },

      finish: function () {
        if ($scope.createBookingForm.$valid) {
          $scope.loading = true;

          if ($scope.booking && $scope.booking.rooms) {
            $scope.booking.rooms.forEach(function (room) {
              room.cancellation_policy_id = $scope.common.cancellationPolicyId;
            });
          }

          if ($scope.addCreditCard === true && gateway == 'braintree') {
            $timeout(function () {
              $('.submit-braintree').trigger('click');
            }, 0);
          } else {
            if (gateway == 'stripe' && $scope.card.number) {
              Stripe.card.createToken({
                name: $scope.card.cardholder_name,
                number: $scope.card.number,
                cvc: $scope.card.cvv,
                exp_month: $scope.card.expiration.split('/')[0],
                exp_year: $scope.card.expiration.split('/')[1]
              }, function(status, response) {
                $scope.booking.nonce = response.id;
                $scope.booking.cvv_present = true;

                saveBooking();
              });
            } else if (gateway == 'worldpay') {
              $('.booking-form').submit();
            } else if (gateway == 'omise' && $scope.card.number) {
              Omise.createToken('card',{
                name: $scope.card.cardholder_name,
                number: $scope.card.number,
                security_code: $scope.card.cvv,
                expiration_month: $scope.card.expiration.split('/')[0],
                expiration_year: $scope.card.expiration.split('/')[1]
              }, function(status, response) {
                $scope.booking.nonce = response.id;
                $scope.booking.cvv_present = true;

                saveBooking();
              });
            } else if (gateway == 'worldpay') {
              $('.booking-form').submit();
            } else if (gateway == 'stripe_sca' && $scope.addCreditCard && $scope.card.number) {
              if (typeof($rootScope.hotel.paymentGatewaySettings.passAddressInfo) == "undefined" || $rootScope.hotel.paymentGatewaySettings.passAddressInfo == true) {
                var data = {};
                data.address = {};
                data.address.city = $scope.guest.city;
                data.address.country = $scope.guest.countryShort;
                data.address.line1 = $scope.guest.address;
                data.address.state = $scope.guest.state;
                data.address.postal_code = $scope.guest.zipCode;
              }

              $scope.stripeScaGateway.createPaymentMethod('card', $scope.cardElements, {
                billing_details: data
              })
                .then(function (result) {
                  if (result.error) {
                    return Promise.reject(result.error);
                  }

                  $scope.booking.nonce = result.paymentMethod.id;
                  $scope.booking.cvv_present = result.paymentMethod.card.checks.cvc_check;

                  saveBooking();
                })
                .catch(function(error){
                  // validation errors should already be displayed on stripe elements, so do not do anything special with it
                  // other error type probably should be handled explicitly
                  if (error.type !== "validation_error") {
                    console.error(error);
                  }

                  $scope.loading = false;
                });
            } else {
              saveBooking();
            }
          }
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.form_is_not_valid_js_str'));
        }
      },

      addRoom: function () {
        if ($scope.createBookingForm.$invalid) {
          return;
        }

        var index = $scope.booking.rooms.length;

        ctrl.roomBuilderService.buildRoom(index).then(function (room) {
          room.guest.last_name = $scope.booking.rooms[0].guest.last_name;

          $scope.booking.rooms.push(room);
          $scope.activeRoomIndex = index;

          RoomCalculator.calcTotalPerRoom(room);
          $scope.calcTotal();
        });
      },

      setActiveRoom: function (index) {
        $scope.activeRoomIndex = index;
      },

      removeRoom: function (index) {
        $scope.booking.rooms.splice(index, 1);
        $scope.activeRoomIndex = $scope.booking.rooms.length - 1;

        $scope.calcTotal();
      },

      hasNotValidRooms: function () {
        var isRoomValid = true;

        _.each($scope.booking.rooms, function (room) {
          isRoomValid = isRoomValid && room.available;
          isRoomValid = isRoomValid && room.nights && room.nights.length > 0;

          if (room.isGuestDirty) {
            isRoomValid = isRoomValid && room.guest.last_name;
          }

          if (room.isGuestCleared) {
            isRoomValid = isRoomValid && room.guest.last_name;
          }
        });

        return !isRoomValid;
      },

      // FEATURES: sale-channels
      // method should be deleted after feature goes out of feature flag
      searchChannel: function (query) {
        var channels = _.compact(_.uniq(_.union(($rootScope.hotel.offlineChannels || []), ['Walk In', 'Telephone', 'Email'])));
        $scope.booking.channel = query;

        return channels
          .filter(function(channel) {
            return query && query.length > 0 && channel && channel.toLowerCase ? channel.toLowerCase().indexOf(query.toLowerCase()) != -1 : true;
          }).sort(function(a, b) {
            if (a > b) { return 1; }
            if (a < b) { return -1; }
            return 0;
          });
      },

      searchCustomer: function(query) {
        return $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/customers', {
          params: {
            query: query,
            page: 0,
            sort_field: 'visible_name',
            sort_direction: 'ASC'
          }
        }).then(function(results) {
          return results.data.customers;
        });
      },

      clearGuestInfo: function(room) {
        room.guest = {
          title: null,
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          address: null,
          city: null,
          country: null,
          state: null,
          zipCode: null,
          locale: null,
          hotel_id: $rootScope.hotel.id
        };

        room.isGuestDirty = false;
      },

      assignGuest: function(guestContainer, guest) {
        $scope.guests[guest.id] = guest;

        guestContainer.guest.id = guest.id;
        guestContainer.guest.first_name = guest.first_name;
        guestContainer.guest.last_name = guest.last_name;
        guestContainer.guest.email = guest.email;
        guestContainer.guest.phone = guest.phone;
        guestContainer.guest.address = guest.address;
        guestContainer.guest.city = guest.city;
        guestContainer.guest.country = guest.country;
        guestContainer.guest.state = guest.state;
        guestContainer.guest.zipCode = guest.zip_code;
        guestContainer.guest.locale = guest.locale;
        guestContainer.guest.nationality = guest.nationality;
        guestContainer.guest.identifiction_type_id = guest.identifiction_type_id;
        guestContainer.guest.identification = guest.identification;
        guestContainer.guest_id = guest.id;

        guestContainer.isGuestCleared = false;
        guestContainer.wasSettled = new Date().getTime();
      },

      onGuestChange: function (guest) {
        if (guest.customer_id && $scope.booking.customer_id === null && !$scope.customerInfo.query) {
          $scope.booking.customer_id = guest.customer_id;

          $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/customers/' + guest.customer_id)
            .then(function(response) {
              if (response && response.data && response.data.customer) {
                $scope.customer = response.data.customer;
                $scope.customer.guest_id = guest.id;
                $scope.customerInfo.query = response.data.customer.name;
              }
            });
        }
      },

      chooseCustomer: function(customer) {
        if (customer) {
          customer.name = customer.visible_name;
          $scope.customer = customer;
          $scope.booking.customer_id = customer.id;

          if (customer.guest_id && guestIsEmpty($scope.booking.rooms[0])) {
            $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/'+customer.guest_id)
              .then(function(response) {
                $scope.assignGuest($scope.booking.rooms[0], response.data.guest);
              });
          }
        }
      },

      booking: {
        source: 'app',
        confirmation: false,
        nonce: null,
        hotel_id: $rootScope.hotel.id,
        customer_id: null,
        rooms: []
      },
      card: {
        number: null,
        expiration: null,
        cvv: null,
        cardholder_name: null,
        type: null
      },
      customer: {
        id: null,
        first_name: '',
        last_name: '',
        email: '',
        customerType: 0
      },
      customerInfo: {
        query: '',
        type: 0
      },

      total: 0,
      loading: false,
      blocked_rooms: [],
      sale_channels: $rootScope.hotel.saleChannels,
      isSaleChannelsFeatureEnabled: $rootScope.hotel.saleChannelsFeatureEnabled
    }
  );

  this.initialRoom = options.initialRoom;
  this.roomBuilderService = options.roomBuilderService;

  this.roomBuilderService.booking = $scope.booking;
  this.roomBuilderService.blockedRooms = $scope.blocked_rooms;

  this.initialRoom.$service.booking = $scope.booking;
  this.initialRoom.$service.blockedRooms = $scope.blocked_rooms;

  $scope.booking.rooms.push(this.initialRoom);
  $scope.blocked_rooms.push(this.initialRoom.room_id);

  RoomCalculator.calcTotalPerRoom(this.initialRoom);
  $scope.calcTotal();

  $timeout(function(){
    angular.element('[name="lastName0"]').focus();
  });
}

angular
  .module('buuqit')
  .controller('CreateBookingModalCtrl', CreateBookingModalCtrl);

CreateBookingModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$filter",
  "$timeout",
  "$http",
  "$sce",
  "$q",
  "UIDialogService",
  "options",
  "BookingFactory",
  "BookingStorage",
  "CalendarStorage",
  "RateByDateStorage",
  "AvailabilityChecker",
  "RestrictionStorage",
  "GuestFactory"
];

function CreateBookingModalCtrl ($rootScope, $scope, $i18next, $mdDialog, $filter, $timeout, $http, $sce, $q, UIDialogService, options, BookingFactory, BookingStorage, CalendarStorage, RateByDateStorage, AvailabilityChecker, RestrictionStorage, GuestFactory) {
  var activeRoom         = 0,
    closed_rooms       = [],
    initialRoom        = $filter('filter')($rootScope.hotel.rooms, function(el){return el.id == options.room_id;})[0],
    calcNigthsCount,
    fillNights,
    calcTotalPerRoom,
    calcTotal,
    setInitialRoom,
    saveBooking,
    roomTemplate,
    getRestrictions,
    filterAvailableRates,
    paymentFormMapping = {
      'valitor': 'wubook',
      'valitor_pay': 'wubook',
      'payment_express': 'wubook',
      'borgun': 'wubook'
    },
    paymentFormTemplate = paymentFormMapping[$rootScope.hotel.paymentGateway] || $rootScope.hotel.paymentGateway;

  $scope.locales = window.locales;
  $scope.loadNights = false;
  $scope.loadRestrictions = false;
  $scope.countries = countries_in;
  $scope.currencySymbol = $rootScope.currencySymbol;
  $scope.gateway = $rootScope.hotel.paymentGateway;

  $scope.payment_form = getTemplatePath('tokenization/create_booking/' + paymentFormTemplate + '.html');
  $scope.pci_booking_iframe_path = $sce.trustAsResourceUrl(SERVER_PATH + '/api/public/v1/credit_card_form');

  $scope.pcibooking_callback = function (event) {
    // if we are processing message from pci booking iframe
    if (event.data && (_.isObject(event.data) || event.data === 'invalid' || event.data === 'valid')) {
      // card in iframe is invalid, iframe shows invalid fields
      if (event.data === 'invalid' || (event.data.valid !== undefined && !event.data.valid)) {
        $scope.loading = false;
        return;
      }

      // card in iframe is valid, submitting card for tokenization
      if (event.data === 'valid' || (event.data.valid !== undefined && event.data.valid)) {
        document.getElementById('pcibooking_frame').contentWindow.postMessage('submit', '*');

        return;
      }

      // card tokenization completed
      var data = event.data;
      var status = data.success;
      var token = data.token;
      var card = data.card;

      if (status === undefined) return;
      if (status === true) {
        $scope.booking.nonce = card ? card.card_token : token;
        $scope.booking.cvv_present = true;
        $scope.booking.cardholder_name = card ? card.cardholder_name : window.decodeURI(data.cardHolderName);
        $scope.booking.card_type = card ? card.card_type : data.cardType;
        $scope.booking.expiration_year = card ? card.expiration_year : data.expiration.slice(2,6);
        $scope.booking.expiration_month = card ? card.expiration_month : data.expiration.slice(0,2);
        $scope.booking.last_4 = card ? card.card_number : data.cardNumber;

        if (window.addEventListener) {
          window.removeEventListener('message', $scope.pcibooking_callback);
        } else if (window.attachEvent) {
          window.detachEvent('onmessage', $scope.pcibooking_callback);
        }

        saveBooking();
      } else {
        $rootScope.notify($i18next.t('general.other.error'));
        $scope.loading = false;
        return;
      }
    }
  };


  // TODO: Move this logic into tokenization library
  if (window.braintree && $scope.gateway == 'braintree') {
    braintree.setup($rootScope.hotel.clientToken, "dropin", {
      container: "braintree-drop-in",
      onPaymentMethodReceived: function (response) {
        $scope.booking.nonce = response.nonce;
        $scope.booking.cvv_present = true;
        saveBooking();
      }
    });
  }

  if ($scope.gateway === 'wubook' || $scope.gateway == 'payment_express' || $scope.gateway == 'valitor' || $scope.gateway == 'borgun') {
    if (window.addEventListener) {
      window.addEventListener('message', $scope.pcibooking_callback);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', $scope.pcibooking_callback);
    }
  }

  if (window.Stripe && $scope.gateway == 'stripe') {
    Stripe.setPublishableKey($rootScope.hotel.clientToken);
  }

  if (window.Stripe && $scope.gateway === 'stripe_sca') {
    $scope.stripeScaGateway = window.Stripe($rootScope.hotel.clientToken);
    var elements = $scope.stripeScaGateway.elements();
    $scope.cardElements = elements.create('card', {
      hidePostalCode: true,
    });

    $scope.cardElements.on('change', function (payload) {
      if (payload.elementType === 'card') {
        $scope.card.number = true;
      }
    });

    var waitAndMount = function() {
      setTimeout(function () {
        if (document.getElementById('stripe-sca-drop-in')) {
          $scope.cardElements.mount('#stripe-sca-drop-in');
        } else {
          waitAndMount();
        }
      }, 500)};
    waitAndMount();
  }

  if (window.Omise && $scope.gateway == 'omise') {
    Omise.setPublicKey($rootScope.hotel.clientToken);
  }

  if (window.Worldpay && $scope.gateway == 'worldpay') {
    setTimeout(function() {
      Worldpay.useOwnForm({
        'clientKey': $rootScope.hotel.clientToken,
        'form': document.getElementsByClassName('booking-form')[0],
        'reusable': true,
        'callback': function(status, response) {
          if (response.error) {
          } else {
            $scope.booking.nonce = response.token;
            $scope.booking.cvv_present = true;
            saveBooking();
          }
        }
      });
    }, 500);
  }

  $scope.wubook = {
    getNonce : function () {
      return btoa([$scope.card.number, $scope.card.cvv, $scope.card.cardholder_name, $scope.card.expiration].join('|'));
    }
  };

  calcNigthsCount = function (booking) {
    return moment(booking.date_out).diff(moment(booking.date_in), 'days');
  };


  fillNights = function (number_of_nights, date_in, roomRateId) {
    var nights = number_of_nights,
      dates = [];

    $scope.loadNights = true;

    if (typeof(date_in) == 'number') {
      date_in = new Date(date_in);
    }

    if (typeof(date_in) == 'string') {
      date_in = moment(date_in).toDate();
    }

    for (x = 0; x < nights; x++) {
      dates.push(moment(date_in).add(x, 'd').format('YYYY-MM-DD'));
    }

    if ($scope.booking && $scope.booking.rooms[activeRoom].restrictions) {
      return $q(function(resolve) {
        $scope.loadNights = false;
        resolve(dates.map(function(date) {
          return {
            date: date,
            price: $scope.booking.rooms[activeRoom].restrictions[roomRateId][date] && $scope.booking.rooms[activeRoom].restrictions[roomRateId][date]['rate'] || 0
          };
        }));
      });
    } else {
      return $q(function(resolve) {
        $scope.loadNights = false;
        resolve(dates.map(function(date) {
          return {
            date: date,
            price: 0
          };
        }));
      });
    }
  };

  $scope.cover_room_types = (function() {
    out = [];
    $rootScope.hotel.roomTypes.forEach(function(rt) {
      out.push({
        id: rt.id,
        title: rt.shortName,
        room_type_id: rt.id
      });
    });

    $rootScope.hotel.coverRoomTypes.forEach(function(rt) {
      out.push({
        id: 's'+rt.id,
        title: rt.name + ' ' + $i18next.t("bookings.create_booking.booking_form.virtual_js_str"),
        room_type_id: rt.roomTypeId
      });
    });
    return out;
  })();

  $scope.policies = $rootScope.hotel.cancellationPolicies.filter(function(el){ return !el.isRemoved; });

  var rr = $rootScope
    .hotel
    .roomRepresentations.filter(function (e) {return e.roomTypeId == initialRoom.roomTypeId})
    .map(function(rr) {
      return rr.id;
    });
  var roomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {return rr.indexOf(roomRate.roomRepresentationId) !== -1 && roomRate.isRemoved == false})
    .map(function(el) {return el.rateCategoryId});
  var initialRateCategories = $rootScope.hotel.rateCategories.filter(function(el) {return roomRates.indexOf(el.id) !== -1});
  var initialRate = initialRateCategories.filter(function(el) {return el.isBaseRate})[0];

  if (!initialRate) {
    initialRate = initialRateCategories[0];
  }

  roomTemplate = {
    active             : true,
    available          : true,
    room_name          : null,
    opened_in          : false,
    opened_out         : false,
    total_price        : 0,
    maxDates           : 30,

    checkin_date       : options.date_in,
    checkin_time       : null,
    checkout_date      : options.date_out,
    min_checkout_date  : moment(options.date_in).add(1, 'day').toDate(),
    max_checkout_date  : options.date_out,

    number_of_nights   : calcNigthsCount(options),
    number_of_adults   : $rootScope.hotel.roomTypes.filter(function(roomType) {return roomType.id == initialRoom.roomTypeId;})[0].defaultAdultsCount,
    number_of_children : $rootScope.hotel.roomTypes.filter(function(roomType) {return roomType.id == initialRoom.roomTypeId;})[0].defaultChildrenCount,

    room_type          : initialRoom.roomTypeId,
    room_type_id       : initialRoom.roomTypeId,
    room_id            : null,
    cover_room_type    : $scope.cover_room_types.filter(function(el) {return el.id == initialRoom.roomTypeId})[0],
    rate_category_id   : initialRate ? initialRate.id : null,
    hotel_id           : $rootScope.hotel.id,

    room_select        : null,
    room_type_select   : $rootScope.hotel.roomTypes.filter(function(roomType) {return roomType.id == initialRoom.roomTypeId;})[0],
    rate_select        : initialRate ? initialRate[0] : null,

    dont_move          : false,
    note               : null,

    nights_select      : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],

    guest : {
      title        : null,
      first_name   : null,
      last_name    : null,
      email        : null,
      phone        : null,
      hotel_id     : $rootScope.hotel.id
    }
  };

  roomTemplate.roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(roomRepresentation) {
    return roomRepresentation.roomTypeId == roomTemplate.room_type_id && roomRepresentation.coverRoomTypeId == null;
  })[0];
  roomTemplate.roomRepresentationId = roomTemplate.roomRepresentation.id;

  roomTemplate.applicableRoomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {
    return roomRate.roomRepresentationId == roomTemplate.roomRepresentationId
      && roomRate.maxAdults >= Number(roomTemplate.number_of_adults)
      && roomRate.maxChildren >= Number(roomTemplate.number_of_children)
      && roomRate.isRemoved === false;
  });

  roomTemplate.roomRate = $rootScope.hotel.roomRates.filter(function(roomRate) {
    return roomRate.isRemoved === false && roomRate.rateCategoryId === roomTemplate.rate_category_id && roomRate.roomRepresentationId === roomTemplate.roomRepresentation.id
  })[0];

  roomTemplate.cancellation_policy_id = roomTemplate.roomRate.cancellationPolicyId;

  getRestrictions = function (room) {
    $scope.loadRestrictions = true;
    RestrictionStorage
      .load(
        moment(room.checkin_date).format('YYYY-MM-DD'),
        moment(room.checkout_date).format('YYYY-MM-DD')
      )
      .then(function(restrictions) {
        room.restrictions = restrictions;
        filterAvailableRates(room);
        $scope.loadRestrictions = false;
      });
  }

  filterAvailableRates = function(room) {
    room.applicableRoomRates = $rootScope.hotel
      .roomRates
      .filter(function(roomRate) {
        return roomRate.roomRepresentationId == room.roomRepresentationId
          && roomRate.maxAdults >= Number(room.number_of_adults)
          && roomRate.maxChildren >= Number(room.number_of_children)
          && roomRate.isRemoved === false;
      })
      .filter(function(roomRate) {
        var values = [];

        var rateRestrictions = room.restrictions[roomRate.id];
        if (!rateRestrictions) {
          return false;
        }

        Object
          .keys(rateRestrictions)
          .sort()
          .forEach(function(date) {
            var d = new Date(new Date(date).setHours(0,0,0,0));
            if (d >= room.checkin_date && d <= room.checkout_date) {
              values.push(room.restrictions[roomRate.id][date]);
            }
          });

        return values[values.length - 1].closedToDeparture == false
          && values[0].closedToArrival == false
          && values[0].minStayArrival <= Number(room.number_of_nights)
          && (values[0].maxStay >= Number(room.number_of_nights) || values[0].maxStay == 0)
          && values.slice(0, values.length - 1).map(function(el) { return el.stopSell; }).reduce(function(out, el) {
            return out && el == false;
          }, true)
          && values.slice(0, values.length - 1).map(function(el) { return el.minStayThrough; }).reduce(function(out, el) {
            return out && el <= Number(room.number_of_nights);
          }, true);
      });

    var applicableRateCategoryIds = _.uniq(room.applicableRoomRates.map(function(el) {
      return el.rateCategoryId;
    }));

    $scope.changeRoom('rate');
  }

  fillNights(calcNigthsCount(options), options.date_in, roomTemplate.roomRate.id).then(function(result) {
    roomTemplate.nights = result;
  });


  calcTotalPerRoom = function () {
    var total = 0;

    for (var night in $scope.booking.rooms[activeRoom].nights) {
      if ($scope.booking.rooms[activeRoom].nights.hasOwnProperty(night)) {
        total += $scope.booking.rooms[activeRoom].nights[night].price;
      }
    }

    $scope.booking.rooms[activeRoom].total_price = parseFloat(total.toFixed($rootScope.currencyFractionSize));
    calcTotal();
  };


  calcTotal = function () {
    var total = 0;

    for (var room in $scope.booking.rooms) {
      if ($scope.booking.rooms.hasOwnProperty(room)) {
        total += $scope.booking.rooms[room].total_price;
      }
    }

    $scope.total = total;
  };


  setInitialRoom = function () {
    var firstRoom = angular.copy(roomTemplate);

    firstRoom.room_name = initialRoom.number;
    firstRoom.room_id   = initialRoom.id;
    firstRoom.room_select = $rootScope.hotel.rooms.filter(function (room) { return room.id == initialRoom.id;})[0];

    $scope.booking.rooms.push(firstRoom);
    $scope.blocked_rooms.push(options.room_id);

    calcTotalPerRoom();

    $timeout(function(){
      angular.element('[name="lastName0"]').focus();
    });
  };


  saveBooking = function () {
    var booking = angular.copy($scope.booking);
    var available = true;

    var guest_is_changed = booking.rooms
        .map(function(room) {
          return $scope.guestIsChanged(room.guest);
        })
        .reduce(function(acc, el) {
          return acc || el;
        }, false);

    if ($scope.customerInfo.query !== $scope.customer.name) {
      booking.customer_id = null;
    }

    if ($scope.customerInfo.query && !booking.customer_id) {
      booking.customer = $scope.generateCustomer();
    }

    if (guest_is_changed && $scope.guestOverrideIsResolved !== true) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.create_booking.guest_changes_confirmation.title'),
        text: $i18next.t('bookings.create_booking.guest_changes_confirmation.text'),
        negative: $i18next.t('bookings.create_booking.guest_changes_confirmation.negative'),
        positive: $i18next.t('bookings.create_booking.guest_changes_confirmation.positive'),
        positive_callback: function () {
          $scope.booking.rooms.forEach(function(room) {
            if ($scope.guestIsChanged(room.guest)) {
              room.guest.id = null;
              room.guest_id = null;
            }
          });
          $scope.guestOverrideIsResolved = true;
          saveBooking();
        },
        negative_callback: function () {
          $scope.guestOverrideIsResolved = true;
          saveBooking();
        }
      });
    } else {
      if ($filter('filter')(booking.rooms, function(el){return el.available === false;}).length > 0) {
        available = false;
      }

      if (available) {
        createBooking(booking);
      } else {
        $scope.loading = false;
        $rootScope.alert($i18next.t("bookings.create_booking.alert.not_all_rooms_available_for_booking_js_str"));
      }
    }
  };

  createBooking = function (booking) {
    booking = angular.copy(booking);
    var check = _checkRoomOccupancy(booking);
    if (check.status === false) {
      UIDialogService.open('confirmation', {
        title: $i18next.t('bookings.create_booking.confirmation.title'),
        text: $i18next.t('bookings.create_booking.confirmation.text') + '<br/>'+_generateProblemMessage(check.problems),
        positive_callback: function () {
          createBookingCallback(booking);
        },
        negative_callback: function () {
          $scope.loading = false;
        }
      });
    } else {
      createBookingCallback(booking);
    }
  };


  createBookingCallback = function (booking) {
    if ($scope.gateway == 'none') {
      booking.nonce = $scope[$scope.gateway].getNonce();
    }

    if (($scope.gateway == 'wubook' || $scope.gateway == 'payment_express' || $scope.gateway == 'valitor' || $scope.gateway == 'borgun') && $scope.booking.nonce === null && $scope.addCreditCard) {
      document.getElementById('pcibooking_frame').contentWindow.postMessage('validate', '*');
    } else {
      $scope.loading = true;

      _.each(booking.rooms, function (el) {
        var rate = $rootScope.hotel.rateCategories.filter(function(rc) {return rc.id == el.rate_category_id})[0];
        el.rate_category_id = Number(el.rate_category_id);
        el.room_type_id = Number(el.room_type_id);
        el.room_rate_id = el.roomRate.id;
        el.room_id = Number(el.room_id);
        el.number_of_nights = Number(el.number_of_nights);
        el.checkin_date = $filter('date')(el.checkin_date, "yyyy-MM-dd");
        el.room_representation_id = el.roomRepresentationId;
        el.nights.forEach(function(p) {
          if (((p.price === undefined) || (p.price === null)) && (el.total_price == 0)) {
            p.price = 0;
          }
        })
      });

      _createBooking(booking);
    }
  };


  _generateProblemMessage = function (problems) {
    return problems.map(function(problem) {
      return $i18next.t('general.other.room') + " " + problem[0] + "," + $i18next.t('bookings.create_booking.max_adults_js_str') + " " + problem[1] + ", " + $i18next.t('bookings.create_booking.max_children_js_str') + " " + problem[2] + ", "+ $i18next.t('profile_nav.settings.inventory.room_type_form.max_occupancy_label') + ": " + problem[3];
    }).join('\r\n');
  }


  _checkRoomOccupancy = function (booking) {
    var status = true;
    var problems = [];
    booking.rooms.forEach(function (room) {
      var roomStatus = Number(room.number_of_adults) <= room.room_type_select.maxAdults && Number(room.number_of_children) <= room.room_type_select.maxChildren && (Number(room.number_of_adults) + Number(room.number_of_children)) <= room.room_type_select.maxOccupancy;
      status = status && roomStatus
      if (roomStatus === false) {
        problems.push([
          room.room_name,
          room.room_type_select.maxAdults,
          room.room_type_select.maxChildren,
          room.room_type_select.maxOccupancy
        ]);
      }
    });

    return {
      status: status,
      problems: problems
    }
  };


  _createBooking = function (booking) {
    booking.id = String(new Date().getTime());
    booking = new BookingFactory(booking);
    BookingStorage.bookings.push(booking);
    booking._save();

    $rootScope.bookingForHighlight = booking.id;

    $scope.removeEventListeners();
    $mdDialog.hide(booking);
  };


  checkAvailable = function (index) {
    var room = $scope.booking.rooms[index],
      availability = AvailabilityChecker.checkAvailability(
        room.room_id,
        room.checkin_date,
        room.number_of_nights
      );

    if (availability.closed.indexOf($scope.booking.rooms[index].room_id) > -1) {
      $scope.booking.rooms[index].room_id     = null;
      if ($scope.room_types.filter($scope.notBlockedRoomTypesFilter).indexOf($scope.booking.rooms[index].room_type_select) == -1) {
        $scope.booking.rooms[index].room_type = null;
      }
    }
    closed_rooms = availability.closed;
    $scope.booking.rooms[index].maxDates  = availability.diff;
    $scope.booking.rooms[index].nights_select = [];

    for (x = 1; x <= availability.diff; x++) {
      $scope.booking.rooms[index].nights_select.push(x);
    }

    $scope.booking.rooms[index].available = availability.available;
    $scope.booking.rooms[index].max_checkout_date = moment($scope.booking.rooms[index].checkin_date).add(availability.diff, 'days').toDate();
  };

  angular.extend(
    $scope,
    {
      guests: {},
      addCreditCard : $scope.gateway === 'braintree',


      toggleCreditCard : function () {
        $scope.addCreditCard = !$scope.addCreditCard;
      },


      removeEventListeners: function() {
        if ($scope.gateway === 'wubook' || $scope.gateway == 'payment_express' || $scope.gateway == 'valitor' || $scope.gateway == 'borgun') {
          if (window.addEventListener) {
            window.removeEventListener('message', $scope.pcibooking_callback);
          } else if (window.attachEvent) {
            window.detachEvent('onmessage', $scope.pcibooking_callback);
          }
        }

        if ($scope.gateway === 'stripe_sca') {
          $scope.cardElements.destroy();
        }
      },


      ok: function () {
        $scope.removeEventListeners();
        $mdDialog.hide();
      },


      cancel: function () {
        $scope.removeEventListeners();
        $mdDialog.hide();
      },


      tokenizeStripe: function() {
        Stripe.card.createToken({
          name: $scope.card.cardholder_name,
          number: $scope.card.number,
          cvc: $scope.card.cvv,
          exp_month: $scope.card.expiration.split('/')[0],
          exp_year: $scope.card.expiration.split('/')[1]
        }, function(status, response) {
          $scope.booking.nonce = response.id;
          $scope.booking.cvv_present = true;
          saveBooking();
        });
      },

      tokenizeBraintree: function() {
        $timeout(function () {
          $('.submit-braintree').trigger('click');
        }, 0);
      },

      tokenizeWorldpay: function() {
        $('.booking-form').submit();
      },
      tokenizeOmise: function() {
        Omise.createToken('card',{
          name: $scope.card.cardholder_name,
          number: $scope.card.number,
          security_code: $scope.card.cvv,
          expiration_month: $scope.card.expiration.split('/')[0],
          expiration_year: $scope.card.expiration.split('/')[1]
        }, function(status, response) {
          $scope.booking.nonce = response.id;
          $scope.booking.cvv_present = true;
          saveBooking();
        });
      },
      tokenizeStripeSca: function() {
        if (typeof($rootScope.hotel.paymentGatewaySettings.passAddressInfo) == "undefined" || $rootScope.hotel.paymentGatewaySettings.passAddressInfo == true) {
          var data = {};
          data.address = {};
          data.address.city = ($scope.guest || $scope.customer).city;
          data.address.country = ($scope.guest || $scope.customer).countryShort;
          data.address.line1 = ($scope.guest || $scope.customer).address;
          data.address.state = ($scope.guest || $scope.customer).state;
          data.address.postal_code = ($scope.guest || $scope.customer).zipCode;
        }

        $scope.stripeScaGateway.createPaymentMethod('card', $scope.cardElements, {
          billing_details: data
        })
          .then(function (result) {
            if (result.error) {
              return Promise.reject(result.error);
            }

            $scope.booking.nonce = result.paymentMethod.id;
            $scope.booking.cvv_present = result.paymentMethod.card.checks.cvc_check;

            saveBooking();
          })
          .catch(function(error){
            // validation errors should already be displayed on stripe elements, so do not do anything special with it
            // other error type probably should be handled explicitly
            if (error.type !== "validation_error") {
              console.error(error);
            }

            $scope.loading = false;
          })
      },
      finish: function () {
        if ($scope.createBookingForm.$valid) {
          $scope.loading = true;

          if ($scope.addCreditCard === true && $scope.gateway == 'braintree') {
            $scope.tokenizeBraintree()
          } else {
            if ($scope.gateway == 'stripe' && $scope.card.number) {
              $scope.tokenizeStripe();
            } else if ($scope.gateway == 'worldpay') {
              $scope.tokenizeWorldpay();
            } else if ($scope.gateway == 'omise' && $scope.card.number) {
              $scope.tokenizeOmise();
            } else if ($scope.gateway == 'stripe_sca' && $scope.addCreditCard && $scope.card.number) {
              $scope.tokenizeStripeSca();
            } else {
              saveBooking();
            }
          }
        } else {
          $rootScope.alert($i18next.t('general.alert_modals.form_is_not_valid_js_str'));
        }
      },


      addRoom: function () {
        if (!$scope.createBookingForm.$invalid) {
          var index = $scope.booking.rooms.length;

          for (var el in $scope.booking.rooms) {
            if ($scope.booking.rooms.hasOwnProperty(el)) {
              $scope.booking.rooms[el].active = false;
            }
          }

          roomTemplate.guest.last_name = $scope.booking.rooms[0].guest.last_name
          room = angular.copy(roomTemplate);
          $scope.booking.rooms.push(room);
          room.restrictions = $scope.booking.rooms[0].restrictions;
          activeRoom = index;
          calcTotalPerRoom();
        }
      },


      setActiveRoom: function (index) {
        for (var el in $scope.booking.rooms) {
          if ($scope.booking.rooms.hasOwnProperty(el)) {
            $scope.booking.rooms[el].active = false;
          }
        }

        $scope.booking.rooms[index].active = true;
        activeRoom = index;
      },

      setRoomRate: function(room) {
        roomRate = $rootScope.hotel.roomRates.filter(function(el) {
          return el.isRemoved === false
            && el.roomRepresentationId === room.roomRepresentation.id
            && el.rateCategoryId === room.rate_category_id
            && el.maxAdults === Number(room.number_of_adults)
            && el.maxChildren === Number(room.number_of_children);
        });

        if ($rootScope.hotel.addons.useNearestOccupancy === true) {
          if (roomRate.length === 0) {
            var occ = Number(room.number_of_adults) + Number(room.number_of_children);

            roomRate = $rootScope.hotel.roomRates.filter(function(el) {
              return el.isRemoved === false
                && el.roomRepresentationId === room.roomRepresentation.id
                && el.rateCategoryId === room.rate_category_id
                && el.maxAdults + el.maxChildren >= occ;
            }).sort(function(a, b) {
              return Math.abs(a.maxAdults + a.maxChildren - occ) - Math.abs(b.maxAdults + b.maxChildren - occ);
            });
          }
        }

        if (roomRate.length === 0) {
          roomRate = $rootScope.hotel.roomRates.filter(function(el) {
            return el.isRemoved === false
              && el.roomRepresentationId === room.roomRepresentation.id
              && el.rateCategoryId === room.rate_category_id
              && el.maxAdults === Number(room.number_of_adults);
          });
        }

        if (roomRate.length > 0) {
          room.roomRate = roomRate[0];
        } else {
          room.roomRate = $rootScope.hotel.roomRates
            .filter(function(el) {
              return el.isRemoved === false
                && el.roomRepresentationId === room.roomRepresentation.id
                && el.rateCategoryId === room.rate_category_id;
            })
            .sort(function(a, b) {
              var av = [a.maxAdults, a.maxChildren];
              var bv = [b.maxAdults, b.maxChildren];
              if (av > bv) { return -1; }
              if (av < bv) { return 1; }
              return 0
            })[0];
        }

        if (room.roomRate) {
          room.cancellation_policy_id = room.roomRate.cancellationPolicyId;
        }
      },

      changeRoom: function (field) {
        var room = $scope.booking.rooms[activeRoom];
        var reFillNights = false;

        if (field == 'rate') {
          room.rate_category_id = room.rate.id;
          reFillNights = true;
        }

        if (field == 'number_of_nights') {
          out = moment(room.checkin_date).add(room.number_of_nights, 'days').toDate();
          if (out != room.checkout_date) {
            room.checkout_date = out;
          }
        }

        if (field == 'number_of_nights' || field == 'checkin_date') {
          var restrictions = $scope.booking.rooms[activeRoom].restrictions,
            checkin = moment(room.checkin_date).format('YYYY-MM-DD'),
            checkout = moment(room.checkout_date).format('YYYY-MM-DD');
          needLoad = new Array(moment(room.checkout_date).diff(moment(room.checkin_date), 'days'))
            .fill(null)
            .map(function(el, index) {
              return restrictions[room.roomRate.id][moment(room.checkin_date).add(index, 'days').format('YYYY-MM-DD')] === undefined;
            })
            .reduce(function(acc, el) {return acc || el}, false);

          if (!restrictions || needLoad) {
            getRestrictions(room);
          }
        }

        if (field == 'room_type') {
          room.room_type_select = $scope.room_types.filter(function(el) {if (el.id == parseInt(room.cover_room_type.room_type_id)) { return el;} })[0];
          room.room_type = room.cover_room_type.room_type_id;
          room.roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(roomRepresentation) {
            return roomRepresentation.roomTypeId == room.room_type
              && roomRepresentation.coverRoomTypeId == (typeof(room.cover_room_type.id) === 'number' ? null : Number(room.cover_room_type.id.replace('s', '')))
          })[0];
          room.roomRepresentationId = room.roomRepresentation.id;
          var baseRateId = $rootScope.hotel.rateCategories.filter(function(el) {
            return el.isBaseRate === true
          })[0].id;
          if (Number(room.number_of_adults) > room.roomRepresentation.maxAdults) {
            room.number_of_adults = room.roomRepresentation.maxAdults;
          }
          if (Number(room.number_of_children) > room.roomRepresentation.maxChildren) {
            room.number_of_children = room.roomRepresentation.maxChildren;
          }
          room.rate_category_id = baseRateId;
          $scope.booking.rooms[activeRoom].rate = $scope.rates.filter(function(el) {return el.id == room.roomRate.rateCategoryId})[0];
          $scope.booking.rooms[activeRoom].rate_category_id = room.rate.id;
          $scope.booking.rooms[activeRoom].room_type_id = room.room_type;
          $timeout(function() {
            if (room.restrictions) {
              filterAvailableRates(room);
            }
            $scope.changeRoom('rate');
          }, 0);
        }

        if (field == 'room_id') {
          var selectedRoom = $scope.rooms.filter(function (el) {return el.id == room.room_id})[0];
          if (selectedRoom.roomTypeId != room.room_type) {
            room.room_type = selectedRoom.roomTypeId;
            room.cover_room_type = this.cover_room_types.reduce(function(acc, el) {acc[el.id] = el; return acc;}, {})[room.room_type];
            this.changeRoom('room_type');
            return;
          }
        }

        if (room.room_id) {
          $scope.blocked_rooms[activeRoom] = room.room_id;
          room.roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(roomRepresentation) {
            return roomRepresentation.roomTypeId == $scope.booking.rooms[activeRoom].room_type_id
              && roomRepresentation.coverRoomTypeId == (typeof($scope.booking.rooms[activeRoom].cover_room_type.id) === 'number' ? null : Number($scope.booking.rooms[activeRoom].cover_room_type.id.replace('s', '')))
          })[0];
          room.roomRepresentationId = room.roomRepresentation.id;

          room.room_name = $filter('filter')($scope.rooms, function(el){return el.id == room.room_id;})[0].number;
          reFillNights = true;
        }

        if (reFillNights) {
          $scope.setRoomRate(room);
          if (room && room.roomRate) {
            fillNights(
              $scope.booking.rooms[activeRoom].number_of_nights,
              $scope.booking.rooms[activeRoom].checkin_date,
              room.roomRate.id
            ).then(function(result) {
              room.nights = result;
              calcTotalPerRoom();
            });
          }
        }

        if (room && room.roomRate) {
          $scope.recomendedMaxAdults = Math.max.apply(Math, $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved == false && el.roomRepresentationId == room.roomRepresentationId && el.rateCategoryId == room.roomRate.rateCategoryId}).map(function(el) {return el.maxAdults}));
          $scope.recomendedMaxChildren = Math.max.apply(Math, $rootScope.hotel.roomRates.filter(function(el) {return el.isRemoved == false && el.roomRepresentationId == room.roomRepresentationId && el.rateCategoryId == room.roomRate.rateCategoryId}).map(function(el) {return el.maxChildren}));
        }
        checkAvailable(activeRoom);
      },


      removeRoom: function (index) {
        $scope.booking.rooms.splice(index, 1);
        $scope.booking.rooms[$scope.booking.rooms.length - 1].active = true;
        activeRoom = $scope.booking.rooms.length - 1;
        calcTotalPerRoom();
      },


      notBlockedRoomFilter: function (room) {
        if (!room.isActive) return false;
        return $scope.booking.rooms
          .filter(function(room, index) {
            return index !== activeRoom;
          })
          .filter(function(room) {
            return !($scope.booking.rooms[activeRoom].checkin_date >= room.checkout_date || $scope.booking.rooms[activeRoom].checkout_date <= room.checkin_date);
          })
          .map(function(room) {
            return Number(room.room_id);
          })
          .indexOf(room.id) == -1 && closed_rooms.indexOf(room.id) == -1;
      },


      notBlockedCoverRoomTypesFilter: function (type) {
        var types = [],
          closed = _.without(closed_rooms.concat($scope.blocked_rooms), $scope.booking.rooms[activeRoom].room_id);

        _.each($scope.rooms, function(room) {
          if (closed.indexOf(room.id) == -1) {
            types.push(room.roomTypeId);
          }
        });

        types = _.uniq(types);

        return types.indexOf(type.room_type_id) > -1;
      },


      notBlockedRoomTypesFilter: function (type) {
        var types = [],
          closed = _.without(closed_rooms.concat($scope.blocked_rooms), $scope.booking.rooms[activeRoom].room_id);

        _.each($scope.rooms, function(room) {
          if (closed.indexOf(room.id) == -1) {
            types.push(room.roomTypeId);
          }
        });

        types = _.uniq(types);

        return types.indexOf(type.id) > -1;
      },


      hasNotValidRooms: function () {
        var out = true;

        _.each($scope.booking.rooms, function (room) {
          out = out && room.available && room.nights && room.nights.length > 0;
        });

        return !out;
      },


      getRoomType: function () {
        return $rootScope.hotel.roomTypes.filter(function(roomType) {return roomType.id == $scope.booking.rooms[activeRoom].room_type;})[0].shortName;
      },


      checkField: function (val, suffix) {
        return $scope.createBookingForm[val+suffix].$invalid;
      },


      dateInChanged: function () {
        var val = $scope.booking.rooms[activeRoom].checkin_date;
        $scope.booking.rooms[activeRoom].checkout_date = moment(val).add($scope.booking.rooms[activeRoom].number_of_nights, 'days').toDate();
        $scope.booking.rooms[activeRoom].min_checkout_date = moment(val).add(1, 'day').toDate();
        $scope.changeRoom('checkin_date');
      },


      dateOutChanged: function () {
        var val = $scope.booking.rooms[activeRoom].checkout_date;
        var diff = moment(val).diff(moment($scope.booking.rooms[activeRoom].checkin_date), 'days');
        if (diff > 0 && diff <= $scope.booking.rooms[activeRoom].maxDates) {
          if ($scope.booking.rooms[activeRoom].number_of_nights != diff) {
            $scope.booking.rooms[activeRoom].number_of_nights = diff;
            $scope.changeRoom('number_of_nights');
          }
        }
      },


      recalcNightsFromTotal: function () {
        var total   = $scope.booking.rooms[activeRoom].total_price,
          count   = $scope.booking.rooms[activeRoom].nights.length,
          per_day = Math.floor(total / count),
          correct = Math.round((total % count) * 100) / 100;

        _.each($scope.booking.rooms[activeRoom].nights, function(night) {
          night.price = per_day;
        });

        if ($scope.booking.rooms[activeRoom].nights[0]) {
          $scope.booking.rooms[activeRoom].nights[0].price = $scope.booking.rooms[activeRoom].nights[0].price+correct;
        }

        calcTotal();
      },


      resetNightPrices: function () {
        $scope.changeRoom();
      },


      getRates: function(index) {
        var roomTypeID = $scope.booking.rooms[activeRoom].cover_room_type.room_type_id;
        var coverRoomTypeID = $scope.booking.rooms[activeRoom].cover_room_type.id.indexOf && $scope.booking.rooms[activeRoom].cover_room_type.id.indexOf('s') !== -1 ? parseInt($scope.booking.rooms[activeRoom].cover_room_type.id.replace('s', '')) : null;
        var roomRepresentation = $rootScope.hotel.roomRepresentations.filter(function(el) {
          return el.roomTypeId === roomTypeID && el.coverRoomTypeId === coverRoomTypeID;
        })[0];
        var rateCategoryIds = _.uniq($rootScope.hotel.roomRates
          .filter(function(el) {
            return el.isRemoved === false && el.roomRepresentationId === roomRepresentation.id
          })
          .map(function(el) {
            return el.rateCategoryId;
          }));
        var applicableRateCategoryIds = _.uniq($scope.booking.rooms[activeRoom].applicableRoomRates
          .map(function(el) {
            return el.rateCategoryId;
          }));

        rates = $rootScope.hotel.rateCategories.filter(function(rate) {
          return rateCategoryIds.indexOf(rate.id) > -1;
        });

        rates.forEach(function(el) {
          el['applicable'] = Number(applicableRateCategoryIds.indexOf(el.id) > -1) * (-1);
        });

        return _.sortBy(rates, function(rate){ return rate.applicable; });
      },


      getRooms: function(rooms) {
        var room = $scope.booking.rooms[activeRoom];

        return rooms
          .filter(this.notBlockedRoomFilter).map(function(el) {
            el.applicable = Number(el.roomTypeId == Number(room.room_type));
            return el;
          })
          .sort(function(a, b) {
            return (a.applicable - b.applicable) * -1;
          });
      },


      setConfirmationToTrue: function ($index) {
        if ($index === 0 && $scope.confirmationManualChanged === false) {
          $scope.booking.confirmation = !_.isEmpty($scope.booking.rooms[0].guest.email);
        }
      },


      setConfirmationManualChanged: function () {
        $scope.confirmationManualChanged = true;
      },


      changeAdultsCount: function (room) {
        room.adultsChanged = true;
      },

      customerWasSettled: null,

      searchGuest: function(field) {
        var room = $scope.booking.rooms[activeRoom];
        var params = {};
        params[field] = room.guest[field];
        if (room.wasSettled === undefined || room.wasSettled === null || new Date().getTime() - room.wasSettled > 2500) {
          return $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/autocomplete', {
            params: params
          }).then(function(results) {
            return results.data.guests;
          });
        }
      },

      // FEATURES: sale-channels
      // method should be deleted after feature
      searchChannel: function (query) {
        var channels = _.compact(_.uniq(_.union(($rootScope.hotel.offlineChannels || []), ['Walk In', 'Telephone', 'Email'])));
        $scope.booking.channel = query;

        return channels
          .filter(function(channel) {
            return query && query.length > 0 && channel && channel.toLowerCase ? channel.toLowerCase().indexOf(query.toLowerCase()) != -1 : true;
          }).sort(function(a, b) {
            if (a > b) { return 1; }
            if (a < b) { return -1; }
            return 0;
          });
      },

      changeGuest: function(guest) {
        var room = $scope.booking.rooms[activeRoom];
        if (guest) {
          $scope.assignGuest(room, guest);
          if (guest.customer_id && $scope.booking.customer_id === null && !$scope.customerInfo.query) {
            $scope.booking.customer_id = guest.customer_id;
            $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/customers/'+guest.customer_id)
              .then(function(response) {
                if (response && response.data && response.data.customer) {
                  $scope.customer = response.data.customer;
                  $scope.selected_customer = response.data.customer;
                  $scope.customerInfo.query = response.data.customer.name;
                }
              });
          }
        }
      },

      assignGuest: function(room, guest) {
        $scope.guests[guest.id] = guest;
        room.guest.id = guest.id;
        room.guest.first_name = guest.first_name;
        room.guest.last_name = guest.last_name;
        room.guest.email = guest.email;
        room.guest.phone = guest.phone;
        room.guest.address = guest.address;
        room.guest.city = guest.city;
        room.guest.country = guest.country;
        room.guest.state = guest.state;
        room.guest.zipCode = guest.zip_code;
        room.guest.locale = guest.locale;
        room.guest.nationality = guest.nationality;
        room.guest.identifiction_type_id = guest.identifiction_type_id;
        room.guest.identification = guest.identification;
        room.guest_id = guest.id;
        room.wasSettled = new Date().getTime();
      },

      guestIsChanged: function(guest) {
        if (guest.id && $scope.guests[guest.id]) {
          var original = $scope.guests[guest.id];
          return !(
            guest.first_name === original.first_name
            && guest.last_name === original.last_name
            && guest.email === original.email
            && guest.phone === original.phone
            && guest.address === original.address
            && guest.city === original.city
            && guest.country === original.country
            && guest.state === original.state
            && guest.zipCode === original.zip_code
            && guest.locale === original.locale
            && guest.nationality === original.nationality
            && guest.identifiction_type_id === original.identifiction_type_id
            && guest.identification === original.identification
          )
        } else {
          return false;
        }
      },

      guestIsEmpty: function(room) {
        return !(Boolean(room.guest.first_name) || Boolean(room.guest.last_name));
      },

      clearGuestInfo: function(room) {
        room.guest = angular.copy(roomTemplate.guest);
      },

      chooseCustomer: function(customer) {
        if (customer) {
          customer.name = customer.visible_name;
          $scope.customer = customer;
          $scope.selected_customer = customer;
          $scope.booking.customer_id = customer.id;
          $scope.customerWasSettled = new Date().getTime();

          if (customer.guest_id && $scope.guestIsEmpty($scope.booking.rooms[0])) {
            $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/guests/'+customer.guest_id)
              .then(function(response) {
                $scope.assignGuest($scope.booking.rooms[0], response.data.guest);
              });
          }
        }
      },

      changeCustomerType: function(type) {
        $scope.customerType = type;
      },

      generateCustomer: function() {
        var output = {
          customer_type: $scope.customerType
        };

        if ($scope.customerType === 1) {
          output["company_name"] = $scope.customerInfo.query;
          // output["last_name"] = $scope.customerInfo.query;
        } else {
          var names = $scope.customerInfo.query.split(" ");

          if (names.length === 1) {
            output["last_name"] = names.join(" ");
          } else {
            output["first_name"] = names[0];
            output["last_name"] = names.slice(1, names.length).join(" ");
          }
        }

        return output;
      },

      recalcRoomPrice: calcTotalPerRoom,

      // Variables
      total       : 0,
      room_types  : $rootScope.hotel.roomTypes,
      room_types_by_id: $rootScope.hotel.roomTypes.reduce(function(acc, el) {acc[el.id] = el; return acc;}, {}),
      rooms       : $rootScope.hotel.rooms,
      rates       : $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved === false}),
      titles      : titles,
      times       : times,
      today       : $rootScope.currentDate,
      prevDay     : moment($rootScope.currentDate).toDate(),
      dateOptions : {
        formatYear  : 'yy',
        startingDay : 1
      },
      blocked_rooms : [],
      loading       : false,
      card          : {
        number          : null,
        expiration      : null,
        cvv             : null,
        cardholder_name : null,
        type            : null
      },
      adults_select : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
      child_select  : ['0',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
      bookingSaving   : false,
      offlineMode     : $rootScope.networkStatus,
      confirmationManualChanged : false,
      customer: {
        id: null,
        first_name: '',
        last_name: '',
        email: ''
      },
      selected_customer: {},
      customerInfo: {
        query: ''
      },
      customerType: 0,
      sale_channels: $rootScope.hotel.saleChannels,
      isSaleChannelsFeatureEnabled: $rootScope.hotel.saleChannelsFeatureEnabled
    }
  );

  $scope.booking = {
    source       : 'app',
    confirmation : false,
    nonce        : null,
    hotel_id     : $rootScope.hotel.id,
    customer_id  : null,
    rooms : []
  };

  setInitialRoom();

  checkAvailable(0);

  getRestrictions($scope.booking.rooms[0]);
}

angular
  .module('buuqit')
  .controller('CheckinDialogCtrl', CheckinDialogCtrl)
  .component(
    'selectScrollableCheckinExtras',
    TBFLibs.react2angular(
      TBFLibs.SelectScrollable,
      [ 'onScroll', 
        'onSearch', 
        'onSelect', 
        'options',
        'value',
        'placeholder',
        'caretDownFilledSuffix',
        'opened',
        'onDropdownVisibleChange'
      ],
      ['$i18next']
    )
  );

CheckinDialogCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "$q",
  "BookingStorage",
  "GuestFactory",
  "BookingExtraFactory",
  "room",
  "checkin",
  "ExtrasFactory",
  "$timeout",
  "$mdMenu",
  "StringTransformService",
  "$http"
];

function CheckinDialogCtrl ($rootScope, $scope, $i18next, $mdDialog, $q, BookingStorage, GuestFactory, BookingExtraFactory, room, checkin, ExtrasFactory, $timeout, $mdMenu, StringTransformService, $http) {
  var requiredFields = {
    __ : {
      firstName: true,
      lastName: true
    },
    Spain : {
      firstName: true,
      lastName: true,
      identificationTypeId: true,
      identification: true,
      addons_idIssueDate: true,
      addons_sex: true,
      addons_birthDate: true,
      addons_citizenship: true
    }
  }
  room.roomNumber = $rootScope.hotel.rooms.filter(function(el) {return el.id == room.roomId})[0].number;
  room.roomTypeName = $rootScope.hotel.roomTypes.filter(function(el) {return el.id == room.roomTypeId})[0].name;
  room.ratePlanTitle = $rootScope.hotel.rateCategories.filter(function(el) {return el.id == room.rateCategoryId})[0].name;
  room.cancellationPolicyTitle = $rootScope.hotel.cancellationPolicies.filter(function(el) {return el.id == room.cancellationPolicyId})[0].title;
  room = _normalizeGuests(room);
  room = _fillDates(room);

  BookingStorage.load_by_id(room.bookingId, false, function(booking) {
    booking.preparedToken = _prepareToken(booking.token);
    booking.preparedChannel = _prepareChannel(booking.channel);
    booking.preparedChannelReservationId = _prepareChannelReservationId(booking.channelReservationId);
    $scope.booking = booking;
    $scope.extras = [];
  });

  angular.extend($scope, {
    requiredFields: requiredFields[$rootScope.hotel.country] ? requiredFields[$rootScope.hotel.country] : requiredFields.__,
    countries: countries_in,
    locales: window.locales,
    idTypes: $rootScope.hotel.identificationTypes,
    room: room,
    step: 1,
    forms: {},
    extrasListLoading: false,
    extrasOptions: [],
    extrasList: [],
    extrasReqParams: { term: '', pagination: { page: 1, limit: 10 } },
    extrasTotal: null,
    selectedExtraVal: "",
    favSelectOpened: false,
    favExtrasListLoading: false,
    favExtrasOptions: [],
    favExtrasList: [],
    favExtrasReqParams: { term: '', pagination: { page: 1, limit: 10 }, favorite: true },
    favExtrasTotal: null,

    nextStep: nextStep,
    prevStep: prevStep,
    closeModal: closeModal,
    openMenu: openMenu,
    addExtra: addExtra,
    addOtherExtra: addOtherExtra,
    hideAddExtrasForm: hideAddExtrasForm,
    saveAddExtrasForm: saveAddExtrasForm,
    recalcTotal: recalcTotal,
    recalcTotalFromDates: recalcTotalFromDates,
    dropExtra: dropExtra,
    finish: finish,
    onLoadExtras: onLoadExtras,
    onSearchExtras: onSearchExtras,
    onSelectExtra: onSelectExtra,
    onLoadFavExtras: onLoadFavExtras,
    onSearchFavExtras: onSearchFavExtras,
    onSelectFavExtra: onSelectFavExtra,
    onExtraFormDropdownVisibleChange: onExtraFormDropdownVisibleChange
  });

  // Public methods
  function nextStep() {
    if ($scope.step === 1) {
      onLoadAllBookingExtras({page: 1, limit: 50 }, $scope.booking);
    }
    $scope.step++;
  }

  function prevStep() {
    $scope.step--;
  }

  function closeModal() {
    $mdDialog.hide();
  }

  function openMenu($mdOpenMenu, ev) {
    if($scope.favExtrasList.length == 0) onLoadFavExtras();
    $mdOpenMenu(ev);

    $timeout(function () {
      $scope.favSelectOpened = true;
    }, 100);
  };

  $scope.$on("$mdMenuClose", function() { 
    $scope.favSelectOpened = false;
  });

  function addExtra(extra) {
    $scope.newExtra = _fillExtraDefaults({extra: extra});
    $scope.addExtraFormIsVisible = true;
  }

  function addOtherExtra() {
    $scope.newExtra = _fillExtraDefaults({});
    $scope.addExtraFormIsVisible = true;
  }

  function hideAddExtrasForm() {
    $scope.newExtra = {};
    $scope.addExtraFormIsVisible = false;
  }

  function saveAddExtrasForm() {
    $scope.addExtraFormIsVisible = false;
    var selectedKeys = _.keys($scope.newExtra.dates)
      .filter(function(date) {
        return $scope.newExtra.dates[date];
      });
    
    selectedKeys
      .map(function(date) {
        var count = $scope.newExtra.count / selectedKeys.length;
        $scope.extras.push({
          bookingId: $scope.booking.id,
          bookingRoomId: $scope.room.id,
          count: count,
          extraId: $scope.newExtra.extraId,
          hotelId: $rootScope.hotel.id,
          price: $scope.newExtra.price,
          sellDate: date,
          title: $scope.newExtra.extra.title,
          total: $scope.newExtra.price * count
        });
      });
  }

  function recalcTotal(newExtra) {
    newExtra.total = newExtra.count * newExtra.price;
  }

  function recalcTotalFromDates(newExtra) {
    newExtra.count = _generateCount(newExtra.dates, newExtra.persons, newExtra.sellMode);
    recalcTotal(newExtra);
  }

  function dropExtra(extra) {
    $scope.extras = _.without($scope.extras, extra);
  }

  function finish(openPaymentScreen) {
    $scope.saveInProgress = true;
    $q.all([
      $q.all(
        $scope.room.guests
          .filter(function(guest) {
            return guest.skipGuest !== true;
          })
          .map(function(guest) {
            guest.addonsJson = JSON.stringify(guest.addons);
            return guest;
          })
          .map(function(guest) {
            return new GuestFactory(guest)
              .save();
          })
      ),
      $q.all(
        $scope.extras
          .filter(function(extra) {
            return !extra.id;
          })
          .map(function(extra) {
            return new BookingExtraFactory({
              extraId    : extra.extraId,
              booking_id : extra.bookingId,
              booking_room_id : extra.bookingRoomId,
              hotel_id   : extra.hotelId,
              price      : extra.price,
              vat        : 20,
              count      : extra.count,
              total      : extra.total,
              title      : extra.title,
              sell_date  : moment(extra.sellDate).format('YYYY-MM-DD')
            }).save();
          })
      )
    ]).then(function() {
      BookingStorage.load_by_id(room.bookingId, false, function(booking) {
        $scope.saveInProgress = false;
        checkin(openPaymentScreen);
        closeModal();
      });
    });
  }

  // Private methods
  function _prepareToken(token) {
    if (token && token.split) {
      return token.split('-').map(function(block) {
        if (block.indexOf('/') > -1) {
          return block.split('/')[0];
        } else {
          return block;
        }
      }).join('-');
    } else {
      return token;
    }
  }

  function _prepareChannel(channel) {
    if (channel == 'BOOKINGS EUROPE B.V.') {
      return 'Booking.com';
    } else {
      return channel;
    }
  }

  function _prepareChannelReservationId(token) {
    if (token && token.indexOf && token.indexOf('/') > -1) {
      return token.split('/')[0];
    } else {
      return token;
    }
  }

  function _generateRepresentationName(guest) {
    if (guest.firstName || guest.lastName) {
      guest.representationName = [guest.title, guest.firstName, guest.lastName].join(' ').trim();
    } else {
      guest.representationName = "Unnamed Guest";
    }

    ['birthDate', 'idIssueDate'].forEach(function(k){
      if (guest.addons !== undefined && guest.addons[k] !== undefined && guest.addons[k] !== null) {
        guest.addons[k] = moment(guest.addons[k]).toDate();
      }
    });

    return guest;
  }

  function _normalizeGuests(room) {
    var guests_length = room.guests.length;
    if (guests_length < room.numberOfAdults + room.numberOfChildren) {
      for (x = 0; x < room.numberOfAdults + room.numberOfChildren - guests_length; x++) {
        room.guests.push({
          hotelId: $rootScope.hotel.id,
          roomId: room.roomId,
          bookingRoomId: room.id
        });
      }
    }

    room.guests = room.guests.map(_generateRepresentationName);

    return room;
  }

  function _fillDates(room) {
    room.dates = new Array(room.numberOfNights + 1).fill().map(function(item, index) {
      return moment(room.checkinDate).add(index, 'days').toDate()
    });

    return room;
  }

  function _fillExtraDefaults(newExtra) {
    var out = newExtra;
    out.persons = room.numberOfAdults + room.numberOfChildren;
    out.sellMode = newExtra.extra && newExtra.extra.sellMode ? newExtra.extra.sellMode : null;
    if (newExtra.extra) {
      out.extraId = newExtra.extra.id;
      out.price = newExtra.extra.price;
    }
    out.dates = _generateDateCheckboxes($scope.room.dates, out.sellMode);
    out.count = _generateCount(out.dates, out.persons, out.sellMode);
    if (out.price) { out.total = out.count * out.price; }

    return out;
  }

  function _generateDateCheckboxes(dates, sellMode) {
    switch (sellMode) {
      case 'per_night':
        return dates.reduce(function(acc, date, index) {
          acc[date] = index !== dates.length - 1;
          return acc;
        }, {});
        break;
      case 'per_person_per_night':
        return dates.reduce(function(acc, date, index) {
          acc[date] = index !== dates.length - 1;
          return acc;
        }, {});
        break;
      default:
        return dates.reduce(function(acc, date, index) {
          acc[date] = index === 0;
          return acc;
        }, {});
        break;
    }
  }

  function _generateCount(dates, personsCount, sellMode) {
    var nightsCount = _.values(dates).filter(function(el) {return el === true}).length;

    switch (sellMode) {
      case 'per_person':
        return personsCount * nightsCount;
        break;
      case 'per_person_per_night':
        return nightsCount * personsCount;
        break;
      default:
        return nightsCount;
        break;
    }
  }

  // form extras list management
  function onExtraFormDropdownVisibleChange (open) {
    if(open && $scope.extrasList.length == 0 && $rootScope.hotel && $rootScope.hotel.id) {
      onLoadExtras();
    };
  };

  function onLoadExtras() {
    if($rootScope.hotel && $rootScope.hotel.id && $scope.extrasTotal ? ($scope.extrasList.length < $scope.extrasTotal) : true) {
      _fetchExtras();
    };
  };

  function onSearchExtras(term) {
    $scope.extrasReqParams.term = term;
    $scope.extrasReqParams.pagination.page = 1;

    return _fetchExtras();
  };

  function onSelectExtra(value) {
    $scope.selectedExtraVal = value;
    addExtra($scope.extrasList.find(function(el) { return el.id == value }));

    $scope.extrasReqParams.term = '';
    $scope.extrasReqParams.pagination.page = 1;

    _fetchExtras();
  };

  function _fetchExtras() {
    if(!$scope.extrasListLoading) {
      $scope.extrasListLoading = true;

      var par = $scope.extrasReqParams;
      var extrasFactory = new ExtrasFactory();

      return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
        if (data.data) {
          var currentPage = $scope.extrasReqParams.pagination.page;

          if(data.data.meta) {
            $scope.extrasReqParams.pagination.page = data.data.meta.page + 1;
            $scope.extrasTotal = data.data.meta.total;
          };
  
          if(data.data.extras) {
            var newExtras = StringTransformService.snakeToCamel(data.data.extras);
            var newExtrasOptions = newExtras.map(function(extra) {return {value: Number(extra.id), label: extra.title}});

            if(currentPage > 1) {
              $scope.extrasList = $scope.extrasList.concat(newExtras);
              $scope.extrasOptions = $scope.extrasOptions.concat(newExtrasOptions);
            } else {
              $scope.extrasList = newExtras;
              $scope.extrasOptions = newExtrasOptions;
            };
          };
        };
      }).finally (function() {
        $scope.extrasListLoading = false;
      });
    };
  };

  // favorite extras list management
  function onLoadFavExtras() {
    if($rootScope.hotel && $rootScope.hotel.id && $scope.favExtrasTotal ? ($scope.favExtrasList.length < $scope.favExtrasTotal) : true) {
      _fetchFavExtras();
    };
  };

  function onSearchFavExtras(term) {
    $scope.favExtrasReqParams.term = term;
    $scope.favExtrasReqParams.pagination.page = 1;

    _fetchFavExtras();
  };

  function onSelectFavExtra(value, option) {
    var favExtra = $scope.favExtrasList.find(function(el) { return el.id == value });

    addExtra(favExtra);
    
    $scope.selectedExtraVal = { key: value, value: value, label: option.children };

    $scope.favSelectOpened = false;
    $mdMenu.hide(null, { closeAll: true });

    if($scope.favExtrasReqParams.term) {
      $scope.favExtrasReqParams.term = '';
      $scope.favExtrasReqParams.pagination.page = 1;

      _fetchFavExtras();
    };
  };

  var otherExtraOption = { value: '', label: $i18next.t('checkin_dialog.controls.other') };

  function _fetchFavExtras() {
    if(!$scope.favExtrasListLoading) {
      $scope.favExtrasListLoading = true;

      var par = $scope.favExtrasReqParams;
      var extrasFactory = new ExtrasFactory();

      return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
        if (data.data) {
          var currentPage = $scope.favExtrasReqParams.pagination.page;

          if(data.data.meta) {
            $scope.favExtrasReqParams.pagination.page = data.data.meta.page + 1;
            $scope.favExtrasTotal = data.data.meta.total;
          };
  
          if(data.data.extras) {
            var newExtras = StringTransformService.snakeToCamel(data.data.extras);
            var newExtrasOptions = newExtras.map(function(extra) {return {value: Number(extra.id), label: extra.title}});

            if(currentPage > 1) {
              $scope.favExtrasList = $scope.favExtrasList.concat(newExtras);
              $scope.favExtrasOptions = $scope.favExtrasOptions.concat(newExtrasOptions);
            } else {
              $scope.favExtrasList = newExtras;
              
              var favExtras = [];
              favExtras = favExtras.concat([otherExtraOption]);
              favExtras = favExtras.concat(newExtrasOptions);
              
              $scope.favExtrasOptions = favExtras;
            };
          };
        };
      }).finally (function() {
        $scope.favExtrasListLoading = false;
      });
    };
  };

  function onLoadBookingExtras (params, booking) {
    try {
      var url = SERVER_PATH + "/api/v1/hotels/" + $rootScope.hotel.id +"/bookings/" + booking.id + "/extras";
      var searchParams = new URLSearchParams();

      Object.keys(params).map(function(param) {
        if (['limit', 'page'].includes(param)) {
          searchParams.set("pagination[" + param + "]", params[param]);
        } else {
          var paramName = param.replace(/[A-Z]/g, '_' + '$&').toLowerCase();
          searchParams.set(paramName, params[param]);
        }
      });

      var queryString = searchParams.toString();
      var queryUrl = url + "?" + queryString;

      return $http.get(queryUrl);
    } catch(e) {
      console.error(e, 'error')
    }
  }

  function onLoadAllBookingExtras(params, booking) {
    var bookingExtras = [];
    return onLoadBookingExtras(params, booking).then(function (response) {
      bookingExtras = bookingExtras.concat(response.data.data);
      if (response.data && response.data.meta && response.data.meta.page * response.data.meta.limit < response.data.meta.total) {
        var updatedParams = params;
        updatedParams.page = updatedParams.page + 1;

        return onLoadAllBookingExtras(updatedParams, booking);
      } else {
        $scope.extras = bookingExtras.filter(function (extra) {
          return extra.bookingRoomId == room.id;
        });
      }
    });
  }
}

angular
  .module('buuqit')
  .controller('BookingManagementModalCtrl', BookingManagementModalCtrl);

BookingManagementModalCtrl.$inject = [
  "$rootScope",
  "$filter",
  "$scope",
  "$mdDialog",
  "$i18next",
  "booking",
  "activeTab",
  "params",
  "UIDialogService",
  "BookingStorage",
  "DeviceDetector"
];

function BookingManagementModalCtrl ($rootScope, $filter, $scope, $mdDialog, $i18next, booking, activeTab, params, UIDialogService, BookingStorage, DeviceDetector) {
  var TABS = ['rooms', 'extras_and_discounts', 'taxes_and_fees', 'customer', 'invoice', 'payment', 'email', 'history', 'folios', 'guests', 'attachments'];
  angular.extend(
    $scope,
    {
      active_tab : _.isUndefined(activeTab) || activeTab === null ? 0 : TABS.indexOf(activeTab),
      params     : params,
      template   : getTemplatePath('booking_management/' + (_.isUndefined(activeTab) || activeTab === null ? TABS[0] : activeTab) + '.html'),
      loading    : false,
      booking    : booking,
      hotel      : $rootScope.hotel,
      countries  : countries_in,
      gateway    : $rootScope.hotel.paymentGateway,
      is_mobile  : DeviceDetector === 'mobile',
      cancel_all_visible: (function() {
        if (booking && booking.rooms) {
          return booking.rooms.filter(function(room) {return room.status != 'canceled';}).length > 0;
        } else {
          return [];
        }
      })(),

      convertCurrency: function (amount) {
        return customCurrencyExtended(amount, booking, $scope.booking.isForeignAmount(), $filter, $rootScope);
      },

      openTab: function ($event, tab_index) {
        $event.preventDefault();
        $scope.active_tab = tab_index;
        $scope.template = getTemplatePath('booking_management/' + TABS[tab_index] + '.html');
      },

      closeModal: function () {
        var date;
        if ($scope.booking.rooms.length > 0) {
          date = angular.copy($scope.booking.rooms[0].checkinDate)
        } else {
          date = new Date();
        }
        $mdDialog.hide(date);
      },
      openNotesModal: function(roomId, bookingId) {
        noteModal(roomId, bookingId, BookingStorage, UIDialogService)
      },
      editSaleChannel: function() {
        var saleChannel = angular.copy($scope.booking.saleChannel);

        UIDialogService.open('choose-sale-channel', {
          title: $i18next.t('bookings.change_channel_name_title'),
          placeholder: $i18next.t('bookings.change_channel_name_placeholder'),
          collection: $rootScope.hotel.saleChannels,
          value: saleChannel ? saleChannel.name : null,
          callback: function (saleChannelName) {
            UIDialogService.close('choose-sale-channel');

            $scope.booking.hotelId = $rootScope.hotel.id;
            $scope.booking.channel = saleChannelName;

            $scope.booking.save();
          }
        }, true);
      },

      // FEATURES: sale-channels
      // method should be removed after feature
      editChannel: function() {
        UIDialogService.open('channel-name', {
          title: $i18next.t('bookings.change_channel_name_title'),
          placeholder: $i18next.t('bookings.change_channel_name_placeholder'),
          value: angular.copy($scope.booking.channel),
          callback: function (value) {
            UIDialogService.close('channel-name');
            $scope.booking.hotelId = $rootScope.hotel.id;
            $scope.booking.channel = value;
            $scope.booking.save();
          }
        });
      },

      editReference: function() {
        UIDialogService.open('channel-name', {
          title: $i18next.t('bookings.change_reference_title'),
          placeholder: $i18next.t('bookings.change_reference_placeholder'),
          value: angular.copy($scope.booking.channelReservationId),
          callback: function (value) {
            UIDialogService.close('channel-name');
            $scope.booking.hotelId = $rootScope.hotel.id;
            $scope.booking.channelReservationId = value;
            $scope.booking.save();
          }
        });
      },

      isSaleChannelsFeatureEnabled: $rootScope.hotel.saleChannelsFeatureEnabled,
      notifyMobileUsers:  function() {
        if ($scope.is_mobile) {
          $rootScope.notify($i18next.t('bookings.use_landscape'), true);
        }
      },
    }
  );

  $scope.roomSize = booking.rooms.filter(function(e) { return e.status != 'canceled'}).length;
  $scope.notifyMobileUsers();

  _prepareToken = function(token) {
    if (token && token.split) {
      return token.split('-').map(function(block) {
        if (block.indexOf('/') > -1) {
          return block.split('/')[0];
        } else {
          return block;
        }
      }).join('-');
    } else {
      return token;
    }
  }

  _prepareChannel = function(channel) {
    if (channel == 'BOOKINGS EUROPE B.V.') {
      return 'Booking.com';
    } else {
      return channel;
    }
  }

  _prepareChannelReservationId = function(token) {
    if (token && token.indexOf && token.indexOf('/') > -1) {
      return token.split('/')[0];
    } else {
      return token;
    }
  }

  if (booking && booking.rooms) {
    _.each(booking.rooms, function(el) {
      el.checkinDate = new Date(el.checkinDate);
      el.checkoutDate = new Date(el.checkoutDate);
    });

    booking.preparedToken = _prepareToken(booking.token);
    booking.preparedChannel = _prepareChannel(booking.channel);
    booking.preparedChannelReservationId = _prepareChannelReservationId(booking.channelReservationId);
  }


  var escapeListener =  $rootScope.$on('escape:pressed', function () {
    $scope.closeModal();
  });

  var bookingManagementListener = $rootScope.$on('booking_management:reload', function(event, booking) {
    if ($scope.booking.id === booking.id) {
      $scope.booking = booking;
      $scope.roomSize = $scope.booking.rooms.filter(function(e) { return e.status != 'canceled'}).length;
      booking.preparedToken = _prepareToken(booking.token);
      booking.preparedChannel = _prepareChannel(booking.channel);
      booking.preparedChannelReservationId = _prepareChannelReservationId(booking.channelReservationId);
    }
  });

  $scope.$on('$destroy', function() {
    if (escapeListener) {
      escapeListener();
    }
    if (bookingManagementListener) {
      bookingManagementListener();
    }
  });
}

angular
  .module('buuqit')
  .controller('AddToWaitlistModalCtrl', AddToWaitlistModalCtrl);

AddToWaitlistModalCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$mdDialog",
  "WaitlistFactory",
  "WaitlistStorage",
  "waitlist"
];

function AddToWaitlistModalCtrl ($rootScope, $scope, $i18next, $mdDialog, WaitlistFactory, WaitlistStorage, waitlist) {
  if (waitlist) {
    $scope.originalWaitlist = JSON.parse(JSON.stringify(waitlist));

    var originalCheckinDate = waitlist.checkinDate;
    var originalCheckoutDate = waitlist.checkoutDate;

    // Create separate variables for temporary Date objects
    $scope.tempCheckinDate = new Date(originalCheckinDate);
    $scope.tempCheckoutDate = new Date(originalCheckoutDate);
  }

  angular.extend(
    $scope,
    {
      waitlist: waitlist,
      room_options: new Array($rootScope.hotel.rooms.length).fill(0).map(function(v,i){return i+1}),
      cancel : function () {
        $mdDialog.hide();
      },
      remove : function () {
        $scope.waitlist.hotelId = $rootScope.hotel.id;
        WaitlistStorage.removeList($scope.waitlist);
        $mdDialog.hide();
      },
      save : function () {
        if ($scope.addToWaitlist.$valid) {
          if(!$scope.waitlist.id) {
            var new_list = new WaitlistFactory();
            WaitlistStorage.waitlists.push(new_list)
            new_list.checkinDate = $scope.tempCheckinDate;
            new_list.checkoutDate = $scope.tempCheckoutDate;
            new_list.subject = $scope.waitlist.subject;
            new_list.notes = $scope.waitlist.notes;
            new_list.numberOfRooms = $scope.waitlist.numberOfRooms;
            new_list.amount = $scope.waitlist.amount;
            $scope.waitlist = new_list;
          } else {
            // trick to update the waitlist in the waitlistStorage
            // these hacks are needed because waitlists are stored in YYYY-MM-DD format
            // and the component uses Date objects
            // so we need to convert them back and forth in order for calendar to work properly
            var updated_list = Object.assign($scope.originalWaitlist, $scope.waitlist, {
              checkinDate: convertDateToYYYYMMDD($scope.tempCheckinDate),
              checkoutDate: convertDateToYYYYMMDD($scope.tempCheckoutDate)
            });
            WaitlistStorage.parseUpdatedData(updated_list);
            // trick to update the waitlist in the modal
            var component_updated_list = Object.assign(new WaitlistFactory(), updated_list, {
              checkinDate: $scope.tempCheckinDate,
              checkoutDate: $scope.tempCheckoutDate
            });
            $scope.waitlist = component_updated_list;
          }
          $scope.waitlist.hotelId = $rootScope.hotel.id;
          $scope.waitlist.save(WaitlistStorage.parseUpdatedData);
          $mdDialog.hide();
          return true;
        }
        return false;
      }
    }
  );
  function convertDateToYYYYMMDD(date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }
}

angular
  .module('buuqit')
  .controller('Reports.StatisticalReportIsCtrl', StatisticalReportIsCtrl);

StatisticalReportIsCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.StatisticalReportIsFactory", "Reports.Token"];

function StatisticalReportIsCtrl ($rootScope, $scope, $i18next, StatisticalReportIsFactory, TokenFactory) {
  $scope.dates = Array(23).fill(0).map(function(v, index) {
    return moment().date(15).subtract(index - 1, 'month');
  })

  $scope.dateFrom = $scope.dates[1];
  $scope.loading = false;
  $scope.report = {};
  $scope.errors = [];


  function process(type, success_msg) {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.source.get(
      $scope.dateFrom.format('YYYY-MM-DD'),
      type
    ).then(function (response) {
      $scope.loading = false;
      $scope.report = response[0];
      $scope.errors = response[1];

      if ($scope.errors.length > 0) {
        $rootScope.notify($i18next.t('reports.statistical_report_is.validate_unsuccessful'));
      } else {
        if (success_msg !== undefined) {
          $rootScope.notify($i18next.t('reports.statistical_report_is.' + success_msg));
        }
      }
    }, function(error) {
      console.error('Error fetching statistical report:', error);
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  }

  $scope.getReport = function () {
    process('get_data', 'loaded');
  };

  $scope.validate = function () {
    process('validate', 'validate_successful');
  };

  $scope.send = function () {
    process('send', 'send_successful');
  };

  $scope.openGuest = function(booking_id, guest_id) {
    $rootScope.openBookingManagementModal(booking_id, 'guests', {guest_id: guest_id});
  }

  $scope.export = function () {
    if ($scope.loading) {
      return;
    }
    getDownloadToken(function (token) {
      var path = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/reports/statistical_report_is/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'statistical_report_is'
    });
    var params = {
      month: $scope.dateFrom.format('YYYY-MM-DD'),
      type: 'export'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.setBookingOrderProperty = function (property) {
    if ($scope.orderBookingProperty == property) {
      $scope.orderBookingDirection = !$scope.orderBookingDirection;
    } else {
      $scope.orderBookingProperty = property;
      $scope.orderBookingDirection = false;
    }
  }

  $scope.setOrderPropertyRate = function (property) {
    if ($scope.orderPropertyRate == property) {
      $scope.orderDirectionRate = !$scope.orderDirectionRate;
    } else {
      $scope.orderPropertyRate = property;
      $scope.orderDirectionRate = false;
    }
  };

  var init = function () {
    $scope.source = new StatisticalReportIsFactory({hotel_id: $rootScope.hotel.id});
    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.ReservationReportCtrl', ReservationReportCtrl);

ReservationReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.ReservationReport", "Reports.Token"];

function ReservationReportCtrl ($rootScope, $scope, $i18next, ReservationReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'month').toDate();
  $scope.types = [
    "rooms",
    "guests"
  ];
  $scope.type = $scope.types[0];
  $scope.report_data = [];
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo <= $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).add(1, 'day').toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD '),
      $scope.type
    ).then(function (response) {
      $scope.loading = false;
      angular.copy(response.report, $scope.report_data);
    }, function(error){
      console.error('Error fetching reservation report:', error);
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'reservation_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      type: $scope.type,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  var init = function () {
    $scope.source = new ReservationReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('ReportsCtrl', ReportsCtrl);

ReportsCtrl.$inject = ["$rootScope", "$scope", "$routeParams", "$location", "$timeout"];

function ReportsCtrl ($rootScope, $scope, $routeParams, $location, $timeout) {
  var pages = ['daily-checkout-report', 'credit-report', 'booking-report', 'cancellation-report', 'housekeeping-report', 'extras-report', 'occupancy-report', 'debtors-report', 'folio-report', 'booking-waitlist-report'];

  $rootScope.loading = false;

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
      $scope.template = getTemplatePath('reports/' + $routeParams.report + '.html');
    }
  });

  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    $scope.template = getTemplatePath('reports/' + $routeParams.report + '.html');
  }
  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.RatePlanReportCtrl', RatePlanReportCtrl);

RatePlanReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.RatePlanReport", "Reports.Token"];

function RatePlanReportCtrl ($rootScope, $scope, $i18next, RatePlanReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = new Date();
  $scope.types = [
    "Arrival",
    "Departure",
    "Booking Date"
  ];
  $scope.type = $scope.types[0];
  $scope.orderBookingProperty = 'customer';
  $scope.orderBookingDirection = false;
  $scope.orderPropertyRate = 'numberOfReservations';
  $scope.orderDirectionRate = false;
  $scope.bookings = []
  $scope.showBookings = false
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD'),
      moment($scope.dateTo).format('YYYY-MM-DD'),
      $scope.type
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response;
    }, function(error){
      console.error('Error fetching rate plan report:', error);
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export_to_excel = function (format) {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    }, format);
  }

  function getDownloadToken(callback, format) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'rate_plan_report'
    });
    var params = {
      type: $scope.type,
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD'),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD')
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setBookingOrderProperty = function (property) {
    if ($scope.orderBookingProperty == property) {
      $scope.orderBookingDirection = !$scope.orderBookingDirection;
    } else {
      $scope.orderBookingProperty = property;
      $scope.orderBookingDirection = false;
    }
  }

  $scope.setOrderPropertyRate = function (property) {
    if ($scope.orderPropertyRate == property) {
      $scope.orderDirectionRate = !$scope.orderDirectionRate;
    } else {
      $scope.orderPropertyRate = property;
      $scope.orderDirectionRate = false;
    }
  };

  $scope.openBooking = function (id) {
    $rootScope.openBookingManagementModal(id);
  };

  $scope.showRatePlanBookings = function(rate) {
    rate.showBookings = !rate.showBookings;
  };

  var init = function () {
    $scope.source = new RatePlanReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}
angular
  .module('buuqit')
  .controller('Reports.PoliceReportCtrl', PoliceReportCtrl);

PoliceReportCtrl.$inject = ["$rootScope", "$scope", "Reports.PoliceReport", "Reports.Token"];

function PoliceReportCtrl ($rootScope, $scope, PoliceReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'day').toDate();
  $scope.old_data = JSON.stringify({
    dateFrom: $scope.dateFrom,
    dateTo: $scope.dateTo
  });
  $scope.orderProperty = 'number';
  $scope.orderDirection = false;
  $scope.requested = false;

  $scope.isSpainHotel = $rootScope.hotel.country === 'ES';

  $scope.defFields = {
    'Thailand': [
      ['First Name', 'first_name', '<a ng-click="openGuest(guest.id, guest.bookingId)">{{guest.firstName}}</a>'],
      ['Last Name', 'last_name', '<a ng-click="openGuest(guest.id, guest.bookingId)">{{guest.lastName}}</a>'],
      ['Sex', 'sex', '{{guest.sex}}'],
      ['Country', 'country', '{{guest.country}}'],
      ['Nationality', 'nationality', '{{guest.nationality}}'],
      ['ID Number', 'identification', '{{guest.identification}}'],
      ['ID Type', 'identificationType', '{{guest.identificationType}}'],
      ['Arrival Date', 'arrivalDate', '{{guest.arrivalDate | dateToMoment: "MMM D, YYYY"}}'],
      ['Departure Date', 'departureDate', '{{guest.departureDate | dateToMoment: "MMM D, YYYY"}}']
    ],
    'Spain': [
      ['Name', 'last_name', '<a ng-click="openGuest(guest.id, guest.bookingId)">{{guest.firstName}} {{guest.lastName}}</a>'],
      ['Local ID Number', 'localNumber', '{{guest.localNumber}}'],
      ['Foreign ID Number', 'foreignNumber', '{{guest.foreignNumber}}'],
      ['ID Type (for report)', 'idType', '{{guest.idType}}'],
      ['ID Type (verbose)', 'idTypeVerbose', '{{guest.idTypeVerbose}}'],
      ['ID Issue Date', 'idIssueDate', '{{guest.idIssueDate}}'],
      ['Last Name', 'lastName', '{{guest.lastName}}'],
      ['Middle Name', 'middleName', '{{guest.middleName}}'],
      ['First Name', 'firstName', '{{guest.firstName}}'],
      ['Sex', 'sex', '{{guest.sex}}'],
      ['Birth Date', 'birthDate', '{{guest.birthDate}}'],
      ['Citizenship', 'citizenship', '{{guest.citizenship}}'],
      ['Arrival Date', 'arrivalDate', '{{guest.arrivalDate}}'],
      ['Departure Date', 'departureDate', '{{guest.departureDate}}']
    ],
    'default': [
      ['Name', 'last_name', '<a ng-click="openGuest(guest.id, guest.bookingId)">{{guest.firstName}} {{guest.lastName}}</a>'],
      ['Country', 'country', '{{guest.country}}'],
      ['Nationality', 'nationality', '{{guest.nationality}}'],
      ['ID Number', 'identification', '{{guest.identification}}'],
      ['ID Type', 'identificationType', '{{guest.identificationType}}'],
      ['Arrival Date', 'arrivalDate', '{{guest.arrivalDate | dateToMoment: "MMM D, YYYY"}}'],
      ['Departure Date', 'departureDate', '{{guest.departureDate | dateToMoment: "MMM D, YYYY"}}']
    ]
  }

  $scope.onChange = function () {
    var new_data = {
      dateFrom: $scope.dateFrom,
      dateTo: $scope.dateTo
    }
    if ($scope.old_data != JSON.stringify(new_data)) {
      $scope.old_data = JSON.stringify({
        dateFrom: $scope.dateFrom,
        dateTo: $scope.dateTo
      });
      $scope.getPoliceReport();
    }
  }

  $scope.getPoliceReport = function () {
    $scope.requested = true;
    $scope.source
      .get(
        moment($scope.dateFrom).format('YYYY-MM-DD'),
        moment($scope.dateTo).format('YYYY-MM-DD'),
        $scope.type
      )
      .then(function (response) {
        $scope.requested = false;
        $scope.report = response.report;
        if (response.report.additionalFields) {
          $scope.fields = getMainFields();
          response.report.additionalFields.forEach(function(el) {
            $scope.fields.push([el.name, el.field, '{{guest["'+el.field+'"]}}'])
          })
        }
      }).catch(function(error) {
        console.error('Error fetching police report:', error);
      });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function (format) {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    }, format);
  }

  function getDownloadToken(callback, format) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'police_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      type: $scope.type,
      export: 'true'
    }

    if (format) {
      params.fmt = format; // format word name is overridden by rails to request type format: json
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  }

  $scope.openGuest = function(guest_id, booking_id) {
    $rootScope.openBookingManagementModal(booking_id, 'guests', {guest_id: guest_id});
  }

  var getMainFields = function () {
    return angular.copy($scope.defFields[$rootScope.hotel.country] || $scope.defFields['default']);
  }

  var initPoliceReport = function () {
    $scope.fields = getMainFields();
    $scope.requested = true;
    $scope.source = new PoliceReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getPoliceReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    initPoliceReport();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes && $scope.requested === false) {
        initPoliceReport();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.PerformanceChargeReportCtrl', PerformanceChargeReportCtrl);

PerformanceChargeReportCtrl.$inject = ["$rootScope", "$scope", "Reports.PerformanceChargeReport"];

function PerformanceChargeReportCtrl ($rootScope, $scope, PerformanceChargeReport) {
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'day').toDate();
  $scope.orderProperty = 'customer';
  $scope.orderDirection = false;

  $scope.getReport = function () {
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo <= $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).add(1, 'day').toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD ')
    ).then(function (response) {
      $scope.report_data = response;
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    window.location.href = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/reports/performance_charge_report/?dateFrom=' + moment($scope.dateFrom).format('YYYY-MM-DD ') + '&dateTo=' + moment($scope.dateTo).format('YYYY-MM-DD ') + '&export=true';
  };

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.totalSum = function (property_name) {
    if ($scope.report_data && $scope.report_data.bookings) {
      return _.toArray($scope.report_data.bookings)
        .map(function(el) {
          return el[property_name];
        })
        .reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue;
        }, 0);
    } else {
      return 0;
    }
  };

  var init = function () {
    $scope.source = new PerformanceChargeReport({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.OccupancyReportCtrl', OccupancyReportCtrl);

OccupancyReportCtrl.$inject = ["$rootScope", "$scope", "Reports.OccupancyReport", "Reports.Token", "$i18next"];

function OccupancyReportCtrl ($rootScope, $scope, OccupancyReportFactory, TokenFactory, $i18next) {
  $scope.loading = false;
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'month').toDate();
  $scope.excludeBlockers = false;

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'occupancy_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      export: 'true',
      excludeBlockers: $scope.excludeBlockers
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.charts = {
    total: null,
    roomType: null
  }

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD '),
      null,
      $scope.excludeBlockers
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response;
      $scope.total = (response.total || 0).toFixed(2);
      $scope.selected_room_type = response.report[0];
      $scope.drawTotalChart();
      $scope.drawRoomTypeChart();
    }, function(){
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.drawTotalChart = function () {
    if ($scope.charts.total) {
      $scope.charts.total.detach();
    }
    var data = {
      labels: $scope.report_data.report
        .filter(function(el) {
          return el.roomType != 'All Room Types';
        })
        .map(function(el) {return el.roomType + '\r\n' + (el.total || 0).toFixed(2) + '%'}),
      series: [
        $scope.report_data.report
        .filter(function(el) {
          return el.roomType != 'All Room Types';
        })
        .map(
          function(el) {
            return Object
              .values(el.occupancy)
              .map(function(val) {return val.percent;})
              .reduce(function(a,b) {return a + b}, 0) / Object.keys(el.occupancy).length;
          }
        )
      ]
    };

    var options = {
      high: 100,
      low: 0,
      axisY: {
        onlyInteger: true,
        labelInterpolationFnc: function(value, index) {
          return value + '%';
        }
      }
    };

    $scope.charts.total = new Chartist.Bar('.total_occupancy_chart', data, options);
  };

  $scope.drawRoomTypeChart = function () {
    if ($scope.charts.roomType) {
      $scope.charts.roomType.detach();
    }
    var values = Object.values($scope.selected_room_type.occupancy);
    var data = {
      labels: [],
      series: [
        values
          .map(function(val, index) {
            return {
              meta: moment(Object.keys($scope.selected_room_type.occupancy)[index]).format('ddd, DD MMM'),
              value: (val.percent || 0).toFixed(2)
            }
          })
      ]
    };

    var options = {
      high: 100,
      low: 0,
      axisY: {
        onlyInteger: true,
        labelInterpolationFnc: function(value, index) {
          return value + '%';
        }
      },
      chartPadding: {
        bottom: 20
      },
      plugins: [
        Chartist.plugins.tooltip({
          currency: '%',
          currencyFormatCallback: function(val, options) {
            return val + options.currency;
          },
          appendToBody: true
        })
      ]
    };

    $scope.charts.roomType = new Chartist.Bar('.avarage_occupancy_chart', data, options);
  }

  $scope.selectRoomType = function(el) {
    $scope.selected_room_type = el;
    $scope.drawRoomTypeChart();
  }

  $scope.print = function () {
    window.print();
  };

  var init = function () {
    $scope.source = new OccupancyReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if ($scope.charts.total) {
      $scope.charts.total.detach();
    }
    if ($scope.charts.roomType) {
      $scope.charts.roomType.detach();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.MealReportCtrl', MealReportCtrl)
  .component(
    'selectScrollableMealExtras',
    TBFLibs.react2angular(
      TBFLibs.SelectScrollable,
      [ 'onScroll', 
        'onSearch', 
        'onSelect', 
        'options',
        'placeholder',
        'caretDownFilledSuffix',
        'onDropdownVisibleChange'
      ],
      ['$i18next']
    )
  );


MealReportCtrl.$inject = ["$rootScope", "$scope", "Reports.MealReport", "ExtrasFactory", "Reports.Token", "$i18next"];

function MealReportCtrl ($rootScope, $scope, MealReportFactory, ExtrasFactory, TokenFactory, $i18next) {
  $scope.date = new Date();
  $scope.extras = [];
  $scope.mealExtrasReqParams = { term: '', pagination: { page: 1, limit: 10 }, meal: true, all: true };
  $scope.mealExtrasTotal = null;
  $scope.extra = "";
  $scope.extrasLoading = false,
  $scope.old_data = JSON.stringify({
    date: $scope.date,
    extras: $scope.extra
  });
  $scope.summary = [];
  $scope.summaryTotal = 0;
  $scope.summaryCount = 0;
  $scope.orderProperty = 'room_number';
  $scope.orderDirection = false;
  $scope.requested = false;

  $scope.onChange = function () {
    var new_data = {
      date: $scope.date,
      extras: $scope.extra
    }
    if ($scope.old_data != JSON.stringify(new_data)) {
      $scope.old_data = JSON.stringify({
        date: $scope.date,
        extras: $scope.extra
      });
      $scope.getMealReport();
    }
  }

  $scope.getMealReport = function () {
    $scope.source
      .get(
        moment($scope.date).format('YYYY-MM-DD'),
        $scope.extra == "" ? [] : $scope.extra
      )
      .then(function (response) {
        $scope.report_data = response;
        $scope.summary = [];
        _.uniq($scope.report_data.soldExtras.map(function(el) {return el.title}))
          .forEach(function(meal_extra) {
            var solded = $scope.report_data.soldExtras.filter(function(el) {return el.title === meal_extra});

            $scope.summary.push({
              title: meal_extra,
              count: solded.map(function(el) {return el.count;}).reduce(function(a,b) {return a + b}, 0),
              amount: solded.map(function(el) {return Number(el.revenue);}).reduce(function(a,b) {return a + b}, 0)
            });
          });
        $scope.summaryCount = $scope.summary.map(function(el) {return el.count}).reduce(function(a,b) {return a + b}, 0);
        $scope.summaryTotal = $scope.summary.map(function(el) {return el.amount}).reduce(function(a,b) {return a + b}, 0);
      });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'meal_report'
    });
    var params = {
      date: moment($scope.date).format('YYYY-MM-DD '),
      extra_id: $scope.extra,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.openBooking = function (id) {
    $rootScope.openBookingManagementModal(id);
  };

  var allMealExtrasOption = { value: '', label: $i18next.t('reports.meal_report.all_meal_extras_option') };

  $scope.onDropdownVisibleChange = function (open) {
    if(open && $scope.extras.length == 0 && $rootScope.hotel && $rootScope.hotel.id) {
      fetchMealExtras();
    };
  };

  $scope.onLoadMealExtras = function () {
    if($rootScope.hotel && $rootScope.hotel.id && $scope.mealExtrasTotal ? ($scope.extras.length < $scope.mealExtrasTotal) : true) {
      fetchMealExtras();
    };
  };

  $scope.onSearchMealExtras = function (term) {
    $scope.mealExtrasReqParams.term = term;
    $scope.mealExtrasReqParams.pagination.page = 1;
    fetchMealExtras();
  };

  var fetchMealExtras = function() {
    if(!$scope.extrasLoading) {
      $scope.extrasLoading = true;

      var par = $scope.mealExtrasReqParams;
      var extrasFactory = new ExtrasFactory();

      return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
        if (data.data) {
          var currentPage = $scope.mealExtrasReqParams.pagination.page;
          
          if(data.data.meta) {
            $scope.mealExtrasReqParams.pagination.page = data.data.meta.page + 1;
            $scope.mealExtrasTotal = data.data.meta.total + 1;
          }

          var extras = [];
          if(data.data.extras) {
            if(currentPage === 1 && !$scope.mealExtrasReqParams.term) extras = extras.concat(allMealExtrasOption);
            if(currentPage > 1) extras = extras.concat($scope.extras);

            var removedText = ' (' + $i18next.t("general.other.removed") + ')';
            var newExtras = data.data.extras.map(function(extra) {
              return {
                value: Number(extra.id),
                label: extra.is_removed ? extra.title + removedText : extra.title
              }
            });

            extras = extras.concat(newExtras);
          }

          $scope.extras = extras;
        };
      }).catch(function (error) {
        console.error('Error fetching meal extras:', error);
      }).finally (function() {
        $scope.extrasLoading = false;
      });
    };
  }

  $scope.onSelectMealExtra = function(value) {
    $scope.extra = value;
    $scope.mealExtrasReqParams.term = '';
    $scope.mealExtrasReqParams.pagination.page = 1;
    fetchMealExtras();
  };

  var initMeal = function () {
    $scope.requested = true;
    $scope.source = new MealReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getMealReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    initMeal();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes && $scope.requested === false) {
        initMeal();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.ManagerReportCtrl', ManagerReportCtrl);

ManagerReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.ManagerReport"];

function ManagerReportCtrl ($rootScope, $scope, $i18next, ManagerReportFactory) {
  $scope.date = new Date();
  $scope.c = {};
  $scope.p = {};
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.date.setHours(0,0,0,0);

    $scope.source.get(
      moment($scope.date).format('YYYY-MM-DD')
    ).then(function (response) {
      $scope.loading = false;
      var p = response.report.prev;
      var c = response.report.current;
      c.revpar = {
        today: c.totalRevenue.today / c.availableRooms.today,
        mtd: c.totalRevenue.mtd / c.availableRooms.mtd,
        ytd: c.totalRevenue.ytd / c.availableRooms.ytd,
      }
      p.revpar = {
        today: p.totalRevenue.today / p.availableRooms.today,
        mtd: p.totalRevenue.mtd / p.availableRooms.mtd,
        ytd: p.totalRevenue.ytd / p.availableRooms.ytd,
      }
      $scope.c = response.report.current;
      $scope.p = response.report.prev;

      $scope.d = {};

      ['arrivalRooms', 'arrivalGuests', 'departureRooms',
       'departureGuests', 'cancellations', 'reservationsToday',
       'blockedRooms', 'availableRooms', 'occupiedRooms', 'arrivalTomorrow',
       'departureTomorrow', 'occupancyTomorrow', 'revenue',
       'extrasRevenue', 'totalRevenue', 'avgRateRoom', 'avgRateGuest',
       'occupancy', 'occupancyWoExcludes', 'revpar'].forEach(function(d){
        $scope.d[d] = {
          today: percent100(c[d].today, p[d].today),
          mtd: percent100(c[d].mtd, p[d].mtd),
          ytd: percent100(c[d].ytd, p[d].ytd)
        };
      });

    }, function(error) {
      console.error('Failed to fetch manager report:', error);
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };


  function percent100(a, b) {
    if (b == 0) {
      return  a > 0 ? 100 : 0;
    }
    return (a - b) / b * 100;
  }

  var init = function () {
    $scope.source = new ManagerReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.hotel = $rootScope.hotel;
    $scope.currencyFractionSize = $rootScope.currencyFractionSize;
    $scope.currencySymbol = $rootScope.currencySymbol;
    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.InHouseReportCtrl', ReportsInHouseReportCtrl);

ReportsInHouseReportCtrl.$inject = ["$rootScope", "$scope", "Reports.InHouseReport", "Reports.Token"];

function ReportsInHouseReportCtrl ($rootScope, $scope, InHouseReportFactory, TokenFactory) {
  $scope.date = new Date();
  $scope.totals = {
    occupancy: 0,
    rooms: 0,
    total: 0,
    due: 0
  }

  $scope.getReport = function () {
    $scope.source.get(moment($scope.date).format('YYYY-MM-DD')).then(function (response) {
      $scope.report_data = response;
      $scope.totals = {
        occupancy: 0,
        occupancyChildrens: 0,
        rooms: 0,
        total: 0,
        due: 0
      }
      $scope.report_data.report.forEach(function(r) {
        $scope.totals['occupancy'] += parseInt(r.occupancy);
        $scope.totals['occupancyChildrens'] += parseInt(r.occupancyChildrens);
        $scope.totals['rooms'] += 1;
        $scope.totals['total'] += r.total;
        $scope.totals['due'] += r.due;
      })
    });
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'in_house_report'
    });
    var params = {
      date: moment($scope.date).format('YYYY-MM-DD '),
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.print = function () {
    window.print();
  };

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  }

  var init = function () {
    $scope.source = new InHouseReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }
  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.HousekeepingReportCtrl', HousekeepingReportCtrl);

HousekeepingReportCtrl.$inject = ["$rootScope", "$scope", "$timeout", "Reports.HousekeepingReport", "$i18next", "$http"];

function HousekeepingReportCtrl ($rootScope, $scope, $timeout, HousekeepingReportFactory, $i18next, $http) {
  $scope.date = new Date();
  $scope.housekeepingEnabled = $rootScope.hotel.housekeepingEnabled
  $scope.loading = false;
  $scope.report_data = [];
  $scope.totals = {
    checkingIn: 0,
    occupied: 0,
    checkingOut: 0
  };

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.source.get(moment($scope.date).format('YYYY-MM-DD')).then(function (response) {
      angular.copy(response.report, $scope.report_data);
      $scope.totals = {
        occupied: $scope.report_data.occupied.rooms.reduce(function(total, a){ return a[2] + total}, 0),
        checkingIn: $scope.report_data.checkingIn.rooms.reduce(function(total, a){ return a[2] + total}, 0),
        checkingOut: $scope.report_data.checkingOut.rooms.reduce(function(total, a){ return a[2] + total}, 0)
      }
      $scope.loading = false;
    }, function(){
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    if ($scope.loading == true) {
      return;
    }

    $scope.loading = true;
    $('#pdfHKReportDocument').remove();
    getDownloadToken(moment($scope.date).format('YYYY-MM-DD'), function (token) {
      var path = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/reports/housekeeping_report/export/' + token + '.pdf?print=true';

      function printDocument() {
        var printWrap = $('body');
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = path;
        iframe.name = 'pdfHKReport';
        iframe.id = 'pdfHKReportDocument';
        iframe.width = '100%';
        iframe.height = '100%';

        iframe.onload = function () {
          try {
            setTimeout(function () {
              $scope.loading = false;
              if (iframe.contentWindow) {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
              } else {
                console.error('Unable to print PDF.');
              }
            }, 100);
          } catch (e) {
            console.error('Unable to print pdf', e);
            $scope.loading = false;
          }
        };

        printWrap.append(iframe);
      }

      printDocument();
    });
  }


  $scope.export = function() {
    if ($scope.loading == true) {
      return;
    }

    $scope.loading = true;
    getDownloadToken(moment($scope.date).format('YYYY-MM-DD'), function(token){
      var path = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/reports/housekeeping_report/export/' + token +'.pdf';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  $scope.export_to_excel = function() {
    getDownloadToken(moment($scope.date).format('YYYY-MM-DD'), function(token){
      var path = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/reports/housekeeping_report/export/' + token +'.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(date, callback) {
    $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/reports/housekeeping_report/token?date=' + date + '&lang=' + window.language)
      .then(function(response) {
        if (response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function(error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  var init = function () {
    $scope.source = new HousekeepingReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.FolioReportCtrl', FolioReportCtrl);

FolioReportCtrl.$inject = ["$rootScope", "$scope", "$http", "$timeout", "Reports.FolioReport", "Reports.Token"];

function FolioReportCtrl ($rootScope, $scope, $http, $timeout, FolioReportFactory, TokenFactory) {
  $scope.types = ['all', 'folio', 'invoice', 'receipt', 'missing_receipt', 'missing_receipt_all_bookings', 'voided'];
  $scope.type = 'all';
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'day').toDate();
  $scope.old_data = JSON.stringify({
    dateFrom: $scope.dateFrom,
    dateTo: $scope.dateTo,
    type: $scope.type
  });
  $scope.bookkeepings = $rootScope.hotel.bookkeepings;
  $scope.orderProperty = 'number';
  $scope.orderDirection = false;
  $scope.requested = false;
  $scope.allSelect = false;
  $scope.loading = false;
  $scope.canPdfExport = false;

  $scope.DISPLAY_INCREMENT = 100;
  $scope.displayLimit = 100;
  $scope.loadingMore = false;

  $scope.filterDateTypes = [
    "Folio Date",
    "Arrival",
    "Departure",
    "Booking Date"
  ];
  $scope.filterDateType = $scope.filterDateTypes[0];

  $scope.onAllChange = function() {
    ($scope.report.folios || []).forEach(function(f){
       $scope.selected[f.id] = $scope.allSelect;
    });
    $scope.canPdfExport = ($scope.report.folios || []).length > 0 && $scope.allSelect;
  }

  $scope.getVisibleFoliosCount = function() {
    if (!$scope.report || !$scope.report.folios) return 0;
    return Math.min($scope.displayLimit, $scope.report.folios.length);
  };

  $scope.hasMoreFolios = function() {
    if (!$scope.report || !$scope.report.folios) return false;
    return $scope.report.folios.length > $scope.displayLimit;
  };

  $scope.loadMore = function() {
    if ($scope.loadingMore || !$scope.hasMoreFolios() || $scope.requested) return;
    $scope.loadingMore = true;
    $timeout(function() {
      // Double-check report isn't being requested (race condition protection)
      if (!$scope.requested) {
        $scope.displayLimit += $scope.DISPLAY_INCREMENT;
      }
      $scope.loadingMore = false;
    }, 50);
  };

  $scope.onChange = function () {
    var new_data = {
      dateFrom: $scope.dateFrom,
      dateTo: $scope.dateTo,
      type: $scope.type
    }
    if ($scope.old_data != JSON.stringify(new_data)) {
      $scope.old_data = JSON.stringify({
        dateFrom: $scope.dateFrom,
        dateTo: $scope.dateTo,
        type: $scope.type
      });
      $scope.getFolioReport();
    }
  }

  $scope.showFolioBookkeepingLogs = function(event, folio) {
    if (folio.status != 'receipt') {return}
    if (typeof(folio.bookkeepingLogsLast.find(function(item) {return item.inProgress === true} )) !== 'undefined') {
      folio.sendingAccountingReport = true
    }
    folio.showBookkeepingLogs = !folio.showBookkeepingLogs;
  };

  $scope.getReceiptStatusIcon = function(bookkeepingLog) {
    if (typeof(bookkeepingLog) === 'undefined') {
      return '#a0a0a0'
    }
    if (bookkeepingLog.inProgress) {
      return '#fdb650'
    }
    if (bookkeepingLog.isSuccess) {
      return '#74c971'
    } else {
      return '#ed5b4f'
    }
    return '#a0a0a0'
  }

  $scope.onFolioChange = function () {
    $scope.canPdfExport = Object.keys($scope.selected).filter(function(k) {
      return $scope.selected[k];
    }).length > 0;
  }

  $scope.sendAccountingReport = function(folio, bookkeeping) {
    folio.sendingAccountingReport = true
    $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/folios/' + folio.id + '/send_to_bookkeeping', {
      bookkeeping_id: bookkeeping.id
    }).then(function(response) {
      bookkeepingLogLast = folio.bookkeepingLogsLast.find(function(item) {return item.bookkeepingId == bookkeeping.id} )

      now = new Date()
      current_timestamp = now.toISOString()

      bookkeepingLogNew = {createdAt: current_timestamp, bookkeepingId: bookkeeping.id, folioId: folio.id, isSuccess: false, inProgress: true}
      folio.bookkeepingLogs.push(bookkeepingLogNew)

      if (typeof(bookkeepingLogLast) === 'undefined') {
        folio.bookkeepingLogsLast.push(bookkeepingLogNew)
      } else {
        bookkeepingLogLast.isSuccess = false
        bookkeepingLogLast.inProgress = true
      }
    }, function(error) {
    });
  }

  $scope.getFolioReport = function () {
    if ($scope.requested) {
      return;
    }
    $scope.requested = true;
    $scope.source
      .get(
        moment($scope.dateFrom).format('YYYY-MM-DD'),
        moment($scope.dateTo).format('YYYY-MM-DD'),
        $scope.type,
        $scope.filterDateType,
        $scope.showOnlyFailedSendBookkeeping
      )
      .then(function (response) {
        $scope.requested = false;
        $scope.report = response.report;
        $scope.selected = {};
        $scope.allSelect = false;
        $scope.canPdfExport = false;
        $scope.displayLimit = $scope.DISPLAY_INCREMENT;
        $scope.totals = {
          totalAccommodation: 0,
          totalExtra: 0,
          totalDiscount: 0,
          total: 0,
          due: 0,
          taxes: {}
        }
        $scope.report.taxes.forEach(function(t){
          $scope.totals.taxes[t] = 0;
        });

        $scope.report.folios.forEach(function(f){
          $scope.totals.totalAccommodation += parseFloat(f.totalAccommodation) || 0;
          $scope.totals.totalExtra += parseFloat(f.totalExtra) || 0;
          $scope.totals.totalDiscount += parseFloat(f.totalDiscount) || 0;
          $scope.totals.total += parseFloat(f.total) || 0;
          $scope.totals.due += parseFloat(f.due) || 0;
          $scope.report.taxes.forEach(function(t){
            $scope.totals.taxes[t] += parseFloat(f.taxes[t]) || 0;
          });

          // Pre-compute bookkeeping status map for performance optimization
          f.bookkeepingStatusMap = {};
          (f.bookkeepingLogsLast || []).forEach(function(log) {
            f.bookkeepingStatusMap[log.bookkeepingId] = {
              log: log,
              color: $scope.getReceiptStatusIcon(log)
            };
          });

          // Pre-compute status color for bookkeeping logs (expanded view)
          (f.bookkeepingLogs || []).forEach(function(log) {
            log.statusColor = $scope.getReceiptStatusIcon(log);
          });
        });
      });
  };

  $scope.print = function () {
    window.print();
  };


  $scope.export = function () {
    getFolioReportToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getFolioReportToken(callback) {
    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'folio_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      export: 'true',
      type: $scope.type,
      filterDateType: $scope.filterDateType,
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
    $scope.displayLimit = $scope.DISPLAY_INCREMENT;
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  }

  $scope.openFolio = function(folio_id, booking_id) {
    $rootScope.openBookingManagementModal(booking_id, 'folios', {folio_id: folio_id});
  }

  var initFolioReport = function () {
    $scope.source = new FolioReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getFolioReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    initFolioReport();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes && $scope.requested === false) {
        initFolioReport();
      }
    });
  }

  $scope.exportInvoices = function() {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    var folios = Object.keys($scope.selected).filter(function(k) {
      return $scope.selected[k];
    })
    if (folios.length > 0) {
      getDownloadToken(folios.join(','), function(token){
        var path = SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/reports/folios_report_invoices/export/' + token +'.xlsx';
        window.location.href = path;
        $scope.loading = false;
      });
    } else {
      $scope.loading = false;
    }
  }

  function getDownloadToken(folios, callback) {
    $http.get(SERVER_PATH + '/api/v1/hotels/'+$rootScope.hotel.id+'/reports/folios_report_invoices/token?folios=' + folios)
      .then(function(response) {
        if (response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function(error) {
        console.error('Failed to fetch download token:', error);
        $scope.loading = false;
      });
  }

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.FinancialReportCtrl', FinancialReportCtrl);

FinancialReportCtrl.$inject = ["$rootScope", "$scope", "Reports.FinancialReport", "Reports.Token", "$i18next", "$http"];

function FinancialReportCtrl ($rootScope, $scope, FinancialReportFactory, TokenFactory, $i18next, $http) {
  $scope.loading = false;
  $scope.dateFrom = new Date();
  $scope.dateTo = moment($scope.dateFrom).add(1, 'month').toDate();
  $scope.excludeBlockers = true;

  $scope.export = function () {
    if ($scope.loading) {
      return;
    }
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'financial_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      excludeBlockers: $scope.excludeBlockers,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD '),
      $scope.excludeBlockers
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response.report;
      $scope.report = {
        dateFrom: response.dateFrom,
        dateTo: response.dateTo,
        taxes: response.taxes
      };
    }, function(){
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };


  $scope.print = function () {
    window.print();
  };

  var init = function () {
    $scope.source = new FinancialReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.ExtrasReportCtrl', ExtrasReportCtrl)
  .component(
    'extrasReportSelectScrollable',
    TBFLibs.react2angular(
      TBFLibs.SelectScrollable,
      [ 'onScroll', 
        'onSearch', 
        'onSelect', 
        'options',
        'placeholder',
        'caretDownFilledSuffix',
        'onDropdownVisibleChange',
      ],
      ['$i18next']
    )
  );

ExtrasReportCtrl.$inject = ["$rootScope", "$scope", "ExtrasFactory", "Reports.ExtrasReport", "Reports.Token", "$i18next"];

function ExtrasReportCtrl ($rootScope, $scope, ExtrasFactory, ExtrasReportFactory, TokenFactory, $i18next) {
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'day').toDate();
  $scope.extras = [];
  $scope.extrasReqParams = { term: '', pagination: { page: 1, limit: 10 }, all: true };
  $scope.extrasTotal = null;
  $scope.extra = "";
  $scope.extrasLoading = false,
  $scope.old_data = JSON.stringify({
    dateFrom: $scope.dateFrom,
    dateTo: $scope.dateTo,
    extras: $scope.extra
  });
  $scope.filterCategory = null;
  $scope.orderProperty = 'guest_name';
  $scope.orderDirection = false;
  $scope.requested = false;
  $scope.colorSet = [
    "#fd797b",
    "#fd927a",
    "#fdac7a",
    "#fec578",
    "#fedb7d",
    "#ffe9b0",
    "#fff4d4",
    "#e6edff"
  ];

  $scope.onChange = function () {
    var new_data = {
      dateFrom: $scope.dateFrom,
      dateTo: $scope.dateTo,
      extras: $scope.extra
    }
    if ($scope.old_data != JSON.stringify(new_data)) {
      $scope.old_data = JSON.stringify({
        dateFrom: $scope.dateFrom,
        dateTo: $scope.dateTo,
        extras: $scope.extra
      });
      $scope.getExtrasReport();
    }
  }

  $scope.recalcTotals = function () {
    var categories = $scope.report_data.categoryRevenue.filter(function(el) { return el.title === $scope.filterCategory});
    if (categories.length) {
      $scope.filterTotals = categories[0].revenue;
    } else {
      $scope.filterCategory = null;
      $scope.filterTotals = $scope.total;
    }
  }

  $scope.getExtrasReport = function () {
    $scope.source
      .get(
        moment($scope.dateFrom).format('YYYY-MM-DD'),
        moment($scope.dateTo).format('YYYY-MM-DD'),
        $scope.extra == "" ? [] : $scope.extra
      )
      .then(function (response) {
        $scope.report_data = response;
        $scope.report_data.extrasRevenue = $scope.report_data.extrasRevenue.sort(function(a,b) {
          if (Number(a.revenue) < Number(b.revenue)) {
            return -1;
          }
          if (Number(a.revenue) > Number(b.revenue)) {
            return 1;
          }
          return 0;
        });

        $scope.report_data.categoryRevenue = $scope.report_data.categoryRevenue.sort(function(a,b) {
          if (Number(a.revenue) < Number(b.revenue)) {
            return -1;
          }
          if (Number(a.revenue) > Number(b.revenue)) {
            return 1;
          }
          return 0;
        });

        $scope.total = $scope.report_data.extrasRevenue.map(function(extra) {return Number(extra.revenue);}).reduce(function(a, b) {return a + b}, 0);
        drawEarningChart();
        drawCategoryEarningChart();
        $scope.recalcTotals();
      });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'extras_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      extra_id: $scope.extra,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.getColor = function(el, set) {
    return $scope.colorSet[set.indexOf(el)];
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  };

  var allExtrasOption = { value: '', label: $i18next.t('reports.extras_report.all_extras_option') };

  $scope.onDropdownVisibleChange = function (open) {
    if(open && $scope.extras.length == 0 && $rootScope.hotel && $rootScope.hotel.id) {
      fetchExtras();
    };
  };

  $scope.onLoadExtras = function () {
    if($rootScope.hotel && $rootScope.hotel.id && $scope.extrasTotal ? ($scope.extras.length < $scope.extrasTotal) : true) {
      fetchExtras();
    };
  };

  $scope.onSearchExtras = function (term) {
    $scope.extrasReqParams.term = term;
    $scope.extrasReqParams.pagination.page = 1;
    fetchExtras();
  };

  var fetchExtras = function() {
    if(!$scope.extrasLoading) {
      $scope.extrasLoading = true;

      var par = $scope.extrasReqParams;
      var extrasFactory = new ExtrasFactory();

      return extrasFactory.getExtras($rootScope.hotel.id, par).then(function (data) {
        if (data.data) {
          var currentPage = $scope.extrasReqParams.pagination.page;
          
          if(data.data.meta) {
            $scope.extrasReqParams.pagination.page = data.data.meta.page + 1;
            $scope.extrasTotal = data.data.meta.total + 1;
          }

          var extras = [];
          if(data.data.extras) {
            if(currentPage === 1 && !$scope.extrasReqParams.term) extras = extras.concat(allExtrasOption);
            if(currentPage > 1) extras = extras.concat($scope.extras);

            var removedText = ' (' + $i18next.t("general.other.removed") + ')';
            var newExtras = data.data.extras.map(function(extra) {
              return {
                value: Number(extra.id),
                label: extra.is_removed ? extra.title + removedText : extra.title
              }
            });

            extras = extras.concat(newExtras);
          }

          $scope.extras = extras;
        };
      }).finally (function() {
        $scope.extrasLoading = false;
      });
    };
  }

  $scope.onSelectExtra = function(value) {
    $scope.extra = value;
    $scope.extrasReqParams.term = '';
    $scope.extrasReqParams.pagination.page = 1;
    fetchExtras();
  };

  var initExtras = function () {
    $scope.requested = true;
    $scope.source = new ExtrasReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getExtrasReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    initExtras();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes && $scope.requested === false) {
        initExtras();
      }
    });
  }


  function drawEarningChart() {
    var ctx = document.getElementById("extrasEarningChart").getContext("2d");

    var myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: $scope.report_data.extrasRevenue.map(function(el) {return el.title;}),
          datasets: [{
            label: "Extras Earning",
            backgroundColor: $scope.colorSet,
            data: $scope.report_data.extrasRevenue.map(function(el) {return Number(el.revenue);})
          }]
        },
        options: {
          cutoutPercentage: 70,
          legend: { display: false }
        }
    });
  }


  function drawCategoryEarningChart() {
    var ctx = document.getElementById("extraCategoriesEarningChart").getContext("2d");

    var myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: $scope.report_data.categoryRevenue.map(function(el) {return el.title;}),
          datasets: [{
            label: "Extra Categories Earning",
            backgroundColor: $scope.colorSet,
            data: $scope.report_data.categoryRevenue.map(function(el) {return Number(el.revenue);})
          }]
        },
        options: {
          cutoutPercentage: 70,
          legend: { display: false }
        }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.EndOfDayReportCtrl', EndOfDayReportCtrl);

EndOfDayReportCtrl.$inject = ["$rootScope", "$scope", "Reports.EndOfDayReport", "Reports.Token", "$i18next"];

function EndOfDayReportCtrl ($rootScope, $scope, EndOfDayReportFactory, TokenFactory, $i18next) {
  $scope.loading = false;
  $scope.activePt = undefined;

  date = new Date();
  date.setDate(date.getDate() - 1);
  $scope.date = date;
  $scope.dateTo = date;
  $scope.perUser = '';
  $scope.users = [];

  $scope.report = {
    date: $scope.date,
    totals: {
      items_quantity: 0,
      net: 0,
      tax: 0,
      total: 0,
      payments_quantity: 0,
      payments: 0
    }
  };

  $scope.currency = $rootScope.hotel.currency
  $scope.currencyLocale = formatCurrencyLocale();

  $scope.zeroPaid = false;
  $scope.zeroUnpaid = false;

  // Sometimes we need to replace the locale for unsupported languages, for example icelandic, in order to use the correct currency format
  function formatCurrencyLocale() {
    currentLocal = localStorage.getItem('user_locale') || 'en'
    switch (currentLocal) {
      case 'is':
        return 'de'
      default:
        return currentLocal
    }
  }

  $scope.formatAmount = function (amount) {
    return Intl.NumberFormat($scope.currencyLocale, {minimumFractionDigits: $scope.currencyFractionSize, maximumFractionDigits: $scope.currencyFractionSize}).format(amount);
  }

  $scope.colorNegativeAmounts = function (amount) {
    if (amount < 0) {
      return 'red'
    }
    return ''
  }

  $scope.export = function (format) {
    if ($scope.loading) {
      return;
    }
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    }, format);
  }

  function getDownloadToken(callback, format) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'end_of_day_report'
    });
    var params = {
      date: moment($scope.date).format('YYYY-MM-DD '),
      date_to: moment($scope.dateTo).format('YYYY-MM-DD '),
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.date.setHours(0,0,0,0);

    $scope.source.get(
      moment($scope.date).format('YYYY-MM-DD'),
      moment($scope.dateTo).format('YYYY-MM-DD'),
      $scope.perUser
    ).then(function (response) {
      $scope.deactivatePt();
      $scope.loading = false;
      $scope.report_data = response.report;
      $scope.categories = $rootScope.hotel.accountingCategories.reduce(function(map, ac) {
        map[ac.id] = ac;
        return map;
      }, {});
      $scope.paymentTypes = _.union($rootScope.hotel.systemPaymentTypes, $rootScope.hotel.customPaymentTypes).reduce(function(map, ac) {
        map[ac.id] = ac;
        return map;
      }, {});


      var totals = {
        items_quantity: 0,
        net: 0,
        tax: 0,
        total: 0,
        payments_quantity: 0,
        payments: 0
      }

      Object.values($scope.report_data.items).forEach(function(acs) {
        Object.values(acs).forEach(function(ac) {
          totals.items_quantity += ac.quantity;
          totals.net += ac.net;
          totals.tax += ac.tax;
          totals.total += ac.total;
        })
      });

      Object.values($scope.report_data.payments).forEach(function(pt_val) {
        totals.payments_quantity += pt_val['quantity']
        totals.payments += pt_val['value'];
      })

      $scope.report = {
        date: response.date,
        totals: totals
      };


    }, function(e){
      $scope.loading = false;
      message = e.data ? e.data.error : $i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str');

      $rootScope.notify(message);
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.openBookingModal = function(booking_id, folio_id) {
    $rootScope.openBookingManagementModal(booking_id, 'folios', {folio_id: folio_id});

  }

  $scope.activatePt = function(pt) {
    $scope.activePt = pt;
  }

  $scope.deactivatePt = function() {
    $scope.activePt = undefined;
  }

  function getUsers() {
    $rootScope.hotel.get_users({ no_corp_acct: true }).then(function(response) {
      if(response.data) {
        $scope.users = response.data.users;

        $scope.users.sort(function(a,b) {
          var valueA = a.user_name || a.user_email;
          var valueB = b.user_name || b.user_email;

          return valueA.localeCompare(valueB);
        });
      }
    }).catch(function() {
      $rootScope.alert('Something went wrong, try again later.');
    });
  };

  var init = function () {
    $scope.source = new EndOfDayReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
    $scope.users = getUsers();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.DepositReportCtrl', DepositReportCtrl);

DepositReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.DepositReport"];

function DepositReportCtrl ($rootScope, $scope, $i18next, DepositReportFactory) {
  $scope.loading = false;
  $scope.report_data = {};

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.source.get().then(function (response) {
      $scope.loading = false;
      angular.copy(response.report, $scope.report_data);
    }, function(){
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  }

  $scope.openFolio = function(folio_id, booking_id) {
    $rootScope.openBookingManagementModal(booking_id, 'folios', {folio_id: folio_id});
  }

  var init = function () {
    $scope.source = new DepositReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.DebtorsReportCtrl', DebtorsReportCtrl);

DebtorsReportCtrl.$inject = ["$rootScope", "$scope", "Reports.DebtorsReport", "Reports.Token"];

function DebtorsReportCtrl ($rootScope, $scope, DebtorsReportFactory, TokenFactory) {
  $scope.mode = 0;
  $scope.loading = false;
  $scope.getReport = function () {
    $scope.loading = true;
    $scope.source.get().then(function (response) {
      $scope.groups = [];
      response.report.bookings.forEach(function(b) {
        if ($scope.groups.length == 0 || ($scope.groups[$scope.groups.length - 1].index != b.group && b.group <= 6)) {
          $scope.groups.push({index: b.group, bookings: [], totals: {count: 0, accomodation: 0, extras: 0, discounts: 0, due: 0}});
        }

        var group = $scope.groups[$scope.groups.length - 1];
        group.bookings.push(b);
        group.totals.count += 1;
        group.totals.accomodation += b.accomodation;
        group.totals.extras += b.extras;
        group.totals.discounts += b.discounts;
        group.totals.due += b.due;
      })
      $scope.customers = response.report.customers;
    }).finally(function() {
      $scope.loading = false;
    });
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  }

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'debtors_report'
    });
    var params = {
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  var init = function () {
    $scope.source = new DebtorsReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }
  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.DailyCheckoutReportCtrl', ReportsDailyCheckoutReportCtrl);

ReportsDailyCheckoutReportCtrl.$inject = ["$rootScope", "$scope", "Reports.DailyCheckoutReport", "Reports.Token", "$http"];

function ReportsDailyCheckoutReportCtrl ($rootScope, $scope, DailyCheckoutReportFactory, TokenFactory, $http) {
  $scope.date = new Date();
  $scope.orderProperty = 'customer';
  $scope.orderDirection = false;

  $scope.getReport = function () {
    $scope.source.get(moment($scope.date).format('YYYY-MM-DD')).then(function (response) {
      $scope.report_data = response;
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    var reportType = $scope.source.$url().split('/').pop();
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: reportType
    });

    tokenResource.getToken({
      date: moment($scope.date).format('YYYY-MM-DD')
    }).then(function (response) {
      if (response && response.data && response.data.token) {
        callback(response.data.token);
      } else {
        $scope.loading = false;
      }
    }, function (error) {
      console.error('Error fetching download token:', error);
      $scope.loading = false;
    });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  var init = function () {
    $scope.source = new DailyCheckoutReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.CreditReportCtrl', ReportsCreditReportCtrl);

ReportsCreditReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.CreditReport", "$http"];

function ReportsCreditReportCtrl ($rootScope, $scope, $i18next, CreditReportFactory, $http) {
  var activeSystemPaymentTypes = $rootScope.hotel.systemPaymentTypes.filter(function(type) {return type.isActive != false})

  $scope.useField = 'date';
  $scope.dateFrom = moment(new Date()).subtract(1, 'day').toDate();
  $scope.timeFrom = '00:00';
  $scope.dateTo = new Date();
  $scope.timeTo = '00:00';
  $scope.times = times;
  $scope.orderProperty = 'customer';
  $scope.orderDirection = false;
  $scope.loading = false;

  $scope.properties = [$rootScope.hotel.id];
  $scope.perUser = '';
  $scope.users = [];
  $scope.getReport = function () {
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).add(1, 'day').toDate();
    }
    $scope.loading = true;
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD ') + $scope.timeFrom,
      moment($scope.dateTo).format('YYYY-MM-DD ') + $scope.timeTo,
      $scope.properties,
      $scope.paymentType,
      $scope.useField,
      $scope.perUser
    ).then(function (response) {
      $scope.report_data = response;
    }, function(){
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    })
    .finally(function() {
      $scope.loading = false;
    });
  };

  $scope.print = function () {
    window.print();
  };

  function downloadXlsxFromBinaryData(response) {
    var blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    var url = URL.createObjectURL(blob);

    var a = document.createElement('a');
    a.href = url;
    a.download = 'report.xlsx';
    a.click();
    URL.revokeObjectURL(url);
  }

  $scope.export = function () {
    fetch(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/reports/daily_credit_report/?dateFrom=' + moment($scope.dateFrom).format('YYYY-MM-DD ') + $scope.timeFrom + '&dateTo=' + moment($scope.dateTo).format('YYYY-MM-DD ') + $scope.timeTo + '&export=true&properties=' + $scope.properties.join(',') + '&paymentType=' + $scope.paymentType.join(',') + '&split_payments=' + $rootScope.hotel.splitPaymentsInCreditReportExport + '&useField=' + $scope.useField, { headers: { 'Authorization': $http.defaults.headers.common['AUTHORIZATION'] } })
      .then(function (response) { return response.blob(); })
      .then(function (buffer) { return downloadXlsxFromBinaryData(buffer); })
      .catch (function (error) {
        console.error('Error:' + error);
        $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
      })
  };

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.openBooking = function(id) {
    $rootScope.openBookingManagementModal(id);
  }

  $scope.getCategoryName = function(category) {
    if (category == 'prepayment_redeem') {
      return 'redeem';
    } else {
      return category;
    }
  }

  function sortPaymentTypes(a, b) {
    if (typeof (activeSystemPaymentTypes.find(function(type2) {return type2.id == Math.floor(b[0])})) == 'undefined') {
      return -1
    }
  }

  function setUsers () {
    $rootScope.hotel.get_users({ no_corp_acct: true }).then(function(response) {
      if(response.data) {
        $scope.users = response.data.users;
        $scope.users.sort(function(a,b) {
          var valueA = a.user_name || a.user_email;
          var valueB = b.user_name || b.user_email;
          return valueA.localeCompare(valueB);
        });
      }
    }).catch(function() {
      $rootScope.alert('Something went wrong, try again later.');
    });
  }

  var init = function () {
    $scope.paymentTypes = _.union(
      [
        [1, $i18next.t('bookings.payment_form.payment_types.Cash')],
        [2, $i18next.t('bookings.payment_form.payment_types.Cheque')],
        [3, $i18next.t('bookings.payment_form.payment_types.Bank Transfer')],
        [4, $i18next.t('bookings.payment_form.payment_types.Voucher')],
        [5.1, 'Offline ' + $i18next.t('bookings.payment_form.payment_types.Credit Card')],
        [5.2, 'Online ' + $i18next.t('bookings.payment_form.payment_types.Credit Card')],
        [6, $i18next.t('bookings.payment_form.payment_types.Debit Card')],
        [7, $i18next.t('bookings.payment_form.payment_types.Other')]
      ].map(function(type) {
        return [type[0], (typeof (activeSystemPaymentTypes.find(function(type2) {return type2.id == Math.floor(type[0])})) == 'undefined' ? (type[1] + ' ' + $i18next.t('common_for_app.disabled')) : type[1]) ]}),
      $rootScope.hotel.customPaymentTypes.map(function(type) {return [type.id, type.name];})
    ).sort(sortPaymentTypes);

    $scope.paymentType = $scope.paymentTypes.map(function(z) {return z[0];});

    $scope.source = new CreditReportFactory({hotel_id: $rootScope.hotel.id});
    $scope.getReport();
    setUsers();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.CitizenshipReportCtrl', CitizenshipReportCtrl);

CitizenshipReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.CitizenshipReport", "Reports.Token"];

function CitizenshipReportCtrl ($rootScope, $scope, $i18next, CitizenshipReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = moment(new Date()).add(1, 'day').toDate();
  $scope.types = [
    "Arrival",
    "Departure",
    "Booking Date"
  ];
  $scope.type = $scope.types[0];
  $scope.orderProperty = 'country';
  $scope.orderDirection = false;
  $scope.orderBookingProperty = 'customer';
  $scope.orderBookingDirection = false;
  $scope.bookings = []
  $scope.showBookings = false
  $scope.citizenship = ''
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo <= $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).add(1, 'day').toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD '),
      $scope.type
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response;
      $scope.report_data.countries = Object.keys(response.countries).map(function(key) {
        var item = response.countries[key];
        item.country = key;
        return item;
      });
    }, function(){
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function (format) {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    }, format);
  }

  function getDownloadToken(callback, format) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'citizenship_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      type: $scope.type,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.setBookingOrderProperty = function (property) {
    if ($scope.orderBookingProperty == property) {
      $scope.orderBookingDirection = !$scope.orderBookingDirection;
    } else {
      $scope.orderBookingProperty = property;
      $scope.orderBookingDirection = false;
    }
  }

  $scope.setOrderPropertyRate = function (property) {
    if ($scope.orderPropertyRate == property) {
      $scope.orderDirectionRate = !$scope.orderDirectionRate;
    } else {
      $scope.orderPropertyRate = property;
      $scope.orderDirectionRate = false;
    }
  };

  $scope.totalSum = function (property_name) {
    if ($scope.report_data && $scope.report_data.countries) {
      return $scope.report_data.countries
        .map(function(el) {
          return el[property_name];
        })
        .reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue;
        }, 0);
    } else {
      return 0;
    }
  };

  $scope.totalAvg = function (property_name) {
    if ($scope.report_data && $scope.report_data.countries && $scope.report_data.countries.filter(function(e) {return e[property_name] != null;}).length > 0) {
      return $scope.report_data.countries
        .map(function(el) {
          return el[property_name];
        })
        .reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue;
        }, 0) / $scope.report_data.countries.filter(function(e) {return e[property_name] != null;}).length;
    } else {
      return 0;
    }
  };

  $scope.openBooking = function (id) {
    $rootScope.openBookingManagementModal(id);
  };

  $scope.showChannelBookings = function(event, country) {
    var item = $scope.report_data.countries.find(function(el) {return el.country == country});
    item.showBookings = !item.showBookings;
  };

  var init = function () {
    $scope.source = new CitizenshipReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.ChannelReportCtrl', ChannelReportCtrl);

ChannelReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.ChannelReport", "Reports.Token"];

function ChannelReportCtrl ($rootScope, $scope, $i18next, ChannelReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = new Date();
  $scope.types = [
    "Arrival",
    "Departure",
    "Booking Date"
  ];
  $scope.type = $scope.types[0];
  $scope.orderProperty = 'customer';
  $scope.orderBookingProperty = 'customer';
  $scope.orderBookingDirection = false;
  $scope.orderDirection = false;
  $scope.orderPropertyRate = 'title';
  $scope.orderDirectionRate = false;
  $scope.bookings = []
  $scope.showBookings = false
  $scope.channel = ''
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD'),
      moment($scope.dateTo).format('YYYY-MM-DD'),
      $scope.type
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response;
    }, function(){
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'channel_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      type: $scope.type,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  $scope.setBookingOrderProperty = function (property) {
    if ($scope.orderBookingProperty == property) {
      $scope.orderBookingDirection = !$scope.orderBookingDirection;
    } else {
      $scope.orderBookingProperty = property;
      $scope.orderBookingDirection = false;
    }
  }

  $scope.setOrderPropertyRate = function (property) {
    if ($scope.orderPropertyRate == property) {
      $scope.orderDirectionRate = !$scope.orderDirectionRate;
    } else {
      $scope.orderPropertyRate = property;
      $scope.orderDirectionRate = false;
    }
  };

  $scope.totalSum = function (property_name) {
    if ($scope.report_data && $scope.report_data.channels) {
      return _.toArray($scope.report_data.channels)
        .map(function(el) {
          return el[property_name];
        })
        .reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue;
        }, 0);
    } else {
      return 0;
    }
  };

  $scope.totalAvg = function (property_name) {
    if ($scope.report_data && $scope.report_data.channels && _.toArray($scope.report_data.channels).filter(function(e) {return e[property_name] != null;}).length > 0) {
      return _.toArray($scope.report_data.channels)
        .map(function(el) {
          return el[property_name];
        })
        .reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue;
        }, 0) / _.toArray($scope.report_data.channels).filter(function(e) {return e[property_name] != null;}).length;
    } else {
      return 0;
    }
  };

  $scope.openBooking = function (id) {
    $rootScope.openBookingManagementModal(id);
  };

  $scope.showChannelBookings = function(event, channel) {
    $scope.report_data.channels[channel].showBookings = !$scope.report_data.channels[channel].showBookings;
  };

  var init = function () {
    $scope.source = new ChannelReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }
  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.CancellationReportCtrl', CancellationReportCtrl);

CancellationReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.CancellationReport", "Reports.Token"];

function CancellationReportCtrl ($rootScope, $scope, $i18next, CancellationReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = new Date();
  $scope.orderProperty = 'customer';
  $scope.orderDirection = false;
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD'),
      moment($scope.dateTo).format('YYYY-MM-DD')
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response;
      $scope.totals = {
        nights: 0,
        amountOfRooms: 0,
        canceledAmount: 0,
      }
      $scope.report_data.bookings.forEach(function(a) {
        $scope.totals.nights += a.nights;
        $scope.totals.amountOfRooms += a.amountOfRooms;
        $scope.totals.canceledAmount += a.canceledAmount;
      });
    }, function(error) {
      console.error('Failed to fetch report:', error);
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'booking_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      type: 'Cancellation',
      allow_canceled: 'true',
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.openBooking = function (id) {
    $rootScope.openBookingManagementModal(id);
  };

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  var init = function () {
    $scope.source = new CancellationReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.BookingWaitlistReportCtrl', BookingWaitlistReportCtrl);

BookingWaitlistReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.BookingWaitlistReport", "Reports.Token"];

function BookingWaitlistReportCtrl($rootScope, $scope, $i18next, BookingWaitlistReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = new Date();
  $scope.loading = false;

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0, 0, 0, 0);
    $scope.dateTo.setHours(0, 0, 0, 0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD ')
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response;
    }, function () {
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'booking_waitlist_report'
    });
    var params = {
      checkin_date: moment($scope.dateFrom).format('YYYY-MM-DD'),
      checkout_date: moment($scope.dateTo).format('YYYY-MM-DD'),
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  var init = function () {
    $scope.source = new BookingWaitlistReportFactory({ hotel_id: $rootScope.hotel.id });

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.id) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.BookingReportCtrl', BookingReportCtrl);

BookingReportCtrl.$inject = ["$rootScope", "$scope", "$i18next", "Reports.BookingReport", "Reports.Token"];

function BookingReportCtrl ($rootScope, $scope, $i18next, BookingReportFactory, TokenFactory) {
  $scope.dateFrom = new Date();
  $scope.dateTo = new Date();
  $scope.types = [
    "Arrival",
    "Departure",
    "Booking Date",
    "Staying"
  ];
  $scope.type = $scope.types[0];
  $scope.sources = ['All'];
  $scope.bookingSource = 'All';
  $scope.showCancelled = false;
  $scope.dueGreaterZero = false;
  $scope.orderProperty = 'customer';
  $scope.orderDirection = false;
  $scope.loading = false;

  $scope.getReport = function () { 
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD '),
      moment($scope.dateTo).format('YYYY-MM-DD '),
      $scope.type,
      $scope.bookingSource,
      $scope.showCancelled,
      $scope.dueGreaterZero
    ).then(function (response) {
      $scope.loading = false;
      $scope.sources = _.uniq(response.availableSources);
      $scope.report_data = response;
    }, function() {
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.print = function () {
    window.print();
  };

  $scope.export = function () {
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    });
  }

  function getDownloadToken(callback) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'booking_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD'),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD'),
      type: $scope.type,
      export: 'true',
      allow_canceled: $scope.showCancelled,
      due_greater_zero: $scope.dueGreaterZero
    }

    if ($scope.bookingSource !== 'All') {
      params['source'] = $scope.bookingSource;
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.openBooking = function (id) {
    $rootScope.openBookingManagementModal(id);
  };

  $scope.setOrderProperty = function (property) {
    if ($scope.orderProperty == property) {
      $scope.orderDirection = !$scope.orderDirection;
    } else {
      $scope.orderProperty = property;
      $scope.orderDirection = false;
    }
  };

  var init = function () {
    $scope.source = new BookingReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('Reports.AccountingReportCtrl', AccountingReportCtrl);

AccountingReportCtrl.$inject = ["$rootScope", "$scope", "Reports.AccountingReport", "Reports.Token", "$i18next", "$filter"];

function AccountingReportCtrl ($rootScope, $scope, AccountingReportFactory, TokenFactory, $i18next, $filter) {
  $scope.loading = false;
  $scope.dateTo = new Date();
  $scope.dateFrom = moment($scope.dateTo).subtract(1, 'month').toDate();
  $scope.currency = $rootScope.hotel.currency
  $scope.currencyLocale = formatCurrencyLocale();
  $scope.zeroPaid = false;
  $scope.zeroUnpaid = false;

  // Sometimes we need to replace the locale for unsupported languages, for example icelandic, in order to use the correct currency format
  function formatCurrencyLocale() {
    var currentLocal = localStorage.getItem('user_locale') || 'en'
    switch (currentLocal) {
      case 'is':
        return 'de'
      default:
        return currentLocal
    }
  }

  $scope.formatAmount = function (amount) {
    if (amount == undefined) {
      amount = 0;
    }
    return Intl.NumberFormat($scope.currencyLocale, {minimumFractionDigits: $scope.currencyFractionSize, maximumFractionDigits: $scope.currencyFractionSize}).format(amount);
  }

  $scope.colorNegativeAmounts = function (amount) {
    if (amount < 0) {
      return 'red'
    }
    return ''
  }

  $scope.export = function (format) {
    if ($scope.loading) {
      return;
    }
    getDownloadToken(function (token) {
      var path = $scope.source.$url() + '/export/' + token + '.xlsx';
      window.location.href = path;
      $scope.loading = false;
    }, format);
  }

  function getDownloadToken(callback, format) {
    $scope.loading = true;

    var tokenResource = new TokenFactory({
      hotelId: $rootScope.hotel.id,
      reportType: 'accounting_report'
    });
    var params = {
      dateFrom: moment($scope.dateFrom).format('YYYY-MM-DD '),
      dateTo: moment($scope.dateTo).format('YYYY-MM-DD '),
      excludeBlockers: $scope.excludeBlockers,
      export: 'true'
    }

    tokenResource.getToken(params)
      .then(function (response) {
        if (response && response.data && response.data.token) {
          callback(response.data.token);
        } else {
          $scope.loading = false;
        }
      }, function (error) {
        console.error('Error fetching download token:', error);
        $scope.loading = false;
      });
  }

  $scope.getReport = function () {
    if ($scope.loading) {
      return;
    }
    $scope.loading = true;
    $scope.dateFrom.setHours(0,0,0,0);
    $scope.dateTo.setHours(0,0,0,0);
    if ($scope.dateTo < $scope.dateFrom) {
      $scope.dateTo = moment($scope.dateFrom).toDate();
    }
    $scope.source.get(
      moment($scope.dateFrom).format('YYYY-MM-DD'),
      moment($scope.dateTo).format('YYYY-MM-DD')
    ).then(function (response) {
      $scope.loading = false;
      $scope.report_data = response.report;
      $scope.categories = angular.copy($rootScope.hotel.accountingCategories);

      Object.keys(response.report).forEach(function(key){
        var q = {}
        $scope.report_data[key].forEach(function(obj) {
          q[obj.accountingCategoryId] = obj;
          obj.total = obj.totalUnpaid + obj.totalPaid;
          obj.daily = obj.unpaid + obj.paid;
        });

        $scope.report_data[key] = q;
       });

      $scope.deltas = {};

      var row = $scope.report_data[Object.keys($scope.report_data)[0]] || {};

      $scope.paymentsAC = _.union(_.union($rootScope.hotel.systemPaymentTypes, $rootScope.hotel.customPaymentTypes).map(function(pt) {
        return pt.accountingCategoryId
      }).filter (function (q){ return q; }), [$rootScope.hotel.accountingDefaultForPaymentId]);

      $scope.categories.forEach(function(obj) {
        obj.isPayment = $scope.paymentsAC.indexOf(obj.id) !== -1;

        var d = row[obj.id];
        if (d) {
          $scope.deltas[obj.id] = {
            paid: d.totalPaid - d.paid,
            unpaid: d.totalUnpaid - d.unpaid
          }
        } else {
          $scope.deltas[obj.id] = {
            paid: 0,
            unpaid: 0
          }
        }
      });

      $scope.categories = $filter('orderBy')($scope.categories, ['isPayment', 'name']);

      $scope.handleDelta();

      $scope.report = {
        dateFrom: response.dateFrom,
        dateTo: response.dateTo
      };


    }, function(error) {
      console.error('Error fetching report data', error);
      $scope.loading = false;
      $rootScope.notify($i18next.t('general.alert_modals.unknown_error_contact_with_administator_js_str'));
    });
  };

  $scope.handleDelta = function() {
    console.log($scope.zeroPaid);
    console.log($scope.zeroUnpaid);
    Object.keys($scope.report_data).forEach(function(key) {
      $scope.categories.forEach(function(obj) {
        var z = $scope.report_data[key][obj.id];
        if (!z) {
          return;
        }
        z.totalPaidDelta = z.totalPaid - ($scope.zeroPaid ? $scope.deltas[obj.id].paid : 0);
        z.totalUnpaidDelta = z.totalUnpaid - ($scope.zeroUnpaid ? $scope.deltas[obj.id].unpaid : 0);
        z.totalDelta = z.totalUnpaidDelta + z.totalPaidDelta;
      });
    })
  }

  $scope.print = function () {
    window.print();
  };

  var init = function () {
    $scope.source = new AccountingReportFactory({hotel_id: $rootScope.hotel.id});

    $scope.getReport();
  }

  if ($rootScope.hotel && $rootScope.hotel.id) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
        init();
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('SpecialOffersCtrl', SpecialOffersCtrl);

SpecialOffersCtrl.$inject = ['$rootScope', '$scope', '$mdDialog', '$timeout', 'SpecialOfferFactory', 'Globalize'];

function SpecialOffersCtrl ($rootScope, $scope, $mdDialog, $timeout, SpecialOfferFactory, Globalize) {
  $rootScope.loading = false;

  if ($rootScope.hotel) {
    $scope.room_representation_count = $rootScope.hotel.roomRepresentations.length;
    $scope.roomRepresentationsById = $rootScope.hotel.roomRepresentations.reduce(function(obj, el) {
      obj[el.id] = el;
      return obj;
    }, {});
  }

  angular.extend($scope, {
    offers : [],
    newOffer : {
      title: null,
      description: '',
      offerType: 'discount',
      discountType: 'percent',
      discountValue: 5,
      applyTo: 'first_night',
      dateFrom: new Date(),
      dateTo: moment(new Date()).add(30, 'days').toDate(),
      minNights: 1,
      maxNights: 30,
      minDaysAdvance: null,
      maxDaysAdvance: null,
      applySingleOccupancy: false,
      promoCodeEnabled: false,
      memberOnly: false,
      isActive: true,
      promoCode: null,
      earlyOrLate: null,
      isFeatured: false,
      weekDays: '0, 1, 2, 3, 4, 5, 6',
      closedToDeparture: '0, 1, 2, 3, 4, 5, 6',
      discountValuesPerRoom: [],
      extras: [],
      extras_list: [],
    },
    currencySymbol: $rootScope.currencySymbol,


    openOfferDialog : openOfferDialog,
    openMenu : openMenu,
    destroyOffer: destroyOffer,
    disableOffer: disableOffer,
    getInactiveOffersCount: getInactiveOffersCount,
    openDndMenu: openDndMenu,
    changeLang: changeLang,
    getIBELink: getIBELink
  });

  function openOfferDialog (offer) {
    $mdDialog
      .show({
        controller: SpecialOfferModalCtrl,
        templateUrl: getTemplatePath('special_offer_modal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          special_offer : offer
        }
      })
      .then(function(special_offer) {
        if (!_.isUndefined(special_offer)) {
          var old_offer = $scope.offers.filter(function(el) {return el.id == special_offer.id});

          if (old_offer.length > 0) {
            $scope.offers[$scope.offers.indexOf(old_offer[0])] = special_offer;
          } else {
            $scope.offers.push(special_offer);
          }
        }
      });
  }

  function openMenu ($mdOpenMenu, ev) {
    originatorEv = ev;
    $mdOpenMenu(ev);
  }

  function destroyOffer (offer) {
    offer.remove().then(function (response) {
      $scope.offers = _.without($scope.offers, offer);
    });
  }

  function disableOffer (offer) {
    offer
      .toggleActive()
      .then(function (response) {
        offer = response;
      });
  }

  function getInactiveOffersCount () {
    return $scope.offers.filter(function (el) {return el.isActive == false;}).length;
  }

  function openDndMenu($event, className) {
    $timeout(function () {
      angular.element($event.currentTarget).find('.'+ className).trigger('click');
    }, 100);
  }

  function _loadSpecialOffers () {
    SpecialOfferFactory
      .query({}, {hotelId: $rootScope.hotel.id})
      .then(function(response) {
        $scope.offers = response;
        $scope.offers.forEach(function(offer) {
          Globalize.loadTranslation(offer, 'specialOffer')
        })

        $scope.room_types_count = $rootScope.hotel.roomTypes.length;
      });
  }

  function _setCurrencySymbol () {
    $scope.currencySymbol = $rootScope.currencySymbol;
  }

  function changeLang(old_lang) {
    var offers = $scope.offers.concat([$scope.newOffer]);
    offers.forEach(function(offer) {
      Globalize.saveTranslation(offer, 'specialOffer', old_lang);
      Globalize.loadTranslation(offer, 'specialOffer')
    })
  }

  function getIBELink(offer) {
    return window.location.origin + '/' + $rootScope.hotel.slug + '/book/__special_offer_' + offer.id;
  }

  function init() {
    _loadSpecialOffers();
    _setCurrencySymbol();
    $scope.room_representation_count = $rootScope.hotel.roomRepresentations.length;
    $scope.roomRepresentationsById = $rootScope.hotel.roomRepresentations.reduce(function(obj, el) {
      obj[el.id] = el;
      return obj;
    }, {});
    $scope.newOffer.roomRepresentations = $rootScope.hotel.roomRepresentations.map(function(el) {return el.id;});
    var default_policy = $rootScope.hotel.cancellationPolicies.filter(function (el) {return el.isDefault;})[0];
    $scope.newOffer.cancellationPolicyId = default_policy ? default_policy.id : $rootScope.hotel.cancellationPolicies[0].id;
    $scope.newOffer.parentRateCategoryId = $rootScope.hotel.rateCategories.filter(function(el) {
      return el.isRemoved === false && el.isBaseRate === true;
    })[0].id;
  }

  // Check hotel loading, if hotel is not exist, wait untial they loaded.
  if ($rootScope && $rootScope.hotel) {
    init();
  } else {
    var hotelWatcher = $rootScope.$watch('hotel', function () {
      if (typeof($rootScope.hotel) != 'undefined') {
        $timeout(init, 0);
      }
    });
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    originatorEv = null;
  });
}

angular
  .module('buuqit')
  .controller('SpecialOfferModalCtrl', SpecialOfferModalCtrl)
  .component(
    'specialOfferSelectExtras',
    TBFLibs.react2angular(
      TBFLibs.SelectScrollable,
      [ 'onScroll', 
        'onSearch', 
        'onSelect',
        'onDeselect',
        'onDropdownVisibleChange',
        'options',
        'availableExtras',
        'placeholder',
        'mode',
        'caretDownFilledSuffix',
        'value'
      ],
      ['$i18next']
    )
  );

SpecialOfferModalCtrl.$inject = [
  '$rootScope',
  '$scope',
  "$i18next",
  '$mdDialog',
  '$http',
  'SpecialOfferFactory',
  'ExtrasFactory',
  'RateCategoriesStorage',
  'RoomRatesStorage',
  'special_offer',
  'Globalize'
];

function SpecialOfferModalCtrl ($rootScope, $scope, $i18next, $mdDialog, $http, SpecialOfferFactory, ExtrasFactory, RateCategoriesStorage, RoomRatesStorage, special_offer, Globalize) {
  var WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  angular.extend(
    $scope,
    {
      special_offer : _prepareSpecialOfferToDisplay(special_offer),
      room_types : $rootScope.hotel.roomTypes,
      roomRepresentations: $rootScope.hotel.roomRepresentations,
      roomRepresentationsById: angular.copy($rootScope.hotel.roomRepresentations).reduce(function(out, el) {
        out[el.id] = el;
        var rate = special_offer.rates && special_offer.rates.filter(function(rate) {
          return rate.id == el.id
        })[0];
        if (rate) {
          out[el.id].rate = rate.rate;
        }
        return out;
      }, {}),
      rateCategories : $rootScope.hotel.rateCategories.filter(function(rateCategory) {return rateCategory.isRemoved === false}),
      cancellation_policies : $rootScope.hotel.cancellationPolicies,
      currency_symbol : $rootScope.currencySymbol,
      summernote_options : {
        height: 300,
        toolbar: [
          ['headline', ['style']],
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontface', ['fontname']],
          ['textsize', ['fontsize']],
          ['fontclr', ['color']],
          ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
          ['height', ['height']],
          ['table', ['table']],
          ['insert', ['link']],
          ['view', ['fullscreen', 'codeview']],
          ['help', ['help']]
        ]
      },
      website: $rootScope.hotel.domainName ? 'https://' + $rootScope.hotel.domainName : window.location.origin + '/' + $rootScope.hotel.slug,
      availableExtras: special_offer && special_offer.extras && special_offer.extras.length ? special_offer.extras.map(function(extra) { return { key: extra.extraId, value: extra.extraId, label: extra.title }}) : [],
      mealTypes: [
        {code: "RO", title: $i18next.t('offers.special_offers_modal.meal_types.room_only_js_str')},
        {code: "BB", title: $i18next.t('offers.special_offers_modal.meal_types.bed_and_breakfast_js_str')},
        {code: "HB", title: $i18next.t('offers.special_offers_modal.meal_types.half_board_js_str')},
        {code: "FB", title: $i18next.t('offers.special_offers_modal.meal_types.full_board_js_str')},
        {code: "AI", title: $i18next.t('offers.special_offers_modal.meal_types.all_inclusive_js_str')},
        {code: "CM", title: $i18next.t('offers.special_offers_modal.meal_types.custom_js_str')},
        {code: "SC", title: $i18next.t('offers.special_offers_modal.meal_types.self_catering_js_str')},
      ],

      changeSpecialOfferType : changeSpecialOfferType,
      cancel : cancel,
      save : save,
      choosePhotoFile : choosePhotoFile,
      weekDaysTextGenerator : weekDaysTextGenerator,
      closedToDepartureTextGenerator: closedToDepartureTextGenerator,
      roomTypesTextGenerator : roomTypesTextGenerator,
      setDefaultMinDays : setDefaultMinDays,
      normalizeFirstOrLastDay: normalizeFirstOrLastDay,
      changeLang: changeLang,
      fillNextDays: fillNextDays,
      extrasReqParams: { term: '', pagination: { page: 1, limit: 10 } },
      extrasTotal: null
    }
  );


  function changeSpecialOfferType (type) {
    $scope.special_offer.offerType = type;
  }


  function cancel () {
    $mdDialog.hide();
  }


  function save () {
    $scope.loading = true;
    var special_offer = _prepareSpecialOfferToSave(angular.copy($scope.special_offer));
    Globalize.updateCurrentTranslation(special_offer, 'specialOffer');
    var operation = special_offer.id ? 'save' : 'create'

    new SpecialOfferFactory(special_offer)[operation]().then(
      function (saved_offer) {
        RateCategoriesStorage.load().then(function(list) {
          $rootScope.hotel.rateCategories = list;
          RoomRatesStorage.load();
        });
        if ($scope.photo) {
          var form_data = new FormData();
          form_data.append("image", $scope.photo);

          $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/special_offers/' + saved_offer.id + '/upload_image', form_data, {
            headers: {'Content-Type': undefined },
            transformRequest: angular.identity
          }).success(function(response) {
            saved_offer.image = response.image;
            Globalize.loadTranslation(saved_offer, 'specialOffer');
            $scope.loading = false;
            $mdDialog.hide(saved_offer);
          }).error(function(response) {
            $scope.loading = false;
            $rootScope.alert('Error');
            console.warn(response);
          });
        } else {
          $scope.loading = false;
          Globalize.loadTranslation(saved_offer, 'specialOffer');
          $mdDialog.hide(saved_offer);
        }
      },
      function (response) {
        $rootScope.alert('Error');
        console.warn(response);
      }
    );
  }


  function choosePhotoFile (input_object) {
    var reader = new FileReader();

    reader.onload = function (loadEvent) {
      $scope.$apply(function () {
        $scope.fileread = loadEvent.target.result;
      });
    }

    $scope.photo = input_object.files[0];
    reader.readAsDataURL(input_object.files[0]);
  }


  function weekDaysTextGenerator () {
    if ($scope.special_offer.weekDays.length == 7) {
      return $i18next.t('offers.special_offers_modal.all_week_js_str');
    }
    if ($scope.special_offer.weekDays.length == 5 &&
        $scope.special_offer.weekDays.indexOf('5') == -1 &&
        $scope.special_offer.weekDays.indexOf('6') == -1) {
      return $i18next.t('offers.special_offers_modal.weekdays_js_str');
    }
    if ($scope.special_offer.weekDays.length == 2 &&
        $scope.special_offer.weekDays.indexOf('5') != -1 &&
        $scope.special_offer.weekDays.indexOf('6') != -1) {
      return $i18next.t('offers.special_offers_modal.weekends_js_str');
    }
    if ($scope.special_offer.weekDays && _.isArray($scope.special_offer.weekDays)) {
      return $scope.special_offer.weekDays.map(function(el) {return WEEKDAYS[el]}).join(', ');
    } else {
      return $scope.special_offer.weekDays;
    }
  }

  function closedToDepartureTextGenerator () {
    if ($scope.special_offer.closedToDeparture.length == 7) {
      return $i18next.t('offers.special_offers_modal.all_week_js_str');
    }
    if ($scope.special_offer.closedToDeparture.length == 5 &&
        $scope.special_offer.closedToDeparture.indexOf('5') == -1 &&
        $scope.special_offer.closedToDeparture.indexOf('6') == -1) {
      return $i18next.t('offers.special_offers_modal.weekdays_js_str');
    }
    if ($scope.special_offer.closedToDeparture.length == 2 &&
        $scope.special_offer.closedToDeparture.indexOf('5') != -1 &&
        $scope.special_offer.closedToDeparture.indexOf('6') != -1) {
      return $i18next.t('offers.special_offers_modal.weekends_js_str');
    }
    if ($scope.special_offer.closedToDeparture && _.isArray($scope.special_offer.closedToDeparture)) {
      return $scope.special_offer.closedToDeparture.map(function(el) {return WEEKDAYS[el]}).join(', ');
    } else {
      return $scope.special_offer.closedToDeparture;
    }
  }

  function roomTypesTextGenerator () {
    if ($scope.special_offer.roomRepresentations.length == $rootScope.hotel.roomRepresentations.length) {
      return $i18next.t('offers.special_offers_modal.all_rooms_js_str');
    } else {
      return $scope.roomRepresentations.filter(function(el) { return $scope.special_offer.roomRepresentations.indexOf(String(el.id)) > -1;}).map(function(el) {return el.title;}).join(', ');
    }
  }


  function setDefaultMinDays () {
    if ($scope.special_offer.earlyLate === 'early') {
      $scope.special_offer.minDaysAdvance = 30;
      $scope.special_offer.maxDaysAdvance = 365;
    }
    if ($scope.special_offer.earlyLate === 'late') {
      $scope.special_offer.minDaysAdvance = 0;
      $scope.special_offer.maxDaysAdvance = 3;
    }
    if ($scope.special_offer.earlyLate === '') {
      $scope.special_offer.minDaysAdvance = null;
      $scope.special_offer.maxDaysAdvance = null;
    }
  }


  function _prepareSpecialOfferToDisplay (special_offer) {
    special_offer.promoCodeEnabled = !_.isEmpty(special_offer.promoCode);
    special_offer.dateFrom = typeof(special_offer.dateFrom) == 'string' ? new Date(special_offer.dateFrom.replace(/-/g, '\/')) : special_offer.dateFrom;
    special_offer.dateTo = typeof(special_offer.dateTo) == 'string' ? new Date(special_offer.dateTo.replace(/-/g, '\/')) : special_offer.dateTo;
    special_offer.weekDays = typeof(special_offer.weekDays) == 'string' ? special_offer.weekDays.split(', ').map(function(el) {return Number(el);}) : special_offer.weekDays;
    special_offer.closedToDeparture = typeof(special_offer.closedToDeparture) == 'string' ? special_offer.closedToDeparture.split(', ').map(function(el) {return Number(el);}) : special_offer.closedToDeparture;
    if (special_offer.discountValuesPerRoom && special_offer.discountValuesPerRoom.length > 0) {
      var discountValuesPerRoom = [];
      $rootScope.hotel.roomRepresentations.forEach(function(rt) {
        var discount = special_offer.discountValuesPerRoom.filter(function(el) {return el.roomTypeId == rt.id})[0] || {value: 0}
        discountValuesPerRoom.push(discount.value);
      });
    }

    special_offer.extrasList = special_offer.extrasList ? special_offer.extrasList.map(function(extra) { return Number(extra)}) : [];
    special_offer.discountValuesPerRoom = discountValuesPerRoom;
    $scope.fileread = special_offer.image;

    return angular.copy(special_offer);
  }


  function _prepareSpecialOfferToSave (special_offer) {
    special_offer.promoCode = special_offer.promoCodeEnabled ? special_offer.promoCode : null;
    special_offer.hotelId = $rootScope.hotel.id;
    special_offer.weekDays = special_offer.weekDays.join(', ');
    special_offer.closedToDeparture = special_offer.closedToDeparture.join(', ');
    special_offer.roomRepresentationIds = special_offer.roomRepresentations.map(function(el) {return Number(el);});
    special_offer.roomRepresentations = special_offer.roomRepresentations.map(function(el) {return Number(el);});
    special_offer.image = special_offer.image == '/images/public/missing.png' ? null : special_offer.image;
    special_offer.dateFrom = moment(special_offer.dateFrom).format('YYYY-MM-DD');
    special_offer.dateTo = moment(special_offer.dateTo).format('YYYY-MM-DD');
    special_offer.special_extrasList = special_offer.extras;
    if (special_offer.offerType === 'fixed') {
      special_offer.rates = special_offer.roomRepresentationIds.map(function(id) {
        return {
          id: id,
          rate: Object.values($scope.roomRepresentationsById[id].rate)
        };
      });
    }

    if (special_offer.discountType == 'percent_per_room_type' || special_offer.discountType == 'fixed_per_room_type') {
      var discountValuesPerRoom = [];
      $scope.roomRepresentations.forEach(function (el, index) {
        discountValuesPerRoom.push({
          room_type_id: el.id,
          value: special_offer.discountValuesPerRoom[index]
        });
      });

      special_offer.discountValuesPerRoom = JSON.stringify(discountValuesPerRoom);
    }

    if (special_offer.offerType == 'discount') {
      special_offer.applyTo = 'all_nights';
    }

    return special_offer;
  }

  function fillExtras (special_offer) {
    out = [];
    special_offer.extrasList.forEach(function(id) {
      added_extra = special_offer.extras.find(function(el){ return el.extraId === id });
      if (!added_extra) {
        var selected_extra = $scope.availableExtras.find(function (el) {return el.value == id});
        out.push({
          extraId: Number(id),
          title: selected_extra.label,
          sellMode: 'per_booking',
          amount: selected_extra.price,
          includePriceIntoRate: true,
          includePriceIntoRateForInvoice: true,
          showAtInvoice: false,
          excludeFromRate: false,
          applyToFirstDay: false,
          applyToLastDay: false,
          oneDayOffset: false,
        });
      } else {
        out.push(added_extra);
      }
    });

    special_offer.extras = out;
  }

   $scope.onExtraDropdownVisibleChange = function (open) {
    if (open && $rootScope.hotel && $rootScope.hotel.id) {
      $scope.onLoadExtras();
    };
  };

  $scope.onLoadExtras = function () {
    if ($rootScope.hotel && $rootScope.hotel.id && $scope.extrasTotal ? ($scope.availableExtras && $scope.availableExtras.length < $scope.extrasTotal) : true) {
      return fetchExtras();
    };
  };

  $scope.onSearchExtras = function (term) {
    $scope.extrasReqParams.term = term;
    $scope.extrasReqParams.pagination.page = 1;
    fetchExtras();
  };

  $scope.onSelectExtra = function (value) {
    $scope.special_offer.extrasList = $scope.special_offer && $scope.special_offer.extrasList ? $scope.special_offer.extrasList.concat([value]) : [value];
    fillExtras($scope.special_offer);
    $scope.extrasReqParams.term = '';
    $scope.$apply();
  };

  $scope.onDeselectExtra = function (value) {
    $scope.special_offer.extrasList = $scope.special_offer.extrasList.filter(function (id) { return id !== value });
    $scope.special_offer.extras = $scope.special_offer.extras.filter(function (el) { return el.extraId !== value });
    $scope.$apply();
  }

  var fetchExtras = function () {
    var params = $scope.extrasReqParams;
    var extrasFactory = new ExtrasFactory();
    return extrasFactory.getExtras($rootScope.hotel.id, params).then(function (data) {
      if (data.data) {
        var currentPage = $scope.extrasReqParams.pagination.page;

        if (data.data.meta) {
          $scope.extrasReqParams.pagination.page = data.data.meta.page + 1;
          $scope.extrasTotal = data.data.meta.total;
        }
        if (data.data.extras) {
          var extras = data.data.extras.map(function (extra) {
            var formattedExtra = extra;
            formattedExtra.key = extra.id;
            formattedExtra.value = extra.id;
            formattedExtra.label = extra.title;
            return formattedExtra;
          });
        }
        if (currentPage === 1) {
          $scope.availableExtras = extras;
        } else {
          $scope.availableExtras = $scope.availableExtras.concat(extras);
        }
      };
    });
  }

  function normalizeFirstOrLastDay(extra, field) {
    if (extra.applyToLastDay == true && field == 'applyToLastDay') {
      extra.applyToFirstDay = false
    }

    if (extra.applyToFirstDay == true && field == 'applyToFirstDay') {
      extra.applyToLastDay = false
    }
  }

  function changeLang(old_lang) {
    Globalize.saveTranslation($scope.special_offer, 'specialOffer', old_lang);
    Globalize.loadTranslation($scope.special_offer, 'specialOffer');
  }

  function fillNextDays(roomRepresentation) {
    for (x = 1; x < 7; x++) {
      roomRepresentation.rate[x] = roomRepresentation.rate[0];
    }
  }
}

angular
  .module('buuqit')
  .controller('SignupCtrl', SignupCtrl);

SignupCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$sanitize",
  "$timeout",
  "RegistrationFactory",
  "RecaptchaService",
  "StripePromotionCodesFactory"
];

function SignupCtrl ($rootScope, $scope, $i18next, $sanitize, $timeout, RegistrationFactory, RecaptchaService, StripePromotionCodesFactory) {
  $rootScope.loadedCallback();
  $scope.is_white_label = (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) == -1);
  $scope.credentials = {
    locale: 'en',
    numberOfProperties: 1,
    promotionCodeInvalid: false
  };
  $scope.promotionCodeValid = false;
  $scope.disablePromotionCodeInput = false;
  $scope.showPromotionCodeSpinner = false;
  $scope.showPromotionCodeError = false;
  $scope.promoCodeWrapperDivClass = '';
  if (location.search) {
    search = location.search.substr(1).split('&').map(function(el) {return el.split('=')});
    search.forEach(function (param) {
      $scope.credentials[param[0]] = decodeURIComponent(param[1]);
    });
  }
  $scope.loading = false;
  $scope.success = false;
  $scope.year = new Date().getFullYear();
  $scope.countries = countries;
  $scope.countriesTimezones = countries_timezones;
  $scope.step = 1;
  $scope.changeStep = function (step) {
    $scope.step = step;
  }
  $scope.setTimezoneOptions = function () {
    var country = countries_details.find(function (c) {
      return c.code === $scope.credentials.country;
    });

    if (country && country.timezones) {
      $scope.countriesTimezones = country.timezones;
    } else {
      $scope.countriesTimezones = countries_timezones;
    }
  }
  $scope.setPhoneCode = function () {
    var country = countries_details.find(function (country) {
      return country.code == $scope.credentials.country;
    });

    if (country && country.dial_code) {
      $scope.credentials.phone = country.dial_code;
    }
  }
  $scope.selectCountry = function () {
    $scope.setTimezoneOptions();
    $scope.setPhoneCode();
  }
  $scope.validateNumberOfProperties = function () {
    if ($scope.credentials.numberOfProperties < 1) {
      $scope.credentials.numberOfProperties = 1;
    }
  }
  $scope.increaseNumberOfProperties = function () {
    if (!$scope.credentials.numberOfProperties) {
      $scope.credentials.numberOfProperties = 1;
    } else {
      $scope.credentials.numberOfProperties++;
    }
  }
  $scope.decreaseNumberOfProperties = function () {
    if ($scope.credentials.numberOfProperties > 1) {
      $scope.credentials.numberOfProperties--;
    }
  }

  var showPromotionCodeSpinner = function(state) {
    $scope.showPromotionCodeSpinner = state;
  }

  var setPromotionCodeInputState = function(isValid){
    $scope.promotionCodeValid = isValid;
    $scope.promoCodeWrapperDivClass = "promo-code-wrapper-div";


    if(!isValid) {
      $scope.showPromotionCodeError = true;
      return
    }

    $scope.showPromotionCodeError = false;
    $timeout(function(){ $scope.disablePromotionCodeInput = true; }, 100)
  }


  $scope.verifyPromotionCode = function () {
    showPromotionCodeSpinner(true);

    new StripePromotionCodesFactory()
      .verifyPromotionCode($scope.credentials.promotionCode)
      .then(function(data){
        setPromotionCodeInputState(data.promotionCodeIsValid);
      }).finally(function(){
        showPromotionCodeSpinner(false);
      })
  }

  $scope.signUp = function () {
    $scope.loading = true;

    RecaptchaService.execute('signup')
    .then(function(token) {
      $scope.credentials.recaptcha_token = token;
      return (new RegistrationFactory($scope.credentials)).create();
    }).then(
        function (data) {
          $scope.loading = false;
          $scope.success = true;
          $scope.success_text = $sanitize($i18next.t('login.success_container.click_email_link_html', {'email': $scope.credentials.email}));

          var capterra_vkey = '5562195085ee5cd84e5b225f79bf837d',
          capterra_vid = '2099214',
          capterra_prefix = (('https:' == document.location.protocol) ? 'https://ct.capterra.com' : 'http://ct.capterra.com');
          (function() {
            var ct = document.createElement('script'); ct.type = 'text/javascript'; ct.async = true;
            ct.src = capterra_prefix + '/capterra_tracker.js?vid=' + capterra_vid + '&vkey=' + capterra_vkey;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ct, s);
          })();
        },
        function (error) {
          $scope.loading = false;
          if (error.data.errors && error.data.errors.email && error.data.errors.email[0]) {
            $scope.error = $i18next.t('general.other.email')+ ' ' + error.data.errors.email[0];
          }
        }
      );
  };
  
}

angular
  .module('buuqit')
  .directive("compareTo", function() {
    return {
      require: "ngModel",
      scope: {
        otherModelValue: "=compareTo"
      },
      link: function(scope, element, attributes, ngModel) {
        ngModel.$validators.compareTo = function(modelValue) {
          return modelValue == scope.otherModelValue;
        };

        scope.$watch("otherModelValue", function() {
          ngModel.$validate();
        });
      }
    };
  });

angular
  .module('buuqit')
  .controller('SettingsController', SettingsController);

SettingsController.$inject = ["$rootScope", "$scope", "$routeParams", "$http", "StripeBillingFactory"];

function SettingsController ($rootScope, $scope, $routeParams, $http, StripeBillingFactory) {
  $rootScope.loading = false;
  $rootScope.trackEvent('Settings page openned');
  $scope.currentHotelId = $rootScope.hotel ? $rootScope.hotel.id : '';
  $scope.isSaleChannelsFeatureEnabled = $rootScope.hotel ? $rootScope.hotel.saleChannelsFeatureEnabled : false;
  $scope.isAccountingCategoriesFeatureEnabled = $rootScope.hotel ? $rootScope.hotel.accountingCategoriesFeatureEnabled : false;
  $scope.paymentTerminalEnabled = $rootScope.hotel ? $rootScope.hotel.paymentTerminalEnabled : false;
  $scope.shouldShowMySubscriptions = $rootScope.hotel ? $rootScope.hotel.billViaStripeBilling : false;
  $scope.traviaCustomerLookupFeatureEnabled = $rootScope.hotel ? $rootScope.hotel.traviaCustomerLookupFeatureEnabled : false;

  $scope.block = $routeParams.block;
  $scope.template = buildTemplateUrl($routeParams);

  angular.element('[href="#/settings/'+$routeParams.block+'/'+$routeParams.part+'"]')
    .closest('li')
    .addClass('active');

  $scope.toggleCollapsedMenu = function(event) {
    angular.element(event.currentTarget).closest('li.collapsed-link').toggleClass('openned');
  };

  $scope.goToStripeBilling = function(){
    new StripeBillingFactory()
      .createBillingPortalSessionUrl($rootScope.hotel.id)
      .then(function(response) {
        window.open(response.stripeCustomerPortalSessionUrl, "_blank");
      })
      .catch(function() {
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
  }

  var hotelLoadedListener = $rootScope.$on('hotel:loaded', function() {
    $scope.currentHotelId = $rootScope.hotel.id;
    $scope.isSaleChannelsFeatureEnabled = $rootScope.hotel.saleChannelsFeatureEnabled;
    $scope.isAccountingCategoriesFeatureEnabled = $rootScope.hotel.accountingCategoriesFeatureEnabled;
    $scope.paymentTerminalEnabled = $rootScope.hotel.paymentTerminalEnabled;
    $scope.shouldShowMySubscriptions = $rootScope.hotel.billViaStripeBilling;
    $scope.traviaCustomerLookupFeatureEnabled = $rootScope.hotel.traviaCustomerLookupFeatureEnabled;
  });

  $scope.$on('$destroy', function () {
    if (hotelLoadedListener) {
      hotelLoadedListener();
    }
  });
}

function buildTemplateUrl(routeParams) {
  var templateNameParts = [
    routeParams.block.replace(/-/gi, '_'),
  ];

  if (routeParams.part !== undefined) {
    templateNameParts.push(routeParams.part.replace(/-/gi, '_'));
  }

  return getTemplatePath('settings/' + templateNameParts.join('.') + '.html');
}
angular
  .module('buuqit')
  .controller('RoomTypesCtrl', RoomTypesCtrl)
  .component(
    'roomSetup',
    window.TBFLibs.react2angular(
      window.TBFLibs.RoomSetup,
      [
        'roomTypes',
        'onSaveRoomTypes'
      ],
      ['$i18next']
    )
  );

RoomTypesCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$http",
  "StringTransformService"
];

function RoomTypesCtrl($rootScope, $scope, $i18next, $http, StringTransformService) {
  angular.extend($scope, {
    roomTypes: [],
    onSaveRoomTypes: onSaveRoomTypes,
    init: init,
    formatRoomTypes: formatRoomTypes
  });

  function onSaveRoomTypes(roomTypes) {
    return $http.put(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/room_types/initial_rooms_setup', {
      initial_rooms_setup: { room_types: StringTransformService.camelToSnake(roomTypes) }
    }).then(function (response) {
      var data = response && response.data && StringTransformService.snakeToCamel(response.data);
      if (data.hotel) {
        $rootScope.hotel = data.hotel;
        window.location.href = '#/calendar';
        return Promise.resolve(response);
      }
    }).catch(function (error) {
      $rootScope.notify($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      return Promise.reject(error);
    });
  }

  function init() {
    if ($rootScope.hotel.hasSetupRoomTypes === false) {
      $scope.formatRoomTypes();
    } else {
      window.location.href = '#/dashboard';
    }
  }

  function formatRoomTypes() {
    var roomTypes = $rootScope.hotel.roomTypes.map(function (roomType) {
      var rooms = $rootScope.hotel.rooms.filter(function (room) {
        return room.roomTypeId == roomType.id;
      });
      return {
        id: roomType.id,
        roomTypeName: roomType.name,
        totalRooms: rooms ? rooms.length : 0,
        maxOccupancy: roomType.maxOccupancy
      }
    });
    $scope.roomTypes = roomTypes;
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
      $scope.init();
    }
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('SetPasswordCtrl', SetPasswordCtrl);

SetPasswordCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$cookies",
  "$http"
];

function SetPasswordCtrl ($rootScope, $scope, $i18next, $cookies, $http) {
  angular.extend($scope, {
    is_white_label: (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) == -1),
    year : new Date().getFullYear(),
    error : null,
    success: false,
    loading: false,
    credentials: {
      password: '',
      password_confirmation: ''
    },

    send_request : function () {
      var token_params = window.location.search.substr(1,window.location.search.length).split('&').map(function(el) {return el.split('=')}).filter(function(el) {return el[0] === 'token'})[0];
      var token = token_params && token_params.length == 2 ? token_params[1] : null;

      $scope.loading = true;
      $http.post(SERVER_PATH + '/api/v1/users/reset_password', {
        reset_password_token: token,
        password: $scope.credentials.password,
        password_confirmation: $scope.credentials.password_confirmation
      }).then(function(response) {
        $scope.loading = false;
        $scope.success = response.data.success;
        if (response.data.success === false) {
          $rootScope.alert($i18next.t('login.alert.token_is_invalid_js_str'));
        }
      }, function(error) {
        $scope.loading = false;
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    },

    init : function () {
      $rootScope.loading = false;
      $rootScope.loadedCallback();
      angular.element('body').addClass('login-body');
      angular.element('.navbar').addClass('hidden');
    }
  });
  $scope.init();
}

angular
  .module('buuqit')
  .controller('SchedulerCtrl', SchedulerCtrl);

SchedulerCtrl.$inject = [
  "$scope",
  "$rootScope",
  "$timeout",
  "$interval",
  "$filter",
  "$mdDialog",
  "BookingStorage",
  "BlockerStorage",
  "RateByDateStorage",
  "Dates",
  "DateNotesStorage",
  "AvailabilityChecker"
];

function SchedulerCtrl ($scope, $rootScope, $timeout, $interval, $filter, $mdDialog, BookingStorage, BlockerStorage, RateByDateStorage, Dates, DateNotesStorage, AvailabilityChecker) {
  var booking_loading      = false,
      blocker_loading      = false,
      notes_loading        = false,
      rate_by_date_loading = false,
      loading              = false;

  $rootScope.trackEvent('booking page openned');

  $scope.holdHeightRow = 1;
  $scope.holdedArray = [[]];
  $scope.canceledArray = [[]];
  $scope.OFFSET_SCROLL = 75000;
  $scope.max_menu_height = 200;

  $scope.zoomLevels = [
    { width: 40,  height: 26 },
    { width: 50,  height: 31 },
    { width: 60,  height: 36 },
    { width: 70,  height: 41 },
    { width: 80,  height: 46 },
    { width: 90,  height: 51 },
    { width: 100, height: 56 },
    { width: 110, height: 61 },
    { width: 120, height: 66 },
    { width: 130, height: 71 },
    { width: 140, height: 76 },
    { width: 150, height: 81 }
  ];

  $scope.BlockerStorage = BlockerStorage;
  $scope.zoomLevel = parseInt(localStorage.getItem('zoom_level') || 12);

  var drawCalendar = function () {
    getBookings();
    getBlockers();
    getDateNotes();
    getYearRates();

    scrollToToday();
  };


  var getCurrentDatePosition = function () {
    return Math.floor(
      angular.element('.content-slots .scheduler-right').scrollLeft() / $scope.slotWidth
    );
  };

  $scope.getCurrentDatePosition = getCurrentDatePosition;


  var getVisibleDaysRange = function () {
    return Math.floor(
      angular.element('.content-slots .scheduler-right').width() / $scope.slotWidth
    );
  };

  $scope.getVisibleDaysRange = getVisibleDaysRange;


  var scrollToToday = function () {
    $('.content-slots .scheduler-right').scrollLeft($scope.OFFSET_SCROLL - 120 - $scope.slotWidth);
  };


  var scrollToDate = function (date_index) {
    $('.content-slots .scheduler-right')
      .scrollLeft($scope.slotWidth * ($scope.datePosition(Dates.dates[date_index].date) - 1) + $scope.OFFSET_SCROLL - 120)
      .scrollTop(0);

    $('.selected-date').removeClass('selected-date');
    $rootScope.$broadcast('Dates:update', Dates.dates[date_index]);
  };


  var getBookings = function () {
    booking_loading = true;
    calcLoading();
    $scope.BookingStorage = BookingStorage;
    BookingStorage.load(
      $filter('date')($scope.days[0].date, "yyyy-MM-dd"),
      $filter('date')($scope.days[$scope.days.length - 1].date, "yyyy-MM-dd"),
      function () {
        booking_loading = false;
        calcLoading();

        if (!_.isUndefined($rootScope.bookingForHighlight) && _.isUndefined(BookingStorage.get($rootScope.bookingForHighlight))) {
          BookingStorage.load_by_id($scope.bookingForHighlight, false, highlightBooking);
        }

        if (!_.isUndefined($rootScope.bookingForHighlight) && !_.isUndefined(BookingStorage.get($rootScope.bookingForHighlight))) {
          highlightBooking();
        }
      }
    );
  };


  var highlightBooking = function () {
    var dateForLoad = _.max(
      BookingStorage.get($rootScope.bookingForHighlight).rooms.map(
        function (room) {
          return new Date(room.checkinDate).getTime();
        }
      )
    );

    $timeout(function() {
      $scope.selectedDate = new Date(dateForLoad);
      $scope.gotoSelectedDate();
      delete $rootScope.bookingForHighlight;
    }, 0);
  };


  var getDateNotes = function () {
    notes_loading = true;
    calcLoading();
    $scope.DateNotesStorage = DateNotesStorage;
    DateNotesStorage.load(
      $scope.days[0].date,
      $scope.days[$scope.days.length - 1].date,
      function () {
        notes_loading = false;
        calcLoading();
      }
    );
  };


  var getBlockers = function () {
    blocker_loading = true;
    calcLoading();
    BlockerStorage.load(
      $scope.days[0].date,
      $scope.days[$scope.days.length - 1].date,
      function () {
        blocker_loading = false;
        calcLoading();
      }
    );
  };


  var getRateByDates = function () {
    $scope.RateByDateStorage = RateByDateStorage;
    RateByDateStorage.load(
      $filter('date')($scope.days[0].date, "yyyy-MM-dd"),
      $filter('date')($scope.days[$scope.days.length - 1].date, "yyyy-MM-dd"),
      function () {
        rate_by_date_loading = false;
        calcLoading();
      }
    );
  };


  var getYearRates = function () {
    $scope.RateByDateStorage = RateByDateStorage;
    RateByDateStorage.load(
      $filter('date')(new Date(), "yyyy-MM-dd"),
      $filter('date')(moment().add(1, 'year').toDate(), "yyyy-MM-dd"),
      function () {
        rate_by_date_loading = false;
        calcLoading();
      }
    );
  };


  var getRooms = function () {
    return $filter('orderBy')($rootScope.hotel.rooms, 'position').filter(function (room) {return room.isActive;});
  };


  var waitForLoad = function () {
    if (typeof($rootScope.hotel) != "undefined") {
      init();
    } else {
      $timeout(waitForLoad, 100);
    }
  };



  var addDates = function (direction, value) {
    var current, count, start, coefficient,
        searched = moment(value);

    if (direction == -1) {
      current = moment($scope.days[0].date);
      start = 0;
      coefficient = 3;
    } else {
      current = moment($scope.days[$scope.days.length - 1].date);
      start = $scope.days.length - 1;
      coefficient = getVisibleDaysRange();
    }

    count = Math.abs(searched.diff(current, 'days')) + coefficient;

    Dates.load(start, direction, count, function() {
      $('.content-slots .scheduler-right')
        .scrollLeft($scope.slotWidth * ($scope.datePosition(value) - 2) + $scope.OFFSET_SCROLL)
        .scrollTop(0);
    });
  };


  var calcLoading = function () {
    $rootScope.loading = booking_loading || blocker_loading || notes_loading || rate_by_date_loading;
    loading = booking_loading || blocker_loading || notes_loading || rate_by_date_loading;
    if (!$scope.calendarReady) {
      if (!_.isUndefined(BookingStorage.bookings) && !_.isUndefined(BlockerStorage.blockers)) {
        $scope.calendarReady = !$rootScope.loading;
        $rootScope.schedulerScrolling = $rootScope.loading;
      }
    }
  };


  var calcLogic = function (room, targetArray, row) {
    var sum = 0,
        length = room.nights.length,
        max = Math.max($scope[targetArray][0].length, room.col);

    if ($scope[targetArray][row] === undefined) {
      $scope[targetArray][row] = [];
      for (var x1 = 0; x1 <= max; x1++) {
        $scope[targetArray][row].push(0);
      }
    }

    if ($scope[targetArray][row].length < max) {
      for (var x = $scope[targetArray][row].length; x <= max + length; x++) {
        $scope[targetArray][row].push(0);
      }
    }

    if ($scope[targetArray][row][room.col - 1] == room.id) {
      sum = 0;
    } else {
      for (var x2 = 0; x2 < length; x2++) {
        if ($scope[targetArray][row][room.col - 1 + x2]) {
          sum += $scope[targetArray][row][room.col - 1 + x2];
        }
      }
    }

    return sum;
  };


  var calcHoldedRoomPosition = function (room, silent) {
    var row = -1,
        summ = -1;

    if (room.col >= 0) {
      while (summ !== 0) {
        row++;
        summ = calcLogic(room, 'holdedArray', row);
        if (row == 20){summ = 0;}
      }

      for (var x = 0; x < room.nights.length; x++) {
        $scope.holdedArray[row][room.col - 1 + x] = room.id;
      }

      if (row + 1 > $scope.holdHeightRow) {
        $scope.holdHeightRow = row + 1;
      }

      $scope.holdHeight = $scope.slotHeight * $scope.holdedArray.length;
      if (!silent) {
        $rootScope.$broadcast('scheduler:areaSizeChanged');
        $rootScope.$broadcast('scheduler:updateCanceled');
      }
    } else {
      row = 0;
    }

    return $scope.rooms.length + row;
  };


  var calcCanceledRoomPosition = function (room, silent) {
    var row = -1,
        summ = -1;

    if (room.col >= 0) {
      while (summ !== 0) {
        row++;
        summ = calcLogic(room, 'canceledArray', row);
        if (row == 20){summ = 0;}
      }

      for (var x = 0; x < room.nights.length; x++) {
        $scope.canceledArray[row][room.col - 1 + x] = room.id;
      }

      $scope.cancelHeight = $scope.slotHeight * $scope.canceledArray.length;
      if (!silent) {
        $rootScope.$broadcast('scheduler:areaSizeChanged');
      }
    } else {
      row = 0;
    }

    return $scope.rooms.length + row + $scope.holdHeightRow;
  };


  var init = function () {
    $scope.slotWidth  = $scope.zoomLevels[$scope.zoomLevel - 1].width;
    $scope.slotHeight = $scope.zoomLevels[$scope.zoomLevel - 1].height;

    $scope.holdHeight = $scope.slotHeight * $scope.holdedArray.length;
    $scope.cancelHeight = $scope.slotHeight * $scope.canceledArray.length;

    $scope.currentDate  = $rootScope.currentDate;
    $scope.currentDateString = String($scope.currentDate);
    $scope.selectedDate = $rootScope.currentDate;
    $scope.selectedDateString = String($scope.selectedDate);

    $scope.rooms = getRooms();
    $scope.days = Dates.dates;
    $scope.holdedArray = [[]];
    $scope.canceledArray = [[]];
    $rootScope.schedulerIsReady = true;

    for (var x = 0; x < $scope.days.length; x++) {
      $scope.holdedArray[0].push(0);
      $scope.canceledArray[0].push(0);
    }

    drawCalendar();

    $scope.booking_handler = angular.element('.booking-handler');
    $scope.blocker_booking = null;
    $scope.new_booking     = null;
  };


  $scope.goToToday = function () {
    if ($scope.selectedDate != $scope.currentDate) {
      $scope.selectedDate = $scope.currentDate;
      $scope.selectedDateString = String($scope.selectedDate);
    } else {
      scrollToDate(Dates.slotOfDay($scope.currentDate));
    }
  };


  $scope.isToday = function (day) {
    return moment(day).diff(moment($scope.currentDate), 'days') === 0;
  };


  $scope.slotOfRoom = function (roomId, room, silent) {
    if (room && room.status == 'canceled') { return calcCanceledRoomPosition(room, silent); }
    if (room && room.status == 'hold') { return calcHoldedRoomPosition(room, silent); }
    if ($scope.rooms) {
      for (var i = 0; i < $scope.rooms.length; i++) {
        room = $scope.rooms[i];
        if (room.id === roomId) {
          return i;
        }
      }
    }

    return false;
  };


  $scope.getBookings = getBookings;
  $scope.getBlockers = getBlockers;
  $scope.getDateNotes = getDateNotes;
  $scope.getRateByDates = getRateByDates;
  $scope.datePickerOpened = false;


  $scope.isSelectedDate = function (date) {
    return moment(date).isSame(moment($scope.selectedDate), 'day');
  };


  $scope.isCurrentDate = function (date) {
    return moment(date).diff(moment($scope.currentDate), 'days') === 0;
  };


  $scope.roomSlotContextMenuOpen = function (room, day) {

  };


  $scope.openContextMenu = function ($event) {
    var out = '',
        target = $($event.toElement);
    $scope.max_menu_height = angular.element(window).height() - $event.clientY - 10;
    if (target.hasClass('room-slot')) {
      out = 'room-slot';

      $scope.new_blocker = {
        room : $scope.rooms[target.index()],
        day  : Dates.dates[Math.abs(Dates.startDatePos) + parseInt(target.closest('.days-column').data('index'))].date
      };
    } else if (target.hasClass('room-blocker')) {
      out = 'blocker';
      $scope.blocker_for_manage = angular.copy(parseInt(target.data('index')));
    } else if (target.closest('.room-blocker').size() > 0) {
      out = 'blocker';
      $scope.blocker_for_manage = angular.copy(parseInt(target.closest('.room-blocker').data('index')));
    } else if (target.hasClass('booking')) {
      out = 'booking';
      $scope.prepareBookingContextMenu(
        angular.copy(parseInt(target.data('booking-id'))),
        angular.copy(parseInt(target.data('booking-room-id')))
      );
    } else if (target.closest('.booking').size() > 0) {
      out = 'booking';
      $scope.prepareBookingContextMenu(
        angular.copy(parseInt(target.closest('.booking').data('booking-id'))),
        angular.copy(parseInt(target.closest('.booking').data('booking-room-id')))
      );
    }

    $timeout(function() {
      $scope.contextMenuTarget = out;
    }, 10);
  };


  $scope.prepareBookingContextMenu = function (booking_id, room_id) {
    var booking = BookingStorage.get(booking_id),
        room = BookingStorage.get_room(room_id),
        checkin = room ? room.checkinDate : null;

    if (room && checkin) {
      $scope.booking_for_manage = angular.copy(booking.id);
      $scope.room_for_manage    = angular.copy(room.id);

      if (typeof(checkin) == 'object' || checkin.length > 10) {
        checkin = moment(checkin).format('YYYY-MM-DD');
      }

      $scope.bookingContextMenuOptions = {
        'checkin'         : moment(moment().format('YYYY-MM-DD')).toDate() >= moment(checkin).toDate() && room.status == 'pending' && room.occupationStatus == 'pending',
        'cancel_checkin'  : room.occupationStatus == 'checked_in' && moment().format('YYYY-MM-DD') == checkin,
        'checkout'        : room.occupationStatus == 'checked_in',
        'cancel_checkout' : room.occupationStatus == 'checked_out' && moment().toDate() <= moment(room.checkoutDate).toDate(),
        'hold'            : room.status === 'pending' && room.occupationStatus === 'pending' && room.dontMove !== true,
        'move'            : room.status != 'canceled',
        'manage'          : true,
        'cantmove'        : room.dontMove
      };

      if (room.dontMove) {
        $scope.availableRoomsByType = [];
        $scope.otherAvailableTypes = [];
      } else {
        $scope.calculateAvailableRooms(room);
      }
    } else {
      console.warn('Can\'t prepare context menu for room with ID ' + room_id + ' and booking ID ' + booking_id);
    }
  };


  $scope.calculateAvailableRooms = function (booking_room) {
    var rooms        = $rootScope.hotel.rooms,
        type         = $filter('filter')(rooms, function (room) {
          return room.id == booking_room.roomId;
        })[0].roomTypeId,
        availability = AvailabilityChecker.checkAvailability(
          booking_room.roomId,
          moment(booking_room.checkinDate).toDate(),
          booking_room.numberOfNights,
          booking_room.id
        ),
        closed       = availability.closed,
        roomsByType  = $filter('filter')(rooms, function (room) {
          if (booking_room.status == 'hold') {
            return room.roomTypeId == type && closed.indexOf(room.id) == -1 && room.isActive === true;
          } else {
            return room.roomTypeId == type && closed.indexOf(room.id) == -1 && room.id != booking_room.roomId  && room.isActive === true;
          }
        });
        otherAvailableTypes = $filter('filter')(rooms, function (room) {
          if (booking_room.status == 'hold') {
            return room.roomTypeId != type && closed.indexOf(room.id) == -1 && room.isActive === true;
          } else {
            return room.roomTypeId != type && closed.indexOf(room.id) == -1 && room.id != booking_room.roomId && room.isActive === true;
          }
        });

    $scope.otherAvailableTypes = otherAvailableTypes;
    $scope.availableRoomsByType = roomsByType;
  };

  $scope.addNote = function ($event, day) {
    if (!loading) {
      $scope.hidePopover();
      $mdDialog
        .show({
          controller: CreateDateNoteModalCtrl,
          templateUrl: getTemplatePath('createDateNoteModal.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            note : (function() {
              var note = DateNotesStorage.getNote(day.date);

              if (note === null) {
                note = {
                  id   : null,
                  note : null,
                  date : day.date
                };
              }

              return note;
            })(),
            local : {
              parent : $scope,
              day : day
            }
          }
        })
        .then(function(answer) {}, function() {});
    } else {
      $rootScope.alert('Please wait while we load all information');
    }
  };


  $scope.addRoomNote = function ($event, room) {
    if (!loading) {
      angular.element('.popover').remove();

      $mdDialog
        .show({
          controller: CreateRoomNoteModalCtrl,
          templateUrl: getTemplatePath('createRoomNoteModal.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            room : room,
            local : {
              parent : $scope,
              room : room
            }
          }
        })
        .then(function(answer) {}, function() {});
    } else {
      $rootScope.alert('Please wait while we load all information');
    }
  };


  $scope.bookingMouseup = function () {
    if ($scope.new_booking  && $scope.new_booking.move) {
      $scope.booking_handler.css({
        display: 'none'
      });
      $scope.new_booking = null;
    }
  };


  $scope.bookingOver = function (booking, room) {
    if (booking) {
      $scope.hoveredRoomRow = room.roomId;
      if ($scope.new_booking && room.roomId == $scope.new_booking.room_id) {
        $scope.new_booking.move = false;
        $scope.blocker_booking  = booking;
      }

      angular.element('[data-booking-id="'+booking.id+'"]').addClass('hover');
    }
  };


  $scope.setHoveredRoomRow = function (blocker) {
    //$scope.hoveredRoomRow = blocker.roomId;
  };


  $scope.unsetHoveredRoomRow = function () {
    //$scope.hoveredRoomRow = null;
  };


  $scope.bookingOut = function (booking) {
    if (booking) {
      angular.element('[data-booking-id="'+booking.id+'"]').removeClass('hover');
    }
  };


  $scope.open_modal = function (booking) {
    if ($rootScope.hasAccess('bookingCreate') && $rootScope.hotel.roomRates) {
      $rootScope.trackEvent('Create booking modal openned');
      $mdDialog.show({
        controller: CreateBookingModalCtrl,
        templateUrl: getTemplatePath('modals/createBooking.html'),
        parent: angular.element(document.body),
        locals: {
          options : booking
        },
        clickOutsideToClose: false
      })
        .then(function(selectedItem) {
          if (selectedItem && selectedItem.rooms.length > 0) {
            var diff = getCurrentDatePosition() - Dates.slotOfDay(selectedItem.rooms[0].checkinDate) - 1;
            if (diff > 0 || diff < (getVisibleDaysRange() - 1) * (-1)) {
              $scope.selectedDate = moment(
                selectedItem.rooms[0].checkinDate,
                'YYYY-MM-DD'
              ).toDate();

              $scope.selectedDateString = String($scope.selectedDate);
            }
          }
        }, function() {});
    }
  };


  $scope.openRoomBlockerModal = function () {
    if ($rootScope.hasAccess('blockerCreate')) {
      if (!loading) {
        $mdDialog
          .show({
            controller: RoomBlockerModalCtrl,
            templateUrl: getTemplatePath('roomBlockerModal.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              blocker : $scope.new_blocker,
              local : {
                parent : $scope
              }
            }
          })
          .then(function(answer) {
          }, function() {
          });
      } else {
        $rootScope.alert('Please wait while we load all information');
      }
    }
  };


  $scope.holdRoom = function () {
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.hold(function() {$rootScope.$broadcast('holding_area:redraw');});
  };


  $scope.openBookingManagementModal = function (booking_id, tab_index) {
    if ($rootScope.hasAccess('viewBookingInfo')) {
      if (_.isUndefined(booking_id) && !_.isUndefined($scope.booking_for_manage)) { booking_id = $scope.booking_for_manage; }

      if (!_.isUndefined(booking_id)) {
        $rootScope.openBookingManagementModal(booking_id, tab_index);
      }
    }
  };


  $scope.openBlockerManagementModal = function ($event, blocker) {
    if ($rootScope.hasAccess('viewBlockerInfo')) {
      if (!loading) {
        if (blocker) {
          $scope.blocker_for_manage = angular.copy(blocker.id);
        }

        $mdDialog
          .show({
            controller: RoomBlockerModalCtrl,
            templateUrl: getTemplatePath('roomBlockerModal.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            targetEvent: $event,
            locals: {
              blocker : $scope.blocker_for_manage,
              local : {
                parent : $scope,
                blocker : blocker
              }
            }
          });
      } else {
        $rootScope.alert('Please wait while we load all information');
      }
    }
  };


  $scope.removeBlocker = function () {
    var confirm = $mdDialog.confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ariaLabel('Confirm')
      .ok('Confirm')
      .cancel('Cancel');

    $mdDialog.show(confirm).then(function() {
      var blocker = BlockerStorage.get($scope.blocker_for_manage);
      if (blocker) {
        blocker.destroy();

        BlockerStorage.blockers.splice(BlockerStorage.blockers.indexOf(blocker), 1);
        $rootScope.$broadcast('BlockerStorage:destroy', blocker.id);
      }
    }, function() {});
  };


  $scope.suffix = function (num) {
    if (num > 1) {
      return 's';
    }
  };


  $scope.checkin = function () {
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.checkin();
  };


  $scope.cancel_checkin = function () {
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.cancel_checkin();
  };


  $scope.checkout = function () {
    var room = BookingStorage.get_room($scope.room_for_manage),
        booking = BookingStorage.get(room.bookingId);

    room.checkout();

    if (booking.paymentStatus != 'paid') {
      var confirm = $mdDialog.confirm()
        .title('Would you like to add a payment?')
        .textContent('Oops there is an outstanding balance on this account')
        .ariaLabel('Would you like to add a payment?')
        .ok('Yes')
        .cancel('Later');

      $mdDialog.show(confirm).then(function() {
        $rootScope.openBookingManagementModal(booking.id, 'payment');
      }, function() {});
    }
  };


  $scope.cancel_checkout = function () {
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.cancel_checkout();
  };


  $scope.showSubmenu = function ($event) {
    angular.element($event.currentTarget).find('.submenu').addClass('show');
  };


  $scope.hideSubmenu = function ($event) {
    angular.element($event.currentTarget).find('.submenu').removeClass('show');
  };


  $scope.moveBookingToRoom = function (roomId) {
    var room = BookingStorage.get_room($scope.room_for_manage),
        old_status = room.status,
        old_room_id = room.roomId,
        status = room.status;

    room
      .setRoom(roomId)
      .then(function(response) {
        if (response && response.data && response.data.error == true) {
          room.roomId = old_room_id;
          room.status = old_status;
          $rootScope.$broadcast('BookingStorage:update_booking', room.bookingId);
          $rootScope.notify(response.data.message);
        } else {
          if (status == 'hold') {
            $rootScope.$broadcast('scheduler:updateHolded');
          }

          $rootScope.$broadcast('scheduler:areaSizeChanged');
        }
      });
  };


  $scope.getRoomType = function (id) {
    var roomType = $rootScope.hotel.roomTypes.filter(function (room_type) {return room_type.id == id;})[0];
    if (roomType) {
      return roomType.shortName;
    }
  };


  $scope.getShortClass = function (room) {
    return room && room.number ? room.number.length < 4 : true;
  };


  $scope.gotoSelectedDate = function () {
    var value = $scope.selectedDate;

    if (value !== undefined) {
      var index = Dates.slotOfDay(value),
          direction;

      if ($scope.days) {
        if (index && index < $scope.days.length) {
          scrollToDate(index);
        } else {
          direction = -1;
          if ($scope.days[0].date > value) {
            direction = -1;
          }
          if ($scope.days[$scope.days.length - 1].date < value) {
            direction = 1;
          }
          addDates(direction, value);
        }
      }


      $timeout(function() {
        var dates = $scope.days.map(function(el) {return el.date.getTime()});
        var date_from = $filter('date')(moment(Math.min.apply(Math, dates)).toDate(), "yyyy-MM-dd");
        var date_to = $filter('date')(moment(Math.max.apply(Math, dates)).toDate(), "yyyy-MM-dd");
        $scope.BookingStorage.loadUpdates(date_from, date_to);
        $scope.BlockerStorage.loadUpdates(date_from, date_to);
      }, 1500);
    }
  };


  $scope.moveCalendar = function (direction) {
    var position = getCurrentDatePosition(),
        scrolledDays = Math.floor($scope.getVisibleDaysRange() / 4) * direction;


    $('.content-slots .scheduler-right')
      .scrollLeft($scope.slotWidth * (position + scrolledDays));
  };


  $scope.datePosition = function(date) {
    return Math.round((date - $scope.currentDate) / 86400000);
  };

  $scope.htmlSubstring = function (str, count) {
    var div = document.createElement('div');
    div.innerHTML = str;

    walk( div, track );

    function track( el ) {
      if( count > 0 ) {
        var len = el.data.length;
        count -= len;
        if( count <= 0 ) {
          el.data = el.substringData( 0, el.data.length + count );
        }
      } else {
        el.data = '';
      }
    }

    function walk( el, fn ) {
      var node = el.firstChild;
      do {
        if( node.nodeType === 3 ) {
          fn(node);
        } else if( node.nodeType === 1 && node.childNodes && node.childNodes[0] ) {
          walk( node, fn );
        }
      } while( node = node.nextSibling );
    }
    return div.innerHTML;
  }

  $scope.showPopover = function(event, text, type) {
    if (text) {
      if (typeof(text) == 'object') {
        output = '';
        if (text[0]) { output += '<b>Guest Note:</b><br />'+text[0]+'<br />'; }
        if (text[1]) { output += '<b>Hotel Note:</b><br />'+text[1]+'<br />'; }
        if (text[2]) { output += '<b>Housekeeping Note:</b><br />'+text[2]; }
        text = output;
      }
      var popover = $('#scheduler-popover');

      if (popover.size() == 0) {
        $('.scheduler').append('<div class="popover top" id="scheduler-popover"><div class="arrow"></div><div class="popover-content">Some content</div></div>');
        popover = $('#scheduler-popover');
      }

      if (text.length > 150) {
        text = $scope.htmlSubstring(text,100) + '...'
      }

      if (type == 'note') {
        text += '<div class="read-more-at-popover">Click at <i class="fa fa-comment"></i> to edit</div>';
      }

      popover
        .css('opacity', '0')
        .show()
        .find('.popover-content').html(text);

      var width = popover.width(),
          height = popover.height(),
          targetWidth = $(event.currentTarget).width(),
          left = ($(event.currentTarget).offset().left + (targetWidth / 2) - (width / 2) - 2),
          top = $(event.currentTarget).offset().top;

      popover.css({
        top: (top - height - 5) + 'px',
        left: left + 'px',
        opacity: 1
      });
    }
  };


  $scope.hidePopover = function () {
    var popover = $('#scheduler-popover');
    popover.hide();
  };


  $scope.hideContextMenu = function ($event) {
    if ($event === undefined || !angular.element($event.target).parent().hasClass('has-submenu')) {
      angular.element('#ContextMenu').removeClass('open');
    }
  }


  $scope.prepareNewBooking = function () {
    $scope.open_modal({
      room_id: $scope.new_blocker.room.id,
      date_in: $scope.new_blocker.day,
      date_out: moment($scope.new_blocker.day).add(1, 'day').toDate(),
      move: true
    }, {});
  }

  $scope.saveBookingRoomNotes = function (booking_room_id, guest_notes, hotel_notes, housekeeping_notes) {
    var room = BookingStorage.get_room(booking_room_id);
    room.note = guest_notes;
    room.hotelNote = hotel_notes;
    room.housekeepingNote = housekeeping_notes;
    room.save().then(function() {
      $rootScope.$broadcast('BookingStorage:update', room.id, room.bookingId);
    });
  }

  $scope.calendarReady = false;


  $scope.$on('showToday', function () {
    $scope.goToToday();
  });


  if ($rootScope.newDateInterval) {
    $interval.cancel($rootScope.newDateInterval);
  }
  $rootScope.newDateInterval = $interval(function() {
    var date = new Date();
    if (date.getHours() === 4 && date.getMinutes() === 0) {
      var today = moment($filter('date')(moment().toDate(), "yyyy-MM-dd"));
      $scope.currentDate  = today.toDate();
      $scope.currentDateString = String(today.toDate());
      $rootScope.currentDate = $scope.currentDate;

      $rootScope.$broadcast('scheduler:changeDate');
    }
  }, 10000);

  waitForLoad();
}

angular
  .module('buuqit')
  .controller('ProfileCtrl', ProfileCtrl);

ProfileCtrl.$inject = ["$rootScope", "$scope", "$i18next", "$timeout", "UserFactory"];

function ProfileCtrl($rootScope, $scope, $i18next, $timeout, UserFactory) {
  var initialized = false;

  var initialize = function () {
    if (window.TBFLibs && window.TBFLibs.TBFProfilePage && $i18next) {
      window.TBFLibs.TBFProfilePage('react-app__profile', SERVER_PATH, window.language, $i18next)
    }
  }

  angular.extend(
    $scope, {
      user: null,
      changePasswordActive: false,
      loadingSave: false,
      locales: locales,
      languages: languages.reduce(function (out, el) {
        out[el.code] = el;
        return out;
      }, {}),

      changeLocale: changeLocale,
      openChangePassword: openChangePassword,
      save: save
    }
  );

  if ($rootScope.user) {
    $scope.user = $rootScope.user;
  }

  var userWatcher = $rootScope.$watch('user', function () {
    if (typeof ($rootScope.user) !== 'undefined' && $scope.user === null) {
      $scope.user = $rootScope.user;
    }
  });

  function openChangePassword($event, mode) {
    $event.preventDefault();

    $scope.changePasswordActive = mode;
  }

  function save() {
    $scope.loadingSave = true;

    new UserFactory($scope.user).update().then(function () {
      $scope.loadingSave = false;
      $scope.changePasswordActive = false;

      delete $scope.user.old_password;
      delete $scope.user.password;
      delete $scope.user.password_confirmation;

      $rootScope.alert($i18next.t('profile_nav.profile.alert.user_profile_successfully_updated_js_str'));
    }, function (error) {
      $scope.loadingSave = false;
      if (error.data && error.data.errors) {
        msg = error.data.errors.join('.\r\n')
      } else {
        msg = $i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str');
      }
      $rootScope.alert(msg);
    });
  }

  function changeLocale() {
    $rootScope.changeLanguage($scope.user.locale);
  }

  if (initialized === false && $i18next) initialize();

  // Listen for user profile updates from React Profile component
  var profileUpdateListener = $rootScope.$on('user:profile:updated', function(event, updatedUser) {
    $rootScope.user = angular.extend($rootScope.user, updatedUser);
    // Trigger digest cycle to update Angular UI immediately
    $timeout(function() {});
  });

  $scope.$on('$destroy', function () {
    if (userWatcher) {
      userWatcher();
    }
    if (profileUpdateListener) {
      profileUpdateListener();
    }
  });
}
angular
  .module('buuqit')
  .controller('PluginCtrl', PluginCtrl);

  PluginCtrl.$inject = ["$rootScope", "$scope", "$i18next", "$routeParams", "$sce"];

function PluginCtrl ($rootScope, $scope, $i18next, $routeParams, $sce) {
  var self = this;

  angular.extend(
    this,
    {
      loaded    : false,
      plugin    : {},
    }
  );

  $scope.trustSrc = function(src) {
    return $sce.trustAsResourceUrl(src);
  }

  function init () {
    if ($rootScope.hotel) {
      $scope.loaded = true;
      $scope.plugin = $rootScope.hotel.plugins.filter(function(p) { return p.id == $routeParams.id; })[0];
    }
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    init();
  });

  init();

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('OldInventoryCtrl', OldInventoryCtrl);

OldInventoryCtrl.$inject = ["$rootScope", "$scope", "$routeParams", "$location", "$timeout"];

function OldInventoryCtrl ($rootScope, $scope, $routeParams, $location, $timeout) {
  var pages = ['closeout'];

  $rootScope.loading = false;

  if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
    $scope.active_page = pages.filter(pageFilter).indexOf('closeout');
    $scope.active_page_name = 'closeout';
    $rootScope.$broadcast('inventory.' + pages[$scope.active_page]);
  }

  function pageFilter(el) {
    if ($rootScope.hotel) {
      if (el === 'min_stay' && $rootScope.hotel.minStayThroughVisible == false) {
        return false;
      }
      if (el === 'min_stay_arrival' && $rootScope.hotel.minStayArrivalVisible == false) {
        return false;
      }
      if (el === 'closed_to_arrival' && $rootScope.hotel.closedToArrivalVisible == false) {
        return false;
      }
      if (el === 'closed_to_departure' && $rootScope.hotel.closedToDepartureVisible == false) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  // $scope.$watch('active_page', function(val) {
  //   if ($rootScope.hotel) {
  //     var visiblePages = pages.filter(pageFilter);

  //     if (visiblePages.indexOf($routeParams.block) != val) {
  //       $routeParams.block = pages[val];
  //       $location.path('/inventory/' + visiblePages[val], false);
  //       $rootScope.$broadcast('inventory.' + pages[$scope.active_page]);
  //       $scope.active_page_name = visiblePages[val];
  //     }
  //   }
  // });

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && $rootScope.hotel.roomTypes) {
      $timeout(function() {
        $scope.active_page = pages.filter(pageFilter).indexOf('closeout');
        $scope.active_page_name = 'closeout';
        $rootScope.$broadcast('inventory.' + pages[$scope.active_page]);
      }, 20);
    }
  });

  $scope.calcTabClass = function() {
    var length = pages.length;

    if ($rootScope.hotel) {
      ['minStayThroughVisible','minStayArrivalVisible','closedToArrivalVisible','closedToDepartureVisible'].forEach(function(el) {
        if ($rootScope.hotel[el] == false) {
          length--;
        }
      });
    }

    return 'tabs-with-'+length+'-elements';
  }

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('NewInventoryCtrl', NewInventoryCtrl)
  .component('customLogs', window.TBFLibs.react2angular(
    window.TBFLibs.CustomLogs,
    [
      '$i18next',
      'logs',
      'isLoading',
      'onLoadLogs',
      'total',
      'openTrigger'
    ],
    [
      '$i18next'
    ]
  ));

NewInventoryCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$http",
  "$routeParams",
  "$mdDialog",
  "RestrictionStorage",
  "Seasons",
  "CustomLog",
  "StringTransformService"
];

function NewInventoryCtrl ($rootScope, $scope, $i18next, $http, $routeParams, $mdDialog, RestrictionStorage, Seasons, CustomLog, StringTransformService) {
  var RESTRICTIONS = [
    {code: 'rate', camelCaseCode: 'rate', representation:'Rate', type: 'number'},
    {code: 'min_stay_through', camelCaseCode: 'minStayThrough', representation: 'Min Stay Through', type: 'number'},
    {code: 'min_stay_arrival', camelCaseCode: 'minStayArrival', representation: 'Min Stay Arrival', type: 'number'},
    {code: 'max_stay', camelCaseCode: 'maxStay', representation: 'Max Stay', type: 'number'},
    {code: 'closed_to_arrival', camelCaseCode: 'closedToArrival', representation: 'Closed To Arrival', type: 'checkbox'},
    {code: 'closed_to_departure', camelCaseCode: 'closedToDeparture', representation: 'Closed To Departure', type: 'checkbox'},
    {code: 'stop_sell', camelCaseCode: 'stopSell', representation: 'Stop Sell', type: 'checkbox'}
  ];

  var OPTIMAL_COLUMN_WIDTH = 50;

  function init() {
    $scope.confirmation = $mdDialog
      .confirm()
      .title($i18next.t('general.confirm.confirm'))
      .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
      .ok($i18next.t('general.confirm.ok'))
      .cancel($i18next.t('general.confirm.cancel'));
    $scope.manualConfirmation = $mdDialog
      .confirm()
      .title($i18next.t('inventory.new_inventory.confirm.delete_manual_change_title'))
      .textContent($i18next.t('inventory.new_inventory.confirm.deleting_the_manual_change_will_set_the_value_back_to_the_season_default_text_content'))
      .ok($i18next.t('general.confirm.ok'))
      .cancel($i18next.t('general.confirm.cancel'));

    $scope.initialized = true;
    $scope.startDate = new Date((new Date()).setHours(0,0,0,0));
    $scope.showAllInventoryRoomTypes = $routeParams.block === 'availability' ? true : $rootScope.hotel.multiRoomInventoryTableFeatureEnabled,

    $scope.restrictions = RESTRICTIONS.filter(function(el) {
      switch (el.code) {
        case 'min_stay_arrival':
            return $rootScope.hotel.minStayArrivalVisible;
          break;
        case 'min_stay_through':
            return $rootScope.hotel.minStayThroughVisible;
          break;
        case 'closed_to_arrival':
            return $rootScope.hotel.closedToArrivalVisible;
          break;
        case 'closed_to_departure':
            return $rootScope.hotel.closedToDepartureVisible;
          break;
        case 'max_stay':
            return $rootScope.hotel.maxStayVisible;
          break;
        case 'stop_sell':
            return $rootScope.hotel.stopSellVisible;
          break;
        default:
            return true;
          break;
      }
    });

    __setLists();
    __setDefaultSelectedVariables();

    setTimeout(function() {
      $scope.inventory = new TBFInventory({
        el: 'inventory-table',
        startDate: moment($scope.startDate).format('YYYY-MM-DD'),
        rateCategories: $rootScope.hotel.rateCategories,
        roomRepresentations: $rootScope.hotel.roomRepresentations,
        roomRates: $rootScope.hotel.roomRates,
        minStayArrivalVisible: $rootScope.hotel.minStayArrivalVisible,
        minStayThroughVisible: $rootScope.hotel.minStayThroughVisible,
        maxStayVisible: $rootScope.hotel.maxStayVisible,
        closedToArrivalVisible: $rootScope.hotel.closedToArrivalVisible,
        closedToDepartureVisible: $rootScope.hotel.closedToDepartureVisible,
        stopSellVisible: $rootScope.hotel.stopSellVisible,
        Seasons: Seasons,
        loadRestrictions: __loadRestrictions,
        selectedRestrictions: $scope.selectedRestrictions,
        selectedRoomRepresentations: $scope.selectedRoomRepresentations,
        selectedRateCategories: $scope.selectedRateCategories,
        removeCustomValue: removeCustomValue,
        openSelectedLog: openSelectedLog,
        derivedRates: $scope.showOnlyRatePlans,
        showAllInventoryRoomTypes: $scope.showAllInventoryRoomTypes,
        i18n: $i18next.i18n
      });
  
      $scope.selectedDaysInRange = $scope.inventory.countOfDates;
      $scope.daysInRange = $scope.inventory.countOfDates;
      $scope.selectedRoomRepresentation = $scope.selectedRoomRepresentations[0];
      __loadRestrictions();
    }, 100);
  }

  function toggleFilters() {
    $scope.filtersIsVisible = !$scope.filtersIsVisible;
  }

  function initIfPossibleAndNeeded() {
    if ($rootScope.hotel && $rootScope.hotel.roomRates && $scope.initialized !== true) {
      init();
    }
  }

  function chooseOneOption(model, value) {
    $scope[model] = [value];
  }

  function resetChanges() {
    $mdDialog
      .show($scope.confirmation)
      .then(
        function() {
          $scope.resetInProgress = true;
          $scope.inventory.update(
            $scope.inventory.startDate,
            angular.copy(RestrictionStorage.getForDates(
              $scope.inventory.dates.map(function(date) {return date.ISODate})
            )));
          $scope.resetInProgress = false;
        },
        function() {}
      );
  }

  function saveChanges() {
    var hasEmptyManualOverrideFields = $scope.inventory && $scope.inventory.hasEmptyManualOverrideFields();

    if (hasEmptyManualOverrideFields) {
      $rootScope.notify($i18next.t('inventory.empty_fields_notification'));
      return;
    }
    $scope.saveInProgress = true;

    RestrictionStorage.saveChanges(
      $scope.inventory.getChanges()
        .filter(function(el) {return !(el.restriction === 'rate' && el.value === 0)})
    ).then(function(data) {
      if(data && data.success === false){
        $rootScope.notify(data.message, $i18next.t('general.other.error'));
      }
      
      $scope.inventory.update($scope.inventory.startDate, RestrictionStorage.getForDates(
        $scope.inventory.dates.map(function(date) {return date.ISODate})
      ));
      $scope.saveInProgress = false;
    });
  }

  function eraseManualChanges() {
    $mdDialog
      .show({
        controller: EraseDialogController,
        templateUrl: getTemplatePath("modals/eraseDialog.html"),
        parent: angular.element(document.body),
        clickOutsideToClose: true
      })
      .then(function(result) {
        if (result) {
          $scope.eraseInProgress = true;
          RestrictionStorage.bulkEraseManualChanges(
            result.roomRateIds,
            result.dates,
            result.restrictions
          ).then(function() {
            $scope.eraseInProgress = false;
            $scope.inventory.update(
              $scope.inventory.startDate,
              RestrictionStorage.getForDates(
                $scope.inventory.dates.map(function(date) {return date.ISODate})
              )
            );
          });
        }
      });
  }

  function removeCustomValue(room_rate_id, date, restriction) {
    $mdDialog
    .show($scope.manualConfirmation)
    .then(
      function() {
        RestrictionStorage
          .removeCustomValue(room_rate_id, date, restriction)
          .then(function() {
            $scope.inventory.update(
              $scope.inventory.startDate,
              RestrictionStorage.getForDates(
                $scope.inventory.dates.map(function(date) {return date.ISODate})
              )
            );  
          });
      },
      function() {}
    );
  }

  function openSelectedLog(roomRateId, selectedDate, restriction) {
    $scope.selectedCustomLog = { roomRateId: roomRateId, selectedDate: selectedDate, restriction: restriction };
    $scope.logProps = {
      logsIsLoading: true,
      logs: [],
      openDrawerTrigger: true
    }
    $scope.$apply();

    $scope.inventory.toggleLogView(false);
    $scope.inventory.draw();
  }

  function onLoadLogs(filters) {
    $scope.logProps.logsIsLoading = true;
    CustomLog
      .load($scope.selectedCustomLog.roomRateId, $scope.selectedCustomLog.selectedDate,
            $scope.selectedCustomLog.restriction, filters.limit, filters.page)
      .then(function(result) {
        $scope.logProps = { logs: StringTransformService.snakeToCamel(result.data.data), logsIsLoading: false, total: result.data.meta.total };})
      .catch(function (error) {
        $rootScope.notify(error.data.message);
        $scope.logProps = { logsIsLoading: false, logs: [], total: 0 };
      });
  }

  function __getRoomRateSortValue(roomRate) {
    return getName(roomRate.rateCategoryId) + ' ' + (roomRate.maxAdults * 100 + roomRate.maxChildren);
  }

  function __roomRateSort(a, b) {
    if (__getRoomRateSortValue(a) < __getRoomRateSortValue(b)) {
      return -1;
    } else if (__getRoomRateSortValue(a) > __getRoomRateSortValue(b)) {
      return 1;
    } else {
      return 0;
    }
  }

  function __roomRepresentationSort(a, b) {
    if (a.title < b.title) {
      return -1;
    } else if (a.title > b.title) {
      return 1;
    } else {
      return 0;
    }
  }

  function __setLists() {
    $scope.rateCategories = $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved == false}).reduce(function(obj, el) {
      obj[el.id] = el;
      return obj;
    }, {});
    $scope.roomRepresentations = $rootScope.hotel.roomRepresentations.map(function(rr) {
      rr.roomRates = $rootScope.hotel.roomRates.filter(function(el) {
        return el.roomRepresentationId === rr.id && el.isRemoved === false
      }).sort(__roomRateSort);

      return rr;
    }).sort(__roomRepresentationSort);
    $scope.totalCountOfRooms = $scope.roomRepresentations.reduce(function(a, b) {return a + b.countOfRooms;}, 0);
  }

  function __setDefaultSelectedVariables() {
    if ($routeParams.block == 'all') {
      $scope.selectedRestrictions = RESTRICTIONS.map(function(el) {
        return el.code;
      });
    } else if ($routeParams.block == 'rate_main') {
      $scope.selectedRestrictions = ['rate'];
      $scope.selectedRateCategories = Object.values($scope.rateCategories)
        .filter(function(rc) {
          return !rc.parentRateCategoryId;
        })
        .map(function(rc) {
          return rc.id;
        });
    } else {
      $scope.selectedRestrictions = [$routeParams.block];
    }
    $scope.selectedRoomRepresentations = $scope.roomRepresentations.map(function(el) {
      return el.id;
    });
    if ($routeParams.block === 'rate_main') { return; }
    if ($routeParams.block !== 'availability') {
      $scope.selectedRateCategories = Object.keys($scope.rateCategories);
    } else {
      $scope.selectedRateCategories = [];
    }
  }

  function __loadRestrictions() {
    RestrictionStorage
      .inventoryLoad(
        $scope.inventory.dates[0].ISODate,
        $scope.inventory.dates[$scope.inventory.dates.length - 1].ISODate)
      .then(function(result) {
        $scope.inventory.update($scope.inventory.dates[0].date, result);
        $scope.loaded = true;
        $scope.resetInProgress = false;
      }).catch(function(error) {
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        console.error('Error while trying to load inventory data', error);
      });
  }

  function updateFilters() {
    if ($scope.inventory) {
      $scope.inventory.setFilters({
        selectedRateCategories: $scope.selectedRateCategories,
        selectedRestrictions: $scope.selectedRestrictions,
        selectedRoomRepresentations: $scope.showAllInventoryRoomTypes ? $scope.selectedRoomRepresentations : [$scope.selectedRoomRepresentation],
        derivedRates: $scope.showOnlyRatePlans
      });
    }
  }

  function updateDates() {
    $scope.daysInRange = $scope.selectedDaysInRange;
    $scope.inventory.updateCountOfDays($scope.daysInRange);
  }

  function onlyRatePlans(el) {
    if ($scope.showOnlyRatePlans == true) {
      return !el.parentRoomRateId && el.isCalculatedRate == false;
    } else {
      return true;
    }
  }

  function updateStartDate() {
    $scope.inventory.update($scope.startDate);
  }

  function toggleManualOverride() {
    $scope.inventory.toggleManualOverride($scope.manualOverrideIsEnabled);
  }

  function toggleLogsButton() {
    $scope.inventory.toggleLogView(true);
    $rootScope.notify($i18next.t('inventory.new_inventory.change_logs.instructions'));
  }

  function openBulkDialog() {
    $mdDialog
      .show({
        controller: BulkUpdateController,
        templateUrl: getTemplatePath("modals/bulkUpdate.html"),
        parent: angular.element(document.body),
        clickOutsideToClose: true
      })
      .then(function(result) {
        if (result) {
          $scope.bulkSaveInProgress = true;

          RestrictionStorage.saveChanges(result).then(function(data) {
            if(data.success === false){
              $rootScope.notify(data.message, $i18next.t('general.other.error'));
            }

            $scope.inventory.update(
              $scope.inventory.startDate,
              RestrictionStorage.getForDates(
                $scope.inventory.dates.map(function(date) {return date.ISODate})
              )
            );
            $scope.bulkSaveInProgress = false;
          });
        }
      });
  }

  function getName(el) {
    if ($scope.rateCategories[el] && $scope.rateCategories[el].translations) {
      var locale = _.where($scope.rateCategories[el].translations, function(e){
        return e.locale == $rootScope.hotel.locale;
      })
      if (locale.length > 1) {
        return locale[0].name;
      }

      var locale = _.where($scope.rateCategories[el].translations, function(e){
        return e.locale == 'en';
      })
      if (locale.length > 1) {
        return locale[0].name;
      }
    } else {
      if ($scope.rateCategories[el]) {
        return $scope.rateCategories[el].name || '';
      }
      return '';
    }
  }

  angular.extend($scope, {
    initialized: false,
    loaded: false,
    daysInRange: 0,
    selectedDaysInRange: 0,
    selectedRoomRepresentation: [],
    selectedRoomRepresentations: [],
    selectedRateCategories: [],
    selectedRestrictions: [],
    restrictions: RESTRICTIONS,
    eraseInProgress: false,
    resetInProgress: false,
    saveInProgress: false,
    bulkSaveInProgress: false,
    showOnlyRatePlans: false,
    isAvailabilityBlock: $routeParams.block === 'availability',
    filtersIsVisible: false,
    logProps: {
        logs: [],
        logsIsLoading: false,
        total: 0,
        openDrawerTrigger: false
    },
    selectedCustomLog: {},
    manualOverrideIsEnabled: false,
    minDate: new Date((new Date("2017-01-01")).setHours(0,0,0,0)),
    today: new Date((new Date()).setHours(0,0,0,0)),

    updateDates: _.debounce(updateDates, 500),
    chooseOneOption: chooseOneOption,
    resetChanges: resetChanges,
    saveChanges: saveChanges,
    eraseManualChanges: eraseManualChanges,
    removeCustomValue: removeCustomValue,
    openSelectedLog: openSelectedLog,
    updateStartDate: updateStartDate,
    onlyRatePlans: onlyRatePlans,
    applyFiltersForRooms: _.debounce(updateFilters, 300),
    applyFiltersForRestrictions: _.debounce(updateFilters, 300),
    toggleFilters: toggleFilters,
    toggleManualOverride: toggleManualOverride,
    openBulkDialog: openBulkDialog,
    getName: getName,
    toggleLogsButton: toggleLogsButton,
    onLoadLogs: onLoadLogs,

  });

  var hotelWatcher = $rootScope.$watch('hotel', initIfPossibleAndNeeded);
  var languageChangedListener = $rootScope.$on('languageChanged', function() {
    if ($rootScope.hotel && $scope.initialized === true) {
      $scope.inventory.update(
        $scope.inventory.startDate,
        RestrictionStorage.getForDates(
          $scope.inventory.dates.map(function(date) {return date.ISODate})
        )
      );
    }
  });
  var roomRatesLoadedListener = $rootScope.$on('roomRates:loaded', initIfPossibleAndNeeded);

  $scope.$on('$destroy', function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (languageChangedListener) {
      languageChangedListener();
    }
    if (roomRatesLoadedListener) {
      roomRatesLoadedListener();
    }
    if ($scope.inventory) {
      $scope.inventory.destroy();
    }
  });
  
  initIfPossibleAndNeeded();
}

angular
  .module('buuqit')
  .controller('MetricsCtrl', MetricsCtrl);

MetricsCtrl.$inject = ["$rootScope"];

function MetricsCtrl ($rootScope) {
  $rootScope.loading = false;
  $rootScope.loadedCallback();
  $rootScope.trackEvent('Metrics page openned');
}

angular
  .module('buuqit')
  .controller('LoginCtrl', LoginCtrl);

LoginCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$cookies",
  "SessionFactory",
  "DeviceDetector"
];


function LoginCtrl ($rootScope, $scope, $i18next, $cookies, SessionFactory, DeviceDetector) {
  angular.extend($scope, {
    is_white_label: (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) == -1),
    is_mobile: DeviceDetector === 'mobile',
    year : new Date().getFullYear(),
    error : null,
    otpInputActive : false,
    letMeInAccepted : false,
    loading: false,
    credentials: {
      email: null,
      password: null,
      otpClientChallenge: null,
      otp: null,
      rememberMe: null,
      xDeviceBf: $cookies.get('x-device-bf')
    },
    
    login : function () {
      $scope.loading = true;
      (new SessionFactory($scope.credentials))
        .create()
        .then(
          function (data) {
            // if (window.location.origin.indexOf('localhost') === -1 && window.location.origin !== data.redirect) {
            //   window.location.href = data.redirect;
            // } else {
              if (data.otpSent) {
                $scope.loading = false;
                $scope.otpInputActive = true;
                $scope.credentials.otpClientChallenge = data.otpClientChallenge;
                return
              }

              var user_for_save = angular.copy(data.user);
              if (data.user.hotels.length > 0 && localStorage.hotel && JSON.parse(localStorage.hotel).name != data.user.hotels[0].name) {
                var locale = localStorage.getItem('user_locale');
                localStorage.clear();
                locale = localStorage.setItem('user_locale', locale);
              }

              delete user_for_save.email;

              localStorage.setItem('user', JSON.stringify(data.user));
              $rootScope.setUserToken( data.user.id, data.token );

              if (data.xDeviceBf) {
                $rootScope.setRememberMeToken(data.xDeviceBf);
              }
              window.location.href = data.user.systemRole == 'admin' || data.user.systemRole == 'corporate_admin' || data.user.systemRole == 'white_admin' ? '/#/admin' : '/';
              window.location.reload();  
            // }
          },
          function (error) {
            if (error && error.data && error.data.error) {
              $rootScope.alert(error.data.error);
            } else if (error.status === 429) {
              $rootScope.alert($i18next.t('general.alert_modals.too_many_requests'));
            } else {
              $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
            }
            $scope.loading = false;
          }
        );
    },

    isChromium: function () {
      var isChromium = window.chrome,
          winNav = window.navigator,
          vendorName = winNav.vendor,
          isOpera = winNav.userAgent.indexOf("OPR") > -1,
          isIEedge = winNav.userAgent.indexOf("Edge") > -1,
          isIOSChrome = winNav.userAgent.match("CriOS");

      if(isIOSChrome){
         return true;
      } else if(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera == false && isIEedge == false) {
         return true;
      } else {
         return false;
      }
    },

    init : function () {
      if ($scope.is_mobile) {
        var mvp = document.getElementById('metaViewPort');
        mvp.setAttribute('content','width=device-width, initial-scale=1');
      }
      $rootScope.loading = false;
      $rootScope.loadedCallback();
      angular.element('body').addClass('login-body');
      angular.element('.navbar').addClass('hidden');
    },

    letMeIn : function () {
      $scope.letMeInAccepted = true;
    }
  });

  $scope.init();
}

angular
  .module('buuqit')
  .controller('InventoryCtrl', InventoryCtrl);

InventoryCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$http",
  "$routeParams",
  "$mdDialog",
  "RestrictionStorage",
  "Seasons",
  "CustomLog"
];

function InventoryCtrl ($rootScope, $scope, $i18next, $http, $routeParams, $mdDialog, RestrictionStorage, Seasons, CustomLog) {
  var RESTRICTIONS = [
    {code: 'rate', camelCaseCode: 'rate', representation: 'Rate', type: 'number'},
    {code: 'min_stay_through', camelCaseCode: 'minStayThrough', representation: 'Min Stay Through', type: 'number'},
    {code: 'min_stay_arrival', camelCaseCode: 'minStayArrival', representation: 'Min Stay Arrival', type: 'number'},
    {code: 'max_stay', camelCaseCode: 'maxStay', representation: 'Max Stay', type: 'number'},
    {code: 'closed_to_arrival', camelCaseCode: 'closedToArrival', representation: 'Closed To Arrival', type: 'checkbox'},
    {code: 'closed_to_departure', camelCaseCode: 'closedToDeparture', representation: 'Closed To Departure', type: 'checkbox'},
    {code: 'stop_sell', camelCaseCode: 'stopSell', representation: 'Stop Sell', type: 'checkbox'}
  ];

  var OPTIMAL_COLUMN_WIDTH = 50;

  function init() {
    $scope.initialized = true;
    $scope.startDate = new Date((new Date()).setHours(0,0,0,0));
    $scope.i18next = $i18next;

    $scope.restrictions = RESTRICTIONS.filter(function(el) {
      switch (el.code) {
        case 'min_stay_arrival':
            return $rootScope.hotel.minStayArrivalVisible;
          break;
        case 'min_stay_through':
            return $rootScope.hotel.minStayThroughVisible;
          break;
        case 'closed_to_arrival':
            return $rootScope.hotel.closedToArrivalVisible;
          break;
        case 'closed_to_departure':
            return $rootScope.hotel.closedToDepartureVisible;
          break;
        default:
            return true;
          break;
      }
    });
    __generateGradient();
    __generateDates();
    __setLists();
    __setDefaultSelectedVariables();
    __filterRoomsLists();
    __filterRestrictions();
    __loadRestrictions();
  }

  function initIfPossibleAndNeeded() {
    if ($rootScope.hotel && $scope.initialized !== true) {
      init();
    }
  }

  function updateDates() {
    $scope.daysInRange = $scope.selectedDaysInRange;
    __generateDates();
    __loadRestrictions();
    __loadLogs();
  }

  function prevDates() {
    __changeDates('subtract');
  }

  function nextDates() {
    __changeDates('add');
  }


  function chooseOneOption(model, value) {
    $scope[model] = [value];
  }

  function changeRestriction(model, restriction) {
    var code = restriction.camelCaseCode ? restriction.camelCaseCode : restriction;
    model[code + 'IsChanged'] = model[code] != model['original_' + code];
  }

  function resetChanges() {
    $mdDialog
      .show($scope.confirmation)
      .then(
        function() {
          $scope.resetInProgress = true;
          RestrictionStorage.resetChanges();
          $scope.resetInProgress = false;
        },
        function() {}
      );
  }

  function saveChanges() {
    $scope.saveInProgress = true;
    RestrictionStorage.saveChanges().then(function() {
      $scope.saveInProgress = false;
    });
  }

  function eraseManualChanges() {
    $mdDialog
      .show($scope.confirmation)
      .then(
        function() {
          $scope.eraseInProgress = true;
          RestrictionStorage.eraseManualChanges(
            $scope.dates[0].ISODate,
            $scope.dates[$scope.dates.length - 1].ISODate
          ).then(function() {
            $scope.eraseInProgress = false;
          });
        },
        function() {}
      );
  }

  function removeCustomValue(room_rate_id, date, restriction) {
    $mdDialog
    .show($scope.confirmation)
    .then(
      function() {
        RestrictionStorage.removeCustomValue(room_rate_id, date, restriction);
      },
      function() {}
    );
  }

  function getOccupancyPercent(total, occupied) {
    return ((1 - (1 / total) * occupied) * 100).toFixed(2);
  }

  function shadeColor(percent, setNumber) {
    setNumber = setNumber || 1;
    percent = parseInt(percent) < 0 ? 0 : parseInt(percent);
    var point = $scope['ctx' + setNumber].getImageData(percent, 0, 1, 1).data;
    return "#" + ("000000" + __rgbToHex(point[0], point[1], point[2])).slice(-6);
  }

  function calculateOccupancy() {
    $scope.occupancy = {};
    $scope.occupancyPerRoomRepresentation = {}
    $scope.dates.forEach(function(date) {
      var value = parseInt(
        getOccupancyPercent(
          $scope.totalCountOfRooms,
          $scope.roomRepresentations.map(function(roomRepresentation) {
            return roomRepresentation.roomRates[0].id;
          }).reduce(function(out, el) {
            return out + $scope.restrictionValues[el][date.ISODate].availability;
          }, 0)
        )
      );
      $scope.occupancy[date.ISODate] = {
        value: value,
        color: shadeColor(value, 2)
      };
      $scope.occupancyPerRoomRepresentation[date.ISODate] = {};
      $scope.filteredRoomRepresentations.forEach(function(roomRepresentation) {
        $scope.occupancyPerRoomRepresentation[date.ISODate][roomRepresentation.id] = {
          color: shadeColor(getOccupancyPercent(roomRepresentation.countOfRooms, $scope.restrictionValues[roomRepresentation.roomRates[0].id][date.ISODate].availability), 1)
        }
      });
    });
  }

  function __generateGradient() {
    var c = document.createElement('canvas');
    var ctx = c.getContext("2d");
    var grd = ctx.createLinearGradient(0,0,101,0);
    grd.addColorStop(0, "#d6dfee");
    grd.addColorStop(1, "#5078b3");
    ctx.fillStyle=grd;
    ctx.fillRect(0,0,101,100);

    var c2 = document.createElement('canvas');
    var ctx2 = c2.getContext("2d");
    var grd2 = ctx2.createLinearGradient(0,0,101,0);
    grd2.addColorStop(0, "#e3f4e1");
    grd2.addColorStop(1, "#60b660");
    ctx2.fillStyle = grd2;
    ctx2.fillRect(0,0,101,100);

    $scope.ctx1 = ctx;
    $scope.ctx2 = ctx2;
  }

  function __getRoomRateSortValue(roomRate) {
    return getName(roomRate.rateCategoryId) + ' ' + (roomRate.maxAdults * 100 + roomRate.maxChildren);
  }

  function __roomRateSort(a, b) {
    if (__getRoomRateSortValue(a) < __getRoomRateSortValue(b)) {
      return -1;
    } else if (__getRoomRateSortValue(a) > __getRoomRateSortValue(b)) {
      return 1;
    } else {
      return 0;
    }
  }

  function __roomRepresentationSort(a, b) {
    if (a.title < b.title) {
      return -1;
    } else if (a.title > b.title) {
      return 1;
    } else {
      return 0;
    }
  }

  function __generateDates() {
    $scope.dates = new Array($scope.daysInRange)
      .fill(null)
      .map(function(_, index) {
        var date = moment($scope.startDate).add(index, 'day').toDate();
        var seasonRange = Seasons.getSeasonRangeByDate(date);
        return {
          date: date,
          ISODate: moment(date).format('YYYY-MM-DD'),
          day: date.getDate(),
          wday: date.getDay(),
          month: date.getMonth(),
          representation: moment(date).format('DD') + '<br><small>' + moment(date).format('ddd') + '<br>' + moment(date).format('MMM') + '</small>',
          seasonTitle: seasonRange.seasonTitle,
          seasonColor: seasonRange.seasonColor
        }
      });
  }

  function __setLists() {
    $scope.rateCategories = $rootScope.hotel.rateCategories.filter(function(el) {return el.isRemoved == false}).reduce(function(obj, el) {
      obj[el.id] = el;
      return obj;
    }, {});

    $scope.roomRepresentations = $rootScope.hotel.roomRepresentations.map(function(rr) {
      rr.roomRates = $rootScope.hotel.roomRates.filter(function(el) {
        return el.roomRepresentationId === rr.id && el.isRemoved === false
      }).sort(__roomRateSort);

      return rr;
    }).sort(__roomRepresentationSort);

    $scope.totalCountOfRooms = $scope.roomRepresentations.reduce(function(a, b) {return a + b.countOfRooms;}, 0);
  }

  function __setDefaultSelectedVariables() {
    if ($routeParams.block == 'all') {
      $scope.selectedRestrictions = RESTRICTIONS.map(function(el) {
        return el.code;
      });
    } else {
      $scope.selectedRestrictions = [$routeParams.block];
    }

    $scope.selectedRoomRepresentations = $scope.roomRepresentations.map(function(el) {
      return el.id;
    });

    if ($routeParams.block !== 'availability') {
      $scope.selectedRateCategories = Object.keys($scope.rateCategories);
    } else {
      $scope.selectedRateCategories = [];
    }
  }

  function __filterRoomsLists() {
    $scope.filteredRoomRepresentations = $scope.roomRepresentations.filter(function(roomRepresentation) {
      return $scope.selectedRoomRepresentations.indexOf(roomRepresentation.id) != -1;
    }).map(function(roomRepresentation) {
      roomRepresentation.filteredRoomRates = roomRepresentation.roomRates.filter(function(roomRate) {
        return (
          ($scope.showOnlyRatePlans == true ? !roomRate.parentRoomRateId && roomRate.isCalculatedRate == false : true) &&
          $scope.selectedRateCategories.indexOf(roomRate.rateCategoryId) != -1
        );
      });
      return roomRepresentation;
    });
  }

  function __filterRestrictions() {
    $scope.filteredRestrictions = $scope.restrictions.filter(function(restriction) {
      return $scope.selectedRestrictions.indexOf(restriction.code) != -1;
    });
    __loadLogs();
  }

  function __loadRestrictions() {
    RestrictionStorage
      .load($scope.dates[0].ISODate, $scope.dates[$scope.dates.length - 1].ISODate)
      .then(function(result) {
        $scope.restrictionValues = result;
        calculateOccupancy();
        $scope.loaded = true;
      });
  }

  function __changeDates(method) {
    $scope.startDate = moment($scope.startDate)[method]($scope.daysInRange, 'day').toDate();
    if ($scope.startDate < new Date((new Date("2017-01-01")).setHours(0,0,0,0))) {
      $scope.startDate = new Date((new Date("2017-01-01")).setHours(0,0,0,0));
    }
    updateDates();
  }

  function __rgbToHex(r, g, b) {
    if (r > 255 || g > 255 || b > 255)
        throw "Invalid color component";
    return ((r << 16) | (g << 8) | b).toString(16);
  }

  function __calculateCountOfDaysInRange() {
    var tableWidth = angular.element(document).width() - 40;
    var firstColumn = tableWidth * .1666667;
    var secondColumn = tableWidth * .0833333;

    return Math.ceil((tableWidth - firstColumn - secondColumn) / OPTIMAL_COLUMN_WIDTH);
  }

  function onlyRatePlans(el) {
    if ($scope.showOnlyRatePlans == true) {
      return !el.parentRoomRateId && el.isCalculatedRate == false;
    } else {
      return true;
    }
  }

  function getName(el) {
    if ($scope.rateCategories[el] && $scope.rateCategories[el].translations) {
      return ($scope.rateCategories[el].translations[$hotel.lang] || $scope.rateCategories[el].translations['en']).name;
    } else {
      return $scope.rateCategories[el].name || '';
    }
  }

  angular.extend($scope, {
    initialized: false,
    loaded: false,
    daysInRange: __calculateCountOfDaysInRange(),
    selectedDaysInRange: __calculateCountOfDaysInRange(),
    selectedRoomRepresentations: [],
    selectedRateCategories: [],
    selectedRestrictions: [],
    restrictions: RESTRICTIONS,
    eraseInProgress: false,
    resetInProgress: false,
    saveInProgress: false,
    logIsVisible: false,
    showOnlyRatePlans: true,
    logs: [],
    manualOverrideIsEnabled: false,
    minDate: new Date((new Date("2017-01-01")).setHours(0,0,0,0)),
    today: new Date((new Date()).setHours(0,0,0,0)),
    confirmation: $mdDialog
                    .confirm()
                    .title($i18next.t('general.confirm.confirm'))
                    .textContent($i18next.t('general.confirm.are_you_sure_text_content'))
                    .ok($i18next.t('general.confirm.ok'))
                    .cancel($i18next.t('general.confirm.cancel')),

    updateDates: _.debounce(updateDates, 500),
    prevDates: prevDates,
    nextDates: nextDates,
    chooseOneOption: chooseOneOption,
    changeRestriction: changeRestriction,
    resetChanges: resetChanges,
    saveChanges: saveChanges,
    eraseManualChanges: eraseManualChanges,
    removeCustomValue: removeCustomValue,
    getOccupancyPercent: getOccupancyPercent,
    shadeColor: shadeColor,
    updateStartDate: updateDates,
    onlyRatePlans: onlyRatePlans,
    applyFiltersForRooms: __filterRoomsLists,
    applyFiltersForRestrictions: __filterRestrictions,
    getName: getName
  });

  var hotelWatcher = $rootScope.$watch('hotel', initIfPossibleAndNeeded);
  initIfPossibleAndNeeded();

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('ImportCtrl', ImportCtrl);

ImportCtrl.$inject = ["$rootScope", "$scope", "$http"];

function ImportCtrl ($rootScope, $scope, $http) {
  angular.extend(
    $scope,
    {
      files: [],
      profile: "",
      inProgress: false,

      import: upload,
      fileChoosed: fileChoosed
    }
  );

  function fileChoosed ($event) {
    $scope.files = $event.target.files;
  }

  function upload () {
    $scope.inProgress = true;
    _.each($scope.files, function (file) {
      var reader = new FileReader(),
          for_save = {};

      var fd = new FormData();
      fd.append("file", file);

      var type = $scope.profile === '' ? 'import_data' : 'import_with_profile?profile='+$scope.profile;

      $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/' + type, fd, {
          headers: {'Content-Type': undefined },
          transformRequest: angular.identity
      }).success(function(response) {
        $scope.inProgress = false;
        $rootScope.alert('Import is finished');
      }).error(function(response) {
        $scope.inProgress = false;
        $rootScope.alert('Import was failed, please contact with our support team.');
        console.warn('error', response);
      });
    });
  }
}

angular
  .module('buuqit')
  .controller('HotelsCtrl', HotelsCtrl);

HotelsCtrl.$inject = ["$rootScope", "$scope", "$mdDialog", "$http"];

function HotelsCtrl ($rootScope, $scope, $mdDialog, $http) {
  angular.extend(
    $scope,
    {
      user: null,
      hotels: [],

      changeHotel: $rootScope.changeHotel,
      inviteUser: inviteUser,
      showUsers: showUsers,
      createNewHotel: createNewHotel,
      removeUserFromHotel: removeUserFromHotel,
      editUser: editUser
    }
  );

  if ($rootScope.user) {
    init();
    $scope.user = $rootScope.user;
  }

  var userWatcher = $rootScope.$watch('user', function () {
    if (typeof($rootScope.user) !== 'undefined' && $scope.user === null) {
      init();
    }
  });


  function init () {
    $scope.user = $rootScope.user;
    $scope.hotels = $rootScope.user.hotels;
    $rootScope.loadedCallback();
  }


  function inviteUser (hotel) {
    $mdDialog
      .show({
        controller: InviteUserModalCtrl,
        templateUrl: getTemplatePath('inviteUserModal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          hotel: hotel
        }
      });
  }


  function showUsers (hotel) {
    hotel.displayUsers = !hotel.displayUsers;

    if (hotel.displayUsers) {
      $http
        .get(SERVER_PATH + "/api/v1/hotels/" + hotel.id + "/get_users")
        .then(function(response) {
          hotel.users = response.data.users;
        }, function(error) {
          $rootScope.alert('Something went wrong, try again later.');
        })
    }
  }


  function createNewHotel () {
    $mdDialog
      .show({
        controller: CreateNewHotelModalCtrl,
        templateUrl: getTemplatePath('createNewHotelModal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true
      });
  }


  function removeUserFromHotel (hotel, user) {
    var confirm = $mdDialog.confirm()
      .title('Remove User')
      .htmlContent('Are you sure?')
      .ok('Ok')
      .cancel('Cancel');
    $mdDialog.show(confirm).then(function () {
      $http
        .post(
          SERVER_PATH + "/api/v1/hotels/" + hotel.id + "/remove_user",
          {
            user_id: user.id
          }
        )
        .then(function (response) {
          hotel.users = _.without(hotel.users, user);
          $rootScope.notify('User was removed');
        }, function (response) {
          $rootScope.alert(response.data.error, "Error");
        })
    }, function () {
    });
  }


  function editUser (hotel, user) {
    $mdDialog
      .show({
        controller: EditUserModalCtrl,
        templateUrl: getTemplatePath('editUserModal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          hotel: hotel,
          user: user
        }
      });
  }

  $scope.$on('$destroy', function () {
    if (userWatcher) {
      userWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('ForgotCtrl', ForgotCtrl);

ForgotCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$i18next",
  "$cookies",
  "$http",
  "$sanitize"
];

function ForgotCtrl ($rootScope, $scope, $i18next, $cookies, $http, $sanitize) {
  angular.extend($scope, {
    is_white_label: (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) == -1),
    year : new Date().getFullYear(),
    error : null,
    loading: false,
    success: false,
    credentials: {
      email: null
    },

    send_request : function () {
      $scope.loading = true;
      $http.post(SERVER_PATH + '/api/v1/users/forgot_password', {
        email: $scope.credentials.email
      }).then(function(response) {
        $scope.loading = false;
        $scope.success = true;
        $scope.success_text = $sanitize($i18next.t('login.success_container.click_email_link_html', {'email': $scope.credentials.email}));

      }, function(error) {
        $scope.loading = false;
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      });
    },

    init : function () {
      $rootScope.loading = false;
      $rootScope.loadedCallback();
      angular.element('body').addClass('login-body');
      angular.element('.navbar').addClass('hidden');
    }
  });

  $scope.init();
}

angular
  .module('buuqit')
  .controller('DeniedCtrl', DeniedCtrl);

DeniedCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$cookies"
];

function DeniedCtrl ($rootScope, $scope, $cookies) {
}

angular
  .module('buuqit')
  .controller('DashboardCtrl', DashboardCtrl);

DashboardCtrl.$inject = ["$rootScope", "$scope", "$i18next", "DeviceDetector"];

function DashboardCtrl ($rootScope, $scope, $i18next, DeviceDetector) {
  $scope.signedIn = $rootScope.signedIn;
  $scope.is_mobile = DeviceDetector === 'mobile';
  $rootScope.loading = false;
  $scope.i18next = $i18next;
  $scope.threeColumnDashboardEnabled = false;
  $rootScope.trackEvent('Dashboard page openned');
  $scope.init = function () {
    if ($scope.is_mobile) {
      var mvp = document.getElementById('metaViewPort');
      if (mvp) {
        mvp.setAttribute('content','width=device-width, initial-scale=1');
      } else {
        console.warn('Meta viewport tag not found');
      }
    }
  }

  $scope.init();

  var userSignedListener = $rootScope.$on('user_signed', function() {
    $scope.signedIn = $rootScope.signedIn;
  });
  var hotelLoadedListener = $rootScope.$on('hotel:loaded', function() {
    $scope.threeColumnDashboardEnabled = $rootScope.hotel.threeColumnDashboardEnabled;
  });
  var hotelWatcher = $rootScope.$watch('hotel', function (hotel) {
    if (hotel && hotel.threeColumnDashboardEnabled !== $scope.threeColumnDashboardEnabled) {
      $scope.threeColumnDashboardEnabled = hotel.threeColumnDashboardEnabled;
    }
  });

  $scope.$on('$destroy', function () {
    if (userSignedListener) {
      userSignedListener();
    }
    if (hotelLoadedListener) {
      hotelLoadedListener();
    }
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular.module("buuqit").controller("CustomersCtrl", CustomersCtrl);

CustomersCtrl.$inject = [
  "$rootScope",
  "$scope",
  "$http",
  "$mdDialog",
  "FolioBatchService",
  "UIDialogService",
  "CustomerFactory",
  "StatementFactory",
  "$i18next"
];

function CustomersCtrl(
  $rootScope,
  $scope,
  $http,
  $mdDialog,
  FolioBatchService,
  UIDialogService,
  CustomerFactory,
  StatementFactory,
  $i18next
) {
  $rootScope.loading = false;
  var initialized = false;

  var initialize = function() {
    if (window.TBFLibs && window.TBFLibs.TBFCustomersPage) {
      window.TBFLibs.TBFCustomersPage(
        $http.defaults.headers.common["AUTHORIZATION"],
        $rootScope,
        SERVER_PATH + "/api/v1/",
        "root",
        $rootScope.searchQuery,
        {
          onInvoiceStatement: onInvoiceStatement,
          onCreatePayment: onCreatePayment,
          onCreateInvoice: onCreateInvoice,
          onCreateReceipt: onCreateReceipt,
          downloadStatement: downloadStatement,
          onCreateStatementPayment: onCreateStatementPayment,
          onEditCustomer: onEditCustomer,
          onToggleDisableReactionEmails: onToggleDisableReactionEmails,
          onExportToXLS: onExportToXLS
        }
      );

      $rootScope.searchQuery = "";
    }
  };

  var executeCallback = function(callback) {
    return function() {
      if (callback && typeof callback === "function") {
        callback();
      }
    };
  };

  var serverErrorMessage = function() {
    $rootScope.alert("Server error");
  };

  var onInvoiceStatement = function(ids, callback, cancelCallback) {
    var confirm = $mdDialog
      .confirm()
      .title("Create Statement for selected Folios")
      .htmlContent("Are you sure?")
      .ok("Ok")
      .cancel("Cancel");

    $mdDialog.show(confirm).then(function() {
      FolioBatchService.createStatement(ids).then(function(res) {
        executeCallback(callback)();
      }, serverErrorMessage);
    }, executeCallback(cancelCallback));
  };

  var onCreatePayment = function(ids, callback, cancelCallback) {
    UIDialogService.open("payment-note", {
      title: "Payment note",
      placeholder: "Note",
      value: "",
      callback: function(notes) {
        FolioBatchService.createPayment(ids, notes).then(
          executeCallback(callback),
          serverErrorMessage
        );
        UIDialogService.close("payment-note");
      },
      cancelCallback: executeCallback(callback),
    });
  };

  var onCreateInvoice = function(ids, callback, cancelCallback) {
    var confirm = $mdDialog
      .confirm()
      .title("Convert to invoice")
      .htmlContent("Are you sure?")
      .ok("Ok")
      .cancel("Cancel");

    $mdDialog.show(confirm).then(function() {
      FolioBatchService.convertToInvoice(ids).then(
        executeCallback(callback),
        serverErrorMessage
      );
    }, executeCallback(cancelCallback));
  };

  var onCreateReceipt = function(ids, callback, cancelCallback) {
    var confirm = $mdDialog
      .confirm()
      .title("Convert to receipt")
      .htmlContent("Are you sure?")
      .ok("Ok")
      .cancel("Cancel");

    $mdDialog.show(confirm).then(function() {
      FolioBatchService.convertToReceipt(ids).then(
        executeCallback(callback),
        serverErrorMessage
      );
    }, executeCallback(cancelCallback));
  };

  var downloadStatement = function (statementId) {
    return new StatementFactory({
      hotelId: $rootScope.hotel.id,
      statementId: statementId,
    })
      .generate_statement_pdf()
      .then(function (res) {
        return res;
      });
  };

  var onCreateStatementPayment = function(
    statement_ids,
    callback,
    cancelCallback
  ) {
    UIDialogService.open("payment-note", {
      title: "Payment note",
      placeholder: "Note",
      value: "",
      callback: function(notes) {
        FolioBatchService.createStatementPayment(statement_ids, notes).then(
          function (res) {
            executeCallback(callback)();
            $rootScope.notify("Payments created successful");
          },
          serverErrorMessage
        );
        UIDialogService.close("payment-note");
      },
      cancelCallback: executeCallback(cancelCallback)
    });
  };

  var onEditCustomer = function(customerId, callback) {
    function openCustomerModal(customer) {
      $mdDialog
        .show({
          controller: CustomerModalCtrl,
          templateUrl: getTemplatePath("customerModal.html"),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            customer: customer,
            closeCustomerEditForm: executeCallback(callback),
            onNewCustomerCallback: function() {
              $rootScope.notify(
                $i18next.t("customer.customers_list.customer_created")
              );
            },
            local: {
              parent: this,
            },
          },
        })
        .then(
          function(answer) {},
          function() {}
        );
    }

    if (customerId == null || customerId == undefined) {
      var customer = new CustomerFactory({
        hotelId: $rootScope.hotel.id,
        id: undefined,
        type: 0,
      });
      openCustomerModal(customer);
    } else {
      new CustomerFactory({
        hotelId: $rootScope.hotel.id,
        id: customerId,
      })
        .get()
        .then(openCustomerModal);
    }
  };

  var onToggleDisableReactionEmails = function(customer) {
    return new CustomerFactory({
      hotelId: $rootScope.hotel.id,
      id: customer.id,
    })
      .get()
      .then(function(customer) {
        customer.disableReactionEmails = !customer.disableReactionEmails;
        return customer.save().then(function(response) {
          if (response.id) {
            $rootScope.notify(
              $i18next.t(
                "profile_nav.settings.booking_engine.email_setup.notify.changes_was_successfully_saved_js_str"
              )
            );
          } else {
            $rootScope.notify(
              $i18next.t("general.alert_modals.something_went_wrong_js_str")
            );
          }
          return response;
        });
      });
  };

  var onExportToXLS = function (query) {
    var userEmail = $rootScope.user.email;
    UIDialogService.open("customers-export-xls", {
      title: $i18next.t('customer.customers_list.export_customers'),
      placeholder: $i18next.t('customer.customers_list.deliver_to'),
      value: userEmail,
      loading: false,
      callback: function() {
        $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/customers/export?email=' + userEmail + '&query=' + query).then(function() {
          UIDialogService.close("customers-export-xls");
          $rootScope.notify($i18next.t('bookings.email.notify.email_has_been_sent_js_str'));
        }, function(error) {
          UIDialogService.close("customers-export-xls");
          console.error(error);
          $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
        });
      },
    });
  };

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && initialized == false) {
      initialize();
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('ConfirmedCtrl', ConfirmedCtrl);

ConfirmedCtrl.$inject = ["$scope", "$i18next", "$sanitize", "$rootScope"];

function ConfirmedCtrl ($scope, $i18next, $sanitize, $rootScope) {
  angular.extend($scope, {
    go_to_link: $sanitize($i18next.t('login.confirmation.go_to_text', {'link': '#/login'})),
    is_white_label: (['app.thebookingfactory.com', 'localhost'].indexOf(location.hostname) == -1),
  });

  $rootScope.loadedCallback();
  angular.element('body').addClass('login-body');
  angular.element('.navbar').addClass('hidden');
}

angular
  .module('buuqit')
  .controller('ChartCtrl', ChartCtrl);

ChartCtrl.$inject = ["$rootScope"];

function ChartCtrl ($rootScope) {
  $rootScope.loading = false;
}
angular
  .module('buuqit')
  .controller('CalendarCtrl', CalendarCtrl);

CalendarCtrl.$inject = [
  "$scope",
  "$i18next",
  "$rootScope",
  "$timeout",
  "$interval",
  "$filter",
  "$mdDialog",
  "$http",
  "$sanitize",
  "BookingStorage",
  "BlockerStorage",
  "Dates",
  "DateNotesStorage",
  "WaitlistStorage",
  "AvailabilityChecker",
  "CalendarStorage",
  "UIDialogService",
  "RoomBuilderService",
  "RestrictionsService",
  "RoomRatesStorage",
];

function CalendarCtrl ($scope, $i18next, $rootScope, $timeout, $interval, $filter, $mdDialog, $http, $sanitize, BookingStorage, BlockerStorage, Dates, DateNotesStorage, WaitlistStorage, AvailabilityChecker, CalendarStorage, UIDialogService, RoomBuilderService, RestrictionsService, RoomRatesStorage) {
  $rootScope.trackEvent('booking page openned');

  var booking_loading      = false,
      blocker_loading      = false,
      notes_loading        = false,
      rate_by_date_loading = false,
      loading              = false;
      updateShortBookingsDebounced = null;
      isCalendarLoaded = false;
      backDays = 0;
      forwardDays = 0;

  $scope.max_menu_height = 200;

  $scope.clean_statuses = [
    { name: 'Inspected', value: 'inspected' },
    { name: 'Clean', value: 'clean' },
    { name: 'Dirty', value: 'dirty' },
    { name: 'Broken', value: 'broken' },
  ]

  $scope.zoomLevels = [
    { width: 40,  height: 26 },
    { width: 50,  height: 31 },
    { width: 60,  height: 36 },
    { width: 70,  height: 41 },
    { width: 80,  height: 46 },
    { width: 90,  height: 51 },
    { width: 100, height: 56 },
    { width: 110, height: 61 },
    { width: 120, height: 66 },
    { width: 130, height: 71 },
    { width: 140, height: 76 },
    { width: 150, height: 80 }
  ];

  $scope.zoomLevel = parseInt(localStorage.getItem('zoom_level') || 12);
  localStorage.setItem('zoom_level', $scope.zoomLevel);


  var getDateNotes = function (dateFrom, dateTo) {
    notes_loading = true;
    $scope.DateNotesStorage = DateNotesStorage;
    DateNotesStorage.load(
      dateFrom,
      dateTo,
      function () {
        notes_loading = false;
        $scope.updateDateNotes();
      }
    );
  };

  var getWaitlist = function (dateFrom, dateTo) {
    $scope.WaitlistStorage = WaitlistStorage;
    WaitlistStorage.load(
      dateFrom,
      dateTo
    );
  };


  var getBlockers = function (dateFrom, dateTo) {
    blocker_loading = true;
    BlockerStorage.load(
      dateFrom,
      dateTo,
      function () {
        blocker_loading = false;
      }
    );
  };

  var _moveBookingToRoom = function (room, roomId) {
    var old_status = room.status,
      old_room_id = room.roomId,
      status = room.status;

    room
      .setRoom(roomId)
      .then(function(response) {
        var hasError = (response && response.data && response.data.error == true) ||
                       (response && response.status === 400 && response.data && response.data.errors);

        if (hasError) {
          room.roomId = old_room_id;
          room.status = old_status;
          $rootScope.$broadcast('BookingStorage:update', room.id, room.bookingId);
          $rootScope.$broadcast('bookings:update');
          $rootScope.$broadcast('BookingStorage:update_booking', room.bookingId);

          var errorMessage = response.data.errors || response.data.message || $i18next.t('general.alert_modals.something_went_wrong_js_str');
          $rootScope.notify(errorMessage);
        } else {
          if (status == 'hold') {
            $rootScope.$broadcast('scheduler:updateHolded');
          }

          $rootScope.$broadcast('scheduler:areaSizeChanged');
        }
      });
  };

  var fetchCalendarUpdates = $interval(function () {
    if ($rootScope.hotel && $rootScope.hotel.id) {
      CalendarStorage.fetchUpdates();
    }
  }, 60000);


  var fetchBookingsShortRepresentations = function(dateFrom, dateTo, fetchWithPromise) {
    return CalendarStorage.fetchShortRepresentations(dateFrom, dateTo, fetchWithPromise)
      .catch(function(error) {
        console.error('Failed to load short bookings calendar data:', error);
      });
  }

  var getShortBookings = function (dateFrom, dateTo, fetchWithPromise) {
    clearTimeout(updateShortBookingsDebounced);
    updateShortBookingsDebounced = setTimeout(function () {
      fetchBookingsShortRepresentations(dateFrom, dateTo, fetchWithPromise);
   }, 400);
  };

  var fetchWaitlistUpdates = $interval(function () {
    if ($rootScope.hotel && $rootScope.hotel.id) {
      WaitlistStorage.update();
    }
  }, 60000 * 5);

  var fetchDateNotesUpdates = $interval(function () {
    if ($rootScope.hotel && $rootScope.hotel.id) {
      DateNotesStorage.update();
    }
  }, 60000 * 5);

  var setLoadingDays = function (dateFrom, dateTo) {
    if (!isCalendarLoaded || $rootScope.current_date_to < dateTo) {
      backDays = 10;
      forwardDays = 80;
      return;
    }
    if (dateFrom < $rootScope.current_date_from) {
      backDays = 80;
      forwardDays = 10;
      return;
    }
  }

  var init = function () {
    if ($rootScope.hotel && $rootScope.hotel.rooms && document.querySelector('#calendar') && TBFCalendar) {
      $scope.tbfCalendar = new TBFCalendar(document.querySelector('#calendar'), {
        zoom_level: $scope.zoomLevel,
        rooms: $rootScope.hotel.rooms.filter(function(room) {return room.isActive}),
        room_types: $rootScope.hotel.roomTypes,
        seasons: $rootScope.hotel.seasons,
        showCanceledArea: !$rootScope.hotel.calendarSetting.hideCancellationArea,
        showWaitlist: $rootScope.hotel.calendarSetting.showWaitlist,
        waitlistStore: WaitlistStorage,
        storage: CalendarStorage,
        i18n: $i18next.i18n,
        role: $rootScope.user.role,
        style_settings: $filter('fillDefaultToCalendarSettings')(angular.copy($rootScope.hotel.calendarSetting)),
        isHKenabled: $rootScope.hotel.housekeepingEnabled,
        fractionSize: $rootScope.currencyFractionSize,
        events: {
          booking_click: function(event, booking_id) { $scope.openBookingManagementModal(booking_id); },
          booking_right_click: function(event, booking_id, booking_room_id) {
            $scope.bookingContextMenuOptions = {};
            $scope.booking_for_manage = null;
            $scope.room_for_manage    = null;

            if (!BookingStorage.get(booking_id) || !BookingStorage.get(booking_id).hasDetails) {
              return BookingStorage.load_by_id(booking_id, false, function() {
                $scope.openContextMenu(event, booking_id, booking_room_id);
              });
            }
            return $scope.openContextMenu(event, booking_id, booking_room_id);
          },
          booking_mouseenter: $scope.showPopover,
          booking_mouseleave: $scope.hidePopover,
          blocker_click: function(event, blocker_id) { $scope.openBlockerManagementModal(event, blocker_id); },
          blocker_right_click: function(event, blocker_id) { $scope.openContextMenu(event, blocker_id); },
          calendar_right_click: function(event, room_id, date) { $scope.openContextMenu(event, room_id, date); },
          change_room_clean_status: function(event, room_id) { $scope.openContextMenu(event, room_id) },
          add_to_waitlist: $scope.addToWaitlist,
          on_waitlist_click: $scope.editWaitlist,
          create_booking: function(event, room, date_from, date_to) {
            if (!room || typeof(room.id) !== 'number') {
              return;
            }

            var date_in = moment(date_from.localeString)._d;
            var date_out = date_to ? moment(date_to.localeString)._d : moment(date_from.localeString).add(1, 'day')._d

            $scope.openNewBookingModal({
              room_id: room.id,
              date_in: date_in,
              date_out: date_out
            });
          },
          room_note_edit: $scope.addRoomNote,
          date_note_edit: $scope.addNote,
          show_popover: $scope.showPopover,
          hide_popover: $scope.hidePopover,
          click_popover: $scope.clickPopover,
          fetchRequiredInformation: function (dateFrom, dateTo, requiredBookingIDS, callback) {
            setLoadingDays(dateFrom, dateTo);
            isCalendarLoaded = true;
            $rootScope.current_date_from = dateFrom;
            $rootScope.current_date_to = dateTo;
            dateFrom = moment(dateFrom).subtract(backDays, 'days').format('YYYY-MM-DD');
            dateTo = moment(dateTo).add(forwardDays, 'days').format('YYYY-MM-DD');

            getShortBookings(dateFrom, dateTo, true);

            Dates.currentStartDate = dateFrom;
            Dates.currentEndDate = dateTo;
            if (typeof(callback) === 'function') {
              var interval = $interval(function() {
                if (!booking_loading && !blocker_loading && !notes_loading) {
                  $interval.cancel(interval);
                  callback();
                }
              }, 100);
            }
          }
        }
      });

      if (Object.keys(CalendarStorage.storage.blockers).length > 0 || CalendarStorage.storage.shortBookingRooms.length > 0) {
        $scope.tbfCalendar.update();
      }

      if ($rootScope.bookingForHighlight) {
        BookingStorage.load_by_id($rootScope.bookingForHighlight, false, function(booking) {
          var date = Math.min.apply(Math, booking.rooms.map(function(br) {return br.checkinDate}));
          $scope.tbfCalendar.scrollToDate(moment(date).format('YYYY-MM-DD'));
        });
      }

      $scope.getDateNotes(
        moment($scope.currentDate).subtract(100, 'day').toDate(),
        moment($scope.currentDate).add(365*2, 'day').toDate()
      )
      $scope.getWaitlist(
        moment($scope.currentDate).subtract(100, 'day').toDate(),
        moment($scope.currentDate).add(365*2, 'day').toDate()
      )

      $scope.minDate = moment().subtract(3, 'years').add(1, 'day').toDate();
      $scope.maxDate = moment().add(3, 'years').subtract(1, 'day').toDate();

      scheduleNextDailyUpdate();
    } else {
      $timeout(init, 100);
    }
  };


  $scope.goToToday = function () {
    if ($scope.tbfCalendar && $scope.tbfCalendar.scrollToDate) {
      $scope.tbfCalendar.scrollToDate(moment().format('YYYY-MM-DD'));
    }
  };


  $scope.getBlockers = getBlockers;
  $scope.getDateNotes = getDateNotes;
  $scope.getWaitlist = getWaitlist;

  $scope.datePickerOpened = false;


  $scope.openContextMenu = function ($event, arg_1, arg_2) {
    var out = '',
        isBooking = $event.path.map(function(el) {return el.classList && el.classList.contains('booking')}).reduce(function(a, b) {return a || b}, false) || false,
        isBlocker = $event.path.map(function(el) {return el.classList && el.classList.contains('blocker')}).reduce(function(a, b) {return a || b}, false) || false;
        isCleanStatus = $event.path.map(function(el) {return el.classList && el.classList.contains('room-clean-status')}).reduce(function(a, b) {return a || b}, false) || false;

    if ($rootScope.hasAccess('viewBookingInfo') || isCleanStatus) {
      $scope.max_menu_height = angular.element(window).height() - $event.clientY - 10;

      switch (Number(isBooking) + '' + Number(isBlocker) + '' + Number(isCleanStatus)) {
        case '000':
          var room = $rootScope.hotel.rooms.filter(function(room) {return room.id == Number(arg_1);})[0];
          out = 'room-slot';
          date_in = new Date(arg_2);
          date_in = new Date(date_in.getTime() + date_in.getTimezoneOffset() * 60000);
          date_out = moment(date_in).add(1, 'day').toDate();
          $scope.new_blocker = {
            room : room,
            day  : date_in
          };
          $scope.context_room_id = room ? room.id : null;
          $scope.context_date_in = date_in;
          $scope.context_date_out = date_out;
          out = room ? 'room-slot' : null;
          break;
        case '100':
          out = 'booking';
          $scope.prepareBookingContextMenu(Number(arg_1), Number(arg_2));
          break;
        case '010':
          out = 'blocker';
          $scope.blocker_for_manage = Number(arg_1);
          break;
        case '001':
          out = 'clean-status';
          $scope.selectedRoom = $rootScope.hotel.rooms.filter(function(el) {return el.id == arg_1})[0];
          break;
      }
      $scope.contextMenuTarget = out;
      if(!$scope.bookingContextMenuOptions)
        $scope.bookingContextMenuOptions = {hasDetails: true};

      if (isMobile && isMobile.any) {
        $('#ContextMenu').addClass('open');
        $('#ContextMenu').css('top', $event.pageY);
        $('#ContextMenu').css('left', $event.pageX);
        $timeout(function() {}, 0);
      }
    } else {
      $scope.contextMenuTarget = null;
    }
  };


  $scope.prepareBookingContextMenu = function (booking_id, room_id) {
    var booking = BookingStorage.get(booking_id);
    var room = booking ? booking.rooms.filter(function(room) {return room.id == room_id})[0] : null;
    var checkin = room ? room.checkinDate : null;

    if (room && checkin) {
      $scope.booking_for_manage = angular.copy(booking.id);
      $scope.room_for_manage    = angular.copy(room.id);

      if (typeof(checkin) == 'object' || checkin.length > 10) {
        checkin = moment(checkin).format('YYYY-MM-DD');
      }

      $scope.bookingContextMenuOptions = {
        'checkin'         : moment(moment().format('YYYY-MM-DD')).toDate() >= moment(checkin).toDate() && room.status == 'pending' && room.occupationStatus == 'pending',
        'cancel_checkin'  : room.occupationStatus == 'checked_in',
        'checkout'        : room.occupationStatus == 'checked_in',
        'cancel_checkout' : room.occupationStatus == 'checked_out',
        'hold'            : room.status === 'pending' && room.occupationStatus === 'pending' && room.dontMove !== true,
        'holdAll'         : room.status === 'pending' && room.occupationStatus === 'pending' && room.dontMove !== true && booking.rooms.length>1,
        'move'            : room.status != 'canceled',
        'manage'          : true,
        'cantmove'        : room.dontMove,
        'hasDetails'      : booking.hasDetails,
      };

      if (room.dontMove) {
        $scope.availableRoomsByType = [];
        $scope.otherAvailableTypes = [];
      } else {
        $scope.calculateAvailableRooms(room);
      }
    } else {
      BookingStorage.load_by_id(booking_id, false, function() {
        $scope.prepareBookingContextMenu(booking_id, room_id);
      }).catch(function () {
        console.warn($i18next.t('bookings.calendar.console.warn'));
      });
    }
  };

  $scope.calculateAvailableRooms = function (booking_room) {
    var checkin_date = moment(booking_room.checkinDate).startOf('day').toDate();
    var rooms        = $rootScope.hotel.rooms,
        type         = $filter('filter')(rooms, function (room) {
          return room.id == booking_room.roomId;
        })[0].roomTypeId,
        availability = AvailabilityChecker.checkAvailability(
          booking_room.roomId,
          checkin_date,
          booking_room.numberOfNights,
          booking_room.id
        ),
        closed       = availability.closed,
        roomsByType  = $filter('filter')(rooms, function (room) {
          if (booking_room.status == 'hold') {
            return room.roomTypeId == type && closed.indexOf(room.id) == -1 && room.isActive === true;
          } else {
            return room.roomTypeId == type && closed.indexOf(room.id) == -1 && room.id != booking_room.roomId  && room.isActive === true;
          }
        });
        otherAvailableTypes = $filter('filter')(rooms, function (room) {
          if (booking_room.status == 'hold') {
            return room.roomTypeId != type && closed.indexOf(room.id) == -1 && room.isActive === true;
          } else {
            return room.roomTypeId != type && closed.indexOf(room.id) == -1 && room.id != booking_room.roomId && room.isActive === true;
          }
        });
    $scope.otherAvailableTypes = otherAvailableTypes;
    $scope.availableRoomsByType = roomsByType;
  };


  $scope.changeCleanStatus = function (cleanStatus) {
    var room = $scope.selectedRoom,
        oldStatus = room.cleanStatus
    angular.element('.popover').remove();

    if (cleanStatus === 'broken') {
      $mdDialog
        .show({
          controller: CreateRoomHKNoteCtrl,
          templateUrl: getTemplatePath('createRoomHKNoteModal.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            room : room,
            local : {
              parent : $scope,
              room : room
            }
          }
        })
        .then(function(answer) {
          if (answer === 'cancel') {
            $scope.tbfCalendar.updateRoomCleanStatus(room.id, oldStatus);
          } else {
            $scope.tbfCalendar.updateRoomCleanStatus(room.id, cleanStatus, room.hoousekeeper_note);
            $scope.selectedRoom.change_clean_status(cleanStatus, room.hoousekeeper_note).then(function(res) {},
              function(error) {
                console.error(error, 'Error while updating room clean status');
                $scope.tbfCalendar.updateRoomCleanStatus(room.id, oldStatus);
                $rootScope.alert($i18next.t('bookings.calendar.alert.update_clean_status_error'));
            })
          }
      })
    } else {
      room.cleanStatus = cleanStatus
      $scope.tbfCalendar.updateRoomCleanStatus(room.id, cleanStatus);
      $scope.selectedRoom.change_clean_status(cleanStatus, '').then(function(res) {
      }, function (error) {
        console.error(error, 'Error while updating room clean status');
        $scope.tbfCalendar.updateRoomCleanStatus(room.id, oldStatus);
        $rootScope.alert($i18next.t('bookings.calendar.alert.update_clean_status_error'));
      })
    }
  }

  $scope.changeDoNotDisturbStatus = function(status) {
    $scope.tbfCalendar.updateDnDStaus($scope.selectedRoom.id, status);

    $scope.selectedRoom.change_dnd_status(status).then(function(res){
    }, function(err) {
      $scope.tbfCalendar.updateDnDStaus($scope.selectedRoom.id, !status);
      $rootScope.alert($i18next.t('bookings.calendar.alert.change_dnd_status'));
    })
  }


  $scope.addToWaitlist = function ($event, checkin, checkout) {
    $mdDialog
      .show({
        controller: AddToWaitlistModalCtrl,
        templateUrl: getTemplatePath('addToWaitlistModal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          waitlist: {
            checkinDate: new Date(checkin.ISODate),
            checkoutDate: new Date(checkout.ISODate),
            number_of_rooms: 0,
            amount: '',
            subject: '',
            notes: '',
          }
        }
      })
  };

  $scope.editWaitlist = function($event, waitlist) {
    $mdDialog
      .show({
        controller: AddToWaitlistModalCtrl,
        templateUrl: getTemplatePath('addToWaitlistModal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          waitlist: waitlist
        }
      })
  }

  $scope.addNote = function ($event, dateString) {
    if (!loading) {
      $scope.hidePopover();
      $mdDialog
        .show({
          controller: CreateDateNoteModalCtrl,
          templateUrl: getTemplatePath('createDateNoteModal.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            note : (function() {
              var note = DateNotesStorage.getNote(dateString);

              if (note === null) {
                note = {
                  id   : null,
                  note : null,
                  date : dateString
                };
              }

              return note;
            })(),
            local : {
              parent : $scope,
              dateString : dateString
            }
          }
        })
        .then(function(answer) {}, function() {});
    } else {
      $rootScope.alert($i18next.t('bookings.calendar.alert.please_wait_while_we_load_all_information_js_str'));
    }
  };


  $scope.addRoomNote = function ($event, roomId) {
    var room = $rootScope.hotel.rooms.filter(function(el) {return el.id == roomId})[0];
    if (!loading) {
      angular.element('.popover').remove();

      $mdDialog
        .show({
          controller: CreateRoomNoteModalCtrl,
          templateUrl: getTemplatePath('createRoomNoteModal.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            room : room,
            local : {
              parent : $scope,
              room : room
            }
          }
        })
        .then(function(answer) {
          $scope.tbfCalendar.updateRoomNote(roomId, room.note);
        }, function() {
          $scope.tbfCalendar.updateRoomNote(roomId, room.note);
        });
    } else {
      $rootScope.alert($i18next.t('bookings.calendar.alert.please_wait_while_we_load_all_information_js_str'));
    }
  };


  $scope.updateDateNotes = function() {
    if ($scope.DateNotesStorage) {
      $scope.tbfCalendar.updateDateNotes(
        $scope.DateNotesStorage
          .notes
          .sort(function(a, b) {
            var dateA, dateB
            if (a.updatedAt && b.updatedAt) {
              dateA = new Date(a.updatedAt);
              dateB = new Date(b.updatedAt);
            } else {
              dateA = 1;
              dateB = 1;
            }

            if (dateA < dateB) { return -1; }
            if (dateA > dateB) { return 1; }
            return 0;
          })
          .map(function (note) {
            return {
              date: note.date,
              note: note.note,
              is_removed: note.status !== 'active'
            }
          }));
    }
  };

  var newBookingModalTimeout;
  var clearNewBookingModalTimeout = function () {
    if (newBookingModalTimeout) {
      $timeout.cancel(newBookingModalTimeout);
      newBookingModalTimeout = null;
    }
  };

  $scope.openNewBookingModal = function (booking) {
    clearNewBookingModalTimeout();
    if (!$rootScope.hasAccess('bookingCreate')) {
      return;
    }

    var bookingLoadingSpinner = document.getElementsByClassName('booking__loading')[0];
    if ($rootScope.hotel && !$rootScope.hotel.showRoomRate && !$rootScope.hotel.roomRates && RoomRatesStorage.loading) {
      if (bookingLoadingSpinner) {
        bookingLoadingSpinner.classList.add('visible');
      }
      newBookingModalTimeout = $timeout(function () {
        $scope.openNewBookingModal(booking);
      }, 1000);
      return;
    } else {
      if (bookingLoadingSpinner && bookingLoadingSpinner.classList.contains('visible')) {
          bookingLoadingSpinner.classList.remove('visible');
      }
    }

    var rooms, roomRepresentations, roomRates;

    rooms = $rootScope.hotel.rooms.filter(function(room) {
      return room.id == booking.room_id;
    });

    if (rooms.length > 0) {
      roomRepresentations = $rootScope.hotel.roomRepresentations.filter(function(rr) {
        return rr.roomTypeId == rooms[0].roomTypeId;
      }).map(function(rr) {
        return rr.id;
      });
    }

    if (roomRepresentations.length > 0) {
      roomRates = $rootScope.hotel.roomRates.filter(function(roomRate) {
        return roomRepresentations.indexOf(roomRate.roomRepresentationId) !== -1 && roomRate.isRemoved === false;
      });
    }

    if (!roomRates || roomRates.length === 0) {
      return $rootScope.alert($i18next.t('general.errors.room_not_have_any_rate'));
    }

    var bookingModalTemplate;
    var BookingModalController;
    var buildOptionsPromise;

    if ($rootScope.hotel.groupBookingFeatureEnabled) {
      bookingModalTemplate = 'modals/groupedCreateBooking.html';
      BookingModalController = CreateGroupBookingModalCtrl;

      // Restriction service is a singleton service for storing restrictions by room rates and dates. Restrictions for
      // dates are lazy-loaded based on checkin/checkout dates controls in rooms forms and common checkin/checkout dates on
      // group booking form controls. Loaded restrictions are injected in each room service and stores common information by restrictions.
      // When some room loads additional restrictions for dates this information becomes available to other room by using same instance
      // of restrictionsService.
      var restrictionsService = RestrictionsService.build();
      var roomBuilderService = RoomBuilderService.build(restrictionsService);

      buildOptionsPromise = roomBuilderService.buildInitialRoom(booking.room_id, booking.date_in, booking.date_out).then(function (result) {
        return {
          initialRoom: result.initialRoom,
          roomTemplate: result.roomTemplate,
          roomBuilderService: roomBuilderService,
          restrictionsService: restrictionsService,
        }
      })
    } else {
      bookingModalTemplate = 'modals/createBooking.html';
      BookingModalController = CreateBookingModalCtrl;

      buildOptionsPromise = Promise.resolve(booking);
    }

    buildOptionsPromise.then(function (options) {
      $rootScope.trackEvent('Create booking modal openned');

      $mdDialog.show({
        controller: BookingModalController,
        templateUrl: getTemplatePath(bookingModalTemplate),
        parent: angular.element(document.body),
        locals: {
          options: options
        },
        clickOutsideToClose: false,
        escapeToClose: false
      })
        .then(function(booking) {
          if (booking) {
            CalendarStorage.pushBooking(booking);
          }
        }, function() {});
    });
    clearNewBookingModalTimeout();
  };


  $scope.openRoomBlockerModal = function () {
    $('#ContextMenu').removeClass('open');
    if ($rootScope.hasAccess('blockerCreate')) {
      if (!loading) {
        $mdDialog
          .show({
            controller: RoomBlockerModalCtrl,
            templateUrl: getTemplatePath('roomBlockerModal.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              blocker : $scope.new_blocker,
              local : {
                parent : $scope
              }
            }
          })
          .then(function(answer) {
          }, function() {
          });
      } else {
        $rootScope.alert($i18next.t('bookings.calendar.alert.please_wait_while_we_load_all_information_js_str'));
      }
    }
  };


  $scope.holdRoom = function () {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.hold();
  };

  $scope.holdAllRooms = function () {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage);
    var booking = BookingStorage.get(room.bookingId)
    for(var i=0; i<booking.rooms.length;i++) {
      room = BookingStorage.get_room(booking.rooms[i].id);
      if (room.status != 'canceled') {
        room.hold();
      }
    }
  }

  $scope.openBookingManagementModal = function (booking_id, tab_index) {
    $('#ContextMenu').removeClass('open');
    if ($rootScope.hasAccess('viewBookingInfo')) {
      if (_.isUndefined(booking_id) && !_.isUndefined($scope.booking_for_manage)) { booking_id = $scope.booking_for_manage; }

      if (!_.isUndefined(booking_id)) {
        $rootScope.openBookingManagementModal(booking_id, tab_index, {note_modal: $scope.clickPopover});
      }
    }
  };


  $scope.openBlockerManagementModal = function ($event, blocker_id) {
    $('#ContextMenu').removeClass('open');
    blocker_id = blocker_id || $scope.blocker_for_manage;
    if ($rootScope.hasAccess('viewBlockerInfo')) {
      if (BlockerStorage.get(blocker_id)) {
        $scope.openBlockerManagementModalAction($event, blocker_id);
      } else {
        BlockerStorage.get_by_id(blocker_id, function() {
          $scope.openBlockerManagementModalAction($event, blocker_id);
        });
      }
    }
  };

  $scope.openNewBookingAction = function () {
    $('#ContextMenu').removeClass('open');

    $scope.openNewBookingModal({
      room_id: $scope.context_room_id,
      date_in: $scope.context_date_in,
      date_out: $scope.context_date_out
    });
  };

  $scope.openBlockerManagementModalAction = function($event, blocker_id) {
    $mdDialog
      .show({
        controller: RoomBlockerModalCtrl,
        templateUrl: getTemplatePath('roomBlockerModal.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        targetEvent: $event,
        locals: {
          blocker : blocker_id,
          local : {
            parent : $scope,
            blocker : blocker_id
          }
        }
      });
  }


  $scope.removeBlocker = function () {
    $('#ContextMenu').removeClass('open');
    var confirm = $mdDialog.confirm()
      .title('Confirm')
      .textContent('Are you sure?')
      .ariaLabel('Confirm')
      .ok('Confirm')
      .cancel('Cancel');

    $mdDialog.show(confirm).then(function() {
      var blocker = BlockerStorage.get($scope.blocker_for_manage);
      if (blocker) {
        blocker.destroy();

        BlockerStorage.blockers.splice(BlockerStorage.blockers.indexOf(blocker), 1);
        $rootScope.$broadcast('BlockerStorage:destroy', blocker.id);
      }
    }, function() {});
  };


  $scope.suffix = function (num) {
    if (num > 1) {
      return 's';
    }
  };


  $scope.checkin = function () {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage);
    if ($rootScope.hotel.useCheckinProMode === true) {
      $mdDialog.show({
        controller: CheckinDialogCtrl,
        templateUrl: getTemplatePath('modals/checkinDialog.html'),
        parent: angular.element(document.body),
        locals: {
          room : room,
          checkin: function(openPaymentScreen) {
            room.checkin(function() {
              if (openPaymentScreen) {
                $rootScope.openBookingManagementModal(room.bookingId, 'payment');
              }
            });
          }
        },
        clickOutsideToClose: true
      });
    } else {
      room.checkin();
    }
  };


  $scope.cancel_checkin = function () {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.cancel_checkin();
  };


  $scope.checkout = function () {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage),
        booking = BookingStorage.get(room.bookingId);

    room.checkout();

    if (booking.paymentStatus != 'paid') {
      var confirm = $mdDialog.confirm()
        .title($i18next.t('bookings.calendar.confirm.title'))
        .textContent($i18next.t('bookings.calendar.confirm.text_content'))
        .ariaLabel($i18next.t('bookings.calendar.confirm.title'))
        .ok($i18next.t('general.confirm.ok'))
        .cancel($i18next.t('general.confirm.later_cancel'));

      $mdDialog.show(confirm).then(function() {
        $rootScope.openBookingManagementModal(booking.id, 'payment');
      }, function() {});
    }
  };

  $scope.cancel_checkout = function () {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage);

    room.cancel_checkout();
  };


  $scope.showSubmenu = function ($event) {
    angular.element($event.currentTarget).find('.submenu').addClass('show');
  };


  $scope.hideSubmenu = function ($event) {
    angular.element($event.currentTarget).find('.submenu').removeClass('show');
  };


  $scope.moveBookingToRoom = function (roomId) {
    $('#ContextMenu').removeClass('open');
    var room = BookingStorage.get_room($scope.room_for_manage)

    if (room.roomId === roomId || !room.belongsToInvoiceOrReceipt){
      _moveBookingToRoom(room, roomId);
    }
    else {
      var confirm = $mdDialog.confirm()
          .title($i18next.t('bookings.rooms.edit.belongs_to_receipt.title'))
          .textContent($i18next.t('bookings.rooms.edit.belongs_to_receipt.content'))
          .ok('Confirm')
          .cancel('Cancel');

      $mdDialog.show(confirm).then(function() {
        _moveBookingToRoom(room, roomId);
      }, function() {});
    }
  };

  $scope.getRoomType = function (id) {
    var roomType = $rootScope.hotel.roomTypes.filter(function (room_type) {return room_type.id == id;})[0];
    if (roomType) {
      return roomType.shortName;
    }
  };


  $scope.gotoSelectedDate = function () {
    if ($scope.selectedDate !== undefined && $scope.tbfCalendar) {
      $scope.tbfCalendar.scrollToDate(moment($scope.selectedDate).format('YYYY-MM-DD'));
    }
  };


  $scope.htmlSubstring = function (str, count) {
    var div = document.createElement('div');
    div.innerHTML = str;

    walk( div, track );

    function track( el ) {
      if( count > 0 ) {
        var len = el.data.length;
        count -= len;
        if( count <= 0 ) {
          el.data = el.substringData( 0, el.data.length + count );
        }
      } else {
        el.data = '';
      }
    }

    function walk( el, fn ) {
      var node = el.firstChild;
      do {
        if( node.nodeType === 3 ) {
          fn(node);
        } else if( node.nodeType === 1 && node.childNodes && node.childNodes[0] ) {
          walk( node, fn );
        }
      } while( node = node.nextSibling );
    }
    return div.innerHTML;
  }


  $scope.showPopover = function(event, text, type) {
    if (event && text) {
      var popover = $('#scheduler-popover');

      if (popover.size() == 0) {
        $('.scheduler').append('<div class="popover top" id="scheduler-popover"><div class="arrow"></div><div class="popover-content">Some content</div></div>');
        popover = $('#scheduler-popover');
      }

      if (typeof(text) == 'object') {
        output = '';
        if (text[0]) { output += '<b>Guest Note:</b><br />'+$sanitize(text[0])+'<br />'; }
        if (text[1]) { output += '<b>Hotel Note:</b><br />'+$sanitize(text[1])+'<br />'; }
        if (text[2]) { output += '<b>Housekeeping Note:</b><br />'+$sanitize(text[2]); }
        text = output;
      }
      var popover = $('#scheduler-popover');

      if (text.length > 150) {
        text = $scope.htmlSubstring(text,100) + '...'
      }

      if (type == 'notes') {
        text += '<div class="read-more-at-popover">Click at <i class="fa fa-comment"></i> to edit</div>';
      }

      if (type === 'clean_status') {
        if (event.target.classList.contains('broken')) {
          text = $i18next.t('bookings.calendar.popover.broken_room_warning') +  '<br />' + $i18next.t('bookings.calendar.popover.broken_room_details') + ' ' + text
        } else {
          if (event.target.dataset.dnd) {
            text = $i18next.t('bookings.calendar.popover.do_not_disturb_room_warning') + ' <br /> ' + $i18next.t('bookings.calendar.popover.room_clean_status_popover') + ' ' + $i18next.t('bookings.calendar.clean_statuses.' + text)
          } else {
            text = $i18next.t('bookings.calendar.popover.room_clean_status_popover') + ' ' + $i18next.t('bookings.calendar.clean_statuses.' + text)
          }
        }
      }

      popover
        .css('opacity', '0')
        .css('white-space', 'nowrap')
        .show()
        .find('.popover-content')
        .html(text);

      if (type == 'notes' || type == 'clean_status') {
        popover.removeClass('top').addClass('right');
      } else {
        popover.removeClass('right').addClass('top');
      }

      var width = popover.width(),
          height = popover.height(),
          targetWidth = $(event.target).width(),
          targetHeight = $(event.target).height(),
          left = null,
          top = null;

      if (type == 'notes' || type == 'clean_status') {
        left = $(event.target).offset().left + 20;
        top = ($(event.target).offset().top + (targetHeight / 2) + (height / 2) + 2);
      } else {
        left = ($(event.target).offset().left + (targetWidth / 2) - (width / 2) - 2);
        top = $(event.target).offset().top;
      }

      if (left > document.getElementsByTagName('body')[0].offsetWidth) {
        left = document.getElementsByTagName('body')[0].offsetWidth / 2;
      }
      if (left < 0) {
        left = 0;
      }

      popover.css({
        top: (top - height - 5) + 'px',
        left: left + 'px',
        opacity: 1
      });
    }
  };


  $scope.hidePopover = function () {
    var popover = $('#scheduler-popover');
    popover.hide();
  };


  $scope.clickPopover = function(event, bookingRoomId, bookingId) {
    noteModal(bookingRoomId, bookingId, BookingStorage, UIDialogService);
  };

  $scope.zoomIn = function () {
    if ($scope.zoomLevel + 1 < 13 && $scope.tbfCalendar) {
      $scope.zoomLevel++;
      localStorage.setItem('zoom_level', $scope.zoomLevel);
      $scope.tbfCalendar.changeZoomLevel($scope.zoomLevel - 1);
    }
  }

  $scope.zoomOut = function () {
    var dateFrom = moment($rootScope.current_date_from);
    var dateTo = moment($rootScope.current_date_to);

    var calendarDays = dateTo.diff(dateFrom, 'days');

    if (90 < calendarDays) return;

    if ($scope.zoomLevel - 1 > 0 && $scope.tbfCalendar) {
      $scope.zoomLevel--;
      localStorage.setItem('zoom_level', $scope.zoomLevel);
      $scope.tbfCalendar.changeZoomLevel($scope.zoomLevel - 1);
    }
  }

  $scope.$on('showToday', function () {
    $scope.goToToday();
  });

  function scheduleNextDailyUpdate() {
    if ($rootScope.newDateInterval) {
      $timeout.cancel($rootScope.newDateInterval);
      $rootScope.newDateInterval = null;
    }
    
    var now = new Date();
    var nextFourAM = new Date();
    
    nextFourAM.setHours(4, 0, 0, 0);
    
    // If it's already past 4 AM, schedule for tomorrow
    if (now >= nextFourAM) {
      nextFourAM.setDate(nextFourAM.getDate() + 1);
    }
    
    var msUntilNextUpdate = nextFourAM - now;
    
    $rootScope.newDateTimeout = $timeout(function() {
      var today = moment($filter('date')(moment().toDate(), "yyyy-MM-dd"));
      $scope.currentDate = today.toDate();
      $scope.currentDateString = String(today.toDate());
      $rootScope.currentDate = $scope.currentDate;
      
      $rootScope.$broadcast('scheduler:changeDate');
      
      // Schedule the next update
      scheduleNextDailyUpdate();
    }, msUntilNextUpdate);
  }

  $scope.$on('calendar:redraw', function(event, data) {
    if ($scope.tbfCalendar) {
      $scope.tbfCalendar.update(data);
    }
  });

  $scope.$on('waitlists:redraw', function(event){
    if ($scope.tbfCalendar) {
      $scope.tbfCalendar.updateWaitlists();
    }
  });

  $scope.$on('calendar:remove', function(event, data) {
    if ($scope.tbfCalendar) {
      $scope.tbfCalendar.remove(data);
    }
  });

  $scope.$on('date_notes:update', function() {
    $scope.updateDateNotes();
  });

  $scope.$on('seasons:update', function() {
    $scope.tbfCalendar.updateSeasons($rootScope.hotel.seasons);
  });

  $scope.$on('hk:reload_room', function(event, room) {
    reloadRoom(room);
  });

  $scope.$on('hk:reload_rooms', function(event, rooms) {
    rooms.forEach(function(room) {
      reloadRoom(room);
    });
  });

  var reloadRoom = function (room) {
    $scope.tbfCalendar.updateRoomCleanStatus(room.id, room.clean_status, room.housekeeper_note);
    $scope.tbfCalendar.updateDnDStaus(room.id, room.do_not_disturb);
  };

  $scope.$on('$destroy', function() {
    if ($rootScope.newDateInterval) {
      $timeout.cancel($rootScope.newDateInterval);
      $rootScope.newDateInterval = null;
    }
    if (fetchCalendarUpdates) {
      $interval.cancel(fetchCalendarUpdates);
    }

    if (fetchWaitlistUpdates) {
      $interval.cancel(fetchWaitlistUpdates);
    }

    if (fetchDateNotesUpdates) {
      $interval.cancel(fetchDateNotesUpdates);
    }

    $('#ContextMenu').remove();
    $('#scheduler-popover').remove();
  });

  init();
}

angular.module("buuqit")
  .controller("BookingsAndFoliosCtrl", BookingsAndFoliosCtrl)
  .component(
    'reactBookingsAndFoliosPage',
    window.TBFLibs.react2angular(
      window.TBFLibs.BookingsAndFoliosPage,
      [
        'onLoadBookings',
        'onOpenBookingModal',
        'currencySymbol'
      ],
      ['$i18next']
    )
  );

BookingsAndFoliosCtrl.$inject = [
  "$rootScope",
  "$scope",
  "BookingsService"
];

function BookingsAndFoliosCtrl(
  $rootScope,
  $scope,
  BookingsService
) {
  var ctrl = this;
  var initialized = false;

  onLoadBookings = function (params) {
    return BookingsService.getBookings($rootScope.hotel.id, params)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.error('Error loading bookings:', error);
        throw error;
      });
  };

  onOpenBookingModal = function (bookingId) {
    if ($rootScope.hasAccess('viewBookingInfo') && !_.isUndefined(bookingId)) {
      $rootScope.openBookingManagementModal(bookingId);
    }
  }

  var hotelWatcher = $rootScope.$watch("hotel", function() {
    if ($rootScope.hotel && initialized == false) {
      ctrl.onLoadBookings = onLoadBookings;
      ctrl.onOpenBookingModal = onOpenBookingModal;
      ctrl.currencySymbol = $rootScope.currencySymbol;
      initialized = true;
    }
  });

  $scope.$on("$destroy", function() {
    if (hotelWatcher) {
      hotelWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('AdminNewCtrl', AdminNewCtrl);

AdminNewCtrl.$inject = ["$rootScope", "$scope", "$http"];

function AdminNewCtrl ($rootScope, $scope, $http) {
  $rootScope.loading = false;
  $rootScope.loadedCallback();
  var initialized = false;

  login = function(response) {
    $rootScope.loading = true;
    $rootScope.setUserToken( response.data.session.user.id, response.data.session.token );
    var locale = localStorage.getItem('user_locale');
    localStorage.clear();
    locale = localStorage.setItem('user_locale', locale);
    window.location.href = "/";
  }

  initialize = function() {
    if (window.TBFLibs && window.TBFLibs.TBFAdmin && $rootScope.user) {
      if (initialized == false) {
        initialized = true;
        window.TBFLibs.TBFAdmin(
          $http.defaults.headers.common['AUTHORIZATION'],
          login,
          $rootScope.logout,
          SERVER_PATH + '/api/v1/',
          $rootScope.user.systemRole,
          'root'
        );

        if (!$rootScope.isBookingFactoryProduction && $rootScope.domain_settings.intercom_code && $rootScope.user.systemRole !== 'admin') {
          window.Intercom("boot", {
            app_id: $rootScope.domain_settings.intercom_code,
            name: $rootScope.user.name,
            email: $rootScope.user.email,
            created_at: Math.floor(new Date($rootScope.user.createdAt).getTime() / 1000)
          });
        }

      }
    }
  }

  if (initialized == false) {
    initialize();
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if (initialized == false) {
      initialize();
    }
  });

  var userWatcher = $rootScope.$watch('user', function () {
    if (initialized == false) {
      initialize();
    }
  });

  $scope.$on('$destroy', function () {
    if (hotelWatcher) {
      hotelWatcher();
    }
    if (userWatcher) {
      userWatcher();
    }
  });
}

angular
  .module('buuqit')
  .controller('AdminCtrl', AdminCtrl);

AdminCtrl.$inject = ["$scope", "$rootScope", "$location", "$mdDialog", "$http","AdminHotelsFactory", "AdminUsersFactory", "SessionFactory", "AdminCorporateAccountsFactory"];

function AdminCtrl ($scope, $rootScope, $location, $mdDialog, $http, AdminHotelsFactory, AdminUsersFactory, SessionFactory, AdminCorporateAccountsFactory) {
  var addNewHotel, addNewUser, editUser, editHotel, _getHotelNameByID,
      blockUser, unblockUser, changeUserPassword, blockHotel, unblockHotel, createSubscription,
      loginAs, openMenu, openChangePasswordDialog, closingDialog,
      editCorporateAccount, toggleCorporateAccount, addUserToCorporateAccount, addHotelToCorporateAccount, closeEditedCorporateAccount, addNewCorporateAccount;

  addNewUser = function (event) {
    event.preventDefault();

    $mdDialog
      .show({
        controller: AddUserCtrl,
        templateUrl: getTemplatePath('modals/addUser.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $scope
          }
        }
      });
  };


  editUser = function (user) {
    $mdDialog
      .show({
        controller: AddUserCtrl,
        templateUrl: getTemplatePath('modals/addUser.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $scope,
            user: user
          }
        }
      });
  };


  manageUserHotels = function (user) {
    $mdDialog
      .show({
        controller: ManageUserHotelsCtrl,
        templateUrl: getTemplatePath('modals/manageUserHotels.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $scope,
            user: user
          }
        }
      });
  };


  blockUser = function (user) {
    user.status = 'blocked';

    user
      .save()
      .then(
        function (response) {},
        function (error) {
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };


  unblockUser = function (user) {
    user.status = 'active';

    user
      .save()
      .then(
        function (response) {},
        function (error) {
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };


  changeUserPassword = function (user) {
    console.log(user);
  };


  addNewHotel = function (event) {
    event.preventDefault();
    $scope.hotelNew = true;
  };


  editHotel = function (hotel) {
    hotel.edited = true;
  };


  _getHotelNameByID = function (id) {
    if (id === null || id === undefined) {
      return '';
    } else {
      var hotel = $scope.hotels.filter(function(el) { return el.id == id; })[0];
      if (hotel) {
        return hotel.name;
      } else {
        return '';
      }
    }
  };


  blockHotel = function (hotel) {
    hotel.status = 'suspend';

    hotel
      .save()
      .then(
        function (response) {},
        function (error) {
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };


  unblockHotel = function (hotel) {
    hotel.status = 'active';

    hotel
      .save()
      .then(
        function (response) {},
        function (error) {
          $rootScope.alert(error.data.errors.join('.\r\n'));
        }
      );
  };


  createSubscription = function (hotel) {
    hotel
      .subscribe()
      .then(
        function (response) {
          $rootScope.alert('Subscription was created successfull');
        },
        function (error) {
          $rootScope.alert('Something went wrong, please try again later!');
        }
      )
  };


  loginAs = function (user) {
    localforage
      .clear()
      .then(function() {
        (new SessionFactory({email : user.email}))
          .create()
          .then(
            function (data) {
              $rootScope.loading = true;
              $rootScope.setUserToken( data.user.id, data.token );
              var locale = localStorage.getItem('user_locale');
              localStorage.clear();
              locale = localStorage.setItem('user_locale', locale);
              window.location.href = "/";
            },
            function (error) {
              $rootScope.alert(error.data.errors);
            }
          );
      });
  };


  openChangePasswordDialog = function (user) {
    $scope.editedUser = user;
    $mdDialog
      .show({
        controller: ChangeUserPasswordCtrl,
        templateUrl: getTemplatePath('modals/changeUserPassword.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $scope
          }
        }
      });
  };


  openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };


  closeEditedHotel = function(originalValue) {
    var hotel = $scope.hotels.filter(function(element) { return element.edited === true; })[0];

    if (hotel) {
      angular.extend(
        hotel,
        originalValue
      );
      hotel.edited = false;
    }
  };


  closeEditedUser = function(originalValue) {
    var user = $scope.users.filter(function(element) { return element.edited === true; })[0];

    if (user) {
      angular.extend(
        user,
        originalValue
      );
      user.edited = false;
    }
  };


  showParams = function(event) {
    if (event.show) {
      event.show = false;
    } else {
      event.show = true;
    }
  };


  closingDialog = function () {};


  loadLogsForSelectedHotel = function () {
    $http
      .get(SERVER_PATH + '/api/v1/admin_logs?hotel_id=' + $scope.logs_hotel)
      .then(function(response) {
        var out = response.data.logs;
        out.forEach(function (el) {
          el.trigger_arguments = JSON.stringify(JSON.parse(el.trigger_arguments), true, 4);
        })
        $scope.events = out;
      });
  };


  openEvent = function (event, index) {
    var eventsCount = $scope.events.length,
        current_availability = JSON.parse(event.availability_data),
        previous_availability = index < eventsCount - 1 ? JSON.parse($scope.events[index + 1].availability_data) : false;

    $scope.dates = [];
    for (var x = 0; x < 101; x++) {
      $scope.dates.push(moment(current_availability.from).add(x, 'days').toDate());
    }
    $scope.selected_event_id = event.id;
    $scope.currentIndex = index;
    $scope.current_availability = current_availability;
    $scope.previous_availability = previous_availability;
  };


  keyboardNavigation = function (event) {
    var UP_KEY_CODE = 38,
        DOWN_KEY_CODE = 40,
        currentIndex = $scope.currentIndex,
        newIndex;

    if (event.keyCode == UP_KEY_CODE) {
      newIndex = currentIndex - 1;
    } else if (event.keyCode == DOWN_KEY_CODE) {
      newIndex = currentIndex + 1;
    } else {
      return false;
    }

    if (newIndex < 0 || newIndex >= $scope.events.length) {
      return false;
    }

    $scope.openEvent($scope.events[newIndex], newIndex);
  };


  editCorporateAccount = function(account) {
    account.edited = true;
  };

  toggleCorporateAccount = function(account) {
    account.isActive = !account.isActive;
    account.save().then(function(data) {});
  };

  addUserToCorporateAccount = function(account) {
    $mdDialog
      .show({
        controller: AddUserToCorporateAccountCtrl,
        templateUrl: getTemplatePath('modals/addUserToCorporateAccount.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $scope,
            account: account
          }
        }
      });
  };

  addHotelToCorporateAccount = function(account) {
    $mdDialog
      .show({
        controller: AddHotelToCorporateAccountCtrl,
        templateUrl: getTemplatePath('modals/addHotelToCorporateAccount.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          local : {
            parent : $scope,
            account: account
          }
        }
      });
  };

  closeEditedCorporateAccount = function(originalValue) {
    var account = $scope.corporate_accounts.filter(function(element) { return element.edited === true; })[0];

    if (account) {
      angular.extend(
        account,
        originalValue
      );
      account.edited = false;
    }
  };

  addNewCorporateAccount = function(event) {
    event.preventDefault();
    $scope.corporateAccountNew = true;
  };


  angular.extend(
    $scope,
    {
      hotels      : [],
      hotelEdited : null,
      hotelNew    : false,
      users       : [],
      userEdited  : null,
      userNew     : false,
      newHotel    : {},
      newUser     : {},
      corporateAccountNew: false,
      newCorporateAccount: {},

      addNewHotel : addNewHotel,
      editHotel   : editHotel,
      addNewUser  : addNewUser,
      editUser    : editUser,
      blockUser   : blockUser,
      unblockUser : unblockUser,
      changeUserPassword : changeUserPassword,
      blockHotel  : blockHotel,
      unblockHotel : unblockHotel,
      createSubscription : createSubscription,
      loginAs     : loginAs,
      openChangePasswordDialog : openChangePasswordDialog,
      closingDialog : closingDialog,
      openMenu : openMenu,
      closeEditedHotel : closeEditedHotel,
      closeEditedUser : closeEditedUser,
      loadLogsForSelectedHotel: loadLogsForSelectedHotel,
      showParams: showParams,
      openEvent: openEvent,
      keyboardNavigation: keyboardNavigation,

      editCorporateAccount: editCorporateAccount,
      toggleCorporateAccount: toggleCorporateAccount,
      addUserToCorporateAccount: addUserToCorporateAccount,
      addHotelToCorporateAccount: addHotelToCorporateAccount,
      closeEditedCorporateAccount: closeEditedCorporateAccount,
      addNewCorporateAccount: addNewCorporateAccount,

      manageUserHotels: manageUserHotels,

      _getHotelNameByID : _getHotelNameByID
    }
  );


  $rootScope.loading = false;
  $rootScope.loadedCallback();

  angular.element('body').removeClass('login-body');
  angular.element('.navbar').removeClass('hidden');

  var userWatcher = $rootScope.$watch('user', function (user) {
    if (user !== undefined) {
      if (user.role != 'admin') {
        $location.path( '/' );
      }
    }
  });


  // Load hotels
  AdminHotelsFactory.query().then(function (data) {
    $scope.hotels = data;
  }, function (error) {
    console.error(error);
  });


  // Load users
  AdminUsersFactory.query().then(function (data) {
    $scope.users = data;
  }, function (error) {
    console.error(error);
  });

  // Load corporate accounts
  AdminCorporateAccountsFactory.query().then(function (data) {
    $scope.corporate_accounts = data;
  }, function (error) {
    console.error(error);
  });

  $scope.$on('$destroy', function () {
    if (userWatcher) {
      userWatcher();
    }
  });
}

angular
  .module("buuqit")
  .controller("EraseDialogController", EraseDialogController);

EraseDialogController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "$i18next",
  "RoomRatesStorage"
];

function EraseDialogController($rootScope, $scope, $mdDialog, $i18next, RoomRatesStorage) {
  var newRangeTemplate = {
    dateFrom: new Date(new Date().setHours(0,0,0,0)),
    dateTo: new Date(new Date().setHours(0,0,0,0)),
    maxDate: null,
    minDate: null,
    weekdays: [true, true, true, true, true, true, true]
  };

  var hidingRestrictions = [
    ['min_stay_through', 'minStayThroughVisible'],
    ['min_stay_arrival', 'minStayArrivalVisible'],
    ['max_stay', 'maxStayVisible'],
    ['closed_to_arrival', 'closedToArrivalVisible'],
    ['closed_to_departure', 'closedToDepartureVisible'],
    ['stop_sell', 'stopSellVisible']
  ];

  angular.extend($scope, {
    affected_restrictions: [
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ],
    restrictions: [
      {code: 'rate'},
      {code: 'min_stay_through'},
      {code: 'min_stay_arrival'},
      {code: 'max_stay'},
      {code: 'closed_to_arrival'},
      {code: 'closed_to_departure'},
      {code: 'stop_sell'},
    ],
    inProgress: false,
    ranges: [angular.copy(newRangeTemplate)],
    weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    error: null,
    today: new Date(new Date().setHours(0,0,0,0)),
    hideDerivedRates: false,
    
    addRange: addRange,
    removeRange: removeRange,
    selectAllRates: selectAllRates,
    deselectAllRates: deselectAllRates,
    setRangeRestriction: setRangeRestriction,
    toggleDerivedRates: toggleDerivedRates,
    cancel: cancel,
    save: save,
    canErase: canErase
  });

  $scope.restrictions = $rootScope.hotel ? $scope.restrictions.filter(function(restriction) {
    if (hidingRestrictions.map(function(el) {return el[0]}).indexOf(restriction.code) != -1) {
      return $rootScope.hotel[hidingRestrictions.filter(function(el) {return el[0] == restriction.code})[0][1]];
    } else {
      return true;
    }
  }) : $scope.restrictions;

  $scope.rateCategories = $rootScope.hotel ? $rootScope.hotel.rateCategories.reduce(function(out, el) {
    out[el.id] = el;
    return out;
  }, {}) : [];
  $scope.roomRepresentations = $rootScope.hotel ? prepareRoomRepresentations() : [];


  function addRange() {
    $scope.ranges.push(angular.copy(newRangeTemplate));
  }

  function removeRange(index) {
    $scope.ranges.splice(index, 1);
  }

  function selectAllRates(roomRepresentationId) {
    $scope.roomRepresentations.forEach(function(roomRepresentation) {
      if (roomRepresentationId != undefined && roomRepresentation.id != roomRepresentationId) {
        return;
      } else {
        roomRepresentation.filteredRoomRates.forEach(function(roomRate) {
          roomRate.selected = true;
        });
      }
    });
  }

  function deselectAllRates(roomRepresentationId) {
    $scope.roomRepresentations.forEach(function(roomRepresentation) {
      if (roomRepresentationId != undefined && roomRepresentation.id != roomRepresentationId) {
        return;
      } else {
        roomRepresentation.filteredRoomRates.forEach(function(roomRate) {
          roomRate.selected = false;
        });
      }
    });
  }

  function __getRoomRateIds() {
    return _.flatten(
      $scope.roomRepresentations
        .map(function(roomRepresentation) {
          return roomRepresentation
            .filteredRoomRates
            .filter(function(roomRate) { return roomRate.selected; })
            .map(function(roomRate) { return roomRate.id; });
        })
    );
  }

  function __getDates() {
    var dates = [];

    $scope.ranges
      .filter(function(range) {
        return range.dateFrom !== undefined && range.dateTo !== undefined;
      })
      .forEach(function(range) {
        var startDate = moment(range.dateFrom.setHours(0,0,0,0));
        var endDate = moment(range.dateTo.setHours(0,0,0,0));
        var diff = endDate.diff(startDate, 'days') + 1;
        for (x = 0; x < diff; x++) {
          var date = moment(range.dateFrom.setHours(0,0,0,0)).add(x, 'day');
          if (range.weekdays[date.isoWeekday() - 1]) {
            dates.push(date.format('YYYY-MM-DD'));
          }
        }
      });

    return _.uniq(dates);
  }

  function prepareSaveObject() {
    var roomRateIds = __getRoomRateIds();
    var dates = __getDates();
    var restrictions = $scope.restrictions.map(function(el) {return el.code;}).filter(function(_el, index) {
      return $scope.affected_restrictions[index];
    });
    var models = [];
    $scope.error = null;

    if (roomRateIds.length === 0) {
      $scope.error = $i18next.t('inventory.bulk_update.errors.room_rate_id');
    }
    if (dates.length === 0) {
      $scope.error = $i18next.t('inventory.bulk_update.errors.dates');
    }
    if (restrictions.length === 0) {
      $scope.error = $i18next.t('inventory.bulk_update.errors.restrictions');
    }

    if ($scope.error === null) {
      return {
        roomRateIds: roomRateIds,
        dates: dates,
        restrictions: restrictions
      };
    } else {
      return null;
    }
  }

  function setRangeRestriction(range, editedField) {
    var field = editedField === 'dateFrom' ? 'minDate' : 'maxDate';
    range[field] = range[editedField];

    if (editedField === 'dateFrom' && range.dateTo < range.dateFrom) {
      range.dateTo = angular.copy(range.dateFrom);
    }
  }

  function prepareRoomRepresentations() {
    var roomRates = $scope.roomRepresentations ? _.flatten(
      $scope.roomRepresentations.map(function(roomRepresentation) {
        return roomRepresentation.filteredRoomRates;
      })
    ).reduce(function(out, roomRate) {
      out[roomRate.id] = roomRate;
      return out;
    }, {}) : [];

    return angular.copy($rootScope.hotel.roomRepresentations)
      .sort(function(a, b) {
        if (a.title < b.title) { return -1; }
        if (a.title > b.title) { return 1; }
        return 0;
      })
      .map(function(roomRepresentation) {
        roomRepresentation.filteredRoomRates = roomRepresentation.roomRates.filter(function(el) {
          return el.isRemoved === false
              && (
                ($scope.hideDerivedRates === true && el.isCalculatedRate === false && !el.parentRoomRateId)
                ||
                ($scope.hideDerivedRates === false)
              )
        }).sort(function(a, b) {
          var av = $scope.rateCategories[a.rateCategoryId].name + ' ' + (a.maxAdults * 100 + a.maxChildren);
          var bv = $scope.rateCategories[b.rateCategoryId].name + ' ' + (b.maxAdults * 100 + b.maxChildren);
          if (av < bv) { return -1; }
          if (av > bv) { return 1; }
          return 0;
        }).map(function(el) {
          el.selected = roomRates[el.id] ? roomRates[el.id].selected : false;
          return el;
        });

        return roomRepresentation;
      });
  }

  function toggleDerivedRates() {
    $scope.hideDerivedRates = !$scope.hideDerivedRates;

    $scope.roomRepresentations = prepareRoomRepresentations();
  }

  function cancel() {
    $mdDialog.hide(false);
  }

  function save() {
    var data = prepareSaveObject();

    if (data) {
      $mdDialog.hide(data);
    }
  }

  function canErase() {
    return $scope.affected_restrictions.reduce(function(acc, el) {return el || acc}, false);
  }
}

angular
  .module("buuqit")
  .controller("EditSeasonController", EditSeasonController);

EditSeasonController.$inject = ["$scope", "$mdDialog", "Seasons", "season", "Globalize"];

function EditSeasonController($scope, $mdDialog, Seasons, season, Globalize) {
  angular.extend($scope, {
    colors: __generateColorList(),
    season: angular.copy(season),

    errors: [],
    inProgress: false,
    cancel: cancel,
    save: save
  });

  $scope.season.color = '#' + $scope.season.color;

  function cancel() {
    $mdDialog.hide(false);
  }

  function save() {
    if ($scope.editSeason.$valid) {
      __save();
    } else {
      __highlightInvalidFields();
    }
  }

  function __save() {
    $scope.inProgress = true;
    Globalize.updateCurrentTranslation($scope.season, 'season');
    Seasons.updateSeason($scope.season)
      .then(function(data) {
        $mdDialog.hide(true);
        var savedEl = Seasons.list.filter(function (season) {
          return season.id === data.id;
        })[0];
        var index = Seasons.list.indexOf(savedEl);
        Seasons.list[index] = data;
      })
      .catch(function(error) {
        $scope.errors = error.data.errors;
      })
      .finally(function() {
        Globalize.loadTranslation($scope.season, 'season');
        $scope.inProgress = false;
      });
  }

  function __highlightInvalidFields() {
    Object.values($scope.editSeason.$error).forEach(function(invalidFields) {
      invalidFields.forEach(function(field) {
        field.$setTouched();
      });
    });
  }

  function __generateColorList() {
    var usedColors = Seasons.list
      .map(function(season) {
        return season.color;
      })
      .filter(function(color) {
        return season.color !== color;
      });

    var colors = SEASON_COLORS.split(" ").filter(function(color) {
      return usedColors.indexOf(color) === -1;
    });
    if (colors.length == 0) {
      colors = SEASON_COLORS.split(" ");
    }
    return colors;
  }
}

angular
  .module("buuqit")
  .controller("CreateSeasonRangeController", CreateSeasonRangeController);

CreateSeasonRangeController.$inject = [
  "$scope",
  "$mdDialog",
  "Seasons",
  "season"
];

function CreateSeasonRangeController($scope, $mdDialog, Seasons, season) {
  angular.extend($scope, {
    range: {
      startDate: undefined,
      endDate: undefined
    },

    errors: [],
    inProgress: false,
    cancel: cancel,
    save: save
  });

  function cancel() {
    $mdDialog.hide(false);
  }

  function save() {
    if ($scope.createSeasonRange.$valid) {
      __save();
    } else {
      __highlightInvalidFields();
    }
  }

  function __save() {
    $scope.inProgress = true;
    Seasons.createRange(season, $scope.range)
      .then(function(data) {
        $mdDialog.hide(true);
      })
      .catch(function(error) {
        $scope.errors = error.data.errors;
      })
      .finally(function() {
        $scope.inProgress = false;
      });
  }

  function __highlightInvalidFields() {
    Object.values($scope.createSeasonRange.$error).forEach(function(
      invalidFields
    ) {
      invalidFields.forEach(function(field) {
        field.$setTouched();
      });
    });
  }
}

angular
  .module("buuqit")
  .controller("CreateSeasonOrRangeController", CreateSeasonOrRangeController);

CreateSeasonOrRangeController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "Seasons",
  "startDate",
  "endDate",
  "Globalize"
];

function CreateSeasonOrRangeController(
  $rootScope,
  $scope,
  $mdDialog,
  Seasons,
  startDate,
  endDate,
  Globalize
) {

  var dismissWatcher = $scope.$watch('Globalize.locale', function(newValue, oldValue){
    Globalize.saveTranslation($scope.season, 'season', oldValue);
    Globalize.loadTranslation($scope.season, 'season');
  });

  $scope.$on('$destroy', function() {
    dismissWatcher();
  });

  var colors = __generateColorList();
  angular.extend($scope, {
    createNewSeason: true,
    colors: colors,
    seasons: Seasons.list.filter(function(season) {
      return season.isDefault === false;
    }),
    season: {
      title: null,
      color: colors[0],
      seasonRangesAttributes: [
        {
          startDate: startDate,
          endDate: endDate
        }
      ],
      translations: []
    },

    errors: [],
    inProgress: false,
    cancel: cancel,
    save: save
  });

  function cancel() {
    $mdDialog.hide(false);
  }

  function save() {
    if ($scope.createSeasonOrRange.$valid) {
      if ($scope.createNewSeason === true) {
        __saveAsNewSeason();
      } else {
        __saveAsNewRange();
      }
    } else {
      __highlightInvalidFields();
    }
  }

  function __saveAsNewSeason() {
    $scope.inProgress = true;
    Globalize.updateCurrentTranslation($scope.season, 'season');

    Seasons.createSeason($scope.season)
      .then(function(data) {
        Globalize.loadTranslation(data, 'season');
        $mdDialog.hide(true);
      })
      .catch(function(error) {
        $scope.errors = error.data.errors;
      })
      .finally(function() {
        Globalize.loadTranslation($scope.season, 'season');
        $scope.inProgress = false;
      });
  }

  function __saveAsNewRange() {
    $scope.inProgress = true;
    season = Seasons.list.filter(function(season) {
      return season.id === $scope.season.id;
    })[0];

    Seasons.createRange(season, $scope.season.seasonRangesAttributes[0])
      .then(function(data) {
        $mdDialog.hide(true);
      })
      .catch(function(error) {
        $scope.errors = error.data.errors;
      })
      .finally(function() {
        $scope.inProgress = false;
      });
  }

  function __highlightInvalidFields() {
    Object.values($scope.createSeason.$error).forEach(function(invalidFields) {
      invalidFields.forEach(function(field) {
        field.$setTouched();
      });
    });
  }

  function __generateColorList() {
    var usedColors = Seasons.list.map(function(season) {
      return season.color;
    });
    var colors = SEASON_COLORS.split(" ").filter(function(color) {
      return usedColors.indexOf(color) === -1;
    });
    if (colors.length == 0) {
      colors = SEASON_COLORS.split(" ");
    }
    return colors;
  }
}

angular
  .module("buuqit")
  .controller("CreateSeasonController", CreateSeasonController);

CreateSeasonController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "Seasons",
  "startDate",
  "endDate",
  "Globalize"
];

function CreateSeasonController($rootScope, $scope, $mdDialog, Seasons, startDate, endDate, Globalize) {
  var colors = __generateColorList();

  angular.extend($scope, {
    colors: colors,
    season: {
      title: null,
      color: '#'+colors[0],
      seasonRangesAttributes: [
        {
          startDate: startDate || new Date(new Date().setHours(0,0,0,0)),
          endDate: endDate || new Date(new Date().setHours(0,0,0,0))
        }
      ]
    },

    errors: [],
    inProgress: false,
    cancel: cancel,
    save: save,
    ensureCorrectRange: ensureCorrectRange
  });

  var dismissWatcher = $scope.$watch('Globalize.locale', function(newValue, oldValue){
    Globalize.saveTranslation($scope.season, 'season', oldValue);
    Globalize.loadTranslation($scope.season, 'season');
  });

  $scope.$on('$destroy', function() {
    dismissWatcher();
  });

  function ensureCorrectRange() {
    var startDate = $scope.season.seasonRangesAttributes[0].startDate;
    var endDate = $scope.season.seasonRangesAttributes[0].endDate;

    if (startDate > endDate) {
      $scope.season.seasonRangesAttributes[0].endDate = angular.copy(startDate);
    }
  }

  function cancel() {
    $mdDialog.hide(false);
  }

  function save() {
    if ($scope.createSeason.$valid) {
      __save();
    } else {
      __highlightInvalidFields();
    }
  }

  function __save() {
    $scope.inProgress = true;
    Globalize.updateCurrentTranslation($scope.season, 'season');
    Seasons.createSeason($scope.season)
      .then(function(data) {
        $mdDialog.hide(true);
      })
      .catch(function(error) {
        $scope.errors = error.data.errors;
      })
      .finally(function() {
        Globalize.loadTranslation($scope.season, 'season');
        $scope.inProgress = false;
      });
  }

  function __highlightInvalidFields() {
    Object.values($scope.createSeason.$error).forEach(function(invalidFields) {
      invalidFields.forEach(function(field) {
        field.$setTouched();
      });
    });
  }

  function __generateColorList() {
    var usedColors = Seasons.list.map(function(season) {
      return season.color;
    });
    var colors = SEASON_COLORS.split(" ").filter(function(color) {
      return usedColors.indexOf(color) === -1;
    });
    if (colors.length == 0) {
      colors = SEASON_COLORS.split(" ");
    }
    return colors;
  }
}

angular.module('buuqit')
.controller('UIChangePriceController', ['$rootScope', '$scope', 'UIDialogService', function($rootScope, $scope, UIDialogService) {
  this.init = function(element, id) {
    $scope.isOpened = false;
    $scope.element = element;
    $scope.parent = element.closest('md-dialog');
    $scope.close = function () { UIDialogService.close(id); };
    $scope.confirm = function () {
      if (typeof($scope.callback) === 'function')
        $scope.callback($scope.values)
        .then(function(){
          UIDialogService.close(id);
        });
    };

    $scope.perNight = function(night) { return $scope.values.per_night[night.date]; }
    $scope.totalFromNights = function() {
      var values = $scope.values;

      if(values.is_foreign) {
        values.nights.map(function(night){
          night.price = night.foreignAmount * $scope.$parent.booking.foreignCurrencyRate
        })
      }

      $scope.values.total_price = values.nights.reduce(function(a, b){
        if(typeof(a)==='number')
          return a + values.per_night[b.date] * b.price;
        return values.per_night[a.date] * a.price + values.per_night[b.date] * b.price;
      });

      $scope.values.total_foreign_amount =
        values.nights.reduce(function(a, b){
          if(typeof(a)==='number')
            return a + values.per_night[b.date] * b.foreignAmount;
          return values.per_night[a.date] * a.foreignAmount + values.per_night[b.date] * b.foreignAmount;
        });

      values.total_foreign_amount = values.is_foreign ?
        values.nights.length>1?
          values.nights.reduce(function(a, b){
            if(typeof(a)==='number')
              return a + values.per_night[b.date] * b.foreignAmount;
            return values.per_night[a.date] * a.foreignAmount + values.per_night[b.date] * b.foreignAmount;
          }):
          values.per_night[values.nights[0].date] * values.nights[0].foreignAmount:
        0;

    }

    UIDialogService.registerScope(id, $scope);
  };
}])
.directive('uiChangePriceModal', function() {
  return {
    restrict: 'E',
    controller: 'UIChangePriceController',
    scope: {
      onclose: '&'
    },
    templateUrl: 'templates/modals/booking_management/change_price_modal.html',
    replace: true,
    transclude: false,
    link: function(scope, element, attrs, ctrl) {
      attrs.$observe('id', function(newId) {
        if (newId) {
          ctrl.init(element, newId);
        }
      });
    }
  };
})

angular.module('buuqit')
.controller('UIChangeOccupancyController', ['$rootScope', '$scope', 'UIDialogService', function($rootScope, $scope, UIDialogService) {
  this.init = function(element, id) {
    $scope.isOpened = false;
    $scope.element = element;
    $scope.parent = element.closest('md-dialog');
    $scope.close = function () { UIDialogService.close(id); };
    $scope.confirm = function () {
      if (typeof($scope.callback) === 'function')
        $scope.callback($scope.values)
        .then(function(){
          UIDialogService.close(id);
        });
    };
    UIDialogService.registerScope(id, $scope);
  };
}])
.directive('uiChangeOccupancyModal', function() {
  return {
    restrict: 'E',
    controller: 'UIChangeOccupancyController',
    scope: {
      onclose: '&'
    },
    templateUrl: 'templates/modals/booking_management/change_occupancy_modal.html',
    replace: true,
    transclude: false,
    link: function(scope, element, attrs, ctrl) {
      attrs.$observe('id', function(newId) {
        if (newId) {
          ctrl.init(element, newId);
        }
      });
    }
  };
})

angular.module('buuqit')
.controller('UIChangeDateController', ['$rootScope', '$scope', 'UIDialogService', function($rootScope, $scope, UIDialogService) {
  this.init = function(element, id) {
    $scope.isOpened = false;
    $scope.element = element;
    $scope.parent = element.closest('md-dialog');
    $scope.close = function () { UIDialogService.close(id); };
    $scope.confirm = function () {
      if (typeof($scope.callback) === 'function')
        $scope.callback($scope.values)
        .then(function(){
          UIDialogService.close(id);
        });
    };
    UIDialogService.registerScope(id, $scope);
  };
}])
.directive('uiChangeDateModal', function() {
  return {
    restrict: 'E',
    controller: 'UIChangeDateController',
    scope: {
      onclose: '&'
    },
    templateUrl: 'templates/modals/booking_management/change_date_modal.html',
    replace: true,
    transclude: false,
    link: function(scope, element, attrs, ctrl) {
      attrs.$observe('id', function(newId) {
        if (newId) {
          ctrl.init(element, newId);
        }
      });
    }
  };
})

angular
  .module("buuqit")
  .controller("BulkUpdateController", BulkUpdateController);

BulkUpdateController.$inject = [
  "$rootScope",
  "$scope",
  "$mdDialog",
  "$i18next",
  "RoomRatesStorage"
];

function BulkUpdateController($rootScope, $scope, $mdDialog, $i18next, RoomRatesStorage) {
  var newRangeTemplate = {
    dateFrom: new Date(new Date().setHours(0,0,0,0)),
    dateTo: new Date(new Date().setHours(0,0,0,0)),
    maxDate: null,
    minDate: null,
    weekdays: [true, true, true, true, true, true, true]
  };

  var hidingRestrictions = [
    ['min_stay_through', 'minStayThroughVisible'],
    ['min_stay_arrival', 'minStayArrivalVisible'],
    ['max_stay', 'maxStayVisible'],
    ['closed_to_arrival', 'closedToArrivalVisible'],
    ['closed_to_departure', 'closedToDepartureVisible'],
    ['stop_sell', 'stopSellVisible']
  ];

  angular.extend($scope, {
    restrictions: [
      {code: 'rate',                mode: 'number',  default: null, min: 1},
      {code: 'min_stay_through',    mode: 'number',  default: 1, min: 1},
      {code: 'min_stay_arrival',    mode: 'number',  default: 1, min: 1},
      {code: 'max_stay',            mode: 'number',  default: 0, min: 0},
      {code: 'closed_to_arrival',   mode: 'boolean', default: true},
      {code: 'closed_to_departure', mode: 'boolean', default: true},
      {code: 'stop_sell',           mode: 'boolean', default: true},
    ],
    inProgress: false,
    restriction: 'stop_sell',
    restrictionMode: 'boolean',
    value: true,
    ranges: [angular.copy(newRangeTemplate)],
    weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    error: null,
    today: new Date(new Date().setHours(0,0,0,0)),
    hideDerivedRates: false,
    
    changeRestriction: changeRestriction,
    addRange: addRange,
    removeRange: removeRange,
    selectAllRates: selectAllRates,
    deselectAllRates: deselectAllRates,
    setRangeRestriction: setRangeRestriction,
    toggleDerivedRates: toggleDerivedRates,
    cancel: cancel,
    save: save
  });

  $scope.restrictions = $rootScope.hotel ? $scope.restrictions.filter(function(restriction) {
    if (hidingRestrictions.map(function(el) {return el[0]}).indexOf(restriction.code) != -1) {
      return $rootScope.hotel[hidingRestrictions.filter(function(el) {return el[0] == restriction.code})[0][1]];
    } else {
      return true;
    }
  }) : $scope.restrictions;

  $scope.rateCategories = $rootScope.hotel ? $rootScope.hotel.rateCategories.reduce(function(out, el) {
    out[el.id] = el;
    return out;
  }, {}) : [];
  $scope.roomRepresentations = $rootScope.hotel ? prepareRoomRepresentations() : [];


  function changeRestriction() {
    var restriction = $scope.restrictions
      .filter(function(el) {
        return el.code == $scope.restriction
      })[0];

    if (restriction) {
      $scope.value = angular.copy(restriction.default);
      $scope.minValue = angular.copy(restriction.min);
      $scope.restrictionMode = restriction.mode;
    }

    resetRoomRateFilter();
  }

  function addRange() {
    $scope.ranges.push(angular.copy(newRangeTemplate));
  }

  function removeRange(index) {
    $scope.ranges.splice(index, 1);
  }

  function selectAllRates(roomRepresentationId) {
    $scope.roomRepresentations.forEach(function(roomRepresentation) {
      if (roomRepresentationId != undefined && roomRepresentation.id != roomRepresentationId) {
        return;
      } else {
        roomRepresentation.filteredRoomRates.forEach(function(roomRate) {
          roomRate.selected = true;
        });
      }
    });
  }

  function deselectAllRates(roomRepresentationId) {
    $scope.roomRepresentations.forEach(function(roomRepresentation) {
      if (roomRepresentationId != undefined && roomRepresentation.id != roomRepresentationId) {
        return;
      } else {
        roomRepresentation.filteredRoomRates.forEach(function(roomRate) {
          roomRate.selected = false;
        });
      }
    });
  }

  function __getRoomRateIds() {
    return _.flatten(
      $scope.roomRepresentations
        .map(function(roomRepresentation) {
          return roomRepresentation
            .filteredRoomRates
            .filter(function(roomRate) { return roomRate.selected; })
            .map(function(roomRate) { return roomRate.id; });
        })
    );
  }

  function __getDates() {
    var dates = [];

    $scope.ranges
      .filter(function(range) {
        return range.dateFrom !== undefined && range.dateTo !== undefined;
      })
      .forEach(function(range) {
        var startDate = moment(range.dateFrom.setHours(0,0,0,0));
        var endDate = moment(range.dateTo.setHours(0,0,0,0));
        var diff = endDate.diff(startDate, 'days') + 1;
        for (x = 0; x < diff; x++) {
          var date = moment(range.dateFrom.setHours(0,0,0,0)).add(x, 'day');
          if (range.weekdays[date.isoWeekday() - 1]) {
            dates.push(date.format('YYYY-MM-DD'));
          }
        }
      });

    return _.uniq(dates);
  }

  function prepareSaveObject() {
    var roomRateIds = __getRoomRateIds();
    var dates = __getDates();
    var models = [];
    $scope.error = null;

    if (typeof($scope.value) === 'undefined') {
      $scope.error = $i18next.t('inventory.bulk_update.errors.value');
    }
    if (typeof($scope.value) === 'object') {
      $scope.error = $i18next.t('inventory.bulk_update.errors.value');
    }
    if (roomRateIds.length === 0) {
      $scope.error = $i18next.t('inventory.bulk_update.errors.room_rate_id');
    }
    if (dates.length === 0) {
      $scope.error = $i18next.t('inventory.bulk_update.errors.dates');
    }

    if ($scope.error === null) {
      roomRateIds.forEach(function(roomRateId) {
        dates.forEach(function(date) {
          models.push({
            date: date,
            restriction: $scope.restriction,
            room_rate_id: roomRateId,
            value: $scope.value,
          });
        });
      });

      return models;
    } else {
      return null;
    }
  }

  function setRangeRestriction(range, editedField) {
    var field = editedField === 'dateFrom' ? 'minDate' : 'maxDate';
    range[field] = range[editedField];

    if (editedField === 'dateFrom' && range.dateTo < range.dateFrom) {
      range.dateTo = angular.copy(range.dateFrom);
    }
  }

  function resetRoomRateFilter() {
    $scope.hideDerivedRates = false;
    $scope.roomRepresentations = prepareRoomRepresentations();
  }

  function prepareRoomRepresentations() {
    var roomRates = $scope.roomRepresentations ? _.flatten(
      $scope.roomRepresentations.map(function(roomRepresentation) {
        return roomRepresentation.filteredRoomRates;
      })
    ).reduce(function(out, roomRate) {
      out[roomRate.id] = roomRate;
      return out;
    }, {}) : [];

    return angular.copy($rootScope.hotel.roomRepresentations)
      .sort(function(a, b) {
        if (a.title < b.title) { return -1; }
        if (a.title > b.title) { return 1; }
        return 0;
      })
      .map(function(roomRepresentation) {
        roomRepresentation.filteredRoomRates = roomRepresentation.roomRates.filter(function(el) {
          return el.isRemoved === false
              && (
                ($scope.hideDerivedRates === true && el.isCalculatedRate === false && !el.parentRoomRateId)
                ||
                ($scope.hideDerivedRates === false)
              )
        }).sort(function(a, b) {
          var av = $scope.rateCategories[a.rateCategoryId].name + ' ' + (a.maxAdults * 100 + a.maxChildren);
          var bv = $scope.rateCategories[b.rateCategoryId].name + ' ' + (b.maxAdults * 100 + b.maxChildren);
          if (av < bv) { return -1; }
          if (av > bv) { return 1; }
          return 0;
        }).map(function(el) {
          el.selected = roomRates[el.id] ? roomRates[el.id].selected : false;
          return el;
        });

        return roomRepresentation;
      });
  }

  function toggleDerivedRates() {
    $scope.hideDerivedRates = !$scope.hideDerivedRates;

    $scope.roomRepresentations = prepareRoomRepresentations();
  }

  function cancel() {
    $mdDialog.hide(false);
  }

  function save() {
    var data = prepareSaveObject();

    if (data) {
      $mdDialog.hide(data);
    }
  }
}

angular
  .module('buuqit')
  .controller('Inventory.CloseoutController', CloseoutController);

CloseoutController.$inject = ["$rootScope", "$scope", "$http", "$timeout", "RoomBlockerFactory"];

function CloseoutController ($rootScope, $scope, $http, $timeout, RoomBlockerFactory) {
  $rootScope.loading = false;

  $rootScope.trackEvent('Inventory Closeout openned');

  angular.extend($scope, {
    currentDate  : new Date(),
    dates        : [],
    roomTypes    : [],
    availability : [],
    newCloseOut  : {},
    blockersForRemove : {},
    loading      : false,
    startCell    : null,
    stopCell     : null,
    startRow     : null,
    stopRow      : null,
    today        : moment(moment(new Date()).format('YYYY-MM-DD')).toDate(),
    initTimeout  : null,

    // Methods
    loadAvailability : loadAvailability,
    fillDates        : fillDates,
    setUsClosedOut   : setUsClosedOut,
    save             : save,
    reset            : reset,
    compareDate      : compareDate,
    testSentry       : testSentry,
    mouseDownOnCell  : mouseDownOnCell,
    mouseUpOnCell    : mouseUpOnCell,
    mouseMoveOnTable : mouseMoveOnTable,
    isSelected       : isSelected
  });

  if ($rootScope.hotel && $rootScope.hotel.rateCategories) {
    $scope.roomTypes = $rootScope.hotel.roomTypes;
  }

  var hotelWatcher = $rootScope.$watch('hotel', function () {
    if ($rootScope.hotel && $rootScope.hotel.roomTypes && $scope.roomTypes.length === 0) {
      $scope.roomTypes = $rootScope.hotel.roomTypes;
    }
  });


  function loadAvailability () {
    $scope.dates = [];
    $scope.availability = [];

    $scope.fillDates();

    RoomBlockerFactory
      .query({
        checkinDate:  moment($scope.dates[0]).format('YYYY-MM-DD'),
        checkoutDate: moment($scope.dates[$scope.dates.length - 1]).format('YYYY-MM-DD')
      }, {
        hotelId: $rootScope.hotel.id
      })
      .then(function (data) {
        $scope.blockers = data;

        $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/availability?dateFrom=' + moment($scope.dates[0]).format('YYYY-MM-DD') + '&dateTo=' + moment($scope.dates[$scope.dates.length - 1]).format('YYYY-MM-DD')).
          success(function(data) {
            _.each(data.room_types, function (dates, room_type_id) {
              if (!$scope.availability[room_type_id]) { $scope.availability[room_type_id] = []; }
              _.each(dates, function (date, key) {
                if (!$scope.availability[room_type_id][key]) { $scope.availability[room_type_id][key] = {}; }
                $scope.availability[room_type_id][key].available = date.available;
              });
            });

            _.each(data.closed_out, function (obj, date) {
              _.each(obj, function (room_id) {
                var room_type = $rootScope.hotel.rooms.filter(function(room) {return room.id == room_id;})[0];
                if (room_type !== undefined) {
                  $scope.availability[room_type.roomTypeId][date].closedOut = true;
                }
              });
            });
          }).
          error(function(data, status, headers, config) {
          });
      });
  }


  function fillDates () {
    var lastCurrentDate = moment($scope.currentDate).add(1, 'month').date(1),
        firstCurrentDate = moment(angular.copy($scope.currentDate)).date(1);

    while (firstCurrentDate < lastCurrentDate) {
      $scope.dates.push(moment(angular.copy(firstCurrentDate)).format('YYYY-MM-DD'));
      firstCurrentDate = moment(firstCurrentDate).add(1, 'day').toDate();
    }


    _.each($scope.roomTypes, function(roomType) {
      roomTypeNumbersCount = ($rootScope.hotel.rooms.filter(function(el) {return el.roomTypeId == roomType.id;})).length;

      _.each($scope.dates, function(date) {
        if ($scope.availability[roomType.id] === undefined) {
          $scope.availability[roomType.id] = [];
        }

        if ($scope.availability[roomType.id][date] === undefined) {
          day = (new Date(date)).getUTCDay() > 0 ? (new Date(date)).getUTCDay() - 1 : 6;

          $scope.availability[roomType.id][date] = {
            roomTypeId : roomType.id,
            date       : date,
            available  : 0,
            blocked    : 0
          };
        }
      });
    });
  }


  function setUsClosedOut (model) {
    if (model.closedOut) {
      model.closedOut = false;
      model.changed   = true;
      if ($scope.blockersForRemove[model.date] === undefined) {
        $scope.blockersForRemove[model.date] = [];
      }
      $scope.blockersForRemove[model.date].push(model.roomTypeId);
    } else {
      model.closedOut = true;
      model.changed   = true;

      if ($scope.blockersForRemove[model.date]) {
        $scope.blockersForRemove[model.date] = _.without($scope.blockersForRemove[model.date], model.roomTypeId);
      }
    }
  }


  function save () {
    $scope.loading = true;
    var changed = [];
    _.each($scope.roomTypes, function(roomType) {
      _.each($scope.dates, function(date) {
        if ($scope.availability[roomType.id][date].changed) {
          changed.push($scope.availability[roomType.id][date]);
        }
      });
    });

    toCreateBlockers = changed.filter(function (el) {return el.closedOut === true;});
    toRemoveBlockers = changed.filter(function (el) {return el.closedOut === false;});

    $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/room_blockers/manage_close_out', {
      'to_create_blockers' : toCreateBlockers,
      'to_remove_blockers' : toRemoveBlockers
    }).then(function() {
      $scope.loading = false;
      $rootScope.notify('Save successful');
      $scope.loadAvailability();
    }, function(error) {
      $scope.loading = false;
      $rootScope.notify(error.statusText, 'error');
    });
  }


  function reset () {
    $scope.blockersForRemove = [];
    $scope.loadAvailability();
  }


  function compareDate (date) {
    return moment(date).diff($scope.today, 'day') >= 0;
  }


  function testSentry () {
    throw new Error("Some new error");
  }


  function mouseDownOnCell(roomType, dateIndex) {
    if (new Date($scope.dates[dateIndex]) >= $scope.today) {
      $scope.selectionIsActive = true;
      $scope.startCell = dateIndex;
      $scope.startRow = getRoomTypeIndex(roomType);
      $scope.stopCell = dateIndex;
      $scope.stopRow = getRoomTypeIndex(roomType);
    }
  }


  function mouseUpOnCell(roomType, dateIndex) {
    $scope.selectionIsActive = false;
    if ($scope.stopCell - $scope.startCell > 0 || $scope.stopRow - $scope.startRow > 0) {
      for (var x = $scope.startRow; x <= $scope.stopRow; x++) {
        for (var y = $scope.startCell; y <= $scope.stopCell; y++) {
          var roomType = $scope.roomTypes[x],
              date = $scope.dates[y],
              model = $scope.availability[roomType.id][date];

          if (model.closedOut == false || model.closedOut == undefined) {
            model.closedOut = true;
            model.changed   = true;

            if ($scope.blockersForRemove[model.date]) {
              $scope.blockersForRemove[model.date] = _.without($scope.blockersForRemove[model.date], model.roomTypeId);
            }
          }
        }
      }
    }
  }


  function mouseMoveOnTable(roomType, dateIndex) {
    if ($scope.selectionIsActive && new Date($scope.dates[dateIndex]) >= $scope.today) {
      if (dateIndex > $scope.startCell) {
        $scope.stopCell = dateIndex
      } else {
        $scope.stopCell = $scope.startCell;
        $scope.startCell = dateIndex;
      }

      var roomIndex = getRoomTypeIndex(roomType);
      if (roomIndex > $scope.startRow) {
        $scope.stopRow = roomIndex
      } else {
        $scope.stopRow = $scope.startRow;
        $scope.startRow = roomIndex;
      }
    }
  }


  function isSelected(roomType, dateIndex) {
    if ($scope.selectionIsActive) {
      var roomIndex = getRoomTypeIndex(roomType);
      return roomIndex >= $scope.startRow && roomIndex <= $scope.stopRow && dateIndex >= $scope.startCell && dateIndex <= $scope.stopCell;
    } else {
      return false;
    }
  }


  function getRoomTypeIndex(roomType) {
    return $scope.roomTypes.indexOf(roomType);
  }


  function init() {
    if ($rootScope.hotel) {
      $scope.loadAvailability();
    } else {
      $scope.initTimeout = $timeout(init, 100);
    }
  }

  init();

  $scope.$watch('currentDate', function(prev, next) {
    if ($rootScope.hotel && prev != next) {
      $scope.loadAvailability();
    }
  });
  $scope.$on('$destroy', function() {
    if ($scope.initTimeout) {
      $timeout.cancel($scope.initTimeout);
    }
    if (hotelWatcher) {
      hotelWatcher();
    }
    $scope.availability = null;
    $scope.blockers = null;
  });
}

angular
  .module('buuqit')
  .service('WaitlistStorage', WaitlistStorage);

WaitlistStorage.$inject = ["$rootScope", "WaitlistFactory", "$interval"];

function _safe_call(f, args, caller) { if(typeof(f)==='function') f.apply(caller, args) };

function WaitlistStorage ($rootScope, WaitlistFactory, $interval) {
  var self = this;

  this.checkin_date = null;
  this.checkout_date = null;
  this.waitlists  = [];

  this.load = function (from, to, cb) {
      if ($rootScope.networkStatus) {
        WaitlistFactory
          .query({checkinDate: from, checkoutDate: to}, {hotelId: $rootScope.hotel.id})
          .then(function(data) {
            self.lastUpdated = self.get_last_updated(data);

            self.waitlists = data.map(function(w) {
              if(w.amount && w.amount.length > 0) w.amount = Math.round(w.amount)
              return w;
            }); // Yes this is a total hack but it's quicker than getting backend changes.

            _safe_call(cb, [true], this);
            $rootScope.$broadcast('waitlists:redraw');
          }).catch(function(error) {
            console.error('Error loading waitlists', error);
          });
      } else _safe_call(cb, [false], this);
  };

  this.get_last_updated = function() {
    return parseInt(String(moment().add(-1, 'day').toDate().getTime()).substr(0,10)) || null;
  }

  this.update = function() {
    var last_update = self.get_last_updated();
    if ($rootScope.networkStatus && $rootScope.schedulerScrolling === false) {
      WaitlistFactory
        .query({
          checkinDate:  self.from_date,
          checkoutDate: self.to_date,
          last_update: last_update
        }, {
          hotelId: $rootScope.hotel.id
        })
        .then(self.parseUpdatedData)
        .catch(function(error) {
          console.error('Error updating waitlists', error);
        });
    }
  };

  this.get = function (id) {
    return self.waitlists.find(function(note){ return note.id == id; });
  };

  this.indexOf = function(waitlist) {
    return this.waitlists.indexOf(self.get(waitlist.id));
  }

  this.parseUpdatedData = function (data) {
    if(!Array.isArray(data)) data = [data];
    data.map(function (waitlist) {
      if(waitlist.amount !== undefined) waitlist.amount = Math.round(waitlist.amount)
      var index = self.indexOf(waitlist);
      if(index > -1) self.waitlists[index] = waitlist;
      else self.waitlists.push(waitlist);
    });
    $rootScope.$broadcast('waitlists:redraw');
    self.lastUpdated = self.get_last_updated();
  };

  this.syncronizeStorage = function () {
    self.waitlists.map(function(note) { note.sync(); });
    $rootScope.removedWaitlists.map(function(note) { note.sync(); });
    self.update(self);
  };

  this.removeList = function (waitlist) {
    var index = this.waitlists.indexOf(waitlist);
    this.waitlists.splice(index, 1);
    waitlist.destroy(function(){
      $rootScope.$broadcast('waitlists:redraw');
    });
  };

  this.get_by_id = function (id) {
    WaitlistFactory
      .get({hotelId: $rootScope.hotel.id, id: id})
      .then(self.parseUpdatedData)
      .catch(function(error) {
        console.error('Error getting waitlist by id', error);
      });
  }

  $rootScope.$on('waitlists:update', self.update);
  $rootScope.$on('network:connect', this.syncronizeStorage);
}

angular.module('buuqit')
  .service('UIDialogService', ['$timeout', function($timeout) {
    var self = this,
      dialogFilter,
      activeDialogId,
      scopeMap = {};

    this.registerScope = function(dialogId, dialogScope) {
      scopeMap[dialogId] = dialogScope;
    };

    this.open = function(dialogId, settings, afterOpen) {
      var modalScope = angular.extend(scopeMap[dialogId], settings);

      activeDialogId = dialogId;

      dialogFilter = angular.element('<div/>', {class: 'dialog-filter'});

      dialogFilter
        .appendTo(modalScope.parent)
        .bind('click', function() { self.close(dialogId); });

      modalScope.element
        .appendTo(modalScope.parent);

      $timeout(function() {
        modalScope.isOpened = true;

        if (typeof(afterOpen) == 'boolean' && afterOpen == true && typeof(modalScope.afterOpen) == 'function') {
          modalScope.afterOpen();
        }

        dialogFilter.addClass('dialog-filter--is-shown');
        modalScope.element.addClass('dialog--is-shown');
      }, 100);
    };

    this.close = function(dialogId) {
      activeDialogId = undefined;

      dialogFilter.removeClass('dialog-filter--is-shown');
      scopeMap[dialogId].element.removeClass('dialog--is-shown');
      scopeMap[dialogId].onclose();

      dialogFilter.remove();

      scopeMap[dialogId].element
        .removeClass('dialog--is-fixed')
        .appendTo(scopeMap[dialogId].parent);

      scopeMap[dialogId].isOpened = false;
    };
  }])
  .controller('UIPromptController', ['$scope', 'UIDialogService', function($scope, UIDialogService) {
    this.init = function(element, id) {
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');

      $scope.close = function () {
        UIDialogService.close(id);
        if ($scope.cancelCallback && typeof($scope.cancelCallback) === 'function') {
          $scope.cancelCallback();
        }
      };

      $scope.confirm = function () {
        if ($scope.element.find('textarea').size() > 0) {
           if (typeof($scope.callback) === 'function') {
             $scope.callback($scope.element.find('textarea').map(function(index, el) {return $(el).val()}));
           }
        } else {
          var field = $scope.element.find('input');
          var reference = $scope.element.find('[name="reference"]');
          if (typeof($scope.callback) === 'function') {
            if (field.attr('type') === 'number') {
              $scope.callback(Number(field.val()), reference ? reference.val() : null);
            } else {
              $scope.callback(String(field.val()));
            }
          }
        }
      };

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .controller('UICancelationController', ['$scope', 'UIDialogService', function($scope, UIDialogService) {
    this.init = function(element, id) {
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');

      $scope.close = function () {
        UIDialogService.close(id);
      };

      $scope.confirm = function () {
        if (typeof($scope.callback) === 'function') {
          $scope.callback(
            Number($scope.element.find('[name="fee"]').val()),
            $scope.element.find('[role="checkbox"]').attr('aria-checked') == "true" ?
            $scope.element.find('[name="email"]').val() :
            null
          );
        }
      };

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .controller('UIRemoveController', ['$scope', 'UIDialogService', '$i18next', function($scope, UIDialogService, $i18next) {
    this.init = function(element, id) {
      $scope.message = $i18next.t('profile_nav.settings.hotel_profile.taxe_new.confirm.content') || '';
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');

      $scope.close = function () {
        UIDialogService.close(id);
      };

      $scope.confirm = function () {
        if (typeof($scope.callback) === 'function') {
          $scope.callback(
            $scope.element.find('[role="checkbox"]').attr('aria-checked') == "true"
          );
        }
      };

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .controller('UIChangeRoomController', ['$scope', 'UIDialogService', function($scope, UIDialogService) {
    this.init = function(element, id) {
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');

      $scope.close = function () {
        UIDialogService.close(id);
      };

      $scope.confirm = function (date, number, note) {
        if (typeof($scope.callback) === 'function') {
          $scope.callback(date, number, note);
        }
      };

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .controller('UIConfirmController', ['$scope', 'UIDialogService', function($scope, UIDialogService) {
    this.init = function(element, id) {
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');

      $scope.close = function () {
        UIDialogService.close(id);
        if (typeof($scope.negative_callback) === 'function') {
          $scope.negative_callback();
        }
      };

      $scope.confirm = function () {
        UIDialogService.close(id);
        if (typeof($scope.positive_callback) === 'function') {
          $scope.positive_callback();
        }
      };

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .controller('UIRequestPayment', ['$scope', '$rootScope', 'UIDialogService', function($scope, $rootScope, UIDialogService) {
    this.init = function(element, id) {
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');
      $scope.subject = $rootScope.hotel.requestPaymentSubject;
      $scope.body = $rootScope.hotel.requestPaymentBody;

      $scope.insertDropIn = function(editor, dropin) {
        angular.element('[data-role="'+editor+'"]').summernote('insertText', dropin);
      }

      $scope.openMenu = function($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      };

      $scope.dropins = dropins;

      $scope.close = function () {
        UIDialogService.close(id);
      };

      $scope.confirm = function () {
        if (typeof($scope.callback) === 'function') {
          $scope.callback({
            amount: element.find('[name="value"]').val(),
            provider: element.find('[name=".provider"]').val(),
            folio: element.find('[name=".folio"]').val(),
            subject: element.find('[name="subject"]').val(),
            address: element.find('[name="address"]').val(),
            body: element.find('.note-editable.panel-body').html()
          });
        }
      };
      
      $scope.folioChangeBlank = function () {
        var originalDue = angular.copy($scope.booking.due);
        $scope.value = $scope.correctFractionedValue(originalDue);
      }

      $scope.folioChange = function (id) {
        selected_folio = $scope.folios.find(function(f) { return f.id == id });
        if (selected_folio === undefined) {
          $scope.value = $scope.correctFractionedValue(angular.copy($scope.booking.due));
        } else {
          $scope.value = $scope.correctFractionedValue(angular.copy(selected_folio.due));

        }
      };

      $scope.folioDescription = function (folio) {
        return "Folio #" + folio.number + " Due: " + folio.due + " - " + folio.visible_name
      };
      $scope.correctFractionedValue = function (value) {
        return $rootScope.currencyFractionSize > 0 ? Math.floor(value * 100) / 100 : Number(Number(value).toFixed(2));
      }

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .controller('UIExportCustomersToXLS', ['$scope', 'UIDialogService', function($scope, UIDialogService) {
    this.init = function(element, id) {
      $scope.isOpened = false;
      $scope.element = element;
      $scope.parent = element.closest('md-dialog');

      $scope.close = function () {
        UIDialogService.close(id);
      };

      $scope.confirm = function () {
        if (typeof($scope.callback) === 'function') {
          $scope.loading = true;
          $scope.callback($scope.value);
        }
      };

      UIDialogService.registerScope(id, $scope);
    };
  }])
  .directive('uiPromptNumber', function() {
    return {
      restrict: 'E',
      controller: 'UIPromptController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{title}}</div><div class="content"><form name="moneyPromptForm"><small class="form-notice" ng-if="notice"><i class="fa fa-exclamation-circle"></i><span class="form-notice__message">{{notice}}</span></small><md-input-container><label>{{placeholder}}</label><input ng-model="value" name="value" type="number" max="{{max_value}}" min="{{min_value}}" required></md-input-container><md-input-container ng-if="with_reference === true"><label>{{reference_title}}</label><input ng-model="reference" name="reference" type="text" maxlength="64"></md-input-container></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel" | i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="moneyPromptForm.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiCancelationModal', function() {
    return {
      restrict: 'E',
      controller: 'UICancelationController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{"common_for_app.confirm.cancellation_fee_title" | i18next}}</div><div class="content"><form name="moneyPromptForm"><md-input-container><label>{{"common_for_app.confirm.please_enter_cancelation_fee_amount_label" | i18next}}</label><input ng-model="fee" name="fee" type="number" max="{{max_fee}}" min="{{min_fee}}" required></md-input-container><md-checkbox ng-model="sendNotification" aria-label="{{"common_for_app.confirm.send_cancellation_email_checkbox" | i18next}}">{{"common_for_app.confirm.send_cancellation_email_checkbox" | i18next}}</md-checkbox><md-input-container ng-show="sendNotification == true"><label>{{"common_for_app.confirm.notification_email_label" | i18next}}</label><input ng-if="sendNotification" ng-model="email" name="email" type="email" ng-required="sendNotification == true"></md-input-container></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel" | i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="moneyPromptForm.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiChangeRoomModal', ["$rootScope", "AvailabilityChecker", function($rootScope, AvailabilityChecker) {
    return {
      restrict: 'E',
      controller: 'UIChangeRoomController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{"common_for_app.confirm.split_to_another_room_title" | i18next}}</div><div class="content">{{"common_for_app.confirm.this_feature_will_split_the_room_stay_between_two_rooms_content" | i18next}}<form name="moneyPromptForm"><md-datepicker ng-model="date" md-placeholder="{{"common_for_app.confirm.choose_change_date_placeholder" | i18next}}" md-min-date="min_date" md-max-date="max_date" ng-change="updateRooms(date)"></md-datepicker><md-input-container><label>{{"common_for_app.confirm.choose_new_room_label" | i18next}}</label><md-select ng-model="number"><md-option ng-repeat="room in filteredRooms" value="{{room.id}}">{{room.number}}</md-option></md-select></md-input-container><md-input-container><label>{{"common_for_app.confirm.comment_label" | i18next}}</label><input ng-model="note" name="note" type="text"></md-input-container></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel" | i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm(date, number, note)" ng-disabled="moneyPromptForm.$invalid">{{"general.confirm.confirm"|i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        var memory = {};
        scope.rooms = $rootScope.hotel.rooms;
        scope.notBlockedRooms = function(number) {
          var key = [
            scope.date,
            moment(scope.room.checkoutDate).diff(scope.date, 'day'),
            scope.room.id
          ].join(':');
          if (memory[key] == undefined) {
            memory[key] = AvailabilityChecker.checkAvailability(
              number.id,
              scope.date,
              moment(scope.room.checkoutDate).diff(scope.date, 'day'),
              scope.room.id
            ).closed
          }
          return memory[key].indexOf(number.id) === -1;
        }
        scope.filteredRooms = [];
        scope.updateRooms = function(selected_date) {
          if (scope.room && scope.room.checkinDate) {
            scope.min_date = scope.room.checkinDate;
          }

          if (selected_date) {
            scope.date = selected_date;
          }
          if (scope.date && scope.room) {
            scope.filteredRooms = scope.rooms.filter(scope.notBlockedRooms);
          }
        }
        scope.$watch('date', function() {scope.updateRooms()});
        scope.$watch('room', function() {scope.updateRooms()});
        attrs.$observe('id', function(newId) {
          if (newId) {
            memory = {};
            ctrl.init(element, newId);
          }
        });
      }
    };
  }])
  .directive('uiPromptString', function() {
    return {
      restrict: 'E',
      controller: 'UIPromptController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{title}}</div><div class="content"><form name="moneyPromptForm"><md-input-container><label>{{placeholder}}</label><input ng-model="value" name="value" type="text" required></md-input-container></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel"|i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="moneyPromptForm.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiPromptNotes', function() {
    return {
      restrict: 'E',
      controller: 'UIPromptController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal notes-modal"><div class="title">{{title}}</div><div class="content"><form name="moneyPromptForm"><md-input-container><label>Guest Notes</label><textarea ng-model="guest_notes" name="guest_notes" md-no-autogrow="false"></textarea></md-input-container><md-input-container><label>Hotel Notes</label><textarea ng-model="hotel_notes" name="hotel_notes" md-no-autogrow="false"></textarea></md-input-container><md-input-container><label>Housekeeping Notes</label><textarea ng-model="housekeeping_notes" name="housekeeping_notes" md-no-autogrow="false"></textarea></md-input-container></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.buttons.cancel"|i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="moneyPromptForm.$invalid">{{"general.buttons.save"|i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiPromptPassword', function() {
    return {
      restrict: 'E',
      controller: 'UIPromptController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{title}}</div><div class="content"><form name="moneyPromptForm"><md-input-container><label>{{placeholder}}</label><input ng-model="value" name="value" type="password" required></md-input-container></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel"|i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="moneyPromptForm.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiConfirm', function() {
    return {
      restrict: 'E',
      controller: 'UIConfirmController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal buuqit-confirm"><div class="title">{{title}}</div><div class="content" ng-bind-html="text"></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{negative || ("general.confirm.cancel" | i18next)}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()">{{positive || ("general.confirm.confirm" | i18next)}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiAlert', function() {
    return {
      restrict: 'E',
      controller: 'UIConfirmController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal buuqit-alert"><div class="title">{{title}}</div><div class="content">{{text}}</div><div class="md-actions" layout="row"><md-button class="md-raised md-success" ng-click="close()">Ok</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiRequestPayment', ['$rootScope', function($rootScope) {
    return {
      restrict: 'E',
      controller: 'UIRequestPayment',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="content"><form name="requestPaymentForm"><md-input-container><label>{{"common_for_app.confirm.choose_provider_label" | i18next}}</label><md-select ng-model="provider" name="provider"><md-option ng-repeat="provider in providers track by $index" value="{{provider}}">{{names[provider]}}</md-option></md-select></md-input-container><md-input-container><label>Folios</label><md-select ng-model="folio.id" name="folio"><md-option ng-selected="true" ng-click="folioChangeBlank()">Entire booking - Due: {{booking.due}} - {{booking.customer.visibleName}}</md-option><md-option ng-repeat="folio in folios" value="{{folio.id}}" ng-click="folioChange(folio.id)">{{folioDescription(folio)}}</md-option></md-select></md-input-container><md-input-container><label>{{"common_for_app.confirm.amount_to_request_label" | i18next}}</label><input ng-model="value" name="value" type="number" max="{{max_value}}" min="{{min_value}}" required></md-input-container><md-input-container><label>{{"general.other.email_address" | i18next}}</label><input ng-model="address" name="address" type="email" required></md-input-container><md-input-container><label>{{"common_for_app.confirm.subject_label" | i18next}}</label><input ng-model="subject" name="subject" type="text" required></md-input-container><div class="form-group-with-dropins"><label>{{"common_for_app.confirm.mail_body_label" | i18next}}</label><md-menu md-position-mode="target-right target" class="email-dropin-button"><md-button aria-label="{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}" class="md-button" ng-click="openMenu($mdOpenMenu, $event)">Drop In`s</md-button><md-menu-content width="3"><md-menu-item ng-repeat="dropin in dropins"><md-button ng-click="insertDropIn(\'body\', dropin[1])">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu><summernote ng-model="body" height="100" data-role="body"></summernote></div></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel" | i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="requestPaymentForm.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
        scope.names = {
          'wubook' : 'ChannexPCI',
          'stripe' : 'Stripe',
          'stripe_sca' : 'Stripe SCA',
          'omise' : 'Omise',
          'braintree' : 'Braintree',
          'worldpay' : 'WorldPay',
          'payment_express' : 'WindCave',
          'valitor' : 'Valitor',
          'valitor_pay': 'Valitor Pay',
          'wirecard': $rootScope.domain_settings.wirecardName,
          'borgun': 'Borgun'
        };
      }
    };
  }])
  .directive('uiRemoveModal', function() {
    return {
      restrict: 'E',
      controller: 'UIRemoveController',
      scope: {
        onclose: '&'
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{"profile_nav.settings.hotel_profile.taxe_new.confirm.title" | i18next}}</div><div class="content"><div class="text-center" ng-bind-html="message"></div><form name="moneyPromptForm"><md-checkbox ng-model="removeTotally" aria-label="{{"profile_nav.settings.hotel_profile.taxe_new.confirm.aria_label"|i18next}}">{{"profile_nav.settings.hotel_profile.taxe_new.confirm.checkbox"|i18next}}</md-checkbox></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel"|i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="moneyPromptForm.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiChooseSaleChannelModal', function() {
    return {
      restrict: 'E',
      controller: ['$scope', 'UIDialogService', function($scope, UIDialogService) {
        this.init = function(element, id) {
          $scope.isOpened = false;
          $scope.element = element;
          $scope.parent = element.closest('md-dialog');

          var newValue = null;

          $scope.afterOpen = function () {
            newValue = $scope.value;
          };

          $scope.close = function () {
            UIDialogService.close(id);

            if ($scope.cancelCallback && typeof($scope.cancelCallback) === 'function') {
              $scope.cancelCallback();
            }
          };

          $scope.confirm = function () {
            $scope.callback(newValue);
          };

          $scope.onChange = function (value) {
            newValue = value;
          };

          UIDialogService.registerScope(id, $scope);
        };
      }],
      scope: {
        onclose: '&',
      },
      template: '<div><div ng-if="isOpened"><div class="buuqit-modal"><div class="title">{{"dialogs.edit_sale_channel.title" | i18next}}</div><div class="content"><div></div><form name="selectSaleChannel"><sale-channel-input on-change="onChange" value="value" collection="collection"></sale-channel-input></form></div><div class="md-actions" layout="row"><md-button class="md-raised md-warn" ng-click="close()">{{"general.confirm.cancel"|i18next}}</md-button><span flex></span><md-button class="md-raised md-success" ng-click="confirm()" ng-disabled="selectSaleChannel.$invalid">{{"general.confirm.confirm" | i18next}}</md-button></div></div></div></div>',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function (newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  })
  .directive('uiExportCustomersEmail', function() {
    return {
      restrict: 'E',
      controller: 'UIExportCustomersToXLS',
      scope: {
        onclose: '&'
      },
      templateUrl: 'templates/modals/exportCustomersToXLSModal_tpl.html',
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe('id', function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  });

angular.module('buuqit')
.controller('UIPrintRoomsController', ['$scope', 'UIDialogService', function($scope, UIDialogService) {
  this.init = function(element, id, scope) {
    $scope.isOpened = false;
    $scope.element = element;
    $scope.parent = element.closest('md-dialog');
    $scope.printRatePlans = true;
    $scope.printPrices = true;
    $scope.printRoomTypes = true;

    $scope.close = function () {
      UIDialogService.close(id);
      if ($scope.cancelCallback && typeof($scope.cancelCallback) === 'function') {
        $scope.cancelCallback();
      }
    };

    $scope.change = function(field, value) {
      $scope[field] = value
    };

    $scope.print = function () {
      $scope.callback(
        $scope.printRatePlans,
        $scope.printPrices,
        $scope.printRoomTypes
      );
    };

    UIDialogService.registerScope(id, $scope);
  };
}])
.directive('uiPrintRooms', function() {
  return {
    restrict: 'E',
    controller: 'UIPrintRoomsController',
    scope: {
      onclose: '&'
    },
    templateUrl: getTemplatePath('booking_management/uiPrintDialog.html'),
    replace: true,
    transclude: false,
    link: function(scope, element, attrs, ctrl) {
      attrs.$observe('id', function(newId) {
        if (newId) {
          ctrl.init(element, newId, scope);
        }
      });
    }
  };
});
angular
  .module("buuqit")
  .service("StringTransformService", StringTransformService);

function StringTransformService() {
  var snakeToCamel = function(input) {
    if (Array.isArray(input)) {
      return input.map(function(obj) {
        return snakeToCamel(obj);
      });
    } else if (typeof input === 'object' && input !== null) {
      var camelObj = {};
      for (var key in input) {
        if (input.hasOwnProperty(key)) {
          var camelKey = key.replace(/_([a-z])/g, function(match, letter) {
            return letter.toUpperCase();
          });
          camelObj[camelKey] = snakeToCamel(input[key]);
        }
      }
      return camelObj;
    } else {
      return input;
    }
  }
  
  this.snakeToCamel = function(input) {
    return snakeToCamel(input)
  }

  function camelToSnake(input) {
    if (Array.isArray(input)) {
      return input.map(function(obj) {
        return camelToSnake(obj);
      });
    } else if (typeof input === 'object' && input !== null) {
      var snakeObj = {};
      for (var key in input) {
        if (input.hasOwnProperty(key)) {
          var snakeKey = key.replace(/[A-Z]/g, function(letter) {
            return '_' + letter.toLowerCase();
          });
          snakeObj[snakeKey] = camelToSnake(input[key]);
        }
      }
      return snakeObj;
    } else {
      return input;
    }
  }

  this.camelToSnake = function(input) {
    return camelToSnake(input);
  }
}

angular
  .module("buuqit")
  .service('SentryService', SentryService);

  SentryService.$inject = ["$window"];

  function SentryService ($window) {
  
    this.init = function() {
      $window.sentryOnLoad = function() {
        var Sentry = $window.Sentry;
        
        Sentry.init({
          release: $window.VERSION || '1.0.0',
          tracesSampleRate: 0.2,
          replaysSessionSampleRate: 0.1, 
          replaysOnErrorSampleRate: 1.0,
          beforeSend: function(event) {
            // Filter out sensitive data before sending to Sentry
            if (event.request && event.request.headers) {
              delete event.request.headers['AUTHORIZATION'];
            }
            return event;
          }
        });
      };

      var sentryScript = document.createElement('script');
      sentryScript.src = 'https://js.sentry-cdn.com/27cc89fdddc644b781d17148082e5135.min.js';
      sentryScript.crossOrigin = 'anonymous';
      sentryScript.async = true;
      document.head.appendChild(sentryScript);
    }

    this.setUser = function(user) {
      if (!user) return;

      if ($window.Sentry) {
        $window.Sentry.onLoad(function() {
          $window.Sentry.setUser(user);
        });
      }
    };
    this.setContext = function(name, data) {
      if (!name || !data) return;

      if ($window.Sentry) {
        $window.Sentry.onLoad(function() {
          $window.Sentry.setContext(name, data);
        });
      }
    };
  }

angular.module("buuqit").service("Seasons", Seasons);

Seasons.$inject = ["$rootScope", "SeasonFactory", "Globalize"];

function Seasons($rootScope, SeasonFactory, Globalize) {
  var self = this;
  this.list = [];
  this.ranges = [];

  this.load = function() {
    return SeasonFactory.query(
      {},
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      self.list = data;
      self.__fillRanges();
      $rootScope.hotel.seasons = self.list;
      self.list.forEach(function(s) {
        Globalize.loadTranslation(s, 'season');
      })
      return self.list;
    });
  };

  this.set = function(list) {
    this.list = list;
    this.__fillRanges();
  };

  this.removeSeason = function(season) {
    return season.remove().then(function(data) {
      $rootScope.hotel.get().then(function() {
        $rootScope.$broadcast('roomRates:loaded');
        $rootScope.$broadcast('seasons:update');
      });
      return self.load();
    });
  };

  this.removeRange = function(season, range) {
    return season.removeRange(range.id).then(function(data) {
      $rootScope.hotel.get().then(function() {
        $rootScope.$broadcast('roomRates:loaded');
        $rootScope.$broadcast('seasons:update');
      });
      return self.load();
    });
  };

  this.createSeason = function(season) {
    var seasonToSave = angular.copy(season);
    seasonToSave.color = seasonToSave.color.replace('#', '');
    return new SeasonFactory(self.__normalizeSeason(seasonToSave))
      .save()
      .then(function(data) {
        $rootScope.hotel.get().then(function() {
          $rootScope.$broadcast('roomRates:loaded');
          $rootScope.$broadcast('seasons:update');
        });
        self.__fillRanges();
        return data;
      });
  };

  this.updateSeason = function(season) {
    var seasonToSave = angular.copy(season);
    seasonToSave.color = seasonToSave.color.replace('#', '');
    return new SeasonFactory(seasonToSave).save().then(function(data) {
      self.__fillRanges();
      $rootScope.$broadcast('seasons:update');
      return data;
    });
  };

  this.createRange = function(season, range) {
    return season.addRange(range.startDate, range.endDate).then(function(data) {
      self.__fillRanges();
      $rootScope.$broadcast('seasons:update');
      return data;
    });
  };

  this.getSeasonRangeByDate = function(date) {
    var selectedRanges = this.ranges.filter(function(range) {
      return moment(moment(range.startDate).format('YYYY-MM-DD')).toDate() <= new Date(new Date(date).setHours(0,0,0,0)) && moment(moment(range.endDate).format('YYYY-MM-DD')).toDate() >= new Date(new Date(date).setHours(0,0,0,0));
    });

    if (selectedRanges.length > 0) {
      return selectedRanges[0];
    } else {
      return {};
    }
  }
  
  this.getSeasonIDByDate = function(date) {
    return this.getSeasonRangeByDate(date).seasonId;
  }

  this.__normalizeSeason = function(season) {
    var normalized = angular.copy(season);
    normalized.hotelId = $rootScope.hotel.id;
    normalized.seasonRangesAttributes[0].startDate = moment(
      normalized.seasonRangesAttributes[0].startDate
    ).format("YYYY-MM-DD");
    normalized.seasonRangesAttributes[0].endDate = moment(
      normalized.seasonRangesAttributes[0].endDate
    ).format("YYYY-MM-DD");

    return normalized;
  };

  this.__fillRanges = function() {
    this.ranges = _.flatten(this.list.map(function(season) {
      return season.ranges.map(function(range) {
        return {
          id: range.id,
          startDate: _convertToLocalDate(range.startDate),
          endDate: _convertToLocalDate(range.endDate),
          seasonId: season.id,
          seasonTitle: season.title,
          seasonColor: season.color
        };
      });
    }));
  }

  function _convertToLocalDate (dateString) {
    var dateParts = dateString.split('-').map(Number);
    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];
    return new Date(year, month - 1, day);
  }
}

angular
  .module("buuqit")
  .service("SaleChannelStorage", SaleChannelStorage);

SaleChannelStorage.$inject = ["$rootScope", "SaleChannelFactory"];

function SaleChannelStorage($rootScope, SaleChannelFactory) {
  this.load = function () {
    return SaleChannelFactory.query(
      {},
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      $rootScope.hotel.saleChannels = data;

      return data;
    });
  };
}

angular.module("buuqit").service("RoundService", RoundService);

RoundService.$inject = ["$rootScope"];

function RoundService($rootScope) {
  var self = this;

  function toFixed(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
  }

  function getPointsAfterDot() {
    return $rootScope.hotel ? $rootScope.hotel.roundTo : 2;
  }

  function decimalAdjust(type, value, exp) {
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;

    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }

    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));

    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }

  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }

  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }

  this.roundBy_none = function(number) {
    return Number(
      toFixed(
        number,
        getPointsAfterDot()
      )
    );
  }

  this.roundBy_nearest = function(number) {
    return Math.round10(
      number,
      getPointsAfterDot() * -1
    );
  }

  this.roundBy_up = function(number) {
    return Math.ceil10(
      number,
      getPointsAfterDot() * -1
    );
  }

  this.roundBy_down = function(number) {
    return Math.floor10(
      number,
      getPointsAfterDot() * -1
    );
  }

  this.round = function(number) {
    if ($rootScope.hotel) {
      return self['roundBy_'+$rootScope.hotel.roundMethod](number);
    } else {
      return number;
    }
  }
};
angular
  .module("buuqit")
  .service("RoomRatesStorage", RoomRatesStorage);

RoomRatesStorage.$inject = ["$rootScope", "$i18next", "$mdToast", "RoomRateFactory", "RoomRateSeasonFactory"];

function RoomRatesStorage($rootScope, $i18next, $mdToast, RoomRateFactory, RoomRateSeasonFactory) {
  var self = this;
  this.list = [];
  this.loading = false;
  this.toast = undefined;

  this.load = function(message, queryParams) {
    var toastMessage = message ? message : 'common_for_app.room_rate_storage.loading_rates';
    if (this.toast !== undefined) {
      $mdToast.hide(this.toast);
      this.toast = undefined;
    }
    $rootScope.$broadcast('roomRates:start_loading');
    this.loading = true;
    this.toast = $rootScope.notifyWithLoader($i18next.t(toastMessage));

    var defaultParams = {};
    var params = queryParams ? Object.assign(defaultParams, queryParams) : defaultParams;

    return RoomRateFactory.query(
      params,
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      self.list = data;
      $rootScope.hotel.roomRates = data;
      $rootScope.$broadcast('roomRates:loaded');
      return self.list;
    })
    .catch(function(error) {
      console.error('Error while loading room rates', error);
      throw error;
    })
    .finally(function() {
      self.loading = false;
      $mdToast.hide(self.toast);
      self.toast = undefined;
    });
  };

  this.remove = function(roomRate) {
    roomRate.hotelId = $rootScope.hotel.id;
    return new RoomRateFactory(roomRate).remove().then(function(data) {
      if (data.success) {
        return self.load();
      } else {
        console.error('Error while removing room rate', data);
        return {success: false, message: data.msg};
      }
    });
  };

  this.create = function(roomRate) {
    rateCategory = $rootScope.hotel.rateCategories.find(function(rateCategory) {return rateCategory.id == roomRate.rateCategoryId});
    existingRoomRate = $rootScope.hotel.roomRates.find(function(existingRoomRate) {
      return existingRoomRate.rateCategoryId == roomRate.rateCategoryId && existingRoomRate.roomRepresentationId == roomRate.roomRepresentationId && !existingRoomRate.isRemoved
    });

    if (rateCategory && rateCategory.isMultiOccupancyRate && rateCategory.isAutomaticCalculatedRate && !existingRoomRate) {
      roomRate.isDefaultForMultiOccupancy = true;
    }
    roomRate.hotelId = $rootScope.hotel.id;
    return new RoomRateFactory(roomRate)
      .save()
      .then(function(data) {
        self.load();
        return data;
      }, function(response) {
        if (!response.data) {
          response.data = {};
        }
        if (typeof(response.data.success) === 'undefined') {
          response.data.success = false;
          response.data.message = 'Something went wrong!';
          console.error('Error while creating room rate', response);
        }
        return response.data;
      });
  };

  this.update = function(roomRate) {
    roomRate.hotelId = $rootScope.hotel.id;
    return new RoomRateFactory(roomRate).save().then(function(data) {
      return data;
    }, function(response) {
      if (!response.data) {
        response.data = {};
      }
      if (typeof(response.data.success) === 'undefined') {
        response.data.success = false;
        response.data.message = 'Something went wrong!';
        console.error('Error while updating room rate', response);
      }
      return response.data;
    });
  };

  this.updateSeason = function(roomRateSeason) {
    roomRateSeason.hotelId = $rootScope.hotel.id;
    return new RoomRateSeasonFactory(roomRateSeason).save().then(function(data) {
      return data;
    }, function(response) {
      if (!response.data) {
        response.data = {};
      }
      if (typeof(response.data.success) === 'undefined') {
        response.data.success = false;
        response.data.message = 'Something went wrong!';
        console.error('Error while updating room rate season', response);
      }
      return response.data;
    });
  };
}

angular
  .module("buuqit")
  .service("RoomCalculator", RoomCalculator);

RoomCalculator.$inject = ["$rootScope", "$q"];

function RoomCalculator($rootScope, $q) {
  this.$rootScope = $rootScope;
  this.$q = $q;
}

RoomCalculator.prototype.calcNigthsCount = function (dateIn, dateOut) {
  return moment(dateOut).diff(moment(dateIn), 'days');
};

RoomCalculator.prototype.fillNights = function (restrictions, number_of_nights, date_in, roomRateId, roomRate, hotel, booking) {
  var currencyProfile = hotel.currencyProfiles.find(function(currencyProfile) {return currencyProfile.code == roomRate.currencyCode});
  var nights = number_of_nights;
  var dates = [];
  var isForeignAmount = currencyProfile.code != hotel.currency && hotel.foreignInvoicesFeatureEnabled;

  if (typeof(date_in) == 'number') {
    date_in = new Date(date_in);
  }

  if (typeof(date_in) == 'string') {
    date_in = moment(date_in).toDate();
  }

  for (var x = 0; x < nights; x++) {
    dates.push(moment(date_in).add(x, 'd').format('YYYY-MM-DD'));
  }

  if (restrictions) {
    return this.$q(function(resolve) {
      resolve(dates.map(function(date) {
        var price = restrictions[roomRateId][date] && restrictions[roomRateId][date]['rate'] || 0;
        var foreignAmount = undefined;
        if (isForeignAmount) {
          foreignAmount = restrictions[roomRateId][date] && restrictions[roomRateId][date]['rate'] || 0;
          price = price * (booking && booking.foreignCurrencyRate || 1);
        }
        return {
          date: date,
          price: price,
          foreignAmount: foreignAmount,
        };
      }));
    });
  } else {
    return this.$q(function(resolve) {
      resolve(dates.map(function(date) {
        return {
          date: date,
          price: 0,
          foreignAmount: 0
        };
      }));
    });
  }
};

RoomCalculator.prototype.calcTotalPerRoom = function (room) {
  var total = 0;
  var total_foreign = 0;

  for (var night in room.nights) {
    if (room.nights.hasOwnProperty(night)) {
      total += room.nights[night].price;
      total_foreign += room.nights[night].foreignAmount;
    }
  }

  room.total_price = parseFloat(total.toFixed(this.$rootScope.currencyFractionSize));
  room.total_foreign_amount = parseFloat(total_foreign.toFixed(this.$rootScope.currencyFractionSize));
};

angular
  .module("buuqit")
  .service("RestrictionStorage", RestrictionStorage);

RestrictionStorage.$inject = ["$rootScope", "$http", "RestrictionFactory"];

function RestrictionStorage($rootScope, $http, RestrictionFactory) {
  var self = this;
  var ORIGINAL_PREFIX = 'original_';
  var CHANGED_POSTFIX = 'IsChanged';
  var RESTRICTIONS = [
    'availability',
    'rate',
    'minStayThrough',
    'minStayArrival',
    'maxStay',
    'closedToArrival',
    'closedToDeparture',
    'stopSell'
  ];
  this.list = {};
  this.loadResults = {};
  this.dateFrom;
  this.dateTo;

  this.load = function(dateFrom, dateTo) {
    if (!dateFrom || !dateTo) {
      dateFrom = self.dateFrom || moment().format('YYYY-MM-DD');
      dateTo = self.dateTo || moment().add(24, 'days').format('YYYY-MM-DD');
    } else {
      self.dateFrom = dateFrom;
      self.dateTo = dateTo;
    }

    // Limit max range size to prevent huge API calls
    var daysDiff = moment(dateTo).diff(moment(dateFrom), 'days');
    if (daysDiff > 365) {
      console.warn('Date range too large:', daysDiff, 'days. Limiting to 365 days.');
      dateTo = moment(dateFrom).add(365, 'days').format('YYYY-MM-DD');
      self.dateTo = dateTo;
    }

    // Store the promise so other services can wait for it
    self.loadPromise = RestrictionFactory.query(
      {
        date_from: dateFrom,
        date_to: dateTo
      },
      {
        hotelId: $rootScope.hotel.id
      }
    ).then(function(result) {
      self.loadResults = result;
      self.dateFrom = dateFrom;
      self.dateTo = dateTo;
      self.list = self.__mergeList(result);
      self.loadPromise = null;
      return self.list;
    });

    return self.loadPromise;
  };

  this.inventoryLoad = function(dateFrom, dateTo) {
    // Fallback to current range, not cached min/max
    if (!dateFrom || !dateTo) {
      dateFrom = self.dateFrom || moment().format('YYYY-MM-DD');
      dateTo = self.dateTo || moment().add(24, 'days').format('YYYY-MM-DD');
    }

    // Limit max range size to prevent huge API calls
    var daysDiff = moment(dateTo).diff(moment(dateFrom), 'days');
    if (daysDiff > 365) {
      console.warn('InventoryLoad: Date range too large:', daysDiff, 'days. Limiting to 365 days.');
      dateTo = moment(dateFrom).add(365, 'days').format('YYYY-MM-DD');
    }

    return RestrictionFactory.query(
      {
        date_from: dateFrom,
        date_to: dateTo
      },
      {
        hotelId: $rootScope.hotel.id
      }
    ).then(function(result) {
      self.dateFrom = dateFrom;
      self.dateTo = dateTo;
      self.list = self.__mergeList(result);
      return result;
    });
  }

  this.resetChanges = function() {
    Object.keys(self.list).forEach(function(key) {
      Object.keys(self.list[key]).forEach(function(date) {
        RESTRICTIONS.forEach(function(restriction) {
          self.list[key][date][restriction] = self.list[key][date][ORIGINAL_PREFIX + restriction]
          self.list[key][date][restriction + CHANGED_POSTFIX] = false;
        });
      });
    });
  }

  this.saveChanges = function(changes) {
    var changed = [];

    if (!changes) {
      Object.keys(self.list).forEach(function(key) {
        Object.keys(self.list[key]).forEach(function(date) {
          if (RESTRICTIONS.reduce(function(value, restriction) {return value || self.list[key][date][restriction + CHANGED_POSTFIX]}, false)) {
            RESTRICTIONS.forEach(function(restriction) {
              if (self.list[key][date][restriction + CHANGED_POSTFIX]) {
                changed.push({
                  room_rate_id: Number(key),
                  date: date,
                  restriction: restriction,
                  value: self.list[key][date][restriction]
                });
              }
            });
          }
        });
      });
    } else {
      changed = changes;
    }

    return $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/restrictions/mass_save', {
      models: changed
    }).then(function(result) {
      return self.load();
    }).catch(function(error){
      return error.data;
    });
  }

  this.eraseManualChanges = function(dateFrom, dateTo) {
    return $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/restrictions/erase', {
      dateFrom: dateFrom,
      dateTo: dateTo
    }).then(function(result) {
      return self.load(dateFrom, dateTo);
    });
  }

  this.bulkEraseManualChanges = function(roomRateIds, dates, restrictions) {
    return $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/restrictions/bulk_erase', {
      room_rate_ids: roomRateIds,
      dates: dates,
      restrictions: restrictions
    }).then(function(result) {
      return self.load();
    });
  }

  this.removeCustomValue = function(room_rate_id, date, restriction) {
    return $http.post(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/restrictions/remove', {
      room_rate_id: room_rate_id,
      date: date,
      restriction: restriction
    }).then(function(result) {
      return self.load()
    });
  }

  this.__mergeList = function(results) {
    Object.keys(results).forEach(function(key) {
      if (!self.list[key]) {
        self.list[key] = {};
      }

      Object.keys(results[key]).forEach(function(date) {
        if (!self.list[key][date]) {
          self.list[key][date] = {};
        }

        Object.keys(results[key][date]).forEach(function(restriction) {
          self.list[key][date][restriction] = results[key][date][restriction];
          if (restriction.indexOf('IsCustom') == -1) {
            self.list[key][date][ORIGINAL_PREFIX + restriction] = results[key][date][restriction];
          }
          self.list[key][date][restriction + CHANGED_POSTFIX] = false;
        });

        RESTRICTIONS
          .map(function(restriction) {
            return restriction + CHANGED_POSTFIX;
          }).forEach(function(changedRestriction) {
            if (!self.list[key][date][changedRestriction]) { self.list[key][date][changedRestriction] = false; }
          });
      });
    });

    return self.list;
  }

  this.getForDates = function(dates) {
    var keys = Object.keys(this.list);
    out = {};

    keys.forEach(function(key) {
      out[key] = {};
      dates.forEach(function(date) {
        out[key][date] = self.list[key][date];
      })
    });

    return out;
  }
}
angular
  .module("buuqit")
  .service("RelationCalculator", RelationCalculator);

RelationCalculator.$inject = ["RoundService", "CurrencyRate"];

function RelationCalculator(RoundService, CurrencyRate) {
  var strategies = [
    __increaseByAmount,
    __increaseByPercentage,
    __decreaseByAmount,
    __decreaseByPercentage
  ];

  var strategiesString = [
    'increase_by_amount',
    'increase_by_percentage',
    'decrease_by_amount',
    'decrease_by_percentage'
  ];

  this.calc = function(value, strategy, amount, base_currency, target_currency) {
    var exchangeRate = 1;
    var strategyIndex = typeof(strategy) === 'string' ? strategiesString.indexOf(strategy) : strategy;

    if (base_currency !== target_currency) {
      exchangeRate = CurrencyRate.convertByCache(target_currency);
    }

    return RoundService.round(strategies[strategyIndex].call(this, value, amount, exchangeRate));
  }

  function __increaseByAmount(value, amount, exchangeRate) {
    return (value * exchangeRate) + amount;
  }

  function __increaseByPercentage(value, amount, exchangeRate) {
    return ((value * exchangeRate) * (1 + amount / 100));
  }

  function __decreaseByAmount(value, amount, exchangeRate) {
    if (value - amount > 0) {
      return (value * exchangeRate) - amount;
    } else {
      return 0
    }
  }

  function __decreaseByPercentage(value, amount, exchangeRate) {
    return ((value * exchangeRate) * (1 - amount / 100));
  }
}

angular
  .module("buuqit")
  .service('RecaptchaService', RecaptchaService);

  RecaptchaService.$inject = ["$q", "$rootScope"];

  function RecaptchaService ($q, $rootScope) {
    this.execute = function (action) {
      var deferred = $q.defer();

      grecaptcha.ready(function() {
        grecaptcha.execute($rootScope.grecaptcha_site_key, { action: action })
          .then(function(token) {
            deferred.resolve(token);
          })
          .catch(function(error) {
            deferred.reject(error);
          });
      });

      return deferred.promise;
    };
  }

angular.module("buuqit").service("RateCategoriesStorage", RateCategoriesStorage);

RateCategoriesStorage.$inject = ["$rootScope", "$http", "$i18next", "RoomRatesStorage", "RateCategoryFactory", "RoomRateFactory"];

function RateCategoriesStorage($rootScope, $http, $i18next, RoomRatesStorage, RateCategoryFactory, RoomRateFactory) {
  var self = this;
  this.list = [];
  this.roomRateList = [];

  this.load = function() {
    return RateCategoryFactory.query(
      {},
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      self.list = data.rateCategories;
      return self.list;
    });
  };

  this.remove = function(rateCategory) {
    rateCategory.hotelId = $rootScope.hotel.id;
    return new RateCategoryFactory(rateCategory).remove().then(function(data) {
      if (data.success) {
        RoomRatesStorage.load();
        return self.load();
      } else {
        return {success: false, message: data.msg};
      }
    });
  };

  this.create = function(rateCategory) {
    rateCategory.hotelId = $rootScope.hotel.id;
    rateCategory.affectedRoomRates = rateCategory.roomRates;
    rateCategory.isMultiOccupancyRate = !rateCategory.isSingleOccupancyRate;
    rateCategory.startDate = rateCategory.startDateAndEndDateEnabled ? moment(rateCategory.startDateRepresentation).format('YYYY-MM-DD') : null;
    rateCategory.endDate = rateCategory.startDateAndEndDateEnabled ? moment(rateCategory.endDateRepresentation).format('YYYY-MM-DD') : null;
    if (!rateCategory.isAnchored) {
      rateCategory.parentRateCategoryId = null;
    }
    return new RateCategoryFactory(rateCategory)
      .save()
      .then(function(data) {
        $rootScope.hotel.rateCategories.push(data);
        $rootScope.$broadcast('rateCategory:created', data.id);
        RoomRatesStorage.load();
        return data;
      }, function(response) {
        if (!response.data) {
          response.data = {};
        }
        if (typeof(response.data.success) === 'undefined') {
          response.data.success = false;
          response.data.message = 'Something went wrong!';
        }
        return response.data;
      });
  };

  this.update = function(rateCategory) {
    rateCategory.hotelId = $rootScope.hotel.id;
    rateCategory.affectedRoomRates = rateCategory.roomRates;
    rateCategory.isMultiOccupancyRate = !rateCategory.isSingleOccupancyRate;
    if (!rateCategory.startDate && !rateCategory.endDate) {
      rateCategory.startDate = rateCategory.startDateRepresentation ? moment(rateCategory.startDateRepresentation).format('YYYY-MM-DD') : null;
      rateCategory.endDate = rateCategory.endDateRepresentation ? moment(rateCategory.endDateRepresentation).format('YYYY-MM-DD') : null;
    }
    if (!rateCategory.isAnchored) {
      rateCategory.parentRateCategoryId = null;
    }
    return new RateCategoryFactory(rateCategory).save().then(function(data) {
      RoomRatesStorage.load('common_for_app.room_rate_storage.loading_rates_in_background');
      return data;
    }, function(response) {
      return response.data;
    });
  };

  this.updatePriority = function(rateCategory) {
    rateCategory.hotelId = $rootScope.hotel.id;
    return new RateCategoryFactory(rateCategory).updatePriority().then(function(data) {
      return data;
    }, function(response) {
      return response.data;
    });
  }

  this.swapPriority = function(rateCategory, rateCategoryTo, callback) {
    rateCategory.hotelId = $rootScope.hotel.id;
    rateCategory.loading = true;
    rateCategoryTo.loading = true;

    $http.post((new RateCategoryFactory(rateCategory)).$url('swap_priority'), {
      'to' : rateCategoryTo.id,
    }).then(function(response) {
      var data = response.data;
      if (data.success) {
        rateCategory.priority = data.rc1;
        rateCategoryTo.priority = data.rc2;
      } else {
        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
      }
      if (callback && typeof callback === "function") {
        callback();
      }
      rateCategory.loading = false;
      rateCategoryTo.loading = false;
    }, function(error) {
      rateCategory.loading = false;
      rateCategoryTo.loading = false;
      $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
    });
  }

}

angular
  .module('buuqit')
  .service('RateByDateStorage', RateByDateStorage);

RateByDateStorage.$inject = ["$rootScope", "$q", "Seasons", "RestrictionFactory", "RestrictionStorage", "CurrencyRate"];

function RateByDateStorage ($rootScope, $q, Seasons, RestrictionFactory, RestrictionStorage, CurrencyRate) {
  var self = this;

  this.customRates = [];
  this.from_date   = null;
  this.to_date     = null;

  this.__increase_by_amount = function(rate, amount) {
    return rate + amount;
  }


  this.__increase_by_percentage = function(rate, amount) {
    return (rate * (1 + amount / 100)).toFixed(0);
  }


  this.__decrease_by_amount = function(rate, amount) {
    return rate - amount > 0 ? rate - amount : 0;
  }


  this.__decrease_by_percentage = function(rate, amount) {
    return (rate * (1 - amount / 100)).toFixed(0);
  }

  this.__calc_custom_rates = function(result, callback) {
    _.keys(result).forEach(function(key) {
      if (!self.customRates[key]) {
        self.customRates[key] = {};
      }
      _.keys(result[key]).forEach(function(date) {
        self.customRates[key][date] = result[key][date];
      });
    });
    if (typeof(callback) == 'function') {
      callback();
    }
  }


  this.logics = [
    function() {return self.__increase_by_amount.apply(self, arguments)},
    function() {return self.__increase_by_percentage.apply(self, arguments)},
    function() {return self.__decrease_by_amount.apply(self, arguments)},
    function() {return self.__decrease_by_percentage.apply(self, arguments)},
  ];


  this.load = function (from, to, callback, fallback) {
    this.from_date = from;
    this.to_date   = to;

    RestrictionFactory.query(
      {
        date_from: new Date(from) < new Date('2017-01-01') ? moment('2017-01-01').format('YYYY-MM-DD') : moment(from).format('YYYY-MM-DD'),
        date_to: new Date(to) < new Date('2017-01-01') ? moment('2017-01-01').format('YYYY-MM-DD') : moment(to).format('YYYY-MM-DD'),
        restrictions: 'rate'
      },
      {
        hotelId: $rootScope.hotel.id
      }
    ).then(function(result) {
      self.__calc_custom_rates(result, callback);
    }, function() {
      if (typeof(fallback) == 'function') {
        fallback();
      }
    });
  };


  this.syncronizeStorage = function () {
    self.load(self.from_date, self.to_date);
  };


  this.getPriceByDate = function (timestamp, roomRateId) {
    var date = moment(timestamp).format('YYYY-MM-DD');
    var day = (new Date(timestamp)).getDay() > 0 ? (new Date(timestamp)).getDay() - 1 : 6;
    var roomRate = $rootScope.hotel.roomRates.filter(function(el) {return el.id === roomRateId})[0];
    var rate = self.customRates && self.customRates[roomRate.id] && self.customRates[roomRate.id][date] ? self.customRates[roomRate.id][date]['rate'] : null;
    var seasonId = Seasons.getSeasonIDByDate(date);

    if (rate) {
      return Number(rate);
    } else {
      price = 0;
      try {
        price = roomRate.roomRateSeasons.filter(function(rrs) {return rrs.seasonId == seasonId})[0].rate[day];
      } catch (error) {
        console.log(error);
      }
      return parseInt(price);
    }
  };

  this.getPriceByDatePromise = function(timestamps, roomRateId) {
    // if we loaded restrictions in same date range use that data
    // this allows RateByDateStorage.load not to be called inside of room_edit.js upon initialization
    var rsDateFrom = RestrictionStorage.dateFrom ? RestrictionStorage.dateFrom : moment().format('YYYY-MM-DD');
    var rsDateTo = RestrictionStorage.dateTo ? RestrictionStorage.dateTo : moment().format('YYYY-MM-DD');
    var minTimestamp = moment(_.min(timestamps)).format('YYYY-MM-DD');
    var maxTimestamp = moment(_.max(timestamps)).format('YYYY-MM-DD');
    var minTimestampInRSRange = moment(minTimestamp).isSameOrAfter(rsDateFrom);
    var maxTimestampInRSRange = moment(maxTimestamp).isSameOrBefore(rsDateTo);

    if (minTimestampInRSRange && maxTimestampInRSRange) {
      if (RestrictionStorage.loadPromise) {
        return RestrictionStorage.loadPromise.then(function() {
          self.__calc_custom_rates(RestrictionStorage.loadResults);
          return self.getPriceByDatePromise(timestamps, roomRateId);
        });
      } else if (RestrictionStorage.loadResults) {
        self.__calc_custom_rates(RestrictionStorage.loadResults);
      }
    }
    // end
    return $q(function(resolve, reject) {
      var dates = timestamps.map(function(timestamp) { return moment(timestamp).format('YYYY-MM-DD'); });
      var roomRate = $rootScope.hotel.roomRates.filter(function(el) {return el.id === roomRateId})[0];
      var rates = dates.map(function(date) {return self.customRates && self.customRates[roomRate.id] && self.customRates[roomRate.id][date] ? self.customRates[roomRate.id][date]['rate'] : null;});
      var ratesIsValid = rates.reduce(function(out, val) {return out && val !== null}, true);
      var exchangeRate = CurrencyRate.convertByCache(roomRate.currencyCode);
      var resolveFallback = function() {
        resolve(dates.map(function(date, index) {
          var seasonId = Seasons.getSeasonIDByDate(date);
          var day = (new Date(date)).getDay() > 0 ? (new Date(date)).getDay() - 1 : 6;
          var price = 0;
          try {
            price = roomRate.roomRateSeasons.filter(function(rrs) {return rrs.seasonId == seasonId})[0].rate[day];
          } catch (error) {
            console.log(error);
          }

          results = {
            date  : date,
            price : price > 0 ? price / exchangeRate : 0
          }

          if (exchangeRate !== 1) {
            results['foreignAmount'] = price > 0 ? price : 0
          }
          return results
        }));
      };
      var resolveSuccess = function() {
        resolve(dates.map(function(date, index) {
          results = {
            date  : date,
            price : rates[index] / exchangeRate
          }

          if (exchangeRate !== 1) {
            results['foreignAmount'] = rates[index]
          }
          return results
        }));
      };

      if (ratesIsValid) {
        resolveSuccess();
      } else {
        if ($rootScope.networkStatus === true) {
          self.load(
            minTimestamp,
            maxTimestamp,
            function() {
              rates = dates.map(function(date) {return self.customRates && self.customRates[roomRate.id] && self.customRates[roomRate.id][date] ? self.customRates[roomRate.id][date]['rate'] : null;});
              resolveSuccess();
            },
            resolveFallback.bind(this)
          );
        } else {
          resolveFallback();
        }
      }
    });
  }

  $rootScope.$on('network:connect', self.syncronizeStorage);
}

angular
  .module("buuqit")
  .service("NewTaxStorage", NewTaxStorage);

NewTaxStorage.$inject = ["$rootScope", "NewTaxFactory"];

function NewTaxStorage($rootScope, NewTaxFactory) {
  this.load = function () {
    return NewTaxFactory.query(
      {},
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      $rootScope.hotel.newTaxes = data;
      return data;
    });
  };
}

angular
  .module('buuqit')
  .service('NetworkChecker', NetworkChecker);

NetworkChecker.$inject = ["$rootScope", "$i18next", "$http", "$interval", "$location", "$cookies"];

function NetworkChecker ($rootScope, $i18next, $http, $interval, $location, $cookies) {
  var self = this;

  this.checkNetwork = function ( callback ) {
    $http
      .get(SERVER_PATH + '/api/v1/ping')
      .then(function (response) {
        var prev = angular.copy($rootScope.networkStatus);
        $rootScope.networkStatus = response.data.status === 'ok';
        $rootScope.networkStatusDescription = "Online mode";
        if (prev === false) {
          $rootScope.$broadcast('network:connect');
          $('.notification:contains(Loose connection)').trigger('click');
        }
        if (typeof(callback) === 'function') { callback(); }
      }, function (error) {
        if (error.status === 401) {
          if ($location.path() != '/login') {
            $cookies.remove('user', {path: '/'});
            localStorage.removeItem('user');
            window.location.href = "/#/logout";
          }
          $interval.cancel(self.interval);
        } else {
          if ($rootScope.networkStatus === true) {
            $rootScope.notify($i18next.t('common_for_app.notify.loose_connection_with_server_you_work_on_offline_mode_js_str'));
          }
          $rootScope.networkStatus = false;
          $rootScope.networkStatusDescription = "Offline mode";
          if (typeof(callback) === 'function') { callback(); }
        }
      });
  };

  this.run = function () {
    this.interval = $interval(this.checkNetwork, 10000);
  };
}

angular
  .module("buuqit")
  .service("$i18next", $i18next);

$i18next.$inject = ['i18nStorage'];

// PluralResolver based on https://github.com/i18next/i18next/blob/7b6b62a6bc12b863aa70471749066097b00860f4/src/PluralResolver.js

// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
var sets = [
  { lngs: ['ach','ak','am','arn','br','fil','gun','ln','mfe','mg','mi','oc', 'pt', 'pt-BR', 'tg','ti','tr','uz','wa'], nr: [1,2], fc: 1 },

  { lngs: ['af','an','ast','az','bg','bn','ca','da','de','dev','el','en',
      'eo','es','et','eu','fi','fo','fur','fy','gl','gu','ha','hi',
      'hu','hy','ia','it','kn','ku','lb','mai','ml','mn','mr','nah','nap','nb',
      'ne','nl','nn','no','nso','pa','pap','pms','ps','pt-PT','rm','sco',
      'se','si','so','son','sq','sv','sw','ta','te','tk','ur','yo'], nr: [1,2], fc: 2 },

  { lngs: ['ay','bo','cgg','fa','id','ja','jbo','ka','kk','km','ko','ky','lo', 'ms','sah','su','th','tt','ug','vi','wo','zh'], nr: [1], fc: 3 },

  { lngs: ['be','bs', 'cnr', 'dz','hr','ru','sr','uk'], nr: [1,2,5], fc: 4 },

  { lngs: ['ar'], nr: [0,1,2,3,11,100], fc: 5 },
  { lngs: ['cs','sk'], nr: [1,2,5], fc: 6 },
  { lngs: ['csb','pl'], nr: [1,2,5], fc: 7 },
  { lngs: ['cy'], nr: [1,2,3,8], fc: 8 },
  { lngs: ['fr'], nr: [1,2], fc: 9 },
  { lngs: ['ga'], nr: [1,2,3,7,11], fc: 10 },
  { lngs: ['gd'], nr: [1,2,3,20], fc: 11 },
  { lngs: ['is'], nr: [1,2], fc: 12 },
  { lngs: ['jv'], nr: [0,1], fc: 13 },
  { lngs: ['kw'], nr: [1,2,3,4], fc: 14 },
  { lngs: ['lt'], nr: [1,2,10], fc: 15 },
  { lngs: ['lv'], nr: [1,2,0], fc: 16 },
  { lngs: ['mk'], nr: [1,2], fc: 17 },
  { lngs: ['mnk'], nr: [0,1,2], fc: 18 },
  { lngs: ['mt'], nr: [1,2,11,20], fc: 19 },
  { lngs: ['or'], nr: [2,1], fc: 2 },
  { lngs: ['ro'], nr: [1,2,20], fc: 20 },
  { lngs: ['sl'], nr: [5,1,2,3], fc: 21 },
  { lngs: ['he'], nr: [1,2,20,21], fc: 22 }
];

var _rulesPluralsTypes = {
  1: function(n) {return Number(n > 1);},
  2: function(n) {return Number(n != 1);},
  3: function(n) {return 0;},
  4: function(n) {return Number(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);},
  5: function(n) {return Number(n===0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 ? 4 : 5);},
  6: function(n) {return Number((n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2);},
  7: function(n) {return Number(n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);},
  8: function(n) {return Number((n==1) ? 0 : (n==2) ? 1 : (n != 8 && n != 11) ? 2 : 3);},
  9: function(n) {return Number(n >= 2);},
  10: function(n) {return Number(n==1 ? 0 : n==2 ? 1 : n<7 ? 2 : n<11 ? 3 : 4) ;},
  11: function(n) {return Number((n==1 || n==11) ? 0 : (n==2 || n==12) ? 1 : (n > 2 && n < 20) ? 2 : 3);},
  12: function(n) {return Number(n%10!=1 || n%100==11);},
  13: function(n) {return Number(n !== 0);},
  14: function(n) {return Number((n==1) ? 0 : (n==2) ? 1 : (n == 3) ? 2 : 3);},
  15: function(n) {return Number(n%10==1 && n%100!=11 ? 0 : n%10>=2 && (n%100<10 || n%100>=20) ? 1 : 2);},
  16: function(n) {return Number(n%10==1 && n%100!=11 ? 0 : n !== 0 ? 1 : 2);},
  17: function(n) {return Number(n==1 || n%10==1 ? 0 : 1);},
  18: function(n) {return Number(n==0 ? 0 : n==1 ? 1 : 2);},
  19: function(n) {return Number(n==1 ? 0 : n===0 || ( n%100>1 && n%100<11) ? 1 : (n%100>10 && n%100<20 ) ? 2 : 3);},
  20: function(n) {return Number(n==1 ? 0 : (n===0 || (n%100 > 0 && n%100 < 20)) ? 1 : 2);},
  21: function(n) {return Number(n%100==1 ? 1 : n%100==2 ? 2 : n%100==3 || n%100==4 ? 3 : 0); },
  22: function(n) {return Number(n===1 ? 0 : n===2 ? 1 : (n<0 || n>10) && n%10==0 ? 2 : 3); }
};

function createRules() {
  var rules = {};

  sets.forEach(function(set) {
    set.lngs.forEach(function(l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });

  return rules;
}

var simplifyPluralSuffix = true;

function PluralResolver () {
  this.rules = createRules();
}

PluralResolver.prototype.getRule = function (code) {
  return this.rules[code];
};

PluralResolver.prototype.getSuffix = function (code, count) {
  var rule = this.getRule(code);

  if (rule) {
    var idx = rule.plurals(Math.abs(count));
    var suffix = rule.numbers[idx];

    // special treatment for lngs only having singular and plural
    if (simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      if (suffix === 2) {
        suffix = 'plural';
      } else if (suffix === 1) {
        suffix = '';
      }
    }

    if (simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      return suffix.toString();
    }

    return idx.toString();
  }

  return '';
};

var pluralResolver = new PluralResolver();

function getTranslation(input, substitutions, i18nStorage) {
  var key = input;

  if (substitutions) {
    var tokens = Object.keys(substitutions);

    if (tokens.indexOf('count') !== -1) {
      var suffix = pluralResolver.getSuffix(window.language, substitutions.count);

      if (suffix) {
        key = key.concat('_', suffix);
      }
    }
  }

  return i18nStorage.translations[key];
}

function getFallback(input, substitutions, i18nStorage) {
  var key = input;

  if (substitutions) {
    var tokens = Object.keys(substitutions);

    if (tokens.indexOf('count') !== -1) {
      var suffix = pluralResolver.getSuffix('en', substitutions.count);

      if (suffix) {
        key = key.concat('_', suffix);
      }
    }
  }

  return i18nStorage.fallback[key];
}


function $i18next(i18nStorage) {
  var t = function (input, substitutions) {
    var translation = getTranslation(input, substitutions, i18nStorage);

    if (typeof translation === 'undefined') {
      // translations object can be empty if we were not able to load translations or 'dev' translation is chosen
      // if translations are empty then adding missing translations (in that case all translate keys) to missedI18n hangs
      // angular digest loop. Anyway translation can be missed if any other translation present.
      if (Object.keys(i18nStorage.translations).length !== 0 && window.missedI18n.indexOf(input) === -1) {
        window.missedI18n.push(input);
      }

      // Try to use fallback
      if (window.language != 'en') {
        translation = getFallback(input, substitutions, i18nStorage);
      }

      return translation || input;
    }

    if (substitutions) {
      Object.keys(substitutions).forEach(function (key) {
        translation = translation.replace('{{' + key + '}}', substitutions[key]);
      });
    }

    return translation;
  };

  this.i18n = { t: t };
  this.on = function () {};
  this.t = t;

  window.i18next = this;
}

angular
  .module("buuqit")
  .controller("UIHitPayment", [
    "$scope",
    "$i18next",
    "$rootScope",
    "$http",
    "UIDialogService",
    function($scope, $i18next, $rootScope, $http, UIDialogService) {
      var self = this;

      this.saveState = function() {
        localStorage.setItem('hitPayment'+$scope.$parent.booking.id, JSON.stringify({
          isStarted: $scope.isStarted,
          token: $scope.token,
          isComplete: $scope.isComplete,
          inRequest: $scope.inRequest,
          inQuestion: $scope.inQuestion,
          answerIsSended: $scope.answerIsSended,
          latestResult: $scope.latestResult,
          value: $scope.element.find('[name="value"]').val()
        }));
      }

      this.loadState = function() {
        var data = localStorage.getItem('hitPayment'+$scope.$parent.booking.id);
        if (data) {
          data = JSON.parse(data);
          $scope.isStarted = data.isStarted;
          $scope.token = data.token;
          $scope.isComplete = data.isComplete;
          $scope.inRequest = data.inRequest;
          $scope.inQuestion = data.inQuestion;
          $scope.answerIsSended = data.answerIsSended;
          $scope.latestResult = data.latestResult;
          $scope.value = Number(data.value);
          $scope.element.find('[name="value"]').val(Number(data.value));
          self.callNextQuery();
        } else {
          console.log($i18next.t('bookings.hit_payment_modal.nothing_to_load_console_log'));
        }
      }

      this.clearState = function() {
        localStorage.removeItem('hitPayment'+$scope.$parent.booking.id);
      }

      this.initQuery = function() {
        $scope.isStarted = true;
        $scope.inRequest = true;
        $scope.message = $i18next.t('bookings.hit_payment_modal.query_in_progress_message_js_code');
        $http
          .post(
            SERVER_PATH +
              "/api/v1/hotels/" +
              $rootScope.hotel.id +
              "/bookings/" +
              $scope.$parent.booking.id +
              "/init",
            { amount: $scope.element.find('[name="value"]').val() }
          )
          .then(function(response) {
            $scope.inRequest = false;
            $scope.token = response.data.result.Scr.TxnRef[0];
            $scope.latestResult = response.data.result.Scr;
            self.callNextQuery();
          });
      };

      this.checkQuery = function() {
        setTimeout(function() {
          $scope.inRequest = true;
          $http
            .post(
              SERVER_PATH +
                "/api/v1/hotels/" +
                $rootScope.hotel.id +
                "/bookings/" +
                $scope.$parent.booking.id +
                "/check",
              { token: $scope.token }
            )
            .then(function(response) {
              $scope.inRequest = false;
              $scope.latestResult = response.data.result.Scr;
              if ($scope.answerIsSended == false) {
                self.callNextQuery();
              }
            });
        }, 1500);
      };

      this.answerQuery = function(button, answer) {
        $scope.answerIsSended = true;
        $scope.inRequest = true;
        $http
          .post(
            SERVER_PATH +
              "/api/v1/hotels/" +
              $rootScope.hotel.id +
              "/bookings/" +
              $scope.$parent.booking.id +
              "/answer",
            {
              token: $scope.element.find('[name="value"]').val(),
              button: button,
              answer: answer
            }
          )
          .then(function(response) {
            $scope.inRequest = false;
            $scope.answerIsSended = false;
            $scope.latestResult = response.data.result.Scr;
            self.callNextQuery();
          });
      };

      this.createPayment = function(amount, cardType, cardNumber, transactionID) {
        $http
        .post(
          SERVER_PATH +
            "/api/v1/hotels/" +
            $rootScope.hotel.id +
            "/bookings/" +
            $scope.$parent.booking.id +
            "/create_payment",
          {
            amount: amount,
            card_type: cardType,
            card_number: cardNumber,
            transaction: transactionID
          }
        )
        .then(function(response) {
          $rootScope.$broadcast('booking:reload', $scope.$parent.booking.id);
        });
      };

      this.callNextQuery = function() {
        self.showMessage();
        var buttonIsReqired =
          $scope.latestResult.B1 !== undefined &&
          $scope.latestResult.B2 !== undefined &&
          (($scope.latestResult.B1 && $scope.latestResult.B1.en !== "0") ||
            ($scope.latestResult.B2 && $scope.latestResult.B2.en !== "0"));
        var isFinished = $scope.latestResult.Complete === "1";
        var code = String(Number(buttonIsReqired)) + String(Number(isFinished));
        var reactions = {
          "01": self.finish,
          "11": self.finish,
          "10": self.showButtons,
          "00": self.checkQuery
        };

        this.saveState();
        reactions[code]();
      };

      this.finish = function() {
        $scope.isComplete = true;
        console.log('finished');
        if ($scope.latestResult.Result && $scope.latestResult.Result.AP && $scope.latestResult.Result.AP == "1") {
          self.createPayment(
            $scope.element.find('[name="value"]').val(),
            $scope.latestResult.Result.CT,
            $scope.latestResult.Result.CN.substr($scope.latestResult.Result.CN.length - 4, 4),            
            $scope.latestResult.Result.TR
          )
        }
      };

      this.showButtons = function() {
        if ($scope.latestResult.B1.en !== "0") {
          $scope.button1 = $scope.latestResult.B1;
        }
        if ($scope.latestResult.B2.en !== "0") {
          $scope.button2 = $scope.latestResult.B2;
        }
        self.checkQuery();
      };

      this.showMessage = function() {
        $scope.button1 = null;
        $scope.button2 = null;
        console.log($scope.latestResult);
        $scope.message =
          ($scope.latestResult.DL1 ? $scope.latestResult.DL1 : "") +
          "<br />" +
          ($scope.latestResult.DL2 ? $scope.latestResult.DL2 : "") +
          "<br />" +
          ($scope.latestResult.RT ? $scope.latestResult.RT : "");
      };

      this.init = function(element, id) {
        $scope.isOpened = false;
        $scope.element = element;
        $scope.parent = element.closest("md-dialog");
        $scope.subject = $rootScope.hotel.requestPaymentSubject;
        $scope.body = $rootScope.hotel.requestPaymentBody;
        $scope.isStarted = false;
        $scope.token = null;
        $scope.isComplete = false;
        $scope.inRequest = false;
        $scope.inQuestion = false;
        $scope.answerIsSended = false;

        $scope.insertDropIn = function(editor, dropin) {
          angular
            .element('[data-role="' + editor + '"]')
            .summernote("insertText", dropin);
        };

        $scope.openMenu = function($mdOpenMenu, ev) {
          originatorEv = ev;
          $mdOpenMenu(ev);
        };

        $scope.dropins = dropins;

        $scope.close = function() {
          $scope.isStarted = false;
          $scope.message = null;
          $scope.button1 = null;
          $scope.button2 = null;
          $scope.isComplete = false;
          self.clearState();
          UIDialogService.close(id);
        };

        $scope.start = function() {
          $scope.isStarted = true;
          self.initQuery();
        };

        $scope.buttonCallback = function(buttonIndex) {
          self.answerQuery("B" + buttonIndex, $scope["button" + buttonIndex]);
        };

        $scope.afterOpen = function() {
          self.loadState();
        };

        UIDialogService.registerScope(id, $scope);
      };
    }
  ])
  .directive("uiHitPayment", function() {
    return {
      restrict: "E",
      controller: "UIHitPayment",
      scope: {
        onclose: "&"
      },
      templateUrl: getTemplatePath("modals/hitPayment.html"),
      replace: true,
      transclude: false,
      link: function(scope, element, attrs, ctrl) {
        attrs.$observe("id", function(newId) {
          if (newId) {
            ctrl.init(element, newId);
          }
        });
      }
    };
  });

angular
  .module('buuqit')
  .service('GuestDetailsSettingService', GuestDetailsSettingService);

GuestDetailsSettingService.$inject = ['$rootScope', '$http'];

function GuestDetailsSettingService ($rootScope, $http) {
  this.save = function(args) {
    return $http.post(
      SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/guest_details_setting/',
      {
        guest_details_setting: {
          questions: JSON.stringify(args.questions)
        }
      }
    );
  }
}
angular.module("buuqit").service("Globalize", Globalize);

Globalize.$inject = ["$rootScope"];

function Globalize($rootScope) {
  var self = this;

  angular.extend(
    this,
    {
      'locale': '',
      'locales': [],
      'schema': {},
      'updateCurrentTranslation': updateCurrentTranslation,
      'saveTranslation': saveTranslation,
      'loadTranslation': loadTranslation,
      'updateObjectFromTranslation': updateObjectFromTranslation,
      'nextLocale': nextLocale
    })

  if ($rootScope.hotel) {
    self.locale = $rootScope.hotel.locale;
    angular.copy($rootScope.hotel.locales, self.locales);
    angular.copy($rootScope.hotel.schema, self.schema);
  }


  $rootScope.$watch('hotel.locales', function () {
    // TODO: Probably triggers often than needed.
    if ($rootScope.hotel) {
      self.locale = $rootScope.hotel.locale;
      angular.copy($rootScope.hotel.locales, self.locales);
      angular.copy($rootScope.hotel.schema, self.schema);
    }
  });


  function saveTranslation(obj, type, old_locale) {
    if (old_locale === '' || old_locale === undefined) {
      return;
    }
    if (obj.translations == undefined) {
      obj.translations = [];
    }

    translation = obj.translations.filter(function(t) {return t.locale === old_locale})[0];
    if (translation) {
      updateObjectFromTranslation(translation, obj, type)
    } else {
      var translation = updateObjectFromTranslation({}, obj, type);
      translation.locale = old_locale;
      obj.translations.push(translation);
    }
  }


  function loadTranslation(obj, type) {
    if (obj.translations == undefined) {
      obj.translations = [];
    }

    if (self.locale === '' || self.locale === undefined) {
      return;
    }

    new_translation = obj.translations.filter(function(t) {return t.locale === self.locale})[0];
    if (!new_translation) {
      var new_translation = updateObjectFromTranslation({}, {}, type);
      new_translation.locale = self.locale;
      obj.translations.push(new_translation);
    }
    updateObjectFromTranslation(obj, new_translation, type);
  }


  function updateCurrentTranslation(obj, type) {
    if (self.locale === '') {
      return;
    }
    saveTranslation(obj, type, self.locale);
  }


  function updateObjectFromTranslation(dest, src, type) {
    var attributes = angular.isArray(type) ? type : self.schema[type] || [];
    attributes.forEach(function(p) {
      dest[p] = src[p] || '';
    })
    return dest;
  }

  function nextLocale() {
    var index = self.locales.indexOf(self.locale);
    if ((index === -1) || (index == self.locales.length - 1)) {
      self.locale = self.locales[0];
    } else {
      self.locale = self.locales[index + 1];
    }
  }
}

angular
  .module('buuqit')
  .service('FolioTemplateStorage', FolioTemplateStorage);

  FolioTemplateStorage.$inject = ["$rootScope", "FolioTemplateService"];

function FolioTemplateStorage ($rootScope, FolioTemplateService) {
  var self = this;
  
  this.templates = []

  this.load = function () {
    FolioTemplateService
      .getTemplateList()
      .then(function(res) {
        self.templates = res.data.templates
        $rootScope.$broadcast('FolioTemplateStorage:loaded');
      }).catch(function(error) {
        console.error('Failed to load folio templates:', error);
        throw error;
      });
  }

  $rootScope.$on('hotel:loaded', this.load.bind(this));
}
angular
  .module('buuqit')
  .service('FolioTemplateService', FolioTemplateService);

  FolioTemplateService.$inject = ['$rootScope', '$http'];

function FolioTemplateService ($rootScope, $http) {
  this.create = function(params) {
    return $http.post(
      SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/folio_templates',
      { template: {
          html: params.html,
          css: params.css,
          is_active: params.is_active,
          kind: params.kind
        }
      }
    );
  }
  this.getTemplateList = function () {
    return $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/folio_templates')
  }
  this.preview = function(params) {
    return $http.post(
      SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/folio_templates/preview',
      {
        html: params.html,
        css: params.css,
        type: params.type,
        arg: params.arg,
        kind: params.kind
      }
    );
  }
  this.getDefaultTemplate = function (templateType) {
    return $http.get(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/folio_templates/get_default_template?kind=' + templateType)
  }
  this.remove = function (id) {
    return $http.delete(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/folio_templates/' + id)
  }
}
angular.module("buuqit").service("FolioBatchService", FolioBatchService);

FolioBatchService.$inject = ["$rootScope", "$http"];

function FolioBatchService($rootScope, $http) {
  this.convertToInvoice = function(ids) {
    return $http.post(
      SERVER_PATH +
        "/api/v1/hotels/" +
        $rootScope.hotel.id +
        "/folios/batch/convert_to_invoice",
      { ids: ids }
    );
  };

  this.convertToReceipt = function(ids) {
    return $http.post(
      SERVER_PATH +
        "/api/v1/hotels/" +
        $rootScope.hotel.id +
        "/folios/batch/convert_to_receipt",
      { ids: ids }
    );
  };

  this.createPayment = function(ids, notes) {
    return $http.post(
      SERVER_PATH +
        "/api/v1/hotels/" +
        $rootScope.hotel.id +
        "/folios/batch/create_payment",
      { 
        ids: ids,
        notes: notes
      }
    );
  };

  this.createStatement = function(ids) {
    return $http.post(
      SERVER_PATH +
        "/api/v1/hotels/" +
        $rootScope.hotel.id +
        "/statements/create",
      { ids: ids }
    );
  };

  this.createStatementPayment = function(ids) {
    return $http.post(
      SERVER_PATH +
        "/api/v1/hotels/" +
        $rootScope.hotel.id +
        "/statements/create_payment",
      { ids: ids }
    );
  };
}

angular.module("buuqit").service("FixerIO", FixerIO);

FixerIO.$inject = ["$http"];

function FixerIO($http) {
  var self = this;
  var URL = "http://api.fixer.io/latest?base=#{BASE}&symbols=#{TARGET}";

  this.convert = function(base, target) {
    return $http
      .get(URL.replace("#{BASE}", base).replace("#{TARGET}", target))
      .then(function(response) {
        return response.data.rates[target];
      });
  };
}

angular.module('buuqit')
  .provider('$bookingDrawer', function() {
    var drawerComponent;
    var $drawerScope;
    
    this.openDrawer = function(templateUrl, $compile, $document, $rootScope, $templateRequest, locals) {
      // create scope
      $drawerScope = $rootScope.$new();
      // assign props
      $drawerScope.booking = locals.booking;
      $drawerScope.activeTab = locals.activeTab;
      $drawerScope.params = locals.params;
      $drawerScope.closeDrawer = this.closeDrawer;
      // fetch template and append it to DOM
      $templateRequest(templateUrl).then(function(template) {
        drawerComponent = $compile(template)($drawerScope);
        $document.find('body').append(drawerComponent);
      })
    };
    
    this.closeDrawer = function() {
      // Remove the bookingDrawer element from the DOM
      var $drawerComponent = angular.element(drawerComponent);
      if ($drawerComponent.length) {
        $drawerComponent.remove();
        $drawerScope.$destroy();
      }   
    };
    
    this.$get = function() {
      return {
        openDrawer: this.openDrawer,
        closeDrawer: this.closeDrawer
      };
    };
  });
angular
  .module('buuqit')
  .service('DateNotesStorage', DateNotesStorage);

DateNotesStorage.$inject = ["$rootScope", "DateNoteFactory", "$interval", "$filter", "Dates"];

function DateNotesStorage ($rootScope, DateNoteFactory, $interval, $filter, Dates) {
  var self = this;

  this.notes       = [];
  this.from_date   = null;
  this.to_date     = null;
  this.lastUpdated = null;
  this.interval    = null;

  this.load = function (from, to, callback) {
    self.loadFromCache().then(function (cache) {
      self.from_date = from;
      self.to_date   = to;

      if (cache) {
        self.notes = [];
        self.lastUpdated = self.get_last_updated(cache.notes);

        angular.forEach(cache.notes, function ( note ) {
          Dates.setNote(note);
          self.notes.push(new DateNoteFactory(note));
        });

        if (typeof(callback) == 'function') {
          callback();
        }

        if ($rootScope.networkStatus) {
          DateNoteFactory
            .query({
              checkinDate:  cache.from_date,
              checkoutDate: cache.to_date,
              last_update: self.lastUpdated
            }, {
              hotelId: $rootScope.hotel.id
            })
            .then(function(data) {self.parseUpdatedData(data, self);})
            .catch(function(error) {
              console.error('Failed to load date notes:', error);
            });
        }

        var cacheFrom = new Date(cache.from_date),
            cacheTo   = new Date(cache.to_date),
            selfFrom  = new Date(self.from_date),
            selfTo    = new Date(self.to_date);

        if (cacheFrom > selfFrom && $rootScope.networkStatus) {
          DateNoteFactory
            .query({ checkinDate: self.from_date, checkoutDate: cache.from_date }, { hotelId: $rootScope.hotel.id })
            .then(function(data) {self.parseUpdatedData(data, self);})
            .catch(function(error) {
              console.error('Failed to load date notes:', error);
            });
        }

        if (cacheTo < selfTo && $rootScope.networkStatus) {
          DateNoteFactory
            .query({ checkinDate: cache.to_date, checkoutDate: self.to_date}, { hotelId: $rootScope.hotel.id })
            .then(function(data) {self.parseUpdatedData(data, self);})
            .catch(function(error) {
              console.error('Failed to load date notes:', error);
            });
        }
      } else {
        if ($rootScope.networkStatus) {
          DateNoteFactory
            .query({
              checkinDate:  from,
              checkoutDate: to
            }, {
              hotelId: $rootScope.hotel.id
            })
            .then(function (data) {
              self.lastUpdated = self.get_last_updated(data);
              self.notes = data.filter( function (note) { return note.status != 'removed'; });
              self.updateCache();

              if (typeof(callback) == 'function') {
                callback();
              }

              angular.forEach(self.notes, function(note) {
                Dates.setNote(note);
              });
            }).catch(function(error) {
              console.error('Failed to load date notes:', error);
            });
        } else {
          if (typeof(callback) == 'function') {
            callback();
          }
        }
      }
    }).catch(function(error) {
      console.error('Failed to load date notes from cache:', error);
    });
  };

  this.get_last_updated = function(notes) {
    return parseInt(
      String(
        Math.max.apply(
          Math,
          notes
            .map(function(note) {return new Date(note.updatedAt).getTime()})
        )
      )
      .substr(0,10)
    ) || null;
  }

  this.update = function () {
    var last_update = self.get_last_updated(self.notes);

    if ($rootScope.networkStatus && $rootScope.schedulerScrolling === false) {
      DateNoteFactory
        .query({
          checkinDate:  self.from_date,
          checkoutDate: self.to_date,
          last_update: last_update
        }, {
          hotelId: $rootScope.hotel.id
        })
        .then(function(data) {self.parseUpdatedData(data, self);})
        .catch(function(error) {
          console.error('Failed to update date notes:', error);
        });
    }
  };


  this.loadFromCache = function () {
    return localforage.getItem('datenotesCache');
  };


  this.updateCache = function () {
    self.loadFromCache().then(function (oldCache) {
      var cache = {
            notes       : self.notes,
            from_date   : self.from_date,
            to_date     : self.to_date,
            lastUpdated : self.lastUpdated
          };

      if (oldCache !== null) {
        if (new Date(oldCache.from_date) < new Date(cache.from_date)) {
          cache.from_date = oldCache.from_date;
        }

        if (new Date(oldCache.to_date) > new Date(cache.to_date)) {
          cache.to_date = oldCache.to_date;
        }
      }

      localforage.setItem('datenotesCache', cache);
    }).catch(function(error) {
      console.error('Failed to update date notes cache:', error);
    });
  };


  this.parseUpdatedData = function (data, self) {
    angular.forEach(data, function (note) {
      var id    = note.id,
          temp  = self.notes.filter(function (note_el) {return note_el.id == id;})[0],
          index = self.notes.indexOf(temp);

      if (index > -1) {
        self.notes[index] = note;
      } else {
        self.notes.push(note);
      }

      $rootScope.$broadcast('date_notes:update', note);
      Dates.setNote(note);
    });

    self.lastUpdated = self.get_last_updated(self.notes);
    self.updateCache();
  };


  this.get = function (id) {
    return _.filter(self.notes, function (note) {
      return note.id == id;
    })[0];
  };


  this.syncronizeStorage = function () {
    angular.forEach(self.notes, function(note) {
      note.sync();
    });
    angular.forEach($rootScope.removedDateNotes, function(note) {
      note.sync();
    });
    self.update();
  };


  this.getNote = function (date) {
    date = $filter('date')(date, 'yyyy-MM-dd');
    var notes = this.notes.filter(function (note) { return note.date === date && note.status === 'active'; });

    return notes.length > 0 ? notes[0] : null;
  };


  this.getNoteText = function (date) {
    var note = this.getNote(date);
    return note !== null ? note.note : null;
  };


  this.removeNote = function (note) {
    var index = this.notes.indexOf(note);
    var self = this;

    this.notes.splice(index, 1);
    note.destroy(function() {
      note.note = null;
      self.updateCache();
      Dates.removeNote(note);
    });
  };


  this.get_by_id = function (id) {
    DateNoteFactory.get({
      hotelId: $rootScope.hotel.id,
      id: id
    }).then(function(result) {
      self.parseUpdatedData([result], self);
    }).catch(function(error) {
      console.error('Failed to get date note by ID:', error);
    });
  }


  $rootScope.$on('notes:update', this.updateCache);
  $rootScope.$on('network:connect', this.syncronizeStorage);
}

angular.module("buuqit").service("CustomerService", CustomerService);

CustomerService.$inject = ["$rootScope", "$http"];

function CustomerService($rootScope, $http) {
  var baseUrl = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id;

  this.searchForHotel = function(query) {
    return $http.get(this.buildHotelUrl(), this.buildSearchParams(query));
  };

  this.searchForSaleChannel = function(saleChannelId, query) {
    return $http.get(this.buildSaleChannelsUrl(saleChannelId), this.buildSearchParams(query));
  };

  this.buildHotelUrl = function () {
    return baseUrl + '/customers';
  };

  this.buildSaleChannelsUrl = function (saleChannelId) {
    if (saleChannelId) {
      return baseUrl + '/sale_channels/' + saleChannelId + '/available_customers';
    } else {
      return baseUrl + '/sale_channels/available_customers';
    }
  };

  this.buildSearchParams = function (query) {
    return {
      params: {
        query: query,
        page: 0,
        sort_field: 'visible_name',
        sort_direction: 'ASC'
      }
    }
  }
}

angular
  .module("buuqit")
  .service("CustomLog", CustomLog);

CustomLog.$inject = ["$rootScope", "$http"];

function CustomLog($rootScope, $http) {
  var self = this;
  var RESTRICTIONS = {
    'rate': 'CustomRate',
    'min_stay_through': 'CustomMinStayThrough',
    'min_stay_arrival': 'CustomMinStayArrival',
    'max_stay': 'CustomMaxStay',
    'closed_to_arrival': 'CustomClosedToArrival',
    'closed_to_departure': 'CustomClosedToDeparture',
    'stop_sell': 'CustomStopSell',
    'availability': 'CustomAvailability'
  };
  this.page = 0;

  this.load = function(roomRateId, selectedDate, restriction, limit, page) {
    customRestriction = RESTRICTIONS[restriction];

    return $http.get(
      SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/restrictions/logs?date=' + selectedDate + '&restriction=' + customRestriction + '&room_rate_id=' + roomRateId + '&pagination[page]=' + page + '&pagination[limit]=' + limit,
      {}
    ).then(function(result) {
      return result;
    });
  };
}

angular.module("buuqit").service("CurrencyRate", CurrencyRate);

CurrencyRate.$inject = ["$http", "$rootScope"];

function CurrencyRate($http, $rootScope) {
  var self = this;
  var URL = SERVER_PATH + "/api/v1/currency_rate?base=#{BASE}&target=#{TARGET}";
  var rates = null;

  this.convert = function(base, target) {
    return $http
      .get(URL.replace("#{BASE}", base).replace("#{TARGET}", target))
      .then(function(response) {
        return response.data.exchange_rate;
      });
  };

  this.convertByCache = function(target) {
    if ($rootScope.hotel.currency == target) {
      return 1;
    } else {
      if (!rates) {
        this.setExchangeRateHash();
      }

      return rates[target];
    }
  };

  this.setExchangeRateHash = function() {
    rates = $rootScope.hotel.currencyProfiles.reduce(function(acc, el) {
      acc[el.code] = Number(el.realExchangeRate);
      return acc;
    }, {});
  };
}

angular.module("buuqit").service("CurrencyProfiles", CurrencyProfiles);

CurrencyProfiles.$inject = ["$rootScope", "$filter", "CurrencyProfileFactory", "CurrencyRate"];

function CurrencyProfiles($rootScope, $filter, CurrencyProfileFactory, CurrencyRate) {
  var self = this;
  this.list = [];

  this.load = function() {
    return CurrencyProfileFactory.query(
      {},
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      self.list = data;
      self.__updateStorages();
      return self.list;
    });
  };

  this.remove = function(currencyProfile) {
    return currencyProfile.remove().then(function(data) {
      if (data.success) {
        self.list = _.without(self.list, currencyProfile)
        self.__updateStorages();
      } else {
        $rootScope.alert(data.msg);
      }
    });
  };

  this.create = function(currencyProfile) {
    currencyProfile.hotelId = $rootScope.hotel.id;

    return new CurrencyProfileFactory(currencyProfile)
      .save()
      .then(function(data) {
        self.list.push(data);
        self.__updateStorages();
        return data;
      })
      .catch(function(response) {
        $rootScope.alert($filter('stringifyErrors')(response.data.errors));
        throw response;
      });
  };

  this.reload = function(currencyProfile) {
    currencyProfile.get();
  }

  this.update = function(currencyProfile) {
    return currencyProfile.save().then(function(data) {
      self.__updateStorages();
      return data;
    });
  };

  this.__updateStorages = function() {
    $rootScope.hotel.currencyProfiles = self.list;
    CurrencyRate.setExchangeRateHash();
  }
}

angular.module("buuqit").service("ChannexAPI", ChannexAPI);

ChannexAPI.$inject = ["$http", "$rootScope"];

function ChannexAPI($http, $rootScope) {
  var self = this;
  this.url = function(public, secret, isProd, method, apiKey) {
    if (apiKey) {
      return SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/channex_mapping/' + method + '?api_key=' + encodeURIComponent(apiKey) + '&prod=' + isProd;
    } else {
      return SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/channex_mapping/' + method + '?username=' + public + '&password=' + secret + '&prod=' + isProd;
    }
  }

  this.getHotels = function(public, secret, isProd, apiKey) {
    return $http.get(this.url(public, secret, isProd, 'get_hotels', apiKey));
  };

  this.getRoomsAndRates = function(public, secret, isProd, property, apiKey) {
    return $http.get(this.url(public, secret, isProd, 'get_rooms_and_rates', apiKey) + '&property_id=' + property);
  }

  this.createHotel = function(public, secret, isProd, apiKey) {
    return $http.post(this.url(public, secret, isProd, 'create_hotel', apiKey));
  }

  this.createRoomType = function(public, secret, isProd, property, room_representation_id, apiKey) {
    return $http.post(this.url(public, secret, isProd, 'create_room_type', apiKey), {
      property_id: property,
      room_representation_id: room_representation_id
    });
  }

  this.createRatePlan = function(public, secret, isProd, property, room_type, room_rate_id, apiKey) {
    return $http.post(this.url(public, secret, isProd, 'create_rate_plan', apiKey), {
      property_id: property,
      room_type_id: room_type,
      room_rate_id: room_rate_id
    });
  }

  this.installWebhook = function(public, secret, isProd, properties, channel_id, apiKey) {
    var properties_query = '&' + properties.map(function(h) { return 'property_ids[]=' + h; }).join('&');
    var body = {};
    if (channel_id) {
      body['channel_id'] = channel_id;
    }
    return $http.post(this.url(public, secret, isProd, 'install_webhook', apiKey) + properties_query, body);
  }
}

angular
  .module('buuqit')
  .service('CalendarStorage', CalendarStorage);

CalendarStorage.$inject = ["$rootScope", "$http", "BookingStorage", "BlockerStorage", "$q", "$timeout", "$interval"];

function CalendarStorage ($rootScope, $http, BookingStorage, BlockerStorage, $q, $timeout, $interval) {
  var self = this;

  this.loadedPeriods = [];

  this.loadShortRepresentations = true;

  this.storage = {
    shortBookingRooms: [],
    blockers: {},
    bookings: [],
    lastUpdate: null
  };

  this.__updateOfflineStorage = function() {
    var bookingUpdates = this.storage.shortBookingRooms
      .map(function(e) {return e.updatedAt})
      .filter(function(e) {return typeof(e) === 'number' && isFinite(e)});

    var blockerUpdates = Object.values(this.storage.blockers)
      .map(function(e) {return e.updatedAt})
      .filter(function(e) {return typeof(e) === 'number' && isFinite(e)});

    var max_booking_update = bookingUpdates.length > 0 ? Math.max.apply(Math, bookingUpdates) : 0;
    var max_blocker_update = blockerUpdates.length > 0 ? Math.max.apply(Math, blockerUpdates) : 0;

    this.storage.lastUpdate = Math.max(max_booking_update, max_blocker_update) || null;

    localforage.setItem('calendar', this.storage);
    this.updateBookingStorage();
  }

  this.__loadFromStorage = function() {
    var deferred = $q.defer();

    localforage.getItem('calendar')
      .then(function(response) {
        if (response !== null) {
          self.storage = response;

          // Compatibility fix
          if (self.storage.blockers instanceof Array) {
            self.storage.blockers = self.storage.blockers.reduce(function(acc, cur, i) {
              acc[cur.id] = cur;
              return acc;
            }, {});
          }
          $rootScope.$broadcast('calendar:redraw');
        }
        deferred.resolve();
      })
      .catch(function(error) {
        console.error('Error loading calendar data from storage:', error);
        deferred.resolve(); // Resolve despite the error
      });

    return deferred.promise;
  }

  this.fetchUpdates = function() {
    var path = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id;
    var endpoint = path + '/bookings/short';

    this.loadShortRepresentations = true;

    $http({
      method: 'GET',
      url: endpoint,
      params: { lastUpdate: self.storage.lastUpdate }
    })
    .then(function(response) {
      var data = response.data;

      var bookingRooms = self.updateBookingRooms(data.bookingRooms);
      var blockers = self.updateBlockers(data);
      var forRemove = blockers.forRemove.concat(bookingRooms.forRemove);

      self.loadShortRepresentations = false;
      self.__updateOfflineStorage();

      // Batch UI updates for better performance
      $timeout(function () {
        $rootScope.$broadcast('calendar:remove', forRemove);
        $rootScope.$broadcast('calendar:redraw', { bookingRooms: bookingRooms.updatedBookingRooms, blockers: blockers.updatedBlockers });
      });
    })
    .catch(function(error) {
      self.loadShortRepresentations = false;
      console.error('Error fetching calendar updates:', error);
    });
  };

  this.fetchShortRepresentations = function(dateFrom, dateTo, fetchWithPromise) {
    var path = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id;
    var endpoint = path + '/bookings/short';
    var deferred = $q.defer();

    this.loadShortRepresentations = true;

    endpoint += '?date_from=' + dateFrom + '&date_to=' + dateTo;

    if (self.loadedPeriods) {
      var hasLoadedPeriod = self.loadedPeriods.find(function (loadedPeriod) {
        if (loadedPeriod[0] <= $rootScope.current_date_from && $rootScope.current_date_to <= loadedPeriod[1]) {
          return loadedPeriod;
        }
      });

      if (hasLoadedPeriod) {
        self.loadShortRepresentations = false;
        if (fetchWithPromise !== undefined && fetchWithPromise === true) {
          deferred.resolve({ alreadyLoaded: true });
          return deferred.promise;
        }

        return;
      }
    }

    self.loadedPeriods.push([dateFrom, dateTo]);

    $http({
      method: 'GET',
      url: endpoint
    })
    .then(function(response) {
      var data = response.data;

      // Clean up existing data before adding new elements
      self.storage.shortBookingRooms.forEach(function (e) {
        if (e.additional_index !== undefined) {
          e.additional_index = undefined;
        }
      });

      var bookingRooms = self.updateBookingRooms(data.bookingRooms);
      var blockers = self.updateBlockers(data);
      var forRemove = blockers.forRemove.concat(bookingRooms.forRemove);

      // Mark loading as complete
      self.loadShortRepresentations = false;

      // Update offline storage
      self.__updateOfflineStorage();

      // Batch UI updates for better performance
      $timeout(function () {
        $rootScope.$broadcast('calendar:remove', forRemove);
        $rootScope.$broadcast('calendar:redraw', { bookingRooms: bookingRooms.updatedBookingRooms, blockers: blockers.updatedBlockers });
      });

      deferred.resolve(data);
    })
    .catch(function(error) {
      self.loadShortRepresentations = false;
      console.error('Error loading calendar data:', error);
      deferred.reject(error);
    });

    // Return promise if requested
    if (fetchWithPromise === true) {
      return deferred.promise;
    }
  }

  this.loadOneBooking = function(id) {
    var path = SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id;
    this.loadShortRepresentations = true;
    fetch(path + '/bookings/short/'+id, {headers: {'authorization': $http.defaults.headers.common['AUTHORIZATION']}})
      .then(function(response) {
        return response.json()
      })
      .then(function(response) {
        response.bookingRooms.forEach(function(booking) {
          var new_object = self.bookingFromArray(booking);
          var el = self.storage.shortBookingRooms.filter(function(el) {
            return el.id == booking[0];
          });
          if (el.length > 0) {
            var index = self.storage.shortBookingRooms.indexOf(el[0]);
            $rootScope.$broadcast('calendar:remove', [self.storage.shortBookingRooms[index]]);
            self.storage.shortBookingRooms[index] = new_object;
          } else {
            self.storage.shortBookingRooms.push(new_object);
          }
          $rootScope.$broadcast('calendar:redraw', {bookingRooms: [new_object], blockers: []});
        });
        self.loadShortRepresentations = false;
        // Do not update storage if we get one booking. We should update it only with fullUpdate to prevent missing bookings.
        //self.__updateOfflineStorage();
        response.bookingRooms.forEach(self.updateOneBooking);
      });
  }

  this.throttledLoadOneBooking = _.throttle(this.loadOneBooking, 3000);

  this.getShortList = function () {
    return {
      bookingRooms: angular.copy(this.storage.shortBookingRooms),
      blockers: angular.copy(Object.values(this.storage.blockers))
    }
  }


  this.getBookingRoomById = function (id) {
    return BookingStorage.get_room(id);
  }


  this.getBookingById = function (id) {
    return BookingStorage.get(id);
  }

  this.updateOneBooking = function(shortBookingRoom) {
    var bookingRoom = BookingStorage.get_room(shortBookingRoom.id);
    var booking = BookingStorage.get(shortBookingRoom.bookingId);
    var index;

    if (booking) {
      index = booking.rooms.indexOf(booking.rooms.filter(function(el) {
        return el.id == shortBookingRoom.id
      })[0]);
    }

    if (booking && index && booking.rooms && booking.rooms[index]) {
      booking.rooms[index]['status'] = shortBookingRoom.status;
      booking.rooms[index]['occupationStatus'] = shortBookingRoom.occupationStatus;
    }
  }

  this.updateBookingStorage = function() {
    this.storage.shortBookingRooms.forEach(self.updateOneBooking);
  }

  this.updateBooking = function (event, booking_room_id) {
    $timeout(function() {
      var bookingRoom = BookingStorage.get_room(booking_room_id);
      if (bookingRoom == undefined || bookingRoom == null) {
        // We do not have it yet, do not trigger next logic
        return;
      }
      var booking = BookingStorage.get(bookingRoom.bookingId);
      var el = self.storage.shortBookingRooms.filter(function(b) {return b.id == booking_room_id});
      var index = null;
      if (el.length > 0) {
        el = el[0];
        index = self.storage.shortBookingRooms.indexOf(el);
      };

      if (index == null) {
        // We do not have that booking? Something went wrong?
        return;
      };

      $rootScope.$broadcast('calendar:remove', [self.storage.shortBookingRooms[index]]);
      self.storage.shortBookingRooms[index] = {
        id:               bookingRoom.id,
        bookingId:        bookingRoom.bookingId,
        checkinDate:      moment(bookingRoom.checkinDate).format('YYYY-MM-DD'),
        checkoutDate:     moment(bookingRoom.checkoutDate).format('YYYY-MM-DD'),
        nightsCount:      bookingRoom.nights.length,
        roomId:           bookingRoom.roomId,
        guestName:        bookingRoom.guest ? (bookingRoom.guest.lastName + (bookingRoom.guest.firstName ? ', '+bookingRoom.guest.firstName : '')) : "",
        status:           bookingRoom.status,
        paymentStatus:    self.__generatePaymentStatus(booking),
        occupationStatus: bookingRoom.occupationStatus,
        customerType:     self.__generateCustomerType(booking),
        updatedAt:        bookingRoom.updatedAt,
        due:              booking.due,
        adults:           bookingRoom.numberOfAdults,
        children:         bookingRoom.numberOfChildren,
        dontMove:         bookingRoom.dontMove,
        note:             bookingRoom.note,
        housekeepingNote: bookingRoom.housekeepingNote,
        hotelNote:        bookingRoom.hotelNote,
        isModification:   bookingRoom.isModification,
        salesChannel:     booking.saleChannel?booking.saleChannel.code:null,
        icon:             bookingRoom.icon
      };

      $rootScope.$broadcast('calendar:redraw', {bookingRooms: [self.storage.shortBookingRooms[index]], blockers: []});
    }, 10);
  }


  this.__generatePaymentStatus = function(booking) {
    if (booking.total == booking.due && booking.total > 0) {
      return 0;
    } else if (booking.due == 0) {
      return 1;
    } else {
      return 2;
    }
  }

  this.__generateCustomerType = function(booking) {
    return booking.customer && booking.customer.customerType == 1 ? 1 : 0;
  }



  this.createBookingIfNeeded = function(event, booking_id) {
    var bookings = self.storage.shortBookingRooms.filter(function(booking) {
      return booking.bookingId == booking_id
    });

    if (bookings.length > 0) {
      self.reloadBooking(event, {id: booking_id});
    } else {
      self.pushBooking(BookingStorage.get(booking_id));
    }
  }


  this.pushBooking = function(booking) {
    booking.rooms.forEach(function(bookingRoom) {
      if (self.storage.shortBookingRooms.filter(function(el) {return el.id == bookingRoom.id && el.bookingId == bookingRoom.bookingId}).length == 0) {
        self.storage.shortBookingRooms.push({
          id:               bookingRoom.id,
          bookingId:        bookingRoom.bookingId,
          checkinDate:      typeof(bookingRoom.checkinDate) === 'string' ? bookingRoom.checkinDate : moment(bookingRoom.checkinDate).utc().format('YYYY-MM-DD'),
          checkoutDate:     moment(bookingRoom.checkoutDate).utc().format('YYYY-MM-DD'),
          nightsCount:      bookingRoom.nights.length,
          roomId:           bookingRoom.roomId,
          guestName:        bookingRoom.guest ? (bookingRoom.guest.lastName + (bookingRoom.guest.firstName ? ', '+bookingRoom.guest.firstName : '')) : "",
          status:           bookingRoom.status,
          paymentStatus:    self.__generatePaymentStatus(booking),
          occupationStatus: bookingRoom.occupationStatus,
          customerType:     self.__generateCustomerType(booking),
          updatedAt:        bookingRoom.updatedAt,
          due:              booking.due,
          adults:           bookingRoom.numberOfAdults,
          children:         bookingRoom.numberOfChildren,
          dontMove:         bookingRoom.dontMove,
          note:             bookingRoom.note,
          housekeepingNote: bookingRoom.housekeepingNote,
          hotelNote:        bookingRoom.hotelNote,
          isModification:   bookingRoom.isModification,
          salesChannel:     booking.saleChannel?booking.saleChannel.code:null,
          icon:             bookingRoom.icon
        });

        $rootScope.$broadcast('calendar:redraw', {bookingRooms: [self.storage.shortBookingRooms[self.storage.shortBookingRooms.length - 1]], blockers: []});
      }
    });
  }

  this.__removeBooking = function(id) {
    var bookingRooms = self.storage.shortBookingRooms.filter(function(el) { return el.bookingId == id });

    var wasModification = false;

    // Can be empty if we made booking on another device.
    bookingRooms.forEach(function (bookingRoom) {
      self.storage.shortBookingRooms = _.without(self.storage.shortBookingRooms, bookingRoom);
      wasModification = true;
    });

    if (wasModification) {
      $rootScope.$broadcast('calendar:remove', bookingRooms);
    }
  }

  this.replaceBooking = function(event, oldID, booking) {
    self.__removeBooking(oldID);
    self.pushBooking(booking);
  }

  this.reloadBooking = function(event, booking) {
    booking = BookingStorage.get(booking.id);
    self.replaceBooking(event, booking.id, booking);
  }

  this.pushBlocker = function(event, blocker_id) {
    var blocker = BlockerStorage.get(blocker_id);

    self.storage.blockers[blocker.id] = {
      dateFrom: moment(blocker.dateFrom).format('YYYY-MM-DD'),
      dateTo: moment(blocker.dateTo).format('YYYY-MM-DD'),
      id: blocker.id,
      reason: blocker.reason,
      roomId: blocker.roomId,
      status: blocker.status
    };
    $rootScope.$broadcast('calendar:redraw', {blockers: [self.storage.blockers[blocker.id]], bookingRooms: []});
  }

  this.destroyBlocker = function(event, id) {
    var blocker = self.storage.blockers[id];
    if (blocker) {
      delete self.storage.blockers[blocker.id];
      $rootScope.$broadcast('calendar:remove', [blocker]);
      $rootScope.$broadcast('calendar:redraw');
    }
  }

  this.__updateBlocker = function (event, id) {
    var blockerInStorage = self.storage.blockers[id];
    var blocker = angular.copy(BlockerStorage.get(id));

    if (blockerInStorage) {
      $rootScope.$broadcast('calendar:remove', [self.storage.blockers[blocker.id]]);
      self.storage.blockers[blocker.id] = {
        dateFrom: moment(blocker.dateFrom).format('YYYY-MM-DD'),
        dateTo: moment(blocker.dateTo).format('YYYY-MM-DD'),
        id: blocker.id,
        reason: blocker.reason,
        roomId: blocker.roomId,
        status: blocker.status
      }
      $rootScope.$broadcast('calendar:redraw', { blockers: [self.storage.blockers[blocker.id]], bookingRooms: [] });
    }
  }

  this.updateBookingRooms = function (bookingRooms) {
    var updatedBookingRooms = [];

    var forRemove = [];
    bookingRooms.forEach(function(booking) {
      var storedBookings = self.storage.shortBookingRooms.filter(function(b) {
        return b.id == booking[0];
      });
      var item = self.bookingFromArray(booking);

      if (storedBookings.length > 0) {
        forRemove.push(angular.copy(self.storage.shortBookingRooms[self.storage.shortBookingRooms.indexOf(storedBookings[0])]));
        self.storage.shortBookingRooms[self.storage.shortBookingRooms.indexOf(storedBookings[0])] = item;
      } else {
        self.storage.shortBookingRooms.push(item);
      }
      updatedBookingRooms.push(item);
    });

    return {
      updatedBookingRooms: updatedBookingRooms,
      forRemove: forRemove
    };
  }

  this.updateBlockers = function (data) {
    var updatedBlockers = [];
    var forRemove = [];
     // Process blockers
     data.blockers.forEach(function(blocker) {
      var storedBlocker = self.storage.blockers[blocker[0]];
      var item = self.blockerFromArray(blocker);

      if (storedBlocker) {
        forRemove.push(angular.copy(self.storage.blockers[storedBlocker.id]));
        self.storage.blockers[storedBlocker.id] = item;
      } else {
        self.storage.blockers[item.id] = item;
      }
      updatedBlockers.push(item);
    });

    // Process removed blockers
    if (data && data.removedBlockers && data.removedBlockers.length > 0) {
      data.removedBlockers.forEach(function(removedID) {
        var removed = self.storage.blockers[removedID];
        if (removed) {
          forRemove.push(removed);
          delete self.storage.blockers[removed.id];
        }
      });
    } 
    return {
      forRemove: forRemove,
      updatedBlockers: updatedBlockers
    }
  }

  this.bookingFromArray = function (raw) {
    return {
      id:               raw[0],
      bookingId:        raw[1],
      checkinDate:      raw[2],
      checkoutDate:     raw[3],
      nightsCount:      raw[4],
      roomId:           raw[5],
      guestName:        raw[6],
      status:           raw[7],
      paymentStatus:    raw[8],
      occupationStatus: raw[9],
      customerType:     raw[10],
      updatedAt:        raw[11],
      due:              raw[12],
      adults:           raw[13],
      children:         raw[14],
      dontMove:         raw[15],
      note:             raw[16],
      housekeepingNote: raw[17],
      hotelNote:        raw[18],
      salesChannel:     raw[19],
      icon:             raw[20]
    }
  }
  this.blockerFromArray = function (raw) {
    return {
      id:        raw[0],
      roomId:    raw[1],
      dateFrom:  raw[2],
      dateTo:    raw[3],
      reason:    raw[4],
      status:    raw[5],
      updatedAt: raw[6],
      dateFromTimestamp: moment(raw[2]).utc().toDate().setHours(0,0,0,0),
      dateToTimestamp: moment(raw[3]).utc().toDate().setHours(0,0,0,0)
    }
  }
  $rootScope.$on('cache:clear', function() {
    self.loadedPeriods = [];

    var itemsToRemove = self.storage.shortBookingRooms.concat(Object.values(self.storage.blockers));
    self.storage.shortBookingRooms = [];
    self.storage.blockers = {};
    $rootScope.$broadcast('calendar:remove', itemsToRemove);
    $rootScope.$broadcast('calendar:redraw');

    self.fetchShortRepresentations($rootScope.current_date_from, $rootScope.current_date_to);
  });

  $rootScope.$on('BookingStorage:updateIsReady', this.updateBooking.bind(this));
  $rootScope.$on('BookingStorage:loaded_new_booking', this.createBookingIfNeeded.bind(this));
  $rootScope.$on('booking:replace', this.replaceBooking.bind(this));
  $rootScope.$on('booking_management:reload', this.reloadBooking.bind(this));
  $rootScope.$on('CalendarStorage:blocker_destroy', this.destroyBlocker.bind(this));
  $rootScope.$on('CalendarStorage:blocker_update', this.__updateBlocker.bind(this));
  $rootScope.$on('CalendarStorage:blocker_create', this.pushBlocker.bind(this));
}
angular
  .module('buuqit')
  .service('CalendarSettingService', CalendarSettingService);

CalendarSettingService.$inject = ['$rootScope', '$http'];

function CalendarSettingService ($rootScope, $http) {
  this.save = function(args) {
    return $http.post(
      SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/calendar_setting/',
      {
        calendar_setting: {
          blocker_color: args.blockerColor,
          booking_unpaid_color: args.bookingUnpaidColor,
          booking_paid_color: args.bookingPaidColor,
          booking_partially_color: args.bookingPartiallyColor,
          booking_company_color: args.bookingCompanyColor,
          booking_group_color: args.bookingGroupColor,
          weekend_border_color: args.weekendBorderColor,
          use_rounded_corners: args.useRoundedCorners,
          use_shift_display: args.useShiftDisplay,
          use_shift_create: args.useShiftCreate,
          use_fixed_width_zoom: args.useFixedWidthZoom,
          show_seasons_in_calendar: args.showSeasonsInCalendar,
          show_channel_code: args.showChannelCode,
          show_last_name_first: args.showLastNameFirst,
          hide_cancellation_area: args.hideCancellationArea,
          show_waitlist: args.showWaitlist
        }
      }
    );
  }
}

angular
  .module('buuqit')
  .service('BookingsService', BookingsService);

BookingsService.$inject = ['BookingsFactory'];

function transformParams(param) {
  var output = {};

  if (param.pagination) {
    if (param.pagination.limit) {
      output["pagination[limit]"] = param.pagination.limit;
    }
    if (param.pagination.page) {
      output["pagination[page]"] = param.pagination.page;
    }
  }
  for (var key in param) {
    if (key !== "pagination" && param.hasOwnProperty(key)) {
      var snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
      output[snakeKey] = param[key];
    }
  }

  return output;
}

function BookingsService(BookingsFactory) {
  this.getBookings = function (hotelId, params) {
    var transformedParams = transformParams(params);
    return BookingsFactory.query(
      transformedParams,
      { hotelId: hotelId }
    );
  };
}

angular
  .module('buuqit')
  .service('BookingStorage', BookingStorage);

BookingStorage.$inject = ["$rootScope", "$interval", "BookingFactory", "BookingRoomFactory", "Dates"];

function BookingStorage ($rootScope, $interval, BookingFactory, BookingRoomFactory, Dates) {
  var self = this;
  this.bookings      = [];
  this.booking_rooms = [];
  this.from_date     = null;
  this.to_date       = null;
  this.lastUpdated   = null;
  this.interval      = null;
  this.checked_in_bokings = [];
  this.checked_out_bokings = [];

  this.load = function (from, to, callback, ignore_cache) {
    var urlParam = 'latest';
    this.loadFromCache().then(function (cache) {
      self.from_date = from || self.from_date;
      self.to_date   = to || self.to_date;

      if (cache && cache.bookings && cache.bookings.length > 0) {
        if (cache.bookings[0].rooms && cache.bookings[0].rooms[0] && cache.bookings[0].rooms[0].hotelId) {
          if (parseInt(cache.bookings[0].rooms[0].hotelId) != $rootScope.hotel.id) {
            cache = null;
          }
        } else {
          cache = null;
        }
      }

      if (cache && cache.bookings && cache.bookings.length > 0) {
        self.bookings = [];
        self.lastUpdated = self.getLastUpdatedAt();
        $rootScope.bookingsLastUpdated = self.lastUpdated;

        angular.forEach(cache.bookings, function ( booking ) {
          self.bookings.push(new BookingFactory(booking));
        });
        self.prepareBookingsById();
        self.prepareBookingRoomsById();
        self.syncronizeStorage();

        if (typeof(callback) == 'function') {
          callback();
          $rootScope.$broadcast('BookingStorage:loaded');
        }

        if ($rootScope.networkStatus === true) {
          BookingFactory
            .query({
              from:        cache.from_date ? cache.from_date : self.from_date,
              to:          cache.to_date ? cache.to_date : self.to_date,
              last_update: cache.from_date && cache.to_date ? parseInt(String(cache.lastUpdated).substr(0,10)) : null
            }, {
              hotelId: $rootScope.hotel.id,
              urlParam: urlParam
            })
            .then(function(data) {self.parseUpdatedData(data, self);});
        }

        var cacheFrom = new Date(cache.from_date),
            cacheTo   = new Date(cache.to_date),
            selfFrom  = new Date(self.from_date),
            selfTo    = new Date(self.to_date);

        if (cacheFrom > selfFrom && $rootScope.networkStatus === true) {
          BookingFactory
            .query({
              from: self.from_date,
              to: cache.from_date
            }, {
              hotelId: $rootScope.hotel.id,
              urlParam: urlParam
            })
            .then(function(data) {self.parseUpdatedData(data, self);});
        }

        if (cacheTo < selfTo && $rootScope.networkStatus === true) {
          BookingFactory
            .query({
              from: cache.to_date,
              to: self.to_date
            }, {
              hotelId: $rootScope.hotel.id,
              urlParam: urlParam
            })
            .then(function(data) {self.parseUpdatedData(data, self);});
        }
      } else {
        if ($rootScope.networkStatus) {
          BookingFactory
            .query({
              from: from,
              to: to
            }, {
              hotelId: $rootScope.hotel.id,
              urlParam: urlParam
            })
            .then(function (data) {
              self.lastUpdated = self.getLastUpdatedAt();
              $rootScope.bookingsLastUpdated = self.lastUpdated;
              self.bookings = data;
              self.prepareBookingsById();
              self.prepareBookingRoomsById();
              self.updateCache();

              if (typeof(callback) == 'function') {
                callback();
                $rootScope.$broadcast('BookingStorage:loaded');
              }
            });
        } else {
          if (typeof(callback) == 'function') {
            callback();
            $rootScope.$broadcast('BookingStorage:loaded');
          }
        }
      }
    });
  };


  this.loadUpdates = function(date_from, date_to) {
    var urlParam = 'latest';
    var self = this;
    BookingFactory
      .query({
        from: date_from,
        to: date_to
      }, {
        hotelId: $rootScope.hotel.id,
        urlParam: urlParam
      })
      .then(function(data) {self.parseUpdatedData(data, self);});
  }


  this.get_booking_rooms = function () {
    return _.flatten(self.bookings.map(function(booking) {
      return booking.rooms;
    }));
  };


  this.get_room = function(id, booking_id, callback) {
    if(!self.bookingRoomsById)
      self.prepareBookingRoomsById();
    var room = self.bookingRoomsById[id];
    if(callback) {
      if(!room) {
        this.load_by_id(booking_id, false, function(data){
          callback(data.rooms.find(function(booking){ return booking.id == id;}));
        });
      } else {
        callback(room);
      }
    }
    return (room) ? (room.save) ? room : new BookingRoomFactory(room) : room;
  };


  this.get = function (id) {
    var result = self.bookingsById ? self.bookingsById[id] : null;
    return (result) ? (result.save) ? result : new BookingFactory(result) : result;
  };


  this.load_by_id = function (id, openAfterLoad, callback, activeTab, params) {
    $rootScope.$broadcast('livefeed:need_update');
    BookingFactory.get({hotelId: $rootScope.hotel.id, id:id}).then(
      function (data) {
        data.rooms.forEach(function(room) {
          room.checkinDate = self.generateDate(room.checkinDate);
          room.checkoutDate = self.generateDate(room.checkoutDate);
        });

        var el = self.bookings.filter(function (booking) {return booking.id == data.id});

        var preparedBookingData = data;
        preparedBookingData.hasDetails = true;

        if (el.length > 0) {
          self.bookings[self.bookings.indexOf(el[0])] = preparedBookingData;
        } else {
          self.bookings.push(preparedBookingData);
        }
        self.bookingsById = self.bookings.reduce(function(acc, booking) {
          acc[booking.id] = booking;
          return acc;
        }, {});
        self.prepareBookingRoomsById();
        $rootScope.$broadcast('BookingStorage:create', data.id);

        if (openAfterLoad === true) {
          $rootScope.openBookingManagementModal(id, activeTab, params);
        }

        self.updateCache();

        if (typeof(callback) === 'function') {
          callback(data);
        }
      },
      function (error) {
        console.error(error);
      }
    );
  };

  this.load_by_ids = function (ids, callback, immediate) {
    var urlParam = 'latest';

    if (immediate == true) {
      var requiredIDS = ids;
    } else {
      var requiredIDS = ids.filter(function(id) {return self.get(id) === undefined});
    }

    requiredIDS = requiredIDS.filter(function(id) {return String(id).length < 13});

    if (requiredIDS.length > 0) {
      BookingFactory
        .query({
          ids: requiredIDS.join(',')
        }, {
          hotelId: $rootScope.hotel.id,
          urlParam: urlParam
        })
        .then(function(data) {
          self.parseUpdatedData(data, self);
          if (typeof(callback) === 'function') {
            callback();
          }
        });
    } else {
      if (typeof(callback) === 'function') {
        callback();
      }
    }
  }

  this.update = function (self) {
    var urlParam = 'latest';
    var lastUpdatedAt = self.getLastUpdatedAt();
    var lastUpdateParam = parseInt(String(lastUpdatedAt).substr(0,10));

    if ($rootScope.networkStatus && $rootScope.schedulerScrolling === false && !isNaN(lastUpdateParam)) {
      BookingFactory
        .query({
          from:        self.from_date,
          to:          self.to_date,
          last_update: lastUpdateParam
        }, {
          hotelId: $rootScope.hotel.id,
          urlParam: urlParam
        })
        .then(function(data) {
          self.parseUpdatedData(data, self);
        });
    }
  };


  this.loadFromCache = function () {
    return localforage.getItem('bookingCache');
  };

  this.updateCache = function () {
    self.loadFromCache().then(function(oldCache) {
      var cache = {
            bookings    : self.bookings,
            from_date   : self.from_date,
            to_date     : self.to_date,
            lastUpdated : self.getLastUpdatedAt()
          };

      if (oldCache !== null) {
        if (new Date(oldCache.from_date) < new Date(cache.from_date)) {
          cache.from_date = oldCache.from_date;
        }

        if (new Date(oldCache.to_date) > new Date(cache.to_date)) {
          cache.to_date = oldCache.to_date;
        }
      }

      $rootScope.$broadcast('BookingStorage:loaded');
      localforage.setItem('bookingCache', cache);
    });
  };

  this.parseUpdatedData = function (data, self) {
    var messages = [];
    angular.forEach(data, function (booking) {
      var id    = booking.id,
          index = self.bookings.findIndex(function (booking_el) {return booking_el.id == id;});

      booking.rooms.forEach(function(room) {
        room.checkinDate = self.generateDate(room.checkinDate);
        room.checkoutDate = self.generateDate(room.checkoutDate);
      });

      if (index > -1) {
        self.bookings[index].__sync = true;
        self.bookings[index]._load(booking);
        messages.push(['BookingStorage:update_booking', id]);
      } else {
        self.bookings.push(booking);
        messages.push(['BookingStorage:loaded_new_booking', id]);
      }

      self.bookingsById[booking.id] = booking;
      _.forEach(booking.rooms, function(booking_room) {
        self.bookingRoomsById[booking_room.id] = booking_room;
      });
    });

    self.prepareBookingRoomsById();
    self.lastUpdated = self.getLastUpdatedAt();
    $rootScope.bookingsLastUpdated = self.lastUpdated;

    _.forEach(messages, function(message) {
      $rootScope.$broadcast(message[0], message[1]);
    });

    self.updateCache();
  };


  this.syncronizeStorage = _.debounce(function () {
    if ($rootScope.bookingsLastUpdated !== null) {
      angular.forEach(self.bookings, function(booking) {
        booking.sync();
      });

      self.update(self);
    }
  }, 500);


  this.destroyEmptyBookings = function () {
    var emptyBookings = self.bookings.filter(function(el) { return el.rooms.length === 0; });

    _.each(emptyBookings, function(el) {
      self.bookings = _.without(self.bookings, el);
    });
    self.bookingsById = self.bookings.reduce(function(acc, booking) {
      acc[booking.id] = booking;
      return acc;
    }, {});
    self.updateCache();
  };


  this.search = function (search_string) {
    var search_string = search_string.toLowerCase();
    return this.bookings.filter(function(booking) {
      return booking.token.toLowerCase().indexOf(search_string) > -1 || (booking.channelReservationId && String(booking.channelReservationId).indexOf(search_string) > -1);
    });
  };

  this.getLastUpdatedAt = function () {
    return _.max(self.bookings.map(function(el) {return new Date(el.updatedAt).getTime();}));
  };

  this.init = function() {
    this.loadFromCache().then(function (cache) {
      if (cache) {
        self.bookings = cache.bookings;
        self.prepareBookingsById();
        self.prepareBookingRoomsById();
        self.lastUpdated = cache.lastUpdated;
        self.from_date = self.getMinDate();
        self.to_date = self.getMaxDate();
      }

      self.updateCache();
      self.load();
    });
  }

  this.generateDate = function(dateSTR) {
    if (new Date().getTimezoneOffset() > 180) {
      var date = dateSTR.split('-').map(function(e) { return Number(e); });
      return new Date(date[0], date[1] - 1, date[2]);
    } else {
      return new Date(dateSTR);
    }
  }

  this.getMinDate = function() {
    if (self.booking_rooms.length > 0) {
      return moment(Math.min.apply(this, self.booking_rooms.map(function(el) {return new Date(el.checkinDate).getTime()}))).format('YYYY-MM-DD');
    } else {
      return null;
    }
  }

  this.getMaxDate = function() {
    if (self.booking_rooms.length > 0) {
      return moment(Math.max.apply(this, self.booking_rooms.map(function(el) {return new Date(el.checkoutDate).getTime()}))).format('YYYY-MM-DD');
    } else {
      return null;
    }
  }

  this.updateRoom = function(event, id, booking_id) {
    self.bookingsById = self.bookings.reduce(function(acc, booking) {
      acc[booking.id] = booking;
      return acc;
    }, {});
    self.prepareBookingRoomsById();
    $rootScope.$broadcast('BookingStorage:updateIsReady', id, booking_id);
  };

  this.prepareBookingsById = function() {
    self.bookingsById = self.bookings.reduce(function(acc, booking) {
      acc[booking.id] = booking;
      return acc;
    }, {});
  }

  this.prepareBookingRoomsById = function() {
    self.booking_rooms = self.get_booking_rooms();
    self.bookingRoomsById = self.booking_rooms.reduce(function(acc, booking) {
      acc[booking.id] = booking;
      return acc;
    }, {});
  }

  this.clearCache = function () {
    localforage.setItem('bookingCache', null).then(function() {
      self.from_date = null;
      self.to_date = null;
      self.load(Dates.currentStartDate, Dates.currentEndDate);
    })
  };

  $rootScope.$on('cache:clear', this.clearCache);

  $rootScope.$on('bookings:update', function() {
    self.updateCache();
  });
  $rootScope.$on('booking:reload', function (event, bookingId) {
    self.load_by_id(bookingId, false, function(booking) {
      $rootScope.$broadcast('booking_management:reload', booking);
      self.updateCache();
    });
  });

  $rootScope.$on('bookings:destroyEmpty', this.destroyEmptyBookings);
  $rootScope.$on('network:connect', this.syncronizeStorage);
  $rootScope.$on('BookingStorage:update', this.updateRoom.bind(this));
}

angular
  .module('buuqit')
  .service('BlockerStorage', BlockerStorage);

BlockerStorage.$inject = ["$rootScope", "RoomBlockerFactory", "Dates", "$interval"];

function BlockerStorage ($rootScope, RoomBlockerFactory, Dates, $interval) {
  var self = this;

  this.blockers      = [];
  this.from_date     = null;
  this.to_date       = null;
  this.lastUpdated   = null;
  this.interval      = null;


  this.load = function (from, to, callback) {
    self.loadFromCache().then(function (cache) {
      self.from_date = from || self.from_date;
      self.to_date   = to || self.to_date;

      if (cache && cache.blockers && cache.blockers.length > 0) {
        if (parseInt(cache.blockers[0].hotelId) != $rootScope.hotel.id) {
          cache = null;
        }
      }

      if (cache && cache.blockers && cache.blockers.length > 0) {
        self.blockers = [];

        angular.forEach(cache.blockers, function ( blocker ) {
          self.blockers.push(new RoomBlockerFactory(blocker));
        });

        self.lastUpdated = self.getLastUpdatedAt();
        if (_.isNaN(parseInt(self.lastUpdated))) {
          self.lastUpdated = null;
        }
        $rootScope.blockerLastUpdated = self.lastUpdated;

        if (typeof(callback) == 'function') {
          callback();
          $rootScope.$broadcast('BlockerStorage:loaded');
        }

        if ($rootScope.networkStatus) {
          query = {
            checkinDate:  cache.from_date ? cache.from_date : self.from_date,
            checkoutDate: cache.to_date ? cache.to_date : self.to_date,
            last_update: self.lastUpdated
          };

          RoomBlockerFactory
            .query(query, {
              hotelId: $rootScope.hotel.id
            })
            .then(function(data) {self.parseUpdatedData(data, self);});
        }

        var cacheFrom = new Date(cache.from_date),
            cacheTo   = new Date(cache.to_date),
            selfFrom  = new Date(self.from_date),
            selfTo    = new Date(self.to_date);

        if (cacheFrom > selfFrom && $rootScope.networkStatus) {
          RoomBlockerFactory
            .query({ checkinDate: self.from_date, checkoutDate: cache.from_date }, { hotelId: $rootScope.hotel.id })
            .then(function(data) {self.parseUpdatedData(data, self);});
        }

        if (cacheTo < selfTo && $rootScope.networkStatus) {
          RoomBlockerFactory
            .query({ checkinDate: cache.to_date, checkoutDate: self.to_date}, { hotelId: $rootScope.hotel.id })
            .then(function(data) {self.parseUpdatedData(data, self);});
        }
      } else {
        if ($rootScope.networkStatus) {
          RoomBlockerFactory
            .query({ checkinDate:  from, checkoutDate: to }, { hotelId: $rootScope.hotel.id })
            .then(function (data) {
              self.lastUpdated = self.getLastUpdatedAt();
              $rootScope.blockerLastUpdated = self.lastUpdated;
              self.blockers = data.filter( function (blocker) { return blocker.status != 'removed'; });
              self.updateCache();

              if (typeof(callback) == 'function') {
                callback();
                $rootScope.$broadcast('BlockerStorage:loaded');
              }
            });
        } else {
          if (typeof(callback) == 'function') {
            callback();
            $rootScope.$broadcast('BlockerStorage:loaded');
          }
        }
      }
    });
  };


  this.update = function (self) {
    var last_update = parseInt(String(self.lastUpdated).substr(0,10));
    if ($rootScope.networkStatus && $rootScope.schedulerScrolling === false) {
      RoomBlockerFactory
        .query({
          checkinDate:  self.from_date,
          checkoutDate: self.to_date,
          last_update: null
        }, {
          hotelId: $rootScope.hotel.id
        })
        .then(function(data) {self.parseUpdatedData(data, self);});
    }
  };


  this.loadUpdates = function(date_from, date_to) {
    var self = this;
    RoomBlockerFactory
      .query({ checkinDate: date_from, checkoutDate: date_to }, { hotelId: $rootScope.hotel.id })
      .then(function(data) {self.parseUpdatedData(data, self);});
  };


  this.loadFromCache = function () {
    return localforage.getItem('blockersCache')
  };

  this.getLastUpdatedAt = function () {
    return _.max(self.blockers.map(function(el) {return new Date(el.updatedAt).getTime();}));
  };

  this.updateCache = function () {
    self.loadFromCache().then(function(oldCache) {
      var cache = {
            blockers    : self.blockers,
            from_date   : self.from_date,
            to_date     : self.to_date
          };

      if (oldCache !== null) {
        if (new Date(oldCache.from_date) < new Date(cache.from_date)) {
          cache.from_date = oldCache.from_date;
        }

        if (new Date(oldCache.to_date) > new Date(cache.to_date)) {
          cache.to_date = oldCache.to_date;
        }
      }

      $rootScope.$broadcast('BlockerStorage:loaded');
      localforage.setItem('blockersCache', cache);
    });
  };


  this.parseUpdatedData = function (data, self) {
    var messages = [];
    angular.forEach(data, function (blocker) {
      var id    = blocker.id,
          temp  = self.blockers.filter(function (blocker_el) {return blocker_el.id == id;})[0],
          index = self.blockers.indexOf(temp);

      if (blocker.status === 'removed') {
        if (index > -1) {
          self.blockers.splice(index, 1);
          messages.push(['BlockerStorage:destroy', blocker.id]);
        }
      } else {
        if (index > -1) {
          self.blockers[index] = blocker;
          messages.push(['BlockerStorage:update', blocker.id]);
        } else {
          self.blockers.push(blocker);
          messages.push(['BlockerStorage:create', blocker.id]);
        }
      }
    });

    self.lastUpdated = self.getLastUpdatedAt();
    $rootScope.blockerLastUpdated = self.lastUpdated;

    _.forEach(messages, function(message) {
      $rootScope.$broadcast(message[0], message[1]);
    });
    $rootScope.$broadcast('BlockerStorage:load');

    self.updateCache();
  };


  this.get = function (id) {
    return _.filter(self.blockers, function (blocker) {
      return blocker.id == id;
    })[0];
  };


  this.get_by_id = function(id, callback) {
    RoomBlockerFactory
      .get({hotelId: $rootScope.hotel.id, id:id})
      .then(function(response) {
        self.parseUpdatedData([response], self);
        if (typeof(callback) === 'function') {
          callback();
        }
      });
  }


  this.syncronizeStorage = function () {
    angular.forEach(self.blockers, function(blocker) {
      blocker.sync();
    });
    angular.forEach($rootScope.removedBlockers, function(blocker) {
      blocker.sync();
    });
    self.update(self);
  };


  this.removeBlocker = function (scope, blocker) {
    self.blockers.splice(self.blockers.indexOf(blocker), 1);
    self.updateCache();
  };

  this.restore = function(event, blocker) {
    var temp  = self.blockers.filter(function (blocker_el) {return blocker_el.id == blocker.id;})[0];
    var index = self.blockers.indexOf(temp);

    self.blockers[index] = blocker;
  }

  this.getLastUpdatedAt = function () {
    var dates = self.blockers.map(function(el) {return new Date(el.updatedAt).getTime();});
    if (dates.length > 0) {
      return _.max(dates);
    } else {
      return null;
    }
  };

  this.clearCache = function () {
    localforage.setItem('blockersCache', null).then(function() {
      self.from_date = null;
      self.to_date = null;
      self.load(Dates.currentStartDate, Dates.currentEndDate);
    })
  };

  $rootScope.$on('cache:clear', this.clearCache);
  $rootScope.$on('blockers:update', this.updateCache);
  $rootScope.$on('blockers:remove', this.removeBlocker);
  $rootScope.$on('network:connect', this.syncronizeStorage);
  $rootScope.$on('BlockerStorage:restore', this.restore);
  $rootScope.$on('Dates:loaded', function() {
    self.load(Dates.startDate.toDate(), Dates.endDate.toDate());
  });
}

angular
  .module('buuqit')
  .service('AvailabilityChecker', AvailabilityChecker);

AvailabilityChecker.$inject = ["$filter", "BookingStorage", "BlockerStorage", "CalendarStorage"];

function AvailabilityChecker ($filter, BookingStorage, BlockerStorage, CalendarStorage) {
  var MAX_BOOKING_NIGHTS_COUNT = 365;

  this.getHoldedInDate = function (date) {
    var checkin_date = moment(date).toDate(),
        bookingsIntersections;

    bookingsIntersections = $filter('orderBy')(
      $filter('filter')(
        CalendarStorage.storage.shortBookingRooms,
        function (booking_room) {
          var checkin  = moment(booking_room.checkinDate).toDate(),
              checkout = moment(booking_room.checkoutDate).toDate();

          return booking_room.status == 'hold' && ((checkin_date >= checkin && checkin_date < checkout));
        }
      ),
      'checkinDate'
    );

    return bookingsIntersections;
  };

  this.getAvailableRoomsByType = function (totalRooms, availableRooms, roomTypes) {
    var availableRoomsByType = {}

    _.each(roomTypes, function (roomType) {
      roomType.availableRoomsCount = 0
      roomType.availableRooms = []
      roomType.totalRooms = []
      availableRoomsByType[roomType.id] = roomType

    });

    _.each(availableRooms, function (room) {
      if (room.isActive) {
        availableRoomsByType[room.roomTypeId].availableRoomsCount += 1;
        availableRoomsByType[room.roomTypeId].availableRooms.push(room);
      }
    })

    _.each(totalRooms, function (room) {
      availableRoomsByType[room.roomTypeId].totalRooms.push(room);
    })
    return availableRoomsByType
  }

  this.getCanceledInDate = function (date) {
    var checkin_date = moment(date).toDate(),
        bookingsIntersections;

    bookingsIntersections = $filter('orderBy')(
      $filter('filter')(
        CalendarStorage.storage.shortBookingRooms,
        function (booking_room) {
          var checkin  = moment(booking_room.checkinDate).toDate(),
              checkout = moment(booking_room.checkoutDate).toDate();

          return booking_room.status == 'canceled' && ((checkin_date >= checkin && checkin_date < checkout));
        }
      ),
      'checkinDate'
    );

    return bookingsIntersections;
  };

  this.checkAvailability = function (room, in_checkin_date, number_of_nigths, booking_id, blocker_id) {
    if (window.features && window.features.newAvailability) {
      return this.checkAvailabilityNew(room, in_checkin_date, number_of_nigths, booking_id, blocker_id);
    } else {
      return this.checkAvailabilityOld(room, in_checkin_date, number_of_nigths, booking_id, blocker_id);
    }
  }

  this.checkAvailabilityOld = function (room, in_checkin_date, number_of_nigths, booking_id, blocker_id) {
    console.time('checkAvailabilityOld');
    var checkin_date_timestamp = moment(in_checkin_date).utc().toDate().setHours(0,0,0,0);
    var checkin_date = new Date(moment(in_checkin_date).toDate().setHours(0,0,0,0));

    var maxPossibleDateInCalendar = moment(new Date()).add(3*365-3, 'day');
    var daysToMax = maxPossibleDateInCalendar.diff(moment(checkin_date_timestamp), 'days');
    var max_bookings_nights_count = daysToMax < MAX_BOOKING_NIGHTS_COUNT ? daysToMax : MAX_BOOKING_NIGHTS_COUNT;

    var checkout_date  = new Date(moment(checkin_date).add(number_of_nigths, 'day').toDate().setHours(0,0,0,0)),
        checkout_date_timestamp = moment(checkin_date).add(number_of_nigths, 'day').utc().toDate().setHours(0,0,0,0),
        checkin_date_M = moment(checkin_date),
        diffs          = [],
        diff,
        bookingsIntersections, nextBooking = undefined,
        blockersIntersections, nextBlocker = undefined,
        available, closedRoomsByBooking, closedRoomsByBlockers, closed;

    closedRoomsByBooking = $filter('filter')(
      CalendarStorage.storage.shortBookingRooms,
      function (room) {
        if (room.checkinDatePrepared == undefined) {
          room.checkinDatePrepared = new Date(moment(room.checkinDate).toDate().setHours(0,0,0,0));
        }
        if (room.checkoutDatePrepared == undefined) {
          room.checkoutDatePrepared = new Date(moment(room.checkoutDate).toDate().setHours(0,0,0,0));
        }

        var checkin  = room.checkinDatePrepared,
            checkout = room.checkoutDatePrepared;

        if (room.status == 'pending' && room.roomId == room && checkin > checkin_date && room.id != booking_id) {
          if (nextBooking == undefined || checkin < nextBooking.checkinDatePrepared) {
            nextBooking = room;
          }
        }

        return room.id != booking_id && room.status == 'pending' && ((checkin_date >= checkin && checkin_date < checkout) || (checkout_date > checkin && checkout_date < checkout) || (checkin_date <= checkin && checkout <= checkout_date));
      }
    );

    bookingsIntersections = $filter('filter')(
      closedRoomsByBooking,
      function (room) {
        return room.roomId == room;
      }
    );

    closedRoomsByBlockers = $filter('filter')(
      Object.values(CalendarStorage.storage.blockers),
      function (blocker) {
        if (blocker.dateFromTimestamp == undefined) {
          blocker.dateFromTimestamp = moment(blocker.dateFrom).utc().toDate().setHours(0,0,0,0);
        }
        if (blocker.dateToTimestamp == undefined) {
          blocker.dateToTimestamp = moment(blocker.dateTo).utc().toDate().setHours(0,0,0,0);
        }

        var checkin  = blocker.dateFromTimestamp,
            checkout = blocker.dateToTimestamp;
        if (blocker.roomId == room && checkin > checkin_date_timestamp && blocker.id != blocker_id) {
          if (nextBlocker == undefined || checkin < nextBlocker.dateFromTimestamp) {
            nextBlocker = blocker;
          }
        }

        return blocker.id != blocker_id && ((checkin_date_timestamp >= checkin && checkin_date_timestamp < checkout) || (checkout_date_timestamp > checkin && checkout_date_timestamp < checkout) || (checkin_date_timestamp <= checkin && checkout <= checkout_date_timestamp));
      }
    );

    blockersIntersections = $filter('filter')(
      closedRoomsByBlockers,
      function (blocker) {
        return blocker.roomId == room;
      }
    );

    if (nextBooking) {
      diffs.push(moment(nextBooking.checkinDate).diff(checkin_date_M, 'days'));
    } else {
      diffs.push(max_bookings_nights_count);
    }

    if (nextBlocker) {
      diffs.push(moment(nextBlocker.dateFrom).diff(checkin_date_M, 'days'));
    } else {
      diffs.push(max_bookings_nights_count);
    }

    diff      = _.min(diffs);
    available = !Boolean(blockersIntersections.length) && !Boolean(bookingsIntersections.length);
    closed    = [];

    _.each(closedRoomsByBooking, function (room) {
      closed.push(room.roomId);
    });

    _.each(closedRoomsByBlockers, function (room) {
      closed.push(room.roomId);
    });
    console.timeEnd('checkAvailabilityOld');

    return {
      diff      : diff,
      available : available,
      closed    : closed
    };
  };

  this.checkAvailabilityNew = function (room, in_checkin_date, number_of_nigths, booking_id, blocker_id) {
    console.time('checkAvailabilityNew');
    var checkin_date_timestamp = moment(in_checkin_date).utc().toDate().setHours(0,0,0,0);
    var checkin_date = new Date(moment(in_checkin_date).toDate().setHours(0,0,0,0));

    var maxPossibleDateInCalendar = moment(new Date()).add(3*365-3, 'day');
    var daysToMax = maxPossibleDateInCalendar.diff(moment(checkin_date_timestamp), 'days');
    var max_bookings_nights_count = daysToMax < MAX_BOOKING_NIGHTS_COUNT ? daysToMax : MAX_BOOKING_NIGHTS_COUNT;

    var checkout_date  = new Date(moment(checkin_date).add(number_of_nigths, 'day').toDate().setHours(0,0,0,0)),
        checkout_date_timestamp = moment(checkin_date).add(number_of_nigths, 'day').utc().toDate().setHours(0,0,0,0),
        checkin_date_M = moment(checkin_date),
        diffs          = [],
        diff,
        bookingsIntersections, nextBooking = undefined,
        blockersIntersections, nextBlocker = undefined,
        available, closedRoomsByBooking, closedRoomsByBlockers, closed;

    closedRoomsByBooking = $filter('filter')(
      CalendarStorage.storage.shortBookingRooms,
      function (room) {
        if (room.checkinDatePrepared == undefined) {
          room.checkinDatePrepared = moment(room.checkinDate).utc().toDate().setHours(0,0,0,0);
        }
        if (room.checkoutDatePrepared == undefined) {
          room.checkoutDatePrepared = moment(room.checkoutDate).utc().toDate().setHours(0,0,0,0);
        }

        var checkin  = room.checkinDatePrepared,
            checkout = room.checkoutDatePrepared;

        if (room.status == 'pending' && room.roomId == room && checkin > checkin_date_timestamp && room.id != booking_id) {
          if (nextBooking == undefined || checkin < nextBooking.checkinDatePrepared) {
            nextBooking = room;
          }
        }

        return room.id != booking_id && room.status == 'pending' && ((checkin_date_timestamp >= checkin && checkin_date_timestamp < checkout) || (checkout_date_timestamp > checkin && checkout_date_timestamp < checkout) || (checkin_date_timestamp <= checkin && checkout <= checkout_date_timestamp));
      }
    );

    bookingsIntersections = $filter('filter')(
      closedRoomsByBooking,
      function (room) {
        return room.roomId == room;
      }
    );

    closedRoomsByBlockers = $filter('filter')(
      Object.values(CalendarStorage.storage.blockers),
      function (blocker) {
        if (blocker.dateFromTimestamp == undefined) {
          blocker.dateFromTimestamp = moment(blocker.dateFrom).utc().toDate().setHours(0,0,0,0);
        }
        if (blocker.dateToTimestamp == undefined) {
          blocker.dateToTimestamp = moment(blocker.dateTo).utc().toDate().setHours(0,0,0,0);
        }

        var checkin  = blocker.dateFromTimestamp,
            checkout = blocker.dateToTimestamp;
        if (blocker.roomId == room && checkin > checkin_date_timestamp && blocker.id != blocker_id) {
          if (nextBlocker == undefined || checkin < nextBlocker.dateFromTimestamp) {
            nextBlocker = blocker;
          }
        }

        return blocker.id != blocker_id && ((checkin_date_timestamp >= checkin && checkin_date_timestamp < checkout) || (checkout_date_timestamp > checkin && checkout_date_timestamp < checkout) || (checkin_date_timestamp <= checkin && checkout <= checkout_date_timestamp));
      }
    );

    blockersIntersections = $filter('filter')(
      closedRoomsByBlockers,
      function (blocker) {
        return blocker.roomId == room;
      }
    );

    if (nextBooking) {
      diffs.push(moment(nextBooking.checkinDate).diff(checkin_date_M, 'days'));
    } else {
      diffs.push(max_bookings_nights_count);
    }

    if (nextBlocker) {
      diffs.push(moment(nextBlocker.dateFrom).diff(checkin_date_M, 'days'));
    } else {
      diffs.push(max_bookings_nights_count);
    }

    diff      = _.min(diffs);
    available = !Boolean(blockersIntersections.length) && !Boolean(bookingsIntersections.length);
    closed    = [];

    _.each(closedRoomsByBooking, function (room) {
      closed.push(room.roomId);
    });

    _.each(closedRoomsByBlockers, function (room) {
      closed.push(room.roomId);
    });
    console.timeEnd('checkAvailabilityNew');

    return {
      diff      : diff,
      available : available,
      closed    : closed
    };
  };

}

angular
  .module("buuqit")
  .service("AccountingCategoriesStorage", AccountingCategoriesStorage);

AccountingCategoriesStorage.$inject = ["$rootScope", "AccountingCategoryFactory"];

function AccountingCategoriesStorage($rootScope, AccountingCategoryFactory) {
  this.load = function () {
    return AccountingCategoryFactory.query(
      {},
      { hotelId: $rootScope.hotel.id }
    ).then(function(data) {
      $rootScope.hotel.accountingCategories = data.accountingCategories;

      return data;
    });
  };
}

angular.module("buuqit").filter("stringifyErrors", stringifyErrors);

stringifyErrors.$inject = ["$filter"];

function stringifyErrors($filter) {
  return function(errors) {
    return Object.keys(errors)
      .map(function(field) {
        return field + ": " + errors[field].join(",");
      })
      .join(",<br />");
  };
}

angular
  .module('buuqit')
  .filter('prettyTranslate', prettyTranslate);

prettyTranslate.$inject = [
  '$rootScope',
  '$i18next',
  'Globalize'
];

function prettyTranslate ($rootScope, $i18next, Globalize) {
  return function(obj, field) {
    if (Globalize.locale != $rootScope.hotel.locale && obj[field] == '' && obj['translations']) {
      var default_locale = obj['translations'].filter(function(t) {return t.locale == $rootScope.hotel.locale;})
      if (default_locale.length && default_locale[0][field] != '') {
        return $i18next.t('general.other.not_translated');
      }
    }
    return obj[field];
  }
}

angular
  .module('buuqit')
  .filter('normalizeLang', normalizeLang);

normalizeLang.$inject = [];

function normalizeLang () {
  return function (val) {
    val = val.toLowerCase();
    var replacements = {
      'en' : 'gb'
    };
    return replacements.hasOwnProperty(val) ? replacements[val] : val;
  };
}
angular
  .module('buuqit')
  .filter('i18next', i18next);

i18next.$inject = ['$i18next'];

function i18next ($i18next) {
  return function(input, substitutions) {
    return $i18next.t(input, substitutions);
  }
}
angular
  .module('buuqit')
  .filter('getArraySize', getArraySize);

getArraySize.$inject = [];

function getArraySize () {
  return function (val) {
    return _.size(_.without(val, undefined));
  };
}
angular
  .module('buuqit')
  .filter('fillDefaultToCalendarSettings', fillDefaultToCalendarSettings);

fillDefaultToCalendarSettings.$inject = ["$filter", "CALENDAR_SETTINGS"];

function fillDefaultToCalendarSettings ($filter, CALENDAR_SETTINGS) {
  return function (settings) {
    _.keys(settings).forEach(function(key) {
      if (settings[key] == null) {
        settings[key] = CALENDAR_SETTINGS[key];
      }
    });

    return settings;
  };
}
angular
  .module('buuqit')
  .filter('diff', diff);

diff.$inject = [];

function diff () {
  return function (val, oldVal) {
    var diff = JsDiff.diffChars(oldVal, val),
        display = '',
        plainText = '',
        addon = '',
        old;

    diff.forEach(function(part){
      var color = part.added ? 'changed' : '';

      if (!part.removed) {
        if (part.added) {
          old = oldVal.substr(plainText.length, part.value.length);
          addon = ' title="'+old+'" ';
        } else {
          addon = '';
        }
        display += '<span class="'+color+'" '+addon+'>'+part.value+'</span>';
        plainText += part.value;
      }
    });

    return display;
  };
}

angular
  .module('buuqit')
  .filter('dayNameByNumber', dayNameByNumber);

dayNameByNumber.$inject = [];

function dayNameByNumber () {
  return function (number, mode) {
    names = {
      "full"  : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "short" : ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]
    };

    return names[mode][number];
  };
}
angular
.module('buuqit')
.filter('dateToMoment', dateToMoment);

dateToMoment.$inject = ['$rootScope'];

function dateToMoment ($rootScope) {
  return function(date, format, timezone, useHotelTz) {
    if (timezone == 'UTC') {
      return useHotelTz ? moment(date).utc().tz($rootScope.hotel.timezone || 'UTC').format(format) : moment(date).utc().format(format);
    } else {
      return moment(date).format(format);
    }
  }
}
angular
  .module('buuqit')
  .filter('customCurrency', customCurrency);

customCurrency.$inject = ["$filter", "$rootScope"];

function customCurrency ($filter, $rootScope) {
  return function (amount, fractionSize, currencyCode) {
    var currency = $filter('currency');
    if (currencyCode !== undefined) {
      var currencySymbol = currencies.filter(function (el) {
        return el[0] == currencyCode;
      })[0][2]
    }

    var currencySymbol = currencySymbol || $rootScope.currencySymbol;

    if (typeof(fractionSize) === 'undefined') {
      fractionSize = $rootScope.currencyFractionSize;
    }

    if (amount !== undefined) {
      if (String(amount).charAt(0) === "-") {
        return currency(amount, currencySymbol, fractionSize).replace("(", "- ").replace(")", "");
      }
    }

    return currency(amount, currencySymbol, fractionSize);
  };
}

angular
.module('buuqit')
.filter('customArray', customArray);

customArray.$inject = ["$filter"];

function customArray ($filter) {
  return function (list, arrayFilter, element) {
    if (arrayFilter) {
      return $filter("filter")(list, function (listItem) {
        return arrayFilter.indexOf(listItem[element]) != -1;
      });
    }
  };
}
angular
  .module('buuqit')
  .filter('capitalize', capitalize);

capitalize.$inject = ["$filter", "$rootScope"];

function capitalize ($filter, $rootScope) {
  return function (string) {
    return string && string[0] ? string[0].toUpperCase() + string.slice(1) : string;
  };
}

angular
  .module('buuqit')
  .factory('WebsiteDataFactory', WebsiteDataFactory);

WebsiteDataFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function WebsiteDataFactory (railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/website_data",
    name: "data",
    serializer: railsSerializer(function () {
      this.rename('headerText1', 'header_text_1');
      this.rename('headerText2', 'header_text_2');
      this.rename('logo', 'logo_img');
      this.rename('favicon', 'favicon_img');
      this.rename('headerImage', 'header_image_img');
      this.rename('featuresBackgroundImage', 'features_background_image_img');
      this.rename('features', 'website_features_attributes');
      this.rename('footers', 'website_footers_attributes');
      this.rename('questions', 'website_questions_attributes');
      this.rename('rooms', 'website_rooms_attributes');
      this.rename('customRooms', 'website_custom_rooms_attributes');
      this.rename('photos', 'website_custom_room_photos_attributes');
      this.rename('pagePhotos', 'website_page_photos_attributes');
      this.rename('pages', 'website_pages_attributes');
      this.rename('aboutPhotos', 'website_about_photos_attributes');
      this.rename('blogRecords', 'website_blog_records_attributes');
      this.rename('redirects', 'website_redirects_attributes');
      this.rename('domains', 'website_domains_attributes');
      this.rename('websiteLinks', 'website_links_attributes');
      this.rename('websiteTranslations', 'website_translations_attributes');
      this.rename('testimonials', 'website_testimonials_attributes');
    })
  });

  resource.prototype.save = function () {
    var self = this;
    return this.$post(this.$url());
  };

  resource.prototype.publish = function () {
    var self = this;
    return this.$post(this.$url() + '/publish/' + self.lang);
  };

  resource.prototype.langDraft = function (lang) {
    var self = this;
    return this.$post(this.$url() + '/draft/' + lang);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('WaitlistFactory', WaitlistFactory);

WaitlistFactory.$inject = ["railsResourceFactory", "$rootScope"];

function WaitlistFactory (railsResourceFactory, $rootScope) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/booking_waitlists/{{id}}",
    name: "booking_waitlist"
  });

  resource.prototype.sync = function (cb) {
    var self = this;

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(function () {
            self.__sync = true;
            if(cb) cb.apply(null, [self]);
        });
      } else {
        this.update().then(function () {
          self.__sync = true;
          if(cb) cb.apply(null, [self]);
        });
      }
    }

    if (this.for_remove) { this.remove(); }

    return this;
  };

  resource.prototype.save = function (cb) {
    this.__sync = false;
    this.sync(cb);
  };

  resource.prototype.destroy = function (callback) {
    if ($rootScope.networkStatus === true) {
      this.remove().then(function () {
        if (callback && typeof(callback)) {
          callback();
        }
      });
    } else {
      if (this.id !== undefined) {
        this.for_remove = true;
        this.status = 'removed';
        $rootScope.removedWaitlists.push(this);
      }
    }
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('VirtualRoomTypeFactory', VirtualRoomTypeFactory);

VirtualRoomTypeFactory.$inject = ["railsResourceFactory"];

function VirtualRoomTypeFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/virtual_room_types/{{id}}",
    name: "virtual_room_type"
  });

  return resource;
}
angular
  .module('buuqit')
  .factory('UserFactory', UserFactory);

UserFactory.$inject = ["railsResourceFactory"];

function UserFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/users/{{id}}",
    name: "user"
  });

  return resource;
}
angular
  .module('buuqit')
  .factory('TriggersFactory', TriggersFactory);

TriggersFactory.$inject = ["$rootScope", "railsResourceFactory"];

function TriggersFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/triggers/{{id}}",
    name: "trigger",
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('TerminalsFactory', TerminalsFactory);

  TerminalsFactory.$inject = [
  "$rootScope",
  "$http"
];

function TerminalsFactory ($rootScope, $http) {

  return {
    getTerminals: getTerminals,
    createTerminal: createTerminal,
    updateTerminal: updateTerminal,
    deleteTerminal: deleteTerminal,
    pairTerminal: pairTerminal,
    charge: charge,
    refund: refund,
    getPaymentTerminalTransactionStatus: getPaymentTerminalTransactionStatus,
  };

  function getTerminals() {
    return $http.get($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals');
  }

  function createTerminal(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals', data)
  }

  function updateTerminal(data) {
    return $http.put($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals/' + data.payment_terminal.id, data);
  }

  function deleteTerminal(data) {
    return $http.delete($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals/' + data.id);
  }

  function pairTerminal(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals/' + data.id + '/pair_device');
  }

  function charge(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals/' + data.payment.id + '/charge', data)
  }
  function refund(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals/' + data.refund.id + '/refund', data)
  }

  function getPaymentTerminalTransactionStatus(data) {
    return $http.get($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/payment_terminals/' + data.id + '/transactions/' + data.correlationId)
  }

}

angular
  .module("buuqit")
  .factory("StripePromotionCodesFactory", StripePromotionCodesFactory);

StripePromotionCodesFactory.$inject = ["railsResourceFactory"];

function StripePromotionCodesFactory(railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/stripe/verify_promotion_code",
    rootWrapping: false
  });

  resource.prototype.verifyPromotionCode = function (promotionCode) {
    return this.$http({
      method: 'POST',
      url: this.$url(),
      data: {
        promotion_code: promotionCode
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('StripeBillingFactory', StripeBillingFactory);

StripeBillingFactory.$inject = ["railsResourceFactory",];

function StripeBillingFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/billing_portal/sessions",
    rootWrapping: false
  });

  resource.prototype.createBillingPortalSessionUrl = function (hotel_id) {
    return this.$http({
      method: 'POST',
      url: this.$url(),
      data: {
        hotel_id: hotel_id
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('StatementFactory', StatementFactory);

StatementFactory.$inject = ["railsResourceFactory",];

function StatementFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/statements/{{statementId}}",
    name: "statement"
  });

  resource.prototype.generate_statement_pdf = function () {
    return this.get(this.$url());
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('SpecialOfferFactory', SpecialOfferFactory);

SpecialOfferFactory.$inject = ['$http', '$rootScope', 'railsResourceFactory', 'railsSerializer'];

function SpecialOfferFactory ($http, $rootScope, railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/special_offers/{{id}}/",
    name: "special_offer"
  });

  resource.prototype.toggleActive = function () {
    return this.$post(this.$url() + '/toggle_active');
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('SessionFactory', SessionFactory);

SessionFactory.$inject = ["railsResourceFactory"];

function SessionFactory (railsResourceFactory) {
  return railsResourceFactory({
    url: SERVER_PATH + "/api/v1/sessions/{{id}}",
    name: "session"
  });
}
angular.module("buuqit").factory("SeasonFactory", SeasonFactory);

SeasonFactory.$inject = ["$rootScope", "$http", "railsResourceFactory"];

function SeasonFactory($rootScope, $http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/seasons/{{id}}",
    name: "season"
  });

  resource.prototype.addRange = function(startDate, endDate) {
    return $http.post(this.$url() + "/add_range/", {
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD")
    });
  };

  resource.prototype.removeRange = function(rangeId) {
    return this.$delete(this.$url() + "/remove_range/" + rangeId);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('SaleChannelFactory', SaleChannelFactory);

SaleChannelFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function SaleChannelFactory(railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/sale_channels/{{id}}",
    name: "sale_channel",
    serializer: railsSerializer(function () {
      this.exclude('customer');
    })
  });

  resource.prototype.merge = function (sourceIds) {
    return this.$http({
      method: 'POST',
      url: this.$url() + '/merge',
      params: {
        'source_ids[]': sourceIds,
      }
    });
  };

  resource.prototype.isSystem = function () {
    return this.kind === 'system';
  };

  resource.prototype.isCustom = function () {
    return this.kind === 'custom';
  };

  return resource;
}

angular
  .module("buuqit")
  .factory("RoomTypeFactory", RoomTypeFactory);

RoomTypeFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function RoomTypeFactory (railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/room_types/{{id}}",
    name: "room_type"
  });

  resource.prototype.updatePriority = function () {
    return this.$post(this.$url() + '/update_priority');
  };

  return resource;
}

angular
  .module("buuqit")
  .factory("RoomRateFactory", RoomRateFactory);

RoomRateFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function RoomRateFactory(railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/room_rates/{{id}}",
    name: "room_rate"
  });

  return resource;
}

angular
  .module("buuqit")
  .factory("RoomRateSeasonFactory", RoomRateSeasonFactory);

RoomRateSeasonFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function RoomRateSeasonFactory(railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/room_rates/{{roomRateId}}/seasons/{{id}}",
    name: "room_rate_season"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('RoomBlockerFactory', RoomBlockerFactory);

RoomBlockerFactory.$inject = ["$rootScope", "$i18next", "railsResourceFactory"];

function RoomBlockerFactory ($rootScope, $i18next, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/room_blockers/{{id}}?lastUpdateTimestamp={{lastUpdateTimestamp}}",
    name: "room_blocker"
  });

  resource.prototype.save = function () {
    this.id = this.id || String(new Date().getTime());
    if ($rootScope.networkStatus === true) {
      if (this.id === null || this.id === undefined || typeof(this.id) === 'string') {
        this._create();
      } else {
        this._update();
      }
    } else {
      this.__sync = false;
      $rootScope.$broadcast('blockers:update');
    }

    return this;
  };


  resource.prototype._create = function () {
    var self = this,
        oldId = angular.copy(this.id);
    
    this.id = null;
    this.lastUpdateTimestamp = $rootScope.blockerLastUpdated;

    this
      .create()
      .then(
        function () {
          self.__sync = true;
          self.dateFromTimestamp = moment(self.dateFrom).utc().toDate().setHours(0,0,0,0);
          self.dateToTimestamp = moment(self.dateTo).utc().toDate().setHours(0,0,0,0);

          $rootScope.$broadcast('BlockerStorage:destroy', oldId);
          $rootScope.$broadcast('blockers:update');
          $rootScope.$broadcast('CalendarStorage:blocker_create', self.id);
        },
        function (error) {
          self.id = oldId;
          if (error.status !== -1 && error.data.status === 'Error') {
            self.dateFromTimestamp = moment(self.dateFrom).utc().toDate().setHours(0,0,0,0);
            self.dateToTimestamp = moment(self.dateTo).utc().toDate().setHours(0,0,0,0);

            self.status = 'removed';
            $rootScope.$broadcast('blockers:remove', self);
            $rootScope.$broadcast('BlockerStorage:destroy', oldId);
            $rootScope.$broadcast('blockers:update');
            $rootScope.notify(error.data.msg, $i18next.t('general.other.error'));
          }

          if (error.status === -1) {
            self.__sync = false;
          }
        }
      );
  };


  resource.prototype._update = function () {
    var self = this;

    this.lastUpdateTimestamp = $rootScope.blockerLastUpdated;

    this
      .update()
      .then(
        function () {
          self.dateFromTimestamp = moment(self.dateFrom).utc().toDate().setHours(0,0,0,0);
          self.dateToTimestamp = moment(self.dateTo).utc().toDate().setHours(0,0,0,0);

          self.__sync = true;
          $rootScope.$broadcast('BlockerStorage:update', self.id);
          $rootScope.$broadcast('CalendarStorage:blocker_update', self.id);
          $rootScope.$broadcast('blockers:update');
        },
        function (error) {
          if (error.data.status === 'Error') {  
            self.dateFrom = self.prevDateFrom;
            self.dateTo = self.prevDateTo;
            self.dateFromTimestamp = moment(self.dateFrom).utc().toDate().setHours(0,0,0,0);
            self.dateToTimestamp = moment(self.dateTo).utc().toDate().setHours(0,0,0,0);

            self.roomId = self.prevRoomId;
            self.reason = self.prevReason;
            $rootScope.notify(error.data.msg, $i18next.t('general.other.error'));
            self.__sync = true;

            $rootScope.$broadcast('blockers:update');
            $rootScope.$broadcast('BlockerStorage:restore', self);
            $rootScope.$broadcast('BlockerStorage:update', self.id);
            $rootScope.$broadcast('CalendarStorage:blocker_update', self.id);
          }
        }
      );
  };


  resource.prototype.sync = function () {
    if (typeof(this.id) === 'string') { this.save(); }
    if (this.__sync === false) { this.save(); }
    if (this.__remove === true) { this.remove(); }
  };


  resource.prototype.destroy = function () {
    var self = this;
    $rootScope.$broadcast('CalendarStorage:blocker_destroy', self.id);
    if ($rootScope.networkStatus === true) {
      this.remove().then(function () {}, function (error) {
        if (error.status === 0) {
          self.__remove = true;
          $rootScope.removedBlockers.push(self);
        }
      });
    } else {
      if (typeof(this.id) === 'number') {
        this.__remove = true;
        $rootScope.removedBlockers.push(this);
      }
    }
  };


  return resource;
}
angular
  .module("buuqit")
  .factory("RoomFactory", RoomFactory);

RoomFactory.$inject = ["$rootScope", "railsResourceFactory", "$http"];

function RoomFactory ($rootScope, railsResourceFactory, $http) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/rooms/{{id}}",
    name: "room"
  });

  resource.prototype.change_clean_status = function(clean_status, hk_note){
    return this.$http({
      method: 'POST',
      url: this.$url() + '/change_room_clean_status',
      data: {
        'clean_status': clean_status,
        'housekeeper_note': hk_note,
      }
    });
  }

  resource.prototype.change_dnd_status = function(status) {
    return this.$http({
      method: 'POST',
      url: this.$url() + '/change_do_not_distrub_status',
      data: {
        'do_not_disturb': status
      }
    });
  }
 
  resource.prototype.move = function (position) {
    return this.$post(this.$url() + '/move/', {position: 'asd'});
  };

  resource.prototype.sync = function () {
    var self = this;

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(function () {self.__sync = true;});
      } else {
        this.update().then(function () {self.__sync = true;});
      }
    }

    if (this.for_remove) { this.remove().then(function () {$rootScope.hotel.touch();}); }

    return this;
  };

  resource.prototype.save = function () {
    this.__sync = false;
    this.sync();
  };

  resource.prototype.destroy = function () {
    if ($rootScope.networkStatus === true) {
      this.remove();
    } else {
      this.for_remove = true;
      $rootScope.removedRooms.push(this);
    }
  };

  resource.prototype.multipleCreate = function (model) {
    return $http.post(this.$url(), {room: {
      available_online: model.availableOnline,
      hotel_id: model.hotelId,
      is_active: model.isActive,
      loading: model.loading,
      number: model.number,
      priority: model.priority,
      property_id: model.propertyId,
      room_type_id: model.roomTypeId,
      common_door_name: model.commonDoorName,
      key_code: model.keyCode
    }});
  };

  return resource;
}

angular
  .module("buuqit")
  .factory("RestrictionFactory", RestrictionFactory);

RestrictionFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function RestrictionFactory(railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/restrictions/",
    name: "restrictions"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('RegistrationFactory', RegistrationFactory);

RegistrationFactory.$inject = ["railsResourceFactory"];

function RegistrationFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/registration",
    name: "registration"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('RecursionHelper', ['$compile', function($compile){
    return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function(element, link){
            // Normalize the link parameter
            if(angular.isFunction(link)){
                link = { post: link };
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function(scope, element){
                    // Compile the contents
                    if(!compiledContents){
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function(clone){
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if(link && link.post){
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    };
}]);
angular
  .module('buuqit')
  .factory('ReactionsFactory', ReactionsFactory);

ReactionsFactory.$inject = ["$rootScope", "railsResourceFactory", "railsSerializer"];

function ReactionsFactory ($rootScope, railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reactions/{{id}}",
    name: "reaction",
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('ReactionTasksFactory', ReactionTasksFactory);

ReactionTasksFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ReactionTasksFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reactions/tasks",
    name: "reaction_tasks"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('ReactionEventsFactory', ReactionEventsFactory);

ReactionEventsFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ReactionEventsFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reactions/events",
    name: "reaction_events"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('ReactionConditionsFactory', ReactionConditionsFactory);

ReactionConditionsFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ReactionConditionsFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reactions/conditions",
    name: "reaction_conditions"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('RateCategoryFactory', RateCategoryFactory);

  RateCategoryFactory.$inject = ["railsResourceFactory"];

function RateCategoryFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/rate_categories/{{id}}",
    name: "rate_category"
  });

  resource.prototype.updatePriority = function () {
    return this.$post(this.$url() + '/update_priority');
  };

  return resource;
}
angular
  .module('buuqit')
  .factory('ProvidersFactory', ProvidersFactory);

ProvidersFactory.$inject = ["$rootScope", "railsResourceFactory"];

function ProvidersFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/providers/{{id}}",
    name: "provider"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('PropertiesFactory', PropertiesFactory);

PropertiesFactory.$inject = ["railsResourceFactory"];

function PropertiesFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/properties/{{id}}",
    name: "property"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('PosProfilesFactory', PosProfilesFactory);

PosProfilesFactory.$inject = ["railsResourceFactory"];

function PosProfilesFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/pos_profiles/{{id}}",
    name: "pos_profile"
  });

  return resource;
}

angular
  .module("buuqit")
  .factory("PluginFactory", PluginFactory);

PluginFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function PluginFactory (railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/plugins/{{id}}",
    name: "plugin"
  });

  resource.prototype.install = function () {
    return this.$post(this.$url() + '/install');
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('PhotoFactory', PhotoFactory);

PhotoFactory.$inject = ["railsResourceFactory"];

function PhotoFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/photos/{{id}}",
    name: "photo"
  });

  return resource;
}
angular
  .module('buuqit')
  .factory('PaymentTypeFactory', PaymentTypeFactory);

  PaymentTypeFactory.$inject = ["$rootScope", "railsResourceFactory"];

function PaymentTypeFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/payment_types/{{id}}",
    name: "payment_type"
  });

  resource.prototype.remove = function (replaceWith) {
    return this.$delete(this.$url() + '?replaceWith=' + replaceWith);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('PaymentFactory', PaymentFactory);

PaymentFactory.$inject = ["$rootScope", "railsResourceFactory"];

function PaymentFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/payments/{{id}}",
    name: "payment"
  });


  resource.prototype.refund = function (amount) {
    this.refund_amount = amount;
    return this.$post(this.$url() + '/refund');
  };


  resource.prototype.charge = function () {
    return this.$post(this.$url() + '/charge');
  };


  resource.prototype.convertToPayment = function () {
    return this.$post(this.$url() + '/convert_deposit_to_payment');
  };


  resource.prototype.convertPrepaymentToPayment = function (amount) {
    this.convert_amount = amount;
    return this.$post(this.$url() + '/convert_prepayment_to_payment');
  };


  resource.prototype.sync = function (bookingId, callback) {
    var self = this;
    if (bookingId !== undefined) {this.bookingId = bookingId;}

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(
          function () {
            // self.date = new Date(self.date);
            self.__sync = true;
            $rootScope.$broadcast('bookings:update');
            if (typeof(callback) == 'function') { callback(self); }
          },
          function (error) {
            if (error.status === 0) {self.__sync = false;}
            if (typeof(callback) == 'function') { callback(self, error); }
          }
        );
      } else {
        this.update().then(
          function () {
            // self.date = new Date(self.date);
            self.__sync = true;
            $rootScope.$broadcast('bookings:update');
            if (typeof(callback) == 'function') { callback(self); }
          },
          function (error) {
            if (error.status === 0) {self.__sync = false;}
            if (typeof(callback) == 'function') { callback(self, error); }
          }
        );
      }
    }

    if (this.for_remove) { this.remove(); }

    return this;
  };


  resource.prototype.save = function (callback) {
    this.__sync = false;
    this.sync(undefined, callback);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('NewTaxFactory', NewTaxFactory);

NewTaxFactory.$inject = ["$http", "railsResourceFactory"];

function NewTaxFactory ($http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/new_taxes/{{id}}",
    name: "tax",
    pluralName: "taxes"
  });

  resource.prototype.remove = function (removeTotally) {
    return $http.delete(this.$url() + '?removeTotally=' + removeTotally);
  };

  resource.prototype.move = function (position) {
    return this.$post(this.$url() + '/move/', {position: position});
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('LogFactory', LogFactory);

LogFactory.$inject = ["$http", "railsResourceFactory"];

function LogFactory ($http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{id}}/bookings/{{booking_id}}/logs",
    name: "log"
  });

  resource.prototype.getLogs = function (hotelId, bookingId, params) {
    var searchParams = new URLSearchParams();

    if (params) {
      Object.keys(params).map(function(param) {
        if (param == 'pagination') {
          Object.keys(params.pagination).map(function (par) {
            searchParams.set("pagination[" + par + "]", params.pagination[par]);
          });
        } else {
          searchParams.set(param, params[param]);
        }
      });
    }

    var url = SERVER_PATH + "/api/v1/hotels/" + hotelId + "/bookings/" + bookingId + "/logs";
    var queryString = searchParams.toString();
    var queryUrl = url + "?" + queryString;

    return $http.get(queryUrl);
  }

  return resource;
}
angular
  .module('buuqit')
  .factory('LiveFeedFactory', LiveFeedFactory);

LiveFeedFactory.$inject = ["railsResourceFactory"];

function LiveFeedFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/live_feed",
    name: "event"
  });

  resource.prototype.markAsRead = function () {
    var self = this;
    this.readStatus = true;

    this
      .$put(this.$url() + '/' + this.id + '/mark_as_read')
      .then(
        function () {},
        function (error) { if (error.status === 0) { self.__sync = false; } }
      );
  };

  return resource;
}
angular
  .module('buuqit')
  .factory('KeyLockFactory', KeyLockFactory);

  KeyLockFactory.$inject = [
  "$rootScope",
  "$http"
];

function KeyLockFactory ($rootScope, $http) {

  return {
    getKeyLocks: getKeyLocks,
    createKeyLock: createKeyLock,
    updateKeyLock: updateKeyLock,
    deleteKeyLock: deleteKeyLock,
  };

  function getKeyLocks() {
    return $http.get($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/key_locks');
  }

  function createKeyLock(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/key_locks', data)
  }

  function updateKeyLock(data) {
    return $http.put($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/key_locks/' + data.id, data)
  }

  function deleteKeyLock(key) {
    return $http.delete($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/key_locks/' + key.id);
  }

}

angular
  .module('buuqit')
  .factory('InvoiceNumberSettingsFactory', InvoiceNumberSettingsFactory);

InvoiceNumberSettingsFactory.$inject = ["$rootScope", "railsResourceFactory"];

function InvoiceNumberSettingsFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/invoice_number_settings",
    name: "invoice_number_settings"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('IdentificationTypeFactory', IdentificationTypeFactory);

  IdentificationTypeFactory.$inject = ["$rootScope", "railsResourceFactory"];

function IdentificationTypeFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/identification_types/{{id}}",
    name: "identification_type"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('HousekeepingSystemFactory', HousekeepingSystemFactory);

  HousekeepingSystemFactory.$inject = [
  "$rootScope",
  "$http"
];

function HousekeepingSystemFactory ($rootScope, $http) {

  return {
    getHousekeepings: getHousekeepings,
    createHousekeeping: createHousekeeping,
    deleteHousekeeping: deleteHousekeeping,
  };

  function getHousekeepings() {
    return $http.get($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/housekeeping_providers');
  }

  function createHousekeeping(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/housekeeping_providers', data)
  }

  function deleteHousekeeping(key) {
    return $http.delete($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/housekeeping_providers/' + key.id);
  }

}

angular
  .module("buuqit")
  .factory("HotelPolicyFactory", HotelPolicyFactory);

HotelPolicyFactory.$inject = ["railsResourceFactory"];

function HotelPolicyFactory (railsResourceFactory) {
  return railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/hotel_policies/{{id}}",
    name: "hotel_policy"
  });
}
angular
  .module('buuqit')
  .factory('HotelFactory', HotelFactory);

HotelFactory.$inject = [
  "railsResourceFactory",
  "railsSerializer",
  "$http",
];

function HotelFactory (railsResourceFactory, railsSerializer, $http) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{id}}",
    name: "hotel",

    serializer: railsSerializer(function () {
      this.exclude('rooms',
        'newTaxes',
        'roomRates',
        'roomRepresentations',
        'roomTypes',
        'saleChannels',
        'seasons',
        'schema',
        'rateCategories',
        'properties',
        'posProfiles',
        'plugins',
        'paymentTypes',
        'offlineChannels',
        'extras',
        'extraCategories',
        'categories',
        'bookingOptions',
        'coverRoomTypes',
        'pictures'
      );

      this.resource('rooms', 'RoomFactory');
      this.resource('cancellationPolicies', 'CancellationPolicyFactory');
      this.resource('hotelPolicy', 'HotelPolicyFactory');
      this.resource('identificationTypes', 'IdentificationTypeFactory');
      this.resource('invoiceNumberSettings', 'InvoiceNumberSettingsFactory');
      this.resource('customPaymentTypes', 'PaymentTypeFactory');
      this.resource('systemPaymentTypes', 'PaymentTypeFactory');
      this.resource('plugins', 'PluginFactory');
      this.resource('saleChannels', 'SaleChannelFactory');
      this.resource('accountingCategories', 'AccountingCategoryFactory');

      this.rename('memberSettings', 'member_settings_attributes', true);
      this.rename('emailSettings', 'email_settings_attributes', true);
      this.rename('calendarSetting', 'calendar_setting_attributes', true);
      this.rename('companyAddress', 'company_address_attributes', true);
    })
  });

  resource.prototype.create = function () {
    return this.$post(this.$url() + '/create');
  };

  resource.prototype.sync = function () {
    return this.$post(this.$url() + '/sync_with_wubook');
  };

  resource.prototype.sync_dependencies = function () {
    _.each(this.rooms, function (room) { if (room.__sync === false) { room.save(); } });
  };

  resource.prototype.generate_api_key = function () {
    return this.$post(this.$url() + '/generate_api_key');
  };

  resource.prototype.subscription_status = function () {
    return $http.get(this.$url() + '/subscription_status');
  };

  resource.prototype.update_tokens = function () {
    return $http.get(this.$url() + '/update_tokens');
  };

  resource.prototype.change_default_language = function (locale) {
    return this.$post(this.$url() + '/change_default_language?locale=' + locale);
  };

  resource.prototype.get_users = function (params) {
    var url = this.$url() + '/get_users';

    return $http.get(url, { params: params });
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('GuestFactory', GuestFactory);

  GuestFactory.$inject = [
  "$rootScope",
  "$http",
  "railsResourceFactory",
];

function GuestFactory ($rootScope, $http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/guests/{{id}}",
    name: "guest"
  });

  resource.prototype.removeFrom = function (bookingRoomId) {
    return $http.post(this.$url() + '/remove_from/' + bookingRoomId, {});
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('FolioFactory', FolioFactory);

FolioFactory.$inject = [
  "$rootScope",
  "$http",
  "railsResourceFactory",
  "railsSerializer",
  "CustomerFactory"
];

function FolioFactory ($rootScope, $http, railsResourceFactory, railsSerializer, CustomerFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/folios/{{id}}",
    name: "folio",
    serializer: railsSerializer(function () {
      this.resource('customer', 'CustomerFactory');
    })
  });

  resource.prototype.moveItems = function (target, folioItems, paymentItems) {
    return $http.post(this.$url() + '/move_items/', {
      target_folio: target,
      folio_items: folioItems,
      payment_items: paymentItems
    });
  };

  resource.prototype.applyDiscount = function (ids, discount_id, is_percent, amount, discount_name, is_foreign_amount) {
    return $http.post(this.$url() + '/apply_discount/', {
      discount_id: discount_id,
      is_percent: is_percent,
      amount: amount,
      folio_item_ids: ids,
      discount_name: discount_name,
      is_foreign_amount: is_foreign_amount
    });
  };

  resource.prototype.removeDiscount = function (folioDiscount) {
    return $http.delete(this.$url() + '/remove_discount/' + folioDiscount, {});
  };

  resource.prototype.createInvoice = function () {
    return this.$post(this.$url() + '/convert_to_invoice');
  }

  resource.prototype.update = function () {
    return this.$put(this.$url());
  }

  resource.prototype.createReceipt = function () {
    return this.$post(this.$url() + '/convert_to_receipt');
  }

  resource.prototype.movePaymentsAndCreateReceipt = function (payments, extras) {
    return $http.post(this.$url() + '/convert_to_receipt', {payments: payments, extras: extras});
  }

  resource.prototype.void = function () {
    return this.$post(this.$url() + '/void');
  }

  resource.prototype.credit = function () {
    return this.$post(this.$url() + '/credit');
  }

  resource.prototype.toggleItemVisibility = function (folioItem) {
    return $http.post(this.$url() + '/toggle_visibility/' + folioItem.id, {});
  }

  resource.prototype.toggleItemComplimentary = function (folioItem) {
    return $http.post(this.$url() + '/toggle_complimentary/' + folioItem.id, {});
  }

  resource.prototype.sendTo = function (email) {
    return $http.post(this.$url() + '/send_email/', {email: email});
  }

  resource.prototype.removeTax = function (taxId) {
    return $http.delete(this.$url() + '/remove_tax/' + taxId);
  }

  resource.prototype.updateTax = function (taxId, payload) {
    return $http.post(this.$url() + '/update_tax/' + taxId, {folio_tax: payload});
  }

  resource.prototype.resetTax = function (taxId) {
    return $http.post(this.$url() + '/reset_tax/' + taxId);
  }

  resource.prototype.addTax = function (folioItemId, payload) {
    return $http.post(this.$url() + '/add_tax/' + folioItemId, {folio_tax: payload});
  }

  resource.prototype.moveTaxes = function (target, source, taxIds) {
    return $http.post(this.$url() + '/move_tax/', {
      source_folio_id: source,
      target_folio_id: target,
      target_tax_ids: taxIds
    });
  }

  resource.prototype.getFolios = function (params) {
    var searchParams = new URLSearchParams();

    if (params) {
      Object.keys(params).map(function (param) {
        if (param == 'pagination') {
          Object.keys(params.pagination).map(function (par) {
            searchParams.set("pagination[" + par + "]", params.pagination[par]);
          });
        } else {
          searchParams.set(param, params[param]);
        }
      });
    }

    var queryString = searchParams.toString();
    var url = this.$url() + '/list' + "?" + queryString;
    return $http.get(url);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('Reports.FinancialReport', FinancialReportFactory);

FinancialReportFactory.$inject = ["$rootScope", "railsResourceFactory"];

function FinancialReportFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/reports/financial_report"
  });

  resource.prototype.get = function (dateFrom, dateTo, excludeBlockers) {
    return this.$http({
      method: 'GET',
      url: this.$url(),
      params: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        excludeBlockers: excludeBlockers
      }
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('FacilityFactory', FacilityFactory);

FacilityFactory.$inject = ["railsResourceFactory"];

function FacilityFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/facilities/{{id}}",
    name: "facility"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('ExtraFactory', ExtraFactory);

ExtraFactory.$inject = ["railsResourceFactory"];

function ExtraFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/extras/{{id}}",
    name: "extra"
  });

  resource.prototype.remove = function (replaceWith) {
    return this.$delete(this.$url() + '?replaceWith=' + replaceWith);
  };

  return resource;
}

angular
.module('buuqit')
.factory('ExtraCategoriesFactory', ExtraCategoriesFactory);

ExtraCategoriesFactory.$inject = ["railsResourceFactory"];

function ExtraCategoriesFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/extra_categories/{{id}}",
    name: "extra_category"
  });

  resource.prototype.remove = function (replaceWith) {
    return this.$delete(this.$url() + '?replaceWith=' + replaceWith);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('ExtrasFactory', ExtrasFactory);

ExtrasFactory.$inject = ["$http", "railsResourceFactory"];

function ExtrasFactory($http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/extras",
    name: "extras"
  });

  resource.prototype.getExtras = function (hotelId, params) {
    var searchParams = new URLSearchParams();

    if (params) {
      Object.keys(params).map(function(param) {
        if (param == 'pagination') {
          Object.keys(params.pagination).map(function (par) {
            searchParams.set("pagination[" + par + "]", params.pagination[par]);
          });
        } else if (param == 'extra_ids') {
          params.extra_ids.forEach(function(id) {
            searchParams.append("extra_ids[]", id);
          });
        } else {
          searchParams.set(param, params[param]);
        }
      });
    }

    var url = SERVER_PATH + "/api/v1/hotels/" + hotelId + "/extras";
    var queryString = searchParams.toString();
    var queryUrl = url + "?" + queryString;

    return $http.get(queryUrl);
  }
  return resource;
}
angular
  .module("buuqit")
  .factory("EmailTemplatesListFactory", EmailTemplatesListFactory);

EmailTemplatesListFactory.$inject = ["railsResourceFactory"];

function EmailTemplatesListFactory(railsResourceFactory) {

  var endpoints = {
    email: {
      path: "email_templates",
      name: "emailTemplates"
    },
    system: {
      path: "system_email_templates",
      name: "systemEmailTemplates"
    }
  };

  return function (type) {

    if (!endpoints[type]) {
      throw new Error("Unknown email template type: " + type);
    }

    return railsResourceFactory({
      url: SERVER_PATH + "/api/v1/hotels/{{hotel_id}}/" + endpoints[type].path,
      name: endpoints[type].name,
      params: {
        hotel_id: null
      }
    });

  };
}

angular
  .module('buuqit')
  .factory('EmailTemplateFactory', EmailTemplateFactory);

EmailTemplateFactory.$inject = ["railsResourceFactory"];

function EmailTemplateFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/email_templates/{{id}}",
    name: "email_template"
  });

  return resource;
}
angular
  .module("buuqit")
  .factory("EmailTemplatePreviewFactory", EmailTemplatePreviewFactory);

  EmailTemplatePreviewFactory.$inject = [
    "railsResourceFactory",
  ];

function EmailTemplatePreviewFactory(railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/email_template_preview",
    name: "email"
  });

  return resource;
}
angular
  .module("buuqit")
  .factory("EmailSystemConfigFactory", EmailSystemConfigFactory);

EmailSystemConfigFactory.$inject = [
  "railsResourceFactory",
];

function EmailSystemConfigFactory(railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/system_email_config",
    name: "email"
  });

  return resource;
}
angular
  .module('buuqit')
  .factory('DiscountFactory', DiscountFactory);

DiscountFactory.$inject = ["railsResourceFactory"];

function DiscountFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/discounts/{{id}}",
    name: "discount"
  });

  return resource;
}
angular
  .module('buuqit')
  .factory('DiscountsFactory', DiscountsFactory);

DiscountsFactory.$inject = ["$http", "railsResourceFactory"];

function DiscountsFactory($http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/discounts",
    name: "discounts"
  });

  resource.prototype.getDiscounts = function (hotelId, params) {
    var searchParams = new URLSearchParams();

    if (params) {
      Object.keys(params).map(function(param) {
        if (param == 'pagination') {
          Object.keys(params.pagination).map(function (par) {
            searchParams.set("pagination[" + par + "]", params.pagination[par]);
          });
        } else {
          searchParams.set(param, params[param]);
        }
      });
    }

    var url = SERVER_PATH + "/api/v1/hotels/" + hotelId + "/discounts";
    var queryString = searchParams.toString();
    var queryUrl = url + "?" + queryString;

    return $http.get(queryUrl);
  }

  return resource;
}
angular
  .module('buuqit')
  .factory('DeviceDetector', DeviceDetector);

function DeviceDetector () {
  return deviceType();
}

function deviceType() {
  var ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
  }
  else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return "mobile";
  }
  return "desktop";
};
angular
  .module('buuqit')
  .factory('DevKeyFactory', DevKeyFactory);

DevKeyFactory.$inject = [
  "$rootScope",
  "$http"
];

function DevKeyFactory ($rootScope, $http) {

  return {
    loadPerms: loadPerms,
    loadKeys: loadKeys,
    createKey: createKey,
    updateKey: updateKey,
    deleteKey: deleteKey
  };

  function processKey(k) {
    var perms = {};
    k.perms.forEach(function(p) {
      perms[p] = true
    }); 
    k.perms = perms;
  }

  function loadPerms() {
    return $http.get($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/devkeys/get_perms');
  }

  function loadKeys() {
    return $http.get($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/devkeys/')
      .then(function(response){
        response.data.forEach(processKey);
        return response.data;
      });
  }

  function createKey(data) {
    return $http.post($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/devkeys/', data)
      .then(function(response){
        processKey(response.data);
        return response.data;
      })
  }

  function updateKey(key, data) {
    return $http.put($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/devkeys/' + key.id, data)
      .then(function(response){
        processKey(response.data);
        return response.data;
      })
  }

  function deleteKey(key) {
    return $http.delete($rootScope.server_path + '/api/v1/hotels/' + $rootScope.hotel.id +'/devkeys/' + key.id);
  }

}

angular
  .module('buuqit')
  .factory('DateNoteFactory', DateNoteFactory);

DateNoteFactory.$inject = ["railsResourceFactory", "$rootScope"];

function DateNoteFactory (railsResourceFactory, $rootScope) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/date_notes/{{id}}",
    name: "date_note"
  });

  resource.prototype.sync = function () {
    var self = this;

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(function () {self.__sync = true;});
      } else {
        this.update().then(function () {self.__sync = true;});
      }
    }

    if (this.for_remove) { this.remove(); }

    return this;
  };

  resource.prototype.save = function () {
    this.__sync = false;
    this.sync();
  };

  resource.prototype.destroy = function (callback) {
    if ($rootScope.networkStatus === true) {
      this.remove().then(function () {
        if (callback && typeof(callback)) {
          callback();
        }
      });
    } else {
      if (this.id !== undefined) {
        this.for_remove = true;
        this.status = 'removed';
        $rootScope.removedDateNotes.push(this);
      }
    }
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('CustomerFactory', CustomerFactory);

CustomerFactory.$inject = ["$rootScope", "railsResourceFactory"];

function CustomerFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/customers/{{id}}",
    name: "customer"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('CustomEmailTemplateFactory', CustomEmailTemplateFactory);

CustomEmailTemplateFactory.$inject = ["railsResourceFactory"];

function CustomEmailTemplateFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/custom_email_templates/{{id}}",
    name: "custom_email_templates"
  });

  return resource;
}
angular.module("buuqit").factory("CurrencyProfileFactory", CurrencyProfileFactory);

CurrencyProfileFactory.$inject = ["$rootScope", "$http", "railsResourceFactory"];

function CurrencyProfileFactory($rootScope, $http, railsResourceFactory) {
  var setExchangeRate = function(currencyProfile) {
    if (currencyProfile.isExchangeRate === true) {
      currencyProfile.visibleExchangeRate = "Live Exchange";
    } else {
      currencyProfile.visibleExchangeRate = currencyProfile.exchangeRate;
    }
    currencyProfile.exchangeRate = Number(currencyProfile.exchangeRate);

    return currencyProfile;
  }
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/currency_profiles/{{id}}",
    name: "currency_profile",
    responseInterceptors: [function(promise) {
      return promise.then(function(response) {
        if (response.data.map) {
          response.data = response.data.map(setExchangeRate);
        } else {
          response.data = setExchangeRate(response.data);
        }
        return response;
      });
    }]
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('CreditCardFactory', CreditCardFactory);

CreditCardFactory.$inject = ["railsResourceFactory", "$http"];

function CreditCardFactory (railsResourceFactory, $http) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/credit_cards/{{id}}",
    name: "credit_card"
  });

  resource.prototype.showCredentials = function (password) {
    return $http.post(this.$url() + '/credentials', {
      pwd : btoa(password)
    });
  };

  resource.prototype.tokenizeCard = function (provider) {
    return $http.post(this.$url() + '/tokenize?provider=' + provider);
  };

  return resource;
}

angular
  .module("buuqit")
  .factory("CoverRoomTypeFactory", CoverRoomTypeFactory);

CoverRoomTypeFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function CoverRoomTypeFactory (railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/cover_room_types/{{id}}",
    name: "cover_room_type"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('ChannelManagerFactory', ChannelManagerFactory);

ChannelManagerFactory.$inject = ["$rootScope", "$http", "railsResourceFactory", "railsSerializer"];

function ChannelManagerFactory ($rootScope, $http, railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/channels/{{id}}",
    name: "channel",
    serializer: railsSerializer(function () {
      this.add('settings', function(channel) {
        var settings = JSON.parse(channel.settings);
        delete settings['hotels'];
        delete settings['roomTypesArray'];
        return JSON.stringify(settings);
      });
    })

  });

  resource.prototype.sync = function () {
    return $http.post(this.$url() + '/sync');
  };

  resource.prototype.fetch_missing_bookings = function () {
    return $http.post(this.$url() + '/fetch_missing_bookings');
  }

  return resource;
}

angular
  .module("buuqit")
  .factory("CancellationPolicyFactory", CancellationPolicyFactory);

CancellationPolicyFactory.$inject = ["railsResourceFactory"];

function CancellationPolicyFactory (railsResourceFactory) {
  return railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/cancellation_policies/{{id}}",
    name: "cancellation_policy"
  });
}
angular
  .module('buuqit')
  .factory('BookkeepingsFactory', BookkeepingsFactory);

BookkeepingsFactory.$inject = ["$rootScope", "$http", "railsResourceFactory"];

function BookkeepingsFactory ($rootScope, $http, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookkeepings/{{id}}",
    name: "bookkeeping"
  });

  resource.prototype.download_payment_types = function () {
    return $http.get(this.$url() + '/get_payment_types');
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('BookingMergeFactory', BookingMergeFactory);

BookingMergeFactory.$inject = ["$http", "railsResourceFactory", "StringTransformService"];

function BookingMergeFactory($http, railsResourceFactory, StringTransformService) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/available_to_merge",
    name: "bookingsMerge"
  });

  resource.prototype.getAvailableBookings = function (hotelId, bookingId, params) {
    var searchParams = new URLSearchParams();

    if (params) {
      Object.keys(params).map(function (param) {
        if (param == 'pagination') {
          Object.keys(params.pagination).map(function (par) {
            searchParams.set("pagination[" + par + "]", params.pagination[par]);
          });
        } else {
          searchParams.set(param, params[param]);
        }
      });
    }

    var url = SERVER_PATH + "/api/v1/hotels/" + hotelId + "/bookings/" + bookingId + "/available_to_merge";
    var queryString = searchParams.toString();
    var queryUrl = url + "?" + queryString;

    return $http.get(queryUrl).then(function (response) {
      var formattedResponse = StringTransformService.snakeToCamel(response);
      return formattedResponse;
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('BookingsFactory', BookingsFactory);

BookingsFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BookingsFactory($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/search",
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('BookingWidgetSettingsFactory', BookingWidgetSettingsFactory);

BookingWidgetSettingsFactory.$inject = ["railsResourceFactory"];

function BookingWidgetSettingsFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/booking_widget_settings/{{id}}",
    name: "booking_widget_setting"
  });

  return resource;
}

angular
  .module("buuqit")
  .factory("BookingRoomsFactory", BookingRoomsFactory);

BookingRoomsFactory.$inject = ["railsResourceFactory", "$http", "$rootScope"];

function BookingRoomsFactory(railsResourceFactory, $http, $rootScope) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/rooms",
    name: "booking_rooms"
  });

  resource.prototype.cancelBookingRooms = function (booking_room_ids, email) {
    return $http.post(this.$url() + '/bulk_cancel', {
      'booking_room_ids': booking_room_ids,
      'email': email
    });
  }

  resource.prototype.checkinBookingRooms = function (booking_room_ids) {
    return $http.post(this.$url() + '/bulk_checkin', {
      'booking_room_ids': booking_room_ids,
    });
  };

  resource.prototype.cancelCheckoutBookingRooms = function (booking_room_ids) {
    var self = this;

    for (var booking_room_id in booking_room_ids){
      $rootScope.$broadcast('BookingStorage:update', booking_room_id, this.bookingId);
    }

    $rootScope.$broadcast('bookings:update');

    return $http.post(this.$url().split('?')[0] + '/bulk_cancel_checkout',{
      'booking_room_ids': booking_room_ids
    });
  }

  resource.prototype.cancelCheckInBookingRooms = function (booking_room_ids) {
    return $http.post(this.$url() + '/bulk_cancel_checkin', {
      'booking_room_ids': booking_room_ids,
    });
  };

  resource.prototype.checkoutBookingRooms = function (booking_room_ids) {
    return $http.post(this.$url() + '/bulk_checkout', {
      'booking_room_ids': booking_room_ids,
    });
  };

  return resource;
}
angular
  .module('buuqit')
  .factory('BookingRoomFactory', BookingRoomFactory);

BookingRoomFactory.$inject = ["railsResourceFactory", "railsSerializer", "$rootScope", "$i18next", "$http"];

function BookingRoomFactory (railsResourceFactory, railsSerializer, $rootScope, $i18next, $http) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/rooms/{{id}}?lastUpdateTimestamp={{lastUpdateTimestamp}}",
    name: "booking_room",
    serializer: railsSerializer(function () {
      this.exclude('guests',
                   'nights_select',
                   'rate_select',
                   'restrictions',
                   'room_select',
                   'room_type_select',
                   'room_rate',
                   'room_representation',
                   'applicable_room_rates',
                   'roomRepresentation',
                   'roomRate');
      this.resource('guest', 'GuestFactory');
      this.rename('nights', 'price_by_night');
      this.rename('guest', 'guest_attributes');
    })
  });


  var originalSave = resource.prototype.save;
  resource.prototype.save = function () {
    return originalSave.call(this).catch(function (error) {
      console.error('Save error:', error);

      if (error.status === 0) {
        this.__sync = false;
      }

      $rootScope.alert('Something went wrong, please try again later.');
      return Promise.reject(error);
    });
  };


  resource.prototype.hold = function () {
    var self = this;
    this.status = 'hold';

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus && typeof(this.id) === 'number') {
      this.$post(this.$url().split('?')[0] + '/hold').then(function () {}, function (error) { if (error.status === 0) { self.__sync = false; } });
    } else {
      this.__sync = false;
      this.for_create = false;
    }
  };


  resource.prototype.checkin = function (callback) {
    var self = this;
    this.occupationStatus = 'checked_in';

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus) {
      return this.$post(this.$url().split('?')[0] + '/checkin')
        .then(
          function () {
            if (typeof(callback) === 'function') { callback(); }
          },
          function (error) {
            if (error.status === 0) {
              self.__sync = false;
              if (typeof(callback) === 'function') { callback(); }
            }
          }
        );
    } else {
      if (typeof(callback) === 'function') { callback(); }
      this.__sync = false;
      this.for_create = false;
    }
  };


  resource.prototype.checkout = function (callback) {
    var self = this;
    this.occupationStatus = 'checked_out';

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus) {
      return this.$post(this.$url().split('?')[0] + '/checkout').then(
        function () {
          if (typeof(callback) === 'function') { callback(); }
        },
        function (error) {
          if (error.status === 0) {
            self.__sync = false;
            if (typeof(callback) === 'function') { callback(); }
          }
        }
      );
    } else {
      if (typeof(callback) === 'function') { callback(); }
      this.__sync = false;
      this.for_create = false;
    }
  };


  resource.prototype.cancel_checkin = function () {
    var self = this;
    this.occupationStatus = 'pending';

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus) {
      return this.$post(this.$url().split('?')[0] + '/cancel_checkin').then(function (response) { return response}, function (error) { if (error.status === 0) { self.__sync = false; } });
    } else {
      this.__sync = false;
      this.for_create = false;
    }
  };


  resource.prototype.cancel_checkout = function () {
    var self = this;
    this.occupationStatus = 'checked_in';

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus) {
      return this.$post(this.$url().split('?')[0] + '/cancel_checkout').then(function (response) { return response}, function (error) { if (error.status === 0) { self.__sync = false; } });
    } else {
      this.__sync = false;
      this.for_create = false;
    }
  };


  resource.prototype.setRoom = function (roomId) {
    var self = this;
    this.roomId = roomId;
    this.status = 'pending';

    $rootScope.lastModifiedBooking = this.bookingId;
    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus && typeof(this.id) === 'number') {
      return this
        .$post(this.$url().split('?')[0] + '/update_room/' + roomId)
        .then(
          function(data) {
            return data;
          },
          function(error) {
            if (error.status === 0) {
              self.__sync = false;
            } else {
              return error;
            }
          }
        );
    } else {
      this.__sync = false;
      this.for_create = false;

      return new Promise();
    }
  };


  resource.prototype.cancel = function (email, callback) {
    $rootScope.lastModifiedBooking = this.bookingId;
    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.trackEvent('Cancel room', { booking_room_id: this.id });

    if ($rootScope.networkStatus) {
      return $http.delete(SERVER_PATH + '/api/v1/hotels/' + $rootScope.hotel.id + '/bookings/' + this.bookingId + '/rooms/' + this.id, {
        headers: { 'authorization': $http.defaults.headers.common['AUTHORIZATION'] },
        params: { email: email }
      })
        .then(function (response) {
          if (response.status === 200) {
            this.status = 'canceled';
            if (typeof (callback) === 'function') { callback(); }
          }
        })
    } else {
      this.__sync = false;
      this.for_create = false;
    }

    $rootScope.$broadcast('bookings:update');
  };


  resource.prototype.markAsCanceled = function () {
    var self = this;
    $rootScope.lastModifiedBooking = this.bookingId;
    this.canceledMark = true;
    $rootScope.isDisabledPusherEvents = true;

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);
    $rootScope.$broadcast('bookings:update');

    if ($rootScope.networkStatus && typeof (this.id) === 'number') {
      this.$post(this.$url().split('?')[0] + '/mark_as_canceled')
        .then(function () { }, function (error) {
          if (error.status === 0) {
            self.__sync = false;
          }
        })
        .finally(function () {
          $rootScope.isDisabledPusherEvents = false;
        });
    } else {
      this.__sync = false;
      this.for_create = false;
    }
  };


  resource.prototype.restore = function () {
    var self = this;
    $rootScope.lastModifiedBooking = this.bookingId;
    this.status = 'pending';

    $rootScope.$broadcast('BookingStorage:update', this.id, this.bookingId);

    if ($rootScope.networkStatus) {
      return this.$post(this.$url().split('?')[0] + '/restore').then(function () {}, function (error) { if (error.status === 0) { self.__sync = false; } });
    } else {
      this.__sync = false;
      this.for_create = false;
    }

    $rootScope.$broadcast('bookings:update');
  };


  resource.prototype.split_room = function () {
    return this.$post(this.$url().split('?')[0] + '/split');
  };


  resource.prototype.sync = function () {
    var self = this;
    this.lastUpdateTimestamp = $rootScope.bookingsLastUpdated;
    if (this.__sync === false && this.for_create === false && typeof(this.id) === 'number') {
      this.update().then(function () {
        self.__sync = true;
      }, function (error) {
        if (error.status !== 0 && error.data.status === 'Error') {
          $rootScope.alert($i18next.t('bookings.rooms.alert.something_went_wrong_booking_room_moved_to_hold_area_js_str'));
          self.hold();
        }
      });
    }
  };
  return resource;
}

angular
  .module('buuqit')
  .factory('BookingOptionFactory', BookingOptionFactory);

BookingOptionFactory.$inject = ["railsResourceFactory"];

function BookingOptionFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/booking_options/{{id}}",
    name: "booking_option"
  });

  return resource;
}
angular
  .module('buuqit')
  .factory('BookingLettersFactory', BookingLettersFactory);

BookingLettersFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BookingLettersFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/letters/{{id}}",
    name: "letter"
  });

  resource.prototype.sync = function (bookingId, positive_callback, negative_callback) {
    var self = this;

    if (bookingId !== undefined) {this.bookingId = bookingId;}

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(function (response) {
          $rootScope.$broadcast('bookings:update');
          self.__sync = true;
          if (typeof(positive_callback) === 'function') {
            positive_callback();
          }
        }, function(response) {
          var message;
          if (typeof(negative_callback) === 'function') {
            if (response.data && response.data.errors) {
              message = response.data.errors;
            } else {
              message = 'Unknown error';
            }
            negative_callback(message);
          }
        });
      } else {
        this.update().then(function (response) {
          if (typeof(positive_callback) === 'function') {
            positive_callback();
          }
          $rootScope.$broadcast('bookings:update');
          self.__sync = true;
        }, function (response) {
          var message;
          if (typeof(negative_callback) === 'function') {
            if (response.data && response.data.errors) {
              message = response.data.errors;
            } else {
              message = 'Unknown error';
            }
            negative_callback(message);
          }
        });
      }
    }

    if (this.for_remove) { this.remove(); }

    return this;
  };

  resource.prototype.save = function (positive_callback, negative_callback) {
    this.__sync = false;
    this.sync(undefined, positive_callback, negative_callback);
  };

  resource.prototype.destroy = function () {
    if ($rootScope.networkStatus === true) {
      this.remove();
      $rootScope.$broadcast('bookings:update');
    } else {
      this.for_remove = true;
      $rootScope.removedLetters.push(this);
    }
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('BookingExtraFactory', BookingExtraFactory);

BookingExtraFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BookingExtraFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/extras/{{id}}",
    name: "booking_extra"
  });

  resource.prototype.sync = function (bookingId, onSave) {
    var self = this;

    if (bookingId !== undefined) {this.bookingId = bookingId;}

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(
          function (data) {
            self.__sync = true;
            if (onSave !== undefined) {
              return onSave(data);
            }
            $rootScope.$broadcast('bookings:update');
          },
          function (error) {
            if (error.status === 0) {
              self.__sync = false;
            }
            if (onSave !== undefined) {
              return onSave(false);
            }
          }
        );
      } else {
        this.update().then(
          function (data) {
            self.__sync = true;
            if (onSave !== undefined) {
              return onSave(data);
            }
            $rootScope.$broadcast('bookings:update');
          },
          function (error) {
            if (error.status === 0) {
              self.__sync = false;
            }
            if (onSave !== undefined) {
              return onSave(false);
            }
          }
        );
      }
    }

    if (this.for_remove) { this.remove(); }

    return this;
  };

  resource.prototype.save = function (onSave) {
    var self = this;
    return new Promise(function (resolve, reject) {
      try {
        self.__sync = false;
        self.sync(undefined, onSave);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  };

  resource.prototype.destroy = function (callback) {
    var self = this;
    if ($rootScope.networkStatus === true) {
      this.remove().then(
        function (data) {
          $rootScope.$broadcast('bookings:update');
          if (callback !== undefined) {
            return callback(data);
          }
        },
        function (error) {
          if (error.status === 0) {
            self.for_remove = true;
            $rootScope.removedExtras.push(self);
          }
          if (callback !== undefined) {
            return callback(false);
          }
        }
      );
    } else {
      this.for_remove = true;
      $rootScope.removedExtras.push(this);
    }
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('BookingDiscountFactory', BookingDiscountFactory);

BookingDiscountFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BookingDiscountFactory ($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/discounts/{{id}}",
    name: "booking_discount"
  });


  resource.prototype.sync = function (bookingId) {
    var self = this;

    if (bookingId !== undefined) {this.bookingId = bookingId;}

    if (this.__sync === false && $rootScope.networkStatus === true) {
      if (this.id === undefined) {
        this.create().then(
          function () {
            self.__sync = true;
            $rootScope.$broadcast('bookings:update');
          },
          function (error) { if (error.status === 0) {self.__sync = false;} }
        );
      } else {
        this.update().then(
          function () {
            self.__sync = true;
            $rootScope.$broadcast('bookings:update');
          },
          function (error) { if (error.status === 0) {self.__sync = false;} }
        );
      }
    }

    if (this.for_remove) { this.remove(); }

    return this;
  };


  resource.prototype.save = function () {
    this.__sync = false;
    return this.sync();
  };


  resource.prototype.destroy = function () {
    var self = this;

    if ($rootScope.networkStatus === true) {
      this.remove().then(
        function () {
          $rootScope.$broadcast('bookings:update');
        },
        function (error) {
          if (error.status === 0) {
            self.for_remove = true;
            $rootScope.removedDiscounts.push(self);
          }
        }
      );
    } else {
      this.for_remove = true;
      $rootScope.removedDiscounts.push(this);
    }
  };


  return resource;
}

angular
  .module("buuqit")
  .factory("BookingCustomersFactory", BookingCustomersFactory);

BookingCustomersFactory.$inject = ["railsResourceFactory"];

function BookingCustomersFactory(railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/customers",
    name: "bookingCustomers"
  });

  resource.prototype.getCustomers = function () {
    return this.$http({
      method: 'GET',
      url: this.$url()
    });
  }

  return resource;
}
angular
  .module('buuqit')
  .factory('BookingFactory', BookingFactory);

BookingFactory.$inject = [
  "$rootScope",
  "$i18next",
  "$timeout",
  "railsResourceFactory",
  "railsSerializer",
  "BookingRoomFactory",
  "PaymentFactory",
  "BookingExtraFactory",
  "BookingDiscountFactory",
  "FolioFactory"
];

function BookingFactory ($rootScope, $i18next, $timeout, railsResourceFactory, railsSerializer, BookingRoomFactory, PaymentFactory, BookingExtraFactory, BookingDiscountFactory, BookingLettersFactory, FolioFactory) {

  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/{{urlParam ? urlParam : 'bookings'}}/{{id}}",
    name: "booking",
    serializer: railsSerializer(function () {
      this.resource('room', 'BookingRoomFactory');
      this.resource('rooms', 'BookingRoomFactory');
      this.resource('payments', 'PaymentFactory');
      this.resource('letters', 'BookingLettersFactory');
      this.resource('bookingExtras', 'BookingExtraFactory');
      this.resource('bookingDiscounts', 'BookingDiscountFactory');
      this.resource('folios', 'FolioFactory');

      this.rename('nights', 'room_price_per_night_attributes', true);
      this.rename('guest', 'guest_attributes', true);
      this.rename('rooms', 'booking_rooms_attributes', true);
      this.rename('customer', 'customer_attr', true);
    })
  });

  resource.prototype.isForeignAmount = function() {
    return this.foreignCurrency !== null && this.foreignCurrency !== $rootScope.hotel.currency;
  }

  resource.prototype.getActiveCurrency = function() {
    var currencyCode = this.foreignCurrency;
    if (currencyCode !== "" && currencyCode !== undefined && currencyCode !== null) {
      var currencySymbol = currencies.filter(function (el) {
        return el[0] == currencyCode;
      })[0][2]
    }

    return currencySymbol || $rootScope.currencySymbol;
  }

  resource.prototype._save = function () {
    this.lastUpdateTimestamp = $rootScope.bookingsLastUpdated;
    if (typeof(this.id) === 'string') { this.prepare(); }

    if ($rootScope.networkStatus === true) {
      if (this.id === null || this.id === undefined || typeof(this.id) === 'string') {
        this._create();
      } else {
        this._update();
      }
    } else {
      this.__sync = false;
      $rootScope.$broadcast('bookings:update');
    }

    return this;
  };


  resource.prototype._create = function () {
    var self = this,
        oldId = angular.copy(this.id),
        discounts = angular.copy(this.bookingDiscounts),
        payments = angular.copy(this.payments),
        letters = angular.copy(this.letters) || [],
        saveObj = angular.copy(this);

    this.lastUpdateTimestamp = $rootScope.bookingsLastUpdated;
    saveObj.id = null;
    saveObj.rooms = saveObj.rooms.map(function(room) {
      if (room.guest && room.guest.skip) {
        delete room.guest;
      }

      room.id = null;
      room.bookingId = null;

      return room;
    });
    saveObj
      .save()
      .then(
        function (data) {
          angular.extend(self, data);
          self.__sync = true;
          self.bookingDiscounts = discounts;
          self.payments         = payments;
          self.letters          = letters;
          angular.forEach(self.bookingExtras,    function (el) { el.sync(data.id); });
          angular.forEach(self.bookingDiscounts, function (el) { el.sync(data.id); });
          angular.forEach(self.payments,         function (el) { el.sync(data.id); });
          angular.forEach(self.letters,          function (el) { el.sync(data.id); });


          if (data.customer.cardErrors && data.customer.cardErrors.length > 0) {
            $rootScope.notify($i18next.t('bookings.notify.booking_was_saved_but_credit_card_was_rejected_with_message_js_str') + ' '+ data.customer.cardErrors.join('. '), $i18next.t('general.other.error'));
          }

          if (_.compact(self.rooms.map(function(el) {if (el.status === 'hold') {return el;}})).length > 0) {
            $rootScope.notify($i18next.t('bookings.notify.error_on_booking_save_booking_moved_into_hold_area_js_str'), $i18next.t('general.other.error'));
          }

          if (self.customer.cardNotSaved === true) {
            $rootScope.notify($i18next.t('bookings.notify.credit_card_was_rejected_booking_saved_without_card_js_str'));
          }

          $rootScope.bookingForHighlight = self.id;
          $rootScope.$broadcast('BookingStorage:remove_temp', oldId);
          $rootScope.$broadcast('bookings:update');

          $rootScope.$broadcast('booking:replace', oldId, self);
        },
        function (error) {
          self.id = oldId;
          angular.forEach(self.rooms, function (room, index) {
            room.bookingId = oldId;
            room.id = oldId + '-' + index;
          });

          if (error.status === 403 || error.status === 500) {
            if (error.data && error.data.errors && error.data.errors.hasOwnProperty('booking_rooms.checkin_date')) {
              _.each(error.data.errors['booking_rooms.checkin_date'], function(room_id) {
                room_with_error = self.rooms.filter(function(el){return el.roomId === parseInt(room_id);});
                if (room_with_error.length > 0) {
                  self.rooms = _.without(self.rooms, room_with_error[0]);

                  $rootScope.notify($i18next.t('bookings.notify.some_critical_error_with_booking_save_booking_was_removed_js_str'), $i18next.t('general.other.error'));

                  if (self.rooms.length === 0) {
                    $rootScope.$broadcast('bookings:destroyEmpty', oldId);
                  }
                }
              });
            } else {
              if (error.data && error.data.msg == 'Credit card verification error') {
                delete self.nonce;
                $rootScope.notify(error.data.msg+ '. ' + $i18next.t('bookings.notify.booking_was_saved_without_card_information_js_str'), $i18next.t('general.other.error'));
                self._create();
              } else if ((error.data && error.data.status === 'Error') || error.status === 500) {
                angular.forEach(self.rooms, function (room) {
                  room.status = 'hold';
                });
                self.errorShowed = true;
                $rootScope.$broadcast('bookings:update');
                $rootScope.$broadcast('BookingStorage:update_booking', oldId);
                if (!self.errorShowed) {
                  $rootScope.notify($i18next.t('bookings.notify.error_on_booking_save_booking_moved_into_hold_area_js_str'), $i18next.t('general.other.error'));
                }
              } else if (error.status === 403) {
                var errorMessage = $i18next.t('bookings.notify.some_critical_error_with_booking_save_booking_was_removed_js_str');
                if (error.data) {
                  if (error.data.msg) {
                    errorMessage = error.data.msg;
                  } else if (error.data.errors) {
                    errorMessage = error.data.errors;
                  } else if (error.data.message) {
                    errorMessage = error.data.message;
                  }
                }
                $rootScope.notify(errorMessage, $i18next.t('bookings.notify.save_booking_error'));
                $timeout(function() {
                  $rootScope.$broadcast('cache:clear');
                }, 250);
                console.error('Booking creation failed with 403:', error);
              }
            }
          } else if (error.status === 0) {
            self.__sync = false;
          } else if (error.status === -1) {
            $rootScope.networkStatus = false;
            self.__sync = false;
            $rootScope.$broadcast('bookings:update');
          }
        }
      );
  };


  resource.prototype._update = function () {
    var self = this;

    $rootScope.$broadcast('BookingStorage:update_booking', this.id);

    this
      .update()
      .then(
        function () {
          self.__sync = true;
          $rootScope.$broadcast('bookings:update');
        },
        function (error) {
          if ((error.status !== 0 && error.data.status === 'Error') || error.status === 500) {
            angular.forEach(self.rooms, function (room) {
              room.status = 'hold';
            });

            $rootScope.$broadcast('bookings:update');
            $rootScope.notify($i18next.t('bookings.notify.error_on_booking_save_booking_moved_into_hold_area_js_str'), $i18next.t('general.other.error'));
          }

          if (error.status === 0) { self.__sync = false; }
        }
      );
  };


  resource.prototype.sync = function () {
    this.lastUpdateTimestamp = $rootScope.bookingsLastUpdated;
    if (this.__sync === false) { this._save(); }

    if (typeof(this.id) === 'number') {
      angular.forEach(this.rooms,            function (el) { el.sync(); });
      angular.forEach(this.bookingExtras,    function (el) { el.sync(self.id); });
      angular.forEach(this.bookingDiscounts, function (el) { el.sync(self.id); });
      angular.forEach(this.payments,         function (el) { el.sync(self.id); });
      angular.forEach(this.letters,          function (el) { el.sync(self.id); });
    }
  };

  resource.prototype.prepare = function () {
    var booking = angular.copy(this),
        id = this.id,
        total = 0,
        customer,
        offlineBooking;

    angular.forEach(booking.rooms, function (room) { total += room.totalPrice; });

    customer = booking.customer;

    offlineBooking = {
      bookingDiscounts: [],
      bookingExtras: [],
      customer: customer,
      due: total,
      id: id,
      payer: "guest",
      paymentStatus: "pending",
      payments: [],
      letters: [],
      rooms: [],
      source: "app",
      channel: booking.channel && booking.channel.length > 0 ? booking.channel : null,
      token: "",
      total: total,
      totalDiscount: 0,
      totalExtras: 0,
      totalPaid: 0,
      totalRoom: total,
      __sync: false
    };

    angular.forEach(booking.rooms, function (room, $index) {
      var attrs = {
        bookingId: id,
        isForeignAmount: room.isForeignAmount,
        checkinDate: room.checkinDate,
        checkinTime: room.checkinTime,
        checkoutDate: room.checkoutDate,
        dontMove: room.dontMove,
        hotelId: booking.hotelId,
        id: String(id) + '-' + $index,
        nights: room.nights,
        note: room.note,
        numberOfAdults: room.numberOfAdults,
        numberOfChildren: room.numberOfChildren,
        numberOfNights: room.numberOfNights,
        occupationStatus: "pending",
        rateCategoryId: room.rateCategoryId,
        roomId: room.roomId,
        roomTypeId: room.roomTypeId,
        virtualRoomTypeId: room.virtualRoomTypeId,
        roomRateId: room.roomRateId,
        roomRepresentationId: room.roomRepresentationId,
        cancellationPolicyId: room.cancellationPolicyId,
        status: "pending",
        guest: room.guest,
        guestId: room.guestId,
      };

      offlineBooking.rooms.push(new BookingRoomFactory(attrs));
    });

    angular.extend(this, offlineBooking);
    $rootScope.$broadcast('bookings:update');
    $rootScope.updateOfflineChannels(booking.channel);
  };


  resource.prototype._load = function (data) {
    var unsavedExtras, unsavedDiscounts, unsavedPayments, unsavedLetters;
    if (this.__sync === true) {
      unsavedExtras = this.bookingExtras ? this.bookingExtras.filter(function (el) {return el.__sync === false;}) : [];
      unsavedDiscounts = this.bookingDiscounts ? this.bookingDiscounts.filter(function (el) {return el.__sync === false;}) : [];
      unsavedPayments = this.payments ? this.payments.filter(function (el) {return el.__sync === false;}) : [];
      unsavedLetters = this.letters ? this.letters.filter(function (el) {return el.__sync === false;}) : [];

      if (unsavedExtras.length + unsavedDiscounts.length + unsavedPayments.length + unsavedLetters.length === 0) {

        _.each(data.payments, function (payment, index) {
          data.payments[index].date = new Date(payment.date);
        });

        angular.extend(this, data);
      }
    }
  };


  resource.prototype.mergeWith = function (merged_booking_id) {
    return this.$post(this.$url().split('?')[0] + '/merge_with/'+merged_booking_id);
  };

  resource.prototype.updateForeignCurrencyRate = function (value) {
    return this.$post(this.$url().split('?')[0] + '/update_foreign_currency_rate?new_foreign_currency_rate=' + value.foreignCurrencyRate + '&foreign_currency=' + value.foreignCurrency);
  }

  resource.prototype.split_room = function (room, targetRoom, changeDate, note) {
    if (this.customer.notes && this.customer.notes != null && this.customer.notes != 'null' && note !== undefined) {
      this.customer.notes += '. ' + note;
    } else {
      this.customer.notes = note;
    }
    return this.$post(this.$url().split('?')[0] + '/split_room?room=' + room.id + '&target=' + targetRoom + '&date=' + moment(changeDate).format('YYYY-MM-DD'));
  };

  resource.prototype.sendPaymentRequest = function (request) {
    this.amount = request.amount;
    this.subject = request.subject;
    this.body = request.body;
    this.address = request.address;
    this.provider = request.provider;
    this.folio_id = request.folio === "" ? null : request.folio;
    return this.$post(this.$url().split('?')[0] + '/send_payment_request/');
  };

  resource.prototype.markAsCanceled = function (total) {
    return this.$post(this.$url().split('?')[0] + '/mark_as_canceled/?total=' + total);
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('BeeFreeFactory', BeeFreeFactory);

BeeFreeFactory.$inject = ["$rootScope", "railsResourceFactory"];

function BeeFreeFactory($rootScope, railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/beefree_token"
  });

  resource.prototype.get = function (date) {
    return this.$http({
      method: 'GET',
      url: this.$url()
    });
  }

  return resource;
}

angular
  .module('buuqit')
  .factory('AttachmentFactory', AttachmentFactory);

AttachmentFactory.$inject = [
  "$rootScope",
  "$http",
  "railsResourceFactory",
  "railsSerializer",
];

function AttachmentFactory ($rootScope, $http, railsResourceFactory, railsSerializer) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/bookings/{{bookingId}}/attachments/{{id}}",
    name: "attachment"
  });

  return resource;
}

angular
  .module('buuqit')
  .factory('AdminUsersFactory', AdminUsersFactory);

AdminUsersFactory.$inject = ["railsResourceFactory"];

function AdminUsersFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/admin_users/{{id}}",
    name: "user"
  });


  resource.prototype.updateAssociations = function () {
    return this.$post(this.$url() + '/update_associations');
  };


  return resource;
}

angular
  .module('buuqit')
  .factory('AdminHotelsFactory', AdminHotelsFactory);

AdminHotelsFactory.$inject = ["railsResourceFactory"];

function AdminHotelsFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/admin_hotels/{{id}}",
    name: "hotel"
  });


  resource.prototype.subscribe = function () {
    return this.$post(this.$url() + '/subscribe');
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('AdminCorporateAccountsFactory', AdminCorporateAccountsFactory);

AdminCorporateAccountsFactory.$inject = ["railsResourceFactory"];

function AdminCorporateAccountsFactory (railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/admin_corporate_accounts/{{id}}",
    name: "corporate_account"
  });

  resource.prototype.addHotel = function (hotel_id) {
    this.hotel_id = hotel_id;
    return this.$post(this.$url() + '/add_hotel');
  };

  resource.prototype.addUser = function (user_id, role) {
    this.user_id = user_id;
    this.role = role;
    return this.$post(this.$url() + '/add_user');
  };

  resource.prototype.removeHotel = function (hotel_id) {
    this.hotel_id = hotel_id;
    return this.$post(this.$url() + '/remove_hotel');
  };

  resource.prototype.removeUser = function (user_id) {
    this.user_id = user_id;
    return this.$post(this.$url() + '/remove_user');
  };

  return resource;
}

angular
  .module('buuqit')
  .factory('AccountingCategoryFactory', AccountingCategoryFactory);

AccountingCategoryFactory.$inject = ["railsResourceFactory", "railsSerializer"];

function AccountingCategoryFactory(railsResourceFactory) {
  var resource = railsResourceFactory({
    url: SERVER_PATH + "/api/v1/hotels/{{hotelId}}/accounting_categories/{{id}}",
    name: "accounting_category",
  });

  resource.prototype.remove = function (replaceWith) {
    return this.$delete(this.$url() + '?replaceWith=' + replaceWith);
  };

  return resource;
}

angular
  .module('buuqit')
  .directive('multiSelect', function() {
    function link(scope, element, attrs) {
      var options = {
        onChange: function() {
          element.change();
        },
        buttonClass: 'form-control',
        buttonWidth: '100%'
        // buttonContainer: '<div class="btn-group" />',
      };

      element.multiselect(options);

      // Watch for any changes to the length of our select element
      scope.$watch(function () {
        return element[0].length;
      }, function () {
        element.multiselect('rebuild');
      });

      // Watch for any changes from outside the directive and refresh
      scope.$watch(attrs.ngModel, function () {
        element.multiselect('refresh');
      });
    }

    return {
      restrict: 'A',
      link: link
    };
  });
angular
  .module('buuqit')
  .directive('ngI18next', ngI18next);

ngI18next.$inject = ['$i18next', '$sanitize'];

function ngI18next($i18next, $sanitize) {
  function link(scope, element, attrs) {
    var key = attrs.ngI18next.replace('[html]', '');
    var translation = $i18next.t(key);

    element.html($sanitize(translation));
  }

  return {
    restrict: 'A',
    link: link
  };
}
angular
  .module('buuqit')
  .directive('dynamic', function ($compile) {
    return {
      restrict: 'A',
      replace: true,
      link: function (scope, ele, attrs) {
        scope.$watch(attrs.dynamic, function(html) {
          ele.html(html);
          $compile(ele.contents())(scope);
        });
      }
    };
  });
var titles = ["Mr.", "Ms.", "Mrs.", "Miss", "Dr"],
    times = [
      "00:00",
      "00:30",
      "01:00",
      "01:30",
      "02:00",
      "02:30",
      "03:00",
      "03:30",
      "04:00",
      "04:30",
      "05:00",
      "05:30",
      "06:00",
      "06:30",
      "07:00",
      "07:30",
      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",
      "21:00",
      "21:30",
      "22:00",
      "22:30",
      "23:00",
      "23:30"
    ],
    room_types = [
      "Standard Double",
      "Executive Double",
      "Twin Room / Family Room",
      "Small Double for One"
    ],
    rooms = [
      {id:  1, number :  1, type : "Standard Double"},
      {id:  2, number :  2, type : "Executive Double"},
      {id:  3, number :  3, type : "Standard Double"},
      {id:  4, number :  4, type : "Executive Double"},
      {id:  5, number :  5, type : "Executive Double"},
      {id:  6, number :  6, type : "Twin Room / Family Room"},
      {id:  7, number :  7, type : "Executive Double"},
      {id:  8, number :  8, type : "Twin Room / Family Room"},
      {id:  9, number :  9, type : "Executive Double"},
      {id: 10, number : 10, type : "Executive Double"},
      {id: 11, number : 11, type : "Twin Room / Family Room"},
      {id: 12, number : 12, type : "Executive Double"},
      {id: 13, number : 13, type : "Standard Double"},
      {id: 14, number : 14, type : "Standard Double"},
      {id: 15, number : 15, type : "Small Double for One"},
      {id: 16, number : 16, type : "Small Double for One"}
    ],
    extras = [
      {id:  1, title: "Champagne", price: 10},
      {id:  2, title: "Extra Bed", price: 15},
      {id:  3, title: "Flowers", price: 5},
      {id:  4, title: "Airport Transfer", price: 24},
      {id:  5, title: "Early Checkin", price: 5},
      {id:  6, title: "Car Parking", price: 10},
      {id:  7, title: "Evening set meal", price: 12},
      {id:  8, title: "Ipad Hire", price: 2}
    ],
    countries_in = [
      "United Kingdom",
      "United States",
      "Australia",
      "Germany",
      "France",
      "Afghanistan",
      "Åland Islands",
      "Albania",
      "Algeria",
      "American Samoa",
      "AndorrA",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory",
      "Brunei Darussalam",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands",
      "Colombia",
      "Comoros",
      "Congo",
      "Congo, Democratic Republic",
      "Cook Islands",
      "Costa Rica",
      "Cote D\"Ivoire",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands (Malvinas)",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "French Guiana",
      "French Polynesia",
      "French Southern Territories",
      "Gabon",
      "Gambia",
      "Georgia",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and Mcdonald Islands",
      "Holy See (Vatican City State)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea (North)",
      "Korea (South)",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libyan Arab Jamahiriya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestinian Territory, Occupied",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Montenegro",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syrian Arab Republic",
      "Taiwan, Province of China",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States Minor Outlying Islands",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Viet Nam",
      "Virgin Islands, British",
      "Virgin Islands, U.S.",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ],

    icons = [
      'adjust',
      'anchor',
      'archive',
      'area-chart',
      'arrows',
      'arrows-h',
      'arrows-v',
      'asterisk',
      'at',
      'ban',
      'bar-chart',
      'barcode',
      'bars',
      'bed',
      'beer',
      'bell',
      'bell-o',
      'bell-slash',
      'bell-slash-o',
      'bicycle',
      'binoculars',
      'birthday-cake',
      'bolt',
      'bomb',
      'book',
      'bookmark',
      'bookmark-o',
      'briefcase',
      'bug',
      'building',
      'building-o',
      'bullhorn',
      'bullseye',
      'bus',
      'calculator',
      'calendar',
      'calendar-o',
      'camera',
      'camera-retro',
      'car',
      'caret-square-o-down',
      'caret-square-o-left',
      'caret-square-o-right',
      'caret-square-o-up',
      'cart-arrow-down',
      'cart-plus',
      'cc',
      'certificate',
      'check',
      'check-circle',
      'check-circle-o',
      'check-square',
      'check-square-o',
      'child',
      'circle',
      'circle-o',
      'circle-o-notch',
      'circle-thin',
      'clock-o',
      'cloud',
      'cloud-download',
      'cloud-upload',
      'code',
      'code-fork',
      'coffee',
      'cog',
      'cogs',
      'comment',
      'comment-o',
      'comments',
      'comments-o',
      'compass',
      'copyright',
      'credit-card',
      'crop',
      'crosshairs',
      'cube',
      'cubes',
      'cutlery',
      'database',
      'desktop',
      'diamond',
      'dot-circle-o',
      'download',
      'ellipsis-h',
      'ellipsis-v',
      'envelope',
      'envelope-o',
      'envelope-square',
      'eraser',
      'exchange',
      'exclamation',
      'exclamation-circle',
      'exclamation-triangle',
      'external-link',
      'external-link-square',
      'eye',
      'eye-slash',
      'eyedropper',
      'fax',
      'female',
      'fighter-jet',
      'file-archive-o',
      'file-audio-o',
      'file-code-o',
      'file-excel-o',
      'file-image-o',
      'file-pdf-o',
      'file-powerpoint-o',
      'file-video-o',
      'file-word-o',
      'film',
      'filter',
      'fire',
      'fire-extinguisher',
      'flag',
      'flag-checkered',
      'flag-o',
      'flask',
      'folder',
      'folder-o',
      'folder-open',
      'folder-open-o',
      'frown-o',
      'futbol-o',
      'gamepad',
      'gavel',
      'gift',
      'glass',
      'globe',
      'graduation-cap',
      'hdd-o',
      'headphones',
      'heart',
      'heart-o',
      'heartbeat',
      'history',
      'home',
      'inbox',
      'info',
      'info-circle',
      'key',
      'keyboard-o',
      'language',
      'laptop',
      'leaf',
      'lemon-o',
      'level-down',
      'level-up',
      'life-ring',
      'lightbulb-o',
      'line-chart',
      'location-arrow',
      'lock',
      'magic',
      'magnet',
      'male',
      'map-marker',
      'meh-o',
      'microphone',
      'microphone-slash',
      'minus',
      'minus-circle',
      'minus-square',
      'minus-square-o',
      'mobile',
      'money',
      'moon-o',
      'motorcycle',
      'music',
      'newspaper-o',
      'paint-brush',
      'paper-plane',
      'paper-plane-o',
      'paw',
      'pencil',
      'pencil-square',
      'pencil-square-o',
      'phone',
      'phone-square',
      'picture-o',
      'pie-chart',
      'plane',
      'plug',
      'plus',
      'plus-circle',
      'plus-square',
      'plus-square-o',
      'power-off',
      'print',
      'puzzle-piece',
      'qrcode',
      'question',
      'question-circle',
      'quote-left',
      'quote-right',
      'random',
      'recycle',
      'refresh',
      'reply',
      'reply-all',
      'retweet',
      'road',
      'rocket',
      'rss',
      'rss-square',
      'search',
      'search-minus',
      'search-plus',
      'server',
      'share',
      'share-alt',
      'share-alt-square',
      'share-square',
      'share-square-o',
      'shield',
      'ship',
      'shopping-cart',
      'sign-in',
      'sign-out',
      'signal',
      'sitemap',
      'sliders',
      'smile-o',
      'sort',
      'sort-alpha-asc',
      'sort-alpha-desc',
      'sort-amount-asc',
      'sort-amount-desc',
      'sort-asc',
      'sort-desc',
      'sort-numeric-asc',
      'sort-numeric-desc',
      'space-shuttle',
      'spinner',
      'spoon',
      'square',
      'square-o',
      'star',
      'star-half',
      'star-half-o',
      'star-o',
      'street-view',
      'suitcase',
      'sun-o',
      'tablet',
      'tachometer',
      'tag',
      'tags',
      'tasks',
      'taxi',
      'terminal',
      'thumb-tack',
      'thumbs-down',
      'thumbs-o-down',
      'thumbs-o-up',
      'thumbs-up',
      'ticket',
      'times',
      'times-circle',
      'times-circle-o',
      'tint',
      'toggle-off',
      'toggle-on',
      'trash',
      'trash-o',
      'tree',
      'trophy',
      'truck',
      'tty',
      'umbrella',
      'university',
      'unlock',
      'unlock-alt',
      'upload',
      'user',
      'user-plus',
      'user-secret',
      'user-times',
      'users',
      'video-camera',
      'volume-down',
      'volume-off',
      'volume-up',
      'wheelchair',
      'wifi',
      'wrench',
      'ambulance',
      'bicycle',
      'bus',
      'car',
      'fighter-jet',
      'motorcycle',
      'plane',
      'rocket',
      'ship',
      'space-shuttle',
      'subway',
      'taxi',
      'train',
      'truck',
      'wheelchair',
      'circle-thin',
      'mars',
      'mars-double',
      'mars-stroke',
      'mars-stroke-h',
      'mars-stroke-v',
      'mercury',
      'neuter',
      'transgender',
      'transgender-alt',
      'venus',
      'venus-double',
      'venus-mars',
      'file',
      'file-archive-o',
      'file-audio-o',
      'file-code-o',
      'file-excel-o',
      'file-image-o',
      'file-o',
      'file-pdf-o',
      'file-powerpoint-o',
      'file-text',
      'file-text-o',
      'file-video-o',
      'file-word-o',
      'circle-o-notch',
      'cog',
      'refresh',
      'spinner',
      'check-square',
      'check-square-o',
      'circle',
      'circle-o',
      'dot-circle-o',
      'minus-square',
      'minus-square-o',
      'plus-square',
      'plus-square-o',
      'square',
      'square-o',
      'cc-amex',
      'cc-discover',
      'cc-mastercard',
      'cc-paypal',
      'cc-stripe',
      'cc-visa',
      'credit-card',
      'google-wallet',
      'paypal',
      'area-chart',
      'bar-chart',
      'line-chart',
      'pie-chart',
      'btc',
      'eur',
      'gbp',
      'ils',
      'inr',
      'jpy',
      'krw',
      'money',
      'rub',
      'try',
      'usd',
      'align-center',
      'align-justify',
      'align-left',
      'align-right',
      'bold',
      'chain-broken',
      'clipboard',
      'columns',
      'eraser',
      'file',
      'file-o',
      'file-text',
      'file-text-o',
      'files-o',
      'floppy-o',
      'font',
      'header',
      'indent',
      'italic',
      'link',
      'list',
      'list-alt',
      'list-ol',
      'list-ul',
      'outdent',
      'paperclip',
      'paragraph',
      'repeat',
      'scissors',
      'strikethrough',
      'subscript',
      'superscript',
      'table',
      'text-height',
      'text-width',
      'th',
      'th-large',
      'th-list',
      'underline',
      'undo',
      'angle-double-down',
      'angle-double-left',
      'angle-double-right',
      'angle-double-up',
      'angle-down',
      'angle-left',
      'angle-right',
      'angle-up',
      'arrow-circle-down',
      'arrow-circle-left',
      'arrow-circle-o-down',
      'arrow-circle-o-left',
      'arrow-circle-o-right',
      'arrow-circle-o-up',
      'arrow-circle-right',
      'arrow-circle-up',
      'arrow-down',
      'arrow-left',
      'arrow-right',
      'arrow-up',
      'arrows',
      'arrows-alt',
      'arrows-h',
      'arrows-v',
      'caret-down',
      'caret-left',
      'caret-right',
      'caret-square-o-down',
      'caret-square-o-left',
      'caret-square-o-right',
      'caret-square-o-up',
      'caret-up',
      'chevron-circle-down',
      'chevron-circle-left',
      'chevron-circle-right',
      'chevron-circle-up',
      'chevron-down',
      'chevron-left',
      'chevron-right',
      'chevron-up',
      'hand-o-down',
      'hand-o-left',
      'hand-o-right',
      'hand-o-up',
      'long-arrow-down',
      'long-arrow-left',
      'long-arrow-right',
      'long-arrow-up',
      'arrows-alt',
      'backward',
      'compress',
      'eject',
      'expand',
      'fast-backward',
      'fast-forward',
      'forward',
      'pause',
      'play',
      'play-circle',
      'play-circle-o',
      'step-backward',
      'step-forward',
      'stop',
      'youtube-play',
      'adn',
      'android',
      'angellist',
      'apple',
      'behance',
      'behance-square',
      'bitbucket',
      'bitbucket-square',
      'btc',
      'buysellads',
      'cc-amex',
      'cc-discover',
      'cc-mastercard',
      'cc-paypal',
      'cc-stripe',
      'cc-visa',
      'codepen',
      'connectdevelop',
      'css3',
      'dashcube',
      'delicious',
      'deviantart',
      'digg',
      'dribbble',
      'dropbox',
      'drupal',
      'empire',
      'facebook',
      'facebook-official',
      'facebook-square',
      'flickr',
      'forumbee',
      'foursquare',
      'git',
      'git-square',
      'github',
      'github-alt',
      'github-square',
      'google',
      'google-plus',
      'google-plus-square',
      'google-wallet',
      'gratipay',
      'hacker-news',
      'html5',
      'instagram',
      'ioxhost',
      'joomla',
      'jsfiddle',
      'lastfm',
      'lastfm-square',
      'leanpub',
      'linkedin',
      'linkedin-square',
      'linux',
      'maxcdn',
      'meanpath',
      'medium',
      'openid',
      'pagelines',
      'paypal',
      'pied-piper',
      'pied-piper-alt',
      'pinterest',
      'pinterest-p',
      'pinterest-square',
      'qq',
      'rebel',
      'reddit',
      'reddit-square',
      'renren',
      'sellsy',
      'share-alt',
      'share-alt-square',
      'shirtsinbulk',
      'simplybuilt',
      'skyatlas',
      'skype',
      'slack',
      'slideshare',
      'soundcloud',
      'spotify',
      'stack-exchange',
      'stack-overflow',
      'steam',
      'steam-square',
      'stumbleupon',
      'stumbleupon-circle',
      'tencent-weibo',
      'trello',
      'tumblr',
      'tumblr-square',
      'twitch',
      'twitter',
      'twitter-square',
      'viacoin',
      'vimeo-square',
      'vine',
      'vk',
      'weibo',
      'weixin',
      'whatsapp',
      'windows',
      'wordpress',
      'xing',
      'xing-square',
      'yahoo',
      'yelp',
      'youtube',
      'youtube-play',
      'youtube-square',
      'ambulance',
      'h-square',
      'heart',
      'heart-o',
      'heartbeat',
      'hospital-o',
      'medkit',
      'plus-square',
      'stethoscope',
      'user-md',
      'wheelchair'
    ],
    currencies = [["ALL","Albanian Lek","Lek"], ["AED", "United Arab Emirates dirham", "Dh"], ["AFN","Afghan Afghani","؋"], ["AMD", "Armenian Dram", "AMD"], ["ARS","Argentine Peso","$"], ["AWG","Aruban Florin","ƒ"], ["AUD","Australian Dollar","$"], ["AZN","Azerbaijani Manat","ман"], ["BSD","Bahamian Dollar","$"], ["BBD","Barbadian Dollar","$"], ["BYR","Belarusian Ruble","p."], ["BZD","Belize Dollar","BZ$"], ["BMD","Bermudian Dollar","$"], ["BOB","Bolivian Boliviano","$b"], ["BAM","Bosnia and Herzegovina Convertible Mark","KM"], ["BWP","Botswana Pula","P"], ["BGN","Bulgarian Lev","лв"], ["BRL","Brazilian Real","R$"], ["BND","Brunei Dollar","$"], ["KHR","Cambodian Riel","៛"], ["CAD","Canadian Dollar","$"], ["KYD","Cayman Islands Dollar","$"], ["CLP","Chilean Peso","$"], ["CNY","Chinese Renminbi Yuan","¥"], ["COP","Colombian Peso","$"], ["CRC","Costa Rican Colón","₡"], ["HRK","Croatian Kuna","kn"], ["CUP","Cuban Peso","₱"], ["CZK","Czech Koruna","Kč"], ["DKK","Danish Krone","kr"], ["DOP","Dominican Peso","RD$"], ["XCD","East Caribbean Dollar","$"], ["EGP","Egyptian Pound","£"], ["SVC","Salvadoran Colón","$"], ["EEK","Estonian Kroon","kr"], ["EUR","Euro","€"], ["FKP","Falkland Pound","£"], ["FJD","Fijian Dollar","$"], ["GHS","Ghanaian Cedi","¢"], ["GIP","Gibraltar Pound","£"], ["GTQ","Guatemalan Quetzal","Q"], ["GYD","Guyanese Dollar","$"], ["HNL","Honduran Lempira","L"], ["HKD","Hong Kong Dollar","$"], ["HUF","Hungarian Forint","Ft"], ["ISK","Icelandic Króna","kr", 0], ["INR","Indian Rupee","₹"], ["IDR","Indonesian Rupiah","Rp"], ["IRR","Iranian Rial","﷼"], ["ILS","Israeli New Sheqel","₪"], ["JMD","Jamaican Dollar","J$"], ["JOD", "Jordanian Dinar", "د.أ"], ["JPY","Japanese Yen","¥"], ["KES","Kenyan shilling","KSh"], ["KZT","Kazakhstani Tenge","лв"],["KPW","North Korean Won","₩"],["KRW","South Korean Won","₩"],["KGS","Kyrgyzstani Som","лв"],["LAK","Lao Kip","₭"],["LVL","Latvian Lats","Ls"],["LBP","Lebanese Lira","£"],["LRD","Liberian Dollar","$"],["LTL","Lithuanian Litas","Lt"], ["MAD", "Moroccan Dirham", ""], ["MGA", "Malagasy ariary", "Ar"],["MKD","Macedonian Denar","ден"],["MYR","Malaysian Ringgit","RM"],["MVR", "Maldivian Rufiyaa", "Rf"],["MUR","Mauritian Rupee","₨"],["MXN","Mexican Peso","$"],["MNT","Mongolian Tögrög","₮"],["MZN","Mozambican Metical","MT"],["NAD","Namibian Dollar","$"],["NPR","Nepalese Rupee","₨"],["ANG","Netherlands Antillean Gulden","ƒ"],["NZD","New Zealand Dollar","$"],["NIO","Nicaraguan Córdoba","C$"],["NGN","Nigerian Naira","₦"],["NOK","Norwegian Krone","kr"],["OMR","Omani Rial","﷼"],["PKR","Pakistani Rupee","₨"],["PAB","Panamanian Balboa","B/."],["PYG","Paraguayan Guaraní","Gs"],["PEN","Peruvian Nuevo Sol","S/."],["PHP","Philippine Peso","₱"],["PLN","Polish Złoty","zł"],["QAR","Qatari Riyal","﷼"],["RON","Romanian Leu","lei"],["RUB","Russian Ruble","руб"],["SHP","Saint Helenian Pound","£"],["SAR","Saudi Riyal","﷼"],["RSD","Serbian Dinar","Дин."],["SCR","Seychellois Rupee","₨"],["SGD","Singapore Dollar","$"],["SBD","Solomon Islands Dollar","$"],["SOS","Somali Shilling","S"],["ZAR","South African Rand","R"],["LKR","Sri Lankan Rupee","LKR"],["SEK","Swedish Krona","kr"],["CHF","Swiss Franc","CHF"],["SRD","Surinamese Dollar","$"],["SYP","Syrian Pound","£"],["TRY", "Turkish Lira", "TL"],["TWD","New Taiwan Dollar","NT$"],["THB","Thai Baht","฿"],["TTD","Trinidad and Tobago Dollar","TT$"],["UAH","Ukrainian Hryvnia","₴"],["GBP","British Pound","£"],["USD","United States Dollar","$"],["UYU","Uruguayan Peso","$U"],["UZS","Uzbekistani Som","лв"],["VEF","Venezuelan Bolívar","Bs"],["VND","Vietnamese Đồng","₫"],["YER","Yemeni Rial","﷼"],["ZWD","Zimbabwean Dollar","Z$"],["XAF", "Central African CFA franc", "FCFA"],["XOF", "West African CFA franc", "CFA"]],
    dropins = [
      ['Hotel Name','{{hotel_name}}'],
      ['Hotel City','{{hotel_city}}'],
      ['Hotel Address','{{hotel_address}}'],
      ['Hotel Postal Code','{{hotel_postal_code}}'],
      ['Booking Reference','{{booking_reference}}'],
      ['Booking Channel Reference','{{booking_channel_reference}}'],
      ['Booking Channel','{{booking_channel}}'],
      ['Customer First Name','{{customer_first_name}}'],
      ['Customer Last Name','{{customer_last_name}}'],
      ['Customer Email Address','{{customer_email}}'],
      ['Customer Address','{{customer_address}}'],
      ['Customer Country','{{customer_country}}'],
      ['Customer City','{{customer_city}}'],
      ['Customer State','{{customer_state}}'],
      ['Customer Postal Code','{{customer_postalcode}}'],
      ['Customer Phone','{{customer_phone}}'],
      ['Customer Nationality','{{customer_nationality}}'],
      ['Customer Identification','{{customer_identification}}'],
      ['Customer Locale','{{customer_locale}}'],
      ['Customer (Company) Name','{{customer_company_name}}'],
      ['Customer (Company) Bill To','{{customer_billto}}'],
      ['Customer (Company) Tax Number','{{customer_tax_number}}'],
      ['Customer Notes','{{customer_notes}}'],
      ['Arrival Date','{{arrival_date}}'],
      ['Departure Date','{{departure_date}}'],
      ['Number Of Rooms','{{number_of_rooms}}'],
      ['Number Of Nights','{{number_of_nights}}'],
      ['Amount Due','{{amount_due}}'],
      ['Total Amount','{{total_amount}}'],
      ['Amount Paid','{{amount_paid}}'],
      ['Invoice Number','{{invoice_number}}'],
      ['Request Payment Link', '{{payment_link}}'],
      ['Fail Reason', '{{fail_reason}}'],
      ['Footer Template', '{{footer_template}}'],
      ['Key Code List View', '{{keycode}}'],
      ['Key Code Comma Separated', '{{keycode_csv}}'],
    ],
    emailAdressDropins = [
      ['Customer Email Address','{{customer_email}}'],
      ['Hotel Email Address','{{hotel_email}}'],
    ]
    SEASON_COLORS = "AAAAAA F0E68C E6E6FA FFF0F5 7CFC00 FFFACD ADD8E6 F08080 E0FFFF FAFAD2 90EE90 FFB6C1 FFA07A 20B2AA 87CEFA 778899";
    ROOM_COLORS = "76A9E0 AAAAAA F0E68C ADD8E6 F08080 90EE90 FFB6C1 FFA07A 20B2AA 87CEFA 778899";

(function() {
  var restrictionsTable = {
    admin: {
      default: true,
    },
    owner: {
      default: true,
      admin: false
    },
    manager: {
      default: true,
      admin: false
    },
    user: {
      default: true,
      admin: false
    },
    reception: {
      default: true,
      "new_inventory.rate": false,
      "new_inventory.min_stay": false,
      "new_inventory.closed_to_arrival": false,
      "new_inventory.closed_to_departure": false,
      website: false,
      settings: false,
      admin: false
    },
    reception_no_finance: {
      default: true,
      "new_inventory.rate": false,
      "new_inventory.min_stay": false,
      "new_inventory.closed_to_arrival": false,
      "new_inventory.closed_to_departure": false,
      settings: false,
      admin: false,
      "reports.credit-report": false,
      "reports.booking-report": false,
      "reports.cancellation-report": false,
      "reports.channel-report": false,
      "reports.extras-report": false,
      "reports.occupancy-report": false,
      "reports.financial-report": false,
      "reports.rate-plan-report": false,
      "reports.deposit-report": false,
      "reports.manager-report": false,
      "reports.meal-report": true,
      revenueChart: false,
      website: false
    },
    housekeeper: {
      default: false,
      navigationMenu: true,
      profile: true,
      bookings: true,
      reports: true,
      "reports.housekeeping-report": true,
      admin: false,
      dashboard: true,
      calendar: true
    },
    reports_bookings_customers: {
      default: false,
      navigationMenu: true,
      profile: true,
      bookings: true,
      reports: true,
      customers: true,
      "reports.credit-report": true,
      "reports.daily-checkout-report": true,
      "reports.booking-report": true,
      "reports.cancellation-report": true,
      "reports.housekeeping-report": true,
      "reports.channel-report": true,
      "reports.extras-report": true,
      "reports.meal-report": true,
      "reports.occupancy-report": true,
      "reports.debtors-report": true,
      "reports.in-house-report": true,
      "reports.folio-report": true,
      "reports.police-report": true,
      "reports.statistical-report-is": true,
      schedulerRightClickMenu: true,
      quickCheckIn: true,
      quickCheckOut: true,
      markAsRead: true,
      viewBookingInfo: true,
      dashboardCharts: true,
      dashboard: true,
      calendar: true
    }
  };

  var ROUTE_ACCESS_ALIASES = {
    'new_inventory.all': 'new_inventory.rate',
    'new_inventory.rate_main': 'new_inventory.rate',
    'closeout': 'new_inventory.closeout',
  }

  var SEGMENT_KEY_MAPPING = {
    'reports': 'report',
    'new_inventory': 'block'
  }


  window.restrictions = {
    hasAccess: function(user, rule) {
      var role = user.role;
      if (user.systemRole === 'admin' || user.systemRole === 'corporate_admin' || user.systemRole === 'white_admin') {
        role = 'admin';
      }

      if (restrictionsTable[role] && typeof(restrictionsTable[role][rule]) == 'undefined') {
        restrictionsTable[role][rule] = restrictionsTable[role]["default"];
      }
      if (rule == 'website' && window.location.host == 'sinazo.jurni.app') {
        return false;
      }
      return restrictionsTable[role][rule];
    },
    hasAccessByRoute: function(user, route) {
      segment = route.$$route.segment;
      param = route.params[SEGMENT_KEY_MAPPING[segment]]

      if (param !== undefined) {
        rule = segment + '.' + param
      } else {
        rule = segment
      }

      if (ROUTE_ACCESS_ALIASES[rule]) {
        rule = ROUTE_ACCESS_ALIASES[rule]
      }

      if (user === undefined || user === null) {
        return segment === 'dashboard';
      } else {
        console.log('hasAccessByRoute: ' + rule + ' ' + this.hasAccess(user, rule));
        return this.hasAccess(user, rule);
      }
    }
  };
})();

var countries_timezones = [
  "Africa/Abidjan",
  "Africa/Accra",
  "Africa/Addis_Ababa",
  "Africa/Algiers",
  "Africa/Asmara",
  "Africa/Asmera",
  "Africa/Bamako",
  "Africa/Bangui",
  "Africa/Banjul",
  "Africa/Bissau",
  "Africa/Blantyre",
  "Africa/Brazzaville",
  "Africa/Bujumbura",
  "Africa/Cairo",
  "Africa/Casablanca",
  "Africa/Ceuta",
  "Africa/Conakry",
  "Africa/Dakar",
  "Africa/Dar_es_Salaam",
  "Africa/Djibouti",
  "Africa/Douala",
  "Africa/El_Aaiun",
  "Africa/Freetown",
  "Africa/Gaborone",
  "Africa/Harare",
  "Africa/Johannesburg",
  "Africa/Juba",
  "Africa/Kampala",
  "Africa/Khartoum",
  "Africa/Kigali",
  "Africa/Kinshasa",
  "Africa/Lagos",
  "Africa/Libreville",
  "Africa/Lome",
  "Africa/Luanda",
  "Africa/Lubumbashi",
  "Africa/Lusaka",
  "Africa/Malabo",
  "Africa/Maputo",
  "Africa/Maseru",
  "Africa/Mbabane",
  "Africa/Mogadishu",
  "Africa/Monrovia",
  "Africa/Nairobi",
  "Africa/Ndjamena",
  "Africa/Niamey",
  "Africa/Nouakchott",
  "Africa/Ouagadougou",
  "Africa/Porto-Novo",
  "Africa/Sao_Tome",
  "Africa/Timbuktu",
  "Africa/Tripoli",
  "Africa/Tunis",
  "Africa/Windhoek",
  "America/Adak",
  "America/Anchorage",
  "America/Anguilla",
  "America/Antigua",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/ComodRivadavia",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Aruba",
  "America/Asuncion",
  "America/Atikokan",
  "America/Atka",
  "America/Bahia",
  "America/Bahia_Banderas",
  "America/Barbados",
  "America/Belem",
  "America/Belize",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Bogota",
  "America/Boise",
  "America/Buenos_Aires",
  "America/Cambridge_Bay",
  "America/Campo_Grande",
  "America/Cancun",
  "America/Caracas",
  "America/Catamarca",
  "America/Cayenne",
  "America/Cayman",
  "America/Chicago",
  "America/Chihuahua",
  "America/Coral_Harbour",
  "America/Cordoba",
  "America/Costa_Rica",
  "America/Creston",
  "America/Cuiaba",
  "America/Curacao",
  "America/Danmarkshavn",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Denver",
  "America/Detroit",
  "America/Dominica",
  "America/Edmonton",
  "America/Eirunepe",
  "America/El_Salvador",
  "America/Ensenada",
  "America/Fort_Wayne",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Godthab",
  "America/Goose_Bay",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guatemala",
  "America/Guayaquil",
  "America/Guyana",
  "America/Halifax",
  "America/Havana",
  "America/Hermosillo",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Indianapolis",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Jamaica",
  "America/Jujuy",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Knox_IN",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lima",
  "America/Los_Angeles",
  "America/Louisville",
  "America/Lower_Princes",
  "America/Maceio",
  "America/Managua",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Mendoza",
  "America/Menominee",
  "America/Merida",
  "America/Metlakatla",
  "America/Mexico_City",
  "America/Miquelon",
  "America/Moncton",
  "America/Monterrey",
  "America/Montevideo",
  "America/Montreal",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nipigon",
  "America/Nome",
  "America/Noronha",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Ojinaga",
  "America/Panama",
  "America/Pangnirtung",
  "America/Paramaribo",
  "America/Phoenix",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Acre",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Recife",
  "America/Regina",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Rosario",
  "America/Santa_Isabel",
  "America/Santarem",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Sao_Paulo",
  "America/Scoresbysund",
  "America/Shiprock",
  "America/Sitka",
  "America/St_Barthelemy",
  "America/St_Johns",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Thule",
  "America/Thunder_Bay",
  "America/Tijuana",
  "America/Toronto",
  "America/Tortola",
  "America/Vancouver",
  "America/Virgin",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yakutat",
  "America/Yellowknife",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville",
  "Antarctica/Macquarie",
  "Antarctica/Mawson",
  "Antarctica/McMurdo",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/South_Pole",
  "Antarctica/Syowa",
  "Antarctica/Vostok",
  "Arctic/Longyearbyen",
  "Asia/Aden",
  "Asia/Almaty",
  "Asia/Amman",
  "Asia/Anadyr",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Ashkhabad",
  "Asia/Baghdad",
  "Asia/Bahrain",
  "Asia/Baku",
  "Asia/Bangkok",
  "Asia/Beirut",
  "Asia/Bishkek",
  "Asia/Brunei",
  "Asia/Calcutta",
  "Asia/Choibalsan",
  "Asia/Chongqing",
  "Asia/Chungking",
  "Asia/Colombo",
  "Asia/Dacca",
  "Asia/Damascus",
  "Asia/Dhaka",
  "Asia/Dili",
  "Asia/Dubai",
  "Asia/Dushanbe",
  "Asia/Gaza",
  "Asia/Harbin",
  "Asia/Hebron",
  "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong",
  "Asia/Hovd",
  "Asia/Irkutsk",
  "Asia/Istanbul",
  "Asia/Jakarta",
  "Asia/Jayapura",
  "Asia/Jerusalem",
  "Asia/Kabul",
  "Asia/Kamchatka",
  "Asia/Karachi",
  "Asia/Kashgar",
  "Asia/Kathmandu",
  "Asia/Katmandu",
  "Asia/Khandyga",
  "Asia/Kolkata",
  "Asia/Krasnoyarsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Kuwait",
  "Asia/Macao",
  "Asia/Macau",
  "Asia/Magadan",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Muscat",
  "Asia/Nicosia",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Omsk",
  "Asia/Oral",
  "Asia/Phnom_Penh",
  "Asia/Pontianak",
  "Asia/Pyongyang",
  "Asia/Qatar",
  "Asia/Qyzylorda",
  "Asia/Rangoon",
  "Asia/Riyadh",
  "Asia/Saigon",
  "Asia/Sakhalin",
  "Asia/Samarkand",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Tashkent",
  "Asia/Tbilisi",
  "Asia/Tehran",
  "Asia/Tel_Aviv",
  "Asia/Thimbu",
  "Asia/Thimphu",
  "Asia/Tokyo",
  "Asia/Ujung_Pandang",
  "Asia/Ulaanbaatar",
  "Asia/Ulan_Bator",
  "Asia/Urumqi",
  "Asia/Ust-Nera",
  "Asia/Vientiane",
  "Asia/Vladivostok",
  "Asia/Yakutsk",
  "Asia/Yekaterinburg",
  "Asia/Yerevan",
  "Atlantic/Azores",
  "Atlantic/Bermuda",
  "Atlantic/Canary",
  "Atlantic/Cape_Verde",
  "Atlantic/Faeroe",
  "Atlantic/Faroe",
  "Atlantic/Jan_Mayen",
  "Atlantic/Madeira",
  "Atlantic/Reykjavik",
  "Atlantic/South_Georgia",
  "Atlantic/St_Helena",
  "Atlantic/Stanley",
  "Australia/ACT",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Broken_Hill",
  "Australia/Canberra",
  "Australia/Currie",
  "Australia/Darwin",
  "Australia/Eucla",
  "Australia/Hobart",
  "Australia/LHI",
  "Australia/Lindeman",
  "Australia/Lord_Howe",
  "Australia/Melbourne",
  "Australia/NSW",
  "Australia/North",
  "Australia/Perth",
  "Australia/Queensland",
  "Australia/South",
  "Australia/Sydney",
  "Australia/Tasmania",
  "Australia/Victoria",
  "Australia/West",
  "Australia/Yancowinna",
  "Brazil/Acre",
  "Brazil/DeNoronha",
  "Brazil/East",
  "Brazil/West",
  "Canada/Atlantic",
  "Canada/Central",
  "Canada/East-Saskatchewan",
  "Canada/Eastern",
  "Canada/Mountain",
  "Canada/Newfoundland",
  "Canada/Pacific",
  "Canada/Saskatchewan",
  "Canada/Yukon",
  "Chile/Continental",
  "Chile/EasterIsland",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Athens",
  "Europe/Belfast",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Bratislava",
  "Europe/Brussels",
  "Europe/Bucharest",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Chisinau",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/Gibraltar",
  "Europe/Guernsey",
  "Europe/Helsinki",
  "Europe/Isle_of_Man",
  "Europe/Istanbul",
  "Europe/Jersey",
  "Europe/Kaliningrad",
  "Europe/Kiev",
  "Europe/Lisbon",
  "Europe/Ljubljana",
  "Europe/London",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Mariehamn",
  "Europe/Minsk",
  "Europe/Monaco",
  "Europe/Moscow",
  "Europe/Nicosia",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Podgorica",
  "Europe/Prague",
  "Europe/Riga",
  "Europe/Rome",
  "Europe/Samara",
  "Europe/San_Marino",
  "Europe/Sarajevo",
  "Europe/Simferopol",
  "Europe/Skopje",
  "Europe/Sofia",
  "Europe/Stockholm",
  "Europe/Tallinn",
  "Europe/Tirane",
  "Europe/Tiraspol",
  "Europe/Uzhgorod",
  "Europe/Vaduz",
  "Europe/Vatican",
  "Europe/Vienna",
  "Europe/Vilnius",
  "Europe/Volgograd",
  "Europe/Warsaw",
  "Europe/Zagreb",
  "Europe/Zaporozhye",
  "Europe/Zurich",
  "Indian/Antananarivo",
  "Indian/Chagos",
  "Indian/Christmas",
  "Indian/Cocos",
  "Indian/Comoro",
  "Indian/Kerguelen",
  "Indian/Mahe",
  "Indian/Maldives",
  "Indian/Mauritius",
  "Indian/Mayotte",
  "Indian/Reunion",
  "Mexico/BajaNorte",
  "Mexico/BajaSur",
  "Mexico/General",
  "Pacific/Apia",
  "Pacific/Auckland",
  "Pacific/Chatham",
  "Pacific/Chuuk",
  "Pacific/Easter",
  "Pacific/Efate",
  "Pacific/Enderbury",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Funafuti",
  "Pacific/Galapagos",
  "Pacific/Gambier",
  "Pacific/Guadalcanal",
  "Pacific/Guam",
  "Pacific/Honolulu",
  "Pacific/Johnston",
  "Pacific/Kiritimati",
  "Pacific/Kosrae",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Marquesas",
  "Pacific/Midway",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Norfolk",
  "Pacific/Noumea",
  "Pacific/Pago_Pago",
  "Pacific/Palau",
  "Pacific/Pitcairn",
  "Pacific/Pohnpei",
  "Pacific/Ponape",
  "Pacific/Port_Moresby",
  "Pacific/Rarotonga",
  "Pacific/Saipan",
  "Pacific/Samoa",
  "Pacific/Tahiti",
  "Pacific/Tarawa",
  "Pacific/Tongatapu",
  "Pacific/Truk",
  "Pacific/Wake",
  "Pacific/Wallis",
  "Pacific/Yap"
]
var countries_details = [
  {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF",
    "timezones": [
      "Asia/Kabul"
    ],
  },
  {
    "name": "Aland Islands",
    "dial_code": "+358",
    "code": "AX",
    "timezones": [
      "Europe/Mariehamn"
    ]
  },
  {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL",
    "timezones": [
      "Europe/Tirane"
    ]
  },
  {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ",
    "timezones": [
      "Africa/Algiers"
    ]
  },
  {
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "code": "AS",
    "timezones": "Pacific/Pago_Pago"
  },
  {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD",
    "timezones": [
      "Europe/Andorra"
    ]
  },
  {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO",
    "timezones": [
      "Africa/Luanda"
    ]
  },
  {
    "name": "Anguilla",
    "dial_code": "+1264",
    "code": "AI",
    "timezones": [
      "America/Anguilla"
    ]
  },
  {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ",
    "timezones": [
      "Antarctica/McMurdo",
      "Antarctica/South_Pole",
      "Antarctica/Rothera",
      "Antarctica/Palmer",
      "Antarctica/Mawson",
      "Antarctica/Davis",
      "Antarctica/Casey",
      "Antarctica/Vostok",
      "Antarctica/DumontDUrville",
      "Antarctica/Syowa"
    ]
  },
  {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG",
    "timezones": "America/Antigua"
  },
  {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR",
    "timezones": [
      "America/Argentina/Buenos_Aires",
      "America/Argentina/Cordoba",
      "America/Argentina/Salta",
      "America/Argentina/Jujuy",
      "America/Argentina/Tucuman",
      "America/Argentina/Catamarca",
      "America/Argentina/La_Rioja",
      "America/Argentina/San_Juan",
      "America/Argentina/Mendoza",
      "America/Argentina/San_Luis",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Ushuaia"
    ]
  },
  {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM",
    "timezones": [
      "Asia/Yerevan"
    ]
  },
  {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW",
    "timezones": [
      "America/Aruba"
    ]
  },
  {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU",
    "timezones": [
      "Australia/Lord_Howe",
      "Antarctica/Macquarie",
      "Australia/Hobart",
      "Australia/Currie",
      "Australia/Melbourne",
      "Australia/Sydney",
      "Australia/Broken_Hill",
      "Australia/Brisbane",
      "Australia/Lindeman",
      "Australia/Adelaide",
      "Australia/Darwin",
      "Australia/Perth",
      "Australia/Eucla"
    ]
  },
  {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT",
    "timezones": [
      "Europe/Vienna"
    ]
  },
  {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ",
    "timezones": [
      "Asia/Baku"
    ]
  },
  {
    "name": "Bahamas",
    "dial_code": "+1242",
    "code": "BS",
    "timezones": [
      "America/Nassau"
    ]
  },
  {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH",
    "timezones": [
      "Asia/Bahrain"
    ]
  },
  {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD",
    "timezones": [
      "Asia/Dhaka"
    ]
  },
  {
    "name": "Barbados",
    "dial_code": "+1246",
    "code": "BB",
    "timezones": [
      "America/Barbados"
    ]
  },
  {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY",
    "timezones": [
      "Europe/Minsk"
    ]
  },
  {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE",
    "timezones": [
      "Europe/Brussels"
    ]
  },
  {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ",
    "timezones": [
      "America/Belize"
    ]
  },
  {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ",
    "timezones": [
      "Africa/Porto-Novo"
    ]
  },
  {
    "name": "Bermuda",
    "dial_code": "+1441",
    "code": "BM",
    "timezones": [
      "Atlantic/Bermuda"
    ]
  },
  {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT",
    "timezones": [
      "Asia/Thimphu"
    ]
  },
  {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "code": "BO",
    "timezones": [
      "America/La_Paz"
    ]
  },
  {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA",
    "timezones": [
      "Europe/Sarajevo"
    ]
  },
  {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW",
    "timezones": [
      "Africa/Gaborone"
    ]
  },
  {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR",
    "timezones": [
      "America/Noronha",
      "America/Belem",
      "America/Fortaleza",
      "America/Recife",
      "America/Araguaina",
      "America/Maceio",
      "America/Bahia",
      "America/Sao_Paulo",
      "America/Campo_Grande",
      "America/Cuiaba",
      "America/Santarem",
      "America/Porto_Velho",
      "America/Boa_Vista",
      "America/Manaus",
      "America/Eirunepe",
      "America/Rio_Branco"
    ]
  },
  {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO",
    "timezones": [
      "Indian/Chagos"
    ]
  },
  {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN",
    "timezones": [
      "Asia/Brunei"
    ]
  },
  {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG",
    "timezones": [
      "Europe/Sofia"
    ],
  },
  {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF",
    "timezones": [
      "Africa/Ouagadougou"
    ]
  },
  {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI",
    "timezones": [
      "Africa/Bujumbura"
    ]
  },
  {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH",
    "timezones": [
      "Asia/Phnom_Penh"
    ]
  },
  {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM",
    "timezones": [
      "Africa/Douala"
    ],
  },
  {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA",
    "timezones": [
      "America/St_Johns",
      "America/Halifax",
      "America/Glace_Bay",
      "America/Moncton",
      "America/Goose_Bay",
      "America/Blanc-Sablon",
      "America/Montreal",
      "America/Toronto",
      "America/Nipigon",
      "America/Thunder_Bay",
      "America/Iqaluit",
      "America/Pangnirtung",
      "America/Resolute",
      "America/Atikokan",
      "America/Rankin_Inlet",
      "America/Winnipeg",
      "America/Rainy_River",
      "America/Regina",
      "America/Swift_Current",
      "America/Edmonton",
      "America/Cambridge_Bay",
      "America/Yellowknife",
      "America/Inuvik",
      "America/Creston",
      "America/Dawson_Creek",
      "America/Vancouver",
      "America/Whitehorse",
      "America/Dawson"
    ],
  },
  {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV",
    "timezones": [
      "Atlantic/Cape_Verde"
    ],
  },
  {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY",
    "timezones": [
      "America/Cayman"
    ]
  },
  {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF",
    "timezones": [
      "Africa/Bangui"
    ]
  },
  {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD",
    "timezones": [
      "Africa/Ndjamena"
    ]
  },
  {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL",
    "timezones": [
      "America/Santiago",
      "Pacific/Easter"
    ],
  },
  {
    "name": "China",
    "dial_code": "+86",
    "code": "CN",
    "timezones": [
      "Asia/Shanghai",
      "Asia/Harbin",
      "Asia/Chongqing",
      "Asia/Urumqi",
      "Asia/Kashgar"
    ],
  },
  {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX",
    "timezones": [
      "Indian/Christmas"
    ]
  },
  {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC",
    "timezones": [
      "Indian/Cocos"
    ],
  },
  {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO",
    "timezones": [
      "America/Bogota"
    ]
  },
  {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM",
    "timezones": [
      "Indian/Comoro"
    ]
  },
  {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG",
    "timezones": [
      "Africa/Brazzaville"
    ]
  },
  {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD",
    "timezones": [
      "Africa/Kinshasa",
      "Africa/Lubumbashi"
    ],
  },
  {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK",
    "timezones": [
      "Pacific/Rarotonga"
    ],
  },
  {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR",
    "timezones": [
      "America/Costa_Rica"
    ]
  },
  {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI",
    "timezones": [
      "Africa/Abidjan"
    ]
  },
  {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR",
    "timezones": [
      "Europe/Zagreb"
    ],
  },
  {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU",
    "timezones": [
      "America/Havana"
    ]
  },
  {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY",
    "timezones": [
      "Asia/Nicosia"
    ]
  },
  {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ",
    "timezones": [
      "Europe/Prague"
    ],
  },
  {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK",
    "timezones": [
      "Europe/Copenhagen"
    ]
  },
  {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ",
    "timezones": [
      "Africa/Djibouti"
    ]
  },
  {
    "name": "Dominica",
    "dial_code": "+1767",
    "code": "DM",
    "timezones": [
      "America/Dominica"
    ]
  },
  {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "code": "DO",
    "timezones": [
      "America/Santo_Domingo"
    ],
  },
  {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC",
    "timezones": [
      "America/Guayaquil",
      "Pacific/Galapagos"
    ],
  },
  {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG",
    "timezones": [
      "Africa/Cairo"
    ]
  },
  {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV",
    "timezones": [
      "America/El_Salvador"
    ],
  },
  {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ",
    "timezones": [
      "Africa/Malabo"
    ]
  },
  {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER",
    "timezones": [
      "Africa/Asmara"
    ],
  },
  {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE",
    "timezones": [
      "Europe/Tallinn"
    ],
  },
  {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET",
    "timezones": [
      "Africa/Addis_Ababa"
    ]
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK",
    "timezones": [
      "Atlantic/Stanley"
    ]
  },
  {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO",
    "timezones": [
      "Atlantic/Faroe"
    ],
  },
  {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ",
    "timezones": [
      "Pacific/Fiji"
    ]
  },
  {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI",
    "timezones": [
      "Europe/Helsinki"
    ]
  },
  {
    "name": "France",
    "dial_code": "+33",
    "code": "FR",
    "timezones": [
      "Europe/Paris"
    ],
  },
  {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF",
    "timezones": [
      "America/Cayenne"
    ],
  },
  {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF",
    "timezones": [
      "Pacific/Tahiti",
      "Pacific/Marquesas",
      "Pacific/Gambier"
    ]
  },
  {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA",
    "timezones": [
      "Africa/Libreville"
    ],
  },
  {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM",
    "timezones": [
      "Africa/Banjul"
    ]
  },
  {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE",
    "timezones": [
      "Asia/Tbilisi"
    ]
  },
  {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE",
    "timezones": [
      "Europe/Berlin",
      "Europe/Busingen"
    ],
  },
  {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH",
    "timezones": [
      "Africa/Accra"
    ]
  },
  {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI",
    "timezones": [
      "Europe/Gibraltar"
    ]
  },
  {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR",
    "timezones": [
      "Europe/Athens"
    ]
  },
  {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL",
    "timezones": [
      "America/Godthab",
      "America/Danmarkshavn",
      "America/Scoresbysund",
      "America/Thule"
    ],
  },
  {
    "name": "Grenada",
    "dial_code": "+1473",
    "code": "GD",
    "timezones": [
      "America/Grenada"
    ]
  },
  {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP",
    "timezones": [
      "America/Guadeloupe"
    ]
  },
  {
    "name": "Guam",
    "dial_code": "+1671",
    "code": "GU",
    "timezones": [
      "Pacific/Guam"
    ],
  },
  {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT",
    "timezones": [
      "America/Guatemala"
    ]
  },
  {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG",
    "timezones": [
      "Europe/Guernsey"
    ]
  },
  {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN",
    "timezones": [
      "Africa/Conakry"
    ],
  },
  {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW",
    "timezones": [
      "Africa/Bissau"
    ],
  },
  {
    "name": "Guyana",
    "dial_code": "+595",
    "code": "GY",
    "timezones": [
      "America/Guyana"
    ]
  },
  {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT",
    "timezones": [
      "America/Port-au-Prince"
    ]
  },
  {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA",
    "timezones": [
      "Europe/Vatican"
    ],
  },
  {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN",
    "timezones": [
      "America/Tegucigalpa"
    ]
  },
  {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK",
    "timezones": [
      "Asia/Hong_Kong"
    ],
  },
  {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU",
    "timezones": [
      "Europe/Budapest"
    ]
  },
  {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS",
    "timezones": [
      "Atlantic/Reykjavik"
    ]
  },
  {
    "name": "India",
    "dial_code": "+91",
    "code": "IN",
    "timezones": [
      "Asia/Kolkata"
    ],
  },
  {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID",
    "timezones": [
      "Asia/Jakarta",
      "Asia/Pontianak",
      "Asia/Makassar",
      "Asia/Jayapura"
    ]
  },
  {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR",
    "timezones": [
      "Asia/Tehran"
    ]
  },
  {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ",
    "timezones": [
      "Asia/Baghdad"
    ],
  },
  {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE",
    "timezones": [
      "Europe/Dublin"
    ]
  },
  {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM",
    "timezones": [
      "Europe/Isle_of_Man"
    ]
  },
  {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL",
    "timezones": [
      "Asia/Jerusalem"
    ]
  },
  {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT",
    "timezones": [
      "Europe/Rome"
    ],
  },
  {
    "name": "Jamaica",
    "dial_code": "+1876",
    "code": "JM",
    "timezones": [
      "America/Jamaica"
    ]
  },
  {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP",
    "timezones": [
      "Asia/Tokyo"
    ]
  },
  {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE",
    "timezones": [
      "Europe/Jersey"
    ]
  },
  {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO",
    "timezones": [
      "Asia/Amman"
    ]
  },
  {
    "name": "Kazakhstan",
    "dial_code": "+77",
    "code": "KZ",
    "timezones": [
      "Asia/Almaty",
      "Asia/Qyzylorda",
      "Asia/Aqtobe",
      "Asia/Aqtau",
      "Asia/Oral"
    ],
  },
  {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE",
    "timezones": [
      "Africa/Nairobi"
    ]
  },
  {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI",
    "timezones": [
      "Pacific/Tarawa",
      "Pacific/Enderbury",
      "Pacific/Kiritimati"
    ]
  },
  {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP",
    "timezones": [
      "Asia/Pyongyang"
    ],
  },
  {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR",
    "timezones": [
      "Asia/Seoul"
    ]
  },
  {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW",
    "timezones": [
      "Asia/Kuwait"
    ]
  },
  {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG",
    "timezones": [
      "Asia/Bishkek"
    ]
  },
  {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA",
    "timezones": [
      "Asia/Vientiane"
    ],
  },
  {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV",
    "timezones": [
      "Europe/Riga"
    ]
  },
  {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB",
    "timezones": [
      "Asia/Beirut"
    ],
  },
  {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS",
    "timezones": [
      "Africa/Maseru"
    ],
  },
  {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR",
    "timezones": [
      "Africa/Monrovia"
    ]
  },
  {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY",
    "timezones": [
      "Africa/Tripoli"
    ],
  },
  {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI",
    "timezones": [
      "Europe/Vaduz"
    ]
  },
  {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT",
    "timezones": [
      "Europe/Vilnius"
    ]
  },
  {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU",
    "timezones": [
      "Europe/Luxembourg"
    ],
  },
  {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO",
    "timezones": [
      "Asia/Macau"
    ],
  },
  {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK",
    "timezones": [
      "Europe/Skopje"
    ]
  },
  {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG",
    "timezones": [
      "Indian/Antananarivo"
    ],
  },
  {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW",
    "timezones": [
      "Africa/Blantyre"
    ],
  },
  {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY",
    "timezones": [
      "Asia/Kuala_Lumpur",
      "Asia/Kuching"
    ]
  },
  {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV",
    "timezones": [
      "Indian/Maldives"
    ],
  },
  {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML",
    "timezones": [
      "Africa/Bamako"
    ]
  },
  {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT",
    "timezones": [
      "Europe/Malta"
    ],
  },
  {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH",
    "timezones": [
      "Pacific/Majuro",
      "Pacific/Kwajalein"
    ]
  },
  {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ",
    "timezones": [
      "America/Martinique"
    ]
  },
  {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR",
    "timezones": [
      "Africa/Nouakchott"
    ],
  },
  {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU",
    "timezones": [
      "Indian/Mauritius"
    ]
  },
  {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT",
    "timezones": [
      "Indian/Mayotte"
    ]
  },
  {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX",
    "timezones": [
      "America/Mexico_City",
      "America/Cancun",
      "America/Merida",
      "America/Monterrey",
      "America/Matamoros",
      "America/Mazatlan",
      "America/Chihuahua",
      "America/Ojinaga",
      "America/Hermosillo",
      "America/Tijuana",
      "America/Santa_Isabel",
      "America/Bahia_Banderas"
    ],
  },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM",
    "timezones": [
      "Pacific/Chuuk",
      "Pacific/Pohnpei",
      "Pacific/Kosrae"
    ]
  },
  {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD",
    "timezones": [
      "Europe/Chisinau"
    ]
  },
  {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC",
    "timezones": [
      "Europe/Monaco"
    ]
  },
  {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN",
    "timezones": [
      "Asia/Ulaanbaatar",
      "Asia/Hovd",
      "Asia/Choibalsan"
    ],
  },
  {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME",
    "timezones": [
      "Europe/Podgorica"
    ]
  },
  {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS",
    "timezones": [
      "America/Montserrat"
    ]
  },
  {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA",
    "timezones": [
      "Africa/Casablanca"
    ]
  },
  {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ",
    "timezones": [
      "Africa/Maputo"
    ],
  },
  {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM",
    "timezones": [
      "Asia/Rangoon"
    ]
  },
  {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA",
    "timezones": [
      "Africa/Windhoek"
    ]
  },
  {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR",
    "timezones": [
      "Pacific/Nauru"
    ]
  },
  {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP",
    "timezones": [
      "Asia/Kathmandu"
    ]
  },
  {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL",
    "timezones": [
      "Europe/Amsterdam"
    ],
  },
  {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN"
  },
  {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC",
    "timezones": [
      "Pacific/Noumea"
    ],
  },
  {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ",
    "timezones": [
      "Pacific/Auckland",
      "Pacific/Chatham"
    ]
  },
  {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI",
    "timezones": [
      "America/Managua"
    ]
  },
  {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE",
    "timezones": [
      "Africa/Niamey"
    ],
  },
  {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG",
    "timezones": [
      "Africa/Lagos"
    ],
  },
  {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU",
    "timezones": [
      "Pacific/Niue"
    ]
  },
  {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF",
    "timezones": [
      "Pacific/Norfolk"
    ]
  },
  {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "code": "MP",
    "timezones": [
      "Pacific/Saipan"
    ]
  },
  {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO",
    "timezones": [
      "Europe/Oslo"
    ],
  },
  {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM",
    "timezones": [
      "Asia/Muscat"
    ]
  },
  {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK",
    "timezones": [
      "Asia/Karachi"
    ]
  },
  {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW",
    "timezones": [
      "Pacific/Palau"
    ]
  },
  {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS",
    "timezones": [
      "Asia/Gaza",
      "Asia/Hebron"
    ],
  },
  {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA",
    "timezones": [
      "America/Panama"
    ],
  },
  {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG",
    "timezones": [
      "Pacific/Port_Moresby"
    ]
  },
  {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY",
    "timezones": [
      "America/Asuncion"
    ]
  },
  {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE",
    "timezones": [
      "America/Lima"
    ],
  },
  {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH",
    "timezones": [
      "Asia/Manila"
    ]
  },
  {
    "name": "Pitcairn",
    "dial_code": "+872",
    "code": "PN",
    "timezones": [
      "Pacific/Pitcairn"
    ]
  },
  {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL",
    "timezones": [
      "Europe/Warsaw"
    ],
  },
  {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT",
    "timezones": [
      "Europe/Lisbon",
      "Atlantic/Madeira",
      "Atlantic/Azores"
    ],
  },
  {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "code": "PR",
    "timezones": [
      "America/Puerto_Rico"
    ]
  },
  {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA",
    "timezones": [
      "Asia/Qatar"
    ]
  },
  {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO",
    "timezones": [
      "Europe/Bucharest"
    ],
  },
  {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU",
    "timezones": [
      "Europe/Kaliningrad",
      "Europe/Moscow",
      "Europe/Volgograd",
      "Europe/Samara",
      "Asia/Yekaterinburg",
      "Asia/Omsk",
      "Asia/Novosibirsk",
      "Asia/Novokuznetsk",
      "Asia/Krasnoyarsk",
      "Asia/Irkutsk",
      "Asia/Yakutsk",
      "Asia/Khandyga",
      "Asia/Vladivostok",
      "Asia/Sakhalin",
      "Asia/Ust-Nera",
      "Asia/Magadan",
      "Asia/Kamchatka",
      "Asia/Anadyr"
    ]
  },
  {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW",
    "timezones": [
      "Africa/Kigali"
    ],
  },
  {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE",
    "timezones": [
      "Indian/Reunion"
    ]
  },
  {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL",
    "timezones": [
      "America/St_Barthelemy"
    ]
  },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH",
    "timezones": [
      "Atlantic/St_Helena"
    ],
  },
  {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "code": "KN",
    "timezones": [
      "America/St_Kitts"
    ]
  },
  {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "code": "LC",
    "timezones": [
      "America/St_Lucia"
    ],
  },
  {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF",
    "timezones": [
      "America/Marigot"
    ]
  },
  {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM",
    "timezones": [
      "America/Miquelon"
    ]
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "code": "VC",
    "timezones": [
      "America/St_Vincent"
    ]
  },
  {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS",
    "timezones": [
      "Pacific/Apia"
    ]
  },
  {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM",
    "timezones": [
      "Europe/San_Marino"
    ],
  },
  {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST",
    "timezones": [
      "Africa/Sao_Tome"
    ]
  },
  {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA",
    "timezones": [
      "Asia/Riyadh"
    ],
  },
  {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN",
    "timezones": [
      "Africa/Dakar"
    ]
  },
  {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS",
    "timezones": [
      "Europe/Belgrade"
    ]
  },
  {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC",
    "timezones": [
      "Indian/Mahe"
    ],
  },
  {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL",
    "timezones": [
      "Africa/Freetown"
    ]
  },
  {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG",
    "timezones": [
      "Asia/Singapore"
    ]
  },
  {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK",
    "timezones": [
      "Europe/Bratislava"
    ]
  },
  {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI",
    "timezones": [
      "Europe/Ljubljana"
    ]
  },
  {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB",
    "timezones": [
      "Pacific/Guadalcanal"
    ],
  },
  {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO",
    "timezones": [
      "Africa/Mogadishu"
    ]
  },
  {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA",
    "timezones": [
      "Africa/Johannesburg"
    ],
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS",
    "timezones": [
      "Atlantic/South_Georgia"
    ]
  },
  {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES",
    "timezones": [
      "Europe/Madrid",
      "Africa/Ceuta",
      "Atlantic/Canary"
    ],
  },
  {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK",
    "timezones": [
      "Asia/Colombo"
    ]
  },
  {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD",
    "timezones": [
      "Africa/Khartoum"
    ]
  },
  {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR",
    "timezones": [
      "America/Paramaribo"
    ]
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ",
    "timezones": [
      "Arctic/Longyearbyen"
    ],
  },
  {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ",
    "timezones": [
      "Africa/Mbabane"
    ]
  },
  {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE",
    "timezones": [
      "Europe/Stockholm"
    ]
  },
  {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH",
    "timezones": [
      "Europe/Zurich"
    ],
  },
  {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY",
    "timezones": [
      "Asia/Damascus"
    ],
  },
  {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW",
    "timezones": [
      "Asia/Taipei"
    ]
  },
  {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ",
    "timezones": [
      "Asia/Dushanbe"
    ]
  },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "code": "TZ",
    "timezones": [
      "Africa/Dar_es_Salaam"
    ]
  },
  {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH",
    "timezones": [
      "Asia/Bangkok"
    ],
  },
  {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL",
    "timezones": [
      "Asia/Dili"
    ]
  },
  {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG",
    "timezones": [
      "Africa/Lome"
    ]
  },
  {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK",
    "timezones": [
      "Pacific/Fakaofo"
    ]
  },
  {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO",
    "timezones": [
      "Pacific/Tongatapu"
    ],
  },
  {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "code": "TT",
    "timezones": [
      "America/Port_of_Spain"
    ]
  },
  {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN",
    "timezones": [
      "Africa/Tunis"
    ]
  },
  {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR",
    "timezones": [
      "Europe/Istanbul"
    ]
  },
  {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM",
    "timezones": [
      "Asia/Ashgabat"
    ],
  },
  {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "code": "TC",
    "timezones": [
      "America/Grand_Turk"
    ],
  },
  {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV",
    "timezones": [
      "Pacific/Funafuti"
    ]
  },
  {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG",
    "timezones": [
      "Africa/Kampala"
    ]
  },
  {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA",
    "timezones": [
      "Europe/Kiev",
      "Europe/Uzhgorod",
      "Europe/Zaporozhye",
      "Europe/Simferopol"
    ],
  },
  {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE",
    "timezones": [
      "Asia/Dubai"
    ],
  },
  {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB",
    "timezones": [
      "Europe/London"
    ],
  },
  {
    "name": "United States",
    "dial_code": "+1",
    "code": "US",
    "timezones": [
      "America/New_York",
      "America/Detroit",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Indiana/Indianapolis",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Vevay",
      "America/Chicago",
      "America/Indiana/Tell_City",
      "America/Indiana/Knox",
      "America/Menominee",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/North_Dakota/Beulah",
      "America/Denver",
      "America/Boise",
      "America/Shiprock",
      "America/Phoenix",
      "America/Los_Angeles",
      "America/Anchorage",
      "America/Juneau",
      "America/Sitka",
      "America/Yakutat",
      "America/Nome",
      "America/Adak",
      "America/Metlakatla",
      "Pacific/Honolulu"
    ],
  },
  {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY",
    "timezones": [
      "America/Montevideo"
    ]
  },
  {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ",
    "timezones": [
      "Asia/Samarkand",
      "Asia/Tashkent"
    ]
  },
  {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU",
    "timezones": [
      "Pacific/Efate"
    ],
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE",
    "timezones": [
      "America/Caracas"
    ],
  },
  {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN",
    "timezones": [
      "Asia/Ho_Chi_Minh"
    ]
  },
  {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "code": "VG",
    "timezones": [
      "America/Tortola"
    ],
  },
  {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "code": "VI",
    "timezones": [
      "America/St_Thomas"
    ]
  },
  {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF",
    "timezones": [
      "Pacific/Wallis"
    ]
  },
  {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE",
    "timezones": [
      "Asia/Aden"
    ],
  },
  {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM",
    "timezones": [
      "Africa/Lusaka"
    ]
  },
  {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW",
    "timezones": [
      "Africa/Harare"
    ]
  }
]
var countries = [
    {
        "name": "United Kingdom",
        "code": "GB"
    },
    {
        "name": "United States",
        "code": "US"
    },
    {
        "name": "Australia",
        "code": "AU"
    },
    {
        "name": "Germany",
        "code": "DE"
    },
    {
        "name": "France",
        "code": "FR"
    },
    {
        "name": "Afghanistan",
        "code": "AF"
    },
    {
        "name": "Åland Islands",
        "code": "AX"
    },
    {
        "name": "Albania",
        "code": "AL"
    },
    {
        "name": "Algeria",
        "code": "DZ"
    },
    {
        "name": "American Samoa",
        "code": "AS"
    },
    {
        "name": "AndorrA",
        "code": "AD"
    },
    {
        "name": "Angola",
        "code": "AO"
    },
    {
        "name": "Anguilla",
        "code": "AI"
    },
    {
        "name": "Antarctica",
        "code": "AQ"
    },
    {
        "name": "Antigua and Barbuda",
        "code": "AG"
    },
    {
        "name": "Argentina",
        "code": "AR"
    },
    {
        "name": "Armenia",
        "code": "AM"
    },
    {
        "name": "Aruba",
        "code": "AW"
    },
    {
        "name": "Austria",
        "code": "AT"
    },
    {
        "name": "Azerbaijan",
        "code": "AZ"
    },
    {
        "name": "Bahamas",
        "code": "BS"
    },
    {
        "name": "Bahrain",
        "code": "BH"
    },
    {
        "name": "Bangladesh",
        "code": "BD"
    },
    {
        "name": "Barbados",
        "code": "BB"
    },
    {
        "name": "Belarus",
        "code": "BY"
    },
    {
        "name": "Belgium",
        "code": "BE"
    },
    {
        "name": "Belize",
        "code": "BZ"
    },
    {
        "name": "Benin",
        "code": "BJ"
    },
    {
        "name": "Bermuda",
        "code": "BM"
    },
    {
        "name": "Bhutan",
        "code": "BT"
    },
    {
        "name": "Bolivia",
        "code": "BO"
    },
    {
        "name": "Bosnia and Herzegovina",
        "code": "BA"
    },
    {
        "name": "Botswana",
        "code": "BW"
    },
    {
        "name": "Bouvet Island",
        "code": "BV"
    },
    {
        "name": "Brazil",
        "code": "BR"
    },
    {
        "name": "British Indian Ocean Territory",
        "code": "IO"
    },
    {
        "name": "Brunei Darussalam",
        "code": "BN"
    },
    {
        "name": "Bulgaria",
        "code": "BG"
    },
    {
        "name": "Burkina Faso",
        "code": "BF"
    },
    {
        "name": "Burundi",
        "code": "BI"
    },
    {
        "name": "Cambodia",
        "code": "KH"
    },
    {
        "name": "Cameroon",
        "code": "CM"
    },
    {
        "name": "Canada",
        "code": "CA"
    },
    {
        "name": "Cape Verde",
        "code": "CV"
    },
    {
        "name": "Cayman Islands",
        "code": "KY"
    },
    {
        "name": "Central African Republic",
        "code": "CF"
    },
    {
        "name": "Chad",
        "code": "TD"
    },
    {
        "name": "Chile",
        "code": "CL"
    },
    {
        "name": "China",
        "code": "CN"
    },
    {
        "name": "Christmas Island",
        "code": "CX"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "code": "CC"
    },
    {
        "name": "Colombia",
        "code": "CO"
    },
    {
        "name": "Comoros",
        "code": "KM"
    },
    {
        "name": "Congo",
        "code": "CG"
    },
    {
        "name": "Congo, Democratic Republic",
        "code": "CD"
    },
    {
        "name": "Cook Islands",
        "code": "CK"
    },
    {
        "name": "Costa Rica",
        "code": "CR"
    },
    {
        "name": "Cote D\"Ivoire",
        "code": "CI"
    },
    {
        "name": "Croatia",
        "code": "HR"
    },
    {
        "name": "Cuba",
        "code": "CU"
    },
    {
        "name": "Cyprus",
        "code": "CY"
    },
    {
        "name": "Czech Republic",
        "code": "CZ"
    },
    {
        "name": "Denmark",
        "code": "DK"
    },
    {
        "name": "Djibouti",
        "code": "DJ"
    },
    {
        "name": "Dominica",
        "code": "DM"
    },
    {
        "name": "Dominican Republic",
        "code": "DO"
    },
    {
        "name": "Ecuador",
        "code": "EC"
    },
    {
        "name": "Egypt",
        "code": "EG"
    },
    {
        "name": "El Salvador",
        "code": "SV"
    },
    {
        "name": "Equatorial Guinea",
        "code": "GQ"
    },
    {
        "name": "Eritrea",
        "code": "ER"
    },
    {
        "name": "Estonia",
        "code": "EE"
    },
    {
        "name": "Ethiopia",
        "code": "ET"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "code": "FK"
    },
    {
        "name": "Faroe Islands",
        "code": "FO"
    },
    {
        "name": "Fiji",
        "code": "FJ"
    },
    {
        "name": "Finland",
        "code": "FI"
    },
    {
        "name": "French Guiana",
        "code": "GF"
    },
    {
        "name": "French Polynesia",
        "code": "PF"
    },
    {
        "name": "French Southern Territories",
        "code": "TF"
    },
    {
        "name": "Gabon",
        "code": "GA"
    },
    {
        "name": "Gambia",
        "code": "GM"
    },
    {
        "name": "Georgia",
        "code": "GE"
    },
    {
        "name": "Ghana",
        "code": "GH"
    },
    {
        "name": "Gibraltar",
        "code": "GI"
    },
    {
        "name": "Greece",
        "code": "GR"
    },
    {
        "name": "Greenland",
        "code": "GL"
    },
    {
        "name": "Grenada",
        "code": "GD"
    },
    {
        "name": "Guadeloupe",
        "code": "GP"
    },
    {
        "name": "Guam",
        "code": "GU"
    },
    {
        "name": "Guatemala",
        "code": "GT"
    },
    {
        "name": "Guernsey",
        "code": "GG"
    },
    {
        "name": "Guinea",
        "code": "GN"
    },
    {
        "name": "Guinea-Bissau",
        "code": "GW"
    },
    {
        "name": "Guyana",
        "code": "GY"
    },
    {
        "name": "Haiti",
        "code": "HT"
    },
    {
        "name": "Heard Island and Mcdonald Islands",
        "code": "HM"
    },
    {
        "name": "Holy See (Vatican City State)",
        "code": "VA"
    },
    {
        "name": "Honduras",
        "code": "HN"
    },
    {
        "name": "Hong Kong",
        "code": "HK"
    },
    {
        "name": "Hungary",
        "code": "HU"
    },
    {
        "name": "Iceland",
        "code": "IS"
    },
    {
        "name": "India",
        "code": "IN"
    },
    {
        "name": "Indonesia",
        "code": "ID"
    },
    {
        "name": "Iran",
        "code": "IR"
    },
    {
        "name": "Iraq",
        "code": "IQ"
    },
    {
        "name": "Ireland",
        "code": "IE"
    },
    {
        "name": "Isle of Man",
        "code": "IM"
    },
    {
        "name": "Israel",
        "code": "IL"
    },
    {
        "name": "Italy",
        "code": "IT"
    },
    {
        "name": "Jamaica",
        "code": "JM"
    },
    {
        "name": "Japan",
        "code": "JP"
    },
    {
        "name": "Jersey",
        "code": "JE"
    },
    {
        "name": "Jordan",
        "code": "JO"
    },
    {
        "name": "Kazakhstan",
        "code": "KZ"
    },
    {
        "name": "Kenya",
        "code": "KE"
    },
    {
        "name": "Kiribati",
        "code": "KI"
    },
    {
        "name": "Korea (North)",
        "code": "KP"
    },
    {
        "name": "Korea (South)",
        "code": "KR"
    },
    {
        "name": "Kosovo",
        "code": "XK"
    },
    {
        "name": "Kuwait",
        "code": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "code": "KG"
    },
    {
        "name": "Laos",
        "code": "LA"
    },
    {
        "name": "Latvia",
        "code": "LV"
    },
    {
        "name": "Lebanon",
        "code": "LB"
    },
    {
        "name": "Lesotho",
        "code": "LS"
    },
    {
        "name": "Liberia",
        "code": "LR"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "code": "LY"
    },
    {
        "name": "Liechtenstein",
        "code": "LI"
    },
    {
        "name": "Lithuania",
        "code": "LT"
    },
    {
        "name": "Luxembourg",
        "code": "LU"
    },
    {
        "name": "Macao",
        "code": "MO"
    },
    {
        "name": "Macedonia",
        "code": "MK"
    },
    {
        "name": "Madagascar",
        "code": "MG"
    },
    {
        "name": "Malawi",
        "code": "MW"
    },
    {
        "name": "Malaysia",
        "code": "MY"
    },
    {
        "name": "Maldives",
        "code": "MV"
    },
    {
        "name": "Mali",
        "code": "ML"
    },
    {
        "name": "Malta",
        "code": "MT"
    },
    {
        "name": "Marshall Islands",
        "code": "MH"
    },
    {
        "name": "Martinique",
        "code": "MQ"
    },
    {
        "name": "Mauritania",
        "code": "MR"
    },
    {
        "name": "Mauritius",
        "code": "MU"
    },
    {
        "name": "Mayotte",
        "code": "YT"
    },
    {
        "name": "Mexico",
        "code": "MX"
    },
    {
        "name": "Micronesia",
        "code": "FM"
    },
    {
        "name": "Moldova",
        "code": "MD"
    },
    {
        "name": "Monaco",
        "code": "MC"
    },
    {
        "name": "Mongolia",
        "code": "MN"
    },
    {
        "name": "Montserrat",
        "code": "MS"
    },
    {
        "name": "Morocco",
        "code": "MA"
    },
    {
        "name": "Mozambique",
        "code": "MZ"
    },
    {
        "name": "Myanmar",
        "code": "MM"
    },
    {
        "name": "Namibia",
        "code": "NA"
    },
    {
        "name": "Nauru",
        "code": "NR"
    },
    {
        "name": "Nepal",
        "code": "NP"
    },
    {
        "name": "Netherlands",
        "code": "NL"
    },
    {
        "name": "Netherlands Antilles",
        "code": "AN"
    },
    {
        "name": "New Caledonia",
        "code": "NC"
    },
    {
        "name": "New Zealand",
        "code": "NZ"
    },
    {
        "name": "Nicaragua",
        "code": "NI"
    },
    {
        "name": "Niger",
        "code": "NE"
    },
    {
        "name": "Nigeria",
        "code": "NG"
    },
    {
        "name": "Niue",
        "code": "NU"
    },
    {
        "name": "Norfolk Island",
        "code": "NF"
    },
    {
        "name": "Northern Mariana Islands",
        "code": "MP"
    },
    {
        "name": "Norway",
        "code": "NO"
    },
    {
        "name": "Oman",
        "code": "OM"
    },
    {
        "name": "Pakistan",
        "code": "PK"
    },
    {
        "name": "Palau",
        "code": "PW"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "code": "PS"
    },
    {
        "name": "Panama",
        "code": "PA"
    },
    {
        "name": "Papua New Guinea",
        "code": "PG"
    },
    {
        "name": "Paraguay",
        "code": "PY"
    },
    {
        "name": "Peru",
        "code": "PE"
    },
    {
        "name": "Philippines",
        "code": "PH"
    },
    {
        "name": "Pitcairn",
        "code": "PN"
    },
    {
        "name": "Poland",
        "code": "PL"
    },
    {
        "name": "Portugal",
        "code": "PT"
    },
    {
        "name": "Puerto Rico",
        "code": "PR"
    },
    {
        "name": "Qatar",
        "code": "QA"
    },
    {
        "name": "Reunion",
        "code": "RE"
    },
    {
        "name": "Romania",
        "code": "RO"
    },
    {
        "name": "Russian Federation",
        "code": "RU"
    },
    {
        "name": "Rwanda",
        "code": "RW"
    },
    {
        "name": "Saint Helena",
        "code": "SH"
    },
    {
        "name": "Saint Kitts and Nevis",
        "code": "KN"
    },
    {
        "name": "Saint Lucia",
        "code": "LC"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "code": "PM"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "code": "VC"
    },
    {
        "name": "Samoa",
        "code": "WS"
    },
    {
        "name": "San Marino",
        "code": "SM"
    },
    {
        "name": "Sao Tome and Principe",
        "code": "ST"
    },
    {
        "name": "Saudi Arabia",
        "code": "SA"
    },
    {
        "name": "Senegal",
        "code": "SN"
    },
    {
        "name": "Serbia",
        "code": "RS"
    },
        {
        "name": "Montenegro",
        "code": "ME"
    },
    {
        "name": "Seychelles",
        "code": "SC"
    },
    {
        "name": "Sierra Leone",
        "code": "SL"
    },
    {
        "name": "Singapore",
        "code": "SG"
    },
    {
        "name": "Slovakia",
        "code": "SK"
    },
    {
        "name": "Slovenia",
        "code": "SI"
    },
    {
        "name": "Solomon Islands",
        "code": "SB"
    },
    {
        "name": "Somalia",
        "code": "SO"
    },
    {
        "name": "South Africa",
        "code": "ZA"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "code": "GS"
    },
    {
        "name": "Spain",
        "code": "ES"
    },
    {
        "name": "Sri Lanka",
        "code": "LK"
    },
    {
        "name": "Sudan",
        "code": "SD"
    },
    {
        "name": "Suriname",
        "code": "SR"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "code": "SJ"
    },
    {
        "name": "Swaziland",
        "code": "SZ"
    },
    {
        "name": "Sweden",
        "code": "SE"
    },
    {
        "name": "Switzerland",
        "code": "CH"
    },
    {
        "name": "Syrian Arab Republic",
        "code": "SY"
    },
    {
        "name": "Taiwan, Province of China",
        "code": "TW"
    },
    {
        "name": "Tajikistan",
        "code": "TJ"
    },
    {
        "name": "Tanzania",
        "code": "TZ"
    },
    {
        "name": "Thailand",
        "code": "TH"
    },
    {
        "name": "Timor-Leste",
        "code": "TL"
    },
    {
        "name": "Togo",
        "code": "TG"
    },
    {
        "name": "Tokelau",
        "code": "TK"
    },
    {
        "name": "Tonga",
        "code": "TO"
    },
    {
        "name": "Trinidad and Tobago",
        "code": "TT"
    },
    {
        "name": "Tunisia",
        "code": "TN"
    },
    {
        "name": "Turkey",
        "code": "TR"
    },
    {
        "name": "Turkmenistan",
        "code": "TM"
    },
    {
        "name": "Turks and Caicos Islands",
        "code": "TC"
    },
    {
        "name": "Tuvalu",
        "code": "TV"
    },
    {
        "name": "Uganda",
        "code": "UG"
    },
    {
        "name": "Ukraine",
        "code": "UA"
    },
    {
        "name": "United Arab Emirates",
        "code": "AE"
    },
    {
        "name": "United States Minor Outlying Islands",
        "code": "UM"
    },
    {
        "name": "Uruguay",
        "code": "UY"
    },
    {
        "name": "Uzbekistan",
        "code": "UZ"
    },
    {
        "name": "Vanuatu",
        "code": "VU"
    },
    {
        "name": "Venezuela",
        "code": "VE"
    },
    {
        "name": "Viet Nam",
        "code": "VN"
    },
    {
        "name": "Virgin Islands, British",
        "code": "VG"
    },
    {
        "name": "Virgin Islands, U.S.",
        "code": "VI"
    },
    {
        "name": "Wallis and Futuna",
        "code": "WF"
    },
    {
        "name": "Western Sahara",
        "code": "EH"
    },
    {
        "name": "Yemen",
        "code": "YE"
    },
    {
        "name": "Zambia",
        "code": "ZM"
    },
    {
        "name": "Zimbabwe",
        "code": "ZW"
    }
];


var languages = [
      {"code":"ab","name":"Abkhaz","nativeName":"аҧсуа"},
      {"code":"aa","name":"Afar","nativeName":"Afaraf"},
      {"code":"af","name":"Afrikaans","nativeName":"Afrikaans"},
      {"code":"ak","name":"Akan","nativeName":"Akan"},
      {"code":"sq","name":"Albanian","nativeName":"Shqip"},
      {"code":"am","name":"Amharic","nativeName":"አማርኛ"},
      {"code":"ar","name":"Arabic","nativeName":"العربية"},
      {"code":"an","name":"Aragonese","nativeName":"Aragonés"},
      {"code":"hy","name":"Armenian","nativeName":"Հայերեն"},
      {"code":"as","name":"Assamese","nativeName":"অসমীয়া"},
      {"code":"av","name":"Avaric","nativeName":"авар мацӀ, магӀарул мацӀ"},
      {"code":"ae","name":"Avestan","nativeName":"avesta"},
      {"code":"ay","name":"Aymara","nativeName":"aymar aru"},
      {"code":"az","name":"Azerbaijani","nativeName":"azərbaycan dili"},
      {"code":"bm","name":"Bambara","nativeName":"bamanankan"},
      {"code":"ba","name":"Bashkir","nativeName":"башҡорт теле"},
      {"code":"eu","name":"Basque","nativeName":"euskara, euskera"},
      {"code":"be","name":"Belarusian","nativeName":"Беларуская"},
      {"code":"bn","name":"Bengali","nativeName":"বাংলা"},
      {"code":"bh","name":"Bihari","nativeName":"भोजपुरी"},
      {"code":"bi","name":"Bislama","nativeName":"Bislama"},
      {"code":"bs","name":"Bosnian","nativeName":"bosanski jezik"},
      {"code":"br","name":"Breton","nativeName":"brezhoneg"},
      {"code":"bg","name":"Bulgarian","nativeName":"български език"},
      {"code":"my","name":"Burmese","nativeName":"ဗမာစာ"},
      {"code":"ca","name":"Catalan; Valencian","nativeName":"Català"},
      {"code":"ch","name":"Chamorro","nativeName":"Chamoru"},
      {"code":"ce","name":"Chechen","nativeName":"нохчийн мотт"},
      {"code":"ny","name":"Chichewa; Chewa; Nyanja","nativeName":"chiCheŵa, chinyanja"},
      {"code":"zh","name":"Chinese","nativeName":"中文 (Zhōngwén), 汉语, 漢語"},
      {"code":"cv","name":"Chuvash","nativeName":"чӑваш чӗлхи"},
      {"code":"kw","name":"Cornish","nativeName":"Kernewek"},
      {"code":"co","name":"Corsican","nativeName":"corsu, lingua corsa"},
      {"code":"cr","name":"Cree","nativeName":"ᓀᐦᐃᔭᐍᐏᐣ"},
      {"code":"hr","name":"Croatian","nativeName":"hrvatski"},
      {"code":"cs","name":"Czech","nativeName":"česky, čeština"},
      {"code":"da","name":"Danish","nativeName":"dansk"},
      {"code":"dv","name":"Divehi; Dhivehi; Maldivian;","nativeName":"ދިވެހި"},
      {"code":"nl","name":"Dutch","nativeName":"Nederlands, Vlaams"},
      {"code":"en","name":"English","nativeName":"English"},
      {"code":"eo","name":"Esperanto","nativeName":"Esperanto"},
      {"code":"et","name":"Estonian","nativeName":"eesti, eesti keel"},
      {"code":"ee","name":"Ewe","nativeName":"Eʋegbe"},
      {"code":"fo","name":"Faroese","nativeName":"føroyskt"},
      {"code":"fj","name":"Fijian","nativeName":"vosa Vakaviti"},
      {"code":"fi","name":"Finnish","nativeName":"suomi, suomen kieli"},
      {"code":"fr","name":"French","nativeName":"français, langue française"},
      {"code":"ff","name":"Fula; Fulah; Pulaar; Pular","nativeName":"Fulfulde, Pulaar, Pular"},
      {"code":"gl","name":"Galician","nativeName":"Galego"},
      {"code":"ka","name":"Georgian","nativeName":"ქართული"},
      {"code":"de","name":"German","nativeName":"Deutsch"},
      {"code":"el","name":"Greek, Modern","nativeName":"Ελληνικά"},
      {"code":"gn","name":"Guaraní","nativeName":"Avañeẽ"},
      {"code":"gu","name":"Gujarati","nativeName":"ગુજરાતી"},
      {"code":"ht","name":"Haitian; Haitian Creole","nativeName":"Kreyòl ayisyen"},
      {"code":"ha","name":"Hausa","nativeName":"Hausa, هَوُسَ"},
      {"code":"he","name":"Hebrew (modern)","nativeName":"עברית"},
      {"code":"hz","name":"Herero","nativeName":"Otjiherero"},
      {"code":"hi","name":"Hindi","nativeName":"हिन्दी, हिंदी"},
      {"code":"ho","name":"Hiri Motu","nativeName":"Hiri Motu"},
      {"code":"hu","name":"Hungarian","nativeName":"Magyar"},
      {"code":"ia","name":"Interlingua","nativeName":"Interlingua"},
      {"code":"id","name":"Indonesian","nativeName":"Bahasa Indonesia"},
      {"code":"ie","name":"Interlingue","nativeName":"Originally called Occidental; then Interlingue after WWII"},
      {"code":"ga","name":"Irish","nativeName":"Gaeilge"},
      {"code":"ig","name":"Igbo","nativeName":"Asụsụ Igbo"},
      {"code":"ik","name":"Inupiaq","nativeName":"Iñupiaq, Iñupiatun"},
      {"code":"io","name":"Ido","nativeName":"Ido"},
      {"code":"is","name":"Icelandic","nativeName":"Íslenska"},
      {"code":"it","name":"Italian","nativeName":"Italiano"},
      {"code":"iu","name":"Inuktitut","nativeName":"ᐃᓄᒃᑎᑐᑦ"},
      {"code":"ja","name":"Japanese","nativeName":"日本語 (にほんご／にっぽんご)"},
      {"code":"jv","name":"Javanese","nativeName":"basa Jawa"},
      {"code":"kl","name":"Kalaallisut, Greenlandic","nativeName":"kalaallisut, kalaallit oqaasii"},
      {"code":"kn","name":"Kannada","nativeName":"ಕನ್ನಡ"},
      {"code":"kr","name":"Kanuri","nativeName":"Kanuri"},
      {"code":"ks","name":"Kashmiri","nativeName":"कश्मीरी, كشميري‎"},
      {"code":"kk","name":"Kazakh","nativeName":"Қазақ тілі"},
      {"code":"km","name":"Khmer","nativeName":"ភាសាខ្មែរ"},
      {"code":"ki","name":"Kikuyu, Gikuyu","nativeName":"Gĩkũyũ"},
      {"code":"rw","name":"Kinyarwanda","nativeName":"Ikinyarwanda"},
      {"code":"ky","name":"Kirghiz, Kyrgyz","nativeName":"кыргыз тили"},
      {"code":"kv","name":"Komi","nativeName":"коми кыв"},
      {"code":"kg","name":"Kongo","nativeName":"KiKongo"},
      {"code":"ko","name":"Korean","nativeName":"한국어 (韓國語), 조선말 (朝鮮語)"},
      {"code":"ku","name":"Kurdish","nativeName":"Kurdî, كوردی‎"},
      {"code":"kj","name":"Kwanyama, Kuanyama","nativeName":"Kuanyama"},
      {"code":"la","name":"Latin","nativeName":"latine, lingua latina"},
      {"code":"lb","name":"Luxembourgish, Letzeburgesch","nativeName":"Lëtzebuergesch"},
      {"code":"lg","name":"Luganda","nativeName":"Luganda"},
      {"code":"li","name":"Limburgish, Limburgan, Limburger","nativeName":"Limburgs"},
      {"code":"ln","name":"Lingala","nativeName":"Lingála"},
      {"code":"lo","name":"Lao","nativeName":"ພາສາລາວ"},
      {"code":"lt","name":"Lithuanian","nativeName":"lietuvių kalba"},
      {"code":"lu","name":"Luba-Katanga","nativeName":""},
      {"code":"lv","name":"Latvian","nativeName":"latviešu valoda"},
      {"code":"gv","name":"Manx","nativeName":"Gaelg, Gailck"},
      {"code":"mk","name":"Macedonian","nativeName":"македонски јазик"},
      {"code":"mg","name":"Malagasy","nativeName":"Malagasy fiteny"},
      {"code":"ms","name":"Malay","nativeName":"bahasa Melayu, بهاس ملايو‎"},
      {"code":"ml","name":"Malayalam","nativeName":"മലയാളം"},
      {"code":"mt","name":"Maltese","nativeName":"Malti"},
      {"code":"mi","name":"Māori","nativeName":"te reo Māori"},
      {"code":"mr","name":"Marathi (Marāṭhī)","nativeName":"मराठी"},
      {"code":"mh","name":"Marshallese","nativeName":"Kajin M̧ajeļ"},
      {"code":"mn","name":"Mongolian","nativeName":"монгол"},
      {"code":"na","name":"Nauru","nativeName":"Ekakairũ Naoero"},
      {"code":"nv","name":"Navajo, Navaho","nativeName":"Diné bizaad, Dinékʼehǰí"},
      {"code":"nb","name":"Norwegian Bokmål","nativeName":"Norsk bokmål"},
      {"code":"nd","name":"North Ndebele","nativeName":"isiNdebele"},
      {"code":"ne","name":"Nepali","nativeName":"नेपाली"},
      {"code":"ng","name":"Ndonga","nativeName":"Owambo"},
      {"code":"nn","name":"Norwegian Nynorsk","nativeName":"Norsk nynorsk"},
      {"code":"no","name":"Norwegian","nativeName":"Norsk"},
      {"code":"ii","name":"Nuosu","nativeName":"ꆈꌠ꒿ Nuosuhxop"},
      {"code":"nr","name":"South Ndebele","nativeName":"isiNdebele"},
      {"code":"oc","name":"Occitan","nativeName":"Occitan"},
      {"code":"oj","name":"Ojibwe, Ojibwa","nativeName":"ᐊᓂᔑᓈᐯᒧᐎᓐ"},
      {"code":"cu","name":"Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic","nativeName":"ѩзыкъ словѣньскъ"},
      {"code":"om","name":"Oromo","nativeName":"Afaan Oromoo"},
      {"code":"or","name":"Oriya","nativeName":"ଓଡ଼ିଆ"},
      {"code":"os","name":"Ossetian, Ossetic","nativeName":"ирон æвзаг"},
      {"code":"pa","name":"Panjabi, Punjabi","nativeName":"ਪੰਜਾਬੀ, پنجابی‎"},
      {"code":"pi","name":"Pāli","nativeName":"पाऴि"},
      {"code":"fa","name":"Persian","nativeName":"فارسی"},
      {"code":"pl","name":"Polish","nativeName":"polski"},
      {"code":"ps","name":"Pashto, Pushto","nativeName":"پښتو"},
      {"code":"pt","name":"Portuguese","nativeName":"Português"},
      {"code":"qu","name":"Quechua","nativeName":"Runa Simi, Kichwa"},
      {"code":"rm","name":"Romansh","nativeName":"rumantsch grischun"},
      {"code":"rn","name":"Kirundi","nativeName":"kiRundi"},
      {"code":"ro","name":"Romanian, Moldavian, Moldovan","nativeName":"română"},
      {"code":"ru","name":"Russian","nativeName":"русский язык"},
      {"code":"sa","name":"Sanskrit (Saṁskṛta)","nativeName":"संस्कृतम्"},
      {"code":"sc","name":"Sardinian","nativeName":"sardu"},
      {"code":"sd","name":"Sindhi","nativeName":"सिन्धी, سنڌي، سندھی‎"},
      {"code":"se","name":"Northern Sami","nativeName":"Davvisámegiella"},
      {"code":"sm","name":"Samoan","nativeName":"gagana faa Samoa"},
      {"code":"sg","name":"Sango","nativeName":"yângâ tî sängö"},
      {"code":"sr","name":"Serbian","nativeName":"српски језик"},
      {"code":"gd","name":"Scottish Gaelic; Gaelic","nativeName":"Gàidhlig"},
      {"code":"sn","name":"Shona","nativeName":"chiShona"},
      {"code":"si","name":"Sinhala, Sinhalese","nativeName":"සිංහල"},
      {"code":"sk","name":"Slovak","nativeName":"slovenčina"},
      {"code":"sl","name":"Slovene","nativeName":"slovenščina"},
      {"code":"sl-SI","name":"Slovene","nativeName":"slovenščina"},
      {"code":"so","name":"Somali","nativeName":"Soomaaliga, af Soomaali"},
      {"code":"st","name":"Southern Sotho","nativeName":"Sesotho"},
      {"code":"es","name":"Spanish; Castilian","nativeName":"español, castellano"},
      {"code":"su","name":"Sundanese","nativeName":"Basa Sunda"},
      {"code":"sw","name":"Swahili","nativeName":"Kiswahili"},
      {"code":"ss","name":"Swati","nativeName":"SiSwati"},
      {"code":"sv","name":"Swedish","nativeName":"svenska"},
      {"code":"ta","name":"Tamil","nativeName":"தமிழ்"},
      {"code":"te","name":"Telugu","nativeName":"తెలుగు"},
      {"code":"tg","name":"Tajik","nativeName":"тоҷикӣ, toğikī, تاجیکی‎"},
      {"code":"th","name":"Thai","nativeName":"ไทย"},
      {"code":"ti","name":"Tigrinya","nativeName":"ትግርኛ"},
      {"code":"bo","name":"Tibetan Standard, Tibetan, Central","nativeName":"བོད་ཡིག"},
      {"code":"tk","name":"Turkmen","nativeName":"Türkmen, Түркмен"},
      {"code":"tl","name":"Tagalog","nativeName":"Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"},
      {"code":"tn","name":"Tswana","nativeName":"Setswana"},
      {"code":"to","name":"Tonga (Tonga Islands)","nativeName":"faka Tonga"},
      {"code":"tr","name":"Turkish","nativeName":"Türkçe"},
      {"code":"ts","name":"Tsonga","nativeName":"Xitsonga"},
      {"code":"tt","name":"Tatar","nativeName":"татарча, tatarça, تاتارچا‎"},
      {"code":"tw","name":"Twi","nativeName":"Twi"},
      {"code":"ty","name":"Tahitian","nativeName":"Reo Tahiti"},
      {"code":"ug","name":"Uighur, Uyghur","nativeName":"Uyƣurqə, ئۇيغۇرچە‎"},
      {"code":"uk","name":"Ukrainian","nativeName":"українська"},
      {"code":"ur","name":"Urdu","nativeName":"اردو"},
      {"code":"uz","name":"Uzbek","nativeName":"zbek, Ўзбек, أۇزبېك‎"},
      {"code":"ve","name":"Venda","nativeName":"Tshivenḓa"},
      {"code":"vi","name":"Vietnamese","nativeName":"Tiếng Việt"},
      {"code":"vo","name":"Volapük","nativeName":"Volapük"},
      {"code":"wa","name":"Walloon","nativeName":"Walon"},
      {"code":"cy","name":"Welsh","nativeName":"Cymraeg"},
      {"code":"wo","name":"Wolof","nativeName":"Wollof"},
      {"code":"fy","name":"Western Frisian","nativeName":"Frysk"},
      {"code":"xh","name":"Xhosa","nativeName":"isiXhosa"},
      {"code":"yi","name":"Yiddish","nativeName":"ייִדיש"},
      {"code":"yo","name":"Yoruba","nativeName":"Yorùbá"},
      {"code":"za","name":"Zhuang, Chuang","nativeName":"Saɯ cueŋƅ, Saw cuengh"}
    ];

var locales = [
  {
    code: 'en',
    name: 'English',
    is_production: true
  }, {
    code: 'de',
    name: 'Deutsch',
    is_production: true
  }, {
    code: 'el',
    name: 'Ελληνικά',
    is_production: true
  }, {
    code: 'es',
    name: 'Español',
    is_production: true
  }, {
    code: 'fr',
    name: 'Français',
    is_production: true
  }, {
    code: 'id',
    name: 'Indonesian',
    is_production: true
  }, {
    code: 'it',
    name: 'Italiano',
    is_production: true
  }, {
    code: 'pt',
    name: 'Português',
    is_production: true
  }, {
    code: 'ro',
    name: 'Română',
    is_production: true
  }, {
    code: 'sl-SI',
    name: 'Slovenščina',
    is_production: true
  }, {
    code: 'th',
    name: 'ไทย',
    is_production: true
  }, {
    code: 'is',
    name: 'Íslensku',
    is_production: true
  }
];
angular.module("buuqit").constant(
  'CODEMIRROR_SETTINGS',
  {
    lineWrapping : true,
    lineNumbers: true,
    indentWithTabs: true,
    tabSize: 2,
    mode: 'css',
    theme: 'dracula',
    extraKeys: {
      "F11": function(cm) {
        cm.setOption("fullScreen", !cm.getOption("fullScreen"));
        var isFullscreen = cm.getOption("fullScreen");
        if (isFullscreen) {
          cm.getWrapperElement().parentElement.classList.add('opened');
          cm.focus();
        }
        else {
          cm.getWrapperElement().parentElement.classList.remove('opened');
        }
      },
      "Esc": function(cm) {
        if (cm.getOption("fullScreen")) {
          cm.setOption("fullScreen", false);
          cm.getWrapperElement().parentElement.classList.remove('opened')
        }
      }
    }
  }
);
angular.module("buuqit").constant(
  'CALENDAR_SETTINGS',
  {
    blockerColor: '#b4d0f5',
    bookingUnpaidColor: '#ed5b4f',
    bookingPaidColor: '#74c971',
    bookingPartiallyColor: '#fdb650',
    bookingCompanyColor: '#71b4e9',
    bookingGroupColor: '#74c971',
    weekendBorderColor: '#dce7f5',
    useRoundedCorners: false,
    useShiftDisplay: false,
    useFixedWidthZoom: false,
    showChannelCode: false,
    showLastNameFirst: true
  }
);

(function () {
  "use strict";
  angular
    .module('buuqit')
    .run([
      "$route",
      "$http",
      "$location",
      "$rootScope",
      "$i18next",
      "$filter",
      "$modal",
      "$cookies",
      "$document",
      "$mdDialog",
      "$bookingDrawer",
      "$compile",
      "$templateRequest",
      "$mdToast",
      "$timeout",
      "$interval",
      "localStorageService",
      "UserFactory",
      "SessionFactory",
      "HotelFactory",
      "BookingStorage",
      "NetworkChecker",
      "angulargmContainer",
      "SpecialOfferFactory",
      "CalendarStorage",
      "Seasons",
      "RateByDateStorage",
      "DateNotesStorage",
      "WaitlistStorage",
      "CurrencyProfiles",
      "SaleChannelStorage",
      "NewTaxStorage",
      "UIDialogService",
      "AccountingCategoriesStorage",
      "RoomBuilderService",
      "RestrictionsService",
      "RoomRatesStorage",
      "SentryService",
      function ($route, $http, $location, $rootScope, $i18next, $filter, $modal, $cookies, $document, $mdDialog, $bookingDrawer, $compile, $templateRequest, $mdToast, $timeout, $interval, localStorageService, UserFactory, SessionFactory, Hotel, BookingStorage, NetworkChecker, angulargmContainer, SpecialOfferFactory, CalendarStorage, Seasons, RateByDateStorage, DateNotesStorage, WaitlistStorage, CurrencyProfiles, SaleChannelStorage, NewTaxStorage, UIDialogService, AccountingCategoriesStorage, RoomBuilderService, RestrictionsService, RoomRatesStorage, SentryService) {
        (function () {
          var reduce = Function.bind.call(Function.call, Array.prototype.reduce);
          var isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
          var concat = Function.bind.call(Function.call, Array.prototype.concat);
          var keys = Reflect.ownKeys;

          if (!Object.values) {
            Object.values = function values(O) {
              return reduce(keys(O), function (v, k) {
                concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []), []
              });
            };
          }

          if (!Object.entries) {
            Object.entries = function entries(O) {
              return reduce(keys(O), function (e, k) {
                concat(e, typeof k === 'string' && isEnumerable(O, k) ? [
                  [k, O[k]]
                ] : []), []
              });
            };
          }
        })();

        var ROLES = {
          'user': 'user',
          'owner': 'user',
          'manager': 'user',
          'reception': 'reception',
          'reception_no_finance': 'reception_no_finance',
          'housekeeper': 'housekeeper',
          'reports_bookings_customers': 'reports_bookings_customers'
        };

        var PRODUCTION_DOMAIN = [
          "dev.thebookingfactory.com",
          "app.thebookingfactory.com",
          "app.frontdeskexpress.com",
          "app.acemsthailand.com",
          "app.boostly.co.uk",
          "app.all-in-one-digital-hotel.com",
          "frontdesk.travelbookgroup.com",
          "frontdesk.rainmaker.travel",
          "app.ngeluwunganhotelsoftware.com",
          "app.juvohotels.ro",
          "app.juvo.ro",
          "app.myhoteliq.com",
          "app.lion-revenue.com",
          "frontdesk.webconnection.asia",
          "app.siliconres.com",
          "app.hashtag-hotels.com",
          "app.coverpms.is",
          "app.reservatio.com.mx",
          "app.sortmybookings.com",
          "app.fairwinghotels.com",
          "app.fairwinglabs.com",
          "app.behottel.com",
          "app.cover.is",
          "app.skuli.me",
          "app.albpms.al",
          "app.gohotelpms.com",
          "app.roommanager.ie",
          "app.ionian.eu",
          "app.mssnctrl.io",
          "app.res-suite.com",
          "app.admagiq.es",
          "app.luxepms.com",
          "app.reservationcentric.com",
          "app.hotelinfo-online.net",
          "app.manageyourinn.com",
          "app.ternstay.com",
          "app.emberspec.net",
          "app.myguesthub.com.au",
          "sinazo.jurni.app",
          "app.syncnbook.com"
        ];

        var HOUSEKEEPING_ENABLED_DOMAINS = {
          "app.test.thebookingfactory.com": "https://housekeeping.test.bookingfactory.io/",
          "app.thebookingfactory.com": "https://housekeeping.bookingfactory.io/",
          "app.albpms.al": "https://housekeeping.albpms.al/"
        };

        var subscriptionInterval;

        var token = $cookies.get('buuqit_token');
        $rootScope.notificationsIsEnabled = false;
        $rootScope.server_path = SERVER_PATH;
        $rootScope.filter = '';
        $rootScope.env = PRODUCTION_DOMAIN.indexOf(window.location.host) != -1 ? 'production' : 'development';
        $rootScope.locales = locales;
        $rootScope.red_highlight = $rootScope.server_path.indexOf('localhost') != -1;
        $rootScope.missedI18n = window.missedI18n;
        $rootScope.version = window.VERSION;
        $rootScope.housekeeping_link = window.location.host in HOUSEKEEPING_ENABLED_DOMAINS ? HOUSEKEEPING_ENABLED_DOMAINS[window.location.host] : '';
        $rootScope.current_date_from = moment().format('YYYY-MM-DD');
        $rootScope.current_date_to = moment().add(80, 'days').format('YYYY-MM-DD');
        $rootScope.grecaptcha_site_key = '6LcksCAqAAAAAJELXANWWUFjziiFM4pmFNMsGweX';

        var productionEnv = $rootScope.env === 'production';

        // Init Sentry
        if (productionEnv) {
          SentryService.init();
        }

        if ('Notification' in window) {
          $rootScope.notificationsIsEnabled = Notification.permission === 'granted';
        }

        if (mobilecheck()) {
          angular.element('body').addClass('mobile');
        }

        var gmapPromise = angulargmContainer.getMapPromise('hotelLocationMap');
        var gmapPromise2 = angulargmContainer.getMapPromise('WebsiteMap');

        gmapPromise.then(function (gmap) {
          $rootScope.profile_hotel_gmap = gmap;
        });

        gmapPromise2.then(function (gmap) {
          $rootScope.website_gmap = gmap;
        });

        var sendGoogleAnalyticsPageView = function () {
          if (typeof($rootScope.hotel) == 'undefined') {
            return;
          }
          ga('create', 'UA-177562543-1', 'auto');
          ga('set', 'dimension1', $rootScope.hotel.name);
          ga('send', {
            'hitType': 'pageview',
            'page': location.hash
          });
        }

        var initializeNotifications = function () {
          if ('Notification' in window) {
            var notificationRequest = Notification.requestPermission();
            if (notificationRequest) {
              notificationRequest.then(function (rule) {
                $rootScope.notificationsIsEnabled = rule === 'granted';
              });
            }
          }
        }

        var initializeCurrencyUpdate = function () {
          setInterval(
            function () {
              CurrencyProfiles.load();
            },
            1000 * 60 * 60 * 24
          );
        }

        var initializePusherChannel = function () {
          // Initialize Pusher
          Pusher.logToConsole = false;
          var pusherId = $rootScope.env === 'production' ? '4f71c9f873f5dd48c70e' : '4eea38ada514b5a7978b';
          var pusher = new Pusher(pusherId, {
            cluster: 'eu',
            encrypted: true
          });

          if ($rootScope.pusher_channel) {
            pusher.unsubscribe($rootScope.hotel.slug);
          }
          $rootScope.pusher_channel = pusher.subscribe($rootScope.hotel.slug);

          $rootScope.pusher_channel.bind('sale_channels:reload', function () {
            SaleChannelStorage.load().then(function () {
              $rootScope.$broadcast('sale_channels:updated');
            });
          });

          $rootScope.pusher_channel.bind('accounting_categories:reload', function () {
            AccountingCategoriesStorage.load().then(function () {
              $rootScope.$broadcast('accounting_categories:updated');
            });
          });

          $rootScope.pusher_channel.bind('extras:reload', function () {
            NewTaxStorage.load().then(function () {
              $rootScope.$broadcast('extras:updated');
            });
          });

          $rootScope.pusher_channel.bind('calendar:guest', function (payload) {
            if ($rootScope.activeBookingId && !$rootScope.isDisabledPusherEvents) {
              var booking = BookingStorage.get($rootScope.activeBookingId);
              if (booking && booking.rooms) {
                var updatedGuest = booking.rooms.find(function (room) {
                  return room.guests.find(function (guest) {
                    return guest.id == payload.guest_id;
                  });
                });
                if (updatedGuest) {
                  $rootScope.notify($i18next.t('This booking has been updated by another user, please reopen the booking to fetch latest version'));
                }
              }
            }
          });

          $rootScope.pusher_channel.bind('calendar:date_note', function (event) {
            DateNotesStorage.get_by_id(event.room_note_id);
          });

          $rootScope.pusher_channel.bind('hk:reload_room', function (data) {
            $rootScope.$broadcast('hk:reload_room', data.room)
          });

          $rootScope.pusher_channel.bind('hk:reload_rooms', function (data) {
            $rootScope.$broadcast('hk:reload_rooms', data.rooms)
          });

          $rootScope.pusher_channel.bind('features:change', function (data) {
            if (window.features === undefined) {
              window.features = {};
            }
            Object.keys(data).forEach(function (k) {
              window.features[k] = data[k];
            });
          });

          $rootScope.isDisabledPusherEvents = false;

          $rootScope.pusher_channel.bind('calendar:update_booking', function (payload) {
            if ($rootScope.activeBookingId == payload.booking_id) {
              if ($rootScope.isDisabledPusherEvents) {
                BookingStorage.load_by_id(payload.booking_id, false, function (booking) {
                  $rootScope.$broadcast('booking_management:reload', booking);
                  BookingStorage.updateCache();
                });
              } else {
                $rootScope.notify($i18next.t('This booking has been updated by another user, please reopen the booking to fetch latest version'));
              }
            }
          });
          $rootScope.pusher_channel.bind('booking', function (message) {
            if ($rootScope.lastModifiedBooking != message.booking_id) {
              BookingStorage.load_by_id(message.booking_id, false, function (data) {
                var channel = data.channel ? data.channel : 'Website';
                if ($rootScope.notificationsIsEnabled) {
                  var words = {
                    'Cancellation': {
                      title: $i18next.t('common_for_app.new_booking_notification_js_code.new_cancellation_title'),
                      body: $i18next.t('common_for_app.new_booking_notification_js_code.cancelled_booking_from_body') + ' ' + channel
                    },
                    'Modification': {
                      title: $i18next.t('common_for_app.new_booking_notification_js_code.booking_was_modified_title'),
                      body: $i18next.t('common_for_app.new_booking_notification_js_code.modified_booking_from_body') + ' ' + channel
                    },
                    'Booking': {
                      title: $i18next.t('common_for_app.new_booking_notification_js_code.new_booking_title'),
                      body: $i18next.t('common_for_app.new_booking_notification_js_code.new_booking_from_body') + ' ' + channel
                    }
                  }

                  if (message.source != 'app') {
                    var notification = new Notification('New Booking', {
                      title: words[message.message].title,
                      icon: $rootScope.server_path + '/api/public/v1/favicon',
                      body: words[message.message].body,
                      data: {
                        booking_id: message.booking_id
                      }
                    });

                    notification.onclick = function (e) {
                      window.focus();
                      $rootScope.openBookingManagementModal(e.target.data.booking_id);
                    }
                  }
                }
              });
            }

            $rootScope.lastModifiedBooking = null;
          });
        };

        var original = $location.path;
        $location.path = function (path, reload) {
          if (reload === false) {
            var lastRoute = $route.current;
            var un = $rootScope.$on('$locationChangeSuccess', function () {
              $route.current = lastRoute;
              un();
            });
          }
          return original.apply($location, [path]);
        };

        if (window.applicationCache && window.applicationCache.status !== 0) {
          window.applicationCache.addEventListener('updateready', function () {
            if ($rootScope.waitStamp === undefined || new Date().getTime() - $rootScope.waitStamp > 300000) {
              UIDialogService.open('update-confirmation', {
                title: $i18next.t('common_for_app.confirm.update_available_title'),
                text: $i18next.t('common_for_app.confirm.the_application_has_been_updated_htmlcontent'),
                negative: $i18next.t('common_for_app.confirm.wait_5_minutes_cancel'),
                positive: $i18next.t('common_for_app.confirm.ok_ok'),
                positive_callback: function () {
                  var locale = localStorage.getItem('user_locale');

                  localStorage.clear();
                  localforage.clear();

                  localStorage.setItem('user_locale', locale);

                  window.location.reload();
                },
                negative_callback: function () {
                  $rootScope.waitStamp = new Date().getTime();
                }
              });
            }
          });
        }

        if ('serviceWorker' in navigator && productionEnv) {
          navigator.serviceWorker.register('service-worker.js').then(function (reg) {
            if (navigator.serviceWorker.controller && navigator.serviceWorker.controller.state == 'activated') {
              setInterval(function () {
                reg.update();
              }, 300000);
            }
            reg.onupdatefound = function () {
              var installingWorker = reg.installing;

              installingWorker.onstatechange = function () {
                switch (installingWorker.state) {
                  case 'installed':
                    if (navigator.serviceWorker.controller) {
                      UIDialogService.open('update-confirmation', {
                        title: $i18next.t('common_for_app.confirm.update_available_title'),
                        text: $i18next.t('common_for_app.confirm.the_application_has_been_updated_htmlcontent'),
                        negative: $i18next.t('common_for_app.confirm.later_cancel'),
                        positive: $i18next.t('common_for_app.confirm.ok_ok'),
                        positive_callback: function () {
                          var locale = localStorage.getItem('user_locale');

                          localStorage.clear();
                          localforage.clear();

                          localStorage.setItem('user_locale', locale);

                          window.location.reload();
                        },
                        negative_callback: function () {}
                      });
                    } else {
                      console.log('Content is now available offline!');
                    }
                    break;

                  case 'redundant':
                    console.error('The installing service worker became redundant.');
                    break;
                }
              };
            };
          }).catch(function (e) {
            console.error('Error during service worker registration:', e);
          });
        }

        var isFreshChatUserInitiated = function () {
          return window.fcWidget.user.isExists()
            .then(function (data) {
              if (data && data.data === true) {
                return Promise.resolve(true);
              }
            })
            .catch(function (error) {
              console.error("Error fetching if Freshchat user is initiated", error);
              return Promise.resolve(false)
            });
        }

        var clearFreshChatUser = function () {
          return window.fcWidget.user.clear()
            .then(function (data) {
              return Promise.resolve(data);
            })
            .catch(function (error) {
              console.error("Error fetching Freshchat user", error);
              return Promise.resolve(false);
            });
        }

        var clearFreshChatUserData = function () {
          return isFreshChatUserInitiated()
            .then(function (isInitiated) {
              if (isInitiated) {
                return clearFreshChatUser()
                  .then(function (clearData) {
                    return clearData;
                  });
              } else {
                return Promise.resolve();
              }
            })
            .catch(function (error) {
              console.error("Error fetching if Freshchat user is initiated", error);
            });
        }

        $rootScope.data = {};

        $rootScope.getUser = function () {
          if ($rootScope.networkStatus) {
            angular.element('.loader-system').addClass('ng-hide');
            angular.element('.loader-user').removeClass('ng-hide');
            SessionFactory.get($cookies.get('buuqit_user')).then(
              function (data) {
                $rootScope.initUser(true, data.user);
                angular.element('body').removeClass('login-body');
                angular.element('.navbar').removeClass('hidden');
              },
              function () {
                angular.element('.loader-user').addClass('ng-hide');
                $rootScope.clearSession();
                $location.path(LOGIN_PATH);
              }
            );
          } else {
            if (localStorage.getItem('user') !== null) {
              $rootScope.user = JSON.parse(localStorage.getItem('user'));
              $rootScope.user.name = $rootScope.user.name ? $rootScope.user.name : 'User';
              $rootScope.signedIn = true;
              $rootScope.loadHotel();
            }
          }
        };


        $rootScope.initUser = function (signed, data) {
          if (signed === undefined) {
            signed = false;
          }

          if (data === undefined) {
            data = {};
          }

          $rootScope.user = data;
          $rootScope.user.name = data.name ? data.name : 'User';
          localStorage.setItem('user', JSON.stringify(data));
          $rootScope.signedIn = signed;
          $rootScope.$broadcast('user_signed');
          angular.element('.loader-user').addClass('ng-hide');
          angular.element('.loader-hotel').removeClass('ng-hide');

          if ($rootScope.user.systemRole != 'admin' && $rootScope.user.systemRole != 'corporate_admin' && $rootScope.user.systemRole != 'white_admin') {
            if ($location.path() == '/login' || $location.path() == '/admin') {
              $location.path('/');
            }
            $rootScope.loadHotel();
          } else {
            angular.element('body').removeClass('login-body');
            angular.element('.navbar').removeClass('hidden');

            if (!localStorage.getItem('admin_hotel')) {
              $location.path('/admin');
            } else {
              $rootScope.loadHotel();
            }
          }
        };


        $rootScope.setUserToken = function (userId, token, userName, userEmail) {
          $http.defaults.headers.common['AUTHORIZATION'] = token;

          $cookies.put('buuqit_token', token, {
            path: '/'
          });
          $cookies.put('buuqit_user', userId, {
            path: '/'
          });

          $cookies.put('buuqit_user_name', userName, {
            path: '/'
          });

          $cookies.put('buuqit_user_email', userEmail, {
            path: '/'
          });
        };

        $rootScope.setRememberMeToken = function (token) {
          $cookies.put('x-device-bf', token, {
            path: '/',
            expires: moment(new Date()).add(60, 'days').toDate(),
            secure: true,
            samesite: "strict"
          });
        };

        $rootScope.clearSession = function () {
          delete $rootScope.user;
          delete $rootScope.domain_settings;
          delete $http.defaults.headers.common['AUTHORIZATION'];

          localStorage.removeItem('user');
          localStorage.removeItem('admin_hotel');
          localforage.removeItem('domain_settings');
          $cookies.remove('user', {
            path: '/'
          });
          $cookies.remove('buuqit_token', {
            path: '/'
          });
          $cookies.remove('buuqit_user', {
            path: '/'
          });
          $cookies.remove('test-user')
          $cookies.remove('buuqit_user_name', {
            path: '/'
          })
          $cookies.remove('buuqit_user_email', {
            path: '/'
          })
          $cookies.remove('hotel_id', {
            path: '/'
          });

          $cookies.remove('buuqit_user_locale', {
            path: '/'
          })

          localStorage.removeItem('blockersCache');
          // TODO: Remove after migration to localforage
          localStorage.removeItem('bookingCache');
          localStorage.removeItem('datenotesCache');
          localStorage.removeItem('hotel');
          localStorage.removeItem('hotel_id');

          localforage.removeItem('bookingCache');
          localforage.removeItem('blockersCache');
          localforage.removeItem('datenotesCache');
          localforage.removeItem('calendar');
          localforage.removeItem('domain_settings');
        };


        $rootScope.logout = function () {
          (new SessionFactory({
            id: 1
          })).delete()
            .then(function () {
              $rootScope.clearSession();
              if (window.fcWidget) {
                clearFreshChatUserData()
                  .then(function () {
                    console.log('Cleared FreshChat user');
                  })
                  .catch(function (error) {
                    console.error("Error clearing Freshchat user", error);
                  });
              }

              $location.path(LOGIN_PATH);
            });
        };


        $rootScope.loadHotel = function () {
          var initial_hotel_id = localStorage.getItem('hotel_id');
          var hotel_id = initial_hotel_id;
          var admin_hotel_id = localStorage.getItem('admin_hotel');

          if (!hotel_id) {
            hotel_id = admin_hotel_id;
          }

          if ($rootScope.user && $rootScope.user.hotels) {
            if (hotel_id == null && $rootScope.user.hotels.length > 1) {
              $mdDialog
                .show({
                  controller: ChooseHotelCtrl,
                  templateUrl: getTemplatePath('modals/chooseHotel.html'),
                  parent: angular.element(document.body),
                  clickOutsideToClose: true,
                  locals: {
                    local: {
                      parent: $rootScope,
                      hotels: $rootScope.user.hotels
                    }
                  }
                });
            }
            if ($rootScope.user.hotels.length === 0) {
              $location.path('/logout');
              $rootScope.alert($i18next.t('common_for_app.alert.your_user_does_not_associate_with_hotel_js_str'));
            } else {
              if (admin_hotel_id && admin_hotel_id != initial_hotel_id) {
                var hotel = $rootScope.user.hotels.filter(function (el) {
                  return el.id == admin_hotel_id
                })[0];

                if (hotel) {
                  return $rootScope.changeHotel(hotel);
                }
              }

              if (!$rootScope.isBookingFactoryProduction && productionEnv && $rootScope.domain_settings.intercom_code) {
                window.Intercom("boot", {
                  app_id: $rootScope.domain_settings.intercom_code,
                  name: $rootScope.user.name,
                  email: $rootScope.user.email,
                  created_at: Math.floor(new Date($rootScope.user.createdAt).getTime() / 1000),
                  application_version: window.VERSION,
                });
              }

              if ($rootScope.isBookingFactoryProduction) {
                // Beamer initialization
                window.beamer_config = {
                  product_id: 'BOYVerWe27307',
                  user_firstname: $rootScope.user.name,
                  user_lastname: '',
                  user_email: $rootScope.user.email,
                  user_id: $rootScope.user.id,
                  selector: 'beamer-newsfeed-button',
                };

                var elementContainer = angular.element('body');
                var beamerScript = document.createElement('script');
                beamerScript.setAttribute("src", "https://app.getbeamer.com/js/beamer-embed.js");

                elementContainer.append(beamerScript);

                // FreshChat initialization
                window.fcWidgetMessengerConfig = {
                  firstName: ' ',
                  lastName: $rootScope.user.name,
                  email: $rootScope.user.email
                }

                var freshChatScript = document.createElement("script");
                freshChatScript.setAttribute("type","text/javascript");
                freshChatScript.setAttribute("src", "//fw-cdn.com/1430544/2394900.js")
                freshChatScript.setAttribute("widgetId", "7777d052-c011-412b-b3a6-4165481a35a6")
                document.body.appendChild(freshChatScript);

              }

              localforage.getItem('hotel').then(function (stored_hotel) {
                angular.element('.loader-hotel').removeClass('ng-hide');

                if ($rootScope.networkStatus) {
                  if ($rootScope.user.hotels.map(function (h) {
                      return h.id
                    }).indexOf(Number(hotel_id)) == -1) {
                    hotel_id = $rootScope.user.hotels[0].id;
                  }
                  if (!hotel_id) {
                    hotel_id = $rootScope.user.hotels[0].id;
                  }
                  Hotel.get(hotel_id).then(
                    function (data) {
                      if (!data.hasSetupRoomTypes) {
                        $location.path(ROOM_TYPES);
                      }
                      fillUserPerms($rootScope.user, hotel_id);

                      if (!window.restrictions.hasAccessByRoute($rootScope.user, $route.current)) {
                        $location.path('/');
                      }

                      $rootScope.hotel = data;
                      if (!$rootScope.hotel.showRoomRate) {
                        $rootScope.loadRoomRates();
                      }
                      window.features = $rootScope.hotel.features || {};

                      $rootScope.trackEvent('app-is-started', {
                        hotel: $rootScope.hotel.name
                      });
                      localStorage.setItem('user', JSON.stringify($rootScope.user));

                      if ($rootScope.hotel.currency) {
                        var item = currencies.filter(function (el) {
                          return el[0] == $rootScope.hotel.currency;
                        })[0] || ['', '', '??', 2];
                        $rootScope.currencySymbol = item[2];
                        $rootScope.currencyFractionSize = item[3];

                        if (typeof ($rootScope.currencyFractionSize) === 'undefined') {
                          $rootScope.currencyFractionSize = 2;
                        }
                      }

                      $rootScope.hotel.sync_dependencies();
                      localforage.setItem('hotel', data);
                      $('.bookLink').attr('href', window.location.origin + '/' + data.slug + '/book');
                      angular.element('body').removeClass('login-body');
                      angular.element('.navbar').removeClass('hidden');
                      NetworkChecker.run();
                      $rootScope.$broadcast('hotel:loaded');
                      $rootScope.loadedCallback();

                      SpecialOfferFactory
                        .query({}, {
                          hotelId: $rootScope.hotel.id
                        })
                        .then(function (response) {
                          $rootScope.specialOffers = response;
                        });

                      Seasons.set($rootScope.hotel.seasons);

                      localStorage.setItem('hotel_id', $rootScope.hotel.id);

                      initializeNotifications();
                      initializePusherChannel();
                      initializeCurrencyUpdate();

                      if (productionEnv) {
                        SentryService.setUser({
                          id: $rootScope.user.id,
                          email: $rootScope.user.email,
                          username: $rootScope.user.name,
                        });
                        SentryService.setContext('hotel', {
                          id: $rootScope.hotel.id,
                          name: $rootScope.hotel.name
                        });
                      }

                      if ($rootScope.hotel.paymentGateway === 'stripe') {
                        var scriptElement = document.createElement('script');
                        scriptElement.setAttribute("src", "https://js.stripe.com/v2/");

                        var elementContainer = angular.element('body');
                        elementContainer.append(scriptElement);
                      }

                      if ($rootScope.hotel.paymentGateway === 'stripe_sca') {
                        var scriptElement = document.createElement('script');
                        scriptElement.setAttribute("src", "https://js.stripe.com/v3/");

                        var elementContainer = angular.element('body');
                        elementContainer.append(scriptElement);
                      }

                      if ($rootScope.hotel.paymentGateway && $rootScope.hotel.clientToken === null && $rootScope.hotel.paymentGateway !== 'wubook' && $rootScope.hotel.paymentGateway !== 'none' && $rootScope.hotel.paymentGateway !== 'wirecard') {
                        $rootScope.hotel.paymentGateway = 'none';
                        $rootScope.notify($i18next.t('common_for_app.notify.you_are_work_without_payment_gateway_js_str'));
                      }

                      sendGoogleAnalyticsPageView()

                      if ($rootScope.hotel.billViaStripeBilling && !$rootScope.hotel.subscriptionValid) {
                        var twoHours = 7200000;
                        
                        notifySubscriptionInvalid();
                        if (subscriptionInterval) $interval.cancel(subscriptionInterval);
                        subscriptionInterval = $interval(function() {
                          hotelSubscriptionStatus();
                        }, twoHours);
                      }
                    },
                    function (error) {
                      if (error.data) {
                        $rootScope.alert(JSON.stringify(error.data.errors));
                      } else {
                        $rootScope.alert($i18next.t('general.alert_modals.something_went_wrong_try_again_later_js_str'));
                      }
                      console.log('Loading hotel error', error);
                    }
                  );
                } else {
                  if (stored_hotel !== null) {
                    $rootScope.hotel = stored_hotel;
                    $('.bookLink').attr('href', '/' + $rootScope.hotel.slug + '/book');
                    angular.element('body').removeClass('login-body');
                    angular.element('.navbar').removeClass('hidden');
                    NetworkChecker.run();
                    $rootScope.$broadcast('hotel:loaded');
                    $rootScope.loadedCallback();
                  }
                }
              });
            }
          }
        };

        $rootScope.loadRoomRates = function () {
          var loadMsg = $i18next.t('common_for_app.room_rates.loading');
          var params = { active: true };
          RoomRatesStorage.load(loadMsg, params).then(function (roomRates) {
            localforage.getItem('hotel').then(function (stored_hotel) {
              if (stored_hotel) {
                stored_hotel.roomRates = roomRates;
                localforage.setItem('hotel', stored_hotel);
              }
            });
          });
        };

        function hotelSubscriptionStatus () {
          $rootScope.hotel.subscription_status().then(function (hotel) {
            var statusValid = hotel.data.subscription_valid;

            if (!statusValid) notifySubscriptionInvalid();
            if (statusValid) $interval.cancel(subscriptionInterval);
          });
        }

        function notifySubscriptionInvalid () {
          $mdToast.show({
            controller: StripeSubscriptionCtrl,
            parent: angular.element(document.body),
            templateUrl: getTemplatePath('modals/notifySubscriptionInfo.html'),
            position: '70px right',
            hideDelay: 0,
          });
        };

        $rootScope.showToday = function () {
          $rootScope.$broadcast('showToday');
        };

        $rootScope.clearCache = function () {
          $rootScope.$broadcast('cache:clear');
          $rootScope.notify($i18next.t('general.other.cache_cleared'));
        };

        $rootScope.changeHotel = function (hotel) {
          if (!$rootScope.hotel || $rootScope.hotel.id != hotel.id) {
            var locale = localStorage.getItem('user_locale');
            var user = localStorage.getItem('user');
            localStorage.clear();
            if (user) {
              user = JSON.parse(user);
              fillUserPerms(user, hotel.id);
              localStorage.setItem('user', JSON.stringify(user));
            }
            localStorage.setItem('user_locale', locale);
            localStorage.setItem('hotel_id', hotel.id);

            $cookies.put('hotel_id', hotel.id, {
              path: '/'
            });

            $cookies.put('buuqit_user_locale', locale, {
              path: '/'
            })

            localforage.clear(function () {
              location.reload();
            });

            if ($rootScope.user.systemRole === "admin" || $rootScope.user.systemRole === "white_admin") {
              localStorage.setItem('admin_hotel', hotel.id);
            }
          }
        };


        $rootScope.alert = function (message, title) {
          title = title || 'Alert title';

          $mdDialog.show(
            $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(false)
            .title(title)
            .htmlContent(message)
            .ok('ok')
          );
        };

        $rootScope.error_notify = function(message) {
          var toast = $mdToast.simple()
            .textContent(message)
            .theme('error-toast')
            .action('OK')
            .hideDelay(0)
            .position('70px right');
          $mdToast.show(toast);
        };


        $rootScope.notify = function (message, fixed) {
          var toast;

          if (fixed) {
            toast = $mdToast.simple()
              .content(message)
              .action('OK')
              .hideDelay(0)
              .position('70px right');
          } else {
            toast = $mdToast.simple()
              .content(message)
              .hideDelay(5000)
              .position('70px right');
          }
          $mdToast.show(toast);
        };

        $rootScope.notifyWithLoader = function (message) {
          var toast;

          toast = $mdToast.simple({
              template: [
                '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">',
                '<i class="fa fa-spin fa-spinner" style="margin-right: 5px;"></i><span flex>{{ toast.content }}</span>',
                '<md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ng-class="{\'md-highlight\': toast.highlightAction}">',
                '{{ toast.action }}',
                '</md-button>',
                '</md-toast>'
              ].join('')
            })
            .content(message)
            .hideDelay(0)
            .position('70px right');
          $mdToast.show(toast);
          return toast;

        };

        $rootScope.getActiveClass = function (href, parent) {
          if (parent === undefined) {
            return $location.path() === href;
          } else {
            return $location.path().indexOf(href) === 0;
          }
        };


        $rootScope.hasAccess = function (rule) {
          if ($rootScope.user) {
            return window.restrictions.hasAccess($rootScope.user, rule);
          } else {
            return false;
          }
        };

        $rootScope.isBookingFactoryProduction = window.location.host === 'app.thebookingfactory.com';

        $rootScope.search_by = 'customers';

        $rootScope.changeSearchByFilter = function (filter, $event) {
          if (!$rootScope.searchQuery) {
            $event.stopPropagation();
          }
          $rootScope.search_by = filter;
          if ($rootScope.searchQuery) {
            window.location.hash = "#/customers";
          }
        }

        $rootScope.searchCallback = function (event) {
          $rootScope.searchQuery = event.currentTarget.value;
          if (event.keyCode === 13) {
            event.currentTarget.value = '';
            event.currentTarget.blur();
            var dropdown = angular.element(event.currentTarget).closest('li.dropdown');
            dropdown.removeClass('open');
            window.location.hash = "#/customers";
          }
        };


        $rootScope.trackEvent = function (event_name, metadata) {
          if (!$rootScope.isBookingFactoryProduction && productionEnv) {
            window.Intercom('trackEvent', event_name, metadata);
          }
        };

        $rootScope.activeBookingId = null;
        var bookingLoadingSpinner = document.getElementsByClassName('booking__loading')[0];
        $rootScope.openBookingManagementModal = function (booking_id, tab_index, params) {
          bookingLoadingSpinner.classList.add('visible');
          BookingStorage.load_by_id(booking_id, false, function(booking) {
            bookingLoadingSpinner.classList.remove('visible');
            $rootScope.trackEvent('open booking', {
              booking_id: booking_id,
              active_tab: tab_index
            });
            var locals = {
              booking: BookingStorage.get(booking_id),
              activeTab: tab_index,
              params: params
            };
            $rootScope.activeBookingId = booking_id;
            $bookingDrawer.openDrawer(getTemplatePath('drawerProvider.html'), $compile, $document, $rootScope, $templateRequest, locals);
          });
        };

        var newBookingModalTimeout;
        var clearNewBookingModalTimeout = function () {
          if (newBookingModalTimeout) {
            $timeout.cancel(newBookingModalTimeout);
            newBookingModalTimeout = null;
          }
        };


        $rootScope.openNewBookingModal = function (booking, groupBookingSteps) {
          clearNewBookingModalTimeout();
          if (!$rootScope.hasAccess('bookingCreate')) {
            return;
          }

          if ($rootScope.hotel && !$rootScope.hotel.showRoomRate && !$rootScope.hotel.roomRates && RoomRatesStorage.loading) {
            if (bookingLoadingSpinner) {
              bookingLoadingSpinner.classList.add('visible');
            }
            newBookingModalTimeout = $timeout(function () {
              $rootScope.openNewBookingModal(booking, groupBookingSteps);
            }, 1000);
            return;
          } else {
            if (bookingLoadingSpinner && bookingLoadingSpinner.classList.contains('visible')) {
              bookingLoadingSpinner.classList.remove('visible');
            }
          }

          if (!booking) {
            var date_in = new Date();
            var date_out = moment(new Date()).add(1, 'day').toDate();

            booking = {
              room_id: $rootScope.hotel.rooms[0].id,
              date_in: new Date(date_in.getTime() + date_in.getTimezoneOffset() * 60000),
              date_out: new Date(date_out.getTime() + date_out.getTimezoneOffset() * 60000)
            }
          }

          var rooms, roomRepresentations, roomRates;

          rooms = $rootScope.hotel.rooms.filter(function (room) {
            return room.id == booking.room_id;
          });

          if (rooms.length > 0) {
            roomRepresentations = $rootScope.hotel.roomRepresentations.filter(function (rr) {
              return rr.roomTypeId == rooms[0].roomTypeId;
            }).map(function (rr) {
              return rr.id;
            });
          }

          if (roomRepresentations.length > 0) {
            roomRates = $rootScope.hotel.roomRates.filter(function (roomRate) {
              return roomRepresentations.indexOf(roomRate.roomRepresentationId) !== -1 && roomRate.isRemoved === false;
            });
          }

          if (!roomRates || roomRates.length === 0) {
            return $rootScope.alert($i18next.t('general.errors.room_not_have_any_rate'));
          }

          var bookingModalTemplate;
          var BookingModalController;
          var buildOptionsPromise;

          if ($rootScope.hotel.groupBookingFeatureEnabled) {
            bookingModalTemplate = 'modals/groupedCreateBooking.html';
            BookingModalController = CreateGroupBookingModalCtrl;

            // Restriction service is a singleton service for storing restrictions by room rates and dates. Restrictions for
            // dates are lazy-loaded based on checkin/checkout dates controls in rooms forms and common checkin/checkout dates on
            // group booking form controls. Loaded restrictions are injected in each room service and stores common information by restrictions.
            // When some room loads additional restrictions for dates this information becomes available to other room by using same instance
            // of restrictionsService.
            var restrictionsService = RestrictionsService.build();
            var roomBuilderService = RoomBuilderService.build(restrictionsService);

            buildOptionsPromise = roomBuilderService.buildInitialRoom(booking.room_id, booking.date_in, booking.date_out).then(function (result) {
              return {
                initialRoom: result.initialRoom,
                roomTemplate: result.roomTemplate,
                roomBuilderService: roomBuilderService,
                restrictionsService: restrictionsService,
              }
            })
          } else {
            bookingModalTemplate = 'modals/createBooking.html';
            BookingModalController = CreateBookingModalCtrl;

            buildOptionsPromise = Promise.resolve(booking);
          }

          buildOptionsPromise.then(function (options) {
            $rootScope.trackEvent('Create booking modal openned');
            if (groupBookingSteps) {
              options.step = 'pick_dates';
            }
            $mdDialog.show({
                controller: BookingModalController,
                templateUrl: getTemplatePath(bookingModalTemplate),
                parent: angular.element(document.body),
                locals: {
                  options: options
                },
                clickOutsideToClose: false,
                escapeToClose: false
              })
              .then(function (booking) {
                if (booking) {
                  CalendarStorage.pushBooking(booking);
                }
              }, function () {});
          });
          clearNewBookingModalTimeout();
        };



        $rootScope.openClosestElementDropdown = function (event) {
          if (!$(event.target).closest('.dropdown').hasClass('open')) {
            setTimeout(function () {
              $(event.target).closest('.dropdown').find('[name="filter"]').focus();
            }, 10);
          }
        };


        $rootScope.current_date = new Date();
        $rootScope.loading = true;
        $rootScope.networkStatus = true;
        $rootScope.networkStatusDescription = "Online mode";
        $rootScope.removedExtras = [];
        $rootScope.removedBlockers = [];
        $rootScope.removedDiscounts = [];
        $rootScope.removedPayments = [];
        $rootScope.removedDateNotes = [];
        $rootScope.removedWaitlists = [];
        $rootScope.html_el = angular.element('html');
        $rootScope.currentDate = new Date(new Date().setHours(0, 0, 0, 0));

        if (new Date().getHours() < 4) {
          $rootScope.currentDate = new Date(moment(new Date()).subtract(1, 'day').toDate().setHours(0, 0, 0, 0));
        }

        $rootScope.$on('$routeChangeSuccess', function (event, toState) {
          sendGoogleAnalyticsPageView();
        });

        $rootScope.$on('network:connect', function () {
          angular.forEach($rootScope.removedExtras, function (el) {
            el.remove();
          });
          angular.forEach($rootScope.removedBlockers, function (el) {
            el.remove();
          });
          angular.forEach($rootScope.removedDiscounts, function (el) {
            el.remove();
          });
          angular.forEach($rootScope.removedPayments, function (el) {
            el.remove();
          });

          _.each($rootScope.hotel.rooms, function (room) {
            if (room.__sync === false) {
              room.save();
            }
          });

          $rootScope.removedExtras = [];
          $rootScope.removedBlockers = [];
          $rootScope.removedDiscounts = [];
          $rootScope.removedPayments = [];
        });

        $rootScope.schedulerScrolling = false;

        $rootScope.updateOfflineChannels = function (channel) {
          if ($rootScope.hotel) {
            if (!$rootScope.hotel.offlineChannels) {
              $rootScope.hotel.offlineChannels = [];
            }
            if ($rootScope.hotel.offlineChannels.indexOf(channel) == -1) {
              $rootScope.hotel.offlineChannels.push(channel);
            }
          }
        };

        $rootScope.loadedCallback = function () {
          $rootScope.html_el.removeClass('loading');
          angular.element('.loader').addClass('ng-hide');
        }

        $rootScope.changeLanguage = function (locale) {
          var confirm = $mdDialog.confirm()
            .title($i18next.t('general.confirm.confirm'))
            .textContent($i18next.t('general.confirm.language_change_confirmation'))
            .ok($i18next.t('general.confirm.confirm'))
            .cancel($i18next.t('general.confirm.cancel'));

          $mdDialog.show(confirm).then(function () {
            localStorage.setItem('user_locale', locale);
            window.location.reload();
          }, function () {});
        };

        // Only call get_info if domain_settings not already loaded (prevents multiple calls)
        if (!$rootScope.domain_settings) {
          localforage.getItem('domain_settings').then(function (cachedSettings) {
            if (cachedSettings) {
              // Use $timeout to match async flow of fresh get_info call
              $timeout(function() {
                $rootScope.domain_settings = cachedSettings;
                $rootScope.domain_settings.isSinazo = $rootScope.domain_settings.domain_name == 'sinazo.jurni.app';
                $rootScope.domain_settings.wirecardName = $rootScope.domain_settings.isSinazo ? 'VISTA.pay' : 'rainmaker.pay (Wirecard)';
                document.title = $rootScope.domain_settings.name;
                continueInitialization();
              });
            } else {
              $http.get($rootScope.server_path + '/api/public/v1/get_info').then(function (response) {
                $rootScope.domain_settings = response.data;
                $rootScope.domain_settings.isSinazo = $rootScope.domain_settings.domain_name == 'sinazo.jurni.app';
                $rootScope.domain_settings.wirecardName = $rootScope.domain_settings.isSinazo ? 'VISTA.pay' : 'rainmaker.pay (Wirecard)';
                document.title = response.data.name;

                // Cache domain settings in localforage
                localforage.setItem('domain_settings', $rootScope.domain_settings);

                continueInitialization();
              });
            }
          });
        } else {
          continueInitialization();
        }

        function continueInitialization() {
          if (token) {
            $http.defaults.headers.common['AUTHORIZATION'] = token;
            NetworkChecker.checkNetwork(function () {
              $rootScope.getUser();
            });
          } else {
            if ($location.$$path != LOGIN_PATH && $location.$$path != SIGNUP_PATH && $location.$$path != FORGOT_PATH && $location.$$path != SET_PASSWORD_PATH && $location.$$path != CONFIRMED_PATH) {
              $location.path(LOGIN_PATH);
            }
          }
        }

        function fillUserPerms(user, hotel_id) {
          var hotel = user.hotels.filter(function (el) {
            return el.id == hotel_id
          })[0];
          user.isOwner = hotel.role == 'owner';
          user.role = ROLES[hotel.role];

          if (user.systemRole === 'admin') {
            user.role = 'admin';
          }

          user.aclRole = user.systemRole === 'admin' ? 'admin' : hotel.role;
        }

        $document.bind('keydown', function (evt) {
          if (evt.which === 27 && angular.element('.dialog-filter:visible').size() === 0) {
            $rootScope.$broadcast('escape:pressed');
          }
        });
      }
    ]);
}());

(function () {
  "use strict";
  angular.module("buuqit").config([
    "$routeSegmentProvider",
    "$routeProvider",
    "$httpProvider",
    "$mdThemingProvider",
    "$mdDateLocaleProvider",
    function (
      $routeSegmentProvider,
      $routeProvider,
      $httpProvider,
      $mdThemingProvider,
      $mdDateLocaleProvider
    ) {
      var login, signup, resolver, denied, forgot, set_password, confirmed, set_room_types;
      var PRODUCTION_DOMAIN = [
        "app.thebookingfactory.com",
        "dev.thebookingfactory.com",
        "app.frontdeskexpress.com",
        "app.acemsthailand.com",
        "app.boostly.co.uk",
        "app.all-in-one-digital-hotel.com",
        "frontdesk.rainmaker.travel",
        "app.ngeluwunganhotelsoftware.com",
        "sinazo.jurni.app"
      ];
      var HOTEL_IDS_HAS_ACCESS_TO_PLUGIN_FEATURES = [
        '1'
      ]

      document.addEventListener('language_changed', function () {
        moment.months().forEach(function (el, index) {
          $mdDateLocaleProvider.months[index] = el;
        });
        moment.monthsShort().forEach(function (el, index) {
          $mdDateLocaleProvider.shortMonths[index] = el;
        });
        moment.weekdays().forEach(function (el, index) {
          $mdDateLocaleProvider.days[index] = el;
        });
        moment.weekdaysShort().forEach(function (el, index) {
          $mdDateLocaleProvider.shortDays[index] = el;
        });
      });
      $mdDateLocaleProvider.months = moment.months();
      $mdDateLocaleProvider.shortMonths = moment.monthsShort();
      $mdDateLocaleProvider.days = moment.weekdays();
      $mdDateLocaleProvider.shortDays = moment.weekdaysShort();
      $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format("DD MMM YYYY");
      };

      $mdThemingProvider
        .theme("default")
        .primaryPalette("light-blue")
        .accentPalette("blue");

      $mdThemingProvider.theme("docs-dark", "default").dark();

      login = {
        templateUrl: getTemplatePath("login.html"),
        controller: "LoginCtrl"
      };

      signup = {
        templateUrl: getTemplatePath("signup.html"),
        controller: "SignupCtrl"
      };

      forgot = {
        templateUrl: getTemplatePath("forgot.html"),
        controller: "ForgotCtrl"
      };

      set_password = {
        templateUrl: getTemplatePath("set_password.html"),
        controller: "SetPasswordCtrl"
      };

      confirmed = {
        templateUrl: getTemplatePath("confirmed.html"),
        controller: "ConfirmedCtrl"
      };

      denied = {
        templateUrl: getTemplatePath("denied.html"),
        controller: "DeniedCtrl"
      };

      set_room_types = {
        templateUrl: getTemplatePath("set_room_types.html"),
        controller: "RoomTypesCtrl"
      }

      resolver = function (rule) {
        return {
          isUserNotLoggedIn: [
            "$q",
            "$route",
            function ($q, $route) {
              var user;
              if (PRODUCTION_DOMAIN.indexOf(window.location.host) != -1) {
                window.Intercom("update");
              }
              var defer = $q.defer();
              if (localStorage.getItem("user")) {
                user = JSON.parse(localStorage.getItem("user"));
              }

              if (window.restrictions.hasAccessByRoute(user, $route.current)) {
                defer.resolve();
              } else {
                defer.reject();
              }

              return defer.promise;
            }
          ],
          isHotelSupportPlugins: [
            "$q",
            function ($q) {
              var currentHotelId = localStorage.getItem('hotel_id'),
                defer = $q.defer(),
                isPluginSegment;

              isPluginSegment = window.location.hash.includes('plugins')

              if (isPluginSegment) {
                if (HOTEL_IDS_HAS_ACCESS_TO_PLUGIN_FEATURES.includes(currentHotelId)) {
                  defer.resolve();
                } else {
                  defer.reject();
                }
              } else {
                defer.resolve()
              }

              return defer.promise;
            }
          ]
        };
      };

      $routeSegmentProvider
        .when("/login", "login")
        .when("/signup", "signup")
        .when("/forgot", "forgot")
        .when("/set_password", "set_password")
        .when("/confirmed", "confirmed")
        .when("/set_room_types", "set_room_types")
        .when("/logout", "logout")
        .when("/bookings", "bookings")
        .when("/bookings-and-folios", "bookings_and_folios")
        .when("/calendar", "calendar")
        .when("/inventory/closeout", "closeout")
        .when("/inventory/:block?", "new_inventory")
        .when("/new_inventory/:block?", "inventory")
        .when("/old_inventory/:block?", "old_inventory")
        .when("/special_offers", "special_offers")
        .when("/customers", "customers")
        .when("/customers/:customer_id", "customers")
        .when("/settings/:block?/:part?", "settings")
        .when("/website/:block?/:id?", "website")
        .when("/profile", "profile")
        .when("/session/clear", "clearSession")
        .when("/reports/performance-charge-report", "dashboard")
        .when("/reports/:report", "reports")
        .when("/reports/:report/:param", "reports")
        .when("/plugins/:id", "plugin")
        .when("/hotels", "hotels")
        .when("/import", "import")
        .when("/admin", "admin")
        .when("/admin/:part?", "admin")
        .when("/", "dashboard")
        .segment("login", login)
        .segment("signup", signup)
        .segment("forgot", forgot)
        .segment("set_password", set_password)
        .segment("confirmed", confirmed)
        .segment("set_room_types", set_room_types)
        .segment("logout", {
          controller: [
            "$rootScope",
            function ($rootScope) {
              $rootScope.logout();
            }
          ]
        })
        .segment("bookings", {
          templateUrl: getTemplatePath("scheduler.html"),
          controller: "SchedulerCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("calendar", {
          templateUrl: getTemplatePath("calendar.html"),
          controller: "CalendarCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("closeout", {
          templateUrl: getTemplatePath("old_inventory.html"),
          controller: "OldInventoryCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("inventory", {
          templateUrl: getTemplatePath("inventory.html"),
          controller: "InventoryCtrl",
          dependencies: ["block"],
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("new_inventory", {
          templateUrl: getTemplatePath("new_inventory.html"),
          controller: "NewInventoryCtrl",
          dependencies: ["block"],
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("old_inventory", {
          templateUrl: getTemplatePath("old_inventory.html"),
          controller: "OldInventoryCtrl",
          dependencies: ["block"],
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("special_offers", {
          templateUrl: getTemplatePath("special_offers.html"),
          controller: "SpecialOffersCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("customers", {
          templateUrl: getTemplatePath("customers.html"),
          controller: "CustomersCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("bookings_and_folios", {
          templateUrl: getTemplatePath("bookings_and_folios.html"),
          controller: "BookingsAndFoliosCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("settings", {
          templateUrl: getTemplatePath("settings.html"),
          controller: "SettingsController",
          dependencies: ["block", "part"],
          resolve: resolver("settings"),
          resolveFailed: denied
        })
        .segment("chart", {
          templateUrl: getTemplatePath("chart.html"),
          controller: "ChartCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("website", {
          templateUrl: getTemplatePath("website.html"),
          controller: "WebsiteCtrl",
          dependencies: ["block", "id"],
          resolve: resolver("websiteManagement"),
          resolveFailed: denied
        })
        .segment("profile", {
          templateUrl: getTemplatePath("profile.html"),
          controller: "ProfileCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("dashboard", {
          templateUrl: getTemplatePath("dashboard.html"),
          controller: "DashboardCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("reports", {
          templateUrl: getTemplatePath("reports.html"),
          controller: "ReportsCtrl",
          dependencies: ["report"],
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("hotels", {
          templateUrl: getTemplatePath("hotels.html"),
          controller: "HotelsCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("import", {
          templateUrl: getTemplatePath("import.html"),
          controller: "ImportCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("admin", {
          templateUrl: getTemplatePath("admin_new.html"),
          controller: "AdminNewCtrl",
          resolve: resolver("admin"),
          resolveFailed: denied
        })
        .segment("plugin", {
          templateUrl: getTemplatePath("plugin.html"),
          controller: "PluginCtrl",
          resolve: resolver(),
          resolveFailed: denied
        })
        .segment("denied", denied);

      $routeProvider.otherwise({
        redirectTo: "/"
      });

      $httpProvider.defaults.headers.common["X-CSRF-Token"] = $(
        "meta[name=csrf-token]"
      ).attr("content");
      $httpProvider.defaults.headers.common['X-App-Version'] = window.VERSION;
    }
  ]);

  // Fix for datepicker calendar opening to wrong month on scrolled pages
  // Backports the fix from Angular Material 1.1.5 (issues #10144, #10209)
  // Root cause: When page is scrolled far down and disableScrollAround() converts body to
  // position:fixed, the virtual repeat's initial scroll calculation gets corrupted.
  // Fix: Force multiple scroll corrections after calendar opens and DOM settles
  angular.module('buuqit').run(['$timeout', function($timeout) {
    $timeout(function() {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList &&
                node.classList.contains('md-datepicker-calendar-pane')) {

              function scrollToCorrectMonth() {
                var calendarEl = node.querySelector('md-calendar');
                if (calendarEl) {
                  var calendarCtrl = angular.element(calendarEl).controller('mdCalendar');
                  if (calendarCtrl && calendarCtrl.scrollToMonth) {
                    var targetDate = calendarCtrl.selectedDate || new Date();
                    calendarCtrl.scrollToMonth(targetDate);
                  }
                }
              }

              // Multiple scroll attempts at different timings to handle race conditions
              $timeout(scrollToCorrectMonth, 0);    // After current digest
              $timeout(scrollToCorrectMonth, 50);   // After initial render
              $timeout(scrollToCorrectMonth, 150);  // After animations start
              $timeout(scrollToCorrectMonth, 300);  // Final safety scroll
            }
          });
        });
      });

      observer.observe(document.body, { childList: true });
    }, 0);
  }]);

  var nextUniqueId = 0;
  angular
    .module('material.core')
    .factory('$mdUtil', UtilFactory);

  function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window) {
    // Setup some core variables for the processTemplate method
    var startSymbol = $interpolate.startSymbol(),
      endSymbol = $interpolate.endSymbol(),
      usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));

    /**
     * Checks if the target element has the requested style by key
     * @param {DOMElement|JQLite} target Target element
     * @param {string} key Style key
     * @param {string=} expectedVal Optional expected value
     * @returns {boolean} Whether the target element has the style or not
     */
    var hasComputedStyle = function (target, key, expectedVal) {
      var hasValue = false;

      if (target && target.length) {
        var computedStyles = $window.getComputedStyle(target[0]);
        hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
      }

      return hasValue;
    };

    var $mdUtil = {
      dom: {},
      now: window.performance ?
        angular.bind(window.performance, window.performance.now) : Date.now || function () {
          return new Date().getTime();
        },

      clientRect: function (element, offsetParent, isOffsetRect) {
        var node = getNode(element);
        offsetParent = getNode(offsetParent || node.offsetParent || document.body);
        var nodeRect = node.getBoundingClientRect();

        // The user can ask for an offsetRect: a rect relative to the offsetParent,
        // or a clientRect: a rect relative to the page
        var offsetRect = isOffsetRect ?
          offsetParent.getBoundingClientRect() : {
            left: 0,
            top: 0,
            width: 0,
            height: 0
          };
        return {
          left: nodeRect.left - offsetRect.left,
          top: nodeRect.top - offsetRect.top,
          width: nodeRect.width,
          height: nodeRect.height
        };
      },
      offsetRect: function (element, offsetParent) {
        return $mdUtil.clientRect(element, offsetParent, true);
      },

      // Annoying method to copy nodes to an array, thanks to IE
      nodesToArray: function (nodes) {
        nodes = nodes || [];

        var results = [];
        for (var i = 0; i < nodes.length; ++i) {
          results.push(nodes.item(i));
        }
        return results;
      },

      /**
       * Calculate the positive scroll offset
       * TODO: Check with pinch-zoom in IE/Chrome;
       *       https://code.google.com/p/chromium/issues/detail?id=496285
       */
      scrollTop: function (element) {
        element = angular.element(element || $document[0].body);

        var body = (element[0] == $document[0].body) ? $document[0].body : undefined;
        var scrollTop = body ? body.scrollTop + body.parentElement.scrollTop : 0;

        // Calculate the positive scroll offset
        return scrollTop || Math.abs(element[0].getBoundingClientRect().top);
      },

      /**
       * `findFocusTarget()` provides an optional way to identify the focused element when a dialog, bottomsheet, sideNav
       * or other element opens. This is optional attribute finds a nested element with the mdAutoFocus attribute and optional
       * expression. An expression may be specified as the directive value; to enable conditional activation of the autoFocus.
       *
       * NOTE: It is up to the component logic to use the '$mdUtil.findFocusTarget()'
       *
       * @usage
       * <hljs lang="html">
       * <md-dialog>
       *   <form>
       *     <md-input-container>
       *       <label for="testInput">Label</label>
       *       <input id="testInput" type="text" md-autofocus>
       *     </md-input-container>
       *   </form>
       * </md-dialog>
       * </hljs>
       *
       *<hljs lang="html">
       * <md-bottom-sheet class="md-list md-has-header">
       *  <md-subheader>Comment Actions</md-subheader>
       *  <md-list>
       *    <md-list-item ng-repeat="item in items">
       *
       *      <md-button md-autofocus="$index == 2">
       *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
       *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
       *      </md-button>
       *
       *    </md-list-item>
       *  </md-list>
       * </md-bottom-sheet>
       *</hljs>
       **/
      findFocusTarget: function (containerEl, attributeVal) {
        var AUTO_FOCUS = '[md-autofocus]';
        var elToFocus;

        elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);

        if (!elToFocus && attributeVal != AUTO_FOCUS) {
          // Scan for deprecated attribute
          elToFocus = scanForFocusable(containerEl, '[md-auto-focus]');

          if (!elToFocus) {
            // Scan for fallback to 'universal' API
            elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
          }
        }

        return elToFocus;

        /**
         * Can target and nested children for specified Selector (attribute)
         * whose value may be an expression that evaluates to True/False.
         */
        function scanForFocusable(target, selector) {
          var elFound, items = target[0].querySelectorAll(selector);

          // Find the last child element with the focus attribute
          if (items && items.length) {
            var EXP_ATTR = /\s*\[?([\-a-z]*)\]?\s*/i;
            var matches = EXP_ATTR.exec(selector);
            var attribute = matches ? matches[1] : null;

            items.length && angular.forEach(items, function (it) {
              it = angular.element(it);

              // If the expression evaluates to FALSE, then it is not focusable target
              var focusExpression = it[0].getAttribute(attribute);
              var isFocusable = !focusExpression || !$mdUtil.validateScope(it) ? true :
                (it.scope().$eval(focusExpression) !== false);

              if (isFocusable) elFound = it;
            });
          }
          return elFound;
        }
      },

      // Disables scroll around the passed element.
      disableScrollAround: function (element, parent) {
        $mdUtil.disableScrollAround._count = $mdUtil.disableScrollAround._count || 0;
        ++$mdUtil.disableScrollAround._count;
        if ($mdUtil.disableScrollAround._enableScrolling) return $mdUtil.disableScrollAround._enableScrolling;
        element = angular.element(element);
        var body = $document[0].body,
          restoreBody = disableBodyScroll(),
          restoreElement = disableElementScroll(parent);

        return $mdUtil.disableScrollAround._enableScrolling = function () {
          if (!--$mdUtil.disableScrollAround._count) {
            restoreBody();
            restoreElement();
            delete $mdUtil.disableScrollAround._enableScrolling;
          }
        };

        // Creates a virtual scrolling mask to absorb touchmove, keyboard, scrollbar clicking, and wheel events
        function disableElementScroll(element) {
          element = angular.element(element || body)[0];
          var zIndex = 50;
          var scrollMask = angular.element(
            '<div class="md-scroll-mask" style="z-index: ' + zIndex + '">' +
            '  <div class="md-scroll-mask-bar"></div>' +
            '</div>');
          element.appendChild(scrollMask[0]);

          scrollMask.on('wheel', preventDefault);
          scrollMask.on('touchmove', preventDefault);
          $document.on('keydown', disableKeyNav);

          return function restoreScroll() {
            scrollMask.off('wheel');
            scrollMask.off('touchmove');
            scrollMask[0].parentNode.removeChild(scrollMask[0]);
            $document.off('keydown', disableKeyNav);
            delete $mdUtil.disableScrollAround._enableScrolling;
          };

          // Prevent keypresses from elements inside the body
          // used to stop the keypresses that could cause the page to scroll
          // (arrow keys, spacebar, tab, etc).
          function disableKeyNav(e) {
            //-- temporarily removed this logic, will possibly re-add at a later date
            //if (!element[0].contains(e.target)) {
            //  e.preventDefault();
            //  e.stopImmediatePropagation();
            //}
          }

          function preventDefault(e) {
            e.preventDefault();
          }
        }

        // Converts the body to a position fixed block and translate it to the proper scroll
        // position
        function disableBodyScroll() {
          var htmlNode = body.parentNode;
          var restoreHtmlStyle = htmlNode.getAttribute('style') || '';
          var restoreBodyStyle = body.getAttribute('style') || '';
          var scrollOffset = $mdUtil.scrollTop(body);
          var clientWidth = body.clientWidth;

          if (body.scrollHeight > body.clientHeight + 1) {
            applyStyles(body, {
              position: 'fixed',
              width: '100%',
              top: -scrollOffset + 'px'
            });

            applyStyles(htmlNode, {
              overflowY: 'scroll'
            });
          }

          if (body.clientWidth < clientWidth) applyStyles(body, {
            overflow: 'hidden'
          });

          return function restoreScroll() {
            body.setAttribute('style', restoreBodyStyle);
            htmlNode.setAttribute('style', restoreHtmlStyle);
            body.scrollTop = scrollOffset;
            htmlNode.scrollTop = scrollOffset;
          };
        }

        function applyStyles(el, styles) {
          for (var key in styles) {
            el.style[key] = styles[key];
          }
        }
      },
      enableScrolling: function () {
        var method = this.disableScrollAround._enableScrolling;
        method && method();
      },
      floatingScrollbars: function () {
        if (this.floatingScrollbars.cached === undefined) {
          var tempNode = angular.element('<div style="width: 100%; z-index: -1; position: absolute; height: 35px; overflow-y: scroll"><div style="height: 60px;"></div></div>');
          $document[0].body.appendChild(tempNode[0]);
          this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
          tempNode.remove();
        }
        return this.floatingScrollbars.cached;
      },

      // Mobile safari only allows you to set focus in click event listeners...
      forceFocus: function (element) {
        var node = element[0] || element;

        document.addEventListener('click', function focusOnClick(ev) {
          if (ev.target === node && ev.$focus) {
            node.focus();
            ev.stopImmediatePropagation();
            ev.preventDefault();
            node.removeEventListener('click', focusOnClick);
          }
        }, true);

        var newEvent = document.createEvent('MouseEvents');
        newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
          false, false, false, false, 0, null);
        newEvent.$material = true;
        newEvent.$focus = true;
        node.dispatchEvent(newEvent);
      },

      /**
       * facade to build md-backdrop element with desired styles
       * NOTE: Use $compile to trigger backdrop postLink function
       */
      createBackdrop: function (scope, addClass) {
        return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
      },

      /**
       * supplant() method from Crockford's `Remedial Javascript`
       * Equivalent to use of $interpolate; without dependency on
       * interpolation symbols and scope. Note: the '{<token>}' can
       * be property names, property chains, or array indices.
       */
      supplant: function (template, values, pattern) {
        pattern = pattern || /\{([^\{\}]*)\}/g;
        return template.replace(pattern, function (a, b) {
          var p = b.split('.'),
            r = values;
          try {
            for (var s in p) {
              if (p.hasOwnProperty(s)) {
                r = r[p[s]];
              }
            }
          } catch (e) {
            r = a;
          }
          return (typeof r === 'string' || typeof r === 'number') ? r : a;
        });
      },

      fakeNgModel: function () {
        return {
          $fake: true,
          $setTouched: angular.noop,
          $setViewValue: function (value) {
            this.$viewValue = value;
            this.$render(value);
            this.$viewChangeListeners.forEach(function (cb) {
              cb();
            });
          },
          $isEmpty: function (value) {
            return ('' + value).length === 0;
          },
          $parsers: [],
          $formatters: [],
          $viewChangeListeners: [],
          $render: angular.noop
        };
      },

      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds.
      // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
      // @param invokeApply should the $timeout trigger $digest() dirty checking
      debounce: function (func, wait, scope, invokeApply) {
        var timer;

        return function debounced() {
          var context = scope,
            args = Array.prototype.slice.call(arguments);

          $timeout.cancel(timer);
          timer = $timeout(function () {

            timer = undefined;
            func.apply(context, args);

          }, wait || 10, invokeApply);
        };
      },

      // Returns a function that can only be triggered every `delay` milliseconds.
      // In other words, the function will not be called unless it has been more
      // than `delay` milliseconds since the last call.
      throttle: function throttle(func, delay) {
        var recent;
        return function throttled() {
          var context = this;
          var args = arguments;
          var now = $mdUtil.now();

          if (!recent || (now - recent > delay)) {
            func.apply(context, args);
            recent = now;
          }
        };
      },

      /**
       * Measures the number of milliseconds taken to run the provided callback
       * function. Uses a high-precision timer if available.
       */
      time: function time(cb) {
        var start = $mdUtil.now();
        cb();
        return $mdUtil.now() - start;
      },

      /**
       * Create an implicit getter that caches its `getter()`
       * lookup value
       */
      valueOnUse: function (scope, key, getter) {
        var value = null,
          args = Array.prototype.slice.call(arguments);
        var params = (args.length > 3) ? args.slice(3) : [];

        Object.defineProperty(scope, key, {
          get: function () {
            if (value === null) value = getter.apply(scope, params);
            return value;
          }
        });
      },

      /**
       * Get a unique ID.
       *
       * @returns {string} an unique numeric string
       */
      nextUid: function () {
        return '' + nextUniqueId++;
      },

      /**
       * By default AngularJS attaches information about binding and scopes to DOM nodes,
       * and adds CSS classes to data-bound elements. But this information is NOT available
       * when `$compileProvider.debugInfoEnabled(false);`
       *
       * @see https://docs.angularjs.org/guide/production
       */
      validateScope: function (element) {
        var hasScope = element && angular.isDefined(element.scope());
        if (!hasScope) {
          $log.warn("element.scope() is not available when 'debug mode' == false. @see https://docs.angularjs.org/guide/production!");
        }

        return hasScope;
      },

      // Stop watchers and events from firing on a scope without destroying it,
      // by disconnecting it from its parent and its siblings' linked lists.
      disconnectScope: function disconnectScope(scope) {
        if (!scope) return;

        // we can't destroy the root scope or a scope that has been already destroyed
        if (scope.$root === scope) return;
        if (scope.$$destroyed) return;

        var parent = scope.$parent;
        scope.$$disconnected = true;

        // See Scope.$destroy
        if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
        if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
        if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
        if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;

        scope.$$nextSibling = scope.$$prevSibling = null;

      },

      // Undo the effects of disconnectScope above.
      reconnectScope: function reconnectScope(scope) {
        if (!scope) return;

        // we can't disconnect the root node or scope already disconnected
        if (scope.$root === scope) return;
        if (!scope.$$disconnected) return;

        var child = scope;

        var parent = child.$parent;
        child.$$disconnected = false;
        // See Scope.$new for this logic...
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }
      },

      /*
       * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
       *
       * @param el Element to start walking the DOM from
       * @param tagName Tag name to find closest to el, such as 'form'
       */
      getClosest: function getClosest(el, tagName, onlyParent) {
        if (el instanceof angular.element) el = el[0];
        tagName = tagName.toUpperCase();
        if (onlyParent) el = el.parentNode;
        if (!el) return null;
        do {
          if (el.nodeName === tagName) {
            return el;
          }
        } while (el = el.parentNode);
        return null;
      },

      /**
       * Build polyfill for the Node.contains feature (if needed)
       */
      elementContains: function (node, child) {
        var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
        var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function (arg) {
          // compares the positions of two nodes and returns a bitmask
          return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
        });

        return findFn(child);
      },

      /**
       * Functional equivalent for $element.filter(‘md-bottom-sheet’)
       * useful with interimElements where the element and its container are important...
       *
       * @param {[]} elements to scan
       * @param {string} name of node to find (e.g. 'md-dialog')
       * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
       * @param {boolean=} optional flag to enable log warnings; defaults to false
       */
      extractElementByName: function (element, nodeName, scanDeep, warnNotFound) {
        var found = scanTree(element);
        if (!found && !!warnNotFound) {
          $log.warn($mdUtil.supplant("Unable to find node '{0}' in element '{1}'.", [nodeName, element[0].outerHTML]));
        }

        return angular.element(found || element);

        /**
         * Breadth-First tree scan for element with matching `nodeName`
         */
        function scanTree(element) {
          return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
        }

        /**
         * Case-insensitive scan of current elements only (do not descend).
         */
        function scanLevel(element) {
          if (element) {
            for (var i = 0, len = element.length; i < len; i++) {
              if (element[i].nodeName.toLowerCase() === nodeName) {
                return element[i];
              }
            }
          }
          return null;
        }

        /**
         * Scan children of specified node
         */
        function scanChildren(element) {
          var found;
          if (element) {
            for (var i = 0, len = element.length; i < len; i++) {
              var target = element[i];
              if (!found) {
                for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
                  found = found || scanTree([target.childNodes[j]]);
                }
              }
            }
          }
          return found;
        }

      },

      /**
       * Give optional properties with no value a boolean true if attr provided or false otherwise
       */
      initOptionalProperties: function (scope, attr, defaults) {
        defaults = defaults || {};
        angular.forEach(scope.$$isolateBindings, function (binding, key) {
          if (binding.optional && angular.isUndefined(scope[key])) {
            var attrIsDefined = angular.isDefined(attr[binding.attrName]);
            scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
          }
        });
      },

      /**
       * Alternative to $timeout calls with 0 delay.
       * nextTick() coalesces all calls within a single frame
       * to minimize $digest thrashing
       *
       * @param callback
       * @param digest
       * @returns {*}
       */
      nextTick: function (callback, digest, scope) {
        //-- grab function reference for storing state details
        var nextTick = $mdUtil.nextTick;
        var timeout = nextTick.timeout;
        var queue = nextTick.queue || [];

        //-- add callback to the queue
        queue.push(callback);

        //-- set default value for digest
        if (digest == null) digest = true;

        //-- store updated digest/queue values
        nextTick.digest = nextTick.digest || digest;
        nextTick.queue = queue;

        //-- either return existing timeout or create a new one
        return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

        /**
         * Grab a copy of the current queue
         * Clear the queue for future use
         * Process the existing queue
         * Trigger digest if necessary
         */
        function processQueue() {
          var skip = scope && scope.$$destroyed;
          var queue = !skip ? nextTick.queue : [];
          var digest = !skip ? nextTick.digest : null;

          nextTick.queue = [];
          nextTick.timeout = null;
          nextTick.digest = false;

          queue.forEach(function (callback) {
            callback();
          });

          if (digest) $rootScope.$digest();
        }
      },

      /**
       * Processes a template and replaces the start/end symbols if the application has
       * overriden them.
       *
       * @param template The template to process whose start/end tags may be replaced.
       * @returns {*}
       */
      processTemplate: function (template) {
        if (usesStandardSymbols) {
          return template;
        } else {
          if (!template || !angular.isString(template)) return template;
          return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        }
      },

      /**
       * Scan up dom hierarchy for enabled parent;
       */
      getParentWithPointerEvents: function (element) {
        var parent = element.parent();

        // jqLite might return a non-null, but still empty, parent; so check for parent and length
        while (hasComputedStyle(parent, 'pointer-events', 'none')) {
          parent = parent.parent();
        }

        return parent;
      },

      getNearestContentElement: function (element) {
        var current = element.parent()[0];
        // Look for the nearest parent md-content, stopping at the rootElement.
        while (current && current !== $rootElement[0] && current !== document.body && current.nodeName !== 'MD-CONTENT') {
          current = current.parentNode;
        }
        return current;
      },

      hasComputedStyle: hasComputedStyle
    };

    // Instantiate other namespace utility methods

    $mdUtil.dom.animator = $$mdAnimate($mdUtil);

    return $mdUtil;

    function getNode(el) {
      return el[0] || el;
    }

  }
  UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window"];
})();
var defaultLanguage = 'en';
window.language = localStorage.getItem('user_locale') || defaultLanguage;

var supportedLocales = locales.map(function (locale) {
  return locale.code;
});
supportedLocales.push('dev');

// Ensure that user locale is in list of supported locales, otherwise use default language
if (supportedLocales.indexOf(window.language) === -1) {
  window.language = defaultLanguage;
  localStorage.setItem('user_locale', window.language);
}

var locizeProjectId = '81f1912f-6c96-4c3b-b97b-9fae4a95dd8f';
var locizeNamespace = 'general';
var locizeVersion = 'latest';

moment.locale(window.language);

var translations, fallback;
window.missedI18n = [];

function loadLanguage(locale) {
  var promises = [
    $.get('https://api.locize.io/' + locizeProjectId + '/' + locizeVersion + '/' + locale + '/' + locizeNamespace)
  ];
  if (locale != 'en') {
    promises.push($.get('https://api.locize.io/' + locizeProjectId + '/' + locizeVersion + '/en/' + locizeNamespace));
  }
  return Promise.all(promises)
    .then(function (response) {
      translations = response[0];
      if (response[1]) {
        fallback = response[1];
      } else {
        fallback = {};
      }

      if (window.dropins) {
        window.dropins.forEach(function (item) {
          item[0] = translations['general.dropins_dropdown.' + item[0]] || fallback['general.dropins_dropdown.' + item[0]] || item[0];
        });
      }

      return response;
    })
    .catch(function () {
      translations = {};
      fallback = {};
    });
}

var langInit = loadLanguage(window.language).then(function () {
  document.getElementsByTagName('body')[0].classList.remove('lang-load');
});

var applicationInitialization = Promise.all([
  langInit
]);

applicationInitialization.then(function () {
  angular
    .module('buuqit')
    .service('i18nStorage', function () {
      this.translations = translations;
      this.fallback = fallback;
    });

  angular.bootstrap(document, ['buuqit']);
});

angular.module("buuqit").run(["$templateCache", function($templateCache) {$templateCache.put("templates/addToWaitlistModal_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.waitlist\' | i18next}}\" class=\"add-to-waitlist-modal\" ng-cloak=\"\"><form name=\"addToWaitlist\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'bookings.waitlist_modal.add_to_waitlist\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"waitlist-modal-content\"><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"col-xs-6 date-col\"><label>{{\'general.other.checkin\' | i18next}}</label><md-datepicker ng-model=\"tempCheckinDate\" md-placeholder=\"{{\'general.other.checkin\' | i18next}}\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'general.other.checkout\' | i18next}}</label><md-datepicker ng-model=\"tempCheckoutDate\" md-placeholder=\"{{\'general.other.checkout\' | i18next}}\" md-min-date=\"tempCheckinDate\"></md-datepicker></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container class=\"md-block\"><label>{{\'general.other.number_of_rooms\' | i18next}}</label> <input ng-model=\"waitlist.numberOfRooms\" type=\"number\" name=\"number_of_rooms\" maxlength=\"8\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container class=\"md-block\"><label>{{\'general.other.amount\' | i18next}}</label> <input ng-model=\"waitlist.amount\" type=\"number\" name=\"amount\" maxlength=\"8\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container class=\"md-block\"><label>{{\'general.other.subject\' | i18next}}</label> <input ng-model=\"waitlist.subject\" name=\"subject\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container class=\"md-block\"><label>{{\'general.labels.note\' | i18next}}</label> <textarea ng-model=\"waitlist.notes\" columns=\"1\" rows=\"5\" name=\"notes\"></textarea></md-input-container></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warn\" ng-show=\"waitlist.id\" ng-click=\"remove()\">{{\'general.buttons.remove\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"createDateNote.$invalid\" ng-click=\"save()\">{{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/admin_new_tpl.html","<div id=\"root\" style=\"height: 100%;\"></div>");
$templateCache.put("templates/admin_tpl.html","<md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Hotels\"><md-content class=\"md-padding\"><table class=\"table table-striped\"><thead><tr><th>Hotel title</th><th>Slug</th><th>Status</th><th>Production</th><th>Subscription</th><th></th></tr></thead><tbody><tr ng-repeat=\"hotel in hotels | orderBy:\'name\'\"><td ng-if=\"hotel.edited === true\" colspan=\"7\"><hotel-form ng-model=\"hotel\"></hotel-form></td><td ng-hide=\"hotel.edited\">{{hotel.name}}</td><td ng-hide=\"hotel.edited\">{{hotel.slug}}</td><td ng-hide=\"hotel.edited\">{{hotel.status}}</td><td ng-hide=\"hotel.edited\"><i ng-show=\"hotel.isProduction == true\" class=\"fa fa-circle\" style=\"color: #4AD647\"></i></td><td ng-hide=\"hotel.edited\"><i ng-show=\"hotel.subscription == true\" class=\"fa fa-circle\" style=\"color: #4AD647\"></i></td><td class=\"controls dropdown-controls text-right\" ng-hide=\"hotel.edited\"><md-menu><md-button aria-label=\"Open menu\" class=\"md-button md-options\" ng-click=\"openMenu($mdOpenMenu, $event)\">Options <i class=\"fa fa-caret-down\"></i></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"editHotel(hotel)\">Edit</md-button></md-menu-item><md-menu-item ng-show=\"hotel.status == \'active\'\"><md-button ng-click=\"blockHotel(hotel)\">Block</md-button></md-menu-item><md-menu-item ng-show=\"hotel.status == \'suspend\'\"><md-button ng-click=\"unblockHotel(hotel)\">UnBlock</md-button></md-menu-item><md-menu-item ng-show=\"hotel.subscription == false\"><md-button ng-click=\"createSubscription(hotel)\">Create Subscription</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><hotel-form ng-model=\"newHotel\" ng-show=\"hotelNew\"></hotel-form><a href=\"#\" ng-click=\"addNewHotel($event)\"><i class=\"fa fa-plus\"></i> Add Hotel</a></md-content></md-tab><md-tab label=\"Users\"><md-content class=\"md-padding\"><table class=\"table table-striped\"><thead><tr><th>Email</th><th>Name</th><th>Status</th><th>Hotel</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in users | orderBy:\'email\'\"><td>{{user.email}}</td><td>{{user.name}}</td><td>{{user.status}}</td><td>{{user.hotelNames}}</td><td class=\"controls dropdown-controls text-right\"><md-menu><md-button aria-label=\"Open menu\" class=\"md-button md-options\" ng-click=\"openMenu($mdOpenMenu, $event)\">Options <i class=\"fa fa-caret-down\"></i></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"editUser(user)\">Edit</md-button></md-menu-item><md-menu-item><md-button ng-click=\"manageUserHotels(user)\">Manage Hotels</md-button></md-menu-item><md-menu-item ng-show=\"user.status == \'active\'\"><md-button ng-click=\"blockUser(user)\">Block</md-button></md-menu-item><md-menu-item ng-show=\"user.status == \'blocked\'\"><md-button ng-click=\"unblockUser(user)\">UnBlock</md-button></md-menu-item><md-menu-item><md-button ng-click=\"openChangePasswordDialog(user)\">Change Password</md-button></md-menu-item><md-menu-item><md-button ng-click=\"loginAs(user)\">Login as this user</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><user-form ng-model=\"newUser\" ng-show=\"userNew\"></user-form><a href=\"#\" ng-click=\"addNewUser($event)\"><i class=\"fa fa-plus\"></i> Add User</a></md-content></md-tab><md-tab label=\"Corporate Accounts\"><md-content class=\"md-padding\"><table class=\"table table-striped\"><thead><tr><th>Company Name</th><th>Contact Person</th><th>Phone</th><th>Count of Hotels</th><th>Count of Users</th><th>Status</th><th></th></tr></thead><tbody><tr ng-repeat=\"account in corporate_accounts | orderBy:\'name\'\"><td ng-if=\"account.edited === true\" colspan=\"7\"><corporate-account-form ng-model=\"account\"></corporate-account-form></td><td ng-hide=\"account.edited\">{{account.companyName}}</td><td ng-hide=\"account.edited\">{{account.contactPerson}}</td><td ng-hide=\"account.edited\">{{account.phone}}</td><td ng-hide=\"account.edited\">{{account.hotels.length}}</td><td ng-hide=\"account.edited\">{{account.users.length}}</td><td ng-hide=\"account.edited\"><i ng-show=\"account.isActive == true\" class=\"fa fa-circle\" style=\"color: #4AD647\"></i></td><td class=\"controls dropdown-controls text-right\" ng-hide=\"account.edited\"><md-menu><md-button aria-label=\"Open menu\" class=\"md-button md-options\" ng-click=\"openMenu($mdOpenMenu, $event)\">Options <i class=\"fa fa-caret-down\"></i></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"editCorporateAccount(account)\">Edit</md-button></md-menu-item><md-menu-item ng-if=\"account.isActive\"><md-button ng-click=\"toggleCorporateAccount(account)\">Disable account</md-button></md-menu-item><md-menu-item ng-if=\"account.isActive == false\"><md-button ng-click=\"toggleCorporateAccount(account)\">Enable account</md-button></md-menu-item><md-menu-item><md-button ng-click=\"addUserToCorporateAccount(account)\">Add User</md-button></md-menu-item><md-menu-item><md-button ng-click=\"addHotelToCorporateAccount(account)\">Add Hotel</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><corporate-account-form ng-model=\"newCorporateAccount\" ng-show=\"corporateAccountNew\"></corporate-account-form><a href=\"#\" ng-click=\"addNewCorporateAccount($event)\"><i class=\"fa fa-plus\"></i> Add Corporate Account</a></md-content></md-tab><md-tab label=\"Logs\"><md-content class=\"md-padding\"><div class=\"logs_control__hotel_selector\"><md-input-container><label>Select Hotel</label><md-select ng-model=\"logs_hotel\" ng-change=\"loadLogsForSelectedHotel()\"><md-option ng-repeat=\"hotel in hotels | orderBy:\'name\'\" value=\"{{hotel.id}}\">{{hotel.name}}</md-option></md-select></md-input-container></div><div class=\"logs_control__events_list\"><div class=\"logs_control__event row\" ng-class=\"{\'selected\' : event.id == selected_event_id}\" ng-repeat=\"event in events | orderBy:\'-id\'\" ng-click=\"openEvent(event, $index)\" ng-keydown=\"keyboardNavigation($event, $index)\"><div class=\"col-xs-2\">{{event.created_at | date:\'dd/MM/yyyy hh:mm:ss\'}}</div><div class=\"col-xs-1\">{{event.user}}</div><div class=\"col-xs-2\">{{event.trigger_action}}</div><div class=\"col-xs-7\"><a ng-click=\"showParams(event)\"><span ng-if=\"!event.show\">Show</span> <span ng-if=\"event.show\">Hide</span> Params</a><pre ng-if=\"event.show == true\">{{event.trigger_arguments}}</pre></div></div></div><div class=\"logs_control__availability_compare\"><legend>Availability Table</legend><strong>Current Date:</strong> {{current_availability.from | date:\'dd/MM/yyyy\'}} <span ng-if=\"previous_availability\"><strong>Previous Date:</strong> {{previous_availability.from | date:\'dd/MM/yyyy\'}}</span><div class=\"row\"><div class=\"col-xs-1\"></div><div class=\"col-xs-11\"><span class=\"logs_control__date\" ng-repeat=\"date in dates track by $index\">{{date | date:\'dd\'}}</span></div></div><div ng-repeat=\"(key, availability) in current_availability.data | orderBy:key\" class=\"row\"><div class=\"col-xs-1\">{{key}}</div><div class=\"col-xs-11 logs_control__availability_table\">{{availability}}</div></div></div></md-content></md-tab></md-tabs>");
$templateCache.put("templates/bookingManagementModal_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.create_booking\' | i18next}}\" class=\"modal-manage-booking\" ng-class=\"{\'modal-manage-booking-mobile\': is_mobile}\" ng-cloak=\"\"><div class=\"booking-management-left-side\"><a class=\"tab-link\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 0)\" ng-class=\"{\'active\' : active_tab == 0}\">{{\'general.other.rooms\' | i18next}} ({{ roomSize }}) <span>{{convertCurrency(booking.totalRoom)}}</span></a> <a class=\"tab-link\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 0)\" ng-class=\"{\'active\' : active_tab == 0}\"><i class=\"fa fa-building\" aria-hidden=\"true\"></i> ({{ roomSize }}) <span>{{convertCurrency(booking.totalRoom)}}</span></a> <a class=\"tab-link\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 1)\" ng-class=\"{\'active\' : active_tab == 1}\">{{\'general.other.extras\' | i18next}} <span ng-class=\"{\'negative\' : booking.totalExtras < 0}\">{{convertCurrency(booking.totalExtras)}}</span></a> <a class=\"tab-link\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 1)\" ng-class=\"{\'active\' : active_tab == 1}\"><i class=\"fa fa-plus-square\" aria-hidden=\"true\"></i> <span ng-class=\"{\'negative\' : booking.totalExtras < 0}\">{{convertCurrency(booking.totalExtras)}}</span></a> <a class=\"tab-link small\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 9)\" ng-class=\"{\'active\' : active_tab == 9}\">{{\'bookings.management_modal.guests_link\' | i18next}}</a> <a class=\"tab-link small\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 9)\" ng-class=\"{\'active\' : active_tab == 9}\"><i class=\"fa fa-users\" aria-hidden=\"true\"></i></a> <a class=\"tab-link small\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 8)\" ng-class=\"{\'active\' : active_tab == 8}\">{{\'bookings.management_modal.folios_link\' | i18next}}</a> <a class=\"tab-link small\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 8)\" ng-class=\"{\'active\' : active_tab == 8}\"><i class=\"fa fa-address-card\" aria-hidden=\"true\"></i></a> <a class=\"tab-link small\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 5)\" ng-class=\"{\'active\' : active_tab == 5}\">{{\'bookings.management_modal.payment_link\' | i18next}}</a> <a class=\"tab-link small\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 5)\" ng-class=\"{\'active\' : active_tab == 5}\"><i class=\"fa fa-money\" aria-hidden=\"true\"></i></a> <a class=\"tab-link small\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 6)\" ng-class=\"{\'active\' : active_tab == 6}\">{{\'general.other.email\' | i18next}}</a> <a class=\"tab-link small\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 6)\" ng-class=\"{\'active\' : active_tab == 6}\"><i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i></a> <a class=\"tab-link small\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 7)\" ng-class=\"{\'active\' : active_tab == 7}\">{{\'bookings.management_modal.history_link\' | i18next}}</a> <a class=\"tab-link small\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 7)\" ng-class=\"{\'active\' : active_tab == 7}\"><i class=\"fa fa-history\" aria-hidden=\"true\"></i></a> <a class=\"tab-link small\" ng-if=\"!is_mobile\" ng-click=\"openTab($event, 10)\" ng-class=\"{\'active\' : active_tab == 10}\">{{\'bookings.management_modal.attachments\' | i18next}}</a> <a class=\"tab-link small\" ng-if=\"is_mobile\" ng-click=\"openTab($event, 10)\" ng-class=\"{\'active\' : active_tab == 10}\"><i class=\"fa fa-paperclip\" aria-hidden=\"true\"></i></a><hr><a class=\"tab-link small inactive\">{{\'general.other.summary\' | i18next}} <span class=\"grand-total\">{{\'bookings.management_modal.summary_link.grand_total_span\' | i18next}}:<br><span>{{convertCurrency(booking.total)}}</span></span> <span ng-class=\"{\'negative\' : booking.due > 0, \'inactive\' : booking.due == 0}\">{{\'general.other.due\' | i18next}}:<br><span>{{convertCurrency(booking.due)}}</span></span> <span ng-class=\"{\'positive\' : booking.totalPaid == booking.total, \'inactive\' : booking.totalPaid == 0}\">{{\'general.other.paid\' | i18next}}:<br><span>{{convertCurrency(booking.totalPaid)}}</span></span></a></div><div class=\"booking-management-right-side\"><div class=\"background\"></div><div class=\"header\">#{{booking.preparedToken}} <span ng-show=\"booking.source == \'channel\'\">({{booking.preparedChannel}} {{\'bookings.management_modal.right_side_div.booking_span\' | i18next}}<span ng-show=\"booking.preparedChannelReservationId\">&nbsp;{{booking.preparedChannelReservationId}}</span>)</span> <span ng-show=\"booking.source == \'app\'\">( {{\'bookings.management_modal.right_side_div.offline_booking_span\' | i18next}} <span>,&nbsp; <span ng-if=\"isSaleChannelsFeatureEnabled\" class=\"editable__item\" tooltip=\"{{bookings.change_sale_channel}}\" tooltip-append-to-body=\"true\" ng-click=\"editSaleChannel()\"><span class=\"gray\" ng-if=\"!booking.saleChannel\">{{\'bookings.change_sale_channel\' | i18next}}</span> {{booking.saleChannel.name}}</span> <span ng-if=\"!isSaleChannelsFeatureEnabled\" class=\"editable__item\" tooltip=\"Edit Channel\" tooltip-append-to-body=\"true\" ng-click=\"editChannel()\"><span class=\"gray\" ng-if=\"!booking.channel\">{{\'bookings.change_channel_name_title\' | i18next}}</span> {{booking.channel}}</span></span> <span><span ng-if=\"booking.channel\">,&nbsp;</span> <span class=\"editable__item\" tooltip=\"Edit Reference\" tooltip-append-to-body=\"true\" ng-click=\"editReference()\"><span class=\"gray\" ng-if=\"booking.channel && !booking.preparedChannelReservationId\">{{\'bookings.change_reference_title\' | i18next}}</span> {{booking.preparedChannelReservationId}}</span></span> )</span> <span ng-show=\"booking.source == \'widget\'\">({{\'bookings.management_modal.right_side_div.website_booking_span\' | i18next}}<span ng-show=\"booking.channel\">, {{booking.channel}}</span>)</span> <small>{{\'bookings.management_modal.right_side_div.small\' | i18next}}</small> <a class=\"close-link\" ng-click=\"closeModal()\"><i class=\"fa fa-times\"></i></a></div><div class=\"content\" ng-include=\"template\"></div></div><ui-prompt-number id=\"money-prompt\" class=\"buuqit-modal-wrapper\"></ui-prompt-number><ui-change-date-modal id=\"change-date-modal\" class=\"buuqit-modal-wrapper\"></ui-change-date-modal><ui-change-price-modal id=\"change-price-modal\" class=\"buuqit-modal-wrapper\"></ui-change-price-modal><ui-change-occupancy-modal id=\"change-occupancy-modal\" class=\"buuqit-modal-wrapper\"></ui-change-occupancy-modal><ui-cancelation-modal id=\"cancellation-modal\" class=\"buuqit-modal-wrapper\"></ui-cancelation-modal><ui-change-room-modal id=\"change-room-modal\" class=\"buuqit-modal-wrapper\"></ui-change-room-modal><ui-prompt-string id=\"cardholder-name\" class=\"buuqit-modal-wrapper\"></ui-prompt-string><ui-prompt-string id=\"channel-name\" class=\"buuqit-modal-wrapper\"></ui-prompt-string><ui-choose-sale-channel-modal id=\"choose-sale-channel\" class=\"buuqit-modal-wrapper\"></ui-choose-sale-channel-modal><ui-prompt-password id=\"credit-password\" class=\"buuqit-modal-wrapper\"></ui-prompt-password><ui-confirm id=\"confirmation\" class=\"buuqit-modal-wrapper\"></ui-confirm><ui-alert id=\"alert\" class=\"buuqit-modal-wrapper\"></ui-alert><ui-request-payment id=\"request-payment\" class=\"buuqit-modal-wrapper\"></ui-request-payment><ui-hit-payment id=\"hit-payment\" class=\"buuqit-modal-wrapper\"></ui-hit-payment><ui-print-rooms id=\"print-rooms\" class=\"buuqit-modal-wrapper\"></ui-print-rooms></md-dialog>");
$templateCache.put("templates/bookings_and_folios_tpl.html","<div style=\"height: 100%; padding: 40px 20px;\" ng-controller=\"BookingsAndFoliosCtrl as ctrl\"><react-bookings-and-folios-page on-load-bookings=\"ctrl.onLoadBookings\" on-open-booking-modal=\"ctrl.onOpenBookingModal\" currency-symbol=\"ctrl.currencySymbol\"></react-bookings-and-folios-page></div>");
$templateCache.put("templates/calendar_tpl.html","<div class=\"scheduler\"><div id=\"calendar\" class=\"calendar__block\" context-menu=\"\" data-target=\"ContextMenu\"></div><div class=\"scheduler-left\"><div class=\"date-select\"><i class=\"fa fa-calendar calendar-datepicker-button\"></i> <span class=\"today-text\">{{\'general.other.date\' | i18next}}</span>&nbsp;<md-datepicker ng-model=\"selectedDate\" md-min-date=\"minDate\" md-max-date=\"maxDate\" ng-change=\"gotoSelectedDate()\"></md-datepicker></div><div class=\"today-btn\" ng-click=\"goToToday()\">{{\'general.other.today\' | i18next}}</div><div class=\"zoom-control\"><button ng-click=\"zoomIn()\"><i class=\"fa fa-plus\"></i></button> <button ng-click=\"zoomOut()\"><i class=\"fa fa-minus\"></i></button></div></div><div class=\"popover top\" id=\"scheduler-popover\"><div class=\"arrow\"></div><div class=\"popover-content\">{{\'bookings.calendar.some_content_div\' | i18next}}</div></div><div class=\"dropdown position-fixed context-menu\" id=\"ContextMenu\" ng-show=\"hasAccess(\'schedulerRightClickMenu\') || contextMenuTarget === \'clean-status\'\"><ul class=\"dropdown-menu\" role=\"menu\"><li ng-if=\"!bookingContextMenuOptions.hasDetails\" class=\"text-center\"><i class=\"fa fa-spin fa-spinner\"></i> {{\'general.other.loading\' | i18next}}...</li><li ng-show=\"contextMenuTarget == \'clean-status\'\" ng-repeat=\"clean_status in clean_statuses\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"changeCleanStatus(clean_status.value)\">{{\'bookings.calendar.clean_statuses.\' + clean_status.value | i18next }}</a></li><li ng-show=\"contextMenuTarget == \'clean-status\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"changeDoNotDisturbStatus(!selectedRoom.doNotDisturb)\">{{\'bookings.calendar.clean_statuses.do_not_disturb\' | i18next }} <i ng-show=\"selectedRoom.doNotDisturb\" class=\"fa fa-check\" aria-hidden=\"true\"></i></a></li><li ng-show=\"contextMenuTarget == \'room-slot\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"openRoomBlockerModal()\">{{\'bookings.calendar.block_room_link\' | i18next}}</a></li><li ng-show=\"contextMenuTarget == \'room-slot\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"openNewBookingAction()\">{{\'bookings.calendar.create_booking_link\' | i18next}}</a></li><li ng-show=\"contextMenuTarget == \'blocker\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"openBlockerManagementModal($event)\">{{\'bookings.calendar.manage_block_link\' | i18next}}</a></li><li ng-show=\"contextMenuTarget == \'blocker\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"removeBlocker()\">{{\'bookings.calendar.remove_block_link\' | i18next}}</a></li><li ng-show=\"bookingContextMenuOptions.checkin && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"checkin()\">{{\'bookings.calendar.check_in_link\' | i18next}}</a></li><li ng-show=\"bookingContextMenuOptions.cancel_checkin && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"2\" ng-click=\"cancel_checkin()\">{{\'bookings.calendar.cancel_check_in_link\' | i18next}}</a></li><li ng-show=\"bookingContextMenuOptions.checkout && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" ng-click=\"checkout()\">{{\'bookings.calendar.check_out_link\' | i18next}}</a></li><li ng-show=\"bookingContextMenuOptions.cancel_checkout && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\" ng-click=\"cancel_checkout()\">{{\'bookings.calendar.cancel_check_out_link\' | i18next}}</a></li><li class=\"has-submenu\" ng-show=\"bookingContextMenuOptions.move && contextMenuTarget == \'booking\'\" ng-mouseover=\"showSubmenu($event)\" ng-mouseout=\"hideSubmenu($event)\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"5\">{{\'bookings.calendar.quick_move_link\' | i18next}} <span class=\"submenu-arrow\"><i class=\"fa fa-caret-right\"></i></span></a><ul class=\"dropdown-menu submenu\" style=\"max-height: {{max_menu_height}}px;\"><li ng-repeat=\"room in availableRoomsByType\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" ng-click=\"moveBookingToRoom(room.id)\">{{room.number}}</a></li><li ng-show=\"bookingContextMenuOptions.hold\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\" ng-click=\"holdRoom()\">{{\'bookings.calendar.holding_area_link\' | i18next}}</a></li><li ng-show=\"bookingContextMenuOptions.holdAll\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\" ng-click=\"holdAllRooms()\">{{\'bookings.calendar.holding_all_link\' | i18next}}</a></li><li ng-show=\"bookingContextMenuOptions.cantmove\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\">{{\'bookings.calendar.cannot_be_moved_link\' | i18next}}</a></li><li ng-show=\"otherAvailableTypes.length > 0\"><a class=\"inactive-submenu-link\">{{\'bookings.calendar.other_rooms_link\' | i18next}}:</a></li><li ng-repeat=\"room in otherAvailableTypes\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" ng-click=\"moveBookingToRoom(room.id)\">{{room.number}}</a></li></ul></li><li ng-show=\"bookingContextMenuOptions.manage && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"8\" ng-click=\"openBookingManagementModal()\">{{\'bookings.calendar.edit_booking_link\' | i18next}}</a></li></ul></div></div><ui-prompt-notes id=\"booking-notes\" class=\"buuqit-modal-wrapper\"></ui-prompt-notes>");
$templateCache.put("templates/chart_tpl.html","<div class=\"metrics\"><div class=\"row\"><div class=\"col-md-12\"><a class=\"back-btn\" href=\"#/metrics\"><i class=\"fa fa-arrow-left\"></i> Back</a><br><img src=\"images/charts/chart-big.png\" class=\"big-chart\"></div></div></div>");
$templateCache.put("templates/confirmed_tpl.html","<div class=\"login-page\"><div class=\"row-fluid\"><div class=\"col-xs-12 login-page__right-block login-page__white-label\"><div class=\"login-page__header text-center\"><img ng-src=\"{{server_path+\'/api/public/v1/big_logo\'}}\" alt=\"{{domain_settings.name}}\"><p class=\"login-page__hero\">{{\'login.sign_in_title\' | i18next}}</p></div><div class=\"login-container success-container text-center\"><p>{{\'login.confirmation.congratulations_text\' | i18next}}</p><p>{{\'login.confirmation.activation_note\' | i18next}}</p><p ng-bind-html=\"go_to_link\"></p></div></div></div></div>");
$templateCache.put("templates/createDateNoteModal_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.date_note\' | i18next}}\" ng-cloak=\"\"><form name=\"createDateNote\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-hide=\"note.id\">{{\'bookings.create_date_note_modal.add_note\' | i18next}}</h2><h2 ng-show=\"note.id\">{{\'bookings.create_date_note_modal.edit_note\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"col-xs-12 date-col\"><label>{{\'general.other.date\' | i18next}}</label><md-datepicker ng-model=\"note.date\" md-placeholder=\"{{\'general.other.date\' | i18next}}\"></md-datepicker></div><div class=\"col-xs-12\"><md-input-container class=\"md-block\"><label>{{\'general.labels.note\' | i18next}}</label> <textarea ng-model=\"note.note\" md-maxlength=\"255\" columns=\"1\" name=\"note\" required=\"\"></textarea></md-input-container></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warn\" ng-show=\"note.id || note.__sync === false\" ng-click=\"remove()\">{{\'general.buttons.clear\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"createDateNote.$invalid\" ng-click=\"save()\">{{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/createNewHotelModal_tpl.html","<md-dialog aria-label=\"create new hotel\" ng-cloak=\"\"><form name=\"createNewHotel\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Create New Hotel</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Hotel name</label> <input type=\"text\" ng-model=\"hotel.name\" name=\"name\" required=\"\" autofocus=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Reception email</label> <input type=\"email\" ng-model=\"hotel.email\" name=\"email\" required=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Phone</label> <input type=\"phone\" ng-model=\"hotel.phone\" name=\"phone\" required=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Number of Rooms</label> <input type=\"number\" ng-model=\"hotel.numberOfRooms\" name=\"number_of_rooms\" required=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Country</label><md-select ng-model=\"hotel.country\" required=\"\"><md-option ng-repeat=\"country in countries\" value=\"{{country.code}}\">{{country.name}}</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"createNewHotel.$invalid || saving == true\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-show=\"saving\" ng-class=\"{\'fa-spin\':saving == true}\"></i> Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/createRoomHKNoteModal_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.hk_note\' | i18next}}\" ng-cloak=\"\"><form name=\"createDateNote\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-hide=\"note\">{{\'bookings.create_room_note_modal.add_room_hk_note_title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>{{\'general.labels.hk_note\' | i18next}}</label> <textarea ng-model=\"room.hoousekeeper_note\" name=\"hoousekeeper_note\" required=\"\" autofocus=\"\"></textarea></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"createDateNote.$invalid\" ng-click=\"save()\">{{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/createRoomNoteModal_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.date_note\' | i18next}}\" ng-cloak=\"\"><form name=\"createDateNote\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-hide=\"note\">{{\'bookings.create_room_note_modal.add_room_note_title\' | i18next}}</h2><h2 ng-show=\"note\">{{\'bookings.create_room_note_modal.edit_room_note_title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>{{\'general.labels.note\' | i18next}}</label> <textarea ng-model=\"room.note\" name=\"note\" required=\"\" autofocus=\"\"></textarea></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warn\" ng-show=\"note\" ng-click=\"remove()\">{{\'general.buttons.clear\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"createDateNote.$invalid\" ng-click=\"save()\">{{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/customerModal_tpl.html","<md-dialog aria-label=\"{{\'bookings.folios.edit_customer\' | i18next}}\" ng-cloak=\"\" class=\"modal-edit-customer\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \"bookings.folios.edit_customer\" | i18next }}</h2></div></md-toolbar><md-dialog-content><customer-form customer=\"customer\" on-close=\"(cancel)\" on-new-customer=\"(onNewCustomer)\"></customer-form></md-dialog-content></md-dialog>");
$templateCache.put("templates/customers_tpl.html","<div id=\"root\" style=\"height: 100%;\"></div><ui-prompt-string id=\"payment-note\" class=\"buuqit-modal-wrapper\"></ui-prompt-string><ui-prompt-notes id=\"booking-notes\" class=\"buuqit-modal-wrapper\"></ui-prompt-notes><ui-export-customers-email id=\"customers-export-xls\" class=\"buuqit-modal-wrapper\"></ui-export-customers-email>");
$templateCache.put("templates/dashboard_tpl.html","<div class=\"metrics\" ng-if=\"signedIn === true\"><div class=\"row\" ng-if=\"user.role != \'housekeeper\' && !is_mobile\"><div ng-class=\"{\'col-md-4\': (hasAccess(\'dashboardCharts\') || threeColumnDashboardEnabled), \'col-md-6\': !(hasAccess(\'dashboardCharts\'))}\"><dashboard-live-feed></dashboard-live-feed></div><div ng-class=\"{\'col-md-4 middle\': (hasAccess(\'dashboardCharts\') && !threeColumnDashboardEnabled), \'col-md-6\': !(hasAccess(\'dashboardCharts\')), \'col-md-4 full-height-col\': (hasAccess(\'dashboardCharts\') && threeColumnDashboardEnabled)}\"><dashboard-checkins style=\"overflow-y: auto\"></dashboard-checkins><dashboard-checkouts ng-if=\"!threeColumnDashboardEnabled || !hasAccess(\'dashboardCharts\')\"></dashboard-checkouts></div><div ng-if=\"threeColumnDashboardEnabled && hasAccess(\'dashboardCharts\') == true\" class=\"col-md-4 full-height-col\"><dashboard-checkouts></dashboard-checkouts></div><div class=\"col-md-4\" ng-show=\"hasAccess(\'dashboardCharts\') && !threeColumnDashboardEnabled\"><div class=\"charts\"><dashboard-charts></dashboard-charts></div></div></div><div class=\"row\" ng-if=\"user.role != \'housekeeper\' && is_mobile\"><div class=\"check-col\" ng-class=\"{\'col-md-4 middle\': (hasAccess(\'dashboardCharts\')), \'col-md-6\': !(hasAccess(\'dashboardCharts\'))}\"><dashboard-checkins style=\"overflow-y: auto\"></dashboard-checkins><dashboard-checkouts></dashboard-checkouts></div><div class=\"full-height-col-mobile-col\" ng-class=\"{\'col-md-4\': (hasAccess(\'dashboardCharts\')), \'col-md-6\': !(hasAccess(\'dashboardCharts\'))}\"><dashboard-live-feed></dashboard-live-feed></div><div class=\"col-md-4\" ng-show=\"hasAccess(\'dashboardCharts\')\"><div class=\"charts\"><dashboard-charts></dashboard-charts></div></div></div><div class=\"row\" ng-if=\"user.role == \'housekeeper\'\"><div class=\"col-md-6 col-md-offset-3\"><dashboard-checkins></dashboard-checkins><dashboard-checkouts></dashboard-checkouts></div></div></div><ui-prompt-notes id=\"booking-notes\" class=\"buuqit-modal-wrapper\"></ui-prompt-notes>");
$templateCache.put("templates/denied_tpl.html","<div class=\"system_message__access_denied\">Access Denied!</div>");
$templateCache.put("templates/drawerProvider_tpl.html","<div><booking-management-drawer booking=\"booking\" active-tab=\"activeTab\" params=\"params\" close-drawer=\"closeDrawer\"></booking-management-drawer><ui-prompt-number id=\"money-prompt\" class=\"buuqit-drawer-wrapper\"></ui-prompt-number><ui-change-date-modal id=\"change-date-modal\" class=\"buuqit-drawer-wrapper\"></ui-change-date-modal><ui-change-price-modal id=\"change-price-modal\" class=\"buuqit-drawer-wrapper\"></ui-change-price-modal><ui-change-occupancy-modal id=\"change-occupancy-modal\" class=\"buuqit-drawer-wrapper\"></ui-change-occupancy-modal><ui-cancelation-modal id=\"cancellation-modal\" class=\"buuqit-drawer-wrapper\"></ui-cancelation-modal><ui-change-room-modal id=\"change-room-modal\" class=\"buuqit-drawer-wrapper\"></ui-change-room-modal><ui-prompt-string id=\"cardholder-name\" class=\"buuqit-drawer-wrapper\"></ui-prompt-string><ui-prompt-string id=\"channel-name\" class=\"buuqit-drawer-wrapper\"></ui-prompt-string><ui-choose-sale-channel-modal id=\"choose-sale-channel\" class=\"buuqit-drawer-wrapper\"></ui-choose-sale-channel-modal><ui-prompt-password id=\"credit-password\" class=\"buuqit-drawer-wrapper\"></ui-prompt-password><ui-confirm id=\"confirmation\" class=\"buuqit-drawer-wrapper\"></ui-confirm><ui-alert id=\"alert\" class=\"buuqit-drawer-wrapper\"></ui-alert><ui-request-payment id=\"request-payment\" class=\"buuqit-drawer-wrapper\"></ui-request-payment><ui-hit-payment id=\"hit-payment\" class=\"buuqit-drawer-wrapper\"></ui-hit-payment><ui-print-rooms id=\"print-rooms\" class=\"buuqit-drawer-wrapper\"></ui-print-rooms></div>");
$templateCache.put("templates/editUserModal_tpl.html","<md-dialog aria-label=\"edit user\" ng-cloak=\"\"><form name=\"editUser\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Edit User</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Username</label> <input ng-model=\"name\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Role</label><md-select ng-model=\"role\" required=\"\"><md-option value=\"owner\">Owner</md-option><md-option value=\"manager\">Manager</md-option><md-option value=\"reception\">Reception</md-option><md-option value=\"reception_no_finance\">Reception (No Finance)</md-option><md-option value=\"housekeeper\">Housekeeper</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"editUser.$invalid || saving == true\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-show=\"saving\" ng-class=\"{\'fa-spin\':saving == true}\"></i> Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/foreignCurrencyEdit_tpl.html","<form class=\"form-horizontal booking-form\" name=\"roomEdit\" novalidate=\"\"><md-content md-theme=\"docs-dark\"><div class=\"dark form-zone\"><legend>{{\'bookings.foreign_currency\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-4 form-block\"><div class=\"form-block date-col\"><md-input-container md-theme=\"docs-dark\"><label>{{\'bookings.currency_rate\' | i18next}}</label> <input type=\"number\" ng-model=\"value.foreignCurrencyRate\" min=\"0\"></md-input-container></div></div><div class=\"col-xs-4 form-block\"><div class=\"form-block\"><md-input-container><label>{{\'bookings.currency\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"value.foreignCurrency\" ng-change=\"handleCurrencyChange()\" required=\"\"><md-option ng-repeat=\"currencyProfile in currencyProfiles\" ng-value=\"currencyProfile.code\">{{currencyProfile.code}}</md-option></md-select></md-input-container></div></div></div></div></md-content><div class=\"control-block text-left\"><md-button class=\"md-raised md-success\" ng-disabled=\"isLoading || roomEdit.$invalid\" ng-click=\"editForeignCurrencyRate()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isLoading\"></i> {{\'general.buttons.save\' | i18next}}</md-button><md-button class=\"md-raised md-button-cancel\" ng-click=\"cancelRoomEditing()\">{{\'general.buttons.cancel\' | i18next}}</md-button></div></form>");
$templateCache.put("templates/forgot_tpl.html","<div class=\"login-page\"><div class=\"row-fluid\"><div class=\"col-xs-12 login-page__right-block login-page__white-label\"><div class=\"login-page__header text-center\"><img ng-src=\"{{server_path+\'/api/public/v1/big_logo\'}}\" alt=\"{{domain_settings.name}}\"><p class=\"login-page__hero\">{{\'login.forgot_title\' | i18next}}</p></div><div class=\"container login-container card\" ng-if=\"!success\"><md-content layout-padding=\"\"><form class=\"form-signin ng-pristine ng-valid\" name=\"loginForm\" ng-submit=\"loginForm.$valid && send_request()\" role=\"form\" novalidate=\"\"><div class=\"login-wrap\"><div class=\"user-login-info\"><md-input-container class=\"md-block\"><label>{{\'general.other.email_address\' | i18next}}</label> <input ng-model=\"credentials.email\" name=\"email\" required=\"\" type=\"email\"></md-input-container><div class=\"error\" ng-show=\"error\">{{error}}</div></div><div class=\"text-center\"><md-button class=\"md-raised md-success\" type=\"submit\" ng-disabled=\"loading\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading\"></i> {{\'login.reset_password\' | i18next}}</md-button></div><div><a href=\"#/login\" class=\"pull-left\">{{\'login.have_account\' | i18next}}</a> <a href=\"#/signup\" class=\"pull-right\">{{\'login.sign_up\' | i18next}}</a></div></div></form></md-content></div><div class=\"login-container success-container text-center\" ng-if=\"success\"><p ng-bind-html=\"success_text\"></p><p>{{\'login.success_container.check_email\' | i18next}}</p><p>{{\'login.success_container.check_spam_box\' | i18next}}</p></div></div></div></div>");
$templateCache.put("templates/hotels_tpl.html","<br><br><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><legend class=\"header\">Hotels</legend><table class=\"table\"><thead><tr><th>Name</th><th>Slug</th><th>Status</th><th>Role</th><th>Corp</th><th class=\"text-right\">Actions</th></tr></thead><tbody><tr ng-repeat-start=\"hotel in hotels | orderBy:\'name\'\"><td>{{hotel.name}}</td><td>{{hotel.slug}}</td><td>{{hotel.status}}</td><td>{{hotel.role}}</td><td>{{hotel.corporateAccount}}</td><td class=\"text-right\"><a ng-click=\"inviteUser(hotel)\" ng-if=\"hotel.role == \'owner\'\">Invite User</a> <span ng-if=\"hotel.role == \'owner\'\">|</span> <a ng-click=\"showUsers(hotel)\" ng-if=\"hotel.role == \'owner\'\"><span ng-hide=\"hotel.displayUsers\">Show</span> <span ng-show=\"hotel.displayUsers\">Hide</span> Users</a> <span ng-if=\"hotel.role == \'owner\'\">|</span> <a ng-click=\"changeHotel(hotel)\">Switch to</a></td></tr><tr ng-repeat-end=\"\" ng-show=\"hotel.displayUsers\"><td colspan=\"6\"><strong>Hotel users:</strong><table class=\"table\"><tr ng-repeat=\"user in hotel.users\"><td>{{user.user_name}}</td><td>{{user.user_email}}</td><td>{{user.role}}</td><td class=\"text-right\"><a ng-click=\"editUser(hotel, user)\">Edit User</a> | <a ng-click=\"removeUserFromHotel(hotel, user)\">Remove</a></td></tr></table></td></tr></tbody></table><a ng-click=\"createNewHotel()\"><i class=\"fa fa-plus\"></i> Create new hotel</a></div></div>");
$templateCache.put("templates/import_tpl.html","<br><br><div class=\"row\" ng-show=\"inProgress == false\"><div class=\"col-md-6 col-md-offset-3\"><legend class=\"header\">Import</legend><label>Profile<select ng-model=\"profile\"><option value=\"\">System</option><option value=\"eviivo\">Eviivo</option><option value=\"royal_clarence\">Royal Clarence</option><option value=\"belle_nuit\">Belle Nuit</option><option value=\"wing_bed\">Wing Bed</option><option value=\"site_minder\">Site Minder</option><option value=\"ketawa\">Ketawa</option><option value=\"hs3_system\">HS3 System</option><option value=\"hotelogic\">Hotelogic</option><option value=\"myuktravel\">MyUKtravel</option><option value=\"beds24\">Beds24</option><option value=\"rms\">RMS</option><option value=\"hofstadir\">hofstadir</option></select><input type=\"file\" onchange=\"angular.element(this).scope().fileChoosed(event)\"> <button ng-click=\"import()\">Import</button></label></div></div><div class=\"row\" ng-show=\"inProgress == true\"><div class=\"col-md-12 text-center\">Import in progress, please wait.<br>This can take several minutes.<br>We show notification when finish.</div></div>");
$templateCache.put("templates/inventory_tpl.html","<div class=\"inventory fluid-container\"><div class=\"inventory-filters\"><legend>{{\'inventory.filters_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-1-5\"><md-input-container><label>{{\'inventory.restrictions_label\' | i18next}}</label><md-select ng-model=\"selectedRestrictions\" multiple=\"\" ng-change=\"applyFiltersForRestrictions()\"><md-option ng-repeat=\"restriction in restrictions\" ng-value=\"restriction.code\" ng-dblclick=\"chooseOneOption(\'selectedRestrictions\', restriction.code)\">{{restriction.representation}}</md-option></md-select></md-input-container></div><div class=\"col-xs-1-5\"><md-input-container><label>{{\'general.other.room_types\' | i18next}}</label><md-select ng-model=\"selectedRoomRepresentations\" multiple=\"\" ng-change=\"applyFiltersForRooms()\"><md-option ng-repeat=\"roomRepresentation in roomRepresentations\" ng-value=\"roomRepresentation.id\" ng-dblclick=\"chooseOneOption(\'selectedRoomRepresentations\', roomRepresentation.id)\">{{roomRepresentation.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-1-5\"><md-input-container><label>{{\'general.other.rate_categories\' | i18next}}</label><md-select ng-model=\"selectedRateCategories\" multiple=\"\" ng-change=\"applyFiltersForRooms()\"><md-option ng-repeat=\"rateCategory in rateCategories\" ng-value=\"rateCategory.id\" ng-dblclick=\"chooseOneOption(\'selectedRateCategories\', rateCategory.id)\">{{rateCategory.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-1-5\"><div class=\"form-block date-col\"><label class=\"datepicker\">{{\'inventory.start_from_label\' | i18next}}</label><md-datepicker ng-model=\"startDate\" ng-change=\"updateStartDate()\" md-min-date=\"minDate\"></md-datepicker></div></div><div class=\"col-xs-1-5\"><md-input-container><label>{{\'inventory.number_of_days_label\' | i18next}}</label> <input ng-model=\"selectedDaysInRange\" type=\"number\" min=\"0\" ng-change=\"updateDates()\"></md-input-container></div></div></div><div class=\"inventory-table\" ng-if=\"loaded\"><table class=\"table\"><thead><tr><th rowspan=\"2\" class=\"col-xs-2\">{{\'general.other.room_types\' | i18next}}</th><th rowspan=\"2\" class=\"col-xs-1\">{{\'general.other.restriction\' | i18next}}</th><th colspan=\"{{daysInRange}}\" class=\"text-center col-xs-9\"><i class=\"fa fa-arrow-left pull-left\" tooltip=\"{{\'inventory.previous_dates_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"prevDates()\"></i> <i class=\"fa fa-arrow-right pull-right\" tooltip=\"{{\'inventory.next_dates_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"nextDates()\"></i> {{\'inventory.dates_th\' | i18next}}</th></tr><tr><th ng-repeat=\"date in dates track by date.ISODate\" class=\"text-center dateColumnHeader\"><span ng-bind-html=\"date.representation\"></span><div class=\"seasonHeighlighter\" style=\"background-color: #{{date.seasonColor}}\" tooltip=\"{{date.seasonTitle}}\" tooltip-append-to-body=\"true\"></div></th></tr></thead><tbody><tr class=\"roomRepresentation-header roomRepresentation-header__hotel\"><td><strong>{{\'inventory.hotel_td\' | i18next}}</strong></td><td>{{\'general.other.occupancy\' | i18next}}</td><td ng-repeat=\"date in dates track by date.ISODate\" class=\"text-center value-column\" style=\"background-color: {{occupancy[date.ISODate].color}}\">{{occupancy[date.ISODate].value}}%</td></tr><tr ng-repeat-start=\"roomRepresentation in filteredRoomRepresentations track by roomRepresentation.id\" class=\"roomRepresentation-header\"><td><strong>{{roomRepresentation.title}}</strong> <span class=\"label label-primary\" ng-if=\"roomRepresentation.virtualRoom\">{{\'inventory.virtual_room_td\' | i18next}}</span></td><td>{{\'general.other.availability\' | i18next}}</td><td ng-repeat=\"date in dates track by date.ISODate\" class=\"text-center restriction-block restriction-block-availability\" ng-class=\"{ \'restriction-block__changed\': restrictionValues[roomRepresentation.roomRates[0].id][date.ISODate][\'availabilityIsChanged\'] == true, \'restriction-block__custom\': restrictionValues[roomRepresentation.roomRates[0].id][date.ISODate][\'availabilityIsCustom\'] == true }\" style=\"background-color: {{occupancyPerRoomRepresentation[date.ISODate][roomRepresentation.id].color}}\"><input type=\"number\" class=\"form-control\" ng-model=\"restrictionValues[roomRepresentation.roomRates[0].id][date.ISODate].availability\" ng-disabled=\"!manualOverrideIsEnabled || date.date < today\" ng-change=\"changeRestriction(restrictionValues[roomRepresentation.roomRates[0].id][date.ISODate], \'availability\')\"> <i class=\"fa fa-times remove-custom-value\" tooltip=\"{{\'inventory.remove_custom_value_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"removeCustomValue(roomRepresentation.roomRates[0].id, date.ISODate, \'availability\')\"></i></td></tr><tr ng-class=\"{\'primary_rate\' : roomRate.parentRoomRateId == null && roomRate.isCalculatedRate == false}\" ng-repeat=\"roomRate in roomRepresentation.filteredRoomRates track by roomRate.id\" ng-repeat-end=\"\"><td class=\"roomRateHeader\"><div class=\"roomRateHeader__title\">{{rateCategories[roomRate.rateCategoryId].name}}</div><div class=\"additional-info\"><span class=\"shortCode\">{{roomRate.shortCode}}</span> <i class=\"fa fa-chain\" tooltip=\"{{\'inventory.chained_rate_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"roomRate.parentRoomRateId\"></i> <i class=\"fa fa-calculator\" tooltip=\"{{\'inventory.calculated_rate_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"roomRate.isCalculatedRate\"></i> &nbsp; <i class=\"fa fa-user\" tooltip=\"{{\'inventory.max_count_of_adults_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\" tooltip=\"{{\'inventory.max_count_of_children_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> {{roomRate.maxChildren}}</div></td><td class=\"restriction-column\"><div class=\"restriction-block restriction-block-title\" ng-repeat=\"restriction in filteredRestrictions track by restriction.code\">{{restriction.representation}}</div></td><td class=\"text-center restriction-column\" ng-repeat=\"date in dates track by date.ISODate\"><div ng-repeat=\"restriction in filteredRestrictions track by restriction.code\" class=\"restriction-block\" ng-class=\"{ \'restriction-block__changed\': restrictionValues[roomRate.id][date.ISODate][restriction.camelCaseCode+\'IsChanged\'] == true, \'restriction-block__custom\': restrictionValues[roomRate.id][date.ISODate][restriction.camelCaseCode+\'IsCustom\'] == true }\"><input type=\"{{restriction.type}}\" class=\"form-control\" ng-disabled=\"date.date < today\" ng-model=\"restrictionValues[roomRate.id][date.ISODate][restriction.camelCaseCode]\" ng-change=\"changeRestriction(restrictionValues[roomRate.id][date.ISODate], restriction)\"> <i class=\"fa fa-times remove-custom-value\" tooltip=\"{{\'inventory.remove_custom_value_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"removeCustomValue(roomRate.id, date.ISODate, restriction.code)\"></i></div></td></tr></tbody></table></div><div class=\"inventory-toolbar\"><div class=\"row\"><div class=\"col-xs-6\"><md-checkbox ng-model=\"showOnlyRatePlans\" aria-label=\"Only Rate Plans\" ng-change=\"applyFiltersForRooms()\">{{\'inventory.hide_derived_rate_plans_checkbox\' | i18next}}</md-checkbox><md-checkbox ng-model=\"manualOverrideIsEnabled\" aria-label=\"Manual Override Enabled\">{{\'inventory.manual_availability_override_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-6 text-right\"><md-button class=\"md-raised md-primary\" ng-disabled=\"eraseInProgress\" ng-click=\"eraseManualChanges()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : eraseInProgress}\" ng-hide=\"!eraseInProgress\"></i> {{\'inventory.erase_manual_changes_button\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"resetInProgress\" ng-click=\"resetChanges()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : resetInProgress}\" ng-hide=\"!resetInProgress\"></i> {{\'inventory.reset_changes_button\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"saveInProgress\" ng-click=\"saveChanges()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : saveInProgress}\" ng-hide=\"!saveInProgress\"></i> {{\'inventory.save_changes_button\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/inviteUserModal_tpl.html","<md-dialog aria-label=\"invite user\" ng-cloak=\"\"><form name=\"inviteUser\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Invite User</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Email</label> <input type=\"email\" ng-model=\"email\" name=\"email\" required=\"\" autofocus=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Username</label> <input type=\"text\" ng-model=\"name\" name=\"name\" required=\"\"></md-input-container><md-input-container class=\"md-block\"><label>Role</label><md-select ng-model=\"role\" required=\"\"><md-option value=\"manager\">Manager</md-option><md-option value=\"reception\">Reception</md-option><md-option value=\"reception_no_finance\">Reception (No Finance)</md-option><md-option value=\"housekeeper\">Housekeeper</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-disabled=\"inviteUser.$invalid || saving == true\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-show=\"saving\" ng-class=\"{\'fa-spin\':saving == true}\"></i> Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/keyLocksEdit_tpl.html","<form class=\"form-horizontal booking-form ng-pristine\" name=\"roomEdit\" novalidate=\"\"><div class=\"fields\"><legend style=\"border-bottom: 0;\">{{\'key_locks.legend\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"loading_room_keys\" ng-class=\"{\'fa-spin\' : true}\"></i></legend><table class=\"table table-striped\"><thead><tr><th>{{\'general.other.guest_name\' | i18next}}</th><th>{{\"general.other.email_address\" | i18next}}</th><th>{{\'general.other.phone_number\' | i18next}}</th><th>Key code</th></tr></thead><tbody><tr ng-if=\"room_keys[edited_room.id]\" ng-repeat=\"key in room_keys[edited_room.id]\"><td>{{key.name}}</td><td>{{key.email}}</td><td>{{key.phone}}</td><td>{{key.key_code}}</td></tr></tbody></table></div><div class=\"control-block text-left\"><md-button class=\"md-raised md-success\" ng-disabled=\"creatingRoomKey\" ng-click=\"createBookingRoomKey()\">{{\'key_locks.create\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"creatingRoomKey\" ng-class=\"{\'fa-spin\' : true}\"></i></md-button><md-button class=\"md-raised md-button-cancel\" ng-click=\"closeDisplayRoomKeys()\">{{\'general.buttons.close\' | i18next}}</md-button></div></form>");
$templateCache.put("templates/login_tpl.html","<div class=\"login-page\" ng-class=\"{\'login-page-mobile\':is_mobile}\"><div class=\"row-fluid\"><div class=\"col-xs-12 login-page__right-block login-page__white-label\"><div class=\"login-page__header text-center\"><img ng-src=\"{{server_path+\'/api/public/v1/big_logo\'}}\" alt=\"{{domain_settings.name}}\"><p class=\"login-page__hero\">{{\'login.sign_in_title\' | i18next}}</p><p class=\"login-page__small\" ng-if=\"is_white_label == false\">{{\'login.sign_in_small\' | i18next}}</p><p class=\"login-page__small\" ng-if=\"is_white_label == true\">{{\'login.sign_in_small_white_label\' | i18next}}</p></div><div class=\"container login-container card\" ng-if=\"isChromium() || letMeInAccepted === true\"><md-content layout-padding=\"\" style=\"padding: 40px 8px 8px 8px;\"><form class=\"form-signin ng-pristine ng-valid\" name=\"loginForm\" ng-submit=\"loginForm.$valid && login()\" role=\"form\" novalidate=\"\"><div class=\"login-wrap\"><div class=\"user-login-info\"><div ng-show=\"otpInputActive\"><p>{{\'login.otp_instructions\' | i18next}}</p><md-input-container class=\"md-block\"><label>{{\'general.other.otp\' | i18next}}</label> <input ng-model=\"credentials.otp\" name=\"otp\" type=\"otp\"></md-input-container><md-input-container class=\"md-block\" ng-hide=\"true\"><label>{{\'general.other.otpClientChallenge\' | i18next}}</label> <input ng-model=\"credentials.otpClientChallenge\" name=\"otpClientChallenge\" type=\"otpClientChallenge\"></md-input-container></div><div ng-hide=\"otpInputActive\"><md-input-container class=\"md-block\"><label>{{\'general.other.email_address\' | i18next}}</label> <input ng-model=\"credentials.email\" name=\"email\" required=\"\" type=\"email\"></md-input-container><md-input-container class=\"md-block\"><label>{{\'login.password_label\' | i18next}}</label> <input ng-model=\"credentials.password\" name=\"password\" required=\"\" type=\"password\"></md-input-container><md-checkbox ng-model=\"credentials.remember_me\" name=\"remember_me\" aria-label=\"{{\'login.remember_me\' | i18next}}\">{{\'login.remember_me\' | i18next}}</md-checkbox></div><recaptcha-label><div class=\"error\" ng-show=\"error\">{{error}}</div></recaptcha-label></div><div class=\"text-center\"><md-button class=\"md-raised md-success\" type=\"submit\" ng-disabled=\"loading\">{{\'login.sign_in\' | i18next}} <i class=\"fa fa-spinner fa-spin\" ng-show=\"loading\"></i></md-button></div><div><a href=\"#/forgot\" class=\"pull-left\">{{\'login.forgot_password\' | i18next}}</a> <a href=\"#/signup\" class=\"pull-right\">{{\'login.sign_up\' | i18next}}</a></div></div></form></md-content></div><div class=\"container login-container card text-center\" ng-if=\"!isChromium() && letMeInAccepted === false\"><h1>{{\'login.warning_container.title\' | i18next}}</h1><p>{{\'login.warning_container.paragraph_best_results\' | i18next}}<br><a href=\"https://www.google.com/chrome/\" target=\"_blank\">{{\'login.warning_container.paragraph_link_chrome\' | i18next}}</a></p><img class=\"chrome-logo\" src=\"images/chrome.png\"><br><a class=\"let-me-in\" ng-click=\"letMeIn()\">{{\'login.warning_container.link_let_me\' | i18next}}</a></div></div></div></div>");
$templateCache.put("templates/metrics_tpl.html","<div class=\"charts-metrics\"><div class=\"row\"><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-01.png\"></a></div><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-02.png\"></a></div><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-03.png\"></a></div></div><div class=\"row\"><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-04.png\"></a></div><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-05.png\"></a></div><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-06.png\"></a></div></div><div class=\"row\"><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-07.png\"></a></div><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-08.png\"></a></div><div class=\"col-md-4\"><a href=\"#/metrics/chart\"><img src=\"images/charts/chart-09.png\"></a></div></div></div>");
$templateCache.put("templates/new_inventory_tpl.html","<div class=\"inventory fluid-container\"><div class=\"inventoryDatePicker\"><div class=\"form-block date-col\"><label class=\"datepicker\">{{\'inventory.new_inventory.start_from_label\' | i18next}}</label><md-datepicker ng-model=\"startDate\" ng-change=\"updateStartDate()\" md-min-date=\"minDate\"></md-datepicker></div></div><div id=\"inventory-table\"></div><div><custom-logs $i18next=\"$i18next.i18n\" logs=\"logProps.logs\" is-loading=\"logProps.logsIsLoading\" on-load-logs=\"onLoadLogs\" total=\"logProps.total\" open-trigger=\"logProps.openDrawerTrigger\"></custom-logs></div><div class=\"inventory-filters inventory-collapsable-filers\" ng-show=\"filtersIsVisible === true\"><div class=\"row\"><div class=\"col-xs-3\" ng-class=\"{\'col-xs-4\' : !showAllInventoryRoomTypes}\"><md-input-container><label>{{\'inventory.new_inventory.restrictions_label\' | i18next}}</label><md-select ng-model=\"selectedRestrictions\" multiple=\"\" ng-change=\"applyFiltersForRestrictions()\" ng-disabled=\"isAvailabilityBlock\"><md-option ng-repeat=\"restriction in restrictions\" ng-value=\"restriction.code\" ng-dblclick=\"chooseOneOption(\'selectedRestrictions\', restriction.code)\">{{\'general.restrictions.\' + restriction.representation | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-show=\"showAllInventoryRoomTypes\"><md-input-container><label>{{\'general.other.room_types\' | i18next}}</label><md-select ng-model=\"selectedRoomRepresentations\" multiple=\"\" ng-change=\"applyFiltersForRooms()\"><md-option ng-repeat=\"roomRepresentation in roomRepresentations\" ng-value=\"roomRepresentation.id\" ng-dblclick=\"chooseOneOption(\'selectedRoomRepresentations\', roomRepresentation.id)\">{{roomRepresentation.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-class=\"{\'col-xs-4\' : !showAllInventoryRoomTypes}\"><md-input-container><label>{{\'general.other.rate_categories\' | i18next}}</label><md-select ng-model=\"selectedRateCategories\" multiple=\"\" ng-change=\"applyFiltersForRooms()\" ng-disabled=\"isAvailabilityBlock\"><md-option ng-repeat=\"rateCategory in rateCategories\" ng-value=\"rateCategory.id\" ng-dblclick=\"chooseOneOption(\'selectedRateCategories\', rateCategory.id)\">{{rateCategory.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3 inventory-filters__checkbox\" ng-class=\"{\'col-xs-4\' : !showAllInventoryRoomTypes}\"><md-checkbox ng-model=\"showOnlyRatePlans\" aria-label=\"{{\'inventory.new_inventory.only_rate_plans_aria_label\' | i18next}}\" ng-change=\"applyFiltersForRooms()\">{{\'inventory.new_inventory.hide_derived_rate_plans_checkbox\' | i18next}}</md-checkbox></div></div></div><div class=\"inventory-toolbar\"><div class=\"row\"><div class=\"col-xs-4\" ng-class=\"{\'col-md-6\' : !showAllInventoryRoomTypes}\"><div ng-show=\"!showAllInventoryRoomTypes\" class=\"selectedRoomRepresentationWrap\"><md-input-container class=\"selectSpecificRoomType\"><label>{{\'general.other.selected_room_type\' | i18next}}</label><md-select ng-model=\"selectedRoomRepresentation\" ng-change=\"applyFiltersForRooms()\"><md-option ng-repeat=\"roomRepresentation in roomRepresentations\" ng-value=\"roomRepresentation.id\">{{roomRepresentation.title}}</md-option></md-select></md-input-container></div><span class=\"inventory-filter-title\" ng-click=\"toggleFilters()\"><i class=\"fa fa-caret-right\" ng-if=\"filtersIsVisible == false\"></i> <i class=\"fa fa-caret-up\" ng-if=\"filtersIsVisible == true\"></i> {{\'inventory.new_inventory.filters_span\' | i18next}}</span> &nbsp;&nbsp;<md-checkbox ng-model=\"manualOverrideIsEnabled\" aria-label=\"{{\'general.aria_labels.manual_override_enabled\' | i18next}}\" ng-change=\"toggleManualOverride()\">{{\'inventory.new_inventory.manual_availability_override_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-8 text-right\" ng-class=\"{\'col-md-6\' : !showAllInventoryRoomTypes}\"><md-button class=\"md-raised md-primary\" ng-click=\"toggleLogsButton()\">{{\'inventory.show_logs_link\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"bulkSaveInProgress\" ng-click=\"openBulkDialog()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : bulkSaveInProgress}\" ng-hide=\"!bulkSaveInProgress\"></i> {{\'inventory.bulk_update_button\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"eraseInProgress\" ng-click=\"eraseManualChanges()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : eraseInProgress}\" ng-hide=\"!eraseInProgress\"></i> {{\'inventory.erase_manual_changes_button\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"resetInProgress\" ng-click=\"resetChanges()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : resetInProgress}\" ng-hide=\"!resetInProgress\"></i> {{\'inventory.reset_changes_button\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"saveInProgress\" ng-click=\"saveChanges()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : saveInProgress}\" ng-hide=\"!saveInProgress\"></i> {{\'inventory.save_changes_button\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/old_inventory_tpl.html","<md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"active_page\" class=\"inventory-tabs\" ng-class=\"calcTabClass()\"><md-tab label=\"Close Out\"><md-content class=\"md-padding\" ng-show=\"active_page_name === \'closeout\'\"><div ng-if=\"active_page_name === \'closeout\'\"><ng-include src=\"\'templates/inventory/closeout_tpl.html\'\"></ng-include></div></md-content></md-tab></md-tabs>");
$templateCache.put("templates/plugin_tpl.html","<div class=\"plugin\"><iframe ng-src=\"{{trustSrc(plugin.url)}}\"></iframe></div>");
$templateCache.put("templates/profile_tpl.html","<div id=\"react-app__profile\"></div>");
$templateCache.put("templates/recaptcha_label_tpl.html","<div><label>This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\" target=\"_blank\" rel=\"noopener noreferrer\">Terms of Service</a> apply.</label></div>");
$templateCache.put("templates/reports_tpl.html","<div class=\"report-content\"><div ng-include=\"template\"></div></div><ui-prompt-notes id=\"booking-notes\" class=\"buuqit-modal-wrapper\"></ui-prompt-notes>");
$templateCache.put("templates/roomBlockerModal_tpl.html","<md-dialog aria-label=\"{{\'bookings.block_room_modal.block_room_title\' | i18next}}\" ng-cloak=\"\"><form name=\"createRoomBlocker\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'bookings.block_room_modal.block_room_title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"form-group has-error\" ng-hide=\"blocker.available\"><div class=\"col-xs-12\"><p class=\"help-block\">{{\'bookings.block_room_modal.room_is_not_available_for_text\' | i18next}}</p></div></div><div class=\"col-xs-6 date-col\"><label>{{\'bookings.block_room_modal.date_from_label\' | i18next}}</label><md-datepicker ng-model=\"blocker.dateFromTMP\" md-placeholder=\"Date from\" ng-change=\"change()\" md-min-date=\"prevDay\" md-max-date=\"maxDate\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'bookings.block_room_modal.date_to_label\' | i18next}}</label><md-datepicker ng-model=\"blocker.dateToTMP\" md-placeholder=\"Date to\" ng-change=\"change()\" md-min-date=\"blocker.minDateTo\" md-max-date=\"maxForMaxDate\"></md-datepicker></div><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.room\' | i18next}}</label><md-select ng-model=\"blocker.roomId\" ng-change=\"change()\" required=\"\"><md-option ng-repeat=\"room in not_blocker_rooms\" ng-value=\"{{room.id}}\">{{room.number}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12\"><md-input-container class=\"md-block\"><label>{{\'bookings.block_room_modal.reason_label\' | i18next}}</label> <textarea ng-model=\"blocker.reason\" md-maxlength=\"255\" columns=\"1\" name=\"reason\" required=\"\"></textarea></md-input-container></div><div class=\"col-xs-12\" ng-if=\"user.systemRole == \'admin\' || user.aclRole == \'manager\' || user.aclRole == \'owner\'\">Created At: {{blocker.createdAt | dateToMoment:\"ddd, D MMM YYYY HH:mm\"}} (UTC: {{blocker.createdAt | dateToMoment:\"HH:mm\":\"UTC\"}})<br>Updated At: {{blocker.updatedAt | dateToMoment:\"ddd, D MMM YYYY HH:mm\"}} (UTC: {{blocker.updatedAt | dateToMoment:\"HH:mm\":\"UTC\"}})<br></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-warn\" ng-show=\"blocker.id\" ng-click=\"remove()\">{{\'general.buttons.clear\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-disabled=\"createRoomBlocker.$invalid\" ng-click=\"save()\">{{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/roomEdit_tpl.html","<form class=\"form-horizontal booking-form\" name=\"roomEdit\" novalidate=\"\"><md-content md-theme=\"docs-dark\"><div class=\"dark form-zone\"><legend>{{\'bookings.room_edit.room_details_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12 col-md-4 form-block\"><div class=\"form-block date-col\"><label class=\"datepicker\"><i class=\"fa fa-arrow-down\"></i> {{\'bookings.room_edit.check_in_date_datepicker_label\' | i18next}}</label><md-datepicker ng-model=\"value.checkinDate\" ng-change=\"dateInChanged()\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"form-block date-col\"><label class=\"datepicker\"><i class=\"fa fa-arrow-up\"></i> {{\'bookings.room_edit.check_out_date_datepicker_label\' | i18next}}</label><md-datepicker ng-model=\"value.checkoutDate\" ng-change=\"dateOutChanged(value.checkoutDate)\" md-min-date=\"value.min_checkout_date\" md-max-date=\"value.max_checkout_date\" md-theme=\"docs-dark\"></md-datepicker></div><div><div class=\"half form-block\"><md-input-container><label><i class=\"fa fa-moon-o\"></i> {{\'general.other.nights\' | i18next}}</label><md-select ng-model=\"value.numberOfNights\" ng-change=\"changeRoom(\'numberOfNights\')\" md-theme=\"docs-dark\"><md-option ng-repeat=\"night in value.nights_select\" value=\"{{night}}\">{{night}}</md-option></md-select></md-input-container></div><div class=\"half form-block\"><md-input-container><label><i class=\"fa fa-clock-o\"></i> {{\'general.other.arrival\' | i18next}}</label><md-select ng-model=\"value.checkinTime\" md-theme=\"docs-dark\"><md-option></md-option><md-option ng-repeat=\"time in times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container></div><div class=\"clearfix\"></div></div></div><div class=\"col-xs-12 col-md-4 form-block\"><div><md-input-container><label>{{\'bookings.room_edit.available_room_rate_select_label\' | i18next}}</label><md-select ng-model=\"value.rate_select\" ng-change=\"changeRoom(\'rate\')\" required=\"\" md-theme=\"docs-dark\" ng-disabled=\"value.occupationStatus != \'pending\'\"><md-option ng-repeat=\"rate in getRates()\" ng-value=\"rate\" ng-selected=\"rate.id == value.rate_select.id\" ng-class=\"{\'unapplicable\' : rate.applicable == 0}\">{{rate.name}} <span ng-if=\"rate.applicable == 0\">({{\'bookings.create_booking.booking_form.restrictions_does_not_match\' | i18next}})</span></md-option></md-select></md-input-container></div><div><md-input-container><label>{{\'bookings.room_edit.available_room_type_select_label\' | i18next}}</label><md-select ng-model=\"value.coverRoomType\" ng-change=\"changeRoom(\'roomType\')\" required=\"\" md-theme=\"docs-dark\" class=\"error-forced\" ng-disabled=\"((value.dontMove && value.id) || value.occupationStatus != \'pending\')\"><md-option ng-repeat=\"type in (cover_room_types | filter:notBlockedRoomTypesFilter)\" ng-value=\"type\" ng-selected=\"type.id == value.coverRoomType.id\">{{type.title}}</md-option></md-select></md-input-container></div><div><md-input-container><label>{{\'bookings.room_edit.room_selection_select_label\' | i18next}}</label><md-select ng-model=\"value.roomId\" ng-change=\"changeRoom(\'roomSelect\')\" required=\"\" md-theme=\"docs-dark\" class=\"error-forced\" ng-disabled=\"((value.dontMove && value.id) || value.occupationStatus != \'pending\')\"><md-option ng-repeat=\"room in getRooms(rooms)\" value=\"{{room.id}}\" ng-class=\"{\'unapplicable\' : room.applicable == 0}\">{{room.number}} <span ng-if=\"room.applicable == 0\">({{room_types_by_id[room.roomTypeId].name}})</span></md-option></md-select></md-input-container></div></div><div class=\"col-xs-12 col-md-4 form-block\"><div><div class=\"half form-block\"><md-input-container><label><i class=\"fa fa-male\"></i> {{\'bookings.room_edit.adults_select_label\' | i18next}} {{\'general.other.max\' | i18next}} {{recomendedMaxAdults}}</label><md-select ng-model=\"value.numberOfAdults\" ng-change=\"changeRoom(\'rate\')\" md-theme=\"docs-dark\" ng-disabled=\"value.occupationStatus != \'pending\'\"><md-option ng-repeat=\"adult in adults_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"half form-block\"><md-input-container><label><i class=\"fa fa-child\"></i> {{\'general.other.children\' | i18next}} {{\'general.other.max\' | i18next}} {{recomendedMaxChildren}}</label><md-select ng-model=\"value.numberOfChildren\" ng-change=\"changeRoom(\'rate\')\" md-theme=\"docs-dark\" ng-disabled=\"value.occupationStatus != \'pending\'\"><md-option ng-repeat=\"adult in child_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"clearfix\"></div></div><div><md-checkbox ng-model=\"value.dontMove\" aria-label=\"{{\'bookings.room_edit.do_not_move_checkbox\' | i18next}}\">{{\'bookings.room_edit.do_not_move_checkbox\' | i18next}}</md-checkbox></div><div><md-input-container><label>{{\'general.other.cancellation_policy\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"value.cancellationPolicyId\" required=\"\" ng-change=\"setCustomPolicy(value)\"><md-option ng-repeat=\"policy in policies\" value=\"{{policy.id}}\">{{policy.title}}</md-option></md-select></md-input-container><div class=\"bookingRoomEdit__resetToDefaultPolicy\" ng-if=\"value.cancellationPolicyIsCustom\"><a ng-click=\"resetCancellationPolicy(value)\">{{\'bookings.room_edit.reset_to_default_policy\' | i18next}}</a></div></div></div></div></div></md-content><div class=\"grey\"><div class=\"nights\"><legend>{{\'general.other.price_per_night\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loadNights}\" ng-show=\"loadNights\"></i></legend><button class=\"btn btn-default btn--m btn--raised btn--grey pull-right btn-sm btn-reset\" xl-ripple=\"\" ng-click=\"resetNightPrices()\">{{\'bookings.room_edit.reset_prices_button\' | i18next}}</button><div class=\"row\"><div class=\"night form-block\" ng-repeat=\"night in value.nights | orderBy:\'date\'\"><md-input-container ng-if=\"value.isForeignAmount\" md-theme=\"docs-dark\"><label>{{night.date | dateToMoment : \'ddd D\'}}</label> <input type=\"number\" ng-class=\"{\'currency\': currencySymbol && currencySymbol.length < 2}\" ng-model=\"night.foreignAmount\" min=\"0\" ng-change=\"calcTotalPerRoom()\" onclick=\"this.select()\"> <span class=\"currency-char\" ng-if=\"currencySymbol && currencySymbol.length < 2\">{{currencySymbol}}</span></md-input-container><md-input-container ng-if=\"!value.isForeignAmount\" md-theme=\"docs-dark\"><label>{{night.date | dateToMoment : \'ddd D\'}}</label> <input type=\"number\" ng-class=\"{\'currency\': currencySymbol && currencySymbol.length < 2}\" ng-model=\"night.price\" min=\"0\" ng-change=\"calcTotalPerRoom()\" onclick=\"this.select()\"> <span class=\"currency-char\" ng-if=\"currencySymbol && currencySymbol.length < 2\">{{currencySymbol}}</span></md-input-container></div></div></div><div class=\"total\"><md-input-container ng-if=\"value.isForeignAmount\" md-theme=\"docs-dark\"><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': currencySymbol && currencySymbol.length < 2}\" ng-model=\"value.total_foreign_amount\" name=\"totalPrice{{value.id}}\" min=\"0\" ng-change=\"recalcNightsFromForeignTotal()\" onclick=\"this.select()\"> <span class=\"currency-char\" ng-if=\"currencySymbol && currencySymbol.length < 2\">{{currencySymbol}}</span></md-input-container><md-input-container ng-if=\"!value.isForeignAmount\" md-theme=\"docs-dark\"><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': currencySymbol && currencySymbol.length < 2}\" ng-model=\"value.total_price\" name=\"totalPrice{{value.id}}\" min=\"0\" ng-change=\"recalcNightsFromTotal()\" onclick=\"this.select()\"> <span class=\"currency-char\" ng-if=\"currencySymbol && currencySymbol.length < 2\">{{currencySymbol}}</span></md-input-container></div></div><div class=\"fields\"><legend>{{\'bookings.room_edit.guest_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12 col-md-6 form-block\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-min-length=\"2\" md-search-text=\"value.guest.firstName\" md-items=\"item in searchGuest(\'firstName\')\" md-item-text=\"item.first_name\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"900\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.first_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-12 col-md-6 form-block\"><md-autocomplete flex=\"\" ng-required=\"true\" md-input-minlength=\"1\" md-min-length=\"2\" md-search-text=\"value.guest.lastName\" md-items=\"item in searchGuest(\'lastName\')\" md-item-text=\"item.last_name\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"900\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.last_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 form-block\"><div class=\"form-block\"><md-autocomplete flex=\"\" md-input-minlength=\"2\" md-search-text=\"value.guest.email\" md-items=\"item in searchGuest(\'email\')\" md-item-text=\"item.email\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"900\" md-input-name=\"guestEmail\" md-input-class=\"{\'md-input-invalid\': roomEdit.guestEmail.$touched && roomEdit.guestEmail.$error.emailFormat}\" md-floating-label=\"{{\'bookings.create_booking.autocomplete.email_floating_label\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template><div ng-messages=\"roomEdit.guestEmail.$error\" ng-if=\"roomEdit.guestEmail.$touched && roomEdit.guestEmail.$error.emailFormat\"><div class=\"error-message\" ng-message=\"emailFormat\">{{\'general.email_invalid\' | i18next}}</div></div></md-autocomplete></div></div><div class=\"col-xs-12 col-md-6 form-block\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-search-text=\"value.guest.phone\" md-items=\"item in searchGuest(\'phone\')\" md-item-text=\"item.mobile_phone\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"900\" md-floating-label=\"{{\'general.other.phone_number\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row\"><div class=\"col-xs-12 form-block\"><md-input-container><label><i class=\"fa fa-comment\"></i> {{\'bookings.room_edit.guest_request_label\' | i18next}}</label> <input type=\"text\" ng-model=\"value.note\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12 form-block\"><md-input-container><label><i class=\"fa fa-comment\"></i> {{\'bookings.room_edit.housekeeping_notes_label\' | i18next}}</label> <input type=\"text\" ng-model=\"value.housekeepingNote\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12 icon-selector\"><label class=\"mobile-label\">Icon</label><md-input-container><label>Icon</label> <i ng-repeat=\"icon in icon_choices\" ng-class=\"icon_class(icon)\" data-icon-name=\"{{icon}}\" ng-click=\"set_icon($event)\"></i></md-input-container></div></div></div><div class=\"control-block\" ng-if=\"value.cancellationPolicyDescription\"><strong>{{\'general.other.cancellation_policy\' | i18next}}</strong><br>{{value.cancellationPolicyDescription}}</div><div class=\"control-block text-left\"><md-button class=\"md-raised md-success\" ng-disabled=\"canBeSaved()\" ng-click=\"finishFolioRoomEditing()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button><md-button class=\"md-raised md-button-cancel\" ng-click=\"cancelRoomEditing()\">{{\'general.buttons.cancel\' | i18next}}</md-button></div></form>");
$templateCache.put("templates/scheduler_tpl.html","<div class=\"scheduler\" zoom-control=\"\" scheduler-selector=\"\"><div class=\"loader\" ng-hide=\"calendarReady\"></div><div id=\"scheduler\" scheduler-body=\"\"><div class=\"navigation-arrow arrow-left\" ng-click=\"moveCalendar(-1)\"><i class=\"fa fa-angle-left\"></i></div><div class=\"navigation-arrow arrow-right\" ng-click=\"moveCalendar(1)\"><i class=\"fa fa-angle-right\"></i></div><div><div id=\"scheduler-header\"><div class=\"content-header\"><div class=\"content-header-inner\"><div class=\"scheduler-left\"><div class=\"date-select\"><i class=\"fa fa-calendar calendar-datepicker-button\"></i> <span class=\"today-text\">Date</span>&nbsp;<md-datepicker ng-model=\"selectedDate\" ng-change=\"gotoSelectedDate()\"></md-datepicker></div><div class=\"zoom-control\"><button ng-click=\"zoomIn()\"><i class=\"fa fa-plus\"></i></button> <button ng-click=\"zoomOut()\"><i class=\"fa fa-minus\"></i></button></div></div><div class=\"scheduler-right\"><div class=\"columns-container\" header-columns=\"\"></div></div></div></div></div></div><div><div id=\"scheduler-body\"><div class=\"content-slots\"><div class=\"scheduler-left\"><div class=\"rooms\"><div class=\"room-info\" ng-class=\"{short: getShortClass(room), hovered: room.id === hoveredRoomRow}\" ng-mouseover=\"unsetHoveredRoomRow()\" ng-repeat=\"room in rooms track by $index | orderBy:\'position\'\"><strong>{{room.number}}</strong><br><span>{{getRoomType(room.roomTypeId)}}</span><div class=\"add-note\" ng-hide=\"room.note\"><a href=\"\" ng-click=\"addRoomNote($event, room)\" tooltip=\"Add Room Note\" tooltip-append-to-body=\"true\"><i class=\"fa fa-edit\"></i></a></div><div class=\"note\" ng-show=\"room.note\"><i class=\"fa fa-asterisk\" popover=\"{{room.note}}\" popover-append-to-body=\"true\" popover-placement=\"right\" popover-trigger=\"mouseenter\" ng-click=\"addRoomNote($event, room)\"></i></div></div><div class=\"separator\"></div><div class=\"holded-rooms room-info\" style=\"height: {{holdHeight}}px\">Holding area</div><div class=\"separator\"></div><div class=\"canceled-rooms room-info\" style=\"height: {{cancelHeight}}px\">Canceled rooms</div></div></div><div class=\"scheduler-right calendar-zone\" header-scroller=\"\" context-menu=\"openContextMenu($event)\" data-target=\"ContextMenu\"><div class=\"columns-container\" columns-container=\"\"></div><div class=\"bookings-container\" blocker-renderer=\"\" booking-renderer=\"\"><div class=\"booking-handler\"></div></div></div></div></div></div></div><div class=\"popover top\" id=\"scheduler-popover\"><div class=\"arrow\"></div><div class=\"popover-content\">Some content</div></div><div class=\"dropdown position-fixed context-menu\" id=\"ContextMenu\" ng-show=\"hasAccess(\'schedulerRightClickMenu\')\"><ul class=\"dropdown-menu\" role=\"menu\" ng-click=\"hideContextMenu($event)\"><li ng-show=\"contextMenuTarget == \'room-slot\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"openRoomBlockerModal()\">Block room</a></li><li ng-show=\"contextMenuTarget == \'room-slot\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"prepareNewBooking()\">Create Booking</a></li><li ng-show=\"contextMenuTarget == \'blocker\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"openBlockerManagementModal($event)\">Manage block</a></li><li ng-show=\"contextMenuTarget == \'blocker\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"removeBlocker()\">Remove block</a></li><li ng-show=\"bookingContextMenuOptions.checkin && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"1\" ng-click=\"checkin()\">Check-in</a></li><li ng-show=\"bookingContextMenuOptions.cancel_checkin && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"2\" ng-click=\"cancel_checkin()\">Cancel Check-in</a></li><li ng-show=\"bookingContextMenuOptions.checkout && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" ng-click=\"checkout()\">Check-out</a></li><li ng-show=\"bookingContextMenuOptions.cancel_checkout && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\" ng-click=\"cancel_checkout()\">Cancel Check-out</a></li><li class=\"has-submenu\" ng-show=\"bookingContextMenuOptions.move && contextMenuTarget == \'booking\'\" ng-mouseover=\"showSubmenu($event)\" ng-mouseout=\"hideSubmenu($event)\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"5\">Quick move <span class=\"submenu-arrow\"><i class=\"fa fa-caret-right\"></i></span></a><ul class=\"dropdown-menu submenu\" style=\"max-height: {{max_menu_height}}px;\"><li ng-repeat=\"room in availableRoomsByType\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" ng-click=\"moveBookingToRoom(room.id)\">{{room.number}}</a></li><li ng-show=\"bookingContextMenuOptions.hold\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\" ng-click=\"holdRoom()\">Holding Area</a></li><li ng-show=\"bookingContextMenuOptions.cantmove\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"4\">Cannot be Moved</a></li><li ng-show=\"otherAvailableTypes.length > 0\"><a class=\"inactive-submenu-link\">Other Rooms:</a></li><li ng-repeat=\"room in otherAvailableTypes\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"3\" ng-click=\"moveBookingToRoom(room.id)\">{{room.number}}</a></li></ul></li><li ng-show=\"bookingContextMenuOptions.manage && contextMenuTarget == \'booking\'\"><a class=\"pointer\" role=\"menuitem\" tabindex=\"8\" ng-click=\"openBookingManagementModal()\">Edit booking</a></li></ul></div></div><ui-prompt-notes id=\"booking-notes\" class=\"buuqit-modal-wrapper\"></ui-prompt-notes>");
$templateCache.put("templates/set_password_tpl.html","<div class=\"login-page\"><div class=\"row-fluid\"><div class=\"col-xs-12 login-page__right-block login-page__white-label\"><div class=\"login-page__header text-center\"><img ng-src=\"{{server_path+\'/api/public/v1/big_logo\'}}\" alt=\"{{domain_settings.name}}\"><p class=\"login-page__hero\">{{\'login.forgot_title\' | i18next}}</p><p class=\"login-page__small\">{{\'login.enter_your_new_password_text_small\' | i18next}}</p></div><div class=\"container login-container card\" ng-if=\"!success\"><md-content layout-padding=\"\"><form class=\"form-signin ng-pristine ng-valid\" name=\"signupForm\" ng-submit=\"signupForm.$valid && send_request()\" role=\"form\" novalidate=\"\"><div class=\"login-wrap\"><div class=\"user-login-info\"><md-input-container class=\"md-block\"><label>{{\'login.password_label\' | i18next}}</label> <input ng-model=\"credentials.password\" name=\"password\" required=\"\" type=\"password\" ng-minlength=\"15\"><div ng-messages=\"signupForm.password.$error\"><div ng-message=\"minlength\" ng-if=\"signupForm.password.$error.minlength\">{{\'login.minimum_length_div\' | i18next}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{\'login.password_сonfirmation_label\' | i18next}}</label> <input ng-model=\"credentials.password_confirmation\" name=\"password_confirmation\" required=\"\" type=\"password\" compare-to=\"credentials.password\" ng-minlength=\"15\"><div ng-messages=\"signupForm.password_confirmation.$error\"><div ng-message=\"minlength\" ng-if=\"signupForm.password_confirmation.$error.minlength && !signupForm.password_confirmation.$error.compareTo\">{{\'login.minimum_length_div\' | i18next}}</div><div ng-message=\"compareTo\" ng-if=\"signupForm.password_confirmation.$error.compareTo\">{{\'login.confirmation_should_be_equal_to_password_div\' | i18next}}</div></div></md-input-container><div class=\"error\" ng-show=\"error\">{{error}}</div></div><div class=\"text-center\"><md-button class=\"md-raised md-success\" type=\"submit\" ng-disabled=\"loading\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading\"></i> {{\'login.set_password_button\' | i18next}}</md-button></div><div><a href=\"#/login\" class=\"pull-left\">{{\'login.have_account\' | i18next}}</a> <a href=\"#/signup\" class=\"pull-right\">{{\'login.sign_up\' | i18next}}</a></div></div></form></md-content></div><div class=\"login-container success-container text-center\" ng-if=\"success\"><p>{{\'login.password_was_successfull_changed_text\' | i18next}}</p><p>{{\'login.go_to_text\' | i18next}} <a href=\"#/login\">{{\'login.login_link\' | i18next}}</a> {{\'login.page_to_sign_up_text\' | i18next}}</p></div></div></div></div>");
$templateCache.put("templates/set_room_types_tpl.html","<div ng-controller=\"RoomTypesCtrl\" class=\"room_types_container\"><div class=\"room_types\"><room-setup room-types=\"roomTypes\" on-save-room-types=\"onSaveRoomTypes\"></room-setup></div></div>");
$templateCache.put("templates/settings_tpl.html","<a id=\"top\"></a><div class=\"row settings-container app-settings website-settings\"><div class=\"left-side-navigation\"><ul class=\"nav mail-nav\"><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'profile\'}\"><span class=\"settings-profile-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.hotel_profile.hotel_profile_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/profile/details\">{{\'profile_nav.settings.sidebar.hotel_profile.hotel_details_link\' | i18next}}</a></li><li><a href=\"#/settings/profile/properties\">{{\'profile_nav.settings.sidebar.hotel_profile.hotel_properties_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'content\'}\"><span class=\"settings-content-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.hotel_content_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/content/policy\">{{\'profile_nav.settings.sidebar.hotel_profile.hotel_policy_link\' | i18next}}</a></li><li><a href=\"#/settings/content/extras\">{{\'general.other.extras\' | i18next}}</a></li><li><a href=\"#/settings/content/room-type-facilities\">{{\'profile_nav.settings.sidebar.inventory.room_type_facilities_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'guest\'}\"><span class=\"settings-guest-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.guest_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/guest/registration-form\">{{\'profile_nav.settings.sidebar.hotel_profile.guest_registration_form_link\' | i18next}}</a></li><li><a href=\"#/settings/guest/identification-types\">{{\'profile_nav.settings.sidebar.booking_engine.identification_types_link\' | i18next}}</a></li><li><a href=\"#/settings/guest/guest_details\">{{\'profile_nav.settings.sidebar.other.guest_details_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'communication\'}\"><span class=\"settings-communication-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.communication_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/communication/hotel-email-setup\">{{\'profile_nav.settings.sidebar.hotel_profile.hotel_email_setup_link\' | i18next}}</a></li><li><a href=\"#/settings/communication/email-setup\">{{\'profile_nav.settings.sidebar.booking_engine.email_setup_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'system\'}\"><span class=\"settings-system-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.system_settings_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/system/hotel_features\">{{\'profile_nav.settings.sidebar.hotel_profile.features\' | i18next}}</a></li><li><a href=\"#/settings/system/calendar-settings\">{{\'profile_nav.settings.sidebar.booking_engine.calendar_settings_link\' | i18next}}</a></li><li><a href=\"#/settings/system/i18n-settings\">{{\'profile_nav.settings.sidebar.booking_engine.i18n_settings_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'finance\'}\"><span class=\"settings-finance-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.finance_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/finance/payment-types\">{{\'profile_nav.settings.sidebar.booking_engine.payment_types_link\' | i18next}}</a></li><li><a href=\"#/settings/finance/taxes\">{{\'profile_nav.settings.sidebar.hotel_profile.tax_information_link\' | i18next}}</a></li><li><a href=\"#/settings/finance/invoice-number-settings\">{{\'profile_nav.settings.sidebar.booking_engine.invoice_number_settings_link\' | i18next}}</a></li><li><a href=\"#/settings/finance/pos-profiles\">{{\'profile_nav.settings.sidebar.booking_engine.pos_profiles_link\' | i18next}}</a></li><li><a href=\"#/settings/finance/currency_profiles\">{{\'profile_nav.settings.sidebar.hotel_profile.currencies_link\' | i18next}}</a></li><li ng-if=\"isAccountingCategoriesFeatureEnabled\"><a href=\"#/settings/finance/accounting-categories\">{{\'profile_nav.settings.sidebar.booking_engine.accounting_categories_link\' | i18next}}</a></li><li><a href=\"#/settings/finance/payment-gateway\">{{\'profile_nav.settings.sidebar.other.payment_gateway_link\' | i18next}}</a></li><li ng-if=\"paymentTerminalEnabled\"><a href=\"#/settings/finance/payment-terminal\">{{\'profile_nav.settings.sidebar.other.payment_terminal_link\' | i18next}}</a></li><li><a href=\"#/settings/finance/bookkeeping-systems\">{{\'profile_nav.settings.sidebar.other.bookkeeping_systems_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'inventory\'}\"><span class=\"settings-inventory-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.inventory.inventory_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/inventory/settings\">{{\'general.other.settings\' | i18next}}</a></li><li><a href=\"#/settings/inventory/room-type\">{{\'general.other.room_type\' | i18next}}</a></li><li><a href=\"#/settings/inventory/room-setup\">{{\'general.other.room_setup\' | i18next}}</a></li><li><a href=\"#/settings/inventory/cancellation-policy\">{{\'general.other.cancellation_policy\' | i18next}}</a></li><li><a href=\"#/settings/inventory/rates\">{{\'general.other.rate_plans\' | i18next}}</a></li><li><a href=\"#/settings/inventory/seasons\">{{\'profile_nav.settings.sidebar.inventory.seasons_and_events_link\' | i18next}}</a></li><li><a href=\"#/settings/inventory/discounts\">{{\'general.other.discounts\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'connectivity\'}\"><span class=\"settings-connectivity-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'profile_nav.settings.sidebar.hotel_profile.connectivity_span\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/connectivity/channel-manager\">{{\'profile_nav.settings.sidebar.booking_engine.channel_manager_link\' | i18next}}</a></li><li><a href=\"#/settings/connectivity/booking-engine-settings\">{{\'profile_nav.settings.sidebar.booking_engine.booking_engine_settings_link\' | i18next}}</a></li><li ng-show=\"isSaleChannelsFeatureEnabled\"><a href=\"#/settings/connectivity/sale-channels\">{{\'profile_nav.settings.sidebar.booking_engine.sale_channels_link\' | i18next}}</a></li><li><a href=\"#/settings/connectivity/widget\">{{\'profile_nav.settings.sidebar.other.booking_widget_link\' | i18next}}</a></li><li><a href=\"#/settings/connectivity/api_key\">{{\'profile_nav.settings.sidebar.other.api_key_link\' | i18next}}</a></li><li><a href=\"#/settings/connectivity/dev_keys\">{{\'profile_nav.settings.sidebar.other.dev_keys_link\' | i18next}}</a></li><li><a href=\"#/settings/connectivity/key_lock_systems\">{{\'profile_nav.settings.sidebar.other.key_lock_systems\' | i18next}}</a></li><li><a href=\"#/settings/connectivity/housekeeping_systems\">{{\'profile_nav.settings.sidebar.other.housekeeping_systems\' | i18next}}</a></li><li ng-if=\"hotel.websiteBuilder != \'hidden\'\"><a href=\"#/settings/connectivity/domain_alias\">{{\'profile_nav.settings.sidebar.other.domain_alias_link\' | i18next}}</a></li></ul></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': block == \'other\'}\"><span class=\"settings-other-toggle\" ng-click=\"toggleCollapsedMenu($event)\">{{\'general.picture_zones.Other\' | i18next}}</span><ul class=\"nav mail-nav\"><li><a href=\"#/settings/other/reactions\">{{\'profile_nav.settings.sidebar.other.reactions_link\' | i18next}}</a></li><li ng-if=\"currentHotelId == 1\"><a href=\"#/settings/other/plugins\">{{\'profile_nav.settings.sidebar.other.plugins_link\' | i18next }}</a></li><li ng-if=\"currentHotelId && !hotel.addons.disabledFolioTemplating\"><a href=\"#/settings/other/folio\">{{\'profile_nav.settings.sidebar.other.folio_link\' | i18next}}</a></li><li><a href=\"#/settings/other/country-specific\">{{\'profile_nav.settings.other.country_specific_legend\' | i18next}}</a></li></ul></li><li ng-show=\"shouldShowMySubscriptions\"><a ng-click=\"goToStripeBilling()\">{{\'profile_nav.settings.sidebar.my_subscriptions_link\' | i18next}}</a></li></ul></div><div class=\"settings-body\" ng-include=\"template\"></div></div>");
$templateCache.put("templates/signup_tpl.html","<div class=\"login-page\"><div class=\"row-fluid\"><div class=\"col-xs-12 login-page__right-block login-page__white-label\"><div class=\"login-page__header text-center\"><img ng-src=\"{{server_path+\'/api/public/v1/big_logo\'}}\" alt=\"{{domain_settings.name}}\"><p class=\"sign-up-page__hero\" ng-hide=\"success\">{{\'login.sign_up_title\' | i18next}}</p><p class=\"sign-up-page__hero\" ng-show=\"success\">{{\'login.signed_up_title\' | i18next}}</p><p class=\"login-page__small\" ng-hide=\"success\" ng-if=\"is_white_label == true\">{{\'login.sign_up_small_white_label\' | i18next}}</p></div><div class=\"container login-container signup-container card\" ng-hide=\"success\"><md-content layout-padding=\"\"><form class=\"form-signin ng-pristine ng-valid\" name=\"signupForm\" ng-submit=\"signupForm.$valid && signUp()\" role=\"form\" id=\"signupForm\" novalidate=\"\"><div class=\"login-wrap\"><div class=\"user-login-info\"><div class=\"sign-up-step-1\" ng-show=\"step == 1\"><div class=\"sign-up-subtitle\"><p class=\"login-page__small\" ng-hide=\"success\" ng-if=\"is_white_label == false\">{{\'login.sign_up_small\' | i18next}}</p><p class=\"login-page__small\">{{\'general.step_one_of_two\' | i18next}}</p></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'general.other.email_address\' | i18next}} ({{\'login.email_label_additional\' | i18next}})</label> <input ng-model=\"credentials.email\" name=\"email\" required=\"\" type=\"email\"></md-input-container><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.sign_up_step_2.contact_name_label\' | i18next}}</label> <input ng-model=\"credentials.name\" name=\"name\" required=\"\" type=\"text\"></md-input-container></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.password_label\' | i18next}}</label> <input ng-model=\"credentials.password\" name=\"password\" required=\"\" type=\"password\" ng-minlength=\"15\"><div ng-messages=\"signupForm.password.$error\"><div ng-message=\"minlength\" ng-if=\"signupForm.password.$error.minlength\">{{\'login.password_minlength\' | i18next}}</div></div></md-input-container><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.password_сonfirmation_label\' | i18next}}</label> <input ng-model=\"credentials.password_confirmation\" name=\"password_confirmation\" required=\"\" type=\"password\" compare-to=\"credentials.password\" ng-minlength=\"15\"><div ng-messages=\"signupForm.password_confirmation.$error\"><div ng-message=\"minlength\" ng-if=\"signupForm.password_confirmation.$error.minlength && !signupForm.password_confirmation.$error.compareTo\">{{\'login.password_minlength\' | i18next}}</div><div ng-message=\"compareTo\" ng-if=\"signupForm.password_confirmation.$error.compareTo\">{{\'login.password_message_compareTo\' | i18next}}</div></div></md-input-container></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"credentials.country\" ng-change=\"selectCountry()\" required=\"\"><md-option ng-repeat=\"country in countries\" value=\"{{country.code}}\">{{country.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block flex-row-item\"><label>Timezone</label><md-select ng-model=\"credentials.timezone\" required=\"\"><md-option ng-repeat=\"timezone in countriesTimezones\" value=\"{{timezone}}\">{{timezone}}</md-option></md-select></md-input-container></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.sign_up_step_2.tel_no_label\' | i18next}}</label> <input ng-model=\"credentials.phone\" name=\"phone\" required=\"\" type=\"text\"></md-input-container></div><div class=\"flex-row-end\"><div class=\"text-right flex-row-item\"><md-button class=\"md-raised md-primary\" ng-click=\"changeStep(2)\" ng-disabled=\"!(signupForm.email.$valid && signupForm.password.$valid && signupForm.password_confirmation.$valid)\">{{\'login.next\' | i18next}}</md-button><div><a href=\"#/forgot\" class=\"pull-left\">{{\'login.forgot_password\' | i18next}}</a> <a href=\"#/login\" class=\"pull-right\">{{\'login.have_account\' | i18next}}</a></div></div></div></div><div class=\"sign-up-step-2\" ng-show=\"step == 2\"><div class=\"login-page__header text-center\"><p class=\"sign-up-page__hero\">Almost done</p><p class=\"login-page__small\">Tell us a little bit about your property</p><p class=\"login-page__small\">{{\'general.step_two_of_two\' | i18next}}</p></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.sign_up_step_2.property_name_label\' | i18next}}</label> <input ng-model=\"credentials.propertyName\" name=\"property_name\" required=\"\" type=\"text\"></md-input-container><md-input-container class=\"md-block flex-row-item\"><label>{{\'general.dropins_dropdown.number_of_rooms\' | i18next}}</label> <input ng-model=\"credentials.numberOfRooms\" name=\"number_of_rooms\" type=\"number\" required=\"\"></md-input-container></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'profile_nav.settings.hotel_profile.hotel_details.comapny_name_of_your_hotel_label\' | i18next}}</label> <input ng-model=\"credentials.companyName\" name=\"company_name\" required=\"\"></md-input-container><div class=\"md-block flex-row-item property-wrapper\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.sign_up_step_2.number_of_properties\' | i18next}}</label> <input ng-model=\"credentials.numberOfProperties\" name=\"number_of_properties\" type=\"number\" required=\"\" min=\"1\" ng-change=\"validateNumberOfProperties()\"></md-input-container><div class=\"properties-action-wrapper\"><md-button class=\"md-icon-button properties-action\" ng-click=\"increaseNumberOfProperties()\"><md-icon>add</md-icon></md-button><md-button class=\"md-icon-button properties-action\" ng-click=\"decreaseNumberOfProperties()\" ng-disabled=\"credentials.numberOfProperties <= 1\"><md-icon>remove</md-icon></md-button></div></div></div><div class=\"flex-row\"><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.sign_up_step_2.company_registration_id\' | i18next}}</label> <input ng-model=\"credentials.companyRegistrationId\" name=\"company_registration_id\"></md-input-container><md-input-container class=\"md-block flex-row-item\"><label>{{\'login.sign_up_step_2.promo_code_field_label\' | i18next}}</label><div ng-class=\"promoCodeWrapperDivClass\" style=\"position:relative;\"><div style=\"display: flex; flex-direction: row; float-wrap: none; justify-content: space-between;\"><div class=\"promo-code-input-div\"><input ng-model=\"credentials.promotionCode\" name=\"promotion_code\" type=\"text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"verifyPromotionCode()\" ng-disabled=\"disablePromotionCodeInput\"></div><div class=\"backdrop ng-scope promo-code-spinner-div\" ng-show=\"showPromotionCodeSpinner\"><i class=\"fa fa-spin fa-spinner\"></i></div></div></div><div ng-messages=\"\"><div ng-message=\"minlength\" ng-if=\"!promotionCodeValid && showPromotionCodeError\">{{\'login.sign_up_step_2.promo_code_is_not_valid_message\' | i18next}}</div><div ng-message=\"minlength\" ng-if=\"promotionCodeValid && disablePromotionCodeInput\" style=\"color:green;\">{{\'login.sign_up_step_2.promo_code_is_valid_message\' | i18next}}</div></div></md-input-container></div><md-input-container class=\"md-block\"><label>{{\'login.sign_up_step_2.additional_information_questions\' | i18next}}</label> <textarea class=\"registration-additional-info\" ng-model=\"credentials.additionalInformationQuestions\" name=\"additional_information_questions\" rows=\"3\"></textarea></md-input-container><div class=\"error\" ng-show=\"error\">{{error}}</div><div class=\"sign-up-submit-section-container\"><div class=\"sign-up-submit-section\"><md-checkbox aria-label=\"{{\'login.sign_up_step_2.agreements.select_all_aria_label\' | i18next}}\" ng-model=\"credentials.agree\">{{\'login.sign_up_step_2.agreements.description\' | i18next}} <a href=\"{{domain_settings.customer_agreement_link}}\">{{\'login.sign_up_step_2.agreements.customer_agreement\' | i18next}}</a>, <a href=\"{{domain_settings.privacy_policy_link}}\">{{\'general.other.privacy_policy\' | i18next}}</a>, <a href=\"{{domain_settings.acceptable_use_policy_link}}\">{{\'login.sign_up_step_2.agreements.acceptable_use_policy\' | i18next}}</a></md-checkbox><div class=\"text-center\"><md-button class=\"md-raised md-success\" type=\"submit\" ng-disabled=\"!credentials.agree || loading\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading\"></i> {{\'login.sign_up\' | i18next}}</md-button></div><recaptcha-label></recaptcha-label></div><div class=\"flex-row sign-up-submit-section\"><a href=\"#/forgot\" class=\"pull-left\">{{\'login.forgot_password\' | i18next}}</a> <a href=\"#/login\" class=\"pull-right\">{{\'login.have_account\' | i18next}}</a></div></div></div></div></div></form></md-content></div><div class=\"login-container success-container text-center\" ng-if=\"success\"><p ng-bind-html=\"success_text\"></p><p>{{\'login.success_container.check_email\' | i18next}}</p><p>{{\'login.success_container.check_spam_box\' | i18next}}</p><script type=\"text/javascript\">\n        /*  */\n        var google_conversion_id = 1031741621;\n        var google_conversion_language = \"en\";\n        var google_conversion_format = \"3\";\n        var google_conversion_color = \"ffffff\";\n        var google_conversion_label = \"UaY6CPrX32sQtcH86wM\";\n        var google_remarketing_only = false;\n        /*  */\n        </script><script type=\"text/javascript\" src=\"//www.googleadservices.com/pagead/conversion.js\">\n        </script><noscript><div style=\"display:inline;\"><img height=\"1\" width=\"1\" style=\"border-style:none;\" alt=\"\" src=\"//www.googleadservices.com/pagead/conversion/1031741621/?label=UaY6CPrX32sQtcH86wM&amp;guid=ON&amp;script=0\"></div></noscript><script>(function (){var url = window.location; var oImg = document.createElement(\"img\");oImg.setAttribute(\'src\',\'https://app.hatchbuck.com/TrackWebPage?ACID=4277&URL=\' + url);})();  </script></div></div></div><script type=\"text/javascript\" id=\"hs-script-loader\" async=\"\" defer=\"\" src=\"//js.hs-scripts.com/5313128.js\"></script></div>");
$templateCache.put("templates/special_offer_modal_tpl.html","<form class=\"special_offers__edit_dialog\" novalidate=\"\" name=\"special_offer_form\"><locale-selector class=\"ng-hide\" change=\"changeLang\"></locale-selector><div class=\"special_offers__dialog_header\"><div class=\"row special_offers__close_container\"><div class=\"col-xs-12 text-right\"><i class=\"fa fa-times\" ng-click=\"cancel()\"></i></div></div><div class=\"row\"><div class=\"col-xs-9 special_offers__header_fields\"><md-input-container md-theme=\"docs-dark\" class=\"special_offers__title_field\"><locale-selector-next></locale-selector-next><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"special_offer.title\" name=\"title\" required=\"\"></md-input-container><md-input-container md-theme=\"docs-dark\"><label>{{\'offers.special_offers_modal.special_offer_type_label\' | i18next}}</label><md-select ng-model=\"special_offer.offerType\" required=\"\"><md-option value=\"package\">{{\'offers.special_offers_modal.increase_price_offer_option\' | i18next}}</md-option><md-option value=\"discount\">{{\'offers.special_offers_modal.decrease_price_offer_option\' | i18next}}</md-option><md-option value=\"fixed\">{{\'offers.special_offers_modal.fixed_offer_option\' | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\"><div class=\"special_offers__image_upload image_upload\" ng-style=\"{\'background-image\' : \'url(\'+fileread+\')\'}\" ng-class=\"{\'special_offers__image_upload__uploaded\' : fileread, \'image_upload__uploaded\' : fileread}\"><i class=\"fa fa-image\"></i> <span ng-if=\"!fileread\">{{\'offers.special_offers_modal.image_upload.add_photo_span\' | i18next}}</span> <span ng-if=\"fileread\">{{\'offers.special_offers_modal.image_upload.change_photo_span\' | i18next}}</span> <input type=\"file\" name=\"image\" ng-model=\"special_offer.photo\" onchange=\"angular.element(this).scope().choosePhotoFile(this)\"></div></div></div></div><div class=\"special_offers__field_group\" ng-if=\"special_offer.offerType != \'fixed\'\"><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.inventory.rate_plans.room_rate_modal.relation_from\' | i18next}}</label><md-select ng-model=\"special_offer.parentRateCategoryId\" required=\"\"><md-option ng-repeat=\"rateCategory in rateCategories\" value=\"{{rateCategory.id}}\">{{rateCategory.name}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-3\"><md-input-container><label ng-if=\"special_offer.offerType == \'package\'\">{{\'offers.special_offers_modal.cost_increase_type_label\' | i18next}}</label> <label ng-if=\"special_offer.offerType == \'discount\'\">{{\'offers.special_offers_modal.discount_type_label\' | i18next}}</label><md-select ng-model=\"special_offer.discountType\"><md-option value=\"percent\">{{\'general.other.percent\' | i18next}}</md-option><md-option value=\"fixed\">{{\'general.other.fixed_amount\' | i18next}}</md-option><md-option value=\"percent_per_room_type\" ng-if=\"special_offer.offerType == \'discount\'\">{{\'offers.special_offers_modal.discount_type_select.percent_per_room_type\' | i18next}}</md-option><md-option value=\"fixed_per_room_type\" ng-if=\"special_offer.offerType == \'discount\'\">{{\'offers.special_offers_modal.discount_type_select.fixed_per_room_type\' | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-hide=\"special_offer.discountType == \'percent_per_room_type\' || special_offer.discountType == \'fixed_per_room_type\'\"><md-input-container><label ng-if=\"special_offer.discountType == \'percent\' && special_offer.offerType == \'package\'\">% {{\'offers.special_offers_modal.increase_nightly_rate\' | i18next}}</label> <label ng-if=\"special_offer.discountType == \'percent\' && special_offer.offerType == \'discount\'\">% {{\'offers.special_offers_modal.off_nightly_rate\' | i18next}}</label> <label ng-if=\"special_offer.discountType == \'fixed\' && special_offer.offerType == \'package\'\">{{currency_symbol}} {{\'offers.special_offers_modal.increase_nightly_rate\' | i18next}}</label> <label ng-if=\"special_offer.discountType == \'fixed\' && special_offer.offerType == \'discount\'\">{{currency_symbol}} {{\'offers.special_offers_modal.off_nightly_rate\' | i18next}}</label> <input type=\"text\" ng-model=\"special_offer.discountValue\" name=\"discount_value\" required=\"\"></md-input-container></div><div class=\"col-xs-6\"><md-switch ng-model=\"special_offer.derivedRestrictions\">{{\'profile_nav.settings.inventory.rate_plans.room_rate_modal.inherit_restrictions\' | i18next}}</md-switch></div></div><div class=\"row\" ng-if=\"special_offer.discountType == \'percent_per_room_type\' || special_offer.discountType == \'fixed_per_room_type\'\"><div class=\"col-xs-12\"><legend class=\"discount_label\" ng-if=\"special_offer.discountType == \'percent_per_room_type\'\">% {{\'offers.special_offers_modal.off_nightly_rate_legend\' | i18next}}</legend><legend class=\"discount_label\" ng-if=\"special_offer.discountType == \'fixed_per_room_type\'\">{{currency_symbol}} {{\'offers.special_offers_modal.off_nightly_rate_legend\' | i18next}}</legend></div><div class=\"col-xs-6\" ng-repeat=\"roomType in roomRepresentations\"><md-input-container><label>{{roomType.title}}</label> <input type=\"text\" ng-model=\"special_offer.discountValuesPerRoom[$index]\" name=\"discount_value{{$index}}\" required=\"\"></md-input-container></div></div></div><div class=\"special_offers__field_group\"><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'offers.special_offers_modal.short_description_label\' | i18next}}</label> <textarea ng-model=\"special_offer.shortDescription\" name=\"short_description\" md-maxlength=\"180\" required=\"\"></textarea></md-input-container></div></div><legend class=\"special_offers__description_legend\">{{\'general.other.description\' | i18next}}<locale-selector-next></locale-selector-next></legend><div class=\"row\"><div class=\"col-xs-12\"><summernote on-paste=\"wysiwygPaste(evt)\" config=\"summernote_options\" ng-model=\"special_offer.description\"></summernote></div></div></div><div class=\"special_offers__field_group\"><legend>{{\'general.other.availability\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'offers.special_offers_modal.only_for_rooms_label\' | i18next}}</label><md-select ng-model=\"special_offer.roomRepresentations\" ng-class=\"{\'special_offers__selected_text_hidden\' : special_offer.roomRepresentations}\" multiple=\"\" required=\"\"><md-option ng-repeat=\"room_type in roomRepresentations\" value=\"{{room_type.id}}\">{{room_type.title}}</md-option></md-select></md-input-container><span class=\"special_offers__selected_text\" ng-if=\"special_offer.roomRepresentations\">{{roomTypesTextGenerator()}}</span></div></div><br><div class=\"row\" ng-if=\"special_offer.offerType == \'fixed\'\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr><th class=\"vrt-title-column col-xs-4\">{{\'general.other.room_type\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Mon\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Tue\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Wed\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Thu\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Fri\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Sat\' | i18next}}</th><th class=\"text-center\">{{\'general.days_of_week.Sun\' | i18next}}</th></tr></thead><tbody><tr ng-show=\"special_offer.roomRepresentations.length == 0\"><td colspan=\"8\" class=\"text-center\">{{\'profile_nav.settings.inventory.rate_plans.rate_category_form.choose_room_type_to_fill_rates_td\' | i18next}}</td></tr><tr ng-repeat=\"roomRateId in special_offer.roomRepresentations\"><td class=\"vrt-title-column\">{{roomRepresentationsById[roomRateId].title}} <span class=\"label label-primary\" ng-if=\"roomRate.virtualRoom\">{{\'profile_nav.settings.inventory.rate_plans.general_fro_section.virtual_room_span\' | i18next}}</span><div class=\"additional-info\"><i class=\"fa fa-user\"></i> {{roomRepresentationsById[roomRateId].maxAdults}} <i class=\"fa fa-child\"></i> {{roomRepresentationsById[roomRateId].maxChildren}}</div><i class=\"fa fa-toggle-right fill-next-days\" tooltip=\"{{\'profile_nav.settings.inventory.general_for_section.copy_for_all_days_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"fillNextDays(roomRepresentationsById[roomRateId])\"></i></td><td class=\"field-cell\" ng-repeat=\"day in [0,1,2,3,4,5,6]\"><input type=\"text\" ng-model=\"roomRepresentationsById[roomRateId].rate[day]\" class=\"inventory-table-field form-control\" required=\"\"></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"form-block date-col form-block-icon\"><label class=\"datepicker\">{{\'offers.special_offers_modal.starts_off_label\' | i18next}}</label><md-datepicker ng-model=\"special_offer.dateFrom\" required=\"\"></md-datepicker></div></div><div class=\"col-xs-3 special_offers__sptripe_before\"><div class=\"form-block date-col form-block-icon\"><label class=\"datepicker\">{{\'offers.special_offers_modal.ends_label\' | i18next}}</label><md-datepicker ng-model=\"special_offer.dateTo\" required=\"\"></md-datepicker></div></div><div class=\"col-xs-3\" ng-if=\"special_offer.derivedRestrictions != true\"><md-input-container><label>{{\'offers.special_offers_modal.minimum_nights\' | i18next}}</label> <input type=\"text\" ng-model=\"special_offer.minNights\" name=\"min_nights\" max=\"{{special_offer.maxNights}}\" required=\"\"></md-input-container></div><div class=\"col-xs-3 special_offers__sptripe_before\" ng-if=\"special_offer.derivedRestrictions != true\"><md-input-container><label>{{\'offers.special_offers_modal.maximum_nights\' | i18next}}</label> <input type=\"number\" ng-model=\"special_offer.maxNights\" name=\"max_nights\" min=\"{{special_offer.minNights}}\" required=\"\"></md-input-container></div></div><div class=\"row\" ng-if=\"special_offer.derivedRestrictions != true\"><div class=\"col-xs-6\"><md-input-container><label>{{\'offers.special_offers_modal.check_in_available_on_label\' | i18next}}</label><md-select ng-model=\"special_offer.weekDays\" ng-class=\"{\'special_offers__selected_text_hidden\' : special_offer.weekDays}\" multiple=\"\" required=\"\"><md-option value=\"0\">{{\'general.days_of_week.monday\' | i18next}}</md-option><md-option value=\"1\">{{\'general.days_of_week.tuesday\' | i18next}}</md-option><md-option value=\"2\">{{\'general.days_of_week.wednesday\' | i18next}}</md-option><md-option value=\"3\">{{\'general.days_of_week.thursday\' | i18next}}</md-option><md-option value=\"4\">{{\'general.days_of_week.friday\' | i18next}}</md-option><md-option value=\"5\">{{\'general.days_of_week.saturday\' | i18next}}</md-option><md-option value=\"6\">{{\'general.days_of_week.sunday\' | i18next}}</md-option></md-select></md-input-container><span class=\"special_offers__selected_text\" ng-if=\"special_offer.weekDays\">{{weekDaysTextGenerator()}}</span></div><div class=\"col-xs-6\"><md-input-container><label>{{\'offers.special_offers_modal.check_out_available_on_label\' | i18next}}</label><md-select ng-model=\"special_offer.closedToDeparture\" ng-class=\"{\'special_offers__selected_text_hidden\' : special_offer.closedToDeparture}\" multiple=\"\" required=\"\"><md-option value=\"0\">{{\'general.days_of_week.monday\' | i18next}}</md-option><md-option value=\"1\">{{\'general.days_of_week.tuesday\' | i18next}}</md-option><md-option value=\"2\">{{\'general.days_of_week.wednesday\' | i18next}}</md-option><md-option value=\"3\">{{\'general.days_of_week.thursday\' | i18next}}</md-option><md-option value=\"4\">{{\'general.days_of_week.friday\' | i18next}}</md-option><md-option value=\"5\">{{\'general.days_of_week.saturday\' | i18next}}</md-option><md-option value=\"6\">{{\'general.days_of_week.sunday\' | i18next}}</md-option></md-select></md-input-container><span class=\"special_offers__selected_text\" ng-if=\"special_offer.closedToDeparture\">{{closedToDepartureTextGenerator()}}</span></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'offers.special_offers_modal.apply_cancellation_policy\' | i18next}}</label><md-select ng-model=\"special_offer.cancellationPolicyId\" required=\"\"><md-option ng-repeat=\"policy in cancellation_policies\" value=\"{{policy.id}}\">{{policy.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'offers.special_offers_modal.meal_type_label\' | i18next}}</label><md-select ng-model=\"special_offer.mealType\" required=\"\"><md-option ng-repeat=\"mealType in mealTypes\" ng-value=\"mealType.code\">{{mealType.title}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'offers.special_offers_modal.early_or_late_bookers_label\' | i18next}}</label><md-select ng-model=\"special_offer.earlyLate\" ng-change=\"setDefaultMinDays()\"><md-option></md-option><md-option value=\"early\">{{\'offers.special_offers_modal.early_option\' | i18next}}</md-option><md-option value=\"late\">{{\'offers.special_offers_modal.late_option\' | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-if=\"special_offer.earlyLate == \'early\'\"><md-input-container><label>{{\'offers.special_offers_modal.minimum_days_in_advance_label\' | i18next}}</label> <input type=\"number\" ng-model=\"special_offer.minDaysAdvance\" min=\"0\" max=\"{{special_offer.maxDaysAdvance}}\" name=\"min_days_advance\" required=\"\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"special_offer.earlyLate == \'early\'\"><md-input-container><label>{{\'offers.special_offers_modal.maximum_days_in_advance_label\' | i18next}}</label> <input type=\"number\" ng-model=\"special_offer.maxDaysAdvance\" min=\"{{special_offer.minDaysAdvance}}\" max=\"600\" name=\"max_days_advance\" required=\"\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"special_offer.earlyLate == \'late\'\"><md-input-container><label>{{\'offers.special_offers_modal.minimum_days_in_advance_label\' | i18next}}</label> <input type=\"number\" ng-model=\"special_offer.minDaysAdvance\" min=\"0\" max=\"{{special_offer.maxDaysAdvance}}\" name=\"min_days_advance\" required=\"\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"special_offer.earlyLate == \'late\'\"><md-input-container><label>{{\'offers.special_offers_modal.maximum_days_in_advance_label\' | i18next}}</label> <input type=\"number\" ng-model=\"special_offer.maxDaysAdvance\" min=\"{{special_offer.minDaysAdvance}}\" max=\"3\" name=\"max_days_advance\" required=\"\"></md-input-container></div></div></div><div class=\"special_offers__field_group\"><legend>{{\'general.other.extras\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'offers.special_offers_modal.sell_with_extras_label\' | i18next}}</label><div class=\"special_offers_extra_select\"><special-offer-select-extras on-scroll=\"onLoadExtras\" on-search=\"onSearchExtras\" on-select=\"onSelectExtra\" on-deselect=\"onDeselectExtra\" on-dropdown-visible-change=\"onExtraDropdownVisibleChange\" options=\"availableExtras\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" mode=\"\'multiple\'\" caret-down-filled-suffix=\"true\" value=\"special_offer.extrasList\"></special-offer-select-extras></div></md-input-container><table class=\"table special-offers-table\" ng-show=\"special_offer.extrasList.length > 0\"><thead><tr><th class=\"col-xs-4\">{{\'offers.special_offers_modal.extra_name_th\' | i18next}}</th><th class=\"col-xs-4\">{{\'offers.special_offers_modal.sell_mode_th\' | i18next}}</th><th class=\"col-xs-4\">{{\'general.other.price\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"extra in special_offer.extras\"><td colspan=\"3\"><div class=\"row\"><div class=\"col-xs-4\">{{extra.title}}</div><div class=\"col-xs-4\"><md-input-container><label>{{\'offers.special_offers_modal.sell_mode_label\' | i18next}}</label><md-select ng-model=\"extra.sellMode\"><md-option value=\"per_booking\">{{\'offers.special_offers_modal.per_booking_th\' | i18next}}</md-option><md-option value=\"per_night\">{{\'offers.special_offers_modal.per_night_th\' | i18next}}</md-option><md-option value=\"per_person\">{{\'offers.special_offers_modal.per_person_th\' | i18next}}</md-option><md-option value=\"per_person_per_night\">{{\'general.other.per_person_per_night\' | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-4\"><md-input-container><label>{{\'general.other.amount\' | i18next}}</label> <input ng-model=\"extra.amount\" type=\"number\" min=\"0\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-8\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.excludeFromRate\" aria-label=\"{{\'general.other.exclude_from_rate\' | i18next}}\">{{\'general.other.exclude_from_rate\' | i18next}}</md-checkbox></md-input-container></div><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.isPercent\" ng-disabled=\"extra.excludeFromRate == true\" aria-label=\"{{\'general.other.is_precent\' | i18next}}\">{{\'general.other.is_percent\' | i18next}}</md-checkbox></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.includePriceIntoRate\" ng-disabled=\"extra.excludeFromRate == true\" aria-label=\"{{\'offers.special_offers_modal.included_in_rate_plan_as_complimentary_checkbox\' | i18next}}\">{{\'offers.special_offers_modal.included_in_rate_plan_as_complimentary_checkbox\' | i18next}} <i class=\"fa fa-question-circle\" tooltip=\"{{\'offers.special_offers_modal.included_in_rate_plan_as_complimentary_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></md-checkbox></md-input-container></div><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.showAtInvoice\" ng-disabled=\"extra.excludeFromRate == true\" aria-label=\"{{\'general.other.show_breakdown_on_invoice\' | i18next}}\">{{\'general.other.show_breakdown_on_invoice\' | i18next}} <i class=\"fa fa-question-circle\" tooltip=\"{{\'offers.special_offers_modal.show_breakdown_on_invoice_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></md-checkbox></md-input-container></div><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.includePriceIntoRateForInvoice\" ng-disabled=\"extra.excludeFromRate == true\" aria-label=\"{{\'offers.special_offers_modal.show_complimentary_items_on_invoice_checkbox\' | i18next}}\">{{\'offers.special_offers_modal.show_complimentary_items_on_invoice_checkbox\' | i18next}} <i class=\"fa fa-question-circle\" tooltip=\"{{\'offers.special_offers_modal.show_complimentary_items_on_invoice_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></md-checkbox></md-input-container></div></div><div class=\"row bordered-bottom\" ng-repeat-end=\"\"><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.oneDayOffset\" ng-disabled=\"extra.sellMode == \'per_booking\' || extra.sellMode == \'per_person\'\" aria-label=\"{{\'offers.special_offers_modal.apply_1_day_offset_checkbox\' | i18next}}\">{{\'offers.special_offers_modal.apply_1_day_offset_checkbox\' | i18next}}</md-checkbox></md-input-container></div><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.applyToFirstDay\" ng-disabled=\"extra.sellMode == \'per_night\' || extra.sellMode == \'per_person_per_night\'\" ng-change=\"normalizeFirstOrLastDay(extra, \'applyToFirstDay\')\" aria-label=\"{{\'offers.special_offers_modal.apply_to_first_day_of_stay_checkbox\' | i18next}}\">{{\'offers.special_offers_modal.apply_to_first_day_of_stay_checkbox\' | i18next}}</md-checkbox></md-input-container></div><div class=\"col-xs-4\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"extra.applyToLastDay\" ng-disabled=\"extra.sellMode == \'per_night\' || extra.sellMode == \'per_person_per_night\'\" ng-change=\"normalizeFirstOrLastDay(extra, \'applyToLastDay\')\" aria-label=\"{{\'offers.special_offers_modal.apply_to_last_day_of_stay_checkbox\' | i18next}}\">{{\'offers.special_offers_modal.apply_to_last_day_of_stay_checkbox\' | i18next}}</md-checkbox></md-input-container></div></div></td></tr></tbody></table></div></div></div><div class=\"special_offers__field_group\"><legend>{{\'offers.special_offers_modal.additional_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-6\"><md-switch ng-model=\"special_offer.promoCodeEnabled\">{{\'offers.special_offers_modal.promo_code_switch\' | i18next}}</md-switch></div><div class=\"col-xs-6\" ng-if=\"special_offer.promoCodeEnabled\"><md-input-container><label>{{\'offers.special_offers_modal.code_label\' | i18next}}</label> <input type=\"text\" ng-model=\"special_offer.promoCode\" name=\"promo_code\"></md-input-container><small><a href=\"{{website}}/book?promocode={{special_offer.promoCode}}\">{{website}}/book?promocode={{special_offer.promoCode}}</a></small></div></div></div><div class=\"special_offers__field_group\"><div class=\"row\"><div class=\"col-xs-4\"><md-switch ng-model=\"special_offer.isActive\">{{\'offers.special_offers_modal.active_offer_switch\' | i18next}}</md-switch></div><div class=\"col-xs-4\"><md-switch ng-model=\"special_offer.isFeatured\">{{\'offers.special_offers_modal.featured_offer_switch\' | i18next}} <i class=\"fa fa-question-circle app_helper\" tooltip-append-to-body=\"true\" tooltip=\"{{\'offers.special_offers_modal.show_this_offer_on_website_tooltip\' | i18next}}\"></i></md-switch></div><div class=\"col-xs-4 text-right special_offer__control_elements\"><md-button class=\"md-raised md-button-cancel\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"(special_offer_form.$invalid || loading)\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\" ng-show=\"loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form>");
$templateCache.put("templates/special_offers_tpl.html","<div class=\"special_offers\"><div style=\"overflow-y: scroll; height:100%;\"><div class=\"special_offers__active_offers\" ng-class=\"{\'special_offers__active_offers__full_height\' : getInactiveOffersCount() == 0}\"><h1>{{\'offers.special_offers.active_offers_title\' | i18next}}<locale-selector change=\"changeLang\"></locale-selector></h1><div class=\"special_offers__offers_not_found\" ng-if=\"offers.length == 0\">{{\'offers.special_offers.offers_not_found.title\' | i18next}}<br><a ng-click=\"openOfferDialog(newOffer)\">{{\'offers.special_offers.offers_not_found.link\' | i18next}}</a></div><div class=\"special_offers__list\" ng-if=\"offers.length > 0\"><div class=\"special_offers__element\" ng-repeat=\"offer in offers | filter:{\'isActive\' : true} track by $index\" ng-click=\"openDndMenu($event, \'active-offer-button\')\"><div class=\"special_offers__cover\"><img src=\"https://tbf-libraries.s3.eu-west-1.amazonaws.com/missing_special_offer.svg\" ng-if=\"offer.image.indexOf(\'missing\') != -1\" class=\"special_offer__element_cover\"> <img ng-src=\"{{offer.image}}\" ng-if=\"offer.image.indexOf(\'missing\') == -1\" class=\"special_offer__element_cover\"></div><h2>{{offer.title}}</h2><strong ng-if=\"offer.discountType == \'fixed\' && offer.offerType !== \'fixed\'\">{{currencySymbol}}{{offer.discountValue}} <span ng-if=\"offer.offerType == \'discount\'\">{{\'offers.special_offers.offers__element.discount_span\' | i18next}}</span> <span ng-if=\"offer.offerType == \'package\'\">{{\'offers.special_offers.offers__element.increase_nightly_rate_span\' | i18next}}</span></strong> <strong ng-if=\"offer.discountType == \'percent\' && offer.offerType !== \'fixed\'\">{{offer.discountValue}}% <span ng-if=\"offer.offerType == \'discount\'\">{{\'offers.special_offers.offers__element.discount_span\' | i18next}}</span> <span ng-if=\"offer.offerType == \'package\'\">{{\'offers.special_offers.offers__element.increase_nightly_rate_span\' | i18next}}</span></strong> <strong ng-if=\"offer.discountType == \'fixed_per_room_type\' && offer.offerType !== \'fixed\'\">{{\'general.other.fixed\' | i18next}} <span ng-if=\"offer.offerType == \'discount\'\">{{\'offers.special_offers.offers__element.discount_span\' | i18next}}</span> <span ng-if=\"offer.offerType == \'package\'\">{{\'offers.special_offers.offers__element.increase_nightly_rate_span\' | i18next}}</span> {{\'offers.special_offers.offers__element.per_room\' | i18next}}</strong> <strong ng-if=\"offer.discountType == \'percent_per_room_type\' && offer.offerType !== \'fixed\'\">{{\'general.other.percent\' | i18next}} <span ng-if=\"offer.offerType == \'discount\'\">{{\'offers.special_offers.offers__element.discount_span\' | i18next}}</span> <span ng-if=\"offer.offerType == \'package\'\">{{\'offers.special_offers.offers__element.increase_nightly_rate_span\' | i18next}}</span></strong> <strong ng-if=\"offer.offerType === \'fixed\'\">{{\'offers.special_offers_modal.fixed_offer_option\' | i18next}}</strong> , <span ng-if=\"offer.roomRepresentationCodes.length < room_representation_count\">{{offer.roomRepresentationCodes.join(\', \')}}</span> <span ng-if=\"offer.roomRepresentationCodes.length == room_representation_count\">{{\'offers.special_offers.all_rooms_span\' | i18next}}</span><div class=\"special_offer__week_highlights\"><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.monday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(0) > -1}\"></div><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.tuesday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(1) > -1}\"></div><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.wednesday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(2) > -1}\"></div><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.thursday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(3) > -1}\"></div><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.friday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(4) > -1}\"></div><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.saturday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(5) > -1}\"></div><div class=\"special_offer__week_day\" tooltip-append-to-body=\"true\" tooltip=\"{{\'general.days_of_week.sunday\' | i18next}}\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(6) > -1}\"></div></div><div class=\"special_offer__date_range\">{{offer.dateFrom | dateToMoment:\'DD MMM\'}} - {{offer.dateTo | dateToMoment:\'DD MMM\'}}</div><div class=\"special_offer__options special_offer__is_featured\" ng-if=\"offer.isFeatured == true\"><i class=\"fa fa-star\" tooltip-append-to-body=\"true\" tooltip=\"{{\'offers.special_offers.featured_special_offer_tooltip\' | i18next}}\"></i></div><div class=\"special_offer__options\"><md-menu><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button active-offer-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><i class=\"fa fa-spinner\" ng-show=\"offer.loading\" ng-class=\"{\'fa-spin\' : offer.loading}\"></i> {{\'general.other.options\' | i18next}} <i class=\"fa fa-caret-down\"></i></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"openOfferDialog(offer)\">{{\'offers.special_offers.options.edit_offer_button\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"destroyOffer(offer)\">{{\'offers.special_offers.options.remove_offer_button\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"disableOffer(offer)\">{{\'offers.special_offers.options.disable_offer_button\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button href=\"{{getIBELink(offer)}}\" target=\"_blank\">{{\'offers.special_offers.options.show_at_ibe\' | i18next}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"special_offers__add_new_offer\" ng-click=\"openOfferDialog(newOffer)\">+<br>{{\'offers.special_offers.add_offer\' | i18next}}</div></div></div><div class=\"special_offers__inactive_offers\" ng-class=\"{\'special_offers__inactive_offers__bottom_placed\' : getInactiveOffersCount() == 0}\"><h1>{{\'offers.special_offers.inactive_offers_title\' | i18next}}</h1><div class=\"special_offers__list\" ng-if=\"getInactiveOffersCount() > 0\"><div class=\"special_offers__element\" ng-repeat=\"offer in offers | filter:{\'isActive\' : false} track by $index\" ng-click=\"openDndMenu($event, \'inactive-offer-button\')\"><img ng-src=\"{{offer.image}}\" class=\"special_offer__element_cover\"><h2>{{offer.title}}</h2><strong>{{offer.discountValue}}</strong>, {{offer.roomTypeCodes.join(\', \')}}<div class=\"special_offer__week_highlights\"><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(0) > -1}\"></div><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(1) > -1}\"></div><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(2) > -1}\"></div><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(3) > -1}\"></div><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(4) > -1}\"></div><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(5) > -1}\"></div><div class=\"special_offer__week_day\" ng-class=\"{\'special_offer__week_day__active\' : offer.weekDays.indexOf(6) > -1}\"></div></div><div class=\"special_offer__date_range\">{{offer.dateFrom | dateToMoment:\'DD MMM\'}} - {{offer.dateTo | dateToMoment:\'DD MMM\'}}</div><div class=\"special_offer__options\"><md-menu><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button inactive-offer-button\" ng-click=\"openMenu($mdOpenMenu, $event)\"><i class=\"fa fa-spinner\" ng-show=\"offer.loading\" ng-class=\"{\'fa-spin\' : offer.loading}\"></i> {{\'general.other.options\' | i18next}} <i class=\"fa fa-caret-down\"></i></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"openOfferDialog(offer)\">{{\'offers.special_offers.options.edit_offer_button\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"destroyOffer(offer)\">{{\'offers.special_offers.options.remove_offer_button\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"disableOffer(offer)\">{{\'offers.special_offers.options.activate_offer_button\' | i18next}}</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div></div></div>");
$templateCache.put("templates/website_tpl.html","<div class=\"row settings-container website-settings\"><div class=\"left-side-navigation\"><ul class=\"nav nav-pills nav-stacked mail-nav\"><li><strong>{{\'website_settings.sidebar.title\' | i18next}}</strong><md-content md-theme=\"docs-dark\" class=\"website-language-chooser\"><md-input-container><label>{{\'website_settings.sidebar.language_input_container.label\' | i18next}}</label><md-select ng-model=\"lang\" ng-change=\"setLangVersion()\"><md-option ng-repeat=\"lng in availableLangs\" value=\"{{lng}}\"><span class=\"flag-icon flag-icon-{{lng | normalizeLang}}\"></span> {{getFullLanguageName(lng)}}</md-option><md-option ng-click=\"openAddLanguageDialog()\" value=\"Add new language\">{{\'website_settings.sidebar.language_input_container.option\' | i18next}}</md-option></md-select></md-input-container><div class=\"row lang-links\"><div class=\"col-xs-6\"><a ng-click=\"setAsDefault(lang)\" ng-if=\"websiteDefaultLang != lang\" aria-label=\"{{\'website_settings.sidebar.language_input_container.set_as_default_link\' | i18next}}\"><i class=\"fa fa-eye\"></i> {{\'website_settings.sidebar.language_input_container.set_as_default_link\' | i18next}}<md-tooltip md-direction=\"top\">{{\'website_settings.sidebar.language_input_container.set_as_default_link\' | i18next}}</md-tooltip></a> <a ng-click=\"false\" ng-if=\"websiteDefaultLang == lang\" aria-label=\"{{\'website_settings.sidebar.language_input_container.default_lang\' | i18next}}\"><i class=\"fa fa-eye\"></i> {{\'website_settings.sidebar.language_input_container.default_lang\' | i18next}}<md-tooltip md-direction=\"top\">{{\'website_settings.sidebar.language_input_container.default_lang\' | i18next}}</md-tooltip></a></div><div class=\"col-xs-6\"><a ng-click=\"removeLang(lang)\" ng-hide=\"lang == \'en\' || lang == websiteDefaultLang\" aria-label=\"{{\'website_settings.sidebar.language_input_container.unpublish_link\' | i18next}}\"><i class=\"fa fa-trash\"></i> {{\'general.buttons.remove\' | i18next}}<md-tooltip md-direction=\"top\">{{\'website_settings.sidebar.language_input_container.unpublish_link\' | i18next}}</md-tooltip></a></div></div></md-content><ul class=\"nav mail-nav\"><li ng-class=\"{\'active\': active == \'template\'}\"><a ng-click=\"setActive(\'template\')\">{{\'general.other.template\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'header\'}\"><a ng-click=\"setActive(\'header\')\">{{\'general.other.header\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'navigation\'}\"><a ng-click=\"setActive(\'navigation\')\">{{\'website_settings.sidebar.navigation_link\' | i18next}}</a></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': [\'body_text\', \'term_and_conditions\', \'privacy_policy\', \'about_text\', \'footer\'].indexOf(active) > -1}\"><span ng-click=\"toggleCollapsedMenu($event)\">{{\'website_settings.sidebar.static_text_span\' | i18next}}</span><ul class=\"nav\"><li ng-class=\"{\'active\': active == \'body_text\'}\"><a ng-click=\"setActive(\'body_text\')\">{{\'website_settings.sidebar.body_text_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'term_and_conditions\'}\"><a ng-click=\"setActive(\'term_and_conditions\')\">{{\'general.other.terms_and_conditions\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'privacy_policy\'}\"><a ng-click=\"setActive(\'privacy_policy\')\">{{\'general.other.privacy_policy\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'about_text\'}\"><a ng-click=\"setActive(\'about_text\')\">{{\'website_settings.sidebar.about_text_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'footer\'}\"><a ng-click=\"setActive(\'footer\')\">{{\'website_settings.sidebar.footer_link\' | i18next}}</a></li></ul></li><li ng-class=\"{\'active\': active == \'features\'}\"><a ng-click=\"setActive(\'features\')\">{{\'general.other.features\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'faq\'}\"><a ng-click=\"setActive(\'faq\')\">{{\'general.other.faq\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'rooms\'}\"><a ng-click=\"setActive(\'rooms\')\">{{\'general.other.rooms\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'testimonials\'}\"><a ng-click=\"setActive(\'testimonials\')\">{{\'website_settings.sidebar.testimonials_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'pages\' || active == \'page_edit\'}\"><a ng-click=\"setActive(\'pages\')\">{{\'website_settings.sidebar.custom_pages_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'blog\' || active == \'blog_edit\'}\"><a ng-click=\"setActive(\'blog\')\">{{\'website_settings.sidebar.blog_posts_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'pictures\'}\"><a ng-click=\"setActive(\'pictures\')\">{{\'website_settings.sidebar.pictures_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'gallery\'}\"><a ng-click=\"setActive(\'gallery\')\">{{\'general.other.gallery\' | i18next}}</a></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': [\'main\', \'contacts\', \'tripadvisor\', \'comments\'].indexOf(active) > -1}\"><span ng-click=\"toggleCollapsedMenu($event)\">{{\'general.other.settings\' | i18next}}</span><ul class=\"nav\"><li ng-class=\"{\'active\': active == \'main\'}\"><a ng-click=\"setActive(\'main\')\">{{\'website_settings.sidebar.google_settings_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'contacts\'}\"><a ng-click=\"setActive(\'contacts\')\">{{\'general.other.contacts\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'tripadvisor\'}\"><a ng-click=\"setActive(\'tripadvisor\')\">{{\'website_settings.sidebar.tripadvisor_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'comments\'}\"><a ng-click=\"setActive(\'comments\')\">{{\'website_settings.sidebar.blog_comments_link\' | i18next}}</a></li></ul></li><li></li><li class=\"collapsed-link\" ng-class=\"{\'openned\': [\'interface\', \'facilities\'].indexOf(active) > -1}\"><span ng-click=\"toggleCollapsedMenu($event)\">{{\'website_settings.sidebar.translations_span\' | i18next}}</span><ul class=\"nav\"><li ng-class=\"{\'active\': active == \'interface\'}\"><a ng-click=\"setActive(\'interface\')\">{{\'website_settings.sidebar.interface_link\' | i18next}}</a></li><li ng-class=\"{\'active\': active == \'facilities\'}\"><a ng-click=\"setActive(\'facilities\')\">{{\'general.other.facilities\' | i18next}}</a></li></ul></li><li></li></ul></li></ul></div><div class=\"settings-body\"><form><div ng-include=\"template\"></div></form></div></div>");
$templateCache.put("templates/dashboard/charts_tpl.html","<div ng-controller=\"Dashboard.ChartsController as ctrl\"><react-dashboard-charts occupancies=\"ctrl.occupancies\" revenues=\"ctrl.revenues\" booking-sources=\"ctrl.bookingSources\" currency-symbol=\"ctrl.currencySymbol\" hide-revenue=\"!hasAccess(\'revenueChart\')\" is-loading=\"ctrl.isLoading\"></react-dashboard-charts></div>");
$templateCache.put("templates/dashboard/checkins_tpl.html","<div ng-controller=\"Dashboard.CheckinsController as ctrl\"><react-dashboard-checkins checkins=\"ctrl.checkins\" currency-symbol=\"ctrl.currencySymbol\" currency-fraction-size=\"ctrl.currencyFractionSize\" checked-today-count=\"ctrl.checkedTodayCount\" tomorrow-checkins-count=\"ctrl.tomorrowCheckinsCount\" show-loading-indicator=\"ctrl.loading\" hide-prices=\"user.role == \'housekeeper\'\" use-pro-mode=\"ctrl.useProMode\" show-quick-checkin-menu-option=\"hasAccess(\'quickCheckIn\')\" show-view-booking-info-menu-option=\"hasAccess(\'viewBookingInfo\')\" on-view-booking=\"ctrl.handleViewBooking\" on-quick-checkin=\"ctrl.handleQuickCheckin\" on-checkin-and-payment=\"ctrl.handleCheckinAndPayment\" on-pro-checkin=\"ctrl.handleProCheckin\" on-add-comment=\"ctrl.handleAddComment\"></react-dashboard-checkins></div>");
$templateCache.put("templates/dashboard/checkouts_tpl.html","<div ng-controller=\"Dashboard.CheckoutsController as ctrl\"><react-dashboard-checkouts checkouts=\"ctrl.checkouts\" currency-symbol=\"ctrl.currencySymbol\" checked-out-today-count=\"ctrl.checkedTodayCount\" show-loading-indicator=\"ctrl.loading\" hide-prices=\"user.role == \'housekeeper\'\" show-quick-checkout-menu-option=\"hasAccess(\'quickCheckOut\')\" show-view-booking-info-menu-option=\"hasAccess(\'viewBookingInfo\')\" on-view-booking=\"ctrl.handleViewBooking\" on-quick-checkout=\"ctrl.handleQuickCheckOut\" on-checkout-and-payment=\"ctrl.handleCheckOutAndPayment\" on-add-comment=\"ctrl.handleAddComment\"></react-dashboard-checkouts></div>");
$templateCache.put("templates/dashboard/liveFeed_tpl.html","<div ng-controller=\"Dashboard.LiveFeedController as ctrl\" class=\"react-dashboard-livefeed\"><react-dashboard-live-feed feed-events=\"ctrl.feedEvents\" show-view-booking-menu-option=\"hasAccess(\'viewBookingInfo\')\" on-view-booking=\"ctrl.openBooking\" on-open-calendar=\"ctrl.openCalendar\" show-mark-all-as-read=\"hasAccess(\'markAsRead\')\" mark-as-read=\"ctrl.markAsRead\" mark-all-as-read=\"ctrl.markAllAsRead\" load-more-visible=\"ctrl.loadMoreVisible\" load-more=\"ctrl.loadMore\"></react-dashboard-live-feed></div>");
$templateCache.put("templates/booking_management/attachments_tpl.html","<booking-attachments-tab></booking-attachments-tab>");
$templateCache.put("templates/booking_management/bookingAttachmentsTab_tpl.html","<div class=\"backdrop ng-scope\" ng-if=\"loading\"><i class=\"fa fa-spin fa-spinner\"></i></div><div class=\"table-container attachments\"><div class=\"table-container\"><table class=\"table table-striped\"><thead><tr><th>{{\'general.other.guest\' | i18next}} / {{\'general.other.booking\' | i18next}}</th><th>{{\'general.other.type\' | i18next}}</th><th>{{\'general.other.link\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"attachment in attachments\"><td>{{attachment.entityName}}</td><td>{{showType(attachment.type)}}</td><td><a href=\"{{attachment.url}}\" target=\"_blank\">{{\'general.other.link\' | i18next}}</a></td><td class=\"text-right\"><a ng-click=\"removeAttachment(attachment)\" tooltip=\"Remove attachment\" ng-if=\"!attachment.loading\" tooltip-append-to-body=\"true\"><i class=\"fa fa-trash\"></i></a></td></tr><tr class=\"text-center\" ng-if=\"attachments.length == 0\"><td colspan=\"4\">No files yet</td></tr></tbody></table></div><div><booking-guest-attachment name=\"\'Booking\'\" attachment=\"attachment\" choose-file=\"chooseFile\" multi=\"true\"></booking-guest-attachment><md-button ng-if=\"attachment.files.length > 0\" ng-click=\"uploadFiles()\">Upload</md-button></div></div>");
$templateCache.put("templates/booking_management/bookingCardVault_tpl.html","<div ng-controller=\"BookingCardVaultController as ctrl\"><react-booking-payment-cards booking-customers=\"ctrl.bookingCustomers\" active-customer=\"ctrl.activeCustomer\" cards=\"ctrl.cards\" booking-id=\"ctrl.bookingId\" action-loading=\"ctrl.actionLoading\" card-animation=\"ctrl.cardAnimation\" card-form-visible=\"ctrl.cardFormVisible\" show-credentials-modal=\"ctrl.showCredentialsModal\" pci-booking-iframe-path=\"ctrl.pciBookingIframePath\" credentials-iframe-path=\"ctrl.credentialsIframePath\" gateway=\"ctrl.gateway\" gateways=\"ctrl.gateways\" online=\"ctrl.online\" other-cards-size=\"ctrl.otherCardsSize\" charge-card=\"ctrl.chargeCard\" change-customer=\"ctrl.changeCustomer\" preauthorize-card=\"ctrl.preauthorizeCard\" change-cardholder-name=\"ctrl.changeCardholderName\" show-card-credentials=\"ctrl.showCardCredentials\" tokenize-card=\"ctrl.tokenizeCard\" destroy-card=\"ctrl.destroyCard\" next-card=\"ctrl.nextCard\" save-stripe-sca-card=\"ctrl.saveStripeScaCard\" save-stripe-card=\"ctrl.saveStripeCard\" save-wubook-card=\"ctrl.saveWubookCard\" handle-add-card=\"ctrl.handleAddCard\" handle-credentials-modal=\"ctrl.handleCredentialsModal\"></react-booking-payment-cards></div>");
$templateCache.put("templates/booking_management/bookingCustomerTab_tpl.html","<h3 class=\"customer-header\">{{\'bookings.customer.title\' | i18next}}<div class=\"pull-right invoice-controls\"><md-button class=\"md-raised\" ng-click=\"printRegistrationForm()\"><i class=\"fa fa-print\" ng-hide=\"print_loading == true\"></i> <i class=\"fa fa-spinner\" ng-show=\"print_loading == true\" ng-class=\"{\'fa-spin\' : print_loading}\"></i> {{\'bookings.customer.print_form_button\' | i18next}}</md-button></div></h3><script type=\"text/ng-template\" id=\"customTemplate.html\"><a> {{match.label.firstName}} {{match.label.lastName}} {{match.label.email}} </a></script><div>{{\'bookings.customer.who_pays_radio_group_title\' | i18next}}<br><md-radio-group ng-model=\"booking.customer.customerType\" class=\"inline\"><md-radio-button value=\"0\">{{\'bookings.customer.guest_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"1\">{{\'bookings.customer.company_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div ng-show=\"booking.customer.customerType == 1\">{{\'bookings.customer.what_paying_for_radio_group_title\' | i18next}}<br><md-radio-group ng-model=\"booking.customer.paymentType\" class=\"inline\"><md-radio-button value=\"0\">{{\'bookings.customer.accommodation_only_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"1\">{{\'bookings.customer.accommodation_and_dinner_allowance_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"row\" ng-show=\"booking.customer.customerType == 1\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.company_name_label\' | i18next}}</label> <input name=\"companyName\" ng-model=\"booking.customer.companyName\"></md-input-container></div></div><div class=\"row\" ng-show=\"booking.customer.customerType == 0\"><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.first_name\' | i18next}}</label> <input type=\"text\" ng-model=\"booking.customer.firstName\" name=\"firstName\" maxlength=\"250\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.last_name\' | i18next}}</label> <input type=\"text\" name=\"lastName\" ng-model=\"booking.customer.lastName\" maxlength=\"250\"></md-input-container></div></div><div class=\"row\" ng-show=\"booking.customer.customerType == 0\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.nationality_label\' | i18next}}</label> <input type=\"text\" ng-model=\"booking.customer.nationality\" name=\"nationality\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select ng-model=\"booking.customer.locale\"><md-optgroup label=\"Locales\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_no_label\' | i18next}}</label> <input type=\"text\" name=\"identification\" ng-model=\"booking.customer.identification\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_type_label\' | i18next}}</label><md-select ng-model=\"booking.customer.identificationTypeId\"><md-option ng-value=\"idType.id\" ng-repeat=\"idType in idTypes\">{{idType.title}}</md-option></md-select></md-input-container></div></div><h4>{{\'bookings.customer.address_title\' | i18next}}</h4><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" name=\"address\" ng-model=\"booking.customer.address\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.city_label\' | i18next}}</label> <input type=\"text\" name=\"city\" ng-model=\"booking.customer.city\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"booking.customer.country\"><md-option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\" ng-show=\"booking.customer.country == \'United States\'\"><md-input-container><label>{{\'bookings.customer.state_label\' | i18next}}</label> <input type=\"text\" name=\"state\" ng-model=\"booking.customer.state\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.postal_code\' | i18next}}</label> <input type=\"text\" name=\"zipCode\" ng-model=\"booking.customer.zipCode\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.email_label\' | i18next}}</label> <input type=\"text\" name=\"email\" ng-model=\"booking.customer.email\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.mobile_phone_label\' | i18next}}</label> <input type=\"text\" name=\"mobilePhone\" ng-model=\"booking.customer.mobilePhone\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.work_phone_label\' | i18next}}</label> <input type=\"text\" ng-model=\"booking.customer.workPhone\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.notes_label\' | i18next}}</label> <input type=\"text\" ng-model=\"booking.customer.notes\"></md-input-container></div></div><div class=\"row\" ng-show=\"booking.customer.customerType == 1\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.your_reference_label\' | i18next}}</label> <input type=\"text\" ng-model=\"booking.customer.referenceText\"></md-input-container></div></div><div class=\"row form-control-block\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-primary\" ng-disabled=\"(createBookingForm.$invalid || loading || hasNotValidRooms())\" ng-click=\"saveCustomer()\">{{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/booking_management/bookingDiscounts_tpl.html","<div><h3>{{\'general.other.discounts\' | i18next}}</h3><div class=\"table-container\"><table class=\"table table-discounts table-hover\"><thead><tr><th class=\"col-xs-6\">{{\'bookings.discounts.discount name_th\' | i18next}}</th><th class=\"col-xs-3\">{{\'general.other.type\' | i18next}}</th><th class=\"col-xs-1\">{{\'general.other.amount\' | i18next}}</th><th class=\"col-xs-1\">{{\'general.other.total\' | i18next}}</th><th class=\"col-xs-1 controls\"></th></tr></thead><tbody><tr ng-repeat=\"discount in booking.bookingDiscounts track by $index\"><td ng-show=\"editedDiscount==$index\" colspan=\"6\" class=\"edited-row\"><discount-form ng-model=\"discount\"></discount-form></td><td ng-hide=\"editedDiscount==$index\" class=\"padded-left\">{{discount.title}}</td><td ng-hide=\"editedDiscount==$index\"><span ng-show=\"discount.percent\">{{\'general.other.percent\' | i18next}}</span> <span ng-hide=\"discount.percent\">{{\'general.other.fixed\' | i18next}}</span></td><td ng-hide=\"editedDiscount==$index\"><span ng-show=\"discount.percent\">{{discount.amount}}%</span> <span ng-hide=\"discount.percent\">{{discount.amount | customCurrency}}</span></td><td ng-hide=\"editedDiscount==$index\">{{discount.total | customCurrency}}</td><td ng-hide=\"editedDiscount==$index\" class=\"controls\"><a ng-click=\"editDiscounts($index)\" ng-hide=\"editedDiscount==$index\"><i tooltip=\"{{\'bookings.discounts.edit_discount_details_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"removeDiscounts($index)\" ng-hide=\"editedDiscount==$index\"><i tooltip=\"{{\'bookings.discounts.remove_discount_from_booking_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr class=\"table-form\" ng-if=\"discountsFormVisible\"><td colspan=\"6\" class=\"edited-row\"><discount-form ng-model=\"newDiscount\"></discount-form></td></tr></tbody><tfoot><tr><td class=\"new-link\"><a ng-click=\"showDiscountsForm()\"><i class=\"fa fa-plus\"></i> {{\'bookings.discounts.add_discount_new_link\' | i18next}}</a></td><td colspan=\"2\" class=\"total text-right\">{{\'bookings.discounts.discounts_total_new_link\' | i18next}}:</td><td colspan=\"2\" class=\"total\"><span class=\"summ\">{{booking.totalDiscount | customCurrency}}</span></td></tr></tfoot></table></div></div>");
$templateCache.put("templates/booking_management/bookingEmailTab_tpl.html","<h3>{{\'bookings.email.send_email_to_clients_title\' | i18next}}</h3><div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.email.send_to_label\' | i18next}}</label><md-chips ng-model=\"letter.selectedAddress\" md-separator-keys=\"delimiters\" md-require-match=\"false\" md-transform-chip=\"transformChip($chip)\" placeholder=\"Email address\" secondary-placeholder=\"Add another email address\" input-aria-label=\"Emails\" input-aria-describedby=\"customSeparatorKeyDescription\"><md-autocomplete md-no-cache=\"true\" md-selected-item=\"selectedItem\" md-items=\"address in findAddress(addressQuery)\" md-search-text=\"addressQuery\" md-escape-options=\"blur\" md-min-length=\"0\" placeholder=\"Email address\"><span>{{address.firstName}} {{address.lastName}} ({{ address.email }})</span></md-autocomplete></md-chips></md-input-container></div></div><hr class=\"separator payment-separator\"><h3>{{\'bookings.email.edit_email_content_title\' | i18next}}</h3><div class=\"row\"><div class=\"col-xs-12 email-template-title\">{{\'bookings.template_editor.choose_editor\' | i18next}}</div><div class=\"col-xs-12 email-template-wrapper\"><div class=\"email-template-builder-option\" ng-click=\"setTemplateEditor(\'basic\')\" ng-class=\'{\"active-template-builder\" : templateEditor === \"basic\"}\'>{{\'bookings.template_editor.basic\' | i18next}}</div><div class=\"email-template-builder-option\" ng-class=\'{\"active-template-builder\" : templateEditor === \"advanced\"}\' ng-click=\"setTemplateEditor(\'advanced\')\">{{\'bookings.template_editor.advanced\' | i18next}}</div></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.email.letter_subject_label\' | i18next}}</label> <input type=\"text\" ng-model=\"letter.subject\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.email.choose_template_label\' | i18next}}</label><md-select ng-model=\"letter.template_id\" ng-change=\"setAdditionalTemplate()\"><md-option value=\"default\" ng-selected=\"true\">{{\'profile_nav.settings.booking_engine.email_setup.email_templates.blank_template\' | i18next}}</md-option><md-option ng-repeat=\"template in getTemplates()\" value=\"{{template.id}}\">{{template.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12 booking-email-dropins\" ng-if=\"templateEditor === \'basic\'\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button\"><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">{{\'general.other.drop_in_s\' | i18next}}</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in dropins\"><md-button ng-click=\"insertDropIn(\'letterText\', dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu><summernote ng-model=\"letter.text\" on-paste=\"wysiwygPaste(evt)\" data-role=\"letterText\"></summernote></div><div class=\"col-xs-12 booking-email-dropins\" ng-if=\"templateEditor === \'advanced\'\"><react-email-template-builder container=\"\'letter-template\'\" base-template=\"letter.textBase\" base-template-json=\"JSON.parse(JSON.stringify(letter.text_json))\" additional-template=\"additionalTemplate\" merge-tags=\"mergeTags\" hotel-id=\"hotel.id\" email-type=\"\'newEmailTemplate\'\" should-save=\"shouldSend\" on-save=\"deliveryLetter\" on-send=\"sendTestLetter\" on-load-bee-free-token=\"onLoadBeeFreeToken\"></react-email-template-builder></div><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.email.attach_invoice_checkbox\' | i18next}}</label><md-select multiple=\"\" ng-model=\"letter.selectedFolios\"><md-option ng-repeat=\"folio in folios\" value=\"{{folio.id}}\">{{folio.visibleNumber}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-checkbox ng-model=\"letter.attachConfirmation\" aria-label=\"{{\'bookings.email.attach_confirmation_checkbox\' | i18next}}\">{{\'bookings.email.attach_confirmation_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-6\"><div class=\"text-right\"><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"letter.selectedAddress.length == 0 || letter_sending == true\" ng-click=\"setShouldDeliverLetter()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : letter_sending}\" ng-show=\"letter_sending\"></i> {{\'bookings.email.send_email_button\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/booking_management/bookingExtras_tpl.html","<h3>{{\'general.other.extras\' | i18next}}</h3><div ng-controller=\"BookingExtrasController as ctrl\"><react-booking-extras booking-extras=\"ctrl.paginatedBookingExtras\" hotel-extras=\"ctrl.extras\" hotel-extras-meta=\"ctrl.extrasMeta\" rooms=\"ctrl.rooms\" categories=\"ctrl.categories\" grouped-taxes=\"ctrl.grouppedTaxes\" deposit-extra-id=\"ctrl.depositExtraId\" create-new-extra-via-booking-enabled=\"ctrl.createNewExtraViaBookingEnabled\" removing-extra-in-progress=\"ctrl.removingExtraInProgress\" is-foreign-amount=\"ctrl.isForeignAmount\" foreign-currency-rate=\"ctrl.foreignCurrencyRate\" currency-symbol=\"ctrl.currencySymbol\" total-extras=\"ctrl.totalExtras\" min-sell-date=\"ctrl.minSellDate\" convert-currency=\"ctrl.convertCurrency\" on-save=\"ctrl.onSave\" on-delete=\"ctrl.onDelete\" on-bulk-delete=\"ctrl.onBulkDelete\" on-load-extras=\"ctrl.onLoadExtras\" is-booking-updated=\"ctrl.isBookingUpdated\" on-load-hotel-extras=\"ctrl.onLoadHotelExtras\" on-load-folios=\"ctrl.onLoadFolios\"></react-booking-extras></div>");
$templateCache.put("templates/booking_management/bookingFoliosByRoom_tpl.html","<div><div ng-controller=\"Booking.FoliosByRoomController as ctrl\"><react-folio-view-by-room accomodations-and-extras=\"ctrl.accomodationsAndExtras\" discounts=\"ctrl.discounts\" folios=\"ctrl.folios\" active-folio=\"ctrl.activeFolio\" new-taxes=\"ctrl.newTaxes\" convert-currency=\"ctrl.convertCurrency\" remove-discount=\"ctrl.removeDiscount\" generate-tax-text=\"ctrl.generateTaxText\" remove-tax=\"ctrl.removeTax\" reset-tax=\"ctrl.resetTax\" save-folio-tax=\"ctrl.saveFolioTax\" touch-selected-items-count=\"ctrl.touchSelectedItemsCount\" toggle-folio-room-selection=\"ctrl.toggleFolioRoomSelection\" toggle-folio-item-complimentary=\"ctrl.toggleFolioItemComplimentary\" toggle-folio-item-visibility=\"ctrl.toggleFolioItemVisibility\" select-accomodations-and-extras=\"ctrl.selectAccomodationsAndExtras\"></react-folio-view-by-room></div></div>");
$templateCache.put("templates/booking_management/bookingFoliosTab_tpl.html","<div class=\"table-container folios\"><div class=\"row nav-folios-block\"><div class=\"col-xs-10\"><ul class=\"nav nav-pills nav-folios\"><li ng-repeat=\"folio in visibleLinks\" ng-class=\"{\'active\' : folio.index === activeFolio}\" class=\"nav-folios--visible-link\"><a ng-click=\"openFolio(folio.index)\" class=\"nav-folios--link\"><small><i class=\"fa fa-circle\" style=\"color: {{folio.due > 0 ? \'#ed5b4f\' : (folio.due == 0 ? \'#74c971\' : \'#ffd74a\') }}\"></i></small> {{representationStatus(folio)}} #{{folio.number}}<br><small class=\"nav-folios--customer-name\">{{folio.visibleName}}</small></a></li><li role=\"presentation\" class=\"dropdown\" ng-if=\"otherLinks.length > 0\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">{{\'general.other.more\' | i18next}} <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li ng-repeat=\"folio in otherLinks\" ng-class=\"{\'active\' : folio.index === activeFolio}\"><a ng-click=\"openFolio(folio.index)\"><small><i class=\"fa fa-circle\" style=\"color: {{folio.due > 0 ? \'#ed5b4f\' : (folio.due == 0 ? \'#74c971\' : \'#ffd74a\') }}\"></i></small> {{representationStatus(folio)}} #{{folio.number}}<br><small class=\"nav-folios--customer-name\">{{folio.visibleName}}</small></a></li></ul></li></ul></div><div class=\"col-xs-2\"><ul class=\"nav nav-pills nav-folios\" ng-if=\"loadingFolios === false\"><li class=\"pull-right folios--add-folio\"><a ng-click=\"addFolio()\" ng-class=\"{\'disabled\' : addFolioInProgress}\"><i class=\"fa fa-plus\" ng-show=\"addFolioInProgress == false\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : addFolioInProgress == true}\" ng-show=\"addFolioInProgress == true\"></i> &nbsp; {{\'bookings.folios.add_folio\' | i18next}}</a></li></ul></div></div><div ng-if=\"activeFolio === null && loadingFolios === true\" class=\"text-center load-folios-spinner\"><i class=\"fa fa-spin fa-spinner\"></i></div><div ng-if=\"activeFolio === null && loadingFolios === false\" class=\"text-center\">{{\'bookings.folios.zero_folio_message\' | i18next}}<br><a ng-click=\"addFolio()\">{{\'bookings.folios.add_folio\' | i18next}}</a></div><div ng-if=\"activeFolio !== null\" class=\"folio__{{folios[activeFolio].status}}\"><ul class=\"nav nav-pills folios--actions\"><li ng-if=\"folios[activeFolio].status === \'folio\'\" ng-class=\"{\'disabled\' : !folios[activeFolio].canBeRemoved}\"><a ng-click=\"removeFolio()\"><i class=\"fa fa-trash\"></i> {{\'general.buttons.remove\' | i18next}}</a></li><li ng-class=\"{\'disabled\' : folios[activeFolio].voidInProgress === true}\" ng-click=\"voidFolio()\" ng-if=\"folios[activeFolio].status === \'invoice\'\"><a><i class=\"fa fa-trash\" ng-if=\"folios[activeFolio].voidInProgress !== true\"></i> <i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].voidInProgress === true\"></i> {{\'bookings.folios.void\' | i18next}}</a></li><li ng-class=\"{\'disabled\' : folios[activeFolio].creditInProgress === true}\" ng-click=\"creditFolio()\" ng-if=\"folios[activeFolio].status === \'receipt\' && folios[activeFolio].creditStatus === \'no_credit\'\"><a><i class=\"fa fa-trash\" ng-if=\"folios[activeFolio].creditInProgress !== true\"></i> <i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].creditInProgress === true\"></i> {{\'bookings.folios.credit\' | i18next}}</a></li><li class=\"pull-right\" ng-if=\"folios[activeFolio].status === \'folio\'\"><md-menu><a ng-click=\"openDropDown($mdOpenMenu, $event)\">{{\'bookings.folios.view_by\' | i18next}} <i class=\"fa fa-caret-down\"></i></a><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"setViewFoliosBy(\'category\')\">{{\'profile_nav.settings.hotel_profile.extras_categories.category_th\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"setViewFoliosBy(\'room\')\">{{\'checkin_dialog.room\' | i18next}}</md-button></md-menu-item></md-menu-content></md-menu></li><li class=\"pull-right\" ng-class=\"{\'disabled\': selectedPayableItemsCount == 0}\" ng-if=\"folios[activeFolio].status === \'folio\'\"><a ng-click=\"openAddDiscountForm()\"><i class=\"fa fa-percent\"></i> {{\'bookings.discounts.add_discount_new_link\' | i18next}}</a></li><li class=\"pull-right\" ng-class=\"{\'disabled\': selectedItemsCount == 0}\" ng-if=\"folios[activeFolio].status === \'folio\'\"><md-menu><a ng-click=\"openDropDown($mdOpenMenu, $event)\">{{\'bookings.folios.move_to\' | i18next}} <i class=\"fa fa-caret-down\"></i></a><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"folio in folios | filter:moveToFilter\"><md-button ng-click=\"moveItems(folio)\">{{folio.visibleNumber}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"moveItems()\">{{\'bookings.folios.new_folio\' | i18next}}</md-button></md-menu-item></md-menu-content></md-menu></li><li class=\"pull-right\"><a ng-click=\"downloadPDF()\"><i class=\"fa fa-file-pdf-o\"></i> PDF</a></li><li class=\"pull-right\"><a ng-click=\"openEmailsTab($event)\"><i class=\"fa fa-envelope\"></i> {{\'bookings.folios.send\' | i18next}}</a></li><li class=\"pull-right\"><a ng-click=\"print()\"><i class=\"fa fa-print\" ng-if=\"folios[activeFolio].printLoading != true\"></i> <i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].printLoading == true\"></i> {{\'bookings.invoice.invoice_status.print_button\' | i18next}}</a></li><li class=\"pull-right\" ng-class=\"{\'disabled\' : folios[activeFolio].createInvoiceInProgress === true}\" ng-if=\"folios[activeFolio].status === \'folio\' && folios[activeFolio].due == 0\"><a ng-click=\"createReceipt()\" ng-if=\"folios[activeFolio].due == 0\"><i class=\"fa fa-book\" ng-if=\"folios[activeFolio].createInvoiceInProgress !== true\"></i> <i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].createInvoiceInProgress === true\"></i> {{\'bookings.folios.create_receipt\' | i18next}}</a></li><li class=\"pull-right create-receipt-with-warning\" ng-if=\"folios[activeFolio].status === \'folio\' && folios[activeFolio].due != 0\"><i class=\"fa fa-exclamation-triangle\" ng-if=\"folios[activeFolio].due < 0\" tooltip-append-to-body=\"true\" tooltip=\"{{\'bookings.payment.cannot_create_invoice_warning\' | i18next}}\" style=\"color: #ffd74a\"></i> <a ng-click=\"createInvoice()\" ng-class=\"{disabled: folios[activeFolio].due < 0}\"><i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].createInvoiceInProgress === true\"></i> {{\'bookings.folios.create_invoice\' | i18next}}</a></li><li class=\"pull-right\" ng-if=\"folios[activeFolio].status === \'invoice\' && folios[activeFolio].due != 0\"><a ng-click=\"sendPaymentRequest()\"></a></li><li class=\"pull-right create-receipt-with-warning\" ng-if=\"folios[activeFolio].status === \'invoice\'\"><i class=\"fa fa-exclamation-triangle\" ng-if=\"folios[activeFolio].due != 0\" tooltip-append-to-body=\"true\" tooltip=\"{{\'bookings.payment.cannot_create_receipt_warning\' | i18next}}\" style=\"color: #ffd74a\"></i> <a ng-click=\"createReceipt()\" ng-class=\"{disabled: folios[activeFolio].due != 0}\"><i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].createInvoiceInProgress === true\"></i> {{\'bookings.folios.create_receipt\' | i18next}}</a></li></ul><div class=\"folio--customer--form\" ng-if=\"folios[activeFolio].customerEditFormIsOpened === true\"><h4>{{\'bookings.folios.edit_customer\' | i18next}}</h4><customer-form customer=\"folios[activeFolio].customer\" on-close=\"closeCustomerEditForm\" on-new-customer=\"setNewCustomer\"></customer-form></div><div class=\"folio--moveItem--interface\" ng-if=\"folios[activeFolio].moveInterfaceIsOpened === true\"><h4>{{\'bookings.folios.move_items_to\' | i18next}} {{moveItemsTargetName ? moveItemsTargetName : \'bookings.folios.new_folio\'}}</h4><div class=\"folioItem--header\"><div class=\"row\"><div class=\"col-xs-4\">{{\'bookings.folios.item\' | i18next}}</div><div class=\"col-xs-2 text-center\">{{\'bookings.folios.current_folio\' | i18next}}</div><div class=\"col-xs-4 text-center\">&rarr;</div><div class=\"col-xs-2 text-center\">{{\'bookings.folios.target_folio\' | i18next}}</div></div></div><div ng-repeat=\"item in folios[activeFolio].folioRooms | filter:{selectedAtLeastOne:true}\" class=\"folio--moveItem folio--moveItem--room\"><div class=\"row\"><div class=\"col-xs-4 folio--moveItem--title\">{{item.title}}</div><div class=\"col-xs-8\"><div class=\"row text-center\"><div class=\"col-xs-3\">{{convertCurrency(item.currentFolio)}}</div><div class=\"col-xs-6\" ng-if=\"item.amount == 0\"></div><div class=\"col-xs-6 folio--moveItem--modeSwitcher\" ng-if=\"item.amount != 0\"><a ng-click=\"switchMode(item, \'percent\')\" ng-class=\"{\'active\' : item.mode == \'percent\'}\">{{\'bookings.folios.by_percent\' | i18next}}</a> | <a ng-click=\"switchMode(item, \'amount\')\" ng-class=\"{\'active\' : item.mode == \'amount\'}\">{{\'bookings.folios.by_amount\' | i18next}}</a><br><a ng-click=\"setPredefinedMoveValue(item, 0)\" ng-class=\"{\'disabled\' : item.mode == \'count\'}\">0%</a> | <a ng-click=\"setPredefinedMoveValue(item, 50)\" ng-class=\"{\'disabled\' : item.mode == \'count\'}\">50%</a> | <a ng-click=\"setPredefinedMoveValue(item, 100)\" ng-class=\"{\'disabled\' : item.mode == \'count\'}\">100%</a></div><div class=\"col-xs-3\">{{convertCurrency(item.targetFolio)}}</div></div></div></div><div class=\"folio--moveItem--nightBreakdown\" ng-repeat=\"itemId in item.filteredFolioItems | orderBy:nightsComparator track by $index\"><div class=\"row\"><div class=\"col-xs-4 folio--nightItem\">{{\'bookings.folios.night\' | i18next}} {{folios[activeFolio].accomodationItemsById[itemId].title | date:\'d MMM yyyy\'}}</div><div class=\"col-xs-2 text-center\"><md-input-container ng-show=\"item.mode == \'amount\'\"><input type=\"number\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].currentFolio\" ng-change=\"changeCurrentPart(folios[activeFolio].accomodationItemsById[itemId])\" aria-label=\"Current Amount\" min=\"{{folios[activeFolio].accomodationItemsById[itemId].min}}\" max=\"{{folios[activeFolio].accomodationItemsById[itemId].max}}\"></md-input-container><md-input-container ng-show=\"item.mode == \'percent\'\"><input type=\"number\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].currentFolioPercent\" ng-change=\"changeCurrentPart(folios[activeFolio].accomodationItemsById[itemId])\" aria-label=\"Current Percent\" min=\"0\" max=\"100\"></md-input-container></div><div class=\"col-xs-4 text-center\" ng-if=\"folios[activeFolio].accomodationItemsById[itemId].amount == 0\"><input type=\"checkbox\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].selected\"></div><div class=\"col-xs-4 folio--moveItem--slider folio--moveItem--slider--percent\" ng-if=\"folios[activeFolio].accomodationItemsById[itemId].amount != 0\"><md-slider-container ng-show=\"item.mode == \'amount\'\"><md-slider flex=\"\" md-discrete=\"\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].targetFolio\" aria-label=\"Amount Slider\" min=\"{{folios[activeFolio].accomodationItemsById[itemId].min}}\" max=\"{{folios[activeFolio].accomodationItemsById[itemId].max}}\" ng-change=\"changeNightTargetPart(folios[activeFolio].accomodationItemsById[itemId], item)\"></md-slider></md-slider-container><md-slider-container ng-show=\"item.mode == \'percent\'\"><md-slider flex=\"\" md-discrete=\"\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].targetFolioPercent\" aria-label=\"Percent Slider\" min=\"0\" max=\"100\" ng-change=\"changeNightTargetPart(folios[activeFolio].accomodationItemsById[itemId], item)\"></md-slider></md-slider-container></div><div class=\"col-xs-2 text-center\"><md-input-container ng-show=\"item.mode == \'amount\'\"><input type=\"number\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].targetFolio\" ng-change=\"changeTargetPart(folios[activeFolio].accomodationItemsById[itemId])\" aria-label=\"Target Amount\" min=\"{{folios[activeFolio].accomodationItemsById[itemId].min}}\" max=\"{{folios[activeFolio].accomodationItemsById[itemId].max}}\"></md-input-container><md-input-container ng-show=\"item.mode == \'percent\'\"><input type=\"number\" ng-model=\"folios[activeFolio].accomodationItemsById[itemId].targetFolioPercent\" ng-change=\"changeTargetPart(folios[activeFolio].accomodationItemsById[itemId])\" aria-label=\"Target Percent\" min=\"0\" max=\"100\"></md-input-container></div></div></div></div><div ng-repeat=\"mode in [\'extraItems\', \'folioPayments\']\"><div ng-repeat=\"item in folios[activeFolio][mode] | filter:{move:true}\" class=\"folio--moveItem\" ng-class=\"{\'folio--moveItem--zeroItem\' : item.amount == 0}\"><div class=\"row\"><div class=\"col-xs-4 folio--moveItem--title\">{{item.title}}</div><div class=\"col-xs-8\"><div ng-if=\"item.amount != 0\"><div class=\"row\" ng-show=\"item.mode == \'amount\'\"><div class=\"col-xs-3 folio--moveItem--input\"><md-input-container><input type=\"number\" ng-model=\"item.currentFolio\" ng-change=\"changeCurrentPart(item)\" aria-label=\"Current Amount\" min=\"{{item.min}}\" max=\"{{item.max}}\"></md-input-container></div><div class=\"col-xs-6 folio--moveItem--slider folio--moveItem--slider--amount\"><md-slider-container><md-slider flex=\"\" md-discrete=\"\" ng-model=\"item.targetFolio\" aria-label=\"Amount Slider\" min=\"{{item.amount > 0 ? item.min : item.max}}\" max=\"{{item.amount > 0 ? item.max : item.min}}\" ng-change=\"changeTargetPart(item)\"></md-slider></md-slider-container></div><div class=\"col-xs-3 folio--moveItem--input\"><md-input-container><input type=\"number\" ng-model=\"item.targetFolio\" ng-change=\"changeTargetPart(item)\" aria-label=\"Target Amount\" min=\"{{item.min}}\" max=\"{{item.max}}\"></md-input-container></div></div><div class=\"row\" ng-show=\"item.mode == \'percent\'\"><div class=\"col-xs-3 folio--moveItem--input\"><md-input-container><input type=\"number\" ng-model=\"item.currentFolioPercent\" ng-change=\"changeCurrentPart(item)\" aria-label=\"Current Percent\" min=\"0\" max=\"100\"></md-input-container></div><div class=\"col-xs-6 folio--moveItem--slider folio--moveItem--slider--percent\"><md-slider-container><md-slider flex=\"\" md-discrete=\"\" ng-model=\"item.targetFolioPercent\" aria-label=\"Percent Slider\" min=\"0\" max=\"100\" ng-change=\"changeTargetPart(item)\"></md-slider></md-slider-container></div><div class=\"col-xs-3 folio--moveItem--input\"><md-input-container><input type=\"number\" ng-model=\"item.targetFolioPercent\" ng-change=\"changeTargetPart(item)\" aria-label=\"Target Percent\" min=\"0\" max=\"100\"></md-input-container></div></div><div class=\"row\" ng-class=\"{\'folio--sliderBlock--disabled\': item.sliderIsDisabled}\" ng-show=\"item.mode == \'count\'\"><div class=\"col-xs-3 folio--moveItem--input\"><md-input-container><input type=\"number\" ng-model=\"item.currentFolioCount\" ng-change=\"changeCountCurrentPart(item)\" aria-label=\"Current Count\" min=\"0\" max=\"{{item.count}}\"></md-input-container></div><div class=\"col-xs-6 folio--moveItem--slider folio--moveItem--slider--count\"><md-slider-container><md-slider flex=\"\" md-discrete=\"\" ng-model=\"item.targetFolioCount\" aria-label=\"Count Slider\" min=\"0\" max=\"{{item.count}}\" ng-change=\"changeCountTargetPart(item)\"></md-slider></md-slider-container></div><div class=\"col-xs-3 folio--moveItem--input\"><md-input-container><input type=\"number\" ng-model=\"item.targetFolioCount\" ng-change=\"changeCountTargetPart(item)\" aria-label=\"Target Count\" min=\"0\" max=\"{{item.count}}\"></md-input-container></div></div></div><div class=\"row text-center\"><div class=\"col-xs-3\">{{convertCurrency(item.currentFolio)}}</div><div class=\"col-xs-6 text-center\" ng-if=\"item.amount == 0\"><input type=\"checkbox\" ng-model=\"item.selected\"></div><div class=\"col-xs-6 folio--moveItem--modeSwitcher\" ng-if=\"item.amount != 0\"><a ng-click=\"switchMode(item, \'count\')\" ng-if=\"mode != \'folioPayments\'\" ng-class=\"{\'active\' : item.mode == \'count\'}\">{{\'bookings.folios.by_count\' | i18next}}</a> <span ng-if=\"mode != \'folioPayments\'\">|</span> <a ng-click=\"switchMode(item, \'percent\')\" ng-class=\"{\'active\' : item.mode == \'percent\'}\">{{\'bookings.folios.by_percent\' | i18next}}</a> | <a ng-click=\"switchMode(item, \'amount\')\" ng-class=\"{\'active\' : item.mode == \'amount\'}\">{{\'bookings.folios.by_amount\' | i18next}}</a><br><a ng-click=\"setPredefinedMoveValue(item, 0)\" ng-class=\"{\'disabled\' : item.mode == \'count\'}\">0%</a> | <a ng-click=\"setPredefinedMoveValue(item, 50)\" ng-class=\"{\'disabled\' : item.mode == \'count\'}\">50%</a> | <a ng-click=\"setPredefinedMoveValue(item, 100)\" ng-class=\"{\'disabled\' : item.mode == \'count\'}\">100%</a></div><div class=\"col-xs-3\">{{convertCurrency(item.targetFolio)}}</div></div></div></div></div></div><div ng-repeat=\"item in folios[activeFolio].taxes | filter:{move:true}\" ng-if=\"folios[activeFolio].taxesMoveIsVisible === true && user.systemRole == \'admin\'\" class=\"folio--moveItem folio--moveItem--zeroItem\"><div class=\"row\"><div class=\"col-xs-4 folio--moveItem--title\">{{item.tax}}</div><div class=\"col-xs-8\"><div class=\"row text-center\"><div class=\"col-xs-12 text-center\"><input type=\"checkbox\" ng-model=\"item.selected\"></div></div></div></div></div><div class=\"row form-control-block\"><div class=\"col-xs-6 text-left\"><md-button class=\"md-raised md-warn\" ng-click=\"closeMoveInterface()\" ng-disabled=\"folios[activeFolio].moveItemsInProgress == true\">{{\'general.buttons.cancel\' | i18next}}</md-button></div><div class=\"col-xs-6 text-right\"><md-button class=\"md-raised md-primary\" ng-disabled=\"folios[activeFolio].moveItemsInProgress == true\" ng-click=\"submitMoveInterface()\"><i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].moveItemsInProgress == true\"></i> {{\'bookings.folios.move\' | i18next}}</md-button></div></div></div><div class=\"folio--scrollable-content-block\"><div class=\"folio-discount-form\" ng-if=\"folios[activeFolio].discountFormIsOpened === true\"><div class=\"row folio-discount-form--row\"><div class=\"col-xs-6\"><md-autocomplete flex=\"\" md-input-name=\"discountQueryField\" md-search-text=\"discountQuery\" md-items=\"item in searchDiscount(discountQuery)\" md-item-text=\"item.title\" md-delay=\"700\" md-selected-item-change=\"chooseDiscount(item)\" md-no-cache=\"true\" md-floating-label=\"Discount\"><md-item-template><span>{{item.title}}</span></md-item-template></md-autocomplete></div><div class=\"col-xs-4 folio-discount-form--radio\"><md-radio-group ng-model=\"folios[activeFolio].discountIsPercent\" class=\"inline\"><md-radio-button ng-value=\"true\" ng-click=\"changeDiscount(\'discountIsPercent\', true)\">{{\'general.other.percent\' | i18next}}</md-radio-button><md-radio-button ng-value=\"false\" ng-click=\"changeDiscount(\'discountIsPercent\', false)\">{{\'general.other.fixed\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"col-xs-2\"><md-input-container><label>{{\'general.other.\' + (folios[activeFolio].discountIsPercent ? \'percent\' : \'fixed\') | i18next}}</label> <input type=\"number\" min=\"0\" ng-model=\"folios[activeFolio].discountAmount\" onkeypress=\"return (event.charCode == 8 || event.charCode == 0) ? null : (event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-10\">{{\'bookings.folios.apply_to_selected_items\' | i18next}}</div><div class=\"col-xs-2 text-right\" ng-if=\"saveFolioDiscount === true\"><i class=\"fa fa-spin fa-spinner\"></i></div><div class=\"col-xs-2 text-right\" ng-if=\"saveFolioDiscount !== true\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : folios[activeFolio].saveFolioDiscount == true}\" ng-show=\"folios[activeFolio].saveFolioDiscount == true\"></i> <i class=\"fa fa-check\" ng-show=\"folios[activeFolio].saveFolioDiscount == false\" tooltip=\"{{\'bookings.folios.apply_discount\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"applyDiscount()\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"closeAddDiscountForm()\"></i></div></div></div><div class=\"row\"><div class=\"col-xs-6 folio-customer-block\"><span ng-if=\"folios[activeFolio].status === \'folio\'\">{{\'bookings.folios.folio_for\' | i18next}}:</span> <span ng-if=\"folios[activeFolio].status === \'receipt\'\">{{\'bookings.folios.receipt_for\' | i18next}}:</span> <span ng-if=\"folios[activeFolio].status === \'invoice\'\">{{\'bookings.folios.invoice_for\' | i18next}}:</span> <span ng-if=\"folios[activeFolio].status === \'voided\'\">{{\'bookings.folios.voided_invoice_for\' | i18next}}:</span><div class=\"folios--findCustomer\" ng-if=\"folios[activeFolio].findCustomerFormIsOpened == true\"><select-customer-input customer-query=\"customerInfo.query\" on-change=\"chooseCustomer\"></select-customer-input><div class=\"folios--findCustomer--controls text-right\"><i class=\"fa fa-check\" ng-if=\"folios[activeFolio].selectedCustomer\" tooltip=\"{{\'bookings.folios.set_customer\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"applyFindedCustomer()\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleFindCustomerForm()\"></i></div></div><div ng-if=\"folios[activeFolio].customerEditFormIsOpened !== true && folios[activeFolio].findCustomerFormIsOpened !== true\"><h4><span ng-if=\"folios[activeFolio].customer.customerType === 0\"><span ng-if=\"folios[activeFolio].customer.firstName\">{{folios[activeFolio].customer.firstName}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'firstName\')\" ng-if=\"!folios[activeFolio].customer.firstName\">{{\'general.other.first_name\' | i18next}}</span> <span ng-if=\"folios[activeFolio].customer.lastName\">{{folios[activeFolio].customer.lastName}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'lastName\')\" ng-if=\"!folios[activeFolio].customer.lastName\">{{\'general.other.last_name\' | i18next}}</span></span> <span ng-if=\"folios[activeFolio].customer.customerType === 1\"><span ng-if=\"folios[activeFolio].customer.companyName\">{{folios[activeFolio].customer.companyName}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'companyName\')\" ng-if=\"!folios[activeFolio].customer.companyName\">{{\'bookings.customer.company_name_label\' | i18next}}</span></span><md-menu ng-if=\"folios[activeFolio].status != \'receipt\'\"><i class=\"fa fa-edit\" ng-click=\"openDropDown($mdOpenMenu, $event)\" tooltip=\"{{\'bookings.folios.change_customer\' | i18next}}\"></i><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"toggleFindCustomerForm()\">{{\'bookings.folios.find_customer\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"createNewCustomer()\">{{\'bookings.folios.create_new_customer\' | i18next}}</md-button></md-menu-item><md-menu-divider ng-if=\"otherBookingCustomers.length > 1 || bookingGuests.length > 0\"></md-menu-divider><md-menu-item ng-repeat=\"customer in otherBookingCustomers | filter:{id:\'!\' + folios[activeFolio].customer.id}\"><md-button ng-click=\"changeCustomerTo(customer.id)\">{{customer.visibleName}}</md-button></md-menu-item><md-menu-item ng-repeat=\"guest in bookingGuests | filter:{customerId:\'!\' + folios[activeFolio].customer.id}\"><md-button ng-click=\"changeGuestToCustomer(guest)\">{{guest.visibleName}}</md-button></md-menu-item></md-menu-content></md-menu></h4><span ng-if=\"folios[activeFolio].customer.address\">{{folios[activeFolio].customer.address}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'address\')\" ng-if=\"!folios[activeFolio].customer.address\">{{\'customer.customer_page.address\' | i18next}}</span>, <span ng-if=\"folios[activeFolio].customer.city\">{{folios[activeFolio].customer.city}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'city\')\" ng-if=\"!folios[activeFolio].customer.city\">{{\'bookings.invoice.client_info.city\' | i18next}}</span>, <span ng-if=\"folios[activeFolio].customer.zipCode\">{{folios[activeFolio].customer.zipCode}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'zipCode\')\" ng-if=\"!folios[activeFolio].customer.zipCode\">{{\'customer.customer_page.postal_code\' | i18next}}</span>, <span ng-if=\"folios[activeFolio].customer.country\">{{folios[activeFolio].customer.country}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'country\')\" ng-if=\"!folios[activeFolio].customer.country\">{{\'customer.customer_page.country\' | i18next}}</span>, <span ng-if=\"folios[activeFolio].customer.nationalIdNumber\">{{\'bookings.customer.national_identification_number_short\' | i18next}}: {{folios[activeFolio].customer.nationalIdNumber}}</span> <span class=\"folio--customer--empty\" ng-click=\"openCustomerEditForm(\'nationalIdNumber\')\" ng-if=\"!folios[activeFolio].customer.nationalIdNumber\">{{\'bookings.customer.national_identification_number\' | i18next}}</span></div></div><div class=\"col-xs-6 text-right folios--number\" ng-class=\"{\'folio--number-folio\' : folios[activeFolio].status == \'folio\'}\" ng-if=\"folios[activeFolio].sendEmailFormIsOpened !== true && folios[activeFolio].numberEditFormIsOpened !== true && folios[activeFolio].dateEditFormIsOpened !== true && folios[activeFolio].taxDateEditFormIsOpened !== true\"><div class=\"folio--folio-status\">Status: <strong>{{representationStatus(folios[activeFolio])}}</strong></div><div ng-if=\"folios[activeFolio].status === \'folio\' && booking.isForeignAmount()\">{{\'bookings.currency\' | i18next}}: <i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].toggleIsForeignCurrencyLoading === true\"></i> <strong ng-if=\"folios[activeFolio].toggleIsForeignCurrencyLoading !== true\">{{folios[activeFolio].isForeignAmount ? booking.foreignCurrency : defaultCurrency}}</strong><md-menu ng-if=\"folios[activeFolio].toggleIsForeignCurrencyLoading !== true\"><i class=\"fa fa-edit\" ng-click=\"openDropDown($mdOpenMenu, $event)\"></i><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"toggleIsForeignAmount(false)\">{{defaultCurrency}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"toggleIsForeignAmount(true)\">{{booking.foreignCurrency}}</md-button></md-menu-item></md-menu-content></md-menu><br></div>{{\'bookings.folios.number_short\' | i18next}}: <strong>{{folios[activeFolio].number}}</strong> <i class=\"fa fa-edit\" ng-click=\"toggleEditFolioNumber()\" ng-if=\"folios[activeFolio].status !== \'folio\' && folios[activeFolio].status !== \'receipt\' && allowChangeInvoiceNumberFeature === true\"></i><br>{{\'bookings.folios.date\' | i18next}}: {{folios[activeFolio].date | dateToMoment:\'MMM DD, YYYY\'}}<i class=\"fa fa-edit\" ng-click=\"toggleEditFolioDate()\" ng-if=\"folios[activeFolio].status !== \'voided\' && folios[activeFolio].status !== \'receipt\' && allowChangeInvoiceDateFeature === true\"></i> <span ng-if=\"folios[activeFolio].status != \'folio\'\"><br>{{\'bookings.folios.tax_date\' | i18next}}: {{folios[activeFolio].taxDate | dateToMoment:\'MMM DD, YYYY\'}} <i class=\"fa fa-edit\" ng-click=\"toggleEditFolioTaxDate()\" ng-if=\"folios[activeFolio].status !== \'voided\' && folios[activeFolio].status !== \'receipt\'\"></i></span></div><div class=\"col-xs-6 text-left folios--number folios--number--form\" ng-if=\"folios[activeFolio].numberEditFormIsOpened === true\"><md-input-container><label>{{\'bookings.folios.number\' | i18next}}</label> <input type=\"text\" ng-model=\"folios[activeFolio].editableNumber\"></md-input-container><div class=\"text-left pull-left\"><small class=\"folios--number--warning\"><i class=\"fa fa-exclamation-circle\"></i> {{\'bookings.folios.number_warning\' | i18next}}</small></div><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleEditFolioNumber(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleEditFolioNumber(false)\"></i></div></div><div class=\"col-xs-6 text-left folios--number folios--number--form\" ng-if=\"folios[activeFolio].dateEditFormIsOpened === true\"><div class=\"date-col\"><label class=\"datepicker\">{{\'general.other.date\' | i18next}}</label><md-datepicker ng-model=\"folios[activeFolio].editableDate\"></md-datepicker></div><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleEditFolioDate(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleEditFolioDate(false)\"></i></div></div><div class=\"col-xs-6 text-left folios--number folios--number--form\" ng-if=\"folios[activeFolio].taxDateEditFormIsOpened === true\"><div class=\"date-col\"><label class=\"datepicker\">{{\'general.other.date\' | i18next}}</label><md-datepicker ng-model=\"folios[activeFolio].editableTaxDate\"></md-datepicker></div><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleEditFolioTaxDate(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleEditFolioTaxDate(false)\"></i></div></div><div class=\"col-xs-6 text-left folios--number folios--number--form\" ng-if=\"folios[activeFolio].sendEmailFormIsOpened === true\"><md-input-container><label>{{\'general.other.email\' | i18next}}</label> <input type=\"text\" ng-model=\"folios[activeFolio].email\"></md-input-container><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleSendInterface(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"toggleSendInterface(false)\"></i></div></div></div><div ng-if=\"viewFoliosBy === \'category\'\"><div ng-if=\"folios[activeFolio].folioRooms.length !== 0\"><h4>{{\'reports.debtors_report.accomodation_th\' | i18next}}</h4><div class=\"folioItem--header\"><div class=\"row\"><div class=\"col-xs-6 folioItem--titleColumn\">{{\'general.other.title\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'general.other.count\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'bookings.invoice.charges.net_th\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'general.other.taxes\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'customer.bookings_list.total\' | i18next}}</div></div></div><div ng-repeat=\"folioItem in folios[activeFolio].folioRooms\" class=\"folioItem\"><div class=\"row folioItem--details\"><div class=\"col-xs-6 folioItem--titleColumn\"><input type=\"checkbox\" data-room-check=\"{{folios[activeFolio].id}}-{{folioItem.id}}\" ng-model=\"folioItem.selected\" ng-change=\"toggleFolioRoomSelection(folioItem)\" ng-disabled=\"folios[activeFolio].status !== \'folio\'\"> {{folioItem.title}} ({{\'general.other.room\' | i18next}}: {{folioItem.room}}, {{folioItem.ratePlan}})</div><div class=\"col-xs-1-5 text-right\">{{folioItem.count}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioItem.net)}}</div><div class=\"col-xs-1-5 text-right\"><span ng-click=\"toggleShowTaxBreakdown(folioItem)\">{{convertCurrency(folioItem.taxes.total)}}</span></div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioItem.amountWithTaxes)}}</div></div><div class=\"row folioItem--discount\" ng-repeat=\"folioDiscount in folioItem.discounts\"><div class=\"col-xs-12 folioItem--titleColumn\">{{\'bookings.total.discount_span\' | i18next}}: {{folioDiscount.title}} -{{convertCurrency(folioDiscount.amount)}}</div></div><div class=\"row folioItem--discount\"><div class=\"col-xs-12 folioItem--titleColumn\"><a class=\"folioItem--breakdownLink\" ng-click=\"toggleShowNightBreakdown(folioItem)\">{{\'bookings.folios.nights_breakdown\' | i18next}} <i class=\"fa fa-caret-up\" ng-if=\"folioItem.showNightBreakdown === true\"></i> <i class=\"fa fa-caret-down\" ng-if=\"folioItem.showNightBreakdown !== true\"></i></a> <a class=\"folioItem--breakdownLink\" ng-click=\"toggleShowTaxBreakdown(folioItem)\">{{\'bookings.folios.tax_breakdown\' | i18next}} <i class=\"fa fa-caret-up\" ng-if=\"folioItem.showTaxBreakdown === true\"></i> <i class=\"fa fa-caret-down\" ng-if=\"folioItem.showTaxBreakdown !== true\"></i></a></div></div><div ng-if=\"folioItem.showNightBreakdown === true\" ng-repeat=\"folioItemId in folioItem.folioItems | orderBy:nightsComparator\" class=\"folioItem--nights\"><div class=\"row folioItem--night\"><div class=\"col-xs-6 folioItem--titleColumn\"><input type=\"checkbox\" ng-model=\"folios[activeFolio].accomodationItemsById[folioItemId].selected\" ng-change=\"touchSelectedItemsCount(folios[activeFolio].accomodationItemsById[folioItemId])\" ng-disabled=\"folios[activeFolio].status !== \'folio\'\"> {{\'bookings.folios.night\' | i18next}} {{folios[activeFolio].accomodationItemsById[folioItemId].title | date:\'d MMM yyyy\'}} <span ng-if=\"folios[activeFolio].accomodationItemsById[folioItemId].isSplitted\">({{\'bookings.folios.splitted_item\' | i18next}})</span></div><div class=\"col-xs-3 text-right\">{{convertCurrency(folios[activeFolio].accomodationItemsById[folioItemId].net)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].accomodationItemsById[folioItemId].taxes.total)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].accomodationItemsById[folioItemId].amountWithTaxes)}}</div></div><div><div class=\"row folioItem--discount\" ng-repeat=\"folioDiscount in folios[activeFolio].accomodationItemsById[folioItemId].folioDiscounts\"><div class=\"col-xs-12 folioItem--titleColumn\">{{\'bookings.total.discount_span\' | i18next}}: {{folioDiscount.title}} (<span ng-if=\"folioDiscount.discountType === \'fixed\'\">{{convertCurrency(folioDiscount.value)}}</span><span ng-if=\"folioDiscount.discountType === \'percent\'\">{{folioDiscount.value}}%</span>) -{{convertCurrency(folioDiscount.amount)}} <a class=\"folioItem--discount--remove\" ng-click=\"removeDiscount(folioDiscount.id)\" ng-if=\"folios[activeFolio].status != \'receipt\'\">{{\'general.buttons.remove\' | i18next}}</a></div></div></div><div ng-if=\"folioItem.showTaxBreakdown === true && folioItem.showNightBreakdown === true\"><div class=\"row folioItem--tax\" ng-repeat=\"folioTax in folios[activeFolio].accomodationItemsById[folioItemId].taxes.included\"><div ng-if=\"folioTax.editMode !== true\"><div class=\"col-xs-6 folioItem--titleColumn\">{{folioTax.tax}} <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"removeTax(folioTax)\">{{\'general.buttons.remove\' | i18next}}</a> <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"editTax(folioTax)\">{{\'general.buttons.edit\' | i18next}}</a></div><div class=\"col-xs-3 text-right\">{{generateTaxText(folioTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioTax.amount)}}</div></div><div ng-if=\"folioTax.editMode === true\" class=\"col-xs-12\"><folio-tax-form folio-tax=\"folioTax\" folio-item-id=\"folioItemId\" folio=\"folios[activeFolio]\" on-save=\"saveFolioTax\" on-reset=\"resetTax\"></folio-tax-form></div></div><div class=\"row folioItem--tax\" ng-repeat=\"folioTax in folios[activeFolio].accomodationItemsById[folioItemId].taxes.excluded\"><div ng-if=\"folioTax.editMode !== true\"><div class=\"col-xs-6 folioItem--titleColumn\">{{folioTax.tax}} ({{\'booking.taxes.excluded\' | i18next}}) <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"removeTax(folioTax)\">{{\'general.buttons.remove\' | i18next}}</a> <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"editTax(folioTax)\">{{\'general.buttons.edit\' | i18next}}</a></div><div class=\"col-xs-3 text-right\">{{generateTaxText(folioTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioTax.amount)}}</div></div><div ng-if=\"folioTax.editMode === true\" class=\"col-xs-12\"><folio-tax-form folio-tax=\"folioTax\" folio-item-id=\"folioItemId\" folio=\"folios[activeFolio]\" on-save=\"saveFolioTax\" on-reset=\"resetTax\"></folio-tax-form></div></div><div class=\"row folioItem--tax\"><folio-tax-form ng-if=\"folios[activeFolio].accomodationItemsById[folioItemId].newTax && folios[activeFolio].accomodationItemsById[folioItemId].newTax.editMode === true\" folio-tax=\"folios[activeFolio].accomodationItemsById[folioItemId].newTax\" folio-item-id=\"folioItemId\" folio=\"folios[activeFolio]\" on-save=\"saveFolioTax\"></folio-tax-form><div class=\"col-xs-6 folioItem--titleColumn\"><a ng-click=\"addTax(folios[activeFolio].accomodationItemsById[folioItemId])\" ng-if=\"folios[activeFolio].status === \'folio\'\"><i class=\"fa fa-plus-circle\"></i> {{\'profile_nav.settings.hotel_profile.taxe_new.add_tax_or_fee\' | i18next}}</a></div></div></div></div><div ng-if=\"folioItem.showTaxBreakdown === true && folioItem.showNightBreakdown !== true\"><div class=\"row folioItem--tax\" ng-repeat=\"folioTax in folioItem.taxes.included\"><div class=\"col-xs-6 folioItem--titleColumn\">{{folioTax.tax}}</div><div class=\"col-xs-3 text-right\">{{generateTaxText(folioTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioTax.amount)}}</div></div><div class=\"row folioItem--tax\" ng-repeat=\"folioTax in folioItem.taxes.excluded\"><div class=\"col-xs-6 folioItem--titleColumn\">{{folioTax.tax}} ({{\'booking.taxes.excluded\' | i18next}})</div><div class=\"col-xs-3 text-right\"><span ng-if=\"folioTax.calculationLogic == \'fixed\'\">{{convertCurrency(folioTax.value) }}</span> <span ng-if=\"folioTax.calculationLogic == \'percent\'\">{{folioTax.value}}%</span> <span ng-if=\"folioTax.calculationLogic != \'fixed\' && folioTax.calculationLogic != \'percent\'\">{{convertCurrency(folioTax.value) }} {{\'general.other.\' + folioTax.calculationLogic | i18next}}</span> <span ng-if=\"folioTax.taxedAmount && folioTax.calculationLogic == \'percent\'\">({{convertCurrency(folioTax.taxedAmount)}})</span></div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioTax.amount)}}</div></div></div></div><div class=\"folioItem--total\"><div class=\"row\"><div class=\"col-xs-7-5 text-right\">{{\'customer.bookings_list.total\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].accomodationTotalNet)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].accomodationTotalTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].accomodationTotalAmount)}}</div></div></div></div><div ng-if=\"folios[activeFolio].extraItems.length !== 0\"><h4>{{\'general.other.extras\' | i18next}}</h4><div class=\"folioItem--header\"><div class=\"row\"><div class=\"col-xs-6 folioItem--titleColumn\">{{\'general.other.title\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'general.other.count\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'bookings.invoice.charges.net_th\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'general.other.taxes\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{\'customer.bookings_list.total\' | i18next}}</div></div></div><div ng-repeat=\"folioItem in folios[activeFolio].extraItems\" class=\"folioItem\"><div class=\"row folioItem--details\"><div class=\"col-xs-6 folioItem--titleColumn\"><input type=\"checkbox\" ng-model=\"folioItem.selected\" ng-change=\"touchSelectedItemsCount(folioItem)\" ng-disabled=\"folios[activeFolio].status !== \'folio\'\"> {{folioItem.title}} <span ng-if=\"folioItem.isSplitted || folioItem.room\">( <span ng-if=\"folioItem.room\">{{\'general.other.room\' | i18next}} {{folioItem.room}}</span> <span ng-if=\"folioItem.isSplitted\">, {{\'bookings.folios.splitted_item\' | i18next}}</span> )</span><div class=\"pull-right\" ng-if=\"folios[activeFolio].status === \'folio\'\"><i class=\"fa folioItem--visibility\" ng-class=\"{ \'folioItem--visibility--active\' : folioItem.isVisible == false, \'fa-eye-slash\' : folioItem.isVisible == false, \'fa-eye\' : folioItem.isVisible == true }\" ng-click=\"toggleFolioItemVisibility(folioItem)\" tooltip=\"{{\'bookings.folios.show_hide\' | i18next}}\" tooltip-append-to-body=\"true\"></i> <i class=\"fa folioItem--visibility\" ng-if=\"folioItem.amountWithTaxes == 0\" ng-class=\"{ \'folioItem--visibility--active\' : folioItem.isComplimentary == true, \'fa-gift\' : folioItem.isComplimentary == true, \'fa-money\' : folioItem.isComplimentary == false, }\" ng-click=\"toggleFolioItemComplimentary(folioItem)\" tooltip=\"{{\'bookings.folios.show_as_complimentary\' | i18next}}\" tooltip-append-to-body=\"true\"></i></div></div><div class=\"col-xs-1-5 text-right\">{{folioItem.count}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioItem.net)}}</div><div class=\"col-xs-1-5 text-right\"><span ng-click=\"toggleShowTaxBreakdown(folioItem)\">{{convertCurrency(folioItem.taxes.total)}}</span></div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioItem.amountWithTaxes)}}</div></div><div class=\"row folioItem--discount\" ng-repeat=\"folioDiscount in folioItem.folioDiscounts\"><div class=\"col-xs-12 folioItem--titleColumn\">{{\'bookings.total.discount_span\' | i18next}}: {{folioDiscount.title}} (<span ng-if=\"folioDiscount.discountType === \'fixed\'\">{{convertCurrency(folioDiscount.value)}}</span><span ng-if=\"folioDiscount.discountType === \'percent\'\">{{folioDiscount.value}}%</span>) -{{convertCurrency(folioDiscount.amount)}} <a ng-click=\"removeDiscount(folioDiscount.id)\">{{\'general.buttons.remove\' | i18next}}</a></div></div><div class=\"row folioItem--discount\"><div class=\"col-xs-12 folioItem--titleColumn\"><a class=\"folioItem--breakdownLink\" ng-click=\"toggleShowTaxBreakdown(folioItem)\">{{\'bookings.folios.tax_breakdown\' | i18next}} <i class=\"fa fa-caret-up\" ng-if=\"folioItem.showTaxBreakdown === true\"></i> <i class=\"fa fa-caret-down\" ng-if=\"folioItem.showTaxBreakdown !== true\"></i></a></div></div><div ng-if=\"folioItem.showTaxBreakdown === true\"><div class=\"row folioItem--tax folioItem--extraTax\" ng-repeat=\"folioTax in folioItem.taxes.included\"><div ng-if=\"folioTax.editMode !== true\"><div class=\"col-xs-6 folioItem--titleColumn\">{{folioTax.tax}} <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"removeTax(folioTax)\">{{\'general.buttons.remove\' | i18next}}</a> <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"editTax(folioTax)\">{{\'general.buttons.edit\' | i18next}}</a></div><div class=\"col-xs-3 text-right\">{{generateTaxText(folioTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioTax.amount)}}</div></div><div ng-if=\"folioTax.editMode === true\" class=\"col-xs-12\"><folio-tax-form folio-tax=\"folioTax\" folio-item-id=\"folioItem.id\" folio=\"folios[activeFolio]\" on-save=\"saveFolioTax\" on-reset=\"resetTax\"></folio-tax-form></div></div><div class=\"row folioItem--tax folioItem--extraTax\" ng-repeat=\"folioTax in folioItem.taxes.excluded\"><div ng-if=\"folioTax.editMode !== true\"><div class=\"col-xs-6 folioItem--titleColumn\">{{folioTax.tax}} ({{\'booking.taxes.excluded\' | i18next}}) <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"removeTax(folioTax)\">{{\'general.buttons.remove\' | i18next}}</a> <a class=\"control\" ng-if=\"folios[activeFolio].status === \'folio\'\" ng-click=\"editTax(folioTax)\">{{\'general.buttons.edit\' | i18next}}</a></div><div class=\"col-xs-3 text-right\">{{generateTaxText(folioTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folioTax.amount)}}</div></div><div ng-if=\"folioTax.editMode === true\" class=\"col-xs-12\"><folio-tax-form folio-tax=\"folioTax\" folio-item-id=\"folioItem.id\" folio=\"folios[activeFolio]\" on-save=\"saveFolioTax\" on-reset=\"resetTax\"></folio-tax-form></div></div><div class=\"row folioItem--tax folioItem--new--extraTax\"><folio-tax-form ng-if=\"folioItem.newTax && folioItem.newTax.editMode === true\" folio-tax=\"folioItem.newTax\" folio-item-id=\"folioItem.id\" folio=\"folios[activeFolio]\" on-save=\"saveFolioTax\"></folio-tax-form><div class=\"col-xs-6 folioItem--titleColumn\"><a ng-click=\"addTax(folioItem)\" ng-if=\"folios[activeFolio].status === \'folio\'\"><i class=\"fa fa-plus-circle\"></i> {{\'profile_nav.settings.hotel_profile.taxe_new.add_tax_or_fee\' | i18next}}</a></div></div></div></div><div class=\"folioItem--total\"><div class=\"row\"><div class=\"col-xs-7-5 text-right\">{{\'customer.bookings_list.total\' | i18next}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].extraTotalNet)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].extraTotalTax)}}</div><div class=\"col-xs-1-5 text-right\">{{convertCurrency(folios[activeFolio].extraTotalAmount)}}</div></div></div></div></div><div ng-if=\"viewFoliosBy === \'room\' && convertCurrency && (folios[activeFolio].folioRooms.length !== 0 || folios[activeFolio].extraItems.length !== 0)\"><booking-folios-by-room accomodations-and-extras=\"accomodationsAndExtrasByRoom\" discounts=\"discounts\" folios=\"folios\" active-folio=\"activeFolio\" new-taxes=\"newTaxes\" convert-currency=\"convertCurrency\" remove-discount=\"removeDiscount\" generate-tax-text=\"generateTaxText\" remove-tax=\"removeTax\" reset-tax=\"resetTax\" save-folio-tax=\"saveFolioTax\" touch-selected-items-count=\"touchSelectedItemsCount\" toggle-folio-room-selection=\"toggleFolioRoomSelection\" toggle-folio-item-complimentary=\"toggleFolioItemComplimentary\" toggle-folio-item-visibility=\"toggleFolioItemVisibility\" select-accomodations-and-extras=\"selectAccomodationsAndExtras\"></booking-folios-by-room></div><div ng-if=\"folios[activeFolio].haveFeeOrCityTax === true && user.systemRole == \'admin\'\"><h4>Fees And City Taxes</h4><div><div class=\"folioItem--header\"><div class=\"row\"><div class=\"col-xs-6 folioItem--titleColumn\">{{\'general.other.title\' | i18next}}</div><div class=\"col-xs-4\"></div><div class=\"col-xs-2 text-right\">{{\'general.other.amount\' | i18next}}</div></div></div><div ng-repeat=\"tax in folios[activeFolio].taxes.filter(feeOrCityTaxFilter)\" class=\"folioItem\"><div class=\"row folioItem--details\"><div class=\"col-xs-5 folioItem--titleColumn\"><input type=\"checkbox\" ng-disabled=\"folios[activeFolio].status != \'folio\'\" ng-model=\"tax.selected\" ng-change=\"touchSelectedItemsCount(tax)\"> {{tax.tax}} ({{tax.calculationMethod}})</div><div class=\"col-xs-5 text-right\">{{generateTaxText(tax)}}</div><div class=\"col-xs-2 text-right\">{{convertCurrency(tax.amount)}}</div></div></div></div><br></div><div ng-if=\"folios[activeFolio].folioPayments.length > 0 || folios[activeFolio].status != \'voided\'\"><h4>{{\'bookings.invoice.payments.title\' | i18next}}</h4><div ng-if=\"folios[activeFolio].folioPayments.length !== 0\"><div class=\"folioItem--header\"><div class=\"row\"><div class=\"col-xs-8 folioItem--titleColumn\">{{\'general.other.title\' | i18next}}</div><div class=\"col-xs-2\">{{\'general.other.date\' | i18next}}</div><div class=\"col-xs-2 text-right\">{{\'general.other.amount\' | i18next}}</div></div></div><div ng-repeat=\"folioPayment in folios[activeFolio].folioPayments\" class=\"folioItem\" ng-class=\"{\'folioItem--deposit\' : folioPayment.calculable == false}\"><div class=\"row folioItem--details\"><div class=\"col-xs-8 folioItem--titleColumn\"><input type=\"checkbox\" ng-disabled=\"folios[activeFolio].status != \'folio\'\" ng-model=\"folioPayment.selected\" ng-change=\"touchSelectedItemsCount(folioPayment)\"> {{folioPayment.paymentType}} {{showOperation(folioPayment)}}<br><small>{{folioPayment.description}}</small></div><div class=\"col-xs-2\">{{folioPayment.createdAt | date}}</div><div class=\"col-xs-2 text-right\">{{convertCurrency(folioPayment.amount)}}</div></div></div><div class=\"folioItem--total\"><div class=\"row\"><div class=\"col-xs-8\"></div><div class=\"col-xs-2\">{{\'customer.bookings_list.total\' | i18next}}</div><div class=\"col-xs-2 text-right\">{{convertCurrency(folios[activeFolio].totalPaid)}}</div></div><div class=\"row\"><div class=\"col-xs-8\"></div><div class=\"col-xs-2\">{{\'bookings.folios.total_charged\' | i18next}}</div><div class=\"col-xs-2 text-right\">{{convertCurrency(folios[activeFolio].totalCharged)}}</div></div></div></div><div class=\"text-center\" ng-if=\"folios[activeFolio].due != 0\"><span ng-if=\"folios[activeFolio].folioPayments.length === 0\">{{\'bookings.folios.zero_payments_message\' | i18next}}</span><br><a ng-click=\"openPaymentsTab($event)\">{{\'bookings.folios.create_payment\' | i18next}}</a><span ng-if=\"folios[activeFolio].status == \'invoice\'\">or {{\'bookings.folios.move_payments\' | i18next}}:</span><div class=\"folioItem--header\" ng-if=\"folios[activeFolio].status == \'invoice\'\"><div class=\"row\"><div class=\"col-xs-8 folioItem--titleColumn text-left\">{{\'general.other.title\' | i18next}}</div><div class=\"col-xs-2\">{{\'general.other.from\' | i18next}}</div><div class=\"col-xs-2 text-right\">{{\'general.other.amount\' | i18next}}</div></div></div><div class=\"folioItem\" ng-repeat=\"folioPayment in availablePayments\" ng-if=\"folios[activeFolio].status == \'invoice\'\"><div class=\"row folioItem--details\"><div class=\"col-xs-8 folioItem--titleColumn text-left\"><input type=\"checkbox\" ng-model=\"folioPayment.selected\" ng-change=\"changeSelectedPayments()\"> {{folioPayment.paymentType}} {{showOperation(folioPayment)}}</div><div class=\"col-xs-2\">{{folioPayment.folioNumber}}</div><div class=\"col-xs-2 text-right\">{{convertCurrency(folioPayment.amount)}}</div></div></div><i class=\"fa fa-exclamation-triangle\" tooltip-append-to-body=\"true\" tooltip=\"{{\'bookings.payment.cannot_create_receipt_warning\' | i18next}}\" style=\"color: #ffd74a\" ng-if=\"folios[activeFolio].status == \'invoice\' && !moveAndDoReceiptAllowed\"></i> <a ng-click=\"movePaymentsAndCreateReceipt()\" ng-class=\"{disabled: !moveAndDoReceiptAllowed}\" ng-if=\"folios[activeFolio].status == \'invoice\'\"><i class=\"fa fa-spin fa-spinner\" ng-if=\"folios[activeFolio].createInvoiceInProgress === true\"></i> {{\'bookings.folios.move_payments_and_create_receipt\' | i18next}}</a></div></div><div class=\"row\"><div class=\"col-xs-5 folios--notes\"><div ng-if=\"folios[activeFolio].noteOverride || defaultNoteText\"><div class=\"folios--notes--value\" ng-if=\"folios[activeFolio].overrideNoteEditIsEnabled !== true\"><span ng-if=\"folios[activeFolio].noteOverride\">{{folios[activeFolio].noteOverride}}</span> <span ng-if=\"!folios[activeFolio].noteOverride\">{{defaultNoteText}}</span> <i class=\"fa fa-edit\" tooltip=\"{{\'bookings.folios.override_default_notes\'| i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"enableOverrideNoteEditMode()\"></i></div><div ng-if=\"folios[activeFolio].overrideNoteEditIsEnabled === true\"><md-input-container><label>{{\'bookings.customer.notes_label\' | i18next}}</label> <textarea class=\"folios--notes--editableOverrideNote\" ng-model=\"folios[activeFolio].editableOverrideNote\"></textarea></md-input-container><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"disableOverrideNoteEditMode(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"disableOverrideNoteEditMode(false)\"></i></div></div></div><div><div class=\"folios--notes--value\" ng-if=\"folios[activeFolio].noteEditIsEnabled !== true\"><span ng-if=\"folios[activeFolio].note\">{{folios[activeFolio].note}}</span> <span ng-if=\"!folios[activeFolio].note\" class=\"folios--notes--empty\">{{\'bookings.folios.notes_message\' | i18next}}</span> <i class=\"fa fa-edit\" tooltip=\"{{\'bookings.folios.edit_note\'| i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"enableNoteEditMode()\"></i></div><div ng-if=\"folios[activeFolio].noteEditIsEnabled === true\"><md-input-container><label>{{\'bookings.customer.notes_label\' | i18next}}</label> <textarea class=\"folios--notes--editableNote\" ng-model=\"folios[activeFolio].editableNote\"></textarea></md-input-container><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"disableNoteEditMode(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"disableNoteEditMode(false)\"></i></div></div></div><div><div class=\"folios--notes--value\" ng-if=\"folios[activeFolio].overlayEditIsEnabled !== true\"><span ng-if=\"folios[activeFolio].overlayText\">{{folios[activeFolio].overlayText}}</span> <span ng-if=\"!folios[activeFolio].overlayText\" class=\"folios--notes--empty\">{{\'bookings.folios.overlay_message\' | i18next}}</span> <i class=\"fa fa-edit\" tooltip=\"{{\'bookings.folios.edit_overlay\'| i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"enableOverlayEditMode()\"></i></div><div ng-if=\"folios[activeFolio].overlayEditIsEnabled === true\"><md-input-container><label>{{\'bookings.customer.overlay_label\' | i18next}}</label> <textarea class=\"folios--notes--editableOverlay\" ng-model=\"folios[activeFolio].editableOverlay\"></textarea></md-input-container><div class=\"text-right\"><i class=\"fa fa-check\" tooltip=\"{{\'general.buttons.save\'|i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"disableOverlayEditMode(true)\"></i> <i class=\"fa fa-times\" tooltip=\"{{\'general.buttons.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" ng-click=\"disableOverlayEditMode(false)\"></i></div></div></div></div><div class=\"col-xs-7 text-right\"><h2>{{\'customer.bookings_list.total\' | i18next}}: {{convertCurrency(folios[activeFolio].total)}}</h2><div ng-if=\"folios[activeFolio].totalDiscount > 0\">{{\'bookings.folios.total_discount\' | i18next}}: -{{convertCurrency(folios[activeFolio].totalDiscount)}}</div><div>{{\'bookings.folios.accomodation_subtotal\' | i18next}}: {{convertCurrency(folios[activeFolio].accomodationTotalNet)}}</div><div>{{\'bookings.folios.extra_subtotal\' | i18next}}: {{convertCurrency(folios[activeFolio].extraTotalNet)}}<br></div><div ng-repeat=\"tax in folios[activeFolio].taxes\">{{tax.tax}} {{generateTaxText(tax)}}: {{convertCurrency(tax.amount)}}</div><div>{{\'bookings.folios.due\' | i18next}}: {{convertCurrency(folios[activeFolio].due)}}</div></div></div></div></div></div>");
$templateCache.put("templates/booking_management/bookingGuestAttachment_tpl.html","<div class=\"booking-guest-attachment\">{{name}} <a href=\"{{attachment.attachment.url}}\" ng-if=\"attachment.attachment\" target=\"_blank\">Link</a><md-button class=\"md-primary\" ng-class=\"{\'md-success\': attachment.files.length > 0}\"><span class=\"image_upload\"><i class=\"fa fa-check\" ng-if=\"attachment.files.length > 0\"></i> Select file<input type=\"file\" name=\"image\" multiple=\"\" ng-model=\"image\" onchange=\"angular.element(this).scope().choosePhotoFile(this)\" ng-if=\"multi\"> <input type=\"file\" name=\"image\" ng-model=\"image\" onchange=\"angular.element(this).scope().choosePhotoFile(this)\" ng-if=\"!multi\"></span></md-button><div class=\"file-name\" ng-repeat=\"file in attachment.files\">{{file.name}}</div></div>");
$templateCache.put("templates/booking_management/bookingGuestAttachments_tpl.html","<div class=\"backdrop\" ng-if=\"loading\"><i class=\"fa fa-spin fa-spinner\"></i></div><div class=\"row\"><div class=\"col-xs-6\"><booking-guest-attachment name=\"\'Facial\'\" attachment=\"files[\'facial_picture\']\"></booking-guest-attachment></div><div class=\"col-xs-6\"><booking-guest-attachment name=\"\'Back ID\'\" attachment=\"files[\'back_id_picture\']\"></booking-guest-attachment></div></div><div class=\"row\"><div class=\"col-xs-6\"><booking-guest-attachment name=\"\'Front ID\'\" attachment=\"files[\'front_id_picture\']\"></booking-guest-attachment></div><div class=\"col-xs-6\"><booking-guest-attachment name=\"\'Signature\'\" attachment=\"files[\'digital_signature\']\"></booking-guest-attachment></div></div><div class=\"text-center\"><md-button ng-if=\"files[\'facial_picture\'].selected || files[\'back_id_picture\'].selected || files[\'front_id_picture\'].selected || files[\'digital_signature\'].selected\" class=\"md-raised\" ng-click=\"uploadFiles()\">Save</md-button></div>");
$templateCache.put("templates/booking_management/bookingGuestsTab_tpl.html","<div ng-controller=\"BookingGuestsTabController as ctrl\"><react-booking-guests booking-guests=\"ctrl.bookingGuests\" booking-rooms=\"ctrl.bookingRooms\" hotel-rooms=\"ctrl.hotelRooms\" room-types=\"ctrl.roomTypes\" cover-room-types=\"ctrl.coverRoomTypes\" room-representations=\"ctrl.roomRepresentations\" lead-guest=\"ctrl.leadGuest\" rooms=\"ctrl.rooms\" nationalities=\"ctrl.nationalities\" locales=\"ctrl.locales\" id-types=\"ctrl.idTypes\" countries=\"ctrl.countries\" hotel-country=\"ctrl.hotelCountry\" guest-details-settings=\"ctrl.guestDetailsSettings\" get-booking-guests-url=\"ctrl.getBookingGuestsUrl\" authorization-token=\"ctrl.authorizationToken\" upload-files=\"ctrl.uploadFiles\" fetch-guest-attachments=\"ctrl.fetchGuestAttachments\" print-registration-form=\"ctrl.printRegistrationForm\" on-delete=\"ctrl.onDelete\" on-save-booking-guest-form=\"ctrl.onSaveBookingGuestForm\" print-registration-form-for-all=\"ctrl.printRegistrationFormForAll\" change-lead-guest=\"ctrl.changeLeadGuest\" save-bulk-edit-changes=\"ctrl.saveBulkEditChanges\"></react-booking-guests></div>");
$templateCache.put("templates/booking_management/bookingHistoryTab_tpl.html","<h3>{{\'bookings.history.title\' | i18next}}</h3><div ng-controller=\"BookingHistoryTableController as ctrl\"><react-booking-history-table logs=\"ctrl.logs\" get-email=\"ctrl.getEmail\" load-logs=\"ctrl.loadLogs\" hotel-id=\"ctrl.hotelId\" booking-id=\"ctrl.bookingId\" logs-meta=\"ctrl.logsMeta\"></react-booking-history-table></div>");
$templateCache.put("templates/booking_management/bookingManagementDrawer_tpl.html","<div ng-controller=\"BookingManagementDrawerCtrl as ctrl\" id=\"booking-drawer\"><react-booking-management active-tab=\"ctrl.activeTab\" booking-channel=\"ctrl.bookingChannel\" booking-prepared-token=\"ctrl.bookingPreparedToken\" booking-prepared-channel=\"ctrl.bookingPreparedChannel\" booking-prepared-channel-reservation-id=\"ctrl.bookingPreparedChannelReservationId\" booking-source=\"ctrl.bookingSource\" booking-due=\"ctrl.bookingDue\" booking-total=\"ctrl.bookingTotal\" booking-total-extras=\"ctrl.bookingTotalExtras\" booking-total-paid=\"ctrl.bookingTotalPaid\" booking-total-room=\"ctrl.bookingTotalRoom\" booking-drawer-controller-ref=\"ctrl.bookingDrawerControllerRef\" is-sale-channels-feature-enabled=\"ctrl.isSaleChannelsFeatureEnabled\" room-size=\"ctrl.roomSize\" convert-currency=\"ctrl.convertCurrency\" close-booking-management-drawer-controller=\"ctrl.closeBookingManagementDrawerController\" edit-channel=\"ctrl.editChannel\" edit-reference=\"ctrl.editReference\" edit-sale-channel=\"ctrl.editSaleChannel\" open-drawer-tab=\"ctrl.openDrawerTab\" booking-management-mounted=\"ctrl.bookingManagementMounted\"></react-booking-management></div>");
$templateCache.put("templates/booking_management/bookingPaymentTab_tpl.html","<booking-card-vault ng-hide=\"gateway == \'none\'\"></booking-card-vault><hr class=\"separator payment-separator\"><booking-payments></booking-payments>");
$templateCache.put("templates/booking_management/bookingPayments_tpl.html","<h3>{{\'bookings.payment.transactions_title\' | i18next}}</h3><div ng-controller=\"BookingPaymentsController as ctrl\"><react-booking-payment-transactions booking-payments=\"ctrl.bookingPayments\" booking-rooms=\"ctrl.bookingRooms\" payment-types=\"ctrl.paymentTypes\" card-types=\"ctrl.cardTypes\" folios=\"ctrl.folios\" booking-due=\"ctrl.bookingDue\" booking-total-paid=\"ctrl.bookingTotalPaid\" foreign-currency-rate=\"ctrl.foreignCurrencyRate\" timezone=\"ctrl.timezone\" root-timezone=\"ctrl.rootTimezone\" wirecard-name=\"ctrl.wirecardName\" foreign-currency=\"ctrl.foreignCurrency\" currency-symbol=\"ctrl.currencySymbol\" payer-name=\"ctrl.payerName\" allow-change-payment-feature=\"ctrl.allowChangePaymentFeature\" deposit-feature-enabled=\"ctrl.depositFeatureEnabled\" payment-request-is-visible=\"ctrl.paymentRequestIsVisible\" hit-is-visible=\"ctrl.hitIsVisible\" payment-terminal-enabled=\"ctrl.paymentTerminalEnabled\" online=\"ctrl.online\" action-loading=\"ctrl.actionLoading\" is-foreign-amount=\"ctrl.isForeignAmount\" custom-currency=\"ctrl.customCurrency\" on-save-payment-form=\"ctrl.onSavePaymentForm\" on-save-terminal-payment-form=\"ctrl.onSaveTerminalPaymentForm\" fetch-payment-terminals=\"ctrl.fetchPaymentTerminals\" refund-manual-payment=\"ctrl.refundManualPayment\" refund-payment-terminal=\"ctrl.refundPaymentTerminal\" convert-deposit-to-payment=\"ctrl.convertDepositToPayment\" refund-payment=\"ctrl.refundPayment\" void-payment=\"ctrl.voidPayment\" submit-payment=\"ctrl.submitPayment\" request-payment=\"ctrl.requestPayment\" hit-payment=\"ctrl.hitPayment\" on-load-folios=\"ctrl.onLoadFolios\"></react-booking-payment-transactions></div>");
$templateCache.put("templates/booking_management/bookingRooms_tpl.html","<div ng-controller=\"BookingRoomsController as ctrl\" class=\"bookingRoomsReact\"><react-booking-rooms booking-rooms=\"ctrl.bookingRooms\" booking-info=\"ctrl.bookingInfo\" booking-channel-reservation-id=\"ctrl.bookingChannelReservationId\" booking-prepared-channel=\"ctrl.bookingPreparedChannel\" room-types=\"ctrl.roomTypes\" rate-categories=\"ctrl.rateCategories\" hotel-rooms=\"ctrl.hotelRooms\" room-representations=\"ctrl.roomRepresentations\" cover-room-types=\"ctrl.coverRoomTypes\" virtual-room-types=\"ctrl.virtualRoomTypes\" housekeeping-enabled=\"ctrl.housekeepingEnabled\" foreign-invoices-feature-enabled=\"ctrl.foreignInvoicesFeatureEnabled\" booking-rooms-ref=\"ctrl.bookingRoomsRef\" root-timezone=\"ctrl.rootTimezone\" cancellation-policies=\"ctrl.cancellationPolicies\" hotel-properties=\"ctrl.hotelProperties\" hotel-booking-com-code=\"ctrl.hotelBookingComCode\" key-locks=\"ctrl.keyLocks\" booking-payments=\"ctrl.bookingPayments\" booking-token=\"ctrl.bookingToken\" room-keys=\"ctrl.roomKeys\" foreign-currency-rate=\"ctrl.foreignCurrencyRate\" foreign-currency=\"ctrl.foreignCurrency\" currency-profiles=\"ctrl.currencyProfiles\" convert-currency=\"ctrl.convertCurrency\" save-booking-room-notes=\"ctrl.saveBookingRoomNotes\" checkin=\"ctrl.checkin\" show-room-keys=\"ctrl.showRoomKeys\" checkout=\"ctrl.checkout\" cancel-room=\"ctrl.cancelRoom\" mark-room-as-canceled=\"ctrl.markRoomAsCanceled\" split-room=\"ctrl.splitRoom\" restore-room=\"ctrl.restoreRoom\" change-room=\"ctrl.changeRoom\" checkin-selected=\"ctrl.checkinSelected\" checkout-selected=\"ctrl.checkoutSelected\" cancel-checkin-status=\"ctrl.cancelCheckinStatus\" cancel-checkout-status=\"ctrl.cancelCheckoutStatus\" cancel-selected=\"ctrl.cancelSelected\" change-selected-date=\"ctrl.changeSelectedDate\" change-selected-occupancy=\"ctrl.changeSelectedOccupancy\" change-selected-price=\"ctrl.changeSelectedPrice\" print-rooms-info=\"ctrl.printRoomsInfo\" merge-with-booking=\"ctrl.mergeWithBooking\" create-booking-room-key=\"ctrl.createBookingRoomKey\" edit-foreign-currency-rate=\"ctrl.editForeignCurrencyRate\" open-room-form=\"ctrl.openRoomForm\" show-booking-rooms-with-status=\"ctrl.showBookingRoomsWithStatus\" bulk-status-updating=\"ctrl.bulkStatusUpdating\" on-load-available-merge-bookings=\"ctrl.onLoadAvailableMergeBookings\"></react-booking-rooms></div>");
$templateCache.put("templates/booking_management/customerForm_tpl.html","<div class=\"customer-form\"><div class=\"customer-form__type-select\"><div class=\"customer-form__type-title\">{{\'bookings.customer.customer_type_title\' | i18next}}</div><md-radio-group ng-model=\"customer.customerType\" class=\"inline\"><md-radio-button value=\"0\">{{\'bookings.customer.guest_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"1\">{{\'bookings.customer.company_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"row\" ng-show=\"customer.customerType == 1\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.company_name_label\' | i18next}}</label> <input name=\"companyName\" ng-model=\"customer.companyName\"></md-input-container></div></div><div class=\"row\" ng-show=\"customer.customerType == 1\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.bill_to_label\' | i18next}}</label> <input name=\"billTo\" ng-model=\"customer.billTo\"></md-input-container></div></div><div class=\"row\" ng-show=\"customer.customerType == 1\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.tax_number_label\' | i18next}}</label> <input name=\"taxNumber\" ng-model=\"customer.taxNumber\"></md-input-container></div></div><div class=\"row\" ng-show=\"customer.customerType == 0\"><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.first_name\' | i18next}}</label> <input type=\"text\" ng-model=\"customer.firstName\" name=\"firstName\" maxlength=\"250\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.last_name\' | i18next}}</label> <input type=\"text\" name=\"lastName\" ng-model=\"customer.lastName\" maxlength=\"250\"></md-input-container></div></div><div class=\"row\" ng-show=\"customer.customerType == 0\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.nationality_label\' | i18next}}</label> <input type=\"text\" ng-model=\"customer.nationality\" name=\"nationality\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select ng-model=\"customer.locale\"><md-optgroup label=\"Locales\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_no_label\' | i18next}}</label> <input type=\"text\" name=\"identification\" ng-model=\"customer.identification\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_type_label\' | i18next}}</label><md-select ng-model=\"customer.identificationTypeId\"><md-option ng-value=\"idType.id\" ng-repeat=\"idType in idTypes\">{{idType.title}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.national_identification_number\' | i18next}}</label> <input type=\"text\" name=\"nationalIdNumber\" ng-model=\"customer.nationalIdNumber\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select ng-model=\"customer.locale\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.channel_manager.rate_category_th\' | i18next}}</label><md-select ng-model=\"customer.rateCategoryId\"><md-option ng-repeat=\"rateCategory in rateCategories\" value=\"{{rateCategory.id}}\">{{rateCategory.name}}</md-option></md-select></md-input-container></div></div><div class=\"customer-form__section-title\"><h4>{{\'bookings.customer.address_title\' | i18next}}</h4></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" name=\"address\" ng-model=\"customer.address\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.city_label\' | i18next}}</label> <input type=\"text\" name=\"city\" ng-model=\"customer.city\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"customer.country\"><md-option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\" ng-show=\"customer.country == \'United States\'\"><md-input-container><label>{{\'bookings.customer.state_label\' | i18next}}</label> <input type=\"text\" name=\"state\" ng-model=\"customer.state\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.postal_code\' | i18next}}</label> <input type=\"text\" name=\"zipCode\" ng-model=\"customer.zipCode\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><multi-email-input ng-model=\"customer.email\" placeholder=\"{{\'bookings.customer.email_label\' | i18next}}\" class=\"multi-email-input\"></multi-email-input></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.mobile_phone_label\' | i18next}}</label> <input type=\"text\" name=\"mobilePhone\" ng-model=\"customer.mobilePhone\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.work_phone_label\' | i18next}}</label> <input type=\"text\" ng-model=\"customer.workPhone\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.notes_label\' | i18next}}</label> <input type=\"text\" ng-model=\"customer.notes\"></md-input-container></div></div><div class=\"row\" ng-show=\"customer.customerType == 1\"><div class=\"col-xs-12\"><md-input-container><label>{{\'bookings.customer.your_reference_label\' | i18next}}</label> <input type=\"text\" ng-model=\"customer.referenceText\"></md-input-container></div></div><div class=\"row form-control-block\"><div class=\"col-xs-6 text-left\"><md-button class=\"md-raised md-warn\" ng-click=\"onClose()\">{{\'general.buttons.cancel\' | i18next}}</md-button></div><div class=\"col-xs-6 text-right\"><md-button class=\"md-raised md-primary\" ng-click=\"saveCustomer()\"><i class=\"fa fa-spin fa-spinner\" ng-if=\"saveCustomerInProgress == true\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div>");
$templateCache.put("templates/booking_management/customer_tpl.html","<booking-customer-tab></booking-customer-tab>");
$templateCache.put("templates/booking_management/email_tpl.html","<booking-email-tab></booking-email-tab>");
$templateCache.put("templates/booking_management/extras_and_discounts_tpl.html","<booking-extras></booking-extras>");
$templateCache.put("templates/booking_management/folioTaxForm_tpl.html","<form name=\"folioTaxForm\" novalidate=\"\"><div class=\"folios__folioTax__form\" ng-class=\"{\'folios__folioTax__form__new\' : !editedTax.id}\"><div class=\"folios__folioTax__form__title\" ng-if=\"editedTax.id\">Edit Tax</div><div class=\"folios__folioTax__form__title\" ng-if=\"!editedTax.id\">Add Tax</div><div><md-input-container><label>{{\'general.other.tax\' | i18next}}</label><md-select ng-model=\"editedTax.taxId\" ng-change=\"onTaxChange()\" ng-disabled=\"editedTax.id\" required=\"\"><md-option ng-value=\"tax.id\" ng-repeat=\"tax in taxes\">{{tax.name}}</md-option></md-select></md-input-container></div><div class=\"row\" ng-if=\"editedTax.id || editedTax.isManual === true\"><div class=\"col-xs-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.taxe_new.value_th\' | i18next}}</label> <input type=\"number\" name=\"value\" ng-model=\"editedTax.value\" required=\"\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.amount\' | i18next}}</label> <input type=\"number\" name=\"amount\" ng-model=\"editedTax.amount\" required=\"\"></md-input-container></div></div><div class=\"row control-row\"><div class=\"col-xs-6\"><a ng-click=\"onReset(editedTax)\" ng-if=\"onReset && editedTax.id\"><i class=\"fa fa-refresh\"></i> {{\'general.buttons.reset_to_default\' | i18next}}</a><md-checkbox ng-model=\"editedTax.isManual\" aria-label=\"manual\" ng-if=\"!editedTax.id\">Is Manual</md-checkbox></div><div class=\"col-xs-6 text-right controls\"><a ng-click=\"save()\" ng-class=\"{\'disabled\' : loading}\"><i class=\"fa fa-check\" ng-if=\"loading !== true\"></i> <i class=\"fa fa-spinner\" ng-if=\"loading === true\" ng-class=\"{\'fa-spin\' : loading === true}\"></i> &nbsp; {{\'general.buttons.save\' | i18next}}</a> <a ng-click=\"onClose()\" ng-class=\"{\'disabled\' : loading}\"><i class=\"fa fa-times\"></i> {{\'general.buttons.cancel\' | i18next}}</a></div><div class=\"folios__folioTax__form__error\" ng-class=\"{\'show\' : errorIsVisible === true}\">{{error}}</div></div></div></form>");
$templateCache.put("templates/booking_management/folios_tpl.html","<booking-folios-tab></booking-folios-tab>");
$templateCache.put("templates/booking_management/guests_tpl.html","<booking-guests-tab></booking-guests-tab>");
$templateCache.put("templates/booking_management/history_tpl.html","<booking-history-tab></booking-history-tab>");
$templateCache.put("templates/booking_management/payment_tpl.html","<booking-payment-tab></booking-payment-tab>");
$templateCache.put("templates/booking_management/rooms_tpl.html","<booking-rooms></booking-rooms>");
$templateCache.put("templates/booking_management/uiPrintDialog_tpl.html","<div><div ng-if=\"isOpened\"><div class=\"buuqit-modal\"><div class=\"title\">{{ \"print_dialog.title\" | i18next }}</div><div class=\"content\"><form name=\"printDialogForm\"><md-checkbox ng-change=\"change(\'printRatePlans\', printRatePlans)\" ng-model=\"printRatePlans\" aria-label=\"{{\'print_dialog.print_rate_plans\' | i18next}}\">{{ \"print_dialog.print_rate_plans\" | i18next }}</md-checkbox><br><md-checkbox ng-change=\"change(\'printPrices\', printPrices)\" ng-model=\"printPrices\" aria-label=\"{{\'print_dialog.print_prices\' | i18next}}\">{{ \"print_dialog.print_prices\" | i18next }}</md-checkbox><br><md-checkbox ng-change=\"change(\'printRoomTypes\', printRoomTypes)\" ng-model=\"printRoomTypes\" aria-label=\"{{\'print_dialog.print_room_types\' | i18next}}\">{{ \"print_dialog.print_room_types\" | i18next }}</md-checkbox></form></div><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"close()\">{{ \"general.confirm.cancel\" | i18next }}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-success\" ng-click=\"print()\" ng-disabled=\"printDialogForm.$invalid\">{{ \"print_dialog.print\" | i18next }}</md-button></div></div></div></div>");
$templateCache.put("templates/inventory/closeout_tpl.html","<div ng-controller=\"Inventory.CloseoutController as CloseoutCtrl\"><div class=\"row\"><div class=\"col-md-6 text-left rate-period\"><span class=\"label label-default\">{{\'inventory.general_for_section.rate_period.label_default\' | i18next}}</span> <span class=\"label label-success\">{{\'inventory.general_for_section.rate_period.label_success\' | i18next}}</span> <span class=\"label label-danger\">{{\'inventory.general_for_section.rate_period.label_danger\' | i18next}}</span></div><div class=\"col-md-6 text-right\"><md-button class=\"md-raised md-success\" ng-click=\"save()\"><i ng-show=\"loading\" class=\"fa fa-spinner\" ng-class=\"{ \'fa-spin\' : loading === true }\"></i> {{\'inventory.general_for_section.save_changes_button\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"reset()\">{{\'inventory.general_for_section.reset_changes_button\' | i18next}}</md-button></div></div><br><table class=\"table table-hover general-table table-editable table-bordered table-availability\"><thead><tr><th rowspan=\"2\">{{\'general.other.room_types\' | i18next}}</th><th colspan=\"{{dates.length}}\" class=\"rate-period text-center\">{{\'inventory.closeout.availability_for_th\' | i18next}}:<month-selector ng-model=\"currentDate\"></month-selector></th></tr><tr><th ng-repeat=\"date in dates\" class=\"date text-center\">{{date | date:\'dd\'}}<br>{{date | date:\'EEE\'}}</th></tr></thead><tbody><tr ng-repeat=\"roomType in roomTypes\"><td class=\"room-type-cell rate-type-cell\">{{roomType.shortName}}</td><td ng-repeat=\"date in dates\" ng-mousedown=\"mouseDownOnCell(roomType, $index)\" ng-mouseup=\"mouseUpOnCell(roomType, $index)\" ng-mousemove=\"mouseMoveOnTable(roomType, $index)\" ng-class=\"{\'success\': availability[roomType.id][date].available > 0, \'active\': availability[roomType.id][date].available == 0, \'danger\': availability[roomType.id][date].closedOut, \'disabled\' : !compareDate(date), \'selected\' : isSelected(roomType, $index)}\" class=\"text-center handle-cell\" ng-click=\"setUsClosedOut(availability[roomType.id][date])\">{{availability[roomType.id][date].available}}</td></tr></tbody></table></div>");
$templateCache.put("templates/forms/accountingCategoryForm_tpl.html","<div class=\"table-form\"><form name=\"accountingCategoryForm\" novalidate=\"\"><legend ng-if=\"vm.accountingCategory.id\">{{\'general.tooltip.edit\' | i18next}}</legend><legend ng-if=\"!vm.accountingCategory.id\">{{\'general.tooltip.create\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.name\' | i18next}}</label> <input ng-model=\"vm.accountingCategory.name\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'accounting_category.internal_code\' | i18next}}</label> <input ng-model=\"vm.accountingCategory.internalCode\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'accounting_category.external_code\' | i18next}}</label> <input ng-model=\"vm.accountingCategory.externalCode\"></md-input-container></div></div><div class=\"form-buttons\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelAction()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"vm.saveAction()\" ng-disabled=\"accountingCategoryForm.$invalid || vm.requestInProgress\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : vm.requestInProgress}\" ng-if=\"vm.requestInProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/forms/channexIntegrationForm_tpl.html","<div style=\"display: none\" class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.public_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.apiPublicKey\" name=\"channexApiPublicKey\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.public_key\' | i18next}}\"></div></div><div style=\"display: none\" class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.secret_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"password\" class=\"form-control\" ng-model=\"channel.settings.apiSecretKey\" autocomplete=\"new-password\" name=\"channexApiSecretKey\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.secret_key\' | i18next}}\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.apikey\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.apiKey\" name=\"channexApiKey\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.apikey\' | i18next}}\"></div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-checkbox ng-model=\"channel.settings.isProd\" ng-disabled=\"channel.id\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.isProd\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.isProd\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-button class=\"md-raised md-primary\" ng-click=\"ctrl.loadChannexHotels(channel)\">{{ \'profile_nav.settings.booking_engine.channel_manager.reload_hotels\' | i18next }}</md-button></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.days_to_sync_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"number\" class=\"form-control\" ng-model=\"channel.settings.daysToSync\" name=\"daysToSync\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.days_to_sync_label\' | i18next}}\"></div></div><div class=\"text-center\" ng-if=\"channel.settings.hotels == null || channel.settings.hotels == undefined\"><a ng-click=\"ctrl.loadChannexHotels(channel)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.connect\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.connect\' | i18next}}</a></div><div class=\"form-group\" ng-if=\"channel.settings.hotels !== null && channel.settings.hotels !== undefined\"><div class=\"col-xs-3 mapping__hotels-label\"><label>{{\'profile_nav.settings.booking_engine.channel_manager.choose_hotel\' | i18next}}:</label> <a ng-click=\"ctrl.loadChannexHotels(channel)\" class=\"mapping__hotels-reload\" tooltip=\"{{\'profile_nav.settings.booking_engine.channel_manager.reload_hotels\' | i18next}}\" tooltip-append-to-body=\"true\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.reload_hotels\' | i18next}}\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-refresh\"></i></a></div><div class=\"col-xs-9 mapping__hotels-list\"><md-select multiple=\"\" ng-model=\"channel.settings.hotelCodeCache\" ng-change=\"ctrl.channexProcessHotelsChange(channel)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.choose_hotel\' | i18next}}\"><md-option ng-repeat=\"hotel in channel.settings.hotels track by (hotel.id || $index)\" value=\"{{hotel.id}}\" ng-if=\"hotel.id\">{{hotel.title}}</md-option></md-select><md-button class=\"md-raised md-primary channel-apply-hotel-change\" ng-class=\"{\'ng-hide\': !channel.needUpdate}\" ng-click=\"ctrl.channexApplyHotelsChange(channel)\">{{ \'profile_nav.settings.booking_engine.channel_manager.apply_and_reload\' | i18next }}</md-button>{{\'profile_nav.settings.booking_engine.channel_manager.choose_message\' | i18next}} <a ng-click=\"ctrl.createChannexHotel(channel)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.create_new_hotel\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.create_new_hotel\' | i18next}}</a></div></div><div><div ng-repeat=\"hotel in channel.settings.hotels track by (hotel.id || $index)\" ng-if=\"channel.settings.hotelCode.indexOf(hotel.id) !== -1 || (!hotel.id && hotel.roomTypes.length)\"><legend>{{hotel.title}} <small ng-if=\"hotel.id && channel.settings.webhooks[hotel.id]\">{{\'profile_nav.settings.booking_engine.channel_manager.webhook_installed\' | i18next}}: {{ channel.settings.webhooks[hotel.id] | date:\'dd/MM/yyyy hh:mm:ss\' }}</small></legend><div class=\"mapping__room-type\" ng-repeat=\"roomType in hotel.roomTypes | orderBy:\'title\' track by (roomType.id || $index)\"><div class=\"row\"><div class=\"col-xs-5\"><strong>{{roomType.title}}</strong> <i class=\"fa fa-trash\" ng-click=\"ctrl.channexUnmapRoomType(channel, hotel, roomType)\" ng-if=\"hotel.id\" aria-label=\"{{\'general.buttons.delete\' | i18next}}\" role=\"button\" tabindex=\"0\"></i></div><div class=\"col-xs-3 text-right\" ng-if=\"hotel.id\"><a ng-click=\"ctrl.createChannexRoomType(channel, hotel, roomType)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.create_new\' | i18next}} {{roomType.title}}\">{{\'profile_nav.settings.booking_engine.channel_manager.create_new\' | i18next}}</a> {{\'profile_nav.settings.booking_engine.channel_manager.map_message\' | i18next}}</div><div class=\"col-xs-4\" ng-if=\"hotel.id\"><select class=\"form-control\" ng-model=\"channel.settings.roomTypeCodes[roomType.id]\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.map_room_type\' | i18next}} {{roomType.title}}\"><option value=\"{{null}}\">{{\'profile_nav.settings.booking_engine.channel_manager.n/a_option\' | i18next}}</option><option ng-repeat=\"code in channel.settings.roomTypesArray | filter:{propertyId:hotel.id} track by code.id\" value=\"{{code.id}}\">{{code.title}}</option></select></div><div class=\"col-xs-7\" ng-if=\"!hotel.id\"><select class=\"form-control\" ng-model=\"roomType.propertyId\" ng-change=\"ctrl.channexUpdateHotel(channel, hotel, roomType)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.select_hotel_for\' | i18next}} {{roomType.title}}\"><option ng-repeat=\"code in channel.settings.hotels track by (code.id || $index)\" value=\"{{code.id}}\" ng-if=\"channel.settings.hotelCode.indexOf(code.id) !== -1 || !code.id\">{{code.title}}</option></select></div></div><div class=\"mapping__rate-plans\" ng-if=\"channel.settings.roomTypeCodes[roomType.id]\"><div class=\"row mapping__rate-plan\" ng-repeat=\"roomRate in roomType.roomRates | orderBy:\'title\' track by (roomRate.id || $index)\"><div class=\"col-xs-5 mapping__rate-plan__title\">{{roomRate.title}} <span class=\"pull-right\"><i class=\"fa fa-user\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\"></i> {{roomRate.maxChildren}}</span></div><div class=\"col-xs-3 text-right\"><a ng-click=\"ctrl.createChannexRate(channel, hotel, roomType, roomRate)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.create_new\' | i18next}} {{roomRate.title}}\">{{\'profile_nav.settings.booking_engine.channel_manager.create_new\' | i18next}}</a> {{\'profile_nav.settings.booking_engine.channel_manager.map_message\' | i18next}}</div><div class=\"col-xs-4\"><select class=\"form-control\" ng-model=\"channel.settings.roomRateRateCodes[roomRate.id]\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.map_rate_plan\' | i18next}} {{roomRate.title}}\"><option value=\"{{null}}\">{{\'profile_nav.settings.booking_engine.channel_manager.n/a_option\' | i18next}}</option><option ng-repeat=\"code in channel.settings.roomTypes[channel.settings.roomTypeCodes[roomType.id]].ratePlans track by code.id\" value=\"{{code.id}}\">{{code.title}}</option></select></div></div></div></div><div class=\"row\" ng-if=\"hotel.id && channel.settings.hotels[channel.settings.hotels.length -1].length > 0\"><div class=\"col-xs-12\"><a ng-click=\"ctrl.channexMoveUnmapped(channel, hotel)\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.move_unmapped_here\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.move_unmapped_here\' | i18next}}</a></div></div></div></div>");
$templateCache.put("templates/forms/corporateAccountForm_tpl.html","<form name=\"corporateAccountForm\"><legend ng-if=\"value.id == undefined\">New corporate account</legend><legend ng-if=\"value.id != undefined\">Edit corporate account</legend><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Company Name</label> <input type=\"text\" ng-model=\"value.companyName\" required=\"\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Contact Person</label> <input type=\"text\" ng-model=\"value.contactPerson\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Phone</label> <input type=\"text\" ng-model=\"value.phone\" required=\"\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Email</label> <input type=\"email\" ng-model=\"value.email\" required=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Addres</label> <input type=\"text\" ng-model=\"value.address\" required=\"\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>VAT</label> <input type=\"text\" ng-model=\"value.vat\" required=\"\"></md-input-container></div></div><br><br><div class=\"row\" ng-if=\"value.id\"><div class=\"col-md-12\"><strong>Hotels</strong><table class=\"table\"><tr ng-repeat=\"hotel in value.hotels\"><td>{{hotel.name}}</td><td class=\"text-right\"><a ng-click=\"removeHotel(hotel)\"><i class=\"fa fa-times\"></i></a></td></tr></table></div></div><div class=\"row\" ng-if=\"value.id\"><div class=\"col-md-12\"><strong>Users</strong><table class=\"table\"><tr ng-repeat=\"user in value.users\"><td>{{user.name}}</td><td>{{user.email}}</td><td>{{user.corporateRole}}</td><td class=\"text-right\"><a ng-click=\"removeUser(user)\"><i class=\"fa fa-times\"></i></a></td></tr></table></div></div><div class=\"row\"><div class=\"col-md-6 text-left\"><md-checkbox ng-model=\"value.isActive\" aria-label=\"Is Active\">Active</md-checkbox></div><div class=\"col-md-6 text-right\"><md-button class=\"md-raised md-success\" ng-click=\"save()\" ng-disabled=\"corporateAccountForm.$invalid\"><i class=\"fa fa-spin fa-spinner\" ng-show=\"saving\"></i> Save</md-button><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\">Cancel</md-button></div></div></form>");
$templateCache.put("templates/forms/coverRoomTypeForm_tpl.html","<form name=\"CoverRoomTypeForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.room_type\' | i18next}}:</label><select class=\"form-control\" ng-model=\"value.roomTypeId\" ng-change=\"loadBedConfig()\" name=\"roomTypeId\" required=\"\"><option ng-repeat=\"roomType in roomTypes\" value=\"{{roomType.id}}\">{{roomType.name}}</option></select></div><div class=\"row form-group\"><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.max_adults\' | i18next}}:</label> <input type=\"text\" name=\"maxAdults\" ng-model=\"value.maxAdults\" class=\"form-control\" tabindex=\"104\" required=\"\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.max_children\' | i18next}}:</label> <input type=\"text\" name=\"maxChildren\" ng-model=\"value.maxChildren\" class=\"form-control\" tabindex=\"106\" required=\"\"></div></div></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.display_name\' | i18next}}:<locale-selector-next></locale-selector-next></label> <input type=\"text\" name=\"name\" ng-model=\"value.name\" class=\"form-control\" tabindex=\"102\" placeholder=\"Standart Double Room\" required=\"\"></div><div class=\"row form-group\"><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'profile_nav.settings.inventory.room_type_form.max_occ_label\' | i18next}}:</label> <input type=\"text\" name=\"minStay\" ng-model=\"value.maxOccupancy\" class=\"form-control\" tabindex=\"107\" required=\"\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'profile_nav.settings.inventory.room_type_form.default_price_label\' | i18next}}:</label> <input type=\"text\" name=\"defaultPrice\" ng-model=\"value.defaultPrice\" class=\"form-control\" tabindex=\"112\" required=\"\"></div></div></div></div></div><div class=\"row form-group\" ng-if=\"isAccountingCategoriesFeatureEnabled\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.accounting_category\' | i18next}}:</label><select class=\"form-control\" ng-model=\"value.accountingCategoryId\" ng-options=\"accountingCategory.id as accountingCategory.name for accountingCategory in ctrl.accountingCategories\"></select></div></div></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.description\' | i18next}}:<locale-selector-next></locale-selector-next></label> <textarea class=\"form-control description\" name=\"description\" ng-model=\"value.description\" tabindex=\"108\"></textarea></div></div></div><div class=\"row\"><div class=\"col-xs-6 form-group\"><label>{{\'profile_nav.settings.inventory.room_type_form.available_facilities_label\' | i18next}}</label><select multiple=\"\" size=\"6\" class=\"form-control\" ng-model=\"selectedAvailableFacility\" ng-options=\"facility.id as facility.title for facility in facilities\" ng-change=\"moveToSelected()\"></select></div><div class=\"col-xs-6 form-group\"><label>{{\'profile_nav.settings.inventory.room_type_form.your_selected_facilities_label\' | i18next}}</label><select multiple=\"\" size=\"6\" class=\"form-control\" ng-model=\"selectedChoosedFacility\" ng-options=\"facility.id as facility.title for facility in value.facilities\" ng-change=\"moveFromSelected()\"></select></div></div><div class=\"row bed-config\"><div class=\"col-xs-12\"><div class=\"bed-config-header\"><strong>{{\'profile_nav.settings.inventory.room_type_form.bed_config_header\' | i18next}}</strong> <a class=\"pull-right\" ng-click=\"addBedConfig()\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type_form.add_config_link\' | i18next}}</a></div><datalist id=\"bedTypes\"><option value=\"{{\'profile_nav.settings.inventory.room_type_form.crib_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.rollaway_or_extra_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.modern_cot_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.single_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.double_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.twin_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.standard_double_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.queen_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.olympic_queen_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.king_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.super_king_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.grand_king_option\' | i18next}}\"></option></datalist><div class=\"text-center\" ng-if=\"!value.bedConfigRaw || value.bedConfigRaw.length == 0\">{{\'profile_nav.settings.inventory.room_type_form.current_room_type_does_not_have_any_bed_configuration_div\' | i18next}}<br><a ng-click=\"addBedConfig()\">{{\'profile_nav.settings.inventory.room_type_form.add_first_bed_config_link\' | i18next}}</a></div><div class=\"row\" ng-repeat=\"config in value.bedConfigRaw\" ng-if=\"value.bedConfigRaw && value.bedConfigRaw.length > 0\"><div class=\"col-xs-12\"><div class=\"bed-config-config-header\"><strong>{{\'profile_nav.settings.inventory.room_type_form.config_header\' | i18next}} #{{$index}}</strong> <a class=\"pull-right\" ng-click=\"removeBedConfig($index)\"><i class=\"fa fa-times\"></i> {{\'profile_nav.settings.inventory.room_type_form.remove_config_link\' | i18next}}</a> <a class=\"pull-right\" ng-click=\"addBed(config)\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type_form.add_bed_link\' | i18next}}</a></div><div class=\"row bed-config-table-header\"><div class=\"col-xs-5\">{{\'profile_nav.settings.inventory.room_type_form.bed_type_table_header\' | i18next}} <span tooltip=\"Required\" tooltip-append-to-body=\"true\">*</span></div><div class=\"col-xs-2\">{{\'general.other.count\' | i18next}} <span tooltip=\"Required\" tooltip-append-to-body=\"true\">*</span></div><div class=\"col-xs-4\">{{\'profile_nav.settings.inventory.room_type_form.size_table_header\' | i18next}}</div></div><div class=\"row bed-config-row\" ng-repeat=\"bed in config\"><div class=\"col-xs-5\"><div class=\"form-group\"><input type=\"text\" list=\"bedTypes\" ng-model=\"bed[0]\" class=\"form-control\" name=\"bedType{{$parent.$index}}-{{$index}}\" required=\"\"></div></div><div class=\"col-xs-2\"><div class=\"form-group\"><input type=\"number\" ng-model=\"bed[1]\" class=\"form-control\" name=\"bedCount{{$parent.$index}}-{{$index}}\" required=\"\" min=\"1\"></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><input type=\"text\" ng-model=\"bed[2]\" class=\"form-control\" name=\"bedSize{{$parent.$index}}-{{$index}}\"></div></div><div class=\"col-xs-1 text-right\"><i class=\"fa fa-times\" ng-click=\"removeBed(config, $index)\" tooltip=\"Remove Bed\" tooltip-append-to-body=\"true\"></i></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"photos-container\" ng-show=\"(value.photos.length > 0)\"><div ng-repeat=\"photo in value.photos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.picture}}\" ng-show=\"photo.picture\"></div><div class=\"tools\"><a href=\"{{photo.picture.replace(\'thumb\', \'big\')}}\" ng-show=\"photo.picture\" aria-label=\"{{\'general.tooltip.direct_link\' | i18next}}\"><md-tooltip md-direction=\"bottom\">{{\'general.tooltip.direct_link\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <span aria-label=\"{{\'general.tooltip.feature_image\' | i18next}}\"><i class=\"fa\" ng-class=\"{\'fa-star\' : photo.featured == true, \'fa-star-o\' : photo.featured == false || photo.featured == null}\" ng-hide=\"photo.loading\" ng-click=\"featurePhoto(photo)\"></i><md-tooltip md-direction=\"bottom\" ng-hide=\"photo.loading\">{{\'general.tooltip.feature_image\' | i18next}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-show=\"photo.loading\">{{\'general.tooltip.feature_image\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-show=\"photo.loading\"></i></span> <span class=\"pull-right\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><i class=\"fa fa-times-circle\" ng-hide=\"photo.loading\" ng-click=\"removePhoto(photo)\"></i><md-tooltip md-direction=\"bottom\" ng-hide=\"photo.loading\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-show=\"photo.loading\">{{\'general.tooltip.removing\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-show=\"photo.loading\"></i></span></div></div></div></div><div class=\"col-xs-12\"><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\" ng-show=\"photoLoaded != true\"></i> <i class=\"fa fa-spinner\" ng-show=\"photoLoaded == true\" ng-class=\"{\'fa-spin\': photoLoaded == true}\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" onchange=\"angular.element(this).scope().multipleFileUpload(event)\" multiple=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeCreateForm()\" ng-disabled=\"saving == true\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"CoverRoomTypeForm.$invalid || saving == true\" ng-click=\"saveCreateForm()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : saving}\" ng-show=\"saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></form>");
$templateCache.put("templates/forms/hotelForm_tpl.html","<legend ng-if=\"value.id == undefined\">New hotel</legend><legend ng-if=\"value.id != undefined\">Edit hotel</legend><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Hotel name</label> <input type=\"text\" ng-model=\"value.name\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Hotel description</label> <input type=\"text\" ng-model=\"value.description\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Email</label> <input type=\"text\" ng-model=\"value.email\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Website</label> <input type=\"text\" ng-model=\"value.websiteUrl\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Phone</label> <input type=\"text\" ng-model=\"value.phone\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Fax</label> <input type=\"text\" ng-model=\"value.fax\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4\"><md-input-container><label>Country</label> <input type=\"text\" ng-model=\"value.country\"></md-input-container></div><div class=\"col-md-4\"><md-input-container><label>State</label> <input type=\"text\" ng-model=\"value.state\"></md-input-container></div><div class=\"col-md-4\"><md-input-container><label>City</label> <input type=\"text\" ng-model=\"value.city\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-4\"><md-input-container><label>ZIP Code</label> <input type=\"text\" ng-model=\"value.zipCode\"></md-input-container></div><div class=\"col-md-8\"><md-input-container><label>Address</label> <input type=\"text\" ng-model=\"value.address\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6 text-left\"><label><input type=\"checkbox\" ng-model=\"value.isProduction\"> Production account</label></div><div class=\"col-md-6 text-right\"><md-button class=\"md-raised md-success\" ng-click=\"save()\"><i class=\"fa fa-spin fa-spinner\" ng-show=\"saving\"></i> Save</md-button><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\">Cancel</md-button></div></div>");
$templateCache.put("templates/forms/localeSelectorForm_tpl.html","<md-menu ng-class=\"{\'ng-show\': $rootScope.hotel.locales.length > 1}\"><md-button md-position-mode=\"target-right target\" aria-label=\"Open phone interactions menu\" class=\"md-button\" ng-click=\"$mdOpenMenu($event)\">Locale: {{Globalize.locale}}</md-button><md-menu-content><md-radio-group ng-model=\"Globalize.locale\"><md-menu-item ng-repeat=\"locale in Globalize.locales\" class=\"locize-item\"><md-radio-button ng-value=\"locale\" aria-label=\"{{locale}}\">{{locale}}</md-radio-button></md-menu-item></md-radio-group></md-menu-content></md-menu>");
$templateCache.put("templates/forms/localeSelectorNextForm_tpl.html","<span ng-class=\"{\'ng-show\': $rootScope.hotel.locales.length > 1}\" ng-click=\"nextLocale($event);\">{{Globalize.locale}}<md-icon md-svg-src=\"images/translate.svg\"></md-icon><md-tooltip md-direction=\"bottom\">{{\'locales.selector.next_lang\' | i18next}}</md-tooltip></span>");
$templateCache.put("templates/forms/paymentForm_tpl.html","<form name=\"addPaymentForm\" novalidate=\"\" class=\"addPaymentForm\"><strong>{{\'bookings.payment_form.add_manual_strong\' | i18next}} {{value.operation}}</strong><div class=\"row\"><div class=\"col-xs-3 date-picker date-col\"><label>{{\'bookings.payment_form.payment_date_label\' | i18next}}</label><md-datepicker ng-model=\"value.dateValue\"></md-datepicker></div><div class=\"col-xs-5\"><md-input-container><label>{{\'general.other.payer_name\' | i18next}}</label> <input type=\"text\" ng-model=\"value.payerName\" name=\"payerName\" required=\"\"></md-input-container></div><div class=\"col-xs-4\"><md-input-container><label>{{\'general.other.type\' | i18next}}</label><md-select ng-model=\"value.type\" ng-required=\"true\"><md-option ng-repeat=\"type in paymentTypes\" value=\"{{type[0]}}\">{{type[1]}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\" ng-hide=\"value.type==\'Credit Card\' || value.type==\'Debit Card\'\"><md-input-container><label>{{\'general.other.description\' | i18next}}</label> <input type=\"text\" ng-model=\"value.description\"></md-input-container></div><div class=\"col-xs-6\" ng-show=\"value.type==\'Credit Card\' || value.type==\'Debit Card\'\"><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.payment_form.card_type_label\' | i18next}}</label><md-select ng-model=\"value.cardType\" ng-required=\"{{value.type==\'Credit Card\' || value.type==\'Debit Card\'}}\"><md-option ng-repeat=\"card in cardTypes\" value=\"{{card}}\">{{card}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.payment_form.card_ending_label\' | i18next}}</label> <input type=\"text\" ng-model=\"value.cardEnd\" ng-required=\"{{value.type==\'Credit Card\' || value.type==\'Debit Card\'}}\" name=\"cardEnding\"></md-input-container></div></div></div><div class=\"col-xs-3\" ng-if=\"!value.id\"><md-input-container><label>{{\'bookings.payment_form.associated_folio\' | i18next}}</label><md-select ng-model=\"value.folioId\"><md-option class=\"folio-option\" ng-repeat=\"folio in folios\" value=\"{{folio.id}}\" ng-click=\"changeFolioSelection(folio)\">{{folio.number}} ({{\'bookings.folios.due\' | i18next}}: {{folio.due}}) <span class=\"customer-option-info\">{{folio.customer.visibleName}}</span></md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-class=\"{\'col-xs-6\' : value.id}\"><md-input-container><label>{{\'general.other.amount\' | i18next}} ({{currencySymbol}})</label> <input ng-if=\"!value.isForeignAmount\" type=\"number\" ng-model=\"value.amount\" required=\"\" name=\"amount\"> <input ng-if=\"value.isForeignAmount\" type=\"number\" ng-model=\"value.foreignAmount\" required=\"\" name=\"amount\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12 controls\" ng-hide=\"paymentAnimation\"><a ng-click=\"savePaymentForm()\"><i tooltip=\"{{\'general.tooltip.save\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-check\"></i></a> <a ng-click=\"hidePaymentForm()\"><i tooltip=\"{{\'general.tooltip.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></div><div class=\"col-xs-1 controls\" ng-show=\"paymentAnimation\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : paymentAnimation}\"></i></div></div></form>");
$templateCache.put("templates/forms/posProfileForm_tpl.html","<div class=\"table-form\"><form name=\"PosProfileForm\" novalidate=\"\" class=\"pos_form\"><legend ng-if=\"profile.id\">{{\'profile_nav.settings.hotel_profile.hotel_property.pos.edit_pos_profile_legend\' | i18next}}</legend><legend ng-if=\"!profile.id\">{{\'profile_nav.settings.hotel_profile.hotel_property.pos.create_pos_profile_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-6\"><div class=\"row\"><div class=\"col-xs-12\"><md-select ng-model=\"profile.posType\" ng-disabled=\"profile.id\" required=\"\" placeholder=\"Type\" ng-class=\"{\'has-error\' : !profile.posType && showErrors}\"><md-option ng-repeat=\"type in pos_types\" value=\"{{type.id}}\">{{type.name}}</md-option></md-select></div></div></div><div class=\"col-xs-6\"><md-checkbox ng-model=\"profile.enabled\" class=\"pos_profile_enable\">{{\'profile_nav.settings.hotel_profile.pos.enabled_label\' | i18next}}</md-checkbox></div></div><div class=\"form-horizontal\" ng-if=\"profile.posType == \'lightspeed\'\"><div class=\"form-group\" ng-class=\"{\'has-error\' : PosProfileForm.lightspeedUsername.$invalid == true && showErrors == true}\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.pos.lightspeed_username_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" name=\"lightspeedUsername\" class=\"form-control\" ng-model=\"profile.data.lightspeedUsername\" required=\"\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : PosProfileForm.lightspeedPassword.$invalid == true && showErrors == true}\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.pos.lightspeed_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" name=\"lightspeedPassword\" class=\"form-control\" ng-model=\"profile.data.lightspeedPassword\" required=\"\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : PosProfileForm.lightspeedCompanyid.$invalid == true && showErrors == true}\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.pos.lightspeed_company_id_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" name=\"lightspeedCompanyid\" class=\"form-control\" ng-model=\"profile.data.lightspeedCompanyid\" required=\"\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : PosProfileForm.lightspeedServer.$invalid == true && showErrors == true}\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.pos.lightspeed_server_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" name=\"lightspeedServer\" class=\"form-control\" ng-model=\"profile.data.lightspeedServer\" placeholder=\"https://<server_name>-web.posios.com\" required=\"\"></div></div></div><div class=\"pos-directions alert alert-info\" ng-if=\"profile.id && profile.posType !== \'icr_touch\'\"><div>{{\'profile_nav.settings.hotel_profile.pos.please_configure_label\' | i18next}}:<p><strong>{{\'profile_nav.settings.hotel_profile.pos.endpoint_label\' | i18next}}:</strong> {{profile.endpoint}}</p><p><strong>{{\'profile_nav.settings.hotel_profile.pos.username_label\' | i18next}}:</strong> {{profile.data.username}}</p><p><strong>{{\'profile_nav.settings.hotel_profile.pos.password_label\' | i18next}}:</strong> {{profile.data.password}}</p><div class=\"pos-autoconfigure\" ng-if=\"profile.posType == \'lightspeed\'\">{{\'profile_nav.settings.hotel_profile.pos.configure_automatically_label\' | i18next}}<md-button class=\"md-raised md-success\" ng-click=\"install(profile)\" ng-disabled=\"profile.loading\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"profile.loading\"></i> {{\'profile_nav.settings.hotel_profile.pos.autoinstall\' | i18next}}</md-button>Last auto-configuration: <span ng-if=\"profile.data.lightspeedLastConfiguration\">{{ profile.data.lightspeedLastConfiguration | dateToMoment : \"MMM D, YYYY h:mm:ss A\" }}</span> <span ng-if=\"!profile.data.lightspeedLastConfiguration\">none</span></div></div></div><div ng-if=\"profile.id && profile.posType !== \'icr_touch\'\"><legend>{{ \'profile_nav.settings.hotel_profile.pos.extras_mapping_label\' | i18next }}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container class=\"without-top-margin\"><md-checkbox ng-model=\"profile.data.useSeparateExtras\" aria-label=\"{{\'general.other.is_precent\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.pos.use_separate_extras_label\' | i18next}} <small>{{\'profile_nav.settings.hotel_profile.pos.use_separate_extras_description\' | i18next}}</small></md-checkbox></md-input-container></div></div><div class=\"row\"><table class=\"table table-hover general-table table-editable ng-scope\"><thead><tr><th>{{ \'profile_nav.settings.hotel_profile.pos.incoming_category_label\' | i18next }}</th><th>{{ \'profile_nav.settings.hotel_profile.pos.mapped_to_label\' | i18next }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"(key, value) in profile.data.extras as extras_list\"><td class=\"col-xs-6\">{{ key }}</td><td class=\"col-xs-5 autocomplete-col\"><span ng-hide=\"extra.edited == key\">{{ mapping[value] }}</span><div class=\"pos_mapping_extra_select\"><select-scrollable-extras ng-if=\"extra.edited == key\" on-scroll=\"onLoadExtras\" on-search=\"onSearchExtras\" on-select=\"selectedExtraChange\" options=\"extras\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" value=\"extra.selected\"></select-scrollable-extras></div></td><td class=\"col-xs-1\"><i class=\"fa fa-edit\" ng-hide=\"extra.edited == key\" ng-click=\"extra.edit(key, value)\" tooltip=\"{{\'edit\' | i18next}}\"></i> <i class=\"fa fa-floppy-o\" ng-click=\"extra.save(profile, key)\" tooltip=\"{{\'edit\' | i18next}}\" ng-show=\"extra.edited == key\"></i> <i class=\"fa fa-times\" ng-click=\"extra.cancel()\" tooltip=\"{{\'edit\' | i18next}}\" ng-show=\"extra.edited == key\"></i></td></tr><tr ng-if=\"!hasExtrasMapping\"><td colspan=\"3\">{{\'profile_nav.settings.hotel_profile.pos.extra_not_found_label\' | i18next}}</td></tr></tbody></table></div></div><div class=\"pos-directions alert alert-info\" ng-if=\"profile.id && profile.posType === \'icr_touch\'\"><div><p>{{\'profile_nav.settings.hotel_profile.pos.dropbox_directions\' | i18next}}</p><div class=\"pos-autoconfigure\"><md-button class=\"md-raised md-success\" ng-click=\"install(profile)\" ng-disabled=\"profile.loading || (profile.data.dropboxToken !== undefined && profile.data.dropboxToken !== \'\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"profile.loading\"></i> {{\'profile_nav.settings.hotel_profile.pos.autoinstall\' | i18next}}</md-button><span ng-if=\"profile.data.dropboxToken !== undefined && profile.data.dropboxToken !== \'\'\">{{\'profile_nav.settings.hotel_profile.pos.dropbox_token_present\' | i18next}}.</span></div></div></div><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeForm()\" ng-disabled=\"profile.loading\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveForm()\" ng-disabled=\"profile.loading\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"profile.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></form></div>");
$templateCache.put("templates/forms/roomForm_tpl.html","<form name=\"RoomForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-1\"><input type=\"text\" name=\"number\" ng-model=\"value.number\" class=\"form-control\" tabindex=\"100\" placeholder=\"\" required=\"\"></div><div class=\"col-xs-2\"><select class=\"form-control\" ng-model=\"value.roomTypeId\" ng-options=\"type.id as type.shortName for type in ctrl.roomTypes\" required=\"\"></select></div><div class=\"col-xs-1\"><select class=\"form-control\" ng-model=\"value.propertyId\" ng-options=\"type.id as type.name for type in ctrl.hotel.properties\" required=\"\"></select></div><div class=\"col-xs-1\"><input type=\"number\" name=\"priority\" ng-model=\"value.priority\" class=\"form-control\" min=\"1\" max=\"1000000\" required=\"\"></div><div class=\"col-xs-1 text-center\"><label class=\"inline\"><input type=\"checkbox\" ng-model=\"value.availableOnline\"></label></div><div class=\"col-xs-1 text-center\"><label class=\"inline\"><input type=\"checkbox\" ng-model=\"value.isActive\"></label></div><div class=\"col-xs-1\"><input type=\"text\" name=\"key_code\" ng-model=\"value.keyCode\" class=\"form-control\" tabindex=\"100\" placeholder=\"\" required=\"\" ng-hide=\"ctrl.hotel.roomKeyFromBookingRoomId\" ng-disabled=\"ctrl.hotel.roomKeyFromBookingRoomId\"><div class=\"text-center\" ng-show=\"ctrl.hotel.roomKeyFromBookingRoomId\">{{\'profile_nav.settings.hotel_profile.room_setup.dynamic\' | i18next}}</div></div><div class=\"col-xs-1\"><input type=\"text\" name=\"common_door_name\" ng-model=\"value.commonDoorName\" class=\"form-control\" tabindex=\"100\" placeholder=\"\" required=\"\"></div><div class=\"col-xs-1\"><input type=\"color\" name=\"color\" list=\"colors\" class=\"form-control\" ng-model=\"value.backgroundColor\" style=\"padding: 0px;\"><datalist id=\"colors\"><option ng-repeat=\"color in ctrl.color_options\">#{{color}}</option></datalist></div><div class=\"col-xs-1 text-center\"><label class=\"inline\"><input type=\"checkbox\" ng-model=\"value.divider\"></label></div><div class=\"col-xs-1 text-right controls\"><a ng-click=\"ctrl.saveCreateForm(value)\"><i tooltip=\"{{\'general.tooltip.save\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-check\" ng-hide=\"value.loading\"></i> <i tooltip=\"{{\'general.tooltip.saving\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': value.loading}\" ng-show=\"value.loading\"></i></a> <a ng-click=\"ctrl.closeCreateForm()\"><i tooltip=\"{{\'general.tooltip.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></div></div></form>");
$templateCache.put("templates/forms/roomTypeForm_tpl.html","<form name=\"RoomTypeForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.roomType.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'general.other.room_type\' | i18next}}:<locale-selector-next></locale-selector-next></label> <input type=\"text\" name=\"roomType\" ng-model=\"value.roomType\" class=\"form-control\" tabindex=\"100\" placeholder=\"Double\" required=\"\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.shortName.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'profile_nav.settings.inventory.room_type_form.short_name_label\' | i18next}}:<locale-selector-next></locale-selector-next></label> <input type=\"text\" name=\"shortName\" ng-model=\"value.shortName\" class=\"form-control\" tabindex=\"101\" placeholder=\"Standart Double\" required=\"\"></div></div><div class=\"col-xs-6\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.name.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'general.other.display_name\' | i18next}}:<locale-selector-next></locale-selector-next></label> <input type=\"text\" name=\"name\" ng-model=\"value.name\" class=\"form-control\" tabindex=\"102\" placeholder=\"Standart Double Room\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.maxAdults.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'general.other.max_adults\' | i18next}}:</label> <input type=\"text\" name=\"maxAdults\" ng-model=\"value.maxAdults\" class=\"form-control\" tabindex=\"104\" required=\"\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.maxChildren.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'general.other.max_children\' | i18next}}:</label> <input type=\"text\" name=\"maxChildren\" ng-model=\"value.maxChildren\" class=\"form-control\" tabindex=\"106\" required=\"\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.minStay.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'profile_nav.settings.inventory.room_type_form.max_occupancy_label\' | i18next}}:</label> <input type=\"text\" name=\"minStay\" ng-model=\"value.maxOccupancy\" class=\"form-control\" tabindex=\"107\" required=\"\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\" ng-if=\"!value.id\" ng-class=\"{\'has-error\' : RoomTypeForm.defaultPrice.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'profile_nav.settings.inventory.room_type_form.default_price_per_night_label\' | i18next}}:</label> <input type=\"text\" name=\"defaultPrice\" ng-model=\"value.defaultPrice\" class=\"form-control\" tabindex=\"108\" required=\"\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\" ng-if=\"$rootScope.hotel.country == \'IS\'\"><label class=\"control-label\">{{\'profile_nav.settings.inventory.room_type_form.kind_label\' | i18next}}:</label><select class=\"form-control\" ng-model=\"value.kind\"><option value=\"{{kind.value}}\" ng-value=\"kind.value\" ng-repeat=\"kind in icelandKind\">{{kind.name}}</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.defaultAdultsCount.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'general.other.default_adults\' | i18next}}:</label> <input type=\"text\" name=\"defaultAdultsCount\" ng-model=\"value.defaultAdultsCount\" class=\"form-control\" tabindex=\"104\" required=\"\"></div></div><div class=\"col-xs-3\"><div class=\"form-group\" ng-class=\"{\'has-error\' : RoomTypeForm.defaultChildrenCount.$invalid == true && showErrors == true}\"><label class=\"control-label\">{{\'general.other.default_children\' | i18next}}:</label> <input type=\"text\" name=\"defaultChildrenCount\" ng-model=\"value.defaultChildrenCount\" class=\"form-control\" tabindex=\"106\" required=\"\"></div></div><div class=\"col-xs-6\" ng-if=\"isAccountingCategoriesFeatureEnabled\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.accounting_category\' | i18next}}:</label><select class=\"form-control\" ng-model=\"value.accountingCategoryId\" ng-options=\"accountingCategory.id as accountingCategory.name for accountingCategory in ctrl.accountingCategories\"></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">{{\'general.other.description\' | i18next}}:<locale-selector-next></locale-selector-next></label> <textarea class=\"form-control description\" name=\"description\" ng-model=\"value.description\" tabindex=\"109\"></textarea></div></div></div><div class=\"row\"><div class=\"col-xs-6 form-group\"><label>{{\'profile_nav.settings.inventory.room_type_form.available_facilities_label\' | i18next}}</label><select multiple=\"\" size=\"6\" class=\"form-control\" ng-model=\"selectedAvailableFacility\" ng-options=\"facility.id as facility.title for facility in facilities\" ng-change=\"moveToSelected()\"></select></div><div class=\"col-xs-6 form-group\"><label>{{\'profile_nav.settings.inventory.room_type_form.your_selected_facilities_label\' | i18next}}</label><select multiple=\"\" size=\"6\" class=\"form-control\" ng-model=\"selectedChoosedFacility\" ng-options=\"facility.id as facility.title for facility in value.facilities\" ng-change=\"moveFromSelected()\"></select></div></div><div class=\"row bed-config\"><div class=\"col-xs-12\"><div class=\"bed-config-header\"><strong>{{\'profile_nav.settings.inventory.room_type_form.bed_config_header\' | i18next}}</strong> <a class=\"pull-right\" ng-click=\"addBedConfig()\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type_form.add_config_link\' | i18next}}</a></div><datalist id=\"bedTypes\"><option value=\"{{\'profile_nav.settings.inventory.room_type_form.crib_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.rollaway_or_extra_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.modern_cot_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.single_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.double_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.twin_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.standard_double_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.queen_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.olympic_queen_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.king_bed_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.super_king_option\' | i18next}}\"></option><option value=\"{{\'profile_nav.settings.inventory.room_type_form.grand_king_option\' | i18next}}\"></option></datalist><div class=\"text-center\" ng-if=\"!value.bedConfigRaw || value.bedConfigRaw.length == 0\">{{\'profile_nav.settings.inventory.room_type_form.current_room_type_does_not_have_any_bed_configuration_div\' | i18next}}<br><a ng-click=\"addBedConfig()\">{{\'profile_nav.settings.inventory.room_type_form.add_first_bed_config_link\' | i18next}}</a></div><div class=\"row\" ng-repeat=\"config in value.bedConfigRaw\" ng-if=\"value.bedConfigRaw && value.bedConfigRaw.length > 0\"><div class=\"col-xs-12\"><div class=\"bed-config-config-header\"><strong>{{\'profile_nav.settings.inventory.room_type_form.config_header\' | i18next}} #{{$index}}</strong> <a class=\"pull-right\" ng-click=\"removeBedConfig($index)\"><i class=\"fa fa-times\"></i> {{\'profile_nav.settings.inventory.room_type_form.remove_config_link\' | i18next}}</a> <a class=\"pull-right\" ng-click=\"addBed(config)\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type_form.add_bed_link\' | i18next}}</a></div><div class=\"row bed-config-table-header\"><div class=\"col-xs-5\">{{\'profile_nav.settings.inventory.room_type_form.bed_type_table_header\' | i18next}} <span tooltip=\"Required\" tooltip-append-to-body=\"true\">*</span></div><div class=\"col-xs-2\">{{\'general.other.count\' | i18next}} <span tooltip=\"Required\" tooltip-append-to-body=\"true\">*</span></div><div class=\"col-xs-4\">{{\'profile_nav.settings.inventory.room_type_form.size_table_header\' | i18next}}</div></div><div class=\"row bed-config-row\" ng-repeat=\"bed in config\"><div class=\"col-xs-5\"><div class=\"form-group\"><input type=\"text\" list=\"bedTypes\" ng-model=\"bed[0]\" class=\"form-control\" name=\"bedType{{$parent.$index}}-{{$index}}\" required=\"\"></div></div><div class=\"col-xs-2\"><div class=\"form-group\"><input type=\"number\" ng-model=\"bed[1]\" class=\"form-control\" name=\"bedCount{{$parent.$index}}-{{$index}}\" required=\"\" min=\"1\"></div></div><div class=\"col-xs-4\"><div class=\"form-group\"><input type=\"text\" ng-model=\"bed[2]\" class=\"form-control\" name=\"bedSize{{$parent.$index}}-{{$index}}\"></div></div><div class=\"col-xs-1 text-right\"><i class=\"fa fa-times\" ng-click=\"removeBed(config, $index)\" tooltip=\"Remove Bed\" tooltip-append-to-body=\"true\"></i></div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\">{{\'profile_nav.settings.inventory.room_type_form.ical_link_text\' | i18next}}: <a href=\"{{value.link}}\">{{value.link}}</a><br><br></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"photos-container\" ng-show=\"(value.photos.length > 0)\"><div ng-repeat=\"photo in value.photos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.picture}}\" ng-show=\"photo.picture\"></div><div class=\"tools\"><a href=\"{{photo.picture.replace(\'thumb\', \'big\')}}\" ng-show=\"photo.picture\" aria-label=\"{{\'general.tooltip.direct_link\' | i18next}}\"><md-tooltip md-direction=\"bottom\">{{\'general.tooltip.direct_link\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <span aria-label=\"{{\'general.tooltip.feature_image\' | i18next}}\"><i class=\"fa\" ng-class=\"{\'fa-star\' : photo.featured == true, \'fa-star-o\' : photo.featured == false || photo.featured == null}\" ng-hide=\"photo.loading\" ng-click=\"featurePhoto(photo)\"></i><md-tooltip md-direction=\"bottom\" ng-hide=\"photo.loading\">{{\'general.tooltip.feature_image\' | i18next}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-show=\"photo.loading\">{{\'general.tooltip.feature_image\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-show=\"photo.loading\"></i></span> <span class=\"pull-right\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><i class=\"fa fa-times-circle\" ng-hide=\"photo.loading\" ng-click=\"removePhoto(photo)\"></i><md-tooltip md-direction=\"bottom\" ng-hide=\"photo.loading\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-show=\"photo.loading\">{{\'general.tooltip.removing\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-show=\"photo.loading\"></i></span></div></div></div></div><div class=\"col-xs-12\"><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\" ng-show=\"photoLoaded != true\"></i> <i class=\"fa fa-spinner\" ng-show=\"photoLoaded == true\" ng-class=\"{\'fa-spin\': photoLoaded == true}\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" onchange=\"angular.element(this).scope().multipleFileUpload(event)\" multiple=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 text-right\"><button class=\"btn btn-primary\" ng-disabled=\"saving == true\" ng-click=\"saveCreateForm()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : saving}\" ng-show=\"saving\"></i> {{\'general.buttons.save\' | i18next}}</button> <button class=\"btn btn-danger\" ng-click=\"closeCreateForm()\">{{\'general.buttons.cancel\' | i18next}}</button></div></div></form>");
$templateCache.put("templates/forms/saleChannelForm_tpl.html","<div class=\"table-form\"><form name=\"vm.saleChannelForm\" novalidate=\"\"><legend ng-if=\"vm.saleChannel.id\">{{\'general.tooltip.edit\' | i18next}}</legend><legend ng-if=\"!vm.saleChannel.id\">{{\'general.tooltip.create\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.name\' | i18next}}</label> <input ng-model=\"vm.saleChannel.name\" ng-change=\"vm.onNameChange()\" required=\"\" ng-disabled=\"vm.saleChannel.isSystem()\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.abbreviation\' | i18next}}</label> <input maxlength=\"8\" ng-model=\"vm.saleChannel.code\" required=\"\" ng-disabled=\"vm.saleChannel.isSystem()\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12 radio-group\"><md-radio-group ng-model=\"vm.saleChannel.status\" class=\"inline\" ng-required=\"true\"><md-radio-button value=\"confirmed\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.active\' | i18next}}</md-radio-button><md-radio-button value=\"draft\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.draft\' | i18next}}</md-radio-button></md-radio-group></div></div><div class=\"row\"><div class=\"col-xs-12 radio-group\"><select-customer-input show-not-found=\"true\" source=\"sale_channel\" sale_channel_id=\"vm.saleChannel.id\" label=\"profile_nav.settings.booking_engine.sale_channels_settings.associated_customer\" customer-query=\"vm.customerQuery\" on-change=\"vm.chooseCustomer\"></select-customer-input></div></div><div ng-if=\"vm.saleChannel.customer_id || vm.saleChannel.customer\"><legend>{{\'profile_nav.settings.booking_engine.sale_channels_settings.folio_routing_settings\' | i18next}}</legend><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"vm.saleChannel.useChannelCustomerForAccommodation\" aria-label=\"{{\'profile_nav.settings.booking_engine.sale_channels_settings.use_channel_customer_for_accommodation\' | i18next}}\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.use_channel_customer_for_accommodation\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"vm.saleChannel.useChannelCustomerForExtras\" aria-label=\"{{\'profile_nav.settings.booking_engine.sale_channels_settings.use_channel_customer_for_extras\' | i18next}}\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.use_channel_customer_extras\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"vm.saleChannel.useRoutingOnlyForVirtualCards\" aria-label=\"{{\'profile_nav.settings.booking_engine.sale_channels_settings.use_routing_only_for_virtual_cards\' | i18next}}\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.use_routing_only_for_virtual_cards\' | i18next}}</md-checkbox></div></div></div><div class=\"form-buttons\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.cancelAction()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"vm.saveAction()\" ng-disabled=\"vm.saleChannelForm.$invalid || vm.requestInProgress\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : vm.requestInProgress}\" ng-if=\"vm.requestInProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/forms/settingsDiscountForm_tpl.html","<form name=\"DiscountForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-4\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label><locale-selector-next></locale-selector-next><input type=\"text\" ng-model=\"value.title\" name=\"title\" required=\"\"></md-input-container></div><div class=\"col-xs-3 radio-group\"><md-radio-group ng-model=\"value.percent\" class=\"inline\"><md-radio-button value=\"1\">{{\'general.other.percent\' | i18next}}</md-radio-button><md-radio-button value=\"0\">{{\'general.other.fixed\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"col-xs-3\"><md-input-container><label>{{\'general.other.amount\' | i18next}}</label> <input type=\"number\" ng-model=\"value.amount\" name=\"amount\" min=\"0\" max=\"{{ value.percent ? 100 : \'\'}}\" required=\"\"></md-input-container></div><div class=\"col-xs-2 text-right controls\"><a ng-click=\"saveCreateForm(value)\" aria-label=\"{{\'general.buttons.save\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.buttons.save\' | i18next}}</md-tooltip><i class=\"fa fa-check\"></i></a> <a ng-click=\"ctrl.closeCreateForm()\" aria-label=\"{{\'general.buttons.cancel\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.buttons.cancel\' | i18next}}</md-tooltip><i class=\"fa fa-times\"></i></a></div></div></form>");
$templateCache.put("templates/forms/settingsExtraCategoryForm_tpl.html","<div class=\"table-form\"><form name=\"ExtraForm\" novalidate=\"\"><legend>{{\'profile_nav.settings.hotel_profile.extras_categories_form.edit_extra_category\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label><locale-selector-next></locale-selector-next><input type=\"text\" ng-model=\"value.title\" name=\"title\" required=\"\"></md-input-container></div></div><div class=\"row\" ng-if=\"isAccountingCategoriesFeatureEnabled\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.accounting_category\' | i18next}}</label><md-select ng-model=\"value.accountingCategoryId\"><md-option ng-repeat=\"accountingCategory in ctrl.accountingCategories\" value=\"{{accountingCategory.id}}\">{{accountingCategory.name}}</md-option></md-select></md-input-container></div></div><div class=\"row\" ng-hide=\"value.withoutTaxes\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.attached_taxes\' | i18next}}</label><md-select ng-model=\"value.taxGroups\" class=\"save_extras_checkbox\" ng-disabled=\"!(user.role == \'admin\' || user.aclRole == \'manager\' || user.isOwner == true || user.corporateRole == \'owner\' || user.corporateRole == \'manager\') && value.id\" multiple=\"\"><md-option ng-repeat=\"taxGroup in ctrl.grouppedTaxes | filter:{applicableToExtra:true}\" value=\"{{taxGroup.id}}\">{{taxGroup.name}}</md-option></md-select></md-input-container></div></div><br><div class=\"form-buttons row\"><div class=\"col-xs-12 text-right save_extras_footer\"><md-checkbox ng-model=\"value.withoutTaxes\" class=\"save_extras_checkbox\" aria-label=\"{{\'general.other.without_taxes\' | i18next}}\" ng-disabled=\"!(user.role == \'admin\' || user.aclRole == \'manager\' || user.isOwner == true || user.corporateRole == \'owner\' || user.corporateRole == \'manager\') && value.id\">{{\'general.other.without_taxes\' | i18next}}</md-checkbox><md-button class=\"md-raised md-warn\" ng-click=\"ctrl.closeCategoryForm(value)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveCategoryForm(value)\">{{\'general.buttons.save\' | i18next}}</md-button></div></div></form></div>");
$templateCache.put("templates/forms/settingsFacilityForm_tpl.html","<form name=\"FacilityForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-5\"><md-input-container><label>{{\'general.other.icon\' | i18next}}</label><md-select ng-model=\"value.icon\"><md-option ng-value=\"icon\" ng-repeat=\"icon in uniqIcons\"><i class=\"fa fa-{{icon}}\"></i> <span ng-bind-html=\"icon\"></span></md-option></md-select></md-input-container></div><div class=\"col-xs-5\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label><locale-selector-next></locale-selector-next><input type=\"text\" name=\"title\" ng-model=\"value.title\" placeholder=\"Title\" required=\"\"></md-input-container></div><div class=\"col-xs-2 text-right controls\"><a ng-click=\"saveCreateForm(value)\"><i tooltip=\"{{\'general.tooltip.save\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-check\"></i></a> <a ng-click=\"ctrl.closeCreateForm()\"><i tooltip=\"{{\'general.tooltip.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></div></div></form>");
$templateCache.put("templates/forms/settingsPictureForm_tpl.html","<form name=\"PictureForm\" novalidate=\"\"><div class=\"row picture-row\"><div class=\"col-xs-2\"><label>{{\'website_settings.picture_form.picture_label\' | i18next}}</label><br><img ng-src=\"{{value.picture}}\" style=\"max-width: 110px;\"></div><div class=\"col-xs-2\"><md-input-container><label>{{\'website_settings.picture_form.zone_label\' | i18next}}</label><md-select ng-model=\"value.zone\"><md-option ng-repeat=\"zone in ctrl.zones\" value=\"{{zone}}\">{{\'general.picture_zones.\' + zone | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-show=\"value.zone == \'Room\'\"><md-input-container><label>{{\'general.other.room_type\' | i18next}}</label><md-select ng-model=\"value.roomTypeId\"><md-option ng-repeat=\"type in ctrl.roomTypes\" value=\"{{type.id}}\">{{type.shortName}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3\" ng-class=\"{\'col-xs-6\' : value.zone != \'Room\'}\" ng-show=\"value.zone != \'Website\'\"><md-input-container><label>{{\'general.other.description\' | i18next}}</label> <input type=\"text\" name=\"description\" ng-model=\"value.description\"></md-input-container></div><div class=\"col-xs-3\" ng-class=\"{\'col-xs-6\' : value.zone != \'Room\'}\" ng-show=\"value.zone == \'Website\'\"><md-input-container><label>{{\'website_settings.picture_form.target_label\' | i18next}}</label><md-select ng-model=\"value.description\"><md-option ng-repeat=\"zone in ctrl.targets\" value=\"{{zone}}\">{{\'general.picture_targets.\' + zone | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 text-right controls\" ng-hide=\"value.loading\"><a ng-click=\"saveCreateForm(value)\"><i tooltip=\"{{\'general.tooltip.save\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-check\"></i></a> <a ng-click=\"ctrl.closeCreateForm()\"><i tooltip=\"{{\'general.tooltip.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></div><div class=\"col-xs-2 text-right controls\" ng-show=\"value.loading\"><i class=\"fa fa-spin fa-spinner\"></i></div></div></form>");
$templateCache.put("templates/forms/settingsReactionForm_tpl.html","<div class=\"table-form\"><form class=\"form-horizontal reaction-form\" name=\"reactionForm\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.reactions.task_label\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" ng-model=\"value.task\" ng-required=\"true\" ng-change=\"ctrl.resetSelectedTrigger(value)\"><option ng-repeat=\"task in value.filteredTasks\" value=\"{{task.className}}\" ng-selected=\"task.className == value.task\">{{task.title}}</option></select><p class=\"help-block\" ng-bind-html=\"getTaskDescription(value.task)\"></p></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'general.other.title\' | i18next}}</label><div class=\"col-xs-9\"><input class=\"form-control\" ng-model=\"value.title\" type=\"text\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'general.other.description\' | i18next}}</label><div class=\"col-xs-9\"><input class=\"form-control\" ng-model=\"value.description\" type=\"text\" ng-required=\"true\"></div></div><div class=\"form-group\" ng-repeat=\"arg in getTaskArguments(value.task)\"><legend class=\"task-arguments-legend\" ng-if=\"$index == 0\">{{\'profile_nav.settings.other.reactions.task_default_arguments_legend\' | i18next}}</legend><label class=\"col-xs-3\">{{arg[2]}}:</label><div class=\"col-xs-9\"><select ng-if=\"arg[1] == \'select\'\" class=\"form-control\" ng-model=\"value.defaultArguments[arg[0]]\" ng-required=\"true\"><option ng-repeat=\"option in arg[4]\" value=\"{{option.value}}\" ng-selected=\"option.value == value.defaultArguments[arg[0]]\">{{option.display}}</option></select><div ng-if=\"arg[1] == \'email\'\" class=\"field-with-dropins\"><input data-role=\"emailField{{arg[0]}}\" class=\"form-control\" type=\"text\" ng-model=\"value.defaultArguments[arg[0]]\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button for-email-address\"><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\">{{\'general.other.drop_in_s\' | i18next}}</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in emailAdressDropins\"><md-button ng-click=\"insertEmailAdressDropIn(value.defaultArguments, arg[0], dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu></div><div ng-if=\"arg[1] == \'prefilled\'\" class=\"reaction-prefilled-content\"><div class=\"col-xs-5\"><input class=\"form-control\" type=\"text\" ng-model=\"value.defaultArguments[arg[0]]\" placeholder=\"{{getPrefilledEditableContent(arg[0])}}\"></div><div class=\"col-xs-4 reaction-prefilled-content-uneditable\">{{getPrefilledUneditableContent(arg[0])}}</div></div><input ng-if=\"arg[1] == \'string\'\" class=\"form-control\" ng-model=\"value.defaultArguments[arg[0]]\" type=\"text\" ng-required=\"true\"> <textarea ng-if=\"arg[1] == \'text\'\" class=\"form-control\" ng-model=\"value.defaultArguments[arg[0]]\" ng-required=\"true\"></textarea></div><div ng-if=\"arg[1] == \'wysiwyg\'\" class=\"field-with-dropins col-xs-12\"><react-email-template-builder container=\"\'email-template-container-{{value.task}}\'\" base-template=\"value.defaultArguments.content\" base-template-json=\"value.defaultArguments.contentJson\" merge-tags=\"mergeTags\" hotel-id=\"hotelId\" email-type=\"value.id\" on-send=\"sendTestLetter\" on-save=\"saveEditedReactionWithTemplate\" should-save=\"shouldSave\" additional-template=\"null\" on-load-bee-free-token=\"onLoadBeeFreeToken\"></react-email-template-builder></div><div class=\"col-xs-9\"><input ng-if=\"arg[1] == \'integer\'\" class=\"form-control\" ng-model=\"value.defaultArguments[arg[0]]\" type=\"number\" ng-required=\"true\"> <input ng-if=\"arg[1] == \'boolean\'\" ng-model=\"value.defaultArguments[arg[0]]\" type=\"checkbox\"><p class=\"help-block\" ng-if=\"arg[3]\">{{arg[3]}}</p></div></div><div ng-if=\"value.kind != \'scheduled\'\"><div class=\"form-group\"><label class=\"col-xs-12\">{{\'profile_nav.settings.other.reactions.conditions_label\' | i18next}}:</label></div><settings-condition-group ng-model=\"value.conditions\" ng-scope=\"this\" parent=\"null\"></settings-condition-group></div><div ng-transclude=\"\"></div><div class=\"form-buttons\" ng-hide=\"value.triggerFormOpened\"><div class=\"row\"><div class=\"col-xs-6\"><label><input ng-model=\"value.isEnabled\" type=\"checkbox\"> {{\'general.other.enabled\' | i18next}}</label></div><div class=\"col-xs-6 text-right\"><md-button class=\"md-raised md-primary\" ng-if=\"getTaskIsTestable(value.task) == true\" ng-click=\"testTask(value.task, value.defaultArguments)\">{{\'profile_nav.settings.other.reactions.test_button\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"ctrl.cancelReactionEditing(value)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveEditedReaction(value)\">{{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/forms/settingsTriggerForm_tpl.html","<div class=\"table-form\"><form name=\"TriggerForm\" class=\"form-horizontal\" novalidate=\"\"><legend ng-if=\"value.id\">{{\'profile_nav.settings.other.reactions.edit_trigger_label\' | i18next}}</legend><legend ng-if=\"!value.id\">{{\'profile_nav.settings.hotel_profile.id_types.form.create_trigger_label\' | i18next}}</legend><div class=\"form-group\"><label class=\"col-xs-3\">{{\'general.other.type\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" ng-model=\"value.kind\"><option ng-repeat=\"type in value.filteredTypes\" value=\"{{type}}\">{{type | capitalize}}</option></select></div></div><div ng-if=\"value.kind\"><div class=\"form-group\" ng-hide=\"value.kind === \'scheduled\'\"><label class=\"col-xs-3\">{{\'general.other.event\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" ng-model=\"value.event\" ng-required=\"true\"><option ng-if=\"value.kind === \'before\'\" ng-repeat=\"event in ctrl.before_events\" value=\"{{event.value}}\">{{event.display}}</option><option ng-if=\"value.kind !== \'before\'\" ng-repeat=\"event in ctrl.after_events\" value=\"{{event.value}}\">{{event.display}}</option></select></div></div><div class=\"form-group\" ng-if=\"value.kind == \'scheduled\'\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.reactions.execute_label\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" name=\"executionConditions\" ng-model=\"value.executionConditions\"><option value=\'[\"day\"]\'>{{\'profile_nav.settings.other.reactions.every_day_option\' | i18next}}</option><option value=\'[\"Monday\"]\'>{{\'profile_nav.settings.other.reactions.every_monday_option\' | i18next}}</option><option value=\'[\"Tuesday\"]\'>{{\'profile_nav.settings.other.reactions.every_tuesday_option\' | i18next}}</option><option value=\'[\"Wednesday\"]\'>{{\'profile_nav.settings.other.reactions.every_wednesday_option\' | i18next}}</option><option value=\'[\"Thursday\"]\'>{{\'profile_nav.settings.other.reactions.every_thursday_option\' | i18next}}</option><option value=\'[\"Friday\"]\'>{{\'profile_nav.settings.other.reactions.every_friday_option\' | i18next}}</option><option value=\'[\"Saturday\"]\'>{{\'profile_nav.settings.other.reactions.every_saturday_option\' | i18next}}</option><option value=\'[\"Sunday\"]\'>{{\'profile_nav.settings.other.reactions.every_sunday_option\' | i18next}}</option><option value=\'[\"first\",\"day of month\"]\'>{{\'profile_nav.settings.other.reactions.first_day_of_month_option\' | i18next}}</option><option value=\'[\"last\",\"day of month\"]\'>{{\'profile_nav.settings.other.reactions.last_day_of_month_option\' | i18next}}</option></select></div></div><div class=\"form-group\" ng-if=\"value.kind == \'after\' || value.kind == \'before\'\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.reactions.execute_at_label\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" name=\"executionConditions\" ng-model=\"value.executionConditions\"><option value=\'[0,\"day\"]\' ng-if=\"value.kind == \'after\'\">{{\'profile_nav.settings.other.reactions.immediately_option\' | i18next}}</option><option value=\'[0,\"day\"]\' ng-if=\"value.kind == \'before\'\">{{\'profile_nav.settings.other.reactions.on_day_option\' | i18next}}</option><option value=\'[1,\"day\"]\'>1 {{\'profile_nav.settings.other.reactions.day_option\' | i18next}}</option><option value=\'[2,\"days\"]\'>2 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[3,\"days\"]\'>3 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[4,\"days\"]\'>4 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[5,\"days\"]\'>5 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[6,\"days\"]\'>6 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[7,\"days\"]\'>7 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[8,\"days\"]\'>8 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[9,\"days\"]\'>9 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[10,\"days\"]\'>10 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[14,\"days\"]\'>14 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[30,\"days\"]\'>30 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[55,\"days\"]\'>55 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[60,\"days\"]\'>60 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[84,\"days\"]\'>84 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option><option value=\'[86,\"days\"]\'>86 {{\'profile_nav.settings.other.reactions.days_option\' | i18next}}</option></select></div></div><div class=\"form-group\" ng-if=\"value.kind == \'scheduled\' || value.kind == \'before\'\"><label class=\"col-xs-3\">{{(\'profile_nav.settings.other.reactions.\'+(value.kind == \'before\' ? \'execute_at_time_label\' : \'execution_time_label\')) | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" name=\"executionTime\" ng-model=\"value.executionTime\"><option value=\"\" ng-if=\"value.kind == \'before\'\">None</option><option value=\"0\">00:00</option><option value=\"900\">00:15</option><option value=\"1800\">00:30</option><option value=\"2700\">00:45</option><option value=\"3600\">01:00</option><option value=\"4500\">01:15</option><option value=\"5400\">01:30</option><option value=\"6300\">01:45</option><option value=\"7200\">02:00</option><option value=\"8100\">02:15</option><option value=\"9000\">02:30</option><option value=\"9900\">02:45</option><option value=\"10800\">03:00</option><option value=\"11700\">03:15</option><option value=\"12600\">03:30</option><option value=\"13500\">03:45</option><option value=\"14400\">04:00</option><option value=\"15300\">04:15</option><option value=\"16200\">04:30</option><option value=\"17100\">04:45</option><option value=\"18000\">05:00</option><option value=\"18900\">05:15</option><option value=\"19800\">05:30</option><option value=\"20700\">05:45</option><option value=\"21600\">06:00</option><option value=\"22500\">06:15</option><option value=\"23400\">06:30</option><option value=\"24300\">06:45</option><option value=\"25200\">07:00</option><option value=\"26100\">07:15</option><option value=\"27000\">07:30</option><option value=\"27900\">07:45</option><option value=\"28800\">08:00</option><option value=\"29700\">08:15</option><option value=\"30600\">08:30</option><option value=\"31500\">08:45</option><option value=\"32400\">09:00</option><option value=\"33300\">09:15</option><option value=\"34200\">09:30</option><option value=\"35100\">09:45</option><option value=\"36000\">10:00</option><option value=\"36900\">10:15</option><option value=\"37800\">10:30</option><option value=\"38700\">10:45</option><option value=\"39600\">11:00</option><option value=\"40500\">11:15</option><option value=\"41400\">11:30</option><option value=\"42300\">11:45</option><option value=\"43200\">12:00</option><option value=\"44100\">12:15</option><option value=\"45000\">12:30</option><option value=\"45900\">12:45</option><option value=\"46800\">13:00</option><option value=\"47700\">13:15</option><option value=\"48600\">13:30</option><option value=\"49500\">13:45</option><option value=\"50400\">14:00</option><option value=\"51300\">14:15</option><option value=\"52200\">14:30</option><option value=\"53100\">14:45</option><option value=\"54000\">15:00</option><option value=\"54900\">15:15</option><option value=\"55800\">15:30</option><option value=\"56700\">15:45</option><option value=\"57600\">16:00</option><option value=\"58500\">16:15</option><option value=\"59400\">16:30</option><option value=\"60300\">16:45</option><option value=\"61200\">17:00</option><option value=\"62100\">17:15</option><option value=\"63000\">17:30</option><option value=\"63900\">17:45</option><option value=\"64800\">18:00</option><option value=\"65700\">18:15</option><option value=\"66600\">18:30</option><option value=\"67500\">18:45</option><option value=\"68400\">19:00</option><option value=\"69300\">19:15</option><option value=\"70200\">19:30</option><option value=\"71100\">19:45</option><option value=\"72000\">20:00</option><option value=\"72900\">20:15</option><option value=\"73800\">20:30</option><option value=\"74700\">20:45</option><option value=\"75600\">21:00</option><option value=\"76500\">21:15</option><option value=\"77400\">21:30</option><option value=\"78300\">21:45</option><option value=\"79200\">22:00</option><option value=\"80100\">22:15</option><option value=\"81000\">22:30</option><option value=\"81900\">22:45</option><option value=\"82800\">23:00</option><option value=\"83700\">23:15</option><option value=\"84600\">23:30</option><option value=\"85500\">23:45</option></select></div></div></div><div class=\"task-controls\"><label><input ng-model=\"value.isEnabled\" type=\"checkbox\"> {{\'general.other.enabled\' | i18next}}</label></div><div ng-transclude=\"\"></div><div class=\"form-buttons\" ng-hide=\"value.reactionFormOpened\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"ctrl.cancelTriggerEditing(value)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveTriggerEditing(value)\">{{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/forms/userForm_tpl.html","<legend>New user</legend><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Email address</label> <input type=\"text\" ng-model=\"value.email\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>User name</label> <input type=\"text\" ng-model=\"value.name\"></md-input-container></div></div><div class=\"row\" ng-hide=\"value.id\"><div class=\"col-md-6\"><md-input-container><label>Password</label> <input type=\"password\" ng-model=\"value.password\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Password confirmation</label> <input type=\"password\" ng-model=\"value.password_confirmation\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Role</label><md-select ng-model=\"value.role\"><md-option ng-repeat=\"role in roles\" value=\"{{role}}\">{{role}}</md-option></md-select></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Associated Hotel</label><md-select ng-model=\"value.hotelId\"><md-option ng-repeat=\"hotel in hotels\" value=\"{{hotel.id}}\">{{hotel.name}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12 text-right\"><md-button class=\"md-raised md-success\" ng-click=\"save()\"><i class=\"fa fa-spin fa-spinner\" ng-show=\"saving\"></i> Save</md-button><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\">Cancel</md-button></div></div>");
$templateCache.put("templates/inputs/sale_channel_input_tpl.html","<md-autocomplete md-selected-item=\"ctrl.value\" md-search-text-change=\"ctrl.search()\" md-search-text=\"ctrl.query\" md-items=\"item in ctrl.search()\" md-item-text=\"item\" md-min-length=\"0\" md-autoselect=\"false\" md-select-on-match=\"true\" md-floating-label=\"{{\'bookings.create_booking.source_or_agent_floating_label\' | i18next}}\"><md-item-template><span md-highlight-text=\"ctrl.query\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>{{\'bookings.create_booking.just_fill_other_fields_we_create_new_source_not_found\' | i18next}}</md-not-found></md-autocomplete>");
$templateCache.put("templates/inputs/select_customer_input_tpl.html","<md-autocomplete flex=\"\" md-input-name=\"selectCustomerInput\" md-input-minlength=\"ctrl.minlength\" md-search-text=\"ctrl.customerQuery\" md-items=\"item in ctrl.searchCustomer(ctrl.customerQuery)\" md-item-text=\"item.visible_name\" md-selected-item-change=\"ctrl.onChange(item)\" md-delay=\"1200\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{ctrl.label ? ctrl.label : \'bookings.customer.title\' | i18next}}\"><md-item-template><span>{{item.visible_name}} <i class=\"fa\" ng-class=\"{\'fa-building\': item.type == 1, \'fa-male\': item.type == 0}\"></i> <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.mobile_phone ? item.mobile_phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete>");
$templateCache.put("templates/modals/addHotelToCorporateAccount_tpl.html","<md-dialog aria-label=\"Add Hotel To Corporate Account\" ng-cloak=\"\"><form name=\"addHotelToCorporateAccount\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Hotel To Corporate Account</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-autocomplete md-selected-item=\"hotel\" md-search-text=\"searchText\" md-items=\"hotel in hotels | filter:searchText\" md-item-text=\"hotel.name\" md-min-length=\"0\" placeholder=\"Select hotel\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{hotel.name}}</span></md-item-template><md-not-found>No states matching \"{{searchText}}\" were found.</md-not-found></md-autocomplete></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-click=\"save()\">Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/addLanguage_tpl.html","<md-dialog aria-label=\"Add Language\" ng-cloak=\"\"><form name=\"addLanguage\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'website_settings.add_language_modal.title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-autocomplete md-selected-item=\"newLang\" md-search-text-change=\"searchTextChange(searchText)\" md-search-text=\"searchText\" md-items=\"item in filter(searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" md-autoselect=\"true\" md-floating-label=\"Choose language\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.name}} ({{item.nativeName}})</span></md-item-template><md-not-found>{{\'website_settings.add_language_modal.no_language_matching_not_found\' | i18next: {\"searchText\": searchText} }}</md-not-found></md-autocomplete></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"newLang == null\" ng-click=\"save()\">{{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/addUserToCorporateAccount_tpl.html","<md-dialog aria-label=\"Add User To Corporate Account\" ng-cloak=\"\"><form name=\"addUserToCorporateAccount\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add User To Corporate Account</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-autocomplete md-selected-item=\"user\" md-search-text=\"searchText\" md-items=\"user in users | filter:searchText\" md-item-text=\"user.email\" md-min-length=\"0\" placeholder=\"Select user\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{user.name}} ({{user.email}})</span></md-item-template><md-not-found>No states matching \"{{searchText}}\" were found.</md-not-found></md-autocomplete><md-input-container class=\"md-block\"><label>Assign as role {{role}}</label><md-select ng-model=\"role\"><md-option value=\"owner\">Owner</md-option><md-option value=\"manager\">Manager</md-option><md-option value=\"reception\">Reception</md-option><md-option value=\"reception_no_finance\">Reception (No Finance)</md-option><md-option value=\"housekeeper\">Housekeeper</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"save()\">Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/addUser_tpl.html","<md-dialog aria-label=\"Add User\" ng-cloak=\"\"><form name=\"addUser\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 ng-if=\"!user.id\">Add User</h2><h2 ng-if=\"user.id\">Edit User</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>Email address</label> <input type=\"email\" ng-model=\"user.email\" name=\"email\" required=\"\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>User name</label> <input type=\"text\" ng-model=\"user.name\" name=\"name\" required=\"\"></md-input-container></div></div><div class=\"row\" ng-if=\"!user.id\"><div class=\"col-md-6\"><md-input-container><label>Password</label> <input type=\"password\" ng-model=\"user.password\" name=\"password\" required=\"\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Password confirmation</label> <input type=\"password\" ng-model=\"user.password_confirmation\" name=\"password_confirmation\" required=\"\"></md-input-container></div></div><div class=\"row\" ng-if=\"!user.id\"><div class=\"col-md-6\"><md-input-container><label>Role</label><md-select ng-model=\"user.role\" name=\"role\"><md-option ng-repeat=\"role in roles\" value=\"{{role}}\">{{role}}</md-option></md-select></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>Associated Hotel</label><md-select ng-model=\"user.hotelId\" name=\"hotel\"><md-option ng-repeat=\"hotel in hotels\" value=\"{{hotel.id}}\">{{hotel.name}}</md-option></md-select></md-input-container></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"addUser.$invalid || saving\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : saving}\" ng-show=\"saving\"></i> Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/alert_tpl.html","<div class=\"modal-content\"><div class=\"modal-header\"><button ng-click=\"falseAction()\" type=\"button\" class=\"close\" aria-hidden=\"true\">×</button><h4 class=\"modal-title\">Alert</h4></div><div class=\"modal-body\" ng-bind-html=\"text\"></div><div class=\"modal-footer\"><button ng-click=\"falseAction()\" class=\"btn btn-default\" type=\"button\">Ok</button></div></div>");
$templateCache.put("templates/modals/bulkUpdate_tpl.html","<md-dialog aria-label=\"Bulk Update\" ng-cloak=\"\" class=\"buldUpdate__dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'inventory.bulk_update.title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"buldUpdate__content\"><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'inventory.bulk_update.choose_resetriction\' | i18next}}:</label><md-select ng-model=\"restriction\" required=\"\" ng-change=\"changeRestriction()\"><md-option ng-repeat=\"restriction in restrictions\" ng-value=\"restriction.code\">{{\'general.other.\' + restriction.code | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><div ng-if=\"restrictionMode == \'boolean\'\"><label class=\"bulkUpdate__booleanLabel\">{{\'inventory.bulk_update.value\' | i18next}}:</label><md-radio-group ng-model=\"$parent.value\"><md-radio-button ng-value=\"true\" class=\"md-primary\">{{\'inventory.bulk_update.on\' | i18next}}</md-radio-button><md-radio-button ng-value=\"false\">{{\'inventory.bulk_update.off\' | i18next}}</md-radio-button></md-radio-group></div><div ng-if=\"restrictionMode == \'number\'\"><md-input-container><label>{{\'inventory.bulk_update.value\' | i18next}}:</label> <input ng-model=\"$parent.value\" type=\"number\" min=\"{{minValue}}\" required=\"\"></md-input-container></div></div></div><div class=\"row bulkUpdate__dateRanges\" ng-repeat=\"range in ranges\"><div class=\"col-xs-11\"><div class=\"row\"><div class=\"col-xs-6 date-col\"><label>{{\'general.other.from\' | i18next}}</label><md-datepicker ng-model=\"range.dateFrom\" md-placeholder=\"Date From\" ng-change=\"setRangeRestriction(range, \'dateFrom\')\" md-min-date=\"today\" md-max-date=\"range.maxDate\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'general.other.to\' | i18next}}</label><md-datepicker ng-model=\"range.dateTo\" md-placeholder=\"Date To\" ng-change=\"setRangeRestriction(range, \'dateTo\')\" md-min-date=\"range.minDate\"></md-datepicker></div></div><div class=\"row weekdays\"><div class=\"col-xs-12\"><md-checkbox ng-repeat=\"day in range.weekdays track by $index\" ng-model=\"range.weekdays[$index]\">{{\'general.days_of_week.\' + weekdays[$index] | i18next}}</md-checkbox></div></div></div><div class=\"col-xs-1 bulkUpdate__dateRanges__controls\"><a ng-show=\"$index == ranges.length - 1\" ng-click=\"addRange()\"><i class=\"fa fa-plus\"></i></a> <a ng-hide=\"ranges.length == 1\" ng-click=\"removeRange($index)\"><i class=\"fa fa-minus\"></i></a></div></div><div class=\"row bulkUpdate__rates\"><div class=\"col-xs-12\"><legend>{{\'inventory.bulk_update.apply_to\' | i18next}}:<div class=\"pull-right\"><span ng-show=\"restriction == \'rate\'\"><a ng-click=\"toggleDerivedRates()\">{{ hideDerivedRates ? \'Show derived rates\' : \'Hide derived rates\' }}</a> |</span> <a ng-click=\"selectAllRates()\">{{\'inventory.bulk_update.select_all\' | i18next}}</a> | <a ng-click=\"deselectAllRates()\">{{\'inventory.bulk_update.deselect_all\' | i18next}}</a></div></legend><div ng-repeat=\"roomRepresentation in roomRepresentations track by roomRepresentation.id\"><div><strong>{{roomRepresentation.title}}</strong><div class=\"pull-right\"><a ng-click=\"selectAllRates(roomRepresentation.id)\">{{\'inventory.bulk_update.select_all\' | i18next}}</a> | <a ng-click=\"deselectAllRates(roomRepresentation.id)\">{{\'inventory.bulk_update.deselect_all\' | i18next}}</a></div></div><div class=\"row bulkUpdate__rateRow\" ng-repeat=\"roomRate in roomRepresentation.filteredRoomRates track by roomRate.id\"><div class=\"col-xs-6\"><md-checkbox ng-model=\"roomRate.selected\">{{rateCategories[roomRate.rateCategoryId].name}}</md-checkbox></div><div class=\"col-xs-6 bulkUpdate__rateIcons\"><i class=\"fa fa-user\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.max_count_of_adults_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.max_count_of_children_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> {{roomRate.maxChildren}} <i class=\"fa fa-chain\" tooltip=\"{{\'general.other.derived_rate\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"roomRate.parentRoomRateId\"></i> <i class=\"fa fa-calculator\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.calculated_rate_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"roomRate.isCalculatedRate\"></i> <i class=\"fa fa-star\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.calculated_rate_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"!roomRate.isCalculatedRate && !roomRate.parentRoomRateId\"></i></div></div></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span> <span ng-if=\"error\">{{error}}</span><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : inProgress}\" ng-show=\"inProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></md-dialog>");
$templateCache.put("templates/modals/changeUserPassword_tpl.html","<md-dialog aria-label=\"Change User Password\" ng-cloak=\"\"><form name=\"changeUserPassword\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Change User Password</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>New Password</label> <input type=\"password\" ng-model=\"newPassword\"></md-input-container><md-input-container class=\"md-block\"><label>Confirm Password</label> <input type=\"password\" ng-model=\"confirmPassword\"></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"save()\">Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/checkinDialog_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.checkin_form\' | i18next}}\" class=\"checkin-dialog\" ng-cloak=\"\"><div class=\"checkin-dialog__header\">{{\'checkin_dialog.checkin_title\' | i18next}} #{{booking.preparedToken}} <span ng-show=\"booking.source == \'channel\'\">({{booking.preparedChannel}} {{\'bookings.management_modal.right_side_div.booking_span\' | i18next}} <span ng-show=\"booking.preparedChannelReservationId\">&nbsp;{{booking.preparedChannelReservationId}}</span>)</span> <span ng-show=\"booking.source == \'app\'\">({{\'bookings.management_modal.right_side_div.offline_booking_span\' | i18next}} <span ng-show=\"booking.channel\">, {{booking.channel}}</span>)</span> <span ng-show=\"booking.source == \'widget\'\">({{\'bookings.management_modal.right_side_div.website_booking_span\' | i18next}} <span ng-show=\"booking.channel\">, {{booking.channel}}</span>)</span> <small>Room #{{room.roomNumber}}, {{room.checkinDate | dateToMoment:\"ddd, D MMM YYYY\":\"UTC\"}}, {{room.numberOfNights}} nights</small> <a class=\"checkin-dialog__close-link\" ng-click=\"closeModal()\"><i class=\"fa fa-times\"></i></a></div><div class=\"checkin-dialog__steps\"><div class=\"checkin-dialog__step\" ng-class=\"{\'checkin-dialog__step__active\' : step === 1}\"><div class=\"checkin-dialog__step__title\"><i class=\"fa fa-edit\" ng-if=\"step === 1\"></i> <i class=\"fa fa-circle\" ng-if=\"step !== 1\"></i> {{\'checkin_dialog.guest_details\' | i18next}}</div></div><div class=\"checkin-dialog__step\" ng-class=\"{\'checkin-dialog__step__active\' : step === 2}\"><div class=\"checkin-dialog__step__title\"><i class=\"fa fa-edit\" ng-if=\"step === 2\"></i> <i class=\"fa fa-circle\" ng-if=\"step !== 2\"></i> {{\'checkin_dialog.extras\' | i18next}}</div></div><div class=\"checkin-dialog__step\" ng-class=\"{\'checkin-dialog__step__active\' : step === 3}\"><div class=\"checkin-dialog__step__title\"><i class=\"fa fa-edit\" ng-if=\"step === 3\"></i> <i class=\"fa fa-circle\" ng-if=\"step !== 3\"></i> {{\'checkin_dialog.finish\' | i18next}}</div></div></div><div class=\"checkin-dialog__content\"><div ng-if=\"step === 1\"><h2>{{\'checkin_dialog.room\' | i18next}} #{{room.roomNumber}}</h2><div class=\"checkin-dialog__room-details\"><div class=\"checkin-dialog__room-details__item\"><strong>{{\'checkin_dialog.room_type\' | i18next}}:</strong> {{room.roomTypeName}}</div><div class=\"checkin-dialog__room-details__item\"><strong>{{\'checkin_dialog.occupancy\' | i18next}}:</strong> {{room.numberOfAdults}} <i class=\"fa fa-male\"></i> <span ng-if=\"room.numberOfChildren > 0\">{{room.numberOfChildren}} <i class=\"fa fa-child\"></i></span></div><div class=\"checkin-dialog__room-details__item\"><strong>{{\'checkin_dialog.arrival_date\' | i18next}}:</strong> {{room.checkinDate | dateToMoment:\"ddd, D MMM YYYY\":\"UTC\"}}</div><div class=\"checkin-dialog__room-details__item\"><strong>{{\'checkin_dialog.rate_plan\' | i18next}}:</strong> {{room.ratePlanTitle}}</div><div class=\"checkin-dialog__room-details__item\"><strong>{{\'checkin_dialog.cancellation_policy\' | i18next}}:</strong> {{room.cancellationPolicyTitle}}</div><div class=\"checkin-dialog__room-details__item\"><strong>{{\'checkin_dialog.number_of_nights\' | i18next}}:</strong> {{room.numberOfNights}}</div></div><h2>{{\'checkin_dialog.guests\' | i18next}}:</h2><form name=\"forms.guestsInfoForm\" novalidate=\"\"><div class=\"checkin-dialog__guests\"><div class=\"checkin-dialog__guest\" ng-repeat=\"guest in room.guests\"><h3>{{guest.representationName}}<div class=\"pull-right\"><md-checkbox ng-model=\"guest.skipGuest\" class=\"checkin-dialog__skip-guest-check\" aria-label=\"{{\'checkin_dialog.skip_guest\' | i18next}}\">{{\'checkin_dialog.skip_guest\' | i18next}}</md-checkbox></div></h3><div ng-if=\"guest.skipGuest !== true\"><div class=\"row\"><div class=\"col-xs-4 autocomplete-col\"><md-autocomplete flex=\"\" md-input-name=\"firstName\" md-input-minlength=\"2\" md-search-text=\"guest.firstName\" md-items=\"item in searchGuest()\" md-item-text=\"item.firstName\" md-selected-item-change=\"changeGuestCallback(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.first_name\' | i18next}}\" name=\"firstName[$index]\" ng-required=\"requiredFields[\'firstName\'] === true\"><md-item-template><span>{{item.firstName}} {{item.lastName}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-4\"><md-input-container><label>{{\'bookings.customer.middle_name_label\' | i18next}}</label> <input type=\"text\" name=\"middle_name[$index]\" ng-model=\"guest.addons.middleName\" ng-required=\"requiredFields[\'middleName\'] === true\"></md-input-container></div><div class=\"col-xs-4 autocomplete-col\"><md-autocomplete flex=\"\" md-input-name=\"lastName\" md-input-minlength=\"2\" md-search-text=\"guest.lastName\" md-items=\"item in searchGuest()\" md-item-text=\"item.lastName\" md-selected-item-change=\"changeGuestCallback(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.last_name\' | i18next}}\" name=\"lastName[$index]\" ng-required=\"requiredFields[\'lastName\'] === true\"><md-item-template><span>{{item.firstName}} {{item.lastName}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.nationality_label\' | i18next}}</label> <input type=\"text\" name=\"nationality[$index]\" ng-model=\"guest.nationality\" ng-required=\"requiredFields[\'nationality\'] === true\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select ng-model=\"guest.locale\" ng-required=\"requiredFields[\'locale\'] === true\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_type_label\' | i18next}}</label><md-select ng-model=\"guest.identificationTypeId\" ng-required=\"requiredFields[\'identificationTypeId\'] === true\"><md-option ng-value=\"idType.id\" ng-repeat=\"idType in idTypes\">{{idType.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_no_label\' | i18next}}</label> <input type=\"text\" name=\"identification\" ng-model=\"guest.identification\" ng-required=\"requiredFields[\'identification\'] === true\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.identification_issue_date_label\' | i18next}}</label> <input type=\"date\" ng-model=\"guest.addons.idIssueDate\" ng-required=\"requiredFields[\'addons_idIssueDate\'] === true\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.country_of_citizenship_label\' | i18next}}</label><md-select ng-model=\"guest.addons.citizenship\" ng-required=\"requiredFields[\'addons_citizenship\'] === true\"><md-option ng-value=\"country\" ng-repeat=\"country in countries\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.sex_label\' | i18next}}</label><md-select ng-model=\"guest.addons.sex\" ng-required=\"requiredFields[\'addons_sex\'] === true\"><md-option value=\"M\">{{\'bookings.customer.male_label\' | i18next}}</md-option><md-option value=\"F\">{{\'bookings.customer.female_label\' | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.birth_date_label\' | i18next}}</label> <input type=\"date\" ng-model=\"guest.addons.birthDate\" ng-required=\"requiredFields[\'addons_birthDate\'] === true\"></md-input-container></div></div><h4>{{\'bookings.customer.address_title\' | i18next}}</h4><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" name=\"address\" ng-model=\"guest.address\" ng-required=\"requiredFields[\'address\'] === true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.city_label\' | i18next}}</label> <input type=\"text\" name=\"city\" ng-model=\"guest.city\" ng-required=\"requiredFields[\'city\'] === true\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"guest.country\" ng-required=\"requiredFields[\'country\'] === true\"><md-option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\" ng-show=\"guest.country == \'United States\'\"><md-input-container><label>{{\'bookings.customer.state_label\' | i18next}}</label> <input type=\"text\" name=\"state\" ng-model=\"guest.state\" ng-required=\"requiredFields[\'state\'] === true\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.postal_code\' | i18next}}</label> <input type=\"text\" name=\"zipCode\" ng-model=\"guest.zipCode\" ng-required=\"requiredFields[\'zipCode\'] === true\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6 autocomplete-col\"><md-autocomplete flex=\"\" md-input-name=\"email\" md-input-minlength=\"2\" md-search-text=\"guest.email\" md-items=\"item in searchGuest(guest.email, \'email\')\" md-item-text=\"item.email\" md-selected-item-change=\"changeGuestCallback(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'bookings.customer.email_label\' | i18next}}\"><md-item-template><span>{{item.firstName}} {{item.lastName}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.mobile_phone_label\' | i18next}}</label> <input type=\"text\" name=\"mobilePhone\" ng-model=\"guest.phone\" ng-required=\"requiredFields[\'phone\'] === true\"></md-input-container></div></div></div></div></div></form></div><div ng-if=\"step === 2\"><h2>{{\'checkin_dialog.extras\' | i18next}}</h2><div class=\"table-container\"><table class=\"table table-extras table-hover\"><thead><tr><th class=\"col-xs-5\">{{\'bookings.extras.extras_name_th\' | i18next}}</th><th class=\"col-xs-2\">{{\'bookings.extras.sell_date_th\' | i18next}}</th><th class=\"col-xs-1\">{{\'general.other.count\' | i18next}}</th><th class=\"col-xs-1\">{{\'general.other.total\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"extra in extras track by $index\" ng-show=\"extra.status != \'canceled\'\"><td class=\"padded-left\">{{extra.title}} <i class=\"fa fa-link\" ng-show=\"extra.isMandatory\" tooltip=\"{{\'bookings.extras.auto_added_from_rate_plan_tooltip\' | i18next}}\"></i> <i class=\"fa fa-link\" ng-show=\"extra.isSpecial\" tooltip=\"{{\'bookings.extras.auto_added_from_special_offer_tooltip\' | i18next}}\"></i></td><td>{{extra.sellDate | dateToMoment:\"D MMM YYYY\"}}</td><td>{{extra.count}}</td><td>{{extra.total | customCurrency}} <i class=\"fa fa-trash pull-right\" ng-click=\"dropExtra(extra)\" ng-if=\"!extra.id\"></i></td></tr></tbody></table></div><div class=\"checkin-dialog__add-extra-form\" ng-if=\"addExtraFormIsVisible === true\"><form name=\"addExtrasForm\" novalidate=\"\"><h3>{{\'checkin_dialog.add_new_extra\' | i18next}}</h3><div class=\"table-form\"><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'offers.special_offers_modal.extra_name_th\' | i18next}}</label><div class=\"checkin-dialog__extra-select\"><select-scrollable-checkin-extras on-scroll=\"onLoadExtras\" on-search=\"onSearchExtras\" on-select=\"onSelectExtra\" options=\"extrasOptions\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" caret-down-filled-suffix=\"true\" value=\"selectedExtraVal\" on-dropdown-visible-change=\"onExtraFormDropdownVisibleChange\"></select-scrollable-checkin-extras></div></md-input-container></div></div><div><div class=\"checkin-dialog__extras-form__dates-lable\">{{\'checkin_dialog.affected_dates\' | i18next}}</div><div class=\"checkin-dialog__extras-form__dates-list\"><div class=\"checkin-dialog__extras-form__date-item\" ng-repeat=\"date in room.dates\"><md-checkbox ng-model=\"newExtra.dates[date]\" ng-change=\"recalcTotalFromDates(newExtra)\">{{date | dateToMoment:\"ddd, D MMM YYYY\":\"UTC\"}} <i class=\"fa fa-sign-in\" ng-if=\"$index === 0\"></i> <i class=\"fa fa-sign-out\" ng-if=\"$index === room.dates.length - 1\"></i></md-checkbox></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><md-input-container><label>{{\'checkin_dialog.persons\' | i18next}}</label> <input type=\"number\" ng-model=\"newExtra.persons\" required=\"\" min=\"1\" name=\"count\" ng-change=\"recalcTotalFromDates(newExtra)\"></md-input-container></div><div class=\"col-xs-3\"><md-input-container><label>{{\'general.other.count\' | i18next}}</label> <input type=\"number\" ng-model=\"newExtra.count\" required=\"\" min=\"1\" name=\"count\" ng-change=\"recalcTotal(newExtra)\"></md-input-container></div><div class=\"col-xs-3\"><md-input-container><label>{{\'general.other.price\' | i18next}}</label> <input type=\"number\" ng-model=\"newExtra.price\" required=\"\" min=\"0\" name=\"price\" ng-change=\"recalcTotal(newExtra)\"></md-input-container></div><div class=\"col-xs-3 amount\"><md-input-container><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-model=\"newExtra.total\" name=\"total\" disabled=\"\"></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn md-secondary-error\" ng-click=\"hideAddExtrasForm()\" ng-disabled=\"extrasAnimation\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveAddExtrasForm()\" ng-disabled=\"extrasAnimation\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"extrasAnimation\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div></div><div class=\"checkin-dialog__summary\" ng-if=\"step === 3\"><div ng-if=\"saveInProgress === true\"><i class=\"fa fa-spin fa-spinner\"></i></div><div ng-if=\"saveInProgress !== true\"><md-button class=\"md-raised md-primary\" ng-click=\"finish(false)\">{{\'checkin_dialog.controls.checkin\' | i18next}}</md-button><br>{{\'checkin_dialog.controls.or\' | i18next}}<br><md-button class=\"md-raised md-primary\" ng-click=\"finish(true)\">{{\'checkin_dialog.controls.checkin_and_payment\' | i18next}}</md-button></div></div></div><div class=\"row checkin-dialog__controls\"><div class=\"col-xs-6 text-left\"><md-button class=\"md-raised\" ng-click=\"prevStep()\" ng-if=\"step !== 1 && saveInProgress !== true\">{{\'checkin_dialog.controls.back\' | i18next}}</md-button></div><div class=\"col-xs-6 text-right\"><md-menu ng-if=\"step === 2\"><md-button class=\"md-raised\" ng-click=\"openMenu($mdOpenMenu, $event)\">{{\'checkin_dialog.controls.add_extra\' | i18next}}</md-button><md-menu-content width=\"4\"><div class=\"checkin-dialog__extra-select checkin-dialog__add-extra-select\"><select-scrollable-checkin-extras on-scroll=\"onLoadFavExtras\" on-search=\"onSearchFavExtras\" on-select=\"onSelectFavExtra\" options=\"favExtrasOptions\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" caret-down-filled-suffix=\"true\" opened=\"favSelectOpened\" value=\"{ value: undefined, label: \'\' }\"></select-scrollable-checkin-extras></div></md-menu-content></md-menu><md-button class=\"md-raised md-primary\" ng-click=\"nextStep()\" ng-if=\"step !== 3\" ng-disabled=\"(step === 1 && forms.guestsInfoForm.$valid === false)\"><i class=\"fa fa-spin fa-spinner\" ng-if=\"saveCustomerInProgress == true\"></i> {{\'checkin_dialog.controls.next\' | i18next}}</md-button></div></div></md-dialog>");
$templateCache.put("templates/modals/chooseHotel_tpl.html","<md-dialog aria-label=\"Choose Hotel\" ng-cloak=\"\"><form name=\"chooseHotel\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Choose Hotel</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Hotel</label><md-select ng-model=\"hotel\"><md-option ng-repeat=\"hotel in hotels | orderBy:\'name\'\" ng-value=\"hotel\">{{hotel.name}}</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-primary\" ng-click=\"choose()\">Choose</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/choosePhoto_tpl.html","<md-dialog aria-label=\"Choose Photo\" ng-cloak=\"\"><form name=\"choosePhoto\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Choose Photo</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><div class=\"photo\" ng-repeat=\"photo in dialogPhotos\" ng-click=\"save(photo)\"><img src=\"{{photo.photo}}\"></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">Cancel</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/createBooking_experimental_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.create_booking\' | i18next}}\" class=\"modal-create-booking\" ng-cloak=\"\"><div class=\"room-tabs\"><ul><li ng-repeat=\"room in booking.rooms track by $index\" ng-class=\"{active : $index == activeRoomIndex}\"><a ng-click=\"setActiveRoom($index)\">{{\'general.other.room\' | i18next}} #{{room.room_name}} <i class=\"fa fa-close\" ng-click=\"removeRoom($index)\" ng-hide=\"booking.rooms.length == 1\"></i></a></li></ul><a ng-click=\"addRoom()\" ng-disabled=\"createBookingForm.$invalid\" class=\"add-room\"><i class=\"fa fa-plus-circle\"></i> {{\'bookings.create_booking.room_tabs.add_room_link\' | i18next}}</a></div><form class=\"booking-form\" name=\"createBookingForm\" novalidate=\"\"><div class=\"tab-content\" ng-repeat=\"room in booking.rooms track by $index\" ng-show=\"$index == activeRoomIndex\"><booking-room-full-form booking=\"booking\" room=\"room\" blocked-rooms=\"blocked_rooms\" room-index=\"$index\" calc-total=\"calcTotal\" policies=\"policies\" currency-symbol=\"currencySymbol\" assign-guest=\"assignGuest\" on-guest-change=\"onGuestChange\" clear-guest-info=\"clearGuestInfo\"></booking-room-full-form></div><div class=\"additional_information\"><legend class=\"booking-form__legend\">{{\'general.other.other_info\' | i18next}}</legend><div class=\"row form-row\"><div class=\"col-xs-12\"><select-customer-input customer-query=\"customerInfo.query\" on-change=\"chooseCustomer\"></select-customer-input></div></div><div class=\"row form-row\" ng-if=\"customer.name !== customerInfo.query && customerInfo.query !== \'\'\"><div class=\"col-xs-12\">{{\'bookings.new_customer\' | i18next}}</div><div class=\"col-xs-12\"><md-radio-group ng-model=\"customerInfo.type\" class=\"inline\"><md-radio-button ng-value=\"0\">{{\'bookings.customer.guest_radio_button\' | i18next}}</md-radio-button><md-radio-button ng-value=\"1\">{{\'bookings.customer.company_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"col-xs-12\"><br></div></div><div ng-include=\"payment_form\"></div><div class=\"row form-row\"><div class=\"col-xs-4 form-block\"><md-autocomplete ng-if=\"!isSaleChannelsFeatureEnabled\" md-selected-item=\"booking.channel\" md-search-text-change=\"searchChannel(channelText)\" md-search-text=\"channelText\" md-items=\"item in searchChannel(channelText)\" md-item-text=\"item\" md-min-length=\"0\" md-autoselect=\"false\" md-select-on-match=\"true\" md-floating-label=\"{{\'bookings.create_booking.source_or_agent_floating_label\' | i18next}}\"><md-item-template><span md-highlight-text=\"channelText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>{{\'bookings.create_booking.just_fill_other_fields_we_create_new_source_not_found\' | i18next}}</md-not-found></md-autocomplete><sale-channel-input ng-if=\"isSaleChannelsFeatureEnabled\" value=\"booking.channel\" collection=\"sale_channels\"></sale-channel-input></div><div class=\"col-xs-8 form-block\"><md-input-container><label>{{\'bookings.create_booking.fields.reference_label\' | i18next}}</label> <input maxlength=\"250\" type=\"text\" ng-model=\"booking.channel_reservation_id\"></md-input-container></div></div><div class=\"row form-block\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"booking.confirmation\" aria-label=\"{{\'bookings.create_booking.fields.send_email_confirmation_checkbox\' | i18next}}\">{{\'bookings.create_booking.fields.send_email_confirmation_checkbox\' | i18next}}</md-checkbox></div></div></div></form><div class=\"md-actions\" layout=\"row\"><div class=\"grand-total text-right\"><span class=\"title\">{{\'bookings.create_booking.actions.title\' | i18next}}:</span> <span class=\"summ\">{{total | customCurrency}}</span></div><span flex=\"\"></span><md-button class=\"md-raised md-button-cancel md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"(createBookingForm.$invalid || loading || hasNotValidRooms() || loadNights)\" ng-click=\"finish()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\" ng-show=\"loading\"></i> {{\'general.buttons.book\' | i18next}}</md-button></div><ui-confirm id=\"confirmation\" class=\"buuqit-modal-wrapper\"></ui-confirm></md-dialog>");
$templateCache.put("templates/modals/createBooking_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.create_booking\' | i18next}}\" class=\"modal-create-booking\" ng-cloak=\"\"><div class=\"room-tabs\"><ul><li ng-repeat=\"room in booking.rooms\" ng-class=\"{active : room.active}\"><a ng-click=\"setActiveRoom($index)\">{{\'general.other.room\' | i18next}} #{{room.room_name}} <i class=\"fa fa-close\" ng-click=\"removeRoom($index)\" ng-hide=\"booking.rooms.length == 1\"></i></a></li></ul><a ng-click=\"addRoom()\" ng-disabled=\"createBookingForm.$invalid\" class=\"add-room\"><i class=\"fa fa-plus-circle\"></i> {{\'bookings.create_booking.room_tabs.add_room_link\' | i18next}}</a></div><form class=\"booking-form\" name=\"createBookingForm\" novalidate=\"\"><div class=\"tab-content\" ng-repeat=\"room in booking.rooms track by $index\" ng-show=\"room.active\"><md-content md-theme=\"docs-dark\"><div class=\"row\"><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-down\"></i> {{\'bookings.create_booking.booking_form.check_in_date_label\' | i18next}}</label><md-datepicker ng-model=\"room.checkin_date\" ng-change=\"dateInChanged()\" md-min-date=\"prevDay\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_rate_label\' | i18next}}</label><md-select ng-model=\"room.rate\" ng-change=\"changeRoom(\'rate\')\" required=\"\"><md-option ng-value=\"rate\" ng-repeat=\"rate in getRates($index) track by rate.id\" ng-selected=\"room.rate_category_id == rate.id\" ng-class=\"{\'unapplicable\' : rate.applicable == 0}\">{{rate.name}} <span ng-if=\"rate.applicable == 0\">({{\'bookings.create_booking.booking_form.restrictions_does_not_match\' | i18next}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-male\"></i> {{\'bookings.create_booking.booking_form.adults_label\' | i18next}} {{\'general.other.max\' | i18next}} {{recomendedMaxAdults}}</label><md-select ng-model=\"room.number_of_adults\" ng-change=\"changeRoom(\'rate\')\"><md-option ng-repeat=\"adult in adults_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-child\"></i> {{\'general.other.children\' | i18next}} {{\'general.other.max\' | i18next}} {{recomendedMaxChildren}}</label><md-select ng-model=\"room.number_of_children\" ng-change=\"changeRoom(\'rate\')\"><md-option ng-repeat=\"child in child_select\" value=\"{{child}}\">{{child}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-up\"></i> {{\'bookings.create_booking.booking_form.check_out_date_label\' | i18next}}</label><md-datepicker ng-model=\"room.checkout_date\" ng-change=\"dateOutChanged()\" md-min-date=\"room.min_checkout_date\" md-max-date=\"room.max_checkout_date\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_type_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"room.cover_room_type\" ng-change=\"changeRoom(\'room_type\')\" required=\"\"><md-option ng-repeat=\"room_type in cover_room_types | filter:notBlockedCoverRoomTypesFilter\" ng-value=\"room_type\" ng-selected=\"room_type.id == room.cover_room_type.id\">{{room_type.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-4 form-block form-block-checkbox\"><md-checkbox ng-model=\"room.dont_move\" aria-label=\"{{\'bookings.create_booking.booking_form.do_not_move_label\' | i18next}}\">{{\'bookings.create_booking.booking_form.do_not_move_label\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-moon-o\"></i> {{\'general.other.nights\' | i18next}}</label><md-select ng-model=\"room.number_of_nights\" ng-change=\"changeRoom(\'number_of_nights\')\"><md-option ng-repeat=\"night in room.nights_select\" value=\"{{night}}\">{{night}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-clock-o\"></i> {{\'general.other.arrival\' | i18next}}</label><md-select ng-model=\"room.checkin_time\"><md-option ng-repeat=\"time in times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.room_selection_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"room.room_id\" ng-change=\"changeRoom(\'room_id\')\" required=\"\"><md-option ng-repeat=\"room in getRooms(rooms)\" value=\"{{room.id}}\" ng-class=\"{\'unapplicable\' : room.applicable == 0}\">{{room.number}} <span ng-if=\"room.applicable == 0\">({{room_types_by_id[room.roomTypeId].name}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'general.other.cancellation_policy\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"room.cancellation_policy_id\" required=\"\"><md-option ng-repeat=\"policy in policies\" value=\"{{policy.id}}\">{{policy.title}}</md-option></md-select></md-input-container></div></div></md-content><div class=\"grey\"><div class=\"nights\"><legend>{{\'general.other.price_per_night\' | i18next}}: <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loadNights || loadRestrictions}\" ng-show=\"loadNights || loadRestrictions\"></i></legend><md-button class=\"md-raised pull-right btn-reset\" ng-click=\"resetNightPrices()\">{{\'bookings.create_booking.reset_button\' | i18next}}</md-button><div class=\"row\"><div class=\"night form-block\" ng-repeat=\"night in room.nights\"><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"\"><label>{{night.date | dateToMoment : \'ddd D\'}}</label> <input type=\"number\" ng-class=\"{\'currency\': currencySymbol && currencySymbol.length < 2}\" ng-model=\"night.price\" min=\"0\" ng-change=\"recalcRoomPrice()\" onclick=\"this.select()\"></md-input-container><span ng-if=\"currencySymbol && currencySymbol.length < 2\">{{currencySymbol}}</span></div></div></div></div><div class=\"total\"><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"\"><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': currencySymbol && currencySymbol.length < 2}\" ng-model=\"room.total_price\" name=\"totalPrice{{$index}}\" min=\"0\" ng-change=\"recalcNightsFromTotal()\" onclick=\"this.select()\"></md-input-container><span ng-if=\"currencySymbol && currencySymbol.length < 2\">{{currencySymbol}}</span></div></div></div><div class=\"fields\"><legend class=\"booking-form__legend\">{{\'general.other.guest_info\' | i18next}}<div class=\"pull-right\"><a ng-click=\"clearGuestInfo(room)\">Clear</a></div></legend><div class=\"row form-row\"><div class=\"col-xs-6 form-block\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-min-length=\"2\" md-search-text=\"room.guest.first_name\" md-items=\"item in searchGuest(\'first_name\')\" md-item-text=\"item.first_name\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.first_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small> <i ng-if=\"item.customer_id\" class=\"have-customer fa fa-user\" tooltip-append-to-body=\"true\" tooltip=\"This guest have associated customer\"></i></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6 form-block\"><md-autocomplete flex=\"\" ng-required=\"true\" md-input-minlength=\"1\" md-min-length=\"2\" md-search-text=\"room.guest.last_name\" md-items=\"item in searchGuest(\'last_name\')\" md-item-text=\"item.last_name\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.last_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small> <i ng-if=\"item.customer_id\" class=\"have-customer fa fa-user\" tooltip-append-to-body=\"true\" tooltip=\"This guest have associated customer\"></i></span></md-item-template></md-autocomplete></div></div><div class=\"row form-row\"><div class=\"col-xs-6 form-block form-block-icon\"><md-autocomplete flex=\"\" md-input-minlength=\"2\" md-search-text=\"room.guest.email\" md-items=\"item in searchGuest(\'email\')\" md-item-text=\"item.email\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"500\" md-floating-label=\"{{\'bookings.create_booking.autocomplete.email_floating_label\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small> <i ng-if=\"item.customer_id\" class=\"have-customer fa fa-user\" tooltip-append-to-body=\"true\" tooltip=\"This guest have associated customer\"></i></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6 form-block form-block-icon\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-search-text=\"room.guest.phone\" md-items=\"item in searchGuest(\'phone\')\" md-item-text=\"item.mobile_phone\" md-selected-item-change=\"changeGuest(item)\" md-delay=\"500\" md-floating-label=\"{{\'general.other.phone_number\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small> <i ng-if=\"item.customer_id\" class=\"have-customer fa fa-user\" tooltip-append-to-body=\"true\" tooltip=\"This guest have associated customer\"></i></span></md-item-template></md-autocomplete></div></div><div class=\"row form-row\"><div class=\"col-xs-12 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-comment\"></i> {{\'bookings.create_booking.fields.guest_request_label\' | i18next}}</label> <input type=\"text\" ng-model=\"room.note\"></md-input-container></div></div></div><div class=\"row form-row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" name=\"address\" ng-model=\"room.guest.address\"></md-input-container></div></div><div class=\"row form-row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.create_booking.fields.city_or_town_label\' | i18next}}</label> <input type=\"text\" name=\"city\" ng-model=\"room.guest.city\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"room.guest.country\"><md-option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row form-row\"><div class=\"col-xs-6\" ng-show=\"room.guest.country == \'United States\'\"><md-input-container><label>{{\'bookings.create_booking.fields.state_label\' | i18next}}</label> <input type=\"text\" name=\"state\" ng-model=\"room.guest.state\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.postal_code\' | i18next}}</label> <input type=\"text\" name=\"zipCode\" ng-model=\"room.guest.zipCode\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select ng-model=\"room.guest.locale\"><md-optgroup label=\"Locales\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div></div></div><div class=\"additional_information\"><legend class=\"booking-form__legend\">{{\'general.other.other_info\' | i18next}}</legend><div class=\"row form-row\"><div class=\"col-xs-12\"><select-customer-input customer-query=\"customerInfo.query\" on-change=\"chooseCustomer\"></select-customer-input></div></div><div class=\"row\" ng-if=\"customer.notes\"><div class=\"alert alert-info customer-notes-in-booking\"><strong>{{ \'customer.customer_page.notes\' | i18next }}:</strong> {{ customer.notes }}</div></div><div class=\"row form-row\" ng-if=\"customer.name !== customerInfo.query && customerInfo.query !== \'\'\"><div class=\"col-xs-12\">{{\'bookings.new_customer\' | i18next}}</div><div class=\"col-xs-12\"><md-radio-group ng-model=\"customerType\" class=\"inline\"><md-radio-button value=\"0\" ng-click=\"changeCustomerType(0)\">{{\'bookings.customer.guest_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"1\" ng-click=\"changeCustomerType(1)\">{{\'bookings.customer.company_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"col-xs-12\"><br></div></div><div ng-include=\"payment_form\"></div><div class=\"row form-row\"><div class=\"col-xs-4 form-block\"><md-autocomplete ng-if=\"!isSaleChannelsFeatureEnabled\" md-selected-item=\"booking.channel\" md-search-text-change=\"searchChannel(channelText)\" md-search-text=\"channelText\" md-items=\"item in searchChannel(channelText)\" md-item-text=\"item\" md-min-length=\"0\" md-autoselect=\"false\" md-select-on-match=\"true\" md-floating-label=\"{{\'bookings.create_booking.source_or_agent_floating_label\' | i18next}}\"><md-item-template><span md-highlight-text=\"channelText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>{{\'bookings.create_booking.just_fill_other_fields_we_create_new_source_not_found\' | i18next}}</md-not-found></md-autocomplete><sale-channel-input ng-if=\"isSaleChannelsFeatureEnabled\" value=\"booking.channel\" collection=\"sale_channels\"></sale-channel-input></div><div class=\"col-xs-8 form-block\"><md-input-container><label>{{\'bookings.create_booking.fields.reference_label\' | i18next}}</label> <input maxlength=\"250\" type=\"text\" ng-model=\"booking.channel_reservation_id\"></md-input-container></div></div><div class=\"row form-block\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"booking.confirmation\" aria-label=\"{{\'bookings.create_booking.fields.send_email_confirmation_checkbox\' | i18next}}\" ng-click=\"setConfirmationManualChanged()\">{{\'bookings.create_booking.fields.send_email_confirmation_checkbox\' | i18next}}</md-checkbox></div></div></div></form><div class=\"md-actions\" layout=\"row\"><div class=\"grand-total text-right\"><span class=\"title\">{{\'bookings.create_booking.actions.title\' | i18next}}:</span> <span class=\"summ\">{{total | customCurrency}}</span></div><span flex=\"\"></span><md-button class=\"md-raised md-button-cancel md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success md-secondary-success\" ng-disabled=\"(createBookingForm.$invalid || loading || hasNotValidRooms() || loadNights)\" ng-click=\"finish()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\" ng-show=\"loading\"></i> {{\'general.buttons.book\' | i18next}}</md-button></div><ui-confirm id=\"confirmation\" class=\"buuqit-modal-wrapper\"></ui-confirm></md-dialog>");
$templateCache.put("templates/modals/createSeasonOrRange_tpl.html","<md-dialog aria-label=\"{{\'profile_nav.settings.inventory.create_season_or_event_modal.create_season_or_event\' | i18next}}\" ng-cloak=\"\"><form name=\"createSeasonOrRange\" class=\"createSeasonOrRage\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'profile_nav.settings.inventory.create_season_or_event_modal.create_season_or_event\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-radio-group ng-model=\"createNewSeason\"><md-radio-button ng-value=\"true\">{{\'profile_nav.settings.inventory.create_season_or_event_modal.create_new_season_or_event_title_radio_button\' | i18next}}</md-radio-button><md-radio-button ng-value=\"false\">{{\'profile_nav.settings.inventory.create_season_or_event_modal.or_add_new_range_to_existed_season_radio_button\' | i18next}}</md-radio-button></md-radio-group><div ng-if=\"createNewSeason === true\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"season.title\" required=\"\"></md-input-container><md-input-container><label>{{\'profile_nav.settings.inventory.season_modal_general.color_label\' | i18next}}</label> <input ng-model=\"season.color\" type=\"color\" list=\"colors\"><datalist id=\"colors\"><option ng-repeat=\"color in colors\">#{{color}}</option></datalist></md-input-container><md-checkbox ng-model=\"season.isEvent\" aria-label=\"{{\'profile_nav.settings.inventory.season_modal_general.is_event_checkbox\' | i18next}}\">{{\'profile_nav.settings.inventory.season_modal_general.is_event_checkbox\' | i18next}}</md-checkbox></div><div ng-if=\"createNewSeason === false\"><md-input-container><label>{{\'profile_nav.settings.inventory.create_season_or_event_modal.season_or_event_label\' | i18next}}</label><md-select ng-model=\"season.id\"><md-option ng-repeat=\"season in seasons\" ng-value=\"season.id\">{{season.title}}</md-option></md-select></md-input-container></div><div class=\"row\"><div class=\"col-xs-6 date-col\"><label>{{\'general.other.date_from\' | i18next}}</label><md-datepicker ng-model=\"season.seasonRangesAttributes[0].startDate\" md-placeholder=\"Date from\" md-max-date=\"season.seasonRangesAttributes[0].endDate\" required=\"\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'general.other.date_to\' | i18next}}</label><md-datepicker ng-model=\"season.seasonRangesAttributes[0].endDate\" md-placeholder=\"Date to\" md-min-date=\"season.seasonRangesAttributes[0].startDate\" required=\"\"></md-datepicker></div></div><div class=\"errorMessage\" ng-if=\"errors\" ng-bind-html=\"errors | stringifyErrors\"></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"inProgress\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : inProgress}\" ng-show=\"inProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/createSeasonRange_tpl.html","<md-dialog aria-label=\"{{\'profile_nav.settings.inventory.create_season_range_modal.title\' | i18next}}\" ng-cloak=\"\"><form name=\"createSeasonRange\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'profile_nav.settings.inventory.create_season_range_modal.title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><div class=\"row\"><div class=\"col-xs-6 date-col\"><label>{{\'general.other.date_from\' | i18next}}</label><md-datepicker ng-model=\"range.startDate\" md-placeholder=\"Date from\" md-max-date=\"range.endDate\" required=\"\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'general.other.date_to\' | i18next}}</label><md-datepicker ng-model=\"range.endDate\" md-placeholder=\"Date to\" md-min-date=\"range.startDate\" required=\"\"></md-datepicker></div></div><div class=\"errorMessage\" ng-if=\"errors\" ng-bind-html=\"errors | stringifyErrors\"></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"inProgress\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : inProgress}\" ng-show=\"inProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/createSeason_tpl.html","<md-dialog aria-label=\"{{\'profile_nav.settings.inventory.create_season_modal.create_season_legend\' | i18next}}\" ng-cloak=\"\"><form name=\"createSeason\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'profile_nav.settings.inventory.create_season_modal.create_season_legend\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"season.title\" name=\"title\" required=\"\"></md-input-container><md-input-container><label>{{\'profile_nav.settings.inventory.season_modal_general.color_label\' | i18next}}</label> <input ng-model=\"season.color\" type=\"color\" list=\"colors\" name=\"color\"><datalist id=\"colors\"><option ng-repeat=\"color in colors\">#{{color}}</option></datalist></md-input-container><div class=\"row\"><div class=\"col-xs-6 date-col\"><label>{{\'profile_nav.settings.inventory.general_for_section.date_from_label\' | i18next}}</label><md-datepicker ng-model=\"season.seasonRangesAttributes[0].startDate\" md-placeholder=\"Date from\" name=\"startDate\" ng-change=\"ensureCorrectRange()\" required=\"\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'profile_nav.settings.inventory.general_for_section.date_to_label\' | i18next}}</label><md-datepicker ng-model=\"season.seasonRangesAttributes[0].endDate\" md-placeholder=\"Date to\" md-min-date=\"season.seasonRangesAttributes[0].startDate\" name=\"endDate\" required=\"\"></md-datepicker></div></div><md-checkbox ng-model=\"season.isEvent\" aria-label=\"{{\'profile_nav.settings.inventory.season_modal_general.is_event_checkbox\' | i18next}}\" name=\"isEvent\">{{\'profile_nav.settings.inventory.season_modal_general.is_event_checkbox\' | i18next}}</md-checkbox><div class=\"errorMessage\" ng-if=\"errors\" ng-bind-html=\"errors | stringifyErrors\"></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"inProgress\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : inProgress}\" ng-show=\"inProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/editSeason_tpl.html","<md-dialog aria-label=\"{{\'profile_nav.settings.inventory.edit_season_modal.title\' | i18next}}\" ng-cloak=\"\"><form name=\"editSeason\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'profile_nav.settings.inventory.edit_season_modal.title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"season.title\" required=\"\"></md-input-container><md-input-container><label>{{\'profile_nav.settings.inventory.season_modal_general.color_label\' | i18next}}</label> <input ng-model=\"season.color\" type=\"color\" list=\"colors\"><datalist id=\"colors\"><option ng-repeat=\"color in colors\">#{{color}}</option></datalist></md-input-container><md-checkbox ng-model=\"season.isEvent\" aria-label=\"{{\'profile_nav.settings.inventory.season_modal_general.is_event_checkbox\' | i18next}}\">{{\'profile_nav.settings.inventory.season_modal_general.is_event_checkbox\' | i18next}}</md-checkbox><div class=\"errorMessage\" ng-if=\"errors\" ng-bind-html=\"errors | stringifyErrors\"></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"inProgress\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : inProgress}\" ng-show=\"inProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/eraseDialog_tpl.html","<md-dialog aria-label=\"Erase Dialog\" ng-cloak=\"\" class=\"buldUpdate__dialog\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'inventory.erase_dialog.title\' | i18next}}</h2></div></md-toolbar><md-dialog-content class=\"buldUpdate__content\"><div class=\"row bulkUpdate__dateRanges\" ng-repeat=\"range in ranges\"><div class=\"col-xs-11\"><div class=\"row\"><div class=\"col-xs-6 date-col\"><label>{{\'general.other.from\' | i18next}}</label><md-datepicker ng-model=\"range.dateFrom\" md-placeholder=\"Date From\" ng-change=\"setRangeRestriction(range, \'dateFrom\')\" md-min-date=\"today\" md-max-date=\"range.maxDate\"></md-datepicker></div><div class=\"col-xs-6 date-col\"><label>{{\'general.other.to\' | i18next}}</label><md-datepicker ng-model=\"range.dateTo\" md-placeholder=\"Date To\" ng-change=\"setRangeRestriction(range, \'dateTo\')\" md-min-date=\"range.minDate\"></md-datepicker></div></div><div class=\"row weekdays\"><div class=\"col-xs-12\"><md-checkbox ng-repeat=\"day in range.weekdays track by $index\" ng-model=\"range.weekdays[$index]\">{{\'general.days_of_week.\' + weekdays[$index] | i18next}}</md-checkbox></div></div></div><div class=\"col-xs-1 bulkUpdate__dateRanges__controls\"><a ng-show=\"$index == ranges.length - 1\" ng-click=\"addRange()\"><i class=\"fa fa-plus\"></i></a> <a ng-hide=\"ranges.length == 1\" ng-click=\"removeRange($index)\"><i class=\"fa fa-minus\"></i></a></div></div><div class=\"row bulkUpdate__rates\"><div class=\"col-xs-12\"><legend>{{\'inventory.erase_dialog.restrictions\' | i18next}}:</legend></div><div class=\"col-xs-6\" ng-repeat=\"restriction in restrictions track by $index\"><md-checkbox ng-model=\"affected_restrictions[$index]\">{{\'general.other.\' + restriction.code | i18next}}</md-checkbox></div></div><div class=\"row bulkUpdate__rates\"><div class=\"col-xs-12\"><legend>{{\'inventory.erase_dialog.erase_at\' | i18next}}:<div class=\"pull-right\"><span ng-show=\"restriction == \'rate\'\"><a ng-click=\"toggleDerivedRates()\">{{ hideDerivedRates ? \'Show derived rates\' : \'Hide derived rates\' }}</a> |</span> <a ng-click=\"selectAllRates()\">{{\'inventory.bulk_update.select_all\' | i18next}}</a> | <a ng-click=\"deselectAllRates()\">{{\'inventory.bulk_update.deselect_all\' | i18next}}</a></div></legend><div ng-repeat=\"roomRepresentation in roomRepresentations track by roomRepresentation.id\"><div><strong>{{roomRepresentation.title}}</strong><div class=\"pull-right\"><a ng-click=\"selectAllRates(roomRepresentation.id)\">{{\'inventory.bulk_update.select_all\' | i18next}}</a> | <a ng-click=\"deselectAllRates(roomRepresentation.id)\">{{\'inventory.bulk_update.deselect_all\' | i18next}}</a></div></div><div class=\"row bulkUpdate__rateRow\" ng-repeat=\"roomRate in roomRepresentation.filteredRoomRates track by roomRate.id\"><div class=\"col-xs-6\"><md-checkbox ng-model=\"roomRate.selected\">{{rateCategories[roomRate.rateCategoryId].name}}</md-checkbox></div><div class=\"col-xs-6 bulkUpdate__rateIcons\"><i class=\"fa fa-user\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.max_count_of_adults_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.max_count_of_children_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> {{roomRate.maxChildren}} <i class=\"fa fa-chain\" tooltip=\"{{\'general.other.derived_rate\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"roomRate.parentRoomRateId\"></i> <i class=\"fa fa-calculator\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.calculated_rate_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"roomRate.isCalculatedRate\"></i> <i class=\"fa fa-star\" tooltip=\"{{\'profile_nav.settings.inventory.rate_plans.room_rates.calculated_rate_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" ng-if=\"!roomRate.isCalculatedRate && !roomRate.parentRoomRateId\"></i></div></div></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span> <span ng-if=\"error\">{{error}}</span> <span ng-if=\"!error && !canErase()\">{{\'inventory.erase_dialog.choose_restrictions_message\' | i18next}}</span><md-button class=\"md-raised md-primary md-secondary-success\" ng-disabled=\"!canErase()\" ng-click=\"save()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : inProgress}\" ng-show=\"inProgress\"></i> {{\'inventory.erase_dialog.erase\' | i18next}}</md-button></div></md-dialog>");
$templateCache.put("templates/modals/exportCustomersToXLSModal_tpl.html","<div><div ng-if=\"isOpened\"><div class=\"buuqit-modal\"><div class=\"title\">{{title}}</div><div class=\"content\"><p>{{placeholder}} <span><strong><i>{{value}}</i></strong></span></p></div><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"close()\">{{\"general.confirm.cancel\"|i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-success\" ng-click=\"confirm()\"><i tooltip=\"{{\'general.tooltip.saving\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': loading}\" ng-show=\"loading\"></i> {{\"general.confirm.confirm\" | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/modals/groupedBookingDateSelect_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.create_booking\' | i18next}}\" class=\"modal-create-booking modal-create-booking--grouped\" ng-cloak=\"\"><div class=\"modal-header\">{{modalHeader}}</div><ui-confirm id=\"confirmation\" class=\"buuqit-modal-wrapper\"></ui-confirm></md-dialog>");
$templateCache.put("templates/modals/groupedCreateBooking_tpl.html","<md-dialog aria-label=\"{{\'general.aria_labels.create_booking\' | i18next}}\" class=\"modal-create-booking modal-create-booking--grouped\" ng-cloak=\"\"><div class=\"modal-header\">{{modalHeader}}</div><form class=\"booking-form\" name=\"createBookingForm\" novalidate=\"\" ng-show=\"common.step === \'pick_dates\'\"><div class=\"main-content\"><group-booking-common-fields-form checkin-date=\"common.checkinDate\" checkin-min-date=\"prevDay\" checkout-date=\"common.checkoutDate\" checkout-min-date=\"common.minCheckoutDate\" number-of-nights=\"common.numberOfNights\" number-of-nights-collection=\"nightsSelect\" checkin-time=\"common.checkinTime\" checkin-time-collection=\"times\" rate-category-id=\"common.rateCategoryId\" rate-category-collection=\"rateCategories\" cancellation-policy-id=\"common.cancellationPolicyId\" cancellation-policy-collection=\"policies\" on-dates-change=\"handleCommonDatesChange\"></group-booking-common-fields-form></div></form><form class=\"booking-form\" name=\"createBookingForm\" novalidate=\"\" ng-show=\"common.step === \'pick_rooms\'\"><div class=\"main-content\"><div class=\"row\"><div class=\"col-xs-8\"><div class=\"booking-room-short-form-container ng-scope\" ng-repeat=\"roomType in totalRoomsByRoomType\"><booking-room-type-short-form booking=\"booking\" room-type=\"roomType\" add-room=\"addRoom\" build-room-for-group-booking=\"buildRoomForGroupBooking\"></booking-room-type-short-form></div></div><div class=\"col-xs-4 basket\"><h3>Basket ({{getBasketRooms()}})</h3><div ng-repeat=\"roomType in totalRoomsByRoomType\"><p ng-repeat=\"rooms in roomType.basketRooms\">{{ rooms.roomTypeName }} (<i class=\"fa fa-male\"></i> {{ rooms.number_of_adults }} | <i class=\"fa fa-child\"></i> {{rooms.number_of_children}})</p></div></div></div></div></form><form class=\"booking-form\" name=\"createBookingForm\" novalidate=\"\" ng-show=\"common.step === \'final_booking_form\'\"><div class=\"main-content\"><div ng-show=\"!isBookingRoomFormShown && !isCustomerFormShown\" class=\"room-list\"><div><group-booking-common-fields-form checkin-date=\"common.checkinDate\" checkin-min-date=\"prevDay\" checkout-date=\"common.checkoutDate\" checkout-min-date=\"common.minCheckoutDate\" number-of-nights=\"common.numberOfNights\" number-of-nights-collection=\"nightsSelect\" checkin-time=\"common.checkinTime\" checkin-time-collection=\"times\" rate-category-id=\"common.rateCategoryId\" rate-category-collection=\"rateCategories\" cancellation-policy-id=\"common.cancellationPolicyId\" cancellation-policy-collection=\"policies\" on-dates-change=\"handleCommonDatesChange\"></group-booking-common-fields-form></div><div class=\"row\"><div class=\"section-header\"><legend class=\"booking-form__legend booking-form__legend--rooms\"><a ng-click=\"toggleExpandRooms()\">{{\'general.other.rooms\' | i18next}} ({{booking.rooms.length}}) <i ng-class=\"{\'fa fa-chevron-down\' : expandRoomList, \'fa fa-chevron-right\' : !expandRoomList}\"></i></a></legend><md-menu md-position-mode=\"target-right target\"><md-button ng-disabled=\"availableRooms.length == 0\" aria-label=\"{{\'bookings.create_booking.room_tabs.add_room_link\' | i18next}}\" class=\"md-button\" ng-click=\"$mdOpenMenu($event)\"><span class=\"add-room\"><i class=\"fa fa-plus-circle\"></i> {{\'bookings.create_booking.room_tabs.add_room_link\' | i18next}}</span></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"room in availableRooms\"><md-button ng-click=\"addRoom(room)\">{{ room.number }} ({{ room_types_by_id[room.roomTypeId].name }})</md-button></md-menu-item></md-menu-content></md-menu></div><div ng-show=\"expandRoomList\"><div ng-if=\"roomLoading\" style=\"height: 80px; padding: 30px 20px;\"><i class=\"fa fa-spin fa-spinner\"></i></div><div class=\"booking-room-short-form-container\" ng-repeat=\"room in booking.rooms\"><booking-room-short-form booking=\"booking\" room=\"room\" room-index=\"$index\" calc-total=\"calcTotal\" on-edit-click=\"handleRoomEditClick\" on-delete-click=\"handleRoomDeleteClick\"></booking-room-short-form></div></div></div><div class=\"row\" ng-if=\"foreignInvoicesFeatureEnabled\"><div class=\"col-xs-2\"><md-input-container><label>{{\'bookings.currency\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"booking.foreignCurrency\" ng-change=\"handleCurrencyChange()\"><md-option ng-repeat=\"currencyProfile in currencyProfiles\" ng-value=\"currencyProfile.code\" ng-selected=\"currencyProfile.isDefault\">{{currencyProfile.code}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2\" ng-if=\"booking.isForeignAmount\"><md-input-container><label>{{\'bookings.currency_rate\' | i18next}}</label> <input type=\"number\" ng-model=\"booking.foreignCurrencyRate\" min=\"0\" ng-change=\"handleCurrencyRateChange()\"></md-input-container></div></div><div class=\"additional_information\"><legend class=\"booking-form__legend\">{{\'bookings.customer.title\' | i18next}}</legend><div class=\"find-customer-row\" ng-show=\"!customer.id\"><div class=\"row form-row\"><div class=\"col-xs-12\"><select-customer-input label=\"bookings.folios.find_customer\" customer-query=\"customerInfo.query\" on-change=\"chooseCustomer\"></select-customer-input></div></div><div class=\"row form-row row-margin\"><div class=\"col-xs-12\"><div class=\"find-customer-row__hint-text\" ng-show=\"!customer.id\"><span ng-if=\"customerInfo.query === \'\'\">{{\'bookings.customer.choose_customer_or\' | i18next}}</span> <span ng-if=\"customerInfo.query !== \'\'\">{{\'bookings.customer.not_found\' | i18next}}.</span> <a ng-click=\"handleCreateNewCustomerClick()\">{{\'general.other.create_new\' | i18next}}.</a></div></div></div></div><div ng-show=\"customer.id\"><div class=\"chosen-customer-row\"><div class=\"chosen-customer-row__container\"><div class=\"chosen-customer-row__title\">{{ customer.visible_name }}</div><div class=\"chosen-customer-row__actions\"><a ng-click=\"handleEditCustomerClick()\"><i class=\"fa fa-edit\" role=\"button\" aria-hidden=\"false\"></i></a> <a ng-click=\"handleClearCustomerClick()\"><i class=\"fa fa-times\" role=\"button\" aria-hidden=\"false\"></i></a></div></div></div><div class=\"alert alert-info customer-notes-in-booking\" ng-if=\"customer.notes\"><strong>{{ \'customer.customer_page.notes\' | i18next }}:</strong> {{ customer.notes }}</div></div><div ng-include=\"payment_form\"></div><div class=\"row form-row\"><div class=\"col-xs-4 form-block\"><md-autocomplete ng-if=\"!isSaleChannelsFeatureEnabled\" md-selected-item=\"booking.channel\" md-search-text-change=\"searchChannel(channelText)\" md-search-text=\"channelText\" md-items=\"item in searchChannel(channelText)\" md-item-text=\"item\" md-min-length=\"0\" md-autoselect=\"false\" md-select-on-match=\"true\" md-floating-label=\"{{\'bookings.create_booking.source_or_agent_floating_label\' | i18next}}\"><md-item-template><span md-highlight-text=\"channelText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>{{\'bookings.create_booking.just_fill_other_fields_we_create_new_source_not_found\' | i18next}}</md-not-found></md-autocomplete><sale-channel-input ng-if=\"isSaleChannelsFeatureEnabled\" value=\"booking.channel\" collection=\"sale_channels\"></sale-channel-input></div><div class=\"col-xs-8 form-block\"><md-input-container><label>{{\'bookings.create_booking.fields.reference_label\' | i18next}}</label> <input maxlength=\"250\" type=\"text\" ng-model=\"booking.channel_reservation_id\"></md-input-container></div></div><div class=\"row form-block\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"booking.confirmation\" aria-label=\"{{\'bookings.create_booking.fields.send_email_confirmation_checkbox\' | i18next}}\">{{\'bookings.create_booking.fields.send_email_confirmation_checkbox\' | i18next}}</md-checkbox></div></div></div></div><div ng-if=\"isBookingRoomFormShown\" class=\"main-form\"><booking-room-detailed-form booking=\"booking\" room=\"bookingRoomToEdit\" guests=\"guests\" currency-symbol=\"currencySymbol\" calc-total=\"calcTotal\" policies=\"policies\" assign-guest=\"assignGuest\"></booking-room-detailed-form></div><div ng-if=\"isCustomerFormShown\" class=\"main-form\"><customer-form customer=\"formCustomer\" on-close=\"handleCustomerFormCloseClick\" on-updated-customer=\"handleUpdatedCustomerFormCallback\" on-new-customer=\"handleNewCustomerFormCallback\"></customer-form></div></div></form><div ng-show=\"common.step === \'final_booking_form\'\"><div ng-if=\"isBookingRoomFormShown\"><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-button-cancel md-secondary-error\" ng-click=\"handleEditRoomCancelClick()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"(bookingRoomForm.$invalid || loading)\" ng-click=\"handleEditRoomConfirmClick()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\" ng-show=\"loading\"></i> {{\'general.buttons.confirm\' | i18next}}</md-button></div></div><div ng-if=\"!isBookingRoomFormShown && !isCustomerFormShown\"><div class=\"md-actions\" layout=\"row\"><div class=\"grand-total text-right\"><span class=\"title\">{{\'bookings.create_booking.actions.title\' | i18next}}:</span> <span class=\"summ\">{{total | customCurrency}}</span></div><span flex=\"\"></span><md-button class=\"md-raised md-button-cancel\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"(createBookingForm.$invalid || !isBookingValid() || loading || loadNights)\" ng-click=\"finish()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\" ng-show=\"loading\"></i> {{\'general.buttons.book\' | i18next}}</md-button></div></div><ui-confirm id=\"confirmation\" class=\"buuqit-modal-wrapper\"></ui-confirm></div><div ng-show=\"common.step === \'pick_dates\'\"><div ng-if=\"!isBookingRoomFormShown && !isCustomerFormShown\"><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-button-cancel\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-click=\"pickRooms()\" ng-disabled=\"loadingShortCalendar\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loadingShortCalendar}\" ng-show=\"loadingShortCalendar\"></i> {{\'checkin_dialog.controls.next\' | i18next}}</md-button></div></div></div><div ng-show=\"common.step === \'pick_rooms\'\"><div ng-if=\"!isBookingRoomFormShown && !isCustomerFormShown\"><div class=\"md-actions\" layout=\"row\"><div class=\"grand-total text-right\" ng-if=\"common.step === \'pick_rooms\'\"><span class=\"title\">Total:</span> <span class=\"summ\"><i class=\"fa fa-male\"></i> {{getBasketAdults()}}, <i class=\"fa fa-child\"></i> {{getBasketChildren()}}</span></div><span flex=\"\"></span><md-button class=\"md-raised md-button-cancel\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-click=\"showFinalBookingForm(\'final_booking_form\')\" ng-disabled=\"(!showNextToFinalBookingFormButton || loadingRooms > 0)\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loadingRooms > 0}\" ng-show=\"loadingRooms > 0\"></i> {{\'checkin_dialog.controls.next\' | i18next}}</md-button></div></div></div></md-dialog>");
$templateCache.put("templates/modals/hitPayment_tpl.html","<div><div ng-if=\"isOpened\"><div class=\"buuqit-modal\"><div class=\"title\">{{\'bookings.hit_payment_modal.hit_payment_title\' | i18next}}</div><div class=\"content\"><form name=\"requestPaymentForm\"><md-input-container><label>{{\'bookings.hit_payment_modal.amount_to_charge_label\' | i18next}}</label> <input ng-model=\"value\" name=\"value\" type=\"number\" max=\"{{max_value}}\" min=\"{{min_value}}\" ng-disabled=\"isStarted\" required=\"\"></md-input-container></form></div><div class=\"hit-content\" ng-if=\"isStarted\" ng-bind-html=\"message\"></div><div class=\"text-center\" style=\"width: 100%; height:0;overflow:visible;\" ng-if=\"inRequest\"><i class=\"fa fa-spin fa-spinner\"></i></div><div class=\"md-actions\" layout=\"row\"><div class=\"text-center\" style=\"width: 100%\" ng-if=\"isComplete\"><md-button class=\"md-raised md-warn md-secondary-error\" ng-click=\"close()\">{{\'general.buttons.close\' | i18next}}</md-button></div><md-button class=\"md-raised md-warn md-secondary-error\" ng-click=\"close()\" ng-if=\"isStarted == false\">{{\'general.buttons.cancel\' | i18next}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-success\" ng-click=\"start()\" ng-if=\"isStarted == false\" ng-disabled=\"requestPaymentForm.$invalid\">{{\'general.buttons.confirm\' | i18next}}</md-button><div style=\"width: 100%\" ng-if=\"button1 || button2\"><md-button class=\"md-raised md-success\" ng-class=\"{\'pull-left\': button1 && button2}\" ng-click=\"buttonCallback(\'1\')\" ng-if=\"button1\">{{button1}}</md-button><span flex=\"\"></span><md-button class=\"md-raised md-success pull-right\" ng-class=\"{\'pull-right\': button1 && button2}\" ng-click=\"buttonCallback(\'2\')\" ng-if=\"button2\">{{button2}}</md-button></div></div></div></div></div>");
$templateCache.put("templates/modals/manageUserHotels_tpl.html","<md-dialog aria-label=\"Manage User Hotels\" ng-cloak=\"\"><form name=\"manageUserHotels\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Manage User Hotels</h2></div></md-toolbar><md-dialog-content class=\"user-hotel-manage-modal-content\"><div class=\"md-dialog-content\"><table class=\"table\"><thead><tr><th>Hotel name</th><th>Role</th><th></th></tr></thead><tbody><tr ng-repeat=\"hotel in user.hotels | filter:{forRemove:false}\"><td>{{hotel.hotelName}}</td><td><md-input-container class=\"md-block\" style=\"margin-top: 0;\"><md-select ng-model=\"hotel.role\" aria-label=\"Role\"><md-option value=\"owner\">Owner</md-option><md-option value=\"manager\">Manager</md-option><md-option value=\"reception\">Reception</md-option><md-option value=\"reception_no_finance\">Reception (No Finance)</md-option><md-option value=\"housekeeper\">Housekeeper</md-option></md-select></md-input-container></td><td class=\"text-right\"><i class=\"fa fa-times\" ng-click=\"removeAssociation(hotel)\" tooltip=\"Remove Association\"></i></td></tr></tbody></table><div class=\"row\"><div class=\"col-xs-7\" style=\"margin-top: 20px;\"><md-autocomplete md-selected-item=\"hotel_for_assign\" md-search-text=\"searchText\" md-items=\"hotel in hotels | filter:searchText\" md-item-text=\"hotel.name\" md-min-length=\"0\" placeholder=\"Select hotel\"><md-item-template><span md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{hotel.name}}</span></md-item-template><md-not-found>No states matching \"{{searchText}}\" were found.</md-not-found></md-autocomplete></div><div class=\"col-xs-4\"><md-input-container class=\"md-block\"><label>Assign as role</label><md-select ng-model=\"role_for_assign\"><md-option value=\"owner\">Owner</md-option><md-option value=\"manager\">Manager</md-option><md-option value=\"reception\">Reception</md-option><md-option value=\"reception_no_finance\">Reception (No Finance)</md-option><md-option value=\"housekeeper\">Housekeeper</md-option></md-select></md-input-container></div><div class=\"col-xs-1 text-right\" style=\"margin-top: 35px;\"><i class=\"fa fa-check\" ng-click=\"addAssociation()\" tootip=\"Add\"></i></div></div></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-secondary-error\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"save()\">Save</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/notifySubscriptionInfo_tpl.html","<md-toast role=\"alert\" class=\"md-toast-error\"><span class=\"md-toast-text\" style=\"padding-right: 6px; margin-right: 8px;\">{{\'subscription.notification\' | i18next}}</span><md-button ng-click=\"goToStripeBilling()\">{{\'subscription.billing_portal\' | i18next}}</md-button><md-button ng-click=\"closeToast()\">{{\'general.buttons.close\' | i18next}}</md-button></md-toast>");
$templateCache.put("templates/modals/removeExtra_tpl.html","<md-dialog ng-cloak=\"\"><form name=\"\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Merge <strong>{{extra.title}}</strong> to:</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label></label><md-select ng-model=\"choosedExtra\"><md-option ng-repeat=\"ex in extras\" ng-value=\"ex.id\">{{ex.title}}</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-warn md-secondary-error\" ng-click=\"merge()\">Merge</md-button><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"cancel()\">Cancel</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/removePaymentType_tpl.html","<md-dialog ng-cloak=\"\"><form name=\"mapHotel\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Replace <strong>{{paymentType.name}}</strong> payments with:</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Payment Type</label><md-select ng-model=\"choosedPT\"><md-option ng-repeat=\"pt in paymentTypes\" ng-value=\"pt.id\">{{pt.name}}</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"remove()\">Delete</md-button><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"cancel()\">Cancel</md-button></div></form></md-dialog>");
$templateCache.put("templates/settings/communication.email_setup_tpl.html","<div ng-controller=\"Settings.EmailSetupController as EmailSetupCtrl\"><legend class=\"header\">{{\'profile_nav.settings.booking_engine.email_setup.legend\' | i18next}}<locale-selector change=\"EmailSetupCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.general_settings.general_settings_legend\' | i18next}}</legend><md-input-container><multi-email-input ng-model=\"EmailSetupCtrl.emailSystemConfig.emailFromAddress\" placeholder=\"{{\'profile_nav.settings.booking_engine.email_setup.general_settings.reply_to_email_address_label\' | i18next}}\" class=\"multi-email-input\"></multi-email-input></md-input-container><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.general_settings.from_text_label\' | i18next}}:</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailFromText\" md-maxlength=\"255\"></md-input-container><md-input-container><multi-email-input ng-model=\"EmailSetupCtrl.emailSystemConfig.notificationEmail\" placeholder=\"{{\'profile_nav.settings.booking_engine.email_setup.general_settings.booking_notification_email_address_label\' | i18next}}\" class=\"multi-email-input\"></multi-email-input></md-input-container></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend class=\"settings-relative-box\">{{\'profile_nav.settings.booking_engine.email_setup.footer_template.legend\' | i18next}}<locale-selector-next></locale-selector-next><br><small>{{\'profile_nav.settings.booking_engine.email_setup.footer_template.small\' | i18next}}</small></legend><button ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder !== \'emailFooter\'\" class=\"md-raised md-primary md-button md-ink-ripple\" type=\"button\" ng-click=\"EmailSetupCtrl.openEmailTemplateBuilder(\'emailFooter\')\">{{\'general.aria_labels.open_template_editor\' | i18next}}</button><div ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder === \'emailFooter\'\"><react-email-template-builder container=\"\'email-footer-template\'\" base-template=\"EmailSetupCtrl.hotel.emailFooter\" base-template-json=\"EmailSetupCtrl.hotel.emailFooterJson\" merge-tags=\"[]\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'emailFooter\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.onSave\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.booking_confirmation_email_settings_legend\' | i18next}}</legend><div class=\"form-group form-group-with-dropins\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.check_in_notes_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div><button ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder !== \'checkInNotes\'\" class=\"md-raised md-primary md-button md-ink-ripple\" type=\"button\" ng-click=\"EmailSetupCtrl.openEmailTemplateBuilder(\'checkInNotes\')\">{{\'general.aria_labels.open_template_editor\' | i18next}}</button></div><div ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder === \'checkInNotes\'\"><react-email-template-builder container=\"\'check-in-notes-template\'\" base-template=\"EmailSetupCtrl.hotel.checkInNotes\" base-template-json=\"EmailSetupCtrl.hotel.checkInNotesJson\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'checkInNotes\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.onSave\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div></div><div class=\"form-group form-group-with-dropins\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.directions_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div><button ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder !== \'directions\'\" class=\"md-raised md-primary md-button md-ink-ripple\" type=\"button\" ng-click=\"EmailSetupCtrl.openEmailTemplateBuilder(\'directions\')\">{{\'general.aria_labels.open_template_editor\' | i18next}}</button></div><div ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder === \'directions\'\"><react-email-template-builder container=\"\'directions-template\'\" base-template=\"EmailSetupCtrl.hotel.directions\" base-template-json=\"EmailSetupCtrl.hotel.directionsJson\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'directions\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.onSave\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div></div><div class=\"form-group\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.single_property_bookings_label\' | i18next}}:</label><md-radio-group ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.propertyInSingleBooking\"><md-radio-button value=\"use_hotel\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.use_hotel_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"use_property\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.use_property_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"form-group\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.multi_property_bookings_label\' | i18next}}:</label><md-radio-group ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.propertyInMultiBooking\"><md-radio-button value=\"hide_properties\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.hide_properties_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"hide_hotel\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.hide_hotel_radio_button\' | i18next}}</md-radio-button></md-radio-group></div><div class=\"form-group\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize_confirmation_message\' | i18next}} <i class=\"fa fa-question-circle helper\" tooltip=\"{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize_confirmation_message_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></label><div class=\"row\"><div class=\"col-md-12\"><md-input-container><textarea ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.confirmationMessage\']\"></textarea></md-input-container></div></div></div><div class=\"form-group\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize_confirmation_email_colors\' | i18next}}: <i class=\"fa fa-question-circle helper\" tooltip=\"{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize_confirmation_email_colors_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></label><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.confirmation_header_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].confirmationHeaderInfoTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].confirmationHeaderInfoTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.title_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].titleTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].titleTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.details_color\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].reservationDetailsBackgroundColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].reservationDetailsBackgroundColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.details_text\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].reservationDetailsTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].reservationDetailsTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.room_details_color\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].roomDetailsBackgroundColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].roomDetailsBackgroundColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.room_details_text\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].roomDetailsTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].roomDetailsTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.room_price_and_nights_color\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].roomPriceAndNightsColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationColors\'].roomPriceAndNightsColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationLogo\'].show\" aria-label=\"{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo\' | i18next}}\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo\' | i18next}} <i class=\"fa fa-question-circle helper\" tooltip=\"{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></md-checkbox><div ng-show=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationLogo\'].show\" class=\"inventory-logo-position\"><label>{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo.position\' | i18next}}:</label><md-radio-group ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.customizationLogo\'].position\" layout=\"row\"><md-radio-button value=\"left\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo.position.left\' | i18next}}</md-radio-button><md-radio-button value=\"middle\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo.position.middle\' | i18next}}</md-radio-button><md-radio-button value=\"right\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.show_hotel_logo.position.right\' | i18next}}</md-radio-button></md-radio-group></div></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"EmailSetupCtrl.emailSystemConfig.emailSettings.preferences[\'bookingMailer.newConfirmation.includeFooter\']\" aria-label=\"{{\'profile_nav.settings.booking_engine.email_setup.pre_arrival_email_setup.send_email_checkbox\' | i18next}}\">{{\'profile_nav.settings.booking_engine.email_setup.booking_confirmation.customize.include_footer\' | i18next}}</md-checkbox></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.pre_arrival_email_setup.legend\' | i18next}}</legend><div class=\"form-group\"><md-checkbox ng-model=\"EmailSetupCtrl.hotel.preArrivalEmailEnabled\" aria-label=\"{{\'profile_nav.settings.booking_engine.email_setup.pre_arrival_email_setup.send_email_checkbox\' | i18next}}\">{{\'profile_nav.settings.booking_engine.email_setup.pre_arrival_email_setup.send_email_checkbox\' | i18next}}</md-checkbox></div><div class=\"form-group\" ng-show=\"EmailSetupCtrl.hotel.preArrivalEmailEnabled\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.email_setup.pre_arrival_email_setup.days_before_arrival_label\' | i18next}}</label><md-select ng-model=\"EmailSetupCtrl.hotel.preArrivalEmailPeriod\"><md-option ng-repeat=\"day in EmailSetupCtrl.arrival_days\" value=\"{{day}}\">{{day}}</md-option></md-select></md-input-container></div><div class=\"form-group\" ng-show=\"EmailSetupCtrl.hotel.preArrivalEmailEnabled\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'profile_nav.settings.booking_engine.email_setup.email_subject_label\' | i18next}}:</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.hotel.preArrivalEmailSubject\" md-maxlength=\"255\"></md-input-container></div><div class=\"form-group form-group-with-dropins\" ng-show=\"EmailSetupCtrl.hotel.preArrivalEmailEnabled\"><label>{{\'profile_nav.settings.booking_engine.email_setup.mail_body_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div><button ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder !== \'preArrivalEmail\'\" class=\"md-raised md-primary md-button md-ink-ripple\" type=\"button\" ng-click=\"EmailSetupCtrl.openEmailTemplateBuilder(\'preArrivalEmail\')\">{{\'general.aria_labels.open_template_editor\' | i18next}}</button></div><div ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder === \'preArrivalEmail\'\"><react-email-template-builder container=\"\'pre-arrival-email-body-template\'\" base-template=\"EmailSetupCtrl.hotel.preArrivalEmailBody\" base-template-json=\"EmailSetupCtrl.hotel.preArrivalEmailBodyJson\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'preArrivalEmailBody\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.onSave\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.post_departure.legend\' | i18next}}</legend><div class=\"form-group\"><md-checkbox ng-model=\"EmailSetupCtrl.hotel.postArrivalEmailEnabled\" aria-label=\"{{\'profile_nav.settings.booking_engine.email_setup.post_departure.send_email_after_departure_checkbox\' | i18next}}\">{{\'profile_nav.settings.booking_engine.email_setup.post_departure.send_email_after_departure_checkbox\' | i18next}}</md-checkbox></div><div class=\"form-group\" ng-show=\"EmailSetupCtrl.hotel.postArrivalEmailEnabled\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'profile_nav.settings.booking_engine.email_setup.email_subject_label\' | i18next}}:</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.hotel.postArrivalEmailSubject\" md-maxlength=\"255\"></md-input-container></div><div class=\"form-group form-group-with-dropins\" ng-show=\"EmailSetupCtrl.hotel.postArrivalEmailEnabled\"><label>{{\'profile_nav.settings.booking_engine.email_setup.mail_body_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div><button ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder !== \'postArrivalEmail\'\" class=\"md-raised md-primary md-button md-ink-ripple\" type=\"button\" ng-click=\"EmailSetupCtrl.openEmailTemplateBuilder(\'postArrivalEmail\')\">{{\'general.aria_labels.open_template_editor\' | i18next}}</button></div><div ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder === \'postArrivalEmail\'\"><react-email-template-builder container=\"\'post-arrival-email-body-template\'\" base-template=\"EmailSetupCtrl.hotel.postArrivalEmailBody\" base-template-json=\"EmailSetupCtrl.hotel.postArrivalEmailBodyJson\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'postArrivalEmailBody\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.onSave\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.request_payment.legend\' | i18next}}</legend><div class=\"form-group\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'profile_nav.settings.booking_engine.email_setup.email_subject_label\' | i18next}}:</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.hotel.requestPaymentSubject\" md-maxlength=\"255\"></md-input-container></div><div class=\"form-group form-group-with-dropins\"><label>{{\'profile_nav.settings.booking_engine.email_setup.mail_body_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div><button ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder !== \'requestPayment\'\" class=\"md-raised md-primary md-button md-ink-ripple\" type=\"button\" ng-click=\"EmailSetupCtrl.openEmailTemplateBuilder(\'requestPayment\')\">{{\'general.aria_labels.open_template_editor\' | i18next}}</button></div><div ng-if=\"EmailSetupCtrl.openedEmailTemplateBuilder === \'requestPayment\'\"><react-email-template-builder container=\"\'request-payment-body-email-template\'\" base-template=\"EmailSetupCtrl.hotel.requestPaymentBody\" base-template-json=\"EmailSetupCtrl.hotel.requestPaymentBodyJson\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'requestPaymentBody\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.onSave\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block marged-bottom\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.email_templates.legend\' | i18next}}<br><small>{{\'profile_nav.settings.booking_engine.email_setup.email_templates.small\' | i18next}}</small></legend><table class=\"table table-striped\"><thead><tr><th>{{\'general.other.title\' | i18next}}</th><th class=\"controls\"></th></tr></thead><tbody><tr ng-repeat=\"template in EmailSetupCtrl.hotel.emailTemplates\"><td ng-hide=\"template.edited\">{{template.name}}</td><td ng-hide=\"template.edited\" class=\"controls\"><a ng-click=\"EmailSetupCtrl.editEmailTemplate($index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"EmailSetupCtrl.removeEmailTemplate($index)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td ng-if=\"template.edited\" colspan=\"2\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"template.name\" md-maxlength=\"255\"></md-input-container><div class=\"form-group form-group-with-dropins\"><label>{{\'general.other.text\' | i18next}}</label><react-email-template-builder container=\"\'template-container-{{$index}}\'\" base-template=\"template.text\" base-template-json=\"template.textJson\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"$index\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.saveEmailTemplate\" on-send=\"EmailSetupCtrl.onSendTestLetter\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\" additional-template=\"null\"></react-email-template-builder></div><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"EmailSetupCtrl.closeEditedEmailTemplate($event, $index)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.saveTemplate($event, template, $index)\">{{\'general.buttons.save\' | i18next}}</md-button></div></div></td></tr></tbody></table><div class=\"new-email-template-form table-form\" ng-if=\"EmailSetupCtrl.addNewEmailTemplate\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"EmailSetupCtrl.newEmailTemplate.name\" md-maxlength=\"255\"></md-input-container><div class=\"form-group-with-dropins\"><label>{{\'general.other.text\' | i18next}}</label><react-email-template-builder container=\"\'add-new-email-template\'\" base-template=\"EmailSetupCtrl.newEmailTemplate.text\" base-template-json=\"null\" merge-tags=\"EmailSetupCtrl.mergeTags\" hotel-id=\"EmailSetupCtrl.hotel.id\" email-type=\"\'newEmailTemplate\'\" should-save=\"EmailSetupCtrl.shouldSave\" on-save=\"EmailSetupCtrl.saveAddEmailTemplate\" on-send=\"EmailSetupCtrl.onSendTestLetter\" additional-template=\"null\" on-load-bee-free-token=\"EmailSetupCtrl.onLoadBeeFreeToken\"></react-email-template-builder></div><div class=\"text-right form-buttons marged-top\"><md-button class=\"md-raised md-warn\" ng-click=\"EmailSetupCtrl.closeAddEmailTemplateForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"EmailSetupCtrl.saveAddEmailTemplateForm()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"EmailSetupCtrl.openAddEmailTemplateForm()\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.booking_engine.email_setup.add_email_template_button\' | i18next}}</md-button></div></div></div>");
$templateCache.put("templates/settings/communication.hotel_email_setup_tpl.html","<div ng-controller=\"Settings.HotelEmailSetupController as EmailSetupCtrl\"><legend class=\"header\">{{\'profile_nav.settings.booking_engine.email_setup.legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\"><legend>{{\'profile_nav.settings.booking_engine.email_setup.general_settings.general_settings_legend\' | i18next}}</legend><md-input-container><multi-email-input ng-model=\"EmailSetupCtrl.notificationEmail\" placeholder=\"{{\'profile_nav.settings.profile.hotel_email_setup.booking_notification_email_address_label\' | i18next}}\" class=\"multi-email-input\" ng-required=\"true\"></multi-email-input></md-input-container></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.profile.hotel_email_setup.preferences_legend\' | i18next}}<br><small>{{\'profile_nav.settings.profile.hotel_email_setup.preferences_description\' | i18next}}</small></legend><table class=\"table table-hover general-table table-editable\"><thead><tr><th class=\"col-xs-4\">{{\'general.other.name\' | i18next}}</th><th class=\"col-xs-7\">{{\'general.other.description\' | i18next}}</th><th class=\"col-xs-1\">{{\'general.filters.active\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in hotel.emailSettings.preferences\" ng-if=\"key !== \'bookingMailer.newConfirmation.customizationColors\' && key !== \'bookingMailer.newConfirmation.customizationLogo\' && key !== \'bookingMailer.newConfirmation.confirmationMessage\' && key !== \'bookingMailer.newConfirmation.includeFooter\'\"><td>{{\'profile_nav.settings.profile.hotel_email_setup.preferences.\' + key + \'.label\' | i18next}}</td><td>{{\'profile_nav.settings.profile.hotel_email_setup.preferences.\' + key + \'.description\' | i18next}}</td><td><md-checkbox ng-model=\"hotel.emailSettings.preferences[key]\"></md-checkbox></td></tr></tbody></table></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-disabled=\"EmailSetupCtrl.loading\" ng-click=\"EmailSetupCtrl.save()\"><i class=\"fa fa-spinner\" ng-show=\"EmailSetupCtrl.loading\" ng-class=\"{\'fa-spin\' : EmailSetupCtrl.loading}\"></i>{{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/connectivity.api_key_tpl.html","<div ng-controller=\"Settings.ApiKeyController as ApiKeyCtrl\"><legend class=\"header\">{{\'profile_nav.settings.other.create_api_key.create_api_key_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"ApiKeyCtrl.loaded\" ng-class=\"{\'fa-spin\':ApiKeyCtrl.loaded}\"></i></legend><div class=\"settings-body-block\"><div class=\"row\"><div class=\"col-md-12 text-center api-key-container\" ng-if=\"api_key\"><pre>{{api_key}}</pre><i class=\"fa fa-copy api-key-copy\" ng-click=\"ApiKeyCtrl.copy()\"></i> <textarea class=\"api-key-textarea\">{{api_key}}</textarea></div><div class=\"col-md-12 text-center\" ng-if=\"!api_key\">{{\'profile_nav.settings.other.create_api_key.api_key_is_not_present_div\' | i18next}}</div></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"ApiKeyCtrl.generate_api_key()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"ApiKeyCtrl.save_in_progress\"></i> {{\'profile_nav.settings.other.create_api_key.generate_api_key_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/connectivity.booking_engine_settings_tpl.html","<div ng-controller=\"Settings.BookingEngineSettingsController as IBECtrl\"><locale-selector change=\"IBECtrl.changeLang\"></locale-selector><div class=\"settings-body-block\" style=\"margin-top: 40px;\"><div class=\"full-width-block\"><strong class=\"subblock-header\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.booking_engine_profiles_header\' | i18next}}</strong><table class=\"table table-hover general-table table-editable table-room-rate\"><thead><tr><th class=\"col-xs-5\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-4\">{{\'general.other.slug\' | i18next}}</th><th class=\"col-xs-2\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.link_th\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"profile in IBECtrl.profiles\"><td ng-if=\"profile.edited === true\" colspan=\"4\" class=\"table-form-row\"><ibe-profile-form profile=\"profile\" cancel=\"IBECtrl.cancel\" save=\"IBECtrl.save\"></ibe-profile-form></td><td ng-if=\"profile.edited !== true\" ng-class=\"{\'virtual_profile\' : profile.virtual}\">{{profile.title}} <i class=\"fa fa-question-circle\" ng-if=\"profile.virtual\" tooltip=\"{{\'profile_nav.settings.booking_engine.booking_engine_settings.virtual_profile_help\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-if=\"profile.edited !== true\">{{profile.slug}}</td><td ng-if=\"profile.edited !== true\"><a href=\"{{IBECtrl.getLinkURL(profile.slug)}}\" target=\"_blank\"><i class=\"fa fa-external-link\"></i> {{\'profile_nav.settings.booking_engine.booking_engine_settings.open_link\' | i18next}}</a></td><td class=\"controls text-right\" ng-if=\"profile.edited !== true\"><i class=\"fa fa-spinner\" ng-show=\"profile.loading\" ng-class=\"{\'fa-spin\' : profile.loading}\"></i> <a ng-hide=\"profile.loading || profile.virtual\" ng-click=\"IBECtrl.edit(profile)\"><i tooltip=\"Edit\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <i tooltip=\"You can\'t remove Default Profile\" tooltip-append-to-body=\"true\" class=\"fa fa-times\" ng-show=\"profile.isDefault\"></i> <a ng-hide=\"profile.loading || profile.isDefault || profile.virtual\" ng-click=\"IBECtrl.remove(profile)\"><i tooltip=\"Remove\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr ng-if=\"IBECtrl.addFormIsVisible === true\"><td colspan=\"4\" class=\"table-form-row\"><ibe-profile-form profile=\"IBECtrl.newProfile\" cancel=\"IBECtrl.cancel\" save=\"IBECtrl.save\"></ibe-profile-form></td></tr></tbody></table></div></div><div class=\"spinned text-left toolbar marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"IBECtrl.add()\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.add_new_profile_button\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend class=\"settings-relative-box\">{{\'profile_nav.settings.booking_engine.email_setup.privacy_policy.legend\' | i18next}}<locale-selector-next></locale-selector-next><br><small>{{\'profile_nav.settings.booking_engine.email_setup.privacy_policy.small\' | i18next}}</small></legend><div class=\"field-with-dropins\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button\"><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button\" ng-click=\"IBECtrl.openMenu($mdOpenMenu, $event)\">{{\'general.other.drop_in_s\' | i18next}}</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in IBECtrl.dropins\"><md-button ng-click=\"IBECtrl.insertDropIn(\'privacyPolicyField\', dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu><summernote ng-model=\"IBECtrl.hotel.ibePrivacyPolicy\" on-paste=\"IBECtrl.wysiwygPaste(evt)\" data-role=\"privacyPolicyField\"></summernote></div><legend class=\"settings-relative-box\">{{\'profile_nav.settings.booking_engine.email_setup.terms_of_service.legend\' | i18next}}<locale-selector-next></locale-selector-next><br><small>{{\'profile_nav.settings.booking_engine.email_setup.terms_of_service.small\' | i18next}}</small></legend><div class=\"field-with-dropins\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button\"><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button\" ng-click=\"IBECtrl.openMenu($mdOpenMenu, $event)\">{{\'general.other.drop_in_s\' | i18next}}</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in IBECtrl.dropins\"><md-button ng-click=\"IBECtrl.insertDropIn(\'tosField\', dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu><summernote ng-model=\"IBECtrl.hotel.ibeTos\" on-paste=\"IBECtrl.wysiwygPaste(evt)\" data-role=\"tosField\"></summernote></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"IBECtrl.saveHotel()\">{{\'general.buttons.save\' | i18next}} <i class=\"fa fa-spinner fa-spin\" ng-show=\"IBECtrl.loading\"></i></md-button></div></div>");
$templateCache.put("templates/settings/connectivity.channel_manager_tpl.html","<div ng-controller=\"Settings.ChannelManagers as ctrl\"><legend class=\"header\">{{\'profile_nav.settings.booking_engine.channel_manager.channel_manager_settings_legend\' | i18next}}</legend><div class=\"settings-body-block\" ng-if=\"ctrl.hotelIsProduction || ctrl.channels.length > 0\"><strong class=\"subblock-header\">{{\'profile_nav.settings.booking_engine.channel_manager.channel_managers_subblock_header\' | i18next}}</strong><div class=\"text-center\" ng-if=\"ctrl.channels.length === 0\">{{\'profile_nav.settings.booking_engine.channel_manager.not_connected_channel_manager_text\' | i18next}}</div><table class=\"table table-hover general-table table-editable\" ng-if=\"ctrl.channels.length > 0\"><thead><tr><th class=\"col-xs-4\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-2\">{{\'profile_nav.settings.booking_engine.channel_manager.is_active\' | i18next}}</th><th class=\"col-xs-2\">{{\'profile_nav.settings.booking_engine.channel_manager.is_synced_th\' | i18next}}</th><th class=\"col-xs-2\">{{\'profile_nav.settings.booking_engine.channel_manager.synced_at_th\' | i18next}}</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"channel in ctrl.channels track by (channel.id || $index)\" ng-if=\"channel.name != \'channex\' || (channel.name == \'channex\' && user.addons.channexVisible) || user.role == \'admin\'\"><td ng-hide=\"$index == ctrl.editedChannel\">{{channel.visible_name}} <span ng-if=\"channel.settings.note\">({{channel.settings.note}})</span></td><td ng-hide=\"$index == ctrl.editedChannel\"><i class=\"fa fa-check-circle\" ng-show=\"channel.isActive\" tooltip=\"{{\'profile_nav.settings.booking_engine.channel_manager.this_channel_is_active_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"$index == ctrl.editedChannel\"><i class=\"fa fa-check-circle\" ng-show=\"channel.isSynced\" tooltip=\"{{\'profile_nav.settings.booking_engine.channel_manager.this_channel_is_synced_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"$index == ctrl.editedChannel\">{{channel.syncedAt | dateToMoment: \'MMM D, YYYY\'}}</td><td ng-hide=\"$index == ctrl.editedChannel\" class=\"controls text-right\"><i class=\"fa fa-spinner\" ng-show=\"channel.loading\" ng-class=\"{\'fa-spin\' : type.loading}\"></i> <a ng-click=\"ctrl.fetchMissingBookings($index)\" ng-hide=\"channel.loading\"><i tooltip=\"{{\'profile_nav.settings.booking_engine.channel_manager.fetch_missing_bookings_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-search\"></i></a> <a ng-click=\"ctrl.syncChannel($index)\" ng-hide=\"channel.loading\"><i tooltip=\"{{\'profile_nav.settings.booking_engine.channel_manager.sync_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-refresh\"></i></a> <a ng-click=\"ctrl.openEditForm($index)\" ng-hide=\"channel.loading\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a></td><td colspan=\"5\" ng-show=\"$index == ctrl.editedChannel\" class=\"channels-form-row\" style=\"position: relative;\"><div class=\"block-loader ng-scope\" title=\"Loading...\" ng-class=\"{\'ng-hide\': !channel.loading}\"><i class=\"fa fa-spinner fa-spin\" ng-class=\"{\'fa-spin\': channel.loading}\"></i></div><div class=\"row\"><div class=\"col-xs-12\"><form class=\"form-horizontal\" name=\"paymentchannelForm\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'general.other.name\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.name\" ng-disabled=\"true\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.connection_note\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.note\"></div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-checkbox ng-model=\"channel.isActive\" aria-label=\"{{\'profile_nav.settings.booking_engine.channel_manager.is_active\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.is_active\' | i18next}}</md-checkbox></div></div><div ng-if=\"channel.name == \'wubook\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.wubook.wubook_account_code_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.accountCode\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.wubook.wubook_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.password\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.wubook.wubook_provider_key_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.providerKey\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.wubook.wubook_lcode_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.lcode\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.wubook.wubook_credit_card_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.ccPassword\"></div></div><table class=\"table table-bordered\"><thead><tr><th>{{\'profile_nav.settings.booking_engine.channel_manager.sync_th\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.room_type_th\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.room_rate_th\' | i18next}}</th><th>{{\'general.other.occupancy\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.short_code_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"roomRate in ctrl.roomRates track by roomRate.id\"><td class=\"text-center\"><input type=\"checkbox\" ng-model=\"roomRate.syncWithWubook\" ng-change=\"ctrl.normalizeWubookSettings(channel, roomRate)\"></td><td>{{ctrl.roomRepresentations[roomRate.roomRepresentationId].title}}</td><td>{{ctrl.rateCategoriesByIds[roomRate.rateCategoryId].name}}</td><td><i class=\"fa fa-user\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\"></i> {{roomRate.maxChildren}}</td><td>{{roomRate.shortCode}}</td></tr></tbody></table></div><div ng-if=\"channel.name == \'site_minder\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.site_minder.site_minder_username_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.username\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.site_minder.site_minder_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.password\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.site_minder.hotel_code_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.hotelCode\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.site_minder.region_label\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" ng-model=\"channel.settings.region\"><option value=\"APAC\">{{\'profile_nav.settings.booking_engine.channel_manager.site_minder.apac_option\' | i18next}}</option><option value=\"EMEA\">{{\'profile_nav.settings.booking_engine.channel_manager.site_minder.emea_option\' | i18next}}</option></select></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.days_to_sync_label\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" ng-model=\"channel.settings.daysCount\"><option value=\"400\">400</option><option value=\"550\">550</option><option value=\"750\">750</option></select></div></div><div class=\"form-group\"><label class=\"col-xs-3\" ng-i18next=\"[html]profile_nav.settings.booking_engine.channel_manager.site_minder.room_and_rate_configuration_label\"></label><div class=\"col-xs-9\"><input type=\"file\" class=\"form-control\" placeholder=\"Choose configuration CSV file\" onchange=\"angular.element(this).scope().$parent.$parent.ctrl.uploadConfiguration(event)\" accept=\".csv\"></div></div><div ng-hide=\"channel.settings.csvConfiguration\" class=\"text-center\">{{\'profile_nav.settings.booking_engine.channel_manager.upload_csv_configuration_div\' | i18next}}</div><div ng-show=\"channel.settings.csvConfiguration\"><div class=\"row\"><div class=\"col-xs-12\"><legend>{{\'profile_nav.settings.booking_engine.channel_manager.room_type_associations_legend\' | i18next}}</legend><table class=\"table table-bordered\"><thead><tr><th>{{\'profile_nav.settings.booking_engine.channel_manager.room_rate_combination_th\' | i18next}}</th><th>{{\'general.other.occupancy\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.room_code_th\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.rate_code_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"roomRate in ctrl.roomRates track by roomRate.id\"><td>{{roomRate.title}}</td><td><i class=\"fa fa-user\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\"></i> {{roomRate.maxChildren}}</td><td><select class=\"form-control\" ng-model=\"channel.settings.roomRateRoomCodes[roomRate.id]\"><option value=\"null\">{{\'profile_nav.settings.booking_engine.channel_manager.n/a_option\' | i18next}}</option><option ng-repeat=\"code in channel.settings.csvConfiguration.roomCodes track by $index\" value=\"{{code}}\">{{code}}</option></select></td><td><select class=\"form-control\" ng-model=\"channel.settings.roomRateRateCodes[roomRate.id]\"><option value=\"null\">{{\'profile_nav.settings.booking_engine.channel_manager.n/a_option\' | i18next}}</option><option ng-repeat=\"code in channel.settings.csvConfiguration.rateCodes track by $index\" value=\"{{code}}\">{{code}}</option></select></td></tr></tbody></table></div></div></div></div><div ng-if=\"channel.name == \'vertical_booking\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.vertical_booking_username_label\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.username\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.vertical_booking_password_label\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.password\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.requesto_id_label\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.requestorId\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.hotel_id_label\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"channel.settings.hotelId\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.days_to_sync_label\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" ng-model=\"channel.settings.daysCount\"><option value=\"400\">400</option><option value=\"550\">550</option><option value=\"750\">750</option></select></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.room_cvs_configuration_label\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"file\" class=\"form-control\" placeholder=\"Choose configuration CSV file\" onchange=\"angular.element(this).scope().$parent.$parent.ctrl.uploadVBRoomConfiguration(event)\" accept=\".csv\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.rate_cvs_configuration_label\' | i18next}}</label><div class=\"col-xs-9\"><input type=\"file\" class=\"form-control\" placeholder=\"Choose configuration CSV file\" onchange=\"angular.element(this).scope().$parent.$parent.ctrl.uploadVBRateConfiguration(event)\" accept=\".csv\"></div></div><div class=\"form-group\"><div class=\"col-xs-9 col-xs-offset-3\"><md-checkbox ng-model=\"channel.settings.syncAsMoRates\" aria-label=\"{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.sync_as_mo_rate\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.sync_as_mo_rate\' | i18next}}</md-checkbox></div></div><div ng-hide=\"channel.settings.csvRateConfiguration && channel.settings.csvRoomConfiguration\" class=\"text-center\">{{\'profile_nav.settings.booking_engine.channel_manager.upload_csv_configuration_div\' | i18next}}</div><div ng-show=\"channel.settings.csvRateConfiguration && channel.settings.csvRoomConfiguration\"><div class=\"row\"><div class=\"col-xs-12\"><legend>{{\'profile_nav.settings.booking_engine.channel_manager.room_rate_associations_legend\' | i18next}}</legend><table class=\"table table-bordered\"><thead><tr><th>{{\'profile_nav.settings.booking_engine.channel_manager.room_rate_combination_th\' | i18next}}</th><th>{{\'general.other.occupancy\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.room_code_th\' | i18next}}</th><th>{{\'profile_nav.settings.booking_engine.channel_manager.rate_code_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"roomRate in ctrl.roomRates track by roomRate.id\"><td>{{roomRate.title}}</td><td><i class=\"fa fa-user\"></i> {{roomRate.maxAdults}} <i class=\"fa fa-child\"></i> {{roomRate.maxChildren}}</td><td><select class=\"form-control\" ng-model=\"channel.settings.roomRateRoomCodes[roomRate.id]\"><option value=\"null\">{{\'profile_nav.settings.booking_engine.channel_manager.n/a_option\' | i18next}}</option><option ng-repeat=\"code in channel.settings.csvRoomConfiguration track by $index\" value=\"{{code}}\">{{code}}</option></select></td><td><select class=\"form-control\" ng-model=\"channel.settings.roomRateRateCodes[roomRate.id]\"><option value=\"null\">{{\'profile_nav.settings.booking_engine.channel_manager.n/a_option\' | i18next}}</option><option ng-repeat=\"code in channel.settings.csvRateConfiguration track by $index\" value=\"{{code}}\">{{code}}</option></select></td></tr></tbody></table></div></div></div></div><div ng-if=\"channel.name == \'channex\'\" ng-include=\"ctrl.channexForm\"></div></form></div></div><div class=\"text-right form-buttons marged-top\"><md-button class=\"md-raised md-success\" ng-click=\"ctrl.saveEditing()\">{{\'general.buttons.save\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"ctrl.cancelEditing()\">{{\'general.buttons.cancel\' | i18next}}</md-button></div></td></tr></tbody></table></div><div class=\"settings-body-block marged-bottom\" ng-if=\"!ctrl.hotelIsProduction && ctrl.channels.length == 0\">{{\'profile_nav.settings.booking_engine.channel_manager.connect_to_channel_manager_div\' | i18next}}</div><div class=\"toolbar spinned marged-bottom\" ng-if=\"ctrl.hotelIsProduction || ctrl.channels.length > 0\"><md-menu><md-button class=\"md-raised md-success\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\">{{\'profile_nav.settings.booking_engine.channel_manager.add_channel_button\' | i18next}}</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"ctrl.addChannel(\'site_minder\')\">Site Minder</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.addChannel(\'vertical_booking\')\">Vertical Booking</md-button></md-menu-item><md-menu-item ng-if=\"user.role == \'admin\' || user.addons.channexVisible\"><md-button ng-click=\"ctrl.addChannel(\'channex\')\">Channex</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"settings-body-block\" ng-if=\"ctrl.hotel.trivagoEnabled\"><strong class=\"subblock-header\">{{\'profile_nav.settings.booking_engine.channel_manager.trivago.trivago_integration_settings_div\' | i18next}}</strong><md-checkbox ng-model=\"ctrl.hotel.trivagoEnabled\" aria-label=\"{\'profile_nav.settings.booking_engine.channel_manager.trivago.enable_trivago_integration_checkbox\' | i18next}}\">{{\'profile_nav.settings.booking_engine.channel_manager.trivago.enable_trivago_integration_checkbox\' | i18next}}</md-checkbox></div><div class=\"text-right toolbar spinned marged-bottom\" ng-if=\"ctrl.hotel.trivagoEnabled\"><md-button class=\"md-raised md-success\" ng-disabled=\"ctrl.saveHotelInProgress\" ng-click=\"ctrl.saveHotel()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ctrl.saveHotelInProgress}\" ng-show=\"ctrl.saveHotelInProgress\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/connectivity.dev_keys_tpl.html","<div ng-controller=\"Settings.DevKeysController as DevKeysCtrl\"><legend class=\"header\">{{\'profile_nav.settings.other.dev_keys.dev_keys_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"!loaded_keys || !loaded_perms\" ng-class=\"{\'fa-spin\': !loaded_keys || !loaded_perms}\"></i></legend><div class=\"settings-body-block\"><div class=\"row\" ng-if=\"loaded_keys && loaded_perms\"><h4 class=\"text-center\">Endpoint: <strong>{{endpoint}}</strong></h4><table class=\"table dev-keys-table\"><thead><tr><th class=\"text-center\">{{\'profile_nav.settings.other.dev_keys.dev_key_th\' | i18next}}</th><th class=\"text-center\">{{\'profile_nav.settings.other.dev_keys.permissions_th\' | i18next}}</th><th class=\"text-center\">{{\'profile_nav.settings.booking_engine.channel_manager.is_active\' | i18next}}</th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-if=\"keys.length == 0\"><td class=\"text-center\" colspan=\"4\">{{\'profile_nav.settings.other.dev_keys.no_keys_available\' | i18next}}</td></tr><tr class=\"text-center\" ng-repeat-start=\"key in keys track by $index\"><td>{{key.name}}</td><td><span ng-repeat=\"perm in perms track by $index\"><md-checkbox ng-model=\"key.perms[perm.id]\" ng-disabled=\"key.is_plugin\" style=\"width: 40%\">{{perm[\'group\']}}.{{perm[\'scope\']}}</md-checkbox></span></td><td><md-checkbox ng-model=\"key.is_active\"></md-checkbox></td><td><md-button ng-show=\"!key.show\" class=\"md-raised md-options\" ng-click=\"toggleKey(key);\">{{\'bookings.payment.card_info.show\' | i18next}}</md-button><md-button ng-show=\"key.show\" class=\"md-raised md-options\" ng-click=\"toggleKey(key);\">{{\'bookings.payment.card_info.hide\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"key.is_plugin\" ng-click=\"saveKey(key)\"><i class=\"fa fa-spinner\" ng-show=\"key.loading\" ng-class=\"{\'fa-spin\': key.loading}\"></i>{{\'general.buttons.save\' | i18next}}</md-button><md-button class=\"md-raised md-orange\" ng-disabled=\"key.is_plugin\" ng-click=\"removeKey(key)\">{{\'general.buttons.remove\' | i18next}}</md-button></td></tr><tr class=\"key-data text-left\" ng-if=\"key.show\" ng-repeat-end=\"\"><td colspan=\"4\"><div class=\"alert alert-info\"><div>{{\'profile_nav.settings.other.payment_gateways.public_key\' | i18next}}: {{key.public}}</div><div>{{\'profile_nav.settings.other.payment_gateways.secret_key\' | i18next}}: {{key.secret}}</div></div></td></tr></tbody></table></div></div><div class=\"toolbar-bottom\" ng-if=\"loaded_keys && loaded_perms\"><md-input-container><label for=\"testInput\">{{\'profile_nav.settings.other.dev_keys.new_dev_key\' | i18next}}</label> <input type=\"text\" md-autofocus=\"\" ng-model=\"DevKeysCtrl.newKeyName\"></md-input-container><md-button class=\"md-raised md-success\" ng-click=\"createKey()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"create_in_progress\"></i> {{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.add_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/connectivity.domain_alias_tpl.html","<div ng-controller=\"WebsiteCtrl as website_settings\"><legend class=\"header\">{{\'website_settings.domain_aliases.domain_aliases_legend\' | i18next}}<br><small>{{\'website_settings.domain_aliases.default_domain_small\' | i18next}}</small></legend><div class=\"settings-body-block\"><md-input-container><label>{{\'website_settings.domain_aliases.primary_domain_label\' | i18next}}</label><md-select ng-model=\"website.url\"><md-option ng-value=\"\" ng-selected=\"(website.url == \'\' || website.url === null)\">{{\'website_settings.domain_aliases.system_subdomain_option\' | i18next}}</md-option><md-option ng-value=\"domain.domain\" ng-selected=\"(domain.domain == website.url)\" ng-repeat=\"domain in website.domains\">{{domain.domain}}</md-option></md-select></md-input-container><div ng-hide=\"website.url == \'\' || website.url === null\" class=\"domain-info\"><i class=\"fa fa-info-circle\"></i> {{\'website_settings.domain_aliases.set_the_domain_name_text\' | i18next}}<pre>{{\'website_settings.domain_aliases.cname_record_pre\' | i18next}}: {{cname_record}}</pre></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><legend class=\"header\">{{\'website_settings.domain_aliases.manage_domains_legend\' | i18next}}<br><small>{{\'website_settings.domain_aliases.add_your_custom_domain_names_here_small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom domain-table\"><table class=\"table table-striped\"><thead><tr><th>{{\'website_settings.domain_aliases.domain_th\' | i18next}}</th><th>{{\'website_settings.domain_aliases.status_th\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"domain in website.domains | filter:{ invisible : undefined }\"><td ng-show=\"domain.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'website_settings.domain_aliases.domain_label\' | i18next}}</label> <input type=\"text\" ng-model=\"domain.domain\" md-maxlength=\"255\"></md-input-container><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeEditDomain($event, domain, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditDomain($event, domain, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></td><td ng-hide=\"domain.edited\">{{domain.domain}}</td><td ng-hide=\"domain.edited\"><span ng-class=\"{\'text-yes\':(domain.status.toLowerCase()==\'ok\'), \'text-no\':(domain.status!=\'Ok\')}\">{{domain.status | lowercase}}</span></td><td ng-hide=\"domain.edited\" class=\"controls\"><a href=\"#\" ng-click=\"editDomain($event, domain)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a href=\"#\" ng-click=\"removeDomain($event, domain)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"domain.loading\"></i> <i class=\"fa fa-spinner fa-spin\" ng-show=\"domain.loading\"></i></a></td></tr></tbody></table><div class=\"new-question-form table-form\" ng-show=\"addNewDomain\"><md-input-container><label>{{\'website_settings.domain_aliases.domain_label\' | i18next}}</label> <input type=\"text\" ng-model=\"newDomain.domain\" md-maxlength=\"255\"></md-input-container><div class=\"text-right form-buttons\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddDomainForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewDomain()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddDomainForm($event)\"><i class=\"fa fa-plus\"></i> {{\'website_settings.domain_aliases.add_new_domain_button\' | i18next}}</md-button></div></div><legend class=\"header\">{{\'website_settings.domain_aliases.page_redirect_legend\' | i18next}}<br><small>{{\'website_settings.domain_aliases.links_point_to_old_pages_small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-striped\"><thead><tr><th>{{\'website_settings.domain_aliases.from_url_th\' | i18next}}</th><th>{{\'website_settings.domain_aliases.to_url_th\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"redirect in website.redirects | filter:{ invisible : undefined }\"><td ng-show=\"redirect.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'website_settings.domain_aliases.from_url_label\' | i18next}}</label> <input type=\"text\" ng-model=\"redirect.fromUrl\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.domain_aliases.to_url_label\' | i18next}}</label> <input type=\"text\" ng-model=\"redirect.toUrl\" disabled=\"true\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.domain_aliases.redirect_target_label\' | i18next}}</label><md-select ng-model=\"redirect.toUrl\"><md-option ng-value=\"page.url\" ng-repeat=\"page in pagesCollection\">{{page.title}}</md-option></md-select></md-input-container><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeEditRedirect($event, redirect, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditRedirect($event, redirect, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></td><td ng-hide=\"redirect.edited\">/{{redirect.fromUrl}}</td><td ng-hide=\"redirect.edited\">/{{redirect.toUrl}}</td><td ng-hide=\"redirect.edited\" class=\"controls\"><a href=\"#\" ng-click=\"editRedirect($event, redirect)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a href=\"#\" ng-click=\"removeRedirect($event, redirect)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"redirect.loading\"></i> <i class=\"fa fa-spinner fa-spin\" ng-show=\"redirect.loading\"></i></a></td></tr></tbody></table><div class=\"new-question-form table-form\" ng-show=\"addNewRedirect\"><md-input-container><label>{{\'website_settings.domain_aliases.from_url_label\' | i18next}}</label> <input type=\"text\" ng-model=\"newRedirect.fromUrl\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.domain_aliases.to_url_label\' | i18next}}</label> <input type=\"text\" ng-model=\"newRedirect.toUrl\" disabled=\"true\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.domain_aliases.redirect_target_label\' | i18next}}</label><md-select ng-model=\"newRedirect.toUrl\"><md-option ng-value=\"page.url\" ng-repeat=\"page in pagesCollection\">{{page.title}}</md-option></md-select></md-input-container><div class=\"text-right form-buttons\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddRedirectForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-success md-raised\" ng-click=\"saveNewRedirect()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddRedirectForm($event)\"><i class=\"fa fa-plus\"></i> {{\'website_settings.domain_aliases.add_new_redirect_button\' | i18next}}</md-button></div></div></div>");
$templateCache.put("templates/settings/connectivity.housekeeping_systems_tpl.html","<div ng-controller=\"Settings.HousekeepingSystemsController as HousekeepingSystemCtrl\"><legend class=\"header\">{{\'profile_nav.settings.sidebar.other.housekeeping_systems\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"!loadedHousekeepingSystems\" ng-class=\"{\'fa-spin\': !loadedHousekeepingSystems}\"></i></legend><react-housekeeping-systems on-save=\"HousekeepingSystemCtrl.onSave\" on-delete=\"HousekeepingSystemCtrl.onDelete\" housekeeping-systems-data=\"HousekeepingSystemCtrl.housekeepingSystemsData\"></react-housekeeping-systems></div>");
$templateCache.put("templates/settings/connectivity.key_lock_systems_tpl.html","<div ng-controller=\"Settings.KeyLockController as KeyLockCtrl\"><legend class=\"header\">{{\'profile_nav.settings.sidebar.other.key_lock_systems\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"!loadedKeyLocks\" ng-class=\"{\'fa-spin\': !loadedKeyLocks}\"></i></legend><key-locks on-save=\"KeyLockCtrl.onSave\" on-send-test-letter=\"KeyLockCtrl.onSendTestLetter\" on-load-bee-free-token=\"KeyLockCtrl.onLoadBeeFreeToken\" on-delete=\"KeyLockCtrl.onDelete\" key-locks-data=\"KeyLockCtrl.keyLocksData\" hotel-properties=\"KeyLockCtrl.hotelProperties\" remote-lock-url=\"KeyLockCtrl.remoteLockUrl\" hotel-id=\"KeyLockCtrl.hotelId\"></key-locks></div>");
$templateCache.put("templates/settings/connectivity.sale_channels_tpl.html","<div ng-controller=\"Settings.SaleChannelsController as vm\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header full-width-block-header_with-buttons\"><div class=\"row\"><div class=\"col-xs-4\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.title\' | i18next}}</div><div ng-hide=\"!vm.isListMode || !vm.haveSaleChannels\"><div class=\"col-xs-4\"><a ng-class=\"{\'active\': vm.filter === \'confirmed\'}\" ng-click=\"vm.changeFilter(\'confirmed\')\">{{\'general.filters.active\' | i18next}}</a> &nbsp;|&nbsp; <a ng-class=\"{\'active\': vm.filter === \'all\'}\" ng-click=\"vm.changeFilter(\'all\')\">{{\'general.filters.all\' | i18next}}</a> &nbsp;|&nbsp; <a ng-class=\"{\'active\': vm.filter === \'draft\'}\" ng-click=\"vm.changeFilter(\'draft\')\">{{\'general.filters.draft\' | i18next}}</a></div><div class=\"col-xs-4\"><md-button ng-disabled=\"vm.selectedItemsCount < 2\" class=\"md-raised md-primary pull-right\" ng-click=\"vm.mergeItems()\">{{\'general.buttons.merge\' | i18next}}</md-button></div></div></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"!vm.loading\"><table ng-if=\"vm.haveSaleChannels || vm.createFormVisible\" class=\"table table-hover general-table table-editable\"><thead><tr><th class=\"col-xs-1\"></th><th class=\"col-xs-5\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.name_th\' | i18next}}</th><th class=\"col-xs-5\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.code_th\' | i18next}}</th><th class=\"col-xs-5\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.status_th\' | i18next}}</th><th class=\"col-xs-1 controls\"></th></tr></thead><tbody><tr ng-if=\"vm.haveFilteredSaleChannels\" ng-repeat=\"saleChannel in vm.filteredSaleChannels\"><td ng-if=\"vm.editItemId === saleChannel.id\" colspan=\"4\" class=\"table-form-row\"><sale-channel-form request-in-progress=\"vm.requestInProgress\" sale-channel=\"vm.editSaleChannel\" save-callback=\"vm.updateItem\" cancel-callback=\"vm.closeForm\"></sale-channel-form></td><td ng-if=\"vm.editItemId !== saleChannel.id\"><md-checkbox ng-model=\"saleChannel.isSelected\" aria-label=\"{{\'profile_nav.settings.booking_engine.sale_channels_settings.select\' | i18next}}\"></md-checkbox></td><td ng-if=\"vm.editItemId !== saleChannel.id\">{{saleChannel.name}}</td><td ng-if=\"vm.editItemId !== saleChannel.id\">{{saleChannel.code}}</td><td ng-if=\"vm.editItemId !== saleChannel.id\">{{vm.getStatus(saleChannel)}}</td><td ng-if=\"vm.editItemId !== saleChannel.id\" class=\"controls\"><a ng-click=\"vm.editItem(saleChannel)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-if=\"saleChannel.isCustom()\" ng-click=\"vm.removeItem(saleChannel)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr ng-if=\"!vm.haveFilteredSaleChannels && !vm.createFormVisible\"><td class=\"text-center\" colspan=\"4\">{{\'general.tables.empty_result\' | i18next}}</td></tr><tr ng-if=\"vm.createFormVisible\"><td colspan=\"4\" class=\"table-form-row\"><sale-channel-form request-in-progress=\"vm.requestInProgress\" sale-channel=\"vm.newSaleChannel\" save-callback=\"vm.createItem\" cancel-callback=\"vm.closeForm\"></sale-channel-form></td></tr></tbody></table><div ng-if=\"!vm.haveSaleChannels && !vm.createFormVisible\"><div class=\"text-center full-width-padded-top full-width-padded-bottom\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.you_do_not_have_any_sale_channels\' | i18next}}<br><a ng-click=\"vm.addItem()\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.add_new_sale_channel_button\' | i18next}}</a></div></div></div></div><div ng-if=\"vm.haveSaleChannels && vm.isListMode\" class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-click=\"vm.addItem()\">{{\'profile_nav.settings.booking_engine.sale_channels_settings.add_new_sale_channel_button\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/connectivity.widget_tpl.html","<div ng-controller=\"Settings.WidgetController as WidgetCtrl\"><legend class=\"header\">{{\'profile_nav.settings.other.booking_widget.booking_widget_generation_legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\" ng-hide=\"WidgetCtrl.booking_widgets.length == 0 && WidgetCtrl.newWidgetFormVisible == true\"><div class=\"row\" ng-if=\"WidgetCtrl.booking_widgets.length == 0 && WidgetCtrl.newWidgetFormVisible == false\"><div class=\"col-md-12 text-center\">{{\'profile_nav.settings.other.booking_widget.you_are_not_have_any_booking_widgets_div\' | i18next}}<br><a ng-click=\"WidgetCtrl.openCreateBookingWidgetForm()\">{{\'profile_nav.settings.other.booking_widget.create_first_widget_link\' | i18next}}</a></div></div><div class=\"row\" ng-if=\"WidgetCtrl.booking_widgets.length > 0\"><legend>{{\'profile_nav.settings.other.booking_widget.saved_widgets_legend\' | i18next}}</legend><div class=\"col-md-12\"><table class=\"table table-striped\"><thead><tr><th>{{\'profile_nav.settings.other.booking_widget.hash_code_th\' | i18next}}</th><th class=\"controls\"></th></tr></thead><tbody><tr ng-repeat=\"widget in WidgetCtrl.booking_widgets\"><td ng-if=\"!widget.edited\">{{widget.hashKey}}</td><td ng-if=\"!widget.edited\"><a ng-click=\"WidgetCtrl.editBookingWidget(widget)\"><i class=\"fa fa-edit\"></i></a> &nbsp;&nbsp;&nbsp; <a ng-click=\"WidgetCtrl.removeBookingWidget(widget)\"><i class=\"fa fa-trash\"></i></a></td><td ng-if=\"widget.edited\" colspan=\"2\"><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.title_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.title\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.button_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.buttonText\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.check_in_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.checkinDateText\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.check_out_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.checkoutDateText\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.nights_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.nightsText\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"widget.occupancyVisible\" aria-label=\"{{\'profile_nav.settings.other.booking_widget.show_occupancy_options_checkbox\' | i18next}}\" ng-change=\"WidgetCtrl.preview(widget)\">{{\'profile_nav.settings.other.booking_widget.show_occupancy_options_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"widget.useCheckoutInsteadNights\" aria-label=\"{{\'profile_nav.settings.other.booking_widget.use_checkout_date_instead_nights_count_checkbox\' | i18next}}\" ng-change=\"WidgetCtrl.preview(widget)\">{{\'profile_nav.settings.other.booking_widget.use_checkout_date_instead_nights_count_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.month_names_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.monthNames\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.week_day_names_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.weekDayNames\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.primary_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.primaryColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"widget.primaryColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.text_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.textColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"widget.textColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.background_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.backgroundColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"widget.backgroundColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.label_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.labelColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"widget.labelColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.border_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"widget.borderColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"widget.borderColor\" ng-change=\"WidgetCtrl.preview(widget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.currency_code_label\' | i18next}}</label><md-select ng-model=\"widget.currencyCode\"><md-option value=\"\">N/A</md-option><md-option ng-repeat=\"currency in WidgetCtrl.currencies track by $index\" value=\"{{currency[0]}}\">{{currency[1]}}</md-option></md-select></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.language_code_label\' | i18next}}</label><md-select ng-model=\"widget.languageCode\"><md-option value=\"\">N/A</md-option><md-option ng-repeat=\"language in WidgetCtrl.languages track by $index\" value=\"{{language.code}}\">{{language.name}} ({{language.nativeName}})</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6 preview-widget-box\"></div><div class=\"col-md-6\"><strong>{{\'profile_nav.settings.other.booking_widget.embed_code_div\' | i18next}}:</strong><pre>{{WidgetCtrl.getSettings(widget)}}</pre></div></div><div class=\"text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"WidgetCtrl.closeEditForm(widget)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"WidgetCtrl.saveEditForm(widget)\">{{\'general.buttons.save\' | i18next}}</md-button></div></td></tr></tbody></table><a ng-click=\"WidgetCtrl.openCreateBookingWidgetForm()\">{{\'profile_nav.settings.other.booking_widget.create_new_widget_link\' | i18next}}</a></div></div></div><div class=\"settings-body-block marged-bottom\" ng-if=\"WidgetCtrl.newWidgetFormVisible == true\"><legend>{{\'profile_nav.settings.other.booking_widget.new_booking_widget_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.title_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.title\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.button_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.button_text\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.check_in_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.checkin_date_text\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.check_out_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.checkout_date_text\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.nights_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.nights_text\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"WidgetCtrl.newWidget.occupancy_visible\" aria-label=\"{{\'profile_nav.settings.other.booking_widget.show_occupancy_options_checkbox\' | i18next}}\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\">{{\'profile_nav.settings.other.booking_widget.show_occupancy_options_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"WidgetCtrl.newWidget.use_checkout_instead_nights\" aria-label=\"{{\'profile_nav.settings.other.booking_widget.use_checkout_date_instead_nights_count_checkbox\' | i18next}}\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\">{{\'profile_nav.settings.other.booking_widget.use_checkout_date_instead_nights_count_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.month_names_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.monthes\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.week_day_names_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.week_days\" md-maxlength=\"255\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.primary_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.primary_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"WidgetCtrl.newWidget.primary_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.text_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.text_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"WidgetCtrl.newWidget.text_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.background_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.background_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"WidgetCtrl.newWidget.background_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.label_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.label_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"WidgetCtrl.newWidget.label_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.border_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"WidgetCtrl.newWidget.border_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"WidgetCtrl.newWidget.border_color\" ng-change=\"WidgetCtrl.preview(WidgetCtrl.newWidget)\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.currency_code_label\' | i18next}}</label><md-select ng-model=\"WidgetCtrl.newWidget.currencyCode\"><md-option value=\"\">N/A</md-option><md-option ng-repeat=\"currency in WidgetCtrl.currencies track by $index\" value=\"{{currency[0]}}\">{{currency[1]}}</md-option></md-select></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.other.booking_widget.language_code_label\' | i18next}}</label><md-select ng-model=\"WidgetCtrl.newWidget.languageCode\"><md-option value=\"\">N/A</md-option><md-option ng-repeat=\"language in WidgetCtrl.languages track by $index\" value=\"{{language.code}}\">{{language.name}} ({{language.nativeName}})</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6 preview-widget-box\"></div><div class=\"col-md-6\">{{\'profile_nav.settings.other.booking_widget.save_widget_to_get_embed_code_div\' | i18next}}</div></div><div class=\"text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"WidgetCtrl.closeEditForm(WidgetCtrl.newWidget)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"WidgetCtrl.saveEditForm(WidgetCtrl.newWidget)\">{{\'general.buttons.save\' | i18next}}</md-button></div></div></div>");
$templateCache.put("templates/settings/content.details_tpl.html","<div ng-controller=\"Settings.DetailsController as DetailsCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.hotel_details.legend\' | i18next}} <i class=\"fa fa-spinner fa-spin\" ng-show=\"DetailsCtrl.loaded\"></i><locale-selector change=\"DetailsCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><form name=\"hotel-details-form\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.hotel_details.hotel_description_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-9\"><summernote ng-model=\"DetailsCtrl.hotel.description\"></summernote></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.hotel_details.booking_dot_com_code_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" name=\"bookingComCode\" ng-model=\"DetailsCtrl.hotel.bookingComCode\"></div></div><div class=\"form-group text-center\"><button class=\"btn btn-primary\" ng-click=\"DetailsCtrl.save()\"><i class=\"fa fa-save\" ng-hide=\"DetailsCtrl.loaded\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : DetailsCtrl.loaded}\" ng-show=\"DetailsCtrl.loaded\"></i> {{\'general.buttons.save\' | i18next}}</button></div></form></div></div>");
$templateCache.put("templates/settings/content.extras_tpl.html","<div ng-controller=\"Settings.ExtrasController as ExtrasCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.extras_categories.extras_categories_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ExtrasCtrl.loaded}\" ng-hide=\"ExtrasCtrl.loaded\"></i><locale-selector change=\"ExtrasCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-hover general-table table-editable table-extras\"><thead><tr><th class=\"col-xs-6\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-5\">{{\'general.other.taxes\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"category in ExtrasCtrl.categories | filter:{isRemoved:false} | orderBy:ExtrasCtrl.sortTitleByHotelLang\"><td ng-if=\"category.edited\" colspan=\"3\"><settings-extra-category-form ng-model=\"category\" ng-scope=\"ExtrasCtrl\"></settings-extra-category-form></td><td ng-if=\"!category.edited\">{{category | prettyTranslate: \'title\' }}</td><td ng-if=\"!category.edited\">{{category.taxNames}}</td><td ng-if=\"!category.edited\" class=\"controls text-right\"><a ng-click=\"ExtrasCtrl.openCategoryEditForm(category)\" ng-hide=\"category.isLoading\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a ng-click=\"ExtrasCtrl.mergeExtraCategory(category)\" ng-hide=\"category.isLoading\" aria-label=\"{{\'general.tooltip.merge\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.merge\' | i18next}}</md-tooltip><i class=\"fa fa-compress\"></i></a> <a ng-click=\"ExtrasCtrl.removeExtraCategory(category)\" ng-hide=\"category.isLoading\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-times\"></i></a></td></tr></tbody><tfoot><tr ng-if=\"ExtrasCtrl.createCategoryFormVisible\"><td colspan=\"3\" class=\"edited-row\"><settings-extra-category-form ng-model=\"ExtrasCtrl.newCategory\" ng-scope=\"ExtrasCtrl\"></settings-extra-category-form></td></tr><tr><td colspan=\"3\"><a ng-click=\"ExtrasCtrl.openCreateCategoryForm()\" class=\"control-link\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.hotel_profile.extras_categories.add_extra_category_link\' | i18next}}</a></td></tr></tfoot></table></div><legend class=\"header\">{{\'general.other.extras\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\"><hotel-extras-table extras=\"ExtrasCtrl.extras\" categories=\"ExtrasCtrl.categories\" accounting-categories=\"ExtrasCtrl.accountingCategories\" is-accounting-categories-feature-enabled=\"ExtrasCtrl.isAccountingCategoriesFeatureEnabled\" user=\"ExtrasCtrl.user\" grouped-taxes=\"ExtrasCtrl.grouppedTaxes\" hotel-id=\"ExtrasCtrl.hotelId\" extras-to-merge=\"ExtrasCtrl.extrasToMerge\" extras-meta=\"ExtrasCtrl.extrasMeta\" on-extra-update=\"ExtrasCtrl.saveCreateForm\" on-extra-merge=\"ExtrasCtrl.mergeExtra\" on-extra-delete=\"ExtrasCtrl.removeExtra\" on-load-extras=\"ExtrasCtrl.onLoadExtras\" on-load-extras-to-merge=\"ExtrasCtrl.onLoadExtrasToMerge\" extras-to-merge-meta=\"ExtrasCtrl.extrasToMergeMeta\"></hotel-extras-table></div></div>");
$templateCache.put("templates/settings/content.policy_tpl.html","<div ng-controller=\"Settings.PolicyController as PolicyCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.hotel_policy.legend\' | i18next}}<locale-selector change=\"PolicyCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><form name=\"hotel-details-form\" class=\"form-horizontal\"><legend>{{\'general.other.children\' | i18next}}</legend><div class=\"form-group\"><label class=\"col-xs-12\">{{\'profile_nav.settings.hotel_profile.hotel_policy.if_children_are_allowed_in_accomodation_label\' | i18next}}</label><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"children\" ng-model=\"PolicyCtrl.policy.childrenPolicy\" ng-value=\"\'All ages welcome\'\" ng-click=\"PolicyCtrl.recalcCustom(\'children\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.all_ages_welcome_label\' | i18next}}</label><br><label><input type=\"radio\" name=\"children\" ng-model=\"PolicyCtrl.policy.childrenPolicy\" ng-value=\"\'Sorry, no children and infants\'\" ng-click=\"PolicyCtrl.recalcCustom(\'children\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.no_children_and_infants_label\' | i18next}}</label><br><label><input type=\"radio\" name=\"children\" ng-model=\"PolicyCtrl.policy.childrenPolicy\" ng-value=\"\'Sorry, no infants\'\" ng-click=\"PolicyCtrl.recalcCustom(\'children\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.no_infants_label\' | i18next}}</label><br><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"PolicyCtrl.policy.childrenPolicy == \'Children Custom\'\"></locale-selector-next><label><input name=\"children\" type=\"radio\" ng-model=\"PolicyCtrl.policy.childrenPolicy\" ng-value=\"\'Children Custom\'\" ng-click=\"PolicyCtrl.setCustom(\'children\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.custom_policy_label\' | i18next}}</label><br><textarea ng-show=\"PolicyCtrl.policy.childrenPolicy == \'Children Custom\'\" class=\"form-control\" ng-model=\"PolicyCtrl.policy.childrenPolicyCustom\" ng-keyup=\"PolicyCtrl.generatePolicyText()\"></textarea></div><label><input type=\"radio\" name=\"children\" ng-model=\"PolicyCtrl.policy.childrenPolicy\" ng-value=\"null\" ng-click=\"PolicyCtrl.recalcCustom(\'children\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.omit_this_policy_label\' | i18next}}</label><br></div></div><legend>{{\'profile_nav.settings.hotel_profile.hotel_policy.pets_legend\' | i18next}}</legend><div class=\"form-group\"><label class=\"col-xs-12\">{{\'profile_nav.settings.hotel_profile.hotel_policy.if_pets_are_allowed_in_accomodation_label\' | i18next}}</label><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"pets\" ng-model=\"PolicyCtrl.policy.petsPolicy\" ng-value=\"\'Sorry, no pets\'\" ng-click=\"PolicyCtrl.recalcCustom(\'pets\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.no_pets_label\' | i18next}}</label><br><label><input type=\"radio\" name=\"pets\" ng-model=\"PolicyCtrl.policy.petsPolicy\" ng-value=\"\'Pets welcome, but may incur surcharge\'\" ng-click=\"PolicyCtrl.recalcCustom(\'pets\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.pets_welcome_label\' | i18next}}</label><br><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"PolicyCtrl.policy.petsPolicy == \'Pets Custom\'\"></locale-selector-next><label><input type=\"radio\" name=\"pets\" ng-model=\"PolicyCtrl.policy.petsPolicy\" ng-value=\"\'Pets Custom\'\" ng-click=\"PolicyCtrl.setCustom(\'pets\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.custom_policy_label\' | i18next}}</label><br><textarea ng-show=\"PolicyCtrl.policy.petsPolicy == \'Pets Custom\'\" class=\"form-control\" ng-model=\"PolicyCtrl.policy.petsPolicyCustom\" ng-keyup=\"PolicyCtrl.generatePolicyText()\"></textarea></div><label><input type=\"radio\" name=\"pets\" ng-model=\"PolicyCtrl.policy.petsPolicy\" ng-value=\"null\" ng-click=\"PolicyCtrl.recalcCustom(\'pets\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.omit_this_policy_label\' | i18next}}</label></div></div><legend>{{\'profile_nav.settings.hotel_profile.hotel_policy.smoking_legend\' | i18next}}</legend><div class=\"form-group\"><label class=\"col-xs-12\">{{\'profile_nav.settings.hotel_profile.hotel_policy.if_smoking_is_allowed_label\' | i18next}}</label><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"smoking\" ng-model=\"PolicyCtrl.policy.smokingPolicy\" ng-value=\"\'Strictly no smoking\'\" ng-click=\"PolicyCtrl.recalcCustom(\'smoking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.strictly_no_smoking_label\' | i18next}}</label><br><label><input type=\"radio\" name=\"smoking\" ng-model=\"PolicyCtrl.policy.smokingPolicy\" ng-value=\"\'Smoking in permitted areas only\'\" ng-click=\"PolicyCtrl.recalcCustom(\'smoking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.smoking_in_permitted_areas_only_label\' | i18next}}</label><br><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"PolicyCtrl.policy.smokingPolicy == \'Smoking Custom\'\"></locale-selector-next><label><input type=\"radio\" name=\"smoking\" ng-model=\"PolicyCtrl.policy.smokingPolicy\" ng-value=\"\'Smoking Custom\'\" ng-click=\"PolicyCtrl.setCustom(\'smoking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.custom_policy_label\' | i18next}}</label><br><textarea ng-show=\"PolicyCtrl.policy.smokingPolicy == \'Smoking Custom\'\" class=\"form-control\" ng-model=\"PolicyCtrl.policy.smokingPolicyCustom\" ng-keyup=\"PolicyCtrl.generatePolicyText()\"></textarea></div><label><input type=\"radio\" name=\"smoking\" ng-model=\"PolicyCtrl.policy.smokingPolicy\" ng-value=\"null\" ng-click=\"PolicyCtrl.recalcCustom(\'smoking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.omit_this_policy_label\' | i18next}}</label></div></div><legend>{{\'profile_nav.settings.hotel_profile.hotel_policy.internet_access_legend\' | i18next}}</legend><div class=\"form-group\"><label class=\"col-xs-12\">{{\'profile_nav.settings.hotel_profile.hotel_policy.about_the_internet_access_label\' | i18next}}</label><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"internet\" ng-model=\"PolicyCtrl.policy.internetPolicy\" ng-value=\"\'Free Wifi in all areas\'\" ng-click=\"PolicyCtrl.recalcCustom(\'internet\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.free_wifi_in_all_areas_label\' | i18next}}</label><br><label><input type=\"radio\" name=\"internet\" ng-model=\"PolicyCtrl.policy.internetPolicy\" ng-value=\"\'Free WiFi in most areas depending on signal\'\" ng-click=\"PolicyCtrl.recalcCustom(\'internet\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.free_wifi_in_depending_on_signal_label\' | i18next}}</label><br><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"PolicyCtrl.policy.internetPolicy == \'Internet Custom\'\"></locale-selector-next><label><input type=\"radio\" name=\"internet\" ng-model=\"PolicyCtrl.policy.internetPolicy\" ng-value=\"\'Internet Custom\'\" ng-click=\"PolicyCtrl.setCustom(\'internet\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.custom_policy_label\' | i18next}}</label><br><textarea ng-show=\"PolicyCtrl.policy.internetPolicy == \'Internet Custom\'\" class=\"form-control\" ng-model=\"PolicyCtrl.policy.internetPolicyCustom\" ng-keyup=\"PolicyCtrl.generatePolicyText()\"></textarea></div><label><input type=\"radio\" name=\"internet\" ng-model=\"PolicyCtrl.policy.internetPolicy\" ng-value=\"null\" ng-click=\"PolicyCtrl.recalcCustom(\'internet\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.omit_this_policy_label\' | i18next}}</label></div></div><legend>{{\'profile_nav.settings.hotel_profile.hotel_policy.parking_legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"parking\" ng-model=\"PolicyCtrl.policy.parkingPolicy\" ng-value=\"\'Free On-Site Parking\'\" ng-click=\"PolicyCtrl.recalcCustom(\'parking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.free_on_site_parking_label\' | i18next}}</label><br><label><input type=\"radio\" name=\"parking\" ng-model=\"PolicyCtrl.policy.parkingPolicy\" ng-value=\"\'Limited On-Site Parking Available\'\" ng-click=\"PolicyCtrl.recalcCustom(\'parking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.limited_on_site_parking_available_label\' | i18next}}</label><br><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"PolicyCtrl.policy.parkingPolicy == \'Parking Custom\'\"></locale-selector-next><label><input type=\"radio\" name=\"parking\" ng-model=\"PolicyCtrl.policy.parkingPolicy\" ng-value=\"\'Parking Custom\'\" ng-click=\"PolicyCtrl.setCustom(\'parking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.custom_policy_label\' | i18next}}</label><br><textarea ng-show=\"PolicyCtrl.policy.parkingPolicy == \'Parking Custom\'\" class=\"form-control\" ng-model=\"PolicyCtrl.policy.parkingPolicyCustom\" ng-keyup=\"PolicyCtrl.generatePolicyText()\"></textarea></div><label><input type=\"radio\" name=\"parking\" ng-model=\"PolicyCtrl.policy.parkingPolicy\" ng-value=\"null\" ng-click=\"PolicyCtrl.recalcCustom(\'parking\')\"> {{\'profile_nav.settings.hotel_profile.hotel_policy.omit_this_policy_label\' | i18next}}</label></div></div><div class=\"settings-relative-box\"><legend>{{\'profile_nav.settings.hotel_profile.hotel_policy.other_policies_legend\' | i18next}}<locale-selector-next></locale-selector-next></legend></div><div class=\"form-group\"><div class=\"col-xs-12\"><textarea class=\"form-control\" ng-model=\"PolicyCtrl.policy.otherPolicy\" ng-keyup=\"PolicyCtrl.generatePolicyText(Globalize.locale)\"></textarea></div></div><div class=\"form-group\">{{PolicyCtrl.generatePolicyText(Globalize.locale)}}</div><div class=\"form-group text-center\"><button class=\"btn btn-primary\" ng-click=\"PolicyCtrl.save()\"><i class=\"fa fa-save\" ng-hide=\"PolicyCtrl.loaded\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : PolicyCtrl.loaded}\" ng-show=\"PolicyCtrl.loaded\"></i> {{\'general.buttons.save\' | i18next}}</button></div></form></div></div>");
$templateCache.put("templates/settings/content.room_type_facilities_tpl.html","<div ng-controller=\"Settings.FacilitiesController as FacilitiesCtrl\"><legend class=\"header\">{{\'general.other.facilities\' | i18next}} <i class=\"fa fa-spinner fa-spin\" ng-hide=\"FacilitiesCtrl.loaded\"></i><locale-selector change=\"FacilitiesCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-hover general-table table-editable\"><thead><tr><th class=\"col-xs-5\">{{\'general.other.icon\' | i18next}}</th><th class=\"col-xs-5\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"Facility in FacilitiesCtrl.facilities | orderBy:\'category\'\"><td colspan=\"4\" ng-if=\"$index == FacilitiesCtrl.editedFacility\"><settings-facility-form ng-model=\"Facility\" ng-scope=\"FacilitiesCtrl\"></settings-facility-form></td><td ng-hide=\"$index == FacilitiesCtrl.editedFacility\"><i class=\"fa fa-{{Facility.icon}}\"></i> {{Facility.icon}}</td><td ng-hide=\"$index == FacilitiesCtrl.editedFacility\">{{Facility | prettyTranslate: \'title\'}}</td><td ng-hide=\"$index == FacilitiesCtrl.editedFacility\" class=\"controls text-right\"><a ng-click=\"FacilitiesCtrl.openEditForm($index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"FacilitiesCtrl.removeFacility($index)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr></tbody><tfoot><tr ng-show=\"FacilitiesCtrl.createFormVisible\"><td colspan=\"4\"><settings-facility-form ng-model=\"FacilitiesCtrl.newFacility\" ng-scope=\"FacilitiesCtrl\"></settings-facility-form></td></tr><tr><td colspan=\"4\"><a ng-click=\"FacilitiesCtrl.openCreateForm()\" class=\"control-link\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type_facilities.add_facility_link\' | i18next}}</a></td></tr></tfoot></table></div></div>");
$templateCache.put("templates/settings/edit_ibe_profile_form_tpl.html","<div class=\"table-form\"><form name=\"ibeProfileForm\" autocomplete=\"nope\" action=\"//\"><legend ng-if=\"profle.id\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.edit_booking_engine_profile_legend\' | i18next}}</legend><legend ng-if=\"!profile.id\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.create_booking_engine_profile_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"profile.title\" name=\"title\" required=\"true\" ng-change=\"onTitleChange()\" ng-disabled=\"profile.isDefault == true\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.slug\' | i18next}}</label> <input ng-model=\"profile.slug\" class=\"slug-input\" name=\"slug\" ng-change=\"onSlugChange()\" ng-required=\"profile.isDefault != true\" ng-disabled=\"profile.isDefault == true\"><div class=\"messages\"><div class=\"message\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.only_allows_latin_letters_numbers_and_symbol_div\' | i18next}}</div></div></md-input-container></div></div><div ng-if=\"profile.isDefault != true\"><md-input-container style=\"max-width: {{formWidth}}px;\"><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.available_properties_label\' | i18next}}</label><md-select ng-model=\"profile.propertyIds\" multiple=\"\" required=\"\"><md-option ng-repeat=\"property in properties\" ng-value=\"property.id\">{{property.name}}</md-option></md-select></md-input-container><md-input-container style=\"max-width: {{formWidth}}px;\"><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.available_rooms_label\' | i18next}}</label><md-select ng-model=\"profile.roomRepresentationIds\" multiple=\"\" required=\"\"><md-option ng-repeat=\"roomRepresentation in roomRepresentations\" ng-value=\"roomRepresentation.id\">{{roomRepresentation.title}} <span class=\"label label-primary\" ng-if=\"roomRepresentation.virtualRoom\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.virtual_room_span\' | i18next}}</span></md-option></md-select></md-input-container><md-input-container style=\"max-width: {{formWidth}}px;\"><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.available_rates_label\' | i18next}}</label><md-select ng-model=\"profile.rateCategoryIds\" multiple=\"\" required=\"\"><md-option ng-repeat=\"rateCategory in rateCategories\" ng-value=\"rateCategory.id\">{{rateCategory.name}} <span class=\"label label-primary\" ng-if=\"rateCategory.hasSpecialOffers\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.special_offer_rate_span\' | i18next}}</span></md-option></md-select></md-input-container><md-input-container style=\"max-width: {{formWidth}}px;\"><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.available_extras_label\' | i18next}}</label><div class=\"ibe-extra-select-loader-container\" ng-if=\"extrasValue === null\"><i class=\"fa fa-spinner\" ng-class=\"\'fa-spin\'\"></i></div><div class=\"ibe-extra-select\" ng-if=\"extrasValue !== null\"><booking-profile-select-scrollable on-scroll=\"onLoadExtras\" on-search=\"onSearchExtras\" options=\"extras\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" on-dropdown-visible-change=\"onDropdownVisibleChange\" mode=\"\'multiple\'\" caret-down-filled-suffix=\"true\" value=\"extrasValue\" on-change=\"onSelectExtraChange\" show-arrow=\"true\" auto-clear-search-value=\"false\" on-select=\"onSelectExtra\" on-deselect=\"onDeselectExtra\"></booking-profile-select-scrollable></div></md-input-container></div><div ng-if=\"profile.isDefault == true\" class=\"text-center ibe-note\" ng-i18next=\"[html]profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.note_text_div\"></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.default_language_label\' | i18next}}</label><md-select ng-model=\"profile.language\"><md-option ng-repeat=\"language in languages\" ng-value=\"language.code\">{{language.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.default_currency_label\' | i18next}}</label><md-select ng-model=\"profile.currency\"><md-option ng-repeat=\"currency in currencies\" ng-value=\"currency.code\">{{currency.name}} ({{currency.code}})</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-4\"><md-checkbox ng-model=\"profile.addressIsRequired\" aria-label=\"Address Is Required\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.address_is_required_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-4\" ng-show=\"profile.addressIsRequired === false\"><md-checkbox ng-model=\"profile.hideAddressAtDesktop\" aria-label=\"Hide at desktop\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.hide_at_desktop_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-4\" ng-show=\"profile.addressIsRequired === false\"><md-checkbox ng-model=\"profile.hideAddressAtMobile\" aria-label=\"Hide at mobile\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.hide_at_mobile_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-xs-4\"><md-checkbox ng-model=\"profile.phoneIsRequired\" aria-label=\"Phone Is Required\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.phone_is_required_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-4\" ng-show=\"profile.phoneIsRequired === false\"><md-checkbox ng-model=\"profile.hidePhoneAtDesktop\" aria-label=\"Hide at desktop\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.hide_at_desktop_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-4\" ng-show=\"profile.phoneIsRequired === false\"><md-checkbox ng-model=\"profile.hidePhoneAtMobile\" aria-label=\"Hide at mobile\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.hide_at_mobile_checkbox\' | i18next}}</md-checkbox></div></div><md-checkbox ng-model=\"profile.creditCardIsRequired\" aria-label=\"Credit Card Is Required\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.credit_card_is_required_checkbox\' | i18next}}</md-checkbox><br><md-checkbox ng-model=\"profile.allowStripeThreeDFail\" aria-label=\"Allow Bookings With Failed 3D Secure Check\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.allow_bookings_with_failed_3d_secure_check_checkbox\' | i18next}}</md-checkbox><br><div class=\"row\"><div class=\"col-xs-6\"><md-checkbox ng-model=\"profile.namePerRoomIsRequired\" aria-label=\"Guest Name Per Booked Room\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.guest_name_per_booked_room_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-6\"><md-checkbox ng-model=\"profile.allowZeroPrice\" aria-label=\"Allow Zero Price\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.allow_zero_price_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-checkbox ng-model=\"profile.askForGuestNationality\" aria-label=\"Ask for guest nationality\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.ask_for_guest_nationality_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-6\"><md-checkbox ng-model=\"profile.orderByPriority\" aria-label=\"Order By Room Type Priority\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.order_by_room_type_priority_checkbox\' | i18next}}</md-checkbox></div></div><div ng-show=\"hotelHasMultipleProperties\"><md-checkbox ng-model=\"profile.choosePropertyStep\" aria-label=\"{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.choose_property_step\' | i18next}}\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.choose_property_step\' | i18next}}</md-checkbox><br></div><div><md-checkbox ng-model=\"profile.personsInsteadAdults\" aria-label=\"{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.persons_instead_adults\' | i18next}}\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.persons_instead_adults\' | i18next}}</md-checkbox><br></div><div><md-checkbox ng-model=\"profile.advancedOptions.hideAvailability\" aria-label=\"{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.hide_availability\' | i18next}}\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.hide_availability\' | i18next}}</md-checkbox><br></div><div><md-checkbox ng-model=\"profile.advancedOptions.setAvailableActive\">Set available dates</md-checkbox></div><div class=\"available-dates\"><div class=\"backdrop\" ng-show=\"!profile.advancedOptions.setAvailableActive\"></div><span>From</span><md-datepicker ng-model=\"profile.availableFrom\" md-placeholder=\"Choose date\"></md-datepicker><span>To</span><md-datepicker ng-model=\"profile.availableTo\" md-placeholder=\"Choose date\"></md-datepicker></div><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.predefined_promocode_label\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.promocode\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.predefined_reference_label\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.reference\" md-maxlength=\"255\"></md-input-container><div><md-checkbox ng-model=\"profile.passwordProtectionIsEnabled\" aria-label=\"{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.protect_by_password\' | i18next}}\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.protect_by_password\' | i18next}}</md-checkbox></div><md-input-container ng-if=\"profile.passwordProtectionIsEnabled\"><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.booking_password_label\' | i18next}}</label> <input type=\"password\" ng-model=\"profile.bookingPassword\" md-maxlength=\"255\" autocomplete=\"new-password\"></md-input-container><legend style=\"margin-bottom: 10px;\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.booking_questions_legend\' | i18next}}<md-button class=\"md-raised md-success pull-right legend-button\" ng-click=\"addQuestion()\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.add_button\' | i18next}}</md-button></legend><div ng-repeat=\"question in profile.questions\" class=\"booking-question\"><div><strong>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.question\' | i18next}} #{{$index + 1}}</strong> <i class=\"fa fa-trash pull-right\" ng-click=\"removeQuestion($index)\"></i></div><md-input-container><locale-selector-next></locale-selector-next><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.question\' | i18next}}</label> <input type=\"text\" ng-model=\"question.question\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.type\' | i18next}}</label><md-select ng-model=\"question.type\"><md-option ng-repeat=\"type in types\" value=\"{{type.value}}\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.\' + type.label | i18next}}</md-option></md-select></md-input-container><md-input-container ng-show=\"question.type == \'select\'\"><locale-selector-next></locale-selector-next><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.options_comma_separated_label\' | i18next}}</label> <input type=\"text\" ng-model=\"question.options\"></md-input-container><md-checkbox ng-model=\"question.isRequired\" aria-label=\"Is Required\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.is_required_checkbox\' | i18next}}</md-checkbox></div><legend style=\"margin-bottom: 10px;\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.advanced\' | i18next}}</legend><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.google_adwords\' | i18next}}</label> <textarea ng-model=\"profile.advancedOptions.googleAdwordsRawCode\"></textarea></md-input-container><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.google_analytics\' | i18next}}</label> <textarea ng-model=\"profile.advancedOptions.googleAnalyticsRawCode\"></textarea></md-input-container><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.advanced_notification_email\' | i18next}}</label> <textarea ng-model=\"profile.advancedOptions.notificationCC\"></textarea></md-input-container><legend style=\"margin-bottom: 10px;\">{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_title\' | i18next}}</legend><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_background_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.bodyBackgroundColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.bodyBackgroundColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_header_background_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.navigationBackgroundColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.navigationBackgroundColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_header_menu_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.navigationAdditionalControlColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.navigationAdditionalControlColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_content_panel_background_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.contentPanelBackgroundColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.contentPanelBackgroundColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_main_primary_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.mainPrimaryColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.mainPrimaryColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_main_success_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.mainSuccessColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.mainSuccessColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_main_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.mainTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.mainTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_info_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.infoTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.infoTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_primary_button_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.mainPrimaryButtonTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.mainPrimaryButtonTextColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.customize_success_button_text_color\' | i18next}}</label> <input type=\"text\" ng-model=\"profile.advancedOptions.mainSuccessButtonTextColor\" maxlength=\"7\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"profile.advancedOptions.mainSuccessButtonTextColor\"></md-input-container></div></div><div class=\"form-buttons\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"cancelAction()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveAction()\" ng-disabled=\"ibeProfileForm.$invalid || profile.loading\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : profile.loading}\" ng-if=\"profile.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/settings/finance.accounting_categories_tpl.html","<div ng-controller=\"Settings.AccountingCategoriesController as vm\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header full-width-block-header_with-buttons\"><div class=\"row\"><div class=\"col-xs-4\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.title\' | i18next}}</div></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"vm.loading\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"!vm.loading\"><table ng-if=\"vm.haveItems || vm.createFormVisible\" class=\"table table-hover general-table table-editable\"><thead><tr ng-if=\"vm.haveItems\"><th class=\"col-xs-5\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.name_th\' | i18next}}</th><th class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.internal_code_th\' | i18next}}</th><th class=\"col-xs-3\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.external_code_th\' | i18next}}</th><th class=\"col-xs-1 controls\"></th></tr></thead><tbody><tr ng-if=\"vm.haveItems\" ng-repeat=\"item in vm.items\"><td ng-if=\"vm.editItemId === item.id\" colspan=\"4\" class=\"table-form-row\"><accounting-category-form request-in-progress=\"vm.requestInProgress\" accounting-category=\"vm.itemForEdit\" save-callback=\"vm.updateItem\" cancel-callback=\"vm.closeForm\"></accounting-category-form></td><td ng-if=\"vm.editItemId !== item.id\">{{item.name}}</td><td ng-if=\"vm.editItemId !== item.id\">{{item.internalCode}}</td><td ng-if=\"vm.editItemId !== item.id\">{{item.externalCode}}</td><td ng-if=\"vm.editItemId !== item.id\" class=\"controls\"><a ng-click=\"vm.editItem(item)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"vm.removeItem(item)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr ng-if=\"!vm.haveItems && !vm.createFormVisible\"><td class=\"text-center\" colspan=\"4\">{{\'general.tables.empty_result\' | i18next}}</td></tr><tr ng-if=\"vm.createFormVisible\"><td colspan=\"4\" class=\"table-form-row\"><accounting-category-form request-in-progress=\"vm.requestInProgress\" accounting-category=\"vm.newItem\" save-callback=\"vm.createItem\" cancel-callback=\"vm.closeForm\"></accounting-category-form></td></tr></tbody></table><div ng-if=\"!vm.haveItems && !vm.createFormVisible\"><div class=\"text-center full-width-padded-top full-width-padded-bottom\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.you_do_not_have_any_accounting_categories\' | i18next}}<br><a ng-click=\"vm.addItem()\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.add_new_accounting_category_button\' | i18next}}</a></div></div></div></div><div ng-if=\"vm.haveItems && vm.isListMode\" class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-click=\"vm.addItem()\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.add_new_accounting_category_button\' | i18next}}</md-button></div></div></div><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header full-width-block-header_with-buttons\"><div class=\"row\"><div class=\"col-xs-4\">{{\'profile_nav.settings.booking_engine.accounting_categories_settings.default_for_hotel\'| i18next}}</div></div></div><div class=\"settings-padded-content accounting-defaults\"><div class=\"backdrop\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : vm.loading}\"></i></div><div class=\"row\"><div class=\"col-xs-12\"><md-input-container class=\"accounting-default-selector\"><label>Default for accommodation</label><md-select ng-model=\"vm.hotel.accountingDefaultForAccommodationId\"><md-option ng-repeat=\"ac in vm.items | orderBy:\'name\'\" value=\"{{ac.id}}\">{{ac.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12\"><md-input-container class=\"accounting-default-selector\"><label>Default for extras</label><md-select ng-model=\"vm.hotel.accountingDefaultForExtraId\"><md-option ng-repeat=\"ac in vm.items | orderBy:\'name\'\" value=\"{{ac.id}}\">{{ac.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12\"><md-input-container class=\"accounting-default-selector\"><label>Default for taxes</label><md-select ng-model=\"vm.hotel.accountingDefaultForTaxId\"><md-option ng-repeat=\"ac in vm.items | orderBy:\'name\'\" value=\"{{ac.id}}\">{{ac.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12\"><md-input-container class=\"accounting-default-selector\"><label>Default for payments</label><md-select ng-model=\"vm.hotel.accountingDefaultForPaymentId\"><md-option ng-repeat=\"ac in vm.items | orderBy:\'name\'\" value=\"{{ac.id}}\">{{ac.name}}</md-option></md-select></md-input-container></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-click=\"vm.saveHotel()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : vm.loading}\" ng-if=\"vm.loading\"></i> {{\'profile_nav.settings.booking_engine.accounting_categories_settings.save\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/finance.bookkeeping_systems_tpl.html","<div ng-controller=\"Settings.BookkeepingSystems as ctrl\"><legend class=\"header\">{{\'profile_nav.settings.other.bookkeepings.bookkeepings_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ctrl.loaded == false}\" ng-hide=\"ctrl.loaded\"></i></legend><div class=\"settings-body-block\" ng-if=\"ctrl.loaded === true\"><div class=\"text-center\" ng-if=\"ctrl.bookkeepings.length === 0\">{{\'profile_nav.settings.other.bookkeepings.not_any_bookkeepings_div\' | i18next}}</div><table class=\"table table-hover general-table table-editable\" ng-if=\"ctrl.bookkeepings.length > 0\"><thead><tr><th class=\"col-xs-9\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"bookkeeping in ctrl.bookkeepings\"><td ng-hide=\"$index == ctrl.editedBookkeeping\">{{bookkeeping.readableName}}</td><td ng-hide=\"$index == ctrl.editedBookkeeping\" class=\"controls text-right\"><i class=\"fa fa-spinner\" ng-show=\"bookkeeping.loading\" ng-class=\"{\'fa-spin\' : type.loading}\"></i> <a ng-click=\"ctrl.openEditForm($index)\" ng-hide=\"bookkeeping.loading || bookkeeping.name == \'wubook\'\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"ctrl.downloadPaymentTypes($index)\" ng-hide=\"bookkeeping.loading || bookkeeping.name != \'dk\'\"><i tooltip=\"{{\'general.tooltip.get_payment_types\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-money\"></i></a> <a ng-click=\"ctrl.removeBookkeeping($index)\" ng-hide=\"bookkeeping.loading || bookkeeping.name == \'wubook\'\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td colspan=\"3\" ng-show=\"$index == ctrl.editedBookkeeping\"><div class=\"row\"><div class=\"col-xs-11\"><form class=\"form-horizontal\" name=\"bookkeepingForm\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'general.other.name\' | i18next}}:</label><div class=\"col-xs-9\">{{bookkeeping.readableName}}</div></div><div class=\"form-group\"></div><div ng-if=\"bookkeeping.name == \'dk\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.bearer_token\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"bookkeeping.details.token\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.printed\' | i18next}}:</label><div class=\"col-xs-9\"><md-checkbox ng-model=\"bookkeeping.confirmed\" aria-label=\"{{\'profile_nav.settings.other.bookkeepings.printed\' | i18next}}\">{{\'profile_nav.settings.other.bookkeeping_systems.printed\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.is_identical_customer\' | i18next}}:</label><div class=\"col-xs-9\"><md-checkbox ng-model=\"bookkeeping.isIdenticalCustomer\" aria-label=\"{{\'profile_nav.settings.other.bookkeepings.is_identical_customer\' | i18next}}\">{{\'profile_nav.settings.other.bookkeeping_systems.is_identical_customer\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.check_existing_customer\' | i18next}}:</label><div class=\"col-xs-9\"><md-checkbox ng-model=\"bookkeeping.checkExistingCustomer\" aria-label=\"{{\'profile_nav.settings.other.bookkeepings.check_existing_customer\' | i18next}}\">{{\'profile_nav.settings.other.bookkeeping_systems.check_existing_customer\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.identical_customer_number\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"bookkeeping.identicalCustomerNumber\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.foreign_identical_customer_number\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"bookkeeping.foreignIdenticalCustomerNumber\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.department\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"bookkeeping.department\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.bookkeeping_systems.fixed_receipt_text\' | i18next}}:</label><div class=\"col-xs-9\"><textarea class=\"form-control\" ng-model=\"bookkeeping.fixedReceiptText\">\n                               </textarea></div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-checkbox ng-model=\"bookkeeping.isActive\" aria-label=\"{{\'profile_nav.settings.other.bookkeepings.is_active\' | i18next}}\">{{\'profile_nav.settings.other.folio.is_active_checkbox\' | i18next}}</md-checkbox></div></div></div></form></div><div class=\"col-xs-1 text-right controls controls--in-table\"><a ng-click=\"ctrl.saveEditing()\"><i tooltip=\"{{\'general.tooltip.save\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-check\"></i></a> <a ng-click=\"ctrl.cancelEditing()\"><i tooltip=\"{{\'general.tooltip.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></div></div></td></tr></tbody></table><md-menu><md-button class=\"md-raised md-success\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\" ng-disabled=\"ctrl.formOpen\">{{\'profile_nav.settings.other.bookkeepings.add_bookkeeping_button\' | i18next}}</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"ctrl.addBookkeeping(\'xero\')\">Xero</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.addBookkeeping(\'dk\')\">DK</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("templates/settings/finance.currency_profiles_tpl.html","<div ng-controller=\"Settings.CurrencyProfilesController as CurrencyProfilesCtrl\" class=\"currency-profiles\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.currencies.currencies_legend\' | i18next}}<br><small>{{\'profile_nav.settings.hotel_profile.currencies.small\' | i18next}}</small></legend><div class=\"settings-body-block\"><table class=\"table table-faq table-striped\"><thead><tr><th>{{\'profile_nav.settings.hotel_profile.currencies.currency\' | i18next}}</th><th>{{\'profile_nav.settings.hotel_profile.currencies.is_default_th\' | i18next}}</th><th>{{\'general.other.rate\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"currencyProfile in CurrencyProfilesCtrl.currencyProfiles.list\"><td colspan=\"4\" ng-if=\"CurrencyProfilesCtrl.editedCurrencyProfile == currencyProfile.id\"><div class=\"table-form\"><form name=\"createCurrencyProfileForm\"><legend>{{\'profile_nav.settings.hotel_profile.currencies.edit_currency_profile_legend\' | i18next}}</legend><md-input-container><label>{{\'profile_nav.settings.hotel_profile.currencies.currency\' | i18next}}</label><md-select ng-model=\"currencyProfile.code\" ng-change=\"currencyIsChanged(currencyProfile)\" ng-disabled=\"currencyProfile.id\"><md-option ng-repeat=\"currency in CurrencyProfilesCtrl.currencies\" ng-value=\"currency[0]\">{{currency[0]}} - {{currency[1]}} ({{currency[2]}})</md-option></md-select></md-input-container><md-checkbox ng-model=\"currencyProfile.isExchangeRate\" aria-label=\"{\'profile_nav.settings.hotel_profile.currencies.use_exchange_rate_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.currencies.use_exchange_rate_checkbox\' | i18next}}<div class=\"hint\">{{\'profile_nav.settings.hotel_profile.currencies.automatically_convert_hint_checkbox\' | i18next}}</div></md-checkbox><md-input-container class=\"md-block\"><label>{{\'profile_nav.settings.hotel_profile.currencies.exchange_rate_to_base_currency_label\' | i18next}}</label> <input required=\"\" type=\"number\" step=\"0.01\" name=\"exchangeRate\" ng-min=\"0\" ng-disabled=\"currencyProfile.isExchangeRate\" ng-model=\"currencyProfile.exchangeRate\"> <small>1 {{CurrencyProfilesCtrl.baseCurrency}} {{\'profile_nav.settings.hotel_profile.currencies.is_small\' | i18next}} {{1 * currencyProfile.exchangeRate | number:2}} {{currencyProfile.code}}</small></md-input-container><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"CurrencyProfilesCtrl.closeEditForm(currencyProfile)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"createCurrencyProfileForm.$invalid || CurrencyProfilesCtrl.currencyProfile.saving\" ng-click=\"CurrencyProfilesCtrl.saveCurrencyProfile(currencyProfile)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"currencyProfile.saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></div></td><td ng-if=\"CurrencyProfilesCtrl.editedCurrencyProfile != currencyProfile.id\">{{currencyProfile.code}}</td><td ng-if=\"CurrencyProfilesCtrl.editedCurrencyProfile != currencyProfile.id\"><i class=\"fa fa-check-circle\" ng-show=\"currencyProfile.isDefault\" tooltip=\"{{\'profile_nav.settings.hotel_profile.currencies.this_currency_profile_used_as_default_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-if=\"CurrencyProfilesCtrl.editedCurrencyProfile != currencyProfile.id\">{{currencyProfile.visibleExchangeRate}}</td><td ng-if=\"CurrencyProfilesCtrl.editedCurrencyProfile != currencyProfile.id\" class=\"controls\"><a ng-click=\"CurrencyProfilesCtrl.openEditForm(currencyProfile)\" ng-if=\"!currencyProfile.isDefault\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a ng-click=\"CurrencyProfilesCtrl.removeCurrencyProfile(currencyProfile)\" ng-if=\"!currencyProfile.isDefault\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"currencyProfile.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"currencyProfile.loading\"></i></a></td></tr><tr ng-if=\"CurrencyProfilesCtrl.createFormIsVisible\"><td colspan=\"4\"><div class=\"table-form\"><form name=\"createCurrencyProfileForm\"><legend>{{\'profile_nav.settings.hotel_profile.currencies.create_currency_profile_legend\' | i18next}}</legend><md-input-container><label>{{\'profile_nav.settings.hotel_profile.currencies.currency\' | i18next}}</label><md-select ng-model=\"CurrencyProfilesCtrl.currencyProfile.code\" ng-change=\"CurrencyProfilesCtrl.currencyIsChanged(CurrencyProfilesCtrl.currencyProfile)\"><md-option ng-repeat=\"currency in CurrencyProfilesCtrl.currencies\" ng-value=\"currency[0]\">{{currency[0]}} - {{currency[1]}} ({{currency[2]}})</md-option></md-select></md-input-container><md-checkbox ng-model=\"CurrencyProfilesCtrl.currencyProfile.isExchangeRate\" aria-label=\"{{\'profile_nav.settings.hotel_profile.currencies.use_exchange_rate_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.currencies.use_exchange_rate_checkbox\' | i18next}}<div class=\"hint\">{{\'profile_nav.settings.hotel_profile.currencies.automatically_convert_hint_checkbox\' | i18next}}</div></md-checkbox><md-input-container class=\"md-block\"><label>{{\'profile_nav.settings.hotel_profile.currencies.exchange_rate_to_base_currency_label\' | i18next}}</label> <input required=\"\" type=\"number\" step=\"0.01\" name=\"exchangeRate\" ng-min=\"0\" ng-disabled=\"CurrencyProfilesCtrl.currencyProfile.isExchangeRate\" ng-model=\"CurrencyProfilesCtrl.currencyProfile.exchangeRate\"> <small>1 {{CurrencyProfilesCtrl.baseCurrency}} {{\'profile_nav.settings.hotel_profile.currencies.is_small\' | i18next}} {{1 * CurrencyProfilesCtrl.currencyProfile.exchangeRate | number:2}} {{CurrencyProfilesCtrl.currencyProfile.code}}</small></md-input-container><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"CurrencyProfilesCtrl.closeCreateForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"createCurrencyProfileForm.$invalid || CurrencyProfilesCtrl.currencyProfile.saving\" ng-click=\"CurrencyProfilesCtrl.createCurrencyProfile()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"CurrencyProfilesCtrl.currencyProfile.saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></div></td></tr></tbody></table></div><div class=\"text-left toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"CurrencyProfilesCtrl.openCreateForm()\">{{\'profile_nav.settings.hotel_profile.currencies.add_currency_profile\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/finance.invoice_number_settings_tpl.html","<div ng-controller=\"Settings.InvoiceNumberSettingsController as INSCtrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.general_legend\' | i18next}}</div><div class=\"full-width-padded\" ng-if=\"INSCtrl.initialized\"><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.hotel.extraRoomNumberOnFolioVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.invoice_room_number_label\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.invoice_room_number_label\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.hotel.nightsBreakdownOnFolioVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.invoice_nights_breakdown_label\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.invoice_nights_breakdown_label\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.hotel.vat\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.are_you_vat_registered_label\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.are_you_vat_registered_label\' | i18next}}</md-checkbox></div></div><div ng-if=\"INSCtrl.hotel.vat\"><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.hotel_details.vat_number_label\' | i18next}}</label> <input type=\"text\" required=\"\" ng-model=\"INSCtrl.hotel.vatNumber\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.hotel.showTaxInfo\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_tax_info\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_tax_info\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.hotel_details.vat_tax_name\' | i18next}}</label> <input type=\"text\" required=\"\" ng-model=\"INSCtrl.hotel.vatTaxName\"></md-input-container></div></div></div></div><div class=\"full-width-block-subheader\">{{\'profile_nav.settings.hotel_profile.hotel_details.company_info_subheader\' | i18next}} <small>{{\'profile_nav.settings.hotel_profile.hotel_details.company_info_subheader_description\' | i18next}}</small></div><div class=\"full-width-padded\" ng-if=\"INSCtrl.initialized\"><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.hotel_details.comapny_name_of_your_hotel_label\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.hotel.companyName\"></md-input-container></div><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"INSCtrl.hotel.companyAddress.country\"><md-option ng-value=\"country.name\" ng-repeat=\"country in INSCtrl.countries\">{{country.name}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.hotel_details.county_or_state_or_province_label\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.hotel.companyAddress.state\"></md-input-container></div><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.hotel_details.city_or_town_or_village_label\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.hotel.companyAddress.city\"></md-input-container></div><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.hotel.companyAddress.address\"></md-input-container></div><div class=\"col-xs-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.hotel_details.postcode_label\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.hotel.companyAddress.zipCode\"></md-input-container></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-success\" ng-if=\"INSCtrl.initialized\" ng-click=\"INSCtrl.saveHotel()\" ng-disabled=\"INSCtrl.loadingHotel\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : INSCtrl.loadingHotel}\" ng-if=\"INSCtrl.loadingHotel\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.logo_and_notes_legend\' | i18next}}<locale-selector class=\"locale-selector-top\" change=\"INSCtrl.changeLang\"></locale-selector></div><div class=\"full-width-padded\" ng-if=\"INSCtrl.initialized\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"settings_invoice__image_upload image_upload image_upload_with_size\" ng-style=\"{\'background-image\' : \'url(\' + INSCtrl.fileread + \')\'}\" ng-class=\"{\'settings_invoice__image_upload__uploaded\' : INSCtrl.fileread, \'image_upload__uploaded\' : INSCtrl.fileread}\"><i class=\"fa fa-image\"></i> <span ng-if=\"!INSCtrl.fileread\">{{\'profile_nav.settings.other.invoice.add_logo_span\' | i18next}}</span> <span ng-if=\"INSCtrl.fileread\">{{\'profile_nav.settings.other.invoice.change_logo_span\' | i18next}}</span> <input type=\"file\" name=\"image\" ng-model=\"INSCtrl.invoiceSettings.photo\" onchange=\"angular.element(this).scope().INSCtrl.choosePhotoFile(this)\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.use_text_instead_logo\" aria-label=\"{{\'profile_nav.settings.other.invoice.use_text_instead_logo_checkbox\' | i18next}}\">{{\'profile_nav.settings.other.invoice.use_text_instead_logo_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\" ng-if=\"INSCtrl.use_text_instead_logo\"><div class=\"col-md-12\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'general.other.text\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.invoiceSettings.text\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-input-container><locale-selector-next></locale-selector-next><label>{{\'profile_nav.settings.other.invoice.default_notes_label\' | i18next}}</label> <textarea ng-model=\"INSCtrl.invoiceSettings.default_notes\" md-maxlength=\"255\"></textarea></md-input-container></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-success\" ng-if=\"INSCtrl.initialized\" ng-click=\"INSCtrl.saveLogo()\" ng-disabled=\"INSCtrl.loadingHotel\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : INSCtrl.loadingHotel}\" ng-if=\"INSCtrl.loadingHotel\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.rounding_options_legend\' | i18next}} <small>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.rounding_options_small\' | i18next}}</small></div><div class=\"full-width-padded\" ng-if=\"INSCtrl.initialized\"><form name=\"hotel-details-form\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.hotel_details.round_method\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" name=\"roundMethod\" ng-model=\"INSCtrl.hotel.roundMethod\"><option value=\"none\">None</option><option value=\"nearest\">Round to nearest</option><option value=\"up\">Round Up</option><option value=\"down\">Round Down</option></select></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.hotel_details.round_to\' | i18next}}:</label><div class=\"col-xs-9\"><select class=\"form-control\" name=\"roundTo\" ng-model=\"INSCtrl.hotel.roundTo\"><option ng-value=\"0\" ng-selected=\"INSCtrl.hotel.roundTo == 0\">0 {{\'profile_nav.settings.hotel_profile.hotel_details.points_after_dot\' | i18next}}</option><option ng-value=\"1\" ng-selected=\"INSCtrl.hotel.roundTo == 1\">1 {{\'profile_nav.settings.hotel_profile.hotel_details.points_after_dot\' | i18next}}</option><option ng-value=\"2\" ng-selected=\"INSCtrl.hotel.roundTo == 2\">2 {{\'profile_nav.settings.hotel_profile.hotel_details.points_after_dot\' | i18next}}</option></select></div></div></form></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-success\" ng-if=\"INSCtrl.initialized\" ng-click=\"INSCtrl.saveHotel()\" ng-disabled=\"INSCtrl.loadingHotel\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : INSCtrl.loadingHotel}\" ng-if=\"INSCtrl.loadingHotel\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.legend\' | i18next}}</div><div class=\"full-width-padded text-center\" ng-if=\"INSCtrl.initialized == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"full-width-padded\" ng-if=\"INSCtrl.initialized\"><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.invoiceNumberSettings.isEnabled\" aria-label=\"{{\'profile_nav.settings.hotel_profile.invoice_number_settings.is_enabled\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.is_enabled\' | i18next}}</md-checkbox></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"INSCtrl.invoiceNumberSettings.isEnabled !== true\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.default_text\' | i18next}}</div><div class=\"row\" ng-if=\"INSCtrl.invoiceNumberSettings.isEnabled === true\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.start_value\' | i18next}}</label> <input type=\"number\" required=\"\" ng-model=\"INSCtrl.invoiceNumberSettings.startValue\"></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.last_value\' | i18next}}</label> <input type=\"number\" required=\"\" min=\"{{INSCtrl.invoiceNumberSettings.startValue}}\" max=\"{{INSCtrl.invoiceNumberSettings.maxValue}}\" ng-model=\"INSCtrl.invoiceNumberSettings.lastValue\" ng-change=\"INSCtrl.updateNextInvoiceNumber()\"> <small>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.last_value_description\' | i18next}}</small></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.max_value\' | i18next}}</label> <input type=\"number\" required=\"\" ng-model=\"INSCtrl.invoiceNumberSettings.maxValue\"> <small>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.max_value\' | i18next}}</small></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.length\' | i18next}}</label> <input type=\"number\" min=\"1\" required=\"\" ng-model=\"INSCtrl.invoiceNumberSettings.length\" ng-change=\"INSCtrl.updateNextInvoiceNumber()\"></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.increment_step\' | i18next}}</label> <input type=\"number\" required=\"\" ng-model=\"INSCtrl.invoiceNumberSettings.incrementStep\" min=\"1\" ng-change=\"INSCtrl.updateNextInvoiceNumber()\"></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.prefix\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.invoiceNumberSettings.prefix\" ng-change=\"INSCtrl.updateNextInvoiceNumber()\"></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.postfix\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.invoiceNumberSettings.postfix\" ng-change=\"INSCtrl.updateNextInvoiceNumber()\"> <small>{{\'profile_nav.settings.hotel_profile.invoice_number_settings.available_templates\' | i18next}}:<br><strong>%YYYY%</strong> - {{\'general.other.year\' | i18next}}, 2018<br><strong>%YY%</strong> - {{\'general.other.year\' | i18next}}, 18<br><strong>%MM%</strong> - {{\'general.other.month\' | i18next}}, 02</small></md-input-container></div><div class=\"col-md-12 full-width-padded-top full-width-padded-bottom\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.next_invoice_number_example\' | i18next}}<br><strong>{{INSCtrl.nextInvoiceNumber}}</strong></div><div class=\"col-md-12\"><md-checkbox ng-model=\"INSCtrl.invoiceNumberSettings.resetDateIsEnabled\" aria-label=\"{{\'profile_nav.settings.hotel_profile.invoice_number_settings.reset_date_is_enabled\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.reset_date_is_enabled\' | i18next}}</md-checkbox></div><div class=\"col-md-12 form-block date-col\"><label class=\"datepicker\">{{\'profile_nav.settings.hotel_profile.invoice_number_settings.reset_date\' | i18next}}</label><md-datepicker ng-disabled=\"!INSCtrl.invoiceNumberSettings.resetDateIsEnabled\" ng-model=\"INSCtrl.invoiceNumberSettings.formResetDate\"></md-datepicker></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-success\" ng-if=\"INSCtrl.initialized\" ng-click=\"INSCtrl.save()\" ng-disabled=\"INSCtrl.loading\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : INSCtrl.loading}\" ng-if=\"INSCtrl.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.statement_settings.legend\' | i18next}}</div><div class=\"full-width-padded text-center\" ng-if=\"INSCtrl.initialized == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"full-width-padded\" ng-if=\"INSCtrl.initialized\"><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.statement_settings.reminder\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.statementSettings.reminder\"></md-input-container></div><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.statement_settings.terms\' | i18next}}</label> <input type=\"text\" ng-model=\"INSCtrl.statementSettings.terms\"></md-input-container></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-success\" ng-if=\"INSCtrl.initialized\" ng-click=\"INSCtrl.saveStatementSetting()\" ng-disabled=\"INSCtrl.loadingHotel\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : INSCtrl.loadingHotel}\" ng-if=\"INSCtrl.loadingHotel\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/finance.payment_gateway_tpl.html","<div ng-controller=\"Settings.PaymentGateways as ctrl\"><legend class=\"header\">{{\'profile_nav.settings.other.payment_gateways.payment_gateways_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ctrl.loaded == false}\" ng-hide=\"ctrl.loaded\"></i></legend><div class=\"settings-body-block\" ng-if=\"ctrl.show_stripe_connect\"><p><a ng-click=\"ctrl.goToStripeSca()\" class=\"stripe-connect\"><span>Connect with Stripe SCA</span></a></p></div><div class=\"settings-body-block\" ng-if=\"ctrl.show_stripe_connected\">Your <a href=\"https://dashboard.stripe.com/\" target=\"_blank\">Stripe</a> account is connected!</div><div ng-if=\"user.role === \'admin\'\"><a href=\"#\" ng-click=\"ctrl.switchToListView()\">Switch to list view</a></div><div class=\"settings-body-block\" ng-if=\"!ctrl.show_stripe_connect && !ctrl.show_stripe_connected && ctrl.loaded === true\"><div class=\"text-center\" ng-if=\"ctrl.gateways.length === 0\">{{\'profile_nav.settings.other.payment_gateways.not_any_payment_providers_div\' | i18next}}</div><table class=\"table table-hover general-table table-editable\" ng-if=\"ctrl.gateways.length > 0\"><thead><tr><th class=\"col-xs-9\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-2\">{{\'profile_nav.settings.other.payment_gateways.is_default\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"gateway in ctrl.gateways\" ng-if=\"!gateway.isRemoved\"><td ng-hide=\"$index == ctrl.editedGateway\">{{gateway.readableName}}</td><td ng-hide=\"$index == ctrl.editedGateway\"><i class=\"fa fa-check-circle\" ng-show=\"gateway.isDefault\" tooltip=\"{{\'profile_nav.settings.other.payment_gateways.gateway_used_as_default_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"$index == ctrl.editedGateway\" class=\"controls text-right\"><i class=\"fa fa-spinner\" ng-show=\"gateway.loading\" ng-class=\"{\'fa-spin\' : type.loading}\"></i> <a ng-click=\"ctrl.openEditForm($index)\" ng-hide=\"gateway.loading\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"ctrl.removeGateway($index)\" ng-hide=\"gateway.loading || gateway.name == \'wubook\'\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td colspan=\"3\" ng-show=\"$index == ctrl.editedGateway\"><div class=\"row\"><div class=\"col-xs-11\"><form class=\"form-horizontal\" name=\"paymentGatewayForm\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'general.other.name\' | i18next}}:</label><div class=\"col-xs-9\">{{gateway.readableName}}</div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-checkbox ng-model=\"gateway.isDefault\" aria-label=\"{{\'profile_nav.settings.other.payment_gateways.is_default\' | i18next}}\">{{\'profile_nav.settings.other.payment_gateways.is_default\' | i18next}}</md-checkbox></div></div><div ng-if=\"gateway.name == \'stripe\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.public_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.publicKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.private_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.privateKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-checkbox ng-model=\"gateway.details.passAddressInfo\" aria-label=\"{{\'profile_nav.settings.other.payment_gateways.pass_address_info_label\' | i18next}}\">{{\'profile_nav.settings.other.payment_gateways.pass_address_info_label\' | i18next}}</md-checkbox></div></div></div><div ng-if=\"gateway.name == \'borgun\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.public_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.publicKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.private_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.privateKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.development\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.development_mode_checkbox\' | i18next}}</label></div></div></div><div ng-if=\"gateway.name == \'stripe_sca\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.public_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.publicKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.private_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.privateKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-offset-3 col-xs-9\"><md-checkbox ng-model=\"gateway.details.passAddressInfo\" aria-label=\"{{\'profile_nav.settings.other.payment_gateways.pass_address_info_label\' | i18next}}\">{{\'profile_nav.settings.other.payment_gateways.pass_address_info_label\' | i18next}}</md-checkbox></div></div></div><div ng-if=\"gateway.name == \'omise\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.public_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.publicKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.secret_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.secretKey\" ng-required=\"true\"></div></div></div><div ng-if=\"gateway.name == \'braintree\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.merchant_id\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.merchantId\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.public_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.publicKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.private_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.privateKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.threeDSecureEnabled\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.use_3d_secure\' | i18next}}</label></div></div></div><div ng-if=\"gateway.name == \'worldpay\'\"><div class=\"worldpay-warning form-group\"><label class=\"col-xs-3\">{{\'general.labels.note\' | i18next}}:</label><div class=\"col-xs-9\">{{\'profile_nav.settings.other.payment_gateways.enable_authorisations_div\' | i18next}} <a target=\"_blank\" href=\"https://online.worldpay.com/settings/orders\">{{\'profile_nav.settings.other.payment_gateways.settings_link\' | i18next}}</a> {{\'profile_nav.settings.other.payment_gateways.disable_card_security_code_div\' | i18next}} <a href=\"https://online.worldpay.com/settings/risk\" target=\"_blank\">{{\'profile_nav.settings.other.payment_gateways.risk_settings_link\' | i18next}}</a>.</div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.merchant_id\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.merchantId\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.secret_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.serviceKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.client_key_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.clientKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.threeDSecureEnabled\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.use_3d_secure\' | i18next}}</label></div></div></div><div ng-if=\"gateway.name == \'payment_express\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.post_username_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.postUsername\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.post_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.postPassword\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.pxpay_username_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.pxPayUsername\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.pxpay_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.pxPayPassword\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">Reference template:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.referenceTemplate\" data-role=\"gatewayReference{{$index}}\" ng-required=\"true\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button payment-reference\"><md-button aria-label=\"{{\'common_for_app.confirm.open_menu_aria_label\' | i18next}}\" class=\"md-button\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\">Drop In`s</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in ctrl.dropins\"><md-button ng-click=\"ctrl.insertDropIn(\'gatewayReference\'+$parent.$index, dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.showReference\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.ask_for_reference\' | i18next}}</label></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.usePxPay\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.use_pxpay_to_capture_payments_and_cards_checkbox\' | i18next}}</label></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.development\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.development_mode_checkbox\' | i18next}}</label></div></div><div class=\"form-group\" ng-if=\"gateway.details.development == true\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.hit_username_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.hitUsername\" ng-required=\"true\"></div></div><div class=\"form-group\" ng-if=\"gateway.details.development == true\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.hit_password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.hitPassword\" ng-required=\"true\"></div></div><div class=\"form-group\" ng-if=\"gateway.details.development == true\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.device_serial_number_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.serialNumber\" ng-required=\"true\"></div></div><div class=\"form-group\" ng-if=\"gateway.details.development == true\"><label class=\"col-xs-3\">Device Serial Number:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.serialNumber\" ng-required=\"true\"></div></div></div><div ng-if=\"gateway.name == \'wirecard\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.merchant_id_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.merchantReference\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.application_id_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.applicationId\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.ibeAllowFailed\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.ibe_allow_failed\' | i18next}}</label></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.development\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.development_mode_checkbox\' | i18next}}</label></div></div></div><div ng-if=\"gateway.name == \'valitor_pay\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.api_key\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.apiKey\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.terminal_id\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.terminalId\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.agreement_number\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.agreementNumber\"></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.development\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.development_mode_checkbox\' | i18next}}</label></div></div></div><div ng-if=\"gateway.name == \'valitor\'\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.username_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.username\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.password_label\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.password\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.contact_number\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.contactNumber\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.contact_ss_number\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.contactSsNumber\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.other.payment_gateways.posil_id\' | i18next}}:</label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"gateway.details.posilId\" ng-required=\"true\"></div></div><div class=\"form-group\"><div class=\"col-xs-3\"></div><div class=\"checkbox col-xs-9\"><label><input ng-model=\"gateway.details.development\" type=\"checkbox\"> {{\'profile_nav.settings.other.payment_gateways.development_mode_checkbox\' | i18next}}</label></div></div></div></form></div><div class=\"col-xs-1 text-right controls controls--in-table\"><a ng-click=\"ctrl.saveEditing()\" ng-style=\"gateway.name == \'valitor_pay\' && !gateway.details.apiKey && {\'pointer-events\': \'none\'}\"><i tooltip=\"{{\'general.tooltip.save\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-check\"></i></a> <a ng-click=\"ctrl.cancelEditing()\"><i tooltip=\"{{\'general.tooltip.cancel\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></div></div></td></tr></tbody></table><md-menu><md-button class=\"md-raised md-success\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\">{{\'profile_nav.settings.other.payment_gateways.add_gateway_button\' | i18next}}</md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"!ctrl.africaCluster && ctrl.defaultGatewayName == \'wubook\'\"><md-button ng-click=\"ctrl.addProvider(\'wubook\')\">ChannexPCI</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster && ctrl.defaultGatewayName == \'braintree\'\"><md-button ng-click=\"ctrl.addProvider(\'braintree\')\">Braintree</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster\"><md-button ng-click=\"ctrl.goToStripeSca()\">Stripe SCA Connect</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster && ctrl.defaultGatewayName == \'worldpay\'\"><md-button ng-click=\"ctrl.addProvider(\'worldpay\')\">Worldpay</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster && ctrl.defaultGatewayName == \'omise\'\"><md-button ng-click=\"ctrl.addProvider(\'omise\')\">Omise</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster && ctrl.defaultGatewayName == \'payment_express\'\"><md-button ng-click=\"ctrl.addProvider(\'payment_express\')\">WindCave</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster && ctrl.defaultGatewayName == \'valitor\"><md-button ng-click=\"ctrl.addProvider(\'valitor\')\">Valitor</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster\"><md-button ng-click=\"ctrl.addProvider(\'valitor_pay\')\">ValitorPay</md-button></md-menu-item><md-menu-item ng-if=\"!ctrl.africaCluster\"><md-button ng-click=\"ctrl.addProvider(\'borgun\')\">Borgun</md-button></md-menu-item><md-menu-item ng-if=\"ctrl.defaultGatewayName == \'wirecard\'\"><md-button ng-click=\"ctrl.addProvider(\'wirecard\')\">{{ctrl.wirecardName}}</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("templates/settings/finance.payment_terminal_tpl.html","<div ng-controller=\"Settings.PaymentTerminals as ctrl\"><legend class=\"header\">{{\'profile_nav.settings.other.payment_gateways.payment_terminals_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ctrl.loaded == false}\" ng-hide=\"ctrl.loaded\"></i></legend><div class=\"settings-body-block\"><react-payment-terminals terminals=\"ctrl.terminals\" currency-profiles=\"ctrl.currencyProfiles\" on-save=\"ctrl.onSave\" on-delete=\"ctrl.onDelete\" on-pair=\"ctrl.onPair\"></react-payment-terminals></div></div>");
$templateCache.put("templates/settings/finance.payment_types_tpl.html","<div ng-controller=\"Settings.PaymentTypesController as PaymentTypesCtrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.payment_types.payment_types_legend\' | i18next}}</div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"PaymentTypesCtrl.initialized == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"PaymentTypesCtrl.initialized\"><table class=\"table table-hover general-table table-editable\" ng-if=\"PaymentTypesCtrl.paymentTypes.length !== 0 || PaymentTypesCtrl.addFormIsVisible == true\"><thead><tr><th class=\"col-xs-4\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-7\">{{\'general.other.description\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"paymentType in PaymentTypesCtrl.paymentTypes | orderBy:name\"><td ng-if=\"paymentType.edited === true\" colspan=\"3\" class=\"table-form-row\"><payment-type-form payment-type=\"paymentType\" save=\"PaymentTypesCtrl.save\" cancel=\"PaymentTypesCtrl.cancel\"></payment-type-form></td><td ng-if=\"paymentType.edited !== true\">{{paymentType | prettyTranslate: \'name\'}} <small ng-if=\"paymentType.isSystem && !paymentType.isActive\">({{\'common_for_app.disabled\' | i18next}})</small></td><td ng-if=\"paymentType.edited !== true\">{{paymentType | prettyTranslate: \'description\'}}</td><td class=\"controls text-right\" ng-if=\"paymentType.edited !== true\"><i class=\"fa fa-spinner\" ng-show=\"paymentType.loading\" ng-class=\"{\'fa-spin\' : paymentType.loading}\"></i> <a ng-hide=\"paymentType.loading\" ng-click=\"PaymentTypesCtrl.edit(paymentType)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-if=\"!paymentType.isSystem\" ng-hide=\"paymentType.loading\" ng-click=\"PaymentTypesCtrl.remove(paymentType)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr ng-if=\"PaymentTypesCtrl.addFormIsVisible === true\"><td colspan=\"3\" class=\"table-form-row\"><payment-type-form payment-type=\"PaymentTypesCtrl.newPaymentType\" save=\"PaymentTypesCtrl.create\" cancel=\"PaymentTypesCtrl.cancelAdd\"></payment-type-form></td></tr></tbody></table><div class=\"text-center full-width-padded-top full-width-padded-bottom\" ng-if=\"PaymentTypesCtrl.paymentTypes.length === 0 && PaymentTypesCtrl.addFormIsVisible == false\">{{\'profile_nav.settings.hotel_profile.payment_types.no_payment_types\' | i18next}}<br><a ng-click=\"PaymentTypesCtrl.add()\">{{\'profile_nav.settings.hotel_profile.payment_types.create_first\' | i18next}}</a></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-if=\"PaymentTypesCtrl.initialized\" ng-click=\"PaymentTypesCtrl.add()\">{{\'profile_nav.settings.hotel_profile.payemnt_types.add_new_payment_type\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/finance.pos_profiles_errors_tpl.html","<div ng-controller=\"Settings.PosProfilesErrorsController as PosProfilesCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.pos.pos_profiles_legend\' | i18next}}<br><small></small></legend><div class=\"settings-body-block\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"PosProfilesCtrl.loading\"></i><div ng-if=\"!PosProfilesCtrl.loading\"><p ng-if=\"PosProfilesCtrl.errors.used\">{{\'profile_nav.settings.hotel_profile.pos.already_used\' | i18next}}</p><p ng-if=\"!PosProfilesCtrl.errors.used\">{{\'profile_nav.settings.hotel_profile.pos.error\' | i18next}}</p></div></div><div class=\"spinned text-left toolbar marged-bottom\"><md-button><a href=\"#/settings/finance/pos-profiles\">{{\'profile_nav.settings.hotel_profile.pos.back_to_profiles\' | i18next}}</a></md-button></div></div>");
$templateCache.put("templates/settings/finance.pos_profiles_tpl.html","<div ng-controller=\"Settings.PosProfilesController as PosProfilesCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.pos.pos_profiles_legend\' | i18next}} <i class=\"fa fa-spinner fa-spin\" ng-show=\"PosProfilesCtrl.loading\"></i><br><small>{{\'profile_nav.settings.hotel_profile.pos.pos_profiles_small\' | i18next}}</small></legend><div class=\"settings-body-block\"><div class=\"full-width-block\"><strong class=\"subblock-header\">{{\'profile_nav.settings.hotel_profile.pos.pos_profiles_list_header\' | i18next}}</strong><table class=\"table table-hover general-table table-editable table-room-rate\"><thead><tr><th class=\"col-xs-6\">{{\'profile_nav.settings.hotel_profile.pos.pos_type_th\' | i18next}}</th><th class=\"col-xs-5\">{{\'profile_nav.settings.hotel_profile.pos.enabled_th\' | i18next}}</th><th class=\"col-xs-1 controls\"></th></tr></thead><tbody><tr ng-repeat=\"profile in hotel.posProfiles track by $index\" class=\"pos-profile\"><td ng-if=\"PosProfilesCtrl.editedPosProfile==$index\" colspan=\"3\" class=\"table-form-row\"><pos-profile-form ng-model=\"profile\" ng-scope=\"PosProfilesCtrl\" available-pos-types=\"PosProfilesCtrl.posTypes\"></pos-profile-form></td><td ng-if=\"PosProfilesCtrl.editedPosProfile!=$index\">{{PosProfilesCtrl.alterPosTypeName(profile.posType)}}</td><td ng-if=\"PosProfilesCtrl.editedPosProfile!=$index\"><i class=\"fa fa-check-circle\" ng-show=\"profile.enabled\"></i></td><td ng-hide=\"PosProfilesCtrl.editedPosProfile==$index\" class=\"controls\"><i class=\"fa fa-spinner\" ng-show=\"profile.loading\" ng-class=\"{\'fa-spin\' : profile.loading}\"></i> <a ng-hide=\"profile.loading\" ng-click=\"PosProfilesCtrl.openEditForm(profile)\"><i tooltip=\"Edit\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-hide=\"profile.loading\" ng-click=\"PosProfilesCtrl.removeProfile(profile)\"><i tooltip=\"Remove\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr class=\"table-form\" ng-if=\"PosProfilesCtrl.createFormVisible\"><td colspan=\"3\" class=\"edited-row table-form-row\"><pos-profile-form ng-model=\"PosProfilesCtrl.newPosProfile\" ng-scope=\"PosProfilesCtrl\" available-pos-types=\"availablePosTypes\"></pos-profile-form></td></tr></tbody></table></div></div><div class=\"spinned text-left toolbar marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"PosProfilesCtrl.openCreateForm()\" ng-disabled=\"!availablePosTypes.length\">{{\'profile_nav.settings.hotel_profile.pos.add_new_pos_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/finance.taxes_tpl.html","<div ng-controller=\"Settings.NewTaxesController as TaxesCtrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.taxe_new.taxes_and_fees_legend\' | i18next}}<locale-selector change=\"TaxesCtrl.changeLang\"></locale-selector></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"TaxesCtrl.initialized == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"TaxesCtrl.initialized\"><div class=\"text-center\" ng-show=\"!TaxesCtrl.grouppedTaxes || TaxesCtrl.grouppedTaxes.length == 0\" ng-i18next=\"[html]profile_nav.settings.hotel_profile.taxe_new.taxes_set_up_currently_text\"></div><table class=\"table table-faq table-striped table-taxes\" ng-show=\"TaxesCtrl.grouppedTaxes && TaxesCtrl.grouppedTaxes.length > 0\"><thead><tr><th>{{\'general.other.name\' | i18next}}</th><th>{{\'general.other.type\' | i18next}}</th><th>{{\'profile_nav.settings.hotel_profile.taxe_new.value_th\' | i18next}}</th><th>{{\'profile_nav.settings.hotel_profile.taxe_new.applicable_th\' | i18next}}</th><th></th></tr></thead><tbody dnd-list=\"TaxesCtrl.grouppedTaxes\"><tr ng-repeat=\"taxGroup in TaxesCtrl.grouppedTaxes\" dnd-draggable=\"taxGroup\" dnd-moved=\"TaxesCtrl.DropDownCallback(taxGroup)\" dnd-effect-allowed=\"move\" ng-class=\"{\'removed_tax\': taxGroup.isRemoved}\"><td ng-if=\"taxGroup.activeTax.edited === true\" colspan=\"5\" class=\"form-column\"><div class=\"table-form\"><form name=\"taxEditFrom\"><legend>{{\'profile_nav.settings.hotel_profile.taxe_new.edit_tax_legend\' | i18next}}</legend><md-input-container><label>{{\'general.other.title\' | i18next}}</label><locale-selector-next></locale-selector-next><input required=\"\" ng-model=\"taxGroup.activeTax.name\" md-maxlength=\"255\"></md-input-container><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.type\' | i18next}}</label><md-select ng-model=\"taxGroup.activeTax.mode\" ng-disabled=\"taxGroup.activeTax.id\"><md-option ng-repeat=\"mode in TaxesCtrl.modes\" value=\"{{mode.value}}\">{{\'general.other.type_tax.\' + mode.display | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.taxe_new.inclusive_or_exclusive_label\' | i18next}}</label><md-select ng-model=\"taxGroup.activeTax.calculationMethod\" ng-disabled=\"taxGroup.activeTax.id\"><md-option ng-repeat=\"mode in TaxesCtrl.calculationMethods\" value=\"{{mode.value}}\">{{\'general.other.tax_method.\' + mode.display | i18next}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.taxe_new.charge_mode_label\' | i18next}}</label><md-select ng-model=\"taxGroup.activeTax.calculationLogic\" ng-disabled=\"taxGroup.activeTax.id\" ng-change=\"TaxesCtrl.changeCanculationLogic(taxGroup.activeTax)\"><md-option ng-repeat=\"logic in TaxesCtrl.getFilteredCalculationLogics(taxGroup.activeTax)\" value=\"{{logic.value}}\">{{\'general.other.\' + logic.display | i18next}}</md-option></md-select></md-input-container></div><div class=\"col-xs-6\" ng-if=\"taxGroup.activeTax.calculationLogic != \'per_person_per_night\' && taxGroup.activeTax.calculationLogic != \'per_person_per_booking\'\"><md-input-container class=\"md-block\"><label>{{\'general.other.amount\' | i18next}}</label> <input required=\"\" type=\"number\" step=\"0.01\" name=\"amount\" ng-disabled=\"taxGroup.activeTax.id\" ng-model=\"taxGroup.activeTax.amount\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"taxGroup.activeTax.calculationLogic == \'per_person_per_night\' || taxGroup.activeTax.calculationLogic == \'per_person_per_booking\'\"><md-input-container class=\"md-block\"><label>{{\'general.other.adult_amount\' | i18next}}</label> <input required=\"\" type=\"number\" step=\"0.01\" name=\"amount\" ng-disabled=\"taxGroup.activeTax.id\" ng-model=\"taxGroup.activeTax.amount\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"taxGroup.activeTax.calculationLogic == \'per_person_per_night\' || taxGroup.activeTax.calculationLogic == \'per_person_per_booking\'\"><md-input-container class=\"md-block\"><label>{{\'general.other.child_amount\' | i18next}}</label> <input type=\"number\" step=\"0.01\" name=\"child_amount\" ng-disabled=\"taxGroup.activeTax.id\" ng-model=\"taxGroup.activeTax.childAmount\"></md-input-container></div></div><div class=\"row\" ng-show=\"taxGroup.activeTax.mode != \'fee\'\"><div class=\"col-xs-6\"><md-input-container class=\"md-block\"><label>{{\'profile_nav.settings.hotel_profile.taxe_new.max_nights_label\' | i18next}}</label> <input type=\"number\" name=\"max_nights\" ng-model=\"taxGroup.activeTax.maxNights\"> <i class=\"fa fa-question-circle helper-circle\" tooltip=\"{{\'profile_nav.settings.hotel_profile.taxe_new.certain_amount_of_nights_in_the_booking_tooltip\' | i18next}}\"></i></md-input-container></div><div class=\"col-xs-6\"><md-input-container class=\"md-block\"><label>{{\'profile_nav.settings.hotel_profile.taxe_new.skip_nights_label\' | i18next}}</label> <input type=\"number\" name=\"skip_nights\" ng-model=\"taxGroup.activeTax.skipNights\"> <i class=\"fa fa-question-circle helper-circle\" tooltip=\"{{\'profile_nav.settings.hotel_profile.taxe_new.certain_amount_of_nights_has_passed_tooltip\' | i18next}}\"></i></md-input-container></div></div><div class=\"row\" ng-if=\"isAccountingCategoriesFeatureEnabled\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.accounting_category\' | i18next}}</label><md-select ng-model=\"taxGroup.activeTax.accountingCategoryId\"><md-option ng-repeat=\"accountingCategory in TaxesCtrl.accountingCategories\" value=\"{{accountingCategory.id}}\">{{accountingCategory.name}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6\"><md-checkbox ng-model=\"taxGroup.activeTax.applicableToReservation\" aria-label=\"{{\'profile_nav.settings.hotel_profile.taxe_new.applicable_to_reservation_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.taxe_new.applicable_to_reservation_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-6\"><md-checkbox ng-model=\"taxGroup.activeTax.applicableToExtra\" aria-label=\"{{\'profile_nav.settings.hotel_profile.taxe_new.applicable_to_extra_checkbox\' | i18next}}\" ng-disabled=\"taxGroup.activeTax.calculationLogic != \'fixed\' && taxGroup.activeTax.calculationLogic != \'percent\'\">{{\'profile_nav.settings.hotel_profile.taxe_new.applicable_to_extra_checkbox\' | i18next}}</md-checkbox></div></div><md-checkbox ng-show=\"taxGroup.activeTax.mode == \'tax\'\" ng-model=\"taxGroup.activeTax.isTopOfAnyFee\" aria-label=\"Calculate Top Of Any Fee\">{{\'profile_nav.settings.hotel_profile.taxe_new.calculate_on_top_of_any_fee_checkbox\' | i18next}} <i class=\"fa fa-question-circle helper-circle helper-circle__inline\" tooltip=\"{{\'profile_nav.settings.hotel_profile.taxe_new.on_top_of_any_fee_tooltip\' | i18next}}\"></i></md-checkbox><md-radio-group ng-model=\"taxGroup.activeTax.showAsExtra\" ng-show=\"taxGroup.activeTax.mode == \'fee\'\"><div class=\"row\"><div class=\"col-xs-6\"><md-radio-button ng-value=\"true\" class=\"md-primary\">{{\'profile_nav.settings.hotel_profile.taxe_new.show_as_extra\' | i18next}}</md-radio-button></div><div class=\"col-xs-6\"><md-radio-button ng-value=\"false\" class=\"md-primary\">{{\'profile_nav.settings.hotel_profile.taxe_new.show_as_tax\' | i18next}}</md-radio-button></div></div></md-radio-group><md-radio-group ng-model=\"taxGroup.activeTax.applyMode\" ng-show=\"!taxGroup.activeTax.id\"><div class=\"row\"><div class=\"col-xs-6\"><md-radio-button value=\"for all\" class=\"md-primary\">{{\'profile_nav.settings.hotel_profile.taxe_new.apply_for_past_and_future_bookings_radio_button\' | i18next}}</md-radio-button></div><div class=\"col-xs-6\"><md-radio-button value=\"for future\" class=\"md-primary\">{{\'profile_nav.settings.hotel_profile.taxe_new.apply_only_for_future_bookings_radio_button\' | i18next}}</md-radio-button></div></div></md-radio-group><div class=\"row\" ng-show=\"taxGroup.activeTax.applyMode == \'for future\'\"><div class=\"col-xs-offset-6 col-xs-6\"><div class=\"form-block date-col\"><label class=\"datepicker\">{{\'profile_nav.settings.hotel_profile.taxe_new.apply_after_label\' | i18next}}</label><md-datepicker ng-model=\"taxGroup.activeTax.applicableAfterDate\"></md-datepicker></div></div></div><div ng-if=\"taxGroup.activeTax.id\"><div class=\"row\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"taxGroup.activeTax.updateTax\" aria-label=\"Update Tax Values\">Update Tax Amount</md-checkbox></div></div><div class=\"row\" ng-if=\"taxGroup.activeTax.updateTax\"><div class=\"col-xs-6\" ng-if=\"taxGroup.activeTax.calculationLogic != \'per_person_per_night\' && taxGroup.activeTax.calculationLogic != \'per_person_per_booking\'\"><md-input-container class=\"md-block\"><label>{{\'general.other.amount\' | i18next}}</label> <input required=\"\" type=\"number\" step=\"0.01\" name=\"amount\" ng-model=\"taxGroup.activeTax.newAmount\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"taxGroup.activeTax.calculationLogic == \'per_person_per_night\' || taxGroup.activeTax.calculationLogic == \'per_person_per_booking\'\"><md-input-container class=\"md-block\"><label>{{\'general.other.adult_amount\' | i18next}}</label> <input required=\"\" type=\"number\" step=\"0.01\" name=\"amount\" ng-model=\"taxGroup.activeTax.newAmount\"></md-input-container></div><div class=\"col-xs-3\" ng-if=\"taxGroup.activeTax.calculationLogic == \'per_person_per_night\' || taxGroup.activeTax.calculationLogic == \'per_person_per_booking\'\"><md-input-container class=\"md-block\"><label>{{\'general.other.child_amount\' | i18next}}</label> <input type=\"number\" step=\"0.01\" name=\"child_amount\" ng-model=\"taxGroup.activeTax.newChildAmount\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container class=\"md-block\"><label>{{\'profile_nav.settings.hotel_profile.taxe_new.apply_after_label\' | i18next}}</label> <input type=\"date\" name=\"newTaxFromDate\" ng-model=\"taxGroup.activeTax.newTaxFromDate\"></md-input-container></div></div></div><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"TaxesCtrl.cancelEdit(taxGroup.activeTax)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-disabled=\"taxEditFrom.$invalid || taxGroup.activeTax.saving\" ng-click=\"TaxesCtrl.save(taxGroup.activeTax)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"taxGroup.activeTax.saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></form></div></td><td ng-show=\"taxGroup.activeTax.edited !== true\"><i class=\"fa fa-bars\"></i> {{taxGroup | prettyTranslate: \'name\'}}</td><td ng-show=\"taxGroup.activeTax.edited !== true\">{{\'general.other.\' + taxGroup.mode | i18next}}</td><td ng-show=\"taxGroup.activeTax.edited !== true\"><div ng-repeat=\"option in taxGroup.options\" ng-class=\"{\'removed_tax\': option.isRemoved}\">{{option.visibleAmountText}}</div></td><td ng-show=\"taxGroup.activeTax.edited !== true\"><div ng-repeat=\"option in taxGroup.options\" ng-class=\"{\'removed_tax\': option.isRemoved}\">{{ option.applicableTextPrefix }} {{option.applicableText}}</div></td><td ng-show=\"taxGroup.activeTax.edited !== true\" class=\"controls\"><a ng-click=\"TaxesCtrl.edit(taxGroup.activeTax)\" ng-if=\"taxGroup.activeTax && (user.role == \'admin\' || user.aclRole == \'manager\' || user.isOwner == true || user.corporateRole == \'owner\' || user.corporateRole == \'manager\')\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a ng-click=\"TaxesCtrl.remove(taxGroup.activeTax)\" ng-if=\"taxGroup.activeTax\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"taxGroup.activeTax.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"taxGroup.activeTax.loading\"></i></a></td></tr></tbody></table></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-menu ng-if=\"user.role == \'admin\' || user.aclRole == \'manager\' || user.isOwner == true || user.corporateRole == \'owner\' || user.corporateRole == \'manager\'\"><md-button class=\"md-raised md-success\" ng-click=\"TaxesCtrl.openMenu($mdOpenMenu, $event)\">{{\'profile_nav.settings.hotel_profile.taxe_new.add_tax_or_fee\' | i18next}}</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"TaxesCtrl.addTax(\'tax\')\">{{\'general.other.tax\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"TaxesCtrl.addTax(\'city_tax\')\">{{\'general.other.city_tax\' | i18next}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"TaxesCtrl.addTax(\'fee\')\">{{\'general.other.fee\' | i18next}}</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><ui-remove-modal id=\"remove-confirmation\" class=\"buuqit-modal-wrapper\"></ui-remove-modal></div>");
$templateCache.put("templates/settings/guest.guest_details_tpl.html","<div ng-controller=\"Settings.GuestDetailsController as ctrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\"><div class=\"row\"><div class=\"col-xs-6\">{{ \"profile_nav.settings.other.guest_settings.legend\" | i18next }}</div></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"ctrl.loaded == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{ \"general.other.loading\" | i18next }}</div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"ctrl.loaded == true && ctrl.questions.length == 0\">{{ \"profile_nav.settings.other.guest_settings.empty_message\" | i18next }}</div><div class=\"settings-padded-content\" ng-if=\"ctrl.loaded\"><form name=\"guestQuestionsForm\"><div ng-repeat=\"question in ctrl.questions\" class=\"guest-details-question\"><div class=\"guest-details-question__header\"><strong>{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.question\" | i18next }} #{{ $index + 1 }}</strong> <i class=\"fa fa-trash pull-right\" ng-click=\"ctrl.removeQuestion($index)\"></i></div><md-input-container ng-class=\"{\'md-input-invalid\' : ctrl.validate && !question.field}\"><label>{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.field\" | i18next }}</label> <input type=\"text\" ng-model=\"question.field\" md-maxlength=\"255\" ng-required=\"true\" ng-class=\"{\'ng-touched\' : ctrl.validate}\"></md-input-container><md-input-container ng-class=\"{\'md-input-invalid\' : ctrl.validate && !question.question}\"><label>{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.question\" | i18next }}</label> <input type=\"text\" ng-model=\"question.question\" md-maxlength=\"255\" ng-required=\"true\" ng-class=\"{\'ng-touched\' : ctrl.validate}\"></md-input-container><md-input-container><label>{{ \"general.other.type\" | i18next }}</label><md-select ng-model=\"question.type\"><md-option ng-repeat=\"type in ctrl.types\" value=\"{{type.value}}\">{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.\" + type.label | i18next }}</md-option></md-select></md-input-container><md-input-container ng-if=\"question.type == \'select\'\" ng-class=\"{\'md-input-invalid\' : ctrl.validate && !question.options}\"><locale-selector-next></locale-selector-next><label>{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.options_comma_separated_label\" | i18next }}</label> <input type=\"text\" ng-model=\"question.options\" ng-required=\"true\" ng-class=\"{\'ng-touched\' : ctrl.validate}\"></md-input-container><md-checkbox ng-model=\"question.isRequired\" aria-label=\"Is Required\">{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.is_required_checkbox\" | i18next }}</md-checkbox><md-checkbox ng-model=\"question.showAtReport\">{{ \"profile_nav.settings.other.guest_settings.show_at_report\" | i18next }}</md-checkbox></div></form></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-6 text-left\"><md-button class=\"md-raised md-success legend-button\" ng-click=\"ctrl.addQuestion()\">{{ \"profile_nav.settings.booking_engine.booking_engine_settings.ibe_form.add_button\" | i18next }}</md-button></div><div class=\"col-xs-6 text-right\"><md-button class=\"md-raised md-success legend-button\" ng-click=\"ctrl.save()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"ctrl.loading\"></i> {{ \"general.buttons.save\" | i18next }}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/guest.identification_types_tpl.html","<div ng-controller=\"Settings.IdentificationTypesController as IDTypesCtrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\">{{\'profile_nav.settings.hotel_profile.id_types.id_types_legend\' | i18next}}<locale-selector change=\"IDTypesCtrl.changeLang\"></locale-selector></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"IDTypesCtrl.initialized == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"IDTypesCtrl.initialized\"><table class=\"table table-hover general-table table-editable\" ng-if=\"IDTypesCtrl.idTypes.length !== 0 || IDTypesCtrl.addFormIsVisible == true\"><thead><tr><th class=\"col-xs-11\">{{\'general.other.title\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"idType in IDTypesCtrl.idTypes | orderBy:title\"><td ng-if=\"idType.edited === true\" colspan=\"2\" class=\"table-form-row\"><identification-type-form identification-type=\"idType\" save=\"IDTypesCtrl.save\" cancel=\"IDTypesCtrl.cancel\"></identification-type-form></td><td ng-if=\"idType.edited !== true\">{{idType | prettyTranslate: \'title\'}}</td><td class=\"controls text-right\" ng-if=\"idType.edited !== true\"><i class=\"fa fa-spinner\" ng-show=\"idType.loading\" ng-class=\"{\'fa-spin\' : idType.loading}\"></i> <a ng-hide=\"idType.loading\" ng-click=\"IDTypesCtrl.edit(idType)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-hide=\"idType.loading\" ng-click=\"IDTypesCtrl.remove(idType)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr><tr ng-if=\"IDTypesCtrl.addFormIsVisible === true\"><td colspan=\"2\" class=\"table-form-row\"><identification-type-form identification-type=\"IDTypesCtrl.newIdType\" save=\"IDTypesCtrl.create\" cancel=\"IDTypesCtrl.cancelAdd\"></identification-type-form></td></tr></tbody></table><div class=\"text-center full-width-padded-top full-width-padded-bottom\" ng-if=\"IDTypesCtrl.idTypes.length === 0 && IDTypesCtrl.addFormIsVisible == false\">You not have any Identification Types.<br><a ng-click=\"IDTypesCtrl.add()\">Create First?</a></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-if=\"IDTypesCtrl.initialized\" ng-click=\"IDTypesCtrl.add()\">{{\'profile_nav.settings.hotel_profile.id_types.add_new_ID_type\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/guest.registration_form_tpl.html","<div ng-controller=\"Settings.RegistrationFormController as RegFormCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.guest_registration_form_settings.guest_registration_form_settings_legend\' | i18next}}<locale-selector change=\"RegFormCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><form name=\"hotel-details-form\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.guest_registration_form_settings.custom_question_1_title_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-9\"><textarea class=\"form-control\" ng-model=\"RegFormCtrl.hotel.customQuestionFirst\"></textarea></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.guest_registration_form_settings.custom_question_2_title_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-9\"><textarea class=\"form-control\" ng-model=\"RegFormCtrl.hotel.customQuestionSecond\"></textarea></div></div><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.hotel_profile.guest_registration_form_settings.your_terms_and_conditions_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-9\"><summernote ng-model=\"RegFormCtrl.hotel.guestFormPolicy\" on-paste=\"wysiwygPaste(evt)\" data-role=\"formText\"></summernote></div></div><div class=\"form-group text-center\"><button class=\"btn btn-primary\" ng-click=\"RegFormCtrl.save()\"><i class=\"fa fa-save\" ng-hide=\"RegFormCtrl.loaded\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : RegFormCtrl.loaded}\" ng-show=\"RegFormCtrl.loaded\"></i> {{\'general.buttons.save\' | i18next}}</button></div></form></div></div>");
$templateCache.put("templates/settings/identification_type_form_tpl.html","<div class=\"table-form\"><form name=\"identificationTypeForm\"><legend ng-if=\"identificationType.id\">{{\'profile_nav.settings.hotel_profile.id_types.form.edit_id_type_legend\' | i18next}}</legend><legend ng-if=\"!identificationType.id\">{{\'profile_nav.settings.hotel_profile.id_types.form.create_id_type_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"identificationType.title\" required=\"\"><locale-selector-next></locale-selector-next></md-input-container></div></div><div class=\"form-buttons\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"cancelAction()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveAction()\" ng-disabled=\"identificationTypeForm.$invalid || identificationType.loading\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : identificationType.loading}\" ng-if=\"identificationType.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/settings/inventory.cancellation_policy_tpl.html","<div class=\"cancellation-policy-page\" ng-controller=\"Settings.CancellationPolicyController as CancellationPolicyCtrl\"><legend class=\"header\">{{\'general.other.cancellation_policy\' | i18next}}<locale-selector change=\"CancellationPolicyCtrl.changeLang\"></locale-selector><button class=\"btn btn-success hidden pull-right\" ng-click=\"CancellationPolicyCtrl.addPolicy()\">{{\'profile_nav.settings.inventory.cancellation_policy.add_policy_button\' | i18next}}</button></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-hover general-table table-editable policy-table\"><thead><tr><th>{{\'profile_nav.settings.inventory.cancellation_policy.policy_name_th\' | i18next}}</th><th>{{\'profile_nav.settings.inventory.cancellation_policy.default_th\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"policy in CancellationPolicyCtrl.policies\" ng-if=\"!policy.isRemoved\"><td ng-if=\"policy.edited != true\">{{policy.title}}</td><td ng-if=\"policy.edited != true\"><i ng-if=\"policy.isDefault == true\" class=\"fa fa-circle\" style=\"color: #4AD647\"></i> <i ng-if=\"policy.isDefault != true\" class=\"fa fa-circle\" style=\"color: #999999\"></i></td><td ng-if=\"policy.edited != true\" class=\"controls text-right\"><a ng-click=\"CancellationPolicyCtrl.openEditForm(policy, $index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"CancellationPolicyCtrl.removePolicy(policy)\" ng-disabled=\"policy.removing\" ng-hide=\"policy.removing || policy.isDefault\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a> <i tooltip=\"{{\'general.tooltip.removing\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\':policy.removing}\" ng-show=\"policy.removing\"></i></td><td ng-if=\"policy.edited == true\" colspan=\"3\"><form name=\"hotel-details-form\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.inventory.cancellation_policy.policy_title\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"policy.title\"></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"deposit\" ng-model=\"policy.deposit\" ng-value=\"\'No deposit is required\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.no_deposit_is_required_label\' | i18next}}</label> <label><input type=\"radio\" name=\"deposit\" ng-model=\"policy.deposit\" ng-value=\"\'A deposit equal to the total cost is required at the time of booking\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.deposit_equal_to_total_cost_label\' | i18next}}</label> <label><input type=\"radio\" name=\"deposit\" ng-model=\"policy.deposit\" ng-value=\"\'night deposit is required at the time of booking\'\"> <input type=\"text\" ng-model=\"policy.depositNights\" ng-disabled=\"policy.deposit != \'night deposit is required at the time of booking\'\" class=\"form-control input-in-select\"> {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.night_deposit_is_required_label\' | i18next}}</label> <label><input type=\"radio\" name=\"deposit\" ng-model=\"policy.deposit\" ng-value=\"\'% deposit is required at the time of booking\'\"> <input type=\"text\" ng-model=\"policy.depositPercent\" ng-disabled=\"policy.deposit != \'% deposit is required at the time of booking\'\" class=\"form-control input-in-select\"> % {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.deposit_is_required_label\' | i18next}}</label> <label><input type=\"radio\" name=\"depositHandle\" ng-model=\"policy.deposit\" ng-value=\"\'is required per booking\'\"> <input type=\"text\" ng-model=\"policy.depositPerBooking\" ng-disabled=\"policy.deposit != \'is required per booking\'\" class=\"form-control input-in-select\"> {{hotel.currency}} {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.is_required_per_booking_label\' | i18next}}</label> <label><input type=\"radio\" name=\"depositHandle\" ng-model=\"policy.deposit\" ng-value=\"\'is required per room booked\'\"> <input type=\"text\" ng-model=\"policy.depositPerRoom\" ng-disabled=\"policy.deposit != \'is required per room booked\'\" class=\"form-control input-in-select\"> {{hotel.currency}} {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.is_required_per_room_booked_label\' | i18next}}</label></div></div><legend ng-hide=\"policy.deposit==\'No deposit is required\'\">{{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.legend\' | i18next}}</legend><div class=\"form-group\" ng-hide=\"policy.deposit==\'No deposit is required\'\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"refund\" ng-model=\"policy.refund\" ng-value=\"\'All deposits are non-refundable\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.all_deposits_are_non_refundable_label\' | i18next}}</label> <label><input type=\"radio\" name=\"refund\" ng-model=\"policy.refund\" ng-value=\"\'Deposits are refundable up to days prior to arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.deposits_are_refundable_up_to_label\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-model=\"policy.refundDays\" ng-disabled=\"policy.refund != \'Deposits are refundable up to days prior to arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.days_prior_to_arrival_label\' | i18next}}</label><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"policy.refund == \'Refund Custom Policy\'\"></locale-selector-next><label><input type=\"radio\" name=\"refund\" ng-model=\"policy.refund\" ng-value=\"\'Refund Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-show=\"policy.refund == \'Refund Custom Policy\'\" ng-model=\"policy.refundCustom\"></textarea></label></div></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.details.legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"checkbox\" name=\"detailsRemainingEnabled\" ng-model=\"policy.detailsRemainingEnabled\" ng-value=\"\'Remaining balance to be paid on\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.details.remaining_balance_to_be_paid_on_label\' | i18next}}<select class=\"form-control\" style=\"width: 150px; display: inline-block;\" name=\"detailsRemaining\" ng-disabled=\"policy.detailsRemainingEnabled == false\" ng-model=\"policy.detailsRemaining\"><option value=\"Arrival\">{{\'general.other.arrival\' | i18next}}</option><option value=\"Departure\">{{\'profile_nav.settings.inventory.cancellation_policy.details.departure_option\' | i18next}}</option></select></label> <label><input type=\"checkbox\" name=\"detailsPreauthorize\" ng-model=\"policy.detailsPreauthorize\" ng-value=\"\'We have the right to pre-authorise your card prior to arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.details.to_pre_authorise_card_label\' | i18next}}</label><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"policy.detailsCustomEnabled == true\"></locale-selector-next><label><input type=\"checkbox\" name=\"detailsCustomEnabled\" ng-model=\"policy.detailsCustomEnabled\" ng-value=\"\'Details Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-show=\"policy.detailsCustomEnabled == true\" ng-model=\"policy.detailsCustom\"></textarea></label></div></div></div><legend>{{\'general.other.cancellation_policy\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"cancellation\" ng-model=\"policy.cancellation\" ng-value=\"\'Free cancellation at any time\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.free_cancellation_label\' | i18next}}</label> <label><input type=\"radio\" name=\"cancellation\" ng-model=\"policy.cancellation\" ng-value=\"\'No cancellation or modification can be applied to this booking\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.no_cancellation_or_modification_label\' | i18next}}</label> <label><input type=\"radio\" name=\"cancellation\" ng-model=\"policy.cancellation\" ng-value=\"\'Free cancellation up N day(s) before arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.free_cancellation_up_label\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-model=\"policy.cancellationDays\" ng-disabled=\"policy.cancellation != \'Free cancellation up N day(s) before arrival\'\"><select class=\"form-control\" style=\"width: 150px; display: inline-block;\" name=\"cancellationMode\" ng-disabled=\"policy.cancellation != \'Free cancellation up N day(s) before arrival\'\" ng-model=\"policy.cancellationMode\"><option value=\"Hours\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.hours_option\' | i18next}}</option><option value=\"Days\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.days_option\' | i18next}}</option><option value=\"Weeks\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.weeks_option\' | i18next}}</option></select>{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.before_arrival_label\' | i18next}}</label> <label><input type=\"radio\" name=\"cancellation\" ng-model=\"policy.cancellation\" ng-value=\"\'Flexible Cancellation Fee based at cancellation period\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.flexible_cancellation_fee_label\' | i18next}}</label><div ng-show=\"policy.cancellation == \'Flexible Cancellation Fee based at cancellation period\'\"><div ng-repeat=\"period in policy.cancellationPeriods track by $index\"><span ng-if=\"$index == 0\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.up_span\' | i18next}}</span> <span ng-if=\"$index != 0\">{{policy.cancellationPeriods[$index - 1].days - 1}}</span> {{\'general.other.to\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-change=\"CancellationPolicyCtrl.sortPeriods(policy)\" ng-model=\"period.days\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.days_before_arrival_div\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-model=\"period.percent\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.percent_fee_div\' | i18next}} <i class=\"fa fa-times\" ng-click=\"CancellationPolicyCtrl.removeCancellationPeriod(policy, $index)\" tooltip=\"Remove Period\" tooltip-append-to-body=\"true\"></i></div><button class=\"md-raised md-success md-button md-ink-ripple\" ng-click=\"CancellationPolicyCtrl.addCancellationPeriod(policy)\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.add_new_period_button\' | i18next}}</button></div><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"policy.cancellation == \'Cancellation Custom Policy\'\"></locale-selector-next><label><input type=\"radio\" name=\"cancellation\" ng-model=\"policy.cancellation\" ng-value=\"\'Cancellation Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-model=\"policy.cancellationCustom\" ng-show=\"policy.cancellation == \'Cancellation Custom Policy\'\"></textarea></label></div></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.no_show_cancellation_policy.legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"nonshow\" ng-model=\"policy.nonshow\" ng-value=\"\'In case of no-show or late cancellation the first night will be charged\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.no_show_cancellation_policy.first_night_be_charged_label\' | i18next}}</label> <label><input type=\"radio\" name=\"nowshow\" ng-model=\"policy.nonshow\" ng-value=\"\'In case of no-show or late cancellation the total cost will be charged\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.no_show_cancellation_policy.total_cost_be_charged_label\' | i18next}}</label><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"policy.nonshow == \'NonShow Custom Policy\'\"></locale-selector-next><label><input type=\"radio\" name=\"nonshow\" ng-model=\"policy.nonshow\" ng-value=\"\'NonShow Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-model=\"policy.nonshowCustom\" ng-show=\"policy.nonshow == \'NonShow Custom Policy\'\"></textarea></label></div></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.legend\' | i18next}}</legend><div ng-hide=\"policy.breakfastOmit\"><div class=\"form-group\" ng-hide=\"policy.breakfastCustomPolicy\"><label class=\"col-xs-6\">{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.display_name_for_breakfast_label\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" ng-model=\"policy.breakfastName\"></div></div><div class=\"form-group\" ng-hide=\"policy.breakfastCustomPolicy\"><label class=\"col-xs-6\">{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.room_prices_include_breakfast_label\' | i18next}}</label><div class=\"col-xs-6\"><label><input type=\"radio\" name=\"breakfastIncluded\" ng-model=\"policy.breakfastIncluded\" ng-value=\"true\"> {{\'general.other.yes\' | i18next}}</label> <label><input type=\"radio\" name=\"breakfastIncluded\" ng-model=\"policy.breakfastIncluded\" ng-value=\"false\"> {{\'general.other.no\' | i18next}}</label></div></div><div class=\"form-group\" ng-hide=\"policy.breakfastIncluded || policy.breakfastCustomPolicy\"><label class=\"col-xs-6\">{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.price_per_person_label\' | i18next}}:</label><div class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" ng-model=\"policy.breakfastPrice\"></div></div><div class=\"form-group\"><label class=\"col-xs-6\"><input type=\"checkbox\" ng-model=\"policy.breakfastCustomPolicy\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}}<locale-selector-next ng-show=\"policy.breakfastCustomPolicy\"></locale-selector-next></label><div class=\"col-xs-6\" ng-show=\"policy.breakfastCustomPolicy\"><textarea class=\"form-control\" ng-model=\"policy.breakfastDescription\"></textarea></div></div></div><div class=\"form-group\"><label class=\"col-xs-12\"><input type=\"checkbox\" ng-model=\"policy.breakfastOmit\"> {{\'profile_nav.settings.inventory.cancellation_policy.breakfast.omit_policy_label\' | i18next}}</label></div><div class=\"form-group\"><label class=\"col-xs-12\"><input type=\"checkbox\" ng-model=\"policy.isDefault\"> {{\'profile_nav.settings.inventory.cancellation_policy.breakfast.default_policy_label\' | i18next}}</label></div><div class=\"form-group\">{{CancellationPolicyCtrl.generateText(policy, Globalize.locale)}}</div><div class=\"form-group text-center\"><button class=\"md-raised md-success md-button md-ink-ripple\" ng-click=\"CancellationPolicyCtrl.save(policy)\"><i class=\"fa fa-save\" ng-hide=\"CancellationPolicyCtrl.loaded\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': CancellationPolicyCtrl.loaded}\" ng-show=\"CancellationPolicyCtrl.loaded\"></i> {{\'general.buttons.save\' | i18next}}</button> <button class=\"md-raised md-warn md-button md-ink-ripple\" ng-click=\"CancellationPolicyCtrl.cancel(policy, $index)\"><i class=\"fa fa-times\"></i> {{\'general.buttons.cancel\' | i18next}}</button></div></form></td></tr></tbody><tfoot><tr ng-show=\"CancellationPolicyCtrl.newPolicyVisible\"><td colspan=\"3\"><form name=\"hotel-details-form\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-xs-3\">{{\'profile_nav.settings.inventory.cancellation_policy.policy_title\' | i18next}}:<locale-selector-next></locale-selector-next></label><div class=\"col-xs-9\"><input type=\"text\" class=\"form-control\" ng-model=\"CancellationPolicyCtrl.newPolicy.title\"></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"deposit\" ng-model=\"CancellationPolicyCtrl.newPolicy.deposit\" ng-value=\"\'No deposit is required\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.no_deposit_is_required_label\' | i18next}}</label> <label><input type=\"radio\" name=\"deposit\" ng-model=\"CancellationPolicyCtrl.newPolicy.deposit\" ng-value=\"\'A deposit equal to the total cost is required at the time of booking\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.deposit_equal_to_total_cost_label\' | i18next}}</label> <label><input type=\"radio\" name=\"deposit\" ng-model=\"CancellationPolicyCtrl.newPolicy.deposit\" ng-value=\"\'night deposit is required at the time of booking\'\"> <input type=\"number\" ng-model=\"CancellationPolicyCtrl.newPolicy.depositNights\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.deposit != \'night deposit is required at the time of booking\'\" class=\"form-control input-in-select\"> {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.night_deposit_is_required_label\' | i18next}}</label> <label><input type=\"radio\" name=\"deposit\" ng-model=\"CancellationPolicyCtrl.newPolicy.deposit\" ng-value=\"\'% deposit is required at the time of booking\'\"> <input type=\"number\" ng-model=\"CancellationPolicyCtrl.newPolicy.depositPercent\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.deposit != \'% deposit is required at the time of booking\'\" class=\"form-control input-in-select\"> % {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.deposit_is_required_label\' | i18next}}</label> <label><input type=\"radio\" name=\"depositHandle\" ng-model=\"CancellationPolicyCtrl.newPolicy.deposit\" ng-value=\"\'is required per booking\'\"> <input type=\"number\" ng-model=\"CancellationPolicyCtrl.newPolicy.depositPerBooking\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.deposit != \'is required per booking\'\" class=\"form-control input-in-select\"> {{hotel.currency}} {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.is_required_per_booking_label\' | i18next}}</label> <label><input type=\"radio\" name=\"depositHandle\" ng-model=\"CancellationPolicyCtrl.newPolicy.deposit\" ng-value=\"\'is required per room booked\'\"> <input type=\"number\" ng-model=\"CancellationPolicyCtrl.newPolicy.depositPerRoom\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.deposit != \'is required per room booked\'\" class=\"form-control input-in-select\"> {{hotel.currency}} {{\'profile_nav.settings.inventory.cancellation_policy.handle_deposits.is_required_per_room_booked_label\' | i18next}}</label></div></div><legend ng-hide=\"CancellationPolicyCtrl.newPolicy.deposit==\'No deposit is required\'\">{{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.legend\' | i18next}}</legend><div class=\"form-group\" ng-hide=\"CancellationPolicyCtrl.newPolicy.deposit==\'No deposit is required\'\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"refund\" ng-model=\"CancellationPolicyCtrl.newPolicy.refund\" ng-value=\"\'All deposits are non-refundable\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.all_deposits_are_non_refundable_label\' | i18next}}</label> <label><input type=\"radio\" name=\"refund\" ng-model=\"CancellationPolicyCtrl.newPolicy.refund\" ng-value=\"\'Deposits are refundable up to days prior to arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.deposits_are_refundable_up_to_label\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-model=\"CancellationPolicyCtrl.newPolicy.refundDays\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.refund != \'Deposits are refundable up to days prior to arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.refunds_of_deposits.days_prior_to_arrival_label\' | i18next}}</label><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"CancellationPolicyCtrl.newPolicy.refund == \'Refund Custom Policy\'\"></locale-selector-next><label><input type=\"radio\" name=\"refund\" ng-model=\"CancellationPolicyCtrl.newPolicy.refund\" ng-value=\"\'Refund Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-show=\"CancellationPolicyCtrl.newPolicy.refund == \'Refund Custom Policy\'\" ng-model=\"CancellationPolicyCtrl.newPolicy.refundCustom\"></textarea></label></div></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.details.legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"checkbox\" name=\"detailsRemainingEnabled\" ng-model=\"CancellationPolicyCtrl.newPolicy.detailsRemainingEnabled\" ng-value=\"\'Remaining balance to be paid on\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.details.remaining_balance_to_be_paid_on_label\' | i18next}}<select class=\"form-control\" style=\"width: 150px; display: inline-block;\" name=\"detailsRemaining\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.detailsRemainingEnabled == false\" ng-model=\"CancellationPolicyCtrl.newPolicy.detailsRemaining\"><option value=\"Arrival\">{{\'general.other.arrival\' | i18next}}</option><option value=\"Departure\">{{\'profile_nav.settings.inventory.cancellation_policy.details.departure_option\' | i18next}}</option></select></label> <label><input type=\"checkbox\" name=\"detailsPreauthorize\" ng-model=\"CancellationPolicyCtrl.newPolicy.detailsPreauthorize\" ng-value=\"\'We have the right to pre-authorise your card prior to arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.details.to_pre_authorise_card_label\' | i18next}}</label><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"CancellationPolicyCtrl.newPolicy.detailsCustomEnabled == true\"></locale-selector-next><label><input type=\"checkbox\" name=\"detailsCustomEnabled\" ng-model=\"CancellationPolicyCtrl.newPolicy.detailsCustomEnabled\" ng-value=\"\'Details Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-show=\"CancellationPolicyCtrl.newPolicy.detailsCustomEnabled == true\" ng-model=\"CancellationPolicyCtrl.newPolicy.detailsCustom\"></textarea></label></div></div></div><legend>{{\'general.other.cancellation_policy\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"cancellation\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellation\" ng-value=\"\'Free cancellation at any time\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.free_cancellation_label\' | i18next}}</label> <label><input type=\"radio\" name=\"cancellation\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellation\" ng-value=\"\'No cancellation or modification can be applied to this booking\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.no_cancellation_or_modification_label\' | i18next}}</label> <label><input type=\"radio\" name=\"cancellation\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellation\" ng-value=\"\'Free cancellation up N day(s) before arrival\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.free_cancellation_up_label\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellationDays\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.cancellation != \'Free cancellation up N day(s) before arrival\'\"><select class=\"form-control\" style=\"width: 150px; display: inline-block;\" name=\"cancellationMode\" ng-disabled=\"CancellationPolicyCtrl.newPolicy.cancellation != \'Free cancellation up N day(s) before arrival\'\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellationMode\"><option value=\"Hours\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.hours_option\' | i18next}}</option><option value=\"Days\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.days_option\' | i18next}}</option><option value=\"Weeks\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.weeks_option\' | i18next}}</option></select>{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.before_arrival_label\' | i18next}}</label> <label><input type=\"radio\" name=\"cancellation\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellation\" ng-value=\"\'Flexible Cancellation Fee based at cancellation period\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.flexible_cancellation_fee_label\' | i18next}}</label><div ng-show=\"CancellationPolicyCtrl.newPolicy.cancellation == \'Flexible Cancellation Fee based at cancellation period\'\"><div ng-repeat=\"period in CancellationPolicyCtrl.newPolicy.cancellationPeriods track by $index\"><span ng-if=\"$index == 0\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.up_span\' | i18next}}</span> <span ng-if=\"$index != 0\">{{CancellationPolicyCtrl.newPolicy.cancellationPeriods[$index - 1].days - 1}}</span> {{\'general.other.to\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-change=\"CancellationPolicyCtrl.sortPeriods(CancellationPolicyCtrl.newPolicy)\" ng-model=\"period.days\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.days_before_arrival_div\' | i18next}} <input type=\"number\" class=\"form-control input-in-select\" ng-model=\"period.percent\"> {{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.percent_fee_div\' | i18next}} <i class=\"fa fa-times\" ng-click=\"CancellationPolicyCtrl.removeCancellationPeriod(CancellationPolicyCtrl.newPolicy, $index)\" tooltip=\"Remove Period\" tooltip-append-to-body=\"true\"></i></div><button class=\"md-raised md-success md-button md-ink-ripple\" ng-click=\"CancellationPolicyCtrl.addCancellationPeriod(CancellationPolicyCtrl.newPolicy)\">{{\'profile_nav.settings.inventory.cancellation_policy.cancellation_policy.add_new_period_button\' | i18next}}</button></div><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"CancellationPolicyCtrl.newPolicy.cancellation == \'Cancellation Custom Policy\'\"></locale-selector-next><label><input type=\"radio\" name=\"cancellation\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellation\" ng-value=\"\'Cancellation Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-model=\"CancellationPolicyCtrl.newPolicy.cancellationCustom\" ng-show=\"CancellationPolicyCtrl.newPolicy.cancellation == \'Cancellation Custom Policy\'\"></textarea></label></div></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.no_show_cancellation_policy.legend\' | i18next}}</legend><div class=\"form-group\"><div class=\"col-xs-12\"><label><input type=\"radio\" name=\"nonshow\" ng-model=\"CancellationPolicyCtrl.newPolicy.nonshow\" ng-value=\"\'In case of no-show or late cancellation the first night will be charged\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.no_show_cancellation_policy.first_night_be_charged_label\' | i18next}}</label> <label><input type=\"radio\" name=\"nowshow\" ng-model=\"CancellationPolicyCtrl.newPolicy.nonshow\" ng-value=\"\'In case of no-show or late cancellation the total cost will be charged\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.no_show_cancellation_policy.total_cost_be_charged_label\' | i18next}}</label><div class=\"settings-relative-box\"><locale-selector-next ng-show=\"CancellationPolicyCtrl.newPolicy.nonshow == \'NonShow Custom Policy\'\"></locale-selector-next><label><input type=\"radio\" name=\"nonshow\" ng-model=\"CancellationPolicyCtrl.newPolicy.nonshow\" ng-value=\"\'NonShow Custom Policy\'\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}} <textarea class=\"form-control\" ng-model=\"CancellationPolicyCtrl.newPolicy.nonshowCustom\" ng-show=\"CancellationPolicyCtrl.newPolicy.nonshow == \'NonShow Custom Policy\'\"></textarea></label></div></div></div><legend>{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.legend\' | i18next}}</legend><div ng-hide=\"CancellationPolicyCtrl.newPolicy.breakfastOmit\"><div class=\"form-group\" ng-hide=\"CancellationPolicyCtrl.newPolicy.breakfastCustomPolicy\"><label class=\"col-xs-6\">{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.display_name_for_breakfast_label\' | i18next}}:</label><div class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastName\"></div></div><div class=\"form-group\" ng-hide=\"CancellationPolicyCtrl.newPolicy.breakfastCustomPolicy\"><label class=\"col-xs-6\">{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.room_prices_include_breakfast_label\' | i18next}}</label><div class=\"col-xs-6\"><label><input type=\"radio\" name=\"breakfastIncluded\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastIncluded\" ng-value=\"true\"> {{\'general.other.yes\' | i18next}}</label> <label><input type=\"radio\" name=\"breakfastIncluded\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastIncluded\" ng-value=\"false\"> {{\'general.other.no\' | i18next}}</label></div></div><div class=\"form-group\" ng-hide=\"CancellationPolicyCtrl.newPolicy.breakfastIncluded || CancellationPolicyCtrl.newPolicy.breakfastCustomPolicy\"><label class=\"col-xs-6\">{{\'profile_nav.settings.inventory.cancellation_policy.breakfast.price_per_person_label\' | i18next}}:</label><div class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastPrice\"></div></div><div class=\"form-group\"><label class=\"col-xs-6\"><input type=\"checkbox\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastCustomPolicy\"> {{\'profile_nav.settings.inventory.cancellation_policy.custom_policy_label\' | i18next}}<locale-selector-next ng-show=\"CancellationPolicyCtrl.newPolicy.breakfastCustomPolicy\"></locale-selector-next></label><div class=\"col-xs-6\" ng-show=\"CancellationPolicyCtrl.newPolicy.breakfastCustomPolicy\"><textarea class=\"form-control\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastDescription\"></textarea></div></div></div><div class=\"form-group\"><label class=\"col-xs-12\"><input type=\"checkbox\" ng-model=\"CancellationPolicyCtrl.newPolicy.breakfastOmit\"> {{\'profile_nav.settings.inventory.cancellation_policy.breakfast.omit_policy_label\' | i18next}}</label></div><div class=\"form-group\"><label class=\"col-xs-12\"><input type=\"checkbox\" ng-model=\"CancellationPolicyCtrl.newPolicy.isDefault\"> {{\'profile_nav.settings.inventory.cancellation_policy.breakfast.default_policy_label\' | i18next}}</label></div><div class=\"form-group\">{{CancellationPolicyCtrl.generateText(CancellationPolicyCtrl.newPolicy, Globalize.locale)}}</div><div class=\"form-group text-center\"><button class=\"md-raised md-success md-button md-ink-ripple\" ng-click=\"CancellationPolicyCtrl.save(CancellationPolicyCtrl.newPolicy)\"><i class=\"fa fa-save\" ng-hide=\"CancellationPolicyCtrl.loaded\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': CancellationPolicyCtrl.loaded}\" ng-show=\"CancellationPolicyCtrl.loaded\"></i> {{\'general.buttons.save\' | i18next}}</button> <button class=\"md-raised md-warn md-button md-ink-ripple\" ng-click=\"CancellationPolicyCtrl.cancel()\"><i class=\"fa fa-times\"></i> {{\'general.buttons.cancel\' | i18next}}</button></div></form></td></tr><tr ng-show=\"!CancellationPolicyCtrl.newPolicyVisible\"><td colspan=\"3\"><a ng-click=\"CancellationPolicyCtrl.addPolicy()\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.cancellation_policy.add_new_policy_button\' | i18next}}</a></td></tr></tfoot></table></div></div>");
$templateCache.put("templates/settings/inventory.discounts_tpl.html","<div ng-controller=\"Settings.DiscountsController as DiscountsCtrl\"><legend class=\"header\">{{\'general.other.discounts\' | i18next}}<locale-selector change=\"DiscountsCtrl.changeLang\"></locale-selector></legend><inventory-discounts-table currency-symbol=\"DiscountsCtrl.currencySymbol\" hotel-id=\"DiscountsCtrl.hotelId\" discounts=\"DiscountsCtrl.discounts\" on-discount-update=\"DiscountsCtrl.onDiscountUpdate\" on-discount-delete=\"DiscountsCtrl.onDiscountDelete\" on-load-discounts=\"DiscountsCtrl.onLoadDiscounts\"></inventory-discounts-table></div>");
$templateCache.put("templates/settings/inventory.rates_tpl.html","<div><legend class=\"header\">{{\'general.other.rate_plans\' | i18next}}</legend><rate-categories></rate-categories><room-rates></room-rates></div>");
$templateCache.put("templates/settings/inventory.room_setup_tpl.html","<div ng-controller=\"Settings.RoomController as RoomCtrl\"><legend class=\"header\">{{\'general.other.room_setup\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\"><div class=\"div-table\"><div class=\"row header\"><div class=\"col-xs-1\">{{\'profile_nav.settings.hotel_profile.room_setup.name_ro_number_row_header\' | i18next}}</div><div class=\"col-xs-2\">{{\'general.other.room_type\' | i18next}}</div><div class=\"col-xs-1\">{{\'profile_nav.settings.hotel_profile.room_setup.property_row_header\' | i18next}}</div><div class=\"col-xs-1 text-center\" style=\"white-space: nowrap;\">{{\'profile_nav.settings.hotel_profile.room_setup.priority_row_header\' | i18next}} <i class=\"fa fa-question-circle helper\" tooltip=\"{{\'profile_nav.settings.hotel_profile.room_setup.allocation_priority_higher_number_allocated_first_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i></div><div class=\"col-xs-1 text-center\">{{\'general.other.available_online\' | i18next}}</div><div class=\"col-xs-1 text-center\">{{\'general.other.enabled\' | i18next}}</div><div class=\"col-xs-1 text-center\">{{\'profile_nav.settings.hotel_profile.room_setup.key_code\' | i18next}}</div><div class=\"col-xs-1 text-center\">{{\'profile_nav.settings.hotel_profile.room_setup.common_door_name\' | i18next}}</div><div class=\"col-xs-1 text-center\">{{\'profile_nav.settings.hotel_profile.room_setup.color\' | i18next}}</div><div class=\"col-xs-1 text-center\">{{\'profile_nav.settings.hotel_profile.room_setup.underline\' | i18next}}</div></div><div class=\"rooms\" dnd-list=\"RoomCtrl.rooms\"><div class=\"row\" ng-repeat=\"Room in RoomCtrl.rooms\" dnd-draggable=\"Room\" dnd-moved=\"RoomCtrl.DropDownCallback(Room)\" dnd-effect-allowed=\"move\"><div class=\"col-xs-12\" ng-if=\"$index == RoomCtrl.editedRoom\"><room-form ng-model=\"Room\" ng-scope=\"RoomCtrl\"></room-form></div><div class=\"col-xs-1\" ng-hide=\"$index == RoomCtrl.editedRoom\"><i class=\"fa fa-bars\"></i> {{Room.number}}</div><div class=\"col-xs-2\" ng-hide=\"$index == RoomCtrl.editedRoom\">{{RoomCtrl.getRoomTypeName(Room.roomTypeId)}}</div><div class=\"col-xs-1\" ng-hide=\"$index == RoomCtrl.editedRoom\">{{RoomCtrl.getPropertyName(Room.propertyId)}}</div><div class=\"col-xs-1 text-center\" ng-hide=\"$index == RoomCtrl.editedRoom\">{{Room.priority}}</div><div class=\"col-xs-1 text-center\" ng-hide=\"$index == RoomCtrl.editedRoom\"><i class=\"fa fa-check\" ng-show=\"Room.availableOnline\"></i></div><div class=\"col-xs-1 text-center\" ng-hide=\"$index == RoomCtrl.editedRoom\"><i class=\"fa fa-check\" ng-show=\"Room.isActive\"></i></div><div class=\"col-xs-1 text-center\" ng-hide=\"$index == RoomCtrl.editedRoom\">{{ RoomCtrl.hotel.roomKeyFromBookingRoomId ? (\'profile_nav.settings.hotel_profile.room_setup.dynamic\' | i18next) : Room.keyCode }}</div><div class=\"col-xs-1 text-center\" ng-hide=\"$index == RoomCtrl.editedRoom\">{{Room.commonDoorName}}</div><div class=\"col-xs-1\" style=\"display: flex; justify-content: center;\" ng-hide=\"$index == RoomCtrl.editedRoom\"><div style=\"height: 18px; width: 32px; border-radius: 4px; background-color: {{RoomCtrl.backgroundColor(Room)}}\"></div></div><div class=\"col-xs-1 text-center\" ng-hide=\"$index == RoomCtrl.editedRoom\"><i class=\"fa fa-check\" ng-show=\"Room.divider\"></i></div><div ng-hide=\"$index == RoomCtrl.editedRoom\" class=\"controls text-right col-xs-1\"><a ng-click=\"RoomCtrl.openEditForm($index)\"><i class=\"fa fa-edit\"></i></a> <a ng-click=\"RoomCtrl.removeRoom($index)\"><i class=\"fa fa-times\"></i></a></div></div></div><div ng-show=\"RoomCtrl.createFormVisible\"><room-form ng-model=\"RoomCtrl.newRoom\" ng-scope=\"RoomCtrl\"></room-form></div><div class=\"padded\"><a ng-click=\"RoomCtrl.openCreateForm()\" class=\"control-link\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_setup.add_room_link\' | i18next}}</a></div></div><form name=\"toggleDynamicRoomKey\"><md-input-container><md-checkbox ng-model=\"RoomCtrl.hotel.roomKeyFromBookingRoomId\" aria-label=\"{{\'profile_nav.settings.hotel_profile.room_setup.key_code_from_booking_room_id\' | i18next}}\" ng-change=\"RoomCtrl.saveHotel()\" ng-disabled=\"RoomCtrl.savingHotel\">{{\'profile_nav.settings.hotel_profile.room_setup.key_code_from_booking_room_id\' | i18next}} <i class=\"fa fa-question-circle helper\" tooltip=\"{{\'profile_nav.settings.hotel_profile.room_setup.key_code_from_booking_room_id_tooltip\' | i18next}}\" tooltip-append-to-body=\"true\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : RoomCtrl.savingHotel}\" ng-show=\"RoomCtrl.savingHotel\"></i></md-checkbox></md-input-container></form></div></div>");
$templateCache.put("templates/settings/inventory.room_type_tpl.html","<div ng-controller=\"Settings.RoomTypeController as RoomTypeCtrl\"><legend class=\"header\">{{\'general.other.room_type\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : RoomTypeCtrl.loaded == false}\" ng-hide=\"RoomTypeCtrl.loaded\"></i><locale-selector change=\"RoomTypeCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><strong class=\"subblock-header\">{{\'general.other.room_types\' | i18next}}</strong><table class=\"table table-hover general-table table-editable\" ui-tree=\"RoomTypeCtrl.treeOptions\"><thead><tr><th>{{\'general.other.display_name\' | i18next}}</th><th>{{\'general.other.room_type\' | i18next}}</th><th>{{\'general.other.occupancy\' | i18next}}</th><th></th></tr></thead><tbody ui-tree-nodes=\"\" ng-model=\"RoomTypeCtrl.roomTypes\"><tr ng-repeat=\"RoomType in RoomTypeCtrl.roomTypes\" ui-tree-node=\"\"><td colspan=\"5\" ng-show=\"$index == RoomTypeCtrl.editedRoomType\"><room-type-form ng-model=\"RoomType\" ng-scope=\"RoomTypeCtrl\"></room-type-form></td><td ng-hide=\"$index == RoomTypeCtrl.editedRoomType\"><i class=\"fa fa-bars room-handle\" ui-tree-handle=\"\"></i> {{RoomType | prettyTranslate: \'name\'}} <small>({{RoomType.shortCode}})</small></td><td ng-hide=\"$index == RoomTypeCtrl.editedRoomType\">{{RoomType | prettyTranslate: \'roomType\'}}</td><td ng-hide=\"$index == RoomTypeCtrl.editedRoomType\"><i class=\"fa fa-user\"></i> {{RoomType.maxAdults}} <i class=\"fa fa-child\"></i> {{RoomType.maxChildren}} + {{RoomType.maxInfants}}</td><td ng-hide=\"$index == RoomTypeCtrl.editedRoomType\" class=\"controls text-right\"><a ng-click=\"RoomTypeCtrl.openEditForm($index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"RoomTypeCtrl.removeRoomType($index)\" ng-disabled=\"RoomType.removing\" ng-hide=\"RoomType.removing\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a> <i tooltip=\"{{\'general.tooltip.removing\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\':RoomType.removing}\" ng-show=\"RoomType.removing\"></i></td></tr></tbody><tfoot><tr ng-show=\"RoomTypeCtrl.createFormVisible\"><td colspan=\"5\"><room-type-form ng-model=\"RoomTypeCtrl.newRoomType\" ng-scope=\"RoomTypeCtrl\"></room-type-form></td></tr><tr ng-hide=\"RoomTypeCtrl.createFormVisible\"><td colspan=\"5\"><a ng-click=\"RoomTypeCtrl.openCreateForm()\" class=\"control-link\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type.add_room_type_link\' | i18next}}</a></td></tr></tfoot></table></div><div class=\"settings-body-block\"><strong class=\"subblock-header\">{{\'profile_nav.settings.inventory.room_type.virtual_room_types_title\' | i18next}}</strong><table class=\"table table-hover general-table table-editable\"><thead><tr><th>{{\'general.other.display_name\' | i18next}}</th><th>{{\'profile_nav.settings.inventory.room_type.parent_room_type_th\' | i18next}}</th><th></th></tr></thead><tbody ng-model=\"RoomTypeCtrl.coverRoomTypes\"><tr ng-repeat=\"CoverRoomType in RoomTypeCtrl.coverRoomTypes\"><td colspan=\"3\" ng-show=\"$index == RoomTypeCtrl.editedCoverRoomType\"><cover-room-type-form ng-model=\"CoverRoomType\" ng-scope=\"RoomTypeCtrl\"></cover-room-type-form></td><td ng-hide=\"$index == RoomTypeCtrl.editedCoverRoomType\">{{CoverRoomType | prettyTranslate: \'name\'}} <small>({{CoverRoomType.shortCode}})</small></td><td ng-hide=\"$index == RoomTypeCtrl.editedCoverRoomType\">{{RoomTypeCtrl.getRoomTypeTitle(CoverRoomType.roomTypeId)}}</td><td ng-hide=\"$index == RoomTypeCtrl.editedCoverRoomType\" class=\"controls text-right\"><a ng-click=\"RoomTypeCtrl.openEditCoverRoomTypeForm($index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"RoomTypeCtrl.removeCoverRoomType($index)\" ng-disabled=\"CoverRoomType.removing\" ng-hide=\"CoverRoomType.removing\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a> <i tooltip=\"{{\'general.tooltip.removing\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\':CoverRoomType.removing}\" ng-show=\"CoverRoomType.removing\"></i></td></tr></tbody><tfoot><tr ng-show=\"RoomTypeCtrl.createCoverRoomTypeFormVisible\"><td colspan=\"3\"><cover-room-type-form ng-model=\"RoomTypeCtrl.newCoverRoomType\" ng-scope=\"RoomTypeCtrl\"></cover-room-type-form></td></tr><tr ng-hide=\"RoomTypeCtrl.createCoverRoomTypeFormVisible\"><td colspan=\"3\"><a ng-click=\"RoomTypeCtrl.openCreateCoverRoomTypeForm()\" class=\"control-link\"><i class=\"fa fa-plus\"></i> {{\'profile_nav.settings.inventory.room_type.add_virtual_room_type_link\' | i18next}}</a></td></tr></tfoot></table></div></div>");
$templateCache.put("templates/settings/inventory.seasons_tpl.html","<div ng-controller=\"Settings.SeasonsController as ctrl\"><legend class=\"header\">{{\'profile_nav.settings.inventory.seasons_and_events.seasons_and_events_legend\' | i18next}}<locale-selector change=\"ctrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block marged-bottom\"><div class=\"popover top\" id=\"season-popover\"><div class=\"arrow\"></div><div class=\"popover-content\"></div></div><div class=\"row\"><div class=\"col-lg-9\"><season-calendar></season-calendar></div><div class=\"col-lg-3\"><div><md-button class=\"md-raised md-success seasons-add\" ng-click=\"ctrl.addSeason()\">{{\'profile_nav.settings.inventory.seasons_and_events.add_season_or_event_button\' | i18next}}</md-button></div><div class=\"seasons\" ng-class=\"{\'seasons__highlighted\': ctrl.highlightedSeason !== null}\"><div class=\"seasons__seasons_group\"><h1>{{\'profile_nav.settings.inventory.seasons_and_events.seasons_title\' | i18next}}</h1><div class=\"season\" ng-class=\"{\'season__highlighted\': season.id == ctrl.highlightedSeason}\" ng-repeat=\"season in ctrl.seasons.list | filter:{\'isEvent\': false} track by season.id\"><i class=\"fa fa-square\" style=\"color: #{{season.color}};\"></i> <strong ng-click=\"ctrl.chooseSeason(season)\" ng-class=\"{\'selected\': season.id == ctrl.selectedSeason}\">{{season | prettyTranslate: \'title\'}}</strong><div class=\"pull-right\" ng-if=\"season.isDefault === false\"><i class=\"fa fa-plus fa-action\" ng-click=\"ctrl.addRange(season)\" tooltip=\"{{\'profile_nav.settings.inventory.seasons_and_events.add_range_tooltip\' | i18next}}\"></i> <i class=\"fa fa-edit fa-action\" ng-click=\"ctrl.editSeason(season)\" tooltip=\"{{\'general.tooltip.edit\' | i18next}}\"></i> <i class=\"fa fa-trash fa-action\" ng-click=\"ctrl.removeSeason(season)\" tooltip=\"{{\'profile_nav.settings.inventory.seasons_and_events.remove_season_tooltip\' | i18next}}\"></i></div><div><ul class=\"season-list\"><li ng-repeat=\"range in season.ranges | orderBy:\'startDate\'\">{{range.startDate | dateToMoment:\"DD MMM YYYY\"}} - {{range.endDate | dateToMoment:\"DD MMM YYYY\"}} <i class=\"fa fa-trash fa-action remove-range-btn pull-right\" ng-click=\"ctrl.removeRange(season, range)\" tooltip=\"{{\'profile_nav.settings.inventory.seasons_and_events.remove_range_tooltip\' | i18next}}\" ng-if=\"season.isDefault === false\"></i></li></ul></div></div></div><div class=\"seasons__seasons_group\"><h1>{{\'profile_nav.settings.inventory.seasons_and_events.events_title\' | i18next}}</h1><div class=\"season\" ng-class=\"{\'season__highlighted\': season.id == ctrl.highlightedSeason}\" ng-repeat=\"season in ctrl.seasons.list | filter:{\'isEvent\': true} track by season.id\"><i class=\"fa fa-square\" style=\"color: #{{season.color}};\"></i> <strong ng-click=\"ctrl.chooseSeason(season)\" ng-class=\"{\'selected\': season.id == ctrl.selectedSeason}\">{{season | prettyTranslate: \'title\'}}</strong><div class=\"pull-right\" ng-if=\"season.isDefault === false\"><i class=\"fa fa-plus fa-action\" ng-click=\"ctrl.addRange(season)\" tooltip=\"{{\'profile_nav.settings.inventory.seasons_and_events.add_range_tooltip\' | i18next}}\"></i> <i class=\"fa fa-edit fa-action\" ng-click=\"ctrl.editSeason(season)\" tooltip=\"{{\'general.tooltip.edit\' | i18next}}\"></i> <i class=\"fa fa-trash fa-action\" ng-click=\"ctrl.removeSeason(season)\" tooltip=\"{{\'profile_nav.settings.inventory.seasons_and_events.remove_season_tooltip\' | i18next}}\"></i></div><div><ul class=\"season-list\"><li ng-repeat=\"range in season.ranges | orderBy:\'startDate\'\">{{range.startDate | dateToMoment:\"DD MMM YYYY\"}} - {{range.endDate | dateToMoment:\"DD MMM YYYY\"}} <i class=\"fa fa-trash fa-action remove-range-btn pull-right\" ng-click=\"ctrl.removeRange(season, range)\" tooltip=\"{{\'profile_nav.settings.inventory.seasons_and_events.remove_range_tooltip\' | i18next}}\" ng-if=\"season.isDefault === false\"></i></li></ul></div></div><div ng-show=\"(ctrl.seasons.list | filter:{\'isEvent\': true}).length == 0\">{{\'profile_nav.settings.inventory.seasons_and_events.you_do_not_have_any_events_div\' | i18next}}</div></div></div></div></div></div><div class=\"settings-body-block text-center\" ng-if=\"!ctrl.seasonId\">{{\'profile_nav.settings.inventory.seasons_and_events.choose_season_to_see_prices_and_restrictions_div\' | i18next}}</div><react-season-room-rate-combinations rate-categories=\"ctrl.rateCategories\" room-representations=\"ctrl.roomRepresentations\" seasons=\"ctrl.seasons.list\" room-rates=\"ctrl.roomRates\" cancellation-policies=\"ctrl.cancellationPolicies\" hotel-settings=\"ctrl.hotelSettings\" on-save=\"ctrl.onSave\" on-room-rate-removed=\"ctrl.onRoomRateRemoved\" on-room-rate-changed=\"ctrl.onRoomRateChanged\" on-save-new-room-rate-combination=\"ctrl.onSaveNewRoomRateCombination\" on-save-edit-room-rate-combination=\"ctrl.onSaveEditRoomRateCombination\" season-id=\"ctrl.seasonId\" on-close=\"ctrl.onCloseSeason\" manual-modification-enabled=\"ctrl.manualModificationsEnabled\"></react-season-room-rate-combinations></div>");
$templateCache.put("templates/settings/inventory.settings_tpl.html","<div ng-controller=\"Settings.InventorySettingsController as InventorySettingsCtrl\"><legend class=\"header\">{{\'profile_nav.settings.inventory.inventory_settings.inventory_settings_legend\' | i18next}}</legend><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.inventory.inventory_settings.online_booking_cut_off_date_legend\' | i18next}}</legend><md-checkbox ng-model=\"InventorySettingsCtrl.showCutOffDatePicker\">{{\'profile_nav.settings.inventory.inventory_settings.set_cut_off_date_checkbox\' | i18next}}</md-checkbox><div class=\"form-block date-col\" ng-show=\"InventorySettingsCtrl.showCutOffDatePicker === true\"><label class=\"datepicker\">{{\'profile_nav.settings.inventory.inventory_settings.last_day_bookable_online_label\' | i18next}}</label><md-datepicker ng-model=\"InventorySettingsCtrl.cutOffDate\" md-placeholder=\"Enter date\" md-min-date=\"InventorySettingsCtrl.minDate\"></md-datepicker></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"InventorySettingsCtrl.save()\" ng-disabled=\"InventorySettingsCtrl.saving\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : InventorySettingsCtrl.saving}\" ng-show=\"InventorySettingsCtrl.saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.inventory.inventory_settings.same_day_booking_cut_off_time_legend\' | i18next}}</legend><md-checkbox ng-model=\"InventorySettingsCtrl.showCutOffTimePicker\" ng-disabled=\"InventorySettingsCtrl.timezone == undefined || InventorySettingsCtrl.timezone == null\">{{\'profile_nav.settings.inventory.inventory_settings.set_time_checkbox\' | i18next}}</md-checkbox><div class=\"form-block date-col\" ng-show=\"InventorySettingsCtrl.showCutOffTimePicker === true\"><md-input-container><label>{{\'profile_nav.settings.inventory.inventory_settings.choose_when_to_stop_selling_rooms_online_label\' | i18next}}</label><md-select ng-model=\"InventorySettingsCtrl.stopSellingTime\"><md-option ng-repeat=\"time in InventorySettingsCtrl.times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container><small>{{\'profile_nav.settings.inventory.inventory_settings.in_small\' | i18next}} UTC: {{InventorySettingsCtrl.prepareTime(InventorySettingsCtrl.stopSellingTime)}}</small></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"InventorySettingsCtrl.save()\" ng-disabled=\"InventorySettingsCtrl.saving\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : InventorySettingsCtrl.saving}\" ng-show=\"InventorySettingsCtrl.saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.inventory.inventory_settings.inventory_visibility_legend\' | i18next}}</legend><form name=\"hotel-details-form\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-xs-9\"><md-checkbox ng-model=\"InventorySettingsCtrl.hotel.minStayThroughVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_min_stay_through_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_min_stay_through_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><div class=\"col-xs-9\"><md-checkbox ng-model=\"InventorySettingsCtrl.hotel.minStayArrivalVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_min_stay_arrival_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_min_stay_arrival_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><div class=\"col-xs-9\"><md-checkbox ng-model=\"InventorySettingsCtrl.hotel.closedToArrivalVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_closed_to_arrival_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_closed_to_arrival_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><div class=\"col-xs-9\"><md-checkbox ng-model=\"InventorySettingsCtrl.hotel.closedToDepartureVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_closed_to_departure_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_closed_to_departure_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><div class=\"col-xs-9\"><md-checkbox ng-model=\"InventorySettingsCtrl.hotel.maxStayVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_max_stay_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_max_stay_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"form-group\"><div class=\"col-xs-9\"><md-checkbox ng-model=\"InventorySettingsCtrl.hotel.stopSellVisible\" aria-label=\"{{\'profile_nav.settings.hotel_profile.hotel_details.show_stop_sell_checkbox\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.hotel_details.show_stop_sell_checkbox\' | i18next}}</md-checkbox></div></div></form></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"InventorySettingsCtrl.save()\" ng-disabled=\"InventorySettingsCtrl.saving\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : InventorySettingsCtrl.saving}\" ng-show=\"InventorySettingsCtrl.saving\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/other.country_specific_tpl.html","<div ng-controller=\"Settings.CountrySpecificController as ctrl\"><legend class=\"header\">{{\'profile_nav.settings.other.country_specific_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"ctrl.loading\" ng-class=\"{\'fa-spin\': ctrl.loading}\"></i><br><small>{{\'profile_nav.settings.other.country_specific_description\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped marged-bottom\" ng-if=\"hotel.country == \'IS\'\"><h3>{{\'reports.statistical_report_is_report.legend\' | i18next}}</h3><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.hotel_id_label\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.statsHotelId\"></md-input-container><md-input-container ng-if=\"hotel.countrySpecific.icelandAuth\"><label>{{\'login.login_link\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.statsLogin\"></md-input-container><md-input-container ng-if=\"hotel.countrySpecific.icelandAuth\"><label>{{\'login.password_label\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.statsPassword\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><h3>{{\'reports.statistical_report_is.report_provider\' | i18next}}</h3><md-input-container><label>{{\'reports.statistical_report_is.name\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.name\" md-maxlength=\"100\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.uniq_id\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.uniqueId\" md-maxlength=\"11\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.email\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.email\" md-maxlength=\"100\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.phone\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.phone\" md-maxlength=\"20\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.address\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.address\" md-maxlength=\"100\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.postcode\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.postcode\" md-maxlength=\"3\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.url\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.provider.url\" md-maxlength=\"100\"></md-input-container></div><div class=\"col-md-6\"><h3>{{\'reports.statistical_report_is.report_contact\' | i18next}}</h3><md-input-container><label>{{\'reports.statistical_report_is.name\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.name\" md-maxlength=\"100\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.uniq_id\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.uniqueId\" md-maxlength=\"11\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.email\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.email\" md-maxlength=\"100\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.phone\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.phone\" md-maxlength=\"20\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.address\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.address\" md-maxlength=\"100\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.postcode\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.postcode\" md-maxlength=\"3\"></md-input-container><md-input-container><label>{{\'reports.statistical_report_is.url\' | i18next}}</label> <input ng-model=\"hotel.addons.iceland.contact.url\" md-maxlength=\"100\"></md-input-container></div></div><div class=\"text-right\"><md-button class=\"md-raised md-success\" ng-click=\"ctrl.save()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"ctrl.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div>");
$templateCache.put("templates/settings/other.facebook_tpl.html","<div ng-controller=\"Settings.FacebookController as FacebookCtrl\"><legend class=\"header\">{{\'profile_nav.settings.other.facebook_integration_settings.facebook_integration_settings_legend\' | i18next}} <i class=\"fa fa-spinner\" ng-show=\"FacebookCtrl.loaded\" ng-class=\"{\'fa-spin\':FacebookCtrl.loaded}\"></i></legend><div class=\"settings-body-block\"><div class=\"row\" ng-if=\"hotel.id\"><a href=\"https://www.facebook.com/dialog/pagetab?app_id={{FacebookCtrl.book_now_app_id}}&redirect_uri=https://app.thebookingfactory.com/facebook/booking_page_setup_callback?hotel_id={{hotel.id}}\" target=\"_blank\">{{\'profile_nav.settings.other.facebook_integration_settings.add_book_now_tab_link\' | i18next}}</a></div></div></div>");
$templateCache.put("templates/settings/other.folio_tpl.html","<div ng-controller=\"Settings.FolioController as FolioCtrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\"><div class=\"row\"><div class=\"col-xs-10\">{{\'profile_nav.settings.other.templates.types.\' + FolioCtrl.templateType | i18next}} <i class=\"fa fa-spinner fa-spin\" ng-show=\"defaultLoading == true\"></i><md-menu><i class=\"fa fa-edit\" ng-show=\"defaultLoading == false && FolioCtrl.loaded == true\" ng-click=\"FolioCtrl.openDropDown($mdOpenMenu, $event)\" tooltip=\"{{\'general.buttons.change\' | i18next}}\"></i><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"type in FolioCtrl.templateTypes\"><md-button ng-click=\"FolioCtrl.changeTemplateType(type)\">{{\'profile_nav.settings.other.templates.types.\' + type | i18next}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"col-xs-2 text-right\"><a class=\"help-button\" ng-click=\"FolioCtrl.help_opened = true;\"><i class=\"fa fa-question-circle-o\"></i></a> <a ng-click=\"FolioCtrl.toggleView()\" class=\"toggle-button\" ng-class=\"{ \'vertical\': FolioCtrl.view === \'vertically\', \'horizontal\': FolioCtrl.view !== \'vertically\' }\"><md-tooltip md-direction=\"left\">{{\'profile_nav.settings.other.folio.toggle_ui_view\' | i18next}}</md-tooltip></a></div></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"FolioCtrl.loaded == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content editors\" ng-class=\"{ \'vertical-editor\' : FolioCtrl.view === \'vertically\', \'horizontal-editor\' : FolioCtrl.view !== \'vertically\' }\" ng-if=\"FolioCtrl.loaded && FolioCtrl.isPreviewShown == false\"><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label ng-if=\"FolioCtrl.templateType == \'folio\'\">Preview Folio Number</label> <label ng-if=\"FolioCtrl.templateType == \'guest_reg_form\'\">Preview Booking Token</label> <input ng-model=\"FolioCtrl.templateArg\" type=\"text\"></md-input-container></div></div><div class=\"editor-container html\"><h4>{{\'profile_nav.settings.other.folio.liquid_template\' | i18next}}</h4><div class=\"editor\" ui-codemirror=\"\" ng-model=\"FolioCtrl.liquidCode\" ui-codemirror-opts=\"FolioCtrl.liquidEditor\"></div><md-button class=\"md-default fullscreen-toggle\" ng-click=\"FolioCtrl.toggleFullscreen($event)\"><i class=\"fa fa-arrows-alt\"></i></md-button></div><div class=\"editor-container\"><h4>{{\'profile_nav.settings.other.folio.css_template\' | i18next}}</h4><div class=\"editor\" ui-codemirror=\"\" ng-model=\"FolioCtrl.cssCode\" ui-codemirror-opts=\"FolioCtrl.cssEditor\"></div><md-button class=\"md-default fullscreen-toggle\" ng-click=\"FolioCtrl.toggleFullscreen($event)\"><i class=\"fa fa-arrows-alt\"></i></md-button></div></div><div class=\"settings-padded-content\" ng-if=\"FolioCtrl.loaded && FolioCtrl.isPreviewShown == true\"><div class=\"preview\"><div class=\"text-center middle-loader\" ng-if=\"FolioCtrl.isPreviewLoaded == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"preview-container folio-templates\"><iframe ng-if=\"FolioCtrl.isHTMLpreview == true && FolioCtrl.isPreviewLoaded == true\" srcdoc=\"{{FolioCtrl.preview}}\" frameborder=\"0\"></iframe><div class=\"template_pdf_preview\"></div></div></div></div></div><div class=\"spinned text-left toolbar marged-bottom\" ng-if=\"FolioCtrl.loaded\"><div class=\"row\"><div class=\"col-xs-6 text-left\"><md-checkbox ng-model=\"FolioCtrl.isActive\" aria-label=\"Is Active\" class=\"without-margin\">{{\'profile_nav.settings.other.folio.is_active_checkbox\' | i18next}}</md-checkbox></div><div class=\"col-xs-6 text-right\"><md-button ng-if=\"FolioCtrl.isPreviewShown == false\" class=\"md-default\" ng-click=\"FolioCtrl.showPreview(\'html\')\">{{\'profile_nav.settings.other.folio.show_preview\' | i18next}}</md-button><md-button ng-if=\"FolioCtrl.isPreviewShown == true\" class=\"md-default\" ng-click=\"FolioCtrl.backToEdit(\'html\')\">{{\'profile_nav.settings.other.folio.back_to_edit\' | i18next}}</md-button><md-button class=\"md-raised md-primary\" ng-click=\"FolioCtrl.loadDefaults()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : defaultLoading == true}\" ng-show=\"defaultLoading == true\"></i> {{\'profile_nav.settings.other.folio.load_deaults\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"FolioCtrl.saveTemplate()\">{{\'profile_nav.settings.other.folio.save_btn\' | i18next}}</md-button></div></div></div><div class=\"right-panel-block\" ng-class=\"{opened: FolioCtrl.help_opened}\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\"><div class=\"row\"><div class=\"col-xs-12\">{{\'profile_nav.settings.other.templates.user_manual\' | i18next}}</div></div></div><div class=\"text-center right-panel-block-content\"><iframe ng-if=\"FolioCtrl.help_opened\" ng-src=\"{{FolioCtrl.helpPage}}\" frameborder=\"0\"></iframe></div></div><div class=\"spinned text-left toolbar marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-default\" ng-click=\"FolioCtrl.help_opened = false;\">{{\'general.buttons.close\' | i18next}}</md-button></div></div></div></div></div>");
$templateCache.put("templates/settings/other.hoperator_tpl.html","<div ng-controller=\"Settings.HoperatorController as HoperatorCtrl\" class=\"iframe-settings-block-container\"><iframe ng-if=\"HoperatorCtrl.loaded\" ng-src=\"{{HoperatorCtrl.iframeURL}}\"></iframe></div>");
$templateCache.put("templates/settings/other.plugins_tpl.html","<div ng-controller=\"Settings.PluginsController as PluginsController\"><div class=\"settings-body-block full-width marged-top full-height\" ng-if=\"hotel.id\"><div class=\"full-width-block-header\"><div class=\"pull-left\">{{\'profile_nav.settings.other.plugin_settings.plugin_settings_legend\' | i18next}}</div><div class=\"pull-right\"><a ng-class=\"{\'active\': active_page_name === \'active\'}\" ng-click=\"changeActivePage(\'active\')\">{{\'profile_nav.settings.other.plugin_settings.active_plugins\' | i18next}}</a> &nbsp;|&nbsp; <a ng-class=\"{\'active\': active_page_name === \'all\'}\" ng-click=\"changeActivePage(\'all\')\">{{\'profile_nav.settings.other.plugin_settings.all_plugins\' | i18next}}</a></div><div class=\"clearfix\"></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"loaded == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content full-height-content\" ng-if=\"loaded\"><div ng-repeat=\"plugin in plugins\" class=\"plugin-item\" ng-if=\"plugin.installed || (active_page_name === \'all\' && !plugin.isPrivate)\"><div class=\"row row-no-margin\"><div class=\"col-xs-8 plugin-name\"><h4>{{plugin.name}}</h4></div><div class=\"plugin-action text-right col-xs-4\"><md-button class=\"md-raised\" ng-click=\"showInfo(plugin)\" ng-if=\"plugin.additionalInfoIsVisible\">{{\'general.profile_nav.settings.other.plugin_settings.hide_info_btn\' | i18next}}</md-button><md-button class=\"md-raised\" ng-click=\"showInfo(plugin)\" ng-if=\"!plugin.additionalInfoIsVisible\">{{\'general.profile_nav.settings.other.plugin_settings.show_info_btn\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"install(plugin)\" ng-if=\"!plugin.installed\"><i class=\"fa fa-spin fa-spinner\" ng-show=\"plugin.loading === true\"></i> {{\'general.profile_nav.settings.other.plugin_settings.install_btn\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"remove(plugin)\" ng-if=\"plugin.installed\"><i class=\"fa fa-spin fa-spinner\" ng-show=\"plugin.loading === true\"></i> {{\'general.profile_nav.settings.other.plugin_settings.remove_btn\' | i18next}}</md-button></div></div><div class=\"row row-no-margin\"><div class=\"col-xs-12\"><div class=\"plugin-description__short\"><p>{{plugin.shortDescription}}</p></div><div class=\"plugin-additionl-info\" ng-if=\"plugin.additionalInfoIsVisible\"><p>{{plugin.description}}</p></div></div></div></div><div ng-if=\"!havePlugins && active_page_name === \'active\'\"><div class=\"text-center placeholder-message-center\">{{\'general.profile_nav.settings.other.plugin_settings.yo_do_not_have_any_plugins\' | i18next}}<br><a ng-click=\"changeActivePage(\'all\')\">{{\'general.profile_nav.settings.other.plugin_settings.add_new\' | i18next}}</a></div></div></div></div></div>");
$templateCache.put("templates/settings/other.reactions_tpl.html","<div class=\"reactions reactions-triggers\" ng-controller=\"Settings.Reactions as ctrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\"><div class=\"row\"><div class=\"col-xs-6\">{{\'profile_nav.settings.other.reactions.reactions_legend\' | i18next}}</div><div class=\"col-xs-6 text-right\"><a href=\"#/settings/other/triggers\">{{\'profile_nav.settings.other.triggers.triggers_legend\' | i18next}}</a> &nbsp;|&nbsp; <a href=\"#/settings/other/reactions\" class=\"active\">{{\'profile_nav.settings.other.triggers.tasks_legend\' | i18next}}</a></div></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"ctrl.loaded == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"ctrl.loaded\"><table class=\"table table-hover general-table table-editable\" ng-if=\"ctrl.reactions.length > 0\"><thead><tr><th class=\"col-xs-5\">{{\'general.other.title\' | i18next}} / {{\'general.other.description\' | i18next}}</th><th class=\"col-xs-3\">{{\'general.other.event\' | i18next}}</th><th class=\"col-xs-1 text-center\">{{\'general.other.enabled\' | i18next}}</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"reaction in ctrl.reactions\"><td ng-hide=\"reaction.edited === true\"><strong>{{reaction.title | capitalize}}</strong><br>{{reaction.description | capitalize}}</td><td ng-hide=\"reaction.edited === true\"><ul class=\"reaction-triggers\"><li ng-repeat=\"trigger in ctrl.getReactionTriggers(reaction)\">{{ ctrl.getTriggerSummary(trigger) | capitalize }} <span ng-if=\"trigger.kind == \'scheduled\'\">, <span ng-if=\'trigger.executionConditions[0] == \"day\"\'>{{\'profile_nav.settings.other.reactions.every_day_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Monday\"\'>{{\'profile_nav.settings.other.reactions.every_monday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Tuesday\"\'>{{\'profile_nav.settings.other.reactions.every_tuesday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Wednesday\"\'>{{\'profile_nav.settings.other.reactions.every_wednesday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Thursday\"\'>{{\'profile_nav.settings.other.reactions.every_thursday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Friday\"\'>{{\'profile_nav.settings.other.reactions.every_friday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Saturday\"\'>{{\'profile_nav.settings.other.reactions.every_saturday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Sunday\"\'>{{\'profile_nav.settings.other.reactions.every_sunday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"first\" && trigger.executionConditions[1] == \"day of month\"\'>{{\'profile_nav.settings.other.reactions.first_day_of_month_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"last\" && trigger.executionConditions[1] == \"day of month\"\'>{{\'profile_nav.settings.other.reactions.last_day_of_month_option\' | i18next}}</span> , {{ctrl.getExecutionTime(trigger.executionTime)}}</span></li></ul></td><td ng-hide=\"reaction.edited === true\" class=\"text-center\"><i class=\"fa fa-check-circle\" ng-show=\"reaction.isEnabled\" tooltip=\"{{\'profile_nav.settings.other.reactions.this_reaction_is_enabled\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"reaction.edited === true\" class=\"controls text-right\"><i class=\"fa fa-spinner\" ng-show=\"reaction.loading\" ng-class=\"{\'fa-spin\' : reaction.loading}\"></i> <a ng-click=\"ctrl.duplicateReaction(reaction)\" ng-hide=\"reaction.loading\" class=\"duplicate-button\"><i tooltip=\"{{\'general.tooltip.duplicate\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-copy\"></i></a> <a ng-click=\"ctrl.openEditForm(reaction)\" ng-hide=\"reaction.loading\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"ctrl.removeReaction(reaction)\" ng-hide=\"reaction.loading\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td colspan=\"4\" class=\"table-form-row\" ng-if=\"reaction.edited === true\"><reaction-form ng-model=\"reaction\" ng-scope=\"ctrl\"><div class=\"row\"><div class=\"col-xs-6 sublist-legend\">{{\'profile_nav.settings.other.triggers.triggers_legend\' | i18next}}</div><div class=\"col-xs-6 text-right\" ng-hide=\"reaction.triggerFormOpened\"><md-menu md-position-mode=\"target-right target\" ng-if=\"ctrl.getReactionAvailableTriggers(reaction).length > 0\" class=\"reaction-dropin-button\"><md-button class=\"md-button md-primary\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\">{{\'profile_nav.settings.other.triggers.attach_existing_trigger\' | i18next}}</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"trigger in ctrl.getReactionAvailableTriggers(reaction)\"><md-button ng-click=\"ctrl.attachTriggerToReaction(reaction, trigger)\">{{ctrl.getTriggerSummary(trigger) | capitalize}}</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-raised md-primary\" ng-disabled=\"!reaction.task\" ng-click=\"ctrl.addTrigger(reaction)\">{{\'profile_nav.settings.other.triggers.create_new_trigger\' | i18next}}</md-button></div></div><table class=\"table table-hover general-table table-editable\"><tbody><tr class=\"reaction-trigger\" ng-repeat=\"trigger in reaction.triggers\"><td ng-hide=\"trigger.edited === true\" class=\"col-xs-4\">{{ ctrl.getTriggerSummary(trigger) | capitalize }}</td><td ng-hide=\"trigger.edited === true\" class=\"col-xs-2 text-right\"><i class=\"fa fa-check-circle\" ng-show=\"trigger.isEnabled\" tooltip=\"{{\'profile_nav.settings.other.triggers.this_trigger_is_enabled\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"trigger.edited === true\" class=\"col-xs-2 controls text-right\"><a ng-click=\"ctrl.openTriggerEditForm(reaction, trigger)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"ctrl.detachTriggerFromReaction(reaction, trigger)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td colspan=\"4\" class=\"table-form-row\" ng-if=\"trigger.edited === true\"><trigger-form ng-model=\"trigger\" ng-scope=\"ctrl\"></trigger-form></td></tr></tbody></table></reaction-form></td></tr></tbody></table><div class=\"text-center full-width-padded-top full-width-padded-bottom\" ng-if=\"ctrl.reactions.length === 0\">{{\'profile_nav.settings.other.reactions.set_up_areaction_to_automate_workflow_div\' | i18next}}<br><br></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-click=\"ctrl.addReaction()\">{{\'profile_nav.settings.other.reactions.add_reaction_button\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/other.triggers_tpl.html","<div class=\"reactions reactions-triggers\" ng-controller=\"Settings.Triggers as ctrl\"><div class=\"settings-body-block full-width marged-top\"><div class=\"full-width-block-header\"><div class=\"row\"><div class=\"col-xs-6\">{{\'profile_nav.settings.other.reactions.reactions_legend\' | i18next}}</div><div class=\"col-xs-6 text-right\"><a href=\"#/settings/other/triggers\" class=\"active\">{{\'profile_nav.settings.other.triggers.triggers_legend\' | i18next}}</a> &nbsp;|&nbsp; <a href=\"#/settings/other/reactions\">{{\'profile_nav.settings.other.triggers.tasks_legend\' | i18next}}</a></div></div></div><div class=\"full-width-padded-top full-width-padded-bottom text-center\" ng-if=\"ctrl.loaded == false\"><i class=\"fa fa-spin fa-spinner\"></i><br>{{\'general.other.loading\' | i18next}}</div><div class=\"settings-padded-content\" ng-if=\"ctrl.loaded\"><table class=\"table table-hover general-table table-editable\" ng-if=\"ctrl.triggers.length > 0\"><thead><tr><th class=\"col-xs-5\">{{\'general.other.event\' | i18next}}</th><th class=\"col-xs-3\">{{\'general.other.tasks\' | i18next}}</th><th class=\"col-xs-1 text-center\">{{\'general.other.enabled\' | i18next}}</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"trigger in ctrl.triggers\"><td ng-hide=\"trigger.edited === true\">{{ ctrl.getTriggerSummary(trigger) | capitalize }} <span ng-if=\"trigger.kind == \'scheduled\'\">, <span ng-if=\'trigger.executionConditions[0] == \"day\"\'>{{\'profile_nav.settings.other.reactions.every_day_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Monday\"\'>{{\'profile_nav.settings.other.reactions.every_monday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Tuesday\"\'>{{\'profile_nav.settings.other.reactions.every_tuesday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Wednesday\"\'>{{\'profile_nav.settings.other.reactions.every_wednesday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Thursday\"\'>{{\'profile_nav.settings.other.reactions.every_thursday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Friday\"\'>{{\'profile_nav.settings.other.reactions.every_friday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Saturday\"\'>{{\'profile_nav.settings.other.reactions.every_saturday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"Sunday\"\'>{{\'profile_nav.settings.other.reactions.every_sunday_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"first\" && trigger.executionConditions[1] == \"day of month\"\'>{{\'profile_nav.settings.other.reactions.first_day_of_month_option\' | i18next}}</span> <span ng-if=\'trigger.executionConditions[0] == \"last\" && trigger.executionConditions[1] == \"day of month\"\'>{{\'profile_nav.settings.other.reactions.last_day_of_month_option\' | i18next}}</span> , {{ctrl.getExecutionTime(trigger.executionTime)}}</span></td><td ng-hide=\"trigger.edited === true\"><ul class=\"reaction-triggers\"><li ng-repeat=\"reaction in ctrl.getTriggerReactions(trigger)\">{{ reaction.title }}</li></ul></td><td ng-hide=\"trigger.edited === true\" class=\"text-center\"><i class=\"fa fa-check-circle\" ng-show=\"trigger.isEnabled\" tooltip=\"{{\'profile_nav.settings.other.triggers.this_trigger_is_enabled\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"trigger.edited === true\" class=\"controls text-right\"><i class=\"fa fa-spinner\" ng-show=\"reaction.loading\" ng-class=\"{\'fa-spin\' : reaction.loading}\"></i> <a ng-click=\"ctrl.openEditForm(trigger)\" ng-hide=\"reaction.loading\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"ctrl.removeTrigger(trigger)\" ng-hide=\"reaction.loading\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td colspan=\"4\" class=\"table-form-row\" ng-if=\"trigger.edited === true\"><trigger-form ng-model=\"trigger\" ng-scope=\"ctrl\"><div class=\"row\"><div class=\"col-xs-6 sublist-legend\" ng-hide=\"trigger.reactionFormOpened\">{{\'profile_nav.settings.other.triggers.run_tasks\' | i18next}}</div><div class=\"col-xs-6 text-right\" ng-hide=\"trigger.reactionFormOpened\"><md-menu md-position-mode=\"target-right target\" ng-if=\"ctrl.getTriggerAvailableReactions(trigger).length > 0\" class=\"reaction-dropin-button\"><md-button class=\"md-button md-primary\" ng-click=\"ctrl.openMenu($mdOpenMenu, $event)\">{{\'profile_nav.settings.other.triggers.attach_existing_tasks\' | i18next}}</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"reaction in ctrl.getTriggerAvailableReactions(trigger)\"><md-button ng-click=\"ctrl.attachReactionToTrigger(trigger, reaction)\">{{reaction.title}}</md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-raised md-primary\" ng-click=\"ctrl.addReaction(trigger)\">{{\'profile_nav.settings.other.triggers.create_new_task\' | i18next}}</md-button></div></div><table class=\"table table-hover general-table table-editable\"><tbody><tr class=\"reaction-trigger\" ng-repeat=\"reaction in trigger.reactions\"><td ng-hide=\"reaction.edited === true\" class=\"col-xs-4\"><strong>{{ reaction.title }}</strong></td><td ng-hide=\"reaction.edited === true\" class=\"col-xs-4\">{{ reaction.description }}</td><td ng-hide=\"reaction.edited === true\" class=\"col-xs-2 text-right\"><i class=\"fa fa-check-circle\" ng-show=\"trigger.isEnabled\" tooltip=\"{{\'profile_nav.settings.other.reactions.this_reaction_is_enabled\' | i18next}}\" tooltip-append-to-body=\"true\"></i></td><td ng-hide=\"reaction.edited === true\" class=\"col-xs-2 controls text-right\"><a ng-click=\"ctrl.openReactionEditForm(trigger, reaction)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"ctrl.detachReactionFromTrigger(trigger, reaction)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td colspan=\"4\" class=\"table-form-row\" ng-if=\"reaction.edited === true\"><div class=\"row\"><div class=\"col-xs-12\"><reaction-form ng-model=\"reaction\" ng-scope=\"ctrl\"></reaction-form></div></div></td></tr></tbody></table></trigger-form></td></tr></tbody></table><div class=\"text-center full-width-padded-top full-width-padded-bottom\" ng-if=\"ctrl.reactions.length > 0 && ctrl.triggers.length === 0\">{{\'profile_nav.settings.other.reactions.you_do_not_have_any_triggers\' | i18next}}<br><a ng-click=\"ctrl.addTrigger()\">{{\'profile_nav.settings.other.reactions.create_first_one\' | i18next}}</a><br><br></div><div class=\"text-center full-width-padded-top full-width-padded-bottom\" ng-if=\"ctrl.reactions.length === 0 && ctrl.triggers.length === 0\">{{\'profile_nav.settings.other.reactions.set_up_areaction_to_automate_workflow_div\' | i18next}}<br><br></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-12 text-left\"><md-button class=\"md-raised md-success\" ng-click=\"ctrl.addTrigger()\">{{\'profile_nav.settings.other.triggers.add_trigger\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/payment_type_form_tpl.html","<div class=\"table-form\"><form name=\"paymentTypeForm\"><legend ng-if=\"paymentType.id\">{{\'profile_nav.settings.hotel_profile.payment_types.form.edit_payment_type_legend\' | i18next}}</legend><legend ng-if=\"!paymentType.id\">{{\'profile_nav.settings.hotel_profile.payment_types.form.create_payment_type_legend\' | i18next}}</legend><div class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"paymentType.name\" ng-disabled=\"paymentType.isSystem\" required=\"\"></md-input-container></div></div><div ng-if=\"!paymentType.isSystem\" class=\"row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.description\' | i18next}}</label> <input ng-model=\"paymentType.description\" required=\"\"></md-input-container></div></div><div ng-if=\"paymentType.isSystem\" class=\"row\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"paymentType.isActive\">{{\'general.filters.active\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"paymentType.sendToBookkeeping\">{{\'general.filters.send_to_bookkeeping\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-xs-12\"><md-checkbox ng-model=\"paymentType.sendReceiptToBookkeeping\">{{\'general.filters.send_receipt_to_bookkeeping\' | i18next}}</md-checkbox></div></div><div class=\"row\" ng-if=\"isAccountingCategoriesFeatureEnabled\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.accounting_category\' | i18next}}</label><md-select ng-model=\"paymentType.accountingCategoryId\"><md-option ng-repeat=\"accountingCategory in accountingCategories\" value=\"{{accountingCategory.id}}\">{{accountingCategory.name}}</md-option></md-select></md-input-container></div></div><div class=\"form-buttons\"><div class=\"row\"><div class=\"col-xs-12 text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"cancelAction()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveAction()\" ng-disabled=\"paymentTypeForm.$invalid || paymentType.loading\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : paymentType.loading}\" ng-if=\"paymentType.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></form></div>");
$templateCache.put("templates/settings/profile.details_tpl.html","<div ng-controller=\"Settings.DetailsController as DetailsCtrl\"><react-hotel-details is-admin=\"user.systemRole == \'admin\'\" countries=\"DetailsCtrl.countries\" currencies=\"DetailsCtrl.currencies\" timezones=\"DetailsCtrl.timezones\" hotel=\"DetailsCtrl.hotel\" on-save=\"DetailsCtrl.onSave\"></react-hotel-details></div>");
$templateCache.put("templates/settings/profile.pictures_tpl.html","<div ng-controller=\"Settings.PicturesController as PicturesCtrl\"><legend class=\"header\">Pictures <i class=\"fa fa-spinner fa-spin\" ng-hide=\"PicturesCtrl.loaded\"></i></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-hover general-table table-editable\"><thead><tr><th class=\"col-xs-4\">Photo</th><th class=\"col-xs-3\">Room Type</th><th class=\"col-xs-3\">Description</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"Picture in PicturesCtrl.pictures\"><td colspan=\"4\" ng-show=\"$index == PicturesCtrl.editedPicture\"><settings-picture-form ng-model=\"Picture\" ng-scope=\"PicturesCtrl\"></settings-picture-form></td><td ng-hide=\"$index == PicturesCtrl.editedPicture\"><img ng-src=\"{{Picture.picture}}\"></td><td ng-hide=\"$index == PicturesCtrl.editedPicture\">{{PicturesCtrl.getRoomTypeTitle(Picture.roomTypeId)}}</td><td ng-hide=\"$index == PicturesCtrl.editedPicture\">{{Picture.description}}</td><td ng-hide=\"$index == PicturesCtrl.editedPicture\" class=\"controls text-right\"><a ng-click=\"PicturesCtrl.openEditForm($index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"PicturesCtrl.removePicture($index)\"><i tooltip=\"Remove\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr></tbody><tfoot><tr ng-show=\"PicturesCtrl.createFormVisible\"><td colspan=\"4\"><settings-picture-form ng-model=\"PicturesCtrl.newPicture\" ng-scope=\"PicturesCtrl\"></settings-picture-form></td></tr><tr><td colspan=\"4\"><a ng-click=\"PicturesCtrl.openCreateForm()\" class=\"control-link\"><i class=\"fa fa-plus\"></i> Add Picture</a></td></tr></tfoot></table></div></div>");
$templateCache.put("templates/settings/profile.properties_tpl.html","<div ng-controller=\"Settings.PropertiesController as PropertiesCtrl\"><react-hotel-properties hotel=\"hotel\" on-remove-property=\"PropertiesCtrl.removeProperty\" on-save-property=\"PropertiesCtrl.saveProperty\"></react-hotel-properties></div>");
$templateCache.put("templates/settings/profile.subscription_tpl.html","<div ng-controller=\"Settings.SubscriptionController as SubscriptionCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.subscription.subscription_legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\" ng-if=\"SubscriptionCtrl.subscribed === true\"><legend>Plan Info</legend><strong>Plan:</strong> {{SubscriptionCtrl.getPlanName(SubscriptionCtrl.subscription.plan_id)}}<br><strong>Status:</strong> {{SubscriptionCtrl.getStatusName(SubscriptionCtrl.subscription.status)}} <span ng-show=\"SubscriptionCtrl.subscription.status === \'in_trial\'\">(Expired at {{SubscriptionCtrl.subscription.trial_end | dateToMoment:\'D MMMM YYYY\'}})</span><br><br><br><legend>Card Info</legend><div ng-if=\"SubscriptionCtrl.card.last4\">Cardholder Name: {{SubscriptionCtrl.card.first_name}} {{SubscriptionCtrl.card.last_name}}<br>Card Ending at: {{SubscriptionCtrl.card.last4}}<br>Card status: {{SubscriptionCtrl.card.status}}<br></div><div ng-if=\"!SubscriptionCtrl.card.last4\">Payment method is not specified. Please, go into <a href=\"{{SubscriptionCtrl.portal_session}}\" target=\"_blank\">Customer Portal</a> and fill your card information.</div><br><br><br>More information about your subscription you can find at <a href=\"{{SubscriptionCtrl.portal_session}}\" target=\"_blank\">Customer Portal</a></div><div class=\"settings-body-block marged-bottom\" ng-if=\"SubscriptionCtrl.subscribed === false\">{{\'profile_nav.settings.hotel_profile.subscription.your_hotel_does_not_have_any_subscription_plan_div\' | i18next}}</div></div>");
$templateCache.put("templates/settings/rate_categories_tpl.html","<div ng-controller=\"rateCategoriesController as ctrl\" class=\"settings-body-block\"><react-rate-categories rate-categories=\"ctrl.filteredOrderedRC\" on-submit=\"ctrl.onSubmit\" on-delete=\"ctrl.onDelete\" on-move-up=\"ctrl.moveUp\" on-move-down=\"ctrl.moveDown\" is-admin=\"user.systemRole == \'admin\'\" cancellation-policies=\"ctrl.cancellationPolicies\" currency-profiles=\"ctrl.currencyProfiles\" available-extras=\"ctrl.availableExtras\" new-taxes=\"ctrl.newTaxes\" is-owner=\"user.isOwner == true\" is-manager=\"user.isManager=user.aclRole == \'manager\'\" is-corporate-role-owner=\"user.corporateRole == \'owner\'\" is-corporate-role-manager=\"user.corporateRole == \'manager\'\" min-stay-through-visible=\"ctrl.minStayThroughVisible\" min-stay-arrival-visible=\"ctrl.minStayArrivalVisible\" max-stay-visible=\"ctrl.maxStayVisible\" closed-to-arrival-visible=\"ctrl.closedToArrivalVisible\" closed-to-departure-visible=\"ctrl.closedToDepartureVisible\" stop-sell-visible=\"ctrl.stopSellVisible\" is-accounting-categories-feature-enabled=\"ctrl.isAccountingCategoriesFeatureEnabled\" accounting-categories=\"ctrl.accountingCategories\" room-representations=\"ctrl.roomRepresentations\" hotel-room-rates=\"ctrl.hotelRoomRates\" rate-category-loading=\"ctrl.rateCategoryLoading\" show-special-offers=\"ctrl.showSpecialOffers\" show-expired=\"ctrl.showExpired\" handle-special-offers=\"ctrl.handleSpecialOffers\" handle-expired-rates=\"ctrl.handleExpiredRates\" on-load-hotel-extras=\"ctrl.onLoadHotelExtras\" locales=\"ctrl.locales\" locale=\"ctrl.locale\"></react-rate-categories></div>");
$templateCache.put("templates/settings/room_rates_tpl.html","<div class=\"settings-body-block marged-top marged-bottom no-padded-bottom\"><div ng-controller=\"RoomRatesController as ctrl\"><react-room-rates-combinations rate-categories=\"ctrl.rateCategories\" room-representations=\"ctrl.roomRepresentations\" seasons=\"ctrl.seasons\" room-rates=\"ctrl.roomRates\" hide-fields=\"ctrl.hideFields\" cancellation-policies=\"ctrl.cancellationPolicies\" hotel-settings=\"ctrl.hotelSettings\" on-save=\"ctrl.onSave\" on-room-rate-removed=\"ctrl.onRoomRateRemoved\" on-room-rate-changed=\"ctrl.onRoomRateChanged\" on-save-new-room-rate-combination=\"ctrl.onSaveNewRoomRateCombination\" on-save-edit-room-rate-combination=\"ctrl.onSaveEditRoomRateCombination\" manual-modification-enabled=\"ctrl.manualModificationsEnabled\"></react-room-rates-combinations></div></div>");
$templateCache.put("templates/settings/season_calendar_tpl.html","<div class=\"fullYearCalendar\"><div class=\"fullYearCalendar-header text-center\"><i class=\"fa fa-chevron-left pull-left\" ng-click=\"prevYear()\"></i> <i class=\"fa fa-chevron-right pull-right\" ng-click=\"nextYear()\"></i> {{year}}</div><div class=\"fullYearCalendar-months\"><div class=\"fullYearCalendar-month\" ng-repeat=\"month in months\"><div class=\"fullYearCalendar-monthTitle\">{{month.title}}</div><div class=\"fullYearCalendar-dates\"><div ng-repeat=\"day in month.dates\" class=\"fullYearCalendar-date {{\'fullYearCalendar-\' + day.weekday}} {{\'fullYearCalendar-week-\' + day.weekrow}}\" ng-class=\"{\'selected\' : selection_in_progress && day.date >= selection_start_date && day.date <= selection_end_date}\" ng-mouseenter=\"mouseEnter($event,day.seasonID)\" ng-mouseleave=\"mouseLeave($event,day.seasonID)\" ng-mousedown=\"mouseDown(day.date)\" ng-mouseup=\"mouseUp(day.date)\" ng-mousemove=\"mouseMove(day.date)\" style=\"background-color: #{{day.bgColor}};color: #{{day.color}};\">{{day.date | dateToMoment:\"DD\"}}</div></div></div></div></div>");
$templateCache.put("templates/settings/system.calendar_settings_tpl.html","<div ng-controller=\"Settings.CalendarSettingsController as CalendarSettingsCtrl\" class=\"calendar-settings\"><div class=\"settings-body-block\"><div class=\"full-width-block\"><strong class=\"subblock-header\">{{\'profile_nav.settings.hotel_profile.calendar.calendar_legend\' | i18next}}</strong><div class=\"settings-padded-content\"><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.room_blocker_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.blockerColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.blockerColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.booking_unpiad_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingUnpaidColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingUnpaidColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.booking_paid_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingPaidColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingPaidColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.booking_partially_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingPartiallyColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingPartiallyColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.booking_company_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingCompanyColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingCompanyColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.booking_group_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingGroupColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.bookingGroupColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'profile_nav.settings.hotel_profile.calendar.weekend_border_color\' | i18next}}</label> <input type=\"text\" ng-model=\"CalendarSettingsCtrl.calendarSetting.weekendBorderColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"CalendarSettingsCtrl.calendarSetting.weekendBorderColor\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.useRoundedCorners\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.use_rounded_corners\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.use_rounded_corners\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.useShiftDisplay\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.use_shift_display\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.use_shift_display\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.useShiftCreate\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.use_shift_create\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.use_shift_create\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.useFixedWidthZoom\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.use_fixed_width_zoom\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.use_fixed_width_zoom\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.showSeasonsInCalendar\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.show_seasons_in_calendar\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.show_seasons_in_calendar\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.showChannelCode\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.show_channel_code\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.show_channel_code\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.showLastNameFirst\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.show_last_name_first\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.show_last_name_first\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.hideCancellationArea\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.hide_cancellation_area\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.hide_cancellation_area\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"CalendarSettingsCtrl.calendarSetting.showWaitlist\" aria-label=\"{{\'profile_nav.settings.hotel_profile.calendar.show_waitlist\' | i18next}}\">{{\'profile_nav.settings.hotel_profile.calendar.show_waitlist\' | i18next}}</md-checkbox></div></div></div></div></div><div class=\"text-right toolbar spinned marged-bottom\"><div class=\"row\"><div class=\"col-xs-6 text-left\"><md-button class=\"md-raised md-primary\" ng-click=\"CalendarSettingsCtrl.reset()\">{{\'bookings.create_booking.reset_button\' | i18next}}</md-button></div><div class=\"col-xs-6 text-right\"><md-button class=\"md-raised md-success\" ng-click=\"CalendarSettingsCtrl.save()\" ng-disabled=\"CalendarSettingsCtrl.loading\"><i class=\"fa fa-save\" ng-hide=\"CalendarSettingsCtrl.loading\"></i> <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : CalendarSettingsCtrl.loading}\" ng-show=\"CalendarSettingsCtrl.loading\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></div></div>");
$templateCache.put("templates/settings/system.hotel_features_tpl.html","<div ng-controller=\"Settings.HotelFeaturesController as HotelFeaturesCtrl\"><legend class=\"header\">{{\'profile_nav.settings.sidebar.hotel_profile.features\' | i18next}}</legend><div class=\"settings-body-block\"><table class=\"table table-hover general-table table-editable\"><thead><tr><th class=\"col-xs-8\">{{\'general.other.name\' | i18next}}</th><th class=\"col-xs-1\">{{\'general.filters.active\' | i18next}}</th></tr></thead><tbody><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_housekeeping_features\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.housekeepingEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.modify_housekeeping_status_enabled\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.modifyHousekeepingStatusEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.modify_room_rate_combination_enabled\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.modifyRoomRateCombinationsEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_sale_channels_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.saleChannelsFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_group_booking_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.groupBookingFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.use_checkin_pro_mode\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.useCheckinProMode\"></md-checkbox></td></tr><tr ng-if=\"HotelFeaturesCtrl.hotel.depositFeatureEnabledShow\"><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_deposit_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.depositFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.split_payments_in_credit_report_export\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.splitPaymentsInCreditReportExport\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_accounting_categories_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.accountingCategoriesFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_accounting_report_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.accountingReportFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.allow_change_invoice_date_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.allowChangeInvoiceDateFeature\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.allow_change_invoice_number_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.allowChangeInvoiceNumberFeature\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.allow_change_payment_feature\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.allowChangePaymentFeature\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.foreign_invoices_feature_enabled\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.foreignInvoicesFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.create_new_extra_via_booking_enabled\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.createNewExtraViaBookingEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.multi_room_inventory_table\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.multiRoomInventoryTableFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.show_payment_terminals\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.paymentTerminalEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.show_three_column_dashboard\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.threeColumnDashboardEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.return_room_rates_with_hotel\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.showRoomRate\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.enable_travia_customer_lookup\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.traviaCustomerLookupFeatureEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.optimize_customer_search\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.optimizedCustomersSearchFeatureEnabled\"></md-checkbox></td></tr></tbody></table><br><h4>{{\'bookings.folios.superadmin_only_settings\' | i18next}}</h4><table class=\"table table-hover general-table table-editable\" ng-show=\"user.systemRole == \'admin\'\"><thead><tr><th>{{\'general.other.name\' | i18next}}</th><th>{{\'general.filters.active\' | i18next}}</th></tr></thead><tbody><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.wihp_enabled\' | i18next}}</td><td><md-checkbox ng-model=\"HotelFeaturesCtrl.hotel.addons.wihpEnabled\"></md-checkbox></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.google_platform_id\' | i18next}}</td><td><md-input-container><input type=\"text\" ng-model=\"HotelFeaturesCtrl.hotel.addons.googlePlatformId\" aria-label=\"Google Platform Id\" ng-disabled=\"!HotelFeaturesCtrl.hotel.addons.wihpEnabled\"></md-input-container></td></tr><tr><td>{{\'profile_nav.settings.hotel_profile.hotel_details.wihp_id\' | i18next}}</td><td><md-input-container><input type=\"text\" ng-model=\"HotelFeaturesCtrl.hotel.addons.wihpId\" aria-label=\"WIHP ID\" ng-disabled=\"!HotelFeaturesCtrl.hotel.addons.wihpEnabled\"></md-input-container></td></tr></tbody></table></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-disabled=\"HotelFeaturesCtrl.loading\" ng-click=\"HotelFeaturesCtrl.save()\"><i class=\"fa fa-spinner\" ng-show=\"HotelFeaturesCtrl.loading\" ng-class=\"{\'fa-spin\' : HotelFeaturesCtrl.loading}\"></i>{{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/settings/system.i18n_settings_tpl.html","<div ng-controller=\"Settings.I18nSettingsController as I18nSettingsCtrl\"><legend class=\"header\">{{\'profile_nav.settings.hotel_profile.i18n_settings.i18n_settings_legend\' | i18next}}<locale-selector change=\"I18nSettingsCtrl.changeLang\"></locale-selector></legend><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.hotel_profile.i18n_settings.default_language_label\' | i18next}}<br></legend><md-input-container><label>{{\'profile_nav.settings.hotel_profile.i18n_settings.default_language_label\' | i18next}}</label><md-select ng-model=\"hotel.locale\"><md-optgroup label=\"Default locale\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in I18nSettingsCtrl.possibleLocales | filter:{is_production:true}\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-disabled=\"I18nSettingsCtrl.saving\" ng-click=\"I18nSettingsCtrl.saveDefaultLocale(hotel.locale)\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block\"><legend>{{\'profile_nav.settings.hotel_profile.i18n_settings.supported_locales_legend\' | i18next}}<br><small>{{\'profile_nav.settings.hotel_profile.i18n_settings.supported_locales_description_legend\' | i18next}}</small></legend><md-input-container><label>{{\'profile_nav.settings.hotel_profile.i18n_settings.locales_label\' | i18next}}</label><md-select ng-model=\"hotel.locales\" multiple=\"\"><md-optgroup label=\"Locales\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in I18nSettingsCtrl.possibleLocales | filter:{is_production:true}\" ng-disabled=\"hotel.locale == locale.code\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-disabled=\"I18nSettingsCtrl.saving\" ng-click=\"I18nSettingsCtrl.save()\">{{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block marged-bottom ng-hide\"><legend>Custom Email Templates<br><small>Here you can brand and customize templates per locale</small></legend><table class=\"table table-striped\"><thead><tr><th>Type</th><th class=\"controls\"></th></tr></thead><tbody><tr ng-repeat=\"template in hotel.customEmailTemplates\"><td ng-hide=\"$index == I18nSettingsCtrl.edited\">{{template.emailType}}</td><td ng-hide=\"$index == I18nSettingsCtrl.edited\" class=\"controls\"><a ng-click=\"I18nSettingsCtrl.editEmailTemplate($index)\"><i tooltip=\"Edit\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"I18nSettingsCtrl.removeEmailTemplate($index)\"><i tooltip=\"Remove\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td><td ng-show=\"$index == I18nSettingsCtrl.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>Type</label><md-select ng-model=\"template.emailType\"><md-option ng-repeat=\"type in I18nSettingsCtrl.emailTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><md-input-container class=\"field-with-dropins\"><label>Subject</label> <input data-role=\"templateEditSubject{{$index}}\" class=\"md-input\" type=\"text\" ng-model=\"template.subject\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button for-template\"><md-button aria-label=\"Open menu\" class=\"md-button\" ng-click=\"I18nSettingsCtrl.openMenu($mdOpenMenu, $event)\">Drop In`s</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in I18nSettingsCtrl.dropins\"><md-button ng-click=\"I18nSettingsCtrl.insertDropIn(\'templateEditSubject\'+$parent.$index, dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu></md-input-container><div class=\"form-group form-group-with-dropins\"><label>Template</label><locale-selector-next></locale-selector-next><summernote ng-model=\"template.template\" data-role=\"templateEditTextarea{{$index}}\"></summernote><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button for-template\"><md-button aria-label=\"Open menu\" class=\"md-button\" ng-click=\"I18nSettingsCtrl.openMenu($mdOpenMenu, $event)\">Drop In`s</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in I18nSettingsCtrl.dropins\"><md-button ng-click=\"I18nSettingsCtrl.insertDropIn(\'templateEditTextarea\'+$parent.$index, dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"I18nSettingsCtrl.closeEditedEmailTemplate($event, $index)\">Cancel</md-button><md-button class=\"md-raised md-success\" ng-click=\"I18nSettingsCtrl.saveEditedEmailTemplate($event, template, $index)\">Save</md-button></div></div></td></tr></tbody></table><div class=\"new-email-template-form table-form\" ng-show=\"I18nSettingsCtrl.addNewEmailTemplate\"><md-input-container><label>Type</label><md-select ng-model=\"I18nSettingsCtrl.newEmailTemplate.emailType\"><md-option ng-repeat=\"type in I18nSettingsCtrl.emailTypes\" value=\"{{type}}\">{{type}}</md-option></md-select></md-input-container><md-input-container class=\"field-with-dropins\"><label>Subject</label> <input data-role=\"templateCreateSubject\" class=\"md-input\" type=\"text\" ng-model=\"I18nSettingsCtrl.newEmailTemplate.subject\"><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button for-template\"><md-button aria-label=\"Open menu\" class=\"md-button\" ng-click=\"I18nSettingsCtrl.openMenu($mdOpenMenu, $event)\">Drop In`s</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in I18nSettingsCtrl.dropins\"><md-button ng-click=\"I18nSettingsCtrl.insertDropIn(\'templateCreateSubject\', dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu></md-input-container><div class=\"form-group form-group-with-dropins\"><label>Template</label><locale-selector-next></locale-selector-next><summernote ng-model=\"I18nSettingsCtrl.newEmailTemplate.template\" data-role=\"templateCreateTextarea\"></summernote><md-menu md-position-mode=\"target-right target\" class=\"email-dropin-button for-template\"><md-button aria-label=\"Open menu\" class=\"md-button\" ng-click=\"I18nSettingsCtrl.openMenu($mdOpenMenu, $event)\">Drop In`s</md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"dropin in I18nSettingsCtrl.dropins\"><md-button ng-click=\"I18nSettingsCtrl.insertSummernoteDropIn(\'templateCreateTextarea\', dropin[1])\">{{dropin[0]}}</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"text-right form-buttons marged-top\"><md-button class=\"md-raised md-warn\" ng-click=\"I18nSettingsCtrl.closeAddEmailTemplateForm()\">Cancel</md-button><md-button class=\"md-raised md-success\" ng-click=\"I18nSettingsCtrl.saveAddEmailTemplateForm()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> Save</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"I18nSettingsCtrl.openAddEmailTemplateForm()\"><i class=\"fa fa-plus\"></i> Add email template</md-button></div></div></div>");
$templateCache.put("templates/scheduler/booking_room_detailed_form_tpl.html","<form name=\"bookingRoomForm\"><ng-form name=\"roomDetailsForm\"><md-content md-theme=\"docs-dark\"><div class=\"form-row\"><div class=\"row fields-column\"><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-down\"></i> {{\'bookings.create_booking.booking_form.check_in_date_label\' | i18next}}</label><md-datepicker name=\"checkin_date\" ng-model=\"ctrl.room.checkin_date\" ng-change=\"ctrl.handleRoomCheckinDateChange()\" md-min-date=\"ctrl.prevDay\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-up\"></i> {{\'bookings.create_booking.booking_form.check_out_date_label\' | i18next}}</label><md-datepicker name=\"checkout_date\" ng-model=\"ctrl.room.checkout_date\" ng-change=\"ctrl.handleRoomCheckoutDateChange()\" md-min-date=\"ctrl.room.min_checkout_date\" md-max-date=\"ctrl.room.max_checkout_date\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-moon-o\"></i> {{\'general.other.nights\' | i18next}}</label><md-select name=\"number_of_nights\" ng-model=\"ctrl.room.number_of_nights\" ng-change=\"ctrl.handleNumberOfNightsChange()\"><md-option ng-repeat=\"night in ctrl.room.nights_select\" value=\"{{night}}\">{{night}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-clock-o\"></i> {{\'general.other.arrival\' | i18next}}</label><md-select name=\"checkin_time\" ng-model=\"ctrl.room.checkin_time\"><md-option ng-repeat=\"time in ctrl.times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container></div></div></div><div class=\"form-row\"><div class=\"row fields-column\"><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_rate_label\' | i18next}}</label><md-select name=\"rate_category_id\" ng-model=\"ctrl.room.rateCategoryId\" ng-change=\"ctrl.handleRateCategoryIdChange()\" required=\"\"><md-option ng-value=\"rateCategory.id\" ng-repeat=\"rateCategory in ctrl.availableRateCategories track by rateCategory.id\" ng-selected=\"ctrl.room.rateCategoryId == rateCategory.id\" ng-class=\"{\'unapplicable\' : rateCategory.applicable == 0}\">{{rateCategory.name}} <span ng-if=\"rateCategory.applicable == 0\">({{\'bookings.create_booking.booking_form.restrictions_does_not_match\' | i18next}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'general.other.cancellation_policy\' | i18next}}</label><md-select name=\"cancellation_policy_id\" class=\"error-forced\" ng-model=\"ctrl.room.cancellation_policy_id\" required=\"\"><md-option ng-repeat=\"policy in ctrl.policies\" value=\"{{policy.id}}\">{{policy.title}}</md-option></md-select></md-input-container></div></div></div><div class=\"form-row\"><div class=\"row fields-column\"><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_type_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.cover_room_type\" ng-change=\"ctrl.handleCoverRoomTypeChange()\" required=\"\"><md-option ng-repeat=\"cover_room_type in ctrl.availableCoverRoomTypes\" ng-value=\"cover_room_type\" ng-selected=\"cover_room_type.id == ctrl.room.cover_room_type.id\">{{cover_room_type.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.room_selection_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.room_id\" ng-change=\"ctrl.handleRoomIdChange()\" required=\"\"><md-option ng-repeat=\"room in ctrl.availableRooms\" value=\"{{room.id}}\" ng-class=\"{\'unapplicable\' : room.applicable == 0}\">{{room.number}} <span ng-if=\"room.applicable == 0\">({{ctrl.room_types_by_id[room.roomTypeId].name}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-male\"></i> {{\'bookings.create_booking.booking_form.adults_label\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.recommendedMaxAdults}}</label><md-select ng-model=\"ctrl.room.number_of_adults\" ng-change=\"ctrl.handleNumberOfAdultsChange()\"><md-option ng-repeat=\"adult in ctrl.adults_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-child\"></i> {{\'general.other.children\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.recommendedMaxChildren}}</label><md-select ng-model=\"ctrl.room.number_of_children\" ng-change=\"ctrl.handleNumberOfChildrenChange()\"><md-option ng-repeat=\"child in ctrl.child_select\" value=\"{{child}}\">{{child}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container ng-if=\"!ctrl.booking.isForeignAmount\"><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"ctrl.room.total_price\" min=\"0\" ng-change=\"ctrl.handleRoomTotalPriceChange()\"></md-input-container><md-input-container ng-if=\"ctrl.booking.isForeignAmount\"><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"ctrl.room.total_foreign_amount\" min=\"0\" ng-change=\"ctrl.handleRoomTotalForeignAmountChange()\"></md-input-container><span class=\"currency-char\" ng-if=\"ctrl.currencySymbol && ctrl.currencySymbol.length < 2\">{{ctrl.currencySymbol}}</span> <i ng-click=\"ctrl.handleResetNightPricesClick()\" class=\"fa fa-undo reset-total-icon\" role=\"button\" aria-hidden=\"false\" title=\"{{\'bookings.create_booking.reset_button\' | i18next}}\"></i></div></div></div></md-content><div class=\"grey\"><div class=\"nights\"><legend>{{\'general.other.price_per_night\' | i18next}}: <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ctrl.loadNights || ctrl.loadRestrictions}\" ng-show=\"ctrl.loadNights || ctrl.loadRestrictions\"></i></legend><div class=\"row\"><div class=\"night form-block\" ng-repeat=\"night in ctrl.room.nights\"><md-input-container ng-if=\"!ctrl.booking.isForeignAmount\"><label>{{night.date | dateToMoment : \'ddd D\'}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"night.price\" min=\"0\" ng-change=\"ctrl.handleRoomNightPriceChange()\" onclick=\"this.select()\"></md-input-container><md-input-container ng-if=\"ctrl.booking.isForeignAmount\"><label>{{night.date | dateToMoment : \'ddd D\'}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"night.foreignAmount\" min=\"0\" ng-change=\"ctrl.handleRoomNightPriceChange()\" onclick=\"this.select()\"></md-input-container><span class=\"currency-char\" ng-if=\"ctrl.currencySymbol && ctrl.currencySymbol.length < 2\">{{ctrl.currencySymbol}}</span></div></div></div></div></ng-form><ng-form name=\"guestDetailsForm\"><div class=\"fields\"><legend class=\"booking-form__legend\">{{\'general.other.guest_info\' | i18next}}<div class=\"form-controls pull-right\"><a ng-if=\"ctrl.room.guest.id && ctrl.room.isGuestDirty\" ng-click=\"ctrl.handleResetGuestClick()\">Reset Changes</a> <a ng-click=\"ctrl.handleClearGuestClick()\">Clear</a></div></legend><div class=\"row form-row\"><div class=\"col-xs-6 form-block\"><md-autocomplete flex=\"\" md-input-name=\"first_name\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.first_name\" md-items=\"item in ctrl.searchGuest(\'first_name\')\" md-item-text=\"item.first_name\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.first_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6 form-block\"><md-autocomplete flex=\"\" required=\"\" md-input-name=\"last_name\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.last_name\" md-items=\"item in ctrl.searchGuest(\'last_name\')\" md-item-text=\"item.last_name\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.last_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row form-row\"><div class=\"col-xs-6 form-block form-block-icon\"><md-autocomplete flex=\"\" md-input-name=\"email\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.email\" md-items=\"item in ctrl.searchGuest(\'email\')\" md-item-text=\"item.email\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-floating-label=\"{{\'bookings.create_booking.autocomplete.email_floating_label\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6 form-block form-block-icon\"><md-autocomplete flex=\"\" md-input-name=\"phone\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.phone\" md-items=\"item in ctrl.searchGuest(\'phone\')\" md-item-text=\"item.mobile_phone\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-floating-label=\"{{\'general.other.phone_number\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row form-row\"><div class=\"col-xs-12 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-comment\"></i> {{\'bookings.create_booking.fields.guest_request_label\' | i18next}}</label> <input type=\"text\" ng-model=\"ctrl.room.note\"></md-input-container></div></div></div><div class=\"row form-row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" name=\"address\" ng-model=\"ctrl.room.guest.address\"></md-input-container></div></div><div class=\"row form-row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.create_booking.fields.city_or_town_label\' | i18next}}</label> <input type=\"text\" name=\"city\" ng-model=\"ctrl.room.guest.city\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select name=\"country\" ng-model=\"ctrl.room.guest.country\"><md-option ng-repeat=\"country in ctrl.countries\" value=\"{{country}}\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row form-row\"><div class=\"col-xs-6\" ng-show=\"ctrl.room.guest.country == \'United States\'\"><md-input-container><label>{{\'bookings.create_booking.fields.state_label\' | i18next}}</label> <input type=\"text\" name=\"state\" ng-model=\"ctrl.room.guest.state\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.postal_code\' | i18next}}</label> <input type=\"text\" name=\"zipCode\" ng-model=\"ctrl.room.guest.zipCode\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select name=\"locale\" ng-model=\"ctrl.room.guest.locale\"><md-optgroup label=\"Locales\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in ctrl.locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div></div></ng-form></form>");
$templateCache.put("templates/scheduler/booking_room_full_form_tpl.html","<md-content md-theme=\"docs-dark\"><div class=\"row\"><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-down\"></i> {{\'bookings.create_booking.booking_form.check_in_date_label\' | i18next}}</label><md-datepicker ng-model=\"ctrl.room.checkin_date\" ng-change=\"ctrl.handleRoomCheckinDateChange()\" md-min-date=\"ctrl.prevDay\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_rate_label\' | i18next}}</label><md-select ng-model=\"ctrl.room.rateCategoryId\" ng-change=\"ctrl.handleRateCategoryIdChange()\" required=\"\"><md-option ng-value=\"rateCategory.id\" ng-repeat=\"rateCategory in ctrl.availableRateCategories track by rateCategory.id\" ng-selected=\"ctrl.room.rateCategoryId == rateCategory.id\" ng-class=\"{\'unapplicable\' : rateCategory.applicable == 0}\">{{rateCategory.name}} <span ng-if=\"rateCategory.applicable == 0\">({{\'bookings.create_booking.booking_form.restrictions_does_not_match\' | i18next}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-male\"></i> {{\'bookings.create_booking.booking_form.adults_label\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.recommendedMaxAdults}}</label><md-select ng-model=\"ctrl.room.number_of_adults\" ng-change=\"ctrl.handleNumberOfAdultsChange()\"><md-option ng-repeat=\"adult in ctrl.adults_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-child\"></i> {{\'general.other.children\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.recommendedMaxChildren}}</label><md-select ng-model=\"ctrl.room.number_of_children\" ng-change=\"ctrl.handleNumberOfChildrenChange()\"><md-option ng-repeat=\"child in ctrl.child_select\" value=\"{{child}}\">{{child}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-up\"></i> {{\'bookings.create_booking.booking_form.check_out_date_label\' | i18next}}</label><md-datepicker ng-model=\"ctrl.room.checkout_date\" ng-change=\"ctrl.handleRoomCheckoutDateChange()\" md-min-date=\"ctrl.room.min_checkout_date\" md-max-date=\"ctrl.room.max_checkout_date\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_type_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.cover_room_type\" ng-change=\"ctrl.handleCoverRoomTypeChange()\" required=\"\"><md-option ng-repeat=\"cover_room_type in ctrl.availableCoverRoomTypes\" ng-value=\"cover_room_type\" ng-selected=\"cover_room_type.id == ctrl.room.cover_room_type.id\">{{cover_room_type.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-4 form-block form-block-checkbox\"><md-checkbox ng-model=\"ctrl.room.dont_move\" aria-label=\"{{\'bookings.create_booking.booking_form.do_not_move_label\' | i18next}}\">{{\'bookings.create_booking.booking_form.do_not_move_label\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-moon-o\"></i> {{\'general.other.nights\' | i18next}}</label><md-select ng-model=\"ctrl.room.number_of_nights\" ng-change=\"ctrl.handleNumberOfNightsChange()\"><md-option ng-repeat=\"night in ctrl.room.nights_select\" value=\"{{night}}\">{{night}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-clock-o\"></i> {{\'general.other.arrival\' | i18next}}</label><md-select ng-model=\"ctrl.room.checkin_time\"><md-option ng-repeat=\"time in ctrl.times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.room_selection_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.room_id\" ng-change=\"ctrl.handleRoomIdChange()\" required=\"\"><md-option ng-repeat=\"room in ctrl.availableRooms\" value=\"{{room.id}}\" ng-class=\"{\'unapplicable\' : room.applicable == 0}\">{{room.number}} <span ng-if=\"room.applicable == 0\">({{ctrl.room_types_by_id[room.roomTypeId].name}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'general.other.cancellation_policy\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.cancellation_policy_id\" required=\"\"><md-option ng-repeat=\"policy in ctrl.policies\" value=\"{{policy.id}}\">{{policy.title}}</md-option></md-select></md-input-container></div></div></md-content><div class=\"grey\"><div class=\"nights\"><legend>{{\'general.other.price_per_night\' | i18next}}: <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : ctrl.loadNights || ctrl.loadRestrictions}\" ng-show=\"ctrl.loadNights || ctrl.loadRestrictions\"></i></legend><md-button class=\"md-raised pull-right btn-reset\" ng-click=\"ctrl.handleResetNightPricesClick()\">{{\'bookings.create_booking.reset_button\' | i18next}}</md-button><div class=\"row\"><div class=\"night form-block\" ng-repeat=\"night in ctrl.room.nights\"><md-input-container><label>{{night.date | dateToMoment : \'ddd D\'}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"night.price\" min=\"0\" ng-change=\"ctrl.handleRoomNightPriceChange()\" onclick=\"this.select()\"></md-input-container><span class=\"currency-char\" ng-if=\"ctrl.currencySymbol && ctrl.currencySymbol.length < 2\">{{ctrl.currencySymbol}}</span></div></div></div><div class=\"total\"><md-input-container><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"ctrl.room.total_price\" min=\"0\" ng-change=\"ctrl.handleRoomTotalPriceChange()\" onclick=\"this.select()\"></md-input-container><span class=\"currency-char\" ng-if=\"ctrl.currencySymbol && ctrl.currencySymbol.length < 2\">{{ctrl.currencySymbol}}</span></div></div><ng-form name=\"guestDetailsForm\"><div class=\"fields\"><legend class=\"booking-form__legend\">{{\'general.other.guest_info\' | i18next}}<div class=\"pull-right\"><a ng-click=\"ctrl.clearGuestInfo(ctrl.room)\">Clear</a></div></legend><div class=\"row form-row\"><div class=\"col-xs-6 form-block\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.first_name\" md-items=\"item in ctrl.searchGuest(\'first_name\')\" md-item-text=\"item.first_name\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.first_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6 form-block\"><md-autocomplete flex=\"\" required=\"\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.last_name\" md-items=\"item in ctrl.searchGuest(\'last_name\')\" md-item-text=\"item.last_name\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-menu-class=\"guestNameSuggestions\" md-floating-label=\"{{\'general.other.last_name\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row form-row\"><div class=\"col-xs-6 form-block form-block-icon\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.email\" md-items=\"item in ctrl.searchGuest(\'email\')\" md-item-text=\"item.email\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-floating-label=\"{{\'bookings.create_booking.autocomplete.email_floating_label\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div><div class=\"col-xs-6 form-block form-block-icon\"><md-autocomplete flex=\"\" md-input-minlength=\"1\" md-search-text=\"ctrl.room.guest.phone\" md-items=\"item in ctrl.searchGuest(\'phone\')\" md-item-text=\"item.mobile_phone\" md-selected-item-change=\"ctrl.handleGuestChange(item)\" md-delay=\"500\" md-floating-label=\"{{\'general.other.phone_number\' | i18next}}\"><md-item-template><span>{{item.first_name}} {{item.last_name}} <small>{{item.email ? item.email : \'N/A\'}}<br>{{item.phone ? item.phone : \'N/A\'}}</small></span></md-item-template></md-autocomplete></div></div><div class=\"row form-row\"><div class=\"col-xs-12 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-comment\"></i> {{\'bookings.create_booking.fields.guest_request_label\' | i18next}}</label> <input type=\"text\" ng-model=\"ctrl.room.note\"></md-input-container></div></div></div><div class=\"row form-row\"><div class=\"col-xs-12\"><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" name=\"address\" ng-model=\"ctrl.room.guest.address\"></md-input-container></div></div><div class=\"row form-row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.create_booking.fields.city_or_town_label\' | i18next}}</label> <input type=\"text\" name=\"city\" ng-model=\"ctrl.room.guest.city\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.country\' | i18next}}</label><md-select ng-model=\"ctrl.room.guest.country\"><md-option ng-repeat=\"country in ctrl.countries\" value=\"{{country}}\">{{country}}</md-option></md-select></md-input-container></div></div><div class=\"row form-row\"><div class=\"col-xs-6\" ng-show=\"ctrl.room.guest.country == \'United States\'\"><md-input-container><label>{{\'bookings.create_booking.fields.state_label\' | i18next}}</label> <input type=\"text\" name=\"state\" ng-model=\"ctrl.room.guest.state\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'general.other.postal_code\' | i18next}}</label> <input type=\"text\" name=\"zipCode\" ng-model=\"ctrl.room.guest.zipCode\"></md-input-container></div><div class=\"col-xs-6\"><md-input-container><label>{{\'bookings.customer.preferred_locale\' | i18next}}</label><md-select ng-model=\"ctrl.room.guest.locale\"><md-optgroup label=\"Locales\"><md-option ng-value=\"locale.code\" ng-repeat=\"locale in ctrl.locales | filter:{is_production:true}\">{{locale.name}}</md-option></md-optgroup></md-select></md-input-container></div></div></ng-form>");
$templateCache.put("templates/scheduler/booking_room_short_form_tpl.html","<form name=\"bookingRoomForm\"><div class=\"room\"><div class=\"form-row form-row--main\"><div class=\"row fields-column\"><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_type_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.cover_room_type\" ng-change=\"ctrl.handleCoverRoomTypeChange()\" required=\"\"><md-option ng-repeat=\"cover_room_type in ctrl.availableCoverRoomTypes\" ng-value=\"cover_room_type\" ng-selected=\"cover_room_type.id == ctrl.room.cover_room_type.id\">{{cover_room_type.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.room_selection_label\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.room.room_id\" ng-change=\"ctrl.handleRoomIdChange()\" required=\"\"><md-option ng-repeat=\"room in ctrl.availableRooms\" value=\"{{room.id}}\" ng-class=\"{\'unapplicable\' : room.applicable == 0}\">{{room.number}} <span ng-if=\"room.applicable == 0\">({{ctrl.room_types_by_id[room.roomTypeId].name}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-male\"></i> {{\'bookings.create_booking.booking_form.adults_label\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.recommendedMaxAdults}}</label><md-select ng-model=\"ctrl.room.number_of_adults\" ng-change=\"ctrl.handleNumberOfAdultsChange()\"><md-option ng-repeat=\"adult in ctrl.adults_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-child\"></i> {{\'general.other.children\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.recommendedMaxChildren}}</label><md-select ng-model=\"ctrl.room.number_of_children\" ng-change=\"ctrl.handleNumberOfChildrenChange()\"><md-option ng-repeat=\"child in ctrl.child_select\" value=\"{{child}}\">{{child}}</md-option></md-select></md-input-container></div><div ng-if=\"ctrl.booking.isForeignAmount\" class=\"col-xs-2 form-block\"><md-input-container><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"ctrl.room.total_foreign_amount\" min=\"0\" ng-change=\"ctrl.handleRoomTotalForeignAmountChange()\"></md-input-container><i ng-click=\"ctrl.handleResetNightPricesClick()\" class=\"fa fa-undo reset-total-icon\" role=\"button\" aria-hidden=\"false\" title=\"{{\'bookings.create_booking.reset_button\' | i18next}}\"></i></div><div ng-if=\"!ctrl.booking.isForeignAmount\" class=\"col-xs-2 form-block\"><md-input-container><label>{{\'general.other.total\' | i18next}}</label> <input type=\"number\" ng-class=\"{\'currency\': ctrl.currencySymbol && ctrl.currencySymbol.length < 2}\" ng-model=\"ctrl.room.total_price\" min=\"0\" ng-change=\"ctrl.handleRoomTotalPriceChange()\"></md-input-container><span class=\"currency-char\" ng-if=\"ctrl.currencySymbol && ctrl.currencySymbol.length < 2\">{{ctrl.currencySymbol}}</span> <i ng-click=\"ctrl.handleResetNightPricesClick()\" class=\"fa fa-undo reset-total-icon\" role=\"button\" aria-hidden=\"false\" title=\"{{\'bookings.create_booking.reset_button\' | i18next}}\"></i></div></div><div class=\"actions-column\"><a ng-click=\"ctrl.handleEditClick()\"><i class=\"fa fa-edit\" role=\"button\" aria-hidden=\"false\"></i></a> <a ng-class=\"{\'disabled\': ctrl.booking.rooms.length == 1}\" ng-click=\"ctrl.handleDeleteClick()\"><i class=\"fa fa-times\" role=\"button\" aria-hidden=\"false\"></i></a></div></div></div></form><div class=\"room-summary\"><div class=\"summary-item\"><div class=\"summary-item-title\">{{\'bookings.create_booking.booking_form.check_in_date_label\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.room.checkin_date | dateToMoment:\'DD MMM YYYY\'}}</div></div><div class=\"summary-item\"><div class=\"summary-item-title\">{{\'bookings.create_booking.booking_form.check_out_date_label\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.room.checkout_date | dateToMoment:\'DD MMM YYYY\'}}</div></div><div class=\"summary-item\"><div class=\"summary-item-title\">{{\'general.other.nights\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.room.nights.length}}</div></div><div ng-if=\"ctrl.room.checkin_time\" class=\"summary-item\"><div class=\"summary-item-title\">{{\'general.other.arrival\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.room.checkin_time}}</div></div><div class=\"summary-item\"><div class=\"summary-item-title\">{{\'general.other.room_rate\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.rateCategories[ctrl.room.rateCategory.id]}}</div></div><div class=\"summary-item\"><div class=\"summary-item-title\">{{\'general.other.cancellation_policy\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.cancellationPolicies[ctrl.room.cancellation_policy_id]}}</div></div><div class=\"summary-item\" ng-class=\"{\'no-guest\': !ctrl.room.guest.first_name && !ctrl.room.guest.last_name && !ctrl.room.guest_id}\"><div class=\"summary-item-title\">{{\'bookings.room_edit.guest_legend\' | i18next}}</div><div ng-if=\"!ctrl.room.guest.first_name && !ctrl.room.guest.last_name && !ctrl.room.guest_id\" class=\"summary-item-value\">{{\'general.other.no_with_capital_letter\' | i18next}}</div><div class=\"summary-item-value\">{{ctrl.room.guest.first_name}} {{ctrl.room.guest.last_name}}</div></div></div>");
$templateCache.put("templates/scheduler/booking_room_type_short_form_tpl.html","<form name=\"bookingRoomForm\"><div class=\"room\"><div class=\"row\"><div class=\"section-header\"><legend class=\"booking-form__legend booking-form__legend--rooms\">{{ ctrl.roomType.name }}</legend></div></div><div class=\"form-row form-row--main\"><div class=\"row fields-column\"><div class=\"col-xs-3 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-male\"></i> {{\'bookings.create_booking.booking_form.adults_label\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.roomType.maxAdults}}</label><md-select ng-model=\"ctrl.roomType.number_of_adults\" ng-disabled=\"ctrl.roomType.availableRooms.length == 0\"><md-option ng-repeat=\"adult in ctrl.adults_select\" value=\"{{adult}}\">{{adult}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-child\"></i> {{\'general.other.children\' | i18next}} {{\'general.other.max\' | i18next}} {{ctrl.roomType.maxChildren}}</label><md-select ng-model=\"ctrl.roomType.number_of_children\" ng-change=\"ctrl.handleNumberOfChildrenChange()\" ng-disabled=\"ctrl.roomType.availableRooms.length == 0\"><md-option ng-repeat=\"child in ctrl.child_select\" value=\"{{child}}\">{{child}}</md-option></md-select></md-input-container></div><div class=\"col-xs-3 form-block\"><md-input-container><label>{{\'general.other.number_of_rooms\' | i18next}}</label> <input type=\"number\" ng-model=\"ctrl.roomType.number_of_rooms\" min=\"1\" max=\"{{ctrl.roomType.availableRooms.length}}\" ng-disabled=\"ctrl.roomType.availableRooms.length == 0\"></md-input-container></div><div class=\"col-xs-3 text-right\"><p ng-style=\"(ctrl.roomType.availableRooms.length < 1) && {\'color\':\'red\'}\">Available: {{ctrl.roomType.availableRooms.length}}</p><p>In basket: {{ctrl.roomType.basketRooms.length}}</p></div></div></div><div class=\"row text-center\"><md-button aria-label=\"{{\'bookings.create_booking.room_tabs.add_room_link\' | i18next}}\" class=\"md-button\" ng-click=\"ctrl.addRooms()\" ng-disabled=\"ctrl.roomType.availableRooms.length == 0\"><span class=\"add-room\"><i class=\"fa fa-plus-circle\"></i> {{\'general.other.add_to_basket\' | i18next}}</span></md-button><md-button aria-label=\"{{\'bookings.create_booking.room_tabs.add_room_link\' | i18next}}\" class=\"md-button\" ng-click=\"ctrl.removeAllRooms()\" ng-disabled=\"ctrl.roomType.basketRooms.length == 0\"><span class=\"remove-room\"><i class=\"fa fa-minus-circle\"></i> {{\'general.other.remove_all_from_basket\' | i18next}}</span></md-button></div></div></form>");
$templateCache.put("templates/scheduler/group_booking_common_fields_form_tpl.html","<md-content md-theme=\"docs-dark\"><div class=\"row\"><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-down\"></i> {{\'bookings.create_booking.booking_form.check_in_date_label\' | i18next}}</label><md-datepicker ng-model=\"ctrl.checkinDate\" ng-change=\"ctrl.checkinDateChange()\" md-min-date=\"ctrl.checkinMinDate\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-4 form-block date-col form-block-icon\"><label class=\"datepicker\"><i class=\"fa fa-arrow-up\"></i> {{\'bookings.create_booking.booking_form.check_out_date_label\' | i18next}}</label><md-datepicker ng-model=\"ctrl.checkoutDate\" ng-change=\"ctrl.checkoutDateChange()\" md-min-date=\"ctrl.checkoutMinDate\" md-theme=\"docs-dark\"></md-datepicker></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-moon-o\"></i> {{\'general.other.nights\' | i18next}}</label><md-select ng-model=\"ctrl.numberOfNights\" ng-change=\"ctrl.numberOfNightsChange()\"><md-option ng-repeat=\"night in ctrl.numberOfNightsCollection\" value=\"{{night}}\">{{night}}</md-option></md-select></md-input-container></div><div class=\"col-xs-2 form-block form-block-icon\"><md-input-container><label><i class=\"fa fa-clock-o\"></i> {{\'general.other.arrival\' | i18next}}</label><md-select ng-model=\"ctrl.checkinTime\" ng-change=\"ctrl.checkInTimeChange()\"><md-option ng-repeat=\"time in ctrl.checkinTimeCollection\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container></div></div><div class=\"row\"><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'bookings.create_booking.booking_form.available_room_rate_label\' | i18next}}</label><md-select ng-model=\"ctrl.rateCategoryId\" ng-change=\"ctrl.rateCategoryIdChange()\" required=\"\"><md-option ng-value=\"rateCategory.id\" ng-repeat=\"rateCategory in ctrl.rateCategoryCollection track by rateCategory.id\" ng-selected=\"ctrl.rateCategoryId == rateCategory.id\" ng-class=\"{\'unapplicable\' : rateCategory.applicable == 0}\">{{rateCategory.name}} <span ng-if=\"rateCategory.applicable == 0\">({{\'bookings.create_booking.booking_form.restrictions_does_not_match\' | i18next}})</span></md-option></md-select></md-input-container></div><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'general.other.cancellation_policy\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"ctrl.cancellationPolicyId\" ng-change=\"ctrl.cancellationPolicyIdChange()\" required=\"\"><md-option ng-repeat=\"policy in ctrl.cancellationPolicyCollection\" value=\"{{policy.id}}\">{{policy.title}}</md-option></md-select></md-input-container></div></div></md-content>");
$templateCache.put("templates/reports/accounting-report_tpl.html","<div ng-controller=\"Reports.AccountingReportCtrl as report\"><legend class=\"header\">{{\'reports.accounting_report.legend\' | i18next}} <a class=\"help-button\" ng-click=\"report.help_opened = !report.help_opened;\"><i class=\"fa fa-question-circle-o\"></i></a> <span class=\"printVisible\">{{\'reports.general.from_legend_span\' | i18next}} {{report.dateFrom | dateToMoment:\'DD MMM YYYY\'}} {{\'general.other.to\' | i18next}} {{report.dateTo | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button></div><div><div ng-if=\"report.help_opened\"><div class=\"alert alert-info\"><p>Report calculates statististics around 02:00 of local hotel time for previous day.</p><p>Accounting categories has following columns:</p><p><strong>Unpaid:</strong> All items that was added inside folio/invoices for day</p><p><strong>Paid:</strong> All items that was moved into receipts (i.e. covered with payment)</p><p><strong>Total unpaid:</strong> Cumullative total for unpaid column including current one</p><p><strong>Total paid:</strong> Cumullative total for paid column including current one</p><md-button class=\"md-raised close-help-btn\" ng-click=\"report.help_opened = false;\">{{\'general.buttons.close\' | i18next}}</md-button></div></div><div><md-checkbox ng-model=\"zeroUnpaid\" ng-change=\"handleDelta()\">Start Total Unpaid from 0</md-checkbox><md-checkbox ng-model=\"zeroPaid\" ng-change=\"handleDelta()\">Start Total Paid from 0</md-checkbox><md-checkbox ng-model=\"showDayTotal\">Show daily/total balance</md-checkbox><md-checkbox ng-model=\"showReceipedOnly\">Show only receiped items</md-checkbox></div><div class=\"sticky-table-div\"><table class=\"table accounting-table\"><thead><tr class=\"reports-small-header\"><th class=\"column-end\"></th><th colspan=\"{{ showReceipedOnly ? \'2\' : \'4\' }}\" class=\"column-end text-center\" ng-class=\"{\'payments-delimeter\': !categories[$index].isPayment && categories[$index + 1].isPayment}\" ng-repeat=\"category in categories\">{{category.name}}</th></tr><tr class=\"reports-small-header\"><th class=\"column-end\">{{\'general.other.date\' | i18next}}</th><th class=\"text-right\" ng-repeat-start=\"category in categories\" ng-if=\"!showReceipedOnly\"><span ng-if=\"!category.isPayment\">Unpaid</span> <span ng-if=\"category.isPayment\">Obtained Payments</span></th><th class=\"text-right border-right\"><span ng-if=\"!category.isPayment\">Paid</span> <span ng-if=\"category.isPayment\">Receiped Payments</span></th><th class=\"text-right\" ng-if=\"!showReceipedOnly\"><span ng-if=\"!category.isPayment\">Total Unpaid</span> <span ng-if=\"category.isPayment\">Total Obtained</span></th><th ng-repeat-end=\"\" class=\"column-end text-right\" ng-class=\"{\'payments-delimeter\': !categories[$index].isPayment && categories[$index + 1].isPayment}\"><span ng-if=\"!category.isPayment\">Total Paid</span> <span ng-if=\"category.isPayment\">Total Receiped</span></th></tr></thead><tbody><tr ng-repeat=\"(date, row_categories) in report_data\"><th class=\"column-end\"><a href=\"#/reports/end-of-day-report/{{date}}\">{{date | dateToMoment:\'DD MMM YYYY\'}}</a></th><td class=\"text-right\" ng-if=\"!showReceipedOnly\" ng-repeat-start=\"category in categories\" ng-style=\"{\'color\': colorNegativeAmounts(row_categories[category.id].unpaid)}\">{{::formatAmount(row_categories[category.id].unpaid)}}</td><td class=\"text-right border-right\" ng-style=\"{\'color\': colorNegativeAmounts(row_categories[category.id].paid)}\"><p>{{::formatAmount(row_categories[category.id].paid)}}</p><p ng-if=\"showDayTotal\" ng-style=\"{\'color\': colorNegativeAmounts(row_categories[category.id].daily)}\">{{::formatAmount(row_categories[category.id].daily)}}</p></td><td class=\"text-right\" ng-if=\"!showReceipedOnly\" ng-style=\"{\'color\': colorNegativeAmounts(row_categories[category.id].totalUnpaidDelta)}\">{{formatAmount(row_categories[category.id].totalUnpaidDelta)}}</td><td ng-repeat-end=\"\" class=\"text-right column-end\" ng-class=\"{\'payments-delimeter\': !categories[$index].isPayment && categories[$index + 1].isPayment}\" ng-style=\"{\'color\': colorNegativeAmounts(row_categories[category.id].totalPaidDelta)}\"><p>{{formatAmount(row_categories[category.id].totalPaidDelta)}}</p><p ng-if=\"showDayTotal\" ng-style=\"{\'color\': colorNegativeAmounts(row_categories[category.id].totalDelta)}\">{{formatAmount(row_categories[category.id].totalDelta)}}</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("templates/reports/booking-report_tpl.html","<div ng-controller=\"Reports.BookingReportCtrl as report\" class=\"report-page\"><legend class=\"header\">{{\'reports.booking_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.types_fo_reports.\' + type | i18next}} {{\'reports.general.from_legend_span\' | i18next}} {{dateFrom| dateToMoment:\'DD MMM YYYY\'}} {{\'general.other.to\' | i18next}} {{dateTo| dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\">{{\'inventory.filters_legend\' | i18next}}:<md-input-container><md-select ng-model=\"type\"><md-option ng-repeat=\"type in types\" value=\"{{type}}\">{{\'reports.general.types_fo_reports.\' + type | i18next}}</md-option></md-select></md-input-container><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.booking_source_th\' | i18next}}:</span><md-input-container><md-select ng-model=\"bookingSource\"><md-option ng-repeat=\"source in sources\" value=\"{{source}}\">{{source}}</md-option></md-select></md-input-container><md-checkbox ng-model=\"showCancelled\" aria-label=\"{{\'reports.general.show_cancelled\' | i18next}}\">{{\'reports.general.show_cancelled\' | i18next}}</md-checkbox><md-checkbox ng-model=\"dueGreaterZero\" aria-label=\"{{\'reports.general.show_due_greater_zero\' | i18next}}\">{{\'reports.general.show_due_greater_zero\' | i18next}}</md-checkbox></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.total_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_room_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalRoomRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_extras_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalExtrasRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_taxes_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalTaxesRevenue | customCurrency:2}}</td></tr><tr ng-repeat=\"(tax_name, tax_value) in report_data.taxes\"><td>{{tax_name}}:</td><td class=\"text-right\">{{tax_value | customCurrency:2}}</td></tr><tr><td colspan=\"2\"><strong>{{\'reports.booking_report.sources_td\' | i18next}}</strong></td></tr><tr ng-repeat=\"(source_name, source_data) in report_data.sources\"><td>{{source_name}}:</td><td class=\"text-right\">{{source_data.count}} ({{source_data.revenue | customCurrency:2}})</td></tr></table></div><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.online_credit_card_transactions_td\' | i18next}}</td><td class=\"text-right\">{{report_data.onlineCreditCardTransactions}}</td></tr><tr><td>{{\'reports.general.offline_credit_card_transactions_td\' | i18next}}</td><td class=\"text-right\">{{report_data.offlineCreditCardTransactions}}</td></tr><tr><td>{{\'reports.general.cash_transactions_td\' | i18next}}</td><td class=\"text-right\">{{report_data.cashTransactions}}</td></tr><tr><td>{{\'reports.general.other_transactions_td\' | i18next}}</td><td class=\"text-right\">{{report_data.otherTransactions}}</td></tr><tr class=\"other-payments\" ng-repeat=\"payment in report_data.customPayments\"><td>{{payment[0]}}</td><td class=\"text-right\">{{payment[1]}}</td></tr><tr><td>{{\'reports.general.total_transactions_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalTransactions}}</td></tr></table></div><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.total_online_card_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalOnlineCardRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_offline_card_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalOfflineCardRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_cash_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalCashRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_other_revenue_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalOtherRevenue | customCurrency:2}}</td></tr><tr class=\"other-payments\" ng-repeat=\"payment in report_data.customPayments\"><td>{{payment[0]}}</td><td class=\"text-right\">{{payment[2] | customCurrency:2}}</td></tr><tr><td></td><td></td></tr><tr><td>{{\'reports.general.total_paid_in_full_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalPaidInFull}}</td></tr><tr><td>{{\'reports.general.total_partially_paid_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalPartiallyPaid}} <span ng-if=\"report_data.totalPartiallyPaid\">({{\'general.other.due\' | i18next}}: {{report_data.totalPartiallySumm | customCurrency:2}})</span></td></tr><tr><td>{{\'reports.general.total_unpaid_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalUnpaid}} <span ng-if=\"report_data.totalUnpaid\">({{\'general.other.due\' | i18next}}: {{report_data.totalUnpaidSumm | customCurrency:2}})</span></td></tr></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-click=\"setOrderProperty(\'ourReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-click=\"setOrderProperty(\'channelReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.channel_reference_th\"></th><th ng-click=\"setOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setOrderProperty(\'departureDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.departure_date_th\"></th><th ng-click=\"setOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-click=\"setOrderProperty(\'status\')\" ng-i18next=\"[html]reports.general.status_th\"></th><th ng-click=\"setOrderProperty(\'bookingTotal\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th ng-click=\"setOrderProperty(\'bookingDue\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.bookings | orderBy:orderProperty:orderDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td><a ng-click=\"openBooking(booking.id)\">{{booking.channelReference}}</a></td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.departureDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/booking-waitlist-report_tpl.html","<div ng-controller=\"Reports.BookingWaitlistReportCtrl as report\" class=\"report-page\"><legend class=\"header\">{{\'general.booking_waitlist_report\' | i18next}} <span class=\"printVisible\">{{\'reports.general.from_legend_span\' | i18next}} {{dateFrom | dateToMoment:\'DD MMM YYYY\'}} {{timeFrom}} {{\'general.other.to\' | i18next}} {{dateTo | dateToMoment:\'DD MMM YYYY\'}} {{timeTo}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\"><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-4\"><table class=\"table\"><tr><td>Total</td><td class=\"text-right\">{{report_data.total}}</td></tr></table></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-i18next=\"reports.general.subject\"></th><th ng-i18next=\"reports.general.checkin\"></th><th ng-i18next=\"reports.general.checkout\"></th><th ng-i18next=\"reports.general.numberOfRooms\"></th><th ng-i18next=\"reports.general.amount\"></th><th ng-i18next=\"reports.general.notes\"></th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.bookingsWaitlists\"><td>{{booking.subject}}</td><td>{{booking.checkinDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.checkoutDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.numberOfRooms}}</td><td>{{booking.amount}}</td><td>{{booking.notes}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("templates/reports/cancellation-report_tpl.html","<div ng-controller=\"Reports.CancellationReportCtrl as report\" class=\"report-page\"><legend class=\"header\">{{\'reports.cancellation_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.types_fo_reports.\' + type | i18next}} {{\'reports.general.from_legend_span\' | i18next}} {{dateFrom| dateToMoment:\'DD MMM YYYY\'}} {{\'general.other.to\' | i18next}} {{dateTo| dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\"><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-click=\"setOrderProperty(\'ourReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-click=\"setOrderProperty(\'canceledAt\')\" ng-i18next=\"[html]reports.general.with_br_tag.canceled_at\"></th><th ng-click=\"setOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setOrderProperty(\'departureDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.departure_date_th\"></th><th ng-click=\"setOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-click=\"setOrderProperty(\'canceledAmount\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.canceledAmount_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.bookings | orderBy:orderProperty:orderDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td>{{booking.canceledAt | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.departureDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.nights}}</td><td>{{booking.amountOfRooms}}</td><td>{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"text-right\">{{booking.canceledAmount | customCurrency:2}}</td></tr></tbody><tfoot><tr><th colspan=\"6\"></th><th>{{totals.nights}}</th><th>{{totals.amountOfRooms}}</th><th></th><th></th><th class=\"text-right\">{{totals.canceledAmount | customCurrency:2}}</th></tr></tfoot></table></div></div></div></div>");
$templateCache.put("templates/reports/channel-report_tpl.html","<div ng-controller=\"Reports.ChannelReportCtrl as report\"><legend class=\"header\">{{\'reports.channel_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.types_fo_reports.\' + type | i18next}} {{\'reports.general.from_legend_span\' | i18next}} {{dateFrom| dateToMoment:\'DD MMM YYYY\'}} {{\'reports.general.to_span\' | i18next}} {{dateTo| dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-input-container><md-select ng-model=\"type\"><md-option ng-repeat=\"type in types\" value=\"{{type}}\">{{\'reports.general.types_fo_reports.\' + type | i18next}}</md-option></md-select></md-input-container><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><legend>{{\'reports.channel_report.channel_breakdown\' | i18next}}</legend><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'channel\')\">{{\'reports.channel_report.channel_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'count\')\">{{\'reports.channel_report.number_of_reservations_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'numberOfRoomNights\')\">{{\'reports.channel_report.number_of_room_nights_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'persons\')\">{{\'reports.housekeeping_report.persons_td\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgLeadTime\')\">{{\'reports.channel_report.avg_lead_time_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgLengthOfStay\')\">{{\'reports.channel_report.avg_length_of_stay_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgNightlyRate\')\">{{\'reports.channel_report.avg_nightly_rate_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgEarning\')\">{{\'reports.channel_report.avg_earning_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'totalEarning\')\">{{\'reports.channel_report.total_earning_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat-start=\"(name, channel) in report_data.channels | orderBy:orderProperty:orderDirection\"><td ng-click=\"showChannelBookings($event,name)\"><span class=\"dashed\">{{name}}</span></td><td>{{channel.count}}</td><td>{{channel.numberOfRoomNights}}</td><td>{{channel.persons}}</td><td>{{channel.avgLeadTime | number:2}}</td><td>{{channel.avgLengthOfStay | number:2}}</td><td>{{channel.avgNightlyRate | number:2}}</td><td>{{channel.avgEarning | number:2}}</td><td>{{channel.totalEarning | number:2}}</td></tr><tr ng-repeat-end=\"\" ng-show=\"channel.showBookings == true\"><td colspan=\"8\"><table class=\"table\" ng-if=\"channel.showBookings == true\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setBookingOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.customer\"></th><th ng-click=\"setBookingOrderProperty(\'ourReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-click=\"setBookingOrderProperty(\'channelReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.channel_reference_th\"></th><th ng-click=\"setBookingOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setBookingOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setBookingOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setBookingOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-click=\"setBookingOrderProperty(\'status\')\" ng-i18next=\"[html]reports.general.status_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingTotal\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingDue\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in channel.bookings | orderBy:orderBookingProperty:orderBookingDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td><a ng-click=\"openBooking(booking.id)\">{{booking.channelReference}}</a></td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></td></tr></tbody><tfoot><tr><th></th><th>{{totalSum(\'count\')}}</th><th>{{totalSum(\'numberOfRoomNights\')}}</th><th>{{totalSum(\'persons\')}}</th><th>{{report_data.totalAvgLeadTime | number:2}}</th><th>{{report_data.totalAvgLengthOfStay | number:2}}</th><th>{{report_data.totalAvgNightlyRate | number:2}}</th><th>{{report_data.totalAvgEarnings | number:2}}</th><th>{{totalSum(\'totalEarning\') | number:2}}</th></tr></tfoot></table></div><div class=\"col-xs-12\" ng-if=\"showBookings === true\"><legend>{{selectedChannel}} bookings</legend><table class=\"table table-colapse\"><thead><tr class=\"reports-small-header\"><th ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.channel_reference_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-i18next=\"[html]general.other.nights\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-i18next=\"[html]reports.general.status_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in bookings\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td><a ng-click=\"openBooking(booking.id)\">{{booking.channelReference}}</a></td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/citizenship-report_tpl.html","<div ng-controller=\"Reports.CitizenshipReportCtrl as report\"><legend class=\"header\">{{\'reports.citizenship_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.types_fo_reports.\' + type | i18next}} {{\'reports.general.from_legend_span\' | i18next}} {{dateFrom| dateToMoment:\'DD MMM YYYY\'}} {{\'reports.general.to_span\' | i18next}} {{dateTo| dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-input-container><md-select ng-model=\"type\"><md-option ng-repeat=\"type in types\" value=\"{{type}}\">{{\'reports.general.types_fo_reports.\' + type | i18next}}</md-option></md-select></md-input-container><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'country\')\">{{\'reports.citizenship_report.country_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'count\')\">{{\'reports.channel_report.number_of_reservations_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'totalEarning\')\">{{\'reports.channel_report.total_earning_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgEarning\')\">{{\'reports.channel_report.avg_earning_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgNightlyRate\')\">{{\'reports.channel_report.avg_nightly_rate_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'numberOfRoomNights\')\">{{\'reports.channel_report.number_of_room_nights_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'avgLengthOfStay\')\">{{\'reports.channel_report.avg_length_of_stay_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'persons\')\">{{\'reports.housekeeping_report.persons_td\' | i18next}}</th><th ng-click=\"setOrderProperty(\'guestNights\')\">{{\'reports.citizenship_report.guest_nights_td\' | i18next}}</th></tr></thead><tbody><tr ng-repeat-start=\"country in report_data.countries | orderBy:orderProperty:orderDirection\"><td ng-click=\"showChannelBookings($event,country.country)\"><span class=\"dashed\">{{country.country}}</span></td><td>{{country.count}}</td><td>{{country.totalEarning | number:2}}</td><td>{{country.avgEarning | number:2}}</td><td>{{country.avgNightlyRate | number:2}}</td><td>{{country.numberOfRoomNights}}</td><td>{{country.avgLengthOfStay | number:2}}</td><td>{{country.persons}}</td><td>{{country.guestNights}}</td></tr><tr ng-repeat-end=\"\" ng-show=\"country.showBookings == true\"><td colspan=\"9\"><table class=\"table\" ng-if=\"country.showBookings == true\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setBookingOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.customer\"></th><th ng-click=\"setBookingOrderProperty(\'ourReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-click=\"setBookingOrderProperty(\'channelReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.channel_reference_th\"></th><th ng-click=\"setBookingOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setBookingOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setBookingOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setBookingOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-click=\"setBookingOrderProperty(\'status\')\" ng-i18next=\"[html]reports.general.status_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingTotal\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingDue\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in country.bookings | orderBy:orderBookingProperty:orderBookingDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td><a ng-click=\"openBooking(booking.id)\">{{booking.channelReference}}</a></td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></td></tr></tbody><tfoot><tr><th></th><th>{{totalSum(\'count\')}}</th><th>{{totalSum(\'totalEarning\') | number:2}}</th><th>{{report_data.totalAvgEarnings | number:2}}</th><th>{{report_data.totalAvgNightlyRate | number:2}}</th><th>{{totalSum(\'numberOfRoomNights\')}}</th><th>{{report_data.totalAvgLengthOfStay | number:2}}</th><th>{{totalSum(\'persons\')}}</th><th>{{totalSum(\'guestNights\')}}</th></tr></tfoot></table></div><div class=\"col-xs-12\" ng-if=\"showBookings === true\"><legend>{{selectedChannel}} bookings</legend><table class=\"table table-colapse\"><thead><tr class=\"reports-small-header\"><th ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.channel_reference_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-i18next=\"[html]general.other.nights\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-i18next=\"[html]reports.general.status_th\"></th><th ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in bookings\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td><a ng-click=\"openBooking(booking.id)\">{{booking.channelReference}}</a></td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/credit-report_tpl.html","<div ng-controller=\"Reports.CreditReportCtrl as report\"><legend class=\"header\">{{\'reports.credit_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.from_legend_span\' | i18next}} {{dateFrom | dateToMoment:\'DD MMM YYYY\'}} {{timeFrom}} {{\'general.other.to\' | i18next}} {{dateTo | dateToMoment:\'DD MMM YYYY\'}} {{timeTo}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\" ng-disabled=\"loading\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': loading}\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\"><div><span ng-show=\"user.hotels.length > 0\">{{\'reports.general.property_span\' | i18next}}:</span><md-input-container ng-show=\"user.hotels.length > 0\"><md-select ng-model=\"properties\" multiple=\"\"><md-option ng-repeat=\"hotel in user.hotels\" ng-value=\"hotel.id\">{{hotel.name}}</md-option></md-select></md-input-container><span>{{\'profile_nav.settings.hotel_profile.payment_types.payment_types_legend\' | i18next}}:</span><md-input-container><md-select ng-model=\"paymentType\" multiple=\"\"><md-option ng-repeat=\"pt in paymentTypes\" ng-value=\"pt[0]\">{{pt[1]}}</md-option></md-select></md-input-container><span>{{\'reports.credit_report.use_field\' | i18next}}:</span><md-input-container><md-select ng-model=\"useField\"><md-option value=\"date\">Date</md-option><md-option value=\"created_at\">Created At</md-option></md-select></md-input-container><span>{{\'reports.credit_report.filter_by_account\' | i18next}}:</span><md-input-container><md-select ng-model=\"perUser\"><md-option value=\"\">{{\'reports.credit_report.all_accounts\' | i18next}}</md-option><md-option value=\"system\">{{\'reports.credit_report.no_user_related\' | i18next}}</md-option><md-option ng-repeat=\"user in users\" ng-value=\"user.user_id\">{{user.user_name || user.user_email}}</md-option></md-select></md-input-container></div><div><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-input-container><md-select ng-model=\"timeFrom\"><md-option ng-repeat=\"time in times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-input-container><md-select ng-model=\"timeTo\"><md-option ng-repeat=\"time in times\" value=\"{{time}}\">{{time}}</md-option></md-select></md-input-container></div></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.total_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_charge_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalCharge | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_pre_authorized_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalAuth | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_refunded_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalRefund | customCurrency:2}}</td></tr></table></div><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.online_credit_card_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.onlineCreditCardTransactions}}</td></tr><tr><td>{{\'reports.general.offline_credit_card_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.offlineCreditCardTransactions}}</td></tr><tr><td>{{\'reports.general.cash_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.cashTransactions}}</td></tr><tr><td>{{\'reports.general.other_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.otherTransactions}}</td></tr><tr class=\"other-payments\" ng-repeat=\"payment in report_data.customPayments\"><td>{{payment[0]}}</td><td class=\"text-right\">{{payment[1]}}</td></tr><tr><td>{{\'reports.general.total_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalTransactions}}</td></tr></table></div><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.total_online_card_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalOnlineCardRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_offline_card_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalOfflineCardRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_cash_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalCashRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_other_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalOtherRevenue | customCurrency:2}}</td></tr><tr class=\"other-payments\" ng-repeat=\"payment in report_data.customPayments\"><td>{{payment[0]}}</td><td class=\"text-right\">{{payment[2] | customCurrency:2}}</td></tr></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table credit-report-table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-click=\"setOrderProperty(\'bookingReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_reference_th\"></th><th ng-click=\"setOrderProperty(\'propertyName\')\" ng-if=\"properties.length > 1\" ng-i18next=\"[html]reports.general.with_br_tag.property_name_th\"></th><th ng-click=\"setOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th class=\"hidden-print\" ng-click=\"setOrderProperty(\'payment.date\')\" ng-i18next=\"[html]reports.general.payment_date_th\"></th><th class=\"hidden-print\" ng-click=\"setOrderProperty(\'payment.date\')\" ng-i18next=\"[html]reports.general.payment_created_at_th\"></th><th class=\"hidden-print\"><div class=\"payments_title_wrapper\"><div class=\"col-xs-6\">{{\'reports.general.payments_th\' | i18next}}</div><div class=\"col-xs-4\">{{\'reports.credit_report.charged_by_account\' | i18next}}</div></div></th><th ng-click=\"setOrderProperty(\'status\')\" ng-i18next=\"[html]reports.general.status_th\"></th><th ng-click=\"setOrderProperty(\'bookingTotal\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th ng-click=\"setOrderProperty(\'bookingDue\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat-start=\"booking in report_data.bookings | orderBy:orderProperty:orderDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.bookingReference}}</a></td><td ng-if=\"properties.length > 1\">{{booking.propretyName}}</td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"hidden-print\"><div ng-repeat=\"payment in booking.payments\">{{payment.date | dateToMoment:\'MMM D, YYYY\':\'UTC\':true}}</div></td><td class=\"hidden-print\"><div ng-repeat=\"payment in booking.payments\">{{payment.createdAt | dateToMoment:\'MMM D, YYYY HH:mm\'}}</div></td><td class=\"payment-row hidden-print\"><div class=\"row\" ng-repeat=\"payment in booking.payments\" ng-class=\"\'payment__\' + payment.category\"><div class=\"col-xs-4 payments_category_description\">{{payment.type}} {{payment.description}} <span ng-if=\"payment.transactionId\">({{payment.transactionId}})</span></div><div class=\"col-xs-2 payments_category_name colored-text\">{{getCategoryName(payment.category)}}</div><div class=\"col-xs-4 payments_created_by\">{{payment.createdBy || \'reports.credit_report.no_user_related\' | i18next}}</div><div class=\"col-xs-3 payments_category_totals text-right colored-text\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr><tr ng-repeat-end=\"\" class=\"visible-print\"><td class=\"payment-row\" colspan=\"14\"><div class=\"row\" ng-repeat=\"payment in booking.payments\" ng-class=\"\'payment__\' + payment.category\"><div class=\"col-xs-2\">{{payment.date | dateToMoment: \'MMM D, YYYY\'}}</div><div class=\"col-xs-2\">{{payment.createdAt | dateToMoment: \'MMM D, YYYY HH:mm\'}}</div><div class=\"col-xs-3\">{{payment.type}} {{payment.description}} <span ng-if=\"payment.transactionId\">({{payment.transactionId}})</span></div><div class=\"col-xs-1\" ng-if=\"payment.category == \'prepayment_redeem\'\">redeem</div><div class=\"col-xs-1\" ng-if=\"!(payment.category == \'prepayment_redeem\')\">{{payment.category}}</div><div class=\"col-xs-2 text-right\">{{payment.amount | customCurrency:2}}</div></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/daily-checkout-report_tpl.html","<div ng-controller=\"Reports.DailyCheckoutReportCtrl as report\"><legend class=\"header\">{{\'reports.daily_checkout_report.legend\' | i18next}} <span class=\"printVisible\">{{\'general.other.for\' | i18next}} {{date | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'reports.daily_checkout_report.choose_report_date\' | i18next}}:</span><md-datepicker ng-model=\"date\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.total_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_room_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalRoomRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_extras_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalExtrasRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_taxes_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalTaxesRevenue | customCurrency:2}}</td></tr><tr ng-repeat=\"(tax_name, tax_value) in report_data.taxes\"><td>{{tax_name}}:</td><td class=\"text-right\">{{tax_value | customCurrency:2}}</td></tr></table></div><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.online_credit_card_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.onlineCreditCardTransactions}}</td></tr><tr><td>{{\'reports.general.offline_credit_card_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.offlineCreditCardTransactions}}</td></tr><tr><td>{{\'reports.general.cash_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.cashTransactions}}</td></tr><tr><td>{{\'reports.general.other_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.otherTransactions}}</td></tr><tr class=\"other-payments\" ng-repeat=\"payment in report_data.customPayments\"><td>{{payment[0]}}</td><td class=\"text-right\">{{payment[1]}}</td></tr><tr><td>{{\'reports.general.total_transactions_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalTransactions}}</td></tr></table></div><div class=\"col-xs-4\"><table class=\"table\"><tr><td>{{\'reports.general.total_online_card_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalOnlineCardRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_offline_card_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalOfflineCardRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_cash_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalCashRevenue | customCurrency:2}}</td></tr><tr><td>{{\'reports.general.total_other_revenue_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalOtherRevenue | customCurrency:2}}</td></tr><tr class=\"other-payments\" ng-repeat=\"payment in report_data.customPayments\"><td>{{payment[0]}}</td><td class=\"text-right\">{{payment[2] | customCurrency:2}}</td></tr><tr><td></td><td></td></tr><tr><td>{{\'reports.general.total_paid_in_full_td\' | i18next}}:</td><td class=\"text-right\">{{report_data.totalPaidInFull}}</td></tr><tr><td>{{\'reports.general.total_partially_paid_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalPartiallyPaid}} <span ng-if=\"report_data.totalPartiallyPaid\">({{\'general.other.due\' | i18next}}: {{report_data.totalPartiallySumm | customCurrency:2}})</span></td></tr><tr><td>{{\'reports.general.total_unpaid_td\' | i18next}}</td><td class=\"text-right\">{{report_data.totalUnpaid}} <span ng-if=\"report_data.totalUnpaid\">({{\'general.other.due\' | i18next}}: {{report_data.totalUnpaidSumm | customCurrency:2}})</span></td></tr></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-click=\"setOrderProperty(\'bookingReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_reference_th\"></th><th ng-click=\"setOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-click=\"setOrderProperty(\'status\')\" ng-i18next=\"[html]reports.general.status_th\"></th><th ng-click=\"setOrderProperty(\'bookingTotal\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th ng-click=\"setOrderProperty(\'bookingDue\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.bookings | orderBy:orderProperty:orderDirection\"><td>{{booking.customer}}</td><td>{{booking.bookingReference}}</td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\">{{payment.type}} {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/debtors-report_tpl.html","<div ng-controller=\"Reports.DebtorsReportCtrl as report\"><legend class=\"header\">{{\'reports.debtors_report.legend\' | i18next}} <small class=\"debtors-selector first\"><a ng-click=\"mode = 0;\" ng-class=\"{active: mode == 0}\">Per booking</a></small> | <small class=\"debtors-selector\"><a ng-click=\"mode = 1;\" ng-class=\"{active: mode == 1}\">Per customer</a></small></legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\": loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"\"><div><table class=\"table\" ng-if=\"mode == 0\"><thead><tr class=\"reports-small-header\"><th>{{\'reports.general.booking_reference_th\' | i18next}}</th><th>{{\'reports.debtors_report.invoice_th\' | i18next}}</th><th>{{\'reports.debtors_report.customer_name_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.debtors_report.accomodation_th\' | i18next}}</th><th class=\"text-right\">{{\'general.other.extras\' | i18next}}</th><th class=\"text-right\">{{\'general.other.discounts\' | i18next}}</th><th class=\"text-right\">{{\'reports.debtors_report.amount_due_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat-start=\"group in groups\" ng-if=\"(group.index <= 6) && (group.index > 0)\"><td colspan=\"7\" class=\"text-center under-report-text\"><span>{{\'reports.debtors_report.under_x_days\' | i18next: {\"number\": group.index * 30} }}</span></td></tr><tr ng-repeat=\"booking in group.bookings\"><td><a ng-click=\"openBooking(booking.id)\">{{booking.reference}}</a></td><td>{{booking.invoice}}</td><td>{{booking.customer}}</td><td class=\"text-right\">{{booking.accomodation | customCurrency:2}}</td><td class=\"text-right\">{{booking.extras | customCurrency:2}}</td><td class=\"text-right\">{{booking.discounts | customCurrency:2}}</td><td class=\"text-right\">{{booking.due | customCurrency:2}}</td></tr><tr ng-repeat-end=\"\"><th>{{\'general.other.count\' | i18next}}: {{group.totals.count}}</th><th></th><th></th><th class=\"text-right\">{{group.totals.accomodation | customCurrency:2}}</th><th class=\"text-right\">{{group.totals.extras | customCurrency:2}}</th><th class=\"text-right\">{{group.totals.discounts | customCurrency:2}}</th><th class=\"text-right\">{{group.totals.due | customCurrency:2}}</th></tr></tbody></table><table class=\"table\" ng-if=\"mode == 1\"><thead><tr class=\"reports-small-header\"><th>{{\'reports.debtors_report.customer_name_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.debtors_report.accomodation_th\' | i18next}}</th><th class=\"text-right\">{{\'general.other.extras\' | i18next}}</th><th class=\"text-right\">{{\'general.other.discounts\' | i18next}}</th><th class=\"text-right\">{{\'reports.debtors_report.amount_due_th\' | i18next}}</th><th class=\"debtors-tokens\">{{\'reports.general.booking_reference_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"customer in customers\"><td>{{customer.customer}}</td><td class=\"text-right\">{{customer.accomodation | customCurrency:2}}</td><td class=\"text-right\">{{customer.extras | customCurrency:2}}</td><td class=\"text-right\">{{customer.discounts | customCurrency:2}}</td><td class=\"text-right\">{{customer.due | customCurrency:2}}</td><td class=\"debtors-tokens\"><a class=\"debtors-booking-link\" ng-repeat=\"booking in customer.tokens\" ng-click=\"openBooking(booking[0])\">{{booking[1]}}</a></td></tr></tbody></table></div></div></div>");
$templateCache.put("templates/reports/deposit-report_tpl.html","<div ng-controller=\"Reports.DepositReportCtrl as report\" class=\"deposit-report\"><legend class=\"header\">{{\'reports.deposit_report.legend\' | i18next}}</legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-6\"><table class=\"table\"><tr><td>{{\'reports.deposit_report.bookings_count_th\' | i18next}}</td><td class=\"text-right\">{{report_data.totals.count }}</td></tr><tr><td>{{\'reports.deposit_report.accomodation_th\' | i18next}}</td><td class=\"text-right\">{{report_data.totals.accommodation | customCurrency }}</td></tr><tr><td>{{\'reports.deposit_report.extras_th\' | i18next}}</td><td class=\"text-right\">{{report_data.totals.extra | customCurrency }}</td></tr></table></div><div class=\"col-xs-6\"><table class=\"table\"><tr><td>{{\'reports.deposit_report.total_th\' | i18next}}</td><td class=\"text-right\">{{report_data.totals.total | customCurrency}}</td></tr><tr><td>{{\'reports.deposit_report.amount_paid_th\' | i18next}}</td><td class=\"text-right\">{{report_data.totals.paid | customCurrency}}</td></tr><tr><td>{{\'reports.deposit_report.amount_due_th\' | i18next}}</td><td class=\"text-right\">{{report_data.totals.due | customCurrency}}</td></tr></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'reports.deposit_report.booking_th\' | i18next}}</th><th>{{\'reports.deposit_report.invoice_th\' | i18next}}</th><th>{{\'reports.deposit_report.customer_name_th\' | i18next}}</th><th>{{\'reports.deposit_report.arrival_date_th\' | i18next}}</th><th>{{\'reports.deposit_report.accomodation_th\' | i18next}}</th><th>{{\'reports.deposit_report.extras_th\' | i18next}}</th><th>{{\'reports.deposit_report.total_th\' | i18next}}</th><th>{{\'reports.deposit_report.amount_paid_th\' | i18next}}</th><th>{{\'reports.deposit_report.amount_due_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"f in report_data.bookings track by $index\"><td ng-class=\"{sameBooking: report_data.bookings[$index - 1].bookingId == f.bookingId}\"><a ng-click=\"openBooking(f.bookingId)\">{{f.token}}</a></td><td><a ng-click=\"openFolio(f.id, f.bookingId)\">{{f.invoice}}</a></td><td>{{f.customer}}</td><td>{{f.arrivalDate}}</td><td>{{f.accommodation | customCurrency}}</td><td>{{f.extra | customCurrency}}</td><td>{{f.total | customCurrency}}</td><td>{{f.paid | customCurrency}}</td><td>{{f.due | customCurrency}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/end-of-day-report_tpl.html","<div ng-controller=\"Reports.EndOfDayReportCtrl as report\"><legend class=\"header\">{{\'reports.end_of_day_report.legend\' | i18next}} <span class=\"printVisible\">{{report.date | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"date\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"date\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.credit_report.filter_by_account\' | i18next}}:</span><md-input-container><md-select ng-model=\"perUser\"><md-option value=\"\">{{\'reports.credit_report.all_accounts\' | i18next}}</md-option><md-option value=\"system\">{{\'reports.credit_report.no_user_related\' | i18next}}</md-option><md-option ng-repeat=\"user in users\" ng-value=\"user.user_id\">{{user.user_name || user.user_email}}</md-option></md-select></md-input-container><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button></div><div ng-if=\"!activePt\"><div class=\"sticky-table-div eod-report\"><table class=\"table accounting-table\"><thead><tr class=\"reports-small-header\"><th class=\"\">Accounting Code</th><th class=\"\">Name</th><th>{{\'general.quantity\' | i18next}}</th><th class=\"text-right\">Net</th><th class=\"text-right\">Taxes</th><th class=\"text-right\">Total</th></tr></thead><tbody ng-repeat=\"(ac_id, items) in report_data.items\"><tr ng-repeat=\"(item_name, data) in items\"><th class=\"column-end\">{{ categories[ac_id].externalCode || \'No external code\' }}</th><td class=\"\">{{item_name}}</td><td>{{data.quantity}}</td><td class=\"text-right\">{{formatAmount(data.net)}}</td><td class=\"text-right\">{{formatAmount(data.tax)}}</td><td class=\"text-right\">{{formatAmount(data.total)}}</td></tr></tbody><tfoot><th>Total</th><th></th><th>{{report.totals.items_quantity}}</th><th class=\"text-right\">{{formatAmount(report.totals.net)}}</th><th class=\"text-right\">{{formatAmount(report.totals.tax)}}</th><th class=\"text-right\">{{formatAmount(report.totals.total)}}</th></tfoot></table></div><div class=\"sticky-table-div eod-report\"><table class=\"table accounting-table\"><thead><tr class=\"reports-small-header\"><th class=\"\">Payment Type</th><th>{{\'general.quantity\' | i18next}}</th><th class=\"text-right\">Total</th></tr></thead><tbody ng-repeat=\"(pt_id, pt) in report_data.payments\"><tr ng-click=\"activatePt(pt);\"><td class=\"\">{{ pt.name }} <a>(Details)</a></td><td>{{pt.quantity}}</td><td class=\"text-right\">{{formatAmount(pt.value)}}</td></tr></tbody><tfoot><th></th><th>{{report.totals.payments_quantity}}</th><th class=\"text-right\">{{formatAmount(report.totals.payments)}}</th></tfoot></table></div></div><div ng-if=\"activePt\"><p ng-click=\"deactivatePt()\"><a><< Back to report</a></p><table class=\"table\"><tr><th>{{activePt.name}}</th><th class=\"text-right\">{{formatAmount(activePt.value)}}</th></tr><tr ng-repeat=\"(customer_id, customer) in activePt.customers\" class=\"eod-customer\"><td colspan=\"2\"><table class=\"table\"><thead><tr><th colspan=\"4\">Customer: <a href=\"#/customers/{{customer_id}}\">{{customer.name}}</a></th></tr><tr class=\"reports-small-header\"><th class=\"\">Accounting Code</th><th>{{\'general.quantity\' | i18next}}</th><th class=\"text-right\">Net</th><th class=\"text-right\">Taxes</th><th class=\"text-right\">Total</th></tr></thead><tbody ng-repeat=\"(ac_id, data) in customer.items\"><tr><th class=\"column-end\">{{ categories[ac_id].externalCode || \'No external code\' }}</th><td>{{data.quantity}}</td><td class=\"text-right\">{{formatAmount(data.net)}}</td><td class=\"text-right\">{{formatAmount(data.tax)}}</td><td class=\"text-right\">{{formatAmount(data.total)}}</td></tr></tbody><tfoot><th>Total</th><th>{{customer.quantity}}</th><th class=\"text-right\">{{formatAmount(customer.net)}}</th><th class=\"text-right\">{{formatAmount(customer.tax)}}</th><th class=\"text-right\">{{formatAmount(customer.total)}}</th></tfoot></table><p>Receipts:</p><div ng-repeat=\"(booking_id, booking) in customer.bookings\"><p ng-repeat=\"(folio_id, folio) in booking.folios\"><a ng-click=\"openBookingModal(booking_id, folio.id)\">Booking {{booking.token}}, Receipt {{folio.number}}.</a> <span ng-if=\"folio.otherPayments.length > 0\">Other payments:</span> <span ng-repeat=\"pt in folio.otherPayments\"><span ng-if=\"$index != 0\">,</span>{{pt.name}} {{formatAmount(pt.amount)}}</span></p></div></td></tr></table></div></div>");
$templateCache.put("templates/reports/extras-report_tpl.html","<div ng-controller=\"Reports.ExtrasReportCtrl as report\" class=\"extras-report\"><legend class=\"header\">{{\'reports.extras_report.legend\' | i18next}} <span class=\"printVisible\">, {{report_data.dateFrom | dateToMoment:\'DD MMM YYYY\'}} - {{report_data.dateTo | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><div class=\"report-extra-select\"><extras-report-select-scrollable on-scroll=\"onLoadExtras\" on-search=\"onSearchExtras\" on-select=\"onSelectExtra\" options=\"extras\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" caret-down-filled-suffix=\"true\" on-dropdown-visible-change=\"onDropdownVisibleChange\"></extras-report-select-scrollable></div><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"onChange()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h2>{{\'reports.extras_report.extras_summary_title\' | i18next}}</h2></div></div><div class=\"row\"><div class=\"col-xs-6\"><table class=\"table\"><tr ng-repeat=\"extra in report_data.extrasRevenue\"><td><i class=\"fa fa-square\" ng-style=\"{color: getColor(extra, report_data.extrasRevenue)}\"></i> {{extra.title}}:</td><td class=\"text-right\">{{extra.revenue | customCurrency:2}}</td><td class=\"text-right\">{{extra.count}}</td></tr></table></div><div class=\"col-xs-6\"><table class=\"table\"><tr ng-repeat=\"extra in report_data.categoryRevenue\" ng-click=\"setFilterCategory(extra.title)\"><td><i class=\"fa fa-square\" ng-style=\"{color: getColor(extra, report_data.categoryRevenue)}\"></i> {{extra.title}}:</td><td class=\"text-right\">{{extra.revenue | customCurrency:2}}</td><td class=\"text-right\">{{extra.count}}</td></tr></table></div></div><div class=\"row\"><div class=\"col-xs-6\"><div style=\"max-height: 200px; max-width: 200px; margin: auto;\"><canvas id=\"extrasEarningChart\" height=\"200\" width=\"200\"></canvas></div></div><div class=\"col-xs-6\"><div style=\"max-height: 200px; max-width: 200px; margin: auto;\"><canvas id=\"extraCategoriesEarningChart\" height=\"200\" width=\"200\"></canvas></div></div></div><div class=\"row\"><div class=\"col-xs-6\"><h2>{{\'reports.extras_report.bookings_title\' | i18next}}</h2></div><div class=\"col-xs-6\"><md-input-container class=\"category-selector\"><label>Filter by category</label><md-select ng-model=\"filterCategory\" ng-change=\"recalcTotals()\"><md-option ng-value=\"null\">All</md-option><md-option ng-repeat=\"extra in report_data.categoryRevenue\" value=\"{{extra.title}}\">{{extra.title}}</md-option></md-select></md-input-container></div><div class=\"col-xs-12\"><table class=\"table extras-table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'guestName\')\">{{\'general.other.guest_name\' | i18next}}</th><th ng-click=\"setOrderProperty(\'bookingReference\')\">{{\'reports.general.booking_reference_th\' | i18next}}</th><th>{{\'general.other.extras\' | i18next}}</th><th class=\"text-right\">{{\'general.other.count\' | i18next}}</th><th class=\"text-right\">{{\'general.other.total\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.soldExtras | orderBy:orderProperty:orderDirection\"><td>{{booking.guestName}}</td><td><a ng-click=\"openBooking(booking.bookingId)\">{{booking.bookingReference}}</a></td><td colspan=\"3\"><table class=\"table\"><tr ng-repeat=\"extra in booking.extras\" ng-hide=\"filterCategory && filterCategory != extra.category\"><td class=\"text-left\">{{extra.title}}</td><td class=\"text-right\">{{extra.count}}</td><td class=\"text-right\" ng-repeat-end=\"\">{{extra.revenue | customCurrency:2}}</td></tr></table></td></tr></tbody><tfoot><tr><td colspan=\"4\"><strong>{{\'general.other.total\' | i18next}}:</strong></td><td class=\"text-right\"><strong>{{filterTotals | customCurrency:2}}</strong></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("templates/reports/financial-report_tpl.html","<div ng-controller=\"Reports.FinancialReportCtrl as report\"><legend class=\"header\">{{\'reports.financial_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.from_legend_span\' | i18next}} {{report.dateFrom | dateToMoment:\'DD MMM YYYY\'}} {{\'general.other.to\' | i18next}} {{report.dateTo | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\"><md-checkbox ng-model=\"excludeBlockers\" aria-label=\"{{\'reports.general.exclude_blockers\' | i18next}}\">{{\'reports.general.exclude_blockers\' | i18next}}</md-checkbox></div><div class=\"\"><div><h1>{{\'reports.occupancy_report.daily_breakdown_title\' | i18next}}</h1><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'general.other.date\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_available_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_occupied_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_empty_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.occupancy_percentage_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_count_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.avg_lead_time_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.rate_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.revenue_per_room_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.guests_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.rooms_net_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.extras_net_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.total_net_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.revenue_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.extras_revenue_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.occupancy_report.total_revenue_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.room_taxes_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.extras_taxes_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.total_taxes_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.payments_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.refunds_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.discounts_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"date in report_data | filter:\'!All Dates\'\"><td>{{date.date | dateToMoment:\'DD MMM YYYY\'}}</td><td class=\"text-right\">{{date.nights}}</td><td class=\"text-right\">{{date.bookingsCount}}</td><td class=\"text-right\">{{date.emptyNights}}</td><td class=\"text-right\">{{date.percentage.toFixed(2)}} %</td><td class=\"text-right\">{{date.avgNights.toFixed(2)}}</td><td class=\"text-right\">{{date.avgLeadTime.toFixed(2)}}</td><td class=\"text-right\">{{date.avgRate.toFixed(2)}}</td><td class=\"text-right\">{{date.revenuePerRoom.toFixed(2)}}</td><td class=\"text-right border-right\">{{date.guests}}</td><td class=\"text-right\">{{date.net.toFixed(2)}}</td><td class=\"text-right\">{{date.extrasNet.toFixed(2)}}</td><td class=\"text-right border-right\">{{(date.extrasNet + date.net).toFixed(2)}}</td><td class=\"text-right\">{{date.revenue.toFixed(2)}}</td><td class=\"text-right\">{{date.extrasRevenue.toFixed(2)}}</td><td class=\"text-right border-right\">{{(date.revenue + date.extrasRevenue).toFixed(2)}}</td><td class=\"text-right\">{{date.roomTaxes.toFixed(2)}}</td><td class=\"text-right\">{{date.extrasTaxes.toFixed(2)}}</td><td class=\"text-right border-right\">{{(date.roomTaxes + date.extrasTaxes).toFixed(2)}}</td><td class=\"text-right\">{{date.payments.toFixed(2)}}</td><td class=\"text-right\">{{date.refunds.toFixed(2)}}</td><td class=\"text-right\">{{date.discounts.toFixed(2)}}</td></tr></tbody><tfoot><tr ng-repeat=\"date in report_data | filter:\'All Dates\'\"><th></th><th class=\"text-right\">{{date.nights}}</th><th class=\"text-right\">{{date.bookingsCount}}</th><th class=\"text-right\">{{date.emptyNights}}</th><th class=\"text-right\">{{date.percentage.toFixed(2)}} %</th><th class=\"text-right\">{{date.avgNights.toFixed(2)}}</th><th class=\"text-right\">{{date.avgLeadTime.toFixed(2)}}</th><th class=\"text-right\">{{date.avgRate.toFixed(2) || \'0.00\'}}</th><th class=\"text-right\">{{date.revenuePerRoom.toFixed(2) || \'0.00\'}}</th><th class=\"text-right border-right\">{{date.guests}}</th><th class=\"text-right\">{{date.net.toFixed(2)}}</th><th class=\"text-right\">{{date.extrasNet.toFixed(2)}}</th><th class=\"text-right border-right\">{{(date.extrasNet + date.net).toFixed(2)}}</th><th class=\"text-right\">{{date.revenue.toFixed(2)}}</th><th class=\"text-right\">{{date.extrasRevenue.toFixed(2)}}</th><th class=\"text-right border-right\">{{(date.revenue + date.extrasRevenue).toFixed(2)}}</th><th class=\"text-right\">{{date.roomTaxes.toFixed(2)}}</th><th class=\"text-right\">{{date.extrasTaxes.toFixed(2)}}</th><th class=\"text-right border-right\">{{(date.roomTaxes + date.extrasTaxes).toFixed(2)}}</th><th class=\"text-right\">{{date.payments.toFixed(2)}}</th><th class=\"text-right\">{{date.refunds.toFixed(2)}}</th><th class=\"text-right\">{{date.discounts.toFixed(2)}}</th></tr><tr class=\"reports-small-header\"><th>{{\'general.other.date\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_available_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_occupied_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_empty_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.occupancy_percentage_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_count_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.avg_lead_time_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.rate_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.revenue_per_room_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.guests_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.rooms_net_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.extras_net_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.total_net_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.revenue_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.extras_revenue_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.occupancy_report.total_revenue_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.room_taxes_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.extras_taxes_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.total_taxes_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.payments_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.refunds_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.discounts_th\' | i18next}}</th></tr></tfoot></table></div></div><div class=\"\"><div><h1>{{\'reports.financial_report.taxes_breakdown_title\' | i18next}}</h1><table class=\"table\"><thead><tr class=\"reports-small-header\"><th class=\"border-right\">{{\'general.other.date\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.room_taxes_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.extras_taxes_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.total_taxes_th\' | i18next}}</th><th class=\"text-right\" ng-repeat=\"tax in report.taxes\">{{tax[1]}}</th></tr></thead><tbody><tr ng-repeat=\"date in report_data | filter:\'!All Dates\'\"><td class=\"border-right\">{{date.date | dateToMoment:\'DD MMM YYYY\'}}</td><td class=\"text-right\">{{date.roomTaxes.toFixed(2)}}</td><td class=\"text-right\">{{date.extrasTaxes.toFixed(2)}}</td><td class=\"text-right border-right\">{{(date.roomTaxes + date.extrasTaxes).toFixed(2)}}</td><td class=\"text-right\" ng-repeat=\"tax in report.taxes\">{{((date.taxes[tax[0].toString()] || 0).toFixed(2))}}</td></tr></tbody><tfoot><tr ng-repeat=\"date in report_data | filter:\'All Dates\'\"><th class=\"border-right\"></th><th class=\"text-right\">{{date.roomTaxes.toFixed(2)}}</th><th class=\"text-right\">{{date.extrasTaxes.toFixed(2)}}</th><th class=\"text-right border-right\">{{(date.roomTaxes + date.extrasTaxes).toFixed(2)}}</th><th class=\"text-right\" ng-repeat=\"tax in report.taxes\">{{(date.taxes[tax[0]] || 0).toFixed(2)}}</th></tr><tr class=\"reports-small-header\"><th class=\"border-right\">{{\'general.other.date\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.room_taxes_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.financial_report.extras_taxes_th\' | i18next}}</th><th class=\"text-right border-right\">{{\'reports.financial_report.total_taxes_th\' | i18next}}</th><th class=\"text-right\" ng-repeat=\"tax in report.taxes\">{{tax[1]}}</th></tr></tfoot></table></div></div></div>");
$templateCache.put("templates/reports/folio-report_tpl.html","<div ng-controller=\"Reports.FolioReportCtrl as report\"><legend class=\"header\">{{\'index.reports.folio_report_link\' | i18next}} <span class=\"printVisible\">({{report.dateFrom| dateToMoment:\'DD MMM YYYY\'}} - {{report.dateTo| dateToMoment:\'DD MMM YYYY\'}})</span></legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getFolioReport()\" class=\"md-raised md-success md-button\" ng-disabled=\"requested\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\' : requested}\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i> <i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i> <i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button><md-button ng-click=\"exportInvoices()\" ng-disabled=\"!canPdfExport\"><i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i> <i class=\"fa fa-download\"></i> {{\'reports.general.download_selected_pdf\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\">{{\'inventory.filters_legend\' | i18next}}:<md-input-container><md-select ng-model=\"type\"><md-option ng-repeat=\"type in types\" value=\"{{type}}\">{{\'reports.general.types_folio_report.\' + type | i18next}}</md-option></md-select></md-input-container>{{\'inventory.filter_by_legend\' | i18next}}:<md-input-container><md-select ng-model=\"filterDateType\"><md-option ng-repeat=\"type in filterDateTypes\" value=\"{{type}}\">{{\'reports.general.types_fo_reports.\' + type | i18next}}</md-option></md-select></md-input-container><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-checkbox ng-model=\"showOnlyFailedSendBookkeeping\" aria-label=\"{{\'reports.general.show_only_not_sent_to-accounting_system\' | i18next}}\" ng-show=\"type === \'receipt\'\">{{\'reports.general.show_only_not_sent_to-accounting_system\' | i18next}}</md-checkbox></div><div class=\"report folio-report-scroll-wrapper\"><div class=\"folio-report-scroll-container\" on-scroll-near-end=\"loadMore()\" scroll-reset-on=\"report\"><table class=\"table folio-report-table\"><thead><tr class=\"reports-small-header\"><th class=\"screenVisible\"><md-checkbox ng-model=\"allSelect\" ng-change=\"onAllChange()\"></md-checkbox></th><th ng-click=\"setOrderProperty(\'number\')\">{{\'bookings.folios.number\' | i18next}}</th><th ng-click=\"setOrderProperty(\'date\')\">{{\'general.other.date\' | i18next}}</th><th ng-click=\"setOrderProperty(\'status\')\">{{\'reports.general.status_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'reference\')\">{{\'reports.general.booking_reference_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'customerName\')\">{{\'reports.debtors_report.customer_name_th\' | i18next}}</th><th ng-repeat=\"bookkeeping in bookkeepings | orderBy:\'id\' track by bookkeeping.id\">{{\'reports.debtors_report.accounting_system_sync_status_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'totalAccommodation\')\" class=\"text-right\">{{\'reports.debtors_report.accomodation_th\' | i18next}}</th><th ng-click=\"setOrderProperty(\'totalExtra\')\" class=\"text-right\">{{\'general.other.extras\' | i18next}}</th><th ng-click=\"setOrderProperty(\'totalDiscount\')\" class=\"text-right\">{{\'general.other.discounts\' | i18next}}</th><th ng-click=\"setOrderProperty(\'total\')\" class=\"text-right\">{{\'general.other.total\' | i18next}}</th><th ng-click=\"setOrderProperty(\'due\')\" class=\"text-right\">{{\'reports.debtors_report.amount_due_th\' | i18next}}</th><th class=\"text-right\" ng-repeat=\"tax in report.taxes track by tax\">{{::tax}}</th></tr></thead><tbody><tr ng-repeat-start=\"folio in report.folios | orderBy:orderProperty:orderDirection | limitTo:displayLimit track by folio.id\"><td class=\"screenVisible\"><md-checkbox ng-model=\"selected[folio.id]\" ng-change=\"onFolioChange()\"></md-checkbox></td><td><a ng-click=\"openFolio(folio.id, folio.bookingId)\">{{::folio.visibleNumber}}</a></td><td>{{::folio.date | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{::\'reports.general.types_folio_report.\' + folio.status | i18next}}</td><td><a ng-click=\"openBooking(folio.bookingId)\">{{::folio.reference}}</a></td><td>{{::folio.customerName}}</td><td ng-repeat=\"bookkeeping in bookkeepings track by bookkeeping.id\" ng-click=\"showFolioBookkeepingLogs($event,folio)\"><div ng-if=\"folio.status == \'receipt\'\"><i class=\"fa fa-circle\" ng-style=\"{\'color\': (folio.bookkeepingStatusMap[bookkeeping.id] && folio.bookkeepingStatusMap[bookkeeping.id].color) || \'#a0a0a0\'}\"></i> <span class=\"dashed\">{{\'reports.debtors_report.log\' | i18next}}</span></div></td><td class=\"text-right\">{{folio.totalAccommodation | customCurrency:2}}</td><td class=\"text-right\">{{folio.totalExtra | customCurrency:2}}</td><td class=\"text-right\">{{folio.totalDiscount | customCurrency:2}}</td><td class=\"text-right\">{{folio.total | customCurrency:2}}</td><td class=\"text-right\">{{folio.due | customCurrency:2}}</td><td class=\"text-right\" ng-repeat=\"tax in report.taxes track by tax\">{{(folio.taxes[tax] || 0) | customCurrency:2 }}</td></tr><tr ng-repeat-end=\"\" ng-if=\"folio.showBookkeepingLogs\"><td></td><td colspan=\"14\" style=\"padding-top: 30px;\"><md-button ng-repeat=\"bookkeeping in bookkeepings track by bookkeeping.id\" ng-click=\"sendAccountingReport(folio, bookkeeping)\" class=\"md-raised md-primary md-button\" ng-disabled=\"folio.sendingAccountingReport\">{{\'reports.debtors_report.send_accounting_receipt\' | i18next}}</md-button><table class=\"table\"><thead><tr><th>{{\'bookings.payment.time_th\' | i18next}}</th><th>{{\'reports.debtors_report.status_th\' | i18next}}</th><th>{{\'reports.debtors_report.accounting_system_sync_status_th\' | i18next}}</th><th>{{\'reports.debtors_report.error_message_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"bookkeepingLog in folio.bookkeepingLogs | orderBy:\'createdAt\':true track by bookkeepingLog.id\"><td>{{::bookkeepingLog.createdAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td><i class=\"fa fa-circle\" ng-style=\"{\'color\': bookkeepingLog.statusColor || \'#a0a0a0\'}\"></i></td><td>{{::bookkeepingLog.reference}}</td><td>{{::bookkeepingLog.errorMessage}}</td></tr></tbody></table></td></tr></tbody><tfoot><tr class=\"reports-small-header\"><th class=\"screenVisible\"></th><th></th><th></th><th></th><th></th><th></th><th ng-repeat=\"bookkeeping in bookkeepings track by bookkeeping.id\"></th><th class=\"text-right\">{{totals.totalAccommodation | customCurrency:2}}</th><th class=\"text-right\">{{totals.totalExtra | customCurrency:2}}</th><th class=\"text-right\">{{totals.totalDiscount | customCurrency:2}}</th><th class=\"text-right\">{{totals.total | customCurrency:2}}</th><th class=\"text-right\">{{totals.due | customCurrency:2}}</th><th class=\"text-right\" ng-repeat=\"tax in report.taxes track by tax\">{{totals.taxes[tax] | customCurrency:2}}</th></tr></tfoot></table></div><div class=\"folio-report-scroll-status screenVisible\" ng-if=\"report.folios.length > 0\"><div ng-if=\"loadingMore\" class=\"folio-loading-more\"><i class=\"fa fa-spinner fa-spin\"></i> {{\'reports.general.loading_more\' | i18next}}</div><div ng-if=\"!loadingMore\" class=\"folio-report-count\">{{\'reports.general.showing\' | i18next}} {{getVisibleFoliosCount()}} {{\'reports.general.of\' | i18next}} {{report.folios.length}} {{\'reports.general.folios\' | i18next}}</div></div></div></div>");
$templateCache.put("templates/reports/housekeeping-report_tpl.html","<div ng-controller=\"Reports.HousekeepingReportCtrl as report\"><legend class=\"header\">{{\'reports.housekeeping_report.legend\' | i18next}} <span class=\"printVisible\">{{\'general.other.for\' | i18next}} {{date | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'reports.general.choose_report_date_span\' | i18next}}:</span><md-datepicker ng-model=\"date\" md-placeholder=\"{{\'reports.general.choose_report_date_span\' | i18next}}\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i> <i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export_to_excel()\"><i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i> <i class=\"fa fa-table\"></i> {{\'reports.general.export_xls_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i ng-if=\"loading\" class=\"fa fa-spinner fa-spin\"></i> <i class=\"fa fa-file-pdf-o\"></i> {{\'reports.general.export_pdf_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><tr><td colspan=\"3\" class=\"row-header\">{{\'reports.housekeeping_report.rooms_checking_out_row_header\' | i18next}}</td></tr><tr class=\"report-header\"><td>{{\'reports.housekeeping_report.room_number_td\' | i18next}}</td><td>{{\'general.other.room_type\' | i18next}}</td><td>{{\'reports.housekeeping_report.notes_td\' | i18next}}</td><td>{{\'general.other.guest_name\' | i18next}}</td><td>{{\'reports.housekeeping_report.persons_td\' | i18next}}</td><td ng-if=\"housekeepingEnabled === true\">{{\'reports.housekeeping_report.clean_status_td\' | i18next}}</td></tr><tr ng-repeat=\"room in report_data.checkingOut.rooms\"><td>{{room[0]}}</td><td>{{room[3]}}</td><td>{{room[4]}}</td><td>{{room[1]}}</td><td>{{room[2]}}</td><td ng-if=\"housekeepingEnabled === true\">{{\'bookings.calendar.clean_statuses.\' + room[5] | i18next }}</td></tr><tr class=\"report-footer\"><td>{{\'reports.housekeeping_report.total_rooms\' | i18next}}</td><td>{{report_data.checkingOut.count}}</td><td></td><td></td><td>{{totals.checkingOut}}</td><td ng-if=\"housekeepingEnabled === true\"></td></tr></table><table class=\"table\"><tr><td colspan=\"3\" class=\"row-header\">{{\'reports.housekeeping_report.rooms_occupied_row_header\' | i18next}}</td></tr><tr class=\"report-header\"><td>{{\'reports.housekeeping_report.room_number_td\' | i18next}}</td><td>{{\'general.other.room_type\' | i18next}}</td><td>{{\'reports.housekeeping_report.notes_td\' | i18next}}</td><td>{{\'general.other.guest_name\' | i18next}}</td><td>{{\'reports.housekeeping_report.persons_td\' | i18next}}</td><td>{{\'reports.housekeeping_report.current_stay_td\' | i18next}}</td><td ng-if=\"housekeepingEnabled === true\">{{\'reports.housekeeping_report.clean_status_td\' | i18next}}</td><td ng-if=\"housekeepingEnabled === true\">{{\'reports.housekeeping_report.do_not_disturb_td\' | i18next}}</td></tr><tr ng-repeat=\"room in report_data.occupied.rooms\"><td>{{room[0]}}</td><td>{{room[3]}}</td><td>{{room[4]}}</td><td>{{room[1]}}</td><td>{{room[2]}}</td><td>{{room[6]}}</td><td ng-if=\"housekeepingEnabled === true\">{{room[7]}}</td><td ng-if=\"housekeepingEnabled === true\"><i class=\"fa fa-ban room-clean-status inspected\" ng-if=\"room[5] === \'true\'\"></i></td></tr><tr class=\"report-footer\"><td>{{\'reports.housekeeping_report.total_rooms\' | i18next}}</td><td>{{report_data.occupied.count}}</td><td></td><td></td><td>{{totals.occupied}}</td><td></td><td ng-if=\"housekeepingEnabled === true\"></td><td ng-if=\"housekeepingEnabled === true\"></td></tr></table><table class=\"table\"><tr><td colspan=\"3\" class=\"row-header\">{{\'reports.housekeeping_report.rooms_checking_in_row_header\' | i18next}}</td></tr><tr class=\"report-header\"><td>{{\'reports.housekeeping_report.room_number_td\' | i18next}}</td><td>{{\'general.other.room_type\' | i18next}}</td><td>{{\'reports.housekeeping_report.notes_td\' | i18next}}</td><td>{{\'general.other.guest_name\' | i18next}}</td><td>{{\'reports.housekeeping_report.persons_td\' | i18next}}</td><td ng-if=\"housekeepingEnabled === true\">{{\'reports.housekeeping_report.clean_status_td\' | i18next}}</td></tr><tr ng-repeat=\"room in report_data.checkingIn.rooms\"><td>{{room[0]}}</td><td>{{room[3]}}</td><td>{{room[4]}}</td><td>{{room[1]}}</td><td>{{room[2]}}</td><td ng-if=\"housekeepingEnabled === true\">{{\'bookings.calendar.clean_statuses.\' + room[5] | i18next }}</td></tr><tr class=\"report-footer\"><td>{{\'reports.housekeeping_report.total_rooms\' | i18next}}</td><td>{{report_data.checkingIn.count}}</td><td></td><td></td><td>{{totals.checkingIn}}</td><td ng-if=\"housekeepingEnabled === true\"></td></tr></table><table class=\"table\"><tr ng-if=\"housekeepingEnabled === true\"><td colspan=\"3\" class=\"row-header\">{{\'reports.housekeeping_report.dirty_rooms_header\' | i18next}}</td></tr><tr ng-if=\"housekeepingEnabled === true\" class=\"report-header\"><td>{{\'reports.housekeeping_report.room_number_td\' | i18next}}</td><td>{{\'general.other.room_type\' | i18next}}</td><td>{{\'reports.housekeeping_report.notes_td\' | i18next}}</td><td>{{\'reports.housekeeping_report.status_td\' | i18next}}</td><td>{{\'reports.housekeeping_report.do_not_disturb_td\' | i18next}}</td></tr><tr ng-if=\"housekeepingEnabled === true\" ng-repeat=\"room in report_data.dirty.rooms\"><td>{{room[0]}}</td><td>{{room[1]}}</td><td>{{room[2]}}</td><td><span ng-if=\"room[4].checkingOut && room[4].checkingIn\">Departure -> Arrival</span> <span ng-if=\"room[4].checkingOut && !room[4].checkingIn\">Departure</span> <span ng-if=\"!room[4].checkingOut && room[4].checkingIn\">Arrival</span> <span ng-if=\"room[4].staying\">Staying</span></td><td ng-if=\"housekeepingEnabled === true\"><i class=\"fa fa-ban room-clean-status inspected\" ng-if=\"room[3] === \'true\'\"></i></td></tr><tr ng-if=\"housekeepingEnabled === true\" class=\"report-footer\"><td>{{\'reports.housekeeping_report.total_rooms\' | i18next}}</td><td>{{report_data.dirty.count}}</td><td></td><td></td><td></td></tr></table></div></div></div></div>");
$templateCache.put("templates/reports/in-house-report_tpl.html","<div ng-controller=\"Reports.InHouseReportCtrl as report\"><legend class=\"header\">{{\'reports.in_house_report.legend\' | i18next}} <span class=\"printVisible\">{{\'general.other.for\' | i18next}} {{date | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'reports.general.choose_report_date_span\' | i18next}}:</span><md-datepicker ng-model=\"date\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'guestName\')\" ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-click=\"setOrderProperty(\'reference\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_reference_th\"></th><th ng-click=\"setOrderProperty(\'checkinDate\')\" ng-i18next=\"[html]reports.in_house_report.check_in_date_th\"></th><th ng-click=\"setOrderProperty(\'checkoutDate\')\" ng-i18next=\"[html]reports.in_house_report.check_out_date_th\"></th><th ng-click=\"setOrderProperty(\'occupancy\')\" ng-i18next=\"[html]general.other.occupancy\"></th><th ng-click=\"setOrderProperty(\'room\')\" ng-i18next=\"[html]general.other.room\"></th><th ng-click=\"setOrderProperty(\'rateType\')\" ng-i18next=\"[html]reports.in_house_report.rate_type_th\"></th><th ng-click=\"setOrderProperty(\'dailyRate\')\" ng-i18next=\"[html]reports.in_house_report.daily_rate_th\"></th><th ng-click=\"setOrderProperty(\'total\')\" class=\"text-right\" ng-i18next=\"[html]reports.in_house_report.cost_th\"></th><th ng-click=\"setOrderProperty(\'due\')\" class=\"text-right\" ng-i18next=\"[html]general.other.due\"></th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.report | orderBy:orderProperty:orderDirection\"><td>{{booking.guestName}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.reference}}</a></td><td>{{booking.checkinDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.checkoutDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.occupancy}} <span class=\"inhouse-childrens\" ng-if=\"booking.occupancyChildrens\">({{booking.occupancyChildrens}} {{\'general.other.children\' | i18next}})</span></td><td>{{booking.room}}</td><td>{{booking.rateType}}</td><td class=\"text-right\">{{booking.dailyRate | customCurrency:2}}</td><td class=\"text-right\">{{booking.total | customCurrency:2}}</td><td class=\"text-right\">{{booking.due | customCurrency:2}}</td></tr></tbody><tfoot><tr><th></th><th></th><th></th><th></th><th>{{totals.occupancy}} <span class=\"inhouse-childrens\" ng-if=\"totals.occupancyChildrens\">({{totals.occupancyChildrens}} {{\'general.other.children\' | i18next}})</span></th><th>{{totals.rooms}}</th><th></th><th></th><th class=\"text-right\">{{totals.total | customCurrency:2}}</th><th class=\"text-right\">{{totals.due | customCurrency:2}}</th></tr></tfoot></table></div></div></div></div>");
$templateCache.put("templates/reports/manager-report_tpl.html","<div ng-controller=\"Reports.ManagerReportCtrl as report\" class=\"manager-report\"><legend class=\"header\">{{\'reports.manager_report.legend\' | i18next}} <span class=\"printVisible\">{{ hotel.name }}, {{date| dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'general.other.date\' | i18next}}:</span><md-datepicker ng-model=\"date\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead></thead><tbody><tr class=\"reports-small-header\"><th></th><th></th><th class=\"text-center\">{{ c.year }}</th><th></th><th></th><th class=\"text-center\">{{ p.year }}</th><th></th></tr><tr class=\"border-bottom reports-small-header\"><th>{{\'reports.manager_report.description\' | i18next}}</th><th>{{\'reports.manager_report.today\' | i18next}}</th><th>{{\'reports.manager_report.mtd\' | i18next}}</th><th>{{\'reports.manager_report.ytd\' | i18next}}</th><th>{{\'reports.manager_report.today\' | i18next}}</th><th>{{\'reports.manager_report.mtd\' | i18next}}</th><th>{{\'reports.manager_report.ytd\' | i18next}}</th></tr><tr><td>{{\'reports.manager_report.arrival_rooms\' | i18next}}</td><td ng-class=\"{\'positive\': d.arrivalRooms.today > 0, \'negative\': d.arrivalRooms.today < 0}\">{{ c.arrivalRooms.today }} (<span ng-if=\"d.arrivalRooms.today > 0\">+</span>{{ d.arrivalRooms.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.arrivalRooms.mtd > 0, \'negative\': d.arrivalRooms.mtd < 0}\">{{ c.arrivalRooms.mtd }} (<span ng-if=\"d.arrivalRooms.mtd > 0\">+</span>{{ d.arrivalRooms.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.arrivalRooms.ytd > 0, \'negative\': d.arrivalRooms.ytd < 0}\">{{ c.arrivalRooms.ytd }} (<span ng-if=\"d.arrivalRooms.ytd > 0\">+</span>{{ d.arrivalRooms.ytd.toFixed(2) }}%)</td><td>{{ p.arrivalRooms.today }}</td><td>{{ p.arrivalRooms.mtd }}</td><td>{{ p.arrivalRooms.ytd }}</td></tr><tr><td>{{\'reports.manager_report.arrival_guests\' | i18next}}</td><td ng-class=\"{\'positive\': d.arrivalGuests.today > 0, \'negative\': d.arrivalGuests.today < 0}\">{{ c.arrivalGuests.today }} (<span ng-if=\"d.arrivalGuests.today > 0\">+</span>{{ d.arrivalGuests.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.arrivalGuests.mtd > 0, \'negative\': d.arrivalGuests.mtd < 0}\">{{ c.arrivalGuests.mtd }} (<span ng-if=\"d.arrivalGuests.mtd > 0\">+</span>{{ d.arrivalGuests.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.arrivalGuests.ytd > 0, \'negative\': d.arrivalGuests.ytd < 0}\">{{ c.arrivalGuests.ytd }} (<span ng-if=\"d.arrivalGuests.ytd > 0\">+</span>{{ d.arrivalGuests.ytd.toFixed(2) }}%)</td><td>{{ p.arrivalGuests.today }}</td><td>{{ p.arrivalGuests.mtd }}</td><td>{{ p.arrivalGuests.ytd }}</td></tr><tr><td>{{\'reports.manager_report.departure_rooms\' | i18next}}</td><td ng-class=\"{\'positive\': d.departureRooms.today > 0, \'negative\': d.departureRooms.today < 0}\">{{ c.departureRooms.today }} (<span ng-if=\"d.departureRooms.today > 0\">+</span>{{ d.departureRooms.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.departureRooms.mtd > 0, \'negative\': d.departureRooms.mtd < 0}\">{{ c.departureRooms.mtd }} (<span ng-if=\"d.departureRooms.mtd > 0\">+</span>{{ d.departureRooms.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.departureRooms.ytd > 0, \'negative\': d.departureRooms.ytd < 0}\">{{ c.departureRooms.ytd }} (<span ng-if=\"d.departureRooms.ytd > 0\">+</span>{{ d.departureRooms.ytd.toFixed(2) }}%)</td><td>{{ p.departureRooms.today }}</td><td>{{ p.departureRooms.mtd }}</td><td>{{ p.departureRooms.ytd }}</td></tr><tr class=\"border-bottom\"><td>{{\'reports.manager_report.departure_guests\' | i18next}}</td><td ng-class=\"{\'positive\': d.departureGuests.today > 0, \'negative\': d.departureGuests.today < 0}\">{{ c.departureGuests.today }} (<span ng-if=\"d.departureGuests.today > 0\">+</span>{{ d.departureGuests.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.departureGuests.mtd > 0, \'negative\': d.departureGuests.mtd < 0}\">{{ c.departureGuests.mtd }} (<span ng-if=\"d.departureGuests.mtd > 0\">+</span>{{ d.departureGuests.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.departureGuests.ytd > 0, \'negative\': d.departureGuests.ytd < 0}\">{{ c.departureGuests.ytd }} (<span ng-if=\"d.departureGuests.ytd > 0\">+</span>{{ d.departureGuests.ytd.toFixed(2) }}%)</td><td>{{ p.departureGuests.today }}</td><td>{{ p.departureGuests.mtd }}</td><td>{{ p.departureGuests.ytd }}</td></tr><tr><td colspan=\"7\"></td></tr><tr><td>{{\'reports.manager_report.cancellations\' | i18next}}</td><td ng-class=\"{\'positive\': d.cancellations.today > 0, \'negative\': d.cancellations.today < 0}\">{{ c.cancellations.today }} (<span ng-if=\"d.cancellations.today > 0\">+</span>{{ d.cancellations.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.cancellations.mtd > 0, \'negative\': d.cancellations.mtd < 0}\">{{ c.cancellations.mtd }} (<span ng-if=\"d.cancellations.mtd > 0\">+</span>{{ d.cancellations.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.cancellations.ytd > 0, \'negative\': d.cancellations.ytd < 0}\">{{ c.cancellations.ytd }} (<span ng-if=\"d.cancellations.ytd > 0\">+</span>{{ d.cancellations.ytd.toFixed(2) }}%)</td><td>{{ p.cancellations.today }}</td><td>{{ p.cancellations.mtd }}</td><td>{{ p.cancellations.ytd }}</td></tr><tr><td>{{\'reports.manager_report.reservations_made_today\' | i18next}}</td><td ng-class=\"{\'positive\': d.reservationsToday.today > 0, \'negative\': d.reservationsToday.today < 0}\">{{ c.reservationsToday.today }} (<span ng-if=\"d.reservationsToday.today > 0\">+</span>{{ d.reservationsToday.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.reservationsToday.mtd > 0, \'negative\': d.reservationsToday.mtd < 0}\">{{ c.reservationsToday.mtd }} (<span ng-if=\"d.reservationsToday.mtd > 0\">+</span>{{ d.reservationsToday.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.reservationsToday.ytd > 0, \'negative\': d.reservationsToday.ytd < 0}\">{{ c.reservationsToday.ytd }} (<span ng-if=\"d.reservationsToday.ytd > 0\">+</span>{{ d.reservationsToday.ytd.toFixed(2) }}%)</td><td>{{ p.reservationsToday.today }}</td><td>{{ p.reservationsToday.mtd }}</td><td>{{ p.reservationsToday.ytd }}</td></tr><tr><td>{{\'reports.manager_report.blocked_rooms\' | i18next}}</td><td ng-class=\"{\'positive\': d.blockedRooms.today > 0, \'negative\': d.blockedRooms.today < 0}\">{{ c.blockedRooms.today }} (<span ng-if=\"d.blockedRooms.today > 0\">+</span>{{ d.blockedRooms.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.blockedRooms.mtd > 0, \'negative\': d.blockedRooms.mtd < 0}\">{{ c.blockedRooms.mtd }} (<span ng-if=\"d.blockedRooms.mtd > 0\">+</span>{{ d.blockedRooms.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.blockedRooms.ytd > 0, \'negative\': d.blockedRooms.ytd < 0}\">{{ c.blockedRooms.ytd }} (<span ng-if=\"d.blockedRooms.ytd > 0\">+</span>{{ d.blockedRooms.ytd.toFixed(2) }}%)</td><td>{{ p.blockedRooms.today }}</td><td>{{ p.blockedRooms.mtd }}</td><td>{{ p.blockedRooms.ytd }}</td></tr><tr><td>{{\'reports.manager_report.occupancy\' | i18next}}</td><td ng-class=\"{\'positive\': d.occupancy.today > 0, \'negative\': d.occupancy.today < 0}\">{{ c.occupancy.today.toFixed(2) }}% (<span ng-if=\"d.occupancy.today > 0\">+</span>{{ d.occupancy.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupancy.mtd > 0, \'negative\': d.occupancy.mtd < 0}\">{{ c.occupancy.mtd.toFixed(2) }}% (<span ng-if=\"d.occupancy.mtd > 0\">+</span>{{ d.occupancy.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupancy.ytd > 0, \'negative\': d.occupancy.ytd < 0}\">{{ c.occupancy.ytd.toFixed(2) }}% (<span ng-if=\"d.occupancy.ytd > 0\">+</span>{{ d.occupancy.ytd.toFixed(2) }}%)</td><td>{{ p.occupancy.today.toFixed(2) }}%</td><td>{{ p.occupancy.mtd.toFixed(2) }}%</td><td>{{ p.occupancy.ytd.toFixed(2) }}%</td></tr><tr><td>{{\'reports.manager_report.occupancy_wo_blockers\' | i18next}}</td><td ng-class=\"{\'positive\': d.occupancyWoExcludes.today > 0, \'negative\': d.occupancyWoExcludes.today < 0}\">{{ c.occupancyWoExcludes.today.toFixed(2) }}% (<span ng-if=\"d.occupancyWoExcludes.today > 0\">+</span>{{ d.occupancyWoExcludes.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupancyWoExcludes.mtd > 0, \'negative\': d.occupancyWoExcludes.mtd < 0}\">{{ c.occupancyWoExcludes.mtd.toFixed(2) }}% (<span ng-if=\"d.occupancyWoExcludes.mtd > 0\">+</span>{{ d.occupancyWoExcludes.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupancyWoExcludes.ytd > 0, \'negative\': d.occupancyWoExcludes.ytd < 0}\">{{ c.occupancyWoExcludes.ytd.toFixed(2) }}% (<span ng-if=\"d.occupancyWoExcludes.ytd > 0\">+</span>{{ d.occupancyWoExcludes.ytd.toFixed(2) }}%)</td><td>{{ p.occupancyWoExcludes.today.toFixed(2) }}%</td><td>{{ p.occupancyWoExcludes.mtd.toFixed(2) }}%</td><td>{{ p.occupancyWoExcludes.ytd.toFixed(2) }}%</td></tr><tr><td>{{\'reports.manager_report.available_rooms\' | i18next}}</td><td ng-class=\"{\'positive\': d.availableRooms.today > 0, \'negative\': d.availableRooms.today < 0}\">{{ c.availableRooms.today }} (<span ng-if=\"d.availableRooms.today > 0\">+</span>{{ d.availableRooms.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.availableRooms.mtd > 0, \'negative\': d.availableRooms.mtd < 0}\">{{ c.availableRooms.mtd }} (<span ng-if=\"d.availableRooms.mtd > 0\">+</span>{{ d.availableRooms.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.availableRooms.ytd > 0, \'negative\': d.availableRooms.ytd < 0}\">{{ c.availableRooms.ytd }} (<span ng-if=\"d.availableRooms.ytd > 0\">+</span>{{ d.availableRooms.ytd.toFixed(2) }}%)</td><td>{{ p.availableRooms.today }}</td><td>{{ p.availableRooms.mtd }}</td><td>{{ p.availableRooms.ytd }}</td></tr><tr class=\"border-bottom\"><td>{{\'reports.manager_report.occupied_rooms\' | i18next}}</td><td ng-class=\"{\'positive\': d.occupiedRooms.today > 0, \'negative\': d.occupiedRooms.today < 0}\">{{ c.occupiedRooms.today }} (<span ng-if=\"d.occupiedRooms.today > 0\">+</span>{{ d.occupiedRooms.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupiedRooms.mtd > 0, \'negative\': d.occupiedRooms.mtd < 0}\">{{ c.occupiedRooms.mtd }} (<span ng-if=\"d.occupiedRooms.mtd > 0\">+</span>{{ d.occupiedRooms.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupiedRooms.ytd > 0, \'negative\': d.occupiedRooms.ytd < 0}\">{{ c.occupiedRooms.ytd }} (<span ng-if=\"d.occupiedRooms.ytd > 0\">+</span>{{ d.occupiedRooms.ytd.toFixed(2) }}%)</td><td>{{ p.occupiedRooms.today }}</td><td>{{ p.occupiedRooms.mtd }}</td><td>{{ p.occupiedRooms.ytd }}</td></tr><tr><td colspan=\"7\"></td></tr><tr><td>{{\'reports.manager_report.revenue_tomorrow\' | i18next}}</td><td>{{ c.revenueTomorrow.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td></td><td></td><td>{{ p.revenueTomorrow.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td></td><td></td></tr><tr><td>{{\'reports.manager_report.avg_rate_tomorrow\' | i18next}}</td><td>{{ c.avgRateTomorrow.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td></td><td></td><td>{{ p.avgRateTomorrow.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td></td><td></td></tr><tr><td>{{\'reports.manager_report.arrival_tomorrow\' | i18next}}</td><td ng-class=\"{\'positive\': d.arrivalTomorrow.today > 0, \'negative\': d.arrivalTomorrow.today < 0}\">{{ c.arrivalTomorrow.today }} (<span ng-if=\"d.arrivalTomorrow.today > 0\">+</span>{{ d.arrivalTomorrow.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.arrivalTomorrow.mtd > 0, \'negative\': d.arrivalTomorrow.mtd < 0}\">{{ c.arrivalTomorrow.mtd }} (<span ng-if=\"d.arrivalTomorrow.mtd > 0\">+</span>{{ d.arrivalTomorrow.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.arrivalTomorrow.ytd > 0, \'negative\': d.arrivalTomorrow.ytd < 0}\">{{ c.arrivalTomorrow.ytd }} (<span ng-if=\"d.arrivalTomorrow.ytd > 0\">+</span>{{ d.arrivalTomorrow.ytd.toFixed(2) }}%)</td><td>{{ p.arrivalTomorrow.today }}</td><td>{{ p.arrivalTomorrow.mtd }}</td><td>{{ p.arrivalTomorrow.ytd }}</td></tr><tr><td>{{\'reports.manager_report.departure_tomorrow\' | i18next}}</td><td ng-class=\"{\'positive\': d.departureTomorrow.today > 0, \'negative\': d.departureTomorrow.today < 0}\">{{ c.departureTomorrow.today }} (<span ng-if=\"d.departureTomorrow.today > 0\">+</span>{{ d.departureTomorrow.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.departureTomorrow.mtd > 0, \'negative\': d.departureTomorrow.mtd < 0}\">{{ c.departureTomorrow.mtd }} (<span ng-if=\"d.departureTomorrow.mtd > 0\">+</span>{{ d.departureTomorrow.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.departureTomorrow.ytd > 0, \'negative\': d.departureTomorrow.ytd < 0}\">{{ c.departureTomorrow.ytd }} (<span ng-if=\"d.departureTomorrow.ytd > 0\">+</span>{{ d.departureTomorrow.ytd.toFixed(2) }}%)</td><td>{{ p.departureTomorrow.today }}</td><td>{{ p.departureTomorrow.mtd }}</td><td>{{ p.departureTomorrow.ytd }}</td></tr><tr class=\"border-bottom\"><td>{{\'reports.manager_report.occupancy_tomorrow\' | i18next}}</td><td ng-class=\"{\'positive\': d.occupancyTomorrow.today > 0, \'negative\': d.occupancyTomorrow.today < 0}\">{{ c.occupancyTomorrow.today.toFixed(2) }}% (<span ng-if=\"d.occupancyTomorrow.today > 0\">+</span>{{ d.occupancyTomorrow.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupancyTomorrow.mtd > 0, \'negative\': d.occupancyTomorrow.mtd < 0}\">{{ c.occupancyTomorrow.mtd.toFixed(2) }}% (<span ng-if=\"d.occupancyTomorrow.mtd > 0\">+</span>{{ d.occupancyTomorrow.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.occupancyTomorrow.ytd > 0, \'negative\': d.occupancyTomorrow.ytd < 0}\">{{ c.occupancyTomorrow.ytd.toFixed(2) }}% (<span ng-if=\"d.occupancyTomorrow.ytd > 0\">+</span>{{ d.occupancyTomorrow.ytd.toFixed(2) }}%)</td><td>{{ p.occupancyTomorrow.today.toFixed(2) }}%</td><td>{{ p.occupancyTomorrow.mtd.toFixed(2) }}%</td><td>{{ p.occupancyTomorrow.ytd.toFixed(2) }}%</td></tr><tr><td colspan=\"7\"></td></tr><tr><td>{{\'reports.manager_report.revenue\' | i18next}}</td><td ng-class=\"{\'positive\': d.revenue.today > 0, \'negative\': d.revenue.today < 0}\">{{ c.revenue.today.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.revenue.today > 0\">+</span>{{ d.revenue.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.revenue.mtd > 0, \'negative\': d.revenue.mtd < 0}\">{{ c.revenue.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.revenue.mtd > 0\">+</span>{{ d.revenue.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.revenue.ytd > 0, \'negative\': d.revenue.ytd < 0}\">{{ c.revenue.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.revenue.ytd > 0\">+</span>{{ d.revenue.ytd.toFixed(2) }}%)</td><td>{{ p.revenue.today.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.revenue.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.revenue.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td></tr><tr><td>{{\'reports.manager_report.extras_revenue\' | i18next}}</td><td ng-class=\"{\'positive\': d.extrasRevenue.today > 0, \'negative\': d.extrasRevenue.today < 0}\">{{ c.extrasRevenue.today.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.extrasRevenue.today > 0\">+</span>{{ d.extrasRevenue.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.extrasRevenue.mtd > 0, \'negative\': d.extrasRevenue.mtd < 0}\">{{ c.extrasRevenue.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.extrasRevenue.mtd > 0\">+</span>{{ d.extrasRevenue.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.extrasRevenue.ytd > 0, \'negative\': d.extrasRevenue.ytd < 0}\">{{ c.extrasRevenue.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.extrasRevenue.ytd > 0\">+</span>{{ d.extrasRevenue.ytd.toFixed(2) }}%)</td><td>{{ p.extrasRevenue.today.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.extrasRevenue.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.extrasRevenue.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td></tr><tr><td>{{\'reports.manager_report.total_revenue\' | i18next}}</td><td ng-class=\"{\'positive\': d.totalRevenue.today > 0, \'negative\': d.totalRevenue.today < 0}\">{{ c.totalRevenue.today.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.totalRevenue.today > 0\">+</span>{{ d.totalRevenue.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.totalRevenue.mtd > 0, \'negative\': d.totalRevenue.mtd < 0}\">{{ c.totalRevenue.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.totalRevenue.mtd > 0\">+</span>{{ d.totalRevenue.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.totalRevenue.ytd > 0, \'negative\': d.totalRevenue.ytd < 0}\">{{ c.totalRevenue.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.totalRevenue.ytd > 0\">+</span>{{ d.totalRevenue.ytd.toFixed(2) }}%)</td><td>{{ p.totalRevenue.today.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.totalRevenue.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.totalRevenue.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td></tr><tr><td>{{\'reports.manager_report.avg_rate_room_revenue\' | i18next}}</td><td ng-class=\"{\'positive\': d.avgRateRoom.today > 0, \'negative\': d.avgRateRoom.today < 0}\">{{ c.avgRateRoom.today.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.avgRateRoom.today > 0\">+</span>{{ d.avgRateRoom.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.avgRateRoom.mtd > 0, \'negative\': d.avgRateRoom.mtd < 0}\">{{ c.avgRateRoom.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.avgRateRoom.mtd > 0\">+</span>{{ d.avgRateRoom.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.avgRateRoom.ytd > 0, \'negative\': d.avgRateRoom.ytd < 0}\">{{ c.avgRateRoom.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.avgRateRoom.ytd > 0\">+</span>{{ d.avgRateRoom.ytd.toFixed(2) }}%)</td><td>{{ p.avgRateRoom.today.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.avgRateRoom.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.avgRateRoom.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td></tr><tr><td>{{\'reports.manager_report.avg_rate_guest_revenue\' | i18next}}</td><td ng-class=\"{\'positive\': d.avgRateGuest.today > 0, \'negative\': d.avgRateGuest.today < 0}\">{{ c.avgRateGuest.today.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.avgRateGuest.today > 0\">+</span>{{ d.avgRateGuest.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.avgRateGuest.mtd > 0, \'negative\': d.avgRateGuest.mtd < 0}\">{{ c.avgRateGuest.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.avgRateGuest.mtd > 0\">+</span>{{ d.avgRateGuest.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.avgRateGuest.ytd > 0, \'negative\': d.avgRateGuest.ytd < 0}\">{{ c.avgRateGuest.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.avgRateGuest.ytd > 0\">+</span>{{ d.avgRateGuest.ytd.toFixed(2) }}%)</td><td>{{ p.avgRateGuest.today.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.avgRateGuest.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.avgRateGuest.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td></tr><tr><td>{{\'reports.manager_report.revpar\' | i18next}}</td><td ng-class=\"{\'positive\': d.revpar.today > 0, \'negative\': d.revpar.today < 0}\">{{ c.revpar.today.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.revpar.today > 0\">+</span>{{ d.revpar.today.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.revpar.mtd > 0, \'negative\': d.revpar.mtd < 0}\">{{ c.revpar.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.revpar.mtd > 0\">+</span>{{ d.revpar.mtd.toFixed(2) }}%)</td><td ng-class=\"{\'positive\': d.revpar.ytd > 0, \'negative\': d.revpar.ytd < 0}\">{{ c.revpar.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }} (<span ng-if=\"d.revpar.ytd > 0\">+</span>{{ d.revpar.ytd.toFixed(2) }}%)</td><td>{{ p.revpar.today.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.revpar.mtd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td><td>{{ p.revpar.ytd.toFixed(currencyFractionSize) }} {{ currencySymbol }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/meal-report_tpl.html","<div ng-controller=\"Reports.MealReportCtrl as report\"><legend class=\"header\">{{\'reports.meal_report.meal_report_legend\' | i18next}} <span class=\"printVisible\">{{\'general.other.for\' | i18next}} {{date | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><div class=\"report-extra-select\"><select-scrollable-meal-extras on-scroll=\"onLoadMealExtras\" on-search=\"onSearchMealExtras\" on-select=\"onSelectMealExtra\" options=\"extras\" placeholder=\"\'bookings.add_extras.choose_extra_floating_label\' | i18next\" caret-down-filled-suffix=\"true\" on-dropdown-visible-change=\"onDropdownVisibleChange\"></select-scrollable-meal-extras></div><span>{{\'general.other.date\' | i18next}}:</span><md-datepicker ng-model=\"date\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"onChange()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-6\"><legend>{{\'general.other.summary\' | i18next}}</legend><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'general.other.title\' | i18next}}</th><th>{{\'general.other.count\' | i18next}}</th><th>{{\'general.other.amount\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"extra in summary | orderBy:\'title\'\"><td>{{extra.title}}</td><td>{{extra.count}}</td><td>{{extra.amount | customCurrency:2}}</td></tr></tbody><tfoot><tr><th>{{\'general.other.total\' | i18next}}</th><th>{{summaryCount}}</th><th>{{summaryTotal | customCurrency:2}}</th></tr></tfoot></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'guestName\')\" ng-i18next=\"[html]reports.general.with_br_tag.guest_name_th\"></th><th ng-click=\"setOrderProperty(\'bookingReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_reference_th\"></th><th ng-click=\"setOrderProperty(\'roomNumber\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setOrderProperty(\'title\')\" ng-i18next=\"[html]general.other.meal_extra\"></th><th class=\"text-right\" ng-i18next=\"[html]general.other.count\"></th><th class=\"text-right\">{{\'general.other.total\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.soldExtras | orderBy:orderProperty:orderDirection\"><td>{{booking.guestName}}</td><td><a ng-click=\"openBooking(booking.bookingId)\">{{booking.bookingReference}}</a></td><td>{{booking.roomNumber}}</td><td class=\"text-left\">{{booking.title}}</td><td class=\"text-right\">{{booking.count}}</td><td class=\"text-right\">{{booking.revenue | customCurrency:2}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/occupancy-report_tpl.html","<div ng-controller=\"Reports.OccupancyReportCtrl as report\"><legend class=\"header\">{{\'reports.occupancy_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.from_legend_span\' | i18next}} {{dateFrom | dateToMoment:\'DD MMM YYYY\'}} {{\'general.other.to\' | i18next}} {{dateTo | dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report-filters screenVisible\"><md-checkbox ng-model=\"excludeBlockers\" aria-label=\"{{\'reports.general.exclude_blockers\' | i18next}}\">{{\'reports.general.exclude_blockers\' | i18next}}</md-checkbox></div><div class=\"report\"><div class=\"chart-block\"><h1>{{\'reports.occupancy_report.total_occupancy_title\' | i18next}} {{total}}%</h1><div class=\"total_occupancy_chart\"></div></div><div class=\"chart-block\"><h1>{{\'reports.occupancy_report.avarage_occupancy_for_title\' | i18next}} <span class=\"dropdown text-chooser\"><span class=\"dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">{{selected_room_type.roomType}} <span class=\"caret\"></span></span><ul class=\"dropdown-menu\"><li ng-repeat=\"el in report_data.report\"><a ng-click=\"selectRoomType(el)\">{{el.roomType}}</a></li></ul></span> &nbsp; {{selected_room_type.total.toFixed(2)}}%</h1><div class=\"avarage_occupancy_chart\"></div></div><div><h1>{{\'reports.occupancy_report.room_type_breakdown_title\' | i18next}}</h1><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'general.other.room_type\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_available_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_occupied_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_empty_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.occupancy_percentage_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.booking_rooms_count_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_count_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.rate_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.revenue_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"room_type in report_data.report | filter:\'!All Room Types\'\"><td>{{room_type.roomType}}</td><td class=\"text-right\">{{room_type.nights}}</td><td class=\"text-right\">{{room_type.booked}}</td><td class=\"text-right\">{{room_type.nights - room_type.booked}}</td><td class=\"text-right\">{{room_type.total.toFixed(2)}} %</td><td class=\"text-right\">{{room_type.bookingsCount}}</td><td class=\"text-right\">{{room_type.avgNights.toFixed(2)}}</td><td class=\"text-right\">{{room_type.avgRate.toFixed(2) || \'0.00\'}}</td><td class=\"text-right\">{{room_type.revenue.toFixed(2)}}</td></tr></tbody><tfoot><tr ng-repeat=\"room_type in report_data.report | filter:\'All Room Types\'\"><th>{{room_type.roomType}}</th><th class=\"text-right\">{{room_type.nights}}</th><th class=\"text-right\">{{room_type.booked}}</th><th class=\"text-right\">{{room_type.nights - room_type.booked}}</th><th class=\"text-right\">{{room_type.total.toFixed(2)}} %</th><th class=\"text-right\">{{room_type.bookingsCount}}</th><th class=\"text-right\">{{room_type.avgNights.toFixed(2)}}</th><th class=\"text-right\">{{room_type.avgRate.toFixed(2) || \'0.00\'}}</th><th class=\"text-right\">{{room_type.revenue.toFixed(2)}}</th></tr></tfoot></table></div><div><h1>{{\'reports.occupancy_report.room_breakdown_title\' | i18next}}</h1><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'reports.general.room_number_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_available_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_occupied_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_empty_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.occupancy_percentage_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.booking_rooms_count_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_count_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.rate_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.revenue_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"room in report_data.reportRooms\"><td>{{room.room}}</td><td class=\"text-right\">{{room.nights}}</td><td class=\"text-right\">{{room.booked}}</td><td class=\"text-right\">{{room.nights - room.booked}}</td><td class=\"text-right\">{{room.total.toFixed(2)}} %</td><td class=\"text-right\">{{room.bookingsCount}}</td><td class=\"text-right\">{{room.avgNights.toFixed(2)}}</td><td class=\"text-right\">{{room.avgRate.toFixed(2) || \'0.00\'}}</td><td class=\"text-right\">{{room.revenue.toFixed(2)}}</td></tr></tbody><tfoot><tr ng-repeat=\"room_type in report_data.report | filter:\'All Room Types\'\"><th>{{room_type.roomType}}</th><th class=\"text-right\">{{room_type.nights}}</th><th class=\"text-right\">{{room_type.booked}}</th><th class=\"text-right\">{{room_type.nights - room_type.booked}}</th><th class=\"text-right\">{{room_type.total.toFixed(2)}} %</th><th class=\"text-right\">{{room_type.bookingsCount}}</th><th class=\"text-right\">{{room_type.avgNights.toFixed(2)}}</th><th class=\"text-right\">{{room_type.avgRate.toFixed(2) || \'0.00\'}}</th><th class=\"text-right\">{{room_type.revenue.toFixed(2)}}</th></tr></tfoot></table></div><div><h1>{{\'reports.occupancy_report.daily_breakdown_title\' | i18next}}</h1><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'general.other.date\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_available_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_occupied_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_empty_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.occupancy_percentage_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.booking_rooms_count_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.nights_count_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.avg_lead_time_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.rate_avg_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.revenue_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.extras_revenue_th\' | i18next}}</th><th class=\"text-right\">{{\'reports.occupancy_report.total_revenue_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"date in report_data.dailyBreakdown | filter:\'!All Dates\'\"><td>{{date.date | dateToMoment:\'DD MMM YYYY\'}}</td><td class=\"text-right\">{{date.nights}}</td><td class=\"text-right\">{{date.bookingsCount}}</td><td class=\"text-right\">{{date.emptyNights}}</td><td class=\"text-right\">{{date.percentage.toFixed(2)}} %</td><td class=\"text-right\">{{date.bookingsCount}}</td><td class=\"text-right\">{{date.avgNights.toFixed(2)}}</td><td class=\"text-right\">{{date.avgLeadTime.toFixed(2)}}</td><td class=\"text-right\">{{date.avgRate.toFixed(2) || \'0.00\'}}</td><td class=\"text-right\">{{date.revenue.toFixed(2)}}</td><td class=\"text-right\">{{date.extrasRevenue.toFixed(2)}}</td><td class=\"text-right\">{{date.totalRevenue.toFixed(2)}}</td></tr></tbody><tfoot><tr ng-repeat=\"date in report_data.dailyBreakdown | filter:\'All Dates\'\"><th></th><th class=\"text-right\">{{date.nights}}</th><th class=\"text-right\">{{date.bookingsCount}}</th><th class=\"text-right\">{{date.emptyNights}}</th><th class=\"text-right\">{{date.percentage.toFixed(2)}} %</th><th class=\"text-right\">{{date.bookingsCount}}</th><th class=\"text-right\">{{date.avgNights.toFixed(2)}}</th><th class=\"text-right\">{{date.avgLeadTime.toFixed(2)}}</th><th class=\"text-right\">{{date.avgRate.toFixed(2) || \'0.00\'}}</th><th class=\"text-right\">{{date.revenue.toFixed(2)}}</th><th class=\"text-right\">{{date.extrasRevenue.toFixed(2)}}</th><th class=\"text-right\">{{date.totalRevenue.toFixed(2)}}</th></tr></tfoot></table></div></div></div>");
$templateCache.put("templates/reports/performance-charge-report_tpl.html","<div ng-controller=\"Reports.PerformanceChargeReportCtrl as report\"><legend class=\"header\">Performance Charge Report from {{report_data.dateFrom | dateToMoment:\'DD MMM YYYY\'}} to {{report_data.dateTo | dateToMoment:\'DD MMM YYYY\'}}</legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> Print</md-button><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> Export</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\">Performance Charge: {{report_data.totalBookingCost | number:2}}</div></div><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderProperty(\'customer\')\">Guest<br>Name</th><th ng-click=\"setOrderProperty(\'bookingReference\')\">Booking<br>Reference</th><th ng-click=\"setOrderProperty(\'arrivalDate\')\">Arrival<br>Date</th><th ng-click=\"setOrderProperty(\'bookingDate\')\">Booking<br>Date</th><th ng-click=\"setOrderProperty(\'nights\')\">Nights</th><th ng-click=\"setOrderProperty(\'amountOfRooms\')\">Amount<br>Of Rooms</th><th ng-click=\"setOrderProperty(\'roomNumbers\')\">Room<br>Number</th><th ng-click=\"setOrderProperty(\'bookingSource\')\">Booking<br>Source</th><th>Payments</th><th ng-click=\"setOrderProperty(\'status\')\">Status</th><th>Percent</th><th ng-click=\"setOrderProperty(\'bookingRoomCost\')\" class=\"text-right\">Total</th></tr></thead><tbody><tr ng-repeat=\"booking in report_data.bookings | orderBy:orderProperty:orderDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.bookingReference}}</a></td><td>{{booking.arrivalDate | date}}</td><td>{{booking.bookingDate | date}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td>{{(booking.bookingTotal / 100) | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td></tr></tbody><tfoot><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th>{{totalSum(\'bookingTotal\') / 100 | customCurrency:2}}</th><th class=\"text-right\">{{totalSum(\'bookingTotal\') | customCurrency:2}}</th></tr></tfoot></table></div></div></div></div>");
$templateCache.put("templates/reports/police-report_tpl.html","<div ng-controller=\"Reports.PoliceReportCtrl as report\"><legend class=\"header\">{{\'index.reports.police_report_link\' | i18next}}</legend><div class=\"report-date-picker-container screenVisible\"><md-button ng-click=\"getPoliceReport()\" class=\"md-raised md-success md-button\" ng-disabled=\"requested\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\' : requested}\"></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><div ng-if=\"isSpainHotel\" style=\"display: inline-block\"><md-button ng-click=\"export(\'bin\')\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_bin_button\' | i18next}}</md-button><md-button ng-click=\"export(\'xlsx\')\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_xls_button\' | i18next}}</md-button></div><div ng-if=\"!isSpainHotel\" style=\"display: inline-block\"><md-button ng-click=\"export()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_xls_button\' | i18next}}</md-button></div></div><div class=\"report-filters screenVisible\">{{\'inventory.filters_legend\' | i18next}}: <span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span ng-show=\"hotel.country != \'Spain\'\">{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" ng-show=\"hotel.country != \'Spain\'\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker></div><div class=\"report\"><div><div class=\"warnings alert alert-warning\" ng-if=\"hotel.country == \'ES\' && !hotel.addons[\'hotelEstablishmentEs\']\"><p>Please configure Hotel Establishment Code in <a href=\"#/settings/profile/details\">profile settings</a> before export</p></div><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-repeat=\"col in fields\" ng-click=\"setOrderProperty(col[1])\">{{col[0]}}</th></tr></thead><tbody><tr ng-repeat=\"guest in report.guests | orderBy:orderProperty:orderDirection\"><td ng-repeat=\"col in fields\" dynamic=\"col[2]\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("templates/reports/rate-plan-report_tpl.html","<div ng-controller=\"Reports.RatePlanReportCtrl as report\" class=\"rate-plan-report\"><legend class=\"header\">{{\'reports.channel_report.rate_plan_breakdown\' | i18next}} <span class=\"printVisible\">{{\'reports.general.types_fo_reports.\' + type | i18next}} {{\'reports.general.from_legend_span\' | i18next}} {{dateFrom| dateToMoment:\'DD MMM YYYY\'}} {{\'reports.general.to_span\' | i18next}} {{dateTo| dateToMoment:\'DD MMM YYYY\'}}</span><br></legend><legend><small>This report calculates on the room level and will not include extra revenue</small></legend><div class=\"report-date-picker-container screenVisible\"><md-input-container><md-select ng-model=\"type\"><md-option ng-repeat=\"type in types\" value=\"{{type}}\">{{\'reports.general.types_fo_reports.\' + type | i18next}}</md-option></md-select></md-input-container><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button><md-button ng-click=\"export_to_excel()\"><i class=\"fa fa-table\"></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setOrderPropertyRate(\'title\')\">{{\'reports.channel_report.rate_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'numberOfReservations\')\">{{\'reports.channel_report.number_of_rooms_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'numberOfRoomNights\')\">{{\'reports.channel_report.number_of_room_nights_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'persons\')\">{{\'reports.housekeeping_report.persons_td\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'avgLeadTime\')\">{{\'reports.channel_report.avg_lead_time_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'avgLengthOfStay\')\">{{\'reports.channel_report.avg_length_of_stay_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'avgNightlyRate\')\">{{\'reports.channel_report.avg_nightly_rate_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'avgEarning\')\">{{\'reports.channel_report.avg_earning_th\' | i18next}}</th><th ng-click=\"setOrderPropertyRate(\'totalEarning\')\">{{\'reports.channel_report.total_earning_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat-start=\"rate in report_data.rates | orderBy:orderPropertyRate:orderDirectionRate\"><td ng-click=\"showRatePlanBookings(rate)\"><span class=\"dashed\">{{rate.title}}</span></td><td>{{rate.numberOfReservations}}</td><td>{{rate.numberOfNights}}</td><td>{{rate.persons}}</td><td>{{rate.avgLeadTime | number:2}}</td><td>{{rate.avgLengthOfStay | number:2}}</td><td>{{rate.avgNightlyRate | number:2}}</td><td>{{rate.avgEarnings | number:2}}</td><td>{{rate.earnings | number:2}}</td></tr><tr ng-repeat-end=\"\" ng-show=\"rate.showBookings == true\"><td colspan=\"9\"><table class=\"table\" ng-if=\"rate.showBookings == true\"><thead><tr class=\"reports-small-header\"><th ng-click=\"setBookingOrderProperty(\'customer\')\" ng-i18next=\"[html]reports.general.with_br_tag.customer\"></th><th ng-click=\"setBookingOrderProperty(\'ourReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.our_reference_th\"></th><th ng-click=\"setBookingOrderProperty(\'channelReference\')\" ng-i18next=\"[html]reports.general.with_br_tag.channel_reference_th\"></th><th ng-click=\"setBookingOrderProperty(\'arrivalDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.arrival_date_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingDate\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_date_th\"></th><th ng-click=\"setBookingOrderProperty(\'nights\')\" ng-i18next=\"[html]general.other.nights\"></th><th ng-click=\"setBookingOrderProperty(\'amountOfRooms\')\" ng-i18next=\"[html]reports.general.with_br_tag.amount_of_rooms_th\"></th><th ng-click=\"setBookingOrderProperty(\'roomNumbers\')\" ng-i18next=\"[html]reports.general.with_br_tag.room_number_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingSource\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_source_th\"></th><th ng-i18next=\"[html]reports.general.payments_th\"></th><th ng-click=\"setBookingOrderProperty(\'status\')\" ng-i18next=\"[html]reports.general.status_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingTotal\')\" ng-i18next=\"[html]reports.general.with_br_tag.booking_total_th\"></th><th ng-click=\"setBookingOrderProperty(\'bookingDue\')\" class=\"text-right\" ng-i18next=\"[html]reports.general.with_br_tag.total_due_th\"></th></tr></thead><tbody><tr ng-repeat=\"booking in rate.bookings | orderBy:orderBookingProperty:orderBookingDirection\"><td>{{booking.customer}}</td><td><a ng-click=\"openBooking(booking.id)\">{{booking.ourReference}}</a></td><td><a ng-click=\"openBooking(booking.id)\">{{booking.channelReference}}</a></td><td>{{booking.arrivalDate | dateToMoment: \'MMM D, YYYY\'}}</td><td>{{booking.bookingDate | dateToMoment: \'MMM D, YYYY\'}}</td><td class=\"text-center\">{{booking.nights}}</td><td class=\"text-center\">{{booking.amountOfRooms}}</td><td class=\"text-center\">{{booking.roomNumbers}}</td><td>{{booking.bookingSource}}</td><td class=\"payment-row\"><div class=\"row\" ng-repeat=\"payment in booking.payments\"><div class=\"col-xs-7\"><span ng-if=\"payment.type != \'Credit Card\'\">{{payment.type}}</span> {{payment.description}}</div><div class=\"col-xs-5 text-right\">{{payment.amount | customCurrency:2}}</div></div></td><td>{{booking.status}}</td><td class=\"text-right\">{{booking.bookingTotal | customCurrency:2}}</td><td class=\"text-right\">{{booking.bookingDue | customCurrency:2}}</td></tr></tbody></table></td></tr></tbody><tfoot><tr><th></th><th>{{report_data.rateTotals.totalNumberOfReservations}}</th><th>{{report_data.rateTotals.totalNumberOfRoomNights}}</th><th>{{report_data.rateTotals.totalPersons}}</th><th>{{report_data.rateTotals.totalAvgLeadTime | number:2}}</th><th>{{report_data.rateTotals.totalAvgLengthOfStay | number:2}}</th><th>{{report_data.rateTotals.totalAvgNightlyRate | number:2}}</th><th>{{report_data.rateTotals.totalAvgEarnings | number:2}}</th><th>{{report_data.rateTotals.totalEarning | number:2}}</th></tr></tfoot></table></div></div></div></div>");
$templateCache.put("templates/reports/reservation-report_tpl.html","<div ng-controller=\"Reports.ReservationReportCtrl as report\"><legend class=\"header\">{{\'reports.reservation_report.legend\' | i18next}} <span class=\"printVisible\">{{\'reports.general.types_fo_reports.\' + type | i18next}} {{\'reports.general.from_legend_span\' | i18next}} {{dateFrom| dateToMoment:\'DD MMM YYYY\'}} {{\'reports.general.to_span\' | i18next}} {{dateTo| dateToMoment:\'DD MMM YYYY\'}}</span></legend><div class=\"report-date-picker-container screenVisible\"><md-input-container><md-select ng-model=\"type\"><md-option ng-repeat=\"type in types\" value=\"{{type}}\">{{\'reports.general.types_fo_reports.\' + type | i18next}}</md-option></md-select></md-input-container><span>{{\'general.other.from\' | i18next}}:</span><md-datepicker ng-model=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><span>{{\'reports.general.to_span\' | i18next}}:</span><md-datepicker ng-model=\"dateTo\" md-min-date=\"dateFrom\" md-placeholder=\"Choose report date\"></md-datepicker><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"print()\"><i class=\"fa fa-print\"></i> {{\'reports.general.print_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table\"><thead><tr class=\"reports-small-header\"><th>{{\'reports.reservation_report.date_th\' | i18next}}</th><th>{{\'reports.reservation_report.arrivals_th\' | i18next}}</th><th>{{\'reports.reservation_report.staying_th\' | i18next}}</th><th>{{\'reports.reservation_report.departures_th\' | i18next}}</th><th>{{\'reports.reservation_report.in_house_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"date in report_data\"><td>{{date.date}}</td><td>{{date.arrivals}}</td><td>{{date.stayOvers}}</td><td>{{date.departures}}</td><td>{{date.inHouse}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/reports/statistical-report-is_tpl.html","<div ng-controller=\"Reports.StatisticalReportIsCtrl as report\"><legend class=\"header\">{{\'reports.statistical_report_is_report.legend\' | i18next}}</legend><div class=\"report-date-picker-container screenVisible statistical-report-date-picker\"><md-select ng-model=\"dateFrom\" md-placeholder=\"Choose report date\" style=\"display: inline-block; width: 200px;\"><md-option ng-repeat=\"date in dates\" ng-value=\"date\">{{date | dateToMoment:\"MMM YYYY\"}}</md-option></md-select><md-button ng-click=\"getReport()\" class=\"md-raised md-success md-button\"><i class=\"fa fa-refresh\" ng-class=\'{\"fa-spin\" : loading}\'></i> {{\'reports.general.run_report_button\' | i18next}}</md-button><md-button ng-click=\"validate()\"><i class=\"fa\" ng-class=\'{\"fa-spin\" : loading, \"fa-refresh\": loading, \"fa-print\": !loading}\'></i> {{\'reports.general.validate_button\' | i18next}}</md-button><md-button ng-click=\"send()\"><i class=\"fa\" ng-class=\'{\"fa-spin\" : loading, \"fa-refresh\": loading, \"fa-print\": !loading}\'></i> {{\'reports.general.validate_and_send_button\' | i18next}}</md-button><md-button ng-click=\"export()\"><i class=\"fa\" ng-class=\'{\"fa-spin\" : loading, \"fa-refresh\": loading, \"fa-table\": !loading}\'></i> {{\'reports.general.export_button\' | i18next}}</md-button></div><div class=\"report\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"errors\" ng-if=\"errors.length\"><h3>{{\'reports.statistical_report_is.errors_to_be_fixed\' | i18next}}:</h3><table class=\"table\"><tbody><tr ng-repeat=\"error in errors\"><td><span ng-if=\"error[0] == \'validate\'\">{{error[1]}}</span> <span ng-if=\"error[0] == \'send\'\">{{error[1]}}</span> <a ng-if=\"error[0] == \'hotel\'\" href=\"/#/settings/other/country-specific\">{{\'index.reports.statistical-report\' | i18next}} {{\'profile_nav.settings.booking_engine.channel_manager.vertical_booking.hotel_id_label\' | i18next}}: {{error[1]}}</a> <a ng-if=\"error[0] == \'provider\'\" href=\"/#/settings/other/country-specific\">{{\'reports.statistical_report_is.report_provider\' | i18next}}: {{error[1]}}</a> <a ng-if=\"error[0] == \'contact\'\" href=\"/#/settings/other/country-specific\">{{\'reports.statistical_report_is.report_contact\' | i18next}}: {{error[1]}}</a> <a ng-if=\"error[0] == \'guest\'\" href=\"\" ng-click=\"openGuest(error[2],error[3])\">{{ \'bookings.room_edit.guest_legend\' | i18next}}: {{error[1]}}, {{error[4]}}</a> <a ng-if=\"error[0] == \'room\'\" href=\"/#/settings/inventory/room-type\">{{\'checkin_dialog.room\' | i18next}} {{error[1]}} ({{error[2]}}): {{error[3]}}</a></td></tr></tbody></table></div><div class=\"row\"><div class=\"col-xs-6\"><h3>{{\'reports.statistical_report_is.report_provider\' | i18next}}</h3><p>{{\'reports.statistical_report_is.name\' | i18next}}: <strong>{{ report.providers[0].name }}</strong></p><p>{{\'reports.statistical_report_is.uniq_id\' | i18next}}: <strong>{{ report.providers[0].uniqueId }}</strong></p><p>{{\'reports.statistical_report_is.email\' | i18next}}: <strong>{{ report.providers[0].email }}</strong></p><p>{{\'reports.statistical_report_is.phone\' | i18next}}: <strong>{{ report.providers[0].phone }}</strong></p><p>{{\'reports.statistical_report_is.address\' | i18next}}: <strong>{{ report.providers[0].address }}</strong></p><p>{{\'reports.statistical_report_is.postcode\' | i18next}}: <strong>{{ report.providers[0].postcode }}</strong></p><p>{{\'reports.statistical_report_is.url\' | i18next}}: <strong>{{ report.providers[0].url }}</strong></p></div><div class=\"col-xs-6\"><h3>{{\'reports.statistical_report_is.report_contact\' | i18next}}</h3><p>{{\'reports.statistical_report_is.name\' | i18next}}: <strong>{{ report.contactPersons[0].name }}</strong></p><p>{{\'reports.statistical_report_is.uniq_id\' | i18next}}: <strong>{{ report.contactPersons[0].uniqueId }}</strong></p><p>{{\'reports.statistical_report_is.email\' | i18next}}: <strong>{{ report.contactPersons[0].email }}</strong></p><p>{{\'reports.statistical_report_is.phone\' | i18next}}: <strong>{{ report.contactPersons[0].phone }}</strong></p><p>{{\'reports.statistical_report_is.address\' | i18next}}: <strong>{{ report.contactPersons[0].address }}</strong></p><p>{{\'reports.statistical_report_is.postcode\' | i18next}}: <strong>{{ report.contactPersons[0].postcode }}</strong></p><p>{{\'reports.statistical_report_is.url\' | i18next}}: <strong>{{ report.contactPersons[0].url }}</strong></p></div></div><h3>{{\'reports.statistical_report_is.bed_totals\' | i18next}}</h3><table class=\"table\"><thead><tr class=\"\"><th>{{\'reports.statistical_report_is.num_rooms_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.num_beds_rooms_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.num_apartments_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.num_beds_apartments_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.num_summer_houses_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.num_beds_summer_houses_th\' | i18next}}</th></tr></thead><tbody><tr><td>{{report.roomInfo[0].numRooms}}</td><td>{{report.roomInfo[0].numRoomsBeds}}</td><td>{{report.roomInfo[0].numApartments}}</td><td>{{report.roomInfo[0].numApartmentsBeds}}</td><td>{{report.roomInfo[0].numSummerHouses}}</td><td>{{report.roomInfo[0].numSummerHousesBeds}}</td></tr></tbody></table><h3>{{\'reports.statistical_report_is.country_summary\' | i18next}}</h3><table class=\"table\"><thead><tr class=\"\"><th>{{\'reports.statistical_report_is.country_code_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.type_of_tourism_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.guests_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.nights_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.avg_price_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"row in report.guestInfo\"><td>{{row.countryCode}}</td><td>{{row.typeOfTourism}}</td><td>{{row.guests}}</td><td>{{row.nights}}</td><td>{{row.averagePrice}}</td></tr></tbody></table><h3>{{\'reports.statistical_report_is.nights_totals\' | i18next}}</h3><table class=\"table\"><thead><tr class=\"\"><th>{{\'reports.statistical_report_is.room_nights_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.apartment_nights_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.summer_house_nights_th\' | i18next}}</th><th>{{\'reports.statistical_report_is.avg_price_th\' | i18next}}</th></tr></thead><tbody><tr><td>{{report.totalNightsRooms}}</td><td>{{report.totalNightsApartments}}</td><td>{{report.totalNightsSummerHouses}}</td><td>{{report.averagePrice}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("templates/ui/condition_group_tpl.html","<div class=\"condition-group\"><div class=\"condition-controls\"><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'active\': value.rule === \'ALL\'}\" ng-click=\"ctrl.changeGroupType(value, \'ALL\')\">{{\'profile_nav.settings.other.reactions.condition_group.all_conditions_match_button\' | i18next}}</button> <button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'active\': value.rule === \'ANY\'}\" ng-click=\"ctrl.changeGroupType(value, \'ANY\')\">{{\'profile_nav.settings.other.reactions.condition_group.any_conditions_matches_button\' | i18next}}</button></div><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"ctrl.addCondition(value)\">{{\'profile_nav.settings.other.reactions.condition_group.add_condition_button\' | i18next}}</button> <button class=\"btn btn-default\" ng-click=\"ctrl.addGroup(value)\">{{\'profile_nav.settings.other.reactions.condition_group.add_group_button\' | i18next}}</button></div></div><div class=\"conditions-group-control\" ng-if=\"parent\"><a ng-click=\"ctrl.removeGroup(value, parent)\"><i class=\"fa fa-times\"></i></a></div><div class=\"condition-rule\" ng-repeat=\"condition in value.conditions track by $index\"><div class=\"condition-rule-row\"><div class=\"form-group\"><div class=\"col-xs-5\"><select class=\"form-control\" ng-model=\"condition[1]\" ng-change=\"ctrl.changeCondition(condition, value, $index)\"><option ng-repeat=\"condition_rule in ctrl.conditions\" value=\"{{condition_rule[0]}}\">{{condition_rule[1]}}</option></select></div><div class=\"col-xs-2\"><select class=\"form-control\" ng-disabled=\"condition[1].indexOf(\'.\') > -1 || (condition.$operators || []).length < 2\" ng-model=\"condition[0]\"><option value=\"{{opt.value}}\" ng-repeat=\"opt in condition.$operators\">{{opt.title | i18next}}</option></select></div><div ng-switch=\"condition.$type\"><div ng-switch-when=\"input\"><div class=\"col-xs-5\"><input class=\"form-control\" ng-disabled=\"condition[1].indexOf(\'.\') > -1\" ng-model=\"condition[2]\"></div></div><div ng-switch-when=\"multiselect\"><div class=\"col-xs-5\"><select multiple=\"\" multi-select=\"\" ng-model=\"condition[2]\" ng-options=\"item.id as item.name for item in condition.$options\"></select></div></div></div></div><div class=\"condition-row-control\"><div class=\"conditions-control\"><a ng-click=\"ctrl.removeCondition(value, $index)\"><i class=\"fa fa-times\"></i></a></div></div></div></div><div ng-if=\"value.groups && value.groups.length > 0\"><settings-condition-group ng-model=\"group\" ng-repeat=\"group in value.groups track by $index\" ng-scope=\"ctrl\" parent=\"value\"></settings-condition-group></div></div>");
$templateCache.put("templates/ui/condition_rule_tpl.html","<div class=\"condition-rule\"><div class=\"form-group\"><div class=\"col-xs-5\"><select class=\"form-control\"><option ng-repeat=\"condition in ctrl.conditions\" ng-value=\"condition\">{{condition}}</option></select></div><div class=\"col-xs-2\"><select class=\"form-control\"><option value=\">\">Greater</option><option value=\"<\">Less</option><option value=\"=\">Equal</option><option value=\"!=\">Not Equal</option><option value=\">=\">Greater or Equal</option><option value=\"<=\">Less or Equal</option></select></div><div class=\"col-xs-4\"><input class=\"form-control\"></div><div class=\"col-xs-1\"><i class=\"fa fa-times\"></i></div></div></div>");
$templateCache.put("templates/ui/month_selector_tpl.html","<md-menu><md-button class=\"md-button\" ng-click=\"openMenu($mdOpenMenu, $event)\">{{value | date : \"MMMM yyyy\"}}</md-button><md-menu-content width=\"4\"><div class=\"month-selector year-zone\"><button class=\"md-button md-icon-button month-selector btn-prev\" ng-click=\"prevYear($event)\"><i class=\"fa fa-arrow-circle-left\"></i></button> {{value | date : \"MMMM yyyy\"}} <button class=\"md-button md-icon-button month-selector btn-next\" ng-click=\"nextYear($event)\"><i class=\"fa fa-arrow-circle-right\"></i></button></div><div class=\"month-selector month-zone\"><ul><li><button class=\"md-button\" ng-click=\"setMonth(0)\">Jan</button></li><li><button class=\"md-button\" ng-click=\"setMonth(1)\">Feb</button></li><li><button class=\"md-button\" ng-click=\"setMonth(2)\">Mar</button></li><li><button class=\"md-button\" ng-click=\"setMonth(3)\">Apr</button></li><li><button class=\"md-button\" ng-click=\"setMonth(4)\">May</button></li><li><button class=\"md-button\" ng-click=\"setMonth(5)\">Jun</button></li><li><button class=\"md-button\" ng-click=\"setMonth(6)\">Jul</button></li><li><button class=\"md-button\" ng-click=\"setMonth(7)\">Aug</button></li><li><button class=\"md-button\" ng-click=\"setMonth(8)\">Sep</button></li><li><button class=\"md-button\" ng-click=\"setMonth(9)\">Oct</button></li><li><button class=\"md-button\" ng-click=\"setMonth(10)\">Nov</button></li><li><button class=\"md-button\" ng-click=\"setMonth(11)\">Dec</button></li></ul></div><button class=\"md-button btn--current\" ng-click=\"currentMonth()\">Current month</button></md-menu-content></md-menu><button class=\"md-button md-icon-button month-selector btn-prev\" ng-click=\"prevMonth()\"><md-tooltip md-direction=\"top\">Previous Month</md-tooltip><i class=\"fa fa-arrow-circle-left\"></i></button> <button class=\"md-button md-icon-button month-selector btn-next\" ng-click=\"nextMonth()\"><md-tooltip md-direction=\"top\">Next Month</md-tooltip><i class=\"fa fa-arrow-circle-right\"></i></button>");
$templateCache.put("templates/ui/multi_email_input_tpl.html","<md-input-container class=\"multi-email-input\" ng-class=\"{\'md-input-focused\': inputFocused, \'md-input-invalid\': input && !inputIsValid}\" flex=\"\"><label ng-class=\"{\'chips-label-float\': emails.length || inputFocused || input}\">{{placeholder}}</label><div class=\"input-row-flex\"><div class=\"multi-email-chips-row\" ng-click=\"focusInput()\"><div class=\"multi-email-chip\" ng-repeat=\"email in emails track by $index\">{{email}}<md-button type=\"button\" class=\"md-icon-button remove-chip\" ng-click=\"removeEmail($index)\" tabindex=\"-1\"><md-icon>close</md-icon></md-button></div><input type=\"text\" ng-model=\"input\" ng-keydown=\"onKeydown($event)\" ng-blur=\"onBlur()\" ng-focus=\"onFocus()\" placeholder=\"\" aria-label=\"{{placeholder}}\" class=\"multi-email-text-input\"></div><md-button class=\"md-primary\" type=\"button\" ng-click=\"addEmail(input)\" ng-disabled=\"!input || !inputIsValid\" style=\"min-width:38px;height:32px;\"><md-icon>add</md-icon></md-button></div><div ng-if=\"input && !inputIsValid\" class=\"email-error\">{{\'general.email_invalid\' | i18next}}</div><div ng-if=\"isAtMaxEmails\" class=\"email-error\">{{\'general.limit_reached\' | i18next}}</div><div ng-if=\"ngModelCtrl.$error.required && !inputFocused\" class=\"email-error\">{{ requiredMessage }}</div></md-input-container>");
$templateCache.put("templates/ui/ui_prompt_tpl.html","<div class=\"modal buuqit-modal\" ng-show=\"isOpened\"><div class=\"title\">{{title}}</div><div class=\"content\"><md-input-container><label>Some label for input</label> <input ng-model=\"value\" type=\"number\"></md-input-container></div><div class=\"actions\"><md-button class=\"md-raised\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-raised md-primary\">Confirm</md-button></div></div>");
$templateCache.put("templates/website_settings/about_text_tpl.html","<legend class=\"header\">{{\'website_settings.static_text.about_page.about_page_legend\' | i18next}}<br><small>{{\'website_settings.static_text.about_page.small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><div class=\"form-group\"><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.aboutText\" on-image-upload=\"imageUpload(files, \'aboutTextEditable\', \'aboutTextEditor\')\" data-role=\"aboutTextEditor\"></summernote></div></div><legend>{{\'website_settings.static_text.about_page.associated_images_legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\"><div class=\"form-group photos\"><div class=\"photos-container\" ng-show=\"(website.aboutPhotos.length > 0)\"><div ng-repeat=\"photo in website.aboutPhotos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.data}}\" ng-show=\"photo.data\"> <img ng-src=\"{{photo.photo}}\" ng-show=\"photo.photo\"></div><div class=\"tools\"><a href=\"{{photo.photo.replace(\'thumb\', \'big\')}}\" ng-show=\"photo.photo\" aria-label=\"{{\'website_settings.static_text.about_page.direct_link_tooltip\' | i18next}}\"><md-tooltip md-direction=\"bottom\">{{\'website_settings.static_text.about_page.direct_link_tooltip\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <span class=\"pull-right\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><i class=\"fa fa-times-circle\" ng-hide=\"photo.loading\" ng-click=\"removeFromAboutPhotos(photo)\"></i><md-tooltip md-direction=\"bottom\" ng-hide=\"photo.loading\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><md-tooltip md-direction=\"bottom\" ng-show=\"photo.loading\">{{\'general.tooltip.removing\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-show=\"photo.loading\"></i></span></div></div></div><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" ng-model=\"aboutPhoto\" multiple=\"\" onchange=\"angular.element(this).scope().loadAboutPhotos(event)\"></div></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/blog_edit_tpl.html","<legend class=\"header\" ng-show=\"blog_record.id != undefined\">{{\'website_settings.blog_record.edit_blog_record_legend\' | i18next}}<br><small>{{\'website_settings.blog_record.small\' | i18next}}</small></legend><legend class=\"header\" ng-show=\"blog_record.id == undefined\">{{\'website_settings.blog_record.add_new_blog_record_legend\' | i18next}}<br><small>{{\'website_settings.blog_record.small\' | i18next}}</small></legend><div class=\"settings-body-block\" ng-show=\"blogLoad !== false\"><div class=\"block-loader\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': blogLoad !== false}\"></i></div></div><div ng-show=\"blogLoad === false\"><div class=\"settings-body-block top-padding-cropped marged-bottom\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"blog_record.title\" ng-change=\"slugify(blog_record.title, blog_record)\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'general.other.text\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"blog_record.text\" on-image-upload=\"imageUpload(files, \'blogEditable\', \'blogEditor\')\" data-role=\"blogEditor\"></summernote></div></div><legend class=\"header\">{{\'website_settings.blog_record.search_settings_legend\' | i18next}}</legend><div class=\"settings-body-block top-padding-cropped marged-bottom\"><md-input-container><label>{{\'general.other.slug\' | i18next}}</label> <input type=\"text\" ng-model=\"blog_record.slug\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.page_title\' | i18next}}</label> <input type=\"text\" ng-model=\"blog_record.pageTitle\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.meta_description\' | i18next}}</label> <input type=\"text\" ng-model=\"blog_record.metaDescription\" md-maxlength=\"255\"></md-input-container></div><legend class=\"header\">{{\'website_settings.blog_record.cover_image_legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\"><div class=\"customPhoto existedPhoto fieldPhoto text-center ng-scope\"><div class=\"photoBlock\"><img ng-src=\"{{blog_record.data}}\" ng-show=\"blog_record.cover.data === null || blog_record.data !== undefined\"> <img ng-src=\"{{blog_record.cover}}\" ng-show=\"blog_record.cover.data !== null && blog_record.data === undefined\"></div><md-button class=\"md-raised md-orange\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().loadBlogRecordCover(event, angular.element(this).scope().blog_record)\"> {{\'general.buttons.change\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"removeCoverImage(blog_record)\" ng-show=\"blog_record.cover.indexOf(\'missing\') == -1\">{{\'general.buttons.remove\' | i18next}}</md-button></div><md-input-container><label>{{\'website_settings.blog_record.cover_image_alt_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"blog_record.altText\" md-maxlength=\"255\"></md-input-container></div><legend class=\"header\">{{\'website_settings.blog_record.visibility_legend\' | i18next}}</legend><div class=\"settings-body-block top-padding-cropped\"><md-checkbox ng-model=\"blog_record.published\" aria-label=\"{{\'general.aria_labels.published\' | i18next}}\">{{\'general.checkboxs.published\' | i18next}}</md-checkbox></div><div class=\"text-right toolbar-bottom\" ng-show=\"blog_record.id != undefined\"><md-button class=\"md-raised md-warn pull-left\" ng-click=\"removeBlogRecord($event, blog_record)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"removeBlogRecordLoader\"></i> {{\'general.buttons.remove\' | i18next}}</md-button><md-button class=\"md-raised\" ng-click=\"closeEditBlogRecord($event, blog_record, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditBlogRecord($event, blog_record, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"text-right toolbar-bottom\" ng-show=\"blog_record.id == undefined\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddBlogRecordForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewBlogRecord()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/blog_tpl.html","<legend class=\"header\">{{\'website_settings.blog_posts.legend\' | i18next}}<br><small>{{\'website_settings.blog_posts.small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped\"><md-input-container><label>{{\'website_settings.blog_posts.blog_section_title_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.blogSectionTitle\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'website_settings.blog_posts.blog_section_description_label\' | i18next}}:</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.blogSectionDescription\" on-image-upload=\"imageUpload(files, \'blogDescEditable\', \'blogDescEditor\')\" data-role=\"blogDescEditor\"></summernote></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><legend class=\"header\">{{\'website_settings.blog_posts.blog_records_legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\" ng-show=\"blogLoad !== false\"><div class=\"block-loader\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': blogLoad !== false}\"></i></div></div><div class=\"settings-body-block marged-bottom\" ng-show=\"blogLoad === false\"><table class=\"table table-striped\"><thead><tr><th>{{\'general.other.title\' | i18next}}</th><th>{{\'website_settings.blog_posts.created_at_th\' | i18next}}</th><th>{{\'general.other.published\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"record in blogRecords track by $index\"><td><a ng-click=\"setActive(\'blog_edit\', record.id)\">{{record.title}}</a></td><td>{{record.createdAt | dateToMoment:\'DD.MM.YYYY\'}}</td><td><span ng-hide=\"record.publishing_loader\"><span class=\"text-yes\" ng-show=\"record.published\" ng-click=\"publishBlogRecord(false, record)\">{{\'general.other.yes\' | i18next}}</span> <span class=\"text-no\" ng-show=\"!record.published\" ng-click=\"publishBlogRecord(true, record)\">{{\'general.other.no\' | i18next}}</span></span> <span ng-show=\"record.publishing_loader\"><i class=\"fa fa-spin fa-spinner\"></i></span></td></tr></tbody></table><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"setActive(\'blog_edit\', undefined)\"><i class=\"fa fa-plus\"></i> {{\'website_settings.blog_posts.add_new_blog_record_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/body_text_tpl.html","<legend class=\"header\">{{\'website_settings.static_text.body_text.body_text_legend\' | i18next}}<br><small>{{\'website_settings.static_text.body_text.main_text_small\' | i18next}}</small></legend><div class=\"settings-body-block\"><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.textArea\" on-image-upload=\"imageUpload(files, \'bodyTextEditable\', \'bodyTextEditor\')\" data-role=\"bodyTextEditor\"></summernote></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/comments_tpl.html","<legend class=\"header\">{{\'website_settings.blog_comments.legend\' | i18next}}<br><small>{{\'website_settings.blog_comments.small\' | i18next}}</small></legend><div class=\"settings-body-block\"><p>{{\'website_settings.blog_comments.comment_system_text\' | i18next}} <a href=\"www.disqus.com\">www.disqus.com</a> {{\'website_settings.blog_comments.free_account_text\' | i18next}}</p><md-input-container><label>{{\'website_settings.blog_comments.widget_code_label\' | i18next}}</label> <textarea ng-model=\"website.disqusCode\"></textarea></md-input-container></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/contacts_tpl.html","<legend class=\"header\">{{\'general.other.contacts\' | i18next}}<br><small>{{\'website_settings.contacts.small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped marged-bottom\"><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.contacts.contact_form_email_address_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.contactFormEmail\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.contacts.contact_area_titl_labele\' | i18next}}</label> <input type=\"text\" ng-model=\"website.contactAreaTitle\" md-maxlength=\"255\"></md-input-container></div></div><md-input-container><label>{{\'website_settings.contacts.contact_description_text_label\' | i18next}}</label> <textarea ng-model=\"website.contactDescriptionText\"></textarea></md-input-container><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'general.other.phone_number\' | i18next}}</label> <input type=\"text\" ng-model=\"website.phoneNumber\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'general.other.email_address\' | i18next}}</label> <input type=\"text\" ng-model=\"website.emailAddress\" md-maxlength=\"255\"></md-input-container></div></div><md-input-container><label>{{\'general.other.address\' | i18next}}</label> <input type=\"text\" ng-model=\"website.address\" ng-change=\"geocode($event)\" md-maxlength=\"255\"></md-input-container></div><legend>{{\'website_settings.contacts.contacts_page_seo_settings_legend\' | i18next}}</legend><div class=\"settings-body-block top-padding-cropped marged-bottom\"><md-input-container><label>{{\'general.other.page_title\' | i18next}}</label> <input type=\"text\" ng-model=\"website.contactPageTitle\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.meta_description\' | i18next}}</label> <input type=\"text\" ng-model=\"website.contactMetaDescription\" md-maxlength=\"255\"></md-input-container></div><legend>{{\'website_settings.contacts.google_map_image_label\' | i18next}}</legend><div class=\"settings-body-block no-padded marged-bottom\"><div class=\"form-group\"><input type=\"hidden\" class=\"form-control\" ng-model=\"website.mapCenterLat\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"website.mapCenterLng\"> <input type=\"hidden\" class=\"form-control\" ng-model=\"website.mapZoomLevel\"><react-google-map zoom=\"website.mapZoomLevel\" position=\"{lat: +website.mapCenterLat, lng: +website.mapCenterLng}\" on-position-change=\"setHotelLocation\" on-zoom-change=\"setZoomLevel\"></react-google-map></div></div><legend>{{\'website_settings.contacts.social_profiles_legend\' | i18next}}</legend><div class=\"settings-body-block\"><md-input-container><label>{{\'website_settings.contacts.twitter_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.twitter\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.contacts.facebook_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.facebook\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.contacts.linked_in_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.linkedin\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.contacts.you_tube_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.youtube\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.contacts.google_plus_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.googleplus\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.contacts.pinterest_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.pinterest\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.contacts.instagram_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.instagram\" md-maxlength=\"255\"></md-input-container></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/facilities_tpl.html","<legend class=\"header\">{{\'website_settings.facilities_translations.legend\' | i18next}}<br><small>{{\'website_settings.facilities_translations.small\' | i18next}}...</small></legend><div class=\"settings-body-block\"><table class=\"table table-faq table-striped\"><thead><tr><th>{{\'website_settings.facilities_translations.english_version_th\' | i18next}}</th><th>{{\'website_settings.facilities_translations.localized_version_th\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"facility in hotel.facilities track by $index\"><td><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"facility.title\" md-maxlength=\"255\"></md-input-container></td><td><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"getTranslation(facility.title, \'facility\').value\" md-maxlength=\"255\"></md-input-container></td></tr></tbody></table></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/faq_tpl.html","<legend class=\"header\">{{\'general.other.faq\' | i18next}}<br><small>{{\'website_settings.faq.small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped\"><md-input-container><label>{{\'website_settings.faq.faq_title_label\' | i18next}}:</label> <input ng-model=\"website.faqTitle\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'website_settings.faq.faq_description_label\' | i18next}}:</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.faqSectionDescription\" on-image-upload=\"imageUpload(files, \'faqDescEditable\', \'faqDescEditor\')\" data-role=\"faqDescEditor\"></summernote></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block marged-bottom\"><table class=\"table table-faq table-striped\"><thead><tr><th>{{\'website_settings.faq.question_or_answer_th\' | i18next}}</th><th>{{\'general.other.published\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"question in website.questions | filter:{invisible:undefined} track by $index\"><td ng-show=\"question.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'website_settings.faq.question_label\' | i18next}}:</label> <input ng-model=\"question.question\" md-maxlength=\"255\"></md-input-container><label>{{\'website_settings.faq.answer_label\' | i18next}}:</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"question.answer\"></summernote><md-checkbox ng-model=\"question.showOnline\" aria-label=\"{{\'website_settings.faq.show_on_line_checkbox\' | i18next}}\">{{\'website_settings.faq.show_on_line_checkbox\' | i18next}}</md-checkbox><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeEditQuestion($event, question, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditQuestion($event, question, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></td><td ng-hide=\"question.edited\"><div><strong>{{\'website_settings.faq.first_letter_in_question_word\' | i18next}}:</strong> {{question.question}}</div><div><strong>{{\'website_settings.faq.first_letter_in_answer_word\' | i18next}}:</strong><div ng-bind-html=\"question.answer\"></div></div></td><td ng-hide=\"question.edited\" class=\"vertical-mid\"><span class=\"text-yes\" ng-show=\"question.showOnline\">{{\'general.other.yes\' | i18next}}</span> <span class=\"text-no\" ng-hide=\"question.showOnline\">{{\'general.other.no\' | i18next}}</span></td><td class=\"controls\" ng-hide=\"question.edited\"><a href=\"#\" ng-click=\"editQuestion($event, question)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.links.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a href=\"#\" ng-click=\"removeQuestion($event, question)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.links.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"question.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"question.loading\"></i></a></td></tr></tbody></table><div class=\"new-question-form table-form\" ng-show=\"addNewQuestion\"><md-input-container><label>{{\'website_settings.faq.question_label\' | i18next}}:</label> <input ng-model=\"newQuestion.question\" md-maxlength=\"255\"></md-input-container><label>{{\'website_settings.faq.answer_label\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"newQuestion.answer\"></summernote><md-checkbox ng-model=\"newQuestion.showOnline\" aria-label=\"{{\'website_settings.faq.show_on_line_checkbox\' | i18next}}\">{{\'website_settings.faq.show_on_line_checkbox\' | i18next}}</md-checkbox><div class=\"text-right form-buttons\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddQuestionForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewQuestion()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading_publish}\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddQuestionForm($event)\"><i class=\"fa fa-plus\"></i> {{\'website_settings.faq.add_new_question_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/features_tpl.html","<legend class=\"header\"><span ng-i18next=\"[html]website_settings.features.legend\"></span><br><small>{{\'website_settings.features.small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped\"><md-input-container><label>{{\'website_settings.features.features_section_title_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.featuresTitle\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'website_settings.features.features_description_label\' | i18next}}:</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.featuresSectionDescription\" on-image-upload=\"imageUpload(files, \'featuresDescEditable\', \'featuresDescEditor\')\" data-role=\"featuresDescEditor\"></summernote></div><div class=\"form-group\"><label>{{\'website_settings.features.background_image_label\' | i18next}}</label><div class=\"customPhoto existedPhoto fieldPhoto text-center ng-scope\"><div class=\"photoBlock\"><img ng-src=\"{{website.featuresBackgroundImage.data}}\" height=\"200\" ng-show=\"website.featuresBackgroundImage\"></div><md-button class=\"md-raised md-orange\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().convertToBase64(event, \'featuresBackgroundImage\')\"> {{\'general.buttons.change\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"removeFeatureImage()\" ng-show=\"website.featuresBackgroundImage.data.indexOf(\'missing\') == -1\">{{\'general.buttons.remove\' | i18next}}</md-button></div></div><md-input-container><label>{{\'website_settings.features.background_image_style_label\' | i18next}}</label><md-select ng-model=\"website.featuresStyle\"><md-option value=\"normal\">{{\'website_settings.features.normal_option\' | i18next}}</md-option><md-option value=\"blured\">{{\'website_settings.features.blured_option\' | i18next}}</md-option></md-select></md-input-container></div><div class=\"features-group\"><div class=\"col-sm-4 feature\" ng-repeat=\"feature in website.features\"><div class=\"feature-block\"><strong><i ng-show=\"feature.icon\" class=\"fa fa-{{feature.icon}}\"></i> {{\'website_settings.features.feature_block_title\' | i18next}} #{{$index+1}}</strong><md-autocomplete md-selected-item=\"feature.icon\" md-search-text=\"feature_searchText\" md-items=\"item in feature_filter(feature_searchText)\" md-item-text=\"item\" md-min-length=\"0\" md-autoselect=\"true\" md-floating-label=\"{{\'website_settings.features.choose_icon_floating_label\' | i18next}}\"><md-item-template><span class=\"item-title\"><i class=\"fa fa-{{item}}\"></i> {{item}}</span></md-item-template><md-not-found>{{\'website_settings.features.no_icons_matching_were_found_text\' | i18next: {\"searchText\": searchText} }}</md-not-found></md-autocomplete><md-input-container class=\"md-block\"><label>{{\'general.other.title\' | i18next}}</label> <textarea ng-model=\"feature.title\" columns=\"1\" md-maxlength=\"255\"></textarea></md-input-container><label>{{\'general.other.description\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"feature.description\" config=\"features_summernote_options\"></summernote></div></div></div><div class=\"clearfix\"></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/footer_tpl.html","<legend class=\"header\">{{\'website_settings.static_text.footer_text.footer_text_legend\' | i18next}}<br><small>{{\'website_settings.static_text.footer_text.small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom top-padding-cropped\" ng-repeat=\"footer in website.footers\"><legend>{{\'website_settings.static_text.footer_text.footer_legend\' | i18next}} #{{$index + 1}}</legend><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"footer.title\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'general.other.text\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"footer.text\"></summernote></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/gallery_tpl.html","<legend class=\"header\">{{\'general.other.gallery\' | i18next}}<br><small>{{\'website_settings.gallery.small\' | i18next}}</small></legend><div class=\"settings-body-block\"><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\" ng-show=\"galleryPhotoLoaded != true\"></i> <i class=\"fa fa-spinner\" ng-show=\"galleryPhotoLoaded == true\" ng-class=\"{\'fa-spin\': galleryPhotoLoaded == true}\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" multiple=\"\" onchange=\"angular.element(this).scope().uploadGalleryPhotos(event)\"></div><br><br><legend>{{\'website_settings.gallery.gallery_photos_legend\' | i18next}}</legend><div><div class=\"text-center\" ng-show=\"gallery_photos.length == 0\">{{\'website_settings.gallery.have_not_uploaded_photos_div\' | i18next}}<br>{{\'website_settings.gallery.choose_files_for_upload_div\' | i18next}}</div><div class=\"photos-container\" ng-show=\"(gallery_photos.length > 0)\"><div ng-repeat=\"photo in gallery_photos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.photo}}\"></div><div class=\"tools\"><a href=\"{{photo.photo.replace(\'thumb\', \'original\')}}\" ng-show=\"photo.photo\" aria-label=\"{{\'general.tooltip.direct_link\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.direct_link\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <a ng-click=\"removeGalleryPhoto(photo)\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><i class=\"fa fa-times-circle pull-right\" ng-hide=\"photo.loading\"></i></a> <a class=\"pull-right\" aria-label=\"{{\'general.tooltip.removing\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.removing\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-class=\"{\'fa-spin\' : photo.loading}\" ng-show=\"photo.loading\"></i></a></div></div></div></div><br><br><legend>{{\'website_settings.gallery.other_photos_legend\' | i18next}}</legend><div><div class=\"photos-container\" ng-show=\"(other_photos.length > 0)\"><div ng-repeat=\"photo in other_photos\" class=\"uploaded-photo\"><div class=\"photoBlock visiblePhotoBlock\"><img ng-src=\"{{photo.photo}}\"></div><md-checkbox ng-checked=\"photo.is_visible\" ng-click=\"togglePhotoVisibility(photo)\">{{\'general.checkboxs.visible\' | i18next}}</md-checkbox><div class=\"tools\"><a href=\"{{photo.photo.replace(\'thumb\', \'original\')}}\" ng-show=\"photo.photo\" aria-label=\"{{\'general.tooltip.direct_link\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.direct_link\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a></div></div></div></div></div>");
$templateCache.put("templates/website_settings/header_tpl.html","<legend class=\"header\">{{\'general.other.header\' | i18next}}<br><small>{{\'website_settings.header.change_header_text_and_image_small\' | i18next}}</small></legend><div class=\"settings-body-block\"><div class=\"row\"><div class=\"form-group col-sm-6\"><label>{{\'website_settings.header.hotel_logo_label\' | i18next}}</label><div class=\"customPhoto existedPhoto fieldPhoto text-center ng-scope\"><div class=\"photoBlock\"><img ng-src=\"{{website.logo.data}}\" ng-show=\"website.logo\"></div><md-button class=\"md-raised md-orange\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().convertToBase64(event, \'logo\', \'png,jpeg,gif\')\"> {{\'general.buttons.change\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"removeLogoImage()\" ng-show=\"website.logo.data.indexOf(\'missing\') == -1\">{{\'general.buttons.remove\' | i18next}}</md-button></div></div></div><div class=\"row\"><div class=\"form-group col-sm-6\"><label>{{\'website_settings.header.header_image_label\' | i18next}}</label><div class=\"customPhoto existedPhoto fieldPhoto text-center ng-scope\"><div class=\"photoBlock\"><img ng-src=\"{{website.headerImage.data}}\" ng-show=\"website.headerImage\"></div><md-button class=\"md-raised md-orange\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().convertToBase64(event, \'headerImage\')\"> {{\'general.buttons.change\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"removeHeaderImage()\" ng-show=\"website.headerImage.data.indexOf(\'missing\') == -1\">{{\'general.buttons.remove\' | i18next}}</md-button></div></div></div><div class=\"row\"><div class=\"col-md-12\"><md-checkbox ng-model=\"website.mobileMenuFixed\" aria-label=\"{{\'website_settings.header.mobile_menu_fixed_checkbox\' | i18next}}\">{{\'website_settings.header.mobile_menu_fixed_checkbox\' | i18next}}</md-checkbox></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.logo_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.logoText\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.header_text_line_1_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.headerText1\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.header_text_line_2_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.headerText2\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.booking_button_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.bookingButtonText\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.view_room_button_text_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.viewRoomButtonText\" md-maxlength=\"255\"></md-input-container></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.booking_button_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.bookingButtonColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"website.bookingButtonColor\"></md-input-container></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><md-input-container><label>{{\'website_settings.header.brand_color_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.brandColor\"></md-input-container></div><div class=\"col-md-6\"><md-input-container><label>&nbsp;</label> <input type=\"color\" ng-model=\"website.brandColor\"></md-input-container></div></div></div><div class=\"row\"><div class=\"form-group col-md-12\"><md-radio-group ng-model=\"bookingSystem\"><md-radio-button value=\"internal\" ng-click=\"clearBookingLink(\'internal\')\">{{\'website_settings.header.use_built_in_booking_system_radio_button\' | i18next}}</md-radio-button><md-radio-button value=\"other\" ng-click=\"clearBookingLink(\'other\')\">{{\'website_settings.header.use_other_booking_system_radio_button\' | i18next}}</md-radio-button></md-radio-group><md-input-container><label>{{\'website_settings.header.booking_system_address_label\' | i18next}}</label> <input ng-model=\"website.bookingLink\" ng-disabled=\"bookingSystem == \'internal\'\"></md-input-container></div></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/interface_tpl.html","<legend class=\"header\">{{\'website_settings.interface_translations.legend\' | i18next}}<br><small>{{\'website_settings.interface_translations.small\' | i18next}}</small></legend><div class=\"settings-body-block\"></div>");
$templateCache.put("templates/website_settings/main_tpl.html","<legend class=\"header\">{{\'website_settings.google_settings.seo_settings_legend\' | i18next}}<br><small>{{\'website_settings.google_settings.shows_when_people_search_small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped marged-bottom\"><div class=\"row\"><div class=\"col-xs-6\"><md-input-container><label>{{\'website_settings.google_settings.site_title_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.pageTitle\" md-maxlength=\"255\"></md-input-container></div></div><md-input-container><label>{{\'website_settings.google_settings.site_description_label\' | i18next}}</label> <textarea ng-model=\"website.pageDescription\" md-maxlength=\"255\"></textarea></md-input-container><md-input-container><label>{{\'website_settings.google_settings.site_keywords_label\' | i18next}}</label> <textarea ng-model=\"website.pageKeywords\" md-maxlength=\"255\"></textarea></md-input-container><div class=\"form-group\"><label>{{\'website_settings.google_settings.site_favicon_label\' | i18next}}</label><div class=\"customPhoto existedPhoto fieldPhoto text-center ng-scope\"><div class=\"photoBlock\"><img ng-src=\"{{website.favicon.data}}\" ng-show=\"website.favicon.data\"></div><md-button class=\"md-raised md-orange\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().convertToBase64(event, \'favicon\', \'png,jpeg,vnd.microsoft.icon,gif\')\"> {{\'general.buttons.change\' | i18next}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"removeFaviconImage()\" ng-show=\"website.favicon.data.indexOf(\'missing\') == -1\">{{\'general.buttons.remove\' | i18next}}</md-button></div></div></div><legend class=\"header\">{{\'website_settings.google_settings.google_analytics_legend\' | i18next}}<br><small>{{\'website_settings.google_settings.use_google_analytics_small\' | i18next}}.</small></legend><div class=\"settings-body-block marged-bottom top-padding-cropped\"><md-input-container><label>{{\'website_settings.google_settings.google_analytics_code_label\' | i18next}}</label> <textarea ng-model=\"website.gaCode\"></textarea></md-input-container></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/membership_text_tpl.html","<legend class=\"header\">{{\'website_settings.static_text.membership_page.legend\' | i18next}}<br><small>{{\'website_settings.static_text.membership_page.small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><div class=\"form-group\"><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.membershipText\"></summernote></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/navigation_tpl.html","<legend class=\"header\">{{\'website_settings.navigation.navigation_legend\' | i18next}}<br><small>{{\'website_settings.navigation.manage_menu_items_on_website_small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><legend>{{\'website_settings.navigation.main_menu_legend\' | i18next}}<br><small>{{\'website_settings.navigation.drag_links_small\' | i18next}}</small></legend><script type=\"text/ng-template\" id=\"nodes_renderer.html\"><div ui-tree-handle> <div ng-hide=\"node.link.edited === true\"> <div class=\"col-xs-4\"> <i class=\"fa fa-bars\"></i> {{node.link.title}} </div> <div class=\"col-xs-4\"> {{node.link.category}} </div> <div class=\"col-xs-3\"> {{node.link.value}} </div> <div class=\"col-xs-1 text-right controls\"> <a href=\"#\" ng-click=\"editLink($event, node.link)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\" > <md-tooltip md-direction=\"top\">{{\'general.links.edit\' | i18next}}</md-tooltip> <i class=\"fa fa-edit\"></i> </a> <a href=\"#\" ng-click=\"removeLink($event, node.link)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\" > <md-tooltip md-direction=\"top\">{{\'general.links.remove\' | i18next}}</md-tooltip> <i class=\"fa fa-trash\" ng-hide=\"node.link.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"node.link.loading\"></i> </a> </div> <div class=\"clearfix\"></div> </div> <div class=\"new-question-form table-form\" ng-if=\"node.link.edited === true\"> <md-input-container> <label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"node.link.title\" md-maxlength=\"255\"> </md-input-container> <md-input-container> <label>{{\'website_settings.navigation.category_label\' | i18next}}</label> <md-select ng-model=\"node.link.category\"> <md-option value=\"Predefined Link\">{{\'website_settings.navigation.predefined_link_option\' | i18next}}</md-option> <md-option value=\"Custom Page Link\">{{\'website_settings.navigation.custom_page_link_option\' | i18next}}</md-option> <md-option value=\"Room Page Link\">{{\'website_settings.navigation.room_page_link_option\' | i18next}}</md-option> <md-option value=\"Blog Record Link\">{{\'website_settings.navigation.blog_record_link_option\' | i18next}}</md-option> <md-option value=\"Custom Link\">{{\'website_settings.navigation.custom_link_option\' | i18next}}</md-option> </md-select> </md-input-container> <md-input-container> <label>{{\'website_settings.navigation.parent_label\' | i18next}}</label> <md-select ng-model=\"node.link.parentId\"> <md-option ng-repeat=\"parent in website.websiteLinks | filter : { invisible : undefined, zone: \'top\', parentId: null, id: \'!\'+node.link.id }\" value=\"{{parent.id}}\" ng-selected=\"(link.parentId == parent.id)\"> {{parent.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Predefined Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option value=\"home\">{{\'website_settings.navigation.home_option\' | i18next}}</md-option> <md-option value=\"about\">{{\'website_settings.navigation.about_option\' | i18next}}</md-option> <md-option value=\"rooms\">{{\'website_settings.navigation.rooms_and_services_option\' | i18next}}</md-option> <md-option value=\"features\">{{\'general.other.features\' | i18next}}</md-option> <md-option value=\"faq\">{{\'general.other.faq\' | i18next}}</md-option> <md-option value=\"contacts\">{{\'general.other.contacts\' | i18next}}</md-option> <md-option value=\"blog\">{{\'website_settings.navigation.blog_option\' | i18next}}</md-option> <md-option value=\"booking\">{{\'website_settings.navigation.booking_page_option\' | i18next}}</md-option> <md-option value=\"terms-and-conditions\">{{\'general.other.terms_and_conditions\' | i18next}}</md-option> <md-option value=\"privacy-policy\">{{\'general.other.privacy_policy\' | i18next}}</md-option> <md-option value=\"gallery\">{{\'general.other.gallery\' | i18next}}</md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Custom Page Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option ng-repeat=\"page in pages\" value=\"{{page.slug}}\" ng-selected=\"(node.link.target.slice(1) === page.slug)\"> {{page.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Room Page Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option ng-repeat=\"room in website.rooms\" value=\"{{room.slug}}\" ng-selected=\"(node.link.url.slice(1) === room.slug)\"> {{room.name}} </md-option> <md-option ng-repeat=\"room in website.customRooms\" value=\"{{room.slug}}\" ng-selected=\"(node.link.url.slice(1) === room.slug)\"> {{room.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Blog Record Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option ng-repeat=\"page in blogRecords\" value=\"{{page.slug}}\" ng-selected=\"(node.link.url.slice(6) === page.slug)\"> {{page.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Custom Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <input ng-model=\"node.link.value\" md-maxlength=\"255\"> </md-input-container> <div class=\"text-right form-buttons\"> <md-button class=\"md-raised md-warn\" ng-click=\"cancelLinkEditing(node.link)\"> {{\'general.buttons.cancel\' | i18next}} </md-button> <md-button class=\"md-raised md-success\" ng-click=\"saveLink(node.link)\"> <i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}} </md-button> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ol></script><div data-ui-tree=\"treeOptions\" data-drag-delay=\"300\" data-max-depth=\"2\"><ol ui-tree-nodes=\"\" ng-model=\"topLinks\" id=\"tree-root\"><li ng-repeat=\"node in topLinks\" ui-tree-node=\"\" ng-include=\"\'nodes_renderer.html\'\"></li></ol></div><div class=\"new-link-form new-question-form table-form\" ng-show=\"addNewLink == \'top\'\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"newLink.title\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.navigation.category_label\' | i18next}}</label><md-select ng-model=\"newLink.category\"><md-option value=\"Predefined Link\">{{\'website_settings.navigation.predefined_link_option\' | i18next}}</md-option><md-option value=\"Custom Page Link\">{{\'website_settings.navigation.custom_page_link_option\' | i18next}}</md-option><md-option value=\"Room Page Link\">{{\'website_settings.navigation.room_page_link_option\' | i18next}}</md-option><md-option value=\"Blog Record Link\">{{\'website_settings.navigation.blog_record_link_option\' | i18next}}</md-option><md-option value=\"Custom Link\">{{\'website_settings.navigation.custom_link_option\' | i18next}}</md-option></md-select></md-input-container><md-input-container><label>{{\'website_settings.navigation.parent_label\' | i18next}}</label><md-select ng-model=\"newLink.parentId\"><md-option ng-repeat=\"link in website.websiteLinks | filter : { invisible : undefined, zone: \'top\', parentId: null }\" value=\"{{link.id}}\" ng-selected=\"(newLink.parentId === link.id)\">{{link.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Predefined Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option value=\"home\">{{\'website_settings.navigation.home_option\' | i18next}}</md-option><md-option value=\"about\">{{\'website_settings.navigation.about_option\' | i18next}}</md-option><md-option value=\"rooms\">{{\'website_settings.navigation.rooms_and_services_option\' | i18next}}</md-option><md-option value=\"features\">{{\'general.other.features\' | i18next}}</md-option><md-option value=\"faq\">{{\'general.other.faq\' | i18next}}</md-option><md-option value=\"contacts\">{{\'general.other.contacts\' | i18next}}</md-option><md-option value=\"blog\">{{\'website_settings.navigation.blog_option\' | i18next}}</md-option><md-option value=\"booking\">{{\'website_settings.navigation.booking_page_option\' | i18next}}</md-option><md-option value=\"terms-and-conditions\">{{\'general.other.terms_and_conditions\' | i18next}}</md-option><md-option value=\"privacy-policy\">{{\'general.other.privacy_policy\' | i18next}}</md-option><md-option value=\"gallery\">{{\'general.other.gallery\' | i18next}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Custom Page Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option ng-repeat=\"page in pages\" value=\"{{page.slug}}\" ng-selected=\"(newLink.target.slice(1) === page.slug)\">{{page.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Room Page Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option ng-repeat=\"room in website.rooms\" value=\"{{room.slug}}\" ng-selected=\"(newLink.target.slice(1) === room.slug)\">{{room.name}}</md-option><md-option ng-repeat=\"room in website.customRooms\" value=\"{{room.slug}}\" ng-selected=\"(newLink.target.slice(1) === room.slug)\">{{room.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Blog Record Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option ng-repeat=\"page in blogRecords\" value=\"{{page.slug}}\" ng-selected=\"(newLink.target.slice(6) === page.slug)\">{{page.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Custom Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <input ng-model=\"newLink.value\" md-maxlength=\"255\"></md-input-container><div class=\"text-right form-buttons\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddLinkForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewLink(\'top\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddLinkForm(\'top\')\"><i class=\"fa fa-plus\"></i> {{\'website_settings.navigation.add_new_link\' | i18next}}</md-button></div></div><div class=\"settings-body-block marged-bottom\"><legend>{{\'website_settings.navigation.footer_menu_legend\' | i18next}}<br><small>{{\'website_settings.navigation.drag_links_small\' | i18next}}</small></legend><script type=\"text/ng-template\" id=\"nodes_renderer_footer.html\"><div ui-tree-handle> <div ng-hide=\"node.link.edited === true\"> <div class=\"col-xs-4\"> <i class=\"fa fa-bars\"></i> {{node.link.title}} </div> <div class=\"col-xs-4\"> {{node.link.category}} </div> <div class=\"col-xs-3\"> {{node.link.value}} </div> <div class=\"col-xs-1 text-right controls\"> <a href=\"#\" ng-click=\"editLink($event, node.link)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\" > <md-tooltip md-direction=\"top\">{{\'general.links.edit\' | i18next}}</md-tooltip> <i class=\"fa fa-edit\"></i> </a> <a href=\"#\" ng-click=\"removeLink($event, node.link)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\" > <md-tooltip md-direction=\"top\">{{\'general.links.remove\' | i18next}}</md-tooltip> <i class=\"fa fa-trash\" ng-hide=\"node.link.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"node.link.loading\"></i> </a> </div> <div class=\"clearfix\"></div> </div> <div class=\"new-question-form table-form\" ng-if=\"node.link.edited === true\"> <md-input-container> <label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"node.link.title\" md-maxlength=\"255\"> </md-input-container> <md-input-container> <label>{{\'website_settings.navigation.category_label\' | i18next}}</label> <md-select ng-model=\"node.link.category\"> <md-option value=\"Predefined Link\">{{\'website_settings.navigation.predefined_link_option\' | i18next}}</md-option> <md-option value=\"Custom Page Link\">{{\'website_settings.navigation.custom_page_link_option\' | i18next}}</md-option> <md-option value=\"Room Page Link\">{{\'website_settings.navigation.room_page_link_option\' | i18next}}</md-option> <md-option value=\"Blog Record Link\">{{\'website_settings.navigation.blog_record_link_option\' | i18next}}</md-option> <md-option value=\"Custom Link\">{{\'website_settings.navigation.custom_link_option\' | i18next}}</md-option> </md-select> </md-input-container> <md-input-container> <label>{{\'website_settings.navigation.parent_label\' | i18next}}</label> <md-select ng-model=\"node.link.parentId\"> <md-option ng-repeat=\"parent in website.websiteLinks | filter : { invisible : undefined, zone: \'footer\', parentId: null, id: \'!\'+node.link.id }\" value=\"{{parent.id}}\" ng-selected=\"(link.parentId == parent.id)\"> {{parent.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Predefined Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option value=\"home\">{{\'website_settings.navigation.home_option\' | i18next}}</md-option> <md-option value=\"about\">{{\'website_settings.navigation.about_option\' | i18next}}</md-option> <md-option value=\"rooms\">{{\'website_settings.navigation.rooms_and_services_option\' | i18next}}</md-option> <md-option value=\"features\">{{\'general.other.features\' | i18next}}</md-option> <md-option value=\"faq\">{{\'general.other.faq\' | i18next}}</md-option> <md-option value=\"contacts\">{{\'general.other.contacts\' | i18next}}</md-option> <md-option value=\"blog\">{{\'website_settings.navigation.blog_option\' | i18next}}</md-option> <md-option value=\"booking\">{{\'website_settings.navigation.booking_page_option\' | i18next}}</md-option> <md-option value=\"terms-and-conditions\">{{\'general.other.terms_and_conditions\' | i18next}}</md-option> <md-option value=\"privacy-policy\">{{\'general.other.privacy_policy\' | i18next}}</md-option> <md-option value=\"gallery\">{{\'general.other.gallery\' | i18next}}</md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Custom Page Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option ng-repeat=\"page in pages\" value=\"{{page.slug}}\" ng-selected=\"(node.link.target.slice(1) === page.slug)\"> {{page.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Room Page Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option ng-repeat=\"room in website.rooms\" value=\"{{room.slug}}\" ng-selected=\"(node.link.url.slice(1) === room.slug)\"> {{room.name}} </md-option> <md-option ng-repeat=\"room in website.customRooms\" value=\"{{room.slug}}\" ng-selected=\"(node.link.url.slice(1) === room.slug)\"> {{room.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Blog Record Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <md-select ng-model=\"node.link.value\"> <md-option ng-repeat=\"page in blogRecords\" value=\"{{page.slug}}\" ng-selected=\"(node.link.url.slice(6) === page.slug)\"> {{page.title}} </md-option> </md-select> </md-input-container> <md-input-container ng-show=\"node.link.category === \'Custom Link\'\"> <label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <input ng-model=\"node.link.value\" md-maxlength=\"255\"> </md-input-container> <div class=\"text-right form-buttons\"> <md-button class=\"md-raised md-warn\" ng-click=\"cancelLinkEditing(node.link)\"> {{\'general.buttons.cancel\' | i18next}} </md-button> <md-button class=\"md-raised md-success\" ng-click=\"saveLink(node.link)\"> <i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}} </md-button> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ol></script><div data-ui-tree=\"treeOptions\" data-drag-delay=\"300\" data-max-depth=\"2\"><ol ui-tree-nodes=\"\" ng-model=\"footerLinks\" id=\"tree-root-footer\"><li ng-repeat=\"node in footerLinks\" ui-tree-node=\"\" ng-include=\"\'nodes_renderer_footer.html\'\"></li></ol></div><div class=\"new-link-form new-question-form table-form\" ng-show=\"addNewLink == \'footer\'\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input ng-model=\"newLink.title\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.navigation.category_label\' | i18next}}</label><md-select ng-model=\"newLink.category\"><md-option value=\"Predefined Link\">{{\'website_settings.navigation.predefined_link_option\' | i18next}}</md-option><md-option value=\"Custom Page Link\">{{\'website_settings.navigation.custom_page_link_option\' | i18next}}</md-option><md-option value=\"Room Page Link\">{{\'website_settings.navigation.room_page_link_option\' | i18next}}</md-option><md-option value=\"Blog Record Link\">{{\'website_settings.navigation.blog_record_link_option\' | i18next}}</md-option><md-option value=\"Custom Link\">{{\'website_settings.navigation.custom_link_option\' | i18next}}</md-option></md-select></md-input-container><md-input-container><label>{{\'website_settings.navigation.parent_label\' | i18next}}</label><md-select ng-model=\"newLink.parentId\"><md-option ng-repeat=\"link in website.websiteLinks | filter : { invisible : undefined, zone: \'footer\', parentId: null }\" value=\"{{link.id}}\" ng-selected=\"(newLink.parentId === link.id)\">{{link.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Predefined Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option value=\"home\">{{\'website_settings.navigation.home_option\' | i18next}}</md-option><md-option value=\"about\">{{\'website_settings.navigation.about_option\' | i18next}}</md-option><md-option value=\"rooms\">{{\'website_settings.navigation.rooms_and_services_option\' | i18next}}</md-option><md-option value=\"features\">{{\'general.other.features\' | i18next}}</md-option><md-option value=\"faq\">{{\'general.other.faq\' | i18next}}</md-option><md-option value=\"contacts\">{{\'general.other.contacts\' | i18next}}</md-option><md-option value=\"blog\">{{\'website_settings.navigation.blog_option\' | i18next}}</md-option><md-option value=\"booking\">{{\'website_settings.navigation.booking_page_option\' | i18next}}</md-option><md-option value=\"terms-and-conditions\">{{\'general.other.terms_and_conditions\' | i18next}}</md-option><md-option value=\"privacy-policy\">{{\'general.other.privacy_policy\' | i18next}}</md-option><md-option value=\"gallery\">{{\'general.other.gallery\' | i18next}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Custom Page Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option ng-repeat=\"page in pages\" value=\"{{page.slug}}\" ng-selected=\"(newLink.target.slice(1) === page.slug)\">{{page.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Room Page Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option ng-repeat=\"room in website.rooms\" value=\"{{room.slug}}\" ng-selected=\"(newLink.target.slice(1) === room.slug)\">{{room.name}}</md-option><md-option ng-repeat=\"room in website.customRooms\" value=\"{{room.slug}}\" ng-selected=\"(newLink.target.slice(1) === room.slug)\">{{room.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Blog Record Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label><md-select ng-model=\"newLink.value\"><md-option ng-repeat=\"page in blogRecords\" value=\"{{page.slug}}\" ng-selected=\"(newLink.target.slice(6) === page.slug)\">{{page.title}}</md-option></md-select></md-input-container><md-input-container ng-show=\"newLink.category === \'Custom Link\'\"><label>{{\'website_settings.navigation.target_label\' | i18next}}</label> <input ng-model=\"newLink.value\" md-maxlength=\"255\"></md-input-container><div class=\"text-right form-buttons\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddLinkForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewLink(\'footer\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddLinkForm(\'footer\')\"><i class=\"fa fa-plus\"></i> {{\'website_settings.navigation.add_new_link\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/page_edit_tpl.html","<legend class=\"header\" ng-show=\"page_record.id != undefined\">{{\'website_settings.page_edit.edit_page_legend\' | i18next}}<br><small>{{\'website_settings.page_edit.small\' | i18next}}</small></legend><legend class=\"header\" ng-show=\"page_record.id == undefined\">{{\'website_settings.page_edit.add_new_page_legend\' | i18next}}<br><small>{{\'website_settings.page_edit.small\' | i18next}}</small></legend><div class=\"settings-body-block\" ng-show=\"pagesLoad !== false\"><div class=\"block-loader\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': pagesLoad !== false}\"></i></div></div><div ng-show=\"pagesLoad === false\"><div class=\"settings-body-block top-padding-cropped marged-bottom\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"page_record.title\" ng-change=\"slugify(page_record.title, page_record)\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'general.other.text\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"page_record.content\" on-image-upload=\"imageUpload(files, \'pageEditable\', \'pageEditor\')\" data-role=\"pageEditor\"></summernote></div></div><legend>{{\'website_settings.page_edit.search_settings_legend\' | i18next}}</legend><div class=\"settings-body-block top-padding-cropped marged-bottom\"><md-input-container><label>{{\'general.other.slug\' | i18next}}</label> <input type=\"text\" ng-model=\"page_record.slug\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.page_edit.page_title_label\' | i18next}}</label> <input type=\"text\" ng-model=\"page_record.pageTitle\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.meta_description\' | i18next}}</label> <input type=\"text\" ng-model=\"page_record.metaDescription\" md-maxlength=\"255\"></md-input-container></div><legend>{{\'website_settings.page_edit.associated_images_legend\' | i18next}}</legend><div class=\"settings-body-block marged-bottom\"><div class=\"form-group photos\"><div class=\"photos-container\" ng-show=\"(page_record.pagePhotos.length > 0)\"><div ng-repeat=\"photo in page_record.pagePhotos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.data}}\" ng-show=\"photo.data\"> <img ng-src=\"{{photo.photo}}\" ng-show=\"photo.photo\"></div><div class=\"tools\"><a href=\"{{photo.photo.replace(\'thumb\', \'big\')}}\" ng-show=\"photo.photo\" aria-label=\"{{\'general.tooltip.direct_link\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.direct_link\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <a href=\"#\" class=\"pull-right\" ng-click=\"removeFromCustomPagePhotos($event, photo, page_record)\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><i class=\"fa fa-times-circle\"></i></a></div></div></div><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" ng-model=\"aboutPhoto\" multiple=\"\" onchange=\"angular.element(this).scope().loadCustomPagePhotos(event, angular.element(this).scope().page_record)\"></div><md-button class=\"md-raised md-success\" ng-click=\"chooseFromLoaded(\'pagePhotos\', page_record, true, \'pagePhotos\')\"><i class=\"fa fa-cloud\"></i> {{\'general.buttons.choose_from_loaded\' | i18next}}</md-button></div></div><legend class=\"header\">{{\'website_settings.page_edit.visibility_legend\' | i18next}}</legend><div class=\"settings-body-block top-padding-cropped\"><div class=\"radio-group row\"><md-checkbox ng-model=\"page_record.published\" aria-label=\"{{\'general.aria_labels.published\' | i18next}}\">{{\'general.checkboxs.published\' | i18next}}</md-checkbox></div></div><div class=\"text-right toolbar-bottom\" ng-show=\"page_record.id != undefined\"><md-button class=\"md-raised md-warn pull-left\" ng-click=\"removePageRecord($event, page_record)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"removePageRecordLoader\"></i> {{\'general.buttons.remove\' | i18next}}</md-button><md-button class=\"md-raised md-orange\" ng-click=\"closeEditPageRecord($event, page_record, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditPageRecord($event, page_record, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"text-right toolbar-bottom\" ng-show=\"page_record.id == undefined\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddPageRecordForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewPageRecord()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/pages_tpl.html","<legend class=\"header\">{{\'website_settings.custom_pages.legend\' | i18next}}<br><small>{{\'website_settings.custom_pages.small\' | i18next}} <a ng-click=\"setActive(\'navigation\')\">Navigation Menu</a></small></legend><div class=\"settings-body-block\" ng-show=\"pagesLoad !== false\"><div class=\"block-loader\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\': pagesLoad !== false}\"></i></div></div><div class=\"settings-body-block\" ng-show=\"pagesLoad === false\"><table class=\"table table-striped\"><thead><tr><th>{{\'general.other.title\' | i18next}}</th><th>{{\'general.other.address\' | i18next}}</th><th>{{\'general.other.published\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"page in pages\"><td><a ng-click=\"setActive(\'page_edit\', page.id)\">{{page.title}}</a></td><td>{{page.slug}}</td><td><span class=\"text-yes\" ng-show=\"page.published\" ng-click=\"publishPageRecord(false, page)\">{{\'general.other.yes\' | i18next}}</span> <span class=\"text-no\" ng-show=\"!page.published\" ng-click=\"publishPageRecord(true, page)\">{{\'general.other.no\' | i18next}}</span></td></tr></tbody></table><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"setActive(\'page_edit\')\"><i class=\"fa fa-plus\"></i> {{\'website_settings.custom_pages.add_custom_page_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/pictures_tpl.html","<div ng-controller=\"Settings.PicturesController as PicturesCtrl\"><legend class=\"header\">{{\'website_settings.pictures.legend\' | i18next}} <i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : !PicturesCtrl.loaded}\" ng-hide=\"PicturesCtrl.loaded\"></i><br><small>{{\'website_settings.pictures.small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-hover general-table table-editable\"><thead><tr><th class=\"col-xs-1\">{{\'website_settings.pictures.photo_th\' | i18next}}</th><th class=\"col-xs-3\">{{\'website_settings.pictures.zone_th\' | i18next}}</th><th class=\"col-xs-2\">{{\'general.other.description\' | i18next}}</th><th class=\"col-xs-5\">{{\'website_settings.pictures.path\' | i18next}}</th><th class=\"col-xs-1\"></th></tr></thead><tbody><tr ng-repeat=\"Picture in PicturesCtrl.pictures\"><td colspan=\"5\" ng-show=\"$index == PicturesCtrl.editedPicture\"><settings-picture-form ng-model=\"Picture\" ng-scope=\"PicturesCtrl\"></settings-picture-form></td><td ng-hide=\"$index == PicturesCtrl.editedPicture\"><img ng-src=\"{{Picture.picture}}\" style=\"max-width: 110px;\"></td><td ng-hide=\"$index == PicturesCtrl.editedPicture\">{{\'general.picture_zones.\' + Picture.zone | i18next}} <span ng-show=\"Picture.zone == \'Room\'\">({{PicturesCtrl.getRoomTypeTitle(Picture.roomTypeId)}})</span></td><td ng-hide=\"$index == PicturesCtrl.editedPicture\">{{Picture.description}}</td><td ng-hide=\"$index == PicturesCtrl.editedPicture\"><md-input-container><label>{{\'website_settings.pictures.path\' | i18next}}</label> <input type=\"text\" value=\"{{PicturesCtrl.preparePictureAddress(Picture.picture, Picture.size)}}\" onclick=\"this.select();\"></md-input-container><md-input-container><label>{{\'website_settings.pictures.size_label\' | i18next}}</label><md-select ng-model=\"Picture.size\"><md-option value=\"thumb\" selected=\"\">{{\'website_settings.pictures.thumb_option\' | i18next}} (110 x 110)</md-option><md-option value=\"public\">{{\'website_settings.pictures.public_option\' | i18next}} (290 x 250)</md-option><md-option value=\"big\">{{\'website_settings.pictures.big_option\' | i18next}} (1170 x 380)</md-option><md-option value=\"medium\">{{\'website_settings.pictures.medium_option\' | i18next}} (300 x 300)</md-option><md-option value=\"public_small\">{{\'website_settings.pictures.public_small_option\' | i18next}} (200 x 85)</md-option><md-option value=\"public_big\">{{\'website_settings.pictures.public_big_option\' | i18next}} (735 x 500)</md-option><md-option value=\"small\">{{\'website_settings.pictures.small_option\' | i18next}} (40 x 40)</md-option></md-select></md-input-container></td><td ng-hide=\"$index == PicturesCtrl.editedPicture\" class=\"controls text-right\"><a ng-click=\"PicturesCtrl.openEditForm($index)\"><i tooltip=\"{{\'general.tooltip.edit\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-edit\"></i></a> <a ng-click=\"PicturesCtrl.removePicture($index)\"><i tooltip=\"{{\'general.tooltip.remove\' | i18next}}\" tooltip-append-to-body=\"true\" class=\"fa fa-times\"></i></a></td></tr></tbody><tfoot><tr><td colspan=\"5\"><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\" ng-show=\"PicturesCtrl.photoLoaded != true\"></i> <i class=\"fa fa-spinner\" ng-show=\"PicturesCtrl.photoLoaded == true\" ng-class=\"{\'fa-spin\': PicturesCtrl.photoLoaded == true}\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" onchange=\"angular.element(this).scope().PicturesCtrl.multipleFileUpload(event)\" multiple=\"\"></div></td></tr></tfoot></table></div></div>");
$templateCache.put("templates/website_settings/privacy_policy_tpl.html","<legend class=\"header\">{{\'general.other.privacy_policy\' | i18next}}<br><small>{{\'website_settings.static_text.privacy_policy.small\' | i18next}}</small></legend><div class=\"settings-body-block\"><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.privacyPolicy\" on-image-upload=\"imageUpload(files, \'privacyEditable\', \'privacyEditor\')\" data-role=\"privacyEditor\"></summernote></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/rooms_tpl.html","<legend class=\"header\">{{\'general.other.rooms\' | i18next}}<br><small>{{\'website_settings.rooms.small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-cropped\"><md-input-container><label>{{\'website_settings.rooms.rooms_title\' | i18next}}:</label> <input ng-model=\"website.roomSectionTitle\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'website_settings.rooms.rooms_description\' | i18next}}:</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.roomSectionDescription\" on-image-upload=\"imageUpload(files, \'roomDescEditable\', \'roomDescEditor\')\" data-role=\"roomDescEditor\"></summernote></div></div><div class=\"text-right toolbar spinned marged-bottom\"><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div><div class=\"settings-body-block marged-bottom\"><legend class=\"subheader\">{{\'general.other.rooms\' | i18next}}</legend><table class=\"table table-striped\" ng-hide=\"website.rooms.length === 0\"><thead><tr><th>{{\'general.other.title\' | i18next}}</th><th>{{\'general.other.published\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"room in website.rooms track by $index\"><td ng-show=\"room.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'general.other.name\' | i18next}} <small>({{\'website_settings.mapped_to\' | i18next}}: {{rtMapping[room.roomTypeId]}})</small></label> <input ng-model=\"room.name\" md-maxlength=\"255\"></md-input-container><div class=\"form-group\"><label>{{\'general.other.description\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"room.description\"></summernote></div><md-input-container><label>{{\'website_settings.rooms.introduction_text_label\' | i18next}}</label> <textarea ng-model=\"room.introduction\" md-maxlength=\"255\"></textarea></md-input-container><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeEditRoom($event, room, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditRoom($event, room, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></td><td ng-hide=\"room.edited\">{{room.name}} <small>({{\'website_settings.mapped_to\' | i18next}}: {{rtMapping[room.roomTypeId]}})</small></td><td ng-hide=\"room.edited\"><span ng-hide=\"room.visible_loader\"><span class=\"text-yes\" ng-show=\"room.visible\" ng-click=\"changeRoomVisible(false, room)\">{{\'general.other.yes\' | i18next}}</span> <span class=\"text-no\" ng-show=\"!room.visible\" ng-click=\"changeRoomVisible(true, room)\">{{\'general.other.no\' | i18next}}</span></span> <span ng-show=\"room.visible_loader\"><i class=\"fa fa-spin fa-spinner\"></i></span></td><td ng-hide=\"room.edited\" class=\"controls\"><a href=\"#\" ng-click=\"editRoom($event, room)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a></td></tr></tbody></table></div><div class=\"settings-body-block marged-bottom\"><legend class=\"subheader\">{{\'website_settings.rooms.custom_rooms_legend\' | i18next}}</legend><table class=\"table table-striped\" ng-hide=\"website.customRooms.length === 0\"><thead><tr><th>{{\'general.other.title\' | i18next}}</th><th>{{\'general.other.published\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"room in website.customRooms | filter:{ invisible : undefined }\"><td ng-show=\"room.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"room.title\" ng-change=\"slugify(room.title, room)\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.slug\' | i18next}}</label> <input type=\"text\" ng-model=\"room.slug\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.page_title\' | i18next}}</label> <input type=\"text\" ng-model=\"room.pageTitle\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.meta_description\' | i18next}}</label> <textarea ng-model=\"room.metaDescription\" md-maxlength=\"255\"></textarea></md-input-container><md-input-container><label>{{\'website_settings.rooms.introduction_text_label\' | i18next}}</label> <textarea ng-model=\"room.introduction\" md-maxlength=\"255\"></textarea></md-input-container><div class=\"form-group\"><label>{{\'general.other.description\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"room.description\"></summernote></div><md-input-container><label>{{\'general.other.button_text\' | i18next}}</label> <input type=\"text\" ng-model=\"room.buttonText\" md-maxlength=\"255\"></md-input-container><div class=\"form-group photos\"><label>{{\'website_settings.rooms.photos_label\' | i18next}}</label><br><div class=\"photos-container\" ng-show=\"(room.photos.length > 0)\"><div ng-repeat=\"photo in room.photos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.data}}\" ng-show=\"photo.data\"> <img ng-src=\"{{photo.photo}}\" ng-show=\"photo.photo\"></div><div class=\"tools\"><a href=\"{{photo.photo.replace(\'thumb\', \'big\')}}\" ng-show=\"photo.photo\" aria-label=\"{{\'website_settings.rooms.direct_link_tooltip\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'website_settings.rooms.direct_link_tooltip\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <a ng-click=\"removeFromCustomRoomPhotos(photo, room)\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><i class=\"fa fa-times-circle pull-right\" ng-hide=\"photo.loading\"></i></a> <a class=\"pull-right\" aria-label=\"{{\'general.tooltip.removing\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.removing\' | i18next}}</md-tooltip><i class=\"fa fa-spin fa-spinner\" ng-class=\"{\'fa-spin\' : photo.loading}\" ng-show=\"photo.loading\"></i></a></div></div></div><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\" ng-show=\"customPhotoLoaded != true\"></i> <i class=\"fa fa-spinner\" ng-show=\"customPhotoLoaded == true\" ng-class=\"{\'fa-spin\': customPhotoLoaded == true}\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" ng-model=\"room.photoField\" multiple=\"\" onchange=\"angular.element(this).scope().loadCustomRoomPhotos(event, angular.element(this).scope().room)\"></div><md-button class=\"md-raised md-orange\" ng-click=\"chooseFromLoaded(\'customRoomPhotos\', room, true, \'photos\')\"><i class=\"fa fa-cloud\"></i> {{\'website_settings.rooms.choose_from_loaded_button\' | i18next}}</md-button></div><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeEditCustomRoom($event, room, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditCustomRoom($event, room, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></td><td ng-hide=\"room.edited\">{{room.title}}</td><td ng-hide=\"room.edited\"><span ng-hide=\"room.visible_loader\"><span class=\"text-yes\" ng-show=\"room.visible\" ng-click=\"changeRoomVisible(false, room)\">{{\'general.other.yes\' | i18next}}</span> <span class=\"text-no\" ng-show=\"!room.visible\" ng-click=\"changeRoomVisible(true, room)\">{{\'general.other.no\' | i18next}}</span></span> <span ng-show=\"room.visible_loader\"><i class=\"fa fa-spin fa-spinner\"></i></span></td><td ng-hide=\"room.edited\" class=\"controls\"><a href=\"#\" ng-click=\"editCustomRoom($event, room)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a href=\"#\" ng-click=\"removeCustomRoom($event, room)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"room.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"room.loading\"></i></a></td></tr></tbody></table><div class=\"table-form\" ng-show=\"addNewCustomRoom\"><md-input-container><label>{{\'general.other.title\' | i18next}}</label> <input type=\"text\" ng-model=\"newCustomRoom.title\" ng-change=\"slugify(newCustomRoom.title, newCustomRoom)\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.slug\' | i18next}}</label> <input type=\"text\" ng-model=\"newCustomRoom.slug\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.page_title\' | i18next}}</label> <input type=\"text\" ng-model=\"newCustomRoom.pageTitle\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'general.other.meta_description\' | i18next}}</label> <textarea ng-model=\"newCustomRoom.metaDescription\" md-maxlength=\"255\"></textarea></md-input-container><md-input-container><label>{{\'website_settings.rooms.introduction_text_label\' | i18next}}</label> <textarea ng-model=\"newCustomRoom.introduction\" md-maxlength=\"255\"></textarea></md-input-container><div class=\"form-group\"><label>{{\'general.other.description\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"newCustomRoom.description\"></summernote></div><md-input-container><label>{{\'general.other.button_text\' | i18next}}</label> <input type=\"text\" ng-model=\"newCustomRoom.buttonText\"></md-input-container><div class=\"form-group photos\"><label>{{\'website_settings.rooms.photos_label\' | i18next}}</label><br><div class=\"photos-container\" ng-show=\"(newCustomRoom.photos.length > 0)\"><div ng-repeat=\"photo in newCustomRoom.photos\" class=\"uploaded-photo\"><div class=\"photoBlock\"><img ng-src=\"{{photo.data}}\" ng-show=\"photo.data\"> <img ng-src=\"{{photo.photo}}\" ng-show=\"photo.photo\"></div><div class=\"tools\"><a href=\"{{photo.photo.replace(\'thumb\', \'big\')}}\" ng-show=\"photo.photo\" aria-label=\"{{\'website_settings.rooms.direct_link_tooltip\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'website_settings.rooms.direct_link_tooltip\' | i18next}}</md-tooltip><i class=\"fa fa-link\"></i></a> <a class=\"pull-right\" ng-click=\"removeFromNewPhotos(photo)\" aria-label=\"{{\'general.tooltip.remove_image\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove_image\' | i18next}}</md-tooltip><i class=\"fa fa-times-circle\" ng-hide=\"photo.loading\"></i></a></div></div></div><div class=\"upload-image-btn\"><md-button class=\"md-raised md-primary\"><i class=\"fa fa-upload\" ng-show=\"customPhotoLoaded != true\"></i> <i class=\"fa fa-spinner\" ng-show=\"customPhotoLoaded == true\" ng-class=\"{\'fa-spin\': customPhotoLoaded == true}\"></i> {{\'general.buttons.upload_image\' | i18next}}</md-button><input type=\"file\" class=\"form-control\" placeholder=\"Choose photos\" ng-model=\"newCustomRoom.photoField\" multiple=\"\" onchange=\"angular.element(this).scope().loadCustomRoomPhotos(event, \'new\')\"></div><md-button class=\"md-raised md-orange\" ng-click=\"chooseFromLoaded(\'customRoomPhotos\', newCustomRoom, true, \'photos\')\"><i class=\"fa fa-cloud\"></i> {{\'website_settings.rooms.choose_from_loaded_button\' | i18next}}</md-button></div><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddCustomRoomForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewCustomRoom()\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddCustomRoomForm($event)\"><i class=\"fa fa-plus\"></i> {{\'website_settings.rooms.add_custom_room_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/template_tpl.html","<legend class=\"header\">{{\'general.other.template\' | i18next}}<br><small>{{\'website_settings.template.choose_which_template_you_like_small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><div class=\"row templates\"><label class=\"col-md-12\">{{\'website_settings.template.choose_template_label\' | i18next}}:</label><br><md-radio-group ng-model=\"website.template\"><md-radio-button ng-value=\"1\" aria-label=\"{{\'general.other.template\' | i18next}} #1\"><img src=\"/images/website_template_1.png\"></md-radio-button><md-radio-button ng-value=\"10\" aria-label=\"{{\'general.other.template\' | i18next}} #10\"><img src=\"/images/website_template_10.png\"></md-radio-button><md-radio-button ng-value=\"2\" aria-label=\"{{\'general.other.template\' | i18next}} #2\"><img src=\"/images/website_template_2.png\"></md-radio-button><md-radio-button ng-value=\"3\" aria-label=\"{{\'general.other.template\' | i18next}} #3\"><img src=\"/images/website_template_3.png\"></md-radio-button><md-radio-button ng-value=\"4\" aria-label=\"{{\'general.other.template\' | i18next}} #4\"><img src=\"/images/website_template_4.png\"></md-radio-button><md-radio-button ng-value=\"5\" aria-label=\"{{\'general.other.template\' | i18next}} #5\"><img src=\"/images/website_template_5.png\"></md-radio-button><md-radio-button ng-value=\"6\" aria-label=\"{{\'general.other.template\' | i18next}} #6\"><img src=\"/images/website_template_6.png\"></md-radio-button><md-radio-button ng-value=\"7\" aria-label=\"{{\'general.other.template\' | i18next}} #7\"><img src=\"/images/website_template_7.png\"></md-radio-button></md-radio-group></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/term_and_conditions_tpl.html","<legend class=\"header\">{{\'general.other.terms_and_conditions\' | i18next}}<br><small>{{\'website_settings.static_text.terms_and_conditions.small\' | i18next}}</small></legend><div class=\"settings-body-block\"><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"website.termsAndConditions\" on-image-upload=\"imageUpload(files, \'termsEditable\', \'termsEditor\')\" data-role=\"termsEditor\"></summernote></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/website_settings/testimonials_tpl.html","<legend class=\"header\">{{\'website_settings.testimonials.legend\' | i18next}}<br><small>{{\'website_settings.testimonials.small\' | i18next}}</small></legend><div class=\"settings-body-block marged-bottom\"><table class=\"table table-faq table-striped\"><thead><tr><th>{{\'website_settings.testimonials.testimonial_th\' | i18next}}</th><th>{{\'general.other.name\' | i18next}}</th><th></th></tr></thead><tbody><tr ng-repeat=\"testimonial in website.testimonials track by $index\"><td ng-show=\"testimonial.edited\" colspan=\"3\" class=\"edited-row\"><div class=\"table-form\"><md-input-container><label>{{\'general.other.title\' | i18next}}:</label> <input ng-model=\"testimonial.title\" md-maxlength=\"255\"></md-input-container><label>{{\'website_settings.testimonials.body_label\' | i18next}}:</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"testimonial.body\"></summernote><md-input-container><label>{{\'general.other.name\' | i18next}}:</label> <input ng-model=\"testimonial.name\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.testimonials.link_label\' | i18next}}:</label> <input ng-model=\"testimonial.link\" md-maxlength=\"255\"></md-input-container><div class=\"form-buttons text-right\"><md-button class=\"md-raised md-warn\" ng-click=\"closeEditTestimonial($event, testimonial, true)\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"closeEditTestimonial($event, testimonial, false)\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div></td><td ng-hide=\"testimonial.edited\"><div><strong>{{\'general.other.title\' | i18next}}:</strong> {{testimonial.title}}</div><div><strong>{{\'website_settings.testimonials.body_div\' | i18next}}:</strong><div ng-bind-html=\"testimonial.body\"></div></div></td><td ng-hide=\"testimonial.edited\" class=\"vertical-mid\">{{testimonial.name}}</td><td class=\"controls\" ng-hide=\"testimonial.edited\"><a href=\"#\" ng-click=\"editTestimonial($event, testimonial)\" aria-label=\"{{\'general.tooltip.edit\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.edit\' | i18next}}</md-tooltip><i class=\"fa fa-edit\"></i></a> <a href=\"#\" ng-click=\"removeTestimonial($event, testimonial)\" aria-label=\"{{\'general.tooltip.remove\' | i18next}}\"><md-tooltip md-direction=\"top\">{{\'general.tooltip.remove\' | i18next}}</md-tooltip><i class=\"fa fa-trash\" ng-hide=\"testimonial.loading\"></i> <i class=\"fa fa-spin fa-spinner\" ng-show=\"testimonial.loading\"></i></a></td></tr></tbody></table><div class=\"new-question-form table-form\" ng-show=\"addNewTestimonial\"><md-input-container><label>{{\'general.other.title\' | i18next}}:</label> <input ng-model=\"newTestimonial.title\" md-maxlength=\"255\"></md-input-container><label>{{\'website_settings.testimonials.answer_label\' | i18next}}</label><summernote on-paste=\"wysiwygPaste(evt)\" ng-model=\"newTestimonial.body\"></summernote><md-input-container><label>{{\'general.other.name\' | i18next}}:</label> <input ng-model=\"newTestimonial.name\" md-maxlength=\"255\"></md-input-container><md-input-container><label>{{\'website_settings.testimonials.link_label\' | i18next}}:</label> <input ng-model=\"newTestimonial.link\" md-maxlength=\"255\"></md-input-container><div class=\"text-right form-buttons\"><md-button class=\"md-raised md-warn\" ng-click=\"closeAddTestimonialForm()\">{{\'general.buttons.cancel\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"saveNewTestimonial()\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading_publish}\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div></div><div class=\"settings-body-buttons\"><md-button class=\"md-raised md-primary\" ng-click=\"openAddTestimonialForm($event)\"><i class=\"fa fa-plus\"></i> {{\'website_settings.testimonials.add_new_testimonial_button\' | i18next}}</md-button></div></div>");
$templateCache.put("templates/website_settings/tripadvisor_tpl.html","<legend class=\"header\">{{\'website_settings.tripadvisor.legend\' | i18next}}<br><small>{{\'website_settings.tripadvisor.small\' | i18next}}</small></legend><div class=\"settings-body-block top-padding-crop\"><div class=\"row\"><div class=\"col-md-12\"><md-input-container><label>{{\'website_settings.tripadvisor.widget_code_label\' | i18next}}</label> <textarea ng-model=\"website.tripadvisorCode\"></textarea></md-input-container><md-input-container><label>{{\'website_settings.tripadvisor.listing_link_label\' | i18next}}</label> <input type=\"text\" ng-model=\"website.tripadvisorListingLink\" md-maxlength=\"255\"></md-input-container></div></div></div><div class=\"text-right toolbar-bottom\"><md-button class=\"md-raised md-orange\" ng-click=\"save(\'preview\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_preview\"></i> {{\'general.buttons.save_and_preview\' | i18next}}</md-button><md-button class=\"md-raised md-success\" ng-click=\"save(\'publish\')\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"loading_publish\"></i> {{\'general.buttons.save\' | i18next}}</md-button></div>");
$templateCache.put("templates/modals/booking_management/change_date_modal.html","<div class=\"batch-edit-modal\"><div ng-if=\"isOpened\"><div class=\"buuqit-modal\" ng-if=\"!values.confirm_step\"><div class=\"actions\"><a ng-click=\"check_and_confirm()\" class=\"save\">{{\"checkin_dialog.controls.next\" | i18next}}</a> <a ng-click=\"close()\" class=\"cancel\">{{\"general.confirm.cancel\" | i18next}}</a></div><div class=\"head\"><div class=\"title\">{{\"general.other.date\" | i18next}} {{can_change_all()}}</div><div class=\"sub-title\">{{\"bookings.room_edit.rooms_selected\" | i18next}} ({{values.selected.length}})<i class=\"fas fa-caret-right\"></i></div></div><div class=\"form-block date-col\"><label class=\"datepicker\"><i class=\"fa fa-arrow-down\"></i>{{\"bookings.room_edit.check_in_date_datepicker_label\" | i18next}}</label><md-datepicker ng-model=\"values.checkinDate\" md-hide-icons=\"calendar\" ng-change=\"dateInChanged()\"></md-datepicker></div><div class=\"form-block\"><label><i class=\"fa fa-moon-o\"></i>{{\"general.other.nights\" | i18next}}</label><md-select ng-model=\"values.numberOfNights\" aria-label=\"numberOfNights\"><md-option ng-repeat=\"night in values.nights_select\" value=\"{{night}}\">{{night}}</md-option></md-select></div><div class=\"form-block\"><label><i class=\"fa fa-clock-o\"></i>{{\"general.other.arrival\" | i18next}}</label><md-select ng-model=\"values.checkinTime\" aria-label=\"checkinTime\"><md-option></md-option><md-option ng-repeat=\"time in values.times\" value=\"{{time}}\">{{time}}</md-option></md-select></div></div><div class=\"buuqit-modal\" ng-if=\"values.confirm_step && !values.recalc_confirm_step\"><div class=\"actions\"><a ng-click=\"reduced_number_of_nights() ? setRecalcStep() : confirm();\" class=\"save\">{{\"general.buttons.save\" | i18next}}</a> <a ng-click=\"close()\" class=\"cancel\">{{\"general.confirm.cancel\" | i18next}}</a></div><div class=\"head\"><div class=\"title\">{{\"general.confirm.are_you_sure_text_content\" | i18next}}</div><div class=\"sub-title warning\" ng-if=\"!can_move_all()\">{{\"bookings.room_edit.cannot_move_all\" | i18next}}</div></div><div class=\"\"><div><table class=\"confirmation-table\"><thead><tr><th>{{\'general.other.guest\' | i18next}}</th><th></th><th>{{\'general.other.arrival\' | i18next}}</th><th>{{\'general.other.departure\' | i18next}}</th></tr></thead><tbody><tr ng-repeat=\"room in values.selected\"><td>{{room.guest.firstName}} {{room.guest.lastName}} {{room._canchange}}</td><td class=\"nights\" ng-if=\"room._canmove\">{{values.numberOfNights}} {{\'general.other.nights\' | i18next}}</td><td class=\"dates\" ng-if=\"room._canmove\"><span class=\"old\">{{room.checkinDate | dateToMoment : \'ddd, D MMM YYYY\'}}</span> <i class=\"fas fa-long-arrow-alt-right\"></i> <span class=\"new\">{{values.checkinDate | dateToMoment : \'ddd, D MMM YYYY\'}}</span></td><td ng-if=\"room._canmove\">{{checkout_date() | dateToMoment : \'ddd, D MMM YYYY\'}}</td><td ng-if=\"!room._canmove\" colspan=\"3\">{{\'bookings.calendar.cannot_be_moved_link\' | i18next}}</td></tr></tbody></table></div></div></div><div class=\"buuqit-modal\" ng-if=\"values.recalc_confirm_step\"><div class=\"actions\"><a ng-click=\"confirm()\" class=\"save\">{{\"general.buttons.confirm\" | i18next}}</a> <a ng-click=\"close()\" class=\"cancel\">{{\"general.confirm.cancel\" | i18next}}</a></div><div class=\"head\"><div class=\"title\">{{\"bookings.room_edit.nights_price_auto_recalculation\" | i18next}}</div><div class=\"sub-title\">{{\"bookings.room_edit.nights_price_auto_recalculation_description\" | i18next}}</div></div></div></div></div>");
$templateCache.put("templates/modals/booking_management/change_occupancy_modal.html","<div class=\"batch-edit-modal\"><div ng-if=\"isOpened\"><div class=\"buuqit-modal\"><div class=\"actions\"><a ng-click=\"confirm()\" class=\"save\">{{\"general.confirm.confirm\" | i18next}}</a> <a ng-click=\"close()\" class=\"cancel\">{{\"general.confirm.cancel\" | i18next}}</a></div><div class=\"head\"><div class=\"title\">{{\"general.other.occupancy\" | i18next}}</div><div class=\"sub-title\">{{\"bookings.room_edit.rooms_selected\" | i18next}} ({{selected.length}})</div></div><div class=\"form-block rates\"><md-input-container><label>{{\'general.other.max_adults\' | i18next}} {{values.max.adults}}</label><md-select class=\"error-forced\" ng-model=\"values.selected_adults\" required=\"\"><md-option ng-repeat=\"i in values.adults_range\" ng-value=\"i\">{{i}}</md-option></md-select></md-input-container></div><div class=\"form-block policy\"><md-input-container><label>{{\'general.other.max_children\' | i18next}} {{values.max.children}}</label><md-select class=\"error-forced\" ng-model=\"values.selected_children\" required=\"\"><md-option ng-repeat=\"i in values.child_range\" ng-value=\"i\">{{i}}</md-option></md-select></md-input-container></div></div></div></div>");
$templateCache.put("templates/modals/booking_management/change_price_modal.html","<div class=\"batch-edit-modal\"><div ng-if=\"isOpened\"><div class=\"buuqit-modal\"><div class=\"actions\"><a ng-click=\"confirm()\" class=\"save\">{{\"general.confirm.confirm\" | i18next}}</a> <a ng-click=\"close()\" class=\"cancel\">{{\"general.confirm.cancel\" | i18next}}</a></div><div class=\"head\"><div class=\"title\">{{\"general.other.price\" | i18next}}</div><div class=\"sub-title\">{{\"bookings.room_edit.rooms_selected\" | i18next}} ({{values.selected.length}})</div></div><div class=\"form-block rates\"><md-input-container><label>{{\'bookings.room_edit.available_room_rate_select_label\' | i18next}}</label><md-select ng-model=\"values.selected_rate\"><md-option ng-repeat=\"rate in values.rates\" ng-value=\"rate\">{{rate.name}} <span ng-if=\"!rate.applicable\">({{\'bookings.create_booking.booking_form.restrictions_does_not_match\' | i18next}})</span></md-option></md-select></md-input-container></div><div class=\"form-block policy\"><md-input-container><label>{{\'general.other.cancellation_policy\' | i18next}}</label><md-select class=\"error-forced\" ng-model=\"values.selected_policy\" required=\"\"><md-option ng-repeat=\"policy in values.policies\" ng-value=\"policy.id\">{{policy.title}}</md-option></md-select></md-input-container></div><div class=\"form-block\"><button class=\"update-btn\" ng-click=\"updateRate()\">{{\"bookings.room_edit.update_rate\" | i18next}}</button></div><div class=\"nights\"><div class=\"total form-block\"><md-input-container ng-if=\"values.is_foreign\"><label>{{\"general.other.total\" | i18next}}</label> <input type=\"number\" ng-model=\"values.total_foreign_amount\" name=\"totalPrice{{values.id}}\" min=\"0\" readonly=\"\"></md-input-container><md-input-container ng-if=\"!values.is_foreign\"><label>{{\"general.other.total\" | i18next}}</label> <input type=\"number\" ng-model=\"values.total_price\" name=\"totalPrice{{values.id}}\" min=\"0\" readonly=\"\"></md-input-container><span class=\"currency-char\" ng-if=\"values.currency_symbol && values.currency_symbol.length < 2\">{{values.currency_symbol}}</span></div><div class=\"night form-block\" ng-repeat=\"night in values.nights\"><md-input-container ng-if=\"values.is_foreign\"><label>{{night.date | dateToMoment : \"ddd D\"}} ({{perNight(night)}})</label> <input type=\"number\" ng-model=\"night.foreignAmount\" min=\"0\" ng-change=\"totalFromNights()\" onclick=\"this.select()\"></md-input-container><md-input-container ng-if=\"!values.is_foreign\"><label>{{night.date | dateToMoment : \"ddd D\"}} ({{perNight(night)}})</label> <input type=\"number\" ng-model=\"night.price\" min=\"0\" ng-change=\"totalFromNights()\" onclick=\"this.select()\"></md-input-container><span class=\"currency-char\" ng-if=\"values.currency_symbol && values.currency_symbol.length < 2\">{{values.currency_symbol}}</span></div></div></div></div></div>");
$templateCache.put("templates/modals/merge_items/template_tpl.html","<md-dialog class=\"modal-merge-items\" ng-cloak=\"\"><form name=\"\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{\'general.buttons.merge\' | i18next}} <strong>{{item.title}}</strong> {{\'general.other.to\' | i18next}}:</h2></div></md-toolbar><md-dialog-content><ul class=\"merge-list\"><li class=\"merge-list-item\" ng-class=\"{\'merge-list-item--selected\': selectedItemId === item.id}\" ng-click=\"selectItem(item)\" ng-repeat=\"item in items\"><small>{{item.name}}</small> <span class=\"merge-list-item__selected-icon\"><i class=\"material-icons\">check</i></span></li></ul></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-warn\" ng-click=\"merge()\" ng-disabled=\"loading\"><i class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\" ng-if=\"loading\"></i> {{\'general.buttons.merge\' | i18next}}</md-button><md-button class=\"md-raised md-primary md-secondary-success\" ng-click=\"cancel()\">{{\'general.buttons.cancel\' | i18next}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/modals/select_items/template_tpl.html","<md-dialog ng-cloak=\"\"><form novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Replace <strong>{{item.name}}</strong> with:</h2></div></md-toolbar><md-dialog-content class=\"room-blocker-modal-content\"><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>Select</label><md-select ng-model=\"selectedItemId\"><md-option ng-repeat=\"item in items\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div></md-dialog-content><div class=\"md-actions\" layout=\"row\"><md-button class=\"md-raised md-primary\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"loading\" ng-click=\"confirm()\"><i ng-if=\"loading\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : loading}\"></i> {{buttonName}}</md-button></div></form></md-dialog>");
$templateCache.put("templates/tokenization/create_booking/braintree_tpl.html","<div id=\"braintree-drop-in\" ng-show=\"addCreditCard\"></div><button type=\"submit\" class=\"hidden submit-braintree\">{{\'tokenization.general_for_section.check_button\' | i18next}}</button><div class=\"row\"><div class=\"col-xs-12\"><div class=\"button-container\"><md-button class=\"md-raised md-primary\" aria-label=\"{{\'general.aria_labels.credit_card\' | i18next}}\" ng-click=\"toggleCreditCard()\"><span ng-if=\"addCreditCard === false\">{{\'tokenization.general_for_section.add_credit_card_span\' | i18next}}</span> <span ng-if=\"addCreditCard === true\">{{\'tokenization.general_for_section.hide_credit_card_form_span\' | i18next}}</span></md-button></div></div></div>");
$templateCache.put("templates/tokenization/create_booking/omise_tpl.html","<div class=\"row\"><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.cardholder_name_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.cardholder_name\"></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.card_number_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"card.type\"></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.exp_date_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.expiration\" payments-validate=\"expiry\" payments-format=\"expiry\"></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>CVV / CVC</label> <input type=\"text\" ng-model=\"card.cvv\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"card.type\"></md-input-container></div></div>");
$templateCache.put("templates/tokenization/create_booking/stripe_sca_tpl.html","<div class=\"row\"><div class=\"col-xs-5\"><div id=\"stripe-sca-drop-in\" ng-show=\"addCreditCard\"></div></div></div><button type=\"submit\" class=\"hidden submit-stripe-sca\">{{\'tokenization.general_for_section.check_button\' | i18next}}</button><div class=\"row\"><div class=\"col-xs-12\"><div class=\"button-container\"><md-button class=\"md-raised md-primary\" aria-label=\"{{\'general.aria_labels.credit_card\' | i18next}}\" ng-click=\"toggleCreditCard()\"><span ng-if=\"addCreditCard === false\">{{\'tokenization.general_for_section.add_credit_card_span\' | i18next}}</span> <span ng-if=\"addCreditCard === true\">{{\'tokenization.general_for_section.hide_credit_card_form_span\' | i18next}}</span></md-button></div></div></div>");
$templateCache.put("templates/tokenization/create_booking/stripe_tpl.html","<div class=\"row\"><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.cardholder_name_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.cardholder_name\"></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.card_number_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"card.type\"></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.exp_date_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.expiration\" payments-validate=\"expiry\" payments-format=\"expiry\"></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>CVV / CVC</label> <input type=\"text\" ng-model=\"card.cvv\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"card.type\"></md-input-container></div></div>");
$templateCache.put("templates/tokenization/create_booking/wirecard_tpl.html","<div></div>");
$templateCache.put("templates/tokenization/create_booking/worldpay_tpl.html","<div class=\"row\"><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.cardholder_name_label\' | i18next}}</label> <input type=\"text\" data-worldpay=\"name\"></md-input-container></div><div class=\"col-xs-4 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.card_number_label\' | i18next}}</label> <input type=\"text\" data-worldpay=\"number\" ng-model=\"card.number\" payments-validate=\"card\" payments-format=\"card\"></md-input-container></div><div class=\"col-xs-2 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.exp_date_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.expiration\" payments-validate=\"expiry\" payments-format=\"expiry\"></md-input-container><input data-worldpay=\"exp-month\" type=\"hidden\" value=\"{{card.expiration.split(\'/\')[0]}}\"> <input data-worldpay=\"exp-year\" type=\"hidden\" value=\"{{card.expiration.split(\'/\')[1]}}\"></div><div class=\"col-xs-2 form-block\"><md-input-container><label>CVV / CVC</label> <input type=\"text\" data-worldpay=\"cvc\" ng-model=\"card.cvv\"></md-input-container></div></div>");
$templateCache.put("templates/tokenization/create_booking/wubook_tpl.html","<div id=\"pcibooking-drop-in\" ng-if=\"addCreditCard\"><iframe frameborder=\"0\" border=\"0\" id=\"pcibooking_frame\" ng-src=\"{{pci_booking_iframe_path}}\"></iframe></div><button type=\"submit\" class=\"hidden submit-braintree\">{{\'tokenization.general_for_section.check_button\' | i18next}}</button><div class=\"row\"><div class=\"col-xs-12\"><div class=\"button-container\"><md-button class=\"md-raised md-primary\" aria-label=\"{{\'general.aria_labels.credit_card\' | i18next}}\" ng-click=\"toggleCreditCard()\"><span ng-if=\"addCreditCard === false\">{{\'tokenization.general_for_section.add_credit_card_span\' | i18next}}</span> <span ng-if=\"addCreditCard === true\">{{\'tokenization.general_for_section.hide_credit_card_form_span\' | i18next}}</span></md-button></div></div></div>");
$templateCache.put("templates/tokenization/manage_cards/braintree_tpl.html","<div class=\"flip\" ng-class=\"{\'flipped\' : cardFormVisible}\"><div class=\"cover\" ng-click=\"showCardForm()\"><i class=\"fa fa-plus\"></i><br>{{\'tokenization.general_for_section.add_new_card_div\' | i18next}}</div><div class=\"form\"><i class=\"fa fa-times-circle\" ng-click=\"hideCardForm()\"></i><form name=\"newCardForm\" novalidate=\"\"><div id=\"braintree-drop-in\"></div><md-button class=\"md-raised md-primary md-fab btn\" type=\"submit\" ng-class=\"{\'disabled\':online === false}\" ng-disabled=\"cardAnimation\"><i ng-show=\"cardAnimation\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : cardAnimation}\"></i> <i ng-hide=\"cardAnimation\" class=\"fa fa-check\"></i></md-button></form></div></div>");
$templateCache.put("templates/tokenization/manage_cards/omise_tpl.html","<div class=\"flip\" ng-class=\"{\'flipped\' : cardFormVisible}\"><div class=\"cover\" ng-click=\"showCardForm()\"><i class=\"fa fa-plus\"></i><br>{{\'tokenization.general_for_section.add_new_card_div\' | i18next}}</div><div class=\"form\"><i class=\"fa fa-times-circle\" ng-click=\"hideCardForm()\"></i><form name=\"newCardForm\" novalidate=\"\"><md-input-container><label>{{\'tokenization.general_for_section.cardholder_name_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.cardholder_name\"></md-input-container><br><md-input-container><label>{{\'tokenization.general_for_section.card_number_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"card.type\"></md-input-container><br><div class=\"row\"><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.exp_date_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.expiration\" payments-validate=\"expiry\" payments-format=\"expiry\"></md-input-container></div><div class=\"col-xs-6 form-block\"><md-input-container><label>CVV / CVC</label> <input type=\"text\" ng-model=\"card.cvv\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"card.type\"></md-input-container></div></div><md-button class=\"md-raised md-primary md-fab btn\" ng-click=\"saveOmiseCard()\" ng-class=\"{\'disabled\':online === false}\" ng-disabled=\"cardAnimation\"><i ng-show=\"cardAnimation\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : cardAnimation}\"></i> <i ng-hide=\"cardAnimation\" class=\"fa fa-check\"></i></md-button></form></div></div>");
$templateCache.put("templates/tokenization/manage_cards/stripe_sca_tpl.html","<div class=\"flip\" ng-class=\"{\'flipped\' : cardFormVisible}\"><div class=\"cover\" ng-click=\"showCardForm()\"><i class=\"fa fa-plus\"></i><br>{{\'tokenization.general_for_section.add_new_card_div\' | i18next}}</div><div class=\"form form--stripe_sca\"><i class=\"fa fa-times-circle\" ng-click=\"hideCardForm()\"></i><form name=\"newCardForm\" novalidate=\"\"><div id=\"stripe-sca-drop-in\"></div><md-button class=\"md-raised md-primary md-fab btn\" ng-click=\"saveStripeScaCard()\" ng-class=\"{\'disabled\':online === false}\" ng-disabled=\"cardAnimation\"><i ng-show=\"cardAnimation\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : cardAnimation}\"></i> <i ng-hide=\"cardAnimation\" class=\"fa fa-check\"></i></md-button></form></div></div>");
$templateCache.put("templates/tokenization/manage_cards/stripe_tpl.html","<div class=\"flip\" ng-class=\"{\'flipped\' : cardFormVisible}\"><div class=\"cover\" ng-click=\"showCardForm()\"><i class=\"fa fa-plus\"></i><br>{{\'tokenization.general_for_section.add_new_card_div\' | i18next}}</div><div class=\"form\"><i class=\"fa fa-times-circle\" ng-click=\"hideCardForm()\"></i><form name=\"newCardForm\" novalidate=\"\"><md-input-container><label>{{\'tokenization.general_for_section.cardholder_name_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.cardholder_name\"></md-input-container><br><md-input-container><label>{{\'tokenization.general_for_section.card_number_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"card.type\"></md-input-container><br><div class=\"row\"><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.exp_date_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.expiration\" payments-validate=\"expiry\" payments-format=\"expiry\"></md-input-container></div><div class=\"col-xs-6 form-block\"><md-input-container><label>CVV / CVC</label> <input type=\"text\" ng-model=\"card.cvv\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"card.type\"></md-input-container></div></div><md-button class=\"md-raised md-primary md-fab btn\" ng-click=\"saveStripeCard()\" ng-class=\"{\'disabled\':online === false}\" ng-disabled=\"cardAnimation\"><i ng-show=\"cardAnimation\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : cardAnimation}\"></i> <i ng-hide=\"cardAnimation\" class=\"fa fa-check\"></i></md-button></form></div></div>");
$templateCache.put("templates/tokenization/manage_cards/wirecard_tpl.html","<div></div>");
$templateCache.put("templates/tokenization/manage_cards/worldpay_tpl.html","<div class=\"flip\" ng-class=\"{\'flipped\' : cardFormVisible}\"><div class=\"cover\" ng-click=\"showCardForm()\"><i class=\"fa fa-plus\"></i><br>{{\'tokenization.general_for_section.add_new_card_div\' | i18next}}</div><div class=\"form\"><i class=\"fa fa-times-circle\" ng-click=\"hideCardForm()\"></i><form name=\"newCardForm\" class=\"worldpay-booking-form\" novalidate=\"\"><md-input-container><label>{{\'tokenization.general_for_section.cardholder_name_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.cardholder_name\" data-worldpay=\"name\"></md-input-container><br><md-input-container><label>{{\'tokenization.general_for_section.card_number_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.number\" data-worldpay=\"number\" payments-validate=\"card\" payments-format=\"card\" payments-type-model=\"card.type\"></md-input-container><br><div class=\"row\"><div class=\"col-xs-6 form-block\"><md-input-container><label>{{\'tokenization.general_for_section.exp_date_label\' | i18next}}</label> <input type=\"text\" ng-model=\"card.expiration\" payments-validate=\"expiry\" payments-format=\"expiry\"></md-input-container><input type=\"hidden\" data-worldpay=\"exp-month\" value=\"{{card.expiration.split(\'/\')[0]}}\"> <input type=\"hidden\" data-worldpay=\"exp-year\" value=\"{{card.expiration.split(\'/\')[1]}}\"></div><div class=\"col-xs-6 form-block\"><md-input-container><label>CVV / CVC</label> <input type=\"text\" ng-model=\"card.cvv\" payments-validate=\"cvc\" payments-format=\"cvc\" payments-type-model=\"card.type\" data-worldpay=\"cvc\"></md-input-container></div></div><md-button class=\"md-raised md-primary md-fab btn\" ng-click=\"saveWorldpayCardForm()\" ng-class=\"{\'disabled\':online === false}\" ng-disabled=\"cardAnimation\"><i ng-show=\"cardAnimation\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : cardAnimation}\"></i> <i ng-hide=\"cardAnimation\" class=\"fa fa-check\"></i></md-button></form></div></div>");
$templateCache.put("templates/tokenization/manage_cards/wubook_tpl.html","<div class=\"flip\" ng-class=\"{\'flipped\' : cardFormVisible}\"><div class=\"cover\" ng-click=\"showCardForm()\"><i class=\"fa fa-plus\"></i><br>{{\'tokenization.general_for_section.add_new_card_div\' | i18next}}</div><div class=\"form\"><i class=\"fa fa-times-circle\" ng-click=\"hideCardForm()\"></i><iframe ng-if=\"cardFormVisible\" frameborder=\"0\" border=\"0\" id=\"pcibooking_frame\" ng-src=\"{{pci_booking_iframe_path}}\"></iframe><md-button class=\"md-raised md-primary md-fab btn\" ng-click=\"saveWubookCard()\" ng-class=\"{\'disabled\':online === false}\" ng-disabled=\"cardAnimation\"><i ng-show=\"cardAnimation\" class=\"fa fa-spinner\" ng-class=\"{\'fa-spin\' : cardAnimation}\"></i> <i ng-hide=\"cardAnimation\" class=\"fa fa-check\"></i></md-button></div></div>");}]);